/* eslint-disable */
(function(){"use strict";try{if(typeof document<"u"){var e=document.createElement("style");e.appendChild(document.createTextNode('@import"https://fonts.googleapis.com/css2?family=Inter:wght@100;200;300;400;500;600;700;800;900&display=swap";._typography_iuw1x_1{font-family:Inter,sans-serif}._regular_iuw1x_5{font-weight:400}._medium_iuw1x_9{font-weight:500}._semiBold_iuw1x_13{font-weight:600}._bold_iuw1x_17{font-weight:700}._heading1_iuw1x_21{font-size:72px;line-height:1;letter-spacing:-2.16px}._heading2_iuw1x_27{font-size:48px;line-height:58px}._heading3_iuw1x_32{font-size:24px;line-height:32px}._heading4_iuw1x_37{font-size:12px;line-height:16px;letter-spacing:.36px}._paragraph1_iuw1x_43{font-size:20px;line-height:28px}._paragraph2_iuw1x_48{font-size:16px;line-height:24px;letter-spacing:-.16px}._paragraph3_iuw1x_54{font-size:14px;line-height:20px}._paragraph4_iuw1x_59{font-size:12px;line-height:20px;letter-spacing:-.18px}._paragraph5_iuw1x_65{font-size:10px;line-height:1;letter-spacing:.3px}._button_hjfzv_1{min-width:160px;display:flex;flex-flow:row nowrap;align-items:center;justify-content:center;border-radius:10px;padding:10px 0;font-family:Inter,sans-serif;font-size:16px;line-height:24px;font-weight:400;letter-spacing:.16px;outline:none;border:0;color:var(--ui-color-soft-sky);cursor:pointer;transition:all .15s ease-out}._default_hjfzv_20{background:linear-gradient(82deg,#2a52ee .15%,#00c8ff 87.75%)!important}._secondary_hjfzv_24{background:var(--ui-color-soft-sky-25)!important}._buttonDisabled_hjfzv_28{opacity:.7}._startAdornment_hjfzv_32{display:flex;flex-flow:column nowrap;margin-right:10px}._endAdornment_hjfzv_38{display:flex;flex-flow:column nowrap;margin-left:10px}._info_1gpce_1{display:flex;flex-flow:column nowrap}._title_1gpce_6{color:var(--ui-color-soft-sky)}._inner_1gpce_10{margin-top:4px;display:flex;flex-flow:row nowrap;align-items:center}._icon_1gpce_17{width:24px;height:24px}._value_1gpce_22{flex:1;margin-left:6px;color:var(--ui-color-soft-sky)}._step_1r0nd_1{display:flex;flex-flow:column nowrap}._inner_1r0nd_6{display:flex;flex-flow:column nowrap;row-gap:12px}._actions_1r0nd_12{margin-top:76px;display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;-moz-column-gap:16px;column-gap:16px}._action_1r0nd_12{flex:1}._root_5tzs8_1{display:flex;flex-flow:column nowrap}._items_5tzs8_6{display:flex;flex-flow:column nowrap;row-gap:12px}._actions_5tzs8_12{margin-top:16px;display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;-moz-column-gap:16px;column-gap:16px}._action_5tzs8_12{flex:1}._actionIcon_5tzs8_25{width:24px;height:24px}._input_1fgkd_1{width:100%;display:flex;flex-flow:row nowrap;align-items:center;background-color:var(--ui-color-soft-sky-10);padding:12px 12px 12px 8px;border-radius:14px}._field_1fgkd_11{width:100%;border-radius:14px;border:0;background-color:transparent;outline:none;font-family:Inter,sans-serif;font-size:16px;line-height:24px;font-weight:600;color:var(--ui-color-soft-sky)}._startAdornment_1fgkd_24{display:flex;flex-flow:column nowrap;margin-right:6px}._endAdornment_1fgkd_30{display:flex;flex-flow:column nowrap;margin-left:6px}._button_c3zg3_1{display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;padding:7px 8px;height:24px;border-radius:6px;background-color:#0099ff4d;cursor:pointer;transition:all .15s ease-out}._button_c3zg3_1:hover{background-color:var(--ui-color-electric-teal)}._button_c3zg3_1:hover ._text_c3zg3_16{color:var(--ui-color-soft-sky)}._text_c3zg3_16{color:var(--ui-color-electric-teal)}._container_196n6_1{height:32px}._input_196n6_5{pointer-events:none;height:100%;font-size:14px;line-height:20px;font-weight:400;width:100px;background-color:var(--ui-color-2);color:var(--ui-color-soft-sky);border:none}._exchangeSection_5txqp_1{display:flex;justify-content:space-between;align-items:center;width:172px}._exchangeSectionConnect_5txqp_8{display:flex;justify-content:center;align-items:center;width:172px}._networkInfo_5txqp_15{display:flex;align-items:center}._networkIcon_5txqp_20{width:24px;height:24px;margin-right:6px}._networkName_5txqp_26{color:var(--ui-color-misty-lavender)}._toggler_he8ct_1{display:flex;justify-content:center;align-items:center;width:32px;height:32px;background-color:var(--ui-color-soft-sky-10);border-radius:8px;cursor:pointer}._switchIcon_he8ct_12{color:var(--ui-color-soft-sky);width:28px;height:28px}._panel_9vrhy_1{display:flex;justify-content:space-between}._walletSectionContainer_9vrhy_6{margin-top:12px}._togglerContainer_9vrhy_10{display:flex;align-items:flex-end;padding-left:22px;padding-right:22px}._addressLabel_9vrhy_17{color:var(--ui-color-soft-sky)}._inputInfo_1grl0_1{display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;margin-top:16px}._amountText_1grl0_9{color:var(--ui-color-soft-sky)}._balanceText_1grl0_13{color:var(--ui-color-misty-lavender)}._input_1grl0_1{margin-top:4px}._inputIcon_1grl0_21{width:24px;height:24px}._action_1grl0_26{margin-top:24px}._actionIcon_1grl0_30{width:24px;height:24px}._status_1ctcr_1{position:absolute;top:0;left:0;right:0;bottom:0;display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;border-radius:24px;z-index:10;overflow:hidden}._overlay_1ctcr_16{position:absolute;top:0;left:0;right:0;bottom:0;-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background-color:#050b1599;z-index:1}._inner_1ctcr_27{position:relative;z-index:2;display:flex;flex-flow:column nowrap;align-items:center}._close_1ctcr_35{position:absolute;top:24px;right:24px;width:36px;height:36px;display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;border-radius:10px;background-color:var(--ui-color-soft-sky-10);cursor:pointer;transition:all .15s ease-out;z-index:3}._close_1ctcr_35:hover{background-color:var(--ui-color-soft-sky-25)}._closeIcon_1ctcr_55{width:20px;height:20px;color:var(--ui-color-soft-sky)}._text_172s7_1{max-width:320px;text-align:center;color:var(--ui-color-crimson-red)}._incompleteTransaction_1g8ef_1{position:absolute;top:0;left:0;right:0;bottom:0;width:100%;height:100%;z-index:1;-webkit-backdrop-filter:blur(5px);backdrop-filter:blur(5px);background-color:#050b1599}._incompleteTransactionContent_1g8ef_14{position:relative;display:flex;flex-direction:column;justify-content:center;align-items:center;height:100%}._subTitle_1g8ef_23{color:var(--ui-color-soft-sky)}._continueButton_1g8ef_27{margin-top:16px}._close_1g8ef_31{position:absolute;top:24px;right:24px;width:36px;height:36px;display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;border-radius:10px;background-color:inherit;cursor:pointer;transition:all .15s ease-out}._close_1g8ef_31:hover{background-color:var(--ui-color-soft-sky-25)}._closeIcon_1g8ef_50{width:20px;height:20px;color:var(--ui-color-soft-sky)}._loader_ga1u1_1{width:24px;aspect-ratio:1;border-radius:50%;background:radial-gradient(farthest-side,#3652e5 94%,#0000) top/4px 4px no-repeat,conic-gradient(#0000 30%,#3652e5);-webkit-mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 4px),#000 0);mask:radial-gradient(farthest-side,rgba(0,0,0,0) calc(100% - 4px),#000 0);animation:_loaderAnimation_ga1u1_1 1s infinite linear}@keyframes _loaderAnimation_ga1u1_1{to{transform:rotate(1turn)}}._text_17crq_1{color:var(--ui-color-soft-sky)}._loader_17crq_5{margin-top:16px}._icon_19tiz_1{width:24px;height:24px}._title_19tiz_6{margin-top:8px;color:#10a842;max-width:240px;text-align:center}._loader_19tiz_13{margin-top:16px}._step_141le_1{display:flex;flex-flow:column nowrap;align-items:center}._icon_141le_7{width:24px;height:24px}._title_141le_12{margin-top:8px;color:#10a842;max-width:240px;text-align:center}._items_141le_19{margin-top:16px;display:flex;flex-flow:column nowrap;align-items:center;row-gap:16px}._item_141le_19{display:flex;flex-flow:row nowrap;align-items:center}._itemIcon_141le_33{width:24px;height:24px}._itemValue_141le_38{flex:1;margin-left:6px;color:var(--ui-color-soft-sky)}._close_141le_44{position:absolute;top:24px;right:24px;width:36px;height:36px;display:flex;flex-flow:column nowrap;align-items:center;justify-content:center;border-radius:10px;background-color:var(--ui-color-soft-sky-10);cursor:pointer;transition:all .15s ease-out}._close_141le_44:hover{background-color:var(--ui-color-soft-sky-25)}._closeIcon_141le_63{width:20px;height:20px;color:var(--ui-color-soft-sky)}._swapper_25khg_1{position:relative;width:100%;min-width:328px;max-width:470px;height:272px;display:flex;flex:1 1 auto;flex-flow:column nowrap;padding:24px;background-color:var(--ui-color-2);border:1px solid var(--ui-color-soft-sky-10);border-radius:24px;overflow:hidden}._swapperSuccess_25khg_17{align-items:center;justify-content:center}._inputInfo_25khg_22{display:flex;flex-flow:row nowrap;align-items:center;justify-content:space-between;margin-top:16px}._amountText_25khg_30{color:var(--ui-color-soft-sky)}._balanceText_25khg_34{color:var(--ui-color-misty-lavender)}._input_25khg_22{margin-top:4px}._inputIcon_25khg_42{width:24px;height:24px}._action_25khg_47{margin-top:24px}._actionIcon_25khg_51{width:24px;height:24px}html,body,div,span,applet,object,iframe,h1,h2,h3,h4,h5,h6,p,blockquote,pre,a,abbr,acronym,address,big,cite,code,del,dfn,em,img,ins,kbd,q,s,samp,small,strike,strong,sub,sup,tt,var,b,u,i,center,dl,dt,dd,ol,ul,li,fieldset,form,label,legend,table,caption,tbody,tfoot,thead,tr,th,td,article,aside,canvas,details,embed,figure,figcaption,footer,header,hgroup,main,menu,nav,output,ruby,section,summary,time,mark,audio,video{margin:0;padding:0;border:0;font-size:100%;font:inherit;vertical-align:baseline}article,aside,details,figcaption,figure,footer,header,hgroup,main,menu,nav,section{display:block}*[hidden]{display:none}body{line-height:1}menu,ol,ul{list-style:none}blockquote,q{quotes:none}blockquote:before,blockquote:after,q:before,q:after{content:"";content:none}table{border-collapse:collapse;border-spacing:0}:root{--ui-color-black: #000;--ui-color-white: #fff;--ui-color-2: #050B15;--ui-color-1: rgba(88, 101, 121, .25);--ui-color-3: rgba(16, 168, 66, .3);--ui-color-4: rgba(0, 153, 255, .3);--ui-color-soft-sky-10: rgba(238, 249, 252, .1);--ui-color-soft-sky-25: rgba(238, 249, 252, .25);--ui-color-soft-sky: #F2FCFF;--ui-color-misty-lavender: #BAC1C9;--ui-color-misty-lavender-50: rgba(186, 193, 201, .5);--ui-color-electric-teal: #0099FF;--ui-color-dark-plum: #141D2A;--ui-color-deep-jungle-green: #10A842;--ui-color-crimson-red: #B83D3D}*{box-sizing:border-box}body{font-family:Inter,sans-serif}')),document.head.appendChild(e)}}catch(o){console.error("vite-plugin-css-injected-by-js",o)}})();
import { ConnectButton as VM } from "@rainbow-me/rainbowkit";
import { QueryClientProvider as $M, QueryClient as jM, useQuery as zM } from "@tanstack/react-query";
import { useTonAddress as A5, TonConnectButton as OM, useTonWallet as PM, useTonConnectUI as RM } from "@tonconnect/ui-react";
import * as _r from "react";
import nr, { createContext as BM, useState as Ei, useContext as IM, useEffect as nf, useCallback as zg } from "react";
import { isAddress as DM, getContract as NM, parseUnits as c1, formatUnits as gf } from "viem";
import { useContractRead as FM, useContractReads as LM, erc20ABI as UM, useContractWrite as gd, useWaitForTransaction as jg, useAccount as k5, useBalance as qM } from "wagmi";
function HM(t, e) {
  for (var r = 0; r < e.length; r++) {
    const i = e[r];
    if (typeof i != "string" && !Array.isArray(i)) {
      for (const f in i)
        if (f !== "default" && !(f in t)) {
          const a = Object.getOwnPropertyDescriptor(i, f);
          a && Object.defineProperty(t, f, a.get ? a : {
            enumerable: !0,
            get: () => i[f]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(t, Symbol.toStringTag, { value: "Module" }));
}
function WM(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
var T5 = { exports: {} }, xr = T5.exports = {}, Wn, Kn;
function d1() {
  throw new Error("setTimeout has not been defined");
}
function h1() {
  throw new Error("clearTimeout has not been defined");
}
(function() {
  try {
    typeof setTimeout == "function" ? Wn = setTimeout : Wn = d1;
  } catch {
    Wn = d1;
  }
  try {
    typeof clearTimeout == "function" ? Kn = clearTimeout : Kn = h1;
  } catch {
    Kn = h1;
  }
})();
function C5(t) {
  if (Wn === setTimeout)
    return setTimeout(t, 0);
  if ((Wn === d1 || !Wn) && setTimeout)
    return Wn = setTimeout, setTimeout(t, 0);
  try {
    return Wn(t, 0);
  } catch {
    try {
      return Wn.call(null, t, 0);
    } catch {
      return Wn.call(this, t, 0);
    }
  }
}
function KM(t) {
  if (Kn === clearTimeout)
    return clearTimeout(t);
  if ((Kn === h1 || !Kn) && clearTimeout)
    return Kn = clearTimeout, clearTimeout(t);
  try {
    return Kn(t);
  } catch {
    try {
      return Kn.call(null, t);
    } catch {
      return Kn.call(this, t);
    }
  }
}
var _i = [], Ls = !1, Ra, Uu = -1;
function ZM() {
  !Ls || !Ra || (Ls = !1, Ra.length ? _i = Ra.concat(_i) : Uu = -1, _i.length && B5());
}
function B5() {
  if (!Ls) {
    var t = C5(ZM);
    Ls = !0;
    for (var e = _i.length; e; ) {
      for (Ra = _i, _i = []; ++Uu < e; )
        Ra && Ra[Uu].run();
      Uu = -1, e = _i.length;
    }
    Ra = null, Ls = !1, KM(t);
  }
}
xr.nextTick = function(t) {
  var e = new Array(arguments.length - 1);
  if (arguments.length > 1)
    for (var r = 1; r < arguments.length; r++)
      e[r - 1] = arguments[r];
  _i.push(new I5(t, e)), _i.length === 1 && !Ls && C5(B5);
};
function I5(t, e) {
  this.fun = t, this.array = e;
}
I5.prototype.run = function() {
  this.fun.apply(null, this.array);
};
xr.title = "browser";
xr.browser = !0;
xr.env = {};
xr.argv = [];
xr.version = "";
xr.versions = {};
function ki() {
}
xr.on = ki;
xr.addListener = ki;
xr.once = ki;
xr.off = ki;
xr.removeListener = ki;
xr.removeAllListeners = ki;
xr.emit = ki;
xr.prependListener = ki;
xr.prependOnceListener = ki;
xr.listeners = function(t) {
  return [];
};
xr.binding = function(t) {
  throw new Error("process.binding is not supported");
};
xr.cwd = function() {
  return "/";
};
xr.chdir = function(t) {
  throw new Error("process.chdir is not supported");
};
xr.umask = function() {
  return 0;
};
var GM = T5.exports;
const It = /* @__PURE__ */ WM(GM);
var ut = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function R5(t) {
  return t && t.__esModule && Object.prototype.hasOwnProperty.call(t, "default") ? t.default : t;
}
function P5(t) {
  if (t.__esModule)
    return t;
  var e = t.default;
  if (typeof e == "function") {
    var r = function i() {
      return this instanceof i ? Reflect.construct(e, arguments, this.constructor) : e.apply(this, arguments);
    };
    r.prototype = e.prototype;
  } else
    r = {};
  return Object.defineProperty(r, "__esModule", { value: !0 }), Object.keys(t).forEach(function(i) {
    var f = Object.getOwnPropertyDescriptor(t, i);
    Object.defineProperty(r, i, f.get ? f : {
      enumerable: !0,
      get: function() {
        return t[i];
      }
    });
  }), r;
}
var p1 = { exports: {} }, Mo = {};
/**
 * @license React
 * react-jsx-runtime.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var $g;
function QM() {
  if ($g)
    return Mo;
  $g = 1;
  var t = nr, e = Symbol.for("react.element"), r = Symbol.for("react.fragment"), i = Object.prototype.hasOwnProperty, f = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED.ReactCurrentOwner, a = { key: !0, ref: !0, __self: !0, __source: !0 };
  function l(d, v, m) {
    var h, w = {}, M = null, S = null;
    m !== void 0 && (M = "" + m), v.key !== void 0 && (M = "" + v.key), v.ref !== void 0 && (S = v.ref);
    for (h in v)
      i.call(v, h) && !a.hasOwnProperty(h) && (w[h] = v[h]);
    if (d && d.defaultProps)
      for (h in v = d.defaultProps, v)
        w[h] === void 0 && (w[h] = v[h]);
    return { $$typeof: e, type: d, key: M, ref: S, props: w, _owner: f.current };
  }
  return Mo.Fragment = r, Mo.jsx = l, Mo.jsxs = l, Mo;
}
var So = {}, Vg;
function YM() {
  return Vg || (Vg = 1, It.env.NODE_ENV !== "production" && function() {
    var t = nr, e = Symbol.for("react.element"), r = Symbol.for("react.portal"), i = Symbol.for("react.fragment"), f = Symbol.for("react.strict_mode"), a = Symbol.for("react.profiler"), l = Symbol.for("react.provider"), d = Symbol.for("react.context"), v = Symbol.for("react.forward_ref"), m = Symbol.for("react.suspense"), h = Symbol.for("react.suspense_list"), w = Symbol.for("react.memo"), M = Symbol.for("react.lazy"), S = Symbol.for("react.offscreen"), E = Symbol.iterator, A = "@@iterator";
    function B(H) {
      if (H === null || typeof H != "object")
        return null;
      var ye = E && H[E] || H[A];
      return typeof ye == "function" ? ye : null;
    }
    var k = t.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;
    function C(H) {
      {
        for (var ye = arguments.length, ce = new Array(ye > 1 ? ye - 1 : 0), we = 1; we < ye; we++)
          ce[we - 1] = arguments[we];
        I("error", H, ce);
      }
    }
    function I(H, ye, ce) {
      {
        var we = k.ReactDebugCurrentFrame, Qe = we.getStackAddendum();
        Qe !== "" && (ye += "%s", ce = ce.concat([Qe]));
        var Ze = ce.map(function(lt) {
          return String(lt);
        });
        Ze.unshift("Warning: " + ye), Function.prototype.apply.call(console[H], console, Ze);
      }
    }
    var O = !1, q = !1, $ = !1, ae = !1, he = !1, te;
    te = Symbol.for("react.module.reference");
    function Ee(H) {
      return !!(typeof H == "string" || typeof H == "function" || H === i || H === a || he || H === f || H === m || H === h || ae || H === S || O || q || $ || typeof H == "object" && H !== null && (H.$$typeof === M || H.$$typeof === w || H.$$typeof === l || H.$$typeof === d || H.$$typeof === v || // This needs to include all possible module reference object
      // types supported by any Flight configuration anywhere since
      // we don't know which Flight build this will end up being used
      // with.
      H.$$typeof === te || H.getModuleId !== void 0));
    }
    function x(H, ye, ce) {
      var we = H.displayName;
      if (we)
        return we;
      var Qe = ye.displayName || ye.name || "";
      return Qe !== "" ? ce + "(" + Qe + ")" : ce;
    }
    function n(H) {
      return H.displayName || "Context";
    }
    function o(H) {
      if (H == null)
        return null;
      if (typeof H.tag == "number" && C("Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."), typeof H == "function")
        return H.displayName || H.name || null;
      if (typeof H == "string")
        return H;
      switch (H) {
        case i:
          return "Fragment";
        case r:
          return "Portal";
        case a:
          return "Profiler";
        case f:
          return "StrictMode";
        case m:
          return "Suspense";
        case h:
          return "SuspenseList";
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case d:
            var ye = H;
            return n(ye) + ".Consumer";
          case l:
            var ce = H;
            return n(ce._context) + ".Provider";
          case v:
            return x(H, H.render, "ForwardRef");
          case w:
            var we = H.displayName || null;
            return we !== null ? we : o(H.type) || "Memo";
          case M: {
            var Qe = H, Ze = Qe._payload, lt = Qe._init;
            try {
              return o(lt(Ze));
            } catch {
              return null;
            }
          }
        }
      return null;
    }
    var u = Object.assign, c = 0, g, b, _, p, s, y, T;
    function P() {
    }
    P.__reactDisabledLog = !0;
    function z() {
      {
        if (c === 0) {
          g = console.log, b = console.info, _ = console.warn, p = console.error, s = console.group, y = console.groupCollapsed, T = console.groupEnd;
          var H = {
            configurable: !0,
            enumerable: !0,
            value: P,
            writable: !0
          };
          Object.defineProperties(console, {
            info: H,
            log: H,
            warn: H,
            error: H,
            group: H,
            groupCollapsed: H,
            groupEnd: H
          });
        }
        c++;
      }
    }
    function J() {
      {
        if (c--, c === 0) {
          var H = {
            configurable: !0,
            enumerable: !0,
            writable: !0
          };
          Object.defineProperties(console, {
            log: u({}, H, {
              value: g
            }),
            info: u({}, H, {
              value: b
            }),
            warn: u({}, H, {
              value: _
            }),
            error: u({}, H, {
              value: p
            }),
            group: u({}, H, {
              value: s
            }),
            groupCollapsed: u({}, H, {
              value: y
            }),
            groupEnd: u({}, H, {
              value: T
            })
          });
        }
        c < 0 && C("disabledDepth fell below zero. This is a bug in React. Please file an issue.");
      }
    }
    var Z = k.ReactCurrentDispatcher, F;
    function ee(H, ye, ce) {
      {
        if (F === void 0)
          try {
            throw Error();
          } catch (Qe) {
            var we = Qe.stack.trim().match(/\n( *(at )?)/);
            F = we && we[1] || "";
          }
        return `
` + F + H;
      }
    }
    var re = !1, de;
    {
      var se = typeof WeakMap == "function" ? WeakMap : Map;
      de = new se();
    }
    function Q(H, ye) {
      if (!H || re)
        return "";
      {
        var ce = de.get(H);
        if (ce !== void 0)
          return ce;
      }
      var we;
      re = !0;
      var Qe = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var Ze;
      Ze = Z.current, Z.current = null, z();
      try {
        if (ye) {
          var lt = function() {
            throw Error();
          };
          if (Object.defineProperty(lt.prototype, "props", {
            set: function() {
              throw Error();
            }
          }), typeof Reflect == "object" && Reflect.construct) {
            try {
              Reflect.construct(lt, []);
            } catch (mt) {
              we = mt;
            }
            Reflect.construct(H, [], lt);
          } else {
            try {
              lt.call();
            } catch (mt) {
              we = mt;
            }
            H.call(lt.prototype);
          }
        } else {
          try {
            throw Error();
          } catch (mt) {
            we = mt;
          }
          H();
        }
      } catch (mt) {
        if (mt && we && typeof mt.stack == "string") {
          for (var Xe = mt.stack.split(`
`), ht = we.stack.split(`
`), ct = Xe.length - 1, pt = ht.length - 1; ct >= 1 && pt >= 0 && Xe[ct] !== ht[pt]; )
            pt--;
          for (; ct >= 1 && pt >= 0; ct--, pt--)
            if (Xe[ct] !== ht[pt]) {
              if (ct !== 1 || pt !== 1)
                do
                  if (ct--, pt--, pt < 0 || Xe[ct] !== ht[pt]) {
                    var yt = `
` + Xe[ct].replace(" at new ", " at ");
                    return H.displayName && yt.includes("<anonymous>") && (yt = yt.replace("<anonymous>", H.displayName)), typeof H == "function" && de.set(H, yt), yt;
                  }
                while (ct >= 1 && pt >= 0);
              break;
            }
        }
      } finally {
        re = !1, Z.current = Ze, J(), Error.prepareStackTrace = Qe;
      }
      var bt = H ? H.displayName || H.name : "", wt = bt ? ee(bt) : "";
      return typeof H == "function" && de.set(H, wt), wt;
    }
    function ge(H, ye, ce) {
      return Q(H, !1);
    }
    function Ye(H) {
      var ye = H.prototype;
      return !!(ye && ye.isReactComponent);
    }
    function Ce(H, ye, ce) {
      if (H == null)
        return "";
      if (typeof H == "function")
        return Q(H, Ye(H));
      if (typeof H == "string")
        return ee(H);
      switch (H) {
        case m:
          return ee("Suspense");
        case h:
          return ee("SuspenseList");
      }
      if (typeof H == "object")
        switch (H.$$typeof) {
          case v:
            return ge(H.render);
          case w:
            return Ce(H.type, ye, ce);
          case M: {
            var we = H, Qe = we._payload, Ze = we._init;
            try {
              return Ce(Ze(Qe), ye, ce);
            } catch {
            }
          }
        }
      return "";
    }
    var Be = Object.prototype.hasOwnProperty, st = {}, De = k.ReactDebugCurrentFrame;
    function _e(H) {
      if (H) {
        var ye = H._owner, ce = Ce(H.type, H._source, ye ? ye.type : null);
        De.setExtraStackFrame(ce);
      } else
        De.setExtraStackFrame(null);
    }
    function St(H, ye, ce, we, Qe) {
      {
        var Ze = Function.call.bind(Be);
        for (var lt in H)
          if (Ze(H, lt)) {
            var Xe = void 0;
            try {
              if (typeof H[lt] != "function") {
                var ht = Error((we || "React class") + ": " + ce + " type `" + lt + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof H[lt] + "`.This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.");
                throw ht.name = "Invariant Violation", ht;
              }
              Xe = H[lt](ye, lt, we, ce, null, "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED");
            } catch (ct) {
              Xe = ct;
            }
            Xe && !(Xe instanceof Error) && (_e(Qe), C("%s: type specification of %s `%s` is invalid; the type checker function must return `null` or an `Error` but returned a %s. You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument).", we || "React class", ce, lt, typeof Xe), _e(null)), Xe instanceof Error && !(Xe.message in st) && (st[Xe.message] = !0, _e(Qe), C("Failed %s type: %s", ce, Xe.message), _e(null));
          }
      }
    }
    var Oe = Array.isArray;
    function Fe(H) {
      return Oe(H);
    }
    function Et(H) {
      {
        var ye = typeof Symbol == "function" && Symbol.toStringTag, ce = ye && H[Symbol.toStringTag] || H.constructor.name || "Object";
        return ce;
      }
    }
    function Ue(H) {
      try {
        return oe(H), !1;
      } catch {
        return !0;
      }
    }
    function oe(H) {
      return "" + H;
    }
    function le(H) {
      if (Ue(H))
        return C("The provided key is an unsupported type %s. This value must be coerced to a string before before using it here.", Et(H)), oe(H);
    }
    var ie = k.ReactCurrentOwner, fe = {
      key: !0,
      ref: !0,
      __self: !0,
      __source: !0
    }, Te, N, R;
    R = {};
    function L(H) {
      if (Be.call(H, "ref")) {
        var ye = Object.getOwnPropertyDescriptor(H, "ref").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return H.ref !== void 0;
    }
    function V(H) {
      if (Be.call(H, "key")) {
        var ye = Object.getOwnPropertyDescriptor(H, "key").get;
        if (ye && ye.isReactWarning)
          return !1;
      }
      return H.key !== void 0;
    }
    function ne(H, ye) {
      if (typeof H.ref == "string" && ie.current && ye && ie.current.stateNode !== ye) {
        var ce = o(ie.current.type);
        R[ce] || (C('Component "%s" contains the string ref "%s". Support for string refs will be removed in a future major release. This case cannot be automatically converted to an arrow function. We ask you to manually fix this case by using useRef() or createRef() instead. Learn more about using refs safely here: https://reactjs.org/link/strict-mode-string-ref', o(ie.current.type), H.ref), R[ce] = !0);
      }
    }
    function Se(H, ye) {
      {
        var ce = function() {
          Te || (Te = !0, C("%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        ce.isReactWarning = !0, Object.defineProperty(H, "key", {
          get: ce,
          configurable: !0
        });
      }
    }
    function ue(H, ye) {
      {
        var ce = function() {
          N || (N = !0, C("%s: `ref` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://reactjs.org/link/special-props)", ye));
        };
        ce.isReactWarning = !0, Object.defineProperty(H, "ref", {
          get: ce,
          configurable: !0
        });
      }
    }
    var xe = function(H, ye, ce, we, Qe, Ze, lt) {
      var Xe = {
        // This tag allows us to uniquely identify this as a React Element
        $$typeof: e,
        // Built-in properties that belong on the element
        type: H,
        key: ye,
        ref: ce,
        props: lt,
        // Record the component responsible for creating this element.
        _owner: Ze
      };
      return Xe._store = {}, Object.defineProperty(Xe._store, "validated", {
        configurable: !1,
        enumerable: !1,
        writable: !0,
        value: !1
      }), Object.defineProperty(Xe, "_self", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: we
      }), Object.defineProperty(Xe, "_source", {
        configurable: !1,
        enumerable: !1,
        writable: !1,
        value: Qe
      }), Object.freeze && (Object.freeze(Xe.props), Object.freeze(Xe)), Xe;
    };
    function He(H, ye, ce, we, Qe) {
      {
        var Ze, lt = {}, Xe = null, ht = null;
        ce !== void 0 && (le(ce), Xe = "" + ce), V(ye) && (le(ye.key), Xe = "" + ye.key), L(ye) && (ht = ye.ref, ne(ye, Qe));
        for (Ze in ye)
          Be.call(ye, Ze) && !fe.hasOwnProperty(Ze) && (lt[Ze] = ye[Ze]);
        if (H && H.defaultProps) {
          var ct = H.defaultProps;
          for (Ze in ct)
            lt[Ze] === void 0 && (lt[Ze] = ct[Ze]);
        }
        if (Xe || ht) {
          var pt = typeof H == "function" ? H.displayName || H.name || "Unknown" : H;
          Xe && Se(lt, pt), ht && ue(lt, pt);
        }
        return xe(H, Xe, ht, Qe, we, ie.current, lt);
      }
    }
    var be = k.ReactCurrentOwner, Ie = k.ReactDebugCurrentFrame;
    function rt(H) {
      if (H) {
        var ye = H._owner, ce = Ce(H.type, H._source, ye ? ye.type : null);
        Ie.setExtraStackFrame(ce);
      } else
        Ie.setExtraStackFrame(null);
    }
    var Ne;
    Ne = !1;
    function ze(H) {
      return typeof H == "object" && H !== null && H.$$typeof === e;
    }
    function kt() {
      {
        if (be.current) {
          var H = o(be.current.type);
          if (H)
            return `

Check the render method of \`` + H + "`.";
        }
        return "";
      }
    }
    function Le(H) {
      return "";
    }
    var $e = {};
    function Ot(H) {
      {
        var ye = kt();
        if (!ye) {
          var ce = typeof H == "string" ? H : H.displayName || H.name;
          ce && (ye = `

Check the top-level render call using <` + ce + ">.");
        }
        return ye;
      }
    }
    function je(H, ye) {
      {
        if (!H._store || H._store.validated || H.key != null)
          return;
        H._store.validated = !0;
        var ce = Ot(ye);
        if ($e[ce])
          return;
        $e[ce] = !0;
        var we = "";
        H && H._owner && H._owner !== be.current && (we = " It was passed a child from " + o(H._owner.type) + "."), rt(H), C('Each child in a list should have a unique "key" prop.%s%s See https://reactjs.org/link/warning-keys for more information.', ce, we), rt(null);
      }
    }
    function Ve(H, ye) {
      {
        if (typeof H != "object")
          return;
        if (Fe(H))
          for (var ce = 0; ce < H.length; ce++) {
            var we = H[ce];
            ze(we) && je(we, ye);
          }
        else if (ze(H))
          H._store && (H._store.validated = !0);
        else if (H) {
          var Qe = B(H);
          if (typeof Qe == "function" && Qe !== H.entries)
            for (var Ze = Qe.call(H), lt; !(lt = Ze.next()).done; )
              ze(lt.value) && je(lt.value, ye);
        }
      }
    }
    function Nt(H) {
      {
        var ye = H.type;
        if (ye == null || typeof ye == "string")
          return;
        var ce;
        if (typeof ye == "function")
          ce = ye.propTypes;
        else if (typeof ye == "object" && (ye.$$typeof === v || // Note: Memo only checks outer props here.
        // Inner props are checked in the reconciler.
        ye.$$typeof === w))
          ce = ye.propTypes;
        else
          return;
        if (ce) {
          var we = o(ye);
          St(ce, H.props, "prop", we, H);
        } else if (ye.PropTypes !== void 0 && !Ne) {
          Ne = !0;
          var Qe = o(ye);
          C("Component %s declared `PropTypes` instead of `propTypes`. Did you misspell the property assignment?", Qe || "Unknown");
        }
        typeof ye.getDefaultProps == "function" && !ye.getDefaultProps.isReactClassApproved && C("getDefaultProps is only used on classic React.createClass definitions. Use a static property named `defaultProps` instead.");
      }
    }
    function qe(H) {
      {
        for (var ye = Object.keys(H.props), ce = 0; ce < ye.length; ce++) {
          var we = ye[ce];
          if (we !== "children" && we !== "key") {
            rt(H), C("Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.", we), rt(null);
            break;
          }
        }
        H.ref !== null && (rt(H), C("Invalid attribute `ref` supplied to `React.Fragment`."), rt(null));
      }
    }
    var Ke = {};
    function K(H, ye, ce, we, Qe, Ze) {
      {
        var lt = Ee(H);
        if (!lt) {
          var Xe = "";
          (H === void 0 || typeof H == "object" && H !== null && Object.keys(H).length === 0) && (Xe += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.");
          var ht = Le();
          ht ? Xe += ht : Xe += kt();
          var ct;
          H === null ? ct = "null" : Fe(H) ? ct = "array" : H !== void 0 && H.$$typeof === e ? (ct = "<" + (o(H.type) || "Unknown") + " />", Xe = " Did you accidentally export a JSX literal instead of a component?") : ct = typeof H, C("React.jsx: type is invalid -- expected a string (for built-in components) or a class/function (for composite components) but got: %s.%s", ct, Xe);
        }
        var pt = He(H, ye, ce, Qe, Ze);
        if (pt == null)
          return pt;
        if (lt) {
          var yt = ye.children;
          if (yt !== void 0)
            if (we)
              if (Fe(yt)) {
                for (var bt = 0; bt < yt.length; bt++)
                  Ve(yt[bt], H);
                Object.freeze && Object.freeze(yt);
              } else
                C("React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead.");
            else
              Ve(yt, H);
        }
        if (Be.call(ye, "key")) {
          var wt = o(H), mt = Object.keys(ye).filter(function(at) {
            return at !== "key";
          }), ft = mt.length > 0 ? "{key: someKey, " + mt.join(": ..., ") + ": ...}" : "{key: someKey}";
          if (!Ke[wt + ft]) {
            var gt = mt.length > 0 ? "{" + mt.join(": ..., ") + ": ...}" : "{}";
            C(`A props object containing a "key" prop is being spread into JSX:
  let props = %s;
  <%s {...props} />
React keys must be passed directly to JSX without using spread:
  let props = %s;
  <%s key={someKey} {...props} />`, ft, wt, gt, wt), Ke[wt + ft] = !0;
          }
        }
        return H === i ? qe(pt) : Nt(pt), pt;
      }
    }
    function W(H, ye, ce) {
      return K(H, ye, ce, !0);
    }
    function G(H, ye, ce) {
      return K(H, ye, ce, !1);
    }
    var U = G, X = W;
    So.Fragment = i, So.jsx = U, So.jsxs = X;
  }()), So;
}
It.env.NODE_ENV === "production" ? p1.exports = QM() : p1.exports = YM();
var tt = p1.exports, v1 = function(t, e) {
  return v1 = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(r, i) {
    r.__proto__ = i;
  } || function(r, i) {
    for (var f in i)
      Object.prototype.hasOwnProperty.call(i, f) && (r[f] = i[f]);
  }, v1(t, e);
};
function Fn(t, e) {
  if (typeof e != "function" && e !== null)
    throw new TypeError("Class extends value " + String(e) + " is not a constructor or null");
  v1(t, e);
  function r() {
    this.constructor = t;
  }
  t.prototype = e === null ? Object.create(e) : (r.prototype = e.prototype, new r());
}
var We = function() {
  return We = Object.assign || function(e) {
    for (var r, i = 1, f = arguments.length; i < f; i++) {
      r = arguments[i];
      for (var a in r)
        Object.prototype.hasOwnProperty.call(r, a) && (e[a] = r[a]);
    }
    return e;
  }, We.apply(this, arguments);
};
function ti(t, e) {
  var r = {};
  for (var i in t)
    Object.prototype.hasOwnProperty.call(t, i) && e.indexOf(i) < 0 && (r[i] = t[i]);
  if (t != null && typeof Object.getOwnPropertySymbols == "function")
    for (var f = 0, i = Object.getOwnPropertySymbols(t); f < i.length; f++)
      e.indexOf(i[f]) < 0 && Object.prototype.propertyIsEnumerable.call(t, i[f]) && (r[i[f]] = t[i[f]]);
  return r;
}
function zi(t, e, r, i) {
  function f(a) {
    return a instanceof r ? a : new r(function(l) {
      l(a);
    });
  }
  return new (r || (r = Promise))(function(a, l) {
    function d(h) {
      try {
        m(i.next(h));
      } catch (w) {
        l(w);
      }
    }
    function v(h) {
      try {
        m(i.throw(h));
      } catch (w) {
        l(w);
      }
    }
    function m(h) {
      h.done ? a(h.value) : f(h.value).then(d, v);
    }
    m((i = i.apply(t, e || [])).next());
  });
}
function ji(t, e) {
  var r = { label: 0, sent: function() {
    if (a[0] & 1)
      throw a[1];
    return a[1];
  }, trys: [], ops: [] }, i, f, a, l;
  return l = { next: d(0), throw: d(1), return: d(2) }, typeof Symbol == "function" && (l[Symbol.iterator] = function() {
    return this;
  }), l;
  function d(m) {
    return function(h) {
      return v([m, h]);
    };
  }
  function v(m) {
    if (i)
      throw new TypeError("Generator is already executing.");
    for (; l && (l = 0, m[0] && (r = 0)), r; )
      try {
        if (i = 1, f && (a = m[0] & 2 ? f.return : m[0] ? f.throw || ((a = f.return) && a.call(f), 0) : f.next) && !(a = a.call(f, m[1])).done)
          return a;
        switch (f = 0, a && (m = [m[0] & 2, a.value]), m[0]) {
          case 0:
          case 1:
            a = m;
            break;
          case 4:
            return r.label++, { value: m[1], done: !1 };
          case 5:
            r.label++, f = m[1], m = [0];
            continue;
          case 7:
            m = r.ops.pop(), r.trys.pop();
            continue;
          default:
            if (a = r.trys, !(a = a.length > 0 && a[a.length - 1]) && (m[0] === 6 || m[0] === 2)) {
              r = 0;
              continue;
            }
            if (m[0] === 3 && (!a || m[1] > a[0] && m[1] < a[3])) {
              r.label = m[1];
              break;
            }
            if (m[0] === 6 && r.label < a[1]) {
              r.label = a[1], a = m;
              break;
            }
            if (a && r.label < a[2]) {
              r.label = a[2], r.ops.push(m);
              break;
            }
            a[2] && r.ops.pop(), r.trys.pop();
            continue;
        }
        m = e.call(t, r);
      } catch (h) {
        m = [6, h], f = 0;
      } finally {
        i = a = 0;
      }
    if (m[0] & 5)
      throw m[1];
    return { value: m[0] ? m[1] : void 0, done: !0 };
  }
}
function On(t, e, r) {
  if (r || arguments.length === 2)
    for (var i = 0, f = e.length, a; i < f; i++)
      (a || !(i in e)) && (a || (a = Array.prototype.slice.call(e, 0, i)), a[i] = e[i]);
  return t.concat(a || Array.prototype.slice.call(e));
}
var yd = "Invariant Violation", Hg = Object.setPrototypeOf, JM = Hg === void 0 ? function(t, e) {
  return t.__proto__ = e, t;
} : Hg, O5 = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      r === void 0 && (r = yd);
      var i = t.call(this, typeof r == "number" ? yd + ": " + r + " (see https://github.com/apollographql/invariant-packages)" : r) || this;
      return i.framesToPop = 1, i.name = yd, JM(i, e.prototype), i;
    }
    return e;
  }(Error)
);
function Ia(t, e) {
  if (!t)
    throw new O5(e);
}
var N5 = ["debug", "log", "warn", "error", "silent"], XM = N5.indexOf("log");
function uu(t) {
  return function() {
    if (N5.indexOf(t) >= XM) {
      var e = console[t] || console.log;
      return e.apply(console, arguments);
    }
  };
}
(function(t) {
  t.debug = uu("debug"), t.log = uu("log"), t.warn = uu("warn"), t.error = uu("error");
})(Ia || (Ia = {}));
var Rv = "3.10.3";
const Gi = globalThis || void 0 || self;
function Rn(t) {
  try {
    return t();
  } catch {
  }
}
const m1 = Rn(function() {
  return globalThis;
}) || Rn(function() {
  return window;
}) || Rn(function() {
  return self;
}) || Rn(function() {
  return Gi;
}) || // We don't expect the Function constructor ever to be invoked at runtime, as
// long as at least one of globalThis, window, self, or global is defined, so
// we are under no obligation to make it easy for static analysis tools to
// detect syntactic usage of the Function constructor. If you think you can
// improve your static analysis to detect this obfuscation, think again. This
// is an arms race you cannot win, at least not in JavaScript.
Rn(function() {
  return Rn.constructor("return this")();
});
var Wg = /* @__PURE__ */ new Map();
function g1(t) {
  var e = Wg.get(t) || 1;
  return Wg.set(t, e + 1), "".concat(t, ":").concat(e, ":").concat(Math.random().toString(36).slice(2));
}
function D5(t, e) {
  e === void 0 && (e = 0);
  var r = g1("stringifyForDisplay");
  return JSON.stringify(t, function(i, f) {
    return f === void 0 ? r : f;
  }, e).split(JSON.stringify(r)).join("<undefined>");
}
function lu(t) {
  return function(e) {
    for (var r = [], i = 1; i < arguments.length; i++)
      r[i - 1] = arguments[i];
    if (typeof e == "number") {
      var f = e;
      e = Pv(f), e || (e = Ov(f, r), r = []);
    }
    t.apply(void 0, [e].concat(r));
  };
}
var Rt = Object.assign(function(e, r) {
  for (var i = [], f = 2; f < arguments.length; f++)
    i[f - 2] = arguments[f];
  e || Ia(e, Pv(r, i) || Ov(r, i));
}, {
  debug: lu(Ia.debug),
  log: lu(Ia.log),
  warn: lu(Ia.warn),
  error: lu(Ia.error)
});
function Gr(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  return new O5(Pv(t, e) || Ov(t, e));
}
var Kg = Symbol.for("ApolloErrorMessageHandler_" + Rv);
function U5(t) {
  return typeof t == "string" ? t : D5(t, 2).slice(0, 1e3);
}
function Pv(t, e) {
  if (e === void 0 && (e = []), !!t)
    return m1[Kg] && m1[Kg](t, e.map(U5));
}
function Ov(t, e) {
  if (e === void 0 && (e = []), !!t)
    return "An error occurred! For more details, see the full error text at https://go.apollo.dev/c/err#".concat(encodeURIComponent(JSON.stringify({
      version: Rv,
      message: t,
      args: e.map(U5)
    })));
}
function Lu(t, e) {
  if (!!!t)
    throw new Error(e);
}
function eS(t) {
  return typeof t == "object" && t !== null;
}
function tS(t, e) {
  if (!!!t)
    throw new Error(
      "Unexpected invariant triggered."
    );
}
const rS = /\r\n|[\n\r]/g;
function y1(t, e) {
  let r = 0, i = 1;
  for (const f of t.body.matchAll(rS)) {
    if (typeof f.index == "number" || tS(!1), f.index >= e)
      break;
    r = f.index + f[0].length, i += 1;
  }
  return {
    line: i,
    column: e + 1 - r
  };
}
function nS(t) {
  return L5(
    t.source,
    y1(t.source, t.start)
  );
}
function L5(t, e) {
  const r = t.locationOffset.column - 1, i = "".padStart(r) + t.body, f = e.line - 1, a = t.locationOffset.line - 1, l = e.line + a, d = e.line === 1 ? r : 0, v = e.column + d, m = `${t.name}:${l}:${v}
`, h = i.split(/\r\n|[\n\r]/g), w = h[f];
  if (w.length > 120) {
    const M = Math.floor(v / 80), S = v % 80, E = [];
    for (let A = 0; A < w.length; A += 80)
      E.push(w.slice(A, A + 80));
    return m + Zg([
      [`${l} |`, E[0]],
      ...E.slice(1, M + 1).map((A) => ["|", A]),
      ["|", "^".padStart(S)],
      ["|", E[M + 1]]
    ]);
  }
  return m + Zg([
    // Lines specified like this: ["prefix", "string"],
    [`${l - 1} |`, h[f - 1]],
    [`${l} |`, w],
    ["|", "^".padStart(v)],
    [`${l + 1} |`, h[f + 1]]
  ]);
}
function Zg(t) {
  const e = t.filter(([i, f]) => f !== void 0), r = Math.max(...e.map(([i]) => i.length));
  return e.map(([i, f]) => i.padStart(r) + (f ? " " + f : "")).join(`
`);
}
function iS(t) {
  const e = t[0];
  return e == null || "kind" in e || "length" in e ? {
    nodes: e,
    source: t[1],
    positions: t[2],
    path: t[3],
    originalError: t[4],
    extensions: t[5]
  } : e;
}
class Nv extends Error {
  /**
   * An array of `{ line, column }` locations within the source GraphQL document
   * which correspond to this error.
   *
   * Errors during validation often contain multiple locations, for example to
   * point out two things with the same name. Errors during execution include a
   * single location, the field which produced the error.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array describing the JSON-path into the execution response which
   * corresponds to this error. Only included for errors during execution.
   *
   * Enumerable, and appears in the result of JSON.stringify().
   */
  /**
   * An array of GraphQL AST Nodes corresponding to this error.
   */
  /**
   * The source GraphQL document for the first location of this error.
   *
   * Note that if this Error represents more than one node, the source may not
   * represent nodes after the first node.
   */
  /**
   * An array of character offsets within the source GraphQL document
   * which correspond to this error.
   */
  /**
   * The original error thrown from a field resolver during execution.
   */
  /**
   * Extension fields to add to the formatted error.
   */
  /**
   * @deprecated Please use the `GraphQLErrorOptions` constructor overload instead.
   */
  constructor(e, ...r) {
    var i, f, a;
    const { nodes: l, source: d, positions: v, path: m, originalError: h, extensions: w } = iS(r);
    super(e), this.name = "GraphQLError", this.path = m ?? void 0, this.originalError = h ?? void 0, this.nodes = Gg(
      Array.isArray(l) ? l : l ? [l] : void 0
    );
    const M = Gg(
      (i = this.nodes) === null || i === void 0 ? void 0 : i.map((E) => E.loc).filter((E) => E != null)
    );
    this.source = d ?? (M == null || (f = M[0]) === null || f === void 0 ? void 0 : f.source), this.positions = v ?? (M == null ? void 0 : M.map((E) => E.start)), this.locations = v && d ? v.map((E) => y1(d, E)) : M == null ? void 0 : M.map((E) => y1(E.source, E.start));
    const S = eS(
      h == null ? void 0 : h.extensions
    ) ? h == null ? void 0 : h.extensions : void 0;
    this.extensions = (a = w ?? S) !== null && a !== void 0 ? a : /* @__PURE__ */ Object.create(null), Object.defineProperties(this, {
      message: {
        writable: !0,
        enumerable: !0
      },
      name: {
        enumerable: !1
      },
      nodes: {
        enumerable: !1
      },
      source: {
        enumerable: !1
      },
      positions: {
        enumerable: !1
      },
      originalError: {
        enumerable: !1
      }
    }), h != null && h.stack ? Object.defineProperty(this, "stack", {
      value: h.stack,
      writable: !0,
      configurable: !0
    }) : Error.captureStackTrace ? Error.captureStackTrace(this, Nv) : Object.defineProperty(this, "stack", {
      value: Error().stack,
      writable: !0,
      configurable: !0
    });
  }
  get [Symbol.toStringTag]() {
    return "GraphQLError";
  }
  toString() {
    let e = this.message;
    if (this.nodes)
      for (const r of this.nodes)
        r.loc && (e += `

` + nS(r.loc));
    else if (this.source && this.locations)
      for (const r of this.locations)
        e += `

` + L5(this.source, r);
    return e;
  }
  toJSON() {
    const e = {
      message: this.message
    };
    return this.locations != null && (e.locations = this.locations), this.path != null && (e.path = this.path), this.extensions != null && Object.keys(this.extensions).length > 0 && (e.extensions = this.extensions), e;
  }
}
function Gg(t) {
  return t === void 0 || t.length === 0 ? void 0 : t;
}
function Br(t, e, r) {
  return new Nv(`Syntax Error: ${r}`, {
    source: t,
    positions: [e]
  });
}
class aS {
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The Token at which this Node begins.
   */
  /**
   * The Token at which this Node ends.
   */
  /**
   * The Source document the AST represents.
   */
  constructor(e, r, i) {
    this.start = e.start, this.end = r.end, this.startToken = e, this.endToken = r, this.source = i;
  }
  get [Symbol.toStringTag]() {
    return "Location";
  }
  toJSON() {
    return {
      start: this.start,
      end: this.end
    };
  }
}
class F5 {
  /**
   * The kind of Token.
   */
  /**
   * The character offset at which this Node begins.
   */
  /**
   * The character offset at which this Node ends.
   */
  /**
   * The 1-indexed line number on which this Token appears.
   */
  /**
   * The 1-indexed column number at which this Token begins.
   */
  /**
   * For non-punctuation tokens, represents the interpreted value of the token.
   *
   * Note: is undefined for punctuation tokens, but typed as string for
   * convenience in the parser.
   */
  /**
   * Tokens exist as nodes in a double-linked-list amongst all tokens
   * including ignored tokens. <SOF> is always the first node and <EOF>
   * the last.
   */
  constructor(e, r, i, f, a, l) {
    this.kind = e, this.start = r, this.end = i, this.line = f, this.column = a, this.value = l, this.prev = null, this.next = null;
  }
  get [Symbol.toStringTag]() {
    return "Token";
  }
  toJSON() {
    return {
      kind: this.kind,
      value: this.value,
      line: this.line,
      column: this.column
    };
  }
}
const q5 = {
  Name: [],
  Document: ["definitions"],
  OperationDefinition: [
    "name",
    "variableDefinitions",
    "directives",
    "selectionSet"
  ],
  VariableDefinition: ["variable", "type", "defaultValue", "directives"],
  Variable: ["name"],
  SelectionSet: ["selections"],
  Field: ["alias", "name", "arguments", "directives", "selectionSet"],
  Argument: ["name", "value"],
  FragmentSpread: ["name", "directives"],
  InlineFragment: ["typeCondition", "directives", "selectionSet"],
  FragmentDefinition: [
    "name",
    // Note: fragment variable definitions are deprecated and will removed in v17.0.0
    "variableDefinitions",
    "typeCondition",
    "directives",
    "selectionSet"
  ],
  IntValue: [],
  FloatValue: [],
  StringValue: [],
  BooleanValue: [],
  NullValue: [],
  EnumValue: [],
  ListValue: ["values"],
  ObjectValue: ["fields"],
  ObjectField: ["name", "value"],
  Directive: ["name", "arguments"],
  NamedType: ["name"],
  ListType: ["type"],
  NonNullType: ["type"],
  SchemaDefinition: ["description", "directives", "operationTypes"],
  OperationTypeDefinition: ["type"],
  ScalarTypeDefinition: ["description", "name", "directives"],
  ObjectTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  FieldDefinition: ["description", "name", "arguments", "type", "directives"],
  InputValueDefinition: [
    "description",
    "name",
    "type",
    "defaultValue",
    "directives"
  ],
  InterfaceTypeDefinition: [
    "description",
    "name",
    "interfaces",
    "directives",
    "fields"
  ],
  UnionTypeDefinition: ["description", "name", "directives", "types"],
  EnumTypeDefinition: ["description", "name", "directives", "values"],
  EnumValueDefinition: ["description", "name", "directives"],
  InputObjectTypeDefinition: ["description", "name", "directives", "fields"],
  DirectiveDefinition: ["description", "name", "arguments", "locations"],
  SchemaExtension: ["directives", "operationTypes"],
  ScalarTypeExtension: ["name", "directives"],
  ObjectTypeExtension: ["name", "interfaces", "directives", "fields"],
  InterfaceTypeExtension: ["name", "interfaces", "directives", "fields"],
  UnionTypeExtension: ["name", "directives", "types"],
  EnumTypeExtension: ["name", "directives", "values"],
  InputObjectTypeExtension: ["name", "directives", "fields"]
}, sS = new Set(Object.keys(q5));
function Qg(t) {
  const e = t == null ? void 0 : t.kind;
  return typeof e == "string" && sS.has(e);
}
var Bs;
(function(t) {
  t.QUERY = "query", t.MUTATION = "mutation", t.SUBSCRIPTION = "subscription";
})(Bs || (Bs = {}));
var b1;
(function(t) {
  t.QUERY = "QUERY", t.MUTATION = "MUTATION", t.SUBSCRIPTION = "SUBSCRIPTION", t.FIELD = "FIELD", t.FRAGMENT_DEFINITION = "FRAGMENT_DEFINITION", t.FRAGMENT_SPREAD = "FRAGMENT_SPREAD", t.INLINE_FRAGMENT = "INLINE_FRAGMENT", t.VARIABLE_DEFINITION = "VARIABLE_DEFINITION", t.SCHEMA = "SCHEMA", t.SCALAR = "SCALAR", t.OBJECT = "OBJECT", t.FIELD_DEFINITION = "FIELD_DEFINITION", t.ARGUMENT_DEFINITION = "ARGUMENT_DEFINITION", t.INTERFACE = "INTERFACE", t.UNION = "UNION", t.ENUM = "ENUM", t.ENUM_VALUE = "ENUM_VALUE", t.INPUT_OBJECT = "INPUT_OBJECT", t.INPUT_FIELD_DEFINITION = "INPUT_FIELD_DEFINITION";
})(b1 || (b1 = {}));
var Ct;
(function(t) {
  t.NAME = "Name", t.DOCUMENT = "Document", t.OPERATION_DEFINITION = "OperationDefinition", t.VARIABLE_DEFINITION = "VariableDefinition", t.SELECTION_SET = "SelectionSet", t.FIELD = "Field", t.ARGUMENT = "Argument", t.FRAGMENT_SPREAD = "FragmentSpread", t.INLINE_FRAGMENT = "InlineFragment", t.FRAGMENT_DEFINITION = "FragmentDefinition", t.VARIABLE = "Variable", t.INT = "IntValue", t.FLOAT = "FloatValue", t.STRING = "StringValue", t.BOOLEAN = "BooleanValue", t.NULL = "NullValue", t.ENUM = "EnumValue", t.LIST = "ListValue", t.OBJECT = "ObjectValue", t.OBJECT_FIELD = "ObjectField", t.DIRECTIVE = "Directive", t.NAMED_TYPE = "NamedType", t.LIST_TYPE = "ListType", t.NON_NULL_TYPE = "NonNullType", t.SCHEMA_DEFINITION = "SchemaDefinition", t.OPERATION_TYPE_DEFINITION = "OperationTypeDefinition", t.SCALAR_TYPE_DEFINITION = "ScalarTypeDefinition", t.OBJECT_TYPE_DEFINITION = "ObjectTypeDefinition", t.FIELD_DEFINITION = "FieldDefinition", t.INPUT_VALUE_DEFINITION = "InputValueDefinition", t.INTERFACE_TYPE_DEFINITION = "InterfaceTypeDefinition", t.UNION_TYPE_DEFINITION = "UnionTypeDefinition", t.ENUM_TYPE_DEFINITION = "EnumTypeDefinition", t.ENUM_VALUE_DEFINITION = "EnumValueDefinition", t.INPUT_OBJECT_TYPE_DEFINITION = "InputObjectTypeDefinition", t.DIRECTIVE_DEFINITION = "DirectiveDefinition", t.SCHEMA_EXTENSION = "SchemaExtension", t.SCALAR_TYPE_EXTENSION = "ScalarTypeExtension", t.OBJECT_TYPE_EXTENSION = "ObjectTypeExtension", t.INTERFACE_TYPE_EXTENSION = "InterfaceTypeExtension", t.UNION_TYPE_EXTENSION = "UnionTypeExtension", t.ENUM_TYPE_EXTENSION = "EnumTypeExtension", t.INPUT_OBJECT_TYPE_EXTENSION = "InputObjectTypeExtension";
})(Ct || (Ct = {}));
function w1(t) {
  return t === 9 || t === 32;
}
function Ef(t) {
  return t >= 48 && t <= 57;
}
function z5(t) {
  return t >= 97 && t <= 122 || // A-Z
  t >= 65 && t <= 90;
}
function j5(t) {
  return z5(t) || t === 95;
}
function oS(t) {
  return z5(t) || Ef(t) || t === 95;
}
function fS(t) {
  var e;
  let r = Number.MAX_SAFE_INTEGER, i = null, f = -1;
  for (let l = 0; l < t.length; ++l) {
    var a;
    const d = t[l], v = uS(d);
    v !== d.length && (i = (a = i) !== null && a !== void 0 ? a : l, f = l, l !== 0 && v < r && (r = v));
  }
  return t.map((l, d) => d === 0 ? l : l.slice(r)).slice(
    (e = i) !== null && e !== void 0 ? e : 0,
    f + 1
  );
}
function uS(t) {
  let e = 0;
  for (; e < t.length && w1(t.charCodeAt(e)); )
    ++e;
  return e;
}
function lS(t, e) {
  const r = t.replace(/"""/g, '\\"""'), i = r.split(/\r\n|[\n\r]/g), f = i.length === 1, a = i.length > 1 && i.slice(1).every((S) => S.length === 0 || w1(S.charCodeAt(0))), l = r.endsWith('\\"""'), d = t.endsWith('"') && !l, v = t.endsWith("\\"), m = d || v, h = (
    // add leading and trailing new lines only if it improves readability
    !f || t.length > 70 || m || a || l
  );
  let w = "";
  const M = f && w1(t.charCodeAt(0));
  return (h && !M || a) && (w += `
`), w += r, (h || m) && (w += `
`), '"""' + w + '"""';
}
var it;
(function(t) {
  t.SOF = "<SOF>", t.EOF = "<EOF>", t.BANG = "!", t.DOLLAR = "$", t.AMP = "&", t.PAREN_L = "(", t.PAREN_R = ")", t.SPREAD = "...", t.COLON = ":", t.EQUALS = "=", t.AT = "@", t.BRACKET_L = "[", t.BRACKET_R = "]", t.BRACE_L = "{", t.PIPE = "|", t.BRACE_R = "}", t.NAME = "Name", t.INT = "Int", t.FLOAT = "Float", t.STRING = "String", t.BLOCK_STRING = "BlockString", t.COMMENT = "Comment";
})(it || (it = {}));
class cS {
  /**
   * The previously focused non-ignored token.
   */
  /**
   * The currently focused non-ignored token.
   */
  /**
   * The (1-indexed) line containing the current token.
   */
  /**
   * The character offset at which the current line begins.
   */
  constructor(e) {
    const r = new F5(it.SOF, 0, 0, 0, 0);
    this.source = e, this.lastToken = r, this.token = r, this.line = 1, this.lineStart = 0;
  }
  get [Symbol.toStringTag]() {
    return "Lexer";
  }
  /**
   * Advances the token stream to the next non-ignored token.
   */
  advance() {
    return this.lastToken = this.token, this.token = this.lookahead();
  }
  /**
   * Looks ahead and returns the next non-ignored token, but does not change
   * the state of Lexer.
   */
  lookahead() {
    let e = this.token;
    if (e.kind !== it.EOF)
      do
        if (e.next)
          e = e.next;
        else {
          const r = hS(this, e.end);
          e.next = r, r.prev = e, e = r;
        }
      while (e.kind === it.COMMENT);
    return e;
  }
}
function dS(t) {
  return t === it.BANG || t === it.DOLLAR || t === it.AMP || t === it.PAREN_L || t === it.PAREN_R || t === it.SPREAD || t === it.COLON || t === it.EQUALS || t === it.AT || t === it.BRACKET_L || t === it.BRACKET_R || t === it.BRACE_L || t === it.PIPE || t === it.BRACE_R;
}
function ao(t) {
  return t >= 0 && t <= 55295 || t >= 57344 && t <= 1114111;
}
function zl(t, e) {
  return $5(t.charCodeAt(e)) && V5(t.charCodeAt(e + 1));
}
function $5(t) {
  return t >= 55296 && t <= 56319;
}
function V5(t) {
  return t >= 56320 && t <= 57343;
}
function La(t, e) {
  const r = t.source.body.codePointAt(e);
  if (r === void 0)
    return it.EOF;
  if (r >= 32 && r <= 126) {
    const i = String.fromCodePoint(r);
    return i === '"' ? `'"'` : `"${i}"`;
  }
  return "U+" + r.toString(16).toUpperCase().padStart(4, "0");
}
function Mr(t, e, r, i, f) {
  const a = t.line, l = 1 + r - t.lineStart;
  return new F5(e, r, i, a, l, f);
}
function hS(t, e) {
  const r = t.source.body, i = r.length;
  let f = e;
  for (; f < i; ) {
    const a = r.charCodeAt(f);
    switch (a) {
      case 65279:
      case 9:
      case 32:
      case 44:
        ++f;
        continue;
      case 10:
        ++f, ++t.line, t.lineStart = f;
        continue;
      case 13:
        r.charCodeAt(f + 1) === 10 ? f += 2 : ++f, ++t.line, t.lineStart = f;
        continue;
      case 35:
        return pS(t, f);
      case 33:
        return Mr(t, it.BANG, f, f + 1);
      case 36:
        return Mr(t, it.DOLLAR, f, f + 1);
      case 38:
        return Mr(t, it.AMP, f, f + 1);
      case 40:
        return Mr(t, it.PAREN_L, f, f + 1);
      case 41:
        return Mr(t, it.PAREN_R, f, f + 1);
      case 46:
        if (r.charCodeAt(f + 1) === 46 && r.charCodeAt(f + 2) === 46)
          return Mr(t, it.SPREAD, f, f + 3);
        break;
      case 58:
        return Mr(t, it.COLON, f, f + 1);
      case 61:
        return Mr(t, it.EQUALS, f, f + 1);
      case 64:
        return Mr(t, it.AT, f, f + 1);
      case 91:
        return Mr(t, it.BRACKET_L, f, f + 1);
      case 93:
        return Mr(t, it.BRACKET_R, f, f + 1);
      case 123:
        return Mr(t, it.BRACE_L, f, f + 1);
      case 124:
        return Mr(t, it.PIPE, f, f + 1);
      case 125:
        return Mr(t, it.BRACE_R, f, f + 1);
      case 34:
        return r.charCodeAt(f + 1) === 34 && r.charCodeAt(f + 2) === 34 ? wS(t, f) : mS(t, f);
    }
    if (Ef(a) || a === 45)
      return vS(t, f, a);
    if (j5(a))
      return _S(t, f);
    throw Br(
      t.source,
      f,
      a === 39 ? `Unexpected single quote character ('), did you mean to use a double quote (")?` : ao(a) || zl(r, f) ? `Unexpected character: ${La(t, f)}.` : `Invalid character: ${La(t, f)}.`
    );
  }
  return Mr(t, it.EOF, i, i);
}
function pS(t, e) {
  const r = t.source.body, i = r.length;
  let f = e + 1;
  for (; f < i; ) {
    const a = r.charCodeAt(f);
    if (a === 10 || a === 13)
      break;
    if (ao(a))
      ++f;
    else if (zl(r, f))
      f += 2;
    else
      break;
  }
  return Mr(
    t,
    it.COMMENT,
    e,
    f,
    r.slice(e + 1, f)
  );
}
function vS(t, e, r) {
  const i = t.source.body;
  let f = e, a = r, l = !1;
  if (a === 45 && (a = i.charCodeAt(++f)), a === 48) {
    if (a = i.charCodeAt(++f), Ef(a))
      throw Br(
        t.source,
        f,
        `Invalid number, unexpected digit after 0: ${La(
          t,
          f
        )}.`
      );
  } else
    f = bd(t, f, a), a = i.charCodeAt(f);
  if (a === 46 && (l = !0, a = i.charCodeAt(++f), f = bd(t, f, a), a = i.charCodeAt(f)), (a === 69 || a === 101) && (l = !0, a = i.charCodeAt(++f), (a === 43 || a === 45) && (a = i.charCodeAt(++f)), f = bd(t, f, a), a = i.charCodeAt(f)), a === 46 || j5(a))
    throw Br(
      t.source,
      f,
      `Invalid number, expected digit but got: ${La(
        t,
        f
      )}.`
    );
  return Mr(
    t,
    l ? it.FLOAT : it.INT,
    e,
    f,
    i.slice(e, f)
  );
}
function bd(t, e, r) {
  if (!Ef(r))
    throw Br(
      t.source,
      e,
      `Invalid number, expected digit but got: ${La(
        t,
        e
      )}.`
    );
  const i = t.source.body;
  let f = e + 1;
  for (; Ef(i.charCodeAt(f)); )
    ++f;
  return f;
}
function mS(t, e) {
  const r = t.source.body, i = r.length;
  let f = e + 1, a = f, l = "";
  for (; f < i; ) {
    const d = r.charCodeAt(f);
    if (d === 34)
      return l += r.slice(a, f), Mr(t, it.STRING, e, f + 1, l);
    if (d === 92) {
      l += r.slice(a, f);
      const v = r.charCodeAt(f + 1) === 117 ? r.charCodeAt(f + 2) === 123 ? gS(t, f) : yS(t, f) : bS(t, f);
      l += v.value, f += v.size, a = f;
      continue;
    }
    if (d === 10 || d === 13)
      break;
    if (ao(d))
      ++f;
    else if (zl(r, f))
      f += 2;
    else
      throw Br(
        t.source,
        f,
        `Invalid character within String: ${La(
          t,
          f
        )}.`
      );
  }
  throw Br(t.source, f, "Unterminated string.");
}
function gS(t, e) {
  const r = t.source.body;
  let i = 0, f = 3;
  for (; f < 12; ) {
    const a = r.charCodeAt(e + f++);
    if (a === 125) {
      if (f < 5 || !ao(i))
        break;
      return {
        value: String.fromCodePoint(i),
        size: f
      };
    }
    if (i = i << 4 | af(a), i < 0)
      break;
  }
  throw Br(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${r.slice(
      e,
      e + f
    )}".`
  );
}
function yS(t, e) {
  const r = t.source.body, i = Yg(r, e + 2);
  if (ao(i))
    return {
      value: String.fromCodePoint(i),
      size: 6
    };
  if ($5(i) && r.charCodeAt(e + 6) === 92 && r.charCodeAt(e + 7) === 117) {
    const f = Yg(r, e + 8);
    if (V5(f))
      return {
        value: String.fromCodePoint(i, f),
        size: 12
      };
  }
  throw Br(
    t.source,
    e,
    `Invalid Unicode escape sequence: "${r.slice(e, e + 6)}".`
  );
}
function Yg(t, e) {
  return af(t.charCodeAt(e)) << 12 | af(t.charCodeAt(e + 1)) << 8 | af(t.charCodeAt(e + 2)) << 4 | af(t.charCodeAt(e + 3));
}
function af(t) {
  return t >= 48 && t <= 57 ? t - 48 : t >= 65 && t <= 70 ? t - 55 : t >= 97 && t <= 102 ? t - 87 : -1;
}
function bS(t, e) {
  const r = t.source.body;
  switch (r.charCodeAt(e + 1)) {
    case 34:
      return {
        value: '"',
        size: 2
      };
    case 92:
      return {
        value: "\\",
        size: 2
      };
    case 47:
      return {
        value: "/",
        size: 2
      };
    case 98:
      return {
        value: "\b",
        size: 2
      };
    case 102:
      return {
        value: "\f",
        size: 2
      };
    case 110:
      return {
        value: `
`,
        size: 2
      };
    case 114:
      return {
        value: "\r",
        size: 2
      };
    case 116:
      return {
        value: "	",
        size: 2
      };
  }
  throw Br(
    t.source,
    e,
    `Invalid character escape sequence: "${r.slice(
      e,
      e + 2
    )}".`
  );
}
function wS(t, e) {
  const r = t.source.body, i = r.length;
  let f = t.lineStart, a = e + 3, l = a, d = "";
  const v = [];
  for (; a < i; ) {
    const m = r.charCodeAt(a);
    if (m === 34 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34) {
      d += r.slice(l, a), v.push(d);
      const h = Mr(
        t,
        it.BLOCK_STRING,
        e,
        a + 3,
        // Return a string of the lines joined with U+000A.
        fS(v).join(`
`)
      );
      return t.line += v.length - 1, t.lineStart = f, h;
    }
    if (m === 92 && r.charCodeAt(a + 1) === 34 && r.charCodeAt(a + 2) === 34 && r.charCodeAt(a + 3) === 34) {
      d += r.slice(l, a), l = a + 1, a += 4;
      continue;
    }
    if (m === 10 || m === 13) {
      d += r.slice(l, a), v.push(d), m === 13 && r.charCodeAt(a + 1) === 10 ? a += 2 : ++a, d = "", l = a, f = a;
      continue;
    }
    if (ao(m))
      ++a;
    else if (zl(r, a))
      a += 2;
    else
      throw Br(
        t.source,
        a,
        `Invalid character within String: ${La(
          t,
          a
        )}.`
      );
  }
  throw Br(t.source, a, "Unterminated string.");
}
function _S(t, e) {
  const r = t.source.body, i = r.length;
  let f = e + 1;
  for (; f < i; ) {
    const a = r.charCodeAt(f);
    if (oS(a))
      ++f;
    else
      break;
  }
  return Mr(
    t,
    it.NAME,
    e,
    f,
    r.slice(e, f)
  );
}
const xS = 10, H5 = 2;
function Dv(t) {
  return jl(t, []);
}
function jl(t, e) {
  switch (typeof t) {
    case "string":
      return JSON.stringify(t);
    case "function":
      return t.name ? `[function ${t.name}]` : "[function]";
    case "object":
      return MS(t, e);
    default:
      return String(t);
  }
}
function MS(t, e) {
  if (t === null)
    return "null";
  if (e.includes(t))
    return "[Circular]";
  const r = [...e, t];
  if (SS(t)) {
    const i = t.toJSON();
    if (i !== t)
      return typeof i == "string" ? i : jl(i, r);
  } else if (Array.isArray(t))
    return AS(t, r);
  return ES(t, r);
}
function SS(t) {
  return typeof t.toJSON == "function";
}
function ES(t, e) {
  const r = Object.entries(t);
  return r.length === 0 ? "{}" : e.length > H5 ? "[" + kS(t) + "]" : "{ " + r.map(
    ([f, a]) => f + ": " + jl(a, e)
  ).join(", ") + " }";
}
function AS(t, e) {
  if (t.length === 0)
    return "[]";
  if (e.length > H5)
    return "[Array]";
  const r = Math.min(xS, t.length), i = t.length - r, f = [];
  for (let a = 0; a < r; ++a)
    f.push(jl(t[a], e));
  return i === 1 ? f.push("... 1 more item") : i > 1 && f.push(`... ${i} more items`), "[" + f.join(", ") + "]";
}
function kS(t) {
  const e = Object.prototype.toString.call(t).replace(/^\[object /, "").replace(/]$/, "");
  if (e === "Object" && typeof t.constructor == "function") {
    const r = t.constructor.name;
    if (typeof r == "string" && r !== "")
      return r;
  }
  return e;
}
const TS = globalThis.process && // eslint-disable-next-line no-undef
It.env.NODE_ENV === "production", CS = (
  /* c8 ignore next 6 */
  // FIXME: https://github.com/graphql/graphql-js/issues/2317
  TS ? function(e, r) {
    return e instanceof r;
  } : function(e, r) {
    if (e instanceof r)
      return !0;
    if (typeof e == "object" && e !== null) {
      var i;
      const f = r.prototype[Symbol.toStringTag], a = (
        // We still need to support constructor's name to detect conflicts with older versions of this library.
        Symbol.toStringTag in e ? e[Symbol.toStringTag] : (i = e.constructor) === null || i === void 0 ? void 0 : i.name
      );
      if (f === a) {
        const l = Dv(e);
        throw new Error(`Cannot use ${f} "${l}" from another module or realm.

Ensure that there is only one instance of "graphql" in the node_modules
directory. If different versions of "graphql" are the dependencies of other
relied on modules, use "resolutions" to ensure only one version is installed.

https://yarnpkg.com/en/docs/selective-version-resolutions

Duplicate "graphql" modules cannot be used at the same time since different
versions may have different capabilities and behavior. The data from one
version used in the function from another could produce confusing and
spurious results.`);
      }
    }
    return !1;
  }
);
class W5 {
  constructor(e, r = "GraphQL request", i = {
    line: 1,
    column: 1
  }) {
    typeof e == "string" || Lu(!1, `Body must be a string. Received: ${Dv(e)}.`), this.body = e, this.name = r, this.locationOffset = i, this.locationOffset.line > 0 || Lu(
      !1,
      "line in locationOffset is 1-indexed and must be positive."
    ), this.locationOffset.column > 0 || Lu(
      !1,
      "column in locationOffset is 1-indexed and must be positive."
    );
  }
  get [Symbol.toStringTag]() {
    return "Source";
  }
}
function BS(t) {
  return CS(t, W5);
}
function IS(t, e) {
  return new RS(t, e).parseDocument();
}
class RS {
  constructor(e, r = {}) {
    const i = BS(e) ? e : new W5(e);
    this._lexer = new cS(i), this._options = r, this._tokenCounter = 0;
  }
  /**
   * Converts a name lex token into a name parse node.
   */
  parseName() {
    const e = this.expectToken(it.NAME);
    return this.node(e, {
      kind: Ct.NAME,
      value: e.value
    });
  }
  // Implements the parsing rules in the Document section.
  /**
   * Document : Definition+
   */
  parseDocument() {
    return this.node(this._lexer.token, {
      kind: Ct.DOCUMENT,
      definitions: this.many(
        it.SOF,
        this.parseDefinition,
        it.EOF
      )
    });
  }
  /**
   * Definition :
   *   - ExecutableDefinition
   *   - TypeSystemDefinition
   *   - TypeSystemExtension
   *
   * ExecutableDefinition :
   *   - OperationDefinition
   *   - FragmentDefinition
   *
   * TypeSystemDefinition :
   *   - SchemaDefinition
   *   - TypeDefinition
   *   - DirectiveDefinition
   *
   * TypeDefinition :
   *   - ScalarTypeDefinition
   *   - ObjectTypeDefinition
   *   - InterfaceTypeDefinition
   *   - UnionTypeDefinition
   *   - EnumTypeDefinition
   *   - InputObjectTypeDefinition
   */
  parseDefinition() {
    if (this.peek(it.BRACE_L))
      return this.parseOperationDefinition();
    const e = this.peekDescription(), r = e ? this._lexer.lookahead() : this._lexer.token;
    if (r.kind === it.NAME) {
      switch (r.value) {
        case "schema":
          return this.parseSchemaDefinition();
        case "scalar":
          return this.parseScalarTypeDefinition();
        case "type":
          return this.parseObjectTypeDefinition();
        case "interface":
          return this.parseInterfaceTypeDefinition();
        case "union":
          return this.parseUnionTypeDefinition();
        case "enum":
          return this.parseEnumTypeDefinition();
        case "input":
          return this.parseInputObjectTypeDefinition();
        case "directive":
          return this.parseDirectiveDefinition();
      }
      if (e)
        throw Br(
          this._lexer.source,
          this._lexer.token.start,
          "Unexpected description, descriptions are supported only on type definitions."
        );
      switch (r.value) {
        case "query":
        case "mutation":
        case "subscription":
          return this.parseOperationDefinition();
        case "fragment":
          return this.parseFragmentDefinition();
        case "extend":
          return this.parseTypeSystemExtension();
      }
    }
    throw this.unexpected(r);
  }
  // Implements the parsing rules in the Operations section.
  /**
   * OperationDefinition :
   *  - SelectionSet
   *  - OperationType Name? VariableDefinitions? Directives? SelectionSet
   */
  parseOperationDefinition() {
    const e = this._lexer.token;
    if (this.peek(it.BRACE_L))
      return this.node(e, {
        kind: Ct.OPERATION_DEFINITION,
        operation: Bs.QUERY,
        name: void 0,
        variableDefinitions: [],
        directives: [],
        selectionSet: this.parseSelectionSet()
      });
    const r = this.parseOperationType();
    let i;
    return this.peek(it.NAME) && (i = this.parseName()), this.node(e, {
      kind: Ct.OPERATION_DEFINITION,
      operation: r,
      name: i,
      variableDefinitions: this.parseVariableDefinitions(),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * OperationType : one of query mutation subscription
   */
  parseOperationType() {
    const e = this.expectToken(it.NAME);
    switch (e.value) {
      case "query":
        return Bs.QUERY;
      case "mutation":
        return Bs.MUTATION;
      case "subscription":
        return Bs.SUBSCRIPTION;
    }
    throw this.unexpected(e);
  }
  /**
   * VariableDefinitions : ( VariableDefinition+ )
   */
  parseVariableDefinitions() {
    return this.optionalMany(
      it.PAREN_L,
      this.parseVariableDefinition,
      it.PAREN_R
    );
  }
  /**
   * VariableDefinition : Variable : Type DefaultValue? Directives[Const]?
   */
  parseVariableDefinition() {
    return this.node(this._lexer.token, {
      kind: Ct.VARIABLE_DEFINITION,
      variable: this.parseVariable(),
      type: (this.expectToken(it.COLON), this.parseTypeReference()),
      defaultValue: this.expectOptionalToken(it.EQUALS) ? this.parseConstValueLiteral() : void 0,
      directives: this.parseConstDirectives()
    });
  }
  /**
   * Variable : $ Name
   */
  parseVariable() {
    const e = this._lexer.token;
    return this.expectToken(it.DOLLAR), this.node(e, {
      kind: Ct.VARIABLE,
      name: this.parseName()
    });
  }
  /**
   * ```
   * SelectionSet : { Selection+ }
   * ```
   */
  parseSelectionSet() {
    return this.node(this._lexer.token, {
      kind: Ct.SELECTION_SET,
      selections: this.many(
        it.BRACE_L,
        this.parseSelection,
        it.BRACE_R
      )
    });
  }
  /**
   * Selection :
   *   - Field
   *   - FragmentSpread
   *   - InlineFragment
   */
  parseSelection() {
    return this.peek(it.SPREAD) ? this.parseFragment() : this.parseField();
  }
  /**
   * Field : Alias? Name Arguments? Directives? SelectionSet?
   *
   * Alias : Name :
   */
  parseField() {
    const e = this._lexer.token, r = this.parseName();
    let i, f;
    return this.expectOptionalToken(it.COLON) ? (i = r, f = this.parseName()) : f = r, this.node(e, {
      kind: Ct.FIELD,
      alias: i,
      name: f,
      arguments: this.parseArguments(!1),
      directives: this.parseDirectives(!1),
      selectionSet: this.peek(it.BRACE_L) ? this.parseSelectionSet() : void 0
    });
  }
  /**
   * Arguments[Const] : ( Argument[?Const]+ )
   */
  parseArguments(e) {
    const r = e ? this.parseConstArgument : this.parseArgument;
    return this.optionalMany(it.PAREN_L, r, it.PAREN_R);
  }
  /**
   * Argument[Const] : Name : Value[?Const]
   */
  parseArgument(e = !1) {
    const r = this._lexer.token, i = this.parseName();
    return this.expectToken(it.COLON), this.node(r, {
      kind: Ct.ARGUMENT,
      name: i,
      value: this.parseValueLiteral(e)
    });
  }
  parseConstArgument() {
    return this.parseArgument(!0);
  }
  // Implements the parsing rules in the Fragments section.
  /**
   * Corresponds to both FragmentSpread and InlineFragment in the spec.
   *
   * FragmentSpread : ... FragmentName Directives?
   *
   * InlineFragment : ... TypeCondition? Directives? SelectionSet
   */
  parseFragment() {
    const e = this._lexer.token;
    this.expectToken(it.SPREAD);
    const r = this.expectOptionalKeyword("on");
    return !r && this.peek(it.NAME) ? this.node(e, {
      kind: Ct.FRAGMENT_SPREAD,
      name: this.parseFragmentName(),
      directives: this.parseDirectives(!1)
    }) : this.node(e, {
      kind: Ct.INLINE_FRAGMENT,
      typeCondition: r ? this.parseNamedType() : void 0,
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentDefinition :
   *   - fragment FragmentName on TypeCondition Directives? SelectionSet
   *
   * TypeCondition : NamedType
   */
  parseFragmentDefinition() {
    const e = this._lexer.token;
    return this.expectKeyword("fragment"), this._options.allowLegacyFragmentVariables === !0 ? this.node(e, {
      kind: Ct.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      variableDefinitions: this.parseVariableDefinitions(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    }) : this.node(e, {
      kind: Ct.FRAGMENT_DEFINITION,
      name: this.parseFragmentName(),
      typeCondition: (this.expectKeyword("on"), this.parseNamedType()),
      directives: this.parseDirectives(!1),
      selectionSet: this.parseSelectionSet()
    });
  }
  /**
   * FragmentName : Name but not `on`
   */
  parseFragmentName() {
    if (this._lexer.token.value === "on")
      throw this.unexpected();
    return this.parseName();
  }
  // Implements the parsing rules in the Values section.
  /**
   * Value[Const] :
   *   - [~Const] Variable
   *   - IntValue
   *   - FloatValue
   *   - StringValue
   *   - BooleanValue
   *   - NullValue
   *   - EnumValue
   *   - ListValue[?Const]
   *   - ObjectValue[?Const]
   *
   * BooleanValue : one of `true` `false`
   *
   * NullValue : `null`
   *
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseValueLiteral(e) {
    const r = this._lexer.token;
    switch (r.kind) {
      case it.BRACKET_L:
        return this.parseList(e);
      case it.BRACE_L:
        return this.parseObject(e);
      case it.INT:
        return this.advanceLexer(), this.node(r, {
          kind: Ct.INT,
          value: r.value
        });
      case it.FLOAT:
        return this.advanceLexer(), this.node(r, {
          kind: Ct.FLOAT,
          value: r.value
        });
      case it.STRING:
      case it.BLOCK_STRING:
        return this.parseStringLiteral();
      case it.NAME:
        switch (this.advanceLexer(), r.value) {
          case "true":
            return this.node(r, {
              kind: Ct.BOOLEAN,
              value: !0
            });
          case "false":
            return this.node(r, {
              kind: Ct.BOOLEAN,
              value: !1
            });
          case "null":
            return this.node(r, {
              kind: Ct.NULL
            });
          default:
            return this.node(r, {
              kind: Ct.ENUM,
              value: r.value
            });
        }
      case it.DOLLAR:
        if (e)
          if (this.expectToken(it.DOLLAR), this._lexer.token.kind === it.NAME) {
            const i = this._lexer.token.value;
            throw Br(
              this._lexer.source,
              r.start,
              `Unexpected variable "$${i}" in constant value.`
            );
          } else
            throw this.unexpected(r);
        return this.parseVariable();
      default:
        throw this.unexpected();
    }
  }
  parseConstValueLiteral() {
    return this.parseValueLiteral(!0);
  }
  parseStringLiteral() {
    const e = this._lexer.token;
    return this.advanceLexer(), this.node(e, {
      kind: Ct.STRING,
      value: e.value,
      block: e.kind === it.BLOCK_STRING
    });
  }
  /**
   * ListValue[Const] :
   *   - [ ]
   *   - [ Value[?Const]+ ]
   */
  parseList(e) {
    const r = () => this.parseValueLiteral(e);
    return this.node(this._lexer.token, {
      kind: Ct.LIST,
      values: this.any(it.BRACKET_L, r, it.BRACKET_R)
    });
  }
  /**
   * ```
   * ObjectValue[Const] :
   *   - { }
   *   - { ObjectField[?Const]+ }
   * ```
   */
  parseObject(e) {
    const r = () => this.parseObjectField(e);
    return this.node(this._lexer.token, {
      kind: Ct.OBJECT,
      fields: this.any(it.BRACE_L, r, it.BRACE_R)
    });
  }
  /**
   * ObjectField[Const] : Name : Value[?Const]
   */
  parseObjectField(e) {
    const r = this._lexer.token, i = this.parseName();
    return this.expectToken(it.COLON), this.node(r, {
      kind: Ct.OBJECT_FIELD,
      name: i,
      value: this.parseValueLiteral(e)
    });
  }
  // Implements the parsing rules in the Directives section.
  /**
   * Directives[Const] : Directive[?Const]+
   */
  parseDirectives(e) {
    const r = [];
    for (; this.peek(it.AT); )
      r.push(this.parseDirective(e));
    return r;
  }
  parseConstDirectives() {
    return this.parseDirectives(!0);
  }
  /**
   * ```
   * Directive[Const] : @ Name Arguments[?Const]?
   * ```
   */
  parseDirective(e) {
    const r = this._lexer.token;
    return this.expectToken(it.AT), this.node(r, {
      kind: Ct.DIRECTIVE,
      name: this.parseName(),
      arguments: this.parseArguments(e)
    });
  }
  // Implements the parsing rules in the Types section.
  /**
   * Type :
   *   - NamedType
   *   - ListType
   *   - NonNullType
   */
  parseTypeReference() {
    const e = this._lexer.token;
    let r;
    if (this.expectOptionalToken(it.BRACKET_L)) {
      const i = this.parseTypeReference();
      this.expectToken(it.BRACKET_R), r = this.node(e, {
        kind: Ct.LIST_TYPE,
        type: i
      });
    } else
      r = this.parseNamedType();
    return this.expectOptionalToken(it.BANG) ? this.node(e, {
      kind: Ct.NON_NULL_TYPE,
      type: r
    }) : r;
  }
  /**
   * NamedType : Name
   */
  parseNamedType() {
    return this.node(this._lexer.token, {
      kind: Ct.NAMED_TYPE,
      name: this.parseName()
    });
  }
  // Implements the parsing rules in the Type Definition section.
  peekDescription() {
    return this.peek(it.STRING) || this.peek(it.BLOCK_STRING);
  }
  /**
   * Description : StringValue
   */
  parseDescription() {
    if (this.peekDescription())
      return this.parseStringLiteral();
  }
  /**
   * ```
   * SchemaDefinition : Description? schema Directives[Const]? { OperationTypeDefinition+ }
   * ```
   */
  parseSchemaDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("schema");
    const i = this.parseConstDirectives(), f = this.many(
      it.BRACE_L,
      this.parseOperationTypeDefinition,
      it.BRACE_R
    );
    return this.node(e, {
      kind: Ct.SCHEMA_DEFINITION,
      description: r,
      directives: i,
      operationTypes: f
    });
  }
  /**
   * OperationTypeDefinition : OperationType : NamedType
   */
  parseOperationTypeDefinition() {
    const e = this._lexer.token, r = this.parseOperationType();
    this.expectToken(it.COLON);
    const i = this.parseNamedType();
    return this.node(e, {
      kind: Ct.OPERATION_TYPE_DEFINITION,
      operation: r,
      type: i
    });
  }
  /**
   * ScalarTypeDefinition : Description? scalar Name Directives[Const]?
   */
  parseScalarTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("scalar");
    const i = this.parseName(), f = this.parseConstDirectives();
    return this.node(e, {
      kind: Ct.SCALAR_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: f
    });
  }
  /**
   * ObjectTypeDefinition :
   *   Description?
   *   type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition?
   */
  parseObjectTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("type");
    const i = this.parseName(), f = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), l = this.parseFieldsDefinition();
    return this.node(e, {
      kind: Ct.OBJECT_TYPE_DEFINITION,
      description: r,
      name: i,
      interfaces: f,
      directives: a,
      fields: l
    });
  }
  /**
   * ImplementsInterfaces :
   *   - implements `&`? NamedType
   *   - ImplementsInterfaces & NamedType
   */
  parseImplementsInterfaces() {
    return this.expectOptionalKeyword("implements") ? this.delimitedMany(it.AMP, this.parseNamedType) : [];
  }
  /**
   * ```
   * FieldsDefinition : { FieldDefinition+ }
   * ```
   */
  parseFieldsDefinition() {
    return this.optionalMany(
      it.BRACE_L,
      this.parseFieldDefinition,
      it.BRACE_R
    );
  }
  /**
   * FieldDefinition :
   *   - Description? Name ArgumentsDefinition? : Type Directives[Const]?
   */
  parseFieldDefinition() {
    const e = this._lexer.token, r = this.parseDescription(), i = this.parseName(), f = this.parseArgumentDefs();
    this.expectToken(it.COLON);
    const a = this.parseTypeReference(), l = this.parseConstDirectives();
    return this.node(e, {
      kind: Ct.FIELD_DEFINITION,
      description: r,
      name: i,
      arguments: f,
      type: a,
      directives: l
    });
  }
  /**
   * ArgumentsDefinition : ( InputValueDefinition+ )
   */
  parseArgumentDefs() {
    return this.optionalMany(
      it.PAREN_L,
      this.parseInputValueDef,
      it.PAREN_R
    );
  }
  /**
   * InputValueDefinition :
   *   - Description? Name : Type DefaultValue? Directives[Const]?
   */
  parseInputValueDef() {
    const e = this._lexer.token, r = this.parseDescription(), i = this.parseName();
    this.expectToken(it.COLON);
    const f = this.parseTypeReference();
    let a;
    this.expectOptionalToken(it.EQUALS) && (a = this.parseConstValueLiteral());
    const l = this.parseConstDirectives();
    return this.node(e, {
      kind: Ct.INPUT_VALUE_DEFINITION,
      description: r,
      name: i,
      type: f,
      defaultValue: a,
      directives: l
    });
  }
  /**
   * InterfaceTypeDefinition :
   *   - Description? interface Name Directives[Const]? FieldsDefinition?
   */
  parseInterfaceTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("interface");
    const i = this.parseName(), f = this.parseImplementsInterfaces(), a = this.parseConstDirectives(), l = this.parseFieldsDefinition();
    return this.node(e, {
      kind: Ct.INTERFACE_TYPE_DEFINITION,
      description: r,
      name: i,
      interfaces: f,
      directives: a,
      fields: l
    });
  }
  /**
   * UnionTypeDefinition :
   *   - Description? union Name Directives[Const]? UnionMemberTypes?
   */
  parseUnionTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("union");
    const i = this.parseName(), f = this.parseConstDirectives(), a = this.parseUnionMemberTypes();
    return this.node(e, {
      kind: Ct.UNION_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: f,
      types: a
    });
  }
  /**
   * UnionMemberTypes :
   *   - = `|`? NamedType
   *   - UnionMemberTypes | NamedType
   */
  parseUnionMemberTypes() {
    return this.expectOptionalToken(it.EQUALS) ? this.delimitedMany(it.PIPE, this.parseNamedType) : [];
  }
  /**
   * EnumTypeDefinition :
   *   - Description? enum Name Directives[Const]? EnumValuesDefinition?
   */
  parseEnumTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("enum");
    const i = this.parseName(), f = this.parseConstDirectives(), a = this.parseEnumValuesDefinition();
    return this.node(e, {
      kind: Ct.ENUM_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: f,
      values: a
    });
  }
  /**
   * ```
   * EnumValuesDefinition : { EnumValueDefinition+ }
   * ```
   */
  parseEnumValuesDefinition() {
    return this.optionalMany(
      it.BRACE_L,
      this.parseEnumValueDefinition,
      it.BRACE_R
    );
  }
  /**
   * EnumValueDefinition : Description? EnumValue Directives[Const]?
   */
  parseEnumValueDefinition() {
    const e = this._lexer.token, r = this.parseDescription(), i = this.parseEnumValueName(), f = this.parseConstDirectives();
    return this.node(e, {
      kind: Ct.ENUM_VALUE_DEFINITION,
      description: r,
      name: i,
      directives: f
    });
  }
  /**
   * EnumValue : Name but not `true`, `false` or `null`
   */
  parseEnumValueName() {
    if (this._lexer.token.value === "true" || this._lexer.token.value === "false" || this._lexer.token.value === "null")
      throw Br(
        this._lexer.source,
        this._lexer.token.start,
        `${cu(
          this._lexer.token
        )} is reserved and cannot be used for an enum value.`
      );
    return this.parseName();
  }
  /**
   * InputObjectTypeDefinition :
   *   - Description? input Name Directives[Const]? InputFieldsDefinition?
   */
  parseInputObjectTypeDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("input");
    const i = this.parseName(), f = this.parseConstDirectives(), a = this.parseInputFieldsDefinition();
    return this.node(e, {
      kind: Ct.INPUT_OBJECT_TYPE_DEFINITION,
      description: r,
      name: i,
      directives: f,
      fields: a
    });
  }
  /**
   * ```
   * InputFieldsDefinition : { InputValueDefinition+ }
   * ```
   */
  parseInputFieldsDefinition() {
    return this.optionalMany(
      it.BRACE_L,
      this.parseInputValueDef,
      it.BRACE_R
    );
  }
  /**
   * TypeSystemExtension :
   *   - SchemaExtension
   *   - TypeExtension
   *
   * TypeExtension :
   *   - ScalarTypeExtension
   *   - ObjectTypeExtension
   *   - InterfaceTypeExtension
   *   - UnionTypeExtension
   *   - EnumTypeExtension
   *   - InputObjectTypeDefinition
   */
  parseTypeSystemExtension() {
    const e = this._lexer.lookahead();
    if (e.kind === it.NAME)
      switch (e.value) {
        case "schema":
          return this.parseSchemaExtension();
        case "scalar":
          return this.parseScalarTypeExtension();
        case "type":
          return this.parseObjectTypeExtension();
        case "interface":
          return this.parseInterfaceTypeExtension();
        case "union":
          return this.parseUnionTypeExtension();
        case "enum":
          return this.parseEnumTypeExtension();
        case "input":
          return this.parseInputObjectTypeExtension();
      }
    throw this.unexpected(e);
  }
  /**
   * ```
   * SchemaExtension :
   *  - extend schema Directives[Const]? { OperationTypeDefinition+ }
   *  - extend schema Directives[Const]
   * ```
   */
  parseSchemaExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("schema");
    const r = this.parseConstDirectives(), i = this.optionalMany(
      it.BRACE_L,
      this.parseOperationTypeDefinition,
      it.BRACE_R
    );
    if (r.length === 0 && i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.SCHEMA_EXTENSION,
      directives: r,
      operationTypes: i
    });
  }
  /**
   * ScalarTypeExtension :
   *   - extend scalar Name Directives[Const]
   */
  parseScalarTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("scalar");
    const r = this.parseName(), i = this.parseConstDirectives();
    if (i.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.SCALAR_TYPE_EXTENSION,
      name: r,
      directives: i
    });
  }
  /**
   * ObjectTypeExtension :
   *  - extend type Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend type Name ImplementsInterfaces? Directives[Const]
   *  - extend type Name ImplementsInterfaces
   */
  parseObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("type");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), f = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (i.length === 0 && f.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.OBJECT_TYPE_EXTENSION,
      name: r,
      interfaces: i,
      directives: f,
      fields: a
    });
  }
  /**
   * InterfaceTypeExtension :
   *  - extend interface Name ImplementsInterfaces? Directives[Const]? FieldsDefinition
   *  - extend interface Name ImplementsInterfaces? Directives[Const]
   *  - extend interface Name ImplementsInterfaces
   */
  parseInterfaceTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("interface");
    const r = this.parseName(), i = this.parseImplementsInterfaces(), f = this.parseConstDirectives(), a = this.parseFieldsDefinition();
    if (i.length === 0 && f.length === 0 && a.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.INTERFACE_TYPE_EXTENSION,
      name: r,
      interfaces: i,
      directives: f,
      fields: a
    });
  }
  /**
   * UnionTypeExtension :
   *   - extend union Name Directives[Const]? UnionMemberTypes
   *   - extend union Name Directives[Const]
   */
  parseUnionTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("union");
    const r = this.parseName(), i = this.parseConstDirectives(), f = this.parseUnionMemberTypes();
    if (i.length === 0 && f.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.UNION_TYPE_EXTENSION,
      name: r,
      directives: i,
      types: f
    });
  }
  /**
   * EnumTypeExtension :
   *   - extend enum Name Directives[Const]? EnumValuesDefinition
   *   - extend enum Name Directives[Const]
   */
  parseEnumTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("enum");
    const r = this.parseName(), i = this.parseConstDirectives(), f = this.parseEnumValuesDefinition();
    if (i.length === 0 && f.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.ENUM_TYPE_EXTENSION,
      name: r,
      directives: i,
      values: f
    });
  }
  /**
   * InputObjectTypeExtension :
   *   - extend input Name Directives[Const]? InputFieldsDefinition
   *   - extend input Name Directives[Const]
   */
  parseInputObjectTypeExtension() {
    const e = this._lexer.token;
    this.expectKeyword("extend"), this.expectKeyword("input");
    const r = this.parseName(), i = this.parseConstDirectives(), f = this.parseInputFieldsDefinition();
    if (i.length === 0 && f.length === 0)
      throw this.unexpected();
    return this.node(e, {
      kind: Ct.INPUT_OBJECT_TYPE_EXTENSION,
      name: r,
      directives: i,
      fields: f
    });
  }
  /**
   * ```
   * DirectiveDefinition :
   *   - Description? directive @ Name ArgumentsDefinition? `repeatable`? on DirectiveLocations
   * ```
   */
  parseDirectiveDefinition() {
    const e = this._lexer.token, r = this.parseDescription();
    this.expectKeyword("directive"), this.expectToken(it.AT);
    const i = this.parseName(), f = this.parseArgumentDefs(), a = this.expectOptionalKeyword("repeatable");
    this.expectKeyword("on");
    const l = this.parseDirectiveLocations();
    return this.node(e, {
      kind: Ct.DIRECTIVE_DEFINITION,
      description: r,
      name: i,
      arguments: f,
      repeatable: a,
      locations: l
    });
  }
  /**
   * DirectiveLocations :
   *   - `|`? DirectiveLocation
   *   - DirectiveLocations | DirectiveLocation
   */
  parseDirectiveLocations() {
    return this.delimitedMany(it.PIPE, this.parseDirectiveLocation);
  }
  /*
   * DirectiveLocation :
   *   - ExecutableDirectiveLocation
   *   - TypeSystemDirectiveLocation
   *
   * ExecutableDirectiveLocation : one of
   *   `QUERY`
   *   `MUTATION`
   *   `SUBSCRIPTION`
   *   `FIELD`
   *   `FRAGMENT_DEFINITION`
   *   `FRAGMENT_SPREAD`
   *   `INLINE_FRAGMENT`
   *
   * TypeSystemDirectiveLocation : one of
   *   `SCHEMA`
   *   `SCALAR`
   *   `OBJECT`
   *   `FIELD_DEFINITION`
   *   `ARGUMENT_DEFINITION`
   *   `INTERFACE`
   *   `UNION`
   *   `ENUM`
   *   `ENUM_VALUE`
   *   `INPUT_OBJECT`
   *   `INPUT_FIELD_DEFINITION`
   */
  parseDirectiveLocation() {
    const e = this._lexer.token, r = this.parseName();
    if (Object.prototype.hasOwnProperty.call(b1, r.value))
      return r;
    throw this.unexpected(e);
  }
  // Core parsing utility functions
  /**
   * Returns a node that, if configured to do so, sets a "loc" field as a
   * location object, used to identify the place in the source that created a
   * given parsed object.
   */
  node(e, r) {
    return this._options.noLocation !== !0 && (r.loc = new aS(
      e,
      this._lexer.lastToken,
      this._lexer.source
    )), r;
  }
  /**
   * Determines if the next token is of a given kind
   */
  peek(e) {
    return this._lexer.token.kind === e;
  }
  /**
   * If the next token is of the given kind, return that token after advancing the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectToken(e) {
    const r = this._lexer.token;
    if (r.kind === e)
      return this.advanceLexer(), r;
    throw Br(
      this._lexer.source,
      r.start,
      `Expected ${K5(e)}, found ${cu(r)}.`
    );
  }
  /**
   * If the next token is of the given kind, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalToken(e) {
    return this._lexer.token.kind === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * If the next token is a given keyword, advance the lexer.
   * Otherwise, do not change the parser state and throw an error.
   */
  expectKeyword(e) {
    const r = this._lexer.token;
    if (r.kind === it.NAME && r.value === e)
      this.advanceLexer();
    else
      throw Br(
        this._lexer.source,
        r.start,
        `Expected "${e}", found ${cu(r)}.`
      );
  }
  /**
   * If the next token is a given keyword, return "true" after advancing the lexer.
   * Otherwise, do not change the parser state and return "false".
   */
  expectOptionalKeyword(e) {
    const r = this._lexer.token;
    return r.kind === it.NAME && r.value === e ? (this.advanceLexer(), !0) : !1;
  }
  /**
   * Helper function for creating an error when an unexpected lexed token is encountered.
   */
  unexpected(e) {
    const r = e ?? this._lexer.token;
    return Br(
      this._lexer.source,
      r.start,
      `Unexpected ${cu(r)}.`
    );
  }
  /**
   * Returns a possibly empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  any(e, r, i) {
    this.expectToken(e);
    const f = [];
    for (; !this.expectOptionalToken(i); )
      f.push(r.call(this));
    return f;
  }
  /**
   * Returns a list of parse nodes, determined by the parseFn.
   * It can be empty only if open token is missing otherwise it will always return non-empty list
   * that begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  optionalMany(e, r, i) {
    if (this.expectOptionalToken(e)) {
      const f = [];
      do
        f.push(r.call(this));
      while (!this.expectOptionalToken(i));
      return f;
    }
    return [];
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list begins with a lex token of openKind and ends with a lex token of closeKind.
   * Advances the parser to the next lex token after the closing token.
   */
  many(e, r, i) {
    this.expectToken(e);
    const f = [];
    do
      f.push(r.call(this));
    while (!this.expectOptionalToken(i));
    return f;
  }
  /**
   * Returns a non-empty list of parse nodes, determined by the parseFn.
   * This list may begin with a lex token of delimiterKind followed by items separated by lex tokens of tokenKind.
   * Advances the parser to the next lex token after last item in the list.
   */
  delimitedMany(e, r) {
    this.expectOptionalToken(e);
    const i = [];
    do
      i.push(r.call(this));
    while (this.expectOptionalToken(e));
    return i;
  }
  advanceLexer() {
    const { maxTokens: e } = this._options, r = this._lexer.advance();
    if (e !== void 0 && r.kind !== it.EOF && (++this._tokenCounter, this._tokenCounter > e))
      throw Br(
        this._lexer.source,
        r.start,
        `Document contains more that ${e} tokens. Parsing aborted.`
      );
  }
}
function cu(t) {
  const e = t.value;
  return K5(t.kind) + (e != null ? ` "${e}"` : "");
}
function K5(t) {
  return dS(t) ? `"${t}"` : t;
}
function PS(t) {
  return `"${t.replace(OS, NS)}"`;
}
const OS = /[\x00-\x1f\x22\x5c\x7f-\x9f]/g;
function NS(t) {
  return DS[t.charCodeAt(0)];
}
const DS = [
  "\\u0000",
  "\\u0001",
  "\\u0002",
  "\\u0003",
  "\\u0004",
  "\\u0005",
  "\\u0006",
  "\\u0007",
  "\\b",
  "\\t",
  "\\n",
  "\\u000B",
  "\\f",
  "\\r",
  "\\u000E",
  "\\u000F",
  "\\u0010",
  "\\u0011",
  "\\u0012",
  "\\u0013",
  "\\u0014",
  "\\u0015",
  "\\u0016",
  "\\u0017",
  "\\u0018",
  "\\u0019",
  "\\u001A",
  "\\u001B",
  "\\u001C",
  "\\u001D",
  "\\u001E",
  "\\u001F",
  "",
  "",
  '\\"',
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 2F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 3F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 4F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\\\",
  "",
  "",
  "",
  // 5F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  // 6F
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "",
  "\\u007F",
  "\\u0080",
  "\\u0081",
  "\\u0082",
  "\\u0083",
  "\\u0084",
  "\\u0085",
  "\\u0086",
  "\\u0087",
  "\\u0088",
  "\\u0089",
  "\\u008A",
  "\\u008B",
  "\\u008C",
  "\\u008D",
  "\\u008E",
  "\\u008F",
  "\\u0090",
  "\\u0091",
  "\\u0092",
  "\\u0093",
  "\\u0094",
  "\\u0095",
  "\\u0096",
  "\\u0097",
  "\\u0098",
  "\\u0099",
  "\\u009A",
  "\\u009B",
  "\\u009C",
  "\\u009D",
  "\\u009E",
  "\\u009F"
], Uv = Object.freeze({});
function Ai(t, e, r = q5) {
  const i = /* @__PURE__ */ new Map();
  for (const k of Object.values(Ct))
    i.set(k, US(e, k));
  let f, a = Array.isArray(t), l = [t], d = -1, v = [], m = t, h, w;
  const M = [], S = [];
  do {
    d++;
    const k = d === l.length, C = k && v.length !== 0;
    if (k) {
      if (h = S.length === 0 ? void 0 : M[M.length - 1], m = w, w = S.pop(), C)
        if (a) {
          m = m.slice();
          let O = 0;
          for (const [q, $] of v) {
            const ae = q - O;
            $ === null ? (m.splice(ae, 1), O++) : m[ae] = $;
          }
        } else {
          m = Object.defineProperties(
            {},
            Object.getOwnPropertyDescriptors(m)
          );
          for (const [O, q] of v)
            m[O] = q;
        }
      d = f.index, l = f.keys, v = f.edits, a = f.inArray, f = f.prev;
    } else if (w) {
      if (h = a ? d : l[d], m = w[h], m == null)
        continue;
      M.push(h);
    }
    let I;
    if (!Array.isArray(m)) {
      var E, A;
      Qg(m) || Lu(!1, `Invalid AST Node: ${Dv(m)}.`);
      const O = k ? (E = i.get(m.kind)) === null || E === void 0 ? void 0 : E.leave : (A = i.get(m.kind)) === null || A === void 0 ? void 0 : A.enter;
      if (I = O == null ? void 0 : O.call(e, m, h, w, M, S), I === Uv)
        break;
      if (I === !1) {
        if (!k) {
          M.pop();
          continue;
        }
      } else if (I !== void 0 && (v.push([h, I]), !k))
        if (Qg(I))
          m = I;
        else {
          M.pop();
          continue;
        }
    }
    if (I === void 0 && C && v.push([h, m]), k)
      M.pop();
    else {
      var B;
      f = {
        inArray: a,
        index: d,
        keys: l,
        edits: v,
        prev: f
      }, a = Array.isArray(m), l = a ? m : (B = r[m.kind]) !== null && B !== void 0 ? B : [], d = -1, v = [], w && S.push(w), w = m;
    }
  } while (f !== void 0);
  return v.length !== 0 ? v[v.length - 1][1] : t;
}
function US(t, e) {
  const r = t[e];
  return typeof r == "object" ? r : typeof r == "function" ? {
    enter: r,
    leave: void 0
  } : {
    enter: t.enter,
    leave: t.leave
  };
}
function Z5(t) {
  return Ai(t, FS);
}
const LS = 80, FS = {
  Name: {
    leave: (t) => t.value
  },
  Variable: {
    leave: (t) => "$" + t.name
  },
  // Document
  Document: {
    leave: (t) => Bt(t.definitions, `

`)
  },
  OperationDefinition: {
    leave(t) {
      const e = Ht("(", Bt(t.variableDefinitions, ", "), ")"), r = Bt(
        [
          t.operation,
          Bt([t.name, e]),
          Bt(t.directives, " ")
        ],
        " "
      );
      return (r === "query" ? "" : r + " ") + t.selectionSet;
    }
  },
  VariableDefinition: {
    leave: ({ variable: t, type: e, defaultValue: r, directives: i }) => t + ": " + e + Ht(" = ", r) + Ht(" ", Bt(i, " "))
  },
  SelectionSet: {
    leave: ({ selections: t }) => Tn(t)
  },
  Field: {
    leave({ alias: t, name: e, arguments: r, directives: i, selectionSet: f }) {
      const a = Ht("", t, ": ") + e;
      let l = a + Ht("(", Bt(r, ", "), ")");
      return l.length > LS && (l = a + Ht(`(
`, Fu(Bt(r, `
`)), `
)`)), Bt([l, Bt(i, " "), f], " ");
    }
  },
  Argument: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Fragments
  FragmentSpread: {
    leave: ({ name: t, directives: e }) => "..." + t + Ht(" ", Bt(e, " "))
  },
  InlineFragment: {
    leave: ({ typeCondition: t, directives: e, selectionSet: r }) => Bt(
      [
        "...",
        Ht("on ", t),
        Bt(e, " "),
        r
      ],
      " "
    )
  },
  FragmentDefinition: {
    leave: ({ name: t, typeCondition: e, variableDefinitions: r, directives: i, selectionSet: f }) => (
      // or removed in the future.
      `fragment ${t}${Ht("(", Bt(r, ", "), ")")} on ${e} ${Ht("", Bt(i, " "), " ")}` + f
    )
  },
  // Value
  IntValue: {
    leave: ({ value: t }) => t
  },
  FloatValue: {
    leave: ({ value: t }) => t
  },
  StringValue: {
    leave: ({ value: t, block: e }) => e ? lS(t) : PS(t)
  },
  BooleanValue: {
    leave: ({ value: t }) => t ? "true" : "false"
  },
  NullValue: {
    leave: () => "null"
  },
  EnumValue: {
    leave: ({ value: t }) => t
  },
  ListValue: {
    leave: ({ values: t }) => "[" + Bt(t, ", ") + "]"
  },
  ObjectValue: {
    leave: ({ fields: t }) => "{" + Bt(t, ", ") + "}"
  },
  ObjectField: {
    leave: ({ name: t, value: e }) => t + ": " + e
  },
  // Directive
  Directive: {
    leave: ({ name: t, arguments: e }) => "@" + t + Ht("(", Bt(e, ", "), ")")
  },
  // Type
  NamedType: {
    leave: ({ name: t }) => t
  },
  ListType: {
    leave: ({ type: t }) => "[" + t + "]"
  },
  NonNullType: {
    leave: ({ type: t }) => t + "!"
  },
  // Type System Definitions
  SchemaDefinition: {
    leave: ({ description: t, directives: e, operationTypes: r }) => Ht("", t, `
`) + Bt(["schema", Bt(e, " "), Tn(r)], " ")
  },
  OperationTypeDefinition: {
    leave: ({ operation: t, type: e }) => t + ": " + e
  },
  ScalarTypeDefinition: {
    leave: ({ description: t, name: e, directives: r }) => Ht("", t, `
`) + Bt(["scalar", e, Bt(r, " ")], " ")
  },
  ObjectTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: r, directives: i, fields: f }) => Ht("", t, `
`) + Bt(
      [
        "type",
        e,
        Ht("implements ", Bt(r, " & ")),
        Bt(i, " "),
        Tn(f)
      ],
      " "
    )
  },
  FieldDefinition: {
    leave: ({ description: t, name: e, arguments: r, type: i, directives: f }) => Ht("", t, `
`) + e + (Jg(r) ? Ht(`(
`, Fu(Bt(r, `
`)), `
)`) : Ht("(", Bt(r, ", "), ")")) + ": " + i + Ht(" ", Bt(f, " "))
  },
  InputValueDefinition: {
    leave: ({ description: t, name: e, type: r, defaultValue: i, directives: f }) => Ht("", t, `
`) + Bt(
      [e + ": " + r, Ht("= ", i), Bt(f, " ")],
      " "
    )
  },
  InterfaceTypeDefinition: {
    leave: ({ description: t, name: e, interfaces: r, directives: i, fields: f }) => Ht("", t, `
`) + Bt(
      [
        "interface",
        e,
        Ht("implements ", Bt(r, " & ")),
        Bt(i, " "),
        Tn(f)
      ],
      " "
    )
  },
  UnionTypeDefinition: {
    leave: ({ description: t, name: e, directives: r, types: i }) => Ht("", t, `
`) + Bt(
      ["union", e, Bt(r, " "), Ht("= ", Bt(i, " | "))],
      " "
    )
  },
  EnumTypeDefinition: {
    leave: ({ description: t, name: e, directives: r, values: i }) => Ht("", t, `
`) + Bt(["enum", e, Bt(r, " "), Tn(i)], " ")
  },
  EnumValueDefinition: {
    leave: ({ description: t, name: e, directives: r }) => Ht("", t, `
`) + Bt([e, Bt(r, " ")], " ")
  },
  InputObjectTypeDefinition: {
    leave: ({ description: t, name: e, directives: r, fields: i }) => Ht("", t, `
`) + Bt(["input", e, Bt(r, " "), Tn(i)], " ")
  },
  DirectiveDefinition: {
    leave: ({ description: t, name: e, arguments: r, repeatable: i, locations: f }) => Ht("", t, `
`) + "directive @" + e + (Jg(r) ? Ht(`(
`, Fu(Bt(r, `
`)), `
)`) : Ht("(", Bt(r, ", "), ")")) + (i ? " repeatable" : "") + " on " + Bt(f, " | ")
  },
  SchemaExtension: {
    leave: ({ directives: t, operationTypes: e }) => Bt(
      ["extend schema", Bt(t, " "), Tn(e)],
      " "
    )
  },
  ScalarTypeExtension: {
    leave: ({ name: t, directives: e }) => Bt(["extend scalar", t, Bt(e, " ")], " ")
  },
  ObjectTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: r, fields: i }) => Bt(
      [
        "extend type",
        t,
        Ht("implements ", Bt(e, " & ")),
        Bt(r, " "),
        Tn(i)
      ],
      " "
    )
  },
  InterfaceTypeExtension: {
    leave: ({ name: t, interfaces: e, directives: r, fields: i }) => Bt(
      [
        "extend interface",
        t,
        Ht("implements ", Bt(e, " & ")),
        Bt(r, " "),
        Tn(i)
      ],
      " "
    )
  },
  UnionTypeExtension: {
    leave: ({ name: t, directives: e, types: r }) => Bt(
      [
        "extend union",
        t,
        Bt(e, " "),
        Ht("= ", Bt(r, " | "))
      ],
      " "
    )
  },
  EnumTypeExtension: {
    leave: ({ name: t, directives: e, values: r }) => Bt(["extend enum", t, Bt(e, " "), Tn(r)], " ")
  },
  InputObjectTypeExtension: {
    leave: ({ name: t, directives: e, fields: r }) => Bt(["extend input", t, Bt(e, " "), Tn(r)], " ")
  }
};
function Bt(t, e = "") {
  var r;
  return (r = t == null ? void 0 : t.filter((i) => i).join(e)) !== null && r !== void 0 ? r : "";
}
function Tn(t) {
  return Ht(`{
`, Fu(Bt(t, `
`)), `
}`);
}
function Ht(t, e, r = "") {
  return e != null && e !== "" ? t + e + r : "";
}
function Fu(t) {
  return Ht("  ", t.replace(/\n/g, `
  `));
}
function Jg(t) {
  var e;
  return (e = t == null ? void 0 : t.some((r) => r.includes(`
`))) !== null && e !== void 0 ? e : !1;
}
function Xg(t) {
  return t.kind === Ct.FIELD || t.kind === Ct.FRAGMENT_SPREAD || t.kind === Ct.INLINE_FRAGMENT;
}
function Df(t, e) {
  var r = t.directives;
  return !r || !r.length ? !0 : jS(r).every(function(i) {
    var f = i.directive, a = i.ifArgument, l = !1;
    return a.value.kind === "Variable" ? (l = e && e[a.value.name.value], Rt(l !== void 0, 67, f.name.value)) : l = a.value.value, f.name.value === "skip" ? !l : l;
  });
}
function Af(t, e, r) {
  var i = new Set(t), f = i.size;
  return Ai(e, {
    Directive: function(a) {
      if (i.delete(a.name.value) && (!r || !i.size))
        return Uv;
    }
  }), r ? !i.size : i.size < f;
}
function qS(t) {
  return t && Af(["client", "export"], t, !0);
}
function zS(t) {
  var e = t.name.value;
  return e === "skip" || e === "include";
}
function jS(t) {
  var e = [];
  return t && t.length && t.forEach(function(r) {
    if (zS(r)) {
      var i = r.arguments, f = r.name.value;
      Rt(i && i.length === 1, 68, f);
      var a = i[0];
      Rt(a.name && a.name.value === "if", 69, f);
      var l = a.value;
      Rt(l && (l.kind === "Variable" || l.kind === "BooleanValue"), 70, f), e.push({ directive: r, ifArgument: a });
    }
  }), e;
}
const $S = () => /* @__PURE__ */ Object.create(null), { forEach: VS, slice: ey } = Array.prototype, { hasOwnProperty: HS } = Object.prototype;
let so = class G5 {
  constructor(e = !0, r = $S) {
    this.weakness = e, this.makeData = r;
  }
  lookup() {
    return this.lookupArray(arguments);
  }
  lookupArray(e) {
    let r = this;
    return VS.call(e, (i) => r = r.getChildTrie(i)), HS.call(r, "data") ? r.data : r.data = this.makeData(ey.call(e));
  }
  peek() {
    return this.peekArray(arguments);
  }
  peekArray(e) {
    let r = this;
    for (let i = 0, f = e.length; r && i < f; ++i) {
      const a = r.mapFor(e[i], !1);
      r = a && a.get(e[i]);
    }
    return r && r.data;
  }
  remove() {
    return this.removeArray(arguments);
  }
  removeArray(e) {
    let r;
    if (e.length) {
      const i = e[0], f = this.mapFor(i, !1), a = f && f.get(i);
      a && (r = a.removeArray(ey.call(e, 1)), !a.data && !a.weak && !(a.strong && a.strong.size) && f.delete(i));
    } else
      r = this.data, delete this.data;
    return r;
  }
  getChildTrie(e) {
    const r = this.mapFor(e, !0);
    let i = r.get(e);
    return i || r.set(e, i = new G5(this.weakness, this.makeData)), i;
  }
  mapFor(e, r) {
    return this.weakness && WS(e) ? this.weak || (r ? this.weak = /* @__PURE__ */ new WeakMap() : void 0) : this.strong || (r ? this.strong = /* @__PURE__ */ new Map() : void 0);
  }
};
function WS(t) {
  switch (typeof t) {
    case "object":
      if (t === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
var ps = typeof WeakMap == "function" && !Rn(function() {
  return navigator.product == "ReactNative" && !Gi.HermesInternal;
}), Q5 = typeof WeakSet == "function", Lv = typeof Symbol == "function" && typeof Symbol.for == "function", $l = Lv && Symbol.asyncIterator, KS = typeof Rn(function() {
  return window.document.createElement;
}) == "function", ZS = (
  // Following advice found in this comment from @domenic (maintainer of jsdom):
  // https://github.com/jsdom/jsdom/issues/1537#issuecomment-229405327
  //
  // Since we control the version of Jest and jsdom used when running Apollo
  // Client tests, and that version is recent enought to include " jsdom/x.y.z"
  // at the end of the user agent string, I believe this case is all we need to
  // check. Testing for "Node.js" was recommended for backwards compatibility
  // with older version of jsdom, but we don't have that problem.
  Rn(function() {
    return navigator.userAgent.indexOf("jsdom") >= 0;
  }) || !1
), GS = KS && !ZS;
function lr(t) {
  return t !== null && typeof t == "object";
}
function QS(t, e) {
  var r = e, i = [];
  t.definitions.forEach(function(a) {
    if (a.kind === "OperationDefinition")
      throw Gr(
        71,
        a.operation,
        a.name ? " named '".concat(a.name.value, "'") : ""
      );
    a.kind === "FragmentDefinition" && i.push(a);
  }), typeof r > "u" && (Rt(i.length === 1, 72, i.length), r = i[0].name.value);
  var f = We(We({}, t), { definitions: On([
    {
      kind: "OperationDefinition",
      // OperationTypeNode is an enum
      operation: "query",
      selectionSet: {
        kind: "SelectionSet",
        selections: [
          {
            kind: "FragmentSpread",
            name: {
              kind: "Name",
              value: r
            }
          }
        ]
      }
    }
  ], t.definitions, !0) });
  return f;
}
function Vl(t) {
  t === void 0 && (t = []);
  var e = {};
  return t.forEach(function(r) {
    e[r.name.value] = r;
  }), e;
}
function Hl(t, e) {
  switch (t.kind) {
    case "InlineFragment":
      return t;
    case "FragmentSpread": {
      var r = t.name.value;
      if (typeof e == "function")
        return e(r);
      var i = e && e[r];
      return Rt(i, 73, r), i || null;
    }
    default:
      return null;
  }
}
function YS() {
}
class _1 {
  constructor(e = 1 / 0, r = YS) {
    this.max = e, this.dispose = r, this.map = /* @__PURE__ */ new Map(), this.newest = null, this.oldest = null;
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const r = this.getNode(e);
    return r && r.value;
  }
  get size() {
    return this.map.size;
  }
  getNode(e) {
    const r = this.map.get(e);
    if (r && r !== this.newest) {
      const { older: i, newer: f } = r;
      f && (f.older = i), i && (i.newer = f), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = f);
    }
    return r;
  }
  set(e, r) {
    let i = this.getNode(e);
    return i ? i.value = r : (i = {
      key: e,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = i), this.newest = i, this.oldest = this.oldest || i, this.map.set(e, i), i.value);
  }
  clean() {
    for (; this.oldest && this.map.size > this.max; )
      this.delete(this.oldest.key);
  }
  delete(e) {
    const r = this.map.get(e);
    return r ? (r === this.newest && (this.newest = r.older), r === this.oldest && (this.oldest = r.newer), r.newer && (r.newer.older = r.older), r.older && (r.older.newer = r.newer), this.map.delete(e), this.dispose(r.value, e), !0) : !1;
  }
}
function x1() {
}
const JS = x1, XS = typeof WeakRef < "u" ? WeakRef : function(t) {
  return { deref: () => t };
}, eE = typeof WeakMap < "u" ? WeakMap : Map, tE = typeof FinalizationRegistry < "u" ? FinalizationRegistry : function() {
  return {
    register: x1,
    unregister: x1
  };
}, rE = 10024;
class Ml {
  constructor(e = 1 / 0, r = JS) {
    this.max = e, this.dispose = r, this.map = new eE(), this.newest = null, this.oldest = null, this.unfinalizedNodes = /* @__PURE__ */ new Set(), this.finalizationScheduled = !1, this.size = 0, this.finalize = () => {
      const i = this.unfinalizedNodes.values();
      for (let f = 0; f < rE; f++) {
        const a = i.next().value;
        if (!a)
          break;
        this.unfinalizedNodes.delete(a);
        const l = a.key;
        delete a.key, a.keyRef = new XS(l), this.registry.register(l, a, a);
      }
      this.unfinalizedNodes.size > 0 ? queueMicrotask(this.finalize) : this.finalizationScheduled = !1;
    }, this.registry = new tE(this.deleteNode.bind(this));
  }
  has(e) {
    return this.map.has(e);
  }
  get(e) {
    const r = this.getNode(e);
    return r && r.value;
  }
  getNode(e) {
    const r = this.map.get(e);
    if (r && r !== this.newest) {
      const { older: i, newer: f } = r;
      f && (f.older = i), i && (i.newer = f), r.older = this.newest, r.older.newer = r, r.newer = null, this.newest = r, r === this.oldest && (this.oldest = f);
    }
    return r;
  }
  set(e, r) {
    let i = this.getNode(e);
    return i ? i.value = r : (i = {
      key: e,
      value: r,
      newer: null,
      older: this.newest
    }, this.newest && (this.newest.newer = i), this.newest = i, this.oldest = this.oldest || i, this.scheduleFinalization(i), this.map.set(e, i), this.size++, i.value);
  }
  clean() {
    for (; this.oldest && this.size > this.max; )
      this.deleteNode(this.oldest);
  }
  deleteNode(e) {
    e === this.newest && (this.newest = e.older), e === this.oldest && (this.oldest = e.newer), e.newer && (e.newer.older = e.older), e.older && (e.older.newer = e.newer), this.size--;
    const r = e.key || e.keyRef && e.keyRef.deref();
    this.dispose(e.value, r), e.keyRef ? this.registry.unregister(e) : this.unfinalizedNodes.delete(e), r && this.map.delete(r);
  }
  delete(e) {
    const r = this.map.get(e);
    return r ? (this.deleteNode(r), !0) : !1;
  }
  scheduleFinalization(e) {
    this.unfinalizedNodes.add(e), this.finalizationScheduled || (this.finalizationScheduled = !0, queueMicrotask(this.finalize));
  }
}
var wd = /* @__PURE__ */ new WeakSet();
function Y5(t) {
  t.size <= (t.max || -1) || wd.has(t) || (wd.add(t), setTimeout(function() {
    t.clean(), wd.delete(t);
  }, 100));
}
var Fv = function(t, e) {
  var r = new Ml(t, e);
  return r.set = function(i, f) {
    var a = Ml.prototype.set.call(this, i, f);
    return Y5(this), a;
  }, r;
}, nE = function(t, e) {
  var r = new _1(t, e);
  return r.set = function(i, f) {
    var a = _1.prototype.set.call(this, i, f);
    return Y5(this), a;
  }, r;
}, iE = Symbol.for("apollo.cacheSize"), ri = We({}, m1[iE]), Aa = {};
function qv(t, e) {
  Aa[t] = e;
}
var aE = globalThis.__DEV__ !== !1 ? uE : void 0, sE = globalThis.__DEV__ !== !1 ? lE : void 0, oE = globalThis.__DEV__ !== !1 ? J5 : void 0;
function fE() {
  var t = {
    parser: 1e3,
    canonicalStringify: 1e3,
    print: 2e3,
    "documentTransform.cache": 2e3,
    "queryManager.getDocumentInfo": 2e3,
    "PersistedQueryLink.persistedQueryHashes": 2e3,
    "fragmentRegistry.transform": 2e3,
    "fragmentRegistry.lookup": 1e3,
    "fragmentRegistry.findFragmentSpreads": 4e3,
    "cache.fragmentQueryDocuments": 1e3,
    "removeTypenameFromVariables.getVariableDefinitions": 2e3,
    "inMemoryCache.maybeBroadcastWatch": 5e3,
    "inMemoryCache.executeSelectionSet": 5e4,
    "inMemoryCache.executeSubSelectedArray": 1e4
  };
  return Object.fromEntries(Object.entries(t).map(function(e) {
    var r = e[0], i = e[1];
    return [
      r,
      ri[r] || i
    ];
  }));
}
function uE() {
  var t, e, r, i, f;
  if (globalThis.__DEV__ === !1)
    throw new Error("only supported in development mode");
  return {
    limits: fE(),
    sizes: We({ print: (t = Aa.print) === null || t === void 0 ? void 0 : t.call(Aa), parser: (e = Aa.parser) === null || e === void 0 ? void 0 : e.call(Aa), canonicalStringify: (r = Aa.canonicalStringify) === null || r === void 0 ? void 0 : r.call(Aa), links: S1(this.link), queryManager: {
      getDocumentInfo: this.queryManager.transformCache.size,
      documentTransforms: e4(this.queryManager.documentTransform)
    } }, (f = (i = this.cache).getMemoryInternals) === null || f === void 0 ? void 0 : f.call(i))
  };
}
function J5() {
  return {
    cache: {
      fragmentQueryDocuments: $i(this.getFragmentDoc)
    }
  };
}
function lE() {
  var t = this.config.fragments;
  return We(We({}, J5.apply(this)), { addTypenameDocumentTransform: e4(this.addTypenameTransform), inMemoryCache: {
    executeSelectionSet: $i(this.storeReader.executeSelectionSet),
    executeSubSelectedArray: $i(this.storeReader.executeSubSelectedArray),
    maybeBroadcastWatch: $i(this.maybeBroadcastWatch)
  }, fragmentRegistry: {
    findFragmentSpreads: $i(t == null ? void 0 : t.findFragmentSpreads),
    lookup: $i(t == null ? void 0 : t.lookup),
    transform: $i(t == null ? void 0 : t.transform)
  } });
}
function cE(t) {
  return !!t && "dirtyKey" in t;
}
function $i(t) {
  return cE(t) ? t.size : void 0;
}
function X5(t) {
  return t != null;
}
function e4(t) {
  return M1(t).map(function(e) {
    return { cache: e };
  });
}
function M1(t) {
  return t ? On(On([
    $i(t == null ? void 0 : t.performWork)
  ], M1(t == null ? void 0 : t.left), !0), M1(t == null ? void 0 : t.right), !0).filter(X5) : [];
}
function S1(t) {
  var e;
  return t ? On(On([
    (e = t == null ? void 0 : t.getMemoryInternals) === null || e === void 0 ? void 0 : e.call(t)
  ], S1(t == null ? void 0 : t.left), !0), S1(t == null ? void 0 : t.right), !0).filter(X5) : [];
}
var Qi = Object.assign(function(e) {
  return JSON.stringify(e, dE);
}, {
  reset: function() {
    Is = new nE(
      ri.canonicalStringify || 1e3
      /* defaultCacheSizes.canonicalStringify */
    );
  }
});
globalThis.__DEV__ !== !1 && qv("canonicalStringify", function() {
  return Is.size;
});
var Is;
Qi.reset();
function dE(t, e) {
  if (e && typeof e == "object") {
    var r = Object.getPrototypeOf(e);
    if (r === Object.prototype || r === null) {
      var i = Object.keys(e);
      if (i.every(hE))
        return e;
      var f = JSON.stringify(i), a = Is.get(f);
      if (!a) {
        i.sort();
        var l = JSON.stringify(i);
        a = Is.get(l) || i, Is.set(f, a), Is.set(l, a);
      }
      var d = Object.create(r);
      return a.forEach(function(v) {
        d[v] = e[v];
      }), d;
    }
  }
  return e;
}
function hE(t, e, r) {
  return e === 0 || r[e - 1] <= t;
}
function Fs(t) {
  return { __ref: String(t) };
}
function tr(t) {
  return !!(t && typeof t == "object" && typeof t.__ref == "string");
}
function pE(t) {
  return lr(t) && t.kind === "Document" && Array.isArray(t.definitions);
}
function vE(t) {
  return t.kind === "StringValue";
}
function mE(t) {
  return t.kind === "BooleanValue";
}
function gE(t) {
  return t.kind === "IntValue";
}
function yE(t) {
  return t.kind === "FloatValue";
}
function bE(t) {
  return t.kind === "Variable";
}
function wE(t) {
  return t.kind === "ObjectValue";
}
function _E(t) {
  return t.kind === "ListValue";
}
function xE(t) {
  return t.kind === "EnumValue";
}
function ME(t) {
  return t.kind === "NullValue";
}
function Hs(t, e, r, i) {
  if (gE(r) || yE(r))
    t[e.value] = Number(r.value);
  else if (mE(r) || vE(r))
    t[e.value] = r.value;
  else if (wE(r)) {
    var f = {};
    r.fields.map(function(l) {
      return Hs(f, l.name, l.value, i);
    }), t[e.value] = f;
  } else if (bE(r)) {
    var a = (i || {})[r.name.value];
    t[e.value] = a;
  } else if (_E(r))
    t[e.value] = r.values.map(function(l) {
      var d = {};
      return Hs(d, e, l, i), d[e.value];
    });
  else if (xE(r))
    t[e.value] = r.value;
  else if (ME(r))
    t[e.value] = null;
  else
    throw Gr(82, e.value, r.kind);
}
function SE(t, e) {
  var r = null;
  t.directives && (r = {}, t.directives.forEach(function(f) {
    r[f.name.value] = {}, f.arguments && f.arguments.forEach(function(a) {
      var l = a.name, d = a.value;
      return Hs(r[f.name.value], l, d, e);
    });
  }));
  var i = null;
  return t.arguments && t.arguments.length && (i = {}, t.arguments.forEach(function(f) {
    var a = f.name, l = f.value;
    return Hs(i, a, l, e);
  })), t4(t.name.value, i, r);
}
var EE = [
  "connection",
  "include",
  "skip",
  "client",
  "rest",
  "export",
  "nonreactive"
], Eo = Qi, t4 = Object.assign(function(t, e, r) {
  if (e && r && r.connection && r.connection.key)
    if (r.connection.filter && r.connection.filter.length > 0) {
      var i = r.connection.filter ? r.connection.filter : [];
      i.sort();
      var f = {};
      return i.forEach(function(d) {
        f[d] = e[d];
      }), "".concat(r.connection.key, "(").concat(Eo(f), ")");
    } else
      return r.connection.key;
  var a = t;
  if (e) {
    var l = Eo(e);
    a += "(".concat(l, ")");
  }
  return r && Object.keys(r).forEach(function(d) {
    EE.indexOf(d) === -1 && (r[d] && Object.keys(r[d]).length ? a += "@".concat(d, "(").concat(Eo(r[d]), ")") : a += "@".concat(d));
  }), a;
}, {
  setStringify: function(t) {
    var e = Eo;
    return Eo = t, e;
  }
});
function Wl(t, e) {
  if (t.arguments && t.arguments.length) {
    var r = {};
    return t.arguments.forEach(function(i) {
      var f = i.name, a = i.value;
      return Hs(r, f, a, e);
    }), r;
  }
  return null;
}
function aa(t) {
  return t.alias ? t.alias.value : t.name.value;
}
function E1(t, e, r) {
  for (var i, f = 0, a = e.selections; f < a.length; f++) {
    var l = a[f];
    if (sa(l)) {
      if (l.name.value === "__typename")
        return t[aa(l)];
    } else
      i ? i.push(l) : i = [l];
  }
  if (typeof t.__typename == "string")
    return t.__typename;
  if (i)
    for (var d = 0, v = i; d < v.length; d++) {
      var l = v[d], m = E1(t, Hl(l, r).selectionSet, r);
      if (typeof m == "string")
        return m;
    }
}
function sa(t) {
  return t.kind === "Field";
}
function AE(t) {
  return t.kind === "InlineFragment";
}
function Uf(t) {
  Rt(t && t.kind === "Document", 74);
  var e = t.definitions.filter(function(r) {
    return r.kind !== "FragmentDefinition";
  }).map(function(r) {
    if (r.kind !== "OperationDefinition")
      throw Gr(75, r.kind);
    return r;
  });
  return Rt(e.length <= 1, 76, e.length), t;
}
function Lf(t) {
  return Uf(t), t.definitions.filter(function(e) {
    return e.kind === "OperationDefinition";
  })[0];
}
function A1(t) {
  return t.definitions.filter(function(e) {
    return e.kind === "OperationDefinition" && !!e.name;
  }).map(function(e) {
    return e.name.value;
  })[0] || null;
}
function Kl(t) {
  return t.definitions.filter(function(e) {
    return e.kind === "FragmentDefinition";
  });
}
function r4(t) {
  var e = Lf(t);
  return Rt(e && e.operation === "query", 77), e;
}
function kE(t) {
  Rt(t.kind === "Document", 78), Rt(t.definitions.length <= 1, 79);
  var e = t.definitions[0];
  return Rt(e.kind === "FragmentDefinition", 80), e;
}
function oo(t) {
  Uf(t);
  for (var e, r = 0, i = t.definitions; r < i.length; r++) {
    var f = i[r];
    if (f.kind === "OperationDefinition") {
      var a = f.operation;
      if (a === "query" || a === "mutation" || a === "subscription")
        return f;
    }
    f.kind === "FragmentDefinition" && !e && (e = f);
  }
  if (e)
    return e;
  throw Gr(81);
}
function zv(t) {
  var e = /* @__PURE__ */ Object.create(null), r = t && t.variableDefinitions;
  return r && r.length && r.forEach(function(i) {
    i.defaultValue && Hs(e, i.variable.name, i.defaultValue);
  }), e;
}
const TE = () => /* @__PURE__ */ Object.create(null), { forEach: CE, slice: BE } = Array.prototype, { hasOwnProperty: IE } = Object.prototype;
class jv {
  constructor(e = !0, r = TE) {
    this.weakness = e, this.makeData = r;
  }
  lookup(...e) {
    return this.lookupArray(e);
  }
  lookupArray(e) {
    let r = this;
    return CE.call(e, (i) => r = r.getChildTrie(i)), IE.call(r, "data") ? r.data : r.data = this.makeData(BE.call(e));
  }
  peek(...e) {
    return this.peekArray(e);
  }
  peekArray(e) {
    let r = this;
    for (let i = 0, f = e.length; r && i < f; ++i) {
      const a = this.weakness && ty(e[i]) ? r.weak : r.strong;
      r = a && a.get(e[i]);
    }
    return r && r.data;
  }
  getChildTrie(e) {
    const r = this.weakness && ty(e) ? this.weak || (this.weak = /* @__PURE__ */ new WeakMap()) : this.strong || (this.strong = /* @__PURE__ */ new Map());
    let i = r.get(e);
    return i || r.set(e, i = new jv(this.weakness, this.makeData)), i;
  }
}
function ty(t) {
  switch (typeof t) {
    case "object":
      if (t === null)
        break;
    case "function":
      return !0;
  }
  return !1;
}
let Ir = null;
const ry = {};
let RE = 1;
const PE = () => class {
  constructor() {
    this.id = [
      "slot",
      RE++,
      Date.now(),
      Math.random().toString(36).slice(2)
    ].join(":");
  }
  hasValue() {
    for (let e = Ir; e; e = e.parent)
      if (this.id in e.slots) {
        const r = e.slots[this.id];
        if (r === ry)
          break;
        return e !== Ir && (Ir.slots[this.id] = r), !0;
      }
    return Ir && (Ir.slots[this.id] = ry), !1;
  }
  getValue() {
    if (this.hasValue())
      return Ir.slots[this.id];
  }
  withValue(e, r, i, f) {
    const a = {
      __proto__: null,
      [this.id]: e
    }, l = Ir;
    Ir = { parent: l, slots: a };
    try {
      return r.apply(f, i);
    } finally {
      Ir = l;
    }
  }
  // Capture the current context and wrap a callback function so that it
  // reestablishes the captured context when called.
  static bind(e) {
    const r = Ir;
    return function() {
      const i = Ir;
      try {
        return Ir = r, e.apply(this, arguments);
      } finally {
        Ir = i;
      }
    };
  }
  // Immediately run a callback function without any captured context.
  static noContext(e, r, i) {
    if (Ir) {
      const f = Ir;
      try {
        return Ir = null, e.apply(i, r);
      } finally {
        Ir = f;
      }
    } else
      return e.apply(i, r);
  }
};
function ny(t) {
  try {
    return t();
  } catch {
  }
}
const _d = "@wry/context:Slot", OE = (
  // Prefer globalThis when available.
  // https://github.com/benjamn/wryware/issues/347
  ny(() => globalThis) || // Fall back to global, which works in Node.js and may be converted by some
  // bundlers to the appropriate identifier (window, self, ...) depending on the
  // bundling target. https://github.com/endojs/endo/issues/576#issuecomment-1178515224
  ny(() => Gi) || // Otherwise, use a dummy host that's local to this module. We used to fall
  // back to using the Array constructor as a namespace, but that was flagged in
  // https://github.com/benjamn/wryware/issues/347, and can be avoided.
  /* @__PURE__ */ Object.create(null)
), iy = OE, n4 = iy[_d] || // Earlier versions of this package stored the globalKey property on the Array
// constructor, so we check there as well, to prevent Slot class duplication.
Array[_d] || function(t) {
  try {
    Object.defineProperty(iy, _d, {
      value: t,
      enumerable: !1,
      writable: !1,
      // When it was possible for globalHost to be the Array constructor (a
      // legacy Slot dedup strategy), it was important for the property to be
      // configurable:true so it could be deleted. That does not seem to be as
      // important when globalHost is the global object, but I don't want to
      // cause similar problems again, and configurable:true seems safest.
      // https://github.com/endojs/endo/issues/576#issuecomment-1178274008
      configurable: !0
    });
  } finally {
    return t;
  }
}(PE()), Zl = new n4(), { hasOwnProperty: NE } = Object.prototype, $v = Array.from || function(t) {
  const e = [];
  return t.forEach((r) => e.push(r)), e;
};
function Vv(t) {
  const { unsubscribe: e } = t;
  typeof e == "function" && (t.unsubscribe = void 0, e());
}
const kf = [], DE = 100;
function Ws(t, e) {
  if (!t)
    throw new Error(e || "assertion failure");
}
function i4(t, e) {
  const r = t.length;
  return (
    // Unknown values are not equal to each other.
    r > 0 && // Both values must be ordinary (or both exceptional) to be equal.
    r === e.length && // The underlying value or exception must be the same.
    t[r - 1] === e[r - 1]
  );
}
function a4(t) {
  switch (t.length) {
    case 0:
      throw new Error("unknown value");
    case 1:
      return t[0];
    case 2:
      throw t[1];
  }
}
function s4(t) {
  return t.slice(0);
}
class Gl {
  constructor(e) {
    this.fn = e, this.parents = /* @__PURE__ */ new Set(), this.childValues = /* @__PURE__ */ new Map(), this.dirtyChildren = null, this.dirty = !0, this.recomputing = !1, this.value = [], this.deps = null, ++Gl.count;
  }
  peek() {
    if (this.value.length === 1 && !oa(this))
      return ay(this), this.value[0];
  }
  // This is the most important method of the Entry API, because it
  // determines whether the cached this.value can be returned immediately,
  // or must be recomputed. The overall performance of the caching system
  // depends on the truth of the following observations: (1) this.dirty is
  // usually false, (2) this.dirtyChildren is usually null/empty, and thus
  // (3) valueGet(this.value) is usually returned without recomputation.
  recompute(e) {
    return Ws(!this.recomputing, "already recomputing"), ay(this), oa(this) ? UE(this, e) : a4(this.value);
  }
  setDirty() {
    this.dirty || (this.dirty = !0, o4(this), Vv(this));
  }
  dispose() {
    this.setDirty(), d4(this), Hv(this, (e, r) => {
      e.setDirty(), h4(e, this);
    });
  }
  forget() {
    this.dispose();
  }
  dependOn(e) {
    e.add(this), this.deps || (this.deps = kf.pop() || /* @__PURE__ */ new Set()), this.deps.add(e);
  }
  forgetDeps() {
    this.deps && ($v(this.deps).forEach((e) => e.delete(this)), this.deps.clear(), kf.push(this.deps), this.deps = null);
  }
}
Gl.count = 0;
function ay(t) {
  const e = Zl.getValue();
  if (e)
    return t.parents.add(e), e.childValues.has(t) || e.childValues.set(t, []), oa(t) ? u4(e, t) : l4(e, t), e;
}
function UE(t, e) {
  return d4(t), Zl.withValue(t, LE, [t, e]), qE(t, e) && FE(t), a4(t.value);
}
function LE(t, e) {
  t.recomputing = !0;
  const { normalizeResult: r } = t;
  let i;
  r && t.value.length === 1 && (i = s4(t.value)), t.value.length = 0;
  try {
    if (t.value[0] = t.fn.apply(null, e), r && i && !i4(i, t.value))
      try {
        t.value[0] = r(t.value[0], i[0]);
      } catch {
      }
  } catch (f) {
    t.value[1] = f;
  }
  t.recomputing = !1;
}
function oa(t) {
  return t.dirty || !!(t.dirtyChildren && t.dirtyChildren.size);
}
function FE(t) {
  t.dirty = !1, !oa(t) && f4(t);
}
function o4(t) {
  Hv(t, u4);
}
function f4(t) {
  Hv(t, l4);
}
function Hv(t, e) {
  const r = t.parents.size;
  if (r) {
    const i = $v(t.parents);
    for (let f = 0; f < r; ++f)
      e(i[f], t);
  }
}
function u4(t, e) {
  Ws(t.childValues.has(e)), Ws(oa(e));
  const r = !oa(t);
  if (!t.dirtyChildren)
    t.dirtyChildren = kf.pop() || /* @__PURE__ */ new Set();
  else if (t.dirtyChildren.has(e))
    return;
  t.dirtyChildren.add(e), r && o4(t);
}
function l4(t, e) {
  Ws(t.childValues.has(e)), Ws(!oa(e));
  const r = t.childValues.get(e);
  r.length === 0 ? t.childValues.set(e, s4(e.value)) : i4(r, e.value) || t.setDirty(), c4(t, e), !oa(t) && f4(t);
}
function c4(t, e) {
  const r = t.dirtyChildren;
  r && (r.delete(e), r.size === 0 && (kf.length < DE && kf.push(r), t.dirtyChildren = null));
}
function d4(t) {
  t.childValues.size > 0 && t.childValues.forEach((e, r) => {
    h4(t, r);
  }), t.forgetDeps(), Ws(t.dirtyChildren === null);
}
function h4(t, e) {
  e.parents.delete(t), t.childValues.delete(e), c4(t, e);
}
function qE(t, e) {
  if (typeof t.subscribe == "function")
    try {
      Vv(t), t.unsubscribe = t.subscribe.apply(null, e);
    } catch {
      return t.setDirty(), !1;
    }
  return !0;
}
const zE = {
  setDirty: !0,
  dispose: !0,
  forget: !0
  // Fully remove parent Entry from LRU cache and computation graph
};
function p4(t) {
  const e = /* @__PURE__ */ new Map();
  function r(i) {
    const f = Zl.getValue();
    if (f) {
      let a = e.get(i);
      a || e.set(i, a = /* @__PURE__ */ new Set()), f.dependOn(a);
    }
  }
  return r.dirty = function(f, a) {
    const l = e.get(f);
    if (l) {
      const d = a && NE.call(zE, a) ? a : "setDirty";
      $v(l).forEach((v) => v[d]()), e.delete(f), Vv(l);
    }
  }, r;
}
let sy;
function jE(...t) {
  return (sy || (sy = new jv(typeof WeakMap == "function"))).lookupArray(t);
}
const xd = /* @__PURE__ */ new Set();
function Tf(t, { max: e = Math.pow(2, 16), keyArgs: r, makeCacheKey: i = jE, normalizeResult: f, subscribe: a, cache: l = _1 } = /* @__PURE__ */ Object.create(null)) {
  const d = typeof l == "function" ? new l(e, (M) => M.dispose()) : l, v = function() {
    const M = i.apply(null, r ? r.apply(null, arguments) : arguments);
    if (M === void 0)
      return t.apply(null, arguments);
    let S = d.get(M);
    S || (d.set(M, S = new Gl(t)), S.normalizeResult = f, S.subscribe = a, S.forget = () => d.delete(M));
    const E = S.recompute(Array.prototype.slice.call(arguments));
    return d.set(M, S), xd.add(d), Zl.hasValue() || (xd.forEach((A) => A.clean()), xd.clear()), E;
  };
  Object.defineProperty(v, "size", {
    get: () => d.size,
    configurable: !1,
    enumerable: !1
  }), Object.freeze(v.options = {
    max: e,
    keyArgs: r,
    makeCacheKey: i,
    normalizeResult: f,
    subscribe: a,
    cache: d
  });
  function m(M) {
    const S = M && d.get(M);
    S && S.setDirty();
  }
  v.dirtyKey = m, v.dirty = function() {
    m(i.apply(null, arguments));
  };
  function h(M) {
    const S = M && d.get(M);
    if (S)
      return S.peek();
  }
  v.peekKey = h, v.peek = function() {
    return h(i.apply(null, arguments));
  };
  function w(M) {
    return M ? d.delete(M) : !1;
  }
  return v.forgetKey = w, v.forget = function() {
    return w(i.apply(null, arguments));
  }, v.makeCacheKey = i, v.getKey = r ? function() {
    return i.apply(null, r.apply(null, arguments));
  } : i, Object.freeze(v);
}
function $E(t) {
  return t;
}
var v4 = (
  /** @class */
  function() {
    function t(e, r) {
      r === void 0 && (r = /* @__PURE__ */ Object.create(null)), this.resultCache = Q5 ? /* @__PURE__ */ new WeakSet() : /* @__PURE__ */ new Set(), this.transform = e, r.getCacheKey && (this.getCacheKey = r.getCacheKey), this.cached = r.cache !== !1, this.resetCache();
    }
    return t.prototype.getCacheKey = function(e) {
      return [e];
    }, t.identity = function() {
      return new t($E, { cache: !1 });
    }, t.split = function(e, r, i) {
      return i === void 0 && (i = t.identity()), Object.assign(new t(
        function(f) {
          var a = e(f) ? r : i;
          return a.transformDocument(f);
        },
        // Reasonably assume both `left` and `right` transforms handle their own caching
        { cache: !1 }
      ), { left: r, right: i });
    }, t.prototype.resetCache = function() {
      var e = this;
      if (this.cached) {
        var r = new so(ps);
        this.performWork = Tf(t.prototype.performWork.bind(this), {
          makeCacheKey: function(i) {
            var f = e.getCacheKey(i);
            if (f)
              return Rt(Array.isArray(f), 66), r.lookupArray(f);
          },
          max: ri["documentTransform.cache"],
          cache: Ml
        });
      }
    }, t.prototype.performWork = function(e) {
      return Uf(e), this.transform(e);
    }, t.prototype.transformDocument = function(e) {
      if (this.resultCache.has(e))
        return e;
      var r = this.performWork(e);
      return this.resultCache.add(r), r;
    }, t.prototype.concat = function(e) {
      var r = this;
      return Object.assign(new t(
        function(i) {
          return e.transformDocument(r.transformDocument(i));
        },
        // Reasonably assume both transforms handle their own caching
        { cache: !1 }
      ), {
        left: this,
        right: e
      });
    }, t;
  }()
), yf, Ff = Object.assign(function(t) {
  var e = yf.get(t);
  return e || (e = Z5(t), yf.set(t, e)), e;
}, {
  reset: function() {
    yf = new Fv(
      ri.print || 2e3
      /* defaultCacheSizes.print */
    );
  }
});
Ff.reset();
globalThis.__DEV__ !== !1 && qv("print", function() {
  return yf ? yf.size : 0;
});
var yr = Array.isArray;
function En(t) {
  return Array.isArray(t) && t.length > 0;
}
var oy = {
  kind: Ct.FIELD,
  name: {
    kind: Ct.NAME,
    value: "__typename"
  }
};
function m4(t, e) {
  return !t || t.selectionSet.selections.every(function(r) {
    return r.kind === Ct.FRAGMENT_SPREAD && m4(e[r.name.value], e);
  });
}
function VE(t) {
  return m4(Lf(t) || kE(t), Vl(Kl(t))) ? null : t;
}
function HE(t) {
  var e = /* @__PURE__ */ new Map(), r = /* @__PURE__ */ new Map();
  return t.forEach(function(i) {
    i && (i.name ? e.set(i.name, i) : i.test && r.set(i.test, i));
  }), function(i) {
    var f = e.get(i.name.value);
    return !f && r.size && r.forEach(function(a, l) {
      l(i) && (f = a);
    }), f;
  };
}
function fy(t) {
  var e = /* @__PURE__ */ new Map();
  return function(i) {
    i === void 0 && (i = t);
    var f = e.get(i);
    return f || e.set(i, f = {
      // Variable and fragment spread names used directly within this
      // operation or fragment definition, as identified by key. These sets
      // will be populated during the first traversal of the document in
      // removeDirectivesFromDocument below.
      variables: /* @__PURE__ */ new Set(),
      fragmentSpreads: /* @__PURE__ */ new Set()
    }), f;
  };
}
function g4(t, e) {
  Uf(e);
  for (var r = fy(""), i = fy(""), f = function(k) {
    for (var C = 0, I = void 0; C < k.length && (I = k[C]); ++C)
      if (!yr(I)) {
        if (I.kind === Ct.OPERATION_DEFINITION)
          return r(I.name && I.name.value);
        if (I.kind === Ct.FRAGMENT_DEFINITION)
          return i(I.name.value);
      }
    return globalThis.__DEV__ !== !1 && Rt.error(83), null;
  }, a = 0, l = e.definitions.length - 1; l >= 0; --l)
    e.definitions[l].kind === Ct.OPERATION_DEFINITION && ++a;
  var d = HE(t), v = function(k) {
    return En(k) && k.map(d).some(function(C) {
      return C && C.remove;
    });
  }, m = /* @__PURE__ */ new Map(), h = !1, w = {
    enter: function(k) {
      if (v(k.directives))
        return h = !0, null;
    }
  }, M = Ai(e, {
    // These two AST node types share the same implementation, defined above.
    Field: w,
    InlineFragment: w,
    VariableDefinition: {
      enter: function() {
        return !1;
      }
    },
    Variable: {
      enter: function(k, C, I, O, q) {
        var $ = f(q);
        $ && $.variables.add(k.name.value);
      }
    },
    FragmentSpread: {
      enter: function(k, C, I, O, q) {
        if (v(k.directives))
          return h = !0, null;
        var $ = f(q);
        $ && $.fragmentSpreads.add(k.name.value);
      }
    },
    FragmentDefinition: {
      enter: function(k, C, I, O) {
        m.set(JSON.stringify(O), k);
      },
      leave: function(k, C, I, O) {
        var q = m.get(JSON.stringify(O));
        if (k === q)
          return k;
        if (
          // This logic applies only if the document contains one or more
          // operations, since removing all fragments from a document containing
          // only fragments makes the document useless.
          a > 0 && k.selectionSet.selections.every(function($) {
            return $.kind === Ct.FIELD && $.name.value === "__typename";
          })
        )
          return i(k.name.value).removed = !0, h = !0, null;
      }
    },
    Directive: {
      leave: function(k) {
        if (d(k))
          return h = !0, null;
      }
    }
  });
  if (!h)
    return e;
  var S = function(k) {
    return k.transitiveVars || (k.transitiveVars = new Set(k.variables), k.removed || k.fragmentSpreads.forEach(function(C) {
      S(i(C)).transitiveVars.forEach(function(I) {
        k.transitiveVars.add(I);
      });
    })), k;
  }, E = /* @__PURE__ */ new Set();
  M.definitions.forEach(function(k) {
    k.kind === Ct.OPERATION_DEFINITION ? S(r(k.name && k.name.value)).fragmentSpreads.forEach(function(C) {
      E.add(C);
    }) : k.kind === Ct.FRAGMENT_DEFINITION && // If there are no operations in the document, then all fragment
    // definitions count as usages of their own fragment names. This heuristic
    // prevents accidentally removing all fragment definitions from the
    // document just because it contains no operations that use the fragments.
    a === 0 && !i(k.name.value).removed && E.add(k.name.value);
  }), E.forEach(function(k) {
    S(i(k)).fragmentSpreads.forEach(function(C) {
      E.add(C);
    });
  });
  var A = function(k) {
    return !!// A fragment definition will be removed if there are no spreads that refer
    // to it, or the fragment was explicitly removed because it had no fields
    // other than __typename.
    (!E.has(k) || i(k).removed);
  }, B = {
    enter: function(k) {
      if (A(k.name.value))
        return null;
    }
  };
  return VE(Ai(M, {
    // If the fragment is going to be removed, then leaving any dangling
    // FragmentSpread nodes with the same name would be a mistake.
    FragmentSpread: B,
    // This is where the fragment definition is actually removed.
    FragmentDefinition: B,
    OperationDefinition: {
      leave: function(k) {
        if (k.variableDefinitions) {
          var C = S(
            // If an operation is anonymous, we use the empty string as its key.
            r(k.name && k.name.value)
          ).transitiveVars;
          if (C.size < k.variableDefinitions.length)
            return We(We({}, k), { variableDefinitions: k.variableDefinitions.filter(function(I) {
              return C.has(I.variable.name.value);
            }) });
        }
      }
    }
  }));
}
var Wv = Object.assign(function(t) {
  return Ai(t, {
    SelectionSet: {
      enter: function(e, r, i) {
        if (!(i && i.kind === Ct.OPERATION_DEFINITION)) {
          var f = e.selections;
          if (f) {
            var a = f.some(function(d) {
              return sa(d) && (d.name.value === "__typename" || d.name.value.lastIndexOf("__", 0) === 0);
            });
            if (!a) {
              var l = i;
              if (!(sa(l) && l.directives && l.directives.some(function(d) {
                return d.name.value === "export";
              })))
                return We(We({}, e), { selections: On(On([], f, !0), [oy], !1) });
            }
          }
        }
      }
    }
  });
}, {
  added: function(t) {
    return t === oy;
  }
});
function WE(t) {
  var e = oo(t), r = e.operation;
  if (r === "query")
    return t;
  var i = Ai(t, {
    OperationDefinition: {
      enter: function(f) {
        return We(We({}, f), { operation: "query" });
      }
    }
  });
  return i;
}
function y4(t) {
  Uf(t);
  var e = g4([
    {
      test: function(r) {
        return r.name.value === "client";
      },
      remove: !0
    }
  ], t);
  return e;
}
var KE = Object.prototype.hasOwnProperty;
function uy() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  return Ql(t);
}
function Ql(t) {
  var e = t[0] || {}, r = t.length;
  if (r > 1)
    for (var i = new fa(), f = 1; f < r; ++f)
      e = i.merge(e, t[f]);
  return e;
}
var ZE = function(t, e, r) {
  return this.merge(t[r], e[r]);
}, fa = (
  /** @class */
  function() {
    function t(e) {
      e === void 0 && (e = ZE), this.reconciler = e, this.isObject = lr, this.pastCopies = /* @__PURE__ */ new Set();
    }
    return t.prototype.merge = function(e, r) {
      for (var i = this, f = [], a = 2; a < arguments.length; a++)
        f[a - 2] = arguments[a];
      return lr(r) && lr(e) ? (Object.keys(r).forEach(function(l) {
        if (KE.call(e, l)) {
          var d = e[l];
          if (r[l] !== d) {
            var v = i.reconciler.apply(i, On([
              e,
              r,
              l
            ], f, !1));
            v !== d && (e = i.shallowCopyForMerge(e), e[l] = v);
          }
        } else
          e = i.shallowCopyForMerge(e), e[l] = r[l];
      }), e) : r;
    }, t.prototype.shallowCopyForMerge = function(e) {
      return lr(e) && (this.pastCopies.has(e) || (Array.isArray(e) ? e = e.slice(0) : e = We({ __proto__: Object.getPrototypeOf(e) }, e), this.pastCopies.add(e))), e;
    }, t;
  }()
);
function GE(t, e) {
  var r = typeof Symbol < "u" && t[Symbol.iterator] || t["@@iterator"];
  if (r)
    return (r = r.call(t)).next.bind(r);
  if (Array.isArray(t) || (r = QE(t)) || e) {
    r && (t = r);
    var i = 0;
    return function() {
      return i >= t.length ? { done: !0 } : { done: !1, value: t[i++] };
    };
  }
  throw new TypeError(`Invalid attempt to iterate non-iterable instance.
In order to be iterable, non-array objects must have a [Symbol.iterator]() method.`);
}
function QE(t, e) {
  if (t) {
    if (typeof t == "string")
      return ly(t, e);
    var r = Object.prototype.toString.call(t).slice(8, -1);
    if (r === "Object" && t.constructor && (r = t.constructor.name), r === "Map" || r === "Set")
      return Array.from(t);
    if (r === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))
      return ly(t, e);
  }
}
function ly(t, e) {
  (e == null || e > t.length) && (e = t.length);
  for (var r = 0, i = new Array(e); r < e; r++)
    i[r] = t[r];
  return i;
}
function cy(t, e) {
  for (var r = 0; r < e.length; r++) {
    var i = e[r];
    i.enumerable = i.enumerable || !1, i.configurable = !0, "value" in i && (i.writable = !0), Object.defineProperty(t, i.key, i);
  }
}
function Kv(t, e, r) {
  return e && cy(t.prototype, e), r && cy(t, r), Object.defineProperty(t, "prototype", { writable: !1 }), t;
}
var Zv = function() {
  return typeof Symbol == "function";
}, Gv = function(t) {
  return Zv() && !!Symbol[t];
}, Qv = function(t) {
  return Gv(t) ? Symbol[t] : "@@" + t;
};
Zv() && !Gv("observable") && (Symbol.observable = Symbol("observable"));
var YE = Qv("iterator"), k1 = Qv("observable"), b4 = Qv("species");
function Sl(t, e) {
  var r = t[e];
  if (r != null) {
    if (typeof r != "function")
      throw new TypeError(r + " is not a function");
    return r;
  }
}
function Ao(t) {
  var e = t.constructor;
  return e !== void 0 && (e = e[b4], e === null && (e = void 0)), e !== void 0 ? e : ar;
}
function JE(t) {
  return t instanceof ar;
}
function Ks(t) {
  Ks.log ? Ks.log(t) : setTimeout(function() {
    throw t;
  });
}
function qu(t) {
  Promise.resolve().then(function() {
    try {
      t();
    } catch (e) {
      Ks(e);
    }
  });
}
function w4(t) {
  var e = t._cleanup;
  if (e !== void 0 && (t._cleanup = void 0, !!e))
    try {
      if (typeof e == "function")
        e();
      else {
        var r = Sl(e, "unsubscribe");
        r && r.call(e);
      }
    } catch (i) {
      Ks(i);
    }
}
function T1(t) {
  t._observer = void 0, t._queue = void 0, t._state = "closed";
}
function XE(t) {
  var e = t._queue;
  if (e) {
    t._queue = void 0, t._state = "ready";
    for (var r = 0; r < e.length && (_4(t, e[r].type, e[r].value), t._state !== "closed"); ++r)
      ;
  }
}
function _4(t, e, r) {
  t._state = "running";
  var i = t._observer;
  try {
    var f = Sl(i, e);
    switch (e) {
      case "next":
        f && f.call(i, r);
        break;
      case "error":
        if (T1(t), f)
          f.call(i, r);
        else
          throw r;
        break;
      case "complete":
        T1(t), f && f.call(i);
        break;
    }
  } catch (a) {
    Ks(a);
  }
  t._state === "closed" ? w4(t) : t._state === "running" && (t._state = "ready");
}
function Md(t, e, r) {
  if (t._state !== "closed") {
    if (t._state === "buffering") {
      t._queue.push({
        type: e,
        value: r
      });
      return;
    }
    if (t._state !== "ready") {
      t._state = "buffering", t._queue = [{
        type: e,
        value: r
      }], qu(function() {
        return XE(t);
      });
      return;
    }
    _4(t, e, r);
  }
}
var eA = /* @__PURE__ */ function() {
  function t(r, i) {
    this._cleanup = void 0, this._observer = r, this._queue = void 0, this._state = "initializing";
    var f = new tA(this);
    try {
      this._cleanup = i.call(void 0, f);
    } catch (a) {
      f.error(a);
    }
    this._state === "initializing" && (this._state = "ready");
  }
  var e = t.prototype;
  return e.unsubscribe = function() {
    this._state !== "closed" && (T1(this), w4(this));
  }, Kv(t, [{
    key: "closed",
    get: function() {
      return this._state === "closed";
    }
  }]), t;
}(), tA = /* @__PURE__ */ function() {
  function t(r) {
    this._subscription = r;
  }
  var e = t.prototype;
  return e.next = function(i) {
    Md(this._subscription, "next", i);
  }, e.error = function(i) {
    Md(this._subscription, "error", i);
  }, e.complete = function() {
    Md(this._subscription, "complete");
  }, Kv(t, [{
    key: "closed",
    get: function() {
      return this._subscription._state === "closed";
    }
  }]), t;
}(), ar = /* @__PURE__ */ function() {
  function t(r) {
    if (!(this instanceof t))
      throw new TypeError("Observable cannot be called as a function");
    if (typeof r != "function")
      throw new TypeError("Observable initializer must be a function");
    this._subscriber = r;
  }
  var e = t.prototype;
  return e.subscribe = function(i) {
    return (typeof i != "object" || i === null) && (i = {
      next: i,
      error: arguments[1],
      complete: arguments[2]
    }), new eA(i, this._subscriber);
  }, e.forEach = function(i) {
    var f = this;
    return new Promise(function(a, l) {
      if (typeof i != "function") {
        l(new TypeError(i + " is not a function"));
        return;
      }
      function d() {
        v.unsubscribe(), a();
      }
      var v = f.subscribe({
        next: function(m) {
          try {
            i(m, d);
          } catch (h) {
            l(h), v.unsubscribe();
          }
        },
        error: l,
        complete: a
      });
    });
  }, e.map = function(i) {
    var f = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = Ao(this);
    return new a(function(l) {
      return f.subscribe({
        next: function(d) {
          try {
            d = i(d);
          } catch (v) {
            return l.error(v);
          }
          l.next(d);
        },
        error: function(d) {
          l.error(d);
        },
        complete: function() {
          l.complete();
        }
      });
    });
  }, e.filter = function(i) {
    var f = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = Ao(this);
    return new a(function(l) {
      return f.subscribe({
        next: function(d) {
          try {
            if (!i(d))
              return;
          } catch (v) {
            return l.error(v);
          }
          l.next(d);
        },
        error: function(d) {
          l.error(d);
        },
        complete: function() {
          l.complete();
        }
      });
    });
  }, e.reduce = function(i) {
    var f = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = Ao(this), l = arguments.length > 1, d = !1, v = arguments[1], m = v;
    return new a(function(h) {
      return f.subscribe({
        next: function(w) {
          var M = !d;
          if (d = !0, !M || l)
            try {
              m = i(m, w);
            } catch (S) {
              return h.error(S);
            }
          else
            m = w;
        },
        error: function(w) {
          h.error(w);
        },
        complete: function() {
          if (!d && !l)
            return h.error(new TypeError("Cannot reduce an empty sequence"));
          h.next(m), h.complete();
        }
      });
    });
  }, e.concat = function() {
    for (var i = this, f = arguments.length, a = new Array(f), l = 0; l < f; l++)
      a[l] = arguments[l];
    var d = Ao(this);
    return new d(function(v) {
      var m, h = 0;
      function w(M) {
        m = M.subscribe({
          next: function(S) {
            v.next(S);
          },
          error: function(S) {
            v.error(S);
          },
          complete: function() {
            h === a.length ? (m = void 0, v.complete()) : w(d.from(a[h++]));
          }
        });
      }
      return w(i), function() {
        m && (m.unsubscribe(), m = void 0);
      };
    });
  }, e.flatMap = function(i) {
    var f = this;
    if (typeof i != "function")
      throw new TypeError(i + " is not a function");
    var a = Ao(this);
    return new a(function(l) {
      var d = [], v = f.subscribe({
        next: function(h) {
          if (i)
            try {
              h = i(h);
            } catch (M) {
              return l.error(M);
            }
          var w = a.from(h).subscribe({
            next: function(M) {
              l.next(M);
            },
            error: function(M) {
              l.error(M);
            },
            complete: function() {
              var M = d.indexOf(w);
              M >= 0 && d.splice(M, 1), m();
            }
          });
          d.push(w);
        },
        error: function(h) {
          l.error(h);
        },
        complete: function() {
          m();
        }
      });
      function m() {
        v.closed && d.length === 0 && l.complete();
      }
      return function() {
        d.forEach(function(h) {
          return h.unsubscribe();
        }), v.unsubscribe();
      };
    });
  }, e[k1] = function() {
    return this;
  }, t.from = function(i) {
    var f = typeof this == "function" ? this : t;
    if (i == null)
      throw new TypeError(i + " is not an object");
    var a = Sl(i, k1);
    if (a) {
      var l = a.call(i);
      if (Object(l) !== l)
        throw new TypeError(l + " is not an object");
      return JE(l) && l.constructor === f ? l : new f(function(d) {
        return l.subscribe(d);
      });
    }
    if (Gv("iterator") && (a = Sl(i, YE), a))
      return new f(function(d) {
        qu(function() {
          if (!d.closed) {
            for (var v = GE(a.call(i)), m; !(m = v()).done; ) {
              var h = m.value;
              if (d.next(h), d.closed)
                return;
            }
            d.complete();
          }
        });
      });
    if (Array.isArray(i))
      return new f(function(d) {
        qu(function() {
          if (!d.closed) {
            for (var v = 0; v < i.length; ++v)
              if (d.next(i[v]), d.closed)
                return;
            d.complete();
          }
        });
      });
    throw new TypeError(i + " is not observable");
  }, t.of = function() {
    for (var i = arguments.length, f = new Array(i), a = 0; a < i; a++)
      f[a] = arguments[a];
    var l = typeof this == "function" ? this : t;
    return new l(function(d) {
      qu(function() {
        if (!d.closed) {
          for (var v = 0; v < f.length; ++v)
            if (d.next(f[v]), d.closed)
              return;
          d.complete();
        }
      });
    });
  }, Kv(t, null, [{
    key: b4,
    get: function() {
      return this;
    }
  }]), t;
}();
Zv() && Object.defineProperty(ar, Symbol("extensions"), {
  value: {
    symbol: k1,
    hostReportError: Ks
  },
  configurable: !0
});
function rA(t) {
  var e, r = t.Symbol;
  if (typeof r == "function")
    if (r.observable)
      e = r.observable;
    else {
      typeof r.for == "function" ? e = r.for("https://github.com/benlesh/symbol-observable") : e = r("https://github.com/benlesh/symbol-observable");
      try {
        r.observable = e;
      } catch {
      }
    }
  else
    e = "@@observable";
  return e;
}
var Ms;
typeof self < "u" ? Ms = self : typeof window < "u" ? Ms = window : typeof Gi < "u" ? Ms = Gi : typeof module < "u" ? Ms = module : Ms = Function("return this")();
rA(Ms);
var dy = ar.prototype, hy = "@@observable";
dy[hy] || (dy[hy] = function() {
  return this;
});
var nA = Object.prototype.toString;
function x4(t) {
  return C1(t);
}
function C1(t, e) {
  switch (nA.call(t)) {
    case "[object Array]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(t))
        return e.get(t);
      var r = t.slice(0);
      return e.set(t, r), r.forEach(function(f, a) {
        r[a] = C1(f, e);
      }), r;
    }
    case "[object Object]": {
      if (e = e || /* @__PURE__ */ new Map(), e.has(t))
        return e.get(t);
      var i = Object.create(Object.getPrototypeOf(t));
      return e.set(t, i), Object.keys(t).forEach(function(f) {
        i[f] = C1(t[f], e);
      }), i;
    }
    default:
      return t;
  }
}
function iA(t) {
  var e = /* @__PURE__ */ new Set([t]);
  return e.forEach(function(r) {
    lr(r) && aA(r) === r && Object.getOwnPropertyNames(r).forEach(function(i) {
      lr(r[i]) && e.add(r[i]);
    });
  }), t;
}
function aA(t) {
  if (globalThis.__DEV__ !== !1 && !Object.isFrozen(t))
    try {
      Object.freeze(t);
    } catch (e) {
      if (e instanceof TypeError)
        return null;
      throw e;
    }
  return t;
}
function Cf(t) {
  return globalThis.__DEV__ !== !1 && iA(t), t;
}
function bf(t, e, r) {
  var i = [];
  t.forEach(function(f) {
    return f[e] && i.push(f);
  }), i.forEach(function(f) {
    return f[e](r);
  });
}
function Sd(t, e, r) {
  return new ar(function(i) {
    var f = {
      // Normally we would initialize promiseQueue to Promise.resolve(), but
      // in this case, for backwards compatibility, we need to be careful to
      // invoke the first callback synchronously.
      then: function(v) {
        return new Promise(function(m) {
          return m(v());
        });
      }
    };
    function a(v, m) {
      return function(h) {
        if (v) {
          var w = function() {
            return i.closed ? (
              /* will be swallowed */
              0
            ) : v(h);
          };
          f = f.then(w, w).then(function(M) {
            return i.next(M);
          }, function(M) {
            return i.error(M);
          });
        } else
          i[m](h);
      };
    }
    var l = {
      next: a(e, "next"),
      error: a(r, "error"),
      complete: function() {
        f.then(function() {
          return i.complete();
        });
      }
    }, d = t.subscribe(l);
    return function() {
      return d.unsubscribe();
    };
  });
}
function M4(t) {
  function e(r) {
    Object.defineProperty(t, r, { value: ar });
  }
  return Lv && Symbol.species && e(Symbol.species), e("@@species"), t;
}
function py(t) {
  return t && typeof t.then == "function";
}
var Ss = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      var i = t.call(this, function(f) {
        return i.addObserver(f), function() {
          return i.removeObserver(f);
        };
      }) || this;
      return i.observers = /* @__PURE__ */ new Set(), i.promise = new Promise(function(f, a) {
        i.resolve = f, i.reject = a;
      }), i.handlers = {
        next: function(f) {
          i.sub !== null && (i.latest = ["next", f], i.notify("next", f), bf(i.observers, "next", f));
        },
        error: function(f) {
          var a = i.sub;
          a !== null && (a && setTimeout(function() {
            return a.unsubscribe();
          }), i.sub = null, i.latest = ["error", f], i.reject(f), i.notify("error", f), bf(i.observers, "error", f));
        },
        complete: function() {
          var f = i, a = f.sub, l = f.sources, d = l === void 0 ? [] : l;
          if (a !== null) {
            var v = d.shift();
            v ? py(v) ? v.then(function(m) {
              return i.sub = m.subscribe(i.handlers);
            }, i.handlers.error) : i.sub = v.subscribe(i.handlers) : (a && setTimeout(function() {
              return a.unsubscribe();
            }), i.sub = null, i.latest && i.latest[0] === "next" ? i.resolve(i.latest[1]) : i.resolve(), i.notify("complete"), bf(i.observers, "complete"));
          }
        }
      }, i.nextResultListeners = /* @__PURE__ */ new Set(), i.cancel = function(f) {
        i.reject(f), i.sources = [], i.handlers.complete();
      }, i.promise.catch(function(f) {
      }), typeof r == "function" && (r = [new ar(r)]), py(r) ? r.then(function(f) {
        return i.start(f);
      }, i.handlers.error) : i.start(r), i;
    }
    return e.prototype.start = function(r) {
      this.sub === void 0 && (this.sources = Array.from(r), this.handlers.complete());
    }, e.prototype.deliverLastMessage = function(r) {
      if (this.latest) {
        var i = this.latest[0], f = r[i];
        f && f.call(r, this.latest[1]), this.sub === null && i === "next" && r.complete && r.complete();
      }
    }, e.prototype.addObserver = function(r) {
      this.observers.has(r) || (this.deliverLastMessage(r), this.observers.add(r));
    }, e.prototype.removeObserver = function(r) {
      this.observers.delete(r) && this.observers.size < 1 && this.handlers.complete();
    }, e.prototype.notify = function(r, i) {
      var f = this.nextResultListeners;
      f.size && (this.nextResultListeners = /* @__PURE__ */ new Set(), f.forEach(function(a) {
        return a(r, i);
      }));
    }, e.prototype.beforeNext = function(r) {
      var i = !1;
      this.nextResultListeners.add(function(f, a) {
        i || (i = !0, r(f, a));
      });
    }, e;
  }(ar)
);
M4(Ss);
function qs(t) {
  return "incremental" in t;
}
function sA(t) {
  return "hasNext" in t && "data" in t;
}
function oA(t) {
  return qs(t) || sA(t);
}
function fA(t) {
  return lr(t) && "payload" in t;
}
function S4(t, e) {
  var r = t, i = new fa();
  return qs(e) && En(e.incremental) && e.incremental.forEach(function(f) {
    for (var a = f.data, l = f.path, d = l.length - 1; d >= 0; --d) {
      var v = l[d], m = !isNaN(+v), h = m ? [] : {};
      h[v] = a, a = h;
    }
    r = i.merge(r, a);
  }), r;
}
function zu(t) {
  var e = B1(t);
  return En(e);
}
function B1(t) {
  var e = En(t.errors) ? t.errors.slice(0) : [];
  return qs(t) && En(t.incremental) && t.incremental.forEach(function(r) {
    r.errors && e.push.apply(e, r.errors);
  }), e;
}
function Fa() {
  for (var t = [], e = 0; e < arguments.length; e++)
    t[e] = arguments[e];
  var r = /* @__PURE__ */ Object.create(null);
  return t.forEach(function(i) {
    i && Object.keys(i).forEach(function(f) {
      var a = i[f];
      a !== void 0 && (r[f] = a);
    });
  }), r;
}
function ju(t, e) {
  return Fa(t, e, e.variables && {
    variables: Fa(We(We({}, t && t.variables), e.variables))
  });
}
function Ed(t) {
  return new ar(function(e) {
    e.error(t);
  });
}
var E4 = function(t, e, r) {
  var i = new Error(r);
  throw i.name = "ServerError", i.response = t, i.statusCode = t.status, i.result = e, i;
};
function uA(t) {
  for (var e = [
    "query",
    "operationName",
    "variables",
    "extensions",
    "context"
  ], r = 0, i = Object.keys(t); r < i.length; r++) {
    var f = i[r];
    if (e.indexOf(f) < 0)
      throw Gr(43, f);
  }
  return t;
}
function lA(t, e) {
  var r = We({}, t), i = function(a) {
    typeof a == "function" ? r = We(We({}, r), a(r)) : r = We(We({}, r), a);
  }, f = function() {
    return We({}, r);
  };
  return Object.defineProperty(e, "setContext", {
    enumerable: !1,
    value: i
  }), Object.defineProperty(e, "getContext", {
    enumerable: !1,
    value: f
  }), e;
}
function cA(t) {
  var e = {
    variables: t.variables || {},
    extensions: t.extensions || {},
    operationName: t.operationName,
    query: t.query
  };
  return e.operationName || (e.operationName = typeof e.query != "string" ? A1(e.query) || void 0 : ""), e;
}
function dA(t, e) {
  var r = We({}, t), i = new Set(Object.keys(t));
  return Ai(e, {
    Variable: function(f, a, l) {
      l && l.kind !== "VariableDefinition" && i.delete(f.name.value);
    }
  }), i.forEach(function(f) {
    delete r[f];
  }), r;
}
function vy(t, e) {
  return e ? e(t) : ar.of();
}
function ko(t) {
  return typeof t == "function" ? new vs(t) : t;
}
function du(t) {
  return t.request.length <= 1;
}
var vs = (
  /** @class */
  function() {
    function t(e) {
      e && (this.request = e);
    }
    return t.empty = function() {
      return new t(function() {
        return ar.of();
      });
    }, t.from = function(e) {
      return e.length === 0 ? t.empty() : e.map(ko).reduce(function(r, i) {
        return r.concat(i);
      });
    }, t.split = function(e, r, i) {
      var f = ko(r), a = ko(i || new t(vy)), l;
      return du(f) && du(a) ? l = new t(function(d) {
        return e(d) ? f.request(d) || ar.of() : a.request(d) || ar.of();
      }) : l = new t(function(d, v) {
        return e(d) ? f.request(d, v) || ar.of() : a.request(d, v) || ar.of();
      }), Object.assign(l, { left: f, right: a });
    }, t.execute = function(e, r) {
      return e.request(lA(r.context, cA(uA(r)))) || ar.of();
    }, t.concat = function(e, r) {
      var i = ko(e);
      if (du(i))
        return globalThis.__DEV__ !== !1 && Rt.warn(35, i), i;
      var f = ko(r), a;
      return du(f) ? a = new t(function(l) {
        return i.request(l, function(d) {
          return f.request(d) || ar.of();
        }) || ar.of();
      }) : a = new t(function(l, d) {
        return i.request(l, function(v) {
          return f.request(v, d) || ar.of();
        }) || ar.of();
      }), Object.assign(a, { left: i, right: f });
    }, t.prototype.split = function(e, r, i) {
      return this.concat(t.split(e, r, i || new t(vy)));
    }, t.prototype.concat = function(e) {
      return t.concat(this, e);
    }, t.prototype.request = function(e, r) {
      throw Gr(36);
    }, t.prototype.onError = function(e, r) {
      if (r && r.error)
        return r.error(e), !1;
      throw e;
    }, t.prototype.setOnError = function(e) {
      return this.onError = e, this;
    }, t;
  }()
), hA = vs.split, I1 = vs.execute;
function pA(t) {
  var e, r = t[Symbol.asyncIterator]();
  return e = {
    next: function() {
      return r.next();
    }
  }, e[Symbol.asyncIterator] = function() {
    return this;
  }, e;
}
function vA(t) {
  var e = null, r = null, i = !1, f = [], a = [];
  function l(w) {
    if (!r) {
      if (a.length) {
        var M = a.shift();
        if (Array.isArray(M) && M[0])
          return M[0]({ value: w, done: !1 });
      }
      f.push(w);
    }
  }
  function d(w) {
    r = w;
    var M = a.slice();
    M.forEach(function(S) {
      S[1](w);
    }), !e || e();
  }
  function v() {
    i = !0;
    var w = a.slice();
    w.forEach(function(M) {
      M[0]({ value: void 0, done: !0 });
    }), !e || e();
  }
  e = function() {
    e = null, t.removeListener("data", l), t.removeListener("error", d), t.removeListener("end", v), t.removeListener("finish", v), t.removeListener("close", v);
  }, t.on("data", l), t.on("error", d), t.on("end", v), t.on("finish", v), t.on("close", v);
  function m() {
    return new Promise(function(w, M) {
      if (r)
        return M(r);
      if (f.length)
        return w({ value: f.shift(), done: !1 });
      if (i)
        return w({ value: void 0, done: !0 });
      a.push([w, M]);
    });
  }
  var h = {
    next: function() {
      return m();
    }
  };
  return $l && (h[Symbol.asyncIterator] = function() {
    return this;
  }), h;
}
function mA(t) {
  var e = !1, r = {
    next: function() {
      return e ? Promise.resolve({
        value: void 0,
        done: !0
      }) : (e = !0, new Promise(function(i, f) {
        t.then(function(a) {
          i({ value: a, done: !1 });
        }).catch(f);
      }));
    }
  };
  return $l && (r[Symbol.asyncIterator] = function() {
    return this;
  }), r;
}
function my(t) {
  var e = {
    next: function() {
      return t.read();
    }
  };
  return $l && (e[Symbol.asyncIterator] = function() {
    return this;
  }), e;
}
function gA(t) {
  return !!t.body;
}
function yA(t) {
  return !!t.getReader;
}
function bA(t) {
  return !!($l && t[Symbol.asyncIterator]);
}
function wA(t) {
  return !!t.stream;
}
function _A(t) {
  return !!t.arrayBuffer;
}
function xA(t) {
  return !!t.pipe;
}
function MA(t) {
  var e = t;
  if (gA(t) && (e = t.body), bA(e))
    return pA(e);
  if (yA(e))
    return my(e.getReader());
  if (wA(e))
    return my(e.stream().getReader());
  if (_A(e))
    return mA(e.arrayBuffer());
  if (xA(e))
    return vA(e);
  throw new Error("Unknown body type for responseIterator. Please pass a streamable response.");
}
var Yv = Symbol();
function SA(t) {
  return t.extensions ? Array.isArray(t.extensions[Yv]) : !1;
}
function EA(t) {
  return t.hasOwnProperty("graphQLErrors");
}
var AA = function(t) {
  var e = On(On(On([], t.graphQLErrors, !0), t.clientErrors, !0), t.protocolErrors, !0);
  return t.networkError && e.push(t.networkError), e.map(function(r) {
    return lr(r) && r.message || "Error message not found.";
  }).join(`
`);
}, gi = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      var i = r.graphQLErrors, f = r.protocolErrors, a = r.clientErrors, l = r.networkError, d = r.errorMessage, v = r.extraInfo, m = t.call(this, d) || this;
      return m.name = "ApolloError", m.graphQLErrors = i || [], m.protocolErrors = f || [], m.clientErrors = a || [], m.networkError = l || null, m.message = d || AA(m), m.extraInfo = v, m.__proto__ = e.prototype, m;
    }
    return e;
  }(Error)
), gy = Object.prototype.hasOwnProperty;
function kA(t, e) {
  return zi(this, void 0, void 0, function() {
    var r, i, f, a, l, d, v, m, h, w, M, S, E, A, B, k, C, I, O, q, $, ae, he, te;
    return ji(this, function(Ee) {
      switch (Ee.label) {
        case 0:
          if (TextDecoder === void 0)
            throw new Error("TextDecoder must be defined in the environment: please import a polyfill.");
          r = new TextDecoder("utf-8"), i = (te = t.headers) === null || te === void 0 ? void 0 : te.get("content-type"), f = "boundary=", a = i != null && i.includes(f) ? i == null ? void 0 : i.substring((i == null ? void 0 : i.indexOf(f)) + f.length).replace(/['"]/g, "").replace(/\;(.*)/gm, "").trim() : "-", l = `\r
--`.concat(a), d = "", v = MA(t), m = !0, Ee.label = 1;
        case 1:
          return m ? [4, v.next()] : [3, 3];
        case 2:
          for (h = Ee.sent(), w = h.value, M = h.done, S = typeof w == "string" ? w : r.decode(w), E = d.length - l.length + 1, m = !M, d += S, A = d.indexOf(l, E); A > -1; ) {
            if (B = void 0, ae = [
              d.slice(0, A),
              d.slice(A + l.length)
            ], B = ae[0], d = ae[1], k = B.indexOf(`\r
\r
`), C = TA(B.slice(0, k)), I = C["content-type"], I && I.toLowerCase().indexOf("application/json") === -1)
              throw new Error("Unsupported patch content type: application/json is required.");
            if (O = B.slice(k), O) {
              if (q = A4(t, O), Object.keys(q).length > 1 || "data" in q || "incremental" in q || "errors" in q || "payload" in q)
                if (fA(q)) {
                  if ($ = {}, "payload" in q) {
                    if (Object.keys(q).length === 1 && q.payload === null)
                      return [
                        2
                        /*return*/
                      ];
                    $ = We({}, q.payload);
                  }
                  "errors" in q && ($ = We(We({}, $), { extensions: We(We({}, "extensions" in $ ? $.extensions : null), (he = {}, he[Yv] = q.errors, he)) })), e($);
                } else
                  e(q);
              else if (
                // If the chunk contains only a "hasNext: false", we can call
                // observer.complete() immediately.
                Object.keys(q).length === 1 && "hasNext" in q && !q.hasNext
              )
                return [
                  2
                  /*return*/
                ];
            }
            A = d.indexOf(l);
          }
          return [3, 1];
        case 3:
          return [
            2
            /*return*/
          ];
      }
    });
  });
}
function TA(t) {
  var e = {};
  return t.split(`
`).forEach(function(r) {
    var i = r.indexOf(":");
    if (i > -1) {
      var f = r.slice(0, i).trim().toLowerCase(), a = r.slice(i + 1).trim();
      e[f] = a;
    }
  }), e;
}
function A4(t, e) {
  if (t.status >= 300) {
    var r = function() {
      try {
        return JSON.parse(e);
      } catch {
        return e;
      }
    };
    E4(t, r(), "Response not successful: Received status code ".concat(t.status));
  }
  try {
    return JSON.parse(e);
  } catch (f) {
    var i = f;
    throw i.name = "ServerParseError", i.response = t, i.statusCode = t.status, i.bodyText = e, i;
  }
}
function CA(t, e) {
  t.result && t.result.errors && t.result.data && e.next(t.result), e.error(t);
}
function BA(t) {
  return function(e) {
    return e.text().then(function(r) {
      return A4(e, r);
    }).then(function(r) {
      return !Array.isArray(r) && !gy.call(r, "data") && !gy.call(r, "errors") && E4(e, r, "Server response was missing for query '".concat(Array.isArray(t) ? t.map(function(i) {
        return i.operationName;
      }) : t.operationName, "'.")), r;
    });
  };
}
var R1 = function(t, e) {
  var r;
  try {
    r = JSON.stringify(t);
  } catch (f) {
    var i = Gr(39, e, f.message);
    throw i.parseError = f, i;
  }
  return r;
}, IA = {
  includeQuery: !0,
  includeExtensions: !1,
  preserveHeaderCase: !1
}, RA = {
  // headers are case insensitive (https://stackoverflow.com/a/5259004)
  accept: "*/*",
  // The content-type header describes the type of the body of the request, and
  // so it typically only is sent with requests that actually have bodies. One
  // could imagine that Apollo Client would remove this header when constructing
  // a GET request (which has no body), but we historically have not done that.
  // This means that browsers will preflight all Apollo Client requests (even
  // GET requests). Apollo Server's CSRF prevention feature (introduced in
  // AS3.7) takes advantage of this fact and does not block requests with this
  // header. If you want to drop this header from GET requests, then you should
  // probably replace it with a `apollo-require-preflight` header, or servers
  // with CSRF prevention enabled might block your GET request. See
  // https://www.apollographql.com/docs/apollo-server/security/cors/#preventing-cross-site-request-forgery-csrf
  // for more details.
  "content-type": "application/json"
}, PA = {
  method: "POST"
}, OA = {
  http: IA,
  headers: RA,
  options: PA
}, NA = function(t, e) {
  return e(t);
};
function DA(t, e) {
  for (var r = [], i = 2; i < arguments.length; i++)
    r[i - 2] = arguments[i];
  var f = {}, a = {};
  r.forEach(function(w) {
    f = We(We(We({}, f), w.options), { headers: We(We({}, f.headers), w.headers) }), w.credentials && (f.credentials = w.credentials), a = We(We({}, a), w.http);
  }), f.headers && (f.headers = UA(f.headers, a.preserveHeaderCase));
  var l = t.operationName, d = t.extensions, v = t.variables, m = t.query, h = { operationName: l, variables: v };
  return a.includeExtensions && (h.extensions = d), a.includeQuery && (h.query = e(m, Ff)), {
    options: f,
    body: h
  };
}
function UA(t, e) {
  if (!e) {
    var r = /* @__PURE__ */ Object.create(null);
    return Object.keys(Object(t)).forEach(function(a) {
      r[a.toLowerCase()] = t[a];
    }), r;
  }
  var i = /* @__PURE__ */ Object.create(null);
  Object.keys(Object(t)).forEach(function(a) {
    i[a.toLowerCase()] = {
      originalName: a,
      value: t[a]
    };
  });
  var f = /* @__PURE__ */ Object.create(null);
  return Object.keys(i).forEach(function(a) {
    f[i[a].originalName] = i[a].value;
  }), f;
}
var LA = function(t) {
  if (!t && typeof fetch > "u")
    throw Gr(37);
}, FA = function(t, e) {
  var r = t.getContext(), i = r.uri;
  return i || (typeof e == "function" ? e(t) : e || "/graphql");
};
function qA(t, e) {
  var r = [], i = function(w, M) {
    r.push("".concat(w, "=").concat(encodeURIComponent(M)));
  };
  if ("query" in e && i("query", e.query), e.operationName && i("operationName", e.operationName), e.variables) {
    var f = void 0;
    try {
      f = R1(e.variables, "Variables map");
    } catch (w) {
      return { parseError: w };
    }
    i("variables", f);
  }
  if (e.extensions) {
    var a = void 0;
    try {
      a = R1(e.extensions, "Extensions map");
    } catch (w) {
      return { parseError: w };
    }
    i("extensions", a);
  }
  var l = "", d = t, v = t.indexOf("#");
  v !== -1 && (l = t.substr(v), d = t.substr(0, v));
  var m = d.indexOf("?") === -1 ? "?" : "&", h = d + m + r.join("&") + l;
  return { newURI: h };
}
var yy = Rn(function() {
  return fetch;
}), zA = function(t) {
  t === void 0 && (t = {});
  var e = t.uri, r = e === void 0 ? "/graphql" : e, i = t.fetch, f = t.print, a = f === void 0 ? NA : f, l = t.includeExtensions, d = t.preserveHeaderCase, v = t.useGETForQueries, m = t.includeUnusedVariables, h = m === void 0 ? !1 : m, w = ti(t, ["uri", "fetch", "print", "includeExtensions", "preserveHeaderCase", "useGETForQueries", "includeUnusedVariables"]);
  globalThis.__DEV__ !== !1 && LA(i || yy);
  var M = {
    http: { includeExtensions: l, preserveHeaderCase: d },
    options: w.fetchOptions,
    credentials: w.credentials,
    headers: w.headers
  };
  return new vs(function(S) {
    var E = FA(S, r), A = S.getContext(), B = {};
    if (A.clientAwareness) {
      var k = A.clientAwareness, C = k.name, I = k.version;
      C && (B["apollographql-client-name"] = C), I && (B["apollographql-client-version"] = I);
    }
    var O = We(We({}, B), A.headers), q = {
      http: A.http,
      options: A.fetchOptions,
      credentials: A.credentials,
      headers: O
    };
    if (Af(["client"], S.query)) {
      var $ = y4(S.query);
      if (!$)
        return Ed(new Error("HttpLink: Trying to send a client-only query to the server. To send to the server, ensure a non-client field is added to the query or set the `transformOptions.removeClientFields` option to `true`."));
      S.query = $;
    }
    var ae = DA(S, a, OA, M, q), he = ae.options, te = ae.body;
    te.variables && !h && (te.variables = dA(te.variables, S.query));
    var Ee;
    !he.signal && typeof AbortController < "u" && (Ee = new AbortController(), he.signal = Ee.signal);
    var x = function(p) {
      return p.kind === "OperationDefinition" && p.operation === "mutation";
    }, n = function(p) {
      return p.kind === "OperationDefinition" && p.operation === "subscription";
    }, o = n(oo(S.query)), u = Af(["defer"], S.query);
    if (v && !S.query.definitions.some(x) && (he.method = "GET"), u || o) {
      he.headers = he.headers || {};
      var c = "multipart/mixed;";
      o && u && globalThis.__DEV__ !== !1 && Rt.warn(38), o ? c += "boundary=graphql;subscriptionSpec=1.0,application/json" : u && (c += "deferSpec=20220824,application/json"), he.headers.accept = c;
    }
    if (he.method === "GET") {
      var g = qA(E, te), b = g.newURI, _ = g.parseError;
      if (_)
        return Ed(_);
      E = b;
    } else
      try {
        he.body = R1(te, "Payload");
      } catch (p) {
        return Ed(p);
      }
    return new ar(function(p) {
      var s = i || Rn(function() {
        return fetch;
      }) || yy, y = p.next.bind(p);
      return s(E, he).then(function(T) {
        var P;
        S.setContext({ response: T });
        var z = (P = T.headers) === null || P === void 0 ? void 0 : P.get("content-type");
        return z !== null && /^multipart\/mixed/i.test(z) ? kA(T, y) : BA(S)(T).then(y);
      }).then(function() {
        Ee = void 0, p.complete();
      }).catch(function(T) {
        Ee = void 0, CA(T, p);
      }), function() {
        Ee && Ee.abort();
      };
    });
  });
}, k4 = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var i = t.call(this, zA(r).request) || this;
      return i.options = r, i;
    }
    return e;
  }(vs)
);
const { toString: by, hasOwnProperty: jA } = Object.prototype, wy = Function.prototype.toString, P1 = /* @__PURE__ */ new Map();
function er(t, e) {
  try {
    return O1(t, e);
  } finally {
    P1.clear();
  }
}
function O1(t, e) {
  if (t === e)
    return !0;
  const r = by.call(t), i = by.call(e);
  if (r !== i)
    return !1;
  switch (r) {
    case "[object Array]":
      if (t.length !== e.length)
        return !1;
    case "[object Object]": {
      if (xy(t, e))
        return !0;
      const f = _y(t), a = _y(e), l = f.length;
      if (l !== a.length)
        return !1;
      for (let d = 0; d < l; ++d)
        if (!jA.call(e, f[d]))
          return !1;
      for (let d = 0; d < l; ++d) {
        const v = f[d];
        if (!O1(t[v], e[v]))
          return !1;
      }
      return !0;
    }
    case "[object Error]":
      return t.name === e.name && t.message === e.message;
    case "[object Number]":
      if (t !== t)
        return e !== e;
    case "[object Boolean]":
    case "[object Date]":
      return +t == +e;
    case "[object RegExp]":
    case "[object String]":
      return t == `${e}`;
    case "[object Map]":
    case "[object Set]": {
      if (t.size !== e.size)
        return !1;
      if (xy(t, e))
        return !0;
      const f = t.entries(), a = r === "[object Map]";
      for (; ; ) {
        const l = f.next();
        if (l.done)
          break;
        const [d, v] = l.value;
        if (!e.has(d) || a && !O1(v, e.get(d)))
          return !1;
      }
      return !0;
    }
    case "[object Uint16Array]":
    case "[object Uint8Array]":
    case "[object Uint32Array]":
    case "[object Int32Array]":
    case "[object Int8Array]":
    case "[object Int16Array]":
    case "[object ArrayBuffer]":
      t = new Uint8Array(t), e = new Uint8Array(e);
    case "[object DataView]": {
      let f = t.byteLength;
      if (f === e.byteLength)
        for (; f-- && t[f] === e[f]; )
          ;
      return f === -1;
    }
    case "[object AsyncFunction]":
    case "[object GeneratorFunction]":
    case "[object AsyncGeneratorFunction]":
    case "[object Function]": {
      const f = wy.call(t);
      return f !== wy.call(e) ? !1 : !HA(f, VA);
    }
  }
  return !1;
}
function _y(t) {
  return Object.keys(t).filter($A, t);
}
function $A(t) {
  return this[t] !== void 0;
}
const VA = "{ [native code] }";
function HA(t, e) {
  const r = t.length - e.length;
  return r >= 0 && t.indexOf(e, r) === r;
}
function xy(t, e) {
  let r = P1.get(t);
  if (r) {
    if (r.has(e))
      return !0;
  } else
    P1.set(t, r = /* @__PURE__ */ new Set());
  return r.add(e), !1;
}
var T4 = (
  /** @class */
  function() {
    function t() {
      this.assumeImmutableResults = !1, this.getFragmentDoc = Tf(QS, {
        max: ri["cache.fragmentQueryDocuments"] || 1e3,
        cache: Ml
      });
    }
    return t.prototype.batch = function(e) {
      var r = this, i = typeof e.optimistic == "string" ? e.optimistic : e.optimistic === !1 ? null : void 0, f;
      return this.performTransaction(function() {
        return f = e.update(r);
      }, i), f;
    }, t.prototype.recordOptimisticTransaction = function(e, r) {
      this.performTransaction(e, r);
    }, t.prototype.transformDocument = function(e) {
      return e;
    }, t.prototype.transformForLink = function(e) {
      return e;
    }, t.prototype.identify = function(e) {
    }, t.prototype.gc = function() {
      return [];
    }, t.prototype.modify = function(e) {
      return !1;
    }, t.prototype.readQuery = function(e, r) {
      return r === void 0 && (r = !!e.optimistic), this.read(We(We({}, e), { rootId: e.id || "ROOT_QUERY", optimistic: r }));
    }, t.prototype.watchFragment = function(e) {
      var r = this, i = e.fragment, f = e.fragmentName, a = e.from, l = e.optimistic, d = l === void 0 ? !0 : l, v = {
        returnPartialData: !0,
        id: typeof a == "string" ? a : this.identify(a),
        query: this.getFragmentDoc(i, f),
        optimistic: d
      }, m;
      return new ar(function(h) {
        return r.watch(We(We({}, v), { immediate: !0, query: r.getFragmentDoc(i, f), callback: function(w) {
          if (!er(w, m)) {
            var M = {
              data: w.result,
              complete: !!w.complete
            };
            w.missing && (M.missing = Ql(w.missing.map(function(S) {
              return S.missing;
            }))), m = w, h.next(M);
          }
        } }));
      });
    }, t.prototype.readFragment = function(e, r) {
      return r === void 0 && (r = !!e.optimistic), this.read(We(We({}, e), { query: this.getFragmentDoc(e.fragment, e.fragmentName), rootId: e.id, optimistic: r }));
    }, t.prototype.writeQuery = function(e) {
      var r = e.id, i = e.data, f = ti(e, ["id", "data"]);
      return this.write(Object.assign(f, {
        dataId: r || "ROOT_QUERY",
        result: i
      }));
    }, t.prototype.writeFragment = function(e) {
      var r = e.id, i = e.data, f = e.fragment, a = e.fragmentName, l = ti(e, ["id", "data", "fragment", "fragmentName"]);
      return this.write(Object.assign(l, {
        query: this.getFragmentDoc(f, a),
        dataId: r,
        result: i
      }));
    }, t.prototype.updateQuery = function(e, r) {
      return this.batch({
        update: function(i) {
          var f = i.readQuery(e), a = r(f);
          return a == null ? f : (i.writeQuery(We(We({}, e), { data: a })), a);
        }
      });
    }, t.prototype.updateFragment = function(e, r) {
      return this.batch({
        update: function(i) {
          var f = i.readFragment(e), a = r(f);
          return a == null ? f : (i.writeFragment(We(We({}, e), { data: a })), a);
        }
      });
    }, t;
  }()
);
globalThis.__DEV__ !== !1 && (T4.prototype.getMemoryInternals = oE);
var C4 = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r, i, f, a) {
      var l, d = t.call(this, r) || this;
      if (d.message = r, d.path = i, d.query = f, d.variables = a, Array.isArray(d.path)) {
        d.missing = d.message;
        for (var v = d.path.length - 1; v >= 0; --v)
          d.missing = (l = {}, l[d.path[v]] = d.missing, l);
      } else
        d.missing = d.path;
      return d.__proto__ = e.prototype, d;
    }
    return e;
  }(Error)
), Cr = Object.prototype.hasOwnProperty;
function To(t) {
  return t == null;
}
function B4(t, e) {
  var r = t.__typename, i = t.id, f = t._id;
  if (typeof r == "string" && (e && (e.keyObject = To(i) ? To(f) ? void 0 : { _id: f } : { id: i }), To(i) && !To(f) && (i = f), !To(i)))
    return "".concat(r, ":").concat(typeof i == "number" || typeof i == "string" ? i : JSON.stringify(i));
}
var I4 = {
  dataIdFromObject: B4,
  addTypename: !0,
  resultCaching: !0,
  // Thanks to the shouldCanonizeResults helper, this should be the only line
  // you have to change to reenable canonization by default in the future.
  canonizeResults: !1
};
function WA(t) {
  return Fa(I4, t);
}
function R4(t) {
  var e = t.canonizeResults;
  return e === void 0 ? I4.canonizeResults : e;
}
function KA(t, e) {
  return tr(e) ? t.get(e.__ref, "__typename") : e && e.__typename;
}
var P4 = /^[_a-z][_0-9a-z]*/i;
function ua(t) {
  var e = t.match(P4);
  return e ? e[0] : t;
}
function N1(t, e, r) {
  return lr(e) ? yr(e) ? e.every(function(i) {
    return N1(t, i, r);
  }) : t.selections.every(function(i) {
    if (sa(i) && Df(i, r)) {
      var f = aa(i);
      return Cr.call(e, f) && (!i.selectionSet || N1(i.selectionSet, e[f], r));
    }
    return !0;
  }) : !1;
}
function Rs(t) {
  return lr(t) && !tr(t) && !yr(t);
}
function ZA() {
  return new fa();
}
function O4(t, e) {
  var r = Vl(Kl(t));
  return {
    fragmentMap: r,
    lookupFragment: function(i) {
      var f = r[i];
      return !f && e && (f = e.lookup(i)), f || null;
    }
  };
}
var $u = /* @__PURE__ */ Object.create(null), Ad = function() {
  return $u;
}, My = /* @__PURE__ */ Object.create(null), Bf = (
  /** @class */
  function() {
    function t(e, r) {
      var i = this;
      this.policies = e, this.group = r, this.data = /* @__PURE__ */ Object.create(null), this.rootIds = /* @__PURE__ */ Object.create(null), this.refs = /* @__PURE__ */ Object.create(null), this.getFieldValue = function(f, a) {
        return Cf(tr(f) ? i.get(f.__ref, a) : f && f[a]);
      }, this.canRead = function(f) {
        return tr(f) ? i.has(f.__ref) : typeof f == "object";
      }, this.toReference = function(f, a) {
        if (typeof f == "string")
          return Fs(f);
        if (tr(f))
          return f;
        var l = i.policies.identify(f)[0];
        if (l) {
          var d = Fs(l);
          return a && i.merge(l, f), d;
        }
      };
    }
    return t.prototype.toObject = function() {
      return We({}, this.data);
    }, t.prototype.has = function(e) {
      return this.lookup(e, !0) !== void 0;
    }, t.prototype.get = function(e, r) {
      if (this.group.depend(e, r), Cr.call(this.data, e)) {
        var i = this.data[e];
        if (i && Cr.call(i, r))
          return i[r];
      }
      if (r === "__typename" && Cr.call(this.policies.rootTypenamesById, e))
        return this.policies.rootTypenamesById[e];
      if (this instanceof Di)
        return this.parent.get(e, r);
    }, t.prototype.lookup = function(e, r) {
      if (r && this.group.depend(e, "__exists"), Cr.call(this.data, e))
        return this.data[e];
      if (this instanceof Di)
        return this.parent.lookup(e, r);
      if (this.policies.rootTypenamesById[e])
        return /* @__PURE__ */ Object.create(null);
    }, t.prototype.merge = function(e, r) {
      var i = this, f;
      tr(e) && (e = e.__ref), tr(r) && (r = r.__ref);
      var a = typeof e == "string" ? this.lookup(f = e) : e, l = typeof r == "string" ? this.lookup(f = r) : r;
      if (l) {
        Rt(typeof f == "string", 1);
        var d = new fa(QA).merge(a, l);
        if (this.data[f] = d, d !== a && (delete this.refs[f], this.group.caching)) {
          var v = /* @__PURE__ */ Object.create(null);
          a || (v.__exists = 1), Object.keys(l).forEach(function(m) {
            if (!a || a[m] !== d[m]) {
              v[m] = 1;
              var h = ua(m);
              h !== m && !i.policies.hasKeyArgs(d.__typename, h) && (v[h] = 1), d[m] === void 0 && !(i instanceof Di) && delete d[m];
            }
          }), v.__typename && !(a && a.__typename) && // Since we return default root __typename strings
          // automatically from store.get, we don't need to dirty the
          // ROOT_QUERY.__typename field if merged.__typename is equal
          // to the default string (usually "Query").
          this.policies.rootTypenamesById[f] === d.__typename && delete v.__typename, Object.keys(v).forEach(function(m) {
            return i.group.dirty(f, m);
          });
        }
      }
    }, t.prototype.modify = function(e, r) {
      var i = this, f = this.lookup(e);
      if (f) {
        var a = /* @__PURE__ */ Object.create(null), l = !1, d = !0, v = {
          DELETE: $u,
          INVALIDATE: My,
          isReference: tr,
          toReference: this.toReference,
          canRead: this.canRead,
          readField: function(m, h) {
            return i.policies.readField(typeof m == "string" ? {
              fieldName: m,
              from: h || Fs(e)
            } : m, { store: i });
          }
        };
        if (Object.keys(f).forEach(function(m) {
          var h = ua(m), w = f[m];
          if (w !== void 0) {
            var M = typeof r == "function" ? r : r[m] || r[h];
            if (M) {
              var S = M === Ad ? $u : M(Cf(w), We(We({}, v), { fieldName: h, storeFieldName: m, storage: i.getStorage(e, m) }));
              if (S === My)
                i.group.dirty(e, m);
              else if (S === $u && (S = void 0), S !== w && (a[m] = S, l = !0, w = S, globalThis.__DEV__ !== !1)) {
                var E = function(q) {
                  if (i.lookup(q.__ref) === void 0)
                    return globalThis.__DEV__ !== !1 && Rt.warn(2, q), !0;
                };
                if (tr(S))
                  E(S);
                else if (Array.isArray(S))
                  for (var A = !1, B = void 0, k = 0, C = S; k < C.length; k++) {
                    var I = C[k];
                    if (tr(I)) {
                      if (A = !0, E(I))
                        break;
                    } else if (typeof I == "object" && I) {
                      var O = i.policies.identify(I)[0];
                      O && (B = I);
                    }
                    if (A && B !== void 0) {
                      globalThis.__DEV__ !== !1 && Rt.warn(3, B);
                      break;
                    }
                  }
              }
            }
            w !== void 0 && (d = !1);
          }
        }), l)
          return this.merge(e, a), d && (this instanceof Di ? this.data[e] = void 0 : delete this.data[e], this.group.dirty(e, "__exists")), !0;
      }
      return !1;
    }, t.prototype.delete = function(e, r, i) {
      var f, a = this.lookup(e);
      if (a) {
        var l = this.getFieldValue(a, "__typename"), d = r && i ? this.policies.getStoreFieldName({ typename: l, fieldName: r, args: i }) : r;
        return this.modify(e, d ? (f = {}, f[d] = Ad, f) : Ad);
      }
      return !1;
    }, t.prototype.evict = function(e, r) {
      var i = !1;
      return e.id && (Cr.call(this.data, e.id) && (i = this.delete(e.id, e.fieldName, e.args)), this instanceof Di && this !== r && (i = this.parent.evict(e, r) || i), (e.fieldName || i) && this.group.dirty(e.id, e.fieldName || "__exists")), i;
    }, t.prototype.clear = function() {
      this.replace(null);
    }, t.prototype.extract = function() {
      var e = this, r = this.toObject(), i = [];
      return this.getRootIdSet().forEach(function(f) {
        Cr.call(e.policies.rootTypenamesById, f) || i.push(f);
      }), i.length && (r.__META = { extraRootIds: i.sort() }), r;
    }, t.prototype.replace = function(e) {
      var r = this;
      if (Object.keys(this.data).forEach(function(a) {
        e && Cr.call(e, a) || r.delete(a);
      }), e) {
        var i = e.__META, f = ti(e, ["__META"]);
        Object.keys(f).forEach(function(a) {
          r.merge(a, f[a]);
        }), i && i.extraRootIds.forEach(this.retain, this);
      }
    }, t.prototype.retain = function(e) {
      return this.rootIds[e] = (this.rootIds[e] || 0) + 1;
    }, t.prototype.release = function(e) {
      if (this.rootIds[e] > 0) {
        var r = --this.rootIds[e];
        return r || delete this.rootIds[e], r;
      }
      return 0;
    }, t.prototype.getRootIdSet = function(e) {
      return e === void 0 && (e = /* @__PURE__ */ new Set()), Object.keys(this.rootIds).forEach(e.add, e), this instanceof Di ? this.parent.getRootIdSet(e) : Object.keys(this.policies.rootTypenamesById).forEach(e.add, e), e;
    }, t.prototype.gc = function() {
      var e = this, r = this.getRootIdSet(), i = this.toObject();
      r.forEach(function(l) {
        Cr.call(i, l) && (Object.keys(e.findChildRefIds(l)).forEach(r.add, r), delete i[l]);
      });
      var f = Object.keys(i);
      if (f.length) {
        for (var a = this; a instanceof Di; )
          a = a.parent;
        f.forEach(function(l) {
          return a.delete(l);
        });
      }
      return f;
    }, t.prototype.findChildRefIds = function(e) {
      if (!Cr.call(this.refs, e)) {
        var r = this.refs[e] = /* @__PURE__ */ Object.create(null), i = this.data[e];
        if (!i)
          return r;
        var f = /* @__PURE__ */ new Set([i]);
        f.forEach(function(a) {
          tr(a) && (r[a.__ref] = !0), lr(a) && Object.keys(a).forEach(function(l) {
            var d = a[l];
            lr(d) && f.add(d);
          });
        });
      }
      return this.refs[e];
    }, t.prototype.makeCacheKey = function() {
      return this.group.keyMaker.lookupArray(arguments);
    }, t;
  }()
), N4 = (
  /** @class */
  function() {
    function t(e, r) {
      r === void 0 && (r = null), this.caching = e, this.parent = r, this.d = null, this.resetCaching();
    }
    return t.prototype.resetCaching = function() {
      this.d = this.caching ? p4() : null, this.keyMaker = new so(ps);
    }, t.prototype.depend = function(e, r) {
      if (this.d) {
        this.d(kd(e, r));
        var i = ua(r);
        i !== r && this.d(kd(e, i)), this.parent && this.parent.depend(e, r);
      }
    }, t.prototype.dirty = function(e, r) {
      this.d && this.d.dirty(
        kd(e, r),
        // When storeFieldName === "__exists", that means the entity identified
        // by dataId has either disappeared from the cache or was newly added,
        // so the result caching system would do well to "forget everything it
        // knows" about that object. To achieve that kind of invalidation, we
        // not only dirty the associated result cache entry, but also remove it
        // completely from the dependency graph. For the optimism implementation
        // details, see https://github.com/benjamn/optimism/pull/195.
        r === "__exists" ? "forget" : "setDirty"
      );
    }, t;
  }()
);
function kd(t, e) {
  return e + "#" + t;
}
function Sy(t, e) {
  wf(t) && t.group.depend(e, "__exists");
}
(function(t) {
  var e = (
    /** @class */
    function(r) {
      Fn(i, r);
      function i(f) {
        var a = f.policies, l = f.resultCaching, d = l === void 0 ? !0 : l, v = f.seed, m = r.call(this, a, new N4(d)) || this;
        return m.stump = new GA(m), m.storageTrie = new so(ps), v && m.replace(v), m;
      }
      return i.prototype.addLayer = function(f, a) {
        return this.stump.addLayer(f, a);
      }, i.prototype.removeLayer = function() {
        return this;
      }, i.prototype.getStorage = function() {
        return this.storageTrie.lookupArray(arguments);
      }, i;
    }(t)
  );
  t.Root = e;
})(Bf || (Bf = {}));
var Di = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r, i, f, a) {
      var l = t.call(this, i.policies, a) || this;
      return l.id = r, l.parent = i, l.replay = f, l.group = a, f(l), l;
    }
    return e.prototype.addLayer = function(r, i) {
      return new e(r, this, i, this.group);
    }, e.prototype.removeLayer = function(r) {
      var i = this, f = this.parent.removeLayer(r);
      return r === this.id ? (this.group.caching && Object.keys(this.data).forEach(function(a) {
        var l = i.data[a], d = f.lookup(a);
        d ? l ? l !== d && Object.keys(l).forEach(function(v) {
          er(l[v], d[v]) || i.group.dirty(a, v);
        }) : (i.group.dirty(a, "__exists"), Object.keys(d).forEach(function(v) {
          i.group.dirty(a, v);
        })) : i.delete(a);
      }), f) : f === this.parent ? this : f.addLayer(this.id, this.replay);
    }, e.prototype.toObject = function() {
      return We(We({}, this.parent.toObject()), this.data);
    }, e.prototype.findChildRefIds = function(r) {
      var i = this.parent.findChildRefIds(r);
      return Cr.call(this.data, r) ? We(We({}, i), t.prototype.findChildRefIds.call(this, r)) : i;
    }, e.prototype.getStorage = function() {
      for (var r = this.parent; r.parent; )
        r = r.parent;
      return r.getStorage.apply(
        r,
        // @ts-expect-error
        arguments
      );
    }, e;
  }(Bf)
), GA = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      return t.call(this, "EntityStore.Stump", r, function() {
      }, new N4(r.group.caching, r.group)) || this;
    }
    return e.prototype.removeLayer = function() {
      return this;
    }, e.prototype.merge = function(r, i) {
      return this.parent.merge(r, i);
    }, e;
  }(Di)
);
function QA(t, e, r) {
  var i = t[r], f = e[r];
  return er(i, f) ? i : f;
}
function wf(t) {
  return !!(t instanceof Bf && t.group.caching);
}
function YA(t) {
  return lr(t) ? yr(t) ? t.slice(0) : We({ __proto__: Object.getPrototypeOf(t) }, t) : t;
}
var Ey = (
  /** @class */
  function() {
    function t() {
      this.known = new (Q5 ? WeakSet : Set)(), this.pool = new so(ps), this.passes = /* @__PURE__ */ new WeakMap(), this.keysByJSON = /* @__PURE__ */ new Map(), this.empty = this.admit({});
    }
    return t.prototype.isKnown = function(e) {
      return lr(e) && this.known.has(e);
    }, t.prototype.pass = function(e) {
      if (lr(e)) {
        var r = YA(e);
        return this.passes.set(r, e), r;
      }
      return e;
    }, t.prototype.admit = function(e) {
      var r = this;
      if (lr(e)) {
        var i = this.passes.get(e);
        if (i)
          return i;
        var f = Object.getPrototypeOf(e);
        switch (f) {
          case Array.prototype: {
            if (this.known.has(e))
              return e;
            var a = e.map(this.admit, this), l = this.pool.lookupArray(a);
            return l.array || (this.known.add(l.array = a), globalThis.__DEV__ !== !1 && Object.freeze(a)), l.array;
          }
          case null:
          case Object.prototype: {
            if (this.known.has(e))
              return e;
            var d = Object.getPrototypeOf(e), v = [d], m = this.sortedKeys(e);
            v.push(m.json);
            var h = v.length;
            m.sorted.forEach(function(S) {
              v.push(r.admit(e[S]));
            });
            var l = this.pool.lookupArray(v);
            if (!l.object) {
              var w = l.object = Object.create(d);
              this.known.add(w), m.sorted.forEach(function(S, E) {
                w[S] = v[h + E];
              }), globalThis.__DEV__ !== !1 && Object.freeze(w);
            }
            return l.object;
          }
        }
      }
      return e;
    }, t.prototype.sortedKeys = function(e) {
      var r = Object.keys(e), i = this.pool.lookupArray(r);
      if (!i.keys) {
        r.sort();
        var f = JSON.stringify(r);
        (i.keys = this.keysByJSON.get(f)) || this.keysByJSON.set(f, i.keys = { sorted: r, json: f });
      }
      return i.keys;
    }, t;
  }()
);
function Ay(t) {
  return [
    t.selectionSet,
    t.objectOrReference,
    t.context,
    // We split out this property so we can pass different values
    // independently without modifying options.context itself.
    t.context.canonizeResults
  ];
}
var JA = (
  /** @class */
  function() {
    function t(e) {
      var r = this;
      this.knownResults = new (ps ? WeakMap : Map)(), this.config = Fa(e, {
        addTypename: e.addTypename !== !1,
        canonizeResults: R4(e)
      }), this.canon = e.canon || new Ey(), this.executeSelectionSet = Tf(function(i) {
        var f, a = i.context.canonizeResults, l = Ay(i);
        l[3] = !a;
        var d = (f = r.executeSelectionSet).peek.apply(f, l);
        return d ? a ? We(We({}, d), {
          // If we previously read this result without canonizing it, we can
          // reuse that result simply by canonizing it now.
          result: r.canon.admit(d.result)
        }) : d : (Sy(i.context.store, i.enclosingRef.__ref), r.execSelectionSetImpl(i));
      }, {
        max: this.config.resultCacheMaxSize || ri["inMemoryCache.executeSelectionSet"] || 5e4,
        keyArgs: Ay,
        // Note that the parameters of makeCacheKey are determined by the
        // array returned by keyArgs.
        makeCacheKey: function(i, f, a, l) {
          if (wf(a.store))
            return a.store.makeCacheKey(i, tr(f) ? f.__ref : f, a.varString, l);
        }
      }), this.executeSubSelectedArray = Tf(function(i) {
        return Sy(i.context.store, i.enclosingRef.__ref), r.execSubSelectedArrayImpl(i);
      }, {
        max: this.config.resultCacheMaxSize || ri["inMemoryCache.executeSubSelectedArray"] || 1e4,
        makeCacheKey: function(i) {
          var f = i.field, a = i.array, l = i.context;
          if (wf(l.store))
            return l.store.makeCacheKey(f, a, l.varString);
        }
      });
    }
    return t.prototype.resetCanon = function() {
      this.canon = new Ey();
    }, t.prototype.diffQueryAgainstStore = function(e) {
      var r = e.store, i = e.query, f = e.rootId, a = f === void 0 ? "ROOT_QUERY" : f, l = e.variables, d = e.returnPartialData, v = d === void 0 ? !0 : d, m = e.canonizeResults, h = m === void 0 ? this.config.canonizeResults : m, w = this.config.cache.policies;
      l = We(We({}, zv(r4(i))), l);
      var M = Fs(a), S = this.executeSelectionSet({
        selectionSet: oo(i).selectionSet,
        objectOrReference: M,
        enclosingRef: M,
        context: We({ store: r, query: i, policies: w, variables: l, varString: Qi(l), canonizeResults: h }, O4(i, this.config.fragments))
      }), E;
      if (S.missing && (E = [
        new C4(XA(S.missing), S.missing, i, l)
      ], !v))
        throw E[0];
      return {
        result: S.result,
        complete: !E,
        missing: E
      };
    }, t.prototype.isFresh = function(e, r, i, f) {
      if (wf(f.store) && this.knownResults.get(e) === i) {
        var a = this.executeSelectionSet.peek(
          i,
          r,
          f,
          // If result is canonical, then it could only have been previously
          // cached by the canonizing version of executeSelectionSet, so we can
          // avoid checking both possibilities here.
          this.canon.isKnown(e)
        );
        if (a && e === a.result)
          return !0;
      }
      return !1;
    }, t.prototype.execSelectionSetImpl = function(e) {
      var r = this, i = e.selectionSet, f = e.objectOrReference, a = e.enclosingRef, l = e.context;
      if (tr(f) && !l.policies.rootTypenamesById[f.__ref] && !l.store.has(f.__ref))
        return {
          result: this.canon.empty,
          missing: "Dangling reference to missing ".concat(f.__ref, " object")
        };
      var d = l.variables, v = l.policies, m = l.store, h = m.getFieldValue(f, "__typename"), w = [], M, S = new fa();
      this.config.addTypename && typeof h == "string" && !v.rootIdsByTypename[h] && w.push({ __typename: h });
      function E(I, O) {
        var q;
        return I.missing && (M = S.merge(M, (q = {}, q[O] = I.missing, q))), I.result;
      }
      var A = new Set(i.selections);
      A.forEach(function(I) {
        var O, q;
        if (Df(I, d))
          if (sa(I)) {
            var $ = v.readField({
              fieldName: I.name.value,
              field: I,
              variables: l.variables,
              from: f
            }, l), ae = aa(I);
            $ === void 0 ? Wv.added(I) || (M = S.merge(M, (O = {}, O[ae] = "Can't find field '".concat(I.name.value, "' on ").concat(tr(f) ? f.__ref + " object" : "object " + JSON.stringify(f, null, 2)), O))) : yr($) ? $.length > 0 && ($ = E(r.executeSubSelectedArray({
              field: I,
              array: $,
              enclosingRef: a,
              context: l
            }), ae)) : I.selectionSet ? $ != null && ($ = E(r.executeSelectionSet({
              selectionSet: I.selectionSet,
              objectOrReference: $,
              enclosingRef: tr($) ? $ : a,
              context: l
            }), ae)) : l.canonizeResults && ($ = r.canon.pass($)), $ !== void 0 && w.push((q = {}, q[ae] = $, q));
          } else {
            var he = Hl(I, l.lookupFragment);
            if (!he && I.kind === Ct.FRAGMENT_SPREAD)
              throw Gr(9, I.name.value);
            he && v.fragmentMatches(he, h) && he.selectionSet.selections.forEach(A.add, A);
          }
      });
      var B = Ql(w), k = { result: B, missing: M }, C = l.canonizeResults ? this.canon.admit(k) : Cf(k);
      return C.result && this.knownResults.set(C.result, i), C;
    }, t.prototype.execSubSelectedArrayImpl = function(e) {
      var r = this, i = e.field, f = e.array, a = e.enclosingRef, l = e.context, d, v = new fa();
      function m(h, w) {
        var M;
        return h.missing && (d = v.merge(d, (M = {}, M[w] = h.missing, M))), h.result;
      }
      return i.selectionSet && (f = f.filter(l.store.canRead)), f = f.map(function(h, w) {
        return h === null ? null : yr(h) ? m(r.executeSubSelectedArray({
          field: i,
          array: h,
          enclosingRef: a,
          context: l
        }), w) : i.selectionSet ? m(r.executeSelectionSet({
          selectionSet: i.selectionSet,
          objectOrReference: h,
          enclosingRef: tr(h) ? h : a,
          context: l
        }), w) : (globalThis.__DEV__ !== !1 && ek(l.store, i, h), h);
      }), {
        result: l.canonizeResults ? this.canon.admit(f) : f,
        missing: d
      };
    }, t;
  }()
);
function XA(t) {
  try {
    JSON.stringify(t, function(e, r) {
      if (typeof r == "string")
        throw r;
      return r;
    });
  } catch (e) {
    return e;
  }
}
function ek(t, e, r) {
  if (!e.selectionSet) {
    var i = /* @__PURE__ */ new Set([r]);
    i.forEach(function(f) {
      lr(f) && (Rt(
        !tr(f),
        10,
        KA(t, f),
        e.name.value
      ), Object.values(f).forEach(i.add, i));
    });
  }
}
var Jv = new n4(), ky = /* @__PURE__ */ new WeakMap();
function _f(t) {
  var e = ky.get(t);
  return e || ky.set(t, e = {
    vars: /* @__PURE__ */ new Set(),
    dep: p4()
  }), e;
}
function Ty(t) {
  _f(t).vars.forEach(function(e) {
    return e.forgetCache(t);
  });
}
function tk(t) {
  _f(t).vars.forEach(function(e) {
    return e.attachCache(t);
  });
}
function D4(t) {
  var e = /* @__PURE__ */ new Set(), r = /* @__PURE__ */ new Set(), i = function(a) {
    if (arguments.length > 0) {
      if (t !== a) {
        t = a, e.forEach(function(v) {
          _f(v).dep.dirty(i), rk(v);
        });
        var l = Array.from(r);
        r.clear(), l.forEach(function(v) {
          return v(t);
        });
      }
    } else {
      var d = Jv.getValue();
      d && (f(d), _f(d).dep(i));
    }
    return t;
  };
  i.onNextChange = function(a) {
    return r.add(a), function() {
      r.delete(a);
    };
  };
  var f = i.attachCache = function(a) {
    return e.add(a), _f(a).vars.add(i), i;
  };
  return i.forgetCache = function(a) {
    return e.delete(a);
  }, i;
}
function rk(t) {
  t.broadcastWatches && t.broadcastWatches();
}
var Cy = /* @__PURE__ */ Object.create(null);
function Xv(t) {
  var e = JSON.stringify(t);
  return Cy[e] || (Cy[e] = /* @__PURE__ */ Object.create(null));
}
function By(t) {
  var e = Xv(t);
  return e.keyFieldsFn || (e.keyFieldsFn = function(r, i) {
    var f = function(l, d) {
      return i.readField(d, l);
    }, a = i.keyObject = em(t, function(l) {
      var d = zs(
        i.storeObject,
        l,
        // Using context.readField to extract paths from context.storeObject
        // allows the extraction to see through Reference objects and respect
        // custom read functions.
        f
      );
      return d === void 0 && r !== i.storeObject && Cr.call(r, l[0]) && (d = zs(r, l, L4)), Rt(d !== void 0, 4, l.join("."), r), d;
    });
    return "".concat(i.typename, ":").concat(JSON.stringify(a));
  });
}
function Iy(t) {
  var e = Xv(t);
  return e.keyArgsFn || (e.keyArgsFn = function(r, i) {
    var f = i.field, a = i.variables, l = i.fieldName, d = em(t, function(m) {
      var h = m[0], w = h.charAt(0);
      if (w === "@") {
        if (f && En(f.directives)) {
          var M = h.slice(1), S = f.directives.find(function(k) {
            return k.name.value === M;
          }), E = S && Wl(S, a);
          return E && zs(
            E,
            // If keyPath.length === 1, this code calls extractKeyPath with an
            // empty path, which works because it uses directiveArgs as the
            // extracted value.
            m.slice(1)
          );
        }
        return;
      }
      if (w === "$") {
        var A = h.slice(1);
        if (a && Cr.call(a, A)) {
          var B = m.slice(0);
          return B[0] = A, zs(a, B);
        }
        return;
      }
      if (r)
        return zs(r, m);
    }), v = JSON.stringify(d);
    return (r || v !== "{}") && (l += ":" + v), l;
  });
}
function em(t, e) {
  var r = new fa();
  return U4(t).reduce(function(i, f) {
    var a, l = e(f);
    if (l !== void 0) {
      for (var d = f.length - 1; d >= 0; --d)
        l = (a = {}, a[f[d]] = l, a);
      i = r.merge(i, l);
    }
    return i;
  }, /* @__PURE__ */ Object.create(null));
}
function U4(t) {
  var e = Xv(t);
  if (!e.paths) {
    var r = e.paths = [], i = [];
    t.forEach(function(f, a) {
      yr(f) ? (U4(f).forEach(function(l) {
        return r.push(i.concat(l));
      }), i.length = 0) : (i.push(f), yr(t[a + 1]) || (r.push(i.slice(0)), i.length = 0));
    });
  }
  return e.paths;
}
function L4(t, e) {
  return t[e];
}
function zs(t, e, r) {
  return r = r || L4, F4(e.reduce(function i(f, a) {
    return yr(f) ? f.map(function(l) {
      return i(l, a);
    }) : f && r(f, a);
  }, t));
}
function F4(t) {
  return lr(t) ? yr(t) ? t.map(F4) : em(Object.keys(t).sort(), function(e) {
    return zs(t, e);
  }) : t;
}
function D1(t) {
  return t.args !== void 0 ? t.args : t.field ? Wl(t.field, t.variables) : null;
}
var nk = function() {
}, Ry = function(t, e) {
  return e.fieldName;
}, Py = function(t, e, r) {
  var i = r.mergeObjects;
  return i(t, e);
}, Oy = function(t, e) {
  return e;
}, ik = (
  /** @class */
  function() {
    function t(e) {
      this.config = e, this.typePolicies = /* @__PURE__ */ Object.create(null), this.toBeAdded = /* @__PURE__ */ Object.create(null), this.supertypeMap = /* @__PURE__ */ new Map(), this.fuzzySubtypes = /* @__PURE__ */ new Map(), this.rootIdsByTypename = /* @__PURE__ */ Object.create(null), this.rootTypenamesById = /* @__PURE__ */ Object.create(null), this.usingPossibleTypes = !1, this.config = We({ dataIdFromObject: B4 }, e), this.cache = this.config.cache, this.setRootTypename("Query"), this.setRootTypename("Mutation"), this.setRootTypename("Subscription"), e.possibleTypes && this.addPossibleTypes(e.possibleTypes), e.typePolicies && this.addTypePolicies(e.typePolicies);
    }
    return t.prototype.identify = function(e, r) {
      var i, f = this, a = r && (r.typename || ((i = r.storeObject) === null || i === void 0 ? void 0 : i.__typename)) || e.__typename;
      if (a === this.rootTypenamesById.ROOT_QUERY)
        return ["ROOT_QUERY"];
      for (var l = r && r.storeObject || e, d = We(We({}, r), { typename: a, storeObject: l, readField: r && r.readField || function() {
        var M = tm(arguments, l);
        return f.readField(M, {
          store: f.cache.data,
          variables: M.variables
        });
      } }), v, m = a && this.getTypePolicy(a), h = m && m.keyFn || this.config.dataIdFromObject; h; ) {
        var w = h(We(We({}, e), l), d);
        if (yr(w))
          h = By(w);
        else {
          v = w;
          break;
        }
      }
      return v = v ? String(v) : void 0, d.keyObject ? [v, d.keyObject] : [v];
    }, t.prototype.addTypePolicies = function(e) {
      var r = this;
      Object.keys(e).forEach(function(i) {
        var f = e[i], a = f.queryType, l = f.mutationType, d = f.subscriptionType, v = ti(f, ["queryType", "mutationType", "subscriptionType"]);
        a && r.setRootTypename("Query", i), l && r.setRootTypename("Mutation", i), d && r.setRootTypename("Subscription", i), Cr.call(r.toBeAdded, i) ? r.toBeAdded[i].push(v) : r.toBeAdded[i] = [v];
      });
    }, t.prototype.updateTypePolicy = function(e, r) {
      var i = this, f = this.getTypePolicy(e), a = r.keyFields, l = r.fields;
      function d(v, m) {
        v.merge = typeof m == "function" ? m : m === !0 ? Py : m === !1 ? Oy : v.merge;
      }
      d(f, r.merge), f.keyFn = // Pass false to disable normalization for this typename.
      a === !1 ? nk : yr(a) ? By(a) : typeof a == "function" ? a : f.keyFn, l && Object.keys(l).forEach(function(v) {
        var m = i.getFieldPolicy(e, v, !0), h = l[v];
        if (typeof h == "function")
          m.read = h;
        else {
          var w = h.keyArgs, M = h.read, S = h.merge;
          m.keyFn = // Pass false to disable argument-based differentiation of
          // field identities.
          w === !1 ? Ry : yr(w) ? Iy(w) : typeof w == "function" ? w : m.keyFn, typeof M == "function" && (m.read = M), d(m, S);
        }
        m.read && m.merge && (m.keyFn = m.keyFn || Ry);
      });
    }, t.prototype.setRootTypename = function(e, r) {
      r === void 0 && (r = e);
      var i = "ROOT_" + e.toUpperCase(), f = this.rootTypenamesById[i];
      r !== f && (Rt(!f || f === e, 5, e), f && delete this.rootIdsByTypename[f], this.rootIdsByTypename[r] = i, this.rootTypenamesById[i] = r);
    }, t.prototype.addPossibleTypes = function(e) {
      var r = this;
      this.usingPossibleTypes = !0, Object.keys(e).forEach(function(i) {
        r.getSupertypeSet(i, !0), e[i].forEach(function(f) {
          r.getSupertypeSet(f, !0).add(i);
          var a = f.match(P4);
          (!a || a[0] !== f) && r.fuzzySubtypes.set(f, new RegExp(f));
        });
      });
    }, t.prototype.getTypePolicy = function(e) {
      var r = this;
      if (!Cr.call(this.typePolicies, e)) {
        var i = this.typePolicies[e] = /* @__PURE__ */ Object.create(null);
        i.fields = /* @__PURE__ */ Object.create(null);
        var f = this.supertypeMap.get(e);
        !f && this.fuzzySubtypes.size && (f = this.getSupertypeSet(e, !0), this.fuzzySubtypes.forEach(function(l, d) {
          if (l.test(e)) {
            var v = r.supertypeMap.get(d);
            v && v.forEach(function(m) {
              return f.add(m);
            });
          }
        })), f && f.size && f.forEach(function(l) {
          var d = r.getTypePolicy(l), v = d.fields, m = ti(d, ["fields"]);
          Object.assign(i, m), Object.assign(i.fields, v);
        });
      }
      var a = this.toBeAdded[e];
      return a && a.length && a.splice(0).forEach(function(l) {
        r.updateTypePolicy(e, l);
      }), this.typePolicies[e];
    }, t.prototype.getFieldPolicy = function(e, r, i) {
      if (e) {
        var f = this.getTypePolicy(e).fields;
        return f[r] || i && (f[r] = /* @__PURE__ */ Object.create(null));
      }
    }, t.prototype.getSupertypeSet = function(e, r) {
      var i = this.supertypeMap.get(e);
      return !i && r && this.supertypeMap.set(e, i = /* @__PURE__ */ new Set()), i;
    }, t.prototype.fragmentMatches = function(e, r, i, f) {
      var a = this;
      if (!e.typeCondition)
        return !0;
      if (!r)
        return !1;
      var l = e.typeCondition.name.value;
      if (r === l)
        return !0;
      if (this.usingPossibleTypes && this.supertypeMap.has(l))
        for (var d = this.getSupertypeSet(r, !0), v = [d], m = function(E) {
          var A = a.getSupertypeSet(E, !1);
          A && A.size && v.indexOf(A) < 0 && v.push(A);
        }, h = !!(i && this.fuzzySubtypes.size), w = !1, M = 0; M < v.length; ++M) {
          var S = v[M];
          if (S.has(l))
            return d.has(l) || (w && globalThis.__DEV__ !== !1 && Rt.warn(6, r, l), d.add(l)), !0;
          S.forEach(m), h && // Start checking fuzzy subtypes only after exhausting all
          // non-fuzzy subtypes (after the final iteration of the loop).
          M === v.length - 1 && // We could wait to compare fragment.selectionSet to result
          // after we verify the supertype, but this check is often less
          // expensive than that search, and we will have to do the
          // comparison anyway whenever we find a potential match.
          N1(e.selectionSet, i, f) && (h = !1, w = !0, this.fuzzySubtypes.forEach(function(E, A) {
            var B = r.match(E);
            B && B[0] === r && m(A);
          }));
        }
      return !1;
    }, t.prototype.hasKeyArgs = function(e, r) {
      var i = this.getFieldPolicy(e, r, !1);
      return !!(i && i.keyFn);
    }, t.prototype.getStoreFieldName = function(e) {
      var r = e.typename, i = e.fieldName, f = this.getFieldPolicy(r, i, !1), a, l = f && f.keyFn;
      if (l && r)
        for (var d = {
          typename: r,
          fieldName: i,
          field: e.field || null,
          variables: e.variables
        }, v = D1(e); l; ) {
          var m = l(v, d);
          if (yr(m))
            l = Iy(m);
          else {
            a = m || i;
            break;
          }
        }
      return a === void 0 && (a = e.field ? SE(e.field, e.variables) : t4(i, D1(e))), a === !1 ? i : i === ua(a) ? a : i + ":" + a;
    }, t.prototype.readField = function(e, r) {
      var i = e.from;
      if (i) {
        var f = e.field || e.fieldName;
        if (f) {
          if (e.typename === void 0) {
            var a = r.store.getFieldValue(i, "__typename");
            a && (e.typename = a);
          }
          var l = this.getStoreFieldName(e), d = ua(l), v = r.store.getFieldValue(i, l), m = this.getFieldPolicy(e.typename, d, !1), h = m && m.read;
          if (h) {
            var w = Ny(this, i, e, r, r.store.getStorage(tr(i) ? i.__ref : i, l));
            return Jv.withValue(this.cache, h, [
              v,
              w
            ]);
          }
          return v;
        }
      }
    }, t.prototype.getReadFunction = function(e, r) {
      var i = this.getFieldPolicy(e, r, !1);
      return i && i.read;
    }, t.prototype.getMergeFunction = function(e, r, i) {
      var f = this.getFieldPolicy(e, r, !1), a = f && f.merge;
      return !a && i && (f = this.getTypePolicy(i), a = f && f.merge), a;
    }, t.prototype.runMergeFunction = function(e, r, i, f, a) {
      var l = i.field, d = i.typename, v = i.merge;
      return v === Py ? q4(f.store)(e, r) : v === Oy ? r : (f.overwrite && (e = void 0), v(e, r, Ny(
        this,
        // Unlike options.readField for read functions, we do not fall
        // back to the current object if no foreignObjOrRef is provided,
        // because it's not clear what the current object should be for
        // merge functions: the (possibly undefined) existing object, or
        // the incoming object? If you think your merge function needs
        // to read sibling fields in order to produce a new value for
        // the current field, you might want to rethink your strategy,
        // because that's a recipe for making merge behavior sensitive
        // to the order in which fields are written into the cache.
        // However, readField(name, ref) is useful for merge functions
        // that need to deduplicate child objects and references.
        void 0,
        {
          typename: d,
          fieldName: l.name.value,
          field: l,
          variables: f.variables
        },
        f,
        a || /* @__PURE__ */ Object.create(null)
      )));
    }, t;
  }()
);
function Ny(t, e, r, i, f) {
  var a = t.getStoreFieldName(r), l = ua(a), d = r.variables || i.variables, v = i.store, m = v.toReference, h = v.canRead;
  return {
    args: D1(r),
    field: r.field || null,
    fieldName: l,
    storeFieldName: a,
    variables: d,
    isReference: tr,
    toReference: m,
    storage: f,
    cache: t.cache,
    canRead: h,
    readField: function() {
      return t.readField(tm(arguments, e, d), i);
    },
    mergeObjects: q4(i.store)
  };
}
function tm(t, e, r) {
  var i = t[0], f = t[1], a = t.length, l;
  return typeof i == "string" ? l = {
    fieldName: i,
    // Default to objectOrReference only when no second argument was
    // passed for the from parameter, not when undefined is explicitly
    // passed as the second argument.
    from: a > 1 ? f : e
  } : (l = We({}, i), Cr.call(l, "from") || (l.from = e)), globalThis.__DEV__ !== !1 && l.from === void 0 && globalThis.__DEV__ !== !1 && Rt.warn(7, D5(Array.from(t))), l.variables === void 0 && (l.variables = r), l;
}
function q4(t) {
  return function(r, i) {
    if (yr(r) || yr(i))
      throw Gr(8);
    if (lr(r) && lr(i)) {
      var f = t.getFieldValue(r, "__typename"), a = t.getFieldValue(i, "__typename"), l = f && a && f !== a;
      if (l)
        return i;
      if (tr(r) && Rs(i))
        return t.merge(r.__ref, i), r;
      if (Rs(r) && tr(i))
        return t.merge(r, i.__ref), i;
      if (Rs(r) && Rs(i))
        return We(We({}, r), i);
    }
    return i;
  };
}
function Td(t, e, r) {
  var i = "".concat(e).concat(r), f = t.flavors.get(i);
  return f || t.flavors.set(i, f = t.clientOnly === e && t.deferred === r ? t : We(We({}, t), { clientOnly: e, deferred: r })), f;
}
var ak = (
  /** @class */
  function() {
    function t(e, r, i) {
      this.cache = e, this.reader = r, this.fragments = i;
    }
    return t.prototype.writeToStore = function(e, r) {
      var i = this, f = r.query, a = r.result, l = r.dataId, d = r.variables, v = r.overwrite, m = Lf(f), h = ZA();
      d = We(We({}, zv(m)), d);
      var w = We(We({ store: e, written: /* @__PURE__ */ Object.create(null), merge: function(S, E) {
        return h.merge(S, E);
      }, variables: d, varString: Qi(d) }, O4(f, this.fragments)), { overwrite: !!v, incomingById: /* @__PURE__ */ new Map(), clientOnly: !1, deferred: !1, flavors: /* @__PURE__ */ new Map() }), M = this.processSelectionSet({
        result: a || /* @__PURE__ */ Object.create(null),
        dataId: l,
        selectionSet: m.selectionSet,
        mergeTree: { map: /* @__PURE__ */ new Map() },
        context: w
      });
      if (!tr(M))
        throw Gr(11, a);
      return w.incomingById.forEach(function(S, E) {
        var A = S.storeObject, B = S.mergeTree, k = S.fieldNodeSet, C = Fs(E);
        if (B && B.map.size) {
          var I = i.applyMerges(B, C, A, w);
          if (tr(I))
            return;
          A = I;
        }
        if (globalThis.__DEV__ !== !1 && !w.overwrite) {
          var O = /* @__PURE__ */ Object.create(null);
          k.forEach(function(ae) {
            ae.selectionSet && (O[ae.name.value] = !0);
          });
          var q = function(ae) {
            return O[ua(ae)] === !0;
          }, $ = function(ae) {
            var he = B && B.map.get(ae);
            return !!(he && he.info && he.info.merge);
          };
          Object.keys(A).forEach(function(ae) {
            q(ae) && !$(ae) && sk(C, A, ae, w.store);
          });
        }
        e.merge(E, A);
      }), e.retain(M.__ref), M;
    }, t.prototype.processSelectionSet = function(e) {
      var r = this, i = e.dataId, f = e.result, a = e.selectionSet, l = e.context, d = e.mergeTree, v = this.cache.policies, m = /* @__PURE__ */ Object.create(null), h = i && v.rootTypenamesById[i] || E1(f, a, l.fragmentMap) || i && l.store.get(i, "__typename");
      typeof h == "string" && (m.__typename = h);
      var w = function() {
        var I = tm(arguments, m, l.variables);
        if (tr(I.from)) {
          var O = l.incomingById.get(I.from.__ref);
          if (O) {
            var q = v.readField(We(We({}, I), { from: O.storeObject }), l);
            if (q !== void 0)
              return q;
          }
        }
        return v.readField(I, l);
      }, M = /* @__PURE__ */ new Set();
      this.flattenFields(
        a,
        f,
        // This WriteContext will be the default context value for fields returned
        // by the flattenFields method, but some fields may be assigned a modified
        // context, depending on the presence of @client and other directives.
        l,
        h
      ).forEach(function(I, O) {
        var q, $ = aa(O), ae = f[$];
        if (M.add(O), ae !== void 0) {
          var he = v.getStoreFieldName({
            typename: h,
            fieldName: O.name.value,
            field: O,
            variables: I.variables
          }), te = Dy(d, he), Ee = r.processFieldValue(
            ae,
            O,
            // Reset context.clientOnly and context.deferred to their default
            // values before processing nested selection sets.
            O.selectionSet ? Td(I, !1, !1) : I,
            te
          ), x = void 0;
          O.selectionSet && (tr(Ee) || Rs(Ee)) && (x = w("__typename", Ee));
          var n = v.getMergeFunction(h, O.name.value, x);
          n ? te.info = {
            // TODO Check compatibility against any existing childTree.field?
            field: O,
            typename: h,
            merge: n
          } : Uy(d, he), m = I.merge(m, (q = {}, q[he] = Ee, q));
        } else
          globalThis.__DEV__ !== !1 && !I.clientOnly && !I.deferred && !Wv.added(O) && // If the field has a read function, it may be a synthetic field or
          // provide a default value, so its absence from the written data should
          // not be cause for alarm.
          !v.getReadFunction(h, O.name.value) && globalThis.__DEV__ !== !1 && Rt.error(12, aa(O), f);
      });
      try {
        var S = v.identify(f, {
          typename: h,
          selectionSet: a,
          fragmentMap: l.fragmentMap,
          storeObject: m,
          readField: w
        }), E = S[0], A = S[1];
        i = i || E, A && (m = l.merge(m, A));
      } catch (I) {
        if (!i)
          throw I;
      }
      if (typeof i == "string") {
        var B = Fs(i), k = l.written[i] || (l.written[i] = []);
        if (k.indexOf(a) >= 0 || (k.push(a), this.reader && this.reader.isFresh(f, B, a, l)))
          return B;
        var C = l.incomingById.get(i);
        return C ? (C.storeObject = l.merge(C.storeObject, m), C.mergeTree = U1(C.mergeTree, d), M.forEach(function(I) {
          return C.fieldNodeSet.add(I);
        })) : l.incomingById.set(i, {
          storeObject: m,
          // Save a reference to mergeTree only if it is not empty, because
          // empty MergeTrees may be recycled by maybeRecycleChildMergeTree and
          // reused for entirely different parts of the result tree.
          mergeTree: El(d) ? void 0 : d,
          fieldNodeSet: M
        }), B;
      }
      return m;
    }, t.prototype.processFieldValue = function(e, r, i, f) {
      var a = this;
      return !r.selectionSet || e === null ? globalThis.__DEV__ !== !1 ? x4(e) : e : yr(e) ? e.map(function(l, d) {
        var v = a.processFieldValue(l, r, i, Dy(f, d));
        return Uy(f, d), v;
      }) : this.processSelectionSet({
        result: e,
        selectionSet: r.selectionSet,
        context: i,
        mergeTree: f
      });
    }, t.prototype.flattenFields = function(e, r, i, f) {
      f === void 0 && (f = E1(r, e, i.fragmentMap));
      var a = /* @__PURE__ */ new Map(), l = this.cache.policies, d = new so(!1);
      return function v(m, h) {
        var w = d.lookup(
          m,
          // Because we take inheritedClientOnly and inheritedDeferred into
          // consideration here (in addition to selectionSet), it's possible for
          // the same selection set to be flattened more than once, if it appears
          // in the query with different @client and/or @directive configurations.
          h.clientOnly,
          h.deferred
        );
        w.visited || (w.visited = !0, m.selections.forEach(function(M) {
          if (Df(M, i.variables)) {
            var S = h.clientOnly, E = h.deferred;
            if (
              // Since the presence of @client or @defer on this field can only
              // cause clientOnly or deferred to become true, we can skip the
              // forEach loop if both clientOnly and deferred are already true.
              !(S && E) && En(M.directives) && M.directives.forEach(function(k) {
                var C = k.name.value;
                if (C === "client" && (S = !0), C === "defer") {
                  var I = Wl(k, i.variables);
                  (!I || I.if !== !1) && (E = !0);
                }
              }), sa(M)
            ) {
              var A = a.get(M);
              A && (S = S && A.clientOnly, E = E && A.deferred), a.set(M, Td(i, S, E));
            } else {
              var B = Hl(M, i.lookupFragment);
              if (!B && M.kind === Ct.FRAGMENT_SPREAD)
                throw Gr(13, M.name.value);
              B && l.fragmentMatches(B, f, r, i.variables) && v(B.selectionSet, Td(i, S, E));
            }
          }
        }));
      }(e, i), a;
    }, t.prototype.applyMerges = function(e, r, i, f, a) {
      var l, d = this;
      if (e.map.size && !tr(i)) {
        var v = (
          // Items in the same position in different arrays are not
          // necessarily related to each other, so when incoming is an array
          // we process its elements as if there was no existing data.
          !yr(i) && // Likewise, existing must be either a Reference or a StoreObject
          // in order for its fields to be safe to merge with the fields of
          // the incoming object.
          (tr(r) || Rs(r)) ? r : void 0
        ), m = i;
        v && !a && (a = [tr(v) ? v.__ref : v]);
        var h, w = function(M, S) {
          return yr(M) ? typeof S == "number" ? M[S] : void 0 : f.store.getFieldValue(M, String(S));
        };
        e.map.forEach(function(M, S) {
          var E = w(v, S), A = w(m, S);
          if (A !== void 0) {
            a && a.push(S);
            var B = d.applyMerges(M, E, A, f, a);
            B !== A && (h = h || /* @__PURE__ */ new Map(), h.set(S, B)), a && Rt(a.pop() === S);
          }
        }), h && (i = yr(m) ? m.slice(0) : We({}, m), h.forEach(function(M, S) {
          i[S] = M;
        }));
      }
      return e.info ? this.cache.policies.runMergeFunction(r, i, e.info, f, a && (l = f.store).getStorage.apply(l, a)) : i;
    }, t;
  }()
), z4 = [];
function Dy(t, e) {
  var r = t.map;
  return r.has(e) || r.set(e, z4.pop() || { map: /* @__PURE__ */ new Map() }), r.get(e);
}
function U1(t, e) {
  if (t === e || !e || El(e))
    return t;
  if (!t || El(t))
    return e;
  var r = t.info && e.info ? We(We({}, t.info), e.info) : t.info || e.info, i = t.map.size && e.map.size, f = i ? /* @__PURE__ */ new Map() : t.map.size ? t.map : e.map, a = { info: r, map: f };
  if (i) {
    var l = new Set(e.map.keys());
    t.map.forEach(function(d, v) {
      a.map.set(v, U1(d, e.map.get(v))), l.delete(v);
    }), l.forEach(function(d) {
      a.map.set(d, U1(e.map.get(d), t.map.get(d)));
    });
  }
  return a;
}
function El(t) {
  return !t || !(t.info || t.map.size);
}
function Uy(t, e) {
  var r = t.map, i = r.get(e);
  i && El(i) && (z4.push(i), r.delete(e));
}
var Ly = /* @__PURE__ */ new Set();
function sk(t, e, r, i) {
  var f = function(w) {
    var M = i.getFieldValue(w, r);
    return typeof M == "object" && M;
  }, a = f(t);
  if (a) {
    var l = f(e);
    if (l && !tr(a) && !er(a, l) && !Object.keys(a).every(function(w) {
      return i.getFieldValue(l, w) !== void 0;
    })) {
      var d = i.getFieldValue(t, "__typename") || i.getFieldValue(e, "__typename"), v = ua(r), m = "".concat(d, ".").concat(v);
      if (!Ly.has(m)) {
        Ly.add(m);
        var h = [];
        !yr(a) && !yr(l) && [a, l].forEach(function(w) {
          var M = i.getFieldValue(w, "__typename");
          typeof M == "string" && !h.includes(M) && h.push(M);
        }), globalThis.__DEV__ !== !1 && Rt.warn(14, v, d, h.length ? "either ensure all objects of type " + h.join(" and ") + " have an ID or a custom merge function, or " : "", m, We({}, a), We({}, l));
      }
    }
  }
}
var j4 = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      r === void 0 && (r = {});
      var i = t.call(this) || this;
      return i.watches = /* @__PURE__ */ new Set(), i.addTypenameTransform = new v4(Wv), i.assumeImmutableResults = !0, i.makeVar = D4, i.txCount = 0, i.config = WA(r), i.addTypename = !!i.config.addTypename, i.policies = new ik({
        cache: i,
        dataIdFromObject: i.config.dataIdFromObject,
        possibleTypes: i.config.possibleTypes,
        typePolicies: i.config.typePolicies
      }), i.init(), i;
    }
    return e.prototype.init = function() {
      var r = this.data = new Bf.Root({
        policies: this.policies,
        resultCaching: this.config.resultCaching
      });
      this.optimisticData = r.stump, this.resetResultCache();
    }, e.prototype.resetResultCache = function(r) {
      var i = this, f = this.storeReader, a = this.config.fragments;
      this.storeWriter = new ak(this, this.storeReader = new JA({
        cache: this,
        addTypename: this.addTypename,
        resultCacheMaxSize: this.config.resultCacheMaxSize,
        canonizeResults: R4(this.config),
        canon: r ? void 0 : f && f.canon,
        fragments: a
      }), a), this.maybeBroadcastWatch = Tf(function(l, d) {
        return i.broadcastWatch(l, d);
      }, {
        max: this.config.resultCacheMaxSize || ri["inMemoryCache.maybeBroadcastWatch"] || 5e3,
        makeCacheKey: function(l) {
          var d = l.optimistic ? i.optimisticData : i.data;
          if (wf(d)) {
            var v = l.optimistic, m = l.id, h = l.variables;
            return d.makeCacheKey(
              l.query,
              // Different watches can have the same query, optimistic
              // status, rootId, and variables, but if their callbacks are
              // different, the (identical) result needs to be delivered to
              // each distinct callback. The easiest way to achieve that
              // separation is to include c.callback in the cache key for
              // maybeBroadcastWatch calls. See issue #5733.
              l.callback,
              Qi({ optimistic: v, id: m, variables: h })
            );
          }
        }
      }), (/* @__PURE__ */ new Set([this.data.group, this.optimisticData.group])).forEach(function(l) {
        return l.resetCaching();
      });
    }, e.prototype.restore = function(r) {
      return this.init(), r && this.data.replace(r), this;
    }, e.prototype.extract = function(r) {
      return r === void 0 && (r = !1), (r ? this.optimisticData : this.data).extract();
    }, e.prototype.read = function(r) {
      var i = r.returnPartialData, f = i === void 0 ? !1 : i;
      try {
        return this.storeReader.diffQueryAgainstStore(We(We({}, r), { store: r.optimistic ? this.optimisticData : this.data, config: this.config, returnPartialData: f })).result || null;
      } catch (a) {
        if (a instanceof C4)
          return null;
        throw a;
      }
    }, e.prototype.write = function(r) {
      try {
        return ++this.txCount, this.storeWriter.writeToStore(this.data, r);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.modify = function(r) {
      if (Cr.call(r, "id") && !r.id)
        return !1;
      var i = r.optimistic ? this.optimisticData : this.data;
      try {
        return ++this.txCount, i.modify(r.id || "ROOT_QUERY", r.fields);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.diff = function(r) {
      return this.storeReader.diffQueryAgainstStore(We(We({}, r), { store: r.optimistic ? this.optimisticData : this.data, rootId: r.id || "ROOT_QUERY", config: this.config }));
    }, e.prototype.watch = function(r) {
      var i = this;
      return this.watches.size || tk(this), this.watches.add(r), r.immediate && this.maybeBroadcastWatch(r), function() {
        i.watches.delete(r) && !i.watches.size && Ty(i), i.maybeBroadcastWatch.forget(r);
      };
    }, e.prototype.gc = function(r) {
      var i;
      Qi.reset(), Ff.reset(), this.addTypenameTransform.resetCache(), (i = this.config.fragments) === null || i === void 0 || i.resetCaches();
      var f = this.optimisticData.gc();
      return r && !this.txCount && (r.resetResultCache ? this.resetResultCache(r.resetResultIdentities) : r.resetResultIdentities && this.storeReader.resetCanon()), f;
    }, e.prototype.retain = function(r, i) {
      return (i ? this.optimisticData : this.data).retain(r);
    }, e.prototype.release = function(r, i) {
      return (i ? this.optimisticData : this.data).release(r);
    }, e.prototype.identify = function(r) {
      if (tr(r))
        return r.__ref;
      try {
        return this.policies.identify(r)[0];
      } catch (i) {
        globalThis.__DEV__ !== !1 && Rt.warn(i);
      }
    }, e.prototype.evict = function(r) {
      if (!r.id) {
        if (Cr.call(r, "id"))
          return !1;
        r = We(We({}, r), { id: "ROOT_QUERY" });
      }
      try {
        return ++this.txCount, this.optimisticData.evict(r, this.data);
      } finally {
        !--this.txCount && r.broadcast !== !1 && this.broadcastWatches();
      }
    }, e.prototype.reset = function(r) {
      var i = this;
      return this.init(), Qi.reset(), r && r.discardWatches ? (this.watches.forEach(function(f) {
        return i.maybeBroadcastWatch.forget(f);
      }), this.watches.clear(), Ty(this)) : this.broadcastWatches(), Promise.resolve();
    }, e.prototype.removeOptimistic = function(r) {
      var i = this.optimisticData.removeLayer(r);
      i !== this.optimisticData && (this.optimisticData = i, this.broadcastWatches());
    }, e.prototype.batch = function(r) {
      var i = this, f = r.update, a = r.optimistic, l = a === void 0 ? !0 : a, d = r.removeOptimistic, v = r.onWatchUpdated, m, h = function(M) {
        var S = i, E = S.data, A = S.optimisticData;
        ++i.txCount, M && (i.data = i.optimisticData = M);
        try {
          return m = f(i);
        } finally {
          --i.txCount, i.data = E, i.optimisticData = A;
        }
      }, w = /* @__PURE__ */ new Set();
      return v && !this.txCount && this.broadcastWatches(We(We({}, r), { onWatchUpdated: function(M) {
        return w.add(M), !1;
      } })), typeof l == "string" ? this.optimisticData = this.optimisticData.addLayer(l, h) : l === !1 ? h(this.data) : h(), typeof d == "string" && (this.optimisticData = this.optimisticData.removeLayer(d)), v && w.size ? (this.broadcastWatches(We(We({}, r), { onWatchUpdated: function(M, S) {
        var E = v.call(this, M, S);
        return E !== !1 && w.delete(M), E;
      } })), w.size && w.forEach(function(M) {
        return i.maybeBroadcastWatch.dirty(M);
      })) : this.broadcastWatches(r), m;
    }, e.prototype.performTransaction = function(r, i) {
      return this.batch({
        update: r,
        optimistic: i || i !== null
      });
    }, e.prototype.transformDocument = function(r) {
      return this.addTypenameToDocument(this.addFragmentsToDocument(r));
    }, e.prototype.broadcastWatches = function(r) {
      var i = this;
      this.txCount || this.watches.forEach(function(f) {
        return i.maybeBroadcastWatch(f, r);
      });
    }, e.prototype.addFragmentsToDocument = function(r) {
      var i = this.config.fragments;
      return i ? i.transform(r) : r;
    }, e.prototype.addTypenameToDocument = function(r) {
      return this.addTypename ? this.addTypenameTransform.transformDocument(r) : r;
    }, e.prototype.broadcastWatch = function(r, i) {
      var f = r.lastDiff, a = this.diff(r);
      i && (r.optimistic && typeof i.optimistic == "string" && (a.fromOptimisticTransaction = !0), i.onWatchUpdated && i.onWatchUpdated.call(this, r, a, f) === !1) || (!f || !er(f.result, a.result)) && r.callback(r.lastDiff = a, f);
    }, e;
  }(T4)
);
globalThis.__DEV__ !== !1 && (j4.prototype.getMemoryInternals = sE);
var Jt;
(function(t) {
  t[t.loading = 1] = "loading", t[t.setVariables = 2] = "setVariables", t[t.fetchMore = 3] = "fetchMore", t[t.refetch = 4] = "refetch", t[t.poll = 6] = "poll", t[t.ready = 7] = "ready", t[t.error = 8] = "error";
})(Jt || (Jt = {}));
function If(t) {
  return t ? t < 7 : !1;
}
function ok(t, e, r, i) {
  var f = e.data, a = ti(e, ["data"]), l = r.data, d = ti(r, ["data"]);
  return er(a, d) && Vu(oo(t).selectionSet, f, l, {
    fragmentMap: Vl(Kl(t)),
    variables: i
  });
}
function Vu(t, e, r, i) {
  if (e === r)
    return !0;
  var f = /* @__PURE__ */ new Set();
  return t.selections.every(function(a) {
    if (f.has(a) || (f.add(a), !Df(a, i.variables)) || Fy(a))
      return !0;
    if (sa(a)) {
      var l = aa(a), d = e && e[l], v = r && r[l], m = a.selectionSet;
      if (!m)
        return er(d, v);
      var h = Array.isArray(d), w = Array.isArray(v);
      if (h !== w)
        return !1;
      if (h && w) {
        var M = d.length;
        if (v.length !== M)
          return !1;
        for (var S = 0; S < M; ++S)
          if (!Vu(m, d[S], v[S], i))
            return !1;
        return !0;
      }
      return Vu(m, d, v, i);
    } else {
      var E = Hl(a, i.fragmentMap);
      if (E)
        return Fy(E) ? !0 : Vu(
          E.selectionSet,
          // Notice that we reuse the same aResult and bResult values here,
          // since the fragment ...spread does not specify a field name, but
          // consists of multiple fields (within the fragment's selection set)
          // that should be applied to the current result value(s).
          e,
          r,
          i
        );
    }
  });
}
function Fy(t) {
  return !!t.directives && t.directives.some(fk);
}
function fk(t) {
  return t.name.value === "nonreactive";
}
var qy = Object.assign, uk = Object.hasOwnProperty, L1 = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      var i = r.queryManager, f = r.queryInfo, a = r.options, l = t.call(this, function(B) {
        try {
          var k = B._subscription._observer;
          k && !k.error && (k.error = lk);
        } catch {
        }
        var C = !l.observers.size;
        l.observers.add(B);
        var I = l.last;
        return I && I.error ? B.error && B.error(I.error) : I && I.result && B.next && B.next(I.result), C && l.reobserve().catch(function() {
        }), function() {
          l.observers.delete(B) && !l.observers.size && l.tearDownQuery();
        };
      }) || this;
      l.observers = /* @__PURE__ */ new Set(), l.subscriptions = /* @__PURE__ */ new Set(), l.queryInfo = f, l.queryManager = i, l.waitForOwnResult = Cd(a.fetchPolicy), l.isTornDown = !1;
      var d = i.defaultOptions.watchQuery, v = d === void 0 ? {} : d, m = v.fetchPolicy, h = m === void 0 ? "cache-first" : m, w = a.fetchPolicy, M = w === void 0 ? h : w, S = a.initialFetchPolicy, E = S === void 0 ? M === "standby" ? h : M : S;
      l.options = We(We({}, a), {
        // Remember the initial options.fetchPolicy so we can revert back to this
        // policy when variables change. This information can also be specified
        // (or overridden) by providing options.initialFetchPolicy explicitly.
        initialFetchPolicy: E,
        // This ensures this.options.fetchPolicy always has a string value, in
        // case options.fetchPolicy was not provided.
        fetchPolicy: M
      }), l.queryId = f.queryId || i.generateQueryId();
      var A = Lf(l.query);
      return l.queryName = A && A.name && A.name.value, l;
    }
    return Object.defineProperty(e.prototype, "query", {
      // The `query` computed property will always reflect the document transformed
      // by the last run query. `this.options.query` will always reflect the raw
      // untransformed query to ensure document transforms with runtime conditionals
      // are run on the original document.
      get: function() {
        return this.lastQuery || this.options.query;
      },
      enumerable: !1,
      configurable: !0
    }), Object.defineProperty(e.prototype, "variables", {
      // Computed shorthand for this.options.variables, preserved for
      // backwards compatibility.
      /**
       * An object containing the variables that were provided for the query.
       */
      get: function() {
        return this.options.variables;
      },
      enumerable: !1,
      configurable: !0
    }), e.prototype.result = function() {
      var r = this;
      return new Promise(function(i, f) {
        var a = {
          next: function(d) {
            i(d), r.observers.delete(a), r.observers.size || r.queryManager.removeQuery(r.queryId), setTimeout(function() {
              l.unsubscribe();
            }, 0);
          },
          error: f
        }, l = r.subscribe(a);
      });
    }, e.prototype.resetDiff = function() {
      this.queryInfo.resetDiff();
    }, e.prototype.getCurrentResult = function(r) {
      r === void 0 && (r = !0);
      var i = this.getLastResult(!0), f = this.queryInfo.networkStatus || i && i.networkStatus || Jt.ready, a = We(We({}, i), { loading: If(f), networkStatus: f }), l = this.options.fetchPolicy, d = l === void 0 ? "cache-first" : l;
      if (
        // These fetch policies should never deliver data from the cache, unless
        // redelivering a previously delivered result.
        !(Cd(d) || // If this.options.query has @client(always: true) fields, we cannot
        // trust diff.result, since it was read from the cache without running
        // local resolvers (and it's too late to run resolvers now, since we must
        // return a result synchronously).
        this.queryManager.getDocumentInfo(this.query).hasForcedResolvers)
      )
        if (this.waitForOwnResult)
          this.queryInfo.updateWatch();
        else {
          var v = this.queryInfo.getDiff();
          (v.complete || this.options.returnPartialData) && (a.data = v.result), er(a.data, {}) && (a.data = void 0), v.complete ? (delete a.partial, v.complete && a.networkStatus === Jt.loading && (d === "cache-first" || d === "cache-only") && (a.networkStatus = Jt.ready, a.loading = !1)) : a.partial = !0, globalThis.__DEV__ !== !1 && !v.complete && !this.options.partialRefetch && !a.loading && !a.data && !a.error && V4(v.missing);
        }
      return r && this.updateLastResult(a), a;
    }, e.prototype.isDifferentFromLastResult = function(r, i) {
      if (!this.last)
        return !0;
      var f = this.queryManager.getDocumentInfo(this.query).hasNonreactiveDirective ? !ok(this.query, this.last.result, r, this.variables) : !er(this.last.result, r);
      return f || i && !er(this.last.variables, i);
    }, e.prototype.getLast = function(r, i) {
      var f = this.last;
      if (f && f[r] && (!i || er(f.variables, this.variables)))
        return f[r];
    }, e.prototype.getLastResult = function(r) {
      return this.getLast("result", r);
    }, e.prototype.getLastError = function(r) {
      return this.getLast("error", r);
    }, e.prototype.resetLastResults = function() {
      delete this.last, this.isTornDown = !1;
    }, e.prototype.resetQueryStoreErrors = function() {
      this.queryManager.resetErrors(this.queryId);
    }, e.prototype.refetch = function(r) {
      var i, f = {
        // Always disable polling for refetches.
        pollInterval: 0
      }, a = this.options.fetchPolicy;
      if (a === "cache-and-network" ? f.fetchPolicy = a : a === "no-cache" ? f.fetchPolicy = "no-cache" : f.fetchPolicy = "network-only", globalThis.__DEV__ !== !1 && r && uk.call(r, "variables")) {
        var l = r4(this.query), d = l.variableDefinitions;
        (!d || !d.some(function(v) {
          return v.variable.name.value === "variables";
        })) && globalThis.__DEV__ !== !1 && Rt.warn(
          20,
          r,
          ((i = l.name) === null || i === void 0 ? void 0 : i.value) || l
        );
      }
      return r && !er(this.options.variables, r) && (f.variables = this.options.variables = We(We({}, this.options.variables), r)), this.queryInfo.resetLastWrite(), this.reobserve(f, Jt.refetch);
    }, e.prototype.fetchMore = function(r) {
      var i = this, f = We(We({}, r.query ? r : We(We(We(We({}, this.options), { query: this.options.query }), r), { variables: We(We({}, this.options.variables), r.variables) })), {
        // The fetchMore request goes immediately to the network and does
        // not automatically write its result to the cache (hence no-cache
        // instead of network-only), because we allow the caller of
        // fetchMore to provide an updateQuery callback that determines how
        // the data gets written to the cache.
        fetchPolicy: "no-cache"
      });
      f.query = this.transformDocument(f.query);
      var a = this.queryManager.generateQueryId();
      this.lastQuery = r.query ? this.transformDocument(this.options.query) : f.query;
      var l = this.queryInfo, d = l.networkStatus;
      l.networkStatus = Jt.fetchMore, f.notifyOnNetworkStatusChange && this.observe();
      var v = /* @__PURE__ */ new Set();
      return this.queryManager.fetchQuery(a, f, Jt.fetchMore).then(function(m) {
        return i.queryManager.removeQuery(a), l.networkStatus === Jt.fetchMore && (l.networkStatus = d), i.queryManager.cache.batch({
          update: function(h) {
            var w = r.updateQuery;
            w ? h.updateQuery({
              query: i.query,
              variables: i.variables,
              returnPartialData: !0,
              optimistic: !1
            }, function(M) {
              return w(M, {
                fetchMoreResult: m.data,
                variables: f.variables
              });
            }) : h.writeQuery({
              query: f.query,
              variables: f.variables,
              data: m.data
            });
          },
          onWatchUpdated: function(h) {
            v.add(h.query);
          }
        }), m;
      }).finally(function() {
        v.has(i.query) || $4(i);
      });
    }, e.prototype.subscribeToMore = function(r) {
      var i = this, f = this.queryManager.startGraphQLSubscription({
        query: r.document,
        variables: r.variables,
        context: r.context
      }).subscribe({
        next: function(a) {
          var l = r.updateQuery;
          l && i.updateQuery(function(d, v) {
            var m = v.variables;
            return l(d, {
              subscriptionData: a,
              variables: m
            });
          });
        },
        error: function(a) {
          if (r.onError) {
            r.onError(a);
            return;
          }
          globalThis.__DEV__ !== !1 && Rt.error(21, a);
        }
      });
      return this.subscriptions.add(f), function() {
        i.subscriptions.delete(f) && f.unsubscribe();
      };
    }, e.prototype.setOptions = function(r) {
      return this.reobserve(r);
    }, e.prototype.silentSetOptions = function(r) {
      var i = Fa(this.options, r || {});
      qy(this.options, i);
    }, e.prototype.setVariables = function(r) {
      return er(this.variables, r) ? this.observers.size ? this.result() : Promise.resolve() : (this.options.variables = r, this.observers.size ? this.reobserve({
        // Reset options.fetchPolicy to its original value.
        fetchPolicy: this.options.initialFetchPolicy,
        variables: r
      }, Jt.setVariables) : Promise.resolve());
    }, e.prototype.updateQuery = function(r) {
      var i = this.queryManager, f = i.cache.diff({
        query: this.options.query,
        variables: this.variables,
        returnPartialData: !0,
        optimistic: !1
      }).result, a = r(f, {
        variables: this.variables
      });
      a && (i.cache.writeQuery({
        query: this.options.query,
        data: a,
        variables: this.variables
      }), i.broadcastQueries());
    }, e.prototype.startPolling = function(r) {
      this.options.pollInterval = r, this.updatePolling();
    }, e.prototype.stopPolling = function() {
      this.options.pollInterval = 0, this.updatePolling();
    }, e.prototype.applyNextFetchPolicy = function(r, i) {
      if (i.nextFetchPolicy) {
        var f = i.fetchPolicy, a = f === void 0 ? "cache-first" : f, l = i.initialFetchPolicy, d = l === void 0 ? a : l;
        a === "standby" || (typeof i.nextFetchPolicy == "function" ? i.fetchPolicy = i.nextFetchPolicy(a, {
          reason: r,
          options: i,
          observable: this,
          initialFetchPolicy: d
        }) : r === "variables-changed" ? i.fetchPolicy = d : i.fetchPolicy = i.nextFetchPolicy);
      }
      return i.fetchPolicy;
    }, e.prototype.fetch = function(r, i, f) {
      return this.queryManager.setObservableQuery(this), this.queryManager.fetchConcastWithInfo(this.queryId, r, i, f);
    }, e.prototype.updatePolling = function() {
      var r = this;
      if (!this.queryManager.ssrMode) {
        var i = this, f = i.pollingInfo, a = i.options.pollInterval;
        if (!a) {
          f && (clearTimeout(f.timeout), delete this.pollingInfo);
          return;
        }
        if (!(f && f.interval === a)) {
          Rt(a, 22);
          var l = f || (this.pollingInfo = {});
          l.interval = a;
          var d = function() {
            var m, h;
            r.pollingInfo && (!If(r.queryInfo.networkStatus) && !(!((h = (m = r.options).skipPollAttempt) === null || h === void 0) && h.call(m)) ? r.reobserve({
              // Most fetchPolicy options don't make sense to use in a polling context, as
              // users wouldn't want to be polling the cache directly. However, network-only and
              // no-cache are both useful for when the user wants to control whether or not the
              // polled results are written to the cache.
              fetchPolicy: r.options.initialFetchPolicy === "no-cache" ? "no-cache" : "network-only"
            }, Jt.poll).then(v, v) : v());
          }, v = function() {
            var m = r.pollingInfo;
            m && (clearTimeout(m.timeout), m.timeout = setTimeout(d, m.interval));
          };
          v();
        }
      }
    }, e.prototype.updateLastResult = function(r, i) {
      i === void 0 && (i = this.variables);
      var f = this.getLastError();
      return f && this.last && !er(i, this.last.variables) && (f = void 0), this.last = We({ result: this.queryManager.assumeImmutableResults ? r : x4(r), variables: i }, f ? { error: f } : null);
    }, e.prototype.reobserveAsConcast = function(r, i) {
      var f = this;
      this.isTornDown = !1;
      var a = (
        // Refetching uses a disposable Concast to allow refetches using different
        // options/variables, without permanently altering the options of the
        // original ObservableQuery.
        i === Jt.refetch || // The fetchMore method does not actually call the reobserve method, but,
        // if it did, it would definitely use a disposable Concast.
        i === Jt.fetchMore || // Polling uses a disposable Concast so the polling options (which force
        // fetchPolicy to be "network-only" or "no-cache") won't override the original options.
        i === Jt.poll
      ), l = this.options.variables, d = this.options.fetchPolicy, v = Fa(this.options, r || {}), m = a ? (
        // Disposable Concast fetches receive a shallow copy of this.options
        // (merged with newOptions), leaving this.options unmodified.
        v
      ) : qy(this.options, v), h = this.transformDocument(m.query);
      this.lastQuery = h, a || (this.updatePolling(), r && r.variables && !er(r.variables, l) && // Don't mess with the fetchPolicy if it's currently "standby".
      m.fetchPolicy !== "standby" && // If we're changing the fetchPolicy anyway, don't try to change it here
      // using applyNextFetchPolicy. The explicit options.fetchPolicy wins.
      m.fetchPolicy === d && (this.applyNextFetchPolicy("variables-changed", m), i === void 0 && (i = Jt.setVariables))), this.waitForOwnResult && (this.waitForOwnResult = Cd(m.fetchPolicy));
      var w = function() {
        f.concast === E && (f.waitForOwnResult = !1);
      }, M = m.variables && We({}, m.variables), S = this.fetch(m, i, h), E = S.concast, A = S.fromLink, B = {
        next: function(k) {
          er(f.variables, M) && (w(), f.reportResult(k, M));
        },
        error: function(k) {
          er(f.variables, M) && (w(), f.reportError(k, M));
        }
      };
      return !a && (A || !this.concast) && (this.concast && this.observer && this.concast.removeObserver(this.observer), this.concast = E, this.observer = B), E.addObserver(B), E;
    }, e.prototype.reobserve = function(r, i) {
      return this.reobserveAsConcast(r, i).promise;
    }, e.prototype.resubscribeAfterError = function() {
      for (var r = [], i = 0; i < arguments.length; i++)
        r[i] = arguments[i];
      var f = this.last;
      this.resetLastResults();
      var a = this.subscribe.apply(this, r);
      return this.last = f, a;
    }, e.prototype.observe = function() {
      this.reportResult(
        // Passing false is important so that this.getCurrentResult doesn't
        // save the fetchMore result as this.lastResult, causing it to be
        // ignored due to the this.isDifferentFromLastResult check in
        // this.reportResult.
        this.getCurrentResult(!1),
        this.variables
      );
    }, e.prototype.reportResult = function(r, i) {
      var f = this.getLastError(), a = this.isDifferentFromLastResult(r, i);
      (f || !r.partial || this.options.returnPartialData) && this.updateLastResult(r, i), (f || a) && bf(this.observers, "next", r);
    }, e.prototype.reportError = function(r, i) {
      var f = We(We({}, this.getLastResult()), { error: r, errors: r.graphQLErrors, networkStatus: Jt.error, loading: !1 });
      this.updateLastResult(f, i), bf(this.observers, "error", this.last.error = r);
    }, e.prototype.hasObservers = function() {
      return this.observers.size > 0;
    }, e.prototype.tearDownQuery = function() {
      this.isTornDown || (this.concast && this.observer && (this.concast.removeObserver(this.observer), delete this.concast, delete this.observer), this.stopPolling(), this.subscriptions.forEach(function(r) {
        return r.unsubscribe();
      }), this.subscriptions.clear(), this.queryManager.stopQuery(this.queryId), this.observers.clear(), this.isTornDown = !0);
    }, e.prototype.transformDocument = function(r) {
      return this.queryManager.transform(r);
    }, e;
  }(ar)
);
M4(L1);
function $4(t) {
  var e = t.options, r = e.fetchPolicy, i = e.nextFetchPolicy;
  return r === "cache-and-network" || r === "network-only" ? t.reobserve({
    fetchPolicy: "cache-first",
    // Use a temporary nextFetchPolicy function that replaces itself with the
    // previous nextFetchPolicy value and returns the original fetchPolicy.
    nextFetchPolicy: function(f, a) {
      return this.nextFetchPolicy = i, typeof this.nextFetchPolicy == "function" ? this.nextFetchPolicy(f, a) : r;
    }
  }) : t.reobserve();
}
function lk(t) {
  globalThis.__DEV__ !== !1 && Rt.error(23, t.message, t.stack);
}
function V4(t) {
  globalThis.__DEV__ !== !1 && t && globalThis.__DEV__ !== !1 && Rt.debug(24, t);
}
function Cd(t) {
  return t === "network-only" || t === "no-cache" || t === "standby";
}
var H4 = (
  /** @class */
  function() {
    function t(e) {
      var r = e.cache, i = e.client, f = e.resolvers, a = e.fragmentMatcher;
      this.selectionsToResolveCache = /* @__PURE__ */ new WeakMap(), this.cache = r, i && (this.client = i), f && this.addResolvers(f), a && this.setFragmentMatcher(a);
    }
    return t.prototype.addResolvers = function(e) {
      var r = this;
      this.resolvers = this.resolvers || {}, Array.isArray(e) ? e.forEach(function(i) {
        r.resolvers = uy(r.resolvers, i);
      }) : this.resolvers = uy(this.resolvers, e);
    }, t.prototype.setResolvers = function(e) {
      this.resolvers = {}, this.addResolvers(e);
    }, t.prototype.getResolvers = function() {
      return this.resolvers || {};
    }, t.prototype.runResolvers = function(e) {
      return zi(this, arguments, void 0, function(r) {
        var i = r.document, f = r.remoteResult, a = r.context, l = r.variables, d = r.onlyRunForcedResolvers, v = d === void 0 ? !1 : d;
        return ji(this, function(m) {
          return i ? [2, this.resolveDocument(i, f.data, a, l, this.fragmentMatcher, v).then(function(h) {
            return We(We({}, f), { data: h.result });
          })] : [2, f];
        });
      });
    }, t.prototype.setFragmentMatcher = function(e) {
      this.fragmentMatcher = e;
    }, t.prototype.getFragmentMatcher = function() {
      return this.fragmentMatcher;
    }, t.prototype.clientQuery = function(e) {
      return Af(["client"], e) && this.resolvers ? e : null;
    }, t.prototype.serverQuery = function(e) {
      return y4(e);
    }, t.prototype.prepareContext = function(e) {
      var r = this.cache;
      return We(We({}, e), {
        cache: r,
        // Getting an entry's cache key is useful for local state resolvers.
        getCacheKey: function(i) {
          return r.identify(i);
        }
      });
    }, t.prototype.addExportedVariables = function(e) {
      return zi(this, arguments, void 0, function(r, i, f) {
        return i === void 0 && (i = {}), f === void 0 && (f = {}), ji(this, function(a) {
          return r ? [2, this.resolveDocument(r, this.buildRootValueFromCache(r, i) || {}, this.prepareContext(f), i).then(function(l) {
            return We(We({}, i), l.exportedVariables);
          })] : [2, We({}, i)];
        });
      });
    }, t.prototype.shouldForceResolvers = function(e) {
      var r = !1;
      return Ai(e, {
        Directive: {
          enter: function(i) {
            if (i.name.value === "client" && i.arguments && (r = i.arguments.some(function(f) {
              return f.name.value === "always" && f.value.kind === "BooleanValue" && f.value.value === !0;
            }), r))
              return Uv;
          }
        }
      }), r;
    }, t.prototype.buildRootValueFromCache = function(e, r) {
      return this.cache.diff({
        query: WE(e),
        variables: r,
        returnPartialData: !0,
        optimistic: !1
      }).result;
    }, t.prototype.resolveDocument = function(e, r) {
      return zi(this, arguments, void 0, function(i, f, a, l, d, v) {
        var m, h, w, M, S, E, A, B, k, C, I;
        return a === void 0 && (a = {}), l === void 0 && (l = {}), d === void 0 && (d = function() {
          return !0;
        }), v === void 0 && (v = !1), ji(this, function(O) {
          return m = oo(i), h = Kl(i), w = Vl(h), M = this.collectSelectionsToResolve(m, w), S = m.operation, E = S ? S.charAt(0).toUpperCase() + S.slice(1) : "Query", A = this, B = A.cache, k = A.client, C = {
            fragmentMap: w,
            context: We(We({}, a), { cache: B, client: k }),
            variables: l,
            fragmentMatcher: d,
            defaultOperationType: E,
            exportedVariables: {},
            selectionsToResolve: M,
            onlyRunForcedResolvers: v
          }, I = !1, [2, this.resolveSelectionSet(m.selectionSet, I, f, C).then(function(q) {
            return {
              result: q,
              exportedVariables: C.exportedVariables
            };
          })];
        });
      });
    }, t.prototype.resolveSelectionSet = function(e, r, i, f) {
      return zi(this, void 0, void 0, function() {
        var a, l, d, v, m, h = this;
        return ji(this, function(w) {
          return a = f.fragmentMap, l = f.context, d = f.variables, v = [i], m = function(M) {
            return zi(h, void 0, void 0, function() {
              var S, E;
              return ji(this, function(A) {
                return !r && !f.selectionsToResolve.has(M) ? [
                  2
                  /*return*/
                ] : Df(M, d) ? sa(M) ? [2, this.resolveField(M, r, i, f).then(function(B) {
                  var k;
                  typeof B < "u" && v.push((k = {}, k[aa(M)] = B, k));
                })] : (AE(M) ? S = M : (S = a[M.name.value], Rt(S, 18, M.name.value)), S && S.typeCondition && (E = S.typeCondition.name.value, f.fragmentMatcher(i, E, l)) ? [2, this.resolveSelectionSet(S.selectionSet, r, i, f).then(function(B) {
                  v.push(B);
                })] : [
                  2
                  /*return*/
                ]) : [
                  2
                  /*return*/
                ];
              });
            });
          }, [2, Promise.all(e.selections.map(m)).then(function() {
            return Ql(v);
          })];
        });
      });
    }, t.prototype.resolveField = function(e, r, i, f) {
      return zi(this, void 0, void 0, function() {
        var a, l, d, v, m, h, w, M, S, E = this;
        return ji(this, function(A) {
          return i ? (a = f.variables, l = e.name.value, d = aa(e), v = l !== d, m = i[d] || i[l], h = Promise.resolve(m), (!f.onlyRunForcedResolvers || this.shouldForceResolvers(e)) && (w = i.__typename || f.defaultOperationType, M = this.resolvers && this.resolvers[w], M && (S = M[v ? l : d], S && (h = Promise.resolve(
            // In case the resolve function accesses reactive variables,
            // set cacheSlot to the current cache instance.
            Jv.withValue(this.cache, S, [
              i,
              Wl(e, a),
              f.context,
              { field: e, fragmentMap: f.fragmentMap }
            ])
          )))), [2, h.then(function(B) {
            var k, C;
            if (B === void 0 && (B = m), e.directives && e.directives.forEach(function(O) {
              O.name.value === "export" && O.arguments && O.arguments.forEach(function(q) {
                q.name.value === "as" && q.value.kind === "StringValue" && (f.exportedVariables[q.value.value] = B);
              });
            }), !e.selectionSet || B == null)
              return B;
            var I = (C = (k = e.directives) === null || k === void 0 ? void 0 : k.some(function(O) {
              return O.name.value === "client";
            })) !== null && C !== void 0 ? C : !1;
            if (Array.isArray(B))
              return E.resolveSubSelectedArray(e, r || I, B, f);
            if (e.selectionSet)
              return E.resolveSelectionSet(e.selectionSet, r || I, B, f);
          })]) : [2, null];
        });
      });
    }, t.prototype.resolveSubSelectedArray = function(e, r, i, f) {
      var a = this;
      return Promise.all(i.map(function(l) {
        if (l === null)
          return null;
        if (Array.isArray(l))
          return a.resolveSubSelectedArray(e, r, l, f);
        if (e.selectionSet)
          return a.resolveSelectionSet(e.selectionSet, r, l, f);
      }));
    }, t.prototype.collectSelectionsToResolve = function(e, r) {
      var i = function(l) {
        return !Array.isArray(l);
      }, f = this.selectionsToResolveCache;
      function a(l) {
        if (!f.has(l)) {
          var d = /* @__PURE__ */ new Set();
          f.set(l, d), Ai(l, {
            Directive: function(v, m, h, w, M) {
              v.name.value === "client" && M.forEach(function(S) {
                i(S) && Xg(S) && d.add(S);
              });
            },
            FragmentSpread: function(v, m, h, w, M) {
              var S = r[v.name.value];
              Rt(S, 19, v.name.value);
              var E = a(S);
              E.size > 0 && (M.forEach(function(A) {
                i(A) && Xg(A) && d.add(A);
              }), d.add(v), E.forEach(function(A) {
                d.add(A);
              }));
            }
          });
        }
        return f.get(l);
      }
      return a(e);
    }, t;
  }()
), Ps = new (ps ? WeakMap : Map)();
function Bd(t, e) {
  var r = t[e];
  typeof r == "function" && (t[e] = function() {
    return Ps.set(
      t,
      // The %1e15 allows the count to wrap around to 0 safely every
      // quadrillion evictions, so there's no risk of overflow. To be
      // clear, this is more of a pedantic principle than something
      // that matters in any conceivable practical scenario.
      (Ps.get(t) + 1) % 1e15
    ), r.apply(this, arguments);
  });
}
function zy(t) {
  t.notifyTimeout && (clearTimeout(t.notifyTimeout), t.notifyTimeout = void 0);
}
var Id = (
  /** @class */
  function() {
    function t(e, r) {
      r === void 0 && (r = e.generateQueryId()), this.queryId = r, this.listeners = /* @__PURE__ */ new Set(), this.document = null, this.lastRequestId = 1, this.stopped = !1, this.dirty = !1, this.observableQuery = null;
      var i = this.cache = e.cache;
      Ps.has(i) || (Ps.set(i, 0), Bd(i, "evict"), Bd(i, "modify"), Bd(i, "reset"));
    }
    return t.prototype.init = function(e) {
      var r = e.networkStatus || Jt.loading;
      return this.variables && this.networkStatus !== Jt.loading && !er(this.variables, e.variables) && (r = Jt.setVariables), er(e.variables, this.variables) || (this.lastDiff = void 0), Object.assign(this, {
        document: e.document,
        variables: e.variables,
        networkError: null,
        graphQLErrors: this.graphQLErrors || [],
        networkStatus: r
      }), e.observableQuery && this.setObservableQuery(e.observableQuery), e.lastRequestId && (this.lastRequestId = e.lastRequestId), this;
    }, t.prototype.reset = function() {
      zy(this), this.dirty = !1;
    }, t.prototype.resetDiff = function() {
      this.lastDiff = void 0;
    }, t.prototype.getDiff = function() {
      var e = this.getDiffOptions();
      if (this.lastDiff && er(e, this.lastDiff.options))
        return this.lastDiff.diff;
      this.updateWatch(this.variables);
      var r = this.observableQuery;
      if (r && r.options.fetchPolicy === "no-cache")
        return { complete: !1 };
      var i = this.cache.diff(e);
      return this.updateLastDiff(i, e), i;
    }, t.prototype.updateLastDiff = function(e, r) {
      this.lastDiff = e ? {
        diff: e,
        options: r || this.getDiffOptions()
      } : void 0;
    }, t.prototype.getDiffOptions = function(e) {
      var r;
      return e === void 0 && (e = this.variables), {
        query: this.document,
        variables: e,
        returnPartialData: !0,
        optimistic: !0,
        canonizeResults: (r = this.observableQuery) === null || r === void 0 ? void 0 : r.options.canonizeResults
      };
    }, t.prototype.setDiff = function(e) {
      var r = this, i, f = this.lastDiff && this.lastDiff.diff;
      e && !e.complete && !(!((i = this.observableQuery) === null || i === void 0) && i.options.returnPartialData) && // In the case of a cache eviction, the diff will become partial so we
      // schedule a notification to send a network request (this.oqListener) to
      // go and fetch the missing data.
      !(f && f.complete) || (this.updateLastDiff(e), !this.dirty && !er(f && f.result, e && e.result) && (this.dirty = !0, this.notifyTimeout || (this.notifyTimeout = setTimeout(function() {
        return r.notify();
      }, 0))));
    }, t.prototype.setObservableQuery = function(e) {
      var r = this;
      e !== this.observableQuery && (this.oqListener && this.listeners.delete(this.oqListener), this.observableQuery = e, e ? (e.queryInfo = this, this.listeners.add(this.oqListener = function() {
        var i = r.getDiff();
        i.fromOptimisticTransaction ? e.observe() : $4(e);
      })) : delete this.oqListener);
    }, t.prototype.notify = function() {
      var e = this;
      zy(this), this.shouldNotify() && this.listeners.forEach(function(r) {
        return r(e);
      }), this.dirty = !1;
    }, t.prototype.shouldNotify = function() {
      if (!this.dirty || !this.listeners.size)
        return !1;
      if (If(this.networkStatus) && this.observableQuery) {
        var e = this.observableQuery.options.fetchPolicy;
        if (e !== "cache-only" && e !== "cache-and-network")
          return !1;
      }
      return !0;
    }, t.prototype.stop = function() {
      if (!this.stopped) {
        this.stopped = !0, this.reset(), this.cancel(), this.cancel = t.prototype.cancel;
        var e = this.observableQuery;
        e && e.stopPolling();
      }
    }, t.prototype.cancel = function() {
    }, t.prototype.updateWatch = function(e) {
      var r = this;
      e === void 0 && (e = this.variables);
      var i = this.observableQuery;
      if (!(i && i.options.fetchPolicy === "no-cache")) {
        var f = We(We({}, this.getDiffOptions(e)), { watcher: this, callback: function(a) {
          return r.setDiff(a);
        } });
        (!this.lastWatch || !er(f, this.lastWatch)) && (this.cancel(), this.cancel = this.cache.watch(this.lastWatch = f));
      }
    }, t.prototype.resetLastWrite = function() {
      this.lastWrite = void 0;
    }, t.prototype.shouldWrite = function(e, r) {
      var i = this.lastWrite;
      return !(i && // If cache.evict has been called since the last time we wrote this
      // data into the cache, there's a chance writing this result into
      // the cache will repair what was evicted.
      i.dmCount === Ps.get(this.cache) && er(r, i.variables) && er(e.data, i.result.data));
    }, t.prototype.markResult = function(e, r, i, f) {
      var a = this, l = new fa(), d = En(e.errors) ? e.errors.slice(0) : [];
      if (this.reset(), "incremental" in e && En(e.incremental)) {
        var v = S4(this.getDiff().result, e);
        e.data = v;
      } else if ("hasNext" in e && e.hasNext) {
        var m = this.getDiff();
        e.data = l.merge(m.result, e.data);
      }
      this.graphQLErrors = d, i.fetchPolicy === "no-cache" ? this.updateLastDiff({ result: e.data, complete: !0 }, this.getDiffOptions(i.variables)) : f !== 0 && (F1(e, i.errorPolicy) ? this.cache.performTransaction(function(h) {
        if (a.shouldWrite(e, i.variables))
          h.writeQuery({
            query: r,
            data: e.data,
            variables: i.variables,
            overwrite: f === 1
          }), a.lastWrite = {
            result: e,
            variables: i.variables,
            dmCount: Ps.get(a.cache)
          };
        else if (a.lastDiff && a.lastDiff.diff.complete) {
          e.data = a.lastDiff.diff.result;
          return;
        }
        var w = a.getDiffOptions(i.variables), M = h.diff(w);
        !a.stopped && er(a.variables, i.variables) && a.updateWatch(i.variables), a.updateLastDiff(M, w), M.complete && (e.data = M.result);
      }) : this.lastWrite = void 0);
    }, t.prototype.markReady = function() {
      return this.networkError = null, this.networkStatus = Jt.ready;
    }, t.prototype.markError = function(e) {
      return this.networkStatus = Jt.error, this.lastWrite = void 0, this.reset(), e.graphQLErrors && (this.graphQLErrors = e.graphQLErrors), e.networkError && (this.networkError = e.networkError), e;
    }, t;
  }()
);
function F1(t, e) {
  e === void 0 && (e = "none");
  var r = e === "ignore" || e === "all", i = !zu(t);
  return !i && r && t.data && (i = !0), i;
}
var ck = Object.prototype.hasOwnProperty, jy = /* @__PURE__ */ Object.create(null), dk = (
  /** @class */
  function() {
    function t(e) {
      var r = e.cache, i = e.link, f = e.defaultOptions, a = e.documentTransform, l = e.queryDeduplication, d = l === void 0 ? !1 : l, v = e.onBroadcast, m = e.ssrMode, h = m === void 0 ? !1 : m, w = e.clientAwareness, M = w === void 0 ? {} : w, S = e.localState, E = e.assumeImmutableResults, A = E === void 0 ? !!r.assumeImmutableResults : E, B = e.defaultContext, k = this;
      this.clientAwareness = {}, this.queries = /* @__PURE__ */ new Map(), this.fetchCancelFns = /* @__PURE__ */ new Map(), this.transformCache = new Fv(
        ri["queryManager.getDocumentInfo"] || 2e3
        /* defaultCacheSizes["queryManager.getDocumentInfo"] */
      ), this.queryIdCounter = 1, this.requestIdCounter = 1, this.mutationIdCounter = 1, this.inFlightLinkObservables = new so(!1);
      var C = new v4(
        function(I) {
          return k.cache.transformDocument(I);
        },
        // Allow the apollo cache to manage its own transform caches
        { cache: !1 }
      );
      this.cache = r, this.link = i, this.defaultOptions = f || /* @__PURE__ */ Object.create(null), this.queryDeduplication = d, this.clientAwareness = M, this.localState = S || new H4({ cache: r }), this.ssrMode = h, this.assumeImmutableResults = A, this.documentTransform = a ? C.concat(a).concat(C) : C, this.defaultContext = B || /* @__PURE__ */ Object.create(null), (this.onBroadcast = v) && (this.mutationStore = /* @__PURE__ */ Object.create(null));
    }
    return t.prototype.stop = function() {
      var e = this;
      this.queries.forEach(function(r, i) {
        e.stopQueryNoBroadcast(i);
      }), this.cancelPendingFetches(Gr(25));
    }, t.prototype.cancelPendingFetches = function(e) {
      this.fetchCancelFns.forEach(function(r) {
        return r(e);
      }), this.fetchCancelFns.clear();
    }, t.prototype.mutate = function(e) {
      return zi(this, arguments, void 0, function(r) {
        var i, f, a, l, d, v, m, h = r.mutation, w = r.variables, M = r.optimisticResponse, S = r.updateQueries, E = r.refetchQueries, A = E === void 0 ? [] : E, B = r.awaitRefetchQueries, k = B === void 0 ? !1 : B, C = r.update, I = r.onQueryUpdated, O = r.fetchPolicy, q = O === void 0 ? ((v = this.defaultOptions.mutate) === null || v === void 0 ? void 0 : v.fetchPolicy) || "network-only" : O, $ = r.errorPolicy, ae = $ === void 0 ? ((m = this.defaultOptions.mutate) === null || m === void 0 ? void 0 : m.errorPolicy) || "none" : $, he = r.keepRootFields, te = r.context;
        return ji(this, function(Ee) {
          switch (Ee.label) {
            case 0:
              return Rt(h, 26), Rt(q === "network-only" || q === "no-cache", 27), i = this.generateMutationId(), h = this.cache.transformForLink(this.transform(h)), f = this.getDocumentInfo(h).hasClientExports, w = this.getVariables(h, w), f ? [4, this.localState.addExportedVariables(h, w, te)] : [3, 2];
            case 1:
              w = Ee.sent(), Ee.label = 2;
            case 2:
              return a = this.mutationStore && (this.mutationStore[i] = {
                mutation: h,
                variables: w,
                loading: !0,
                error: null
              }), l = M && this.markMutationOptimistic(M, {
                mutationId: i,
                document: h,
                variables: w,
                fetchPolicy: q,
                errorPolicy: ae,
                context: te,
                updateQueries: S,
                update: C,
                keepRootFields: he
              }), this.broadcastQueries(), d = this, [2, new Promise(function(x, n) {
                return Sd(d.getObservableFromLink(h, We(We({}, te), { optimisticResponse: l ? M : void 0 }), w, !1), function(o) {
                  if (zu(o) && ae === "none")
                    throw new gi({
                      graphQLErrors: B1(o)
                    });
                  a && (a.loading = !1, a.error = null);
                  var u = We({}, o);
                  return typeof A == "function" && (A = A(u)), ae === "ignore" && zu(u) && delete u.errors, d.markMutationResult({
                    mutationId: i,
                    result: u,
                    document: h,
                    variables: w,
                    fetchPolicy: q,
                    errorPolicy: ae,
                    context: te,
                    update: C,
                    updateQueries: S,
                    awaitRefetchQueries: k,
                    refetchQueries: A,
                    removeOptimistic: l ? i : void 0,
                    onQueryUpdated: I,
                    keepRootFields: he
                  });
                }).subscribe({
                  next: function(o) {
                    d.broadcastQueries(), (!("hasNext" in o) || o.hasNext === !1) && x(o);
                  },
                  error: function(o) {
                    a && (a.loading = !1, a.error = o), l && d.cache.removeOptimistic(i), d.broadcastQueries(), n(o instanceof gi ? o : new gi({
                      networkError: o
                    }));
                  }
                });
              })];
          }
        });
      });
    }, t.prototype.markMutationResult = function(e, r) {
      var i = this;
      r === void 0 && (r = this.cache);
      var f = e.result, a = [], l = e.fetchPolicy === "no-cache";
      if (!l && F1(f, e.errorPolicy)) {
        if (qs(f) || a.push({
          result: f.data,
          dataId: "ROOT_MUTATION",
          query: e.document,
          variables: e.variables
        }), qs(f) && En(f.incremental)) {
          var d = r.diff({
            id: "ROOT_MUTATION",
            // The cache complains if passed a mutation where it expects a
            // query, so we transform mutations and subscriptions to queries
            // (only once, thanks to this.transformCache).
            query: this.getDocumentInfo(e.document).asQuery,
            variables: e.variables,
            optimistic: !1,
            returnPartialData: !0
          }), v = void 0;
          d.result && (v = S4(d.result, f)), typeof v < "u" && (f.data = v, a.push({
            result: v,
            dataId: "ROOT_MUTATION",
            query: e.document,
            variables: e.variables
          }));
        }
        var m = e.updateQueries;
        m && this.queries.forEach(function(w, M) {
          var S = w.observableQuery, E = S && S.queryName;
          if (!(!E || !ck.call(m, E))) {
            var A = m[E], B = i.queries.get(M), k = B.document, C = B.variables, I = r.diff({
              query: k,
              variables: C,
              returnPartialData: !0,
              optimistic: !1
            }), O = I.result, q = I.complete;
            if (q && O) {
              var $ = A(O, {
                mutationResult: f,
                queryName: k && A1(k) || void 0,
                queryVariables: C
              });
              $ && a.push({
                result: $,
                dataId: "ROOT_QUERY",
                query: k,
                variables: C
              });
            }
          }
        });
      }
      if (a.length > 0 || (e.refetchQueries || "").length > 0 || e.update || e.onQueryUpdated || e.removeOptimistic) {
        var h = [];
        if (this.refetchQueries({
          updateCache: function(w) {
            l || a.forEach(function(A) {
              return w.write(A);
            });
            var M = e.update, S = !oA(f) || qs(f) && !f.hasNext;
            if (M) {
              if (!l) {
                var E = w.diff({
                  id: "ROOT_MUTATION",
                  // The cache complains if passed a mutation where it expects a
                  // query, so we transform mutations and subscriptions to queries
                  // (only once, thanks to this.transformCache).
                  query: i.getDocumentInfo(e.document).asQuery,
                  variables: e.variables,
                  optimistic: !1,
                  returnPartialData: !0
                });
                E.complete && (f = We(We({}, f), { data: E.result }), "incremental" in f && delete f.incremental, "hasNext" in f && delete f.hasNext);
              }
              S && M(w, f, {
                context: e.context,
                variables: e.variables
              });
            }
            !l && !e.keepRootFields && S && w.modify({
              id: "ROOT_MUTATION",
              fields: function(A, B) {
                var k = B.fieldName, C = B.DELETE;
                return k === "__typename" ? A : C;
              }
            });
          },
          include: e.refetchQueries,
          // Write the final mutation.result to the root layer of the cache.
          optimistic: !1,
          // Remove the corresponding optimistic layer at the same time as we
          // write the final non-optimistic result.
          removeOptimistic: e.removeOptimistic,
          // Let the caller of client.mutate optionally determine the refetching
          // behavior for watched queries after the mutation.update function runs.
          // If no onQueryUpdated function was provided for this mutation, pass
          // null instead of undefined to disable the default refetching behavior.
          onQueryUpdated: e.onQueryUpdated || null
        }).forEach(function(w) {
          return h.push(w);
        }), e.awaitRefetchQueries || e.onQueryUpdated)
          return Promise.all(h).then(function() {
            return f;
          });
      }
      return Promise.resolve(f);
    }, t.prototype.markMutationOptimistic = function(e, r) {
      var i = this, f = typeof e == "function" ? e(r.variables, { IGNORE: jy }) : e;
      return f === jy ? !1 : (this.cache.recordOptimisticTransaction(function(a) {
        try {
          i.markMutationResult(We(We({}, r), { result: { data: f } }), a);
        } catch (l) {
          globalThis.__DEV__ !== !1 && Rt.error(l);
        }
      }, r.mutationId), !0);
    }, t.prototype.fetchQuery = function(e, r, i) {
      return this.fetchConcastWithInfo(e, r, i).concast.promise;
    }, t.prototype.getQueryStore = function() {
      var e = /* @__PURE__ */ Object.create(null);
      return this.queries.forEach(function(r, i) {
        e[i] = {
          variables: r.variables,
          networkStatus: r.networkStatus,
          networkError: r.networkError,
          graphQLErrors: r.graphQLErrors
        };
      }), e;
    }, t.prototype.resetErrors = function(e) {
      var r = this.queries.get(e);
      r && (r.networkError = void 0, r.graphQLErrors = []);
    }, t.prototype.transform = function(e) {
      return this.documentTransform.transformDocument(e);
    }, t.prototype.getDocumentInfo = function(e) {
      var r = this.transformCache;
      if (!r.has(e)) {
        var i = {
          // TODO These three calls (hasClientExports, shouldForceResolvers, and
          // usesNonreactiveDirective) are performing independent full traversals
          // of the transformed document. We should consider merging these
          // traversals into a single pass in the future, though the work is
          // cached after the first time.
          hasClientExports: qS(e),
          hasForcedResolvers: this.localState.shouldForceResolvers(e),
          hasNonreactiveDirective: Af(["nonreactive"], e),
          clientQuery: this.localState.clientQuery(e),
          serverQuery: g4([
            { name: "client", remove: !0 },
            { name: "connection" },
            { name: "nonreactive" }
          ], e),
          defaultVars: zv(Lf(e)),
          // Transform any mutation or subscription operations to query operations
          // so we can read/write them from/to the cache.
          asQuery: We(We({}, e), { definitions: e.definitions.map(function(f) {
            return f.kind === "OperationDefinition" && f.operation !== "query" ? We(We({}, f), { operation: "query" }) : f;
          }) })
        };
        r.set(e, i);
      }
      return r.get(e);
    }, t.prototype.getVariables = function(e, r) {
      return We(We({}, this.getDocumentInfo(e).defaultVars), r);
    }, t.prototype.watchQuery = function(e) {
      var r = this.transform(e.query);
      e = We(We({}, e), { variables: this.getVariables(r, e.variables) }), typeof e.notifyOnNetworkStatusChange > "u" && (e.notifyOnNetworkStatusChange = !1);
      var i = new Id(this), f = new L1({
        queryManager: this,
        queryInfo: i,
        options: e
      });
      return f.lastQuery = r, this.queries.set(f.queryId, i), i.init({
        document: r,
        observableQuery: f,
        variables: f.variables
      }), f;
    }, t.prototype.query = function(e, r) {
      var i = this;
      return r === void 0 && (r = this.generateQueryId()), Rt(e.query, 28), Rt(e.query.kind === "Document", 29), Rt(!e.returnPartialData, 30), Rt(!e.pollInterval, 31), this.fetchQuery(r, We(We({}, e), { query: this.transform(e.query) })).finally(function() {
        return i.stopQuery(r);
      });
    }, t.prototype.generateQueryId = function() {
      return String(this.queryIdCounter++);
    }, t.prototype.generateRequestId = function() {
      return this.requestIdCounter++;
    }, t.prototype.generateMutationId = function() {
      return String(this.mutationIdCounter++);
    }, t.prototype.stopQueryInStore = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.broadcastQueries();
    }, t.prototype.stopQueryInStoreNoBroadcast = function(e) {
      var r = this.queries.get(e);
      r && r.stop();
    }, t.prototype.clearStore = function(e) {
      return e === void 0 && (e = {
        discardWatches: !0
      }), this.cancelPendingFetches(Gr(32)), this.queries.forEach(function(r) {
        r.observableQuery ? r.networkStatus = Jt.loading : r.stop();
      }), this.mutationStore && (this.mutationStore = /* @__PURE__ */ Object.create(null)), this.cache.reset(e);
    }, t.prototype.getObservableQueries = function(e) {
      var r = this;
      e === void 0 && (e = "active");
      var i = /* @__PURE__ */ new Map(), f = /* @__PURE__ */ new Map(), a = /* @__PURE__ */ new Set();
      return Array.isArray(e) && e.forEach(function(l) {
        typeof l == "string" ? f.set(l, !1) : pE(l) ? f.set(r.transform(l), !1) : lr(l) && l.query && a.add(l);
      }), this.queries.forEach(function(l, d) {
        var v = l.observableQuery, m = l.document;
        if (v) {
          if (e === "all") {
            i.set(d, v);
            return;
          }
          var h = v.queryName, w = v.options.fetchPolicy;
          if (w === "standby" || e === "active" && !v.hasObservers())
            return;
          (e === "active" || h && f.has(h) || m && f.has(m)) && (i.set(d, v), h && f.set(h, !0), m && f.set(m, !0));
        }
      }), a.size && a.forEach(function(l) {
        var d = g1("legacyOneTimeQuery"), v = r.getQuery(d).init({
          document: l.query,
          variables: l.variables
        }), m = new L1({
          queryManager: r,
          queryInfo: v,
          options: We(We({}, l), { fetchPolicy: "network-only" })
        });
        Rt(m.queryId === d), v.setObservableQuery(m), i.set(d, m);
      }), globalThis.__DEV__ !== !1 && f.size && f.forEach(function(l, d) {
        l || globalThis.__DEV__ !== !1 && Rt.warn(typeof d == "string" ? 33 : 34, d);
      }), i;
    }, t.prototype.reFetchObservableQueries = function(e) {
      var r = this;
      e === void 0 && (e = !1);
      var i = [];
      return this.getObservableQueries(e ? "all" : "active").forEach(function(f, a) {
        var l = f.options.fetchPolicy;
        f.resetLastResults(), (e || l !== "standby" && l !== "cache-only") && i.push(f.refetch()), r.getQuery(a).setDiff(null);
      }), this.broadcastQueries(), Promise.all(i);
    }, t.prototype.setObservableQuery = function(e) {
      this.getQuery(e.queryId).setObservableQuery(e);
    }, t.prototype.startGraphQLSubscription = function(e) {
      var r = this, i = e.query, f = e.fetchPolicy, a = e.errorPolicy, l = a === void 0 ? "none" : a, d = e.variables, v = e.context, m = v === void 0 ? {} : v;
      i = this.transform(i), d = this.getVariables(i, d);
      var h = function(M) {
        return r.getObservableFromLink(i, m, M).map(function(S) {
          f !== "no-cache" && (F1(S, l) && r.cache.write({
            query: i,
            result: S.data,
            dataId: "ROOT_SUBSCRIPTION",
            variables: M
          }), r.broadcastQueries());
          var E = zu(S), A = SA(S);
          if (E || A) {
            var B = {};
            if (E && (B.graphQLErrors = S.errors), A && (B.protocolErrors = S.extensions[Yv]), l === "none" || A)
              throw new gi(B);
          }
          return l === "ignore" && delete S.errors, S;
        });
      };
      if (this.getDocumentInfo(i).hasClientExports) {
        var w = this.localState.addExportedVariables(i, d, m).then(h);
        return new ar(function(M) {
          var S = null;
          return w.then(function(E) {
            return S = E.subscribe(M);
          }, M.error), function() {
            return S && S.unsubscribe();
          };
        });
      }
      return h(d);
    }, t.prototype.stopQuery = function(e) {
      this.stopQueryNoBroadcast(e), this.broadcastQueries();
    }, t.prototype.stopQueryNoBroadcast = function(e) {
      this.stopQueryInStoreNoBroadcast(e), this.removeQuery(e);
    }, t.prototype.removeQuery = function(e) {
      this.fetchCancelFns.delete(e), this.queries.has(e) && (this.getQuery(e).stop(), this.queries.delete(e));
    }, t.prototype.broadcastQueries = function() {
      this.onBroadcast && this.onBroadcast(), this.queries.forEach(function(e) {
        return e.notify();
      });
    }, t.prototype.getLocalState = function() {
      return this.localState;
    }, t.prototype.getObservableFromLink = function(e, r, i, f) {
      var a = this, l;
      f === void 0 && (f = (l = r == null ? void 0 : r.queryDeduplication) !== null && l !== void 0 ? l : this.queryDeduplication);
      var d, v = this.getDocumentInfo(e), m = v.serverQuery, h = v.clientQuery;
      if (m) {
        var w = this, M = w.inFlightLinkObservables, S = w.link, E = {
          query: m,
          variables: i,
          operationName: A1(m) || void 0,
          context: this.prepareContext(We(We({}, r), { forceFetch: !f }))
        };
        if (r = E.context, f) {
          var A = Ff(m), B = Qi(i), k = M.lookup(A, B);
          if (d = k.observable, !d) {
            var C = new Ss([
              I1(S, E)
            ]);
            d = k.observable = C, C.beforeNext(function() {
              M.remove(A, B);
            });
          }
        } else
          d = new Ss([
            I1(S, E)
          ]);
      } else
        d = new Ss([ar.of({ data: {} })]), r = this.prepareContext(r);
      return h && (d = Sd(d, function(I) {
        return a.localState.runResolvers({
          document: h,
          remoteResult: I,
          context: r,
          variables: i
        });
      })), d;
    }, t.prototype.getResultsFromLink = function(e, r, i) {
      var f = e.lastRequestId = this.generateRequestId(), a = this.cache.transformForLink(i.query);
      return Sd(this.getObservableFromLink(a, i.context, i.variables), function(l) {
        var d = B1(l), v = d.length > 0;
        if (f >= e.lastRequestId) {
          if (v && i.errorPolicy === "none")
            throw e.markError(new gi({
              graphQLErrors: d
            }));
          e.markResult(l, a, i, r), e.markReady();
        }
        var m = {
          data: l.data,
          loading: !1,
          networkStatus: Jt.ready
        };
        return v && i.errorPolicy !== "ignore" && (m.errors = d, m.networkStatus = Jt.error), m;
      }, function(l) {
        var d = EA(l) ? l : new gi({ networkError: l });
        throw f >= e.lastRequestId && e.markError(d), d;
      });
    }, t.prototype.fetchConcastWithInfo = function(e, r, i, f) {
      var a = this;
      i === void 0 && (i = Jt.loading), f === void 0 && (f = r.query);
      var l = this.getVariables(f, r.variables), d = this.getQuery(e), v = this.defaultOptions.watchQuery, m = r.fetchPolicy, h = m === void 0 ? v && v.fetchPolicy || "cache-first" : m, w = r.errorPolicy, M = w === void 0 ? v && v.errorPolicy || "none" : w, S = r.returnPartialData, E = S === void 0 ? !1 : S, A = r.notifyOnNetworkStatusChange, B = A === void 0 ? !1 : A, k = r.context, C = k === void 0 ? {} : k, I = Object.assign({}, r, {
        query: f,
        variables: l,
        fetchPolicy: h,
        errorPolicy: M,
        returnPartialData: E,
        notifyOnNetworkStatusChange: B,
        context: C
      }), O = function(te) {
        I.variables = te;
        var Ee = a.fetchQueryByPolicy(d, I, i);
        return (
          // If we're in standby, postpone advancing options.fetchPolicy using
          // applyNextFetchPolicy.
          I.fetchPolicy !== "standby" && // The "standby" policy currently returns [] from fetchQueryByPolicy, so
          // this is another way to detect when nothing was done/fetched.
          Ee.sources.length > 0 && d.observableQuery && d.observableQuery.applyNextFetchPolicy("after-fetch", r), Ee
        );
      }, q = function() {
        return a.fetchCancelFns.delete(e);
      };
      this.fetchCancelFns.set(e, function(te) {
        q(), setTimeout(function() {
          return $.cancel(te);
        });
      });
      var $, ae;
      if (this.getDocumentInfo(I.query).hasClientExports)
        $ = new Ss(this.localState.addExportedVariables(I.query, I.variables, I.context).then(O).then(function(te) {
          return te.sources;
        })), ae = !0;
      else {
        var he = O(I.variables);
        ae = he.fromLink, $ = new Ss(he.sources);
      }
      return $.promise.then(q, q), {
        concast: $,
        fromLink: ae
      };
    }, t.prototype.refetchQueries = function(e) {
      var r = this, i = e.updateCache, f = e.include, a = e.optimistic, l = a === void 0 ? !1 : a, d = e.removeOptimistic, v = d === void 0 ? l ? g1("refetchQueries") : void 0 : d, m = e.onQueryUpdated, h = /* @__PURE__ */ new Map();
      f && this.getObservableQueries(f).forEach(function(M, S) {
        h.set(S, {
          oq: M,
          lastDiff: r.getQuery(S).getDiff()
        });
      });
      var w = /* @__PURE__ */ new Map();
      return i && this.cache.batch({
        update: i,
        // Since you can perform any combination of cache reads and/or writes in
        // the cache.batch update function, its optimistic option can be either
        // a boolean or a string, representing three distinct modes of
        // operation:
        //
        // * false: read/write only the root layer
        // * true: read/write the topmost layer
        // * string: read/write a fresh optimistic layer with that ID string
        //
        // When typeof optimistic === "string", a new optimistic layer will be
        // temporarily created within cache.batch with that string as its ID. If
        // we then pass that same string as the removeOptimistic option, we can
        // make cache.batch immediately remove the optimistic layer after
        // running the updateCache function, triggering only one broadcast.
        //
        // However, the refetchQueries method accepts only true or false for its
        // optimistic option (not string). We interpret true to mean a temporary
        // optimistic layer should be created, to allow efficiently rolling back
        // the effect of the updateCache function, which involves passing a
        // string instead of true as the optimistic option to cache.batch, when
        // refetchQueries receives optimistic: true.
        //
        // In other words, we are deliberately not supporting the use case of
        // writing to an *existing* optimistic layer (using the refetchQueries
        // updateCache function), since that would potentially interfere with
        // other optimistic updates in progress. Instead, you can read/write
        // only the root layer by passing optimistic: false to refetchQueries,
        // or you can read/write a brand new optimistic layer that will be
        // automatically removed by passing optimistic: true.
        optimistic: l && v || !1,
        // The removeOptimistic option can also be provided by itself, even if
        // optimistic === false, to remove some previously-added optimistic
        // layer safely and efficiently, like we do in markMutationResult.
        //
        // If an explicit removeOptimistic string is provided with optimistic:
        // true, the removeOptimistic string will determine the ID of the
        // temporary optimistic layer, in case that ever matters.
        removeOptimistic: v,
        onWatchUpdated: function(M, S, E) {
          var A = M.watcher instanceof Id && M.watcher.observableQuery;
          if (A) {
            if (m) {
              h.delete(A.queryId);
              var B = m(A, S, E);
              return B === !0 && (B = A.refetch()), B !== !1 && w.set(A, B), B;
            }
            m !== null && h.set(A.queryId, { oq: A, lastDiff: E, diff: S });
          }
        }
      }), h.size && h.forEach(function(M, S) {
        var E = M.oq, A = M.lastDiff, B = M.diff, k;
        if (m) {
          if (!B) {
            var C = E.queryInfo;
            C.reset(), B = C.getDiff();
          }
          k = m(E, B, A);
        }
        (!m || k === !0) && (k = E.refetch()), k !== !1 && w.set(E, k), S.indexOf("legacyOneTimeQuery") >= 0 && r.stopQueryNoBroadcast(S);
      }), v && this.cache.removeOptimistic(v), w;
    }, t.prototype.fetchQueryByPolicy = function(e, r, i) {
      var f = this, a = r.query, l = r.variables, d = r.fetchPolicy, v = r.refetchWritePolicy, m = r.errorPolicy, h = r.returnPartialData, w = r.context, M = r.notifyOnNetworkStatusChange, S = e.networkStatus;
      e.init({
        document: a,
        variables: l,
        networkStatus: i
      });
      var E = function() {
        return e.getDiff();
      }, A = function(O, q) {
        q === void 0 && (q = e.networkStatus || Jt.loading);
        var $ = O.result;
        globalThis.__DEV__ !== !1 && !h && !er($, {}) && V4(O.missing);
        var ae = function(he) {
          return ar.of(We({ data: he, loading: If(q), networkStatus: q }, O.complete ? null : { partial: !0 }));
        };
        return $ && f.getDocumentInfo(a).hasForcedResolvers ? f.localState.runResolvers({
          document: a,
          remoteResult: { data: $ },
          context: w,
          variables: l,
          onlyRunForcedResolvers: !0
        }).then(function(he) {
          return ae(he.data || void 0);
        }) : m === "none" && q === Jt.refetch && Array.isArray(O.missing) ? ae(void 0) : ae($);
      }, B = d === "no-cache" ? 0 : i === Jt.refetch && v !== "merge" ? 1 : 2, k = function() {
        return f.getResultsFromLink(e, B, {
          query: a,
          variables: l,
          context: w,
          fetchPolicy: d,
          errorPolicy: m
        });
      }, C = M && typeof S == "number" && S !== i && If(i);
      switch (d) {
        default:
        case "cache-first": {
          var I = E();
          return I.complete ? {
            fromLink: !1,
            sources: [A(I, e.markReady())]
          } : h || C ? {
            fromLink: !0,
            sources: [A(I), k()]
          } : { fromLink: !0, sources: [k()] };
        }
        case "cache-and-network": {
          var I = E();
          return I.complete || h || C ? {
            fromLink: !0,
            sources: [A(I), k()]
          } : { fromLink: !0, sources: [k()] };
        }
        case "cache-only":
          return {
            fromLink: !1,
            sources: [A(E(), e.markReady())]
          };
        case "network-only":
          return C ? {
            fromLink: !0,
            sources: [A(E()), k()]
          } : { fromLink: !0, sources: [k()] };
        case "no-cache":
          return C ? {
            fromLink: !0,
            // Note that queryInfo.getDiff() for no-cache queries does not call
            // cache.diff, but instead returns a { complete: false } stub result
            // when there is no queryInfo.diff already defined.
            sources: [A(e.getDiff()), k()]
          } : { fromLink: !0, sources: [k()] };
        case "standby":
          return { fromLink: !1, sources: [] };
      }
    }, t.prototype.getQuery = function(e) {
      return e && !this.queries.has(e) && this.queries.set(e, new Id(this, e)), this.queries.get(e);
    }, t.prototype.prepareContext = function(e) {
      e === void 0 && (e = {});
      var r = this.localState.prepareContext(e);
      return We(We(We({}, this.defaultContext), r), { clientAwareness: this.clientAwareness });
    }, t;
  }()
), $y = !1, W4 = (
  /** @class */
  function() {
    function t(e) {
      var r = this;
      if (this.resetStoreCallbacks = [], this.clearStoreCallbacks = [], !e.cache)
        throw Gr(15);
      var i = e.uri, f = e.credentials, a = e.headers, l = e.cache, d = e.documentTransform, v = e.ssrMode, m = v === void 0 ? !1 : v, h = e.ssrForceFetchDelay, w = h === void 0 ? 0 : h, M = e.connectToDevTools, S = M === void 0 ? typeof window == "object" && !window.__APOLLO_CLIENT__ && globalThis.__DEV__ !== !1 : M, E = e.queryDeduplication, A = E === void 0 ? !0 : E, B = e.defaultOptions, k = e.defaultContext, C = e.assumeImmutableResults, I = C === void 0 ? l.assumeImmutableResults : C, O = e.resolvers, q = e.typeDefs, $ = e.fragmentMatcher, ae = e.name, he = e.version, te = e.link;
      te || (te = i ? new k4({ uri: i, credentials: f, headers: a }) : vs.empty()), this.link = te, this.cache = l, this.disableNetworkFetches = m || w > 0, this.queryDeduplication = A, this.defaultOptions = B || /* @__PURE__ */ Object.create(null), this.typeDefs = q, w && setTimeout(function() {
        return r.disableNetworkFetches = !1;
      }, w), this.watchQuery = this.watchQuery.bind(this), this.query = this.query.bind(this), this.mutate = this.mutate.bind(this), this.watchFragment = this.watchFragment.bind(this), this.resetStore = this.resetStore.bind(this), this.reFetchObservableQueries = this.reFetchObservableQueries.bind(this), this.version = Rv, this.localState = new H4({
        cache: l,
        client: this,
        resolvers: O,
        fragmentMatcher: $
      }), this.queryManager = new dk({
        cache: this.cache,
        link: this.link,
        defaultOptions: this.defaultOptions,
        defaultContext: k,
        documentTransform: d,
        queryDeduplication: A,
        ssrMode: m,
        clientAwareness: {
          name: ae,
          version: he
        },
        localState: this.localState,
        assumeImmutableResults: I,
        onBroadcast: S ? function() {
          r.devToolsHookCb && r.devToolsHookCb({
            action: {},
            state: {
              queries: r.queryManager.getQueryStore(),
              mutations: r.queryManager.mutationStore || {}
            },
            dataWithOptimisticResults: r.cache.extract(!0)
          });
        } : void 0
      }), S && this.connectToDevTools();
    }
    return t.prototype.connectToDevTools = function() {
      if (typeof window == "object") {
        var e = window, r = Symbol.for("apollo.devtools");
        (e[r] = e[r] || []).push(this), e.__APOLLO_CLIENT__ = this;
      }
      !$y && globalThis.__DEV__ !== !1 && ($y = !0, setTimeout(function() {
        if (typeof window < "u" && window.document && window.top === window.self && !window.__APOLLO_DEVTOOLS_GLOBAL_HOOK__) {
          var i = window.navigator, f = i && i.userAgent, a = void 0;
          typeof f == "string" && (f.indexOf("Chrome/") > -1 ? a = "https://chrome.google.com/webstore/detail/apollo-client-developer-t/jdkknkkbebbapilgoeccciglkfbmbnfm" : f.indexOf("Firefox/") > -1 && (a = "https://addons.mozilla.org/en-US/firefox/addon/apollo-developer-tools/")), a && globalThis.__DEV__ !== !1 && Rt.log("Download the Apollo DevTools for a better development experience: %s", a);
        }
      }, 1e4));
    }, Object.defineProperty(t.prototype, "documentTransform", {
      /**
       * The `DocumentTransform` used to modify GraphQL documents before a request
       * is made. If a custom `DocumentTransform` is not provided, this will be the
       * default document transform.
       */
      get: function() {
        return this.queryManager.documentTransform;
      },
      enumerable: !1,
      configurable: !0
    }), t.prototype.stop = function() {
      this.queryManager.stop();
    }, t.prototype.watchQuery = function(e) {
      return this.defaultOptions.watchQuery && (e = ju(this.defaultOptions.watchQuery, e)), this.disableNetworkFetches && (e.fetchPolicy === "network-only" || e.fetchPolicy === "cache-and-network") && (e = We(We({}, e), { fetchPolicy: "cache-first" })), this.queryManager.watchQuery(e);
    }, t.prototype.query = function(e) {
      return this.defaultOptions.query && (e = ju(this.defaultOptions.query, e)), Rt(e.fetchPolicy !== "cache-and-network", 16), this.disableNetworkFetches && e.fetchPolicy === "network-only" && (e = We(We({}, e), { fetchPolicy: "cache-first" })), this.queryManager.query(e);
    }, t.prototype.mutate = function(e) {
      return this.defaultOptions.mutate && (e = ju(this.defaultOptions.mutate, e)), this.queryManager.mutate(e);
    }, t.prototype.subscribe = function(e) {
      return this.queryManager.startGraphQLSubscription(e);
    }, t.prototype.readQuery = function(e, r) {
      return r === void 0 && (r = !1), this.cache.readQuery(e, r);
    }, t.prototype.watchFragment = function(e) {
      return this.cache.watchFragment(e);
    }, t.prototype.readFragment = function(e, r) {
      return r === void 0 && (r = !1), this.cache.readFragment(e, r);
    }, t.prototype.writeQuery = function(e) {
      var r = this.cache.writeQuery(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, t.prototype.writeFragment = function(e) {
      var r = this.cache.writeFragment(e);
      return e.broadcast !== !1 && this.queryManager.broadcastQueries(), r;
    }, t.prototype.__actionHookForDevTools = function(e) {
      this.devToolsHookCb = e;
    }, t.prototype.__requestRaw = function(e) {
      return I1(this.link, e);
    }, t.prototype.resetStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !1
        });
      }).then(function() {
        return Promise.all(e.resetStoreCallbacks.map(function(r) {
          return r();
        }));
      }).then(function() {
        return e.reFetchObservableQueries();
      });
    }, t.prototype.clearStore = function() {
      var e = this;
      return Promise.resolve().then(function() {
        return e.queryManager.clearStore({
          discardWatches: !0
        });
      }).then(function() {
        return Promise.all(e.clearStoreCallbacks.map(function(r) {
          return r();
        }));
      });
    }, t.prototype.onResetStore = function(e) {
      var r = this;
      return this.resetStoreCallbacks.push(e), function() {
        r.resetStoreCallbacks = r.resetStoreCallbacks.filter(function(i) {
          return i !== e;
        });
      };
    }, t.prototype.onClearStore = function(e) {
      var r = this;
      return this.clearStoreCallbacks.push(e), function() {
        r.clearStoreCallbacks = r.clearStoreCallbacks.filter(function(i) {
          return i !== e;
        });
      };
    }, t.prototype.reFetchObservableQueries = function(e) {
      return this.queryManager.reFetchObservableQueries(e);
    }, t.prototype.refetchQueries = function(e) {
      var r = this.queryManager.refetchQueries(e), i = [], f = [];
      r.forEach(function(l, d) {
        i.push(d), f.push(l);
      });
      var a = Promise.all(f);
      return a.queries = i, a.results = f, a.catch(function(l) {
        globalThis.__DEV__ !== !1 && Rt.debug(17, l);
      }), a;
    }, t.prototype.getObservableQueries = function(e) {
      return e === void 0 && (e = "active"), this.queryManager.getObservableQueries(e);
    }, t.prototype.extract = function(e) {
      return this.cache.extract(e);
    }, t.prototype.restore = function(e) {
      return this.cache.restore(e);
    }, t.prototype.addResolvers = function(e) {
      this.localState.addResolvers(e);
    }, t.prototype.setResolvers = function(e) {
      this.localState.setResolvers(e);
    }, t.prototype.getResolvers = function() {
      return this.localState.getResolvers();
    }, t.prototype.setLocalStateFragmentMatcher = function(e) {
      this.localState.setFragmentMatcher(e);
    }, t.prototype.setLink = function(e) {
      this.link = this.queryManager.link = e;
    }, Object.defineProperty(t.prototype, "defaultContext", {
      get: function() {
        return this.queryManager.defaultContext;
      },
      enumerable: !1,
      configurable: !0
    }), t;
  }()
);
globalThis.__DEV__ !== !1 && (W4.prototype.getMemoryInternals = aE);
var Hu = /* @__PURE__ */ new Map(), q1 = /* @__PURE__ */ new Map(), K4 = !0, Al = !1;
function Z4(t) {
  return t.replace(/[\s,]+/g, " ").trim();
}
function hk(t) {
  return Z4(t.source.body.substring(t.start, t.end));
}
function pk(t) {
  var e = /* @__PURE__ */ new Set(), r = [];
  return t.definitions.forEach(function(i) {
    if (i.kind === "FragmentDefinition") {
      var f = i.name.value, a = hk(i.loc), l = q1.get(f);
      l && !l.has(a) ? K4 && console.warn("Warning: fragment with name " + f + ` already exists.
graphql-tag enforces all fragment names across your application to be unique; read more about
this in the docs: http://dev.apollodata.com/core/fragments.html#unique-names`) : l || q1.set(f, l = /* @__PURE__ */ new Set()), l.add(a), e.has(a) || (e.add(a), r.push(i));
    } else
      r.push(i);
  }), We(We({}, t), { definitions: r });
}
function vk(t) {
  var e = new Set(t.definitions);
  e.forEach(function(i) {
    i.loc && delete i.loc, Object.keys(i).forEach(function(f) {
      var a = i[f];
      a && typeof a == "object" && e.add(a);
    });
  });
  var r = t.loc;
  return r && (delete r.startToken, delete r.endToken), t;
}
function mk(t) {
  var e = Z4(t);
  if (!Hu.has(e)) {
    var r = IS(t, {
      experimentalFragmentVariables: Al,
      allowLegacyFragmentVariables: Al
    });
    if (!r || r.kind !== "Document")
      throw new Error("Not a valid GraphQL document.");
    Hu.set(e, vk(pk(r)));
  }
  return Hu.get(e);
}
function Ln(t) {
  for (var e = [], r = 1; r < arguments.length; r++)
    e[r - 1] = arguments[r];
  typeof t == "string" && (t = [t]);
  var i = t[0];
  return e.forEach(function(f, a) {
    f && f.kind === "Document" ? i += f.loc.source.body : i += f, i += t[a + 1];
  }), mk(i);
}
function gk() {
  Hu.clear(), q1.clear();
}
function yk() {
  K4 = !1;
}
function bk() {
  Al = !0;
}
function wk() {
  Al = !1;
}
var Co = {
  gql: Ln,
  resetCaches: gk,
  disableFragmentWarnings: yk,
  enableExperimentalFragmentVariables: bk,
  disableExperimentalFragmentVariables: wk
};
(function(t) {
  t.gql = Co.gql, t.resetCaches = Co.resetCaches, t.disableFragmentWarnings = Co.disableFragmentWarnings, t.enableExperimentalFragmentVariables = Co.enableExperimentalFragmentVariables, t.disableExperimentalFragmentVariables = Co.disableExperimentalFragmentVariables;
})(Ln || (Ln = {}));
Ln.default = Ln;
var G4 = { exports: {} };
(function(t) {
  t.exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED = void 0, t.exports.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, t.exports.__SERVER_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE = void 0, Object.assign(t.exports, nr);
})(G4);
var ur = G4.exports;
const _k = /* @__PURE__ */ R5(ur), Q4 = /* @__PURE__ */ HM({
  __proto__: null,
  default: _k
}, [ur]);
var Vy = Lv ? Symbol.for("__APOLLO_CONTEXT__") : "__APOLLO_CONTEXT__";
function rm() {
  Rt("createContext" in Q4, 45);
  var t = ur.createContext[Vy];
  return t || (Object.defineProperty(ur.createContext, Vy, {
    value: t = ur.createContext({}),
    enumerable: !1,
    writable: !1,
    configurable: !0
  }), t.displayName = "ApolloContext"), t;
}
var xk = function(t) {
  var e = t.client, r = t.children, i = rm(), f = ur.useContext(i), a = ur.useMemo(function() {
    return We(We({}, f), { client: e || f.client });
  }, [f, e]);
  return Rt(a.client, 46), ur.createElement(i.Provider, { value: a }, r);
};
function nm(t) {
  var e = ur.useContext(rm()), r = t || e.client;
  return Rt(!!r, 49), r;
}
var Hy = !1, Mk = "useSyncExternalStore", Sk = Q4[Mk], Ek = Sk || function(t, e, r) {
  var i = e();
  // DEVIATION: Using __DEV__
  globalThis.__DEV__ !== !1 && !Hy && // DEVIATION: Not using Object.is because we know our snapshots will never
  // be exotic primitive values like NaN, which is !== itself.
  i !== e() && (Hy = !0, globalThis.__DEV__ !== !1 && Rt.error(58));
  var f = ur.useState({
    inst: { value: i, getSnapshot: e }
  }), a = f[0].inst, l = f[1];
  return GS ? ur.useLayoutEffect(function() {
    Object.assign(a, { value: i, getSnapshot: e }), Rd(a) && l({ inst: a });
  }, [t, i, e]) : Object.assign(a, { value: i, getSnapshot: e }), ur.useEffect(function() {
    return Rd(a) && l({ inst: a }), t(function() {
      Rd(a) && l({ inst: a });
    });
  }, [t]), i;
};
function Rd(t) {
  var e = t.value, r = t.getSnapshot;
  try {
    return e !== r();
  } catch {
    return !0;
  }
}
var Qn;
(function(t) {
  t[t.Query = 0] = "Query", t[t.Mutation = 1] = "Mutation", t[t.Subscription = 2] = "Subscription";
})(Qn || (Qn = {}));
var Pa;
function Wy(t) {
  var e;
  switch (t) {
    case Qn.Query:
      e = "Query";
      break;
    case Qn.Mutation:
      e = "Mutation";
      break;
    case Qn.Subscription:
      e = "Subscription";
      break;
  }
  return e;
}
function Y4(t) {
  Pa || (Pa = new Fv(
    ri.parser || 1e3
    /* defaultCacheSizes.parser */
  ));
  var e = Pa.get(t);
  if (e)
    return e;
  var r, i, f;
  Rt(!!t && !!t.kind, 59, t);
  for (var a = [], l = [], d = [], v = [], m = 0, h = t.definitions; m < h.length; m++) {
    var w = h[m];
    if (w.kind === "FragmentDefinition") {
      a.push(w);
      continue;
    }
    if (w.kind === "OperationDefinition")
      switch (w.operation) {
        case "query":
          l.push(w);
          break;
        case "mutation":
          d.push(w);
          break;
        case "subscription":
          v.push(w);
          break;
      }
  }
  Rt(!a.length || l.length || d.length || v.length, 60), Rt(
    l.length + d.length + v.length <= 1,
    61,
    t,
    l.length,
    v.length,
    d.length
  ), i = l.length ? Qn.Query : Qn.Mutation, !l.length && !d.length && (i = Qn.Subscription);
  var M = l.length ? l : d.length ? d : v;
  Rt(M.length === 1, 62, t, M.length);
  var S = M[0];
  r = S.variableDefinitions || [], S.name && S.name.kind === "Name" ? f = S.name.value : f = "data";
  var E = { name: f, type: i, variables: r };
  return Pa.set(t, E), E;
}
Y4.resetCache = function() {
  Pa = void 0;
};
globalThis.__DEV__ !== !1 && qv("parser", function() {
  return Pa ? Pa.size : 0;
});
function J4(t, e) {
  var r = Y4(t), i = Wy(e), f = Wy(r.type);
  Rt(
    r.type === e,
    63,
    i,
    i,
    f
  );
}
var Ak = Symbol.for("apollo.hook.wrappers");
function kk(t, e, r) {
  var i = r.queryManager, f = i && i[Ak], a = f && f[t];
  return a ? a(e) : e;
}
var Tk = Object.prototype.hasOwnProperty;
function Ck(t, e) {
  return e === void 0 && (e = /* @__PURE__ */ Object.create(null)), kk("useQuery", Bk, nm(e && e.client))(t, e);
}
function Bk(t, e) {
  return Ik(nm(e.client), t).useQuery(e);
}
function Ik(t, e) {
  var r = ur.useRef();
  (!r.current || t !== r.current.client || e !== r.current.query) && (r.current = new Rk(t, e, r.current));
  var i = r.current;
  return i.forceUpdateState = ur.useReducer(function(f) {
    return f + 1;
  }, 0)[1], i;
}
var Rk = (
  /** @class */
  function() {
    function t(e, r, i) {
      var f = this;
      this.client = e, this.query = r, this.forceUpdate = function() {
        return f.forceUpdateState();
      }, this.ssrDisabledResult = Cf({
        loading: !0,
        data: void 0,
        error: void 0,
        networkStatus: Jt.loading
      }), this.skipStandbyResult = Cf({
        loading: !1,
        data: void 0,
        error: void 0,
        networkStatus: Jt.ready
      }), this.toQueryResultCache = new (ps ? WeakMap : Map)(), J4(r, Qn.Query);
      var a = i && i.result, l = a && a.data;
      l && (this.previousData = l);
    }
    return t.prototype.forceUpdateState = function() {
      globalThis.__DEV__ !== !1 && Rt.warn(51);
    }, t.prototype.executeQuery = function(e) {
      var r = this, i;
      e.query && Object.assign(this, { query: e.query }), this.watchQueryOptions = this.createWatchQueryOptions(this.queryHookOptions = e);
      var f = this.observable.reobserveAsConcast(this.getObsQueryOptions());
      return this.previousData = ((i = this.result) === null || i === void 0 ? void 0 : i.data) || this.previousData, this.result = void 0, this.forceUpdate(), new Promise(function(a) {
        var l;
        f.subscribe({
          next: function(d) {
            l = d;
          },
          error: function() {
            a(r.toQueryResult(r.observable.getCurrentResult()));
          },
          complete: function() {
            a(r.toQueryResult(l));
          }
        });
      });
    }, t.prototype.useQuery = function(e) {
      var r = this;
      this.renderPromises = ur.useContext(rm()).renderPromises, this.useOptions(e);
      var i = this.useObservableQuery(), f = Ek(ur.useCallback(function(a) {
        if (r.renderPromises)
          return function() {
          };
        r.forceUpdate = a;
        var l = function() {
          var m = r.result, h = i.getCurrentResult();
          m && m.loading === h.loading && m.networkStatus === h.networkStatus && er(m.data, h.data) || r.setResult(h);
        }, d = function(m) {
          if (v.unsubscribe(), v = i.resubscribeAfterError(l, d), !Tk.call(m, "graphQLErrors"))
            throw m;
          var h = r.result;
          (!h || h && h.loading || !er(m, h.error)) && r.setResult({
            data: h && h.data,
            error: m,
            loading: !1,
            networkStatus: Jt.error
          });
        }, v = i.subscribe(l, d);
        return function() {
          setTimeout(function() {
            return v.unsubscribe();
          }), r.forceUpdate = function() {
            return r.forceUpdateState();
          };
        };
      }, [
        // We memoize the subscribe function using useCallback and the following
        // dependency keys, because the subscribe function reference is all that
        // useSyncExternalStore uses internally as a dependency key for the
        // useEffect ultimately responsible for the subscription, so we are
        // effectively passing this dependency array to that useEffect buried
        // inside useSyncExternalStore, as desired.
        i,
        this.renderPromises,
        this.client.disableNetworkFetches
      ]), function() {
        return r.getCurrentResult();
      }, function() {
        return r.getCurrentResult();
      });
      return this.unsafeHandlePartialRefetch(f), this.toQueryResult(f);
    }, t.prototype.useOptions = function(e) {
      var r, i = this.createWatchQueryOptions(this.queryHookOptions = e), f = this.watchQueryOptions;
      er(i, f) || (this.watchQueryOptions = i, f && this.observable && (this.observable.reobserve(this.getObsQueryOptions()), this.previousData = ((r = this.result) === null || r === void 0 ? void 0 : r.data) || this.previousData, this.result = void 0)), this.onCompleted = e.onCompleted || t.prototype.onCompleted, this.onError = e.onError || t.prototype.onError, (this.renderPromises || this.client.disableNetworkFetches) && this.queryHookOptions.ssr === !1 && !this.queryHookOptions.skip ? this.result = this.ssrDisabledResult : this.queryHookOptions.skip || this.watchQueryOptions.fetchPolicy === "standby" ? this.result = this.skipStandbyResult : (this.result === this.ssrDisabledResult || this.result === this.skipStandbyResult) && (this.result = void 0);
    }, t.prototype.getObsQueryOptions = function() {
      var e = [], r = this.client.defaultOptions.watchQuery;
      return r && e.push(r), this.queryHookOptions.defaultOptions && e.push(this.queryHookOptions.defaultOptions), e.push(Fa(this.observable && this.observable.options, this.watchQueryOptions)), e.reduce(ju);
    }, t.prototype.createWatchQueryOptions = function(e) {
      var r;
      e === void 0 && (e = {});
      var i = e.skip;
      e.ssr, e.onCompleted, e.onError, e.defaultOptions;
      var f = ti(e, ["skip", "ssr", "onCompleted", "onError", "defaultOptions"]), a = Object.assign(f, { query: this.query });
      if (this.renderPromises && (a.fetchPolicy === "network-only" || a.fetchPolicy === "cache-and-network") && (a.fetchPolicy = "cache-first"), a.variables || (a.variables = {}), i) {
        var l = a.fetchPolicy, d = l === void 0 ? this.getDefaultFetchPolicy() : l, v = a.initialFetchPolicy, m = v === void 0 ? d : v;
        Object.assign(a, {
          initialFetchPolicy: m,
          fetchPolicy: "standby"
        });
      } else
        a.fetchPolicy || (a.fetchPolicy = ((r = this.observable) === null || r === void 0 ? void 0 : r.options.initialFetchPolicy) || this.getDefaultFetchPolicy());
      return a;
    }, t.prototype.getDefaultFetchPolicy = function() {
      var e, r;
      return ((e = this.queryHookOptions.defaultOptions) === null || e === void 0 ? void 0 : e.fetchPolicy) || ((r = this.client.defaultOptions.watchQuery) === null || r === void 0 ? void 0 : r.fetchPolicy) || "cache-first";
    }, t.prototype.onCompleted = function(e) {
    }, t.prototype.onError = function(e) {
    }, t.prototype.useObservableQuery = function() {
      var e = this.observable = this.renderPromises && this.renderPromises.getSSRObservable(this.watchQueryOptions) || this.observable || // Reuse this.observable if possible (and not SSR)
      this.client.watchQuery(this.getObsQueryOptions());
      this.obsQueryFields = ur.useMemo(function() {
        return {
          refetch: e.refetch.bind(e),
          reobserve: e.reobserve.bind(e),
          fetchMore: e.fetchMore.bind(e),
          updateQuery: e.updateQuery.bind(e),
          startPolling: e.startPolling.bind(e),
          stopPolling: e.stopPolling.bind(e),
          subscribeToMore: e.subscribeToMore.bind(e)
        };
      }, [e]);
      var r = !(this.queryHookOptions.ssr === !1 || this.queryHookOptions.skip);
      return this.renderPromises && r && (this.renderPromises.registerSSRObservable(e), e.getCurrentResult().loading && this.renderPromises.addObservableQueryPromise(e)), e;
    }, t.prototype.setResult = function(e) {
      var r = this.result;
      r && r.data && (this.previousData = r.data), this.result = e, this.forceUpdate(), this.handleErrorOrCompleted(e, r);
    }, t.prototype.handleErrorOrCompleted = function(e, r) {
      var i = this;
      if (!e.loading) {
        var f = this.toApolloError(e);
        Promise.resolve().then(function() {
          f ? i.onError(f) : e.data && (r == null ? void 0 : r.networkStatus) !== e.networkStatus && e.networkStatus === Jt.ready && i.onCompleted(e.data);
        }).catch(function(a) {
          globalThis.__DEV__ !== !1 && Rt.warn(a);
        });
      }
    }, t.prototype.toApolloError = function(e) {
      return En(e.errors) ? new gi({ graphQLErrors: e.errors }) : e.error;
    }, t.prototype.getCurrentResult = function() {
      return this.result || this.handleErrorOrCompleted(this.result = this.observable.getCurrentResult()), this.result;
    }, t.prototype.toQueryResult = function(e) {
      var r = this.toQueryResultCache.get(e);
      if (r)
        return r;
      var i = e.data;
      e.partial;
      var f = ti(e, ["data", "partial"]);
      return this.toQueryResultCache.set(e, r = We(We(We({ data: i }, f), this.obsQueryFields), { client: this.client, observable: this.observable, variables: this.observable.variables, called: !this.queryHookOptions.skip, previousData: this.previousData })), !r.error && En(e.errors) && (r.error = new gi({ graphQLErrors: e.errors })), r;
    }, t.prototype.unsafeHandlePartialRefetch = function(e) {
      e.partial && this.queryHookOptions.partialRefetch && !e.loading && (!e.data || Object.keys(e.data).length === 0) && this.observable.options.fetchPolicy !== "cache-only" && (Object.assign(e, {
        loading: !0,
        networkStatus: Jt.refetch
      }), this.observable.refetch());
    }, t;
  }()
);
function Pk(t, e) {
  var r = ur.useRef(!1), i = nm(e == null ? void 0 : e.client);
  J4(t, Qn.Subscription);
  var f = ur.useState({
    loading: !(e != null && e.skip),
    error: void 0,
    data: void 0,
    variables: e == null ? void 0 : e.variables
  }), a = f[0], l = f[1];
  r.current || (r.current = !0, e != null && e.onSubscriptionData && globalThis.__DEV__ !== !1 && Rt.warn(e.onData ? 52 : 53), e != null && e.onSubscriptionComplete && globalThis.__DEV__ !== !1 && Rt.warn(e.onComplete ? 54 : 55));
  var d = ur.useState(function() {
    return e != null && e.skip ? null : i.subscribe({
      query: t,
      variables: e == null ? void 0 : e.variables,
      fetchPolicy: e == null ? void 0 : e.fetchPolicy,
      context: e == null ? void 0 : e.context
    });
  }), v = d[0], m = d[1], h = ur.useRef(!1);
  ur.useEffect(function() {
    return function() {
      h.current = !0;
    };
  }, []);
  var w = ur.useRef({ client: i, subscription: t, options: e });
  return ur.useEffect(function() {
    var M, S, E, A, B = e == null ? void 0 : e.shouldResubscribe;
    typeof B == "function" && (B = !!B(e)), e != null && e.skip ? (!(e != null && e.skip) != !(!((M = w.current.options) === null || M === void 0) && M.skip) || h.current) && (l({
      loading: !1,
      data: void 0,
      error: void 0,
      variables: e == null ? void 0 : e.variables
    }), m(null), h.current = !1) : (B !== !1 && (i !== w.current.client || t !== w.current.subscription || (e == null ? void 0 : e.fetchPolicy) !== ((S = w.current.options) === null || S === void 0 ? void 0 : S.fetchPolicy) || !(e != null && e.skip) != !(!((E = w.current.options) === null || E === void 0) && E.skip) || !er(e == null ? void 0 : e.variables, (A = w.current.options) === null || A === void 0 ? void 0 : A.variables)) || h.current) && (l({
      loading: !0,
      data: void 0,
      error: void 0,
      variables: e == null ? void 0 : e.variables
    }), m(i.subscribe({
      query: t,
      variables: e == null ? void 0 : e.variables,
      fetchPolicy: e == null ? void 0 : e.fetchPolicy,
      context: e == null ? void 0 : e.context
    })), h.current = !1), Object.assign(w.current, { client: i, subscription: t, options: e });
  }, [i, t, e, h.current]), ur.useEffect(function() {
    if (v) {
      var M = !1, S = v.subscribe({
        next: function(E) {
          var A, B;
          if (!M) {
            var k = {
              loading: !1,
              // TODO: fetchResult.data can be null but SubscriptionResult.data
              // expects TData | undefined only
              data: E.data,
              error: void 0,
              variables: e == null ? void 0 : e.variables
            };
            l(k), !((A = w.current.options) === null || A === void 0) && A.onData ? w.current.options.onData({
              client: i,
              data: k
            }) : !((B = w.current.options) === null || B === void 0) && B.onSubscriptionData && w.current.options.onSubscriptionData({
              client: i,
              subscriptionData: k
            });
          }
        },
        error: function(E) {
          var A, B;
          M || (l({
            loading: !1,
            data: void 0,
            error: E,
            variables: e == null ? void 0 : e.variables
          }), (B = (A = w.current.options) === null || A === void 0 ? void 0 : A.onError) === null || B === void 0 || B.call(A, E));
        },
        complete: function() {
          var E, A;
          M || (!((E = w.current.options) === null || E === void 0) && E.onComplete ? w.current.options.onComplete() : !((A = w.current.options) === null || A === void 0) && A.onSubscriptionComplete && w.current.options.onSubscriptionComplete());
        }
      });
      return function() {
        M = !0, setTimeout(function() {
          S.unsubscribe();
        });
      };
    }
  }, [v]), a;
}
function Ok(t) {
  return lr(t) && "code" in t && "reason" in t;
}
function Nk(t) {
  var e;
  return lr(t) && ((e = t.target) === null || e === void 0 ? void 0 : e.readyState) === WebSocket.CLOSED;
}
var Dk = (
  /** @class */
  function(t) {
    Fn(e, t);
    function e(r) {
      var i = t.call(this) || this;
      return i.client = r, i;
    }
    return e.prototype.request = function(r) {
      var i = this;
      return new ar(function(f) {
        return i.client.subscribe(We(We({}, r), { query: Ff(r.query) }), {
          next: f.next.bind(f),
          complete: f.complete.bind(f),
          error: function(a) {
            if (a instanceof Error)
              return f.error(a);
            var l = Ok(a);
            return l || Nk(a) ? f.error(
              // reason will be available on clean closes
              new Error("Socket closed".concat(l ? " with event ".concat(a.code) : "").concat(l ? " ".concat(a.reason) : ""))
            ) : f.error(new gi({
              graphQLErrors: Array.isArray(a) ? a : [a]
            }));
          }
        });
      });
    }, e;
  }(vs)
);
function Qr(t) {
  return t === null ? "null" : Array.isArray(t) ? "array" : typeof t;
}
function ka(t) {
  return Qr(t) === "object";
}
function Uk(t) {
  return Array.isArray(t) && // must be at least one error
  t.length > 0 && // error has at least a message
  t.every((e) => "message" in e);
}
function Ky(t, e) {
  return t.length < 124 ? t : e;
}
const Lk = "graphql-transport-ws";
var fn;
(function(t) {
  t[t.InternalServerError = 4500] = "InternalServerError", t[t.InternalClientError = 4005] = "InternalClientError", t[t.BadRequest = 4400] = "BadRequest", t[t.BadResponse = 4004] = "BadResponse", t[t.Unauthorized = 4401] = "Unauthorized", t[t.Forbidden = 4403] = "Forbidden", t[t.SubprotocolNotAcceptable = 4406] = "SubprotocolNotAcceptable", t[t.ConnectionInitialisationTimeout = 4408] = "ConnectionInitialisationTimeout", t[t.ConnectionAcknowledgementTimeout = 4504] = "ConnectionAcknowledgementTimeout", t[t.SubscriberAlreadyExists = 4409] = "SubscriberAlreadyExists", t[t.TooManyInitialisationRequests = 4429] = "TooManyInitialisationRequests";
})(fn || (fn = {}));
var wr;
(function(t) {
  t.ConnectionInit = "connection_init", t.ConnectionAck = "connection_ack", t.Ping = "ping", t.Pong = "pong", t.Subscribe = "subscribe", t.Next = "next", t.Error = "error", t.Complete = "complete";
})(wr || (wr = {}));
function X4(t) {
  if (!ka(t))
    throw new Error(`Message is expected to be an object, but got ${Qr(t)}`);
  if (!t.type)
    throw new Error("Message is missing the 'type' property");
  if (typeof t.type != "string")
    throw new Error(`Message is expects the 'type' property to be a string, but got ${Qr(t.type)}`);
  switch (t.type) {
    case wr.ConnectionInit:
    case wr.ConnectionAck:
    case wr.Ping:
    case wr.Pong: {
      if (t.payload != null && !ka(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an object or nullish or missing, but got "${t.payload}"`);
      break;
    }
    case wr.Subscribe: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${Qr(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      if (!ka(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an object, but got ${Qr(t.payload)}`);
      if (typeof t.payload.query != "string")
        throw new Error(`"${t.type}" message payload expects the 'query' property to be a string, but got ${Qr(t.payload.query)}`);
      if (t.payload.variables != null && !ka(t.payload.variables))
        throw new Error(`"${t.type}" message payload expects the 'variables' property to be a an object or nullish or missing, but got ${Qr(t.payload.variables)}`);
      if (t.payload.operationName != null && Qr(t.payload.operationName) !== "string")
        throw new Error(`"${t.type}" message payload expects the 'operationName' property to be a string or nullish or missing, but got ${Qr(t.payload.operationName)}`);
      if (t.payload.extensions != null && !ka(t.payload.extensions))
        throw new Error(`"${t.type}" message payload expects the 'extensions' property to be a an object or nullish or missing, but got ${Qr(t.payload.extensions)}`);
      break;
    }
    case wr.Next: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${Qr(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      if (!ka(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an object, but got ${Qr(t.payload)}`);
      break;
    }
    case wr.Error: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${Qr(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      if (!Uk(t.payload))
        throw new Error(`"${t.type}" message expects the 'payload' property to be an array of GraphQL errors, but got ${JSON.stringify(t.payload)}`);
      break;
    }
    case wr.Complete: {
      if (typeof t.id != "string")
        throw new Error(`"${t.type}" message expects the 'id' property to be a string, but got ${Qr(t.id)}`);
      if (!t.id)
        throw new Error(`"${t.type}" message requires a non-empty 'id' property`);
      break;
    }
    default:
      throw new Error(`Invalid message 'type' property "${t.type}"`);
  }
  return t;
}
function Fk(t, e) {
  return X4(typeof t == "string" ? JSON.parse(t, e) : t);
}
function Bo(t, e) {
  return X4(t), JSON.stringify(t, e);
}
var js = function(t) {
  return this instanceof js ? (this.v = t, this) : new js(t);
}, qk = function(t, e, r) {
  if (!Symbol.asyncIterator)
    throw new TypeError("Symbol.asyncIterator is not defined.");
  var i = r.apply(t, e || []), f, a = [];
  return f = {}, l("next"), l("throw"), l("return"), f[Symbol.asyncIterator] = function() {
    return this;
  }, f;
  function l(M) {
    i[M] && (f[M] = function(S) {
      return new Promise(function(E, A) {
        a.push([M, S, E, A]) > 1 || d(M, S);
      });
    });
  }
  function d(M, S) {
    try {
      v(i[M](S));
    } catch (E) {
      w(a[0][3], E);
    }
  }
  function v(M) {
    M.value instanceof js ? Promise.resolve(M.value.v).then(m, h) : w(a[0][2], M);
  }
  function m(M) {
    d("next", M);
  }
  function h(M) {
    d("throw", M);
  }
  function w(M, S) {
    M(S), a.shift(), a.length && d(a[0][0], a[0][1]);
  }
};
function zk(t) {
  const {
    url: e,
    connectionParams: r,
    lazy: i = !0,
    onNonLazyError: f = console.error,
    lazyCloseTimeout: a = 0,
    keepAlive: l = 0,
    disablePong: d,
    connectionAckWaitTimeout: v = 0,
    retryAttempts: m = 5,
    retryWait: h = async function(g) {
      let b = 1e3;
      for (let _ = 0; _ < g; _++)
        b *= 2;
      await new Promise((_) => setTimeout(_, b + // add random timeout from 300ms to 3s
      Math.floor(Math.random() * 2700 + 300)));
    },
    shouldRetry: w = Pd,
    isFatalConnectionProblem: M,
    on: S,
    webSocketImpl: E,
    /**
     * Generates a v4 UUID to be used as the ID using `Math`
     * as the random number generator. Supply your own generator
     * in case you need more uniqueness.
     *
     * Reference: https://gist.github.com/jed/982883
     */
    generateID: A = function() {
      return "xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx".replace(/[xy]/g, (g) => {
        const b = Math.random() * 16 | 0;
        return (g == "x" ? b : b & 3 | 8).toString(16);
      });
    },
    jsonMessageReplacer: B,
    jsonMessageReviver: k
  } = t;
  let C;
  if (E) {
    if (!$k(E))
      throw new Error("Invalid WebSocket implementation provided");
    C = E;
  } else
    typeof WebSocket < "u" ? C = WebSocket : typeof Gi < "u" ? C = Gi.WebSocket || // @ts-expect-error: Support more browsers
    Gi.MozWebSocket : typeof window < "u" && (C = window.WebSocket || // @ts-expect-error: Support more browsers
    window.MozWebSocket);
  if (!C)
    throw new Error("WebSocket implementation missing; on Node you can `import WebSocket from 'ws';` and pass `webSocketImpl: WebSocket` to `createClient`");
  const I = C, O = (() => {
    const c = /* @__PURE__ */ (() => {
      const b = {};
      return {
        on(_, p) {
          return b[_] = p, () => {
            delete b[_];
          };
        },
        emit(_) {
          var p;
          "id" in _ && ((p = b[_.id]) === null || p === void 0 || p.call(b, _));
        }
      };
    })(), g = {
      connecting: S != null && S.connecting ? [S.connecting] : [],
      opened: S != null && S.opened ? [S.opened] : [],
      connected: S != null && S.connected ? [S.connected] : [],
      ping: S != null && S.ping ? [S.ping] : [],
      pong: S != null && S.pong ? [S.pong] : [],
      message: S != null && S.message ? [c.emit, S.message] : [c.emit],
      closed: S != null && S.closed ? [S.closed] : [],
      error: S != null && S.error ? [S.error] : []
    };
    return {
      onMessage: c.on,
      on(b, _) {
        const p = g[b];
        return p.push(_), () => {
          p.splice(p.indexOf(_), 1);
        };
      },
      emit(b, ..._) {
        for (const p of [...g[b]])
          p(..._);
      }
    };
  })();
  function q(c) {
    const g = [
      // errors are fatal and more critical than close events, throw them first
      O.on("error", (b) => {
        g.forEach((_) => _()), c(b);
      }),
      // closes can be graceful and not fatal, throw them second (if error didnt throw)
      O.on("closed", (b) => {
        g.forEach((_) => _()), c(b);
      })
    ];
  }
  let $, ae = 0, he, te = !1, Ee = 0, x = !1;
  async function n() {
    clearTimeout(he);
    const [c, g] = await ($ ?? ($ = new Promise((p, s) => (async () => {
      if (te) {
        if (await h(Ee), !ae)
          return $ = void 0, s({ code: 1e3, reason: "All Subscriptions Gone" });
        Ee++;
      }
      O.emit("connecting", te);
      const y = new I(typeof e == "function" ? await e() : e, Lk);
      let T, P;
      function z() {
        isFinite(l) && l > 0 && (clearTimeout(P), P = setTimeout(() => {
          y.readyState === I.OPEN && (y.send(Bo({ type: wr.Ping })), O.emit("ping", !1, void 0));
        }, l));
      }
      q((Z) => {
        $ = void 0, clearTimeout(T), clearTimeout(P), s(Z), Z instanceof Zy && (y.close(4499, "Terminated"), y.onerror = null, y.onclose = null);
      }), y.onerror = (Z) => O.emit("error", Z), y.onclose = (Z) => O.emit("closed", Z), y.onopen = async () => {
        try {
          O.emit("opened", y);
          const Z = typeof r == "function" ? await r() : r;
          if (y.readyState !== I.OPEN)
            return;
          y.send(Bo(Z ? {
            type: wr.ConnectionInit,
            payload: Z
          } : {
            type: wr.ConnectionInit
            // payload is completely absent if not provided
          }, B)), isFinite(v) && v > 0 && (T = setTimeout(() => {
            y.close(fn.ConnectionAcknowledgementTimeout, "Connection acknowledgement timeout");
          }, v)), z();
        } catch (Z) {
          O.emit("error", Z), y.close(fn.InternalClientError, Ky(Z instanceof Error ? Z.message : new Error(Z).message, "Internal client error"));
        }
      };
      let J = !1;
      y.onmessage = ({ data: Z }) => {
        try {
          const F = Fk(Z, k);
          if (O.emit("message", F), F.type === "ping" || F.type === "pong") {
            O.emit(F.type, !0, F.payload), F.type === "pong" ? z() : d || (y.send(Bo(F.payload ? {
              type: wr.Pong,
              payload: F.payload
            } : {
              type: wr.Pong
              // payload is completely absent if not provided
            })), O.emit("pong", !1, F.payload));
            return;
          }
          if (J)
            return;
          if (F.type !== wr.ConnectionAck)
            throw new Error(`First message cannot be of type ${F.type}`);
          clearTimeout(T), J = !0, O.emit("connected", y, F.payload, te), te = !1, Ee = 0, p([
            y,
            new Promise((ee, re) => q(re))
          ]);
        } catch (F) {
          y.onmessage = null, O.emit("error", F), y.close(fn.BadResponse, Ky(F instanceof Error ? F.message : new Error(F).message, "Bad response"));
        }
      };
    })())));
    c.readyState === I.CLOSING && await g;
    let b = () => {
    };
    const _ = new Promise((p) => b = p);
    return [
      c,
      b,
      Promise.race([
        // wait for
        _.then(() => {
          if (!ae) {
            const p = () => c.close(1e3, "Normal Closure");
            isFinite(a) && a > 0 ? he = setTimeout(() => {
              c.readyState === I.OPEN && p();
            }, a) : p();
          }
        }),
        // or
        g
      ])
    ];
  }
  function o(c) {
    if (Pd(c) && (jk(c.code) || [
      fn.InternalServerError,
      fn.InternalClientError,
      fn.BadRequest,
      fn.BadResponse,
      fn.Unauthorized,
      // CloseCode.Forbidden, might grant access out after retry
      fn.SubprotocolNotAcceptable,
      // CloseCode.ConnectionInitialisationTimeout, might not time out after retry
      // CloseCode.ConnectionAcknowledgementTimeout, might not time out after retry
      fn.SubscriberAlreadyExists,
      fn.TooManyInitialisationRequests
      // 4499, // Terminated, probably because the socket froze, we want to retry
    ].includes(c.code)))
      throw c;
    if (x)
      return !1;
    if (Pd(c) && c.code === 1e3)
      return ae > 0;
    if (!m || Ee >= m || !w(c) || M != null && M(c))
      throw c;
    return te = !0;
  }
  i || (async () => {
    for (ae++; ; )
      try {
        const [, , c] = await n();
        await c;
      } catch (c) {
        try {
          if (!o(c))
            return;
        } catch (g) {
          return f == null ? void 0 : f(g);
        }
      }
  })();
  function u(c, g) {
    const b = A(c);
    let _ = !1, p = !1, s = () => {
      ae--, _ = !0;
    };
    return (async () => {
      for (ae++; ; )
        try {
          const [y, T, P] = await n();
          if (_)
            return T();
          const z = O.onMessage(b, (J) => {
            switch (J.type) {
              case wr.Next: {
                g.next(J.payload);
                return;
              }
              case wr.Error: {
                p = !0, _ = !0, g.error(J.payload), s();
                return;
              }
              case wr.Complete: {
                _ = !0, s();
                return;
              }
            }
          });
          y.send(Bo({
            id: b,
            type: wr.Subscribe,
            payload: c
          }, B)), s = () => {
            !_ && y.readyState === I.OPEN && y.send(Bo({
              id: b,
              type: wr.Complete
            }, B)), ae--, _ = !0, T();
          }, await P.finally(z);
          return;
        } catch (y) {
          if (!o(y))
            return;
        }
    })().then(() => {
      p || g.complete();
    }).catch((y) => {
      g.error(y);
    }), () => {
      _ || s();
    };
  }
  return {
    on: O.on,
    subscribe: u,
    iterate(c) {
      const g = [], b = {
        done: !1,
        error: null,
        resolve: () => {
        }
      }, _ = u(c, {
        next(s) {
          g.push(s), b.resolve();
        },
        error(s) {
          b.done = !0, b.error = s, b.resolve();
        },
        complete() {
          b.done = !0, b.resolve();
        }
      }), p = function() {
        return qk(this, arguments, function* () {
          for (; ; ) {
            for (g.length || (yield js(new Promise((T) => b.resolve = T))); g.length; )
              yield yield js(g.shift());
            if (b.error)
              throw b.error;
            if (b.done)
              return yield js(void 0);
          }
        });
      }();
      return p.throw = async (s) => (b.done || (b.done = !0, b.error = s, b.resolve()), { done: !0, value: void 0 }), p.return = async () => (_(), { done: !0, value: void 0 }), p;
    },
    async dispose() {
      if (x = !0, $) {
        const [c] = await $;
        c.close(1e3, "Normal Closure");
      }
    },
    terminate() {
      $ && O.emit("closed", new Zy());
    }
  };
}
class Zy extends Error {
  constructor() {
    super(...arguments), this.name = "TerminatedCloseEvent", this.message = "4499: Terminated", this.code = 4499, this.reason = "Terminated", this.wasClean = !1;
  }
}
function Pd(t) {
  return ka(t) && "code" in t && "reason" in t;
}
function jk(t) {
  return [
    1e3,
    1001,
    1006,
    1005,
    1012,
    1013,
    1014
    // Bad Gateway
  ].includes(t) ? !1 : t >= 1e3 && t <= 1999;
}
function $k(t) {
  return typeof t == "function" && "constructor" in t && "CLOSED" in t && "CLOSING" in t && "CONNECTING" in t && "OPEN" in t;
}
const Vk = "EVM", e8 = "EQAzKpZeZBpahP5eUsbU7VE9yRkNZh5VjL-RLnsdMxk24Ele", t8 = "0xA90Da9e3c71DDFcC2D793F80029aCBd21A4A0Db6", qf = "0x17BBBa7a601D562eDD32bEb56cECe38C02417B95", Hk = "https://gagarin.world/bridge-service/graphql", Wk = "wss://gagarin.world/bridge-service/graphql", r8 = "EQAInbqbLa_SRMLnOZKaRWpNQFGe62-1a3CxhUeRcqestXzS", Kk = "https://toncenter.com/api/v2/jsonRPC", Zk = "ad3655c36c502d2929fdc3f9a73add41579674a770d024e2b3ea519be431d421", Gk = D4(!1), Qk = Ln`
  extend type Query {
    isRefetchRequired: Boolean!
  }
`, Yk = {
  Query: {
    isRefetchRequired: () => Gk()
  }
}, Jk = Z5(Ln`
  ${Qk}
`), Xk = {
  ...Yk
}, eT = Hk, tT = Wk, Gy = new k4({
  uri: eT,
  headers: {
    // authorization: 'Bearer YOUR_TOKEN'
  }
}), Qy = new Dk(
  zk({
    url: tT,
    retryAttempts: 5
  })
), rT = Qy ? hA(
  ({ query: t }) => {
    const e = oo(t);
    return e.kind === "OperationDefinition" && e.operation === "subscription";
  },
  Qy,
  Gy
) : Gy, nT = new W4({
  link: rT,
  cache: new j4(),
  resolvers: Xk,
  typeDefs: Jk
}), n8 = BM(void 0);
function im() {
  const t = IM(n8);
  if (!t)
    throw new Error("useError must be used within an ErrorProvider");
  return t;
}
function iT({ children: t }) {
  const [e, r] = Ei("");
  return /* @__PURE__ */ tt.jsx(n8.Provider, { value: { errorMessage: e, setErrorMessage: r }, children: t });
}
const i8 = {};
var a8 = /* @__PURE__ */ ((t) => (t.Pulled = "PULLED", t.Pushed = "PUSHED", t))(a8 || {});
Ln`
    query GetBridgeTransfer($where: BridgeTransferWhereUniqueInput!) {
  bridgeTransfer(where: $where) {
    id
    amount
    externalId
    payloadHash
    receiverAddr
    senderAddr
    signature
    status
    pushTxTimestamp
    pushTxHash
    pullTxTimestamp
    pullTxHash
    createdAt
    updatedAt
  }
}
    `;
const aT = Ln`
    query GetBridgeTransfers($where: BridgeTransferWhereInput, $orderBy: [BridgeTransferOrderByWithRelationInput!], $cursor: BridgeTransferWhereUniqueInput, $take: Int, $skip: Int, $distinct: [BridgeTransferScalarFieldEnum!]) {
  bridgeTransfers(
    where: $where
    orderBy: $orderBy
    cursor: $cursor
    take: $take
    skip: $skip
    distinct: $distinct
  ) {
    id
    amount
    externalId
    payloadHash
    receiverAddr
    senderAddr
    signature
    status
    pushTxTimestamp
    pushTxHash
    pullTxTimestamp
    pullTxHash
    createdAt
    updatedAt
  }
}
    `;
function sT(t) {
  const e = { ...i8, ...t };
  return Ck(aT, e);
}
Ln`
    query GetBridgeTransfersCount {
  bridgeTransfersCount
}
    `;
const oT = Ln`
    subscription BridgeTransferAdded($senderAddr: String!) {
  BRIDGE_TRANSFER_ADDED(senderAddr: $senderAddr) {
    id
    amount
    externalId
    payloadHash
    receiverAddr
    senderAddr
    signature
    status
    pushTxTimestamp
    pushTxHash
    pullTxTimestamp
    pullTxHash
    createdAt
    updatedAt
  }
}
    `;
function fT(t) {
  const e = { ...i8, ...t };
  return Pk(oT, e);
}
var At = {}, Ar = {}, Yl = {};
Yl.byteLength = cT;
Yl.toByteArray = hT;
Yl.fromByteArray = mT;
var Zn = [], xn = [], uT = typeof Uint8Array < "u" ? Uint8Array : Array, Od = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for (var bs = 0, lT = Od.length; bs < lT; ++bs)
  Zn[bs] = Od[bs], xn[Od.charCodeAt(bs)] = bs;
xn[45] = 62;
xn[95] = 63;
function s8(t) {
  var e = t.length;
  if (e % 4 > 0)
    throw new Error("Invalid string. Length must be a multiple of 4");
  var r = t.indexOf("=");
  r === -1 && (r = e);
  var i = r === e ? 0 : 4 - r % 4;
  return [r, i];
}
function cT(t) {
  var e = s8(t), r = e[0], i = e[1];
  return (r + i) * 3 / 4 - i;
}
function dT(t, e, r) {
  return (e + r) * 3 / 4 - r;
}
function hT(t) {
  var e, r = s8(t), i = r[0], f = r[1], a = new uT(dT(t, i, f)), l = 0, d = f > 0 ? i - 4 : i, v;
  for (v = 0; v < d; v += 4)
    e = xn[t.charCodeAt(v)] << 18 | xn[t.charCodeAt(v + 1)] << 12 | xn[t.charCodeAt(v + 2)] << 6 | xn[t.charCodeAt(v + 3)], a[l++] = e >> 16 & 255, a[l++] = e >> 8 & 255, a[l++] = e & 255;
  return f === 2 && (e = xn[t.charCodeAt(v)] << 2 | xn[t.charCodeAt(v + 1)] >> 4, a[l++] = e & 255), f === 1 && (e = xn[t.charCodeAt(v)] << 10 | xn[t.charCodeAt(v + 1)] << 4 | xn[t.charCodeAt(v + 2)] >> 2, a[l++] = e >> 8 & 255, a[l++] = e & 255), a;
}
function pT(t) {
  return Zn[t >> 18 & 63] + Zn[t >> 12 & 63] + Zn[t >> 6 & 63] + Zn[t & 63];
}
function vT(t, e, r) {
  for (var i, f = [], a = e; a < r; a += 3)
    i = (t[a] << 16 & 16711680) + (t[a + 1] << 8 & 65280) + (t[a + 2] & 255), f.push(pT(i));
  return f.join("");
}
function mT(t) {
  for (var e, r = t.length, i = r % 3, f = [], a = 16383, l = 0, d = r - i; l < d; l += a)
    f.push(vT(t, l, l + a > d ? d : l + a));
  return i === 1 ? (e = t[r - 1], f.push(
    Zn[e >> 2] + Zn[e << 4 & 63] + "=="
  )) : i === 2 && (e = (t[r - 2] << 8) + t[r - 1], f.push(
    Zn[e >> 10] + Zn[e >> 4 & 63] + Zn[e << 2 & 63] + "="
  )), f.join("");
}
var am = {};
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */
am.read = function(t, e, r, i, f) {
  var a, l, d = f * 8 - i - 1, v = (1 << d) - 1, m = v >> 1, h = -7, w = r ? f - 1 : 0, M = r ? -1 : 1, S = t[e + w];
  for (w += M, a = S & (1 << -h) - 1, S >>= -h, h += d; h > 0; a = a * 256 + t[e + w], w += M, h -= 8)
    ;
  for (l = a & (1 << -h) - 1, a >>= -h, h += i; h > 0; l = l * 256 + t[e + w], w += M, h -= 8)
    ;
  if (a === 0)
    a = 1 - m;
  else {
    if (a === v)
      return l ? NaN : (S ? -1 : 1) * (1 / 0);
    l = l + Math.pow(2, i), a = a - m;
  }
  return (S ? -1 : 1) * l * Math.pow(2, a - i);
};
am.write = function(t, e, r, i, f, a) {
  var l, d, v, m = a * 8 - f - 1, h = (1 << m) - 1, w = h >> 1, M = f === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0, S = i ? 0 : a - 1, E = i ? 1 : -1, A = e < 0 || e === 0 && 1 / e < 0 ? 1 : 0;
  for (e = Math.abs(e), isNaN(e) || e === 1 / 0 ? (d = isNaN(e) ? 1 : 0, l = h) : (l = Math.floor(Math.log(e) / Math.LN2), e * (v = Math.pow(2, -l)) < 1 && (l--, v *= 2), l + w >= 1 ? e += M / v : e += M * Math.pow(2, 1 - w), e * v >= 2 && (l++, v /= 2), l + w >= h ? (d = 0, l = h) : l + w >= 1 ? (d = (e * v - 1) * Math.pow(2, f), l = l + w) : (d = e * Math.pow(2, w - 1) * Math.pow(2, f), l = 0)); f >= 8; t[r + S] = d & 255, S += E, d /= 256, f -= 8)
    ;
  for (l = l << f | d, m += f; m > 0; t[r + S] = l & 255, S += E, l /= 256, m -= 8)
    ;
  t[r + S - E] |= A * 128;
};
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */
(function(t) {
  const e = Yl, r = am, i = typeof Symbol == "function" && typeof Symbol.for == "function" ? Symbol.for("nodejs.util.inspect.custom") : null;
  t.Buffer = h, t.SlowBuffer = q, t.INSPECT_MAX_BYTES = 50;
  const f = 2147483647;
  t.kMaxLength = f;
  const { Uint8Array: a, ArrayBuffer: l, SharedArrayBuffer: d } = globalThis;
  h.TYPED_ARRAY_SUPPORT = v(), !h.TYPED_ARRAY_SUPPORT && typeof console < "u" && typeof console.error == "function" && console.error(
    "This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support."
  );
  function v() {
    try {
      const N = new a(1), R = { foo: function() {
        return 42;
      } };
      return Object.setPrototypeOf(R, a.prototype), Object.setPrototypeOf(N, R), N.foo() === 42;
    } catch {
      return !1;
    }
  }
  Object.defineProperty(h.prototype, "parent", {
    enumerable: !0,
    get: function() {
      if (h.isBuffer(this))
        return this.buffer;
    }
  }), Object.defineProperty(h.prototype, "offset", {
    enumerable: !0,
    get: function() {
      if (h.isBuffer(this))
        return this.byteOffset;
    }
  });
  function m(N) {
    if (N > f)
      throw new RangeError('The value "' + N + '" is invalid for option "size"');
    const R = new a(N);
    return Object.setPrototypeOf(R, h.prototype), R;
  }
  function h(N, R, L) {
    if (typeof N == "number") {
      if (typeof R == "string")
        throw new TypeError(
          'The "string" argument must be of type string. Received type number'
        );
      return E(N);
    }
    return w(N, R, L);
  }
  h.poolSize = 8192;
  function w(N, R, L) {
    if (typeof N == "string")
      return A(N, R);
    if (l.isView(N))
      return k(N);
    if (N == null)
      throw new TypeError(
        "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof N
      );
    if (oe(N, l) || N && oe(N.buffer, l) || typeof d < "u" && (oe(N, d) || N && oe(N.buffer, d)))
      return C(N, R, L);
    if (typeof N == "number")
      throw new TypeError(
        'The "value" argument must not be of type number. Received type number'
      );
    const V = N.valueOf && N.valueOf();
    if (V != null && V !== N)
      return h.from(V, R, L);
    const ne = I(N);
    if (ne)
      return ne;
    if (typeof Symbol < "u" && Symbol.toPrimitive != null && typeof N[Symbol.toPrimitive] == "function")
      return h.from(N[Symbol.toPrimitive]("string"), R, L);
    throw new TypeError(
      "The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof N
    );
  }
  h.from = function(N, R, L) {
    return w(N, R, L);
  }, Object.setPrototypeOf(h.prototype, a.prototype), Object.setPrototypeOf(h, a);
  function M(N) {
    if (typeof N != "number")
      throw new TypeError('"size" argument must be of type number');
    if (N < 0)
      throw new RangeError('The value "' + N + '" is invalid for option "size"');
  }
  function S(N, R, L) {
    return M(N), N <= 0 ? m(N) : R !== void 0 ? typeof L == "string" ? m(N).fill(R, L) : m(N).fill(R) : m(N);
  }
  h.alloc = function(N, R, L) {
    return S(N, R, L);
  };
  function E(N) {
    return M(N), m(N < 0 ? 0 : O(N) | 0);
  }
  h.allocUnsafe = function(N) {
    return E(N);
  }, h.allocUnsafeSlow = function(N) {
    return E(N);
  };
  function A(N, R) {
    if ((typeof R != "string" || R === "") && (R = "utf8"), !h.isEncoding(R))
      throw new TypeError("Unknown encoding: " + R);
    const L = $(N, R) | 0;
    let V = m(L);
    const ne = V.write(N, R);
    return ne !== L && (V = V.slice(0, ne)), V;
  }
  function B(N) {
    const R = N.length < 0 ? 0 : O(N.length) | 0, L = m(R);
    for (let V = 0; V < R; V += 1)
      L[V] = N[V] & 255;
    return L;
  }
  function k(N) {
    if (oe(N, a)) {
      const R = new a(N);
      return C(R.buffer, R.byteOffset, R.byteLength);
    }
    return B(N);
  }
  function C(N, R, L) {
    if (R < 0 || N.byteLength < R)
      throw new RangeError('"offset" is outside of buffer bounds');
    if (N.byteLength < R + (L || 0))
      throw new RangeError('"length" is outside of buffer bounds');
    let V;
    return R === void 0 && L === void 0 ? V = new a(N) : L === void 0 ? V = new a(N, R) : V = new a(N, R, L), Object.setPrototypeOf(V, h.prototype), V;
  }
  function I(N) {
    if (h.isBuffer(N)) {
      const R = O(N.length) | 0, L = m(R);
      return L.length === 0 || N.copy(L, 0, 0, R), L;
    }
    if (N.length !== void 0)
      return typeof N.length != "number" || le(N.length) ? m(0) : B(N);
    if (N.type === "Buffer" && Array.isArray(N.data))
      return B(N.data);
  }
  function O(N) {
    if (N >= f)
      throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + f.toString(16) + " bytes");
    return N | 0;
  }
  function q(N) {
    return +N != N && (N = 0), h.alloc(+N);
  }
  h.isBuffer = function(R) {
    return R != null && R._isBuffer === !0 && R !== h.prototype;
  }, h.compare = function(R, L) {
    if (oe(R, a) && (R = h.from(R, R.offset, R.byteLength)), oe(L, a) && (L = h.from(L, L.offset, L.byteLength)), !h.isBuffer(R) || !h.isBuffer(L))
      throw new TypeError(
        'The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array'
      );
    if (R === L)
      return 0;
    let V = R.length, ne = L.length;
    for (let Se = 0, ue = Math.min(V, ne); Se < ue; ++Se)
      if (R[Se] !== L[Se]) {
        V = R[Se], ne = L[Se];
        break;
      }
    return V < ne ? -1 : ne < V ? 1 : 0;
  }, h.isEncoding = function(R) {
    switch (String(R).toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "latin1":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
        return !0;
      default:
        return !1;
    }
  }, h.concat = function(R, L) {
    if (!Array.isArray(R))
      throw new TypeError('"list" argument must be an Array of Buffers');
    if (R.length === 0)
      return h.alloc(0);
    let V;
    if (L === void 0)
      for (L = 0, V = 0; V < R.length; ++V)
        L += R[V].length;
    const ne = h.allocUnsafe(L);
    let Se = 0;
    for (V = 0; V < R.length; ++V) {
      let ue = R[V];
      if (oe(ue, a))
        Se + ue.length > ne.length ? (h.isBuffer(ue) || (ue = h.from(ue)), ue.copy(ne, Se)) : a.prototype.set.call(
          ne,
          ue,
          Se
        );
      else if (h.isBuffer(ue))
        ue.copy(ne, Se);
      else
        throw new TypeError('"list" argument must be an Array of Buffers');
      Se += ue.length;
    }
    return ne;
  };
  function $(N, R) {
    if (h.isBuffer(N))
      return N.length;
    if (l.isView(N) || oe(N, l))
      return N.byteLength;
    if (typeof N != "string")
      throw new TypeError(
        'The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof N
      );
    const L = N.length, V = arguments.length > 2 && arguments[2] === !0;
    if (!V && L === 0)
      return 0;
    let ne = !1;
    for (; ; )
      switch (R) {
        case "ascii":
        case "latin1":
        case "binary":
          return L;
        case "utf8":
        case "utf-8":
          return St(N).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return L * 2;
        case "hex":
          return L >>> 1;
        case "base64":
          return Et(N).length;
        default:
          if (ne)
            return V ? -1 : St(N).length;
          R = ("" + R).toLowerCase(), ne = !0;
      }
  }
  h.byteLength = $;
  function ae(N, R, L) {
    let V = !1;
    if ((R === void 0 || R < 0) && (R = 0), R > this.length || ((L === void 0 || L > this.length) && (L = this.length), L <= 0) || (L >>>= 0, R >>>= 0, L <= R))
      return "";
    for (N || (N = "utf8"); ; )
      switch (N) {
        case "hex":
          return T(this, R, L);
        case "utf8":
        case "utf-8":
          return b(this, R, L);
        case "ascii":
          return s(this, R, L);
        case "latin1":
        case "binary":
          return y(this, R, L);
        case "base64":
          return g(this, R, L);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return P(this, R, L);
        default:
          if (V)
            throw new TypeError("Unknown encoding: " + N);
          N = (N + "").toLowerCase(), V = !0;
      }
  }
  h.prototype._isBuffer = !0;
  function he(N, R, L) {
    const V = N[R];
    N[R] = N[L], N[L] = V;
  }
  h.prototype.swap16 = function() {
    const R = this.length;
    if (R % 2 !== 0)
      throw new RangeError("Buffer size must be a multiple of 16-bits");
    for (let L = 0; L < R; L += 2)
      he(this, L, L + 1);
    return this;
  }, h.prototype.swap32 = function() {
    const R = this.length;
    if (R % 4 !== 0)
      throw new RangeError("Buffer size must be a multiple of 32-bits");
    for (let L = 0; L < R; L += 4)
      he(this, L, L + 3), he(this, L + 1, L + 2);
    return this;
  }, h.prototype.swap64 = function() {
    const R = this.length;
    if (R % 8 !== 0)
      throw new RangeError("Buffer size must be a multiple of 64-bits");
    for (let L = 0; L < R; L += 8)
      he(this, L, L + 7), he(this, L + 1, L + 6), he(this, L + 2, L + 5), he(this, L + 3, L + 4);
    return this;
  }, h.prototype.toString = function() {
    const R = this.length;
    return R === 0 ? "" : arguments.length === 0 ? b(this, 0, R) : ae.apply(this, arguments);
  }, h.prototype.toLocaleString = h.prototype.toString, h.prototype.equals = function(R) {
    if (!h.isBuffer(R))
      throw new TypeError("Argument must be a Buffer");
    return this === R ? !0 : h.compare(this, R) === 0;
  }, h.prototype.inspect = function() {
    let R = "";
    const L = t.INSPECT_MAX_BYTES;
    return R = this.toString("hex", 0, L).replace(/(.{2})/g, "$1 ").trim(), this.length > L && (R += " ... "), "<Buffer " + R + ">";
  }, i && (h.prototype[i] = h.prototype.inspect), h.prototype.compare = function(R, L, V, ne, Se) {
    if (oe(R, a) && (R = h.from(R, R.offset, R.byteLength)), !h.isBuffer(R))
      throw new TypeError(
        'The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof R
      );
    if (L === void 0 && (L = 0), V === void 0 && (V = R ? R.length : 0), ne === void 0 && (ne = 0), Se === void 0 && (Se = this.length), L < 0 || V > R.length || ne < 0 || Se > this.length)
      throw new RangeError("out of range index");
    if (ne >= Se && L >= V)
      return 0;
    if (ne >= Se)
      return -1;
    if (L >= V)
      return 1;
    if (L >>>= 0, V >>>= 0, ne >>>= 0, Se >>>= 0, this === R)
      return 0;
    let ue = Se - ne, xe = V - L;
    const He = Math.min(ue, xe), be = this.slice(ne, Se), Ie = R.slice(L, V);
    for (let rt = 0; rt < He; ++rt)
      if (be[rt] !== Ie[rt]) {
        ue = be[rt], xe = Ie[rt];
        break;
      }
    return ue < xe ? -1 : xe < ue ? 1 : 0;
  };
  function te(N, R, L, V, ne) {
    if (N.length === 0)
      return -1;
    if (typeof L == "string" ? (V = L, L = 0) : L > 2147483647 ? L = 2147483647 : L < -2147483648 && (L = -2147483648), L = +L, le(L) && (L = ne ? 0 : N.length - 1), L < 0 && (L = N.length + L), L >= N.length) {
      if (ne)
        return -1;
      L = N.length - 1;
    } else if (L < 0)
      if (ne)
        L = 0;
      else
        return -1;
    if (typeof R == "string" && (R = h.from(R, V)), h.isBuffer(R))
      return R.length === 0 ? -1 : Ee(N, R, L, V, ne);
    if (typeof R == "number")
      return R = R & 255, typeof a.prototype.indexOf == "function" ? ne ? a.prototype.indexOf.call(N, R, L) : a.prototype.lastIndexOf.call(N, R, L) : Ee(N, [R], L, V, ne);
    throw new TypeError("val must be string, number or Buffer");
  }
  function Ee(N, R, L, V, ne) {
    let Se = 1, ue = N.length, xe = R.length;
    if (V !== void 0 && (V = String(V).toLowerCase(), V === "ucs2" || V === "ucs-2" || V === "utf16le" || V === "utf-16le")) {
      if (N.length < 2 || R.length < 2)
        return -1;
      Se = 2, ue /= 2, xe /= 2, L /= 2;
    }
    function He(Ie, rt) {
      return Se === 1 ? Ie[rt] : Ie.readUInt16BE(rt * Se);
    }
    let be;
    if (ne) {
      let Ie = -1;
      for (be = L; be < ue; be++)
        if (He(N, be) === He(R, Ie === -1 ? 0 : be - Ie)) {
          if (Ie === -1 && (Ie = be), be - Ie + 1 === xe)
            return Ie * Se;
        } else
          Ie !== -1 && (be -= be - Ie), Ie = -1;
    } else
      for (L + xe > ue && (L = ue - xe), be = L; be >= 0; be--) {
        let Ie = !0;
        for (let rt = 0; rt < xe; rt++)
          if (He(N, be + rt) !== He(R, rt)) {
            Ie = !1;
            break;
          }
        if (Ie)
          return be;
      }
    return -1;
  }
  h.prototype.includes = function(R, L, V) {
    return this.indexOf(R, L, V) !== -1;
  }, h.prototype.indexOf = function(R, L, V) {
    return te(this, R, L, V, !0);
  }, h.prototype.lastIndexOf = function(R, L, V) {
    return te(this, R, L, V, !1);
  };
  function x(N, R, L, V) {
    L = Number(L) || 0;
    const ne = N.length - L;
    V ? (V = Number(V), V > ne && (V = ne)) : V = ne;
    const Se = R.length;
    V > Se / 2 && (V = Se / 2);
    let ue;
    for (ue = 0; ue < V; ++ue) {
      const xe = parseInt(R.substr(ue * 2, 2), 16);
      if (le(xe))
        return ue;
      N[L + ue] = xe;
    }
    return ue;
  }
  function n(N, R, L, V) {
    return Ue(St(R, N.length - L), N, L, V);
  }
  function o(N, R, L, V) {
    return Ue(Oe(R), N, L, V);
  }
  function u(N, R, L, V) {
    return Ue(Et(R), N, L, V);
  }
  function c(N, R, L, V) {
    return Ue(Fe(R, N.length - L), N, L, V);
  }
  h.prototype.write = function(R, L, V, ne) {
    if (L === void 0)
      ne = "utf8", V = this.length, L = 0;
    else if (V === void 0 && typeof L == "string")
      ne = L, V = this.length, L = 0;
    else if (isFinite(L))
      L = L >>> 0, isFinite(V) ? (V = V >>> 0, ne === void 0 && (ne = "utf8")) : (ne = V, V = void 0);
    else
      throw new Error(
        "Buffer.write(string, encoding, offset[, length]) is no longer supported"
      );
    const Se = this.length - L;
    if ((V === void 0 || V > Se) && (V = Se), R.length > 0 && (V < 0 || L < 0) || L > this.length)
      throw new RangeError("Attempt to write outside buffer bounds");
    ne || (ne = "utf8");
    let ue = !1;
    for (; ; )
      switch (ne) {
        case "hex":
          return x(this, R, L, V);
        case "utf8":
        case "utf-8":
          return n(this, R, L, V);
        case "ascii":
        case "latin1":
        case "binary":
          return o(this, R, L, V);
        case "base64":
          return u(this, R, L, V);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return c(this, R, L, V);
        default:
          if (ue)
            throw new TypeError("Unknown encoding: " + ne);
          ne = ("" + ne).toLowerCase(), ue = !0;
      }
  }, h.prototype.toJSON = function() {
    return {
      type: "Buffer",
      data: Array.prototype.slice.call(this._arr || this, 0)
    };
  };
  function g(N, R, L) {
    return R === 0 && L === N.length ? e.fromByteArray(N) : e.fromByteArray(N.slice(R, L));
  }
  function b(N, R, L) {
    L = Math.min(N.length, L);
    const V = [];
    let ne = R;
    for (; ne < L; ) {
      const Se = N[ne];
      let ue = null, xe = Se > 239 ? 4 : Se > 223 ? 3 : Se > 191 ? 2 : 1;
      if (ne + xe <= L) {
        let He, be, Ie, rt;
        switch (xe) {
          case 1:
            Se < 128 && (ue = Se);
            break;
          case 2:
            He = N[ne + 1], (He & 192) === 128 && (rt = (Se & 31) << 6 | He & 63, rt > 127 && (ue = rt));
            break;
          case 3:
            He = N[ne + 1], be = N[ne + 2], (He & 192) === 128 && (be & 192) === 128 && (rt = (Se & 15) << 12 | (He & 63) << 6 | be & 63, rt > 2047 && (rt < 55296 || rt > 57343) && (ue = rt));
            break;
          case 4:
            He = N[ne + 1], be = N[ne + 2], Ie = N[ne + 3], (He & 192) === 128 && (be & 192) === 128 && (Ie & 192) === 128 && (rt = (Se & 15) << 18 | (He & 63) << 12 | (be & 63) << 6 | Ie & 63, rt > 65535 && rt < 1114112 && (ue = rt));
        }
      }
      ue === null ? (ue = 65533, xe = 1) : ue > 65535 && (ue -= 65536, V.push(ue >>> 10 & 1023 | 55296), ue = 56320 | ue & 1023), V.push(ue), ne += xe;
    }
    return p(V);
  }
  const _ = 4096;
  function p(N) {
    const R = N.length;
    if (R <= _)
      return String.fromCharCode.apply(String, N);
    let L = "", V = 0;
    for (; V < R; )
      L += String.fromCharCode.apply(
        String,
        N.slice(V, V += _)
      );
    return L;
  }
  function s(N, R, L) {
    let V = "";
    L = Math.min(N.length, L);
    for (let ne = R; ne < L; ++ne)
      V += String.fromCharCode(N[ne] & 127);
    return V;
  }
  function y(N, R, L) {
    let V = "";
    L = Math.min(N.length, L);
    for (let ne = R; ne < L; ++ne)
      V += String.fromCharCode(N[ne]);
    return V;
  }
  function T(N, R, L) {
    const V = N.length;
    (!R || R < 0) && (R = 0), (!L || L < 0 || L > V) && (L = V);
    let ne = "";
    for (let Se = R; Se < L; ++Se)
      ne += ie[N[Se]];
    return ne;
  }
  function P(N, R, L) {
    const V = N.slice(R, L);
    let ne = "";
    for (let Se = 0; Se < V.length - 1; Se += 2)
      ne += String.fromCharCode(V[Se] + V[Se + 1] * 256);
    return ne;
  }
  h.prototype.slice = function(R, L) {
    const V = this.length;
    R = ~~R, L = L === void 0 ? V : ~~L, R < 0 ? (R += V, R < 0 && (R = 0)) : R > V && (R = V), L < 0 ? (L += V, L < 0 && (L = 0)) : L > V && (L = V), L < R && (L = R);
    const ne = this.subarray(R, L);
    return Object.setPrototypeOf(ne, h.prototype), ne;
  };
  function z(N, R, L) {
    if (N % 1 !== 0 || N < 0)
      throw new RangeError("offset is not uint");
    if (N + R > L)
      throw new RangeError("Trying to access beyond buffer length");
  }
  h.prototype.readUintLE = h.prototype.readUIntLE = function(R, L, V) {
    R = R >>> 0, L = L >>> 0, V || z(R, L, this.length);
    let ne = this[R], Se = 1, ue = 0;
    for (; ++ue < L && (Se *= 256); )
      ne += this[R + ue] * Se;
    return ne;
  }, h.prototype.readUintBE = h.prototype.readUIntBE = function(R, L, V) {
    R = R >>> 0, L = L >>> 0, V || z(R, L, this.length);
    let ne = this[R + --L], Se = 1;
    for (; L > 0 && (Se *= 256); )
      ne += this[R + --L] * Se;
    return ne;
  }, h.prototype.readUint8 = h.prototype.readUInt8 = function(R, L) {
    return R = R >>> 0, L || z(R, 1, this.length), this[R];
  }, h.prototype.readUint16LE = h.prototype.readUInt16LE = function(R, L) {
    return R = R >>> 0, L || z(R, 2, this.length), this[R] | this[R + 1] << 8;
  }, h.prototype.readUint16BE = h.prototype.readUInt16BE = function(R, L) {
    return R = R >>> 0, L || z(R, 2, this.length), this[R] << 8 | this[R + 1];
  }, h.prototype.readUint32LE = h.prototype.readUInt32LE = function(R, L) {
    return R = R >>> 0, L || z(R, 4, this.length), (this[R] | this[R + 1] << 8 | this[R + 2] << 16) + this[R + 3] * 16777216;
  }, h.prototype.readUint32BE = h.prototype.readUInt32BE = function(R, L) {
    return R = R >>> 0, L || z(R, 4, this.length), this[R] * 16777216 + (this[R + 1] << 16 | this[R + 2] << 8 | this[R + 3]);
  }, h.prototype.readBigUInt64LE = fe(function(R) {
    R = R >>> 0, Be(R, "offset");
    const L = this[R], V = this[R + 7];
    (L === void 0 || V === void 0) && st(R, this.length - 8);
    const ne = L + this[++R] * 2 ** 8 + this[++R] * 2 ** 16 + this[++R] * 2 ** 24, Se = this[++R] + this[++R] * 2 ** 8 + this[++R] * 2 ** 16 + V * 2 ** 24;
    return BigInt(ne) + (BigInt(Se) << BigInt(32));
  }), h.prototype.readBigUInt64BE = fe(function(R) {
    R = R >>> 0, Be(R, "offset");
    const L = this[R], V = this[R + 7];
    (L === void 0 || V === void 0) && st(R, this.length - 8);
    const ne = L * 2 ** 24 + this[++R] * 2 ** 16 + this[++R] * 2 ** 8 + this[++R], Se = this[++R] * 2 ** 24 + this[++R] * 2 ** 16 + this[++R] * 2 ** 8 + V;
    return (BigInt(ne) << BigInt(32)) + BigInt(Se);
  }), h.prototype.readIntLE = function(R, L, V) {
    R = R >>> 0, L = L >>> 0, V || z(R, L, this.length);
    let ne = this[R], Se = 1, ue = 0;
    for (; ++ue < L && (Se *= 256); )
      ne += this[R + ue] * Se;
    return Se *= 128, ne >= Se && (ne -= Math.pow(2, 8 * L)), ne;
  }, h.prototype.readIntBE = function(R, L, V) {
    R = R >>> 0, L = L >>> 0, V || z(R, L, this.length);
    let ne = L, Se = 1, ue = this[R + --ne];
    for (; ne > 0 && (Se *= 256); )
      ue += this[R + --ne] * Se;
    return Se *= 128, ue >= Se && (ue -= Math.pow(2, 8 * L)), ue;
  }, h.prototype.readInt8 = function(R, L) {
    return R = R >>> 0, L || z(R, 1, this.length), this[R] & 128 ? (255 - this[R] + 1) * -1 : this[R];
  }, h.prototype.readInt16LE = function(R, L) {
    R = R >>> 0, L || z(R, 2, this.length);
    const V = this[R] | this[R + 1] << 8;
    return V & 32768 ? V | 4294901760 : V;
  }, h.prototype.readInt16BE = function(R, L) {
    R = R >>> 0, L || z(R, 2, this.length);
    const V = this[R + 1] | this[R] << 8;
    return V & 32768 ? V | 4294901760 : V;
  }, h.prototype.readInt32LE = function(R, L) {
    return R = R >>> 0, L || z(R, 4, this.length), this[R] | this[R + 1] << 8 | this[R + 2] << 16 | this[R + 3] << 24;
  }, h.prototype.readInt32BE = function(R, L) {
    return R = R >>> 0, L || z(R, 4, this.length), this[R] << 24 | this[R + 1] << 16 | this[R + 2] << 8 | this[R + 3];
  }, h.prototype.readBigInt64LE = fe(function(R) {
    R = R >>> 0, Be(R, "offset");
    const L = this[R], V = this[R + 7];
    (L === void 0 || V === void 0) && st(R, this.length - 8);
    const ne = this[R + 4] + this[R + 5] * 2 ** 8 + this[R + 6] * 2 ** 16 + (V << 24);
    return (BigInt(ne) << BigInt(32)) + BigInt(L + this[++R] * 2 ** 8 + this[++R] * 2 ** 16 + this[++R] * 2 ** 24);
  }), h.prototype.readBigInt64BE = fe(function(R) {
    R = R >>> 0, Be(R, "offset");
    const L = this[R], V = this[R + 7];
    (L === void 0 || V === void 0) && st(R, this.length - 8);
    const ne = (L << 24) + // Overflow
    this[++R] * 2 ** 16 + this[++R] * 2 ** 8 + this[++R];
    return (BigInt(ne) << BigInt(32)) + BigInt(this[++R] * 2 ** 24 + this[++R] * 2 ** 16 + this[++R] * 2 ** 8 + V);
  }), h.prototype.readFloatLE = function(R, L) {
    return R = R >>> 0, L || z(R, 4, this.length), r.read(this, R, !0, 23, 4);
  }, h.prototype.readFloatBE = function(R, L) {
    return R = R >>> 0, L || z(R, 4, this.length), r.read(this, R, !1, 23, 4);
  }, h.prototype.readDoubleLE = function(R, L) {
    return R = R >>> 0, L || z(R, 8, this.length), r.read(this, R, !0, 52, 8);
  }, h.prototype.readDoubleBE = function(R, L) {
    return R = R >>> 0, L || z(R, 8, this.length), r.read(this, R, !1, 52, 8);
  };
  function J(N, R, L, V, ne, Se) {
    if (!h.isBuffer(N))
      throw new TypeError('"buffer" argument must be a Buffer instance');
    if (R > ne || R < Se)
      throw new RangeError('"value" argument is out of bounds');
    if (L + V > N.length)
      throw new RangeError("Index out of range");
  }
  h.prototype.writeUintLE = h.prototype.writeUIntLE = function(R, L, V, ne) {
    if (R = +R, L = L >>> 0, V = V >>> 0, !ne) {
      const xe = Math.pow(2, 8 * V) - 1;
      J(this, R, L, V, xe, 0);
    }
    let Se = 1, ue = 0;
    for (this[L] = R & 255; ++ue < V && (Se *= 256); )
      this[L + ue] = R / Se & 255;
    return L + V;
  }, h.prototype.writeUintBE = h.prototype.writeUIntBE = function(R, L, V, ne) {
    if (R = +R, L = L >>> 0, V = V >>> 0, !ne) {
      const xe = Math.pow(2, 8 * V) - 1;
      J(this, R, L, V, xe, 0);
    }
    let Se = V - 1, ue = 1;
    for (this[L + Se] = R & 255; --Se >= 0 && (ue *= 256); )
      this[L + Se] = R / ue & 255;
    return L + V;
  }, h.prototype.writeUint8 = h.prototype.writeUInt8 = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 1, 255, 0), this[L] = R & 255, L + 1;
  }, h.prototype.writeUint16LE = h.prototype.writeUInt16LE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 2, 65535, 0), this[L] = R & 255, this[L + 1] = R >>> 8, L + 2;
  }, h.prototype.writeUint16BE = h.prototype.writeUInt16BE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 2, 65535, 0), this[L] = R >>> 8, this[L + 1] = R & 255, L + 2;
  }, h.prototype.writeUint32LE = h.prototype.writeUInt32LE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 4, 4294967295, 0), this[L + 3] = R >>> 24, this[L + 2] = R >>> 16, this[L + 1] = R >>> 8, this[L] = R & 255, L + 4;
  }, h.prototype.writeUint32BE = h.prototype.writeUInt32BE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 4, 4294967295, 0), this[L] = R >>> 24, this[L + 1] = R >>> 16, this[L + 2] = R >>> 8, this[L + 3] = R & 255, L + 4;
  };
  function Z(N, R, L, V, ne) {
    Ce(R, V, ne, N, L, 7);
    let Se = Number(R & BigInt(4294967295));
    N[L++] = Se, Se = Se >> 8, N[L++] = Se, Se = Se >> 8, N[L++] = Se, Se = Se >> 8, N[L++] = Se;
    let ue = Number(R >> BigInt(32) & BigInt(4294967295));
    return N[L++] = ue, ue = ue >> 8, N[L++] = ue, ue = ue >> 8, N[L++] = ue, ue = ue >> 8, N[L++] = ue, L;
  }
  function F(N, R, L, V, ne) {
    Ce(R, V, ne, N, L, 7);
    let Se = Number(R & BigInt(4294967295));
    N[L + 7] = Se, Se = Se >> 8, N[L + 6] = Se, Se = Se >> 8, N[L + 5] = Se, Se = Se >> 8, N[L + 4] = Se;
    let ue = Number(R >> BigInt(32) & BigInt(4294967295));
    return N[L + 3] = ue, ue = ue >> 8, N[L + 2] = ue, ue = ue >> 8, N[L + 1] = ue, ue = ue >> 8, N[L] = ue, L + 8;
  }
  h.prototype.writeBigUInt64LE = fe(function(R, L = 0) {
    return Z(this, R, L, BigInt(0), BigInt("0xffffffffffffffff"));
  }), h.prototype.writeBigUInt64BE = fe(function(R, L = 0) {
    return F(this, R, L, BigInt(0), BigInt("0xffffffffffffffff"));
  }), h.prototype.writeIntLE = function(R, L, V, ne) {
    if (R = +R, L = L >>> 0, !ne) {
      const He = Math.pow(2, 8 * V - 1);
      J(this, R, L, V, He - 1, -He);
    }
    let Se = 0, ue = 1, xe = 0;
    for (this[L] = R & 255; ++Se < V && (ue *= 256); )
      R < 0 && xe === 0 && this[L + Se - 1] !== 0 && (xe = 1), this[L + Se] = (R / ue >> 0) - xe & 255;
    return L + V;
  }, h.prototype.writeIntBE = function(R, L, V, ne) {
    if (R = +R, L = L >>> 0, !ne) {
      const He = Math.pow(2, 8 * V - 1);
      J(this, R, L, V, He - 1, -He);
    }
    let Se = V - 1, ue = 1, xe = 0;
    for (this[L + Se] = R & 255; --Se >= 0 && (ue *= 256); )
      R < 0 && xe === 0 && this[L + Se + 1] !== 0 && (xe = 1), this[L + Se] = (R / ue >> 0) - xe & 255;
    return L + V;
  }, h.prototype.writeInt8 = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 1, 127, -128), R < 0 && (R = 255 + R + 1), this[L] = R & 255, L + 1;
  }, h.prototype.writeInt16LE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 2, 32767, -32768), this[L] = R & 255, this[L + 1] = R >>> 8, L + 2;
  }, h.prototype.writeInt16BE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 2, 32767, -32768), this[L] = R >>> 8, this[L + 1] = R & 255, L + 2;
  }, h.prototype.writeInt32LE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 4, 2147483647, -2147483648), this[L] = R & 255, this[L + 1] = R >>> 8, this[L + 2] = R >>> 16, this[L + 3] = R >>> 24, L + 4;
  }, h.prototype.writeInt32BE = function(R, L, V) {
    return R = +R, L = L >>> 0, V || J(this, R, L, 4, 2147483647, -2147483648), R < 0 && (R = 4294967295 + R + 1), this[L] = R >>> 24, this[L + 1] = R >>> 16, this[L + 2] = R >>> 8, this[L + 3] = R & 255, L + 4;
  }, h.prototype.writeBigInt64LE = fe(function(R, L = 0) {
    return Z(this, R, L, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  }), h.prototype.writeBigInt64BE = fe(function(R, L = 0) {
    return F(this, R, L, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
  });
  function ee(N, R, L, V, ne, Se) {
    if (L + V > N.length)
      throw new RangeError("Index out of range");
    if (L < 0)
      throw new RangeError("Index out of range");
  }
  function re(N, R, L, V, ne) {
    return R = +R, L = L >>> 0, ne || ee(N, R, L, 4), r.write(N, R, L, V, 23, 4), L + 4;
  }
  h.prototype.writeFloatLE = function(R, L, V) {
    return re(this, R, L, !0, V);
  }, h.prototype.writeFloatBE = function(R, L, V) {
    return re(this, R, L, !1, V);
  };
  function de(N, R, L, V, ne) {
    return R = +R, L = L >>> 0, ne || ee(N, R, L, 8), r.write(N, R, L, V, 52, 8), L + 8;
  }
  h.prototype.writeDoubleLE = function(R, L, V) {
    return de(this, R, L, !0, V);
  }, h.prototype.writeDoubleBE = function(R, L, V) {
    return de(this, R, L, !1, V);
  }, h.prototype.copy = function(R, L, V, ne) {
    if (!h.isBuffer(R))
      throw new TypeError("argument should be a Buffer");
    if (V || (V = 0), !ne && ne !== 0 && (ne = this.length), L >= R.length && (L = R.length), L || (L = 0), ne > 0 && ne < V && (ne = V), ne === V || R.length === 0 || this.length === 0)
      return 0;
    if (L < 0)
      throw new RangeError("targetStart out of bounds");
    if (V < 0 || V >= this.length)
      throw new RangeError("Index out of range");
    if (ne < 0)
      throw new RangeError("sourceEnd out of bounds");
    ne > this.length && (ne = this.length), R.length - L < ne - V && (ne = R.length - L + V);
    const Se = ne - V;
    return this === R && typeof a.prototype.copyWithin == "function" ? this.copyWithin(L, V, ne) : a.prototype.set.call(
      R,
      this.subarray(V, ne),
      L
    ), Se;
  }, h.prototype.fill = function(R, L, V, ne) {
    if (typeof R == "string") {
      if (typeof L == "string" ? (ne = L, L = 0, V = this.length) : typeof V == "string" && (ne = V, V = this.length), ne !== void 0 && typeof ne != "string")
        throw new TypeError("encoding must be a string");
      if (typeof ne == "string" && !h.isEncoding(ne))
        throw new TypeError("Unknown encoding: " + ne);
      if (R.length === 1) {
        const ue = R.charCodeAt(0);
        (ne === "utf8" && ue < 128 || ne === "latin1") && (R = ue);
      }
    } else
      typeof R == "number" ? R = R & 255 : typeof R == "boolean" && (R = Number(R));
    if (L < 0 || this.length < L || this.length < V)
      throw new RangeError("Out of range index");
    if (V <= L)
      return this;
    L = L >>> 0, V = V === void 0 ? this.length : V >>> 0, R || (R = 0);
    let Se;
    if (typeof R == "number")
      for (Se = L; Se < V; ++Se)
        this[Se] = R;
    else {
      const ue = h.isBuffer(R) ? R : h.from(R, ne), xe = ue.length;
      if (xe === 0)
        throw new TypeError('The value "' + R + '" is invalid for argument "value"');
      for (Se = 0; Se < V - L; ++Se)
        this[Se + L] = ue[Se % xe];
    }
    return this;
  };
  const se = {};
  function Q(N, R, L) {
    se[N] = class extends L {
      constructor() {
        super(), Object.defineProperty(this, "message", {
          value: R.apply(this, arguments),
          writable: !0,
          configurable: !0
        }), this.name = `${this.name} [${N}]`, this.stack, delete this.name;
      }
      get code() {
        return N;
      }
      set code(ne) {
        Object.defineProperty(this, "code", {
          configurable: !0,
          enumerable: !0,
          value: ne,
          writable: !0
        });
      }
      toString() {
        return `${this.name} [${N}]: ${this.message}`;
      }
    };
  }
  Q(
    "ERR_BUFFER_OUT_OF_BOUNDS",
    function(N) {
      return N ? `${N} is outside of buffer bounds` : "Attempt to access memory outside buffer bounds";
    },
    RangeError
  ), Q(
    "ERR_INVALID_ARG_TYPE",
    function(N, R) {
      return `The "${N}" argument must be of type number. Received type ${typeof R}`;
    },
    TypeError
  ), Q(
    "ERR_OUT_OF_RANGE",
    function(N, R, L) {
      let V = `The value of "${N}" is out of range.`, ne = L;
      return Number.isInteger(L) && Math.abs(L) > 2 ** 32 ? ne = ge(String(L)) : typeof L == "bigint" && (ne = String(L), (L > BigInt(2) ** BigInt(32) || L < -(BigInt(2) ** BigInt(32))) && (ne = ge(ne)), ne += "n"), V += ` It must be ${R}. Received ${ne}`, V;
    },
    RangeError
  );
  function ge(N) {
    let R = "", L = N.length;
    const V = N[0] === "-" ? 1 : 0;
    for (; L >= V + 4; L -= 3)
      R = `_${N.slice(L - 3, L)}${R}`;
    return `${N.slice(0, L)}${R}`;
  }
  function Ye(N, R, L) {
    Be(R, "offset"), (N[R] === void 0 || N[R + L] === void 0) && st(R, N.length - (L + 1));
  }
  function Ce(N, R, L, V, ne, Se) {
    if (N > L || N < R) {
      const ue = typeof R == "bigint" ? "n" : "";
      let xe;
      throw R === 0 || R === BigInt(0) ? xe = `>= 0${ue} and < 2${ue} ** ${(Se + 1) * 8}${ue}` : xe = `>= -(2${ue} ** ${(Se + 1) * 8 - 1}${ue}) and < 2 ** ${(Se + 1) * 8 - 1}${ue}`, new se.ERR_OUT_OF_RANGE("value", xe, N);
    }
    Ye(V, ne, Se);
  }
  function Be(N, R) {
    if (typeof N != "number")
      throw new se.ERR_INVALID_ARG_TYPE(R, "number", N);
  }
  function st(N, R, L) {
    throw Math.floor(N) !== N ? (Be(N, L), new se.ERR_OUT_OF_RANGE("offset", "an integer", N)) : R < 0 ? new se.ERR_BUFFER_OUT_OF_BOUNDS() : new se.ERR_OUT_OF_RANGE(
      "offset",
      `>= 0 and <= ${R}`,
      N
    );
  }
  const De = /[^+/0-9A-Za-z-_]/g;
  function _e(N) {
    if (N = N.split("=")[0], N = N.trim().replace(De, ""), N.length < 2)
      return "";
    for (; N.length % 4 !== 0; )
      N = N + "=";
    return N;
  }
  function St(N, R) {
    R = R || 1 / 0;
    let L;
    const V = N.length;
    let ne = null;
    const Se = [];
    for (let ue = 0; ue < V; ++ue) {
      if (L = N.charCodeAt(ue), L > 55295 && L < 57344) {
        if (!ne) {
          if (L > 56319) {
            (R -= 3) > -1 && Se.push(239, 191, 189);
            continue;
          } else if (ue + 1 === V) {
            (R -= 3) > -1 && Se.push(239, 191, 189);
            continue;
          }
          ne = L;
          continue;
        }
        if (L < 56320) {
          (R -= 3) > -1 && Se.push(239, 191, 189), ne = L;
          continue;
        }
        L = (ne - 55296 << 10 | L - 56320) + 65536;
      } else
        ne && (R -= 3) > -1 && Se.push(239, 191, 189);
      if (ne = null, L < 128) {
        if ((R -= 1) < 0)
          break;
        Se.push(L);
      } else if (L < 2048) {
        if ((R -= 2) < 0)
          break;
        Se.push(
          L >> 6 | 192,
          L & 63 | 128
        );
      } else if (L < 65536) {
        if ((R -= 3) < 0)
          break;
        Se.push(
          L >> 12 | 224,
          L >> 6 & 63 | 128,
          L & 63 | 128
        );
      } else if (L < 1114112) {
        if ((R -= 4) < 0)
          break;
        Se.push(
          L >> 18 | 240,
          L >> 12 & 63 | 128,
          L >> 6 & 63 | 128,
          L & 63 | 128
        );
      } else
        throw new Error("Invalid code point");
    }
    return Se;
  }
  function Oe(N) {
    const R = [];
    for (let L = 0; L < N.length; ++L)
      R.push(N.charCodeAt(L) & 255);
    return R;
  }
  function Fe(N, R) {
    let L, V, ne;
    const Se = [];
    for (let ue = 0; ue < N.length && !((R -= 2) < 0); ++ue)
      L = N.charCodeAt(ue), V = L >> 8, ne = L % 256, Se.push(ne), Se.push(V);
    return Se;
  }
  function Et(N) {
    return e.toByteArray(_e(N));
  }
  function Ue(N, R, L, V) {
    let ne;
    for (ne = 0; ne < V && !(ne + L >= R.length || ne >= N.length); ++ne)
      R[ne + L] = N[ne];
    return ne;
  }
  function oe(N, R) {
    return N instanceof R || N != null && N.constructor != null && N.constructor.name != null && N.constructor.name === R.name;
  }
  function le(N) {
    return N !== N;
  }
  const ie = function() {
    const N = "0123456789abcdef", R = new Array(256);
    for (let L = 0; L < 16; ++L) {
      const V = L * 16;
      for (let ne = 0; ne < 16; ++ne)
        R[V + ne] = N[L] + N[ne];
    }
    return R;
  }();
  function fe(N) {
    return typeof BigInt > "u" ? Te : N;
  }
  function Te() {
    throw new Error("BigInt not supported");
  }
})(Ar);
const Je = Ar.Buffer, gT = Ar.Blob, yT = Ar.BlobOptions, bT = Ar.Buffer, wT = Ar.File, _T = Ar.FileOptions, xT = Ar.INSPECT_MAX_BYTES, MT = Ar.SlowBuffer, ST = Ar.TranscodeEncoding, ET = Ar.atob, AT = Ar.btoa, kT = Ar.constants, TT = Ar.isAscii, CT = Ar.isUtf8, BT = Ar.kMaxLength, IT = Ar.kStringMaxLength, RT = Ar.resolveObjectURL, PT = Ar.transcode, OT = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  Blob: gT,
  BlobOptions: yT,
  Buffer: bT,
  File: wT,
  FileOptions: _T,
  INSPECT_MAX_BYTES: xT,
  SlowBuffer: MT,
  TranscodeEncoding: ST,
  atob: ET,
  btoa: AT,
  constants: kT,
  default: Je,
  isAscii: TT,
  isUtf8: CT,
  kMaxLength: BT,
  kStringMaxLength: IT,
  resolveObjectURL: RT,
  transcode: PT
}, Symbol.toStringTag, { value: "Module" }));
var hn = {};
const NT = Symbol.for("nodejs.util.inspect.custom");
var fo = NT, uo = {};
Object.defineProperty(uo, "__esModule", { value: !0 });
uo.crc16 = void 0;
function DT(t) {
  let r = 0;
  const i = Je.alloc(t.length + 2);
  i.set(t);
  for (let f of i) {
    let a = 128;
    for (; a > 0; )
      r <<= 1, f & a && (r += 1), a >>= 1, r > 65535 && (r &= 65535, r ^= 4129);
  }
  return Je.from([Math.floor(r / 256), r % 256]);
}
uo.crc16 = DT;
var UT = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
}, o8;
Object.defineProperty(hn, "__esModule", { value: !0 });
hn.address = hn.Address = void 0;
const LT = UT(fo), f8 = uo, z1 = 17, u8 = 81, j1 = 128;
function Yy(t) {
  if (typeof t == "string" && !In.isFriendly(t))
    throw new Error("Unknown address type");
  const e = Je.isBuffer(t) ? t : Je.from(t, "base64");
  if (e.length !== 36)
    throw new Error("Unknown address type: byte length is not equal to 36");
  const r = e.subarray(0, 34), i = e.subarray(34, 36), f = (0, f8.crc16)(r);
  if (!(f[0] === i[0] && f[1] === i[1]))
    throw new Error("Invalid checksum: " + t);
  let a = r[0], l = !1, d = !1;
  if (a & j1 && (l = !0, a = a ^ j1), a !== z1 && a !== u8)
    throw "Unknown address tag";
  d = a === z1;
  let v = null;
  r[1] === 255 ? v = -1 : v = r[1];
  const m = r.subarray(2, 34);
  return { isTestOnly: l, isBounceable: d, workchain: v, hashPart: m };
}
class In {
  static isAddress(e) {
    return e instanceof In;
  }
  static isFriendly(e) {
    return !(e.length !== 48 || !/[A-Za-z0-9+/_-]+/.test(e));
  }
  static isRaw(e) {
    if (e.indexOf(":") === -1)
      return !1;
    let [r, i] = e.split(":");
    return !(!Number.isInteger(parseFloat(r)) || !/[a-f0-9]+/.test(i.toLowerCase()) || i.length !== 64);
  }
  static normalize(e) {
    return typeof e == "string" ? In.parse(e).toString() : e.toString();
  }
  static parse(e) {
    if (In.isFriendly(e))
      return this.parseFriendly(e).address;
    if (In.isRaw(e))
      return this.parseRaw(e);
    throw new Error("Unknown address type: " + e);
  }
  static parseRaw(e) {
    let r = parseInt(e.split(":")[0]), i = Je.from(e.split(":")[1], "hex");
    return new In(r, i);
  }
  static parseFriendly(e) {
    if (Je.isBuffer(e)) {
      let r = Yy(e);
      return {
        isBounceable: r.isBounceable,
        isTestOnly: r.isTestOnly,
        address: new In(r.workchain, r.hashPart)
      };
    } else {
      let r = e.replace(/\-/g, "+").replace(/_/g, "/"), i = Yy(r);
      return {
        isBounceable: i.isBounceable,
        isTestOnly: i.isTestOnly,
        address: new In(i.workchain, i.hashPart)
      };
    }
  }
  constructor(e, r) {
    if (this.toRawString = () => this.workChain + ":" + this.hash.toString("hex"), this.toRaw = () => {
      const i = Je.alloc(36);
      return i.set(this.hash), i.set([this.workChain, this.workChain, this.workChain, this.workChain], 32), i;
    }, this.toStringBuffer = (i) => {
      let f = i && i.testOnly !== void 0 ? i.testOnly : !1, l = (i && i.bounceable !== void 0 ? i.bounceable : !0) ? z1 : u8;
      f && (l |= j1);
      const d = Je.alloc(34);
      d[0] = l, d[1] = this.workChain, d.set(this.hash, 2);
      const v = Je.alloc(36);
      return v.set(d), v.set((0, f8.crc16)(d), 34), v;
    }, this.toString = (i) => {
      let f = i && i.urlSafe !== void 0 ? i.urlSafe : !0, a = this.toStringBuffer(i);
      return f ? a.toString("base64").replace(/\+/g, "-").replace(/\//g, "_") : a.toString("base64");
    }, this[o8] = () => this.toString(), r.length !== 32)
      throw new Error("Invalid address hash length: " + r.length);
    this.workChain = e, this.hash = r, Object.freeze(this);
  }
  equals(e) {
    return e.workChain !== this.workChain ? !1 : e.hash.equals(this.hash);
  }
}
hn.Address = In;
o8 = LT.default;
function FT(t) {
  return In.parse(t);
}
hn.address = FT;
var lo = {}, qT = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
}, l8;
Object.defineProperty(lo, "__esModule", { value: !0 });
lo.ExternalAddress = void 0;
const zT = qT(fo);
class sm {
  static isAddress(e) {
    return e instanceof sm;
  }
  constructor(e, r) {
    this[l8] = () => this.toString(), this.value = e, this.bits = r;
  }
  toString() {
    return `External<${this.bits}:${this.value}>`;
  }
}
lo.ExternalAddress = sm;
l8 = zT.default;
var Jl = {}, qa = {};
Object.defineProperty(qa, "__esModule", { value: !0 });
qa.base32Decode = qa.base32Encode = void 0;
const $1 = "abcdefghijklmnopqrstuvwxyz234567";
function jT(t) {
  const e = t.byteLength;
  let r = 0, i = 0, f = "";
  for (let a = 0; a < e; a++)
    for (i = i << 8 | t[a], r += 8; r >= 5; )
      f += $1[i >>> r - 5 & 31], r -= 5;
  return r > 0 && (f += $1[i << 5 - r & 31]), f;
}
qa.base32Encode = jT;
function $T(t, e) {
  const r = t.indexOf(e);
  if (r === -1)
    throw new Error("Invalid character found: " + e);
  return r;
}
function VT(t) {
  let e;
  e = t.toLowerCase();
  const { length: r } = e;
  let i = 0, f = 0, a = 0;
  const l = Je.alloc(r * 5 / 8 | 0);
  for (let d = 0; d < r; d++)
    f = f << 5 | $T($1, e[d]), i += 5, i >= 8 && (l[a++] = f >>> i - 8 & 255, i -= 8);
  return l;
}
qa.base32Decode = VT;
var HT = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
}, c8;
Object.defineProperty(Jl, "__esModule", { value: !0 });
Jl.ADNLAddress = void 0;
const WT = HT(fo), Jy = qa, Xy = uo;
class kl {
  static parseFriendly(e) {
    if (e.length !== 55)
      throw Error("Invalid address");
    e = "f" + e;
    let r = (0, Jy.base32Decode)(e);
    if (r[0] !== 45)
      throw Error("Invalid address");
    let i = r.slice(33);
    if (!(0, Xy.crc16)(r.slice(0, 33)).equals(i))
      throw Error("Invalid address");
    return new kl(r.slice(1, 33));
  }
  static parseRaw(e) {
    const r = Je.from(e, "base64");
    return new kl(r);
  }
  constructor(e) {
    if (this.toRaw = () => this.address.toString("hex").toUpperCase(), this.toString = () => {
      let r = Je.concat([Je.from([45]), this.address]), i = (0, Xy.crc16)(r);
      return r = Je.concat([r, i]), (0, Jy.base32Encode)(r).slice(1);
    }, this[c8] = () => this.toString(), e.length !== 32)
      throw Error("Invalid address");
    this.address = e;
  }
  equals(e) {
    return this.address.equals(e.address);
  }
}
Jl.ADNLAddress = kl;
c8 = WT.default;
var Xl = {}, ga = {}, Io = {}, Ro = {}, ya = {}, eb;
function ec() {
  if (eb)
    return ya;
  eb = 1, Object.defineProperty(ya, "__esModule", { value: !0 }), ya.paddedBufferToBits = ya.bitsToPaddedBuffer = void 0;
  const t = tc(), e = pa();
  function r(f) {
    let a = new t.BitBuilder(Math.ceil(f.length / 8) * 8);
    a.writeBits(f);
    let l = Math.ceil(f.length / 8) * 8 - f.length;
    for (let d = 0; d < l; d++)
      d === 0 ? a.writeBit(1) : a.writeBit(0);
    return a.buffer();
  }
  ya.bitsToPaddedBuffer = r;
  function i(f) {
    let a = 0;
    for (let l = f.length - 1; l >= 0; l--)
      if (f[l] !== 0) {
        const d = f[l];
        let v = d & -d;
        v & 1 || (v = Math.log2(v) + 1), l > 0 && (a = l << 3), a += 8 - v;
        break;
      }
    return new e.BitString(f, 0, a);
  }
  return ya.paddedBufferToBits = i, ya;
}
var tb;
function pa() {
  if (tb)
    return Ro;
  tb = 1;
  var t = ut && ut.__importDefault || function(a) {
    return a && a.__esModule ? a : { default: a };
  }, e;
  Object.defineProperty(Ro, "__esModule", { value: !0 }), Ro.BitString = void 0;
  const r = ec(), i = t(fo);
  let f = class Wu {
    /**
     * Checks if supplied object is BitString
     * @param src is unknow object
     * @returns true if object is BitString and false otherwise
     **/
    static isBitString(l) {
      return l instanceof Wu;
    }
    /**
     * Constructing BitString from a buffer
     * @param data data that contains the bitstring data. NOTE: We are expecting this buffer to be NOT modified
     * @param offset offset in bits from the start of the buffer
     * @param length length of the bitstring in bits
     */
    constructor(l, d, v) {
      if (this[e] = () => this.toString(), v < 0)
        throw new Error(`Length ${v} is out of bounds`);
      this._length = v, this._data = l, this._offset = d;
    }
    /**
     * Returns the length of the bitstring
     */
    get length() {
      return this._length;
    }
    /**
     * Returns the bit at the specified index
     * @param index index of the bit
     * @throws Error if index is out of bounds
     * @returns true if the bit is set, false otherwise
     */
    at(l) {
      if (l >= this._length)
        throw new Error(`Index ${l} > ${this._length} is out of bounds`);
      if (l < 0)
        throw new Error(`Index ${l} < 0 is out of bounds`);
      let d = this._offset + l >> 3, v = 7 - (this._offset + l) % 8;
      return (this._data[d] & 1 << v) !== 0;
    }
    /**
     * Get a subscring of the bitstring
     * @param offset
     * @param length
     * @returns
     */
    substring(l, d) {
      if (l > this._length)
        throw new Error(`Offset(${l}) > ${this._length} is out of bounds`);
      if (l < 0)
        throw new Error(`Offset(${l}) < 0 is out of bounds`);
      if (d === 0)
        return Wu.EMPTY;
      if (l + d > this._length)
        throw new Error(`Offset ${l} + Length ${d} > ${this._length} is out of bounds`);
      return new Wu(this._data, this._offset + l, d);
    }
    /**
     * Try to get a buffer from the bitstring without allocations
     * @param offset offset in bits
     * @param length length in bits
     * @returns buffer if the bitstring is aligned to bytes, null otherwise
     */
    subbuffer(l, d) {
      if (l > this._length)
        throw new Error(`Offset ${l} is out of bounds`);
      if (l < 0)
        throw new Error(`Offset ${l} is out of bounds`);
      if (l + d > this._length)
        throw new Error(`Offset + Lenght = ${l + d} is out of bounds`);
      if (d % 8 !== 0 || (this._offset + l) % 8 !== 0)
        return null;
      let v = this._offset + l >> 3, m = v + (d >> 3);
      return this._data.subarray(v, m);
    }
    /**
     * Checks for equality
     * @param b other bitstring
     * @returns true if the bitstrings are equal, false otherwise
     */
    equals(l) {
      if (this._length !== l._length)
        return !1;
      for (let d = 0; d < this._length; d++)
        if (this.at(d) !== l.at(d))
          return !1;
      return !0;
    }
    /**
     * Format to canonical string
     * @returns formatted bits as a string
     */
    toString() {
      const l = (0, r.bitsToPaddedBuffer)(this);
      if (this._length % 4 === 0) {
        const d = l.subarray(0, Math.ceil(this._length / 8)).toString("hex").toUpperCase();
        return this._length % 8 === 0 ? d : d.substring(0, d.length - 1);
      } else {
        const d = l.toString("hex").toUpperCase();
        return this._length % 8 <= 4 ? d.substring(0, d.length - 1) + "_" : d + "_";
      }
    }
  };
  return Ro.BitString = f, e = i.default, f.EMPTY = new f(Je.alloc(0), 0, 0), Ro;
}
var rb;
function tc() {
  if (rb)
    return Io;
  rb = 1, Object.defineProperty(Io, "__esModule", { value: !0 }), Io.BitBuilder = void 0;
  const t = hn, e = lo, r = pa();
  let i = class {
    constructor(a = 1023) {
      this._buffer = Je.alloc(Math.ceil(a / 8)), this._length = 0;
    }
    /**
     * Current number of bits written
     */
    get length() {
      return this._length;
    }
    /**
     * Write a single bit
     * @param value bit to write, true or positive number for 1, false or zero or negative for 0
     */
    writeBit(a) {
      let l = this._length;
      if (l > this._buffer.length * 8)
        throw new Error("BitBuilder overflow");
      (typeof a == "boolean" && a === !0 || typeof a == "number" && a > 0) && (this._buffer[l / 8 | 0] |= 1 << 7 - l % 8), this._length++;
    }
    /**
     * Copy bits from BitString
     * @param src source bits
     */
    writeBits(a) {
      for (let l = 0; l < a.length; l++)
        this.writeBit(a.at(l));
    }
    /**
     * Write bits from buffer
     * @param src source buffer
     */
    writeBuffer(a) {
      if (this._length % 8 === 0) {
        if (this._length + a.length * 8 > this._buffer.length * 8)
          throw new Error("BitBuilder overflow");
        a.copy(this._buffer, this._length / 8), this._length += a.length * 8;
      } else
        for (let l = 0; l < a.length; l++)
          this.writeUint(a[l], 8);
    }
    /**
     * Write uint value
     * @param value value as bigint or number
     * @param bits number of bits to write
     */
    writeUint(a, l) {
      if (l < 0 || !Number.isSafeInteger(l))
        throw Error(`invalid bit length. Got ${l}`);
      const d = BigInt(a);
      if (l === 0) {
        if (d !== 0n)
          throw Error(`value is not zero for ${l} bits. Got ${a}`);
        return;
      }
      const v = 1n << BigInt(l);
      if (d < 0 || d >= v)
        throw Error(`bitLength is too small for a value ${a}. Got ${l}`);
      if (this._length + l > this._buffer.length * 8)
        throw new Error("BitBuilder overflow");
      const m = 8 - this._length % 8;
      if (m > 0) {
        const h = Math.floor(this._length / 8);
        if (l < m) {
          const w = Number(d);
          this._buffer[h] |= w << m - l, this._length += l;
        } else {
          const w = Number(d >> BigInt(l - m));
          this._buffer[h] |= w, this._length += m;
        }
      }
      for (l -= m; l > 0; )
        l >= 8 ? (this._buffer[this._length / 8] = Number(d >> BigInt(l - 8) & 0xffn), this._length += 8, l -= 8) : (this._buffer[this._length / 8] = Number(d << BigInt(8 - l) & 0xffn), this._length += l, l = 0);
    }
    /**
     * Write int value
     * @param value value as bigint or number
     * @param bits number of bits to write
     */
    writeInt(a, l) {
      let d = BigInt(a);
      if (l < 0 || !Number.isSafeInteger(l))
        throw Error(`invalid bit length. Got ${l}`);
      if (l === 0) {
        if (a !== 0n)
          throw Error(`value is not zero for ${l} bits. Got ${a}`);
        return;
      }
      if (l === 1) {
        if (a !== -1n && a !== 0n)
          throw Error(`value is not zero or -1 for ${l} bits. Got ${a}`);
        this.writeBit(a === -1n);
        return;
      }
      let v = 1n << BigInt(l) - 1n;
      if (d < -v || d >= v)
        throw Error(`value is out of range for ${l} bits. Got ${a}`);
      d < 0 ? (this.writeBit(!0), d = v + d) : this.writeBit(!1), this.writeUint(d, l - 1);
    }
    /**
     * Wrtie var uint value, used for serializing coins
     * @param value value to write as bigint or number
     * @param bits header bits to write size
     */
    writeVarUint(a, l) {
      let d = BigInt(a);
      if (l < 0 || !Number.isSafeInteger(l))
        throw Error(`invalid bit length. Got ${l}`);
      if (d < 0)
        throw Error(`value is negative. Got ${a}`);
      if (d === 0n) {
        this.writeUint(0, l);
        return;
      }
      const v = Math.ceil(d.toString(2).length / 8), m = v * 8;
      this.writeUint(v, l), this.writeUint(d, m);
    }
    /**
     * Wrtie var int value, used for serializing coins
     * @param value value to write as bigint or number
     * @param bits header bits to write size
     */
    writeVarInt(a, l) {
      let d = BigInt(a);
      if (l < 0 || !Number.isSafeInteger(l))
        throw Error(`invalid bit length. Got ${l}`);
      if (d === 0n) {
        this.writeUint(0, l);
        return;
      }
      let v = d > 0 ? d : -d;
      const m = 1 + Math.ceil(v.toString(2).length / 8), h = m * 8;
      this.writeUint(m, l), this.writeInt(d, h);
    }
    /**
     * Write coins in var uint format
     * @param amount amount to write
     */
    writeCoins(a) {
      this.writeVarUint(a, 4);
    }
    /**
     * Write address
     * @param address write address or address external
     */
    writeAddress(a) {
      if (a == null) {
        this.writeUint(0, 2);
        return;
      }
      if (t.Address.isAddress(a)) {
        this.writeUint(2, 2), this.writeUint(0, 1), this.writeInt(a.workChain, 8), this.writeBuffer(a.hash);
        return;
      }
      if (e.ExternalAddress.isAddress(a)) {
        this.writeUint(1, 2), this.writeUint(a.bits, 9), this.writeUint(a.value, a.bits);
        return;
      }
      throw Error(`Invalid address. Got ${a}`);
    }
    /**
     * Build BitString
     * @returns result bit string
     */
    build() {
      return new r.BitString(this._buffer, 0, this._length);
    }
    /**
     * Build into Buffer
     * @returns result buffer
     */
    buffer() {
      if (this._length % 8 !== 0)
        throw new Error("BitBuilder buffer is not byte aligned");
      return this._buffer.subarray(0, this._length / 8);
    }
  };
  return Io.BitBuilder = i, Io;
}
var Po = {}, va = {};
Object.defineProperty(va, "__esModule", { value: !0 });
va.CellType = void 0;
var nb;
(function(t) {
  t[t.Ordinary = -1] = "Ordinary", t[t.PrunedBranch = 1] = "PrunedBranch", t[t.Library = 2] = "Library", t[t.MerkleProof = 3] = "MerkleProof", t[t.MerkleUpdate = 4] = "MerkleUpdate";
})(nb || (va.CellType = nb = {}));
var Oo = {}, No = {}, Do = {}, rc = {};
Object.defineProperty(rc, "__esModule", { value: !0 });
rc.readUnaryLength = void 0;
function KT(t) {
  let e = 0;
  for (; t.loadBit(); )
    e++;
  return e;
}
rc.readUnaryLength = KT;
var ib;
function om() {
  if (ib)
    return Do;
  ib = 1, Object.defineProperty(Do, "__esModule", { value: !0 }), Do.generateMerkleProof = void 0;
  const t = Tr(), e = rc;
  function r(l) {
    return (0, t.beginCell)().storeUint(1, 8).storeUint(1, 8).storeBuffer(l.hash(0)).storeUint(l.depth(0), 16).endCell({ exotic: !0 });
  }
  function i(l) {
    return (0, t.beginCell)().storeUint(3, 8).storeBuffer(l.hash(0)).storeUint(l.depth(0), 16).storeRef(l).endCell({ exotic: !0 });
  }
  function f(l, d, v, m) {
    const h = d.asCell();
    let w = d.loadBit() ? 1 : 0, M = 0, S = l;
    if (w === 0) {
      M = (0, e.readUnaryLength)(d);
      for (let E = 0; E < M; E++)
        S += d.loadBit() ? "1" : "0";
    } else if ((d.loadBit() ? 1 : 0) === 0) {
      M = d.loadUint(Math.ceil(Math.log2(v + 1)));
      for (let A = 0; A < M; A++)
        S += d.loadBit() ? "1" : "0";
    } else {
      let A = d.loadBit() ? "1" : "0";
      M = d.loadUint(Math.ceil(Math.log2(v + 1)));
      for (let B = 0; B < M; B++)
        S += A;
    }
    if (v - M === 0)
      return h;
    {
      let E = h.beginParse(), A = E.loadRef(), B = E.loadRef();
      return A.isExotic || (S + "0" === m.slice(0, S.length + 1) ? A = f(S + "0", A.beginParse(), v - M - 1, m) : A = r(A)), B.isExotic || (S + "1" === m.slice(0, S.length + 1) ? B = f(S + "1", B.beginParse(), v - M - 1, m) : B = r(B)), (0, t.beginCell)().storeSlice(E).storeRef(A).storeRef(B).endCell();
    }
  }
  function a(l, d, v) {
    const m = (0, t.beginCell)().storeDictDirect(l).endCell().beginParse();
    return i(f("", m, v.bits, v.serialize(d).toString(2).padStart(v.bits, "0")));
  }
  return Do.generateMerkleProof = a, Do;
}
var Uo = {}, ab;
function d8() {
  if (ab)
    return Uo;
  ab = 1, Object.defineProperty(Uo, "__esModule", { value: !0 }), Uo.generateMerkleUpdate = void 0;
  const t = Tr(), e = om();
  function r(f, a) {
    return (0, t.beginCell)().storeUint(4, 8).storeBuffer(f.hash(0)).storeBuffer(a.hash(0)).storeUint(f.depth(0), 16).storeUint(a.depth(0), 16).storeRef(f).storeRef(a).endCell({ exotic: !0 });
  }
  function i(f, a, l, d) {
    const v = (0, e.generateMerkleProof)(f, a, l).refs[0];
    f.set(a, d);
    const m = (0, e.generateMerkleProof)(f, a, l).refs[0];
    return r(v, m);
  }
  return Uo.generateMerkleUpdate = i, Uo;
}
var nc = {};
Object.defineProperty(nc, "__esModule", { value: !0 });
nc.parseDict = void 0;
function ZT(t) {
  let e = 0;
  for (; t.loadBit(); )
    e++;
  return e;
}
function V1(t, e, r, i, f) {
  let a = e.loadBit() ? 1 : 0, l = 0, d = t;
  if (a === 0) {
    l = ZT(e);
    for (let v = 0; v < l; v++)
      d += e.loadBit() ? "1" : "0";
  } else if ((e.loadBit() ? 1 : 0) === 0) {
    l = e.loadUint(Math.ceil(Math.log2(r + 1)));
    for (let m = 0; m < l; m++)
      d += e.loadBit() ? "1" : "0";
  } else {
    let m = e.loadBit() ? "1" : "0";
    l = e.loadUint(Math.ceil(Math.log2(r + 1)));
    for (let h = 0; h < l; h++)
      d += m;
  }
  if (r - l === 0)
    i.set(BigInt("0b" + d), f(e));
  else {
    let v = e.loadRef(), m = e.loadRef();
    v.isExotic || V1(d + "0", v.beginParse(), r - l - 1, i, f), m.isExotic || V1(d + "1", m.beginParse(), r - l - 1, i, f);
  }
}
function GT(t, e, r) {
  let i = /* @__PURE__ */ new Map();
  return t && V1("", t, e, i, r), i;
}
nc.parseDict = GT;
var jr = {}, ic = {};
Object.defineProperty(ic, "__esModule", { value: !0 });
ic.findCommonPrefix = void 0;
function QT(t, e = 0) {
  if (t.length === 0)
    return "";
  let r = t[0].slice(e);
  for (let i = 1; i < t.length; i++) {
    const f = t[i];
    for (; f.indexOf(r, e) !== e; )
      if (r = r.substring(0, r.length - 1), r === "")
        return r;
  }
  return r;
}
ic.findCommonPrefix = QT;
var sb;
function YT() {
  if (sb)
    return jr;
  sb = 1, Object.defineProperty(jr, "__esModule", { value: !0 }), jr.serializeDict = jr.detectLabelType = jr.writeLabelSame = jr.writeLabelLong = jr.writeLabelShort = jr.buildTree = void 0;
  const t = Tr(), e = ic;
  function r(I, O) {
    for (; I.length < O; )
      I = "0" + I;
    return I;
  }
  function i(I, O) {
    if (I.size === 0)
      throw Error("Internal inconsistency");
    let q = /* @__PURE__ */ new Map(), $ = /* @__PURE__ */ new Map();
    for (let [ae, he] of I.entries())
      ae[O] === "0" ? q.set(ae, he) : $.set(ae, he);
    if (q.size === 0)
      throw Error("Internal inconsistency. Left emtpy.");
    if ($.size === 0)
      throw Error("Internal inconsistency. Right emtpy.");
    return { left: q, right: $ };
  }
  function f(I, O) {
    if (I.size === 0)
      throw Error("Internal inconsistency");
    if (I.size === 1)
      return { type: "leaf", value: Array.from(I.values())[0] };
    let { left: q, right: $ } = i(I, O);
    return {
      type: "fork",
      left: a(q, O + 1),
      right: a($, O + 1)
    };
  }
  function a(I, O = 0) {
    if (I.size === 0)
      throw Error("Internal inconsistency");
    const q = (0, e.findCommonPrefix)(Array.from(I.keys()), O);
    return { label: q, node: f(I, q.length + O) };
  }
  function l(I, O) {
    let q = /* @__PURE__ */ new Map();
    for (let $ of Array.from(I.keys())) {
      const ae = r($.toString(2), O);
      q.set(ae, I.get($));
    }
    return a(q);
  }
  jr.buildTree = l;
  function d(I, O) {
    O.storeBit(0);
    for (let q = 0; q < I.length; q++)
      O.storeBit(1);
    return O.storeBit(0), I.length > 0 && O.storeUint(BigInt("0b" + I), I.length), O;
  }
  jr.writeLabelShort = d;
  function v(I) {
    return 1 + I.length + 1 + I.length;
  }
  function m(I, O, q) {
    q.storeBit(1), q.storeBit(0);
    let $ = Math.ceil(Math.log2(O + 1));
    return q.storeUint(I.length, $), I.length > 0 && q.storeUint(BigInt("0b" + I), I.length), q;
  }
  jr.writeLabelLong = m;
  function h(I, O) {
    return 2 + Math.ceil(Math.log2(O + 1)) + I.length;
  }
  function w(I, O, q, $) {
    $.storeBit(1), $.storeBit(1), $.storeBit(I);
    let ae = Math.ceil(Math.log2(q + 1));
    $.storeUint(O, ae);
  }
  jr.writeLabelSame = w;
  function M(I) {
    return 3 + Math.ceil(Math.log2(I + 1));
  }
  function S(I) {
    if (I.length === 0 || I.length === 1)
      return !0;
    for (let O = 1; O < I.length; O++)
      if (I[O] !== I[0])
        return !1;
    return !0;
  }
  function E(I, O) {
    let q = "short", $ = v(I), ae = h(I, O);
    if (ae < $ && ($ = ae, q = "long"), S(I)) {
      let he = M(O);
      he < $ && ($ = he, q = "same");
    }
    return q;
  }
  jr.detectLabelType = E;
  function A(I, O, q) {
    let $ = E(I, O);
    $ === "short" ? d(I, q) : $ === "long" ? m(I, O, q) : $ === "same" && w(I[0] === "1", I.length, O, q);
  }
  function B(I, O, q, $) {
    if (I.type === "leaf" && q(I.value, $), I.type === "fork") {
      const ae = (0, t.beginCell)(), he = (0, t.beginCell)();
      k(I.left, O - 1, q, ae), k(I.right, O - 1, q, he), $.storeRef(ae), $.storeRef(he);
    }
  }
  function k(I, O, q, $) {
    A(I.label, O, $), B(I.node, O - I.label.length, q, $);
  }
  function C(I, O, q, $) {
    const ae = l(I, O);
    k(ae, O, q, $);
  }
  return jr.serializeDict = C, jr;
}
var Zs = {};
Object.defineProperty(Zs, "__esModule", { value: !0 });
Zs.deserializeInternalKey = Zs.serializeInternalKey = void 0;
const h8 = hn, H1 = pa(), JT = ec();
function XT(t) {
  if (typeof t == "number") {
    if (!Number.isSafeInteger(t))
      throw Error("Invalid key type: not a safe integer: " + t);
    return "n:" + t.toString(10);
  } else {
    if (typeof t == "bigint")
      return "b:" + t.toString(10);
    if (h8.Address.isAddress(t))
      return "a:" + t.toString();
    if (Je.isBuffer(t))
      return "f:" + t.toString("hex");
    if (H1.BitString.isBitString(t))
      return "B:" + t.toString();
    throw Error("Invalid key type");
  }
}
Zs.serializeInternalKey = XT;
function eC(t) {
  let e = t.slice(0, 2), r = t.slice(2);
  if (e === "n:")
    return parseInt(r, 10);
  if (e === "b:")
    return BigInt(r);
  if (e === "a:")
    return h8.Address.parse(r);
  if (e === "f:")
    return Je.from(r, "hex");
  if (e === "B:") {
    const i = r.slice(-1) == "_";
    if (i || r.length % 2 != 0) {
      let a = i ? r.length - 1 : r.length;
      const l = r.substr(0, a) + "0";
      return !i && a & 1 ? new H1.BitString(Je.from(l, "hex"), 0, a << 2) : (0, JT.paddedBufferToBits)(Je.from(l, "hex"));
    } else
      return new H1.BitString(Je.from(r, "hex"), 0, r.length << 2);
  }
  throw Error("Invalid key type: " + e);
}
Zs.deserializeInternalKey = eC;
var ob;
function ms() {
  if (ob)
    return No;
  ob = 1, Object.defineProperty(No, "__esModule", { value: !0 }), No.Dictionary = void 0;
  const t = hn, e = Tr(), r = ys(), i = pa(), f = om(), a = d8(), l = nc, d = YT(), v = Zs;
  let m = class Ui {
    /**
     * Create an empty map
     * @param key key type
     * @param value value type
     * @returns Dictionary<K, V>
     */
    static empty(u, c) {
      return u && c ? new Ui(/* @__PURE__ */ new Map(), u, c) : new Ui(/* @__PURE__ */ new Map(), null, null);
    }
    /**
     * Load dictionary from slice
     * @param key key description
     * @param value value description
     * @param src slice
     * @returns Dictionary<K, V>
     */
    static load(u, c, g) {
      let b;
      if (g instanceof r.Cell) {
        if (g.isExotic)
          return Ui.empty(u, c);
        b = g.beginParse();
      } else
        b = g;
      let _ = b.loadMaybeRef();
      return _ && !_.isExotic ? Ui.loadDirect(u, c, _.beginParse()) : Ui.empty(u, c);
    }
    /**
     * Low level method for rare dictionaries from system contracts.
     * Loads dictionary from slice directly without going to the ref.
     *
     * @param key key description
     * @param value value description
     * @param sc slice
     * @returns Dictionary<K, V>
     */
    static loadDirect(u, c, g) {
      if (!g)
        return Ui.empty(u, c);
      let b;
      g instanceof r.Cell ? b = g.beginParse() : b = g;
      let _ = (0, l.parseDict)(b, u.bits, c.parse), p = /* @__PURE__ */ new Map();
      for (let [s, y] of _)
        p.set((0, v.serializeInternalKey)(u.parse(s)), y);
      return new Ui(p, u, c);
    }
    constructor(u, c, g) {
      this._key = c, this._value = g, this._map = u;
    }
    get size() {
      return this._map.size;
    }
    get(u) {
      return this._map.get((0, v.serializeInternalKey)(u));
    }
    has(u) {
      return this._map.has((0, v.serializeInternalKey)(u));
    }
    set(u, c) {
      return this._map.set((0, v.serializeInternalKey)(u), c), this;
    }
    delete(u) {
      const c = (0, v.serializeInternalKey)(u);
      return this._map.delete(c);
    }
    clear() {
      this._map.clear();
    }
    *[Symbol.iterator]() {
      for (const [u, c] of this._map)
        yield [(0, v.deserializeInternalKey)(u), c];
    }
    keys() {
      return Array.from(this._map.keys()).map((u) => (0, v.deserializeInternalKey)(u));
    }
    values() {
      return Array.from(this._map.values());
    }
    store(u, c, g) {
      if (this._map.size === 0)
        u.storeBit(0);
      else {
        let b = this._key;
        c != null && (b = c);
        let _ = this._value;
        if (g != null && (_ = g), !b)
          throw Error("Key serializer is not defined");
        if (!_)
          throw Error("Value serializer is not defined");
        let p = /* @__PURE__ */ new Map();
        for (const [y, T] of this._map)
          p.set(b.serialize((0, v.deserializeInternalKey)(y)), T);
        u.storeBit(1);
        let s = (0, e.beginCell)();
        (0, d.serializeDict)(p, b.bits, _.serialize, s), u.storeRef(s.endCell());
      }
    }
    storeDirect(u, c, g) {
      if (this._map.size === 0)
        throw Error("Cannot store empty dictionary directly");
      let b = this._key;
      c != null && (b = c);
      let _ = this._value;
      if (g != null && (_ = g), !b)
        throw Error("Key serializer is not defined");
      if (!_)
        throw Error("Value serializer is not defined");
      let p = /* @__PURE__ */ new Map();
      for (const [s, y] of this._map)
        p.set(b.serialize((0, v.deserializeInternalKey)(s)), y);
      (0, d.serializeDict)(p, b.bits, _.serialize, u);
    }
    generateMerkleProof(u) {
      return (0, f.generateMerkleProof)(this, u, this._key);
    }
    generateMerkleUpdate(u, c) {
      return (0, a.generateMerkleUpdate)(this, u, this._key, c);
    }
  };
  No.Dictionary = m, m.Keys = {
    /**
     * Standard address key
     * @returns DictionaryKey<Address>
     */
    Address: () => h(),
    /**
     * Create standard big integer key
     * @param bits number of bits
     * @returns DictionaryKey<bigint>
     */
    BigInt: (o) => w(o),
    /**
     * Create integer key
     * @param bits bits of integer
     * @returns DictionaryKey<number>
     */
    Int: (o) => M(o),
    /**
     * Create standard unsigned big integer key
     * @param bits number of bits
     * @returns DictionaryKey<bigint>
     */
    BigUint: (o) => S(o),
    /**
     * Create standard unsigned integer key
     * @param bits number of bits
     * @returns DictionaryKey<number>
     */
    Uint: (o) => E(o),
    /**
     * Create standard buffer key
     * @param bytes number of bytes of a buffer
     * @returns DictionaryKey<Buffer>
     */
    Buffer: (o) => A(o),
    /**
     * Create BitString key
     * @param bits key length
     * @returns DictionaryKey<BitString>
     * Point is that Buffer has to be 8 bit aligned,
     * while key is TVM dictionary doesn't have to be
     * aligned at all.
     */
    BitString: (o) => B(o)
  }, m.Values = {
    /**
     * Create standard integer value
     * @returns DictionaryValue<bigint>
     */
    BigInt: (o) => C(o),
    /**
     * Create standard integer value
     * @returns DictionaryValue<number>
     */
    Int: (o) => k(o),
    /**
     * Create big var int
     * @param bits nubmer of header bits
     * @returns DictionaryValue<bigint>
     */
    BigVarInt: (o) => I(o),
    /**
     * Create standard unsigned integer value
     * @param bits number of bits
     * @returns DictionaryValue<bigint>
     */
    BigUint: (o) => $(o),
    /**
     * Create standard unsigned integer value
     * @param bits number of bits
     * @returns DictionaryValue<bigint>
     */
    Uint: (o) => q(o),
    /**
     * Create big var int
     * @param bits nubmer of header bits
     * @returns DictionaryValue<bigint>
     */
    BigVarUint: (o) => O(o),
    /**
     * Create standard boolean value
     * @returns DictionaryValue<boolean>
     */
    Bool: () => ae(),
    /**
     * Create standard address value
     * @returns DictionaryValue<Address>
     */
    Address: () => he(),
    /**
     * Create standard cell value
     * @returns DictionaryValue<Cell>
     */
    Cell: () => te(),
    /**
     * Create Builder value
     * @param bytes number of bytes of a buffer
     * @returns DictionaryValue<Builder>
     */
    Buffer: (o) => x(o),
    /**
     * Create BitString value
     * @param requested bit length
     * @returns DictionaryValue<BitString>
     * Point is that Buffer is not applicable
     * when length is not 8 bit alligned.
     */
    BitString: (o) => n(o),
    /**
     * Create dictionary value
     * @param key
     * @param value
     */
    Dictionary: (o, u) => Ee(o, u)
  };
  function h() {
    return {
      bits: 267,
      serialize: (o) => {
        if (!t.Address.isAddress(o))
          throw Error("Key is not an address");
        return (0, e.beginCell)().storeAddress(o).endCell().beginParse().preloadUintBig(267);
      },
      parse: (o) => (0, e.beginCell)().storeUint(o, 267).endCell().beginParse().loadAddress()
    };
  }
  function w(o) {
    return {
      bits: o,
      serialize: (u) => {
        if (typeof u != "bigint")
          throw Error("Key is not a bigint");
        return (0, e.beginCell)().storeInt(u, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (u) => (0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadIntBig(o)
    };
  }
  function M(o) {
    return {
      bits: o,
      serialize: (u) => {
        if (typeof u != "number")
          throw Error("Key is not a number");
        if (!Number.isSafeInteger(u))
          throw Error("Key is not a safe integer: " + u);
        return (0, e.beginCell)().storeInt(u, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (u) => (0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadInt(o)
    };
  }
  function S(o) {
    return {
      bits: o,
      serialize: (u) => {
        if (typeof u != "bigint")
          throw Error("Key is not a bigint");
        if (u < 0)
          throw Error("Key is negative: " + u);
        return (0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (u) => (0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadUintBig(o)
    };
  }
  function E(o) {
    return {
      bits: o,
      serialize: (u) => {
        if (typeof u != "number")
          throw Error("Key is not a number");
        if (!Number.isSafeInteger(u))
          throw Error("Key is not a safe integer: " + u);
        if (u < 0)
          throw Error("Key is negative: " + u);
        return (0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadUintBig(o);
      },
      parse: (u) => Number((0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadUint(o))
    };
  }
  function A(o) {
    return {
      bits: o * 8,
      serialize: (u) => {
        if (!Je.isBuffer(u))
          throw Error("Key is not a buffer");
        return (0, e.beginCell)().storeBuffer(u).endCell().beginParse().loadUintBig(o * 8);
      },
      parse: (u) => (0, e.beginCell)().storeUint(u, o * 8).endCell().beginParse().loadBuffer(o)
    };
  }
  function B(o) {
    return {
      bits: o,
      serialize: (u) => {
        if (!i.BitString.isBitString(u))
          throw Error("Key is not a BitString");
        return (0, e.beginCell)().storeBits(u).endCell().beginParse().loadUintBig(o);
      },
      parse: (u) => (0, e.beginCell)().storeUint(u, o).endCell().beginParse().loadBits(o)
    };
  }
  function k(o) {
    return {
      serialize: (u, c) => {
        c.storeInt(u, o);
      },
      parse: (u) => u.loadInt(o)
    };
  }
  function C(o) {
    return {
      serialize: (u, c) => {
        c.storeInt(u, o);
      },
      parse: (u) => u.loadIntBig(o)
    };
  }
  function I(o) {
    return {
      serialize: (u, c) => {
        c.storeVarInt(u, o);
      },
      parse: (u) => u.loadVarIntBig(o)
    };
  }
  function O(o) {
    return {
      serialize: (u, c) => {
        c.storeVarUint(u, o);
      },
      parse: (u) => u.loadVarUintBig(o)
    };
  }
  function q(o) {
    return {
      serialize: (u, c) => {
        c.storeUint(u, o);
      },
      parse: (u) => u.loadUint(o)
    };
  }
  function $(o) {
    return {
      serialize: (u, c) => {
        c.storeUint(u, o);
      },
      parse: (u) => u.loadUintBig(o)
    };
  }
  function ae() {
    return {
      serialize: (o, u) => {
        u.storeBit(o);
      },
      parse: (o) => o.loadBit()
    };
  }
  function he() {
    return {
      serialize: (o, u) => {
        u.storeAddress(o);
      },
      parse: (o) => o.loadAddress()
    };
  }
  function te() {
    return {
      serialize: (o, u) => {
        u.storeRef(o);
      },
      parse: (o) => o.loadRef()
    };
  }
  function Ee(o, u) {
    return {
      serialize: (c, g) => {
        c.store(g);
      },
      parse: (c) => m.load(o, u, c)
    };
  }
  function x(o) {
    return {
      serialize: (u, c) => {
        if (u.length !== o)
          throw Error("Invalid buffer size");
        c.storeBuffer(u);
      },
      parse: (u) => u.loadBuffer(o)
    };
  }
  function n(o) {
    return {
      serialize: (u, c) => {
        if (u.length !== o)
          throw Error("Invalid BitString size");
        c.storeBits(u);
      },
      parse: (u) => u.loadBits(o)
    };
  }
  return No;
}
var di = {}, fb;
function p8() {
  if (fb)
    return di;
  fb = 1, Object.defineProperty(di, "__esModule", { value: !0 }), di.writeString = di.stringToCell = di.readString = void 0;
  const t = Tr();
  function e(l) {
    if (l.remainingBits % 8 !== 0)
      throw new Error(`Invalid string length: ${l.remainingBits}`);
    if (l.remainingRefs !== 0 && l.remainingRefs !== 1)
      throw new Error(`invalid number of refs: ${l.remainingRefs}`);
    let d;
    return l.remainingBits === 0 ? d = Je.alloc(0) : d = l.loadBuffer(l.remainingBits / 8), l.remainingRefs === 1 && (d = Je.concat([d, e(l.loadRef().beginParse())])), d;
  }
  function r(l) {
    return e(l).toString();
  }
  di.readString = r;
  function i(l, d) {
    if (l.length > 0) {
      let v = Math.floor(d.availableBits / 8);
      if (l.length > v) {
        let m = l.subarray(0, v), h = l.subarray(v);
        d = d.storeBuffer(m);
        let w = (0, t.beginCell)();
        i(h, w), d = d.storeRef(w.endCell());
      } else
        d = d.storeBuffer(l);
    }
  }
  function f(l) {
    let d = (0, t.beginCell)();
    return i(Je.from(l), d), d.endCell();
  }
  di.stringToCell = f;
  function a(l, d) {
    i(Je.from(l), d);
  }
  return di.writeString = a, di;
}
var ub;
function fm() {
  if (ub)
    return Oo;
  ub = 1;
  var t = ut && ut.__importDefault || function(d) {
    return d && d.__esModule ? d : { default: d };
  }, e;
  Object.defineProperty(Oo, "__esModule", { value: !0 }), Oo.Slice = void 0;
  const r = t(fo), i = ms(), f = Tr(), a = p8();
  let l = class W1 {
    constructor(v, m) {
      this[e] = () => this.toString(), this._reader = v.clone(), this._refs = [...m], this._refsOffset = 0;
    }
    /**
     * Get remaining bits
     */
    get remainingBits() {
      return this._reader.remaining;
    }
    /**
     * Get offset bits
     */
    get offsetBits() {
      return this._reader.offset;
    }
    /**
     * Get remaining refs
     */
    get remainingRefs() {
      return this._refs.length - this._refsOffset;
    }
    /**
     * Get offset refs
     */
    get offsetRefs() {
      return this._refsOffset;
    }
    /**
     * Skip bits
     * @param bits
     */
    skip(v) {
      return this._reader.skip(v), this;
    }
    /**
     * Load a single bit
     * @returns true or false depending on the bit value
     */
    loadBit() {
      return this._reader.loadBit();
    }
    /**
     * Preload a signle bit
     * @returns true or false depending on the bit value
     */
    preloadBit() {
      return this._reader.preloadBit();
    }
    /**
     * Load a boolean
     * @returns true or false depending on the bit value
     */
    loadBoolean() {
      return this.loadBit();
    }
    /**
     * Load maybe boolean
     * @returns true or false depending on the bit value or null
     */
    loadMaybeBoolean() {
      return this.loadBit() ? this.loadBoolean() : null;
    }
    /**
     * Load bits as a new BitString
     * @param bits number of bits to read
     * @returns new BitString
     */
    loadBits(v) {
      return this._reader.loadBits(v);
    }
    /**
     * Preload bits as a new BitString
     * @param bits number of bits to read
     * @returns new BitString
     */
    preloadBits(v) {
      return this._reader.preloadBits(v);
    }
    /**
     * Load uint
     * @param bits number of bits to read
     * @returns uint value
     */
    loadUint(v) {
      return this._reader.loadUint(v);
    }
    /**
     * Load uint
     * @param bits number of bits to read
     * @returns uint value
     */
    loadUintBig(v) {
      return this._reader.loadUintBig(v);
    }
    /**
     * Preload uint
     * @param bits number of bits to read
     * @returns uint value
     */
    preloadUint(v) {
      return this._reader.preloadUint(v);
    }
    /**
     * Preload uint
     * @param bits number of bits to read
     * @returns uint value
     */
    preloadUintBig(v) {
      return this._reader.preloadUintBig(v);
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeUint(v) {
      return this.loadBit() ? this.loadUint(v) : null;
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeUintBig(v) {
      return this.loadBit() ? this.loadUintBig(v) : null;
    }
    /**
     * Load int
     * @param bits number of bits to read
     * @returns int value
     */
    loadInt(v) {
      return this._reader.loadInt(v);
    }
    /**
     * Load int
     * @param bits number of bits to read
     * @returns int value
     */
    loadIntBig(v) {
      return this._reader.loadIntBig(v);
    }
    /**
     * Preload int
     * @param bits number of bits to read
     * @returns int value
     */
    preloadInt(v) {
      return this._reader.preloadInt(v);
    }
    /**
     * Preload int
     * @param bits number of bits to read
     * @returns int value
     */
    preloadIntBig(v) {
      return this._reader.preloadIntBig(v);
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeInt(v) {
      return this.loadBit() ? this.loadInt(v) : null;
    }
    /**
     * Load maybe uint
     * @param bits number of bits to read
     * @returns uint value or null
     */
    loadMaybeIntBig(v) {
      return this.loadBit() ? this.loadIntBig(v) : null;
    }
    /**
     * Load varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    loadVarUint(v) {
      return this._reader.loadVarUint(v);
    }
    /**
     * Load varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    loadVarUintBig(v) {
      return this._reader.loadVarUintBig(v);
    }
    /**
     * Preload varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    preloadVarUint(v) {
      return this._reader.preloadVarUint(v);
    }
    /**
     * Preload varuint
     * @param bits number of bits to read in header
     * @returns varuint value
     */
    preloadVarUintBig(v) {
      return this._reader.preloadVarUintBig(v);
    }
    /**
     * Load varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    loadVarInt(v) {
      return this._reader.loadVarInt(v);
    }
    /**
     * Load varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    loadVarIntBig(v) {
      return this._reader.loadVarIntBig(v);
    }
    /**
     * Preload varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    preloadVarInt(v) {
      return this._reader.preloadVarInt(v);
    }
    /**
     * Preload varint
     * @param bits number of bits to read in header
     * @returns varint value
     */
    preloadVarIntBig(v) {
      return this._reader.preloadVarIntBig(v);
    }
    /**
     * Load coins
     * @returns coins value
     */
    loadCoins() {
      return this._reader.loadCoins();
    }
    /**
     * Preload coins
     * @returns coins value
     */
    preloadCoins() {
      return this._reader.preloadCoins();
    }
    /**
     * Load maybe coins
     * @returns coins value or null
     */
    loadMaybeCoins() {
      return this._reader.loadBit() ? this._reader.loadCoins() : null;
    }
    /**
     * Load internal Address
     * @returns Address
     */
    loadAddress() {
      return this._reader.loadAddress();
    }
    /**
     * Load optional internal Address
     * @returns Address or null
     */
    loadMaybeAddress() {
      return this._reader.loadMaybeAddress();
    }
    /**
     * Load external address
     * @returns ExternalAddress
     */
    loadExternalAddress() {
      return this._reader.loadExternalAddress();
    }
    /**
     * Load optional external address
     * @returns ExternalAddress or null
     */
    loadMaybeExternalAddress() {
      return this._reader.loadMaybeExternalAddress();
    }
    /**
     * Load address
     * @returns Address, ExternalAddress or null
     */
    loadAddressAny() {
      return this._reader.loadAddressAny();
    }
    /**
     * Load reference
     * @returns Cell
     */
    loadRef() {
      if (this._refsOffset >= this._refs.length)
        throw new Error("No more references");
      return this._refs[this._refsOffset++];
    }
    /**
     * Preload reference
     * @returns Cell
     */
    preloadRef() {
      if (this._refsOffset >= this._refs.length)
        throw new Error("No more references");
      return this._refs[this._refsOffset];
    }
    /**
     * Load optional reference
     * @returns Cell or null
     */
    loadMaybeRef() {
      return this.loadBit() ? this.loadRef() : null;
    }
    /**
     * Preload optional reference
     * @returns Cell or null
     */
    preloadMaybeRef() {
      return this.preloadBit() ? this.preloadRef() : null;
    }
    /**
     * Load byte buffer
     * @param bytes number of bytes to load
     * @returns Buffer
     */
    loadBuffer(v) {
      return this._reader.loadBuffer(v);
    }
    /**
     * Load byte buffer
     * @param bytes number of bytes to load
     * @returns Buffer
     */
    preloadBuffer(v) {
      return this._reader.preloadBuffer(v);
    }
    /**
     * Load string tail
     */
    loadStringTail() {
      return (0, a.readString)(this);
    }
    /**
     * Load maybe string tail
     * @returns string or null
     */
    loadMaybeStringTail() {
      return this.loadBit() ? (0, a.readString)(this) : null;
    }
    /**
     * Load string tail from ref
     * @returns string
     */
    loadStringRefTail() {
      return (0, a.readString)(this.loadRef().beginParse());
    }
    /**
     * Load maybe string tail from ref
     * @returns string or null
     */
    loadMaybeStringRefTail() {
      const v = this.loadMaybeRef();
      return v ? (0, a.readString)(v.beginParse()) : null;
    }
    /**
     * Loads dictionary
     * @param key key description
     * @param value value description
     * @returns Dictionary<K, V>
     */
    loadDict(v, m) {
      return i.Dictionary.load(v, m, this);
    }
    /**
     * Loads dictionary directly from current slice
     * @param key key description
     * @param value value description
     * @returns Dictionary<K, V>
     */
    loadDictDirect(v, m) {
      return i.Dictionary.loadDirect(v, m, this);
    }
    /**
     * Checks if slice is empty
     */
    endParse() {
      if (this.remainingBits > 0 || this.remainingRefs > 0)
        throw new Error("Slice is not empty");
    }
    /**
     * Convert slice to cell
     */
    asCell() {
      return (0, f.beginCell)().storeSlice(this).endCell();
    }
    /**
     *
     * @returns
     */
    asBuilder() {
      return (0, f.beginCell)().storeSlice(this);
    }
    /**
     * Clone slice
     * @returns cloned slice
     */
    clone(v = !1) {
      if (v) {
        let m = this._reader.clone();
        return m.reset(), new W1(m, this._refs);
      } else {
        let m = new W1(this._reader, this._refs);
        return m._refsOffset = this._refsOffset, m;
      }
    }
    /**
     * Print slice as string by converting it to cell
     * @returns string
     */
    toString() {
      return this.asCell().toString();
    }
  };
  return Oo.Slice = l, e = r.default, Oo;
}
var ac = {}, qn = {};
Object.defineProperty(qn, "__esModule", { value: !0 });
qn.BitReader = void 0;
const tC = hn, rC = lo;
class um {
  constructor(e, r = 0) {
    this._checkpoints = [], this._bits = e, this._offset = r;
  }
  /**
   * Offset in source bit string
   */
  get offset() {
    return this._offset;
  }
  /**
   * Number of bits remaining
   */
  get remaining() {
    return this._bits.length - this._offset;
  }
  /**
   * Skip bits
   * @param bits number of bits to skip
   */
  skip(e) {
    if (e < 0 || this._offset + e > this._bits.length)
      throw new Error(`Index ${this._offset + e} is out of bounds`);
    this._offset += e;
  }
  /**
   * Reset to the beginning or latest checkpoint
   */
  reset() {
    this._checkpoints.length > 0 ? this._offset = this._checkpoints.pop() : this._offset = 0;
  }
  /**
   * Save checkpoint
   */
  save() {
    this._checkpoints.push(this._offset);
  }
  /**
   * Load a single bit
   * @returns true if the bit is set, false otherwise
   */
  loadBit() {
    let e = this._bits.at(this._offset);
    return this._offset++, e;
  }
  /**
   * Preload bit
   * @returns true if the bit is set, false otherwise
   */
  preloadBit() {
    return this._bits.at(this._offset);
  }
  /**
   * Load bit string
   * @param bits number of bits to read
   * @returns new bitstring
   */
  loadBits(e) {
    let r = this._bits.substring(this._offset, e);
    return this._offset += e, r;
  }
  /**
   * Preload bit string
   * @param bits number of bits to read
   * @returns new bitstring
   */
  preloadBits(e) {
    return this._bits.substring(this._offset, e);
  }
  /**
   * Load buffer
   * @param bytes number of bytes
   * @returns new buffer
   */
  loadBuffer(e) {
    let r = this._preloadBuffer(e, this._offset);
    return this._offset += e * 8, r;
  }
  /**
   * Preload buffer
   * @param bytes number of bytes
   * @returns new buffer
   */
  preloadBuffer(e) {
    return this._preloadBuffer(e, this._offset);
  }
  /**
   * Load uint value
   * @param bits uint bits
   * @returns read value as number
   */
  loadUint(e) {
    return Number(this.loadUintBig(e));
  }
  /**
   * Load uint value as bigint
   * @param bits uint bits
   * @returns read value as bigint
   */
  loadUintBig(e) {
    let r = this.preloadUintBig(e);
    return this._offset += e, r;
  }
  /**
   * Preload uint value
   * @param bits uint bits
   * @returns read value as number
   */
  preloadUint(e) {
    return Number(this._preloadUint(e, this._offset));
  }
  /**
   * Preload uint value as bigint
   * @param bits uint bits
   * @returns read value as bigint
   */
  preloadUintBig(e) {
    return this._preloadUint(e, this._offset);
  }
  /**
   * Load int value
   * @param bits int bits
   * @returns read value as bigint
   */
  loadInt(e) {
    let r = this._preloadInt(e, this._offset);
    return this._offset += e, Number(r);
  }
  /**
   * Load int value as bigint
   * @param bits int bits
   * @returns read value as bigint
   */
  loadIntBig(e) {
    let r = this._preloadInt(e, this._offset);
    return this._offset += e, r;
  }
  /**
   * Preload int value
   * @param bits int bits
   * @returns read value as bigint
   */
  preloadInt(e) {
    return Number(this._preloadInt(e, this._offset));
  }
  /**
   * Preload int value
   * @param bits int bits
   * @returns read value as bigint
   */
  preloadIntBig(e) {
    return this._preloadInt(e, this._offset);
  }
  /**
   * Load varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarUint(e) {
    let r = Number(this.loadUint(e));
    return Number(this.loadUintBig(r * 8));
  }
  /**
   * Load varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarUintBig(e) {
    let r = Number(this.loadUint(e));
    return this.loadUintBig(r * 8);
  }
  /**
   * Preload varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarUint(e) {
    let r = Number(this._preloadUint(e, this._offset));
    return Number(this._preloadUint(r * 8, this._offset + e));
  }
  /**
   * Preload varuint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarUintBig(e) {
    let r = Number(this._preloadUint(e, this._offset));
    return this._preloadUint(r * 8, this._offset + e);
  }
  /**
   * Load varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarInt(e) {
    let r = Number(this.loadUint(e));
    return Number(this.loadIntBig(r * 8));
  }
  /**
   * Load varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  loadVarIntBig(e) {
    let r = Number(this.loadUint(e));
    return this.loadIntBig(r * 8);
  }
  /**
   * Preload varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarInt(e) {
    let r = Number(this._preloadUint(e, this._offset));
    return Number(this._preloadInt(r * 8, this._offset + e));
  }
  /**
   * Preload varint value
   * @param bits number of bits to read the size
   * @returns read value as bigint
   */
  preloadVarIntBig(e) {
    let r = Number(this._preloadUint(e, this._offset));
    return this._preloadInt(r * 8, this._offset + e);
  }
  /**
   * Load coins value
   * @returns read value as bigint
   */
  loadCoins() {
    return this.loadVarUintBig(4);
  }
  /**
   * Preload coins value
   * @returns read value as bigint
   */
  preloadCoins() {
    return this.preloadVarUintBig(4);
  }
  /**
   * Load Address
   * @returns Address
   */
  loadAddress() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 2)
      return this._loadInternalAddress();
    throw new Error("Invalid address: " + e);
  }
  /**
   * Load internal address
   * @returns Address or null
   */
  loadMaybeAddress() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 0)
      return this._offset += 2, null;
    if (e === 2)
      return this._loadInternalAddress();
    throw new Error("Invalid address");
  }
  /**
   * Load external address
   * @returns ExternalAddress
   */
  loadExternalAddress() {
    if (Number(this._preloadUint(2, this._offset)) === 1)
      return this._loadExternalAddress();
    throw new Error("Invalid address");
  }
  /**
   * Load external address
   * @returns ExternalAddress or null
   */
  loadMaybeExternalAddress() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 0)
      return this._offset += 2, null;
    if (e === 1)
      return this._loadExternalAddress();
    throw new Error("Invalid address");
  }
  /**
   * Read address of any type
   * @returns Address or ExternalAddress or null
   */
  loadAddressAny() {
    let e = Number(this._preloadUint(2, this._offset));
    if (e === 0)
      return this._offset += 2, null;
    if (e === 2)
      return this._loadInternalAddress();
    if (e === 1)
      return this._loadExternalAddress();
    throw Error(e === 3 ? "Unsupported" : "Unreachable");
  }
  /**
   * Load bit string that was padded to make it byte alligned. Used in BOC serialization
   * @param bytes number of bytes to read
   */
  loadPaddedBits(e) {
    if (e % 8 !== 0)
      throw new Error("Invalid number of bits");
    let r = e;
    for (; ; )
      if (this._bits.at(this._offset + r - 1)) {
        r--;
        break;
      } else
        r--;
    let i = this._bits.substring(this._offset, r);
    return this._offset += e, i;
  }
  /**
   * Clone BitReader
   */
  clone() {
    return new um(this._bits, this._offset);
  }
  /**
   * Preload int from specific offset
   * @param bits bits to preload
   * @param offset offset to start from
   * @returns read value as bigint
   */
  _preloadInt(e, r) {
    if (e == 0)
      return 0n;
    let i = this._bits.at(r), f = 0n;
    for (let a = 0; a < e - 1; a++)
      this._bits.at(r + 1 + a) && (f += 1n << BigInt(e - a - 1 - 1));
    return i && (f = f - (1n << BigInt(e - 1))), f;
  }
  /**
   * Preload uint from specific offset
   * @param bits bits to preload
   * @param offset offset to start from
   * @returns read value as bigint
   */
  _preloadUint(e, r) {
    if (e == 0)
      return 0n;
    let i = 0n;
    for (let f = 0; f < e; f++)
      this._bits.at(r + f) && (i += 1n << BigInt(e - f - 1));
    return i;
  }
  _preloadBuffer(e, r) {
    let i = this._bits.subbuffer(r, e * 8);
    if (i)
      return i;
    let f = Je.alloc(e);
    for (let a = 0; a < e; a++)
      f[a] = Number(this._preloadUint(8, r + a * 8));
    return f;
  }
  _loadInternalAddress() {
    if (Number(this._preloadUint(2, this._offset)) !== 2 || this._preloadUint(1, this._offset + 2) !== 0n)
      throw Error("Invalid address");
    let r = Number(this._preloadInt(8, this._offset + 3)), i = this._preloadBuffer(32, this._offset + 11);
    return this._offset += 267, new tC.Address(r, i);
  }
  _loadExternalAddress() {
    if (Number(this._preloadUint(2, this._offset)) !== 1)
      throw Error("Invalid address");
    let r = Number(this._preloadUint(9, this._offset + 2)), i = this._preloadUint(r, this._offset + 11);
    return this._offset += 11 + r, new rC.ExternalAddress(i, r);
  }
}
qn.BitReader = um;
var zf = {};
Object.defineProperty(zf, "__esModule", { value: !0 });
zf.exoticLibrary = void 0;
const nC = qn;
function iC(t, e) {
  const r = new nC.BitReader(t);
  if (t.length !== 264)
    throw new Error(`Library cell must have exactly (8 + 256) bits, got "${t.length}"`);
  let f = r.loadUint(8);
  if (f !== 2)
    throw new Error(`Library cell must have type 2, got "${f}"`);
  return {};
}
zf.exoticLibrary = iC;
var co = {};
Object.defineProperty(co, "__esModule", { value: !0 });
co.exoticMerkleProof = void 0;
const aC = qn;
function sC(t, e) {
  const r = new aC.BitReader(t);
  if (t.length !== 280)
    throw new Error(`Merkle Proof cell must have exactly (8 + 256 + 16) bits, got "${t.length}"`);
  if (e.length !== 1)
    throw new Error(`Merkle Proof cell must have exactly 1 ref, got "${e.length}"`);
  let f = r.loadUint(8);
  if (f !== 3)
    throw new Error(`Merkle Proof cell must have type 3, got "${f}"`);
  const a = r.loadBuffer(32), l = r.loadUint(16), d = e[0].hash(0), v = e[0].depth(0);
  if (l !== v)
    throw new Error(`Merkle Proof cell ref depth must be exactly "${l}", got "${v}"`);
  if (!a.equals(d))
    throw new Error(`Merkle Proof cell ref hash must be exactly "${a.toString("hex")}", got "${d.toString("hex")}"`);
  return {
    proofDepth: l,
    proofHash: a
  };
}
co.exoticMerkleProof = sC;
var ho = {};
Object.defineProperty(ho, "__esModule", { value: !0 });
ho.exoticMerkleUpdate = void 0;
const oC = qn;
function fC(t, e) {
  const r = new oC.BitReader(t), i = 8 + 2 * 272;
  if (t.length !== i)
    throw new Error(`Merkle Update cell must have exactly (8 + (2 * (256 + 16))) bits, got "${t.length}"`);
  if (e.length !== 2)
    throw new Error(`Merkle Update cell must have exactly 2 refs, got "${e.length}"`);
  let f = r.loadUint(8);
  if (f !== 4)
    throw new Error(`Merkle Update cell type must be exactly 4, got "${f}"`);
  const a = r.loadBuffer(32), l = r.loadBuffer(32), d = r.loadUint(16), v = r.loadUint(16);
  if (d !== e[0].depth(0))
    throw new Error(`Merkle Update cell ref depth must be exactly "${d}", got "${e[0].depth(0)}"`);
  if (!a.equals(e[0].hash(0)))
    throw new Error(`Merkle Update cell ref hash must be exactly "${a.toString("hex")}", got "${e[0].hash(0).toString("hex")}"`);
  if (v !== e[1].depth(0))
    throw new Error(`Merkle Update cell ref depth must be exactly "${v}", got "${e[1].depth(0)}"`);
  if (!l.equals(e[1].hash(0)))
    throw new Error(`Merkle Update cell ref hash must be exactly "${l.toString("hex")}", got "${e[1].hash(0).toString("hex")}"`);
  return {
    proofDepth1: d,
    proofDepth2: v,
    proofHash1: a,
    proofHash2: l
  };
}
ho.exoticMerkleUpdate = fC;
var po = {}, vo = {};
Object.defineProperty(vo, "__esModule", { value: !0 });
vo.LevelMask = void 0;
class lm {
  constructor(e = 0) {
    this._mask = 0, this._mask = e, this._hashIndex = uC(this._mask), this._hashCount = this._hashIndex + 1;
  }
  get value() {
    return this._mask;
  }
  get level() {
    return 32 - Math.clz32(this._mask);
  }
  get hashIndex() {
    return this._hashIndex;
  }
  get hashCount() {
    return this._hashCount;
  }
  apply(e) {
    return new lm(this._mask & (1 << e) - 1);
  }
  isSignificant(e) {
    return e === 0 || (this._mask >> e - 1) % 2 !== 0;
  }
}
vo.LevelMask = lm;
function uC(t) {
  return t = t - (t >> 1 & 1431655765), t = (t & 858993459) + (t >> 2 & 858993459), (t + (t >> 4) & 252645135) * 16843009 >> 24;
}
Object.defineProperty(po, "__esModule", { value: !0 });
po.exoticPruned = void 0;
const lC = qn, lb = vo;
function cC(t, e) {
  let r = new lC.BitReader(t), i = r.loadUint(8);
  if (i !== 1)
    throw new Error(`Pruned branch cell must have type 1, got "${i}"`);
  if (e.length !== 0)
    throw new Error(`Pruned Branch cell can't has refs, got "${e.length}"`);
  let f;
  if (t.length === 280)
    f = new lb.LevelMask(1);
  else {
    if (f = new lb.LevelMask(r.loadUint(8)), f.level < 1 || f.level > 3)
      throw new Error(`Pruned Branch cell level must be >= 1 and <= 3, got "${f.level}/${f.value}"`);
    const v = 16 + f.apply(f.level - 1).hashCount * 272;
    if (t.length !== v)
      throw new Error(`Pruned branch cell must have exactly ${v} bits, got "${t.length}"`);
  }
  let a = [], l = [], d = [];
  for (let v = 0; v < f.level; v++)
    l.push(r.loadBuffer(32));
  for (let v = 0; v < f.level; v++)
    d.push(r.loadUint(16));
  for (let v = 0; v < f.level; v++)
    a.push({
      depth: d[v],
      hash: l[v]
    });
  return {
    mask: f.value,
    pruned: a
  };
}
po.exoticPruned = cC;
Object.defineProperty(ac, "__esModule", { value: !0 });
ac.resolveExotic = void 0;
const dC = qn, sc = va, hC = zf, pC = co, vC = ho, mC = po, oc = vo;
function gC(t, e) {
  let r = (0, mC.exoticPruned)(t, e), i = [], f = [], a = new oc.LevelMask(r.mask);
  for (let l = 0; l < r.pruned.length; l++)
    i.push(r.pruned[l].depth), f.push(r.pruned[l].hash);
  return {
    type: sc.CellType.PrunedBranch,
    depths: i,
    hashes: f,
    mask: a
  };
}
function yC(t, e) {
  (0, hC.exoticLibrary)(t, e);
  let r = [], i = [], f = new oc.LevelMask();
  return {
    type: sc.CellType.Library,
    depths: r,
    hashes: i,
    mask: f
  };
}
function bC(t, e) {
  (0, pC.exoticMerkleProof)(t, e);
  let r = [], i = [], f = new oc.LevelMask(e[0].level() >> 1);
  return {
    type: sc.CellType.MerkleProof,
    depths: r,
    hashes: i,
    mask: f
  };
}
function wC(t, e) {
  (0, vC.exoticMerkleUpdate)(t, e);
  let r = [], i = [], f = new oc.LevelMask((e[0].level() | e[1].level()) >> 1);
  return {
    type: sc.CellType.MerkleUpdate,
    depths: r,
    hashes: i,
    mask: f
  };
}
function _C(t, e) {
  let i = new dC.BitReader(t).preloadUint(8);
  if (i === 1)
    return gC(t, e);
  if (i === 2)
    return yC(t, e);
  if (i === 3)
    return bC(t, e);
  if (i === 4)
    return wC(t, e);
  throw Error("Invalid exotic cell type: " + i);
}
ac.resolveExotic = _C;
var fc = {}, xi = {};
Object.defineProperty(xi, "__esModule", { value: !0 });
xi.getRepr = xi.getBitsDescriptor = xi.getRefsDescriptor = void 0;
const sf = va, xC = ec();
function v8(t, e, r) {
  return t.length + (r !== sf.CellType.Ordinary ? 1 : 0) * 8 + e * 32;
}
xi.getRefsDescriptor = v8;
function m8(t) {
  let e = t.length;
  return Math.ceil(e / 8) + Math.floor(e / 8);
}
xi.getBitsDescriptor = m8;
function MC(t, e, r, i, f, a) {
  const l = Math.ceil(e.length / 8), d = Je.alloc(2 + l + 34 * r.length);
  let v = 0;
  d[v++] = v8(r, f, a), d[v++] = m8(t), (0, xC.bitsToPaddedBuffer)(e).copy(d, v), v += l;
  for (const m of r) {
    let h;
    a == sf.CellType.MerkleProof || a == sf.CellType.MerkleUpdate ? h = m.depth(i + 1) : h = m.depth(i), d[v++] = Math.floor(h / 256), d[v++] = h % 256;
  }
  for (const m of r) {
    let h;
    a == sf.CellType.MerkleProof || a == sf.CellType.MerkleUpdate ? h = m.hash(i + 1) : h = m.hash(i), h.copy(d, v), v += 32;
  }
  return d;
}
xi.getRepr = MC;
var Nd = {}, Yi = {}, g8 = { exports: {} };
(function(t, e) {
  (function(r, i) {
    t.exports = i();
  })(ut, function() {
    var r = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
    function i(oe, le, ie, fe) {
      var Te, N, R, L = le || [0], V = (ie = ie || 0) >>> 3, ne = fe === -1 ? 3 : 0;
      for (Te = 0; Te < oe.length; Te += 1)
        N = (R = Te + V) >>> 2, L.length <= N && L.push(0), L[N] |= oe[Te] << 8 * (ne + fe * (R % 4));
      return { value: L, binLen: 8 * oe.length + ie };
    }
    function f(oe, le, ie) {
      switch (le) {
        case "UTF8":
        case "UTF16BE":
        case "UTF16LE":
          break;
        default:
          throw new Error("encoding must be UTF8, UTF16BE, or UTF16LE");
      }
      switch (oe) {
        case "HEX":
          return function(fe, Te, N) {
            return function(R, L, V, ne) {
              var Se, ue, xe, He;
              if (R.length % 2 != 0)
                throw new Error("String of HEX type must be in byte increments");
              var be = L || [0], Ie = (V = V || 0) >>> 3, rt = ne === -1 ? 3 : 0;
              for (Se = 0; Se < R.length; Se += 2) {
                if (ue = parseInt(R.substr(Se, 2), 16), isNaN(ue))
                  throw new Error("String of HEX type contains invalid characters");
                for (xe = (He = (Se >>> 1) + Ie) >>> 2; be.length <= xe; )
                  be.push(0);
                be[xe] |= ue << 8 * (rt + ne * (He % 4));
              }
              return { value: be, binLen: 4 * R.length + V };
            }(fe, Te, N, ie);
          };
        case "TEXT":
          return function(fe, Te, N) {
            return function(R, L, V, ne, Se) {
              var ue, xe, He, be, Ie, rt, Ne, ze, kt = 0, Le = V || [0], $e = (ne = ne || 0) >>> 3;
              if (L === "UTF8")
                for (Ne = Se === -1 ? 3 : 0, He = 0; He < R.length; He += 1)
                  for (xe = [], 128 > (ue = R.charCodeAt(He)) ? xe.push(ue) : 2048 > ue ? (xe.push(192 | ue >>> 6), xe.push(128 | 63 & ue)) : 55296 > ue || 57344 <= ue ? xe.push(224 | ue >>> 12, 128 | ue >>> 6 & 63, 128 | 63 & ue) : (He += 1, ue = 65536 + ((1023 & ue) << 10 | 1023 & R.charCodeAt(He)), xe.push(240 | ue >>> 18, 128 | ue >>> 12 & 63, 128 | ue >>> 6 & 63, 128 | 63 & ue)), be = 0; be < xe.length; be += 1) {
                    for (Ie = (rt = kt + $e) >>> 2; Le.length <= Ie; )
                      Le.push(0);
                    Le[Ie] |= xe[be] << 8 * (Ne + Se * (rt % 4)), kt += 1;
                  }
              else
                for (Ne = Se === -1 ? 2 : 0, ze = L === "UTF16LE" && Se !== 1 || L !== "UTF16LE" && Se === 1, He = 0; He < R.length; He += 1) {
                  for (ue = R.charCodeAt(He), ze === !0 && (ue = (be = 255 & ue) << 8 | ue >>> 8), Ie = (rt = kt + $e) >>> 2; Le.length <= Ie; )
                    Le.push(0);
                  Le[Ie] |= ue << 8 * (Ne + Se * (rt % 4)), kt += 2;
                }
              return { value: Le, binLen: 8 * kt + ne };
            }(fe, le, Te, N, ie);
          };
        case "B64":
          return function(fe, Te, N) {
            return function(R, L, V, ne) {
              var Se, ue, xe, He, be, Ie, rt = 0, Ne = L || [0], ze = (V = V || 0) >>> 3, kt = ne === -1 ? 3 : 0, Le = R.indexOf("=");
              if (R.search(/^[a-zA-Z0-9=+/]+$/) === -1)
                throw new Error("Invalid character in base-64 string");
              if (R = R.replace(/=/g, ""), Le !== -1 && Le < R.length)
                throw new Error("Invalid '=' found in base-64 string");
              for (Se = 0; Se < R.length; Se += 4) {
                for (He = R.substr(Se, 4), xe = 0, ue = 0; ue < He.length; ue += 1)
                  xe |= r.indexOf(He.charAt(ue)) << 18 - 6 * ue;
                for (ue = 0; ue < He.length - 1; ue += 1) {
                  for (be = (Ie = rt + ze) >>> 2; Ne.length <= be; )
                    Ne.push(0);
                  Ne[be] |= (xe >>> 16 - 8 * ue & 255) << 8 * (kt + ne * (Ie % 4)), rt += 1;
                }
              }
              return { value: Ne, binLen: 8 * rt + V };
            }(fe, Te, N, ie);
          };
        case "BYTES":
          return function(fe, Te, N) {
            return function(R, L, V, ne) {
              var Se, ue, xe, He, be = L || [0], Ie = (V = V || 0) >>> 3, rt = ne === -1 ? 3 : 0;
              for (ue = 0; ue < R.length; ue += 1)
                Se = R.charCodeAt(ue), xe = (He = ue + Ie) >>> 2, be.length <= xe && be.push(0), be[xe] |= Se << 8 * (rt + ne * (He % 4));
              return { value: be, binLen: 8 * R.length + V };
            }(fe, Te, N, ie);
          };
        case "ARRAYBUFFER":
          try {
            new ArrayBuffer(0);
          } catch {
            throw new Error("ARRAYBUFFER not supported by this environment");
          }
          return function(fe, Te, N) {
            return function(R, L, V, ne) {
              return i(new Uint8Array(R), L, V, ne);
            }(fe, Te, N, ie);
          };
        case "UINT8ARRAY":
          try {
            new Uint8Array(0);
          } catch {
            throw new Error("UINT8ARRAY not supported by this environment");
          }
          return function(fe, Te, N) {
            return i(fe, Te, N, ie);
          };
        default:
          throw new Error("format must be HEX, TEXT, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
      }
    }
    function a(oe, le, ie, fe) {
      switch (oe) {
        case "HEX":
          return function(Te) {
            return function(N, R, L, V) {
              var ne, Se, ue = "", xe = R / 8, He = L === -1 ? 3 : 0;
              for (ne = 0; ne < xe; ne += 1)
                Se = N[ne >>> 2] >>> 8 * (He + L * (ne % 4)), ue += "0123456789abcdef".charAt(Se >>> 4 & 15) + "0123456789abcdef".charAt(15 & Se);
              return V.outputUpper ? ue.toUpperCase() : ue;
            }(Te, le, ie, fe);
          };
        case "B64":
          return function(Te) {
            return function(N, R, L, V) {
              var ne, Se, ue, xe, He, be = "", Ie = R / 8, rt = L === -1 ? 3 : 0;
              for (ne = 0; ne < Ie; ne += 3)
                for (xe = ne + 1 < Ie ? N[ne + 1 >>> 2] : 0, He = ne + 2 < Ie ? N[ne + 2 >>> 2] : 0, ue = (N[ne >>> 2] >>> 8 * (rt + L * (ne % 4)) & 255) << 16 | (xe >>> 8 * (rt + L * ((ne + 1) % 4)) & 255) << 8 | He >>> 8 * (rt + L * ((ne + 2) % 4)) & 255, Se = 0; Se < 4; Se += 1)
                  be += 8 * ne + 6 * Se <= R ? r.charAt(ue >>> 6 * (3 - Se) & 63) : V.b64Pad;
              return be;
            }(Te, le, ie, fe);
          };
        case "BYTES":
          return function(Te) {
            return function(N, R, L) {
              var V, ne, Se = "", ue = R / 8, xe = L === -1 ? 3 : 0;
              for (V = 0; V < ue; V += 1)
                ne = N[V >>> 2] >>> 8 * (xe + L * (V % 4)) & 255, Se += String.fromCharCode(ne);
              return Se;
            }(Te, le, ie);
          };
        case "ARRAYBUFFER":
          try {
            new ArrayBuffer(0);
          } catch {
            throw new Error("ARRAYBUFFER not supported by this environment");
          }
          return function(Te) {
            return function(N, R, L) {
              var V, ne = R / 8, Se = new ArrayBuffer(ne), ue = new Uint8Array(Se), xe = L === -1 ? 3 : 0;
              for (V = 0; V < ne; V += 1)
                ue[V] = N[V >>> 2] >>> 8 * (xe + L * (V % 4)) & 255;
              return Se;
            }(Te, le, ie);
          };
        case "UINT8ARRAY":
          try {
            new Uint8Array(0);
          } catch {
            throw new Error("UINT8ARRAY not supported by this environment");
          }
          return function(Te) {
            return function(N, R, L) {
              var V, ne = R / 8, Se = L === -1 ? 3 : 0, ue = new Uint8Array(ne);
              for (V = 0; V < ne; V += 1)
                ue[V] = N[V >>> 2] >>> 8 * (Se + L * (V % 4)) & 255;
              return ue;
            }(Te, le, ie);
          };
        default:
          throw new Error("format must be HEX, B64, BYTES, ARRAYBUFFER, or UINT8ARRAY");
      }
    }
    var l = [1116352408, 1899447441, 3049323471, 3921009573, 961987163, 1508970993, 2453635748, 2870763221, 3624381080, 310598401, 607225278, 1426881987, 1925078388, 2162078206, 2614888103, 3248222580, 3835390401, 4022224774, 264347078, 604807628, 770255983, 1249150122, 1555081692, 1996064986, 2554220882, 2821834349, 2952996808, 3210313671, 3336571891, 3584528711, 113926993, 338241895, 666307205, 773529912, 1294757372, 1396182291, 1695183700, 1986661051, 2177026350, 2456956037, 2730485921, 2820302411, 3259730800, 3345764771, 3516065817, 3600352804, 4094571909, 275423344, 430227734, 506948616, 659060556, 883997877, 958139571, 1322822218, 1537002063, 1747873779, 1955562222, 2024104815, 2227730452, 2361852424, 2428436474, 2756734187, 3204031479, 3329325298], d = [3238371032, 914150663, 812702999, 4144912697, 4290775857, 1750603025, 1694076839, 3204075428], v = [1779033703, 3144134277, 1013904242, 2773480762, 1359893119, 2600822924, 528734635, 1541459225], m = "Chosen SHA variant is not supported";
    function h(oe, le) {
      var ie, fe, Te = oe.binLen >>> 3, N = le.binLen >>> 3, R = Te << 3, L = 4 - Te << 3;
      if (Te % 4 != 0) {
        for (ie = 0; ie < N; ie += 4)
          fe = Te + ie >>> 2, oe.value[fe] |= le.value[ie >>> 2] << R, oe.value.push(0), oe.value[fe + 1] |= le.value[ie >>> 2] >>> L;
        return (oe.value.length << 2) - 4 >= N + Te && oe.value.pop(), { value: oe.value, binLen: oe.binLen + le.binLen };
      }
      return { value: oe.value.concat(le.value), binLen: oe.binLen + le.binLen };
    }
    function w(oe) {
      var le = { outputUpper: !1, b64Pad: "=", outputLen: -1 }, ie = oe || {}, fe = "Output length must be a multiple of 8";
      if (le.outputUpper = ie.outputUpper || !1, ie.b64Pad && (le.b64Pad = ie.b64Pad), ie.outputLen) {
        if (ie.outputLen % 8 != 0)
          throw new Error(fe);
        le.outputLen = ie.outputLen;
      } else if (ie.shakeLen) {
        if (ie.shakeLen % 8 != 0)
          throw new Error(fe);
        le.outputLen = ie.shakeLen;
      }
      if (typeof le.outputUpper != "boolean")
        throw new Error("Invalid outputUpper formatting option");
      if (typeof le.b64Pad != "string")
        throw new Error("Invalid b64Pad formatting option");
      return le;
    }
    function M(oe, le, ie, fe) {
      var Te = oe + " must include a value and format";
      if (!le) {
        if (!fe)
          throw new Error(Te);
        return fe;
      }
      if (le.value === void 0 || !le.format)
        throw new Error(Te);
      return f(le.format, le.encoding || "UTF8", ie)(le.value);
    }
    var S = function() {
      function oe(le, ie, fe) {
        var Te = fe || {};
        if (this.t = ie, this.i = Te.encoding || "UTF8", this.numRounds = Te.numRounds || 1, isNaN(this.numRounds) || this.numRounds !== parseInt(this.numRounds, 10) || 1 > this.numRounds)
          throw new Error("numRounds must a integer >= 1");
        this.o = le, this.u = [], this.s = 0, this.h = !1, this.v = 0, this.A = !1, this.l = [], this.H = [];
      }
      return oe.prototype.update = function(le) {
        var ie, fe = 0, Te = this.S >>> 5, N = this.p(le, this.u, this.s), R = N.binLen, L = N.value, V = R >>> 5;
        for (ie = 0; ie < V; ie += Te)
          fe + this.S <= R && (this.m = this.R(L.slice(ie, ie + Te), this.m), fe += this.S);
        this.v += fe, this.u = L.slice(fe >>> 5), this.s = R % this.S, this.h = !0;
      }, oe.prototype.getHash = function(le, ie) {
        var fe, Te, N = this.U, R = w(ie);
        if (this.T) {
          if (R.outputLen === -1)
            throw new Error("Output length must be specified in options");
          N = R.outputLen;
        }
        var L = a(le, N, this.C, R);
        if (this.A && this.F)
          return L(this.F(R));
        for (Te = this.K(this.u.slice(), this.s, this.v, this.B(this.m), N), fe = 1; fe < this.numRounds; fe += 1)
          this.T && N % 32 != 0 && (Te[Te.length - 1] &= 16777215 >>> 24 - N % 32), Te = this.K(Te, N, 0, this.L(this.o), N);
        return L(Te);
      }, oe.prototype.setHMACKey = function(le, ie, fe) {
        if (!this.g)
          throw new Error("Variant does not support HMAC");
        if (this.h)
          throw new Error("Cannot set MAC key after calling update");
        var Te = f(ie, (fe || {}).encoding || "UTF8", this.C);
        this.k(Te(le));
      }, oe.prototype.k = function(le) {
        var ie, fe = this.S >>> 3, Te = fe / 4 - 1;
        if (this.numRounds !== 1)
          throw new Error("Cannot set numRounds with MAC");
        if (this.A)
          throw new Error("MAC key already set");
        for (fe < le.binLen / 8 && (le.value = this.K(le.value, le.binLen, 0, this.L(this.o), this.U)); le.value.length <= Te; )
          le.value.push(0);
        for (ie = 0; ie <= Te; ie += 1)
          this.l[ie] = 909522486 ^ le.value[ie], this.H[ie] = 1549556828 ^ le.value[ie];
        this.m = this.R(this.l, this.m), this.v = this.S, this.A = !0;
      }, oe.prototype.getHMAC = function(le, ie) {
        var fe = w(ie);
        return a(le, this.U, this.C, fe)(this.Y());
      }, oe.prototype.Y = function() {
        var le;
        if (!this.A)
          throw new Error("Cannot call getHMAC without first setting MAC key");
        var ie = this.K(this.u.slice(), this.s, this.v, this.B(this.m), this.U);
        return le = this.R(this.H, this.L(this.o)), le = this.K(ie, this.U, this.S, le, this.U);
      }, oe;
    }(), E = function(oe, le) {
      return (E = Object.setPrototypeOf || { __proto__: [] } instanceof Array && function(ie, fe) {
        ie.__proto__ = fe;
      } || function(ie, fe) {
        for (var Te in fe)
          Object.prototype.hasOwnProperty.call(fe, Te) && (ie[Te] = fe[Te]);
      })(oe, le);
    };
    function A(oe, le) {
      function ie() {
        this.constructor = oe;
      }
      E(oe, le), oe.prototype = le === null ? Object.create(le) : (ie.prototype = le.prototype, new ie());
    }
    function B(oe, le) {
      return oe << le | oe >>> 32 - le;
    }
    function k(oe, le) {
      return oe >>> le | oe << 32 - le;
    }
    function C(oe, le) {
      return oe >>> le;
    }
    function I(oe, le, ie) {
      return oe ^ le ^ ie;
    }
    function O(oe, le, ie) {
      return oe & le ^ ~oe & ie;
    }
    function q(oe, le, ie) {
      return oe & le ^ oe & ie ^ le & ie;
    }
    function $(oe) {
      return k(oe, 2) ^ k(oe, 13) ^ k(oe, 22);
    }
    function ae(oe, le) {
      var ie = (65535 & oe) + (65535 & le);
      return (65535 & (oe >>> 16) + (le >>> 16) + (ie >>> 16)) << 16 | 65535 & ie;
    }
    function he(oe, le, ie, fe) {
      var Te = (65535 & oe) + (65535 & le) + (65535 & ie) + (65535 & fe);
      return (65535 & (oe >>> 16) + (le >>> 16) + (ie >>> 16) + (fe >>> 16) + (Te >>> 16)) << 16 | 65535 & Te;
    }
    function te(oe, le, ie, fe, Te) {
      var N = (65535 & oe) + (65535 & le) + (65535 & ie) + (65535 & fe) + (65535 & Te);
      return (65535 & (oe >>> 16) + (le >>> 16) + (ie >>> 16) + (fe >>> 16) + (Te >>> 16) + (N >>> 16)) << 16 | 65535 & N;
    }
    function Ee(oe) {
      return k(oe, 7) ^ k(oe, 18) ^ C(oe, 3);
    }
    function x(oe) {
      return k(oe, 6) ^ k(oe, 11) ^ k(oe, 25);
    }
    function n(oe) {
      return [1732584193, 4023233417, 2562383102, 271733878, 3285377520];
    }
    function o(oe, le) {
      var ie, fe, Te, N, R, L, V, ne = [];
      for (ie = le[0], fe = le[1], Te = le[2], N = le[3], R = le[4], V = 0; V < 80; V += 1)
        ne[V] = V < 16 ? oe[V] : B(ne[V - 3] ^ ne[V - 8] ^ ne[V - 14] ^ ne[V - 16], 1), L = V < 20 ? te(B(ie, 5), O(fe, Te, N), R, 1518500249, ne[V]) : V < 40 ? te(B(ie, 5), I(fe, Te, N), R, 1859775393, ne[V]) : V < 60 ? te(B(ie, 5), q(fe, Te, N), R, 2400959708, ne[V]) : te(B(ie, 5), I(fe, Te, N), R, 3395469782, ne[V]), R = N, N = Te, Te = B(fe, 30), fe = ie, ie = L;
      return le[0] = ae(ie, le[0]), le[1] = ae(fe, le[1]), le[2] = ae(Te, le[2]), le[3] = ae(N, le[3]), le[4] = ae(R, le[4]), le;
    }
    function u(oe, le, ie, fe) {
      for (var Te, N = 15 + (le + 65 >>> 9 << 4), R = le + ie; oe.length <= N; )
        oe.push(0);
      for (oe[le >>> 5] |= 128 << 24 - le % 32, oe[N] = 4294967295 & R, oe[N - 1] = R / 4294967296 | 0, Te = 0; Te < oe.length; Te += 16)
        fe = o(oe.slice(Te, Te + 16), fe);
      return fe;
    }
    var c = function(oe) {
      function le(ie, fe, Te) {
        var N = this;
        if (ie !== "SHA-1")
          throw new Error(m);
        var R = Te || {};
        return (N = oe.call(this, ie, fe, Te) || this).g = !0, N.F = N.Y, N.C = -1, N.p = f(N.t, N.i, N.C), N.R = o, N.B = function(L) {
          return L.slice();
        }, N.L = n, N.K = u, N.m = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], N.S = 512, N.U = 160, N.T = !1, R.hmacKey && N.k(M("hmacKey", R.hmacKey, N.C)), N;
      }
      return A(le, oe), le;
    }(S);
    function g(oe) {
      return oe == "SHA-224" ? d.slice() : v.slice();
    }
    function b(oe, le) {
      var ie, fe, Te, N, R, L, V, ne, Se, ue, xe, He, be = [];
      for (ie = le[0], fe = le[1], Te = le[2], N = le[3], R = le[4], L = le[5], V = le[6], ne = le[7], xe = 0; xe < 64; xe += 1)
        be[xe] = xe < 16 ? oe[xe] : he(k(He = be[xe - 2], 17) ^ k(He, 19) ^ C(He, 10), be[xe - 7], Ee(be[xe - 15]), be[xe - 16]), Se = te(ne, x(R), O(R, L, V), l[xe], be[xe]), ue = ae($(ie), q(ie, fe, Te)), ne = V, V = L, L = R, R = ae(N, Se), N = Te, Te = fe, fe = ie, ie = ae(Se, ue);
      return le[0] = ae(ie, le[0]), le[1] = ae(fe, le[1]), le[2] = ae(Te, le[2]), le[3] = ae(N, le[3]), le[4] = ae(R, le[4]), le[5] = ae(L, le[5]), le[6] = ae(V, le[6]), le[7] = ae(ne, le[7]), le;
    }
    var _ = function(oe) {
      function le(ie, fe, Te) {
        var N = this;
        if (ie !== "SHA-224" && ie !== "SHA-256")
          throw new Error(m);
        var R = Te || {};
        return (N = oe.call(this, ie, fe, Te) || this).F = N.Y, N.g = !0, N.C = -1, N.p = f(N.t, N.i, N.C), N.R = b, N.B = function(L) {
          return L.slice();
        }, N.L = g, N.K = function(L, V, ne, Se) {
          return function(ue, xe, He, be, Ie) {
            for (var rt, Ne = 15 + (xe + 65 >>> 9 << 4), ze = xe + He; ue.length <= Ne; )
              ue.push(0);
            for (ue[xe >>> 5] |= 128 << 24 - xe % 32, ue[Ne] = 4294967295 & ze, ue[Ne - 1] = ze / 4294967296 | 0, rt = 0; rt < ue.length; rt += 16)
              be = b(ue.slice(rt, rt + 16), be);
            return Ie === "SHA-224" ? [be[0], be[1], be[2], be[3], be[4], be[5], be[6]] : be;
          }(L, V, ne, Se, ie);
        }, N.m = g(ie), N.S = 512, N.U = ie === "SHA-224" ? 224 : 256, N.T = !1, R.hmacKey && N.k(M("hmacKey", R.hmacKey, N.C)), N;
      }
      return A(le, oe), le;
    }(S), p = function(oe, le) {
      this.N = oe, this.I = le;
    };
    function s(oe, le) {
      var ie;
      return le > 32 ? (ie = 64 - le, new p(oe.I << le | oe.N >>> ie, oe.N << le | oe.I >>> ie)) : le !== 0 ? (ie = 32 - le, new p(oe.N << le | oe.I >>> ie, oe.I << le | oe.N >>> ie)) : oe;
    }
    function y(oe, le) {
      var ie;
      return le < 32 ? (ie = 32 - le, new p(oe.N >>> le | oe.I << ie, oe.I >>> le | oe.N << ie)) : (ie = 64 - le, new p(oe.I >>> le | oe.N << ie, oe.N >>> le | oe.I << ie));
    }
    function T(oe, le) {
      return new p(oe.N >>> le, oe.I >>> le | oe.N << 32 - le);
    }
    function P(oe, le, ie) {
      return new p(oe.N & le.N ^ ~oe.N & ie.N, oe.I & le.I ^ ~oe.I & ie.I);
    }
    function z(oe, le, ie) {
      return new p(oe.N & le.N ^ oe.N & ie.N ^ le.N & ie.N, oe.I & le.I ^ oe.I & ie.I ^ le.I & ie.I);
    }
    function J(oe) {
      var le = y(oe, 28), ie = y(oe, 34), fe = y(oe, 39);
      return new p(le.N ^ ie.N ^ fe.N, le.I ^ ie.I ^ fe.I);
    }
    function Z(oe, le) {
      var ie, fe;
      ie = (65535 & oe.I) + (65535 & le.I);
      var Te = (65535 & (fe = (oe.I >>> 16) + (le.I >>> 16) + (ie >>> 16))) << 16 | 65535 & ie;
      return ie = (65535 & oe.N) + (65535 & le.N) + (fe >>> 16), fe = (oe.N >>> 16) + (le.N >>> 16) + (ie >>> 16), new p((65535 & fe) << 16 | 65535 & ie, Te);
    }
    function F(oe, le, ie, fe) {
      var Te, N;
      Te = (65535 & oe.I) + (65535 & le.I) + (65535 & ie.I) + (65535 & fe.I);
      var R = (65535 & (N = (oe.I >>> 16) + (le.I >>> 16) + (ie.I >>> 16) + (fe.I >>> 16) + (Te >>> 16))) << 16 | 65535 & Te;
      return Te = (65535 & oe.N) + (65535 & le.N) + (65535 & ie.N) + (65535 & fe.N) + (N >>> 16), N = (oe.N >>> 16) + (le.N >>> 16) + (ie.N >>> 16) + (fe.N >>> 16) + (Te >>> 16), new p((65535 & N) << 16 | 65535 & Te, R);
    }
    function ee(oe, le, ie, fe, Te) {
      var N, R;
      N = (65535 & oe.I) + (65535 & le.I) + (65535 & ie.I) + (65535 & fe.I) + (65535 & Te.I);
      var L = (65535 & (R = (oe.I >>> 16) + (le.I >>> 16) + (ie.I >>> 16) + (fe.I >>> 16) + (Te.I >>> 16) + (N >>> 16))) << 16 | 65535 & N;
      return N = (65535 & oe.N) + (65535 & le.N) + (65535 & ie.N) + (65535 & fe.N) + (65535 & Te.N) + (R >>> 16), R = (oe.N >>> 16) + (le.N >>> 16) + (ie.N >>> 16) + (fe.N >>> 16) + (Te.N >>> 16) + (N >>> 16), new p((65535 & R) << 16 | 65535 & N, L);
    }
    function re(oe, le) {
      return new p(oe.N ^ le.N, oe.I ^ le.I);
    }
    function de(oe) {
      var le = y(oe, 1), ie = y(oe, 8), fe = T(oe, 7);
      return new p(le.N ^ ie.N ^ fe.N, le.I ^ ie.I ^ fe.I);
    }
    function se(oe) {
      var le = y(oe, 14), ie = y(oe, 18), fe = y(oe, 41);
      return new p(le.N ^ ie.N ^ fe.N, le.I ^ ie.I ^ fe.I);
    }
    var Q = [new p(l[0], 3609767458), new p(l[1], 602891725), new p(l[2], 3964484399), new p(l[3], 2173295548), new p(l[4], 4081628472), new p(l[5], 3053834265), new p(l[6], 2937671579), new p(l[7], 3664609560), new p(l[8], 2734883394), new p(l[9], 1164996542), new p(l[10], 1323610764), new p(l[11], 3590304994), new p(l[12], 4068182383), new p(l[13], 991336113), new p(l[14], 633803317), new p(l[15], 3479774868), new p(l[16], 2666613458), new p(l[17], 944711139), new p(l[18], 2341262773), new p(l[19], 2007800933), new p(l[20], 1495990901), new p(l[21], 1856431235), new p(l[22], 3175218132), new p(l[23], 2198950837), new p(l[24], 3999719339), new p(l[25], 766784016), new p(l[26], 2566594879), new p(l[27], 3203337956), new p(l[28], 1034457026), new p(l[29], 2466948901), new p(l[30], 3758326383), new p(l[31], 168717936), new p(l[32], 1188179964), new p(l[33], 1546045734), new p(l[34], 1522805485), new p(l[35], 2643833823), new p(l[36], 2343527390), new p(l[37], 1014477480), new p(l[38], 1206759142), new p(l[39], 344077627), new p(l[40], 1290863460), new p(l[41], 3158454273), new p(l[42], 3505952657), new p(l[43], 106217008), new p(l[44], 3606008344), new p(l[45], 1432725776), new p(l[46], 1467031594), new p(l[47], 851169720), new p(l[48], 3100823752), new p(l[49], 1363258195), new p(l[50], 3750685593), new p(l[51], 3785050280), new p(l[52], 3318307427), new p(l[53], 3812723403), new p(l[54], 2003034995), new p(l[55], 3602036899), new p(l[56], 1575990012), new p(l[57], 1125592928), new p(l[58], 2716904306), new p(l[59], 442776044), new p(l[60], 593698344), new p(l[61], 3733110249), new p(l[62], 2999351573), new p(l[63], 3815920427), new p(3391569614, 3928383900), new p(3515267271, 566280711), new p(3940187606, 3454069534), new p(4118630271, 4000239992), new p(116418474, 1914138554), new p(174292421, 2731055270), new p(289380356, 3203993006), new p(460393269, 320620315), new p(685471733, 587496836), new p(852142971, 1086792851), new p(1017036298, 365543100), new p(1126000580, 2618297676), new p(1288033470, 3409855158), new p(1501505948, 4234509866), new p(1607167915, 987167468), new p(1816402316, 1246189591)];
    function ge(oe) {
      return oe === "SHA-384" ? [new p(3418070365, d[0]), new p(1654270250, d[1]), new p(2438529370, d[2]), new p(355462360, d[3]), new p(1731405415, d[4]), new p(41048885895, d[5]), new p(3675008525, d[6]), new p(1203062813, d[7])] : [new p(v[0], 4089235720), new p(v[1], 2227873595), new p(v[2], 4271175723), new p(v[3], 1595750129), new p(v[4], 2917565137), new p(v[5], 725511199), new p(v[6], 4215389547), new p(v[7], 327033209)];
    }
    function Ye(oe, le) {
      var ie, fe, Te, N, R, L, V, ne, Se, ue, xe, He, be, Ie, rt, Ne, ze = [];
      for (ie = le[0], fe = le[1], Te = le[2], N = le[3], R = le[4], L = le[5], V = le[6], ne = le[7], xe = 0; xe < 80; xe += 1)
        xe < 16 ? (He = 2 * xe, ze[xe] = new p(oe[He], oe[He + 1])) : ze[xe] = F((be = ze[xe - 2], Ie = void 0, rt = void 0, Ne = void 0, Ie = y(be, 19), rt = y(be, 61), Ne = T(be, 6), new p(Ie.N ^ rt.N ^ Ne.N, Ie.I ^ rt.I ^ Ne.I)), ze[xe - 7], de(ze[xe - 15]), ze[xe - 16]), Se = ee(ne, se(R), P(R, L, V), Q[xe], ze[xe]), ue = Z(J(ie), z(ie, fe, Te)), ne = V, V = L, L = R, R = Z(N, Se), N = Te, Te = fe, fe = ie, ie = Z(Se, ue);
      return le[0] = Z(ie, le[0]), le[1] = Z(fe, le[1]), le[2] = Z(Te, le[2]), le[3] = Z(N, le[3]), le[4] = Z(R, le[4]), le[5] = Z(L, le[5]), le[6] = Z(V, le[6]), le[7] = Z(ne, le[7]), le;
    }
    var Ce = function(oe) {
      function le(ie, fe, Te) {
        var N = this;
        if (ie !== "SHA-384" && ie !== "SHA-512")
          throw new Error(m);
        var R = Te || {};
        return (N = oe.call(this, ie, fe, Te) || this).F = N.Y, N.g = !0, N.C = -1, N.p = f(N.t, N.i, N.C), N.R = Ye, N.B = function(L) {
          return L.slice();
        }, N.L = ge, N.K = function(L, V, ne, Se) {
          return function(ue, xe, He, be, Ie) {
            for (var rt, Ne = 31 + (xe + 129 >>> 10 << 5), ze = xe + He; ue.length <= Ne; )
              ue.push(0);
            for (ue[xe >>> 5] |= 128 << 24 - xe % 32, ue[Ne] = 4294967295 & ze, ue[Ne - 1] = ze / 4294967296 | 0, rt = 0; rt < ue.length; rt += 32)
              be = Ye(ue.slice(rt, rt + 32), be);
            return Ie === "SHA-384" ? [(be = be)[0].N, be[0].I, be[1].N, be[1].I, be[2].N, be[2].I, be[3].N, be[3].I, be[4].N, be[4].I, be[5].N, be[5].I] : [be[0].N, be[0].I, be[1].N, be[1].I, be[2].N, be[2].I, be[3].N, be[3].I, be[4].N, be[4].I, be[5].N, be[5].I, be[6].N, be[6].I, be[7].N, be[7].I];
          }(L, V, ne, Se, ie);
        }, N.m = ge(ie), N.S = 1024, N.U = ie === "SHA-384" ? 384 : 512, N.T = !1, R.hmacKey && N.k(M("hmacKey", R.hmacKey, N.C)), N;
      }
      return A(le, oe), le;
    }(S), Be = [new p(0, 1), new p(0, 32898), new p(2147483648, 32906), new p(2147483648, 2147516416), new p(0, 32907), new p(0, 2147483649), new p(2147483648, 2147516545), new p(2147483648, 32777), new p(0, 138), new p(0, 136), new p(0, 2147516425), new p(0, 2147483658), new p(0, 2147516555), new p(2147483648, 139), new p(2147483648, 32905), new p(2147483648, 32771), new p(2147483648, 32770), new p(2147483648, 128), new p(0, 32778), new p(2147483648, 2147483658), new p(2147483648, 2147516545), new p(2147483648, 32896), new p(0, 2147483649), new p(2147483648, 2147516424)], st = [[0, 36, 3, 41, 18], [1, 44, 10, 45, 2], [62, 6, 43, 15, 61], [28, 55, 25, 21, 56], [27, 20, 39, 8, 14]];
    function De(oe) {
      var le, ie = [];
      for (le = 0; le < 5; le += 1)
        ie[le] = [new p(0, 0), new p(0, 0), new p(0, 0), new p(0, 0), new p(0, 0)];
      return ie;
    }
    function _e(oe) {
      var le, ie = [];
      for (le = 0; le < 5; le += 1)
        ie[le] = oe[le].slice();
      return ie;
    }
    function St(oe, le) {
      var ie, fe, Te, N, R, L, V, ne, Se, ue = [], xe = [];
      if (oe !== null)
        for (fe = 0; fe < oe.length; fe += 2)
          le[(fe >>> 1) % 5][(fe >>> 1) / 5 | 0] = re(le[(fe >>> 1) % 5][(fe >>> 1) / 5 | 0], new p(oe[fe + 1], oe[fe]));
      for (ie = 0; ie < 24; ie += 1) {
        for (N = De(), fe = 0; fe < 5; fe += 1)
          ue[fe] = (R = le[fe][0], L = le[fe][1], V = le[fe][2], ne = le[fe][3], Se = le[fe][4], new p(R.N ^ L.N ^ V.N ^ ne.N ^ Se.N, R.I ^ L.I ^ V.I ^ ne.I ^ Se.I));
        for (fe = 0; fe < 5; fe += 1)
          xe[fe] = re(ue[(fe + 4) % 5], s(ue[(fe + 1) % 5], 1));
        for (fe = 0; fe < 5; fe += 1)
          for (Te = 0; Te < 5; Te += 1)
            le[fe][Te] = re(le[fe][Te], xe[fe]);
        for (fe = 0; fe < 5; fe += 1)
          for (Te = 0; Te < 5; Te += 1)
            N[Te][(2 * fe + 3 * Te) % 5] = s(le[fe][Te], st[fe][Te]);
        for (fe = 0; fe < 5; fe += 1)
          for (Te = 0; Te < 5; Te += 1)
            le[fe][Te] = re(N[fe][Te], new p(~N[(fe + 1) % 5][Te].N & N[(fe + 2) % 5][Te].N, ~N[(fe + 1) % 5][Te].I & N[(fe + 2) % 5][Te].I));
        le[0][0] = re(le[0][0], Be[ie]);
      }
      return le;
    }
    function Oe(oe) {
      var le, ie, fe = 0, Te = [0, 0], N = [4294967295 & oe, oe / 4294967296 & 2097151];
      for (le = 6; le >= 0; le--)
        (ie = N[le >> 2] >>> 8 * le & 255) === 0 && fe === 0 || (Te[fe + 1 >> 2] |= ie << 8 * (fe + 1), fe += 1);
      return fe = fe !== 0 ? fe : 1, Te[0] |= fe, { value: fe + 1 > 4 ? Te : [Te[0]], binLen: 8 + 8 * fe };
    }
    function Fe(oe) {
      return h(Oe(oe.binLen), oe);
    }
    function Et(oe, le) {
      var ie, fe = Oe(le), Te = le >>> 2, N = (Te - (fe = h(fe, oe)).value.length % Te) % Te;
      for (ie = 0; ie < N; ie++)
        fe.value.push(0);
      return fe.value;
    }
    var Ue = function(oe) {
      function le(ie, fe, Te) {
        var N = this, R = 6, L = 0, V = Te || {};
        if ((N = oe.call(this, ie, fe, Te) || this).numRounds !== 1) {
          if (V.kmacKey || V.hmacKey)
            throw new Error("Cannot set numRounds with MAC");
          if (N.o === "CSHAKE128" || N.o === "CSHAKE256")
            throw new Error("Cannot set numRounds for CSHAKE variants");
        }
        switch (N.C = 1, N.p = f(N.t, N.i, N.C), N.R = St, N.B = _e, N.L = De, N.m = De(), N.T = !1, ie) {
          case "SHA3-224":
            N.S = L = 1152, N.U = 224, N.g = !0, N.F = N.Y;
            break;
          case "SHA3-256":
            N.S = L = 1088, N.U = 256, N.g = !0, N.F = N.Y;
            break;
          case "SHA3-384":
            N.S = L = 832, N.U = 384, N.g = !0, N.F = N.Y;
            break;
          case "SHA3-512":
            N.S = L = 576, N.U = 512, N.g = !0, N.F = N.Y;
            break;
          case "SHAKE128":
            R = 31, N.S = L = 1344, N.U = -1, N.T = !0, N.g = !1, N.F = null;
            break;
          case "SHAKE256":
            R = 31, N.S = L = 1088, N.U = -1, N.T = !0, N.g = !1, N.F = null;
            break;
          case "KMAC128":
            R = 4, N.S = L = 1344, N.M(Te), N.U = -1, N.T = !0, N.g = !1, N.F = N.X;
            break;
          case "KMAC256":
            R = 4, N.S = L = 1088, N.M(Te), N.U = -1, N.T = !0, N.g = !1, N.F = N.X;
            break;
          case "CSHAKE128":
            N.S = L = 1344, R = N.O(Te), N.U = -1, N.T = !0, N.g = !1, N.F = null;
            break;
          case "CSHAKE256":
            N.S = L = 1088, R = N.O(Te), N.U = -1, N.T = !0, N.g = !1, N.F = null;
            break;
          default:
            throw new Error(m);
        }
        return N.K = function(ne, Se, ue, xe, He) {
          return function(be, Ie, rt, Ne, ze, kt, Le) {
            var $e, Ot, je = 0, Ve = [], Nt = ze >>> 5, qe = Ie >>> 5;
            for ($e = 0; $e < qe && Ie >= ze; $e += Nt)
              Ne = St(be.slice($e, $e + Nt), Ne), Ie -= ze;
            for (be = be.slice($e), Ie %= ze; be.length < Nt; )
              be.push(0);
            for (be[($e = Ie >>> 3) >> 2] ^= kt << $e % 4 * 8, be[Nt - 1] ^= 2147483648, Ne = St(be, Ne); 32 * Ve.length < Le && (Ot = Ne[je % 5][je / 5 | 0], Ve.push(Ot.I), !(32 * Ve.length >= Le)); )
              Ve.push(Ot.N), 64 * (je += 1) % ze == 0 && (St(null, Ne), je = 0);
            return Ve;
          }(ne, Se, 0, xe, L, R, He);
        }, V.hmacKey && N.k(M("hmacKey", V.hmacKey, N.C)), N;
      }
      return A(le, oe), le.prototype.O = function(ie, fe) {
        var Te = function(V) {
          var ne = V || {};
          return { funcName: M("funcName", ne.funcName, 1, { value: [], binLen: 0 }), customization: M("Customization", ne.customization, 1, { value: [], binLen: 0 }) };
        }(ie || {});
        fe && (Te.funcName = fe);
        var N = h(Fe(Te.funcName), Fe(Te.customization));
        if (Te.customization.binLen !== 0 || Te.funcName.binLen !== 0) {
          for (var R = Et(N, this.S >>> 3), L = 0; L < R.length; L += this.S >>> 5)
            this.m = this.R(R.slice(L, L + (this.S >>> 5)), this.m), this.v += this.S;
          return 4;
        }
        return 31;
      }, le.prototype.M = function(ie) {
        var fe = function(R) {
          var L = R || {};
          return { kmacKey: M("kmacKey", L.kmacKey, 1), funcName: { value: [1128353099], binLen: 32 }, customization: M("Customization", L.customization, 1, { value: [], binLen: 0 }) };
        }(ie || {});
        this.O(ie, fe.funcName);
        for (var Te = Et(Fe(fe.kmacKey), this.S >>> 3), N = 0; N < Te.length; N += this.S >>> 5)
          this.m = this.R(Te.slice(N, N + (this.S >>> 5)), this.m), this.v += this.S;
        this.A = !0;
      }, le.prototype.X = function(ie) {
        var fe = h({ value: this.u.slice(), binLen: this.s }, function(Te) {
          var N, R, L = 0, V = [0, 0], ne = [4294967295 & Te, Te / 4294967296 & 2097151];
          for (N = 6; N >= 0; N--)
            (R = ne[N >> 2] >>> 8 * N & 255) == 0 && L === 0 || (V[L >> 2] |= R << 8 * L, L += 1);
          return V[(L = L !== 0 ? L : 1) >> 2] |= L << 8 * L, { value: L + 1 > 4 ? V : [V[0]], binLen: 8 + 8 * L };
        }(ie.outputLen));
        return this.K(fe.value, fe.binLen, this.v, this.B(this.m), ie.outputLen);
      }, le;
    }(S);
    return function() {
      function oe(le, ie, fe) {
        if (le == "SHA-1")
          this.j = new c(le, ie, fe);
        else if (le == "SHA-224" || le == "SHA-256")
          this.j = new _(le, ie, fe);
        else if (le == "SHA-384" || le == "SHA-512")
          this.j = new Ce(le, ie, fe);
        else {
          if (le != "SHA3-224" && le != "SHA3-256" && le != "SHA3-384" && le != "SHA3-512" && le != "SHAKE128" && le != "SHAKE256" && le != "CSHAKE128" && le != "CSHAKE256" && le != "KMAC128" && le != "KMAC256")
            throw new Error(m);
          this.j = new Ue(le, ie, fe);
        }
      }
      return oe.prototype.update = function(le) {
        this.j.update(le);
      }, oe.prototype.getHash = function(le, ie) {
        return this.j.getHash(le, ie);
      }, oe.prototype.setHMACKey = function(le, ie, fe) {
        this.j.setHMACKey(le, ie, fe);
      }, oe.prototype.getHMAC = function(le, ie) {
        return this.j.getHMAC(le, ie);
      }, oe;
    }();
  });
})(g8);
var cm = g8.exports, mo = {}, Gs = {};
Object.defineProperty(Gs, "__esModule", { value: !0 });
Gs.getSecureRandomWords = Gs.getSecureRandomBytes = void 0;
function SC(t) {
  return Je.from(window.crypto.getRandomValues(new Uint8Array(t)));
}
Gs.getSecureRandomBytes = SC;
function EC(t) {
  return window.crypto.getRandomValues(new Uint16Array(t));
}
Gs.getSecureRandomWords = EC;
var uc = {};
Object.defineProperty(uc, "__esModule", { value: !0 });
uc.hmac_sha512 = void 0;
async function AC(t, e) {
  let r = typeof t == "string" ? Je.from(t, "utf-8") : t, i = typeof e == "string" ? Je.from(e, "utf-8") : e;
  const f = { name: "HMAC", hash: "SHA-512" }, a = await window.crypto.subtle.importKey("raw", r, f, !1, ["sign"]);
  return Je.from(await crypto.subtle.sign(f, a, i));
}
uc.hmac_sha512 = AC;
var lc = {};
Object.defineProperty(lc, "__esModule", { value: !0 });
lc.pbkdf2_sha512 = void 0;
async function kC(t, e, r, i) {
  const f = typeof t == "string" ? Je.from(t, "utf-8") : t, a = typeof e == "string" ? Je.from(e, "utf-8") : e, l = await window.crypto.subtle.importKey("raw", f, { name: "PBKDF2" }, !1, ["deriveBits"]), d = await window.crypto.subtle.deriveBits({ name: "PBKDF2", hash: "SHA-512", salt: a, iterations: r }, l, i * 8);
  return Je.from(d);
}
lc.pbkdf2_sha512 = kC;
var cc = {};
Object.defineProperty(cc, "__esModule", { value: !0 });
cc.sha256 = void 0;
async function TC(t) {
  return typeof t == "string" ? Je.from(await crypto.subtle.digest("SHA-256", Je.from(t, "utf-8"))) : Je.from(await crypto.subtle.digest("SHA-256", t));
}
cc.sha256 = TC;
var dc = {};
Object.defineProperty(dc, "__esModule", { value: !0 });
dc.sha512 = void 0;
async function CC(t) {
  return typeof t == "string" ? Je.from(await crypto.subtle.digest("SHA-512", Je.from(t, "utf-8"))) : Je.from(await crypto.subtle.digest("SHA-512", t));
}
dc.sha512 = CC;
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.sha512 = t.sha256 = t.pbkdf2_sha512 = t.hmac_sha512 = t.getSecureRandomWords = t.getSecureRandomBytes = void 0;
  var e = Gs;
  Object.defineProperty(t, "getSecureRandomBytes", { enumerable: !0, get: function() {
    return e.getSecureRandomBytes;
  } }), Object.defineProperty(t, "getSecureRandomWords", { enumerable: !0, get: function() {
    return e.getSecureRandomWords;
  } });
  var r = uc;
  Object.defineProperty(t, "hmac_sha512", { enumerable: !0, get: function() {
    return r.hmac_sha512;
  } });
  var i = lc;
  Object.defineProperty(t, "pbkdf2_sha512", { enumerable: !0, get: function() {
    return i.pbkdf2_sha512;
  } });
  var f = cc;
  Object.defineProperty(t, "sha256", { enumerable: !0, get: function() {
    return f.sha256;
  } });
  var a = dc;
  Object.defineProperty(t, "sha512", { enumerable: !0, get: function() {
    return a.sha512;
  } });
})(mo);
var BC = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Yi, "__esModule", { value: !0 });
Yi.sha256 = Yi.sha256_fallback = Yi.sha256_sync = void 0;
const IC = BC(cm), RC = mo;
function y8(t) {
  let e;
  typeof t == "string" ? e = Je.from(t, "utf-8").toString("hex") : e = t.toString("hex");
  let r = new IC.default("SHA-256", "HEX");
  r.update(e);
  let i = r.getHash("HEX");
  return Je.from(i, "hex");
}
Yi.sha256_sync = y8;
async function PC(t) {
  return y8(t);
}
Yi.sha256_fallback = PC;
function OC(t) {
  return (0, RC.sha256)(t);
}
Yi.sha256 = OC;
var Ji = {}, NC = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Ji, "__esModule", { value: !0 });
Ji.sha512 = Ji.sha512_fallback = Ji.sha512_sync = void 0;
const DC = NC(cm), UC = mo;
function b8(t) {
  let e;
  typeof t == "string" ? e = Je.from(t, "utf-8").toString("hex") : e = t.toString("hex");
  let r = new DC.default("SHA-512", "HEX");
  r.update(e);
  let i = r.getHash("HEX");
  return Je.from(i, "hex");
}
Ji.sha512_sync = b8;
async function LC(t) {
  return b8(t);
}
Ji.sha512_fallback = LC;
async function FC(t) {
  return (0, UC.sha512)(t);
}
Ji.sha512 = FC;
var jf = {};
Object.defineProperty(jf, "__esModule", { value: !0 });
jf.pbkdf2_sha512 = void 0;
const qC = mo;
function zC(t, e, r, i) {
  return (0, qC.pbkdf2_sha512)(t, e, r, i);
}
jf.pbkdf2_sha512 = zC;
var ni = {}, jC = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(ni, "__esModule", { value: !0 });
ni.hmac_sha512 = ni.hmac_sha512_fallback = void 0;
const $C = jC(cm), VC = mo;
async function HC(t, e) {
  let r = typeof t == "string" ? Je.from(t, "utf-8") : t, i = typeof e == "string" ? Je.from(e, "utf-8") : e;
  const f = new $C.default("SHA-512", "HEX", {
    hmacKey: { value: r.toString("hex"), format: "HEX" }
  });
  f.update(i.toString("hex"));
  const a = f.getHash("HEX");
  return Je.from(a, "hex");
}
ni.hmac_sha512_fallback = HC;
function WC(t, e) {
  return (0, VC.hmac_sha512)(t, e);
}
ni.hmac_sha512 = WC;
var Yn = {};
Object.defineProperty(Yn, "__esModule", { value: !0 });
Yn.getSecureRandomNumber = Yn.getSecureRandomWords = Yn.getSecureRandomBytes = void 0;
const KC = mo;
async function w8(t) {
  return (0, KC.getSecureRandomBytes)(t);
}
Yn.getSecureRandomBytes = w8;
async function _8(t) {
  return _8();
}
Yn.getSecureRandomWords = _8;
async function ZC(t, e) {
  let r = e - t;
  var i = Math.ceil(Math.log2(r));
  if (i > 53)
    throw new Error("Range is too large");
  for (var f = Math.ceil(i / 8), a = Math.pow(2, i) - 1; ; ) {
    let d = await w8(i), v = (f - 1) * 8, m = 0;
    for (var l = 0; l < f; l++)
      m += d[l] * Math.pow(2, v), v -= 8;
    if (m = m & a, !(m >= r))
      return t + m;
  }
}
Yn.getSecureRandomNumber = ZC;
var hc = {}, pc = {};
Object.defineProperty(pc, "__esModule", { value: !0 });
pc.wordlist = void 0;
pc.wordlist = [
  "abacus",
  "abdomen",
  "abdominal",
  "abide",
  "abiding",
  "ability",
  "ablaze",
  "able",
  "abnormal",
  "abrasion",
  "abrasive",
  "abreast",
  "abridge",
  "abroad",
  "abruptly",
  "absence",
  "absentee",
  "absently",
  "absinthe",
  "absolute",
  "absolve",
  "abstain",
  "abstract",
  "absurd",
  "accent",
  "acclaim",
  "acclimate",
  "accompany",
  "account",
  "accuracy",
  "accurate",
  "accustom",
  "acetone",
  "achiness",
  "aching",
  "acid",
  "acorn",
  "acquaint",
  "acquire",
  "acre",
  "acrobat",
  "acronym",
  "acting",
  "action",
  "activate",
  "activator",
  "active",
  "activism",
  "activist",
  "activity",
  "actress",
  "acts",
  "acutely",
  "acuteness",
  "aeration",
  "aerobics",
  "aerosol",
  "aerospace",
  "afar",
  "affair",
  "affected",
  "affecting",
  "affection",
  "affidavit",
  "affiliate",
  "affirm",
  "affix",
  "afflicted",
  "affluent",
  "afford",
  "affront",
  "aflame",
  "afloat",
  "aflutter",
  "afoot",
  "afraid",
  "afterglow",
  "afterlife",
  "aftermath",
  "aftermost",
  "afternoon",
  "aged",
  "ageless",
  "agency",
  "agenda",
  "agent",
  "aggregate",
  "aghast",
  "agile",
  "agility",
  "aging",
  "agnostic",
  "agonize",
  "agonizing",
  "agony",
  "agreeable",
  "agreeably",
  "agreed",
  "agreeing",
  "agreement",
  "aground",
  "ahead",
  "ahoy",
  "aide",
  "aids",
  "aim",
  "ajar",
  "alabaster",
  "alarm",
  "albatross",
  "album",
  "alfalfa",
  "algebra",
  "algorithm",
  "alias",
  "alibi",
  "alienable",
  "alienate",
  "aliens",
  "alike",
  "alive",
  "alkaline",
  "alkalize",
  "almanac",
  "almighty",
  "almost",
  "aloe",
  "aloft",
  "aloha",
  "alone",
  "alongside",
  "aloof",
  "alphabet",
  "alright",
  "although",
  "altitude",
  "alto",
  "aluminum",
  "alumni",
  "always",
  "amaretto",
  "amaze",
  "amazingly",
  "amber",
  "ambiance",
  "ambiguity",
  "ambiguous",
  "ambition",
  "ambitious",
  "ambulance",
  "ambush",
  "amendable",
  "amendment",
  "amends",
  "amenity",
  "amiable",
  "amicably",
  "amid",
  "amigo",
  "amino",
  "amiss",
  "ammonia",
  "ammonium",
  "amnesty",
  "amniotic",
  "among",
  "amount",
  "amperage",
  "ample",
  "amplifier",
  "amplify",
  "amply",
  "amuck",
  "amulet",
  "amusable",
  "amused",
  "amusement",
  "amuser",
  "amusing",
  "anaconda",
  "anaerobic",
  "anagram",
  "anatomist",
  "anatomy",
  "anchor",
  "anchovy",
  "ancient",
  "android",
  "anemia",
  "anemic",
  "aneurism",
  "anew",
  "angelfish",
  "angelic",
  "anger",
  "angled",
  "angler",
  "angles",
  "angling",
  "angrily",
  "angriness",
  "anguished",
  "angular",
  "animal",
  "animate",
  "animating",
  "animation",
  "animator",
  "anime",
  "animosity",
  "ankle",
  "annex",
  "annotate",
  "announcer",
  "annoying",
  "annually",
  "annuity",
  "anointer",
  "another",
  "answering",
  "antacid",
  "antarctic",
  "anteater",
  "antelope",
  "antennae",
  "anthem",
  "anthill",
  "anthology",
  "antibody",
  "antics",
  "antidote",
  "antihero",
  "antiquely",
  "antiques",
  "antiquity",
  "antirust",
  "antitoxic",
  "antitrust",
  "antiviral",
  "antivirus",
  "antler",
  "antonym",
  "antsy",
  "anvil",
  "anybody",
  "anyhow",
  "anymore",
  "anyone",
  "anyplace",
  "anything",
  "anytime",
  "anyway",
  "anywhere",
  "aorta",
  "apache",
  "apostle",
  "appealing",
  "appear",
  "appease",
  "appeasing",
  "appendage",
  "appendix",
  "appetite",
  "appetizer",
  "applaud",
  "applause",
  "apple",
  "appliance",
  "applicant",
  "applied",
  "apply",
  "appointee",
  "appraisal",
  "appraiser",
  "apprehend",
  "approach",
  "approval",
  "approve",
  "apricot",
  "april",
  "apron",
  "aptitude",
  "aptly",
  "aqua",
  "aqueduct",
  "arbitrary",
  "arbitrate",
  "ardently",
  "area",
  "arena",
  "arguable",
  "arguably",
  "argue",
  "arise",
  "armadillo",
  "armband",
  "armchair",
  "armed",
  "armful",
  "armhole",
  "arming",
  "armless",
  "armoire",
  "armored",
  "armory",
  "armrest",
  "army",
  "aroma",
  "arose",
  "around",
  "arousal",
  "arrange",
  "array",
  "arrest",
  "arrival",
  "arrive",
  "arrogance",
  "arrogant",
  "arson",
  "art",
  "ascend",
  "ascension",
  "ascent",
  "ascertain",
  "ashamed",
  "ashen",
  "ashes",
  "ashy",
  "aside",
  "askew",
  "asleep",
  "asparagus",
  "aspect",
  "aspirate",
  "aspire",
  "aspirin",
  "astonish",
  "astound",
  "astride",
  "astrology",
  "astronaut",
  "astronomy",
  "astute",
  "atlantic",
  "atlas",
  "atom",
  "atonable",
  "atop",
  "atrium",
  "atrocious",
  "atrophy",
  "attach",
  "attain",
  "attempt",
  "attendant",
  "attendee",
  "attention",
  "attentive",
  "attest",
  "attic",
  "attire",
  "attitude",
  "attractor",
  "attribute",
  "atypical",
  "auction",
  "audacious",
  "audacity",
  "audible",
  "audibly",
  "audience",
  "audio",
  "audition",
  "augmented",
  "august",
  "authentic",
  "author",
  "autism",
  "autistic",
  "autograph",
  "automaker",
  "automated",
  "automatic",
  "autopilot",
  "available",
  "avalanche",
  "avatar",
  "avenge",
  "avenging",
  "avenue",
  "average",
  "aversion",
  "avert",
  "aviation",
  "aviator",
  "avid",
  "avoid",
  "await",
  "awaken",
  "award",
  "aware",
  "awhile",
  "awkward",
  "awning",
  "awoke",
  "awry",
  "axis",
  "babble",
  "babbling",
  "babied",
  "baboon",
  "backache",
  "backboard",
  "backboned",
  "backdrop",
  "backed",
  "backer",
  "backfield",
  "backfire",
  "backhand",
  "backing",
  "backlands",
  "backlash",
  "backless",
  "backlight",
  "backlit",
  "backlog",
  "backpack",
  "backpedal",
  "backrest",
  "backroom",
  "backshift",
  "backside",
  "backslid",
  "backspace",
  "backspin",
  "backstab",
  "backstage",
  "backtalk",
  "backtrack",
  "backup",
  "backward",
  "backwash",
  "backwater",
  "backyard",
  "bacon",
  "bacteria",
  "bacterium",
  "badass",
  "badge",
  "badland",
  "badly",
  "badness",
  "baffle",
  "baffling",
  "bagel",
  "bagful",
  "baggage",
  "bagged",
  "baggie",
  "bagginess",
  "bagging",
  "baggy",
  "bagpipe",
  "baguette",
  "baked",
  "bakery",
  "bakeshop",
  "baking",
  "balance",
  "balancing",
  "balcony",
  "balmy",
  "balsamic",
  "bamboo",
  "banana",
  "banish",
  "banister",
  "banjo",
  "bankable",
  "bankbook",
  "banked",
  "banker",
  "banking",
  "banknote",
  "bankroll",
  "banner",
  "bannister",
  "banshee",
  "banter",
  "barbecue",
  "barbed",
  "barbell",
  "barber",
  "barcode",
  "barge",
  "bargraph",
  "barista",
  "baritone",
  "barley",
  "barmaid",
  "barman",
  "barn",
  "barometer",
  "barrack",
  "barracuda",
  "barrel",
  "barrette",
  "barricade",
  "barrier",
  "barstool",
  "bartender",
  "barterer",
  "bash",
  "basically",
  "basics",
  "basil",
  "basin",
  "basis",
  "basket",
  "batboy",
  "batch",
  "bath",
  "baton",
  "bats",
  "battalion",
  "battered",
  "battering",
  "battery",
  "batting",
  "battle",
  "bauble",
  "bazooka",
  "blabber",
  "bladder",
  "blade",
  "blah",
  "blame",
  "blaming",
  "blanching",
  "blandness",
  "blank",
  "blaspheme",
  "blasphemy",
  "blast",
  "blatancy",
  "blatantly",
  "blazer",
  "blazing",
  "bleach",
  "bleak",
  "bleep",
  "blemish",
  "blend",
  "bless",
  "blighted",
  "blimp",
  "bling",
  "blinked",
  "blinker",
  "blinking",
  "blinks",
  "blip",
  "blissful",
  "blitz",
  "blizzard",
  "bloated",
  "bloating",
  "blob",
  "blog",
  "bloomers",
  "blooming",
  "blooper",
  "blot",
  "blouse",
  "blubber",
  "bluff",
  "bluish",
  "blunderer",
  "blunt",
  "blurb",
  "blurred",
  "blurry",
  "blurt",
  "blush",
  "blustery",
  "boaster",
  "boastful",
  "boasting",
  "boat",
  "bobbed",
  "bobbing",
  "bobble",
  "bobcat",
  "bobsled",
  "bobtail",
  "bodacious",
  "body",
  "bogged",
  "boggle",
  "bogus",
  "boil",
  "bok",
  "bolster",
  "bolt",
  "bonanza",
  "bonded",
  "bonding",
  "bondless",
  "boned",
  "bonehead",
  "boneless",
  "bonelike",
  "boney",
  "bonfire",
  "bonnet",
  "bonsai",
  "bonus",
  "bony",
  "boogeyman",
  "boogieman",
  "book",
  "boondocks",
  "booted",
  "booth",
  "bootie",
  "booting",
  "bootlace",
  "bootleg",
  "boots",
  "boozy",
  "borax",
  "boring",
  "borough",
  "borrower",
  "borrowing",
  "boss",
  "botanical",
  "botanist",
  "botany",
  "botch",
  "both",
  "bottle",
  "bottling",
  "bottom",
  "bounce",
  "bouncing",
  "bouncy",
  "bounding",
  "boundless",
  "bountiful",
  "bovine",
  "boxcar",
  "boxer",
  "boxing",
  "boxlike",
  "boxy",
  "breach",
  "breath",
  "breeches",
  "breeching",
  "breeder",
  "breeding",
  "breeze",
  "breezy",
  "brethren",
  "brewery",
  "brewing",
  "briar",
  "bribe",
  "brick",
  "bride",
  "bridged",
  "brigade",
  "bright",
  "brilliant",
  "brim",
  "bring",
  "brink",
  "brisket",
  "briskly",
  "briskness",
  "bristle",
  "brittle",
  "broadband",
  "broadcast",
  "broaden",
  "broadly",
  "broadness",
  "broadside",
  "broadways",
  "broiler",
  "broiling",
  "broken",
  "broker",
  "bronchial",
  "bronco",
  "bronze",
  "bronzing",
  "brook",
  "broom",
  "brought",
  "browbeat",
  "brownnose",
  "browse",
  "browsing",
  "bruising",
  "brunch",
  "brunette",
  "brunt",
  "brush",
  "brussels",
  "brute",
  "brutishly",
  "bubble",
  "bubbling",
  "bubbly",
  "buccaneer",
  "bucked",
  "bucket",
  "buckle",
  "buckshot",
  "buckskin",
  "bucktooth",
  "buckwheat",
  "buddhism",
  "buddhist",
  "budding",
  "buddy",
  "budget",
  "buffalo",
  "buffed",
  "buffer",
  "buffing",
  "buffoon",
  "buggy",
  "bulb",
  "bulge",
  "bulginess",
  "bulgur",
  "bulk",
  "bulldog",
  "bulldozer",
  "bullfight",
  "bullfrog",
  "bullhorn",
  "bullion",
  "bullish",
  "bullpen",
  "bullring",
  "bullseye",
  "bullwhip",
  "bully",
  "bunch",
  "bundle",
  "bungee",
  "bunion",
  "bunkbed",
  "bunkhouse",
  "bunkmate",
  "bunny",
  "bunt",
  "busboy",
  "bush",
  "busily",
  "busload",
  "bust",
  "busybody",
  "buzz",
  "cabana",
  "cabbage",
  "cabbie",
  "cabdriver",
  "cable",
  "caboose",
  "cache",
  "cackle",
  "cacti",
  "cactus",
  "caddie",
  "caddy",
  "cadet",
  "cadillac",
  "cadmium",
  "cage",
  "cahoots",
  "cake",
  "calamari",
  "calamity",
  "calcium",
  "calculate",
  "calculus",
  "caliber",
  "calibrate",
  "calm",
  "caloric",
  "calorie",
  "calzone",
  "camcorder",
  "cameo",
  "camera",
  "camisole",
  "camper",
  "campfire",
  "camping",
  "campsite",
  "campus",
  "canal",
  "canary",
  "cancel",
  "candied",
  "candle",
  "candy",
  "cane",
  "canine",
  "canister",
  "cannabis",
  "canned",
  "canning",
  "cannon",
  "cannot",
  "canola",
  "canon",
  "canopener",
  "canopy",
  "canteen",
  "canyon",
  "capable",
  "capably",
  "capacity",
  "cape",
  "capillary",
  "capital",
  "capitol",
  "capped",
  "capricorn",
  "capsize",
  "capsule",
  "caption",
  "captivate",
  "captive",
  "captivity",
  "capture",
  "caramel",
  "carat",
  "caravan",
  "carbon",
  "cardboard",
  "carded",
  "cardiac",
  "cardigan",
  "cardinal",
  "cardstock",
  "carefully",
  "caregiver",
  "careless",
  "caress",
  "caretaker",
  "cargo",
  "caring",
  "carless",
  "carload",
  "carmaker",
  "carnage",
  "carnation",
  "carnival",
  "carnivore",
  "carol",
  "carpenter",
  "carpentry",
  "carpool",
  "carport",
  "carried",
  "carrot",
  "carrousel",
  "carry",
  "cartel",
  "cartload",
  "carton",
  "cartoon",
  "cartridge",
  "cartwheel",
  "carve",
  "carving",
  "carwash",
  "cascade",
  "case",
  "cash",
  "casing",
  "casino",
  "casket",
  "cassette",
  "casually",
  "casualty",
  "catacomb",
  "catalog",
  "catalyst",
  "catalyze",
  "catapult",
  "cataract",
  "catatonic",
  "catcall",
  "catchable",
  "catcher",
  "catching",
  "catchy",
  "caterer",
  "catering",
  "catfight",
  "catfish",
  "cathedral",
  "cathouse",
  "catlike",
  "catnap",
  "catnip",
  "catsup",
  "cattail",
  "cattishly",
  "cattle",
  "catty",
  "catwalk",
  "caucasian",
  "caucus",
  "causal",
  "causation",
  "cause",
  "causing",
  "cauterize",
  "caution",
  "cautious",
  "cavalier",
  "cavalry",
  "caviar",
  "cavity",
  "cedar",
  "celery",
  "celestial",
  "celibacy",
  "celibate",
  "celtic",
  "cement",
  "census",
  "ceramics",
  "ceremony",
  "certainly",
  "certainty",
  "certified",
  "certify",
  "cesarean",
  "cesspool",
  "chafe",
  "chaffing",
  "chain",
  "chair",
  "chalice",
  "challenge",
  "chamber",
  "chamomile",
  "champion",
  "chance",
  "change",
  "channel",
  "chant",
  "chaos",
  "chaperone",
  "chaplain",
  "chapped",
  "chaps",
  "chapter",
  "character",
  "charbroil",
  "charcoal",
  "charger",
  "charging",
  "chariot",
  "charity",
  "charm",
  "charred",
  "charter",
  "charting",
  "chase",
  "chasing",
  "chaste",
  "chastise",
  "chastity",
  "chatroom",
  "chatter",
  "chatting",
  "chatty",
  "cheating",
  "cheddar",
  "cheek",
  "cheer",
  "cheese",
  "cheesy",
  "chef",
  "chemicals",
  "chemist",
  "chemo",
  "cherisher",
  "cherub",
  "chess",
  "chest",
  "chevron",
  "chevy",
  "chewable",
  "chewer",
  "chewing",
  "chewy",
  "chief",
  "chihuahua",
  "childcare",
  "childhood",
  "childish",
  "childless",
  "childlike",
  "chili",
  "chill",
  "chimp",
  "chip",
  "chirping",
  "chirpy",
  "chitchat",
  "chivalry",
  "chive",
  "chloride",
  "chlorine",
  "choice",
  "chokehold",
  "choking",
  "chomp",
  "chooser",
  "choosing",
  "choosy",
  "chop",
  "chosen",
  "chowder",
  "chowtime",
  "chrome",
  "chubby",
  "chuck",
  "chug",
  "chummy",
  "chump",
  "chunk",
  "churn",
  "chute",
  "cider",
  "cilantro",
  "cinch",
  "cinema",
  "cinnamon",
  "circle",
  "circling",
  "circular",
  "circulate",
  "circus",
  "citable",
  "citadel",
  "citation",
  "citizen",
  "citric",
  "citrus",
  "city",
  "civic",
  "civil",
  "clad",
  "claim",
  "clambake",
  "clammy",
  "clamor",
  "clamp",
  "clamshell",
  "clang",
  "clanking",
  "clapped",
  "clapper",
  "clapping",
  "clarify",
  "clarinet",
  "clarity",
  "clash",
  "clasp",
  "class",
  "clatter",
  "clause",
  "clavicle",
  "claw",
  "clay",
  "clean",
  "clear",
  "cleat",
  "cleaver",
  "cleft",
  "clench",
  "clergyman",
  "clerical",
  "clerk",
  "clever",
  "clicker",
  "client",
  "climate",
  "climatic",
  "cling",
  "clinic",
  "clinking",
  "clip",
  "clique",
  "cloak",
  "clobber",
  "clock",
  "clone",
  "cloning",
  "closable",
  "closure",
  "clothes",
  "clothing",
  "cloud",
  "clover",
  "clubbed",
  "clubbing",
  "clubhouse",
  "clump",
  "clumsily",
  "clumsy",
  "clunky",
  "clustered",
  "clutch",
  "clutter",
  "coach",
  "coagulant",
  "coastal",
  "coaster",
  "coasting",
  "coastland",
  "coastline",
  "coat",
  "coauthor",
  "cobalt",
  "cobbler",
  "cobweb",
  "cocoa",
  "coconut",
  "cod",
  "coeditor",
  "coerce",
  "coexist",
  "coffee",
  "cofounder",
  "cognition",
  "cognitive",
  "cogwheel",
  "coherence",
  "coherent",
  "cohesive",
  "coil",
  "coke",
  "cola",
  "cold",
  "coleslaw",
  "coliseum",
  "collage",
  "collapse",
  "collar",
  "collected",
  "collector",
  "collide",
  "collie",
  "collision",
  "colonial",
  "colonist",
  "colonize",
  "colony",
  "colossal",
  "colt",
  "coma",
  "come",
  "comfort",
  "comfy",
  "comic",
  "coming",
  "comma",
  "commence",
  "commend",
  "comment",
  "commerce",
  "commode",
  "commodity",
  "commodore",
  "common",
  "commotion",
  "commute",
  "commuting",
  "compacted",
  "compacter",
  "compactly",
  "compactor",
  "companion",
  "company",
  "compare",
  "compel",
  "compile",
  "comply",
  "component",
  "composed",
  "composer",
  "composite",
  "compost",
  "composure",
  "compound",
  "compress",
  "comprised",
  "computer",
  "computing",
  "comrade",
  "concave",
  "conceal",
  "conceded",
  "concept",
  "concerned",
  "concert",
  "conch",
  "concierge",
  "concise",
  "conclude",
  "concrete",
  "concur",
  "condense",
  "condiment",
  "condition",
  "condone",
  "conducive",
  "conductor",
  "conduit",
  "cone",
  "confess",
  "confetti",
  "confidant",
  "confident",
  "confider",
  "confiding",
  "configure",
  "confined",
  "confining",
  "confirm",
  "conflict",
  "conform",
  "confound",
  "confront",
  "confused",
  "confusing",
  "confusion",
  "congenial",
  "congested",
  "congrats",
  "congress",
  "conical",
  "conjoined",
  "conjure",
  "conjuror",
  "connected",
  "connector",
  "consensus",
  "consent",
  "console",
  "consoling",
  "consonant",
  "constable",
  "constant",
  "constrain",
  "constrict",
  "construct",
  "consult",
  "consumer",
  "consuming",
  "contact",
  "container",
  "contempt",
  "contend",
  "contented",
  "contently",
  "contents",
  "contest",
  "context",
  "contort",
  "contour",
  "contrite",
  "control",
  "contusion",
  "convene",
  "convent",
  "copartner",
  "cope",
  "copied",
  "copier",
  "copilot",
  "coping",
  "copious",
  "copper",
  "copy",
  "coral",
  "cork",
  "cornball",
  "cornbread",
  "corncob",
  "cornea",
  "corned",
  "corner",
  "cornfield",
  "cornflake",
  "cornhusk",
  "cornmeal",
  "cornstalk",
  "corny",
  "coronary",
  "coroner",
  "corporal",
  "corporate",
  "corral",
  "correct",
  "corridor",
  "corrode",
  "corroding",
  "corrosive",
  "corsage",
  "corset",
  "cortex",
  "cosigner",
  "cosmetics",
  "cosmic",
  "cosmos",
  "cosponsor",
  "cost",
  "cottage",
  "cotton",
  "couch",
  "cough",
  "could",
  "countable",
  "countdown",
  "counting",
  "countless",
  "country",
  "county",
  "courier",
  "covenant",
  "cover",
  "coveted",
  "coveting",
  "coyness",
  "cozily",
  "coziness",
  "cozy",
  "crabbing",
  "crabgrass",
  "crablike",
  "crabmeat",
  "cradle",
  "cradling",
  "crafter",
  "craftily",
  "craftsman",
  "craftwork",
  "crafty",
  "cramp",
  "cranberry",
  "crane",
  "cranial",
  "cranium",
  "crank",
  "crate",
  "crave",
  "craving",
  "crawfish",
  "crawlers",
  "crawling",
  "crayfish",
  "crayon",
  "crazed",
  "crazily",
  "craziness",
  "crazy",
  "creamed",
  "creamer",
  "creamlike",
  "crease",
  "creasing",
  "creatable",
  "create",
  "creation",
  "creative",
  "creature",
  "credible",
  "credibly",
  "credit",
  "creed",
  "creme",
  "creole",
  "crepe",
  "crept",
  "crescent",
  "crested",
  "cresting",
  "crestless",
  "crevice",
  "crewless",
  "crewman",
  "crewmate",
  "crib",
  "cricket",
  "cried",
  "crier",
  "crimp",
  "crimson",
  "cringe",
  "cringing",
  "crinkle",
  "crinkly",
  "crisped",
  "crisping",
  "crisply",
  "crispness",
  "crispy",
  "criteria",
  "critter",
  "croak",
  "crock",
  "crook",
  "croon",
  "crop",
  "cross",
  "crouch",
  "crouton",
  "crowbar",
  "crowd",
  "crown",
  "crucial",
  "crudely",
  "crudeness",
  "cruelly",
  "cruelness",
  "cruelty",
  "crumb",
  "crummiest",
  "crummy",
  "crumpet",
  "crumpled",
  "cruncher",
  "crunching",
  "crunchy",
  "crusader",
  "crushable",
  "crushed",
  "crusher",
  "crushing",
  "crust",
  "crux",
  "crying",
  "cryptic",
  "crystal",
  "cubbyhole",
  "cube",
  "cubical",
  "cubicle",
  "cucumber",
  "cuddle",
  "cuddly",
  "cufflink",
  "culinary",
  "culminate",
  "culpable",
  "culprit",
  "cultivate",
  "cultural",
  "culture",
  "cupbearer",
  "cupcake",
  "cupid",
  "cupped",
  "cupping",
  "curable",
  "curator",
  "curdle",
  "cure",
  "curfew",
  "curing",
  "curled",
  "curler",
  "curliness",
  "curling",
  "curly",
  "curry",
  "curse",
  "cursive",
  "cursor",
  "curtain",
  "curtly",
  "curtsy",
  "curvature",
  "curve",
  "curvy",
  "cushy",
  "cusp",
  "cussed",
  "custard",
  "custodian",
  "custody",
  "customary",
  "customer",
  "customize",
  "customs",
  "cut",
  "cycle",
  "cyclic",
  "cycling",
  "cyclist",
  "cylinder",
  "cymbal",
  "cytoplasm",
  "cytoplast",
  "dab",
  "dad",
  "daffodil",
  "dagger",
  "daily",
  "daintily",
  "dainty",
  "dairy",
  "daisy",
  "dallying",
  "dance",
  "dancing",
  "dandelion",
  "dander",
  "dandruff",
  "dandy",
  "danger",
  "dangle",
  "dangling",
  "daredevil",
  "dares",
  "daringly",
  "darkened",
  "darkening",
  "darkish",
  "darkness",
  "darkroom",
  "darling",
  "darn",
  "dart",
  "darwinism",
  "dash",
  "dastardly",
  "data",
  "datebook",
  "dating",
  "daughter",
  "daunting",
  "dawdler",
  "dawn",
  "daybed",
  "daybreak",
  "daycare",
  "daydream",
  "daylight",
  "daylong",
  "dayroom",
  "daytime",
  "dazzler",
  "dazzling",
  "deacon",
  "deafening",
  "deafness",
  "dealer",
  "dealing",
  "dealmaker",
  "dealt",
  "dean",
  "debatable",
  "debate",
  "debating",
  "debit",
  "debrief",
  "debtless",
  "debtor",
  "debug",
  "debunk",
  "decade",
  "decaf",
  "decal",
  "decathlon",
  "decay",
  "deceased",
  "deceit",
  "deceiver",
  "deceiving",
  "december",
  "decency",
  "decent",
  "deception",
  "deceptive",
  "decibel",
  "decidable",
  "decimal",
  "decimeter",
  "decipher",
  "deck",
  "declared",
  "decline",
  "decode",
  "decompose",
  "decorated",
  "decorator",
  "decoy",
  "decrease",
  "decree",
  "dedicate",
  "dedicator",
  "deduce",
  "deduct",
  "deed",
  "deem",
  "deepen",
  "deeply",
  "deepness",
  "deface",
  "defacing",
  "defame",
  "default",
  "defeat",
  "defection",
  "defective",
  "defendant",
  "defender",
  "defense",
  "defensive",
  "deferral",
  "deferred",
  "defiance",
  "defiant",
  "defile",
  "defiling",
  "define",
  "definite",
  "deflate",
  "deflation",
  "deflator",
  "deflected",
  "deflector",
  "defog",
  "deforest",
  "defraud",
  "defrost",
  "deftly",
  "defuse",
  "defy",
  "degraded",
  "degrading",
  "degrease",
  "degree",
  "dehydrate",
  "deity",
  "dejected",
  "delay",
  "delegate",
  "delegator",
  "delete",
  "deletion",
  "delicacy",
  "delicate",
  "delicious",
  "delighted",
  "delirious",
  "delirium",
  "deliverer",
  "delivery",
  "delouse",
  "delta",
  "deluge",
  "delusion",
  "deluxe",
  "demanding",
  "demeaning",
  "demeanor",
  "demise",
  "democracy",
  "democrat",
  "demote",
  "demotion",
  "demystify",
  "denatured",
  "deniable",
  "denial",
  "denim",
  "denote",
  "dense",
  "density",
  "dental",
  "dentist",
  "denture",
  "deny",
  "deodorant",
  "deodorize",
  "departed",
  "departure",
  "depict",
  "deplete",
  "depletion",
  "deplored",
  "deploy",
  "deport",
  "depose",
  "depraved",
  "depravity",
  "deprecate",
  "depress",
  "deprive",
  "depth",
  "deputize",
  "deputy",
  "derail",
  "deranged",
  "derby",
  "derived",
  "desecrate",
  "deserve",
  "deserving",
  "designate",
  "designed",
  "designer",
  "designing",
  "deskbound",
  "desktop",
  "deskwork",
  "desolate",
  "despair",
  "despise",
  "despite",
  "destiny",
  "destitute",
  "destruct",
  "detached",
  "detail",
  "detection",
  "detective",
  "detector",
  "detention",
  "detergent",
  "detest",
  "detonate",
  "detonator",
  "detoxify",
  "detract",
  "deuce",
  "devalue",
  "deviancy",
  "deviant",
  "deviate",
  "deviation",
  "deviator",
  "device",
  "devious",
  "devotedly",
  "devotee",
  "devotion",
  "devourer",
  "devouring",
  "devoutly",
  "dexterity",
  "dexterous",
  "diabetes",
  "diabetic",
  "diabolic",
  "diagnoses",
  "diagnosis",
  "diagram",
  "dial",
  "diameter",
  "diaper",
  "diaphragm",
  "diary",
  "dice",
  "dicing",
  "dictate",
  "dictation",
  "dictator",
  "difficult",
  "diffused",
  "diffuser",
  "diffusion",
  "diffusive",
  "dig",
  "dilation",
  "diligence",
  "diligent",
  "dill",
  "dilute",
  "dime",
  "diminish",
  "dimly",
  "dimmed",
  "dimmer",
  "dimness",
  "dimple",
  "diner",
  "dingbat",
  "dinghy",
  "dinginess",
  "dingo",
  "dingy",
  "dining",
  "dinner",
  "diocese",
  "dioxide",
  "diploma",
  "dipped",
  "dipper",
  "dipping",
  "directed",
  "direction",
  "directive",
  "directly",
  "directory",
  "direness",
  "dirtiness",
  "disabled",
  "disagree",
  "disallow",
  "disarm",
  "disarray",
  "disaster",
  "disband",
  "disbelief",
  "disburse",
  "discard",
  "discern",
  "discharge",
  "disclose",
  "discolor",
  "discount",
  "discourse",
  "discover",
  "discuss",
  "disdain",
  "disengage",
  "disfigure",
  "disgrace",
  "dish",
  "disinfect",
  "disjoin",
  "disk",
  "dislike",
  "disliking",
  "dislocate",
  "dislodge",
  "disloyal",
  "dismantle",
  "dismay",
  "dismiss",
  "dismount",
  "disobey",
  "disorder",
  "disown",
  "disparate",
  "disparity",
  "dispatch",
  "dispense",
  "dispersal",
  "dispersed",
  "disperser",
  "displace",
  "display",
  "displease",
  "disposal",
  "dispose",
  "disprove",
  "dispute",
  "disregard",
  "disrupt",
  "dissuade",
  "distance",
  "distant",
  "distaste",
  "distill",
  "distinct",
  "distort",
  "distract",
  "distress",
  "district",
  "distrust",
  "ditch",
  "ditto",
  "ditzy",
  "dividable",
  "divided",
  "dividend",
  "dividers",
  "dividing",
  "divinely",
  "diving",
  "divinity",
  "divisible",
  "divisibly",
  "division",
  "divisive",
  "divorcee",
  "dizziness",
  "dizzy",
  "doable",
  "docile",
  "dock",
  "doctrine",
  "document",
  "dodge",
  "dodgy",
  "doily",
  "doing",
  "dole",
  "dollar",
  "dollhouse",
  "dollop",
  "dolly",
  "dolphin",
  "domain",
  "domelike",
  "domestic",
  "dominion",
  "dominoes",
  "donated",
  "donation",
  "donator",
  "donor",
  "donut",
  "doodle",
  "doorbell",
  "doorframe",
  "doorknob",
  "doorman",
  "doormat",
  "doornail",
  "doorpost",
  "doorstep",
  "doorstop",
  "doorway",
  "doozy",
  "dork",
  "dormitory",
  "dorsal",
  "dosage",
  "dose",
  "dotted",
  "doubling",
  "douche",
  "dove",
  "down",
  "dowry",
  "doze",
  "drab",
  "dragging",
  "dragonfly",
  "dragonish",
  "dragster",
  "drainable",
  "drainage",
  "drained",
  "drainer",
  "drainpipe",
  "dramatic",
  "dramatize",
  "drank",
  "drapery",
  "drastic",
  "draw",
  "dreaded",
  "dreadful",
  "dreadlock",
  "dreamboat",
  "dreamily",
  "dreamland",
  "dreamless",
  "dreamlike",
  "dreamt",
  "dreamy",
  "drearily",
  "dreary",
  "drench",
  "dress",
  "drew",
  "dribble",
  "dried",
  "drier",
  "drift",
  "driller",
  "drilling",
  "drinkable",
  "drinking",
  "dripping",
  "drippy",
  "drivable",
  "driven",
  "driver",
  "driveway",
  "driving",
  "drizzle",
  "drizzly",
  "drone",
  "drool",
  "droop",
  "drop-down",
  "dropbox",
  "dropkick",
  "droplet",
  "dropout",
  "dropper",
  "drove",
  "drown",
  "drowsily",
  "drudge",
  "drum",
  "dry",
  "dubbed",
  "dubiously",
  "duchess",
  "duckbill",
  "ducking",
  "duckling",
  "ducktail",
  "ducky",
  "duct",
  "dude",
  "duffel",
  "dugout",
  "duh",
  "duke",
  "duller",
  "dullness",
  "duly",
  "dumping",
  "dumpling",
  "dumpster",
  "duo",
  "dupe",
  "duplex",
  "duplicate",
  "duplicity",
  "durable",
  "durably",
  "duration",
  "duress",
  "during",
  "dusk",
  "dust",
  "dutiful",
  "duty",
  "duvet",
  "dwarf",
  "dweeb",
  "dwelled",
  "dweller",
  "dwelling",
  "dwindle",
  "dwindling",
  "dynamic",
  "dynamite",
  "dynasty",
  "dyslexia",
  "dyslexic",
  "each",
  "eagle",
  "earache",
  "eardrum",
  "earflap",
  "earful",
  "earlobe",
  "early",
  "earmark",
  "earmuff",
  "earphone",
  "earpiece",
  "earplugs",
  "earring",
  "earshot",
  "earthen",
  "earthlike",
  "earthling",
  "earthly",
  "earthworm",
  "earthy",
  "earwig",
  "easeful",
  "easel",
  "easiest",
  "easily",
  "easiness",
  "easing",
  "eastbound",
  "eastcoast",
  "easter",
  "eastward",
  "eatable",
  "eaten",
  "eatery",
  "eating",
  "eats",
  "ebay",
  "ebony",
  "ebook",
  "ecard",
  "eccentric",
  "echo",
  "eclair",
  "eclipse",
  "ecologist",
  "ecology",
  "economic",
  "economist",
  "economy",
  "ecosphere",
  "ecosystem",
  "edge",
  "edginess",
  "edging",
  "edgy",
  "edition",
  "editor",
  "educated",
  "education",
  "educator",
  "eel",
  "effective",
  "effects",
  "efficient",
  "effort",
  "eggbeater",
  "egging",
  "eggnog",
  "eggplant",
  "eggshell",
  "egomaniac",
  "egotism",
  "egotistic",
  "either",
  "eject",
  "elaborate",
  "elastic",
  "elated",
  "elbow",
  "eldercare",
  "elderly",
  "eldest",
  "electable",
  "election",
  "elective",
  "elephant",
  "elevate",
  "elevating",
  "elevation",
  "elevator",
  "eleven",
  "elf",
  "eligible",
  "eligibly",
  "eliminate",
  "elite",
  "elitism",
  "elixir",
  "elk",
  "ellipse",
  "elliptic",
  "elm",
  "elongated",
  "elope",
  "eloquence",
  "eloquent",
  "elsewhere",
  "elude",
  "elusive",
  "elves",
  "email",
  "embargo",
  "embark",
  "embassy",
  "embattled",
  "embellish",
  "ember",
  "embezzle",
  "emblaze",
  "emblem",
  "embody",
  "embolism",
  "emboss",
  "embroider",
  "emcee",
  "emerald",
  "emergency",
  "emission",
  "emit",
  "emote",
  "emoticon",
  "emotion",
  "empathic",
  "empathy",
  "emperor",
  "emphases",
  "emphasis",
  "emphasize",
  "emphatic",
  "empirical",
  "employed",
  "employee",
  "employer",
  "emporium",
  "empower",
  "emptier",
  "emptiness",
  "empty",
  "emu",
  "enable",
  "enactment",
  "enamel",
  "enchanted",
  "enchilada",
  "encircle",
  "enclose",
  "enclosure",
  "encode",
  "encore",
  "encounter",
  "encourage",
  "encroach",
  "encrust",
  "encrypt",
  "endanger",
  "endeared",
  "endearing",
  "ended",
  "ending",
  "endless",
  "endnote",
  "endocrine",
  "endorphin",
  "endorse",
  "endowment",
  "endpoint",
  "endurable",
  "endurance",
  "enduring",
  "energetic",
  "energize",
  "energy",
  "enforced",
  "enforcer",
  "engaged",
  "engaging",
  "engine",
  "engorge",
  "engraved",
  "engraver",
  "engraving",
  "engross",
  "engulf",
  "enhance",
  "enigmatic",
  "enjoyable",
  "enjoyably",
  "enjoyer",
  "enjoying",
  "enjoyment",
  "enlarged",
  "enlarging",
  "enlighten",
  "enlisted",
  "enquirer",
  "enrage",
  "enrich",
  "enroll",
  "enslave",
  "ensnare",
  "ensure",
  "entail",
  "entangled",
  "entering",
  "entertain",
  "enticing",
  "entire",
  "entitle",
  "entity",
  "entomb",
  "entourage",
  "entrap",
  "entree",
  "entrench",
  "entrust",
  "entryway",
  "entwine",
  "enunciate",
  "envelope",
  "enviable",
  "enviably",
  "envious",
  "envision",
  "envoy",
  "envy",
  "enzyme",
  "epic",
  "epidemic",
  "epidermal",
  "epidermis",
  "epidural",
  "epilepsy",
  "epileptic",
  "epilogue",
  "epiphany",
  "episode",
  "equal",
  "equate",
  "equation",
  "equator",
  "equinox",
  "equipment",
  "equity",
  "equivocal",
  "eradicate",
  "erasable",
  "erased",
  "eraser",
  "erasure",
  "ergonomic",
  "errand",
  "errant",
  "erratic",
  "error",
  "erupt",
  "escalate",
  "escalator",
  "escapable",
  "escapade",
  "escapist",
  "escargot",
  "eskimo",
  "esophagus",
  "espionage",
  "espresso",
  "esquire",
  "essay",
  "essence",
  "essential",
  "establish",
  "estate",
  "esteemed",
  "estimate",
  "estimator",
  "estranged",
  "estrogen",
  "etching",
  "eternal",
  "eternity",
  "ethanol",
  "ether",
  "ethically",
  "ethics",
  "euphemism",
  "evacuate",
  "evacuee",
  "evade",
  "evaluate",
  "evaluator",
  "evaporate",
  "evasion",
  "evasive",
  "even",
  "everglade",
  "evergreen",
  "everybody",
  "everyday",
  "everyone",
  "evict",
  "evidence",
  "evident",
  "evil",
  "evoke",
  "evolution",
  "evolve",
  "exact",
  "exalted",
  "example",
  "excavate",
  "excavator",
  "exceeding",
  "exception",
  "excess",
  "exchange",
  "excitable",
  "exciting",
  "exclaim",
  "exclude",
  "excluding",
  "exclusion",
  "exclusive",
  "excretion",
  "excretory",
  "excursion",
  "excusable",
  "excusably",
  "excuse",
  "exemplary",
  "exemplify",
  "exemption",
  "exerciser",
  "exert",
  "exes",
  "exfoliate",
  "exhale",
  "exhaust",
  "exhume",
  "exile",
  "existing",
  "exit",
  "exodus",
  "exonerate",
  "exorcism",
  "exorcist",
  "expand",
  "expanse",
  "expansion",
  "expansive",
  "expectant",
  "expedited",
  "expediter",
  "expel",
  "expend",
  "expenses",
  "expensive",
  "expert",
  "expire",
  "expiring",
  "explain",
  "expletive",
  "explicit",
  "explode",
  "exploit",
  "explore",
  "exploring",
  "exponent",
  "exporter",
  "exposable",
  "expose",
  "exposure",
  "express",
  "expulsion",
  "exquisite",
  "extended",
  "extending",
  "extent",
  "extenuate",
  "exterior",
  "external",
  "extinct",
  "extortion",
  "extradite",
  "extras",
  "extrovert",
  "extrude",
  "extruding",
  "exuberant",
  "fable",
  "fabric",
  "fabulous",
  "facebook",
  "facecloth",
  "facedown",
  "faceless",
  "facelift",
  "faceplate",
  "faceted",
  "facial",
  "facility",
  "facing",
  "facsimile",
  "faction",
  "factoid",
  "factor",
  "factsheet",
  "factual",
  "faculty",
  "fade",
  "fading",
  "failing",
  "falcon",
  "fall",
  "false",
  "falsify",
  "fame",
  "familiar",
  "family",
  "famine",
  "famished",
  "fanatic",
  "fancied",
  "fanciness",
  "fancy",
  "fanfare",
  "fang",
  "fanning",
  "fantasize",
  "fantastic",
  "fantasy",
  "fascism",
  "fastball",
  "faster",
  "fasting",
  "fastness",
  "faucet",
  "favorable",
  "favorably",
  "favored",
  "favoring",
  "favorite",
  "fax",
  "feast",
  "federal",
  "fedora",
  "feeble",
  "feed",
  "feel",
  "feisty",
  "feline",
  "felt-tip",
  "feminine",
  "feminism",
  "feminist",
  "feminize",
  "femur",
  "fence",
  "fencing",
  "fender",
  "ferment",
  "fernlike",
  "ferocious",
  "ferocity",
  "ferret",
  "ferris",
  "ferry",
  "fervor",
  "fester",
  "festival",
  "festive",
  "festivity",
  "fetal",
  "fetch",
  "fever",
  "fiber",
  "fiction",
  "fiddle",
  "fiddling",
  "fidelity",
  "fidgeting",
  "fidgety",
  "fifteen",
  "fifth",
  "fiftieth",
  "fifty",
  "figment",
  "figure",
  "figurine",
  "filing",
  "filled",
  "filler",
  "filling",
  "film",
  "filter",
  "filth",
  "filtrate",
  "finale",
  "finalist",
  "finalize",
  "finally",
  "finance",
  "financial",
  "finch",
  "fineness",
  "finer",
  "finicky",
  "finished",
  "finisher",
  "finishing",
  "finite",
  "finless",
  "finlike",
  "fiscally",
  "fit",
  "five",
  "flaccid",
  "flagman",
  "flagpole",
  "flagship",
  "flagstick",
  "flagstone",
  "flail",
  "flakily",
  "flaky",
  "flame",
  "flammable",
  "flanked",
  "flanking",
  "flannels",
  "flap",
  "flaring",
  "flashback",
  "flashbulb",
  "flashcard",
  "flashily",
  "flashing",
  "flashy",
  "flask",
  "flatbed",
  "flatfoot",
  "flatly",
  "flatness",
  "flatten",
  "flattered",
  "flatterer",
  "flattery",
  "flattop",
  "flatware",
  "flatworm",
  "flavored",
  "flavorful",
  "flavoring",
  "flaxseed",
  "fled",
  "fleshed",
  "fleshy",
  "flick",
  "flier",
  "flight",
  "flinch",
  "fling",
  "flint",
  "flip",
  "flirt",
  "float",
  "flock",
  "flogging",
  "flop",
  "floral",
  "florist",
  "floss",
  "flounder",
  "flyable",
  "flyaway",
  "flyer",
  "flying",
  "flyover",
  "flypaper",
  "foam",
  "foe",
  "fog",
  "foil",
  "folic",
  "folk",
  "follicle",
  "follow",
  "fondling",
  "fondly",
  "fondness",
  "fondue",
  "font",
  "food",
  "fool",
  "footage",
  "football",
  "footbath",
  "footboard",
  "footer",
  "footgear",
  "foothill",
  "foothold",
  "footing",
  "footless",
  "footman",
  "footnote",
  "footpad",
  "footpath",
  "footprint",
  "footrest",
  "footsie",
  "footsore",
  "footwear",
  "footwork",
  "fossil",
  "foster",
  "founder",
  "founding",
  "fountain",
  "fox",
  "foyer",
  "fraction",
  "fracture",
  "fragile",
  "fragility",
  "fragment",
  "fragrance",
  "fragrant",
  "frail",
  "frame",
  "framing",
  "frantic",
  "fraternal",
  "frayed",
  "fraying",
  "frays",
  "freckled",
  "freckles",
  "freebase",
  "freebee",
  "freebie",
  "freedom",
  "freefall",
  "freehand",
  "freeing",
  "freeload",
  "freely",
  "freemason",
  "freeness",
  "freestyle",
  "freeware",
  "freeway",
  "freewill",
  "freezable",
  "freezing",
  "freight",
  "french",
  "frenzied",
  "frenzy",
  "frequency",
  "frequent",
  "fresh",
  "fretful",
  "fretted",
  "friction",
  "friday",
  "fridge",
  "fried",
  "friend",
  "frighten",
  "frightful",
  "frigidity",
  "frigidly",
  "frill",
  "fringe",
  "frisbee",
  "frisk",
  "fritter",
  "frivolous",
  "frolic",
  "from",
  "front",
  "frostbite",
  "frosted",
  "frostily",
  "frosting",
  "frostlike",
  "frosty",
  "froth",
  "frown",
  "frozen",
  "fructose",
  "frugality",
  "frugally",
  "fruit",
  "frustrate",
  "frying",
  "gab",
  "gaffe",
  "gag",
  "gainfully",
  "gaining",
  "gains",
  "gala",
  "gallantly",
  "galleria",
  "gallery",
  "galley",
  "gallon",
  "gallows",
  "gallstone",
  "galore",
  "galvanize",
  "gambling",
  "game",
  "gaming",
  "gamma",
  "gander",
  "gangly",
  "gangrene",
  "gangway",
  "gap",
  "garage",
  "garbage",
  "garden",
  "gargle",
  "garland",
  "garlic",
  "garment",
  "garnet",
  "garnish",
  "garter",
  "gas",
  "gatherer",
  "gathering",
  "gating",
  "gauging",
  "gauntlet",
  "gauze",
  "gave",
  "gawk",
  "gazing",
  "gear",
  "gecko",
  "geek",
  "geiger",
  "gem",
  "gender",
  "generic",
  "generous",
  "genetics",
  "genre",
  "gentile",
  "gentleman",
  "gently",
  "gents",
  "geography",
  "geologic",
  "geologist",
  "geology",
  "geometric",
  "geometry",
  "geranium",
  "gerbil",
  "geriatric",
  "germicide",
  "germinate",
  "germless",
  "germproof",
  "gestate",
  "gestation",
  "gesture",
  "getaway",
  "getting",
  "getup",
  "giant",
  "gibberish",
  "giblet",
  "giddily",
  "giddiness",
  "giddy",
  "gift",
  "gigabyte",
  "gigahertz",
  "gigantic",
  "giggle",
  "giggling",
  "giggly",
  "gigolo",
  "gilled",
  "gills",
  "gimmick",
  "girdle",
  "giveaway",
  "given",
  "giver",
  "giving",
  "gizmo",
  "gizzard",
  "glacial",
  "glacier",
  "glade",
  "gladiator",
  "gladly",
  "glamorous",
  "glamour",
  "glance",
  "glancing",
  "glandular",
  "glare",
  "glaring",
  "glass",
  "glaucoma",
  "glazing",
  "gleaming",
  "gleeful",
  "glider",
  "gliding",
  "glimmer",
  "glimpse",
  "glisten",
  "glitch",
  "glitter",
  "glitzy",
  "gloater",
  "gloating",
  "gloomily",
  "gloomy",
  "glorified",
  "glorifier",
  "glorify",
  "glorious",
  "glory",
  "gloss",
  "glove",
  "glowing",
  "glowworm",
  "glucose",
  "glue",
  "gluten",
  "glutinous",
  "glutton",
  "gnarly",
  "gnat",
  "goal",
  "goatskin",
  "goes",
  "goggles",
  "going",
  "goldfish",
  "goldmine",
  "goldsmith",
  "golf",
  "goliath",
  "gonad",
  "gondola",
  "gone",
  "gong",
  "good",
  "gooey",
  "goofball",
  "goofiness",
  "goofy",
  "google",
  "goon",
  "gopher",
  "gore",
  "gorged",
  "gorgeous",
  "gory",
  "gosling",
  "gossip",
  "gothic",
  "gotten",
  "gout",
  "gown",
  "grab",
  "graceful",
  "graceless",
  "gracious",
  "gradation",
  "graded",
  "grader",
  "gradient",
  "grading",
  "gradually",
  "graduate",
  "graffiti",
  "grafted",
  "grafting",
  "grain",
  "granddad",
  "grandkid",
  "grandly",
  "grandma",
  "grandpa",
  "grandson",
  "granite",
  "granny",
  "granola",
  "grant",
  "granular",
  "grape",
  "graph",
  "grapple",
  "grappling",
  "grasp",
  "grass",
  "gratified",
  "gratify",
  "grating",
  "gratitude",
  "gratuity",
  "gravel",
  "graveness",
  "graves",
  "graveyard",
  "gravitate",
  "gravity",
  "gravy",
  "gray",
  "grazing",
  "greasily",
  "greedily",
  "greedless",
  "greedy",
  "green",
  "greeter",
  "greeting",
  "grew",
  "greyhound",
  "grid",
  "grief",
  "grievance",
  "grieving",
  "grievous",
  "grill",
  "grimace",
  "grimacing",
  "grime",
  "griminess",
  "grimy",
  "grinch",
  "grinning",
  "grip",
  "gristle",
  "grit",
  "groggily",
  "groggy",
  "groin",
  "groom",
  "groove",
  "grooving",
  "groovy",
  "grope",
  "ground",
  "grouped",
  "grout",
  "grove",
  "grower",
  "growing",
  "growl",
  "grub",
  "grudge",
  "grudging",
  "grueling",
  "gruffly",
  "grumble",
  "grumbling",
  "grumbly",
  "grumpily",
  "grunge",
  "grunt",
  "guacamole",
  "guidable",
  "guidance",
  "guide",
  "guiding",
  "guileless",
  "guise",
  "gulf",
  "gullible",
  "gully",
  "gulp",
  "gumball",
  "gumdrop",
  "gumminess",
  "gumming",
  "gummy",
  "gurgle",
  "gurgling",
  "guru",
  "gush",
  "gusto",
  "gusty",
  "gutless",
  "guts",
  "gutter",
  "guy",
  "guzzler",
  "gyration",
  "habitable",
  "habitant",
  "habitat",
  "habitual",
  "hacked",
  "hacker",
  "hacking",
  "hacksaw",
  "had",
  "haggler",
  "haiku",
  "half",
  "halogen",
  "halt",
  "halved",
  "halves",
  "hamburger",
  "hamlet",
  "hammock",
  "hamper",
  "hamster",
  "hamstring",
  "handbag",
  "handball",
  "handbook",
  "handbrake",
  "handcart",
  "handclap",
  "handclasp",
  "handcraft",
  "handcuff",
  "handed",
  "handful",
  "handgrip",
  "handgun",
  "handheld",
  "handiness",
  "handiwork",
  "handlebar",
  "handled",
  "handler",
  "handling",
  "handmade",
  "handoff",
  "handpick",
  "handprint",
  "handrail",
  "handsaw",
  "handset",
  "handsfree",
  "handshake",
  "handstand",
  "handwash",
  "handwork",
  "handwoven",
  "handwrite",
  "handyman",
  "hangnail",
  "hangout",
  "hangover",
  "hangup",
  "hankering",
  "hankie",
  "hanky",
  "haphazard",
  "happening",
  "happier",
  "happiest",
  "happily",
  "happiness",
  "happy",
  "harbor",
  "hardcopy",
  "hardcore",
  "hardcover",
  "harddisk",
  "hardened",
  "hardener",
  "hardening",
  "hardhat",
  "hardhead",
  "hardiness",
  "hardly",
  "hardness",
  "hardship",
  "hardware",
  "hardwired",
  "hardwood",
  "hardy",
  "harmful",
  "harmless",
  "harmonica",
  "harmonics",
  "harmonize",
  "harmony",
  "harness",
  "harpist",
  "harsh",
  "harvest",
  "hash",
  "hassle",
  "haste",
  "hastily",
  "hastiness",
  "hasty",
  "hatbox",
  "hatchback",
  "hatchery",
  "hatchet",
  "hatching",
  "hatchling",
  "hate",
  "hatless",
  "hatred",
  "haunt",
  "haven",
  "hazard",
  "hazelnut",
  "hazily",
  "haziness",
  "hazing",
  "hazy",
  "headache",
  "headband",
  "headboard",
  "headcount",
  "headdress",
  "headed",
  "header",
  "headfirst",
  "headgear",
  "heading",
  "headlamp",
  "headless",
  "headlock",
  "headphone",
  "headpiece",
  "headrest",
  "headroom",
  "headscarf",
  "headset",
  "headsman",
  "headstand",
  "headstone",
  "headway",
  "headwear",
  "heap",
  "heat",
  "heave",
  "heavily",
  "heaviness",
  "heaving",
  "hedge",
  "hedging",
  "heftiness",
  "hefty",
  "helium",
  "helmet",
  "helper",
  "helpful",
  "helping",
  "helpless",
  "helpline",
  "hemlock",
  "hemstitch",
  "hence",
  "henchman",
  "henna",
  "herald",
  "herbal",
  "herbicide",
  "herbs",
  "heritage",
  "hermit",
  "heroics",
  "heroism",
  "herring",
  "herself",
  "hertz",
  "hesitancy",
  "hesitant",
  "hesitate",
  "hexagon",
  "hexagram",
  "hubcap",
  "huddle",
  "huddling",
  "huff",
  "hug",
  "hula",
  "hulk",
  "hull",
  "human",
  "humble",
  "humbling",
  "humbly",
  "humid",
  "humiliate",
  "humility",
  "humming",
  "hummus",
  "humongous",
  "humorist",
  "humorless",
  "humorous",
  "humpback",
  "humped",
  "humvee",
  "hunchback",
  "hundredth",
  "hunger",
  "hungrily",
  "hungry",
  "hunk",
  "hunter",
  "hunting",
  "huntress",
  "huntsman",
  "hurdle",
  "hurled",
  "hurler",
  "hurling",
  "hurray",
  "hurricane",
  "hurried",
  "hurry",
  "hurt",
  "husband",
  "hush",
  "husked",
  "huskiness",
  "hut",
  "hybrid",
  "hydrant",
  "hydrated",
  "hydration",
  "hydrogen",
  "hydroxide",
  "hyperlink",
  "hypertext",
  "hyphen",
  "hypnoses",
  "hypnosis",
  "hypnotic",
  "hypnotism",
  "hypnotist",
  "hypnotize",
  "hypocrisy",
  "hypocrite",
  "ibuprofen",
  "ice",
  "iciness",
  "icing",
  "icky",
  "icon",
  "icy",
  "idealism",
  "idealist",
  "idealize",
  "ideally",
  "idealness",
  "identical",
  "identify",
  "identity",
  "ideology",
  "idiocy",
  "idiom",
  "idly",
  "igloo",
  "ignition",
  "ignore",
  "iguana",
  "illicitly",
  "illusion",
  "illusive",
  "image",
  "imaginary",
  "imagines",
  "imaging",
  "imbecile",
  "imitate",
  "imitation",
  "immature",
  "immerse",
  "immersion",
  "imminent",
  "immobile",
  "immodest",
  "immorally",
  "immortal",
  "immovable",
  "immovably",
  "immunity",
  "immunize",
  "impaired",
  "impale",
  "impart",
  "impatient",
  "impeach",
  "impeding",
  "impending",
  "imperfect",
  "imperial",
  "impish",
  "implant",
  "implement",
  "implicate",
  "implicit",
  "implode",
  "implosion",
  "implosive",
  "imply",
  "impolite",
  "important",
  "importer",
  "impose",
  "imposing",
  "impotence",
  "impotency",
  "impotent",
  "impound",
  "imprecise",
  "imprint",
  "imprison",
  "impromptu",
  "improper",
  "improve",
  "improving",
  "improvise",
  "imprudent",
  "impulse",
  "impulsive",
  "impure",
  "impurity",
  "iodine",
  "iodize",
  "ion",
  "ipad",
  "iphone",
  "ipod",
  "irate",
  "irk",
  "iron",
  "irregular",
  "irrigate",
  "irritable",
  "irritably",
  "irritant",
  "irritate",
  "islamic",
  "islamist",
  "isolated",
  "isolating",
  "isolation",
  "isotope",
  "issue",
  "issuing",
  "italicize",
  "italics",
  "item",
  "itinerary",
  "itunes",
  "ivory",
  "ivy",
  "jab",
  "jackal",
  "jacket",
  "jackknife",
  "jackpot",
  "jailbird",
  "jailbreak",
  "jailer",
  "jailhouse",
  "jalapeno",
  "jam",
  "janitor",
  "january",
  "jargon",
  "jarring",
  "jasmine",
  "jaundice",
  "jaunt",
  "java",
  "jawed",
  "jawless",
  "jawline",
  "jaws",
  "jaybird",
  "jaywalker",
  "jazz",
  "jeep",
  "jeeringly",
  "jellied",
  "jelly",
  "jersey",
  "jester",
  "jet",
  "jiffy",
  "jigsaw",
  "jimmy",
  "jingle",
  "jingling",
  "jinx",
  "jitters",
  "jittery",
  "job",
  "jockey",
  "jockstrap",
  "jogger",
  "jogging",
  "john",
  "joining",
  "jokester",
  "jokingly",
  "jolliness",
  "jolly",
  "jolt",
  "jot",
  "jovial",
  "joyfully",
  "joylessly",
  "joyous",
  "joyride",
  "joystick",
  "jubilance",
  "jubilant",
  "judge",
  "judgingly",
  "judicial",
  "judiciary",
  "judo",
  "juggle",
  "juggling",
  "jugular",
  "juice",
  "juiciness",
  "juicy",
  "jujitsu",
  "jukebox",
  "july",
  "jumble",
  "jumbo",
  "jump",
  "junction",
  "juncture",
  "june",
  "junior",
  "juniper",
  "junkie",
  "junkman",
  "junkyard",
  "jurist",
  "juror",
  "jury",
  "justice",
  "justifier",
  "justify",
  "justly",
  "justness",
  "juvenile",
  "kabob",
  "kangaroo",
  "karaoke",
  "karate",
  "karma",
  "kebab",
  "keenly",
  "keenness",
  "keep",
  "keg",
  "kelp",
  "kennel",
  "kept",
  "kerchief",
  "kerosene",
  "kettle",
  "kick",
  "kiln",
  "kilobyte",
  "kilogram",
  "kilometer",
  "kilowatt",
  "kilt",
  "kimono",
  "kindle",
  "kindling",
  "kindly",
  "kindness",
  "kindred",
  "kinetic",
  "kinfolk",
  "king",
  "kinship",
  "kinsman",
  "kinswoman",
  "kissable",
  "kisser",
  "kissing",
  "kitchen",
  "kite",
  "kitten",
  "kitty",
  "kiwi",
  "kleenex",
  "knapsack",
  "knee",
  "knelt",
  "knickers",
  "knoll",
  "koala",
  "kooky",
  "kosher",
  "krypton",
  "kudos",
  "kung",
  "labored",
  "laborer",
  "laboring",
  "laborious",
  "labrador",
  "ladder",
  "ladies",
  "ladle",
  "ladybug",
  "ladylike",
  "lagged",
  "lagging",
  "lagoon",
  "lair",
  "lake",
  "lance",
  "landed",
  "landfall",
  "landfill",
  "landing",
  "landlady",
  "landless",
  "landline",
  "landlord",
  "landmark",
  "landmass",
  "landmine",
  "landowner",
  "landscape",
  "landside",
  "landslide",
  "language",
  "lankiness",
  "lanky",
  "lantern",
  "lapdog",
  "lapel",
  "lapped",
  "lapping",
  "laptop",
  "lard",
  "large",
  "lark",
  "lash",
  "lasso",
  "last",
  "latch",
  "late",
  "lather",
  "latitude",
  "latrine",
  "latter",
  "latticed",
  "launch",
  "launder",
  "laundry",
  "laurel",
  "lavender",
  "lavish",
  "laxative",
  "lazily",
  "laziness",
  "lazy",
  "lecturer",
  "left",
  "legacy",
  "legal",
  "legend",
  "legged",
  "leggings",
  "legible",
  "legibly",
  "legislate",
  "lego",
  "legroom",
  "legume",
  "legwarmer",
  "legwork",
  "lemon",
  "lend",
  "length",
  "lens",
  "lent",
  "leotard",
  "lesser",
  "letdown",
  "lethargic",
  "lethargy",
  "letter",
  "lettuce",
  "level",
  "leverage",
  "levers",
  "levitate",
  "levitator",
  "liability",
  "liable",
  "liberty",
  "librarian",
  "library",
  "licking",
  "licorice",
  "lid",
  "life",
  "lifter",
  "lifting",
  "liftoff",
  "ligament",
  "likely",
  "likeness",
  "likewise",
  "liking",
  "lilac",
  "lilly",
  "lily",
  "limb",
  "limeade",
  "limelight",
  "limes",
  "limit",
  "limping",
  "limpness",
  "line",
  "lingo",
  "linguini",
  "linguist",
  "lining",
  "linked",
  "linoleum",
  "linseed",
  "lint",
  "lion",
  "lip",
  "liquefy",
  "liqueur",
  "liquid",
  "lisp",
  "list",
  "litigate",
  "litigator",
  "litmus",
  "litter",
  "little",
  "livable",
  "lived",
  "lively",
  "liver",
  "livestock",
  "lividly",
  "living",
  "lizard",
  "lubricant",
  "lubricate",
  "lucid",
  "luckily",
  "luckiness",
  "luckless",
  "lucrative",
  "ludicrous",
  "lugged",
  "lukewarm",
  "lullaby",
  "lumber",
  "luminance",
  "luminous",
  "lumpiness",
  "lumping",
  "lumpish",
  "lunacy",
  "lunar",
  "lunchbox",
  "luncheon",
  "lunchroom",
  "lunchtime",
  "lung",
  "lurch",
  "lure",
  "luridness",
  "lurk",
  "lushly",
  "lushness",
  "luster",
  "lustfully",
  "lustily",
  "lustiness",
  "lustrous",
  "lusty",
  "luxurious",
  "luxury",
  "lying",
  "lyrically",
  "lyricism",
  "lyricist",
  "lyrics",
  "macarena",
  "macaroni",
  "macaw",
  "mace",
  "machine",
  "machinist",
  "magazine",
  "magenta",
  "maggot",
  "magical",
  "magician",
  "magma",
  "magnesium",
  "magnetic",
  "magnetism",
  "magnetize",
  "magnifier",
  "magnify",
  "magnitude",
  "magnolia",
  "mahogany",
  "maimed",
  "majestic",
  "majesty",
  "majorette",
  "majority",
  "makeover",
  "maker",
  "makeshift",
  "making",
  "malformed",
  "malt",
  "mama",
  "mammal",
  "mammary",
  "mammogram",
  "manager",
  "managing",
  "manatee",
  "mandarin",
  "mandate",
  "mandatory",
  "mandolin",
  "manger",
  "mangle",
  "mango",
  "mangy",
  "manhandle",
  "manhole",
  "manhood",
  "manhunt",
  "manicotti",
  "manicure",
  "manifesto",
  "manila",
  "mankind",
  "manlike",
  "manliness",
  "manly",
  "manmade",
  "manned",
  "mannish",
  "manor",
  "manpower",
  "mantis",
  "mantra",
  "manual",
  "many",
  "map",
  "marathon",
  "marauding",
  "marbled",
  "marbles",
  "marbling",
  "march",
  "mardi",
  "margarine",
  "margarita",
  "margin",
  "marigold",
  "marina",
  "marine",
  "marital",
  "maritime",
  "marlin",
  "marmalade",
  "maroon",
  "married",
  "marrow",
  "marry",
  "marshland",
  "marshy",
  "marsupial",
  "marvelous",
  "marxism",
  "mascot",
  "masculine",
  "mashed",
  "mashing",
  "massager",
  "masses",
  "massive",
  "mastiff",
  "matador",
  "matchbook",
  "matchbox",
  "matcher",
  "matching",
  "matchless",
  "material",
  "maternal",
  "maternity",
  "math",
  "mating",
  "matriarch",
  "matrimony",
  "matrix",
  "matron",
  "matted",
  "matter",
  "maturely",
  "maturing",
  "maturity",
  "mauve",
  "maverick",
  "maximize",
  "maximum",
  "maybe",
  "mayday",
  "mayflower",
  "moaner",
  "moaning",
  "mobile",
  "mobility",
  "mobilize",
  "mobster",
  "mocha",
  "mocker",
  "mockup",
  "modified",
  "modify",
  "modular",
  "modulator",
  "module",
  "moisten",
  "moistness",
  "moisture",
  "molar",
  "molasses",
  "mold",
  "molecular",
  "molecule",
  "molehill",
  "mollusk",
  "mom",
  "monastery",
  "monday",
  "monetary",
  "monetize",
  "moneybags",
  "moneyless",
  "moneywise",
  "mongoose",
  "mongrel",
  "monitor",
  "monkhood",
  "monogamy",
  "monogram",
  "monologue",
  "monopoly",
  "monorail",
  "monotone",
  "monotype",
  "monoxide",
  "monsieur",
  "monsoon",
  "monstrous",
  "monthly",
  "monument",
  "moocher",
  "moodiness",
  "moody",
  "mooing",
  "moonbeam",
  "mooned",
  "moonlight",
  "moonlike",
  "moonlit",
  "moonrise",
  "moonscape",
  "moonshine",
  "moonstone",
  "moonwalk",
  "mop",
  "morale",
  "morality",
  "morally",
  "morbidity",
  "morbidly",
  "morphine",
  "morphing",
  "morse",
  "mortality",
  "mortally",
  "mortician",
  "mortified",
  "mortify",
  "mortuary",
  "mosaic",
  "mossy",
  "most",
  "mothball",
  "mothproof",
  "motion",
  "motivate",
  "motivator",
  "motive",
  "motocross",
  "motor",
  "motto",
  "mountable",
  "mountain",
  "mounted",
  "mounting",
  "mourner",
  "mournful",
  "mouse",
  "mousiness",
  "moustache",
  "mousy",
  "mouth",
  "movable",
  "move",
  "movie",
  "moving",
  "mower",
  "mowing",
  "much",
  "muck",
  "mud",
  "mug",
  "mulberry",
  "mulch",
  "mule",
  "mulled",
  "mullets",
  "multiple",
  "multiply",
  "multitask",
  "multitude",
  "mumble",
  "mumbling",
  "mumbo",
  "mummified",
  "mummify",
  "mummy",
  "mumps",
  "munchkin",
  "mundane",
  "municipal",
  "muppet",
  "mural",
  "murkiness",
  "murky",
  "murmuring",
  "muscular",
  "museum",
  "mushily",
  "mushiness",
  "mushroom",
  "mushy",
  "music",
  "musket",
  "muskiness",
  "musky",
  "mustang",
  "mustard",
  "muster",
  "mustiness",
  "musty",
  "mutable",
  "mutate",
  "mutation",
  "mute",
  "mutilated",
  "mutilator",
  "mutiny",
  "mutt",
  "mutual",
  "muzzle",
  "myself",
  "myspace",
  "mystified",
  "mystify",
  "myth",
  "nacho",
  "nag",
  "nail",
  "name",
  "naming",
  "nanny",
  "nanometer",
  "nape",
  "napkin",
  "napped",
  "napping",
  "nappy",
  "narrow",
  "nastily",
  "nastiness",
  "national",
  "native",
  "nativity",
  "natural",
  "nature",
  "naturist",
  "nautical",
  "navigate",
  "navigator",
  "navy",
  "nearby",
  "nearest",
  "nearly",
  "nearness",
  "neatly",
  "neatness",
  "nebula",
  "nebulizer",
  "nectar",
  "negate",
  "negation",
  "negative",
  "neglector",
  "negligee",
  "negligent",
  "negotiate",
  "nemeses",
  "nemesis",
  "neon",
  "nephew",
  "nerd",
  "nervous",
  "nervy",
  "nest",
  "net",
  "neurology",
  "neuron",
  "neurosis",
  "neurotic",
  "neuter",
  "neutron",
  "never",
  "next",
  "nibble",
  "nickname",
  "nicotine",
  "niece",
  "nifty",
  "nimble",
  "nimbly",
  "nineteen",
  "ninetieth",
  "ninja",
  "nintendo",
  "ninth",
  "nuclear",
  "nuclei",
  "nucleus",
  "nugget",
  "nullify",
  "number",
  "numbing",
  "numbly",
  "numbness",
  "numeral",
  "numerate",
  "numerator",
  "numeric",
  "numerous",
  "nuptials",
  "nursery",
  "nursing",
  "nurture",
  "nutcase",
  "nutlike",
  "nutmeg",
  "nutrient",
  "nutshell",
  "nuttiness",
  "nutty",
  "nuzzle",
  "nylon",
  "oaf",
  "oak",
  "oasis",
  "oat",
  "obedience",
  "obedient",
  "obituary",
  "object",
  "obligate",
  "obliged",
  "oblivion",
  "oblivious",
  "oblong",
  "obnoxious",
  "oboe",
  "obscure",
  "obscurity",
  "observant",
  "observer",
  "observing",
  "obsessed",
  "obsession",
  "obsessive",
  "obsolete",
  "obstacle",
  "obstinate",
  "obstruct",
  "obtain",
  "obtrusive",
  "obtuse",
  "obvious",
  "occultist",
  "occupancy",
  "occupant",
  "occupier",
  "occupy",
  "ocean",
  "ocelot",
  "octagon",
  "octane",
  "october",
  "octopus",
  "ogle",
  "oil",
  "oink",
  "ointment",
  "okay",
  "old",
  "olive",
  "olympics",
  "omega",
  "omen",
  "ominous",
  "omission",
  "omit",
  "omnivore",
  "onboard",
  "oncoming",
  "ongoing",
  "onion",
  "online",
  "onlooker",
  "only",
  "onscreen",
  "onset",
  "onshore",
  "onslaught",
  "onstage",
  "onto",
  "onward",
  "onyx",
  "oops",
  "ooze",
  "oozy",
  "opacity",
  "opal",
  "open",
  "operable",
  "operate",
  "operating",
  "operation",
  "operative",
  "operator",
  "opium",
  "opossum",
  "opponent",
  "oppose",
  "opposing",
  "opposite",
  "oppressed",
  "oppressor",
  "opt",
  "opulently",
  "osmosis",
  "other",
  "otter",
  "ouch",
  "ought",
  "ounce",
  "outage",
  "outback",
  "outbid",
  "outboard",
  "outbound",
  "outbreak",
  "outburst",
  "outcast",
  "outclass",
  "outcome",
  "outdated",
  "outdoors",
  "outer",
  "outfield",
  "outfit",
  "outflank",
  "outgoing",
  "outgrow",
  "outhouse",
  "outing",
  "outlast",
  "outlet",
  "outline",
  "outlook",
  "outlying",
  "outmatch",
  "outmost",
  "outnumber",
  "outplayed",
  "outpost",
  "outpour",
  "output",
  "outrage",
  "outrank",
  "outreach",
  "outright",
  "outscore",
  "outsell",
  "outshine",
  "outshoot",
  "outsider",
  "outskirts",
  "outsmart",
  "outsource",
  "outspoken",
  "outtakes",
  "outthink",
  "outward",
  "outweigh",
  "outwit",
  "oval",
  "ovary",
  "oven",
  "overact",
  "overall",
  "overarch",
  "overbid",
  "overbill",
  "overbite",
  "overblown",
  "overboard",
  "overbook",
  "overbuilt",
  "overcast",
  "overcoat",
  "overcome",
  "overcook",
  "overcrowd",
  "overdraft",
  "overdrawn",
  "overdress",
  "overdrive",
  "overdue",
  "overeager",
  "overeater",
  "overexert",
  "overfed",
  "overfeed",
  "overfill",
  "overflow",
  "overfull",
  "overgrown",
  "overhand",
  "overhang",
  "overhaul",
  "overhead",
  "overhear",
  "overheat",
  "overhung",
  "overjoyed",
  "overkill",
  "overlabor",
  "overlaid",
  "overlap",
  "overlay",
  "overload",
  "overlook",
  "overlord",
  "overlying",
  "overnight",
  "overpass",
  "overpay",
  "overplant",
  "overplay",
  "overpower",
  "overprice",
  "overrate",
  "overreach",
  "overreact",
  "override",
  "overripe",
  "overrule",
  "overrun",
  "overshoot",
  "overshot",
  "oversight",
  "oversized",
  "oversleep",
  "oversold",
  "overspend",
  "overstate",
  "overstay",
  "overstep",
  "overstock",
  "overstuff",
  "oversweet",
  "overtake",
  "overthrow",
  "overtime",
  "overtly",
  "overtone",
  "overture",
  "overturn",
  "overuse",
  "overvalue",
  "overview",
  "overwrite",
  "owl",
  "oxford",
  "oxidant",
  "oxidation",
  "oxidize",
  "oxidizing",
  "oxygen",
  "oxymoron",
  "oyster",
  "ozone",
  "paced",
  "pacemaker",
  "pacific",
  "pacifier",
  "pacifism",
  "pacifist",
  "pacify",
  "padded",
  "padding",
  "paddle",
  "paddling",
  "padlock",
  "pagan",
  "pager",
  "paging",
  "pajamas",
  "palace",
  "palatable",
  "palm",
  "palpable",
  "palpitate",
  "paltry",
  "pampered",
  "pamperer",
  "pampers",
  "pamphlet",
  "panama",
  "pancake",
  "pancreas",
  "panda",
  "pandemic",
  "pang",
  "panhandle",
  "panic",
  "panning",
  "panorama",
  "panoramic",
  "panther",
  "pantomime",
  "pantry",
  "pants",
  "pantyhose",
  "paparazzi",
  "papaya",
  "paper",
  "paprika",
  "papyrus",
  "parabola",
  "parachute",
  "parade",
  "paradox",
  "paragraph",
  "parakeet",
  "paralegal",
  "paralyses",
  "paralysis",
  "paralyze",
  "paramedic",
  "parameter",
  "paramount",
  "parasail",
  "parasite",
  "parasitic",
  "parcel",
  "parched",
  "parchment",
  "pardon",
  "parish",
  "parka",
  "parking",
  "parkway",
  "parlor",
  "parmesan",
  "parole",
  "parrot",
  "parsley",
  "parsnip",
  "partake",
  "parted",
  "parting",
  "partition",
  "partly",
  "partner",
  "partridge",
  "party",
  "passable",
  "passably",
  "passage",
  "passcode",
  "passenger",
  "passerby",
  "passing",
  "passion",
  "passive",
  "passivism",
  "passover",
  "passport",
  "password",
  "pasta",
  "pasted",
  "pastel",
  "pastime",
  "pastor",
  "pastrami",
  "pasture",
  "pasty",
  "patchwork",
  "patchy",
  "paternal",
  "paternity",
  "path",
  "patience",
  "patient",
  "patio",
  "patriarch",
  "patriot",
  "patrol",
  "patronage",
  "patronize",
  "pauper",
  "pavement",
  "paver",
  "pavestone",
  "pavilion",
  "paving",
  "pawing",
  "payable",
  "payback",
  "paycheck",
  "payday",
  "payee",
  "payer",
  "paying",
  "payment",
  "payphone",
  "payroll",
  "pebble",
  "pebbly",
  "pecan",
  "pectin",
  "peculiar",
  "peddling",
  "pediatric",
  "pedicure",
  "pedigree",
  "pedometer",
  "pegboard",
  "pelican",
  "pellet",
  "pelt",
  "pelvis",
  "penalize",
  "penalty",
  "pencil",
  "pendant",
  "pending",
  "penholder",
  "penknife",
  "pennant",
  "penniless",
  "penny",
  "penpal",
  "pension",
  "pentagon",
  "pentagram",
  "pep",
  "perceive",
  "percent",
  "perch",
  "percolate",
  "perennial",
  "perfected",
  "perfectly",
  "perfume",
  "periscope",
  "perish",
  "perjurer",
  "perjury",
  "perkiness",
  "perky",
  "perm",
  "peroxide",
  "perpetual",
  "perplexed",
  "persecute",
  "persevere",
  "persuaded",
  "persuader",
  "pesky",
  "peso",
  "pessimism",
  "pessimist",
  "pester",
  "pesticide",
  "petal",
  "petite",
  "petition",
  "petri",
  "petroleum",
  "petted",
  "petticoat",
  "pettiness",
  "petty",
  "petunia",
  "phantom",
  "phobia",
  "phoenix",
  "phonebook",
  "phoney",
  "phonics",
  "phoniness",
  "phony",
  "phosphate",
  "photo",
  "phrase",
  "phrasing",
  "placard",
  "placate",
  "placidly",
  "plank",
  "planner",
  "plant",
  "plasma",
  "plaster",
  "plastic",
  "plated",
  "platform",
  "plating",
  "platinum",
  "platonic",
  "platter",
  "platypus",
  "plausible",
  "plausibly",
  "playable",
  "playback",
  "player",
  "playful",
  "playgroup",
  "playhouse",
  "playing",
  "playlist",
  "playmaker",
  "playmate",
  "playoff",
  "playpen",
  "playroom",
  "playset",
  "plaything",
  "playtime",
  "plaza",
  "pleading",
  "pleat",
  "pledge",
  "plentiful",
  "plenty",
  "plethora",
  "plexiglas",
  "pliable",
  "plod",
  "plop",
  "plot",
  "plow",
  "ploy",
  "pluck",
  "plug",
  "plunder",
  "plunging",
  "plural",
  "plus",
  "plutonium",
  "plywood",
  "poach",
  "pod",
  "poem",
  "poet",
  "pogo",
  "pointed",
  "pointer",
  "pointing",
  "pointless",
  "pointy",
  "poise",
  "poison",
  "poker",
  "poking",
  "polar",
  "police",
  "policy",
  "polio",
  "polish",
  "politely",
  "polka",
  "polo",
  "polyester",
  "polygon",
  "polygraph",
  "polymer",
  "poncho",
  "pond",
  "pony",
  "popcorn",
  "pope",
  "poplar",
  "popper",
  "poppy",
  "popsicle",
  "populace",
  "popular",
  "populate",
  "porcupine",
  "pork",
  "porous",
  "porridge",
  "portable",
  "portal",
  "portfolio",
  "porthole",
  "portion",
  "portly",
  "portside",
  "poser",
  "posh",
  "posing",
  "possible",
  "possibly",
  "possum",
  "postage",
  "postal",
  "postbox",
  "postcard",
  "posted",
  "poster",
  "posting",
  "postnasal",
  "posture",
  "postwar",
  "pouch",
  "pounce",
  "pouncing",
  "pound",
  "pouring",
  "pout",
  "powdered",
  "powdering",
  "powdery",
  "power",
  "powwow",
  "pox",
  "praising",
  "prance",
  "prancing",
  "pranker",
  "prankish",
  "prankster",
  "prayer",
  "praying",
  "preacher",
  "preaching",
  "preachy",
  "preamble",
  "precinct",
  "precise",
  "precision",
  "precook",
  "precut",
  "predator",
  "predefine",
  "predict",
  "preface",
  "prefix",
  "preflight",
  "preformed",
  "pregame",
  "pregnancy",
  "pregnant",
  "preheated",
  "prelaunch",
  "prelaw",
  "prelude",
  "premiere",
  "premises",
  "premium",
  "prenatal",
  "preoccupy",
  "preorder",
  "prepaid",
  "prepay",
  "preplan",
  "preppy",
  "preschool",
  "prescribe",
  "preseason",
  "preset",
  "preshow",
  "president",
  "presoak",
  "press",
  "presume",
  "presuming",
  "preteen",
  "pretended",
  "pretender",
  "pretense",
  "pretext",
  "pretty",
  "pretzel",
  "prevail",
  "prevalent",
  "prevent",
  "preview",
  "previous",
  "prewar",
  "prewashed",
  "prideful",
  "pried",
  "primal",
  "primarily",
  "primary",
  "primate",
  "primer",
  "primp",
  "princess",
  "print",
  "prior",
  "prism",
  "prison",
  "prissy",
  "pristine",
  "privacy",
  "private",
  "privatize",
  "prize",
  "proactive",
  "probable",
  "probably",
  "probation",
  "probe",
  "probing",
  "probiotic",
  "problem",
  "procedure",
  "process",
  "proclaim",
  "procreate",
  "procurer",
  "prodigal",
  "prodigy",
  "produce",
  "product",
  "profane",
  "profanity",
  "professed",
  "professor",
  "profile",
  "profound",
  "profusely",
  "progeny",
  "prognosis",
  "program",
  "progress",
  "projector",
  "prologue",
  "prolonged",
  "promenade",
  "prominent",
  "promoter",
  "promotion",
  "prompter",
  "promptly",
  "prone",
  "prong",
  "pronounce",
  "pronto",
  "proofing",
  "proofread",
  "proofs",
  "propeller",
  "properly",
  "property",
  "proponent",
  "proposal",
  "propose",
  "props",
  "prorate",
  "protector",
  "protegee",
  "proton",
  "prototype",
  "protozoan",
  "protract",
  "protrude",
  "proud",
  "provable",
  "proved",
  "proven",
  "provided",
  "provider",
  "providing",
  "province",
  "proving",
  "provoke",
  "provoking",
  "provolone",
  "prowess",
  "prowler",
  "prowling",
  "proximity",
  "proxy",
  "prozac",
  "prude",
  "prudishly",
  "prune",
  "pruning",
  "pry",
  "psychic",
  "public",
  "publisher",
  "pucker",
  "pueblo",
  "pug",
  "pull",
  "pulmonary",
  "pulp",
  "pulsate",
  "pulse",
  "pulverize",
  "puma",
  "pumice",
  "pummel",
  "punch",
  "punctual",
  "punctuate",
  "punctured",
  "pungent",
  "punisher",
  "punk",
  "pupil",
  "puppet",
  "puppy",
  "purchase",
  "pureblood",
  "purebred",
  "purely",
  "pureness",
  "purgatory",
  "purge",
  "purging",
  "purifier",
  "purify",
  "purist",
  "puritan",
  "purity",
  "purple",
  "purplish",
  "purposely",
  "purr",
  "purse",
  "pursuable",
  "pursuant",
  "pursuit",
  "purveyor",
  "pushcart",
  "pushchair",
  "pusher",
  "pushiness",
  "pushing",
  "pushover",
  "pushpin",
  "pushup",
  "pushy",
  "putdown",
  "putt",
  "puzzle",
  "puzzling",
  "pyramid",
  "pyromania",
  "python",
  "quack",
  "quadrant",
  "quail",
  "quaintly",
  "quake",
  "quaking",
  "qualified",
  "qualifier",
  "qualify",
  "quality",
  "qualm",
  "quantum",
  "quarrel",
  "quarry",
  "quartered",
  "quarterly",
  "quarters",
  "quartet",
  "quench",
  "query",
  "quicken",
  "quickly",
  "quickness",
  "quicksand",
  "quickstep",
  "quiet",
  "quill",
  "quilt",
  "quintet",
  "quintuple",
  "quirk",
  "quit",
  "quiver",
  "quizzical",
  "quotable",
  "quotation",
  "quote",
  "rabid",
  "race",
  "racing",
  "racism",
  "rack",
  "racoon",
  "radar",
  "radial",
  "radiance",
  "radiantly",
  "radiated",
  "radiation",
  "radiator",
  "radio",
  "radish",
  "raffle",
  "raft",
  "rage",
  "ragged",
  "raging",
  "ragweed",
  "raider",
  "railcar",
  "railing",
  "railroad",
  "railway",
  "raisin",
  "rake",
  "raking",
  "rally",
  "ramble",
  "rambling",
  "ramp",
  "ramrod",
  "ranch",
  "rancidity",
  "random",
  "ranged",
  "ranger",
  "ranging",
  "ranked",
  "ranking",
  "ransack",
  "ranting",
  "rants",
  "rare",
  "rarity",
  "rascal",
  "rash",
  "rasping",
  "ravage",
  "raven",
  "ravine",
  "raving",
  "ravioli",
  "ravishing",
  "reabsorb",
  "reach",
  "reacquire",
  "reaction",
  "reactive",
  "reactor",
  "reaffirm",
  "ream",
  "reanalyze",
  "reappear",
  "reapply",
  "reappoint",
  "reapprove",
  "rearrange",
  "rearview",
  "reason",
  "reassign",
  "reassure",
  "reattach",
  "reawake",
  "rebalance",
  "rebate",
  "rebel",
  "rebirth",
  "reboot",
  "reborn",
  "rebound",
  "rebuff",
  "rebuild",
  "rebuilt",
  "reburial",
  "rebuttal",
  "recall",
  "recant",
  "recapture",
  "recast",
  "recede",
  "recent",
  "recess",
  "recharger",
  "recipient",
  "recital",
  "recite",
  "reckless",
  "reclaim",
  "recliner",
  "reclining",
  "recluse",
  "reclusive",
  "recognize",
  "recoil",
  "recollect",
  "recolor",
  "reconcile",
  "reconfirm",
  "reconvene",
  "recopy",
  "record",
  "recount",
  "recoup",
  "recovery",
  "recreate",
  "rectal",
  "rectangle",
  "rectified",
  "rectify",
  "recycled",
  "recycler",
  "recycling",
  "reemerge",
  "reenact",
  "reenter",
  "reentry",
  "reexamine",
  "referable",
  "referee",
  "reference",
  "refill",
  "refinance",
  "refined",
  "refinery",
  "refining",
  "refinish",
  "reflected",
  "reflector",
  "reflex",
  "reflux",
  "refocus",
  "refold",
  "reforest",
  "reformat",
  "reformed",
  "reformer",
  "reformist",
  "refract",
  "refrain",
  "refreeze",
  "refresh",
  "refried",
  "refueling",
  "refund",
  "refurbish",
  "refurnish",
  "refusal",
  "refuse",
  "refusing",
  "refutable",
  "refute",
  "regain",
  "regalia",
  "regally",
  "reggae",
  "regime",
  "region",
  "register",
  "registrar",
  "registry",
  "regress",
  "regretful",
  "regroup",
  "regular",
  "regulate",
  "regulator",
  "rehab",
  "reheat",
  "rehire",
  "rehydrate",
  "reimburse",
  "reissue",
  "reiterate",
  "rejoice",
  "rejoicing",
  "rejoin",
  "rekindle",
  "relapse",
  "relapsing",
  "relatable",
  "related",
  "relation",
  "relative",
  "relax",
  "relay",
  "relearn",
  "release",
  "relenting",
  "reliable",
  "reliably",
  "reliance",
  "reliant",
  "relic",
  "relieve",
  "relieving",
  "relight",
  "relish",
  "relive",
  "reload",
  "relocate",
  "relock",
  "reluctant",
  "rely",
  "remake",
  "remark",
  "remarry",
  "rematch",
  "remedial",
  "remedy",
  "remember",
  "reminder",
  "remindful",
  "remission",
  "remix",
  "remnant",
  "remodeler",
  "remold",
  "remorse",
  "remote",
  "removable",
  "removal",
  "removed",
  "remover",
  "removing",
  "rename",
  "renderer",
  "rendering",
  "rendition",
  "renegade",
  "renewable",
  "renewably",
  "renewal",
  "renewed",
  "renounce",
  "renovate",
  "renovator",
  "rentable",
  "rental",
  "rented",
  "renter",
  "reoccupy",
  "reoccur",
  "reopen",
  "reorder",
  "repackage",
  "repacking",
  "repaint",
  "repair",
  "repave",
  "repaying",
  "repayment",
  "repeal",
  "repeated",
  "repeater",
  "repent",
  "rephrase",
  "replace",
  "replay",
  "replica",
  "reply",
  "reporter",
  "repose",
  "repossess",
  "repost",
  "repressed",
  "reprimand",
  "reprint",
  "reprise",
  "reproach",
  "reprocess",
  "reproduce",
  "reprogram",
  "reps",
  "reptile",
  "reptilian",
  "repugnant",
  "repulsion",
  "repulsive",
  "repurpose",
  "reputable",
  "reputably",
  "request",
  "require",
  "requisite",
  "reroute",
  "rerun",
  "resale",
  "resample",
  "rescuer",
  "reseal",
  "research",
  "reselect",
  "reseller",
  "resemble",
  "resend",
  "resent",
  "reset",
  "reshape",
  "reshoot",
  "reshuffle",
  "residence",
  "residency",
  "resident",
  "residual",
  "residue",
  "resigned",
  "resilient",
  "resistant",
  "resisting",
  "resize",
  "resolute",
  "resolved",
  "resonant",
  "resonate",
  "resort",
  "resource",
  "respect",
  "resubmit",
  "result",
  "resume",
  "resupply",
  "resurface",
  "resurrect",
  "retail",
  "retainer",
  "retaining",
  "retake",
  "retaliate",
  "retention",
  "rethink",
  "retinal",
  "retired",
  "retiree",
  "retiring",
  "retold",
  "retool",
  "retorted",
  "retouch",
  "retrace",
  "retract",
  "retrain",
  "retread",
  "retreat",
  "retrial",
  "retrieval",
  "retriever",
  "retry",
  "return",
  "retying",
  "retype",
  "reunion",
  "reunite",
  "reusable",
  "reuse",
  "reveal",
  "reveler",
  "revenge",
  "revenue",
  "reverb",
  "revered",
  "reverence",
  "reverend",
  "reversal",
  "reverse",
  "reversing",
  "reversion",
  "revert",
  "revisable",
  "revise",
  "revision",
  "revisit",
  "revivable",
  "revival",
  "reviver",
  "reviving",
  "revocable",
  "revoke",
  "revolt",
  "revolver",
  "revolving",
  "reward",
  "rewash",
  "rewind",
  "rewire",
  "reword",
  "rework",
  "rewrap",
  "rewrite",
  "rhyme",
  "ribbon",
  "ribcage",
  "rice",
  "riches",
  "richly",
  "richness",
  "rickety",
  "ricotta",
  "riddance",
  "ridden",
  "ride",
  "riding",
  "rifling",
  "rift",
  "rigging",
  "rigid",
  "rigor",
  "rimless",
  "rimmed",
  "rind",
  "rink",
  "rinse",
  "rinsing",
  "riot",
  "ripcord",
  "ripeness",
  "ripening",
  "ripping",
  "ripple",
  "rippling",
  "riptide",
  "rise",
  "rising",
  "risk",
  "risotto",
  "ritalin",
  "ritzy",
  "rival",
  "riverbank",
  "riverbed",
  "riverboat",
  "riverside",
  "riveter",
  "riveting",
  "roamer",
  "roaming",
  "roast",
  "robbing",
  "robe",
  "robin",
  "robotics",
  "robust",
  "rockband",
  "rocker",
  "rocket",
  "rockfish",
  "rockiness",
  "rocking",
  "rocklike",
  "rockslide",
  "rockstar",
  "rocky",
  "rogue",
  "roman",
  "romp",
  "rope",
  "roping",
  "roster",
  "rosy",
  "rotten",
  "rotting",
  "rotunda",
  "roulette",
  "rounding",
  "roundish",
  "roundness",
  "roundup",
  "roundworm",
  "routine",
  "routing",
  "rover",
  "roving",
  "royal",
  "rubbed",
  "rubber",
  "rubbing",
  "rubble",
  "rubdown",
  "ruby",
  "ruckus",
  "rudder",
  "rug",
  "ruined",
  "rule",
  "rumble",
  "rumbling",
  "rummage",
  "rumor",
  "runaround",
  "rundown",
  "runner",
  "running",
  "runny",
  "runt",
  "runway",
  "rupture",
  "rural",
  "ruse",
  "rush",
  "rust",
  "rut",
  "sabbath",
  "sabotage",
  "sacrament",
  "sacred",
  "sacrifice",
  "sadden",
  "saddlebag",
  "saddled",
  "saddling",
  "sadly",
  "sadness",
  "safari",
  "safeguard",
  "safehouse",
  "safely",
  "safeness",
  "saffron",
  "saga",
  "sage",
  "sagging",
  "saggy",
  "said",
  "saint",
  "sake",
  "salad",
  "salami",
  "salaried",
  "salary",
  "saline",
  "salon",
  "saloon",
  "salsa",
  "salt",
  "salutary",
  "salute",
  "salvage",
  "salvaging",
  "salvation",
  "same",
  "sample",
  "sampling",
  "sanction",
  "sanctity",
  "sanctuary",
  "sandal",
  "sandbag",
  "sandbank",
  "sandbar",
  "sandblast",
  "sandbox",
  "sanded",
  "sandfish",
  "sanding",
  "sandlot",
  "sandpaper",
  "sandpit",
  "sandstone",
  "sandstorm",
  "sandworm",
  "sandy",
  "sanitary",
  "sanitizer",
  "sank",
  "santa",
  "sapling",
  "sappiness",
  "sappy",
  "sarcasm",
  "sarcastic",
  "sardine",
  "sash",
  "sasquatch",
  "sassy",
  "satchel",
  "satiable",
  "satin",
  "satirical",
  "satisfied",
  "satisfy",
  "saturate",
  "saturday",
  "sauciness",
  "saucy",
  "sauna",
  "savage",
  "savanna",
  "saved",
  "savings",
  "savior",
  "savor",
  "saxophone",
  "say",
  "scabbed",
  "scabby",
  "scalded",
  "scalding",
  "scale",
  "scaling",
  "scallion",
  "scallop",
  "scalping",
  "scam",
  "scandal",
  "scanner",
  "scanning",
  "scant",
  "scapegoat",
  "scarce",
  "scarcity",
  "scarecrow",
  "scared",
  "scarf",
  "scarily",
  "scariness",
  "scarring",
  "scary",
  "scavenger",
  "scenic",
  "schedule",
  "schematic",
  "scheme",
  "scheming",
  "schilling",
  "schnapps",
  "scholar",
  "science",
  "scientist",
  "scion",
  "scoff",
  "scolding",
  "scone",
  "scoop",
  "scooter",
  "scope",
  "scorch",
  "scorebook",
  "scorecard",
  "scored",
  "scoreless",
  "scorer",
  "scoring",
  "scorn",
  "scorpion",
  "scotch",
  "scoundrel",
  "scoured",
  "scouring",
  "scouting",
  "scouts",
  "scowling",
  "scrabble",
  "scraggly",
  "scrambled",
  "scrambler",
  "scrap",
  "scratch",
  "scrawny",
  "screen",
  "scribble",
  "scribe",
  "scribing",
  "scrimmage",
  "script",
  "scroll",
  "scrooge",
  "scrounger",
  "scrubbed",
  "scrubber",
  "scruffy",
  "scrunch",
  "scrutiny",
  "scuba",
  "scuff",
  "sculptor",
  "sculpture",
  "scurvy",
  "scuttle",
  "secluded",
  "secluding",
  "seclusion",
  "second",
  "secrecy",
  "secret",
  "sectional",
  "sector",
  "secular",
  "securely",
  "security",
  "sedan",
  "sedate",
  "sedation",
  "sedative",
  "sediment",
  "seduce",
  "seducing",
  "segment",
  "seismic",
  "seizing",
  "seldom",
  "selected",
  "selection",
  "selective",
  "selector",
  "self",
  "seltzer",
  "semantic",
  "semester",
  "semicolon",
  "semifinal",
  "seminar",
  "semisoft",
  "semisweet",
  "senate",
  "senator",
  "send",
  "senior",
  "senorita",
  "sensation",
  "sensitive",
  "sensitize",
  "sensually",
  "sensuous",
  "sepia",
  "september",
  "septic",
  "septum",
  "sequel",
  "sequence",
  "sequester",
  "series",
  "sermon",
  "serotonin",
  "serpent",
  "serrated",
  "serve",
  "service",
  "serving",
  "sesame",
  "sessions",
  "setback",
  "setting",
  "settle",
  "settling",
  "setup",
  "sevenfold",
  "seventeen",
  "seventh",
  "seventy",
  "severity",
  "shabby",
  "shack",
  "shaded",
  "shadily",
  "shadiness",
  "shading",
  "shadow",
  "shady",
  "shaft",
  "shakable",
  "shakily",
  "shakiness",
  "shaking",
  "shaky",
  "shale",
  "shallot",
  "shallow",
  "shame",
  "shampoo",
  "shamrock",
  "shank",
  "shanty",
  "shape",
  "shaping",
  "share",
  "sharpener",
  "sharper",
  "sharpie",
  "sharply",
  "sharpness",
  "shawl",
  "sheath",
  "shed",
  "sheep",
  "sheet",
  "shelf",
  "shell",
  "shelter",
  "shelve",
  "shelving",
  "sherry",
  "shield",
  "shifter",
  "shifting",
  "shiftless",
  "shifty",
  "shimmer",
  "shimmy",
  "shindig",
  "shine",
  "shingle",
  "shininess",
  "shining",
  "shiny",
  "ship",
  "shirt",
  "shivering",
  "shock",
  "shone",
  "shoplift",
  "shopper",
  "shopping",
  "shoptalk",
  "shore",
  "shortage",
  "shortcake",
  "shortcut",
  "shorten",
  "shorter",
  "shorthand",
  "shortlist",
  "shortly",
  "shortness",
  "shorts",
  "shortwave",
  "shorty",
  "shout",
  "shove",
  "showbiz",
  "showcase",
  "showdown",
  "shower",
  "showgirl",
  "showing",
  "showman",
  "shown",
  "showoff",
  "showpiece",
  "showplace",
  "showroom",
  "showy",
  "shrank",
  "shrapnel",
  "shredder",
  "shredding",
  "shrewdly",
  "shriek",
  "shrill",
  "shrimp",
  "shrine",
  "shrink",
  "shrivel",
  "shrouded",
  "shrubbery",
  "shrubs",
  "shrug",
  "shrunk",
  "shucking",
  "shudder",
  "shuffle",
  "shuffling",
  "shun",
  "shush",
  "shut",
  "shy",
  "siamese",
  "siberian",
  "sibling",
  "siding",
  "sierra",
  "siesta",
  "sift",
  "sighing",
  "silenced",
  "silencer",
  "silent",
  "silica",
  "silicon",
  "silk",
  "silliness",
  "silly",
  "silo",
  "silt",
  "silver",
  "similarly",
  "simile",
  "simmering",
  "simple",
  "simplify",
  "simply",
  "sincere",
  "sincerity",
  "singer",
  "singing",
  "single",
  "singular",
  "sinister",
  "sinless",
  "sinner",
  "sinuous",
  "sip",
  "siren",
  "sister",
  "sitcom",
  "sitter",
  "sitting",
  "situated",
  "situation",
  "sixfold",
  "sixteen",
  "sixth",
  "sixties",
  "sixtieth",
  "sixtyfold",
  "sizable",
  "sizably",
  "size",
  "sizing",
  "sizzle",
  "sizzling",
  "skater",
  "skating",
  "skedaddle",
  "skeletal",
  "skeleton",
  "skeptic",
  "sketch",
  "skewed",
  "skewer",
  "skid",
  "skied",
  "skier",
  "skies",
  "skiing",
  "skilled",
  "skillet",
  "skillful",
  "skimmed",
  "skimmer",
  "skimming",
  "skimpily",
  "skincare",
  "skinhead",
  "skinless",
  "skinning",
  "skinny",
  "skintight",
  "skipper",
  "skipping",
  "skirmish",
  "skirt",
  "skittle",
  "skydiver",
  "skylight",
  "skyline",
  "skype",
  "skyrocket",
  "skyward",
  "slab",
  "slacked",
  "slacker",
  "slacking",
  "slackness",
  "slacks",
  "slain",
  "slam",
  "slander",
  "slang",
  "slapping",
  "slapstick",
  "slashed",
  "slashing",
  "slate",
  "slather",
  "slaw",
  "sled",
  "sleek",
  "sleep",
  "sleet",
  "sleeve",
  "slept",
  "sliceable",
  "sliced",
  "slicer",
  "slicing",
  "slick",
  "slider",
  "slideshow",
  "sliding",
  "slighted",
  "slighting",
  "slightly",
  "slimness",
  "slimy",
  "slinging",
  "slingshot",
  "slinky",
  "slip",
  "slit",
  "sliver",
  "slobbery",
  "slogan",
  "sloped",
  "sloping",
  "sloppily",
  "sloppy",
  "slot",
  "slouching",
  "slouchy",
  "sludge",
  "slug",
  "slum",
  "slurp",
  "slush",
  "sly",
  "small",
  "smartly",
  "smartness",
  "smasher",
  "smashing",
  "smashup",
  "smell",
  "smelting",
  "smile",
  "smilingly",
  "smirk",
  "smite",
  "smith",
  "smitten",
  "smock",
  "smog",
  "smoked",
  "smokeless",
  "smokiness",
  "smoking",
  "smoky",
  "smolder",
  "smooth",
  "smother",
  "smudge",
  "smudgy",
  "smuggler",
  "smuggling",
  "smugly",
  "smugness",
  "snack",
  "snagged",
  "snaking",
  "snap",
  "snare",
  "snarl",
  "snazzy",
  "sneak",
  "sneer",
  "sneeze",
  "sneezing",
  "snide",
  "sniff",
  "snippet",
  "snipping",
  "snitch",
  "snooper",
  "snooze",
  "snore",
  "snoring",
  "snorkel",
  "snort",
  "snout",
  "snowbird",
  "snowboard",
  "snowbound",
  "snowcap",
  "snowdrift",
  "snowdrop",
  "snowfall",
  "snowfield",
  "snowflake",
  "snowiness",
  "snowless",
  "snowman",
  "snowplow",
  "snowshoe",
  "snowstorm",
  "snowsuit",
  "snowy",
  "snub",
  "snuff",
  "snuggle",
  "snugly",
  "snugness",
  "speak",
  "spearfish",
  "spearhead",
  "spearman",
  "spearmint",
  "species",
  "specimen",
  "specked",
  "speckled",
  "specks",
  "spectacle",
  "spectator",
  "spectrum",
  "speculate",
  "speech",
  "speed",
  "spellbind",
  "speller",
  "spelling",
  "spendable",
  "spender",
  "spending",
  "spent",
  "spew",
  "sphere",
  "spherical",
  "sphinx",
  "spider",
  "spied",
  "spiffy",
  "spill",
  "spilt",
  "spinach",
  "spinal",
  "spindle",
  "spinner",
  "spinning",
  "spinout",
  "spinster",
  "spiny",
  "spiral",
  "spirited",
  "spiritism",
  "spirits",
  "spiritual",
  "splashed",
  "splashing",
  "splashy",
  "splatter",
  "spleen",
  "splendid",
  "splendor",
  "splice",
  "splicing",
  "splinter",
  "splotchy",
  "splurge",
  "spoilage",
  "spoiled",
  "spoiler",
  "spoiling",
  "spoils",
  "spoken",
  "spokesman",
  "sponge",
  "spongy",
  "sponsor",
  "spoof",
  "spookily",
  "spooky",
  "spool",
  "spoon",
  "spore",
  "sporting",
  "sports",
  "sporty",
  "spotless",
  "spotlight",
  "spotted",
  "spotter",
  "spotting",
  "spotty",
  "spousal",
  "spouse",
  "spout",
  "sprain",
  "sprang",
  "sprawl",
  "spray",
  "spree",
  "sprig",
  "spring",
  "sprinkled",
  "sprinkler",
  "sprint",
  "sprite",
  "sprout",
  "spruce",
  "sprung",
  "spry",
  "spud",
  "spur",
  "sputter",
  "spyglass",
  "squabble",
  "squad",
  "squall",
  "squander",
  "squash",
  "squatted",
  "squatter",
  "squatting",
  "squeak",
  "squealer",
  "squealing",
  "squeamish",
  "squeegee",
  "squeeze",
  "squeezing",
  "squid",
  "squiggle",
  "squiggly",
  "squint",
  "squire",
  "squirt",
  "squishier",
  "squishy",
  "stability",
  "stabilize",
  "stable",
  "stack",
  "stadium",
  "staff",
  "stage",
  "staging",
  "stagnant",
  "stagnate",
  "stainable",
  "stained",
  "staining",
  "stainless",
  "stalemate",
  "staleness",
  "stalling",
  "stallion",
  "stamina",
  "stammer",
  "stamp",
  "stand",
  "stank",
  "staple",
  "stapling",
  "starboard",
  "starch",
  "stardom",
  "stardust",
  "starfish",
  "stargazer",
  "staring",
  "stark",
  "starless",
  "starlet",
  "starlight",
  "starlit",
  "starring",
  "starry",
  "starship",
  "starter",
  "starting",
  "startle",
  "startling",
  "startup",
  "starved",
  "starving",
  "stash",
  "state",
  "static",
  "statistic",
  "statue",
  "stature",
  "status",
  "statute",
  "statutory",
  "staunch",
  "stays",
  "steadfast",
  "steadier",
  "steadily",
  "steadying",
  "steam",
  "steed",
  "steep",
  "steerable",
  "steering",
  "steersman",
  "stegosaur",
  "stellar",
  "stem",
  "stench",
  "stencil",
  "step",
  "stereo",
  "sterile",
  "sterility",
  "sterilize",
  "sterling",
  "sternness",
  "sternum",
  "stew",
  "stick",
  "stiffen",
  "stiffly",
  "stiffness",
  "stifle",
  "stifling",
  "stillness",
  "stilt",
  "stimulant",
  "stimulate",
  "stimuli",
  "stimulus",
  "stinger",
  "stingily",
  "stinging",
  "stingray",
  "stingy",
  "stinking",
  "stinky",
  "stipend",
  "stipulate",
  "stir",
  "stitch",
  "stock",
  "stoic",
  "stoke",
  "stole",
  "stomp",
  "stonewall",
  "stoneware",
  "stonework",
  "stoning",
  "stony",
  "stood",
  "stooge",
  "stool",
  "stoop",
  "stoplight",
  "stoppable",
  "stoppage",
  "stopped",
  "stopper",
  "stopping",
  "stopwatch",
  "storable",
  "storage",
  "storeroom",
  "storewide",
  "storm",
  "stout",
  "stove",
  "stowaway",
  "stowing",
  "straddle",
  "straggler",
  "strained",
  "strainer",
  "straining",
  "strangely",
  "stranger",
  "strangle",
  "strategic",
  "strategy",
  "stratus",
  "straw",
  "stray",
  "streak",
  "stream",
  "street",
  "strength",
  "strenuous",
  "strep",
  "stress",
  "stretch",
  "strewn",
  "stricken",
  "strict",
  "stride",
  "strife",
  "strike",
  "striking",
  "strive",
  "striving",
  "strobe",
  "strode",
  "stroller",
  "strongbox",
  "strongly",
  "strongman",
  "struck",
  "structure",
  "strudel",
  "struggle",
  "strum",
  "strung",
  "strut",
  "stubbed",
  "stubble",
  "stubbly",
  "stubborn",
  "stucco",
  "stuck",
  "student",
  "studied",
  "studio",
  "study",
  "stuffed",
  "stuffing",
  "stuffy",
  "stumble",
  "stumbling",
  "stump",
  "stung",
  "stunned",
  "stunner",
  "stunning",
  "stunt",
  "stupor",
  "sturdily",
  "sturdy",
  "styling",
  "stylishly",
  "stylist",
  "stylized",
  "stylus",
  "suave",
  "subarctic",
  "subatomic",
  "subdivide",
  "subdued",
  "subduing",
  "subfloor",
  "subgroup",
  "subheader",
  "subject",
  "sublease",
  "sublet",
  "sublevel",
  "sublime",
  "submarine",
  "submerge",
  "submersed",
  "submitter",
  "subpanel",
  "subpar",
  "subplot",
  "subprime",
  "subscribe",
  "subscript",
  "subsector",
  "subside",
  "subsiding",
  "subsidize",
  "subsidy",
  "subsoil",
  "subsonic",
  "substance",
  "subsystem",
  "subtext",
  "subtitle",
  "subtly",
  "subtotal",
  "subtract",
  "subtype",
  "suburb",
  "subway",
  "subwoofer",
  "subzero",
  "succulent",
  "such",
  "suction",
  "sudden",
  "sudoku",
  "suds",
  "sufferer",
  "suffering",
  "suffice",
  "suffix",
  "suffocate",
  "suffrage",
  "sugar",
  "suggest",
  "suing",
  "suitable",
  "suitably",
  "suitcase",
  "suitor",
  "sulfate",
  "sulfide",
  "sulfite",
  "sulfur",
  "sulk",
  "sullen",
  "sulphate",
  "sulphuric",
  "sultry",
  "superbowl",
  "superglue",
  "superhero",
  "superior",
  "superjet",
  "superman",
  "supermom",
  "supernova",
  "supervise",
  "supper",
  "supplier",
  "supply",
  "support",
  "supremacy",
  "supreme",
  "surcharge",
  "surely",
  "sureness",
  "surface",
  "surfacing",
  "surfboard",
  "surfer",
  "surgery",
  "surgical",
  "surging",
  "surname",
  "surpass",
  "surplus",
  "surprise",
  "surreal",
  "surrender",
  "surrogate",
  "surround",
  "survey",
  "survival",
  "survive",
  "surviving",
  "survivor",
  "sushi",
  "suspect",
  "suspend",
  "suspense",
  "sustained",
  "sustainer",
  "swab",
  "swaddling",
  "swagger",
  "swampland",
  "swan",
  "swapping",
  "swarm",
  "sway",
  "swear",
  "sweat",
  "sweep",
  "swell",
  "swept",
  "swerve",
  "swifter",
  "swiftly",
  "swiftness",
  "swimmable",
  "swimmer",
  "swimming",
  "swimsuit",
  "swimwear",
  "swinger",
  "swinging",
  "swipe",
  "swirl",
  "switch",
  "swivel",
  "swizzle",
  "swooned",
  "swoop",
  "swoosh",
  "swore",
  "sworn",
  "swung",
  "sycamore",
  "sympathy",
  "symphonic",
  "symphony",
  "symptom",
  "synapse",
  "syndrome",
  "synergy",
  "synopses",
  "synopsis",
  "synthesis",
  "synthetic",
  "syrup",
  "system",
  "t-shirt",
  "tabasco",
  "tabby",
  "tableful",
  "tables",
  "tablet",
  "tableware",
  "tabloid",
  "tackiness",
  "tacking",
  "tackle",
  "tackling",
  "tacky",
  "taco",
  "tactful",
  "tactical",
  "tactics",
  "tactile",
  "tactless",
  "tadpole",
  "taekwondo",
  "tag",
  "tainted",
  "take",
  "taking",
  "talcum",
  "talisman",
  "tall",
  "talon",
  "tamale",
  "tameness",
  "tamer",
  "tamper",
  "tank",
  "tanned",
  "tannery",
  "tanning",
  "tantrum",
  "tapeless",
  "tapered",
  "tapering",
  "tapestry",
  "tapioca",
  "tapping",
  "taps",
  "tarantula",
  "target",
  "tarmac",
  "tarnish",
  "tarot",
  "tartar",
  "tartly",
  "tartness",
  "task",
  "tassel",
  "taste",
  "tastiness",
  "tasting",
  "tasty",
  "tattered",
  "tattle",
  "tattling",
  "tattoo",
  "taunt",
  "tavern",
  "thank",
  "that",
  "thaw",
  "theater",
  "theatrics",
  "thee",
  "theft",
  "theme",
  "theology",
  "theorize",
  "thermal",
  "thermos",
  "thesaurus",
  "these",
  "thesis",
  "thespian",
  "thicken",
  "thicket",
  "thickness",
  "thieving",
  "thievish",
  "thigh",
  "thimble",
  "thing",
  "think",
  "thinly",
  "thinner",
  "thinness",
  "thinning",
  "thirstily",
  "thirsting",
  "thirsty",
  "thirteen",
  "thirty",
  "thong",
  "thorn",
  "those",
  "thousand",
  "thrash",
  "thread",
  "threaten",
  "threefold",
  "thrift",
  "thrill",
  "thrive",
  "thriving",
  "throat",
  "throbbing",
  "throng",
  "throttle",
  "throwaway",
  "throwback",
  "thrower",
  "throwing",
  "thud",
  "thumb",
  "thumping",
  "thursday",
  "thus",
  "thwarting",
  "thyself",
  "tiara",
  "tibia",
  "tidal",
  "tidbit",
  "tidiness",
  "tidings",
  "tidy",
  "tiger",
  "tighten",
  "tightly",
  "tightness",
  "tightrope",
  "tightwad",
  "tigress",
  "tile",
  "tiling",
  "till",
  "tilt",
  "timid",
  "timing",
  "timothy",
  "tinderbox",
  "tinfoil",
  "tingle",
  "tingling",
  "tingly",
  "tinker",
  "tinkling",
  "tinsel",
  "tinsmith",
  "tint",
  "tinwork",
  "tiny",
  "tipoff",
  "tipped",
  "tipper",
  "tipping",
  "tiptoeing",
  "tiptop",
  "tiring",
  "tissue",
  "trace",
  "tracing",
  "track",
  "traction",
  "tractor",
  "trade",
  "trading",
  "tradition",
  "traffic",
  "tragedy",
  "trailing",
  "trailside",
  "train",
  "traitor",
  "trance",
  "tranquil",
  "transfer",
  "transform",
  "translate",
  "transpire",
  "transport",
  "transpose",
  "trapdoor",
  "trapeze",
  "trapezoid",
  "trapped",
  "trapper",
  "trapping",
  "traps",
  "trash",
  "travel",
  "traverse",
  "travesty",
  "tray",
  "treachery",
  "treading",
  "treadmill",
  "treason",
  "treat",
  "treble",
  "tree",
  "trekker",
  "tremble",
  "trembling",
  "tremor",
  "trench",
  "trend",
  "trespass",
  "triage",
  "trial",
  "triangle",
  "tribesman",
  "tribunal",
  "tribune",
  "tributary",
  "tribute",
  "triceps",
  "trickery",
  "trickily",
  "tricking",
  "trickle",
  "trickster",
  "tricky",
  "tricolor",
  "tricycle",
  "trident",
  "tried",
  "trifle",
  "trifocals",
  "trillion",
  "trilogy",
  "trimester",
  "trimmer",
  "trimming",
  "trimness",
  "trinity",
  "trio",
  "tripod",
  "tripping",
  "triumph",
  "trivial",
  "trodden",
  "trolling",
  "trombone",
  "trophy",
  "tropical",
  "tropics",
  "trouble",
  "troubling",
  "trough",
  "trousers",
  "trout",
  "trowel",
  "truce",
  "truck",
  "truffle",
  "trump",
  "trunks",
  "trustable",
  "trustee",
  "trustful",
  "trusting",
  "trustless",
  "truth",
  "try",
  "tubby",
  "tubeless",
  "tubular",
  "tucking",
  "tuesday",
  "tug",
  "tuition",
  "tulip",
  "tumble",
  "tumbling",
  "tummy",
  "turban",
  "turbine",
  "turbofan",
  "turbojet",
  "turbulent",
  "turf",
  "turkey",
  "turmoil",
  "turret",
  "turtle",
  "tusk",
  "tutor",
  "tutu",
  "tux",
  "tweak",
  "tweed",
  "tweet",
  "tweezers",
  "twelve",
  "twentieth",
  "twenty",
  "twerp",
  "twice",
  "twiddle",
  "twiddling",
  "twig",
  "twilight",
  "twine",
  "twins",
  "twirl",
  "twistable",
  "twisted",
  "twister",
  "twisting",
  "twisty",
  "twitch",
  "twitter",
  "tycoon",
  "tying",
  "tyke",
  "udder",
  "ultimate",
  "ultimatum",
  "ultra",
  "umbilical",
  "umbrella",
  "umpire",
  "unabashed",
  "unable",
  "unadorned",
  "unadvised",
  "unafraid",
  "unaired",
  "unaligned",
  "unaltered",
  "unarmored",
  "unashamed",
  "unaudited",
  "unawake",
  "unaware",
  "unbaked",
  "unbalance",
  "unbeaten",
  "unbend",
  "unbent",
  "unbiased",
  "unbitten",
  "unblended",
  "unblessed",
  "unblock",
  "unbolted",
  "unbounded",
  "unboxed",
  "unbraided",
  "unbridle",
  "unbroken",
  "unbuckled",
  "unbundle",
  "unburned",
  "unbutton",
  "uncanny",
  "uncapped",
  "uncaring",
  "uncertain",
  "unchain",
  "unchanged",
  "uncharted",
  "uncheck",
  "uncivil",
  "unclad",
  "unclaimed",
  "unclamped",
  "unclasp",
  "uncle",
  "unclip",
  "uncloak",
  "unclog",
  "unclothed",
  "uncoated",
  "uncoiled",
  "uncolored",
  "uncombed",
  "uncommon",
  "uncooked",
  "uncork",
  "uncorrupt",
  "uncounted",
  "uncouple",
  "uncouth",
  "uncover",
  "uncross",
  "uncrown",
  "uncrushed",
  "uncured",
  "uncurious",
  "uncurled",
  "uncut",
  "undamaged",
  "undated",
  "undaunted",
  "undead",
  "undecided",
  "undefined",
  "underage",
  "underarm",
  "undercoat",
  "undercook",
  "undercut",
  "underdog",
  "underdone",
  "underfed",
  "underfeed",
  "underfoot",
  "undergo",
  "undergrad",
  "underhand",
  "underline",
  "underling",
  "undermine",
  "undermost",
  "underpaid",
  "underpass",
  "underpay",
  "underrate",
  "undertake",
  "undertone",
  "undertook",
  "undertow",
  "underuse",
  "underwear",
  "underwent",
  "underwire",
  "undesired",
  "undiluted",
  "undivided",
  "undocked",
  "undoing",
  "undone",
  "undrafted",
  "undress",
  "undrilled",
  "undusted",
  "undying",
  "unearned",
  "unearth",
  "unease",
  "uneasily",
  "uneasy",
  "uneatable",
  "uneaten",
  "unedited",
  "unelected",
  "unending",
  "unengaged",
  "unenvied",
  "unequal",
  "unethical",
  "uneven",
  "unexpired",
  "unexposed",
  "unfailing",
  "unfair",
  "unfasten",
  "unfazed",
  "unfeeling",
  "unfiled",
  "unfilled",
  "unfitted",
  "unfitting",
  "unfixable",
  "unfixed",
  "unflawed",
  "unfocused",
  "unfold",
  "unfounded",
  "unframed",
  "unfreeze",
  "unfrosted",
  "unfrozen",
  "unfunded",
  "unglazed",
  "ungloved",
  "unglue",
  "ungodly",
  "ungraded",
  "ungreased",
  "unguarded",
  "unguided",
  "unhappily",
  "unhappy",
  "unharmed",
  "unhealthy",
  "unheard",
  "unhearing",
  "unheated",
  "unhelpful",
  "unhidden",
  "unhinge",
  "unhitched",
  "unholy",
  "unhook",
  "unicorn",
  "unicycle",
  "unified",
  "unifier",
  "uniformed",
  "uniformly",
  "unify",
  "unimpeded",
  "uninjured",
  "uninstall",
  "uninsured",
  "uninvited",
  "union",
  "uniquely",
  "unisexual",
  "unison",
  "unissued",
  "unit",
  "universal",
  "universe",
  "unjustly",
  "unkempt",
  "unkind",
  "unknotted",
  "unknowing",
  "unknown",
  "unlaced",
  "unlatch",
  "unlawful",
  "unleaded",
  "unlearned",
  "unleash",
  "unless",
  "unleveled",
  "unlighted",
  "unlikable",
  "unlimited",
  "unlined",
  "unlinked",
  "unlisted",
  "unlit",
  "unlivable",
  "unloaded",
  "unloader",
  "unlocked",
  "unlocking",
  "unlovable",
  "unloved",
  "unlovely",
  "unloving",
  "unluckily",
  "unlucky",
  "unmade",
  "unmanaged",
  "unmanned",
  "unmapped",
  "unmarked",
  "unmasked",
  "unmasking",
  "unmatched",
  "unmindful",
  "unmixable",
  "unmixed",
  "unmolded",
  "unmoral",
  "unmovable",
  "unmoved",
  "unmoving",
  "unnamable",
  "unnamed",
  "unnatural",
  "unneeded",
  "unnerve",
  "unnerving",
  "unnoticed",
  "unopened",
  "unopposed",
  "unpack",
  "unpadded",
  "unpaid",
  "unpainted",
  "unpaired",
  "unpaved",
  "unpeeled",
  "unpicked",
  "unpiloted",
  "unpinned",
  "unplanned",
  "unplanted",
  "unpleased",
  "unpledged",
  "unplowed",
  "unplug",
  "unpopular",
  "unproven",
  "unquote",
  "unranked",
  "unrated",
  "unraveled",
  "unreached",
  "unread",
  "unreal",
  "unreeling",
  "unrefined",
  "unrelated",
  "unrented",
  "unrest",
  "unretired",
  "unrevised",
  "unrigged",
  "unripe",
  "unrivaled",
  "unroasted",
  "unrobed",
  "unroll",
  "unruffled",
  "unruly",
  "unrushed",
  "unsaddle",
  "unsafe",
  "unsaid",
  "unsalted",
  "unsaved",
  "unsavory",
  "unscathed",
  "unscented",
  "unscrew",
  "unsealed",
  "unseated",
  "unsecured",
  "unseeing",
  "unseemly",
  "unseen",
  "unselect",
  "unselfish",
  "unsent",
  "unsettled",
  "unshackle",
  "unshaken",
  "unshaved",
  "unshaven",
  "unsheathe",
  "unshipped",
  "unsightly",
  "unsigned",
  "unskilled",
  "unsliced",
  "unsmooth",
  "unsnap",
  "unsocial",
  "unsoiled",
  "unsold",
  "unsolved",
  "unsorted",
  "unspoiled",
  "unspoken",
  "unstable",
  "unstaffed",
  "unstamped",
  "unsteady",
  "unsterile",
  "unstirred",
  "unstitch",
  "unstopped",
  "unstuck",
  "unstuffed",
  "unstylish",
  "unsubtle",
  "unsubtly",
  "unsuited",
  "unsure",
  "unsworn",
  "untagged",
  "untainted",
  "untaken",
  "untamed",
  "untangled",
  "untapped",
  "untaxed",
  "unthawed",
  "unthread",
  "untidy",
  "untie",
  "until",
  "untimed",
  "untimely",
  "untitled",
  "untoasted",
  "untold",
  "untouched",
  "untracked",
  "untrained",
  "untreated",
  "untried",
  "untrimmed",
  "untrue",
  "untruth",
  "unturned",
  "untwist",
  "untying",
  "unusable",
  "unused",
  "unusual",
  "unvalued",
  "unvaried",
  "unvarying",
  "unveiled",
  "unveiling",
  "unvented",
  "unviable",
  "unvisited",
  "unvocal",
  "unwanted",
  "unwarlike",
  "unwary",
  "unwashed",
  "unwatched",
  "unweave",
  "unwed",
  "unwelcome",
  "unwell",
  "unwieldy",
  "unwilling",
  "unwind",
  "unwired",
  "unwitting",
  "unwomanly",
  "unworldly",
  "unworn",
  "unworried",
  "unworthy",
  "unwound",
  "unwoven",
  "unwrapped",
  "unwritten",
  "unzip",
  "upbeat",
  "upchuck",
  "upcoming",
  "upcountry",
  "update",
  "upfront",
  "upgrade",
  "upheaval",
  "upheld",
  "uphill",
  "uphold",
  "uplifted",
  "uplifting",
  "upload",
  "upon",
  "upper",
  "upright",
  "uprising",
  "upriver",
  "uproar",
  "uproot",
  "upscale",
  "upside",
  "upstage",
  "upstairs",
  "upstart",
  "upstate",
  "upstream",
  "upstroke",
  "upswing",
  "uptake",
  "uptight",
  "uptown",
  "upturned",
  "upward",
  "upwind",
  "uranium",
  "urban",
  "urchin",
  "urethane",
  "urgency",
  "urgent",
  "urging",
  "urologist",
  "urology",
  "usable",
  "usage",
  "useable",
  "used",
  "uselessly",
  "user",
  "usher",
  "usual",
  "utensil",
  "utility",
  "utilize",
  "utmost",
  "utopia",
  "utter",
  "vacancy",
  "vacant",
  "vacate",
  "vacation",
  "vagabond",
  "vagrancy",
  "vagrantly",
  "vaguely",
  "vagueness",
  "valiant",
  "valid",
  "valium",
  "valley",
  "valuables",
  "value",
  "vanilla",
  "vanish",
  "vanity",
  "vanquish",
  "vantage",
  "vaporizer",
  "variable",
  "variably",
  "varied",
  "variety",
  "various",
  "varmint",
  "varnish",
  "varsity",
  "varying",
  "vascular",
  "vaseline",
  "vastly",
  "vastness",
  "veal",
  "vegan",
  "veggie",
  "vehicular",
  "velcro",
  "velocity",
  "velvet",
  "vendetta",
  "vending",
  "vendor",
  "veneering",
  "vengeful",
  "venomous",
  "ventricle",
  "venture",
  "venue",
  "venus",
  "verbalize",
  "verbally",
  "verbose",
  "verdict",
  "verify",
  "verse",
  "version",
  "versus",
  "vertebrae",
  "vertical",
  "vertigo",
  "very",
  "vessel",
  "vest",
  "veteran",
  "veto",
  "vexingly",
  "viability",
  "viable",
  "vibes",
  "vice",
  "vicinity",
  "victory",
  "video",
  "viewable",
  "viewer",
  "viewing",
  "viewless",
  "viewpoint",
  "vigorous",
  "village",
  "villain",
  "vindicate",
  "vineyard",
  "vintage",
  "violate",
  "violation",
  "violator",
  "violet",
  "violin",
  "viper",
  "viral",
  "virtual",
  "virtuous",
  "virus",
  "visa",
  "viscosity",
  "viscous",
  "viselike",
  "visible",
  "visibly",
  "vision",
  "visiting",
  "visitor",
  "visor",
  "vista",
  "vitality",
  "vitalize",
  "vitally",
  "vitamins",
  "vivacious",
  "vividly",
  "vividness",
  "vixen",
  "vocalist",
  "vocalize",
  "vocally",
  "vocation",
  "voice",
  "voicing",
  "void",
  "volatile",
  "volley",
  "voltage",
  "volumes",
  "voter",
  "voting",
  "voucher",
  "vowed",
  "vowel",
  "voyage",
  "wackiness",
  "wad",
  "wafer",
  "waffle",
  "waged",
  "wager",
  "wages",
  "waggle",
  "wagon",
  "wake",
  "waking",
  "walk",
  "walmart",
  "walnut",
  "walrus",
  "waltz",
  "wand",
  "wannabe",
  "wanted",
  "wanting",
  "wasabi",
  "washable",
  "washbasin",
  "washboard",
  "washbowl",
  "washcloth",
  "washday",
  "washed",
  "washer",
  "washhouse",
  "washing",
  "washout",
  "washroom",
  "washstand",
  "washtub",
  "wasp",
  "wasting",
  "watch",
  "water",
  "waviness",
  "waving",
  "wavy",
  "whacking",
  "whacky",
  "wham",
  "wharf",
  "wheat",
  "whenever",
  "whiff",
  "whimsical",
  "whinny",
  "whiny",
  "whisking",
  "whoever",
  "whole",
  "whomever",
  "whoopee",
  "whooping",
  "whoops",
  "why",
  "wick",
  "widely",
  "widen",
  "widget",
  "widow",
  "width",
  "wieldable",
  "wielder",
  "wife",
  "wifi",
  "wikipedia",
  "wildcard",
  "wildcat",
  "wilder",
  "wildfire",
  "wildfowl",
  "wildland",
  "wildlife",
  "wildly",
  "wildness",
  "willed",
  "willfully",
  "willing",
  "willow",
  "willpower",
  "wilt",
  "wimp",
  "wince",
  "wincing",
  "wind",
  "wing",
  "winking",
  "winner",
  "winnings",
  "winter",
  "wipe",
  "wired",
  "wireless",
  "wiring",
  "wiry",
  "wisdom",
  "wise",
  "wish",
  "wisplike",
  "wispy",
  "wistful",
  "wizard",
  "wobble",
  "wobbling",
  "wobbly",
  "wok",
  "wolf",
  "wolverine",
  "womanhood",
  "womankind",
  "womanless",
  "womanlike",
  "womanly",
  "womb",
  "woof",
  "wooing",
  "wool",
  "woozy",
  "word",
  "work",
  "worried",
  "worrier",
  "worrisome",
  "worry",
  "worsening",
  "worshiper",
  "worst",
  "wound",
  "woven",
  "wow",
  "wrangle",
  "wrath",
  "wreath",
  "wreckage",
  "wrecker",
  "wrecking",
  "wrench",
  "wriggle",
  "wriggly",
  "wrinkle",
  "wrinkly",
  "wrist",
  "writing",
  "written",
  "wrongdoer",
  "wronged",
  "wrongful",
  "wrongly",
  "wrongness",
  "wrought",
  "xbox",
  "xerox",
  "yahoo",
  "yam",
  "yanking",
  "yapping",
  "yard",
  "yarn",
  "yeah",
  "yearbook",
  "yearling",
  "yearly",
  "yearning",
  "yeast",
  "yelling",
  "yelp",
  "yen",
  "yesterday",
  "yiddish",
  "yield",
  "yin",
  "yippee",
  "yo-yo",
  "yodel",
  "yoga",
  "yogurt",
  "yonder",
  "yoyo",
  "yummy",
  "zap",
  "zealous",
  "zebra",
  "zen",
  "zeppelin",
  "zero",
  "zestfully",
  "zesty",
  "zigzagged",
  "zipfile",
  "zipping",
  "zippy",
  "zips",
  "zit",
  "zodiac",
  "zombie",
  "zone",
  "zoning",
  "zookeeper",
  "zoologist",
  "zoology",
  "zoom"
];
Object.defineProperty(hc, "__esModule", { value: !0 });
hc.newSecureWords = void 0;
const GC = Yn, cb = pc;
async function QC(t = 6) {
  let e = [];
  for (let r = 0; r < t; r++)
    e.push(cb.wordlist[await (0, GC.getSecureRandomNumber)(0, cb.wordlist.length)]);
  return e;
}
hc.newSecureWords = QC;
var Lo = {}, db;
function YC() {
  if (db)
    return Lo;
  db = 1, Object.defineProperty(Lo, "__esModule", { value: !0 }), Lo.newSecurePassphrase = void 0;
  const t = gs();
  async function e(r = 6) {
    return (await (0, t.newSecureWords)(r)).join("-");
  }
  return Lo.newSecurePassphrase = e, Lo;
}
var fr = {};
function JC(t) {
  throw new Error('Could not dynamically require "' + t + '". Please configure the dynamicRequireTargets or/and ignoreDynamicRequires option of @rollup/plugin-commonjs appropriately for this require call to work.');
}
var x8 = { exports: {} }, zt = {}, hu = { exports: {} }, pu = { exports: {} };
const kr = /* @__PURE__ */ P5(OT);
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */
var hb;
function Vt() {
  return hb || (hb = 1, function(t, e) {
    var r = kr, i = r.Buffer;
    function f(l, d) {
      for (var v in l)
        d[v] = l[v];
    }
    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = r : (f(r, e), e.Buffer = a);
    function a(l, d, v) {
      return i(l, d, v);
    }
    a.prototype = Object.create(i.prototype), f(i, a), a.from = function(l, d, v) {
      if (typeof l == "number")
        throw new TypeError("Argument must not be a number");
      return i(l, d, v);
    }, a.alloc = function(l, d, v) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      var m = i(l);
      return d !== void 0 ? typeof v == "string" ? m.fill(d, v) : m.fill(d) : m.fill(0), m;
    }, a.allocUnsafe = function(l) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      return i(l);
    }, a.allocUnsafeSlow = function(l) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      return r.SlowBuffer(l);
    };
  }(pu, pu.exports)), pu.exports;
}
var pb;
function go() {
  if (pb)
    return hu.exports;
  pb = 1;
  var t = 65536, e = 4294967295;
  function r() {
    throw new Error(`Secure random number generation is not supported by this browser.
Use Chrome, Firefox or Internet Explorer 11`);
  }
  var i = Vt().Buffer, f = ut.crypto || ut.msCrypto;
  f && f.getRandomValues ? hu.exports = a : hu.exports = r;
  function a(l, d) {
    if (l > e)
      throw new RangeError("requested too many random bytes");
    var v = i.allocUnsafe(l);
    if (l > 0)
      if (l > t)
        for (var m = 0; m < l; m += t)
          f.getRandomValues(v.slice(m, m + t));
      else
        f.getRandomValues(v);
    return typeof d == "function" ? It.nextTick(function() {
      d(null, v);
    }) : v;
  }
  return hu.exports;
}
var vu = { exports: {} }, vb;
function Lt() {
  return vb || (vb = 1, typeof Object.create == "function" ? vu.exports = function(e, r) {
    r && (e.super_ = r, e.prototype = Object.create(r.prototype, {
      constructor: {
        value: e,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }));
  } : vu.exports = function(e, r) {
    if (r) {
      e.super_ = r;
      var i = function() {
      };
      i.prototype = r.prototype, e.prototype = new i(), e.prototype.constructor = e;
    }
  }), vu.exports;
}
var mu = { exports: {} }, gu = { exports: {} }, mb;
function $f() {
  if (mb)
    return gu.exports;
  mb = 1;
  var t = typeof Reflect == "object" ? Reflect : null, e = t && typeof t.apply == "function" ? t.apply : function(q, $, ae) {
    return Function.prototype.apply.call(q, $, ae);
  }, r;
  t && typeof t.ownKeys == "function" ? r = t.ownKeys : Object.getOwnPropertySymbols ? r = function(q) {
    return Object.getOwnPropertyNames(q).concat(Object.getOwnPropertySymbols(q));
  } : r = function(q) {
    return Object.getOwnPropertyNames(q);
  };
  function i(O) {
    console && console.warn && console.warn(O);
  }
  var f = Number.isNaN || function(q) {
    return q !== q;
  };
  function a() {
    a.init.call(this);
  }
  gu.exports = a, gu.exports.once = k, a.EventEmitter = a, a.prototype._events = void 0, a.prototype._eventsCount = 0, a.prototype._maxListeners = void 0;
  var l = 10;
  function d(O) {
    if (typeof O != "function")
      throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof O);
  }
  Object.defineProperty(a, "defaultMaxListeners", {
    enumerable: !0,
    get: function() {
      return l;
    },
    set: function(O) {
      if (typeof O != "number" || O < 0 || f(O))
        throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + O + ".");
      l = O;
    }
  }), a.init = function() {
    (this._events === void 0 || this._events === Object.getPrototypeOf(this)._events) && (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0), this._maxListeners = this._maxListeners || void 0;
  }, a.prototype.setMaxListeners = function(q) {
    if (typeof q != "number" || q < 0 || f(q))
      throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + q + ".");
    return this._maxListeners = q, this;
  };
  function v(O) {
    return O._maxListeners === void 0 ? a.defaultMaxListeners : O._maxListeners;
  }
  a.prototype.getMaxListeners = function() {
    return v(this);
  }, a.prototype.emit = function(q) {
    for (var $ = [], ae = 1; ae < arguments.length; ae++)
      $.push(arguments[ae]);
    var he = q === "error", te = this._events;
    if (te !== void 0)
      he = he && te.error === void 0;
    else if (!he)
      return !1;
    if (he) {
      var Ee;
      if ($.length > 0 && (Ee = $[0]), Ee instanceof Error)
        throw Ee;
      var x = new Error("Unhandled error." + (Ee ? " (" + Ee.message + ")" : ""));
      throw x.context = Ee, x;
    }
    var n = te[q];
    if (n === void 0)
      return !1;
    if (typeof n == "function")
      e(n, this, $);
    else
      for (var o = n.length, u = E(n, o), ae = 0; ae < o; ++ae)
        e(u[ae], this, $);
    return !0;
  };
  function m(O, q, $, ae) {
    var he, te, Ee;
    if (d($), te = O._events, te === void 0 ? (te = O._events = /* @__PURE__ */ Object.create(null), O._eventsCount = 0) : (te.newListener !== void 0 && (O.emit(
      "newListener",
      q,
      $.listener ? $.listener : $
    ), te = O._events), Ee = te[q]), Ee === void 0)
      Ee = te[q] = $, ++O._eventsCount;
    else if (typeof Ee == "function" ? Ee = te[q] = ae ? [$, Ee] : [Ee, $] : ae ? Ee.unshift($) : Ee.push($), he = v(O), he > 0 && Ee.length > he && !Ee.warned) {
      Ee.warned = !0;
      var x = new Error("Possible EventEmitter memory leak detected. " + Ee.length + " " + String(q) + " listeners added. Use emitter.setMaxListeners() to increase limit");
      x.name = "MaxListenersExceededWarning", x.emitter = O, x.type = q, x.count = Ee.length, i(x);
    }
    return O;
  }
  a.prototype.addListener = function(q, $) {
    return m(this, q, $, !1);
  }, a.prototype.on = a.prototype.addListener, a.prototype.prependListener = function(q, $) {
    return m(this, q, $, !0);
  };
  function h() {
    if (!this.fired)
      return this.target.removeListener(this.type, this.wrapFn), this.fired = !0, arguments.length === 0 ? this.listener.call(this.target) : this.listener.apply(this.target, arguments);
  }
  function w(O, q, $) {
    var ae = { fired: !1, wrapFn: void 0, target: O, type: q, listener: $ }, he = h.bind(ae);
    return he.listener = $, ae.wrapFn = he, he;
  }
  a.prototype.once = function(q, $) {
    return d($), this.on(q, w(this, q, $)), this;
  }, a.prototype.prependOnceListener = function(q, $) {
    return d($), this.prependListener(q, w(this, q, $)), this;
  }, a.prototype.removeListener = function(q, $) {
    var ae, he, te, Ee, x;
    if (d($), he = this._events, he === void 0)
      return this;
    if (ae = he[q], ae === void 0)
      return this;
    if (ae === $ || ae.listener === $)
      --this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : (delete he[q], he.removeListener && this.emit("removeListener", q, ae.listener || $));
    else if (typeof ae != "function") {
      for (te = -1, Ee = ae.length - 1; Ee >= 0; Ee--)
        if (ae[Ee] === $ || ae[Ee].listener === $) {
          x = ae[Ee].listener, te = Ee;
          break;
        }
      if (te < 0)
        return this;
      te === 0 ? ae.shift() : A(ae, te), ae.length === 1 && (he[q] = ae[0]), he.removeListener !== void 0 && this.emit("removeListener", q, x || $);
    }
    return this;
  }, a.prototype.off = a.prototype.removeListener, a.prototype.removeAllListeners = function(q) {
    var $, ae, he;
    if (ae = this._events, ae === void 0)
      return this;
    if (ae.removeListener === void 0)
      return arguments.length === 0 ? (this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0) : ae[q] !== void 0 && (--this._eventsCount === 0 ? this._events = /* @__PURE__ */ Object.create(null) : delete ae[q]), this;
    if (arguments.length === 0) {
      var te = Object.keys(ae), Ee;
      for (he = 0; he < te.length; ++he)
        Ee = te[he], Ee !== "removeListener" && this.removeAllListeners(Ee);
      return this.removeAllListeners("removeListener"), this._events = /* @__PURE__ */ Object.create(null), this._eventsCount = 0, this;
    }
    if ($ = ae[q], typeof $ == "function")
      this.removeListener(q, $);
    else if ($ !== void 0)
      for (he = $.length - 1; he >= 0; he--)
        this.removeListener(q, $[he]);
    return this;
  };
  function M(O, q, $) {
    var ae = O._events;
    if (ae === void 0)
      return [];
    var he = ae[q];
    return he === void 0 ? [] : typeof he == "function" ? $ ? [he.listener || he] : [he] : $ ? B(he) : E(he, he.length);
  }
  a.prototype.listeners = function(q) {
    return M(this, q, !0);
  }, a.prototype.rawListeners = function(q) {
    return M(this, q, !1);
  }, a.listenerCount = function(O, q) {
    return typeof O.listenerCount == "function" ? O.listenerCount(q) : S.call(O, q);
  }, a.prototype.listenerCount = S;
  function S(O) {
    var q = this._events;
    if (q !== void 0) {
      var $ = q[O];
      if (typeof $ == "function")
        return 1;
      if ($ !== void 0)
        return $.length;
    }
    return 0;
  }
  a.prototype.eventNames = function() {
    return this._eventsCount > 0 ? r(this._events) : [];
  };
  function E(O, q) {
    for (var $ = new Array(q), ae = 0; ae < q; ++ae)
      $[ae] = O[ae];
    return $;
  }
  function A(O, q) {
    for (; q + 1 < O.length; q++)
      O[q] = O[q + 1];
    O.pop();
  }
  function B(O) {
    for (var q = new Array(O.length), $ = 0; $ < q.length; ++$)
      q[$] = O[$].listener || O[$];
    return q;
  }
  function k(O, q) {
    return new Promise(function($, ae) {
      function he(Ee) {
        O.removeListener(q, te), ae(Ee);
      }
      function te() {
        typeof O.removeListener == "function" && O.removeListener("error", he), $([].slice.call(arguments));
      }
      I(O, q, te, { once: !0 }), q !== "error" && C(O, he, { once: !0 });
    });
  }
  function C(O, q, $) {
    typeof O.on == "function" && I(O, "error", q, $);
  }
  function I(O, q, $, ae) {
    if (typeof O.on == "function")
      ae.once ? O.once(q, $) : O.on(q, $);
    else if (typeof O.addEventListener == "function")
      O.addEventListener(q, function he(te) {
        ae.once && O.removeEventListener(q, he), $(te);
      });
    else
      throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof O);
  }
  return gu.exports;
}
var Dd, gb;
function M8() {
  return gb || (gb = 1, Dd = $f().EventEmitter), Dd;
}
var Ud = {}, Ld = {}, Fd, yb;
function S8() {
  return yb || (yb = 1, Fd = function() {
    if (typeof Symbol != "function" || typeof Object.getOwnPropertySymbols != "function")
      return !1;
    if (typeof Symbol.iterator == "symbol")
      return !0;
    var e = {}, r = Symbol("test"), i = Object(r);
    if (typeof r == "string" || Object.prototype.toString.call(r) !== "[object Symbol]" || Object.prototype.toString.call(i) !== "[object Symbol]")
      return !1;
    var f = 42;
    e[r] = f;
    for (r in e)
      return !1;
    if (typeof Object.keys == "function" && Object.keys(e).length !== 0 || typeof Object.getOwnPropertyNames == "function" && Object.getOwnPropertyNames(e).length !== 0)
      return !1;
    var a = Object.getOwnPropertySymbols(e);
    if (a.length !== 1 || a[0] !== r || !Object.prototype.propertyIsEnumerable.call(e, r))
      return !1;
    if (typeof Object.getOwnPropertyDescriptor == "function") {
      var l = Object.getOwnPropertyDescriptor(e, r);
      if (l.value !== f || l.enumerable !== !0)
        return !1;
    }
    return !0;
  }), Fd;
}
var qd, bb;
function dm() {
  if (bb)
    return qd;
  bb = 1;
  var t = S8();
  return qd = function() {
    return t() && !!Symbol.toStringTag;
  }, qd;
}
var zd, wb;
function XC() {
  return wb || (wb = 1, zd = Error), zd;
}
var jd, _b;
function eB() {
  return _b || (_b = 1, jd = EvalError), jd;
}
var $d, xb;
function tB() {
  return xb || (xb = 1, $d = RangeError), $d;
}
var Vd, Mb;
function rB() {
  return Mb || (Mb = 1, Vd = ReferenceError), Vd;
}
var Hd, Sb;
function E8() {
  return Sb || (Sb = 1, Hd = SyntaxError), Hd;
}
var Wd, Eb;
function vc() {
  return Eb || (Eb = 1, Wd = TypeError), Wd;
}
var Kd, Ab;
function nB() {
  return Ab || (Ab = 1, Kd = URIError), Kd;
}
var Zd, kb;
function iB() {
  if (kb)
    return Zd;
  kb = 1;
  var t = typeof Symbol < "u" && Symbol, e = S8();
  return Zd = function() {
    return typeof t != "function" || typeof Symbol != "function" || typeof t("foo") != "symbol" || typeof Symbol("bar") != "symbol" ? !1 : e();
  }, Zd;
}
var Gd, Tb;
function aB() {
  if (Tb)
    return Gd;
  Tb = 1;
  var t = {
    __proto__: null,
    foo: {}
  }, e = Object;
  return Gd = function() {
    return { __proto__: t }.foo === t.foo && !(t instanceof e);
  }, Gd;
}
var Qd, Cb;
function sB() {
  if (Cb)
    return Qd;
  Cb = 1;
  var t = "Function.prototype.bind called on incompatible ", e = Object.prototype.toString, r = Math.max, i = "[object Function]", f = function(v, m) {
    for (var h = [], w = 0; w < v.length; w += 1)
      h[w] = v[w];
    for (var M = 0; M < m.length; M += 1)
      h[M + v.length] = m[M];
    return h;
  }, a = function(v, m) {
    for (var h = [], w = m, M = 0; w < v.length; w += 1, M += 1)
      h[M] = v[w];
    return h;
  }, l = function(d, v) {
    for (var m = "", h = 0; h < d.length; h += 1)
      m += d[h], h + 1 < d.length && (m += v);
    return m;
  };
  return Qd = function(v) {
    var m = this;
    if (typeof m != "function" || e.apply(m) !== i)
      throw new TypeError(t + m);
    for (var h = a(arguments, 1), w, M = function() {
      if (this instanceof w) {
        var k = m.apply(
          this,
          f(h, arguments)
        );
        return Object(k) === k ? k : this;
      }
      return m.apply(
        v,
        f(h, arguments)
      );
    }, S = r(0, m.length - h.length), E = [], A = 0; A < S; A++)
      E[A] = "$" + A;
    if (w = Function("binder", "return function (" + l(E, ",") + "){ return binder.apply(this,arguments); }")(M), m.prototype) {
      var B = function() {
      };
      B.prototype = m.prototype, w.prototype = new B(), B.prototype = null;
    }
    return w;
  }, Qd;
}
var Yd, Bb;
function hm() {
  if (Bb)
    return Yd;
  Bb = 1;
  var t = sB();
  return Yd = Function.prototype.bind || t, Yd;
}
var Jd, Ib;
function oB() {
  if (Ib)
    return Jd;
  Ib = 1;
  var t = Function.prototype.call, e = Object.prototype.hasOwnProperty, r = hm();
  return Jd = r.call(t, e), Jd;
}
var Xd, Rb;
function Vf() {
  if (Rb)
    return Xd;
  Rb = 1;
  var t, e = XC(), r = eB(), i = tB(), f = rB(), a = E8(), l = vc(), d = nB(), v = Function, m = function(b) {
    try {
      return v('"use strict"; return (' + b + ").constructor;")();
    } catch {
    }
  }, h = Object.getOwnPropertyDescriptor;
  if (h)
    try {
      h({}, "");
    } catch {
      h = null;
    }
  var w = function() {
    throw new l();
  }, M = h ? function() {
    try {
      return arguments.callee, w;
    } catch {
      try {
        return h(arguments, "callee").get;
      } catch {
        return w;
      }
    }
  }() : w, S = iB()(), E = aB()(), A = Object.getPrototypeOf || (E ? function(b) {
    return b.__proto__;
  } : null), B = {}, k = typeof Uint8Array > "u" || !A ? t : A(Uint8Array), C = {
    __proto__: null,
    "%AggregateError%": typeof AggregateError > "u" ? t : AggregateError,
    "%Array%": Array,
    "%ArrayBuffer%": typeof ArrayBuffer > "u" ? t : ArrayBuffer,
    "%ArrayIteratorPrototype%": S && A ? A([][Symbol.iterator]()) : t,
    "%AsyncFromSyncIteratorPrototype%": t,
    "%AsyncFunction%": B,
    "%AsyncGenerator%": B,
    "%AsyncGeneratorFunction%": B,
    "%AsyncIteratorPrototype%": B,
    "%Atomics%": typeof Atomics > "u" ? t : Atomics,
    "%BigInt%": typeof BigInt > "u" ? t : BigInt,
    "%BigInt64Array%": typeof BigInt64Array > "u" ? t : BigInt64Array,
    "%BigUint64Array%": typeof BigUint64Array > "u" ? t : BigUint64Array,
    "%Boolean%": Boolean,
    "%DataView%": typeof DataView > "u" ? t : DataView,
    "%Date%": Date,
    "%decodeURI%": decodeURI,
    "%decodeURIComponent%": decodeURIComponent,
    "%encodeURI%": encodeURI,
    "%encodeURIComponent%": encodeURIComponent,
    "%Error%": e,
    "%eval%": eval,
    // eslint-disable-line no-eval
    "%EvalError%": r,
    "%Float32Array%": typeof Float32Array > "u" ? t : Float32Array,
    "%Float64Array%": typeof Float64Array > "u" ? t : Float64Array,
    "%FinalizationRegistry%": typeof FinalizationRegistry > "u" ? t : FinalizationRegistry,
    "%Function%": v,
    "%GeneratorFunction%": B,
    "%Int8Array%": typeof Int8Array > "u" ? t : Int8Array,
    "%Int16Array%": typeof Int16Array > "u" ? t : Int16Array,
    "%Int32Array%": typeof Int32Array > "u" ? t : Int32Array,
    "%isFinite%": isFinite,
    "%isNaN%": isNaN,
    "%IteratorPrototype%": S && A ? A(A([][Symbol.iterator]())) : t,
    "%JSON%": typeof JSON == "object" ? JSON : t,
    "%Map%": typeof Map > "u" ? t : Map,
    "%MapIteratorPrototype%": typeof Map > "u" || !S || !A ? t : A((/* @__PURE__ */ new Map())[Symbol.iterator]()),
    "%Math%": Math,
    "%Number%": Number,
    "%Object%": Object,
    "%parseFloat%": parseFloat,
    "%parseInt%": parseInt,
    "%Promise%": typeof Promise > "u" ? t : Promise,
    "%Proxy%": typeof Proxy > "u" ? t : Proxy,
    "%RangeError%": i,
    "%ReferenceError%": f,
    "%Reflect%": typeof Reflect > "u" ? t : Reflect,
    "%RegExp%": RegExp,
    "%Set%": typeof Set > "u" ? t : Set,
    "%SetIteratorPrototype%": typeof Set > "u" || !S || !A ? t : A((/* @__PURE__ */ new Set())[Symbol.iterator]()),
    "%SharedArrayBuffer%": typeof SharedArrayBuffer > "u" ? t : SharedArrayBuffer,
    "%String%": String,
    "%StringIteratorPrototype%": S && A ? A(""[Symbol.iterator]()) : t,
    "%Symbol%": S ? Symbol : t,
    "%SyntaxError%": a,
    "%ThrowTypeError%": M,
    "%TypedArray%": k,
    "%TypeError%": l,
    "%Uint8Array%": typeof Uint8Array > "u" ? t : Uint8Array,
    "%Uint8ClampedArray%": typeof Uint8ClampedArray > "u" ? t : Uint8ClampedArray,
    "%Uint16Array%": typeof Uint16Array > "u" ? t : Uint16Array,
    "%Uint32Array%": typeof Uint32Array > "u" ? t : Uint32Array,
    "%URIError%": d,
    "%WeakMap%": typeof WeakMap > "u" ? t : WeakMap,
    "%WeakRef%": typeof WeakRef > "u" ? t : WeakRef,
    "%WeakSet%": typeof WeakSet > "u" ? t : WeakSet
  };
  if (A)
    try {
      null.error;
    } catch (b) {
      var I = A(A(b));
      C["%Error.prototype%"] = I;
    }
  var O = function b(_) {
    var p;
    if (_ === "%AsyncFunction%")
      p = m("async function () {}");
    else if (_ === "%GeneratorFunction%")
      p = m("function* () {}");
    else if (_ === "%AsyncGeneratorFunction%")
      p = m("async function* () {}");
    else if (_ === "%AsyncGenerator%") {
      var s = b("%AsyncGeneratorFunction%");
      s && (p = s.prototype);
    } else if (_ === "%AsyncIteratorPrototype%") {
      var y = b("%AsyncGenerator%");
      y && A && (p = A(y.prototype));
    }
    return C[_] = p, p;
  }, q = {
    __proto__: null,
    "%ArrayBufferPrototype%": ["ArrayBuffer", "prototype"],
    "%ArrayPrototype%": ["Array", "prototype"],
    "%ArrayProto_entries%": ["Array", "prototype", "entries"],
    "%ArrayProto_forEach%": ["Array", "prototype", "forEach"],
    "%ArrayProto_keys%": ["Array", "prototype", "keys"],
    "%ArrayProto_values%": ["Array", "prototype", "values"],
    "%AsyncFunctionPrototype%": ["AsyncFunction", "prototype"],
    "%AsyncGenerator%": ["AsyncGeneratorFunction", "prototype"],
    "%AsyncGeneratorPrototype%": ["AsyncGeneratorFunction", "prototype", "prototype"],
    "%BooleanPrototype%": ["Boolean", "prototype"],
    "%DataViewPrototype%": ["DataView", "prototype"],
    "%DatePrototype%": ["Date", "prototype"],
    "%ErrorPrototype%": ["Error", "prototype"],
    "%EvalErrorPrototype%": ["EvalError", "prototype"],
    "%Float32ArrayPrototype%": ["Float32Array", "prototype"],
    "%Float64ArrayPrototype%": ["Float64Array", "prototype"],
    "%FunctionPrototype%": ["Function", "prototype"],
    "%Generator%": ["GeneratorFunction", "prototype"],
    "%GeneratorPrototype%": ["GeneratorFunction", "prototype", "prototype"],
    "%Int8ArrayPrototype%": ["Int8Array", "prototype"],
    "%Int16ArrayPrototype%": ["Int16Array", "prototype"],
    "%Int32ArrayPrototype%": ["Int32Array", "prototype"],
    "%JSONParse%": ["JSON", "parse"],
    "%JSONStringify%": ["JSON", "stringify"],
    "%MapPrototype%": ["Map", "prototype"],
    "%NumberPrototype%": ["Number", "prototype"],
    "%ObjectPrototype%": ["Object", "prototype"],
    "%ObjProto_toString%": ["Object", "prototype", "toString"],
    "%ObjProto_valueOf%": ["Object", "prototype", "valueOf"],
    "%PromisePrototype%": ["Promise", "prototype"],
    "%PromiseProto_then%": ["Promise", "prototype", "then"],
    "%Promise_all%": ["Promise", "all"],
    "%Promise_reject%": ["Promise", "reject"],
    "%Promise_resolve%": ["Promise", "resolve"],
    "%RangeErrorPrototype%": ["RangeError", "prototype"],
    "%ReferenceErrorPrototype%": ["ReferenceError", "prototype"],
    "%RegExpPrototype%": ["RegExp", "prototype"],
    "%SetPrototype%": ["Set", "prototype"],
    "%SharedArrayBufferPrototype%": ["SharedArrayBuffer", "prototype"],
    "%StringPrototype%": ["String", "prototype"],
    "%SymbolPrototype%": ["Symbol", "prototype"],
    "%SyntaxErrorPrototype%": ["SyntaxError", "prototype"],
    "%TypedArrayPrototype%": ["TypedArray", "prototype"],
    "%TypeErrorPrototype%": ["TypeError", "prototype"],
    "%Uint8ArrayPrototype%": ["Uint8Array", "prototype"],
    "%Uint8ClampedArrayPrototype%": ["Uint8ClampedArray", "prototype"],
    "%Uint16ArrayPrototype%": ["Uint16Array", "prototype"],
    "%Uint32ArrayPrototype%": ["Uint32Array", "prototype"],
    "%URIErrorPrototype%": ["URIError", "prototype"],
    "%WeakMapPrototype%": ["WeakMap", "prototype"],
    "%WeakSetPrototype%": ["WeakSet", "prototype"]
  }, $ = hm(), ae = oB(), he = $.call(Function.call, Array.prototype.concat), te = $.call(Function.apply, Array.prototype.splice), Ee = $.call(Function.call, String.prototype.replace), x = $.call(Function.call, String.prototype.slice), n = $.call(Function.call, RegExp.prototype.exec), o = /[^%.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|%$))/g, u = /\\(\\)?/g, c = function(_) {
    var p = x(_, 0, 1), s = x(_, -1);
    if (p === "%" && s !== "%")
      throw new a("invalid intrinsic syntax, expected closing `%`");
    if (s === "%" && p !== "%")
      throw new a("invalid intrinsic syntax, expected opening `%`");
    var y = [];
    return Ee(_, o, function(T, P, z, J) {
      y[y.length] = z ? Ee(J, u, "$1") : P || T;
    }), y;
  }, g = function(_, p) {
    var s = _, y;
    if (ae(q, s) && (y = q[s], s = "%" + y[0] + "%"), ae(C, s)) {
      var T = C[s];
      if (T === B && (T = O(s)), typeof T > "u" && !p)
        throw new l("intrinsic " + _ + " exists, but is not available. Please file an issue!");
      return {
        alias: y,
        name: s,
        value: T
      };
    }
    throw new a("intrinsic " + _ + " does not exist!");
  };
  return Xd = function(_, p) {
    if (typeof _ != "string" || _.length === 0)
      throw new l("intrinsic name must be a non-empty string");
    if (arguments.length > 1 && typeof p != "boolean")
      throw new l('"allowMissing" argument must be a boolean');
    if (n(/^%?[^%]*%?$/, _) === null)
      throw new a("`%` may not be present anywhere but at the beginning and end of the intrinsic name");
    var s = c(_), y = s.length > 0 ? s[0] : "", T = g("%" + y + "%", p), P = T.name, z = T.value, J = !1, Z = T.alias;
    Z && (y = Z[0], te(s, he([0, 1], Z)));
    for (var F = 1, ee = !0; F < s.length; F += 1) {
      var re = s[F], de = x(re, 0, 1), se = x(re, -1);
      if ((de === '"' || de === "'" || de === "`" || se === '"' || se === "'" || se === "`") && de !== se)
        throw new a("property names with quotes must have matching quotes");
      if ((re === "constructor" || !ee) && (J = !0), y += "." + re, P = "%" + y + "%", ae(C, P))
        z = C[P];
      else if (z != null) {
        if (!(re in z)) {
          if (!p)
            throw new l("base intrinsic for " + _ + " exists, but the property is not available.");
          return;
        }
        if (h && F + 1 >= s.length) {
          var Q = h(z, re);
          ee = !!Q, ee && "get" in Q && !("originalValue" in Q.get) ? z = Q.get : z = z[re];
        } else
          ee = ae(z, re), z = z[re];
        ee && !J && (C[P] = z);
      }
    }
    return z;
  }, Xd;
}
var eh = { exports: {} }, th, Pb;
function pm() {
  if (Pb)
    return th;
  Pb = 1;
  var t = Vf(), e = t("%Object.defineProperty%", !0) || !1;
  if (e)
    try {
      e({}, "a", { value: 1 });
    } catch {
      e = !1;
    }
  return th = e, th;
}
var rh, Ob;
function vm() {
  if (Ob)
    return rh;
  Ob = 1;
  var t = Vf(), e = t("%Object.getOwnPropertyDescriptor%", !0);
  if (e)
    try {
      e([], "length");
    } catch {
      e = null;
    }
  return rh = e, rh;
}
var nh, Nb;
function fB() {
  if (Nb)
    return nh;
  Nb = 1;
  var t = pm(), e = E8(), r = vc(), i = vm();
  return nh = function(a, l, d) {
    if (!a || typeof a != "object" && typeof a != "function")
      throw new r("`obj` must be an object or a function`");
    if (typeof l != "string" && typeof l != "symbol")
      throw new r("`property` must be a string or a symbol`");
    if (arguments.length > 3 && typeof arguments[3] != "boolean" && arguments[3] !== null)
      throw new r("`nonEnumerable`, if provided, must be a boolean or null");
    if (arguments.length > 4 && typeof arguments[4] != "boolean" && arguments[4] !== null)
      throw new r("`nonWritable`, if provided, must be a boolean or null");
    if (arguments.length > 5 && typeof arguments[5] != "boolean" && arguments[5] !== null)
      throw new r("`nonConfigurable`, if provided, must be a boolean or null");
    if (arguments.length > 6 && typeof arguments[6] != "boolean")
      throw new r("`loose`, if provided, must be a boolean");
    var v = arguments.length > 3 ? arguments[3] : null, m = arguments.length > 4 ? arguments[4] : null, h = arguments.length > 5 ? arguments[5] : null, w = arguments.length > 6 ? arguments[6] : !1, M = !!i && i(a, l);
    if (t)
      t(a, l, {
        configurable: h === null && M ? M.configurable : !h,
        enumerable: v === null && M ? M.enumerable : !v,
        value: d,
        writable: m === null && M ? M.writable : !m
      });
    else if (w || !v && !m && !h)
      a[l] = d;
    else
      throw new e("This environment does not support defining a property as non-configurable, non-writable, or non-enumerable.");
  }, nh;
}
var ih, Db;
function uB() {
  if (Db)
    return ih;
  Db = 1;
  var t = pm(), e = function() {
    return !!t;
  };
  return e.hasArrayLengthDefineBug = function() {
    if (!t)
      return null;
    try {
      return t([], "length", { value: 1 }).length !== 1;
    } catch {
      return !0;
    }
  }, ih = e, ih;
}
var ah, Ub;
function lB() {
  if (Ub)
    return ah;
  Ub = 1;
  var t = Vf(), e = fB(), r = uB()(), i = vm(), f = vc(), a = t("%Math.floor%");
  return ah = function(d, v) {
    if (typeof d != "function")
      throw new f("`fn` is not a function");
    if (typeof v != "number" || v < 0 || v > 4294967295 || a(v) !== v)
      throw new f("`length` must be a positive 32-bit integer");
    var m = arguments.length > 2 && !!arguments[2], h = !0, w = !0;
    if ("length" in d && i) {
      var M = i(d, "length");
      M && !M.configurable && (h = !1), M && !M.writable && (w = !1);
    }
    return (h || w || !m) && (r ? e(
      /** @type {Parameters<define>[0]} */
      d,
      "length",
      v,
      !0,
      !0
    ) : e(
      /** @type {Parameters<define>[0]} */
      d,
      "length",
      v
    )), d;
  }, ah;
}
var Lb;
function A8() {
  return Lb || (Lb = 1, function(t) {
    var e = hm(), r = Vf(), i = lB(), f = vc(), a = r("%Function.prototype.apply%"), l = r("%Function.prototype.call%"), d = r("%Reflect.apply%", !0) || e.call(l, a), v = pm(), m = r("%Math.max%");
    t.exports = function(M) {
      if (typeof M != "function")
        throw new f("a function is required");
      var S = d(e, l, arguments);
      return i(
        S,
        1 + m(0, M.length - (arguments.length - 1)),
        !0
      );
    };
    var h = function() {
      return d(e, a, arguments);
    };
    v ? v(t.exports, "apply", { value: h }) : t.exports.apply = h;
  }(eh)), eh.exports;
}
var sh, Fb;
function k8() {
  if (Fb)
    return sh;
  Fb = 1;
  var t = Vf(), e = A8(), r = e(t("String.prototype.indexOf"));
  return sh = function(f, a) {
    var l = t(f, !!a);
    return typeof l == "function" && r(f, ".prototype.") > -1 ? e(l) : l;
  }, sh;
}
var oh, qb;
function cB() {
  if (qb)
    return oh;
  qb = 1;
  var t = dm()(), e = k8(), r = e("Object.prototype.toString"), i = function(d) {
    return t && d && typeof d == "object" && Symbol.toStringTag in d ? !1 : r(d) === "[object Arguments]";
  }, f = function(d) {
    return i(d) ? !0 : d !== null && typeof d == "object" && typeof d.length == "number" && d.length >= 0 && r(d) !== "[object Array]" && r(d.callee) === "[object Function]";
  }, a = function() {
    return i(arguments);
  }();
  return i.isLegacyArguments = f, oh = a ? i : f, oh;
}
var fh, zb;
function dB() {
  if (zb)
    return fh;
  zb = 1;
  var t = Object.prototype.toString, e = Function.prototype.toString, r = /^\s*(?:function)?\*/, i = dm()(), f = Object.getPrototypeOf, a = function() {
    if (!i)
      return !1;
    try {
      return Function("return function*() {}")();
    } catch {
    }
  }, l;
  return fh = function(v) {
    if (typeof v != "function")
      return !1;
    if (r.test(e.call(v)))
      return !0;
    if (!i) {
      var m = t.call(v);
      return m === "[object GeneratorFunction]";
    }
    if (!f)
      return !1;
    if (typeof l > "u") {
      var h = a();
      l = h ? f(h) : !1;
    }
    return f(v) === l;
  }, fh;
}
var uh, jb;
function hB() {
  if (jb)
    return uh;
  jb = 1;
  var t = Function.prototype.toString, e = typeof Reflect == "object" && Reflect !== null && Reflect.apply, r, i;
  if (typeof e == "function" && typeof Object.defineProperty == "function")
    try {
      r = Object.defineProperty({}, "length", {
        get: function() {
          throw i;
        }
      }), i = {}, e(function() {
        throw 42;
      }, null, r);
    } catch (C) {
      C !== i && (e = null);
    }
  else
    e = null;
  var f = /^\s*class\b/, a = function(I) {
    try {
      var O = t.call(I);
      return f.test(O);
    } catch {
      return !1;
    }
  }, l = function(I) {
    try {
      return a(I) ? !1 : (t.call(I), !0);
    } catch {
      return !1;
    }
  }, d = Object.prototype.toString, v = "[object Object]", m = "[object Function]", h = "[object GeneratorFunction]", w = "[object HTMLAllCollection]", M = "[object HTML document.all class]", S = "[object HTMLCollection]", E = typeof Symbol == "function" && !!Symbol.toStringTag, A = !(0 in [,]), B = function() {
    return !1;
  };
  if (typeof document == "object") {
    var k = document.all;
    d.call(k) === d.call(document.all) && (B = function(I) {
      if ((A || !I) && (typeof I > "u" || typeof I == "object"))
        try {
          var O = d.call(I);
          return (O === w || O === M || O === S || O === v) && I("") == null;
        } catch {
        }
      return !1;
    });
  }
  return uh = e ? function(I) {
    if (B(I))
      return !0;
    if (!I || typeof I != "function" && typeof I != "object")
      return !1;
    try {
      e(I, null, r);
    } catch (O) {
      if (O !== i)
        return !1;
    }
    return !a(I) && l(I);
  } : function(I) {
    if (B(I))
      return !0;
    if (!I || typeof I != "function" && typeof I != "object")
      return !1;
    if (E)
      return l(I);
    if (a(I))
      return !1;
    var O = d.call(I);
    return O !== m && O !== h && !/^\[object HTML/.test(O) ? !1 : l(I);
  }, uh;
}
var lh, $b;
function pB() {
  if ($b)
    return lh;
  $b = 1;
  var t = hB(), e = Object.prototype.toString, r = Object.prototype.hasOwnProperty, i = function(v, m, h) {
    for (var w = 0, M = v.length; w < M; w++)
      r.call(v, w) && (h == null ? m(v[w], w, v) : m.call(h, v[w], w, v));
  }, f = function(v, m, h) {
    for (var w = 0, M = v.length; w < M; w++)
      h == null ? m(v.charAt(w), w, v) : m.call(h, v.charAt(w), w, v);
  }, a = function(v, m, h) {
    for (var w in v)
      r.call(v, w) && (h == null ? m(v[w], w, v) : m.call(h, v[w], w, v));
  }, l = function(v, m, h) {
    if (!t(m))
      throw new TypeError("iterator must be a function");
    var w;
    arguments.length >= 3 && (w = h), e.call(v) === "[object Array]" ? i(v, m, w) : typeof v == "string" ? f(v, m, w) : a(v, m, w);
  };
  return lh = l, lh;
}
var ch, Vb;
function vB() {
  return Vb || (Vb = 1, ch = [
    "Float32Array",
    "Float64Array",
    "Int8Array",
    "Int16Array",
    "Int32Array",
    "Uint8Array",
    "Uint8ClampedArray",
    "Uint16Array",
    "Uint32Array",
    "BigInt64Array",
    "BigUint64Array"
  ]), ch;
}
var dh, Hb;
function mB() {
  if (Hb)
    return dh;
  Hb = 1;
  var t = vB(), e = typeof globalThis > "u" ? ut : globalThis;
  return dh = function() {
    for (var i = [], f = 0; f < t.length; f++)
      typeof e[t[f]] == "function" && (i[i.length] = t[f]);
    return i;
  }, dh;
}
var hh, Wb;
function T8() {
  if (Wb)
    return hh;
  Wb = 1;
  var t = pB(), e = mB(), r = A8(), i = k8(), f = vm(), a = i("Object.prototype.toString"), l = dm()(), d = typeof globalThis > "u" ? ut : globalThis, v = e(), m = i("String.prototype.slice"), h = Object.getPrototypeOf, w = i("Array.prototype.indexOf", !0) || function(B, k) {
    for (var C = 0; C < B.length; C += 1)
      if (B[C] === k)
        return C;
    return -1;
  }, M = { __proto__: null };
  l && f && h ? t(v, function(A) {
    var B = new d[A]();
    if (Symbol.toStringTag in B) {
      var k = h(B), C = f(k, Symbol.toStringTag);
      if (!C) {
        var I = h(k);
        C = f(I, Symbol.toStringTag);
      }
      M["$" + A] = r(C.get);
    }
  }) : t(v, function(A) {
    var B = new d[A](), k = B.slice || B.set;
    k && (M["$" + A] = r(k));
  });
  var S = function(B) {
    var k = !1;
    return t(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      M,
      /** @type {(getter: Getter, name: `\$${import('.').TypedArrayName}`) => void} */
      function(C, I) {
        if (!k)
          try {
            "$" + C(B) === I && (k = m(I, 1));
          } catch {
          }
      }
    ), k;
  }, E = function(B) {
    var k = !1;
    return t(
      // eslint-disable-next-line no-extra-parens
      /** @type {Record<`\$${TypedArrayName}`, Getter>} */
      /** @type {any} */
      M,
      /** @type {(getter: typeof cache, name: `\$${import('.').TypedArrayName}`) => void} */
      function(C, I) {
        if (!k)
          try {
            C(B), k = m(I, 1);
          } catch {
          }
      }
    ), k;
  };
  return hh = function(B) {
    if (!B || typeof B != "object")
      return !1;
    if (!l) {
      var k = m(a(B), 8, -1);
      return w(v, k) > -1 ? k : k !== "Object" ? !1 : E(B);
    }
    return f ? S(B) : null;
  }, hh;
}
var ph, Kb;
function gB() {
  if (Kb)
    return ph;
  Kb = 1;
  var t = T8();
  return ph = function(r) {
    return !!t(r);
  }, ph;
}
var Zb;
function yB() {
  return Zb || (Zb = 1, function(t) {
    var e = cB(), r = dB(), i = T8(), f = gB();
    function a(_e) {
      return _e.call.bind(_e);
    }
    var l = typeof BigInt < "u", d = typeof Symbol < "u", v = a(Object.prototype.toString), m = a(Number.prototype.valueOf), h = a(String.prototype.valueOf), w = a(Boolean.prototype.valueOf);
    if (l)
      var M = a(BigInt.prototype.valueOf);
    if (d)
      var S = a(Symbol.prototype.valueOf);
    function E(_e, St) {
      if (typeof _e != "object")
        return !1;
      try {
        return St(_e), !0;
      } catch {
        return !1;
      }
    }
    t.isArgumentsObject = e, t.isGeneratorFunction = r, t.isTypedArray = f;
    function A(_e) {
      return typeof Promise < "u" && _e instanceof Promise || _e !== null && typeof _e == "object" && typeof _e.then == "function" && typeof _e.catch == "function";
    }
    t.isPromise = A;
    function B(_e) {
      return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? ArrayBuffer.isView(_e) : f(_e) || P(_e);
    }
    t.isArrayBufferView = B;
    function k(_e) {
      return i(_e) === "Uint8Array";
    }
    t.isUint8Array = k;
    function C(_e) {
      return i(_e) === "Uint8ClampedArray";
    }
    t.isUint8ClampedArray = C;
    function I(_e) {
      return i(_e) === "Uint16Array";
    }
    t.isUint16Array = I;
    function O(_e) {
      return i(_e) === "Uint32Array";
    }
    t.isUint32Array = O;
    function q(_e) {
      return i(_e) === "Int8Array";
    }
    t.isInt8Array = q;
    function $(_e) {
      return i(_e) === "Int16Array";
    }
    t.isInt16Array = $;
    function ae(_e) {
      return i(_e) === "Int32Array";
    }
    t.isInt32Array = ae;
    function he(_e) {
      return i(_e) === "Float32Array";
    }
    t.isFloat32Array = he;
    function te(_e) {
      return i(_e) === "Float64Array";
    }
    t.isFloat64Array = te;
    function Ee(_e) {
      return i(_e) === "BigInt64Array";
    }
    t.isBigInt64Array = Ee;
    function x(_e) {
      return i(_e) === "BigUint64Array";
    }
    t.isBigUint64Array = x;
    function n(_e) {
      return v(_e) === "[object Map]";
    }
    n.working = typeof Map < "u" && n(/* @__PURE__ */ new Map());
    function o(_e) {
      return typeof Map > "u" ? !1 : n.working ? n(_e) : _e instanceof Map;
    }
    t.isMap = o;
    function u(_e) {
      return v(_e) === "[object Set]";
    }
    u.working = typeof Set < "u" && u(/* @__PURE__ */ new Set());
    function c(_e) {
      return typeof Set > "u" ? !1 : u.working ? u(_e) : _e instanceof Set;
    }
    t.isSet = c;
    function g(_e) {
      return v(_e) === "[object WeakMap]";
    }
    g.working = typeof WeakMap < "u" && g(/* @__PURE__ */ new WeakMap());
    function b(_e) {
      return typeof WeakMap > "u" ? !1 : g.working ? g(_e) : _e instanceof WeakMap;
    }
    t.isWeakMap = b;
    function _(_e) {
      return v(_e) === "[object WeakSet]";
    }
    _.working = typeof WeakSet < "u" && _(/* @__PURE__ */ new WeakSet());
    function p(_e) {
      return _(_e);
    }
    t.isWeakSet = p;
    function s(_e) {
      return v(_e) === "[object ArrayBuffer]";
    }
    s.working = typeof ArrayBuffer < "u" && s(new ArrayBuffer());
    function y(_e) {
      return typeof ArrayBuffer > "u" ? !1 : s.working ? s(_e) : _e instanceof ArrayBuffer;
    }
    t.isArrayBuffer = y;
    function T(_e) {
      return v(_e) === "[object DataView]";
    }
    T.working = typeof ArrayBuffer < "u" && typeof DataView < "u" && T(new DataView(new ArrayBuffer(1), 0, 1));
    function P(_e) {
      return typeof DataView > "u" ? !1 : T.working ? T(_e) : _e instanceof DataView;
    }
    t.isDataView = P;
    var z = typeof SharedArrayBuffer < "u" ? SharedArrayBuffer : void 0;
    function J(_e) {
      return v(_e) === "[object SharedArrayBuffer]";
    }
    function Z(_e) {
      return typeof z > "u" ? !1 : (typeof J.working > "u" && (J.working = J(new z())), J.working ? J(_e) : _e instanceof z);
    }
    t.isSharedArrayBuffer = Z;
    function F(_e) {
      return v(_e) === "[object AsyncFunction]";
    }
    t.isAsyncFunction = F;
    function ee(_e) {
      return v(_e) === "[object Map Iterator]";
    }
    t.isMapIterator = ee;
    function re(_e) {
      return v(_e) === "[object Set Iterator]";
    }
    t.isSetIterator = re;
    function de(_e) {
      return v(_e) === "[object Generator]";
    }
    t.isGeneratorObject = de;
    function se(_e) {
      return v(_e) === "[object WebAssembly.Module]";
    }
    t.isWebAssemblyCompiledModule = se;
    function Q(_e) {
      return E(_e, m);
    }
    t.isNumberObject = Q;
    function ge(_e) {
      return E(_e, h);
    }
    t.isStringObject = ge;
    function Ye(_e) {
      return E(_e, w);
    }
    t.isBooleanObject = Ye;
    function Ce(_e) {
      return l && E(_e, M);
    }
    t.isBigIntObject = Ce;
    function Be(_e) {
      return d && E(_e, S);
    }
    t.isSymbolObject = Be;
    function st(_e) {
      return Q(_e) || ge(_e) || Ye(_e) || Ce(_e) || Be(_e);
    }
    t.isBoxedPrimitive = st;
    function De(_e) {
      return typeof Uint8Array < "u" && (y(_e) || Z(_e));
    }
    t.isAnyArrayBuffer = De, ["isProxy", "isExternal", "isModuleNamespaceObject"].forEach(function(_e) {
      Object.defineProperty(t, _e, {
        enumerable: !1,
        value: function() {
          throw new Error(_e + " is not supported in userland");
        }
      });
    });
  }(Ld)), Ld;
}
var vh, Gb;
function bB() {
  return Gb || (Gb = 1, vh = function(e) {
    return e && typeof e == "object" && typeof e.copy == "function" && typeof e.fill == "function" && typeof e.readUInt8 == "function";
  }), vh;
}
var Qb;
function mc() {
  return Qb || (Qb = 1, function(t) {
    var e = Object.getOwnPropertyDescriptors || function(P) {
      for (var z = Object.keys(P), J = {}, Z = 0; Z < z.length; Z++)
        J[z[Z]] = Object.getOwnPropertyDescriptor(P, z[Z]);
      return J;
    }, r = /%[sdj%]/g;
    t.format = function(T) {
      if (!q(T)) {
        for (var P = [], z = 0; z < arguments.length; z++)
          P.push(l(arguments[z]));
        return P.join(" ");
      }
      for (var z = 1, J = arguments, Z = J.length, F = String(T).replace(r, function(re) {
        if (re === "%%")
          return "%";
        if (z >= Z)
          return re;
        switch (re) {
          case "%s":
            return String(J[z++]);
          case "%d":
            return Number(J[z++]);
          case "%j":
            try {
              return JSON.stringify(J[z++]);
            } catch {
              return "[Circular]";
            }
          default:
            return re;
        }
      }), ee = J[z]; z < Z; ee = J[++z])
        C(ee) || !te(ee) ? F += " " + ee : F += " " + l(ee);
      return F;
    }, t.deprecate = function(T, P) {
      if (typeof It < "u" && It.noDeprecation === !0)
        return T;
      if (typeof It > "u")
        return function() {
          return t.deprecate(T, P).apply(this, arguments);
        };
      var z = !1;
      function J() {
        if (!z) {
          if (It.throwDeprecation)
            throw new Error(P);
          It.traceDeprecation ? console.trace(P) : console.error(P), z = !0;
        }
        return T.apply(this, arguments);
      }
      return J;
    };
    var i = {}, f = /^$/;
    if (It.env.NODE_DEBUG) {
      var a = It.env.NODE_DEBUG;
      a = a.replace(/[|\\{}()[\]^$+?.]/g, "\\$&").replace(/\*/g, ".*").replace(/,/g, "$|^").toUpperCase(), f = new RegExp("^" + a + "$", "i");
    }
    t.debuglog = function(T) {
      if (T = T.toUpperCase(), !i[T])
        if (f.test(T)) {
          var P = It.pid;
          i[T] = function() {
            var z = t.format.apply(t, arguments);
            console.error("%s %d: %s", T, P, z);
          };
        } else
          i[T] = function() {
          };
      return i[T];
    };
    function l(T, P) {
      var z = {
        seen: [],
        stylize: v
      };
      return arguments.length >= 3 && (z.depth = arguments[2]), arguments.length >= 4 && (z.colors = arguments[3]), k(P) ? z.showHidden = P : P && t._extend(z, P), ae(z.showHidden) && (z.showHidden = !1), ae(z.depth) && (z.depth = 2), ae(z.colors) && (z.colors = !1), ae(z.customInspect) && (z.customInspect = !0), z.colors && (z.stylize = d), h(z, T, z.depth);
    }
    t.inspect = l, l.colors = {
      bold: [1, 22],
      italic: [3, 23],
      underline: [4, 24],
      inverse: [7, 27],
      white: [37, 39],
      grey: [90, 39],
      black: [30, 39],
      blue: [34, 39],
      cyan: [36, 39],
      green: [32, 39],
      magenta: [35, 39],
      red: [31, 39],
      yellow: [33, 39]
    }, l.styles = {
      special: "cyan",
      number: "yellow",
      boolean: "yellow",
      undefined: "grey",
      null: "bold",
      string: "green",
      date: "magenta",
      // "name": intentionally not styling
      regexp: "red"
    };
    function d(T, P) {
      var z = l.styles[P];
      return z ? "\x1B[" + l.colors[z][0] + "m" + T + "\x1B[" + l.colors[z][1] + "m" : T;
    }
    function v(T, P) {
      return T;
    }
    function m(T) {
      var P = {};
      return T.forEach(function(z, J) {
        P[z] = !0;
      }), P;
    }
    function h(T, P, z) {
      if (T.customInspect && P && n(P.inspect) && // Filter out the util module, it's inspect function is special
      P.inspect !== t.inspect && // Also filter out any prototype objects using the circular check.
      !(P.constructor && P.constructor.prototype === P)) {
        var J = P.inspect(z, T);
        return q(J) || (J = h(T, J, z)), J;
      }
      var Z = w(T, P);
      if (Z)
        return Z;
      var F = Object.keys(P), ee = m(F);
      if (T.showHidden && (F = Object.getOwnPropertyNames(P)), x(P) && (F.indexOf("message") >= 0 || F.indexOf("description") >= 0))
        return M(P);
      if (F.length === 0) {
        if (n(P)) {
          var re = P.name ? ": " + P.name : "";
          return T.stylize("[Function" + re + "]", "special");
        }
        if (he(P))
          return T.stylize(RegExp.prototype.toString.call(P), "regexp");
        if (Ee(P))
          return T.stylize(Date.prototype.toString.call(P), "date");
        if (x(P))
          return M(P);
      }
      var de = "", se = !1, Q = ["{", "}"];
      if (B(P) && (se = !0, Q = ["[", "]"]), n(P)) {
        var ge = P.name ? ": " + P.name : "";
        de = " [Function" + ge + "]";
      }
      if (he(P) && (de = " " + RegExp.prototype.toString.call(P)), Ee(P) && (de = " " + Date.prototype.toUTCString.call(P)), x(P) && (de = " " + M(P)), F.length === 0 && (!se || P.length == 0))
        return Q[0] + de + Q[1];
      if (z < 0)
        return he(P) ? T.stylize(RegExp.prototype.toString.call(P), "regexp") : T.stylize("[Object]", "special");
      T.seen.push(P);
      var Ye;
      return se ? Ye = S(T, P, z, ee, F) : Ye = F.map(function(Ce) {
        return E(T, P, z, ee, Ce, se);
      }), T.seen.pop(), A(Ye, de, Q);
    }
    function w(T, P) {
      if (ae(P))
        return T.stylize("undefined", "undefined");
      if (q(P)) {
        var z = "'" + JSON.stringify(P).replace(/^"|"$/g, "").replace(/'/g, "\\'").replace(/\\"/g, '"') + "'";
        return T.stylize(z, "string");
      }
      if (O(P))
        return T.stylize("" + P, "number");
      if (k(P))
        return T.stylize("" + P, "boolean");
      if (C(P))
        return T.stylize("null", "null");
    }
    function M(T) {
      return "[" + Error.prototype.toString.call(T) + "]";
    }
    function S(T, P, z, J, Z) {
      for (var F = [], ee = 0, re = P.length; ee < re; ++ee)
        _(P, String(ee)) ? F.push(E(
          T,
          P,
          z,
          J,
          String(ee),
          !0
        )) : F.push("");
      return Z.forEach(function(de) {
        de.match(/^\d+$/) || F.push(E(
          T,
          P,
          z,
          J,
          de,
          !0
        ));
      }), F;
    }
    function E(T, P, z, J, Z, F) {
      var ee, re, de;
      if (de = Object.getOwnPropertyDescriptor(P, Z) || { value: P[Z] }, de.get ? de.set ? re = T.stylize("[Getter/Setter]", "special") : re = T.stylize("[Getter]", "special") : de.set && (re = T.stylize("[Setter]", "special")), _(J, Z) || (ee = "[" + Z + "]"), re || (T.seen.indexOf(de.value) < 0 ? (C(z) ? re = h(T, de.value, null) : re = h(T, de.value, z - 1), re.indexOf(`
`) > -1 && (F ? re = re.split(`
`).map(function(se) {
        return "  " + se;
      }).join(`
`).slice(2) : re = `
` + re.split(`
`).map(function(se) {
        return "   " + se;
      }).join(`
`))) : re = T.stylize("[Circular]", "special")), ae(ee)) {
        if (F && Z.match(/^\d+$/))
          return re;
        ee = JSON.stringify("" + Z), ee.match(/^"([a-zA-Z_][a-zA-Z_0-9]*)"$/) ? (ee = ee.slice(1, -1), ee = T.stylize(ee, "name")) : (ee = ee.replace(/'/g, "\\'").replace(/\\"/g, '"').replace(/(^"|"$)/g, "'"), ee = T.stylize(ee, "string"));
      }
      return ee + ": " + re;
    }
    function A(T, P, z) {
      var J = T.reduce(function(Z, F) {
        return F.indexOf(`
`) >= 0, Z + F.replace(/\u001b\[\d\d?m/g, "").length + 1;
      }, 0);
      return J > 60 ? z[0] + (P === "" ? "" : P + `
 `) + " " + T.join(`,
  `) + " " + z[1] : z[0] + P + " " + T.join(", ") + " " + z[1];
    }
    t.types = yB();
    function B(T) {
      return Array.isArray(T);
    }
    t.isArray = B;
    function k(T) {
      return typeof T == "boolean";
    }
    t.isBoolean = k;
    function C(T) {
      return T === null;
    }
    t.isNull = C;
    function I(T) {
      return T == null;
    }
    t.isNullOrUndefined = I;
    function O(T) {
      return typeof T == "number";
    }
    t.isNumber = O;
    function q(T) {
      return typeof T == "string";
    }
    t.isString = q;
    function $(T) {
      return typeof T == "symbol";
    }
    t.isSymbol = $;
    function ae(T) {
      return T === void 0;
    }
    t.isUndefined = ae;
    function he(T) {
      return te(T) && u(T) === "[object RegExp]";
    }
    t.isRegExp = he, t.types.isRegExp = he;
    function te(T) {
      return typeof T == "object" && T !== null;
    }
    t.isObject = te;
    function Ee(T) {
      return te(T) && u(T) === "[object Date]";
    }
    t.isDate = Ee, t.types.isDate = Ee;
    function x(T) {
      return te(T) && (u(T) === "[object Error]" || T instanceof Error);
    }
    t.isError = x, t.types.isNativeError = x;
    function n(T) {
      return typeof T == "function";
    }
    t.isFunction = n;
    function o(T) {
      return T === null || typeof T == "boolean" || typeof T == "number" || typeof T == "string" || typeof T == "symbol" || // ES6 symbol
      typeof T > "u";
    }
    t.isPrimitive = o, t.isBuffer = bB();
    function u(T) {
      return Object.prototype.toString.call(T);
    }
    function c(T) {
      return T < 10 ? "0" + T.toString(10) : T.toString(10);
    }
    var g = [
      "Jan",
      "Feb",
      "Mar",
      "Apr",
      "May",
      "Jun",
      "Jul",
      "Aug",
      "Sep",
      "Oct",
      "Nov",
      "Dec"
    ];
    function b() {
      var T = /* @__PURE__ */ new Date(), P = [
        c(T.getHours()),
        c(T.getMinutes()),
        c(T.getSeconds())
      ].join(":");
      return [T.getDate(), g[T.getMonth()], P].join(" ");
    }
    t.log = function() {
      console.log("%s - %s", b(), t.format.apply(t, arguments));
    }, t.inherits = Lt(), t._extend = function(T, P) {
      if (!P || !te(P))
        return T;
      for (var z = Object.keys(P), J = z.length; J--; )
        T[z[J]] = P[z[J]];
      return T;
    };
    function _(T, P) {
      return Object.prototype.hasOwnProperty.call(T, P);
    }
    var p = typeof Symbol < "u" ? Symbol("util.promisify.custom") : void 0;
    t.promisify = function(P) {
      if (typeof P != "function")
        throw new TypeError('The "original" argument must be of type Function');
      if (p && P[p]) {
        var z = P[p];
        if (typeof z != "function")
          throw new TypeError('The "util.promisify.custom" argument must be of type Function');
        return Object.defineProperty(z, p, {
          value: z,
          enumerable: !1,
          writable: !1,
          configurable: !0
        }), z;
      }
      function z() {
        for (var J, Z, F = new Promise(function(de, se) {
          J = de, Z = se;
        }), ee = [], re = 0; re < arguments.length; re++)
          ee.push(arguments[re]);
        ee.push(function(de, se) {
          de ? Z(de) : J(se);
        });
        try {
          P.apply(this, ee);
        } catch (de) {
          Z(de);
        }
        return F;
      }
      return Object.setPrototypeOf(z, Object.getPrototypeOf(P)), p && Object.defineProperty(z, p, {
        value: z,
        enumerable: !1,
        writable: !1,
        configurable: !0
      }), Object.defineProperties(
        z,
        e(P)
      );
    }, t.promisify.custom = p;
    function s(T, P) {
      if (!T) {
        var z = new Error("Promise was rejected with a falsy value");
        z.reason = T, T = z;
      }
      return P(T);
    }
    function y(T) {
      if (typeof T != "function")
        throw new TypeError('The "original" argument must be of type Function');
      function P() {
        for (var z = [], J = 0; J < arguments.length; J++)
          z.push(arguments[J]);
        var Z = z.pop();
        if (typeof Z != "function")
          throw new TypeError("The last argument must be of type Function");
        var F = this, ee = function() {
          return Z.apply(F, arguments);
        };
        T.apply(this, z).then(
          function(re) {
            It.nextTick(ee.bind(null, null, re));
          },
          function(re) {
            It.nextTick(s.bind(null, re, ee));
          }
        );
      }
      return Object.setPrototypeOf(P, Object.getPrototypeOf(T)), Object.defineProperties(
        P,
        e(T)
      ), P;
    }
    t.callbackify = y;
  }(Ud)), Ud;
}
var mh, Yb;
function wB() {
  if (Yb)
    return mh;
  Yb = 1;
  function t(E, A) {
    var B = Object.keys(E);
    if (Object.getOwnPropertySymbols) {
      var k = Object.getOwnPropertySymbols(E);
      A && (k = k.filter(function(C) {
        return Object.getOwnPropertyDescriptor(E, C).enumerable;
      })), B.push.apply(B, k);
    }
    return B;
  }
  function e(E) {
    for (var A = 1; A < arguments.length; A++) {
      var B = arguments[A] != null ? arguments[A] : {};
      A % 2 ? t(Object(B), !0).forEach(function(k) {
        r(E, k, B[k]);
      }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(E, Object.getOwnPropertyDescriptors(B)) : t(Object(B)).forEach(function(k) {
        Object.defineProperty(E, k, Object.getOwnPropertyDescriptor(B, k));
      });
    }
    return E;
  }
  function r(E, A, B) {
    return A = l(A), A in E ? Object.defineProperty(E, A, { value: B, enumerable: !0, configurable: !0, writable: !0 }) : E[A] = B, E;
  }
  function i(E, A) {
    if (!(E instanceof A))
      throw new TypeError("Cannot call a class as a function");
  }
  function f(E, A) {
    for (var B = 0; B < A.length; B++) {
      var k = A[B];
      k.enumerable = k.enumerable || !1, k.configurable = !0, "value" in k && (k.writable = !0), Object.defineProperty(E, l(k.key), k);
    }
  }
  function a(E, A, B) {
    return A && f(E.prototype, A), Object.defineProperty(E, "prototype", { writable: !1 }), E;
  }
  function l(E) {
    var A = d(E, "string");
    return typeof A == "symbol" ? A : String(A);
  }
  function d(E, A) {
    if (typeof E != "object" || E === null)
      return E;
    var B = E[Symbol.toPrimitive];
    if (B !== void 0) {
      var k = B.call(E, A || "default");
      if (typeof k != "object")
        return k;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (A === "string" ? String : Number)(E);
  }
  var v = kr, m = v.Buffer, h = mc(), w = h.inspect, M = w && w.custom || "inspect";
  function S(E, A, B) {
    m.prototype.copy.call(E, A, B);
  }
  return mh = /* @__PURE__ */ function() {
    function E() {
      i(this, E), this.head = null, this.tail = null, this.length = 0;
    }
    return a(E, [{
      key: "push",
      value: function(B) {
        var k = {
          data: B,
          next: null
        };
        this.length > 0 ? this.tail.next = k : this.head = k, this.tail = k, ++this.length;
      }
    }, {
      key: "unshift",
      value: function(B) {
        var k = {
          data: B,
          next: this.head
        };
        this.length === 0 && (this.tail = k), this.head = k, ++this.length;
      }
    }, {
      key: "shift",
      value: function() {
        if (this.length !== 0) {
          var B = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, B;
        }
      }
    }, {
      key: "clear",
      value: function() {
        this.head = this.tail = null, this.length = 0;
      }
    }, {
      key: "join",
      value: function(B) {
        if (this.length === 0)
          return "";
        for (var k = this.head, C = "" + k.data; k = k.next; )
          C += B + k.data;
        return C;
      }
    }, {
      key: "concat",
      value: function(B) {
        if (this.length === 0)
          return m.alloc(0);
        for (var k = m.allocUnsafe(B >>> 0), C = this.head, I = 0; C; )
          S(C.data, k, I), I += C.data.length, C = C.next;
        return k;
      }
      // Consumes a specified amount of bytes or characters from the buffered data.
    }, {
      key: "consume",
      value: function(B, k) {
        var C;
        return B < this.head.data.length ? (C = this.head.data.slice(0, B), this.head.data = this.head.data.slice(B)) : B === this.head.data.length ? C = this.shift() : C = k ? this._getString(B) : this._getBuffer(B), C;
      }
    }, {
      key: "first",
      value: function() {
        return this.head.data;
      }
      // Consumes a specified amount of characters from the buffered data.
    }, {
      key: "_getString",
      value: function(B) {
        var k = this.head, C = 1, I = k.data;
        for (B -= I.length; k = k.next; ) {
          var O = k.data, q = B > O.length ? O.length : B;
          if (q === O.length ? I += O : I += O.slice(0, B), B -= q, B === 0) {
            q === O.length ? (++C, k.next ? this.head = k.next : this.head = this.tail = null) : (this.head = k, k.data = O.slice(q));
            break;
          }
          ++C;
        }
        return this.length -= C, I;
      }
      // Consumes a specified amount of bytes from the buffered data.
    }, {
      key: "_getBuffer",
      value: function(B) {
        var k = m.allocUnsafe(B), C = this.head, I = 1;
        for (C.data.copy(k), B -= C.data.length; C = C.next; ) {
          var O = C.data, q = B > O.length ? O.length : B;
          if (O.copy(k, k.length - B, 0, q), B -= q, B === 0) {
            q === O.length ? (++I, C.next ? this.head = C.next : this.head = this.tail = null) : (this.head = C, C.data = O.slice(q));
            break;
          }
          ++I;
        }
        return this.length -= I, k;
      }
      // Make sure the linked list only shows the minimal necessary information.
    }, {
      key: M,
      value: function(B, k) {
        return w(this, e(e({}, k), {}, {
          // Only inspect one level.
          depth: 0,
          // It should not recurse.
          customInspect: !1
        }));
      }
    }]), E;
  }(), mh;
}
var gh, Jb;
function C8() {
  if (Jb)
    return gh;
  Jb = 1;
  function t(l, d) {
    var v = this, m = this._readableState && this._readableState.destroyed, h = this._writableState && this._writableState.destroyed;
    return m || h ? (d ? d(l) : l && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, It.nextTick(f, this, l)) : It.nextTick(f, this, l)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(l || null, function(w) {
      !d && w ? v._writableState ? v._writableState.errorEmitted ? It.nextTick(r, v) : (v._writableState.errorEmitted = !0, It.nextTick(e, v, w)) : It.nextTick(e, v, w) : d ? (It.nextTick(r, v), d(w)) : It.nextTick(r, v);
    }), this);
  }
  function e(l, d) {
    f(l, d), r(l);
  }
  function r(l) {
    l._writableState && !l._writableState.emitClose || l._readableState && !l._readableState.emitClose || l.emit("close");
  }
  function i() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function f(l, d) {
    l.emit("error", d);
  }
  function a(l, d) {
    var v = l._readableState, m = l._writableState;
    v && v.autoDestroy || m && m.autoDestroy ? l.destroy(d) : l.emit("error", d);
  }
  return gh = {
    destroy: t,
    undestroy: i,
    errorOrDestroy: a
  }, gh;
}
var yh = {}, Xb;
function yo() {
  if (Xb)
    return yh;
  Xb = 1;
  function t(d, v) {
    d.prototype = Object.create(v.prototype), d.prototype.constructor = d, d.__proto__ = v;
  }
  var e = {};
  function r(d, v, m) {
    m || (m = Error);
    function h(M, S, E) {
      return typeof v == "string" ? v : v(M, S, E);
    }
    var w = /* @__PURE__ */ function(M) {
      t(S, M);
      function S(E, A, B) {
        return M.call(this, h(E, A, B)) || this;
      }
      return S;
    }(m);
    w.prototype.name = m.name, w.prototype.code = d, e[d] = w;
  }
  function i(d, v) {
    if (Array.isArray(d)) {
      var m = d.length;
      return d = d.map(function(h) {
        return String(h);
      }), m > 2 ? "one of ".concat(v, " ").concat(d.slice(0, m - 1).join(", "), ", or ") + d[m - 1] : m === 2 ? "one of ".concat(v, " ").concat(d[0], " or ").concat(d[1]) : "of ".concat(v, " ").concat(d[0]);
    } else
      return "of ".concat(v, " ").concat(String(d));
  }
  function f(d, v, m) {
    return d.substr(0, v.length) === v;
  }
  function a(d, v, m) {
    return (m === void 0 || m > d.length) && (m = d.length), d.substring(m - v.length, m) === v;
  }
  function l(d, v, m) {
    return typeof m != "number" && (m = 0), m + v.length > d.length ? !1 : d.indexOf(v, m) !== -1;
  }
  return r("ERR_INVALID_OPT_VALUE", function(d, v) {
    return 'The value "' + v + '" is invalid for option "' + d + '"';
  }, TypeError), r("ERR_INVALID_ARG_TYPE", function(d, v, m) {
    var h;
    typeof v == "string" && f(v, "not ") ? (h = "must not be", v = v.replace(/^not /, "")) : h = "must be";
    var w;
    if (a(d, " argument"))
      w = "The ".concat(d, " ").concat(h, " ").concat(i(v, "type"));
    else {
      var M = l(d, ".") ? "property" : "argument";
      w = 'The "'.concat(d, '" ').concat(M, " ").concat(h, " ").concat(i(v, "type"));
    }
    return w += ". Received type ".concat(typeof m), w;
  }, TypeError), r("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF"), r("ERR_METHOD_NOT_IMPLEMENTED", function(d) {
    return "The " + d + " method is not implemented";
  }), r("ERR_STREAM_PREMATURE_CLOSE", "Premature close"), r("ERR_STREAM_DESTROYED", function(d) {
    return "Cannot call " + d + " after a stream was destroyed";
  }), r("ERR_MULTIPLE_CALLBACK", "Callback called multiple times"), r("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable"), r("ERR_STREAM_WRITE_AFTER_END", "write after end"), r("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError), r("ERR_UNKNOWN_ENCODING", function(d) {
    return "Unknown encoding: " + d;
  }, TypeError), r("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event"), yh.codes = e, yh;
}
var bh, e2;
function B8() {
  if (e2)
    return bh;
  e2 = 1;
  var t = yo().codes.ERR_INVALID_OPT_VALUE;
  function e(i, f, a) {
    return i.highWaterMark != null ? i.highWaterMark : f ? i[a] : null;
  }
  function r(i, f, a, l) {
    var d = e(f, l, a);
    if (d != null) {
      if (!(isFinite(d) && Math.floor(d) === d) || d < 0) {
        var v = l ? a : "highWaterMark";
        throw new t(v, d);
      }
      return Math.floor(d);
    }
    return i.objectMode ? 16 : 16 * 1024;
  }
  return bh = {
    getHighWaterMark: r
  }, bh;
}
var wh, t2;
function I8() {
  if (t2)
    return wh;
  t2 = 1, wh = t;
  function t(r, i) {
    if (e("noDeprecation"))
      return r;
    var f = !1;
    function a() {
      if (!f) {
        if (e("throwDeprecation"))
          throw new Error(i);
        e("traceDeprecation") ? console.trace(i) : console.warn(i), f = !0;
      }
      return r.apply(this, arguments);
    }
    return a;
  }
  function e(r) {
    try {
      if (!ut.localStorage)
        return !1;
    } catch {
      return !1;
    }
    var i = ut.localStorage[r];
    return i == null ? !1 : String(i).toLowerCase() === "true";
  }
  return wh;
}
var _h, r2;
function mm() {
  if (r2)
    return _h;
  r2 = 1, _h = he;
  function t(Z) {
    var F = this;
    this.next = null, this.entry = null, this.finish = function() {
      J(F, Z);
    };
  }
  var e;
  he.WritableState = $;
  var r = {
    deprecate: I8()
  }, i = M8(), f = kr.Buffer, a = (typeof ut < "u" ? ut : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function l(Z) {
    return f.from(Z);
  }
  function d(Z) {
    return f.isBuffer(Z) || Z instanceof a;
  }
  var v = C8(), m = B8(), h = m.getHighWaterMark, w = yo().codes, M = w.ERR_INVALID_ARG_TYPE, S = w.ERR_METHOD_NOT_IMPLEMENTED, E = w.ERR_MULTIPLE_CALLBACK, A = w.ERR_STREAM_CANNOT_PIPE, B = w.ERR_STREAM_DESTROYED, k = w.ERR_STREAM_NULL_VALUES, C = w.ERR_STREAM_WRITE_AFTER_END, I = w.ERR_UNKNOWN_ENCODING, O = v.errorOrDestroy;
  Lt()(he, i);
  function q() {
  }
  function $(Z, F, ee) {
    e = e || za(), Z = Z || {}, typeof ee != "boolean" && (ee = F instanceof e), this.objectMode = !!Z.objectMode, ee && (this.objectMode = this.objectMode || !!Z.writableObjectMode), this.highWaterMark = h(this, Z, "writableHighWaterMark", ee), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var re = Z.decodeStrings === !1;
    this.decodeStrings = !re, this.defaultEncoding = Z.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(de) {
      g(F, de);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.emitClose = Z.emitClose !== !1, this.autoDestroy = !!Z.autoDestroy, this.bufferedRequestCount = 0, this.corkedRequestsFree = new t(this);
  }
  $.prototype.getBuffer = function() {
    for (var F = this.bufferedRequest, ee = []; F; )
      ee.push(F), F = F.next;
    return ee;
  }, function() {
    try {
      Object.defineProperty($.prototype, "buffer", {
        get: r.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var ae;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (ae = Function.prototype[Symbol.hasInstance], Object.defineProperty(he, Symbol.hasInstance, {
    value: function(F) {
      return ae.call(this, F) ? !0 : this !== he ? !1 : F && F._writableState instanceof $;
    }
  })) : ae = function(F) {
    return F instanceof this;
  };
  function he(Z) {
    e = e || za();
    var F = this instanceof e;
    if (!F && !ae.call(he, this))
      return new he(Z);
    this._writableState = new $(Z, this, F), this.writable = !0, Z && (typeof Z.write == "function" && (this._write = Z.write), typeof Z.writev == "function" && (this._writev = Z.writev), typeof Z.destroy == "function" && (this._destroy = Z.destroy), typeof Z.final == "function" && (this._final = Z.final)), i.call(this);
  }
  he.prototype.pipe = function() {
    O(this, new A());
  };
  function te(Z, F) {
    var ee = new C();
    O(Z, ee), It.nextTick(F, ee);
  }
  function Ee(Z, F, ee, re) {
    var de;
    return ee === null ? de = new k() : typeof ee != "string" && !F.objectMode && (de = new M("chunk", ["string", "Buffer"], ee)), de ? (O(Z, de), It.nextTick(re, de), !1) : !0;
  }
  he.prototype.write = function(Z, F, ee) {
    var re = this._writableState, de = !1, se = !re.objectMode && d(Z);
    return se && !f.isBuffer(Z) && (Z = l(Z)), typeof F == "function" && (ee = F, F = null), se ? F = "buffer" : F || (F = re.defaultEncoding), typeof ee != "function" && (ee = q), re.ending ? te(this, ee) : (se || Ee(this, re, Z, ee)) && (re.pendingcb++, de = n(this, re, se, Z, F, ee)), de;
  }, he.prototype.cork = function() {
    this._writableState.corked++;
  }, he.prototype.uncork = function() {
    var Z = this._writableState;
    Z.corked && (Z.corked--, !Z.writing && !Z.corked && !Z.bufferProcessing && Z.bufferedRequest && p(this, Z));
  }, he.prototype.setDefaultEncoding = function(F) {
    if (typeof F == "string" && (F = F.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((F + "").toLowerCase()) > -1))
      throw new I(F);
    return this._writableState.defaultEncoding = F, this;
  }, Object.defineProperty(he.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  });
  function x(Z, F, ee) {
    return !Z.objectMode && Z.decodeStrings !== !1 && typeof F == "string" && (F = f.from(F, ee)), F;
  }
  Object.defineProperty(he.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function n(Z, F, ee, re, de, se) {
    if (!ee) {
      var Q = x(F, re, de);
      re !== Q && (ee = !0, de = "buffer", re = Q);
    }
    var ge = F.objectMode ? 1 : re.length;
    F.length += ge;
    var Ye = F.length < F.highWaterMark;
    if (Ye || (F.needDrain = !0), F.writing || F.corked) {
      var Ce = F.lastBufferedRequest;
      F.lastBufferedRequest = {
        chunk: re,
        encoding: de,
        isBuf: ee,
        callback: se,
        next: null
      }, Ce ? Ce.next = F.lastBufferedRequest : F.bufferedRequest = F.lastBufferedRequest, F.bufferedRequestCount += 1;
    } else
      o(Z, F, !1, ge, re, de, se);
    return Ye;
  }
  function o(Z, F, ee, re, de, se, Q) {
    F.writelen = re, F.writecb = Q, F.writing = !0, F.sync = !0, F.destroyed ? F.onwrite(new B("write")) : ee ? Z._writev(de, F.onwrite) : Z._write(de, se, F.onwrite), F.sync = !1;
  }
  function u(Z, F, ee, re, de) {
    --F.pendingcb, ee ? (It.nextTick(de, re), It.nextTick(P, Z, F), Z._writableState.errorEmitted = !0, O(Z, re)) : (de(re), Z._writableState.errorEmitted = !0, O(Z, re), P(Z, F));
  }
  function c(Z) {
    Z.writing = !1, Z.writecb = null, Z.length -= Z.writelen, Z.writelen = 0;
  }
  function g(Z, F) {
    var ee = Z._writableState, re = ee.sync, de = ee.writecb;
    if (typeof de != "function")
      throw new E();
    if (c(ee), F)
      u(Z, ee, re, F, de);
    else {
      var se = s(ee) || Z.destroyed;
      !se && !ee.corked && !ee.bufferProcessing && ee.bufferedRequest && p(Z, ee), re ? It.nextTick(b, Z, ee, se, de) : b(Z, ee, se, de);
    }
  }
  function b(Z, F, ee, re) {
    ee || _(Z, F), F.pendingcb--, re(), P(Z, F);
  }
  function _(Z, F) {
    F.length === 0 && F.needDrain && (F.needDrain = !1, Z.emit("drain"));
  }
  function p(Z, F) {
    F.bufferProcessing = !0;
    var ee = F.bufferedRequest;
    if (Z._writev && ee && ee.next) {
      var re = F.bufferedRequestCount, de = new Array(re), se = F.corkedRequestsFree;
      se.entry = ee;
      for (var Q = 0, ge = !0; ee; )
        de[Q] = ee, ee.isBuf || (ge = !1), ee = ee.next, Q += 1;
      de.allBuffers = ge, o(Z, F, !0, F.length, de, "", se.finish), F.pendingcb++, F.lastBufferedRequest = null, se.next ? (F.corkedRequestsFree = se.next, se.next = null) : F.corkedRequestsFree = new t(F), F.bufferedRequestCount = 0;
    } else {
      for (; ee; ) {
        var Ye = ee.chunk, Ce = ee.encoding, Be = ee.callback, st = F.objectMode ? 1 : Ye.length;
        if (o(Z, F, !1, st, Ye, Ce, Be), ee = ee.next, F.bufferedRequestCount--, F.writing)
          break;
      }
      ee === null && (F.lastBufferedRequest = null);
    }
    F.bufferedRequest = ee, F.bufferProcessing = !1;
  }
  he.prototype._write = function(Z, F, ee) {
    ee(new S("_write()"));
  }, he.prototype._writev = null, he.prototype.end = function(Z, F, ee) {
    var re = this._writableState;
    return typeof Z == "function" ? (ee = Z, Z = null, F = null) : typeof F == "function" && (ee = F, F = null), Z != null && this.write(Z, F), re.corked && (re.corked = 1, this.uncork()), re.ending || z(this, re, ee), this;
  }, Object.defineProperty(he.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function s(Z) {
    return Z.ending && Z.length === 0 && Z.bufferedRequest === null && !Z.finished && !Z.writing;
  }
  function y(Z, F) {
    Z._final(function(ee) {
      F.pendingcb--, ee && O(Z, ee), F.prefinished = !0, Z.emit("prefinish"), P(Z, F);
    });
  }
  function T(Z, F) {
    !F.prefinished && !F.finalCalled && (typeof Z._final == "function" && !F.destroyed ? (F.pendingcb++, F.finalCalled = !0, It.nextTick(y, Z, F)) : (F.prefinished = !0, Z.emit("prefinish")));
  }
  function P(Z, F) {
    var ee = s(F);
    if (ee && (T(Z, F), F.pendingcb === 0 && (F.finished = !0, Z.emit("finish"), F.autoDestroy))) {
      var re = Z._readableState;
      (!re || re.autoDestroy && re.endEmitted) && Z.destroy();
    }
    return ee;
  }
  function z(Z, F, ee) {
    F.ending = !0, P(Z, F), ee && (F.finished ? It.nextTick(ee) : Z.once("finish", ee)), F.ended = !0, Z.writable = !1;
  }
  function J(Z, F, ee) {
    var re = Z.entry;
    for (Z.entry = null; re; ) {
      var de = re.callback;
      F.pendingcb--, de(ee), re = re.next;
    }
    F.corkedRequestsFree.next = Z;
  }
  return Object.defineProperty(he.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(F) {
      this._writableState && (this._writableState.destroyed = F);
    }
  }), he.prototype.destroy = v.destroy, he.prototype._undestroy = v.undestroy, he.prototype._destroy = function(Z, F) {
    F(Z);
  }, _h;
}
var xh, n2;
function za() {
  if (n2)
    return xh;
  n2 = 1;
  var t = Object.keys || function(m) {
    var h = [];
    for (var w in m)
      h.push(w);
    return h;
  };
  xh = l;
  var e = gm(), r = mm();
  Lt()(l, e);
  for (var i = t(r.prototype), f = 0; f < i.length; f++) {
    var a = i[f];
    l.prototype[a] || (l.prototype[a] = r.prototype[a]);
  }
  function l(m) {
    if (!(this instanceof l))
      return new l(m);
    e.call(this, m), r.call(this, m), this.allowHalfOpen = !0, m && (m.readable === !1 && (this.readable = !1), m.writable === !1 && (this.writable = !1), m.allowHalfOpen === !1 && (this.allowHalfOpen = !1, this.once("end", d)));
  }
  Object.defineProperty(l.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  }), Object.defineProperty(l.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState && this._writableState.getBuffer();
    }
  }), Object.defineProperty(l.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.length;
    }
  });
  function d() {
    this._writableState.ended || It.nextTick(v, this);
  }
  function v(m) {
    m.end();
  }
  return Object.defineProperty(l.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(h) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = h, this._writableState.destroyed = h);
    }
  }), xh;
}
var Mh = {}, i2;
function K1() {
  if (i2)
    return Mh;
  i2 = 1;
  var t = Vt().Buffer, e = t.isEncoding || function(k) {
    switch (k = "" + k, k && k.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function r(k) {
    if (!k)
      return "utf8";
    for (var C; ; )
      switch (k) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return k;
        default:
          if (C)
            return;
          k = ("" + k).toLowerCase(), C = !0;
      }
  }
  function i(k) {
    var C = r(k);
    if (typeof C != "string" && (t.isEncoding === e || !e(k)))
      throw new Error("Unknown encoding: " + k);
    return C || k;
  }
  Mh.StringDecoder = f;
  function f(k) {
    this.encoding = i(k);
    var C;
    switch (this.encoding) {
      case "utf16le":
        this.text = w, this.end = M, C = 4;
        break;
      case "utf8":
        this.fillLast = v, C = 4;
        break;
      case "base64":
        this.text = S, this.end = E, C = 3;
        break;
      default:
        this.write = A, this.end = B;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = t.allocUnsafe(C);
  }
  f.prototype.write = function(k) {
    if (k.length === 0)
      return "";
    var C, I;
    if (this.lastNeed) {
      if (C = this.fillLast(k), C === void 0)
        return "";
      I = this.lastNeed, this.lastNeed = 0;
    } else
      I = 0;
    return I < k.length ? C ? C + this.text(k, I) : this.text(k, I) : C || "";
  }, f.prototype.end = h, f.prototype.text = m, f.prototype.fillLast = function(k) {
    if (this.lastNeed <= k.length)
      return k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, k.length), this.lastNeed -= k.length;
  };
  function a(k) {
    return k <= 127 ? 0 : k >> 5 === 6 ? 2 : k >> 4 === 14 ? 3 : k >> 3 === 30 ? 4 : k >> 6 === 2 ? -1 : -2;
  }
  function l(k, C, I) {
    var O = C.length - 1;
    if (O < I)
      return 0;
    var q = a(C[O]);
    return q >= 0 ? (q > 0 && (k.lastNeed = q - 1), q) : --O < I || q === -2 ? 0 : (q = a(C[O]), q >= 0 ? (q > 0 && (k.lastNeed = q - 2), q) : --O < I || q === -2 ? 0 : (q = a(C[O]), q >= 0 ? (q > 0 && (q === 2 ? q = 0 : k.lastNeed = q - 3), q) : 0));
  }
  function d(k, C, I) {
    if ((C[0] & 192) !== 128)
      return k.lastNeed = 0, "�";
    if (k.lastNeed > 1 && C.length > 1) {
      if ((C[1] & 192) !== 128)
        return k.lastNeed = 1, "�";
      if (k.lastNeed > 2 && C.length > 2 && (C[2] & 192) !== 128)
        return k.lastNeed = 2, "�";
    }
  }
  function v(k) {
    var C = this.lastTotal - this.lastNeed, I = d(this, k);
    if (I !== void 0)
      return I;
    if (this.lastNeed <= k.length)
      return k.copy(this.lastChar, C, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    k.copy(this.lastChar, C, 0, k.length), this.lastNeed -= k.length;
  }
  function m(k, C) {
    var I = l(this, k, C);
    if (!this.lastNeed)
      return k.toString("utf8", C);
    this.lastTotal = I;
    var O = k.length - (I - this.lastNeed);
    return k.copy(this.lastChar, 0, O), k.toString("utf8", C, O);
  }
  function h(k) {
    var C = k && k.length ? this.write(k) : "";
    return this.lastNeed ? C + "�" : C;
  }
  function w(k, C) {
    if ((k.length - C) % 2 === 0) {
      var I = k.toString("utf16le", C);
      if (I) {
        var O = I.charCodeAt(I.length - 1);
        if (O >= 55296 && O <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1], I.slice(0, -1);
      }
      return I;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = k[k.length - 1], k.toString("utf16le", C, k.length - 1);
  }
  function M(k) {
    var C = k && k.length ? this.write(k) : "";
    if (this.lastNeed) {
      var I = this.lastTotal - this.lastNeed;
      return C + this.lastChar.toString("utf16le", 0, I);
    }
    return C;
  }
  function S(k, C) {
    var I = (k.length - C) % 3;
    return I === 0 ? k.toString("base64", C) : (this.lastNeed = 3 - I, this.lastTotal = 3, I === 1 ? this.lastChar[0] = k[k.length - 1] : (this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1]), k.toString("base64", C, k.length - I));
  }
  function E(k) {
    var C = k && k.length ? this.write(k) : "";
    return this.lastNeed ? C + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : C;
  }
  function A(k) {
    return k.toString(this.encoding);
  }
  function B(k) {
    return k && k.length ? this.write(k) : "";
  }
  return Mh;
}
var Sh, a2;
function gc() {
  if (a2)
    return Sh;
  a2 = 1;
  var t = yo().codes.ERR_STREAM_PREMATURE_CLOSE;
  function e(a) {
    var l = !1;
    return function() {
      if (!l) {
        l = !0;
        for (var d = arguments.length, v = new Array(d), m = 0; m < d; m++)
          v[m] = arguments[m];
        a.apply(this, v);
      }
    };
  }
  function r() {
  }
  function i(a) {
    return a.setHeader && typeof a.abort == "function";
  }
  function f(a, l, d) {
    if (typeof l == "function")
      return f(a, null, l);
    l || (l = {}), d = e(d || r);
    var v = l.readable || l.readable !== !1 && a.readable, m = l.writable || l.writable !== !1 && a.writable, h = function() {
      a.writable || M();
    }, w = a._writableState && a._writableState.finished, M = function() {
      m = !1, w = !0, v || d.call(a);
    }, S = a._readableState && a._readableState.endEmitted, E = function() {
      v = !1, S = !0, m || d.call(a);
    }, A = function(I) {
      d.call(a, I);
    }, B = function() {
      var I;
      if (v && !S)
        return (!a._readableState || !a._readableState.ended) && (I = new t()), d.call(a, I);
      if (m && !w)
        return (!a._writableState || !a._writableState.ended) && (I = new t()), d.call(a, I);
    }, k = function() {
      a.req.on("finish", M);
    };
    return i(a) ? (a.on("complete", M), a.on("abort", B), a.req ? k() : a.on("request", k)) : m && !a._writableState && (a.on("end", h), a.on("close", h)), a.on("end", E), a.on("finish", M), l.error !== !1 && a.on("error", A), a.on("close", B), function() {
      a.removeListener("complete", M), a.removeListener("abort", B), a.removeListener("request", k), a.req && a.req.removeListener("finish", M), a.removeListener("end", h), a.removeListener("close", h), a.removeListener("finish", M), a.removeListener("end", E), a.removeListener("error", A), a.removeListener("close", B);
    };
  }
  return Sh = f, Sh;
}
var Eh, s2;
function _B() {
  if (s2)
    return Eh;
  s2 = 1;
  var t;
  function e(I, O, q) {
    return O = r(O), O in I ? Object.defineProperty(I, O, { value: q, enumerable: !0, configurable: !0, writable: !0 }) : I[O] = q, I;
  }
  function r(I) {
    var O = i(I, "string");
    return typeof O == "symbol" ? O : String(O);
  }
  function i(I, O) {
    if (typeof I != "object" || I === null)
      return I;
    var q = I[Symbol.toPrimitive];
    if (q !== void 0) {
      var $ = q.call(I, O || "default");
      if (typeof $ != "object")
        return $;
      throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (O === "string" ? String : Number)(I);
  }
  var f = gc(), a = Symbol("lastResolve"), l = Symbol("lastReject"), d = Symbol("error"), v = Symbol("ended"), m = Symbol("lastPromise"), h = Symbol("handlePromise"), w = Symbol("stream");
  function M(I, O) {
    return {
      value: I,
      done: O
    };
  }
  function S(I) {
    var O = I[a];
    if (O !== null) {
      var q = I[w].read();
      q !== null && (I[m] = null, I[a] = null, I[l] = null, O(M(q, !1)));
    }
  }
  function E(I) {
    It.nextTick(S, I);
  }
  function A(I, O) {
    return function(q, $) {
      I.then(function() {
        if (O[v]) {
          q(M(void 0, !0));
          return;
        }
        O[h](q, $);
      }, $);
    };
  }
  var B = Object.getPrototypeOf(function() {
  }), k = Object.setPrototypeOf((t = {
    get stream() {
      return this[w];
    },
    next: function() {
      var O = this, q = this[d];
      if (q !== null)
        return Promise.reject(q);
      if (this[v])
        return Promise.resolve(M(void 0, !0));
      if (this[w].destroyed)
        return new Promise(function(te, Ee) {
          It.nextTick(function() {
            O[d] ? Ee(O[d]) : te(M(void 0, !0));
          });
        });
      var $ = this[m], ae;
      if ($)
        ae = new Promise(A($, this));
      else {
        var he = this[w].read();
        if (he !== null)
          return Promise.resolve(M(he, !1));
        ae = new Promise(this[h]);
      }
      return this[m] = ae, ae;
    }
  }, e(t, Symbol.asyncIterator, function() {
    return this;
  }), e(t, "return", function() {
    var O = this;
    return new Promise(function(q, $) {
      O[w].destroy(null, function(ae) {
        if (ae) {
          $(ae);
          return;
        }
        q(M(void 0, !0));
      });
    });
  }), t), B), C = function(O) {
    var q, $ = Object.create(k, (q = {}, e(q, w, {
      value: O,
      writable: !0
    }), e(q, a, {
      value: null,
      writable: !0
    }), e(q, l, {
      value: null,
      writable: !0
    }), e(q, d, {
      value: null,
      writable: !0
    }), e(q, v, {
      value: O._readableState.endEmitted,
      writable: !0
    }), e(q, h, {
      value: function(he, te) {
        var Ee = $[w].read();
        Ee ? ($[m] = null, $[a] = null, $[l] = null, he(M(Ee, !1))) : ($[a] = he, $[l] = te);
      },
      writable: !0
    }), q));
    return $[m] = null, f(O, function(ae) {
      if (ae && ae.code !== "ERR_STREAM_PREMATURE_CLOSE") {
        var he = $[l];
        he !== null && ($[m] = null, $[a] = null, $[l] = null, he(ae)), $[d] = ae;
        return;
      }
      var te = $[a];
      te !== null && ($[m] = null, $[a] = null, $[l] = null, te(M(void 0, !0))), $[v] = !0;
    }), O.on("readable", E.bind(null, $)), $;
  };
  return Eh = C, Eh;
}
var Ah, o2;
function xB() {
  return o2 || (o2 = 1, Ah = function() {
    throw new Error("Readable.from is not available in the browser");
  }), Ah;
}
var kh, f2;
function gm() {
  if (f2)
    return kh;
  f2 = 1, kh = te;
  var t;
  te.ReadableState = he, $f().EventEmitter;
  var e = function(Q, ge) {
    return Q.listeners(ge).length;
  }, r = M8(), i = kr.Buffer, f = (typeof ut < "u" ? ut : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function a(se) {
    return i.from(se);
  }
  function l(se) {
    return i.isBuffer(se) || se instanceof f;
  }
  var d = mc(), v;
  d && d.debuglog ? v = d.debuglog("stream") : v = function() {
  };
  var m = wB(), h = C8(), w = B8(), M = w.getHighWaterMark, S = yo().codes, E = S.ERR_INVALID_ARG_TYPE, A = S.ERR_STREAM_PUSH_AFTER_EOF, B = S.ERR_METHOD_NOT_IMPLEMENTED, k = S.ERR_STREAM_UNSHIFT_AFTER_END_EVENT, C, I, O;
  Lt()(te, r);
  var q = h.errorOrDestroy, $ = ["error", "close", "destroy", "pause", "resume"];
  function ae(se, Q, ge) {
    if (typeof se.prependListener == "function")
      return se.prependListener(Q, ge);
    !se._events || !se._events[Q] ? se.on(Q, ge) : Array.isArray(se._events[Q]) ? se._events[Q].unshift(ge) : se._events[Q] = [ge, se._events[Q]];
  }
  function he(se, Q, ge) {
    t = t || za(), se = se || {}, typeof ge != "boolean" && (ge = Q instanceof t), this.objectMode = !!se.objectMode, ge && (this.objectMode = this.objectMode || !!se.readableObjectMode), this.highWaterMark = M(this, se, "readableHighWaterMark", ge), this.buffer = new m(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.paused = !0, this.emitClose = se.emitClose !== !1, this.autoDestroy = !!se.autoDestroy, this.destroyed = !1, this.defaultEncoding = se.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, se.encoding && (C || (C = K1().StringDecoder), this.decoder = new C(se.encoding), this.encoding = se.encoding);
  }
  function te(se) {
    if (t = t || za(), !(this instanceof te))
      return new te(se);
    var Q = this instanceof t;
    this._readableState = new he(se, this, Q), this.readable = !0, se && (typeof se.read == "function" && (this._read = se.read), typeof se.destroy == "function" && (this._destroy = se.destroy)), r.call(this);
  }
  Object.defineProperty(te.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(Q) {
      this._readableState && (this._readableState.destroyed = Q);
    }
  }), te.prototype.destroy = h.destroy, te.prototype._undestroy = h.undestroy, te.prototype._destroy = function(se, Q) {
    Q(se);
  }, te.prototype.push = function(se, Q) {
    var ge = this._readableState, Ye;
    return ge.objectMode ? Ye = !0 : typeof se == "string" && (Q = Q || ge.defaultEncoding, Q !== ge.encoding && (se = i.from(se, Q), Q = ""), Ye = !0), Ee(this, se, Q, !1, Ye);
  }, te.prototype.unshift = function(se) {
    return Ee(this, se, null, !0, !1);
  };
  function Ee(se, Q, ge, Ye, Ce) {
    v("readableAddChunk", Q);
    var Be = se._readableState;
    if (Q === null)
      Be.reading = !1, g(se, Be);
    else {
      var st;
      if (Ce || (st = n(Be, Q)), st)
        q(se, st);
      else if (Be.objectMode || Q && Q.length > 0)
        if (typeof Q != "string" && !Be.objectMode && Object.getPrototypeOf(Q) !== i.prototype && (Q = a(Q)), Ye)
          Be.endEmitted ? q(se, new k()) : x(se, Be, Q, !0);
        else if (Be.ended)
          q(se, new A());
        else {
          if (Be.destroyed)
            return !1;
          Be.reading = !1, Be.decoder && !ge ? (Q = Be.decoder.write(Q), Be.objectMode || Q.length !== 0 ? x(se, Be, Q, !1) : p(se, Be)) : x(se, Be, Q, !1);
        }
      else
        Ye || (Be.reading = !1, p(se, Be));
    }
    return !Be.ended && (Be.length < Be.highWaterMark || Be.length === 0);
  }
  function x(se, Q, ge, Ye) {
    Q.flowing && Q.length === 0 && !Q.sync ? (Q.awaitDrain = 0, se.emit("data", ge)) : (Q.length += Q.objectMode ? 1 : ge.length, Ye ? Q.buffer.unshift(ge) : Q.buffer.push(ge), Q.needReadable && b(se)), p(se, Q);
  }
  function n(se, Q) {
    var ge;
    return !l(Q) && typeof Q != "string" && Q !== void 0 && !se.objectMode && (ge = new E("chunk", ["string", "Buffer", "Uint8Array"], Q)), ge;
  }
  te.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, te.prototype.setEncoding = function(se) {
    C || (C = K1().StringDecoder);
    var Q = new C(se);
    this._readableState.decoder = Q, this._readableState.encoding = this._readableState.decoder.encoding;
    for (var ge = this._readableState.buffer.head, Ye = ""; ge !== null; )
      Ye += Q.write(ge.data), ge = ge.next;
    return this._readableState.buffer.clear(), Ye !== "" && this._readableState.buffer.push(Ye), this._readableState.length = Ye.length, this;
  };
  var o = 1073741824;
  function u(se) {
    return se >= o ? se = o : (se--, se |= se >>> 1, se |= se >>> 2, se |= se >>> 4, se |= se >>> 8, se |= se >>> 16, se++), se;
  }
  function c(se, Q) {
    return se <= 0 || Q.length === 0 && Q.ended ? 0 : Q.objectMode ? 1 : se !== se ? Q.flowing && Q.length ? Q.buffer.head.data.length : Q.length : (se > Q.highWaterMark && (Q.highWaterMark = u(se)), se <= Q.length ? se : Q.ended ? Q.length : (Q.needReadable = !0, 0));
  }
  te.prototype.read = function(se) {
    v("read", se), se = parseInt(se, 10);
    var Q = this._readableState, ge = se;
    if (se !== 0 && (Q.emittedReadable = !1), se === 0 && Q.needReadable && ((Q.highWaterMark !== 0 ? Q.length >= Q.highWaterMark : Q.length > 0) || Q.ended))
      return v("read: emitReadable", Q.length, Q.ended), Q.length === 0 && Q.ended ? ee(this) : b(this), null;
    if (se = c(se, Q), se === 0 && Q.ended)
      return Q.length === 0 && ee(this), null;
    var Ye = Q.needReadable;
    v("need readable", Ye), (Q.length === 0 || Q.length - se < Q.highWaterMark) && (Ye = !0, v("length less than watermark", Ye)), Q.ended || Q.reading ? (Ye = !1, v("reading or ended", Ye)) : Ye && (v("do read"), Q.reading = !0, Q.sync = !0, Q.length === 0 && (Q.needReadable = !0), this._read(Q.highWaterMark), Q.sync = !1, Q.reading || (se = c(ge, Q)));
    var Ce;
    return se > 0 ? Ce = F(se, Q) : Ce = null, Ce === null ? (Q.needReadable = Q.length <= Q.highWaterMark, se = 0) : (Q.length -= se, Q.awaitDrain = 0), Q.length === 0 && (Q.ended || (Q.needReadable = !0), ge !== se && Q.ended && ee(this)), Ce !== null && this.emit("data", Ce), Ce;
  };
  function g(se, Q) {
    if (v("onEofChunk"), !Q.ended) {
      if (Q.decoder) {
        var ge = Q.decoder.end();
        ge && ge.length && (Q.buffer.push(ge), Q.length += Q.objectMode ? 1 : ge.length);
      }
      Q.ended = !0, Q.sync ? b(se) : (Q.needReadable = !1, Q.emittedReadable || (Q.emittedReadable = !0, _(se)));
    }
  }
  function b(se) {
    var Q = se._readableState;
    v("emitReadable", Q.needReadable, Q.emittedReadable), Q.needReadable = !1, Q.emittedReadable || (v("emitReadable", Q.flowing), Q.emittedReadable = !0, It.nextTick(_, se));
  }
  function _(se) {
    var Q = se._readableState;
    v("emitReadable_", Q.destroyed, Q.length, Q.ended), !Q.destroyed && (Q.length || Q.ended) && (se.emit("readable"), Q.emittedReadable = !1), Q.needReadable = !Q.flowing && !Q.ended && Q.length <= Q.highWaterMark, Z(se);
  }
  function p(se, Q) {
    Q.readingMore || (Q.readingMore = !0, It.nextTick(s, se, Q));
  }
  function s(se, Q) {
    for (; !Q.reading && !Q.ended && (Q.length < Q.highWaterMark || Q.flowing && Q.length === 0); ) {
      var ge = Q.length;
      if (v("maybeReadMore read 0"), se.read(0), ge === Q.length)
        break;
    }
    Q.readingMore = !1;
  }
  te.prototype._read = function(se) {
    q(this, new B("_read()"));
  }, te.prototype.pipe = function(se, Q) {
    var ge = this, Ye = this._readableState;
    switch (Ye.pipesCount) {
      case 0:
        Ye.pipes = se;
        break;
      case 1:
        Ye.pipes = [Ye.pipes, se];
        break;
      default:
        Ye.pipes.push(se);
        break;
    }
    Ye.pipesCount += 1, v("pipe count=%d opts=%j", Ye.pipesCount, Q);
    var Ce = (!Q || Q.end !== !1) && se !== It.stdout && se !== It.stderr, Be = Ce ? De : le;
    Ye.endEmitted ? It.nextTick(Be) : ge.once("end", Be), se.on("unpipe", st);
    function st(ie, fe) {
      v("onunpipe"), ie === ge && fe && fe.hasUnpiped === !1 && (fe.hasUnpiped = !0, Oe());
    }
    function De() {
      v("onend"), se.end();
    }
    var _e = y(ge);
    se.on("drain", _e);
    var St = !1;
    function Oe() {
      v("cleanup"), se.removeListener("close", Ue), se.removeListener("finish", oe), se.removeListener("drain", _e), se.removeListener("error", Et), se.removeListener("unpipe", st), ge.removeListener("end", De), ge.removeListener("end", le), ge.removeListener("data", Fe), St = !0, Ye.awaitDrain && (!se._writableState || se._writableState.needDrain) && _e();
    }
    ge.on("data", Fe);
    function Fe(ie) {
      v("ondata");
      var fe = se.write(ie);
      v("dest.write", fe), fe === !1 && ((Ye.pipesCount === 1 && Ye.pipes === se || Ye.pipesCount > 1 && de(Ye.pipes, se) !== -1) && !St && (v("false write response, pause", Ye.awaitDrain), Ye.awaitDrain++), ge.pause());
    }
    function Et(ie) {
      v("onerror", ie), le(), se.removeListener("error", Et), e(se, "error") === 0 && q(se, ie);
    }
    ae(se, "error", Et);
    function Ue() {
      se.removeListener("finish", oe), le();
    }
    se.once("close", Ue);
    function oe() {
      v("onfinish"), se.removeListener("close", Ue), le();
    }
    se.once("finish", oe);
    function le() {
      v("unpipe"), ge.unpipe(se);
    }
    return se.emit("pipe", ge), Ye.flowing || (v("pipe resume"), ge.resume()), se;
  };
  function y(se) {
    return function() {
      var ge = se._readableState;
      v("pipeOnDrain", ge.awaitDrain), ge.awaitDrain && ge.awaitDrain--, ge.awaitDrain === 0 && e(se, "data") && (ge.flowing = !0, Z(se));
    };
  }
  te.prototype.unpipe = function(se) {
    var Q = this._readableState, ge = {
      hasUnpiped: !1
    };
    if (Q.pipesCount === 0)
      return this;
    if (Q.pipesCount === 1)
      return se && se !== Q.pipes ? this : (se || (se = Q.pipes), Q.pipes = null, Q.pipesCount = 0, Q.flowing = !1, se && se.emit("unpipe", this, ge), this);
    if (!se) {
      var Ye = Q.pipes, Ce = Q.pipesCount;
      Q.pipes = null, Q.pipesCount = 0, Q.flowing = !1;
      for (var Be = 0; Be < Ce; Be++)
        Ye[Be].emit("unpipe", this, {
          hasUnpiped: !1
        });
      return this;
    }
    var st = de(Q.pipes, se);
    return st === -1 ? this : (Q.pipes.splice(st, 1), Q.pipesCount -= 1, Q.pipesCount === 1 && (Q.pipes = Q.pipes[0]), se.emit("unpipe", this, ge), this);
  }, te.prototype.on = function(se, Q) {
    var ge = r.prototype.on.call(this, se, Q), Ye = this._readableState;
    return se === "data" ? (Ye.readableListening = this.listenerCount("readable") > 0, Ye.flowing !== !1 && this.resume()) : se === "readable" && !Ye.endEmitted && !Ye.readableListening && (Ye.readableListening = Ye.needReadable = !0, Ye.flowing = !1, Ye.emittedReadable = !1, v("on readable", Ye.length, Ye.reading), Ye.length ? b(this) : Ye.reading || It.nextTick(P, this)), ge;
  }, te.prototype.addListener = te.prototype.on, te.prototype.removeListener = function(se, Q) {
    var ge = r.prototype.removeListener.call(this, se, Q);
    return se === "readable" && It.nextTick(T, this), ge;
  }, te.prototype.removeAllListeners = function(se) {
    var Q = r.prototype.removeAllListeners.apply(this, arguments);
    return (se === "readable" || se === void 0) && It.nextTick(T, this), Q;
  };
  function T(se) {
    var Q = se._readableState;
    Q.readableListening = se.listenerCount("readable") > 0, Q.resumeScheduled && !Q.paused ? Q.flowing = !0 : se.listenerCount("data") > 0 && se.resume();
  }
  function P(se) {
    v("readable nexttick read 0"), se.read(0);
  }
  te.prototype.resume = function() {
    var se = this._readableState;
    return se.flowing || (v("resume"), se.flowing = !se.readableListening, z(this, se)), se.paused = !1, this;
  };
  function z(se, Q) {
    Q.resumeScheduled || (Q.resumeScheduled = !0, It.nextTick(J, se, Q));
  }
  function J(se, Q) {
    v("resume", Q.reading), Q.reading || se.read(0), Q.resumeScheduled = !1, se.emit("resume"), Z(se), Q.flowing && !Q.reading && se.read(0);
  }
  te.prototype.pause = function() {
    return v("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (v("pause"), this._readableState.flowing = !1, this.emit("pause")), this._readableState.paused = !0, this;
  };
  function Z(se) {
    var Q = se._readableState;
    for (v("flow", Q.flowing); Q.flowing && se.read() !== null; )
      ;
  }
  te.prototype.wrap = function(se) {
    var Q = this, ge = this._readableState, Ye = !1;
    se.on("end", function() {
      if (v("wrapped end"), ge.decoder && !ge.ended) {
        var st = ge.decoder.end();
        st && st.length && Q.push(st);
      }
      Q.push(null);
    }), se.on("data", function(st) {
      if (v("wrapped data"), ge.decoder && (st = ge.decoder.write(st)), !(ge.objectMode && st == null) && !(!ge.objectMode && (!st || !st.length))) {
        var De = Q.push(st);
        De || (Ye = !0, se.pause());
      }
    });
    for (var Ce in se)
      this[Ce] === void 0 && typeof se[Ce] == "function" && (this[Ce] = /* @__PURE__ */ function(De) {
        return function() {
          return se[De].apply(se, arguments);
        };
      }(Ce));
    for (var Be = 0; Be < $.length; Be++)
      se.on($[Be], this.emit.bind(this, $[Be]));
    return this._read = function(st) {
      v("wrapped _read", st), Ye && (Ye = !1, se.resume());
    }, this;
  }, typeof Symbol == "function" && (te.prototype[Symbol.asyncIterator] = function() {
    return I === void 0 && (I = _B()), I(this);
  }), Object.defineProperty(te.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), Object.defineProperty(te.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState && this._readableState.buffer;
    }
  }), Object.defineProperty(te.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.flowing;
    },
    set: function(Q) {
      this._readableState && (this._readableState.flowing = Q);
    }
  }), te._fromList = F, Object.defineProperty(te.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.length;
    }
  });
  function F(se, Q) {
    if (Q.length === 0)
      return null;
    var ge;
    return Q.objectMode ? ge = Q.buffer.shift() : !se || se >= Q.length ? (Q.decoder ? ge = Q.buffer.join("") : Q.buffer.length === 1 ? ge = Q.buffer.first() : ge = Q.buffer.concat(Q.length), Q.buffer.clear()) : ge = Q.buffer.consume(se, Q.decoder), ge;
  }
  function ee(se) {
    var Q = se._readableState;
    v("endReadable", Q.endEmitted), Q.endEmitted || (Q.ended = !0, It.nextTick(re, Q, se));
  }
  function re(se, Q) {
    if (v("endReadableNT", se.endEmitted, se.length), !se.endEmitted && se.length === 0 && (se.endEmitted = !0, Q.readable = !1, Q.emit("end"), se.autoDestroy)) {
      var ge = Q._writableState;
      (!ge || ge.autoDestroy && ge.finished) && Q.destroy();
    }
  }
  typeof Symbol == "function" && (te.from = function(se, Q) {
    return O === void 0 && (O = xB()), O(te, se, Q);
  });
  function de(se, Q) {
    for (var ge = 0, Ye = se.length; ge < Ye; ge++)
      if (se[ge] === Q)
        return ge;
    return -1;
  }
  return kh;
}
var Th, u2;
function ym() {
  if (u2)
    return Th;
  u2 = 1, Th = d;
  var t = yo().codes, e = t.ERR_METHOD_NOT_IMPLEMENTED, r = t.ERR_MULTIPLE_CALLBACK, i = t.ERR_TRANSFORM_ALREADY_TRANSFORMING, f = t.ERR_TRANSFORM_WITH_LENGTH_0, a = za();
  Lt()(d, a);
  function l(h, w) {
    var M = this._transformState;
    M.transforming = !1;
    var S = M.writecb;
    if (S === null)
      return this.emit("error", new r());
    M.writechunk = null, M.writecb = null, w != null && this.push(w), S(h);
    var E = this._readableState;
    E.reading = !1, (E.needReadable || E.length < E.highWaterMark) && this._read(E.highWaterMark);
  }
  function d(h) {
    if (!(this instanceof d))
      return new d(h);
    a.call(this, h), this._transformState = {
      afterTransform: l.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, h && (typeof h.transform == "function" && (this._transform = h.transform), typeof h.flush == "function" && (this._flush = h.flush)), this.on("prefinish", v);
  }
  function v() {
    var h = this;
    typeof this._flush == "function" && !this._readableState.destroyed ? this._flush(function(w, M) {
      m(h, w, M);
    }) : m(this, null, null);
  }
  d.prototype.push = function(h, w) {
    return this._transformState.needTransform = !1, a.prototype.push.call(this, h, w);
  }, d.prototype._transform = function(h, w, M) {
    M(new e("_transform()"));
  }, d.prototype._write = function(h, w, M) {
    var S = this._transformState;
    if (S.writecb = M, S.writechunk = h, S.writeencoding = w, !S.transforming) {
      var E = this._readableState;
      (S.needTransform || E.needReadable || E.length < E.highWaterMark) && this._read(E.highWaterMark);
    }
  }, d.prototype._read = function(h) {
    var w = this._transformState;
    w.writechunk !== null && !w.transforming ? (w.transforming = !0, this._transform(w.writechunk, w.writeencoding, w.afterTransform)) : w.needTransform = !0;
  }, d.prototype._destroy = function(h, w) {
    a.prototype._destroy.call(this, h, function(M) {
      w(M);
    });
  };
  function m(h, w, M) {
    if (w)
      return h.emit("error", w);
    if (M != null && h.push(M), h._writableState.length)
      throw new f();
    if (h._transformState.transforming)
      throw new i();
    return h.push(null);
  }
  return Th;
}
var Ch, l2;
function R8() {
  if (l2)
    return Ch;
  l2 = 1, Ch = e;
  var t = ym();
  Lt()(e, t);
  function e(r) {
    if (!(this instanceof e))
      return new e(r);
    t.call(this, r);
  }
  return e.prototype._transform = function(r, i, f) {
    f(null, r);
  }, Ch;
}
var Bh, c2;
function P8() {
  if (c2)
    return Bh;
  c2 = 1;
  var t;
  function e(M) {
    var S = !1;
    return function() {
      S || (S = !0, M.apply(void 0, arguments));
    };
  }
  var r = yo().codes, i = r.ERR_MISSING_ARGS, f = r.ERR_STREAM_DESTROYED;
  function a(M) {
    if (M)
      throw M;
  }
  function l(M) {
    return M.setHeader && typeof M.abort == "function";
  }
  function d(M, S, E, A) {
    A = e(A);
    var B = !1;
    M.on("close", function() {
      B = !0;
    }), t === void 0 && (t = gc()), t(M, {
      readable: S,
      writable: E
    }, function(C) {
      if (C)
        return A(C);
      B = !0, A();
    });
    var k = !1;
    return function(C) {
      if (!B && !k) {
        if (k = !0, l(M))
          return M.abort();
        if (typeof M.destroy == "function")
          return M.destroy();
        A(C || new f("pipe"));
      }
    };
  }
  function v(M) {
    M();
  }
  function m(M, S) {
    return M.pipe(S);
  }
  function h(M) {
    return !M.length || typeof M[M.length - 1] != "function" ? a : M.pop();
  }
  function w() {
    for (var M = arguments.length, S = new Array(M), E = 0; E < M; E++)
      S[E] = arguments[E];
    var A = h(S);
    if (Array.isArray(S[0]) && (S = S[0]), S.length < 2)
      throw new i("streams");
    var B, k = S.map(function(C, I) {
      var O = I < S.length - 1, q = I > 0;
      return d(C, O, q, function($) {
        B || (B = $), $ && k.forEach(v), !O && (k.forEach(v), A(B));
      });
    });
    return S.reduce(m);
  }
  return Bh = w, Bh;
}
var d2;
function MB() {
  return d2 || (d2 = 1, function(t, e) {
    e = t.exports = gm(), e.Stream = e, e.Readable = e, e.Writable = mm(), e.Duplex = za(), e.Transform = ym(), e.PassThrough = R8(), e.finished = gc(), e.pipeline = P8();
  }(mu, mu.exports)), mu.exports;
}
var Ih, h2;
function O8() {
  if (h2)
    return Ih;
  h2 = 1;
  var t = Vt().Buffer, e = MB().Transform, r = Lt();
  function i(a, l) {
    if (!t.isBuffer(a) && typeof a != "string")
      throw new TypeError(l + " must be a string or a buffer");
  }
  function f(a) {
    e.call(this), this._block = t.allocUnsafe(a), this._blockSize = a, this._blockOffset = 0, this._length = [0, 0, 0, 0], this._finalized = !1;
  }
  return r(f, e), f.prototype._transform = function(a, l, d) {
    var v = null;
    try {
      this.update(a, l);
    } catch (m) {
      v = m;
    }
    d(v);
  }, f.prototype._flush = function(a) {
    var l = null;
    try {
      this.push(this.digest());
    } catch (d) {
      l = d;
    }
    a(l);
  }, f.prototype.update = function(a, l) {
    if (i(a, "Data"), this._finalized)
      throw new Error("Digest already called");
    t.isBuffer(a) || (a = t.from(a, l));
    for (var d = this._block, v = 0; this._blockOffset + a.length - v >= this._blockSize; ) {
      for (var m = this._blockOffset; m < this._blockSize; )
        d[m++] = a[v++];
      this._update(), this._blockOffset = 0;
    }
    for (; v < a.length; )
      d[this._blockOffset++] = a[v++];
    for (var h = 0, w = a.length * 8; w > 0; ++h)
      this._length[h] += w, w = this._length[h] / 4294967296 | 0, w > 0 && (this._length[h] -= 4294967296 * w);
    return this;
  }, f.prototype._update = function() {
    throw new Error("_update is not implemented");
  }, f.prototype.digest = function(a) {
    if (this._finalized)
      throw new Error("Digest already called");
    this._finalized = !0;
    var l = this._digest();
    a !== void 0 && (l = l.toString(a)), this._block.fill(0), this._blockOffset = 0;
    for (var d = 0; d < 4; ++d)
      this._length[d] = 0;
    return l;
  }, f.prototype._digest = function() {
    throw new Error("_digest is not implemented");
  }, Ih = f, Ih;
}
var Rh, p2;
function bm() {
  if (p2)
    return Rh;
  p2 = 1;
  var t = Lt(), e = O8(), r = Vt().Buffer, i = new Array(16);
  function f() {
    e.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878;
  }
  t(f, e), f.prototype._update = function() {
    for (var h = i, w = 0; w < 16; ++w)
      h[w] = this._block.readInt32LE(w * 4);
    var M = this._a, S = this._b, E = this._c, A = this._d;
    M = l(M, S, E, A, h[0], 3614090360, 7), A = l(A, M, S, E, h[1], 3905402710, 12), E = l(E, A, M, S, h[2], 606105819, 17), S = l(S, E, A, M, h[3], 3250441966, 22), M = l(M, S, E, A, h[4], 4118548399, 7), A = l(A, M, S, E, h[5], 1200080426, 12), E = l(E, A, M, S, h[6], 2821735955, 17), S = l(S, E, A, M, h[7], 4249261313, 22), M = l(M, S, E, A, h[8], 1770035416, 7), A = l(A, M, S, E, h[9], 2336552879, 12), E = l(E, A, M, S, h[10], 4294925233, 17), S = l(S, E, A, M, h[11], 2304563134, 22), M = l(M, S, E, A, h[12], 1804603682, 7), A = l(A, M, S, E, h[13], 4254626195, 12), E = l(E, A, M, S, h[14], 2792965006, 17), S = l(S, E, A, M, h[15], 1236535329, 22), M = d(M, S, E, A, h[1], 4129170786, 5), A = d(A, M, S, E, h[6], 3225465664, 9), E = d(E, A, M, S, h[11], 643717713, 14), S = d(S, E, A, M, h[0], 3921069994, 20), M = d(M, S, E, A, h[5], 3593408605, 5), A = d(A, M, S, E, h[10], 38016083, 9), E = d(E, A, M, S, h[15], 3634488961, 14), S = d(S, E, A, M, h[4], 3889429448, 20), M = d(M, S, E, A, h[9], 568446438, 5), A = d(A, M, S, E, h[14], 3275163606, 9), E = d(E, A, M, S, h[3], 4107603335, 14), S = d(S, E, A, M, h[8], 1163531501, 20), M = d(M, S, E, A, h[13], 2850285829, 5), A = d(A, M, S, E, h[2], 4243563512, 9), E = d(E, A, M, S, h[7], 1735328473, 14), S = d(S, E, A, M, h[12], 2368359562, 20), M = v(M, S, E, A, h[5], 4294588738, 4), A = v(A, M, S, E, h[8], 2272392833, 11), E = v(E, A, M, S, h[11], 1839030562, 16), S = v(S, E, A, M, h[14], 4259657740, 23), M = v(M, S, E, A, h[1], 2763975236, 4), A = v(A, M, S, E, h[4], 1272893353, 11), E = v(E, A, M, S, h[7], 4139469664, 16), S = v(S, E, A, M, h[10], 3200236656, 23), M = v(M, S, E, A, h[13], 681279174, 4), A = v(A, M, S, E, h[0], 3936430074, 11), E = v(E, A, M, S, h[3], 3572445317, 16), S = v(S, E, A, M, h[6], 76029189, 23), M = v(M, S, E, A, h[9], 3654602809, 4), A = v(A, M, S, E, h[12], 3873151461, 11), E = v(E, A, M, S, h[15], 530742520, 16), S = v(S, E, A, M, h[2], 3299628645, 23), M = m(M, S, E, A, h[0], 4096336452, 6), A = m(A, M, S, E, h[7], 1126891415, 10), E = m(E, A, M, S, h[14], 2878612391, 15), S = m(S, E, A, M, h[5], 4237533241, 21), M = m(M, S, E, A, h[12], 1700485571, 6), A = m(A, M, S, E, h[3], 2399980690, 10), E = m(E, A, M, S, h[10], 4293915773, 15), S = m(S, E, A, M, h[1], 2240044497, 21), M = m(M, S, E, A, h[8], 1873313359, 6), A = m(A, M, S, E, h[15], 4264355552, 10), E = m(E, A, M, S, h[6], 2734768916, 15), S = m(S, E, A, M, h[13], 1309151649, 21), M = m(M, S, E, A, h[4], 4149444226, 6), A = m(A, M, S, E, h[11], 3174756917, 10), E = m(E, A, M, S, h[2], 718787259, 15), S = m(S, E, A, M, h[9], 3951481745, 21), this._a = this._a + M | 0, this._b = this._b + S | 0, this._c = this._c + E | 0, this._d = this._d + A | 0;
  }, f.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var h = r.allocUnsafe(16);
    return h.writeInt32LE(this._a, 0), h.writeInt32LE(this._b, 4), h.writeInt32LE(this._c, 8), h.writeInt32LE(this._d, 12), h;
  };
  function a(h, w) {
    return h << w | h >>> 32 - w;
  }
  function l(h, w, M, S, E, A, B) {
    return a(h + (w & M | ~w & S) + E + A | 0, B) + w | 0;
  }
  function d(h, w, M, S, E, A, B) {
    return a(h + (w & S | M & ~S) + E + A | 0, B) + w | 0;
  }
  function v(h, w, M, S, E, A, B) {
    return a(h + (w ^ M ^ S) + E + A | 0, B) + w | 0;
  }
  function m(h, w, M, S, E, A, B) {
    return a(h + (M ^ (w | ~S)) + E + A | 0, B) + w | 0;
  }
  return Rh = f, Rh;
}
var Ph, v2;
function wm() {
  if (v2)
    return Ph;
  v2 = 1;
  var t = kr.Buffer, e = Lt(), r = O8(), i = new Array(16), f = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], a = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], l = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], d = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ], v = [0, 1518500249, 1859775393, 2400959708, 2840853838], m = [1352829926, 1548603684, 1836072691, 2053994217, 0];
  function h() {
    r.call(this, 64), this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520;
  }
  e(h, r), h.prototype._update = function() {
    for (var k = i, C = 0; C < 16; ++C)
      k[C] = this._block.readInt32LE(C * 4);
    for (var I = this._a | 0, O = this._b | 0, q = this._c | 0, $ = this._d | 0, ae = this._e | 0, he = this._a | 0, te = this._b | 0, Ee = this._c | 0, x = this._d | 0, n = this._e | 0, o = 0; o < 80; o += 1) {
      var u, c;
      o < 16 ? (u = M(I, O, q, $, ae, k[f[o]], v[0], l[o]), c = B(he, te, Ee, x, n, k[a[o]], m[0], d[o])) : o < 32 ? (u = S(I, O, q, $, ae, k[f[o]], v[1], l[o]), c = A(he, te, Ee, x, n, k[a[o]], m[1], d[o])) : o < 48 ? (u = E(I, O, q, $, ae, k[f[o]], v[2], l[o]), c = E(he, te, Ee, x, n, k[a[o]], m[2], d[o])) : o < 64 ? (u = A(I, O, q, $, ae, k[f[o]], v[3], l[o]), c = S(he, te, Ee, x, n, k[a[o]], m[3], d[o])) : (u = B(I, O, q, $, ae, k[f[o]], v[4], l[o]), c = M(he, te, Ee, x, n, k[a[o]], m[4], d[o])), I = ae, ae = $, $ = w(q, 10), q = O, O = u, he = n, n = x, x = w(Ee, 10), Ee = te, te = c;
    }
    var g = this._b + q + x | 0;
    this._b = this._c + $ + n | 0, this._c = this._d + ae + he | 0, this._d = this._e + I + te | 0, this._e = this._a + O + Ee | 0, this._a = g;
  }, h.prototype._digest = function() {
    this._block[this._blockOffset++] = 128, this._blockOffset > 56 && (this._block.fill(0, this._blockOffset, 64), this._update(), this._blockOffset = 0), this._block.fill(0, this._blockOffset, 56), this._block.writeUInt32LE(this._length[0], 56), this._block.writeUInt32LE(this._length[1], 60), this._update();
    var k = t.alloc ? t.alloc(20) : new t(20);
    return k.writeInt32LE(this._a, 0), k.writeInt32LE(this._b, 4), k.writeInt32LE(this._c, 8), k.writeInt32LE(this._d, 12), k.writeInt32LE(this._e, 16), k;
  };
  function w(k, C) {
    return k << C | k >>> 32 - C;
  }
  function M(k, C, I, O, q, $, ae, he) {
    return w(k + (C ^ I ^ O) + $ + ae | 0, he) + q | 0;
  }
  function S(k, C, I, O, q, $, ae, he) {
    return w(k + (C & I | ~C & O) + $ + ae | 0, he) + q | 0;
  }
  function E(k, C, I, O, q, $, ae, he) {
    return w(k + ((C | ~I) ^ O) + $ + ae | 0, he) + q | 0;
  }
  function A(k, C, I, O, q, $, ae, he) {
    return w(k + (C & O | I & ~O) + $ + ae | 0, he) + q | 0;
  }
  function B(k, C, I, O, q, $, ae, he) {
    return w(k + (C ^ (I | ~O)) + $ + ae | 0, he) + q | 0;
  }
  return Ph = h, Ph;
}
var Oh = { exports: {} }, Nh, m2;
function bo() {
  if (m2)
    return Nh;
  m2 = 1;
  var t = Vt().Buffer;
  function e(r, i) {
    this._block = t.alloc(r), this._finalSize = i, this._blockSize = r, this._len = 0;
  }
  return e.prototype.update = function(r, i) {
    typeof r == "string" && (i = i || "utf8", r = t.from(r, i));
    for (var f = this._block, a = this._blockSize, l = r.length, d = this._len, v = 0; v < l; ) {
      for (var m = d % a, h = Math.min(l - v, a - m), w = 0; w < h; w++)
        f[m + w] = r[v + w];
      d += h, v += h, d % a === 0 && this._update(f);
    }
    return this._len += l, this;
  }, e.prototype.digest = function(r) {
    var i = this._len % this._blockSize;
    this._block[i] = 128, this._block.fill(0, i + 1), i >= this._finalSize && (this._update(this._block), this._block.fill(0));
    var f = this._len * 8;
    if (f <= 4294967295)
      this._block.writeUInt32BE(f, this._blockSize - 4);
    else {
      var a = (f & 4294967295) >>> 0, l = (f - a) / 4294967296;
      this._block.writeUInt32BE(l, this._blockSize - 8), this._block.writeUInt32BE(a, this._blockSize - 4);
    }
    this._update(this._block);
    var d = this._hash();
    return r ? d.toString(r) : d;
  }, e.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
  }, Nh = e, Nh;
}
var Dh, g2;
function SB() {
  if (g2)
    return Dh;
  g2 = 1;
  var t = Lt(), e = bo(), r = Vt().Buffer, i = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], f = new Array(80);
  function a() {
    this.init(), this._w = f, e.call(this, 64, 56);
  }
  t(a, e), a.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function l(m) {
    return m << 5 | m >>> 27;
  }
  function d(m) {
    return m << 30 | m >>> 2;
  }
  function v(m, h, w, M) {
    return m === 0 ? h & w | ~h & M : m === 2 ? h & w | h & M | w & M : h ^ w ^ M;
  }
  return a.prototype._update = function(m) {
    for (var h = this._w, w = this._a | 0, M = this._b | 0, S = this._c | 0, E = this._d | 0, A = this._e | 0, B = 0; B < 16; ++B)
      h[B] = m.readInt32BE(B * 4);
    for (; B < 80; ++B)
      h[B] = h[B - 3] ^ h[B - 8] ^ h[B - 14] ^ h[B - 16];
    for (var k = 0; k < 80; ++k) {
      var C = ~~(k / 20), I = l(w) + v(C, M, S, E) + A + h[k] + i[C] | 0;
      A = E, E = S, S = d(M), M = w, w = I;
    }
    this._a = w + this._a | 0, this._b = M + this._b | 0, this._c = S + this._c | 0, this._d = E + this._d | 0, this._e = A + this._e | 0;
  }, a.prototype._hash = function() {
    var m = r.allocUnsafe(20);
    return m.writeInt32BE(this._a | 0, 0), m.writeInt32BE(this._b | 0, 4), m.writeInt32BE(this._c | 0, 8), m.writeInt32BE(this._d | 0, 12), m.writeInt32BE(this._e | 0, 16), m;
  }, Dh = a, Dh;
}
var Uh, y2;
function EB() {
  if (y2)
    return Uh;
  y2 = 1;
  var t = Lt(), e = bo(), r = Vt().Buffer, i = [
    1518500249,
    1859775393,
    -1894007588,
    -899497514
  ], f = new Array(80);
  function a() {
    this.init(), this._w = f, e.call(this, 64, 56);
  }
  t(a, e), a.prototype.init = function() {
    return this._a = 1732584193, this._b = 4023233417, this._c = 2562383102, this._d = 271733878, this._e = 3285377520, this;
  };
  function l(h) {
    return h << 1 | h >>> 31;
  }
  function d(h) {
    return h << 5 | h >>> 27;
  }
  function v(h) {
    return h << 30 | h >>> 2;
  }
  function m(h, w, M, S) {
    return h === 0 ? w & M | ~w & S : h === 2 ? w & M | w & S | M & S : w ^ M ^ S;
  }
  return a.prototype._update = function(h) {
    for (var w = this._w, M = this._a | 0, S = this._b | 0, E = this._c | 0, A = this._d | 0, B = this._e | 0, k = 0; k < 16; ++k)
      w[k] = h.readInt32BE(k * 4);
    for (; k < 80; ++k)
      w[k] = l(w[k - 3] ^ w[k - 8] ^ w[k - 14] ^ w[k - 16]);
    for (var C = 0; C < 80; ++C) {
      var I = ~~(C / 20), O = d(M) + m(I, S, E, A) + B + w[C] + i[I] | 0;
      B = A, A = E, E = v(S), S = M, M = O;
    }
    this._a = M + this._a | 0, this._b = S + this._b | 0, this._c = E + this._c | 0, this._d = A + this._d | 0, this._e = B + this._e | 0;
  }, a.prototype._hash = function() {
    var h = r.allocUnsafe(20);
    return h.writeInt32BE(this._a | 0, 0), h.writeInt32BE(this._b | 0, 4), h.writeInt32BE(this._c | 0, 8), h.writeInt32BE(this._d | 0, 12), h.writeInt32BE(this._e | 0, 16), h;
  }, Uh = a, Uh;
}
var Lh, b2;
function N8() {
  if (b2)
    return Lh;
  b2 = 1;
  var t = Lt(), e = bo(), r = Vt().Buffer, i = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ], f = new Array(64);
  function a() {
    this.init(), this._w = f, e.call(this, 64, 56);
  }
  t(a, e), a.prototype.init = function() {
    return this._a = 1779033703, this._b = 3144134277, this._c = 1013904242, this._d = 2773480762, this._e = 1359893119, this._f = 2600822924, this._g = 528734635, this._h = 1541459225, this;
  };
  function l(M, S, E) {
    return E ^ M & (S ^ E);
  }
  function d(M, S, E) {
    return M & S | E & (M | S);
  }
  function v(M) {
    return (M >>> 2 | M << 30) ^ (M >>> 13 | M << 19) ^ (M >>> 22 | M << 10);
  }
  function m(M) {
    return (M >>> 6 | M << 26) ^ (M >>> 11 | M << 21) ^ (M >>> 25 | M << 7);
  }
  function h(M) {
    return (M >>> 7 | M << 25) ^ (M >>> 18 | M << 14) ^ M >>> 3;
  }
  function w(M) {
    return (M >>> 17 | M << 15) ^ (M >>> 19 | M << 13) ^ M >>> 10;
  }
  return a.prototype._update = function(M) {
    for (var S = this._w, E = this._a | 0, A = this._b | 0, B = this._c | 0, k = this._d | 0, C = this._e | 0, I = this._f | 0, O = this._g | 0, q = this._h | 0, $ = 0; $ < 16; ++$)
      S[$] = M.readInt32BE($ * 4);
    for (; $ < 64; ++$)
      S[$] = w(S[$ - 2]) + S[$ - 7] + h(S[$ - 15]) + S[$ - 16] | 0;
    for (var ae = 0; ae < 64; ++ae) {
      var he = q + m(C) + l(C, I, O) + i[ae] + S[ae] | 0, te = v(E) + d(E, A, B) | 0;
      q = O, O = I, I = C, C = k + he | 0, k = B, B = A, A = E, E = he + te | 0;
    }
    this._a = E + this._a | 0, this._b = A + this._b | 0, this._c = B + this._c | 0, this._d = k + this._d | 0, this._e = C + this._e | 0, this._f = I + this._f | 0, this._g = O + this._g | 0, this._h = q + this._h | 0;
  }, a.prototype._hash = function() {
    var M = r.allocUnsafe(32);
    return M.writeInt32BE(this._a, 0), M.writeInt32BE(this._b, 4), M.writeInt32BE(this._c, 8), M.writeInt32BE(this._d, 12), M.writeInt32BE(this._e, 16), M.writeInt32BE(this._f, 20), M.writeInt32BE(this._g, 24), M.writeInt32BE(this._h, 28), M;
  }, Lh = a, Lh;
}
var Fh, w2;
function AB() {
  if (w2)
    return Fh;
  w2 = 1;
  var t = Lt(), e = N8(), r = bo(), i = Vt().Buffer, f = new Array(64);
  function a() {
    this.init(), this._w = f, r.call(this, 64, 56);
  }
  return t(a, e), a.prototype.init = function() {
    return this._a = 3238371032, this._b = 914150663, this._c = 812702999, this._d = 4144912697, this._e = 4290775857, this._f = 1750603025, this._g = 1694076839, this._h = 3204075428, this;
  }, a.prototype._hash = function() {
    var l = i.allocUnsafe(28);
    return l.writeInt32BE(this._a, 0), l.writeInt32BE(this._b, 4), l.writeInt32BE(this._c, 8), l.writeInt32BE(this._d, 12), l.writeInt32BE(this._e, 16), l.writeInt32BE(this._f, 20), l.writeInt32BE(this._g, 24), l;
  }, Fh = a, Fh;
}
var qh, _2;
function D8() {
  if (_2)
    return qh;
  _2 = 1;
  var t = Lt(), e = bo(), r = Vt().Buffer, i = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ], f = new Array(160);
  function a() {
    this.init(), this._w = f, e.call(this, 128, 112);
  }
  t(a, e), a.prototype.init = function() {
    return this._ah = 1779033703, this._bh = 3144134277, this._ch = 1013904242, this._dh = 2773480762, this._eh = 1359893119, this._fh = 2600822924, this._gh = 528734635, this._hh = 1541459225, this._al = 4089235720, this._bl = 2227873595, this._cl = 4271175723, this._dl = 1595750129, this._el = 2917565137, this._fl = 725511199, this._gl = 4215389547, this._hl = 327033209, this;
  };
  function l(A, B, k) {
    return k ^ A & (B ^ k);
  }
  function d(A, B, k) {
    return A & B | k & (A | B);
  }
  function v(A, B) {
    return (A >>> 28 | B << 4) ^ (B >>> 2 | A << 30) ^ (B >>> 7 | A << 25);
  }
  function m(A, B) {
    return (A >>> 14 | B << 18) ^ (A >>> 18 | B << 14) ^ (B >>> 9 | A << 23);
  }
  function h(A, B) {
    return (A >>> 1 | B << 31) ^ (A >>> 8 | B << 24) ^ A >>> 7;
  }
  function w(A, B) {
    return (A >>> 1 | B << 31) ^ (A >>> 8 | B << 24) ^ (A >>> 7 | B << 25);
  }
  function M(A, B) {
    return (A >>> 19 | B << 13) ^ (B >>> 29 | A << 3) ^ A >>> 6;
  }
  function S(A, B) {
    return (A >>> 19 | B << 13) ^ (B >>> 29 | A << 3) ^ (A >>> 6 | B << 26);
  }
  function E(A, B) {
    return A >>> 0 < B >>> 0 ? 1 : 0;
  }
  return a.prototype._update = function(A) {
    for (var B = this._w, k = this._ah | 0, C = this._bh | 0, I = this._ch | 0, O = this._dh | 0, q = this._eh | 0, $ = this._fh | 0, ae = this._gh | 0, he = this._hh | 0, te = this._al | 0, Ee = this._bl | 0, x = this._cl | 0, n = this._dl | 0, o = this._el | 0, u = this._fl | 0, c = this._gl | 0, g = this._hl | 0, b = 0; b < 32; b += 2)
      B[b] = A.readInt32BE(b * 4), B[b + 1] = A.readInt32BE(b * 4 + 4);
    for (; b < 160; b += 2) {
      var _ = B[b - 30], p = B[b - 15 * 2 + 1], s = h(_, p), y = w(p, _);
      _ = B[b - 2 * 2], p = B[b - 2 * 2 + 1];
      var T = M(_, p), P = S(p, _), z = B[b - 7 * 2], J = B[b - 7 * 2 + 1], Z = B[b - 16 * 2], F = B[b - 16 * 2 + 1], ee = y + J | 0, re = s + z + E(ee, y) | 0;
      ee = ee + P | 0, re = re + T + E(ee, P) | 0, ee = ee + F | 0, re = re + Z + E(ee, F) | 0, B[b] = re, B[b + 1] = ee;
    }
    for (var de = 0; de < 160; de += 2) {
      re = B[de], ee = B[de + 1];
      var se = d(k, C, I), Q = d(te, Ee, x), ge = v(k, te), Ye = v(te, k), Ce = m(q, o), Be = m(o, q), st = i[de], De = i[de + 1], _e = l(q, $, ae), St = l(o, u, c), Oe = g + Be | 0, Fe = he + Ce + E(Oe, g) | 0;
      Oe = Oe + St | 0, Fe = Fe + _e + E(Oe, St) | 0, Oe = Oe + De | 0, Fe = Fe + st + E(Oe, De) | 0, Oe = Oe + ee | 0, Fe = Fe + re + E(Oe, ee) | 0;
      var Et = Ye + Q | 0, Ue = ge + se + E(Et, Ye) | 0;
      he = ae, g = c, ae = $, c = u, $ = q, u = o, o = n + Oe | 0, q = O + Fe + E(o, n) | 0, O = I, n = x, I = C, x = Ee, C = k, Ee = te, te = Oe + Et | 0, k = Fe + Ue + E(te, Oe) | 0;
    }
    this._al = this._al + te | 0, this._bl = this._bl + Ee | 0, this._cl = this._cl + x | 0, this._dl = this._dl + n | 0, this._el = this._el + o | 0, this._fl = this._fl + u | 0, this._gl = this._gl + c | 0, this._hl = this._hl + g | 0, this._ah = this._ah + k + E(this._al, te) | 0, this._bh = this._bh + C + E(this._bl, Ee) | 0, this._ch = this._ch + I + E(this._cl, x) | 0, this._dh = this._dh + O + E(this._dl, n) | 0, this._eh = this._eh + q + E(this._el, o) | 0, this._fh = this._fh + $ + E(this._fl, u) | 0, this._gh = this._gh + ae + E(this._gl, c) | 0, this._hh = this._hh + he + E(this._hl, g) | 0;
  }, a.prototype._hash = function() {
    var A = r.allocUnsafe(64);
    function B(k, C, I) {
      A.writeInt32BE(k, I), A.writeInt32BE(C, I + 4);
    }
    return B(this._ah, this._al, 0), B(this._bh, this._bl, 8), B(this._ch, this._cl, 16), B(this._dh, this._dl, 24), B(this._eh, this._el, 32), B(this._fh, this._fl, 40), B(this._gh, this._gl, 48), B(this._hh, this._hl, 56), A;
  }, qh = a, qh;
}
var zh, x2;
function kB() {
  if (x2)
    return zh;
  x2 = 1;
  var t = Lt(), e = D8(), r = bo(), i = Vt().Buffer, f = new Array(160);
  function a() {
    this.init(), this._w = f, r.call(this, 128, 112);
  }
  return t(a, e), a.prototype.init = function() {
    return this._ah = 3418070365, this._bh = 1654270250, this._ch = 2438529370, this._dh = 355462360, this._eh = 1731405415, this._fh = 2394180231, this._gh = 3675008525, this._hh = 1203062813, this._al = 3238371032, this._bl = 914150663, this._cl = 812702999, this._dl = 4144912697, this._el = 4290775857, this._fl = 1750603025, this._gl = 1694076839, this._hl = 3204075428, this;
  }, a.prototype._hash = function() {
    var l = i.allocUnsafe(48);
    function d(v, m, h) {
      l.writeInt32BE(v, h), l.writeInt32BE(m, h + 4);
    }
    return d(this._ah, this._al, 0), d(this._bh, this._bl, 8), d(this._ch, this._cl, 16), d(this._dh, this._dl, 24), d(this._eh, this._el, 32), d(this._fh, this._fl, 40), l;
  }, zh = a, zh;
}
var M2;
function _m() {
  if (M2)
    return Oh.exports;
  M2 = 1;
  var t = Oh.exports = function(r) {
    r = r.toLowerCase();
    var i = t[r];
    if (!i)
      throw new Error(r + " is not supported (we accept pull requests)");
    return new i();
  };
  return t.sha = SB(), t.sha1 = EB(), t.sha224 = AB(), t.sha256 = N8(), t.sha384 = kB(), t.sha512 = D8(), Oh.exports;
}
var jh, S2;
function TB() {
  if (S2)
    return jh;
  S2 = 1, jh = r;
  var t = $f().EventEmitter, e = Lt();
  e(r, t), r.Readable = gm(), r.Writable = mm(), r.Duplex = za(), r.Transform = ym(), r.PassThrough = R8(), r.finished = gc(), r.pipeline = P8(), r.Stream = r;
  function r() {
    t.call(this);
  }
  return r.prototype.pipe = function(i, f) {
    var a = this;
    function l(S) {
      i.writable && i.write(S) === !1 && a.pause && a.pause();
    }
    a.on("data", l);
    function d() {
      a.readable && a.resume && a.resume();
    }
    i.on("drain", d), !i._isStdio && (!f || f.end !== !1) && (a.on("end", m), a.on("close", h));
    var v = !1;
    function m() {
      v || (v = !0, i.end());
    }
    function h() {
      v || (v = !0, typeof i.destroy == "function" && i.destroy());
    }
    function w(S) {
      if (M(), t.listenerCount(this, "error") === 0)
        throw S;
    }
    a.on("error", w), i.on("error", w);
    function M() {
      a.removeListener("data", l), i.removeListener("drain", d), a.removeListener("end", m), a.removeListener("close", h), a.removeListener("error", w), i.removeListener("error", w), a.removeListener("end", M), a.removeListener("close", M), i.removeListener("close", M);
    }
    return a.on("end", M), a.on("close", M), i.on("close", M), i.emit("pipe", a), i;
  }, jh;
}
var $h, E2;
function ma() {
  if (E2)
    return $h;
  E2 = 1;
  var t = Vt().Buffer, e = TB().Transform, r = K1().StringDecoder, i = Lt();
  function f(a) {
    e.call(this), this.hashMode = typeof a == "string", this.hashMode ? this[a] = this._finalOrDigest : this.final = this._finalOrDigest, this._final && (this.__final = this._final, this._final = null), this._decoder = null, this._encoding = null;
  }
  return i(f, e), f.prototype.update = function(a, l, d) {
    typeof a == "string" && (a = t.from(a, l));
    var v = this._update(a);
    return this.hashMode ? this : (d && (v = this._toString(v, d)), v);
  }, f.prototype.setAutoPadding = function() {
  }, f.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
  }, f.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
  }, f.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
  }, f.prototype._transform = function(a, l, d) {
    var v;
    try {
      this.hashMode ? this._update(a) : this.push(this._update(a));
    } catch (m) {
      v = m;
    } finally {
      d(v);
    }
  }, f.prototype._flush = function(a) {
    var l;
    try {
      this.push(this.__final());
    } catch (d) {
      l = d;
    }
    a(l);
  }, f.prototype._finalOrDigest = function(a) {
    var l = this.__final() || t.alloc(0);
    return a && (l = this._toString(l, a, !0)), l;
  }, f.prototype._toString = function(a, l, d) {
    if (this._decoder || (this._decoder = new r(l), this._encoding = l), this._encoding !== l)
      throw new Error("can't switch encodings");
    var v = this._decoder.write(a);
    return d && (v += this._decoder.end()), v;
  }, $h = f, $h;
}
var Vh, A2;
function Hf() {
  if (A2)
    return Vh;
  A2 = 1;
  var t = Lt(), e = bm(), r = wm(), i = _m(), f = ma();
  function a(l) {
    f.call(this, "digest"), this._hash = l;
  }
  return t(a, f), a.prototype._update = function(l) {
    this._hash.update(l);
  }, a.prototype._final = function() {
    return this._hash.digest();
  }, Vh = function(d) {
    return d = d.toLowerCase(), d === "md5" ? new e() : d === "rmd160" || d === "ripemd160" ? new r() : new a(i(d));
  }, Vh;
}
var Hh, k2;
function CB() {
  if (k2)
    return Hh;
  k2 = 1;
  var t = Lt(), e = Vt().Buffer, r = ma(), i = e.alloc(128), f = 64;
  function a(l, d) {
    r.call(this, "digest"), typeof d == "string" && (d = e.from(d)), this._alg = l, this._key = d, d.length > f ? d = l(d) : d.length < f && (d = e.concat([d, i], f));
    for (var v = this._ipad = e.allocUnsafe(f), m = this._opad = e.allocUnsafe(f), h = 0; h < f; h++)
      v[h] = d[h] ^ 54, m[h] = d[h] ^ 92;
    this._hash = [v];
  }
  return t(a, r), a.prototype._update = function(l) {
    this._hash.push(l);
  }, a.prototype._final = function() {
    var l = this._alg(e.concat(this._hash));
    return this._alg(e.concat([this._opad, l]));
  }, Hh = a, Hh;
}
var Wh, T2;
function U8() {
  if (T2)
    return Wh;
  T2 = 1;
  var t = bm();
  return Wh = function(e) {
    return new t().update(e).digest();
  }, Wh;
}
var Kh, C2;
function L8() {
  if (C2)
    return Kh;
  C2 = 1;
  var t = Lt(), e = CB(), r = ma(), i = Vt().Buffer, f = U8(), a = wm(), l = _m(), d = i.alloc(128);
  function v(m, h) {
    r.call(this, "digest"), typeof h == "string" && (h = i.from(h));
    var w = m === "sha512" || m === "sha384" ? 128 : 64;
    if (this._alg = m, this._key = h, h.length > w) {
      var M = m === "rmd160" ? new a() : l(m);
      h = M.update(h).digest();
    } else
      h.length < w && (h = i.concat([h, d], w));
    for (var S = this._ipad = i.allocUnsafe(w), E = this._opad = i.allocUnsafe(w), A = 0; A < w; A++)
      S[A] = h[A] ^ 54, E[A] = h[A] ^ 92;
    this._hash = m === "rmd160" ? new a() : l(m), this._hash.update(S);
  }
  return t(v, r), v.prototype._update = function(m) {
    this._hash.update(m);
  }, v.prototype._final = function() {
    var m = this._hash.digest(), h = this._alg === "rmd160" ? new a() : l(this._alg);
    return h.update(this._opad).update(m).digest();
  }, Kh = function(h, w) {
    return h = h.toLowerCase(), h === "rmd160" || h === "ripemd160" ? new v("rmd160", w) : h === "md5" ? new e(f, w) : new v(h, w);
  }, Kh;
}
const BB = {
  sign: "rsa",
  hash: "sha224",
  id: "302d300d06096086480165030402040500041c"
}, IB = {
  sign: "rsa",
  hash: "sha256",
  id: "3031300d060960864801650304020105000420"
}, RB = {
  sign: "rsa",
  hash: "sha384",
  id: "3041300d060960864801650304020205000430"
}, PB = {
  sign: "rsa",
  hash: "sha512",
  id: "3051300d060960864801650304020305000440"
}, OB = {
  sign: "ecdsa",
  hash: "sha256",
  id: ""
}, NB = {
  sign: "ecdsa",
  hash: "sha224",
  id: ""
}, DB = {
  sign: "ecdsa",
  hash: "sha384",
  id: ""
}, UB = {
  sign: "ecdsa",
  hash: "sha512",
  id: ""
}, LB = {
  sign: "dsa",
  hash: "sha1",
  id: ""
}, FB = {
  sign: "rsa",
  hash: "rmd160",
  id: "3021300906052b2403020105000414"
}, qB = {
  sign: "rsa",
  hash: "md5",
  id: "3020300c06082a864886f70d020505000410"
}, F8 = {
  sha224WithRSAEncryption: BB,
  "RSA-SHA224": {
    sign: "ecdsa/rsa",
    hash: "sha224",
    id: "302d300d06096086480165030402040500041c"
  },
  sha256WithRSAEncryption: IB,
  "RSA-SHA256": {
    sign: "ecdsa/rsa",
    hash: "sha256",
    id: "3031300d060960864801650304020105000420"
  },
  sha384WithRSAEncryption: RB,
  "RSA-SHA384": {
    sign: "ecdsa/rsa",
    hash: "sha384",
    id: "3041300d060960864801650304020205000430"
  },
  sha512WithRSAEncryption: PB,
  "RSA-SHA512": {
    sign: "ecdsa/rsa",
    hash: "sha512",
    id: "3051300d060960864801650304020305000440"
  },
  "RSA-SHA1": {
    sign: "rsa",
    hash: "sha1",
    id: "3021300906052b0e03021a05000414"
  },
  "ecdsa-with-SHA1": {
    sign: "ecdsa",
    hash: "sha1",
    id: ""
  },
  sha256: OB,
  sha224: NB,
  sha384: DB,
  sha512: UB,
  "DSA-SHA": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  "DSA-SHA1": {
    sign: "dsa",
    hash: "sha1",
    id: ""
  },
  DSA: LB,
  "DSA-WITH-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-SHA224": {
    sign: "dsa",
    hash: "sha224",
    id: ""
  },
  "DSA-WITH-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-SHA256": {
    sign: "dsa",
    hash: "sha256",
    id: ""
  },
  "DSA-WITH-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-SHA384": {
    sign: "dsa",
    hash: "sha384",
    id: ""
  },
  "DSA-WITH-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-SHA512": {
    sign: "dsa",
    hash: "sha512",
    id: ""
  },
  "DSA-RIPEMD160": {
    sign: "dsa",
    hash: "rmd160",
    id: ""
  },
  ripemd160WithRSA: FB,
  "RSA-RIPEMD160": {
    sign: "rsa",
    hash: "rmd160",
    id: "3021300906052b2403020105000414"
  },
  md5WithRSAEncryption: qB,
  "RSA-MD5": {
    sign: "rsa",
    hash: "md5",
    id: "3020300c06082a864886f70d020505000410"
  }
};
var Zh, B2;
function zB() {
  return B2 || (B2 = 1, Zh = F8), Zh;
}
var yu = {}, Gh, I2;
function q8() {
  if (I2)
    return Gh;
  I2 = 1;
  var t = Math.pow(2, 30) - 1;
  return Gh = function(e, r) {
    if (typeof e != "number")
      throw new TypeError("Iterations not a number");
    if (e < 0)
      throw new TypeError("Bad iterations");
    if (typeof r != "number")
      throw new TypeError("Key length not a number");
    if (r < 0 || r > t || r !== r)
      throw new TypeError("Bad key length");
  }, Gh;
}
var Qh, R2;
function z8() {
  if (R2)
    return Qh;
  R2 = 1;
  var t;
  if (ut.process && ut.process.browser)
    t = "utf-8";
  else if (ut.process && ut.process.version) {
    var e = parseInt(It.version.split(".")[0].slice(1), 10);
    t = e >= 6 ? "utf-8" : "binary";
  } else
    t = "utf-8";
  return Qh = t, Qh;
}
var Yh, P2;
function j8() {
  if (P2)
    return Yh;
  P2 = 1;
  var t = Vt().Buffer;
  return Yh = function(e, r, i) {
    if (t.isBuffer(e))
      return e;
    if (typeof e == "string")
      return t.from(e, r);
    if (ArrayBuffer.isView(e))
      return t.from(e.buffer);
    throw new TypeError(i + " must be a string, a Buffer, a typed array or a DataView");
  }, Yh;
}
var Jh, O2;
function $8() {
  if (O2)
    return Jh;
  O2 = 1;
  var t = U8(), e = wm(), r = _m(), i = Vt().Buffer, f = q8(), a = z8(), l = j8(), d = i.alloc(128), v = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
  };
  function m(M, S, E) {
    var A = h(M), B = M === "sha512" || M === "sha384" ? 128 : 64;
    S.length > B ? S = A(S) : S.length < B && (S = i.concat([S, d], B));
    for (var k = i.allocUnsafe(B + v[M]), C = i.allocUnsafe(B + v[M]), I = 0; I < B; I++)
      k[I] = S[I] ^ 54, C[I] = S[I] ^ 92;
    var O = i.allocUnsafe(B + E + 4);
    k.copy(O, 0, 0, B), this.ipad1 = O, this.ipad2 = k, this.opad = C, this.alg = M, this.blocksize = B, this.hash = A, this.size = v[M];
  }
  m.prototype.run = function(M, S) {
    M.copy(S, this.blocksize);
    var E = this.hash(S);
    return E.copy(this.opad, this.blocksize), this.hash(this.opad);
  };
  function h(M) {
    function S(A) {
      return r(M).update(A).digest();
    }
    function E(A) {
      return new e().update(A).digest();
    }
    return M === "rmd160" || M === "ripemd160" ? E : M === "md5" ? t : S;
  }
  function w(M, S, E, A, B) {
    f(E, A), M = l(M, a, "Password"), S = l(S, a, "Salt"), B = B || "sha1";
    var k = new m(B, M, S.length), C = i.allocUnsafe(A), I = i.allocUnsafe(S.length + 4);
    S.copy(I, 0, 0, S.length);
    for (var O = 0, q = v[B], $ = Math.ceil(A / q), ae = 1; ae <= $; ae++) {
      I.writeUInt32BE(ae, S.length);
      for (var he = k.run(I, k.ipad1), te = he, Ee = 1; Ee < E; Ee++) {
        te = k.run(te, k.ipad2);
        for (var x = 0; x < q; x++)
          he[x] ^= te[x];
      }
      he.copy(C, O), O += q;
    }
    return C;
  }
  return Jh = w, Jh;
}
var Xh, N2;
function jB() {
  if (N2)
    return Xh;
  N2 = 1;
  var t = Vt().Buffer, e = q8(), r = z8(), i = $8(), f = j8(), a, l = ut.crypto && ut.crypto.subtle, d = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
  }, v = [];
  function m(E) {
    if (ut.process && !ut.process.browser || !l || !l.importKey || !l.deriveBits)
      return Promise.resolve(!1);
    if (v[E] !== void 0)
      return v[E];
    a = a || t.alloc(8);
    var A = M(a, a, 10, 128, E).then(function() {
      return !0;
    }).catch(function() {
      return !1;
    });
    return v[E] = A, A;
  }
  var h;
  function w() {
    return h || (ut.process && ut.process.nextTick ? h = ut.process.nextTick : ut.queueMicrotask ? h = ut.queueMicrotask : ut.setImmediate ? h = ut.setImmediate : h = ut.setTimeout, h);
  }
  function M(E, A, B, k, C) {
    return l.importKey(
      "raw",
      E,
      { name: "PBKDF2" },
      !1,
      ["deriveBits"]
    ).then(function(I) {
      return l.deriveBits({
        name: "PBKDF2",
        salt: A,
        iterations: B,
        hash: {
          name: C
        }
      }, I, k << 3);
    }).then(function(I) {
      return t.from(I);
    });
  }
  function S(E, A) {
    E.then(function(B) {
      w()(function() {
        A(null, B);
      });
    }, function(B) {
      w()(function() {
        A(B);
      });
    });
  }
  return Xh = function(E, A, B, k, C, I) {
    typeof C == "function" && (I = C, C = void 0), C = C || "sha1";
    var O = d[C.toLowerCase()];
    if (!O || typeof ut.Promise != "function") {
      w()(function() {
        var q;
        try {
          q = i(E, A, B, k, C);
        } catch ($) {
          return I($);
        }
        I(null, q);
      });
      return;
    }
    if (e(B, k), E = f(E, r, "Password"), A = f(A, r, "Salt"), typeof I != "function")
      throw new Error("No callback provided to pbkdf2");
    S(m(O).then(function(q) {
      return q ? M(E, A, B, k, O) : i(E, A, B, k, C);
    }), I);
  }, Xh;
}
var D2;
function V8() {
  return D2 || (D2 = 1, yu.pbkdf2 = jB(), yu.pbkdf2Sync = $8()), yu;
}
var gn = {}, ba = {}, sn = {}, U2;
function H8() {
  if (U2)
    return sn;
  U2 = 1, sn.readUInt32BE = function(f, a) {
    var l = f[0 + a] << 24 | f[1 + a] << 16 | f[2 + a] << 8 | f[3 + a];
    return l >>> 0;
  }, sn.writeUInt32BE = function(f, a, l) {
    f[0 + l] = a >>> 24, f[1 + l] = a >>> 16 & 255, f[2 + l] = a >>> 8 & 255, f[3 + l] = a & 255;
  }, sn.ip = function(f, a, l, d) {
    for (var v = 0, m = 0, h = 6; h >= 0; h -= 2) {
      for (var w = 0; w <= 24; w += 8)
        v <<= 1, v |= a >>> w + h & 1;
      for (var w = 0; w <= 24; w += 8)
        v <<= 1, v |= f >>> w + h & 1;
    }
    for (var h = 6; h >= 0; h -= 2) {
      for (var w = 1; w <= 25; w += 8)
        m <<= 1, m |= a >>> w + h & 1;
      for (var w = 1; w <= 25; w += 8)
        m <<= 1, m |= f >>> w + h & 1;
    }
    l[d + 0] = v >>> 0, l[d + 1] = m >>> 0;
  }, sn.rip = function(f, a, l, d) {
    for (var v = 0, m = 0, h = 0; h < 4; h++)
      for (var w = 24; w >= 0; w -= 8)
        v <<= 1, v |= a >>> w + h & 1, v <<= 1, v |= f >>> w + h & 1;
    for (var h = 4; h < 8; h++)
      for (var w = 24; w >= 0; w -= 8)
        m <<= 1, m |= a >>> w + h & 1, m <<= 1, m |= f >>> w + h & 1;
    l[d + 0] = v >>> 0, l[d + 1] = m >>> 0;
  }, sn.pc1 = function(f, a, l, d) {
    for (var v = 0, m = 0, h = 7; h >= 5; h--) {
      for (var w = 0; w <= 24; w += 8)
        v <<= 1, v |= a >> w + h & 1;
      for (var w = 0; w <= 24; w += 8)
        v <<= 1, v |= f >> w + h & 1;
    }
    for (var w = 0; w <= 24; w += 8)
      v <<= 1, v |= a >> w + h & 1;
    for (var h = 1; h <= 3; h++) {
      for (var w = 0; w <= 24; w += 8)
        m <<= 1, m |= a >> w + h & 1;
      for (var w = 0; w <= 24; w += 8)
        m <<= 1, m |= f >> w + h & 1;
    }
    for (var w = 0; w <= 24; w += 8)
      m <<= 1, m |= f >> w + h & 1;
    l[d + 0] = v >>> 0, l[d + 1] = m >>> 0;
  }, sn.r28shl = function(f, a) {
    return f << a & 268435455 | f >>> 28 - a;
  };
  var t = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
  ];
  sn.pc2 = function(f, a, l, d) {
    for (var v = 0, m = 0, h = t.length >>> 1, w = 0; w < h; w++)
      v <<= 1, v |= f >>> t[w] & 1;
    for (var w = h; w < t.length; w++)
      m <<= 1, m |= a >>> t[w] & 1;
    l[d + 0] = v >>> 0, l[d + 1] = m >>> 0;
  }, sn.expand = function(f, a, l) {
    var d = 0, v = 0;
    d = (f & 1) << 5 | f >>> 27;
    for (var m = 23; m >= 15; m -= 4)
      d <<= 6, d |= f >>> m & 63;
    for (var m = 11; m >= 3; m -= 4)
      v |= f >>> m & 63, v <<= 6;
    v |= (f & 31) << 1 | f >>> 31, a[l + 0] = d >>> 0, a[l + 1] = v >>> 0;
  };
  var e = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
  ];
  sn.substitute = function(f, a) {
    for (var l = 0, d = 0; d < 4; d++) {
      var v = f >>> 18 - d * 6 & 63, m = e[d * 64 + v];
      l <<= 4, l |= m;
    }
    for (var d = 0; d < 4; d++) {
      var v = a >>> 18 - d * 6 & 63, m = e[4 * 64 + d * 64 + v];
      l <<= 4, l |= m;
    }
    return l >>> 0;
  };
  var r = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
  ];
  return sn.permute = function(f) {
    for (var a = 0, l = 0; l < r.length; l++)
      a <<= 1, a |= f >>> r[l] & 1;
    return a >>> 0;
  }, sn.padSplit = function(f, a, l) {
    for (var d = f.toString(2); d.length < a; )
      d = "0" + d;
    for (var v = [], m = 0; m < a; m += l)
      v.push(d.slice(m, m + l));
    return v.join(" ");
  }, sn;
}
var e0, L2;
function mn() {
  if (L2)
    return e0;
  L2 = 1, e0 = t;
  function t(e, r) {
    if (!e)
      throw new Error(r || "Assertion failed");
  }
  return t.equal = function(r, i, f) {
    if (r != i)
      throw new Error(f || "Assertion failed: " + r + " != " + i);
  }, e0;
}
var t0, F2;
function xm() {
  if (F2)
    return t0;
  F2 = 1;
  var t = mn();
  function e(r) {
    this.options = r, this.type = this.options.type, this.blockSize = 8, this._init(), this.buffer = new Array(this.blockSize), this.bufferOff = 0, this.padding = r.padding !== !1;
  }
  return t0 = e, e.prototype._init = function() {
  }, e.prototype.update = function(i) {
    return i.length === 0 ? [] : this.type === "decrypt" ? this._updateDecrypt(i) : this._updateEncrypt(i);
  }, e.prototype._buffer = function(i, f) {
    for (var a = Math.min(this.buffer.length - this.bufferOff, i.length - f), l = 0; l < a; l++)
      this.buffer[this.bufferOff + l] = i[f + l];
    return this.bufferOff += a, a;
  }, e.prototype._flushBuffer = function(i, f) {
    return this._update(this.buffer, 0, i, f), this.bufferOff = 0, this.blockSize;
  }, e.prototype._updateEncrypt = function(i) {
    var f = 0, a = 0, l = (this.bufferOff + i.length) / this.blockSize | 0, d = new Array(l * this.blockSize);
    this.bufferOff !== 0 && (f += this._buffer(i, f), this.bufferOff === this.buffer.length && (a += this._flushBuffer(d, a)));
    for (var v = i.length - (i.length - f) % this.blockSize; f < v; f += this.blockSize)
      this._update(i, f, d, a), a += this.blockSize;
    for (; f < i.length; f++, this.bufferOff++)
      this.buffer[this.bufferOff] = i[f];
    return d;
  }, e.prototype._updateDecrypt = function(i) {
    for (var f = 0, a = 0, l = Math.ceil((this.bufferOff + i.length) / this.blockSize) - 1, d = new Array(l * this.blockSize); l > 0; l--)
      f += this._buffer(i, f), a += this._flushBuffer(d, a);
    return f += this._buffer(i, f), d;
  }, e.prototype.final = function(i) {
    var f;
    i && (f = this.update(i));
    var a;
    return this.type === "encrypt" ? a = this._finalEncrypt() : a = this._finalDecrypt(), f ? f.concat(a) : a;
  }, e.prototype._pad = function(i, f) {
    if (f === 0)
      return !1;
    for (; f < i.length; )
      i[f++] = 0;
    return !0;
  }, e.prototype._finalEncrypt = function() {
    if (!this._pad(this.buffer, this.bufferOff))
      return [];
    var i = new Array(this.blockSize);
    return this._update(this.buffer, 0, i, 0), i;
  }, e.prototype._unpad = function(i) {
    return i;
  }, e.prototype._finalDecrypt = function() {
    t.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var i = new Array(this.blockSize);
    return this._flushBuffer(i, 0), this._unpad(i);
  }, t0;
}
var r0, q2;
function W8() {
  if (q2)
    return r0;
  q2 = 1;
  var t = mn(), e = Lt(), r = H8(), i = xm();
  function f() {
    this.tmp = new Array(2), this.keys = null;
  }
  function a(d) {
    i.call(this, d);
    var v = new f();
    this._desState = v, this.deriveKeys(v, d.key);
  }
  e(a, i), r0 = a, a.create = function(v) {
    return new a(v);
  };
  var l = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
  ];
  return a.prototype.deriveKeys = function(v, m) {
    v.keys = new Array(16 * 2), t.equal(m.length, this.blockSize, "Invalid key length");
    var h = r.readUInt32BE(m, 0), w = r.readUInt32BE(m, 4);
    r.pc1(h, w, v.tmp, 0), h = v.tmp[0], w = v.tmp[1];
    for (var M = 0; M < v.keys.length; M += 2) {
      var S = l[M >>> 1];
      h = r.r28shl(h, S), w = r.r28shl(w, S), r.pc2(h, w, v.keys, M);
    }
  }, a.prototype._update = function(v, m, h, w) {
    var M = this._desState, S = r.readUInt32BE(v, m), E = r.readUInt32BE(v, m + 4);
    r.ip(S, E, M.tmp, 0), S = M.tmp[0], E = M.tmp[1], this.type === "encrypt" ? this._encrypt(M, S, E, M.tmp, 0) : this._decrypt(M, S, E, M.tmp, 0), S = M.tmp[0], E = M.tmp[1], r.writeUInt32BE(h, S, w), r.writeUInt32BE(h, E, w + 4);
  }, a.prototype._pad = function(v, m) {
    if (this.padding === !1)
      return !1;
    for (var h = v.length - m, w = m; w < v.length; w++)
      v[w] = h;
    return !0;
  }, a.prototype._unpad = function(v) {
    if (this.padding === !1)
      return v;
    for (var m = v[v.length - 1], h = v.length - m; h < v.length; h++)
      t.equal(v[h], m);
    return v.slice(0, v.length - m);
  }, a.prototype._encrypt = function(v, m, h, w, M) {
    for (var S = m, E = h, A = 0; A < v.keys.length; A += 2) {
      var B = v.keys[A], k = v.keys[A + 1];
      r.expand(E, v.tmp, 0), B ^= v.tmp[0], k ^= v.tmp[1];
      var C = r.substitute(B, k), I = r.permute(C), O = E;
      E = (S ^ I) >>> 0, S = O;
    }
    r.rip(E, S, w, M);
  }, a.prototype._decrypt = function(v, m, h, w, M) {
    for (var S = h, E = m, A = v.keys.length - 2; A >= 0; A -= 2) {
      var B = v.keys[A], k = v.keys[A + 1];
      r.expand(S, v.tmp, 0), B ^= v.tmp[0], k ^= v.tmp[1];
      var C = r.substitute(B, k), I = r.permute(C), O = S;
      S = (E ^ I) >>> 0, E = O;
    }
    r.rip(S, E, w, M);
  }, r0;
}
var n0 = {}, z2;
function $B() {
  if (z2)
    return n0;
  z2 = 1;
  var t = mn(), e = Lt(), r = {};
  function i(a) {
    t.equal(a.length, 8, "Invalid IV length"), this.iv = new Array(8);
    for (var l = 0; l < this.iv.length; l++)
      this.iv[l] = a[l];
  }
  function f(a) {
    function l(h) {
      a.call(this, h), this._cbcInit();
    }
    e(l, a);
    for (var d = Object.keys(r), v = 0; v < d.length; v++) {
      var m = d[v];
      l.prototype[m] = r[m];
    }
    return l.create = function(w) {
      return new l(w);
    }, l;
  }
  return n0.instantiate = f, r._cbcInit = function() {
    var l = new i(this.options.iv);
    this._cbcState = l;
  }, r._update = function(l, d, v, m) {
    var h = this._cbcState, w = this.constructor.super_.prototype, M = h.iv;
    if (this.type === "encrypt") {
      for (var S = 0; S < this.blockSize; S++)
        M[S] ^= l[d + S];
      w._update.call(this, M, 0, v, m);
      for (var S = 0; S < this.blockSize; S++)
        M[S] = v[m + S];
    } else {
      w._update.call(this, l, d, v, m);
      for (var S = 0; S < this.blockSize; S++)
        v[m + S] ^= M[S];
      for (var S = 0; S < this.blockSize; S++)
        M[S] = l[d + S];
    }
  }, n0;
}
var i0, j2;
function VB() {
  if (j2)
    return i0;
  j2 = 1;
  var t = mn(), e = Lt(), r = xm(), i = W8();
  function f(l, d) {
    t.equal(d.length, 24, "Invalid key length");
    var v = d.slice(0, 8), m = d.slice(8, 16), h = d.slice(16, 24);
    l === "encrypt" ? this.ciphers = [
      i.create({ type: "encrypt", key: v }),
      i.create({ type: "decrypt", key: m }),
      i.create({ type: "encrypt", key: h })
    ] : this.ciphers = [
      i.create({ type: "decrypt", key: h }),
      i.create({ type: "encrypt", key: m }),
      i.create({ type: "decrypt", key: v })
    ];
  }
  function a(l) {
    r.call(this, l);
    var d = new f(this.type, this.options.key);
    this._edeState = d;
  }
  return e(a, r), i0 = a, a.create = function(d) {
    return new a(d);
  }, a.prototype._update = function(d, v, m, h) {
    var w = this._edeState;
    w.ciphers[0]._update(d, v, m, h), w.ciphers[1]._update(m, h, m, h), w.ciphers[2]._update(m, h, m, h);
  }, a.prototype._pad = i.prototype._pad, a.prototype._unpad = i.prototype._unpad, i0;
}
var $2;
function HB() {
  return $2 || ($2 = 1, ba.utils = H8(), ba.Cipher = xm(), ba.DES = W8(), ba.CBC = $B(), ba.EDE = VB()), ba;
}
var a0, V2;
function WB() {
  if (V2)
    return a0;
  V2 = 1;
  var t = ma(), e = HB(), r = Lt(), i = Vt().Buffer, f = {
    "des-ede3-cbc": e.CBC.instantiate(e.EDE),
    "des-ede3": e.EDE,
    "des-ede-cbc": e.CBC.instantiate(e.EDE),
    "des-ede": e.EDE,
    "des-cbc": e.CBC.instantiate(e.DES),
    "des-ecb": e.DES
  };
  f.des = f["des-cbc"], f.des3 = f["des-ede3-cbc"], a0 = a, r(a, t);
  function a(l) {
    t.call(this);
    var d = l.mode.toLowerCase(), v = f[d], m;
    l.decrypt ? m = "decrypt" : m = "encrypt";
    var h = l.key;
    i.isBuffer(h) || (h = i.from(h)), (d === "des-ede" || d === "des-ede-cbc") && (h = i.concat([h, h.slice(0, 8)]));
    var w = l.iv;
    i.isBuffer(w) || (w = i.from(w)), this._des = v.create({
      key: h,
      iv: w,
      type: m
    });
  }
  return a.prototype._update = function(l) {
    return i.from(this._des.update(l));
  }, a.prototype._final = function() {
    return i.from(this._des.final());
  }, a0;
}
var yn = {}, bu = {}, wu = {}, H2;
function KB() {
  return H2 || (H2 = 1, wu.encrypt = function(t, e) {
    return t._cipher.encryptBlock(e);
  }, wu.decrypt = function(t, e) {
    return t._cipher.decryptBlock(e);
  }), wu;
}
var _u = {}, s0, W2;
function Wf() {
  return W2 || (W2 = 1, s0 = function(e, r) {
    for (var i = Math.min(e.length, r.length), f = new Je(i), a = 0; a < i; ++a)
      f[a] = e[a] ^ r[a];
    return f;
  }), s0;
}
var K2;
function ZB() {
  if (K2)
    return _u;
  K2 = 1;
  var t = Wf();
  return _u.encrypt = function(e, r) {
    var i = t(r, e._prev);
    return e._prev = e._cipher.encryptBlock(i), e._prev;
  }, _u.decrypt = function(e, r) {
    var i = e._prev;
    e._prev = r;
    var f = e._cipher.decryptBlock(r);
    return t(f, i);
  }, _u;
}
var o0 = {}, Z2;
function GB() {
  if (Z2)
    return o0;
  Z2 = 1;
  var t = Vt().Buffer, e = Wf();
  function r(i, f, a) {
    var l = f.length, d = e(f, i._cache);
    return i._cache = i._cache.slice(l), i._prev = t.concat([i._prev, a ? f : d]), d;
  }
  return o0.encrypt = function(i, f, a) {
    for (var l = t.allocUnsafe(0), d; f.length; )
      if (i._cache.length === 0 && (i._cache = i._cipher.encryptBlock(i._prev), i._prev = t.allocUnsafe(0)), i._cache.length <= f.length)
        d = i._cache.length, l = t.concat([l, r(i, f.slice(0, d), a)]), f = f.slice(d);
      else {
        l = t.concat([l, r(i, f, a)]);
        break;
      }
    return l;
  }, o0;
}
var f0 = {}, G2;
function QB() {
  if (G2)
    return f0;
  G2 = 1;
  var t = Vt().Buffer;
  function e(r, i, f) {
    var a = r._cipher.encryptBlock(r._prev), l = a[0] ^ i;
    return r._prev = t.concat([
      r._prev.slice(1),
      t.from([f ? i : l])
    ]), l;
  }
  return f0.encrypt = function(r, i, f) {
    for (var a = i.length, l = t.allocUnsafe(a), d = -1; ++d < a; )
      l[d] = e(r, i[d], f);
    return l;
  }, f0;
}
var u0 = {}, Q2;
function YB() {
  if (Q2)
    return u0;
  Q2 = 1;
  var t = Vt().Buffer;
  function e(i, f, a) {
    for (var l, d = -1, v = 8, m = 0, h, w; ++d < v; )
      l = i._cipher.encryptBlock(i._prev), h = f & 1 << 7 - d ? 128 : 0, w = l[0] ^ h, m += (w & 128) >> d % 8, i._prev = r(i._prev, a ? h : w);
    return m;
  }
  function r(i, f) {
    var a = i.length, l = -1, d = t.allocUnsafe(i.length);
    for (i = t.concat([i, t.from([f])]); ++l < a; )
      d[l] = i[l] << 1 | i[l + 1] >> 7;
    return d;
  }
  return u0.encrypt = function(i, f, a) {
    for (var l = f.length, d = t.allocUnsafe(l), v = -1; ++v < l; )
      d[v] = e(i, f[v], a);
    return d;
  }, u0;
}
var l0 = {}, Y2;
function JB() {
  if (Y2)
    return l0;
  Y2 = 1;
  var t = Wf();
  function e(r) {
    return r._prev = r._cipher.encryptBlock(r._prev), r._prev;
  }
  return l0.encrypt = function(r, i) {
    for (; r._cache.length < i.length; )
      r._cache = Je.concat([r._cache, e(r)]);
    var f = r._cache.slice(0, i.length);
    return r._cache = r._cache.slice(i.length), t(i, f);
  }, l0;
}
var c0 = {}, d0, J2;
function K8() {
  if (J2)
    return d0;
  J2 = 1;
  function t(e) {
    for (var r = e.length, i; r--; )
      if (i = e.readUInt8(r), i === 255)
        e.writeUInt8(0, r);
      else {
        i++, e.writeUInt8(i, r);
        break;
      }
  }
  return d0 = t, d0;
}
var X2;
function e6() {
  if (X2)
    return c0;
  X2 = 1;
  var t = Wf(), e = Vt().Buffer, r = K8();
  function i(a) {
    var l = a._cipher.encryptBlockRaw(a._prev);
    return r(a._prev), l;
  }
  var f = 16;
  return c0.encrypt = function(a, l) {
    var d = Math.ceil(l.length / f), v = a._cache.length;
    a._cache = e.concat([
      a._cache,
      e.allocUnsafe(d * f)
    ]);
    for (var m = 0; m < d; m++) {
      var h = i(a), w = v + m * f;
      a._cache.writeUInt32BE(h[0], w + 0), a._cache.writeUInt32BE(h[1], w + 4), a._cache.writeUInt32BE(h[2], w + 8), a._cache.writeUInt32BE(h[3], w + 12);
    }
    var M = a._cache.slice(0, l.length);
    return a._cache = a._cache.slice(l.length), t(l, M);
  }, c0;
}
const XB = {
  cipher: "AES",
  key: 128,
  iv: 16,
  mode: "CBC",
  type: "block"
}, eI = {
  cipher: "AES",
  key: 192,
  iv: 16,
  mode: "CBC",
  type: "block"
}, tI = {
  cipher: "AES",
  key: 256,
  iv: 16,
  mode: "CBC",
  type: "block"
}, Z8 = {
  "aes-128-ecb": {
    cipher: "AES",
    key: 128,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-192-ecb": {
    cipher: "AES",
    key: 192,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-256-ecb": {
    cipher: "AES",
    key: 256,
    iv: 0,
    mode: "ECB",
    type: "block"
  },
  "aes-128-cbc": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-192-cbc": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  "aes-256-cbc": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CBC",
    type: "block"
  },
  aes128: XB,
  aes192: eI,
  aes256: tI,
  "aes-128-cfb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-192-cfb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-256-cfb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB",
    type: "stream"
  },
  "aes-128-cfb8": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-192-cfb8": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-256-cfb8": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB8",
    type: "stream"
  },
  "aes-128-cfb1": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-192-cfb1": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-256-cfb1": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CFB1",
    type: "stream"
  },
  "aes-128-ofb": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-192-ofb": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-256-ofb": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "OFB",
    type: "stream"
  },
  "aes-128-ctr": {
    cipher: "AES",
    key: 128,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-192-ctr": {
    cipher: "AES",
    key: 192,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-256-ctr": {
    cipher: "AES",
    key: 256,
    iv: 16,
    mode: "CTR",
    type: "stream"
  },
  "aes-128-gcm": {
    cipher: "AES",
    key: 128,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-192-gcm": {
    cipher: "AES",
    key: 192,
    iv: 12,
    mode: "GCM",
    type: "auth"
  },
  "aes-256-gcm": {
    cipher: "AES",
    key: 256,
    iv: 12,
    mode: "GCM",
    type: "auth"
  }
};
var h0, t6;
function Mm() {
  if (t6)
    return h0;
  t6 = 1;
  var t = {
    ECB: KB(),
    CBC: ZB(),
    CFB: GB(),
    CFB8: QB(),
    CFB1: YB(),
    OFB: JB(),
    CTR: e6(),
    GCM: e6()
  }, e = Z8;
  for (var r in e)
    e[r].module = t[e[r].mode];
  return h0 = e, h0;
}
var p0 = {}, r6;
function yc() {
  if (r6)
    return p0;
  r6 = 1;
  var t = Vt().Buffer;
  function e(d) {
    t.isBuffer(d) || (d = t.from(d));
    for (var v = d.length / 4 | 0, m = new Array(v), h = 0; h < v; h++)
      m[h] = d.readUInt32BE(h * 4);
    return m;
  }
  function r(d) {
    for (var v = 0; v < d.length; d++)
      d[v] = 0;
  }
  function i(d, v, m, h, w) {
    for (var M = m[0], S = m[1], E = m[2], A = m[3], B = d[0] ^ v[0], k = d[1] ^ v[1], C = d[2] ^ v[2], I = d[3] ^ v[3], O, q, $, ae, he = 4, te = 1; te < w; te++)
      O = M[B >>> 24] ^ S[k >>> 16 & 255] ^ E[C >>> 8 & 255] ^ A[I & 255] ^ v[he++], q = M[k >>> 24] ^ S[C >>> 16 & 255] ^ E[I >>> 8 & 255] ^ A[B & 255] ^ v[he++], $ = M[C >>> 24] ^ S[I >>> 16 & 255] ^ E[B >>> 8 & 255] ^ A[k & 255] ^ v[he++], ae = M[I >>> 24] ^ S[B >>> 16 & 255] ^ E[k >>> 8 & 255] ^ A[C & 255] ^ v[he++], B = O, k = q, C = $, I = ae;
    return O = (h[B >>> 24] << 24 | h[k >>> 16 & 255] << 16 | h[C >>> 8 & 255] << 8 | h[I & 255]) ^ v[he++], q = (h[k >>> 24] << 24 | h[C >>> 16 & 255] << 16 | h[I >>> 8 & 255] << 8 | h[B & 255]) ^ v[he++], $ = (h[C >>> 24] << 24 | h[I >>> 16 & 255] << 16 | h[B >>> 8 & 255] << 8 | h[k & 255]) ^ v[he++], ae = (h[I >>> 24] << 24 | h[B >>> 16 & 255] << 16 | h[k >>> 8 & 255] << 8 | h[C & 255]) ^ v[he++], O = O >>> 0, q = q >>> 0, $ = $ >>> 0, ae = ae >>> 0, [O, q, $, ae];
  }
  var f = [0, 1, 2, 4, 8, 16, 32, 64, 128, 27, 54], a = function() {
    for (var d = new Array(256), v = 0; v < 256; v++)
      v < 128 ? d[v] = v << 1 : d[v] = v << 1 ^ 283;
    for (var m = [], h = [], w = [[], [], [], []], M = [[], [], [], []], S = 0, E = 0, A = 0; A < 256; ++A) {
      var B = E ^ E << 1 ^ E << 2 ^ E << 3 ^ E << 4;
      B = B >>> 8 ^ B & 255 ^ 99, m[S] = B, h[B] = S;
      var k = d[S], C = d[k], I = d[C], O = d[B] * 257 ^ B * 16843008;
      w[0][S] = O << 24 | O >>> 8, w[1][S] = O << 16 | O >>> 16, w[2][S] = O << 8 | O >>> 24, w[3][S] = O, O = I * 16843009 ^ C * 65537 ^ k * 257 ^ S * 16843008, M[0][B] = O << 24 | O >>> 8, M[1][B] = O << 16 | O >>> 16, M[2][B] = O << 8 | O >>> 24, M[3][B] = O, S === 0 ? S = E = 1 : (S = k ^ d[d[d[I ^ k]]], E ^= d[d[E]]);
    }
    return {
      SBOX: m,
      INV_SBOX: h,
      SUB_MIX: w,
      INV_SUB_MIX: M
    };
  }();
  function l(d) {
    this._key = e(d), this._reset();
  }
  return l.blockSize = 4 * 4, l.keySize = 256 / 8, l.prototype.blockSize = l.blockSize, l.prototype.keySize = l.keySize, l.prototype._reset = function() {
    for (var d = this._key, v = d.length, m = v + 6, h = (m + 1) * 4, w = [], M = 0; M < v; M++)
      w[M] = d[M];
    for (M = v; M < h; M++) {
      var S = w[M - 1];
      M % v === 0 ? (S = S << 8 | S >>> 24, S = a.SBOX[S >>> 24] << 24 | a.SBOX[S >>> 16 & 255] << 16 | a.SBOX[S >>> 8 & 255] << 8 | a.SBOX[S & 255], S ^= f[M / v | 0] << 24) : v > 6 && M % v === 4 && (S = a.SBOX[S >>> 24] << 24 | a.SBOX[S >>> 16 & 255] << 16 | a.SBOX[S >>> 8 & 255] << 8 | a.SBOX[S & 255]), w[M] = w[M - v] ^ S;
    }
    for (var E = [], A = 0; A < h; A++) {
      var B = h - A, k = w[B - (A % 4 ? 0 : 4)];
      A < 4 || B <= 4 ? E[A] = k : E[A] = a.INV_SUB_MIX[0][a.SBOX[k >>> 24]] ^ a.INV_SUB_MIX[1][a.SBOX[k >>> 16 & 255]] ^ a.INV_SUB_MIX[2][a.SBOX[k >>> 8 & 255]] ^ a.INV_SUB_MIX[3][a.SBOX[k & 255]];
    }
    this._nRounds = m, this._keySchedule = w, this._invKeySchedule = E;
  }, l.prototype.encryptBlockRaw = function(d) {
    return d = e(d), i(d, this._keySchedule, a.SUB_MIX, a.SBOX, this._nRounds);
  }, l.prototype.encryptBlock = function(d) {
    var v = this.encryptBlockRaw(d), m = t.allocUnsafe(16);
    return m.writeUInt32BE(v[0], 0), m.writeUInt32BE(v[1], 4), m.writeUInt32BE(v[2], 8), m.writeUInt32BE(v[3], 12), m;
  }, l.prototype.decryptBlock = function(d) {
    d = e(d);
    var v = d[1];
    d[1] = d[3], d[3] = v;
    var m = i(d, this._invKeySchedule, a.INV_SUB_MIX, a.INV_SBOX, this._nRounds), h = t.allocUnsafe(16);
    return h.writeUInt32BE(m[0], 0), h.writeUInt32BE(m[3], 4), h.writeUInt32BE(m[2], 8), h.writeUInt32BE(m[1], 12), h;
  }, l.prototype.scrub = function() {
    r(this._keySchedule), r(this._invKeySchedule), r(this._key);
  }, p0.AES = l, p0;
}
var v0, n6;
function rI() {
  if (n6)
    return v0;
  n6 = 1;
  var t = Vt().Buffer, e = t.alloc(16, 0);
  function r(a) {
    return [
      a.readUInt32BE(0),
      a.readUInt32BE(4),
      a.readUInt32BE(8),
      a.readUInt32BE(12)
    ];
  }
  function i(a) {
    var l = t.allocUnsafe(16);
    return l.writeUInt32BE(a[0] >>> 0, 0), l.writeUInt32BE(a[1] >>> 0, 4), l.writeUInt32BE(a[2] >>> 0, 8), l.writeUInt32BE(a[3] >>> 0, 12), l;
  }
  function f(a) {
    this.h = a, this.state = t.alloc(16, 0), this.cache = t.allocUnsafe(0);
  }
  return f.prototype.ghash = function(a) {
    for (var l = -1; ++l < a.length; )
      this.state[l] ^= a[l];
    this._multiply();
  }, f.prototype._multiply = function() {
    for (var a = r(this.h), l = [0, 0, 0, 0], d, v, m, h = -1; ++h < 128; ) {
      for (v = (this.state[~~(h / 8)] & 1 << 7 - h % 8) !== 0, v && (l[0] ^= a[0], l[1] ^= a[1], l[2] ^= a[2], l[3] ^= a[3]), m = (a[3] & 1) !== 0, d = 3; d > 0; d--)
        a[d] = a[d] >>> 1 | (a[d - 1] & 1) << 31;
      a[0] = a[0] >>> 1, m && (a[0] = a[0] ^ 225 << 24);
    }
    this.state = i(l);
  }, f.prototype.update = function(a) {
    this.cache = t.concat([this.cache, a]);
    for (var l; this.cache.length >= 16; )
      l = this.cache.slice(0, 16), this.cache = this.cache.slice(16), this.ghash(l);
  }, f.prototype.final = function(a, l) {
    return this.cache.length && this.ghash(t.concat([this.cache, e], 16)), this.ghash(i([0, a, 0, l])), this.state;
  }, v0 = f, v0;
}
var m0, i6;
function G8() {
  if (i6)
    return m0;
  i6 = 1;
  var t = yc(), e = Vt().Buffer, r = ma(), i = Lt(), f = rI(), a = Wf(), l = K8();
  function d(h, w) {
    var M = 0;
    h.length !== w.length && M++;
    for (var S = Math.min(h.length, w.length), E = 0; E < S; ++E)
      M += h[E] ^ w[E];
    return M;
  }
  function v(h, w, M) {
    if (w.length === 12)
      return h._finID = e.concat([w, e.from([0, 0, 0, 1])]), e.concat([w, e.from([0, 0, 0, 2])]);
    var S = new f(M), E = w.length, A = E % 16;
    S.update(w), A && (A = 16 - A, S.update(e.alloc(A, 0))), S.update(e.alloc(8, 0));
    var B = E * 8, k = e.alloc(8);
    k.writeUIntBE(B, 0, 8), S.update(k), h._finID = S.state;
    var C = e.from(h._finID);
    return l(C), C;
  }
  function m(h, w, M, S) {
    r.call(this);
    var E = e.alloc(4, 0);
    this._cipher = new t.AES(w);
    var A = this._cipher.encryptBlock(E);
    this._ghash = new f(A), M = v(this, M, A), this._prev = e.from(M), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = S, this._alen = 0, this._len = 0, this._mode = h, this._authTag = null, this._called = !1;
  }
  return i(m, r), m.prototype._update = function(h) {
    if (!this._called && this._alen) {
      var w = 16 - this._alen % 16;
      w < 16 && (w = e.alloc(w, 0), this._ghash.update(w));
    }
    this._called = !0;
    var M = this._mode.encrypt(this, h);
    return this._decrypt ? this._ghash.update(h) : this._ghash.update(M), this._len += h.length, M;
  }, m.prototype._final = function() {
    if (this._decrypt && !this._authTag)
      throw new Error("Unsupported state or unable to authenticate data");
    var h = a(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && d(h, this._authTag))
      throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = h, this._cipher.scrub();
  }, m.prototype.getAuthTag = function() {
    if (this._decrypt || !e.isBuffer(this._authTag))
      throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
  }, m.prototype.setAuthTag = function(w) {
    if (!this._decrypt)
      throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = w;
  }, m.prototype.setAAD = function(w) {
    if (this._called)
      throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(w), this._alen += w.length;
  }, m0 = m, m0;
}
var g0, a6;
function Q8() {
  if (a6)
    return g0;
  a6 = 1;
  var t = yc(), e = Vt().Buffer, r = ma(), i = Lt();
  function f(a, l, d, v) {
    r.call(this), this._cipher = new t.AES(l), this._prev = e.from(d), this._cache = e.allocUnsafe(0), this._secCache = e.allocUnsafe(0), this._decrypt = v, this._mode = a;
  }
  return i(f, r), f.prototype._update = function(a) {
    return this._mode.encrypt(this, a, this._decrypt);
  }, f.prototype._final = function() {
    this._cipher.scrub();
  }, g0 = f, g0;
}
var y0, s6;
function bc() {
  if (s6)
    return y0;
  s6 = 1;
  var t = Vt().Buffer, e = bm();
  function r(i, f, a, l) {
    if (t.isBuffer(i) || (i = t.from(i, "binary")), f && (t.isBuffer(f) || (f = t.from(f, "binary")), f.length !== 8))
      throw new RangeError("salt should be Buffer with 8 byte length");
    for (var d = a / 8, v = t.alloc(d), m = t.alloc(l || 0), h = t.alloc(0); d > 0 || l > 0; ) {
      var w = new e();
      w.update(h), w.update(i), f && w.update(f), h = w.digest();
      var M = 0;
      if (d > 0) {
        var S = v.length - d;
        M = Math.min(d, h.length), h.copy(v, S, 0, M), d -= M;
      }
      if (M < h.length && l > 0) {
        var E = m.length - l, A = Math.min(l, h.length - M);
        h.copy(m, E, M, M + A), l -= A;
      }
    }
    return h.fill(0), { key: v, iv: m };
  }
  return y0 = r, y0;
}
var o6;
function nI() {
  if (o6)
    return bu;
  o6 = 1;
  var t = Mm(), e = G8(), r = Vt().Buffer, i = Q8(), f = ma(), a = yc(), l = bc(), d = Lt();
  function v(S, E, A) {
    f.call(this), this._cache = new h(), this._cipher = new a.AES(E), this._prev = r.from(A), this._mode = S, this._autopadding = !0;
  }
  d(v, f), v.prototype._update = function(S) {
    this._cache.add(S);
    for (var E, A, B = []; E = this._cache.get(); )
      A = this._mode.encrypt(this, E), B.push(A);
    return r.concat(B);
  };
  var m = r.alloc(16, 16);
  v.prototype._final = function() {
    var S = this._cache.flush();
    if (this._autopadding)
      return S = this._mode.encrypt(this, S), this._cipher.scrub(), S;
    if (!S.equals(m))
      throw this._cipher.scrub(), new Error("data not multiple of block length");
  }, v.prototype.setAutoPadding = function(S) {
    return this._autopadding = !!S, this;
  };
  function h() {
    this.cache = r.allocUnsafe(0);
  }
  h.prototype.add = function(S) {
    this.cache = r.concat([this.cache, S]);
  }, h.prototype.get = function() {
    if (this.cache.length > 15) {
      var S = this.cache.slice(0, 16);
      return this.cache = this.cache.slice(16), S;
    }
    return null;
  }, h.prototype.flush = function() {
    for (var S = 16 - this.cache.length, E = r.allocUnsafe(S), A = -1; ++A < S; )
      E.writeUInt8(S, A);
    return r.concat([this.cache, E]);
  };
  function w(S, E, A) {
    var B = t[S.toLowerCase()];
    if (!B)
      throw new TypeError("invalid suite type");
    if (typeof E == "string" && (E = r.from(E)), E.length !== B.key / 8)
      throw new TypeError("invalid key length " + E.length);
    if (typeof A == "string" && (A = r.from(A)), B.mode !== "GCM" && A.length !== B.iv)
      throw new TypeError("invalid iv length " + A.length);
    return B.type === "stream" ? new i(B.module, E, A) : B.type === "auth" ? new e(B.module, E, A) : new v(B.module, E, A);
  }
  function M(S, E) {
    var A = t[S.toLowerCase()];
    if (!A)
      throw new TypeError("invalid suite type");
    var B = l(E, !1, A.key, A.iv);
    return w(S, B.key, B.iv);
  }
  return bu.createCipheriv = w, bu.createCipher = M, bu;
}
var xu = {}, f6;
function iI() {
  if (f6)
    return xu;
  f6 = 1;
  var t = G8(), e = Vt().Buffer, r = Mm(), i = Q8(), f = ma(), a = yc(), l = bc(), d = Lt();
  function v(S, E, A) {
    f.call(this), this._cache = new m(), this._last = void 0, this._cipher = new a.AES(E), this._prev = e.from(A), this._mode = S, this._autopadding = !0;
  }
  d(v, f), v.prototype._update = function(S) {
    this._cache.add(S);
    for (var E, A, B = []; E = this._cache.get(this._autopadding); )
      A = this._mode.decrypt(this, E), B.push(A);
    return e.concat(B);
  }, v.prototype._final = function() {
    var S = this._cache.flush();
    if (this._autopadding)
      return h(this._mode.decrypt(this, S));
    if (S)
      throw new Error("data not multiple of block length");
  }, v.prototype.setAutoPadding = function(S) {
    return this._autopadding = !!S, this;
  };
  function m() {
    this.cache = e.allocUnsafe(0);
  }
  m.prototype.add = function(S) {
    this.cache = e.concat([this.cache, S]);
  }, m.prototype.get = function(S) {
    var E;
    if (S) {
      if (this.cache.length > 16)
        return E = this.cache.slice(0, 16), this.cache = this.cache.slice(16), E;
    } else if (this.cache.length >= 16)
      return E = this.cache.slice(0, 16), this.cache = this.cache.slice(16), E;
    return null;
  }, m.prototype.flush = function() {
    if (this.cache.length)
      return this.cache;
  };
  function h(S) {
    var E = S[15];
    if (E < 1 || E > 16)
      throw new Error("unable to decrypt data");
    for (var A = -1; ++A < E; )
      if (S[A + (16 - E)] !== E)
        throw new Error("unable to decrypt data");
    if (E !== 16)
      return S.slice(0, 16 - E);
  }
  function w(S, E, A) {
    var B = r[S.toLowerCase()];
    if (!B)
      throw new TypeError("invalid suite type");
    if (typeof A == "string" && (A = e.from(A)), B.mode !== "GCM" && A.length !== B.iv)
      throw new TypeError("invalid iv length " + A.length);
    if (typeof E == "string" && (E = e.from(E)), E.length !== B.key / 8)
      throw new TypeError("invalid key length " + E.length);
    return B.type === "stream" ? new i(B.module, E, A, !0) : B.type === "auth" ? new t(B.module, E, A, !0) : new v(B.module, E, A);
  }
  function M(S, E) {
    var A = r[S.toLowerCase()];
    if (!A)
      throw new TypeError("invalid suite type");
    var B = l(E, !1, A.key, A.iv);
    return w(S, B.key, B.iv);
  }
  return xu.createDecipher = M, xu.createDecipheriv = w, xu;
}
var u6;
function Sm() {
  if (u6)
    return yn;
  u6 = 1;
  var t = nI(), e = iI(), r = Z8;
  function i() {
    return Object.keys(r);
  }
  return yn.createCipher = yn.Cipher = t.createCipher, yn.createCipheriv = yn.Cipheriv = t.createCipheriv, yn.createDecipher = yn.Decipher = e.createDecipher, yn.createDecipheriv = yn.Decipheriv = e.createDecipheriv, yn.listCiphers = yn.getCiphers = i, yn;
}
var b0 = {}, l6;
function aI() {
  return l6 || (l6 = 1, function(t) {
    t["des-ecb"] = {
      key: 8,
      iv: 0
    }, t["des-cbc"] = t.des = {
      key: 8,
      iv: 8
    }, t["des-ede3-cbc"] = t.des3 = {
      key: 24,
      iv: 8
    }, t["des-ede3"] = {
      key: 24,
      iv: 0
    }, t["des-ede-cbc"] = {
      key: 16,
      iv: 8
    }, t["des-ede"] = {
      key: 16,
      iv: 0
    };
  }(b0)), b0;
}
var c6;
function sI() {
  if (c6)
    return gn;
  c6 = 1;
  var t = WB(), e = Sm(), r = Mm(), i = aI(), f = bc();
  function a(h, w) {
    h = h.toLowerCase();
    var M, S;
    if (r[h])
      M = r[h].key, S = r[h].iv;
    else if (i[h])
      M = i[h].key * 8, S = i[h].iv;
    else
      throw new TypeError("invalid suite type");
    var E = f(w, !1, M, S);
    return d(h, E.key, E.iv);
  }
  function l(h, w) {
    h = h.toLowerCase();
    var M, S;
    if (r[h])
      M = r[h].key, S = r[h].iv;
    else if (i[h])
      M = i[h].key * 8, S = i[h].iv;
    else
      throw new TypeError("invalid suite type");
    var E = f(w, !1, M, S);
    return v(h, E.key, E.iv);
  }
  function d(h, w, M) {
    if (h = h.toLowerCase(), r[h])
      return e.createCipheriv(h, w, M);
    if (i[h])
      return new t({ key: w, iv: M, mode: h });
    throw new TypeError("invalid suite type");
  }
  function v(h, w, M) {
    if (h = h.toLowerCase(), r[h])
      return e.createDecipheriv(h, w, M);
    if (i[h])
      return new t({ key: w, iv: M, mode: h, decrypt: !0 });
    throw new TypeError("invalid suite type");
  }
  function m() {
    return Object.keys(i).concat(e.getCiphers());
  }
  return gn.createCipher = gn.Cipher = a, gn.createCipheriv = gn.Cipheriv = d, gn.createDecipher = gn.Decipher = l, gn.createDecipheriv = gn.Decipheriv = v, gn.listCiphers = gn.getCiphers = m, gn;
}
var wa = {}, Ku = { exports: {} };
Ku.exports;
var d6;
function Y8() {
  return d6 || (d6 = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(Ku)), Ku.exports;
}
var Zu = { exports: {} };
Zu.exports;
var h6;
function oI() {
  return h6 || (h6 = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(Zu)), Zu.exports;
}
var Mu = { exports: {} }, p6;
function Kf() {
  if (p6)
    return Mu.exports;
  p6 = 1;
  var t;
  Mu.exports = function(f) {
    return t || (t = new e(null)), t.generate(f);
  };
  function e(i) {
    this.rand = i;
  }
  if (Mu.exports.Rand = e, e.prototype.generate = function(f) {
    return this._rand(f);
  }, e.prototype._rand = function(f) {
    if (this.rand.getBytes)
      return this.rand.getBytes(f);
    for (var a = new Uint8Array(f), l = 0; l < a.length; l++)
      a[l] = this.rand.getByte();
    return a;
  }, typeof self == "object")
    self.crypto && self.crypto.getRandomValues ? e.prototype._rand = function(f) {
      var a = new Uint8Array(f);
      return self.crypto.getRandomValues(a), a;
    } : self.msCrypto && self.msCrypto.getRandomValues ? e.prototype._rand = function(f) {
      var a = new Uint8Array(f);
      return self.msCrypto.getRandomValues(a), a;
    } : typeof window == "object" && (e.prototype._rand = function() {
      throw new Error("Not implemented yet");
    });
  else
    try {
      var r = b_();
      if (typeof r.randomBytes != "function")
        throw new Error("Not supported");
      e.prototype._rand = function(f) {
        return r.randomBytes(f);
      };
    } catch {
    }
  return Mu.exports;
}
var w0, v6;
function J8() {
  if (v6)
    return w0;
  v6 = 1;
  var t = oI(), e = Kf();
  function r(i) {
    this.rand = i || new e.Rand();
  }
  return w0 = r, r.create = function(f) {
    return new r(f);
  }, r.prototype._randbelow = function(f) {
    var a = f.bitLength(), l = Math.ceil(a / 8);
    do
      var d = new t(this.rand.generate(l));
    while (d.cmp(f) >= 0);
    return d;
  }, r.prototype._randrange = function(f, a) {
    var l = a.sub(f);
    return f.add(this._randbelow(l));
  }, r.prototype.test = function(f, a, l) {
    var d = f.bitLength(), v = t.mont(f), m = new t(1).toRed(v);
    a || (a = Math.max(1, d / 48 | 0));
    for (var h = f.subn(1), w = 0; !h.testn(w); w++)
      ;
    for (var M = f.shrn(w), S = h.toRed(v), E = !0; a > 0; a--) {
      var A = this._randrange(new t(2), h);
      l && l(A);
      var B = A.toRed(v).redPow(M);
      if (!(B.cmp(m) === 0 || B.cmp(S) === 0)) {
        for (var k = 1; k < w; k++) {
          if (B = B.redSqr(), B.cmp(m) === 0)
            return !1;
          if (B.cmp(S) === 0)
            break;
        }
        if (k === w)
          return !1;
      }
    }
    return E;
  }, r.prototype.getDivisor = function(f, a) {
    var l = f.bitLength(), d = t.mont(f), v = new t(1).toRed(d);
    a || (a = Math.max(1, l / 48 | 0));
    for (var m = f.subn(1), h = 0; !m.testn(h); h++)
      ;
    for (var w = f.shrn(h), M = m.toRed(d); a > 0; a--) {
      var S = this._randrange(new t(2), m), E = f.gcd(S);
      if (E.cmpn(1) !== 0)
        return E;
      var A = S.toRed(d).redPow(w);
      if (!(A.cmp(v) === 0 || A.cmp(M) === 0)) {
        for (var B = 1; B < h; B++) {
          if (A = A.redSqr(), A.cmp(v) === 0)
            return A.fromRed().subn(1).gcd(f);
          if (A.cmp(M) === 0)
            break;
        }
        if (B === h)
          return A = A.redSqr(), A.fromRed().subn(1).gcd(f);
      }
    }
    return !1;
  }, w0;
}
var _0, m6;
function X8() {
  if (m6)
    return _0;
  m6 = 1;
  var t = go();
  _0 = B, B.simpleSieve = E, B.fermatTest = A;
  var e = Y8(), r = new e(24), i = J8(), f = new i(), a = new e(1), l = new e(2), d = new e(5);
  new e(16), new e(8);
  var v = new e(10), m = new e(3);
  new e(7);
  var h = new e(11), w = new e(4);
  new e(12);
  var M = null;
  function S() {
    if (M !== null)
      return M;
    var k = 1048576, C = [];
    C[0] = 2;
    for (var I = 1, O = 3; O < k; O += 2) {
      for (var q = Math.ceil(Math.sqrt(O)), $ = 0; $ < I && C[$] <= q && O % C[$] !== 0; $++)
        ;
      I !== $ && C[$] <= q || (C[I++] = O);
    }
    return M = C, C;
  }
  function E(k) {
    for (var C = S(), I = 0; I < C.length; I++)
      if (k.modn(C[I]) === 0)
        return k.cmpn(C[I]) === 0;
    return !0;
  }
  function A(k) {
    var C = e.mont(k);
    return l.toRed(C).redPow(k.subn(1)).fromRed().cmpn(1) === 0;
  }
  function B(k, C) {
    if (k < 16)
      return C === 2 || C === 5 ? new e([140, 123]) : new e([140, 39]);
    C = new e(C);
    for (var I, O; ; ) {
      for (I = new e(t(Math.ceil(k / 8))); I.bitLength() > k; )
        I.ishrn(1);
      if (I.isEven() && I.iadd(a), I.testn(1) || I.iadd(l), C.cmp(l)) {
        if (!C.cmp(d))
          for (; I.mod(v).cmp(m); )
            I.iadd(w);
      } else
        for (; I.mod(r).cmp(h); )
          I.iadd(w);
      if (O = I.shrn(1), E(O) && E(I) && A(O) && A(I) && f.test(O) && f.test(I))
        return I;
    }
  }
  return _0;
}
const fI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"
}, uI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"
}, lI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"
}, cI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"
}, dI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"
}, hI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"
}, pI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"
}, vI = {
  gen: "02",
  prime: "ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dbe115974a3926f12fee5e438777cb6a932df8cd8bec4d073b931ba3bc832b68d9dd300741fa7bf8afc47ed2576f6936ba424663aab639c5ae4f5683423b4742bf1c978238f16cbe39d652de3fdb8befc848ad922222e04a4037c0713eb57a81a23f0c73473fc646cea306b4bcbc8862f8385ddfa9d4b7fa2c087e879683303ed5bdd3a062b3cf5b3a278a66d2a13f83f44f82ddf310ee074ab6a364597e899a0255dc164f31cc50846851df9ab48195ded7ea1b1d510bd7ee74d73faf36bc31ecfa268359046f4eb879f924009438b481c6cd7889a002ed5ee382bc9190da6fc026e479558e4475677e9aa9e3050e2765694dfc81f56e880b96e7160c980dd98edd3dfffffffffffffffff"
}, mI = {
  modp1: fI,
  modp2: uI,
  modp5: lI,
  modp14: cI,
  modp15: dI,
  modp16: hI,
  modp17: pI,
  modp18: vI
};
var x0, g6;
function gI() {
  if (g6)
    return x0;
  g6 = 1;
  var t = Y8(), e = J8(), r = new e(), i = new t(24), f = new t(11), a = new t(10), l = new t(3), d = new t(7), v = X8(), m = go();
  x0 = E;
  function h(B, k) {
    return k = k || "utf8", Je.isBuffer(B) || (B = new Je(B, k)), this._pub = new t(B), this;
  }
  function w(B, k) {
    return k = k || "utf8", Je.isBuffer(B) || (B = new Je(B, k)), this._priv = new t(B), this;
  }
  var M = {};
  function S(B, k) {
    var C = k.toString("hex"), I = [C, B.toString(16)].join("_");
    if (I in M)
      return M[I];
    var O = 0;
    if (B.isEven() || !v.simpleSieve || !v.fermatTest(B) || !r.test(B))
      return O += 1, C === "02" || C === "05" ? O += 8 : O += 4, M[I] = O, O;
    r.test(B.shrn(1)) || (O += 2);
    var q;
    switch (C) {
      case "02":
        B.mod(i).cmp(f) && (O += 8);
        break;
      case "05":
        q = B.mod(a), q.cmp(l) && q.cmp(d) && (O += 8);
        break;
      default:
        O += 4;
    }
    return M[I] = O, O;
  }
  function E(B, k, C) {
    this.setGenerator(k), this.__prime = new t(B), this._prime = t.mont(this.__prime), this._primeLen = B.length, this._pub = void 0, this._priv = void 0, this._primeCode = void 0, C ? (this.setPublicKey = h, this.setPrivateKey = w) : this._primeCode = 8;
  }
  Object.defineProperty(E.prototype, "verifyError", {
    enumerable: !0,
    get: function() {
      return typeof this._primeCode != "number" && (this._primeCode = S(this.__prime, this.__gen)), this._primeCode;
    }
  }), E.prototype.generateKeys = function() {
    return this._priv || (this._priv = new t(m(this._primeLen))), this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed(), this.getPublicKey();
  }, E.prototype.computeSecret = function(B) {
    B = new t(B), B = B.toRed(this._prime);
    var k = B.redPow(this._priv).fromRed(), C = new Je(k.toArray()), I = this.getPrime();
    if (C.length < I.length) {
      var O = new Je(I.length - C.length);
      O.fill(0), C = Je.concat([O, C]);
    }
    return C;
  }, E.prototype.getPublicKey = function(k) {
    return A(this._pub, k);
  }, E.prototype.getPrivateKey = function(k) {
    return A(this._priv, k);
  }, E.prototype.getPrime = function(B) {
    return A(this.__prime, B);
  }, E.prototype.getGenerator = function(B) {
    return A(this._gen, B);
  }, E.prototype.setGenerator = function(B, k) {
    return k = k || "utf8", Je.isBuffer(B) || (B = new Je(B, k)), this.__gen = B, this._gen = new t(B), this;
  };
  function A(B, k) {
    var C = new Je(B.toArray());
    return k ? C.toString(k) : C;
  }
  return x0;
}
var y6;
function yI() {
  if (y6)
    return wa;
  y6 = 1;
  var t = X8(), e = mI, r = gI();
  function i(l) {
    var d = new Je(e[l].prime, "hex"), v = new Je(e[l].gen, "hex");
    return new r(d, v);
  }
  var f = {
    binary: !0,
    hex: !0,
    base64: !0
  };
  function a(l, d, v, m) {
    return Je.isBuffer(d) || f[d] === void 0 ? a(l, "binary", d, v) : (d = d || "binary", m = m || "binary", v = v || new Je([2]), Je.isBuffer(v) || (v = new Je(v, m)), typeof l == "number" ? new r(t(l, v), v, !0) : (Je.isBuffer(l) || (l = new Je(l, d)), new r(l, v, !0)));
  }
  return wa.DiffieHellmanGroup = wa.createDiffieHellmanGroup = wa.getDiffieHellman = i, wa.createDiffieHellman = wa.DiffieHellman = a, wa;
}
var Su = { exports: {} }, Eu = { exports: {} }, b6;
function wc() {
  if (b6)
    return Eu.exports;
  b6 = 1, typeof It > "u" || !It.version || It.version.indexOf("v0.") === 0 || It.version.indexOf("v1.") === 0 && It.version.indexOf("v1.8.") !== 0 ? Eu.exports = { nextTick: t } : Eu.exports = It;
  function t(e, r, i, f) {
    if (typeof e != "function")
      throw new TypeError('"callback" argument must be a function');
    var a = arguments.length, l, d;
    switch (a) {
      case 0:
      case 1:
        return It.nextTick(e);
      case 2:
        return It.nextTick(function() {
          e.call(null, r);
        });
      case 3:
        return It.nextTick(function() {
          e.call(null, r, i);
        });
      case 4:
        return It.nextTick(function() {
          e.call(null, r, i, f);
        });
      default:
        for (l = new Array(a - 1), d = 0; d < l.length; )
          l[d++] = arguments[d];
        return It.nextTick(function() {
          e.apply(null, l);
        });
    }
  }
  return Eu.exports;
}
var M0, w6;
function bI() {
  if (w6)
    return M0;
  w6 = 1;
  var t = {}.toString;
  return M0 = Array.isArray || function(e) {
    return t.call(e) == "[object Array]";
  }, M0;
}
var S0, _6;
function e_() {
  return _6 || (_6 = 1, S0 = $f().EventEmitter), S0;
}
var Au = { exports: {} }, x6;
function Em() {
  return x6 || (x6 = 1, function(t, e) {
    var r = kr, i = r.Buffer;
    function f(l, d) {
      for (var v in l)
        d[v] = l[v];
    }
    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = r : (f(r, e), e.Buffer = a);
    function a(l, d, v) {
      return i(l, d, v);
    }
    f(i, a), a.from = function(l, d, v) {
      if (typeof l == "number")
        throw new TypeError("Argument must not be a number");
      return i(l, d, v);
    }, a.alloc = function(l, d, v) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      var m = i(l);
      return d !== void 0 ? typeof v == "string" ? m.fill(d, v) : m.fill(d) : m.fill(0), m;
    }, a.allocUnsafe = function(l) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      return i(l);
    }, a.allocUnsafeSlow = function(l) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      return r.SlowBuffer(l);
    };
  }(Au, Au.exports)), Au.exports;
}
var Rr = {}, M6;
function Zf() {
  if (M6)
    return Rr;
  M6 = 1;
  function t(A) {
    return Array.isArray ? Array.isArray(A) : E(A) === "[object Array]";
  }
  Rr.isArray = t;
  function e(A) {
    return typeof A == "boolean";
  }
  Rr.isBoolean = e;
  function r(A) {
    return A === null;
  }
  Rr.isNull = r;
  function i(A) {
    return A == null;
  }
  Rr.isNullOrUndefined = i;
  function f(A) {
    return typeof A == "number";
  }
  Rr.isNumber = f;
  function a(A) {
    return typeof A == "string";
  }
  Rr.isString = a;
  function l(A) {
    return typeof A == "symbol";
  }
  Rr.isSymbol = l;
  function d(A) {
    return A === void 0;
  }
  Rr.isUndefined = d;
  function v(A) {
    return E(A) === "[object RegExp]";
  }
  Rr.isRegExp = v;
  function m(A) {
    return typeof A == "object" && A !== null;
  }
  Rr.isObject = m;
  function h(A) {
    return E(A) === "[object Date]";
  }
  Rr.isDate = h;
  function w(A) {
    return E(A) === "[object Error]" || A instanceof Error;
  }
  Rr.isError = w;
  function M(A) {
    return typeof A == "function";
  }
  Rr.isFunction = M;
  function S(A) {
    return A === null || typeof A == "boolean" || typeof A == "number" || typeof A == "string" || typeof A == "symbol" || // ES6 symbol
    typeof A > "u";
  }
  Rr.isPrimitive = S, Rr.isBuffer = kr.Buffer.isBuffer;
  function E(A) {
    return Object.prototype.toString.call(A);
  }
  return Rr;
}
var E0 = { exports: {} }, S6;
function wI() {
  return S6 || (S6 = 1, function(t) {
    function e(a, l) {
      if (!(a instanceof l))
        throw new TypeError("Cannot call a class as a function");
    }
    var r = Em().Buffer, i = mc();
    function f(a, l, d) {
      a.copy(l, d);
    }
    t.exports = function() {
      function a() {
        e(this, a), this.head = null, this.tail = null, this.length = 0;
      }
      return a.prototype.push = function(d) {
        var v = { data: d, next: null };
        this.length > 0 ? this.tail.next = v : this.head = v, this.tail = v, ++this.length;
      }, a.prototype.unshift = function(d) {
        var v = { data: d, next: this.head };
        this.length === 0 && (this.tail = v), this.head = v, ++this.length;
      }, a.prototype.shift = function() {
        if (this.length !== 0) {
          var d = this.head.data;
          return this.length === 1 ? this.head = this.tail = null : this.head = this.head.next, --this.length, d;
        }
      }, a.prototype.clear = function() {
        this.head = this.tail = null, this.length = 0;
      }, a.prototype.join = function(d) {
        if (this.length === 0)
          return "";
        for (var v = this.head, m = "" + v.data; v = v.next; )
          m += d + v.data;
        return m;
      }, a.prototype.concat = function(d) {
        if (this.length === 0)
          return r.alloc(0);
        for (var v = r.allocUnsafe(d >>> 0), m = this.head, h = 0; m; )
          f(m.data, v, h), h += m.data.length, m = m.next;
        return v;
      }, a;
    }(), i && i.inspect && i.inspect.custom && (t.exports.prototype[i.inspect.custom] = function() {
      var a = i.inspect({ length: this.length });
      return this.constructor.name + " " + a;
    });
  }(E0)), E0.exports;
}
var A0, E6;
function t_() {
  if (E6)
    return A0;
  E6 = 1;
  var t = wc();
  function e(f, a) {
    var l = this, d = this._readableState && this._readableState.destroyed, v = this._writableState && this._writableState.destroyed;
    return d || v ? (a ? a(f) : f && (this._writableState ? this._writableState.errorEmitted || (this._writableState.errorEmitted = !0, t.nextTick(i, this, f)) : t.nextTick(i, this, f)), this) : (this._readableState && (this._readableState.destroyed = !0), this._writableState && (this._writableState.destroyed = !0), this._destroy(f || null, function(m) {
      !a && m ? l._writableState ? l._writableState.errorEmitted || (l._writableState.errorEmitted = !0, t.nextTick(i, l, m)) : t.nextTick(i, l, m) : a && a(m);
    }), this);
  }
  function r() {
    this._readableState && (this._readableState.destroyed = !1, this._readableState.reading = !1, this._readableState.ended = !1, this._readableState.endEmitted = !1), this._writableState && (this._writableState.destroyed = !1, this._writableState.ended = !1, this._writableState.ending = !1, this._writableState.finalCalled = !1, this._writableState.prefinished = !1, this._writableState.finished = !1, this._writableState.errorEmitted = !1);
  }
  function i(f, a) {
    f.emit("error", a);
  }
  return A0 = {
    destroy: e,
    undestroy: r
  }, A0;
}
var k0, A6;
function r_() {
  if (A6)
    return k0;
  A6 = 1;
  var t = wc();
  k0 = A;
  function e(b) {
    var _ = this;
    this.next = null, this.entry = null, this.finish = function() {
      g(_, b);
    };
  }
  var r = !It.browser && ["v0.10", "v0.9."].indexOf(It.version.slice(0, 5)) > -1 ? setImmediate : t.nextTick, i;
  A.WritableState = S;
  var f = Object.create(Zf());
  f.inherits = Lt();
  var a = {
    deprecate: I8()
  }, l = e_(), d = Em().Buffer, v = (typeof ut < "u" ? ut : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function m(b) {
    return d.from(b);
  }
  function h(b) {
    return d.isBuffer(b) || b instanceof v;
  }
  var w = t_();
  f.inherits(A, l);
  function M() {
  }
  function S(b, _) {
    i = i || Qs(), b = b || {};
    var p = _ instanceof i;
    this.objectMode = !!b.objectMode, p && (this.objectMode = this.objectMode || !!b.writableObjectMode);
    var s = b.highWaterMark, y = b.writableHighWaterMark, T = this.objectMode ? 16 : 16 * 1024;
    s || s === 0 ? this.highWaterMark = s : p && (y || y === 0) ? this.highWaterMark = y : this.highWaterMark = T, this.highWaterMark = Math.floor(this.highWaterMark), this.finalCalled = !1, this.needDrain = !1, this.ending = !1, this.ended = !1, this.finished = !1, this.destroyed = !1;
    var P = b.decodeStrings === !1;
    this.decodeStrings = !P, this.defaultEncoding = b.defaultEncoding || "utf8", this.length = 0, this.writing = !1, this.corked = 0, this.sync = !0, this.bufferProcessing = !1, this.onwrite = function(z) {
      ae(_, z);
    }, this.writecb = null, this.writelen = 0, this.bufferedRequest = null, this.lastBufferedRequest = null, this.pendingcb = 0, this.prefinished = !1, this.errorEmitted = !1, this.bufferedRequestCount = 0, this.corkedRequestsFree = new e(this);
  }
  S.prototype.getBuffer = function() {
    for (var _ = this.bufferedRequest, p = []; _; )
      p.push(_), _ = _.next;
    return p;
  }, function() {
    try {
      Object.defineProperty(S.prototype, "buffer", {
        get: a.deprecate(function() {
          return this.getBuffer();
        }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
      });
    } catch {
    }
  }();
  var E;
  typeof Symbol == "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] == "function" ? (E = Function.prototype[Symbol.hasInstance], Object.defineProperty(A, Symbol.hasInstance, {
    value: function(b) {
      return E.call(this, b) ? !0 : this !== A ? !1 : b && b._writableState instanceof S;
    }
  })) : E = function(b) {
    return b instanceof this;
  };
  function A(b) {
    if (i = i || Qs(), !E.call(A, this) && !(this instanceof i))
      return new A(b);
    this._writableState = new S(b, this), this.writable = !0, b && (typeof b.write == "function" && (this._write = b.write), typeof b.writev == "function" && (this._writev = b.writev), typeof b.destroy == "function" && (this._destroy = b.destroy), typeof b.final == "function" && (this._final = b.final)), l.call(this);
  }
  A.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
  };
  function B(b, _) {
    var p = new Error("write after end");
    b.emit("error", p), t.nextTick(_, p);
  }
  function k(b, _, p, s) {
    var y = !0, T = !1;
    return p === null ? T = new TypeError("May not write null values to stream") : typeof p != "string" && p !== void 0 && !_.objectMode && (T = new TypeError("Invalid non-string/buffer chunk")), T && (b.emit("error", T), t.nextTick(s, T), y = !1), y;
  }
  A.prototype.write = function(b, _, p) {
    var s = this._writableState, y = !1, T = !s.objectMode && h(b);
    return T && !d.isBuffer(b) && (b = m(b)), typeof _ == "function" && (p = _, _ = null), T ? _ = "buffer" : _ || (_ = s.defaultEncoding), typeof p != "function" && (p = M), s.ended ? B(this, p) : (T || k(this, s, b, p)) && (s.pendingcb++, y = I(this, s, T, b, _, p)), y;
  }, A.prototype.cork = function() {
    var b = this._writableState;
    b.corked++;
  }, A.prototype.uncork = function() {
    var b = this._writableState;
    b.corked && (b.corked--, !b.writing && !b.corked && !b.bufferProcessing && b.bufferedRequest && Ee(this, b));
  }, A.prototype.setDefaultEncoding = function(_) {
    if (typeof _ == "string" && (_ = _.toLowerCase()), !(["hex", "utf8", "utf-8", "ascii", "binary", "base64", "ucs2", "ucs-2", "utf16le", "utf-16le", "raw"].indexOf((_ + "").toLowerCase()) > -1))
      throw new TypeError("Unknown encoding: " + _);
    return this._writableState.defaultEncoding = _, this;
  };
  function C(b, _, p) {
    return !b.objectMode && b.decodeStrings !== !1 && typeof _ == "string" && (_ = d.from(_, p)), _;
  }
  Object.defineProperty(A.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function I(b, _, p, s, y, T) {
    if (!p) {
      var P = C(_, s, y);
      s !== P && (p = !0, y = "buffer", s = P);
    }
    var z = _.objectMode ? 1 : s.length;
    _.length += z;
    var J = _.length < _.highWaterMark;
    if (J || (_.needDrain = !0), _.writing || _.corked) {
      var Z = _.lastBufferedRequest;
      _.lastBufferedRequest = {
        chunk: s,
        encoding: y,
        isBuf: p,
        callback: T,
        next: null
      }, Z ? Z.next = _.lastBufferedRequest : _.bufferedRequest = _.lastBufferedRequest, _.bufferedRequestCount += 1;
    } else
      O(b, _, !1, z, s, y, T);
    return J;
  }
  function O(b, _, p, s, y, T, P) {
    _.writelen = s, _.writecb = P, _.writing = !0, _.sync = !0, p ? b._writev(y, _.onwrite) : b._write(y, T, _.onwrite), _.sync = !1;
  }
  function q(b, _, p, s, y) {
    --_.pendingcb, p ? (t.nextTick(y, s), t.nextTick(u, b, _), b._writableState.errorEmitted = !0, b.emit("error", s)) : (y(s), b._writableState.errorEmitted = !0, b.emit("error", s), u(b, _));
  }
  function $(b) {
    b.writing = !1, b.writecb = null, b.length -= b.writelen, b.writelen = 0;
  }
  function ae(b, _) {
    var p = b._writableState, s = p.sync, y = p.writecb;
    if ($(p), _)
      q(b, p, s, _, y);
    else {
      var T = x(p);
      !T && !p.corked && !p.bufferProcessing && p.bufferedRequest && Ee(b, p), s ? r(he, b, p, T, y) : he(b, p, T, y);
    }
  }
  function he(b, _, p, s) {
    p || te(b, _), _.pendingcb--, s(), u(b, _);
  }
  function te(b, _) {
    _.length === 0 && _.needDrain && (_.needDrain = !1, b.emit("drain"));
  }
  function Ee(b, _) {
    _.bufferProcessing = !0;
    var p = _.bufferedRequest;
    if (b._writev && p && p.next) {
      var s = _.bufferedRequestCount, y = new Array(s), T = _.corkedRequestsFree;
      T.entry = p;
      for (var P = 0, z = !0; p; )
        y[P] = p, p.isBuf || (z = !1), p = p.next, P += 1;
      y.allBuffers = z, O(b, _, !0, _.length, y, "", T.finish), _.pendingcb++, _.lastBufferedRequest = null, T.next ? (_.corkedRequestsFree = T.next, T.next = null) : _.corkedRequestsFree = new e(_), _.bufferedRequestCount = 0;
    } else {
      for (; p; ) {
        var J = p.chunk, Z = p.encoding, F = p.callback, ee = _.objectMode ? 1 : J.length;
        if (O(b, _, !1, ee, J, Z, F), p = p.next, _.bufferedRequestCount--, _.writing)
          break;
      }
      p === null && (_.lastBufferedRequest = null);
    }
    _.bufferedRequest = p, _.bufferProcessing = !1;
  }
  A.prototype._write = function(b, _, p) {
    p(new Error("_write() is not implemented"));
  }, A.prototype._writev = null, A.prototype.end = function(b, _, p) {
    var s = this._writableState;
    typeof b == "function" ? (p = b, b = null, _ = null) : typeof _ == "function" && (p = _, _ = null), b != null && this.write(b, _), s.corked && (s.corked = 1, this.uncork()), s.ending || c(this, s, p);
  };
  function x(b) {
    return b.ending && b.length === 0 && b.bufferedRequest === null && !b.finished && !b.writing;
  }
  function n(b, _) {
    b._final(function(p) {
      _.pendingcb--, p && b.emit("error", p), _.prefinished = !0, b.emit("prefinish"), u(b, _);
    });
  }
  function o(b, _) {
    !_.prefinished && !_.finalCalled && (typeof b._final == "function" ? (_.pendingcb++, _.finalCalled = !0, t.nextTick(n, b, _)) : (_.prefinished = !0, b.emit("prefinish")));
  }
  function u(b, _) {
    var p = x(_);
    return p && (o(b, _), _.pendingcb === 0 && (_.finished = !0, b.emit("finish"))), p;
  }
  function c(b, _, p) {
    _.ending = !0, u(b, _), p && (_.finished ? t.nextTick(p) : b.once("finish", p)), _.ended = !0, b.writable = !1;
  }
  function g(b, _, p) {
    var s = b.entry;
    for (b.entry = null; s; ) {
      var y = s.callback;
      _.pendingcb--, y(p), s = s.next;
    }
    _.corkedRequestsFree.next = b;
  }
  return Object.defineProperty(A.prototype, "destroyed", {
    get: function() {
      return this._writableState === void 0 ? !1 : this._writableState.destroyed;
    },
    set: function(b) {
      this._writableState && (this._writableState.destroyed = b);
    }
  }), A.prototype.destroy = w.destroy, A.prototype._undestroy = w.undestroy, A.prototype._destroy = function(b, _) {
    this.end(), _(b);
  }, k0;
}
var T0, k6;
function Qs() {
  if (k6)
    return T0;
  k6 = 1;
  var t = wc(), e = Object.keys || function(w) {
    var M = [];
    for (var S in w)
      M.push(S);
    return M;
  };
  T0 = v;
  var r = Object.create(Zf());
  r.inherits = Lt();
  var i = n_(), f = r_();
  r.inherits(v, i);
  for (var a = e(f.prototype), l = 0; l < a.length; l++) {
    var d = a[l];
    v.prototype[d] || (v.prototype[d] = f.prototype[d]);
  }
  function v(w) {
    if (!(this instanceof v))
      return new v(w);
    i.call(this, w), f.call(this, w), w && w.readable === !1 && (this.readable = !1), w && w.writable === !1 && (this.writable = !1), this.allowHalfOpen = !0, w && w.allowHalfOpen === !1 && (this.allowHalfOpen = !1), this.once("end", m);
  }
  Object.defineProperty(v.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._writableState.highWaterMark;
    }
  });
  function m() {
    this.allowHalfOpen || this._writableState.ended || t.nextTick(h, this);
  }
  function h(w) {
    w.end();
  }
  return Object.defineProperty(v.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 || this._writableState === void 0 ? !1 : this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(w) {
      this._readableState === void 0 || this._writableState === void 0 || (this._readableState.destroyed = w, this._writableState.destroyed = w);
    }
  }), v.prototype._destroy = function(w, M) {
    this.push(null), this.end(), t.nextTick(M, w);
  }, T0;
}
var C0 = {}, ku = { exports: {} }, T6;
function _I() {
  return T6 || (T6 = 1, function(t, e) {
    var r = kr, i = r.Buffer;
    function f(l, d) {
      for (var v in l)
        d[v] = l[v];
    }
    i.from && i.alloc && i.allocUnsafe && i.allocUnsafeSlow ? t.exports = r : (f(r, e), e.Buffer = a);
    function a(l, d, v) {
      return i(l, d, v);
    }
    f(i, a), a.from = function(l, d, v) {
      if (typeof l == "number")
        throw new TypeError("Argument must not be a number");
      return i(l, d, v);
    }, a.alloc = function(l, d, v) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      var m = i(l);
      return d !== void 0 ? typeof v == "string" ? m.fill(d, v) : m.fill(d) : m.fill(0), m;
    }, a.allocUnsafe = function(l) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      return i(l);
    }, a.allocUnsafeSlow = function(l) {
      if (typeof l != "number")
        throw new TypeError("Argument must be a number");
      return r.SlowBuffer(l);
    };
  }(ku, ku.exports)), ku.exports;
}
var C6;
function B6() {
  if (C6)
    return C0;
  C6 = 1;
  var t = _I().Buffer, e = t.isEncoding || function(k) {
    switch (k = "" + k, k && k.toLowerCase()) {
      case "hex":
      case "utf8":
      case "utf-8":
      case "ascii":
      case "binary":
      case "base64":
      case "ucs2":
      case "ucs-2":
      case "utf16le":
      case "utf-16le":
      case "raw":
        return !0;
      default:
        return !1;
    }
  };
  function r(k) {
    if (!k)
      return "utf8";
    for (var C; ; )
      switch (k) {
        case "utf8":
        case "utf-8":
          return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
          return "utf16le";
        case "latin1":
        case "binary":
          return "latin1";
        case "base64":
        case "ascii":
        case "hex":
          return k;
        default:
          if (C)
            return;
          k = ("" + k).toLowerCase(), C = !0;
      }
  }
  function i(k) {
    var C = r(k);
    if (typeof C != "string" && (t.isEncoding === e || !e(k)))
      throw new Error("Unknown encoding: " + k);
    return C || k;
  }
  C0.StringDecoder = f;
  function f(k) {
    this.encoding = i(k);
    var C;
    switch (this.encoding) {
      case "utf16le":
        this.text = w, this.end = M, C = 4;
        break;
      case "utf8":
        this.fillLast = v, C = 4;
        break;
      case "base64":
        this.text = S, this.end = E, C = 3;
        break;
      default:
        this.write = A, this.end = B;
        return;
    }
    this.lastNeed = 0, this.lastTotal = 0, this.lastChar = t.allocUnsafe(C);
  }
  f.prototype.write = function(k) {
    if (k.length === 0)
      return "";
    var C, I;
    if (this.lastNeed) {
      if (C = this.fillLast(k), C === void 0)
        return "";
      I = this.lastNeed, this.lastNeed = 0;
    } else
      I = 0;
    return I < k.length ? C ? C + this.text(k, I) : this.text(k, I) : C || "";
  }, f.prototype.end = h, f.prototype.text = m, f.prototype.fillLast = function(k) {
    if (this.lastNeed <= k.length)
      return k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    k.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, k.length), this.lastNeed -= k.length;
  };
  function a(k) {
    return k <= 127 ? 0 : k >> 5 === 6 ? 2 : k >> 4 === 14 ? 3 : k >> 3 === 30 ? 4 : k >> 6 === 2 ? -1 : -2;
  }
  function l(k, C, I) {
    var O = C.length - 1;
    if (O < I)
      return 0;
    var q = a(C[O]);
    return q >= 0 ? (q > 0 && (k.lastNeed = q - 1), q) : --O < I || q === -2 ? 0 : (q = a(C[O]), q >= 0 ? (q > 0 && (k.lastNeed = q - 2), q) : --O < I || q === -2 ? 0 : (q = a(C[O]), q >= 0 ? (q > 0 && (q === 2 ? q = 0 : k.lastNeed = q - 3), q) : 0));
  }
  function d(k, C, I) {
    if ((C[0] & 192) !== 128)
      return k.lastNeed = 0, "�";
    if (k.lastNeed > 1 && C.length > 1) {
      if ((C[1] & 192) !== 128)
        return k.lastNeed = 1, "�";
      if (k.lastNeed > 2 && C.length > 2 && (C[2] & 192) !== 128)
        return k.lastNeed = 2, "�";
    }
  }
  function v(k) {
    var C = this.lastTotal - this.lastNeed, I = d(this, k);
    if (I !== void 0)
      return I;
    if (this.lastNeed <= k.length)
      return k.copy(this.lastChar, C, 0, this.lastNeed), this.lastChar.toString(this.encoding, 0, this.lastTotal);
    k.copy(this.lastChar, C, 0, k.length), this.lastNeed -= k.length;
  }
  function m(k, C) {
    var I = l(this, k, C);
    if (!this.lastNeed)
      return k.toString("utf8", C);
    this.lastTotal = I;
    var O = k.length - (I - this.lastNeed);
    return k.copy(this.lastChar, 0, O), k.toString("utf8", C, O);
  }
  function h(k) {
    var C = k && k.length ? this.write(k) : "";
    return this.lastNeed ? C + "�" : C;
  }
  function w(k, C) {
    if ((k.length - C) % 2 === 0) {
      var I = k.toString("utf16le", C);
      if (I) {
        var O = I.charCodeAt(I.length - 1);
        if (O >= 55296 && O <= 56319)
          return this.lastNeed = 2, this.lastTotal = 4, this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1], I.slice(0, -1);
      }
      return I;
    }
    return this.lastNeed = 1, this.lastTotal = 2, this.lastChar[0] = k[k.length - 1], k.toString("utf16le", C, k.length - 1);
  }
  function M(k) {
    var C = k && k.length ? this.write(k) : "";
    if (this.lastNeed) {
      var I = this.lastTotal - this.lastNeed;
      return C + this.lastChar.toString("utf16le", 0, I);
    }
    return C;
  }
  function S(k, C) {
    var I = (k.length - C) % 3;
    return I === 0 ? k.toString("base64", C) : (this.lastNeed = 3 - I, this.lastTotal = 3, I === 1 ? this.lastChar[0] = k[k.length - 1] : (this.lastChar[0] = k[k.length - 2], this.lastChar[1] = k[k.length - 1]), k.toString("base64", C, k.length - I));
  }
  function E(k) {
    var C = k && k.length ? this.write(k) : "";
    return this.lastNeed ? C + this.lastChar.toString("base64", 0, 3 - this.lastNeed) : C;
  }
  function A(k) {
    return k.toString(this.encoding);
  }
  function B(k) {
    return k && k.length ? this.write(k) : "";
  }
  return C0;
}
var B0, I6;
function n_() {
  if (I6)
    return B0;
  I6 = 1;
  var t = wc();
  B0 = C;
  var e = bI(), r;
  C.ReadableState = k, $f().EventEmitter;
  var i = function(F, ee) {
    return F.listeners(ee).length;
  }, f = e_(), a = Em().Buffer, l = (typeof ut < "u" ? ut : typeof window < "u" ? window : typeof self < "u" ? self : {}).Uint8Array || function() {
  };
  function d(F) {
    return a.from(F);
  }
  function v(F) {
    return a.isBuffer(F) || F instanceof l;
  }
  var m = Object.create(Zf());
  m.inherits = Lt();
  var h = mc(), w = void 0;
  h && h.debuglog ? w = h.debuglog("stream") : w = function() {
  };
  var M = wI(), S = t_(), E;
  m.inherits(C, f);
  var A = ["error", "close", "destroy", "pause", "resume"];
  function B(F, ee, re) {
    if (typeof F.prependListener == "function")
      return F.prependListener(ee, re);
    !F._events || !F._events[ee] ? F.on(ee, re) : e(F._events[ee]) ? F._events[ee].unshift(re) : F._events[ee] = [re, F._events[ee]];
  }
  function k(F, ee) {
    r = r || Qs(), F = F || {};
    var re = ee instanceof r;
    this.objectMode = !!F.objectMode, re && (this.objectMode = this.objectMode || !!F.readableObjectMode);
    var de = F.highWaterMark, se = F.readableHighWaterMark, Q = this.objectMode ? 16 : 16 * 1024;
    de || de === 0 ? this.highWaterMark = de : re && (se || se === 0) ? this.highWaterMark = se : this.highWaterMark = Q, this.highWaterMark = Math.floor(this.highWaterMark), this.buffer = new M(), this.length = 0, this.pipes = null, this.pipesCount = 0, this.flowing = null, this.ended = !1, this.endEmitted = !1, this.reading = !1, this.sync = !0, this.needReadable = !1, this.emittedReadable = !1, this.readableListening = !1, this.resumeScheduled = !1, this.destroyed = !1, this.defaultEncoding = F.defaultEncoding || "utf8", this.awaitDrain = 0, this.readingMore = !1, this.decoder = null, this.encoding = null, F.encoding && (E || (E = B6().StringDecoder), this.decoder = new E(F.encoding), this.encoding = F.encoding);
  }
  function C(F) {
    if (r = r || Qs(), !(this instanceof C))
      return new C(F);
    this._readableState = new k(F, this), this.readable = !0, F && (typeof F.read == "function" && (this._read = F.read), typeof F.destroy == "function" && (this._destroy = F.destroy)), f.call(this);
  }
  Object.defineProperty(C.prototype, "destroyed", {
    get: function() {
      return this._readableState === void 0 ? !1 : this._readableState.destroyed;
    },
    set: function(F) {
      this._readableState && (this._readableState.destroyed = F);
    }
  }), C.prototype.destroy = S.destroy, C.prototype._undestroy = S.undestroy, C.prototype._destroy = function(F, ee) {
    this.push(null), ee(F);
  }, C.prototype.push = function(F, ee) {
    var re = this._readableState, de;
    return re.objectMode ? de = !0 : typeof F == "string" && (ee = ee || re.defaultEncoding, ee !== re.encoding && (F = a.from(F, ee), ee = ""), de = !0), I(this, F, ee, !1, de);
  }, C.prototype.unshift = function(F) {
    return I(this, F, null, !0, !1);
  };
  function I(F, ee, re, de, se) {
    var Q = F._readableState;
    if (ee === null)
      Q.reading = !1, Ee(F, Q);
    else {
      var ge;
      se || (ge = q(Q, ee)), ge ? F.emit("error", ge) : Q.objectMode || ee && ee.length > 0 ? (typeof ee != "string" && !Q.objectMode && Object.getPrototypeOf(ee) !== a.prototype && (ee = d(ee)), de ? Q.endEmitted ? F.emit("error", new Error("stream.unshift() after end event")) : O(F, Q, ee, !0) : Q.ended ? F.emit("error", new Error("stream.push() after EOF")) : (Q.reading = !1, Q.decoder && !re ? (ee = Q.decoder.write(ee), Q.objectMode || ee.length !== 0 ? O(F, Q, ee, !1) : o(F, Q)) : O(F, Q, ee, !1))) : de || (Q.reading = !1);
    }
    return $(Q);
  }
  function O(F, ee, re, de) {
    ee.flowing && ee.length === 0 && !ee.sync ? (F.emit("data", re), F.read(0)) : (ee.length += ee.objectMode ? 1 : re.length, de ? ee.buffer.unshift(re) : ee.buffer.push(re), ee.needReadable && x(F)), o(F, ee);
  }
  function q(F, ee) {
    var re;
    return !v(ee) && typeof ee != "string" && ee !== void 0 && !F.objectMode && (re = new TypeError("Invalid non-string/buffer chunk")), re;
  }
  function $(F) {
    return !F.ended && (F.needReadable || F.length < F.highWaterMark || F.length === 0);
  }
  C.prototype.isPaused = function() {
    return this._readableState.flowing === !1;
  }, C.prototype.setEncoding = function(F) {
    return E || (E = B6().StringDecoder), this._readableState.decoder = new E(F), this._readableState.encoding = F, this;
  };
  var ae = 8388608;
  function he(F) {
    return F >= ae ? F = ae : (F--, F |= F >>> 1, F |= F >>> 2, F |= F >>> 4, F |= F >>> 8, F |= F >>> 16, F++), F;
  }
  function te(F, ee) {
    return F <= 0 || ee.length === 0 && ee.ended ? 0 : ee.objectMode ? 1 : F !== F ? ee.flowing && ee.length ? ee.buffer.head.data.length : ee.length : (F > ee.highWaterMark && (ee.highWaterMark = he(F)), F <= ee.length ? F : ee.ended ? ee.length : (ee.needReadable = !0, 0));
  }
  C.prototype.read = function(F) {
    w("read", F), F = parseInt(F, 10);
    var ee = this._readableState, re = F;
    if (F !== 0 && (ee.emittedReadable = !1), F === 0 && ee.needReadable && (ee.length >= ee.highWaterMark || ee.ended))
      return w("read: emitReadable", ee.length, ee.ended), ee.length === 0 && ee.ended ? z(this) : x(this), null;
    if (F = te(F, ee), F === 0 && ee.ended)
      return ee.length === 0 && z(this), null;
    var de = ee.needReadable;
    w("need readable", de), (ee.length === 0 || ee.length - F < ee.highWaterMark) && (de = !0, w("length less than watermark", de)), ee.ended || ee.reading ? (de = !1, w("reading or ended", de)) : de && (w("do read"), ee.reading = !0, ee.sync = !0, ee.length === 0 && (ee.needReadable = !0), this._read(ee.highWaterMark), ee.sync = !1, ee.reading || (F = te(re, ee)));
    var se;
    return F > 0 ? se = s(F, ee) : se = null, se === null ? (ee.needReadable = !0, F = 0) : ee.length -= F, ee.length === 0 && (ee.ended || (ee.needReadable = !0), re !== F && ee.ended && z(this)), se !== null && this.emit("data", se), se;
  };
  function Ee(F, ee) {
    if (!ee.ended) {
      if (ee.decoder) {
        var re = ee.decoder.end();
        re && re.length && (ee.buffer.push(re), ee.length += ee.objectMode ? 1 : re.length);
      }
      ee.ended = !0, x(F);
    }
  }
  function x(F) {
    var ee = F._readableState;
    ee.needReadable = !1, ee.emittedReadable || (w("emitReadable", ee.flowing), ee.emittedReadable = !0, ee.sync ? t.nextTick(n, F) : n(F));
  }
  function n(F) {
    w("emit readable"), F.emit("readable"), p(F);
  }
  function o(F, ee) {
    ee.readingMore || (ee.readingMore = !0, t.nextTick(u, F, ee));
  }
  function u(F, ee) {
    for (var re = ee.length; !ee.reading && !ee.flowing && !ee.ended && ee.length < ee.highWaterMark && (w("maybeReadMore read 0"), F.read(0), re !== ee.length); )
      re = ee.length;
    ee.readingMore = !1;
  }
  C.prototype._read = function(F) {
    this.emit("error", new Error("_read() is not implemented"));
  }, C.prototype.pipe = function(F, ee) {
    var re = this, de = this._readableState;
    switch (de.pipesCount) {
      case 0:
        de.pipes = F;
        break;
      case 1:
        de.pipes = [de.pipes, F];
        break;
      default:
        de.pipes.push(F);
        break;
    }
    de.pipesCount += 1, w("pipe count=%d opts=%j", de.pipesCount, ee);
    var se = (!ee || ee.end !== !1) && F !== It.stdout && F !== It.stderr, Q = se ? Ye : Et;
    de.endEmitted ? t.nextTick(Q) : re.once("end", Q), F.on("unpipe", ge);
    function ge(Ue, oe) {
      w("onunpipe"), Ue === re && oe && oe.hasUnpiped === !1 && (oe.hasUnpiped = !0, st());
    }
    function Ye() {
      w("onend"), F.end();
    }
    var Ce = c(re);
    F.on("drain", Ce);
    var Be = !1;
    function st() {
      w("cleanup"), F.removeListener("close", Oe), F.removeListener("finish", Fe), F.removeListener("drain", Ce), F.removeListener("error", St), F.removeListener("unpipe", ge), re.removeListener("end", Ye), re.removeListener("end", Et), re.removeListener("data", _e), Be = !0, de.awaitDrain && (!F._writableState || F._writableState.needDrain) && Ce();
    }
    var De = !1;
    re.on("data", _e);
    function _e(Ue) {
      w("ondata"), De = !1;
      var oe = F.write(Ue);
      oe === !1 && !De && ((de.pipesCount === 1 && de.pipes === F || de.pipesCount > 1 && Z(de.pipes, F) !== -1) && !Be && (w("false write response, pause", de.awaitDrain), de.awaitDrain++, De = !0), re.pause());
    }
    function St(Ue) {
      w("onerror", Ue), Et(), F.removeListener("error", St), i(F, "error") === 0 && F.emit("error", Ue);
    }
    B(F, "error", St);
    function Oe() {
      F.removeListener("finish", Fe), Et();
    }
    F.once("close", Oe);
    function Fe() {
      w("onfinish"), F.removeListener("close", Oe), Et();
    }
    F.once("finish", Fe);
    function Et() {
      w("unpipe"), re.unpipe(F);
    }
    return F.emit("pipe", re), de.flowing || (w("pipe resume"), re.resume()), F;
  };
  function c(F) {
    return function() {
      var ee = F._readableState;
      w("pipeOnDrain", ee.awaitDrain), ee.awaitDrain && ee.awaitDrain--, ee.awaitDrain === 0 && i(F, "data") && (ee.flowing = !0, p(F));
    };
  }
  C.prototype.unpipe = function(F) {
    var ee = this._readableState, re = { hasUnpiped: !1 };
    if (ee.pipesCount === 0)
      return this;
    if (ee.pipesCount === 1)
      return F && F !== ee.pipes ? this : (F || (F = ee.pipes), ee.pipes = null, ee.pipesCount = 0, ee.flowing = !1, F && F.emit("unpipe", this, re), this);
    if (!F) {
      var de = ee.pipes, se = ee.pipesCount;
      ee.pipes = null, ee.pipesCount = 0, ee.flowing = !1;
      for (var Q = 0; Q < se; Q++)
        de[Q].emit("unpipe", this, { hasUnpiped: !1 });
      return this;
    }
    var ge = Z(ee.pipes, F);
    return ge === -1 ? this : (ee.pipes.splice(ge, 1), ee.pipesCount -= 1, ee.pipesCount === 1 && (ee.pipes = ee.pipes[0]), F.emit("unpipe", this, re), this);
  }, C.prototype.on = function(F, ee) {
    var re = f.prototype.on.call(this, F, ee);
    if (F === "data")
      this._readableState.flowing !== !1 && this.resume();
    else if (F === "readable") {
      var de = this._readableState;
      !de.endEmitted && !de.readableListening && (de.readableListening = de.needReadable = !0, de.emittedReadable = !1, de.reading ? de.length && x(this) : t.nextTick(g, this));
    }
    return re;
  }, C.prototype.addListener = C.prototype.on;
  function g(F) {
    w("readable nexttick read 0"), F.read(0);
  }
  C.prototype.resume = function() {
    var F = this._readableState;
    return F.flowing || (w("resume"), F.flowing = !0, b(this, F)), this;
  };
  function b(F, ee) {
    ee.resumeScheduled || (ee.resumeScheduled = !0, t.nextTick(_, F, ee));
  }
  function _(F, ee) {
    ee.reading || (w("resume read 0"), F.read(0)), ee.resumeScheduled = !1, ee.awaitDrain = 0, F.emit("resume"), p(F), ee.flowing && !ee.reading && F.read(0);
  }
  C.prototype.pause = function() {
    return w("call pause flowing=%j", this._readableState.flowing), this._readableState.flowing !== !1 && (w("pause"), this._readableState.flowing = !1, this.emit("pause")), this;
  };
  function p(F) {
    var ee = F._readableState;
    for (w("flow", ee.flowing); ee.flowing && F.read() !== null; )
      ;
  }
  C.prototype.wrap = function(F) {
    var ee = this, re = this._readableState, de = !1;
    F.on("end", function() {
      if (w("wrapped end"), re.decoder && !re.ended) {
        var ge = re.decoder.end();
        ge && ge.length && ee.push(ge);
      }
      ee.push(null);
    }), F.on("data", function(ge) {
      if (w("wrapped data"), re.decoder && (ge = re.decoder.write(ge)), !(re.objectMode && ge == null) && !(!re.objectMode && (!ge || !ge.length))) {
        var Ye = ee.push(ge);
        Ye || (de = !0, F.pause());
      }
    });
    for (var se in F)
      this[se] === void 0 && typeof F[se] == "function" && (this[se] = /* @__PURE__ */ function(ge) {
        return function() {
          return F[ge].apply(F, arguments);
        };
      }(se));
    for (var Q = 0; Q < A.length; Q++)
      F.on(A[Q], this.emit.bind(this, A[Q]));
    return this._read = function(ge) {
      w("wrapped _read", ge), de && (de = !1, F.resume());
    }, this;
  }, Object.defineProperty(C.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: !1,
    get: function() {
      return this._readableState.highWaterMark;
    }
  }), C._fromList = s;
  function s(F, ee) {
    if (ee.length === 0)
      return null;
    var re;
    return ee.objectMode ? re = ee.buffer.shift() : !F || F >= ee.length ? (ee.decoder ? re = ee.buffer.join("") : ee.buffer.length === 1 ? re = ee.buffer.head.data : re = ee.buffer.concat(ee.length), ee.buffer.clear()) : re = y(F, ee.buffer, ee.decoder), re;
  }
  function y(F, ee, re) {
    var de;
    return F < ee.head.data.length ? (de = ee.head.data.slice(0, F), ee.head.data = ee.head.data.slice(F)) : F === ee.head.data.length ? de = ee.shift() : de = re ? T(F, ee) : P(F, ee), de;
  }
  function T(F, ee) {
    var re = ee.head, de = 1, se = re.data;
    for (F -= se.length; re = re.next; ) {
      var Q = re.data, ge = F > Q.length ? Q.length : F;
      if (ge === Q.length ? se += Q : se += Q.slice(0, F), F -= ge, F === 0) {
        ge === Q.length ? (++de, re.next ? ee.head = re.next : ee.head = ee.tail = null) : (ee.head = re, re.data = Q.slice(ge));
        break;
      }
      ++de;
    }
    return ee.length -= de, se;
  }
  function P(F, ee) {
    var re = a.allocUnsafe(F), de = ee.head, se = 1;
    for (de.data.copy(re), F -= de.data.length; de = de.next; ) {
      var Q = de.data, ge = F > Q.length ? Q.length : F;
      if (Q.copy(re, re.length - F, 0, ge), F -= ge, F === 0) {
        ge === Q.length ? (++se, de.next ? ee.head = de.next : ee.head = ee.tail = null) : (ee.head = de, de.data = Q.slice(ge));
        break;
      }
      ++se;
    }
    return ee.length -= se, re;
  }
  function z(F) {
    var ee = F._readableState;
    if (ee.length > 0)
      throw new Error('"endReadable()" called on non-empty stream');
    ee.endEmitted || (ee.ended = !0, t.nextTick(J, ee, F));
  }
  function J(F, ee) {
    !F.endEmitted && F.length === 0 && (F.endEmitted = !0, ee.readable = !1, ee.emit("end"));
  }
  function Z(F, ee) {
    for (var re = 0, de = F.length; re < de; re++)
      if (F[re] === ee)
        return re;
    return -1;
  }
  return B0;
}
var I0, R6;
function i_() {
  if (R6)
    return I0;
  R6 = 1, I0 = i;
  var t = Qs(), e = Object.create(Zf());
  e.inherits = Lt(), e.inherits(i, t);
  function r(l, d) {
    var v = this._transformState;
    v.transforming = !1;
    var m = v.writecb;
    if (!m)
      return this.emit("error", new Error("write callback called multiple times"));
    v.writechunk = null, v.writecb = null, d != null && this.push(d), m(l);
    var h = this._readableState;
    h.reading = !1, (h.needReadable || h.length < h.highWaterMark) && this._read(h.highWaterMark);
  }
  function i(l) {
    if (!(this instanceof i))
      return new i(l);
    t.call(this, l), this._transformState = {
      afterTransform: r.bind(this),
      needTransform: !1,
      transforming: !1,
      writecb: null,
      writechunk: null,
      writeencoding: null
    }, this._readableState.needReadable = !0, this._readableState.sync = !1, l && (typeof l.transform == "function" && (this._transform = l.transform), typeof l.flush == "function" && (this._flush = l.flush)), this.on("prefinish", f);
  }
  function f() {
    var l = this;
    typeof this._flush == "function" ? this._flush(function(d, v) {
      a(l, d, v);
    }) : a(this, null, null);
  }
  i.prototype.push = function(l, d) {
    return this._transformState.needTransform = !1, t.prototype.push.call(this, l, d);
  }, i.prototype._transform = function(l, d, v) {
    throw new Error("_transform() is not implemented");
  }, i.prototype._write = function(l, d, v) {
    var m = this._transformState;
    if (m.writecb = v, m.writechunk = l, m.writeencoding = d, !m.transforming) {
      var h = this._readableState;
      (m.needTransform || h.needReadable || h.length < h.highWaterMark) && this._read(h.highWaterMark);
    }
  }, i.prototype._read = function(l) {
    var d = this._transformState;
    d.writechunk !== null && d.writecb && !d.transforming ? (d.transforming = !0, this._transform(d.writechunk, d.writeencoding, d.afterTransform)) : d.needTransform = !0;
  }, i.prototype._destroy = function(l, d) {
    var v = this;
    t.prototype._destroy.call(this, l, function(m) {
      d(m), v.emit("close");
    });
  };
  function a(l, d, v) {
    if (d)
      return l.emit("error", d);
    if (v != null && l.push(v), l._writableState.length)
      throw new Error("Calling transform done when ws.length != 0");
    if (l._transformState.transforming)
      throw new Error("Calling transform done when still transforming");
    return l.push(null);
  }
  return I0;
}
var R0, P6;
function xI() {
  if (P6)
    return R0;
  P6 = 1, R0 = r;
  var t = i_(), e = Object.create(Zf());
  e.inherits = Lt(), e.inherits(r, t);
  function r(i) {
    if (!(this instanceof r))
      return new r(i);
    t.call(this, i);
  }
  return r.prototype._transform = function(i, f, a) {
    a(null, i);
  }, R0;
}
var O6;
function MI() {
  return O6 || (O6 = 1, function(t, e) {
    e = t.exports = n_(), e.Stream = e, e.Readable = e, e.Writable = r_(), e.Duplex = Qs(), e.Transform = i_(), e.PassThrough = xI();
  }(Su, Su.exports)), Su.exports;
}
var Fo = { exports: {} }, Gu = { exports: {} };
Gu.exports;
var N6;
function Am() {
  return N6 || (N6 = 1, function(t) {
    (function(e, r) {
      function i(o, u) {
        if (!o)
          throw new Error(u || "Assertion failed");
      }
      function f(o, u) {
        o.super_ = u;
        var c = function() {
        };
        c.prototype = u.prototype, o.prototype = new c(), o.prototype.constructor = o;
      }
      function a(o, u, c) {
        if (a.isBN(o))
          return o;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, o !== null && ((u === "le" || u === "be") && (c = u, u = 10), this._init(o || 0, u || 10, c || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(u) {
        return u instanceof a ? !0 : u !== null && typeof u == "object" && u.constructor.wordSize === a.wordSize && Array.isArray(u.words);
      }, a.max = function(u, c) {
        return u.cmp(c) > 0 ? u : c;
      }, a.min = function(u, c) {
        return u.cmp(c) < 0 ? u : c;
      }, a.prototype._init = function(u, c, g) {
        if (typeof u == "number")
          return this._initNumber(u, c, g);
        if (typeof u == "object")
          return this._initArray(u, c, g);
        c === "hex" && (c = 16), i(c === (c | 0) && c >= 2 && c <= 36), u = u.toString().replace(/\s+/g, "");
        var b = 0;
        u[0] === "-" && (b++, this.negative = 1), b < u.length && (c === 16 ? this._parseHex(u, b, g) : (this._parseBase(u, c, b), g === "le" && this._initArray(this.toArray(), c, g)));
      }, a.prototype._initNumber = function(u, c, g) {
        u < 0 && (this.negative = 1, u = -u), u < 67108864 ? (this.words = [u & 67108863], this.length = 1) : u < 4503599627370496 ? (this.words = [
          u & 67108863,
          u / 67108864 & 67108863
        ], this.length = 2) : (i(u < 9007199254740992), this.words = [
          u & 67108863,
          u / 67108864 & 67108863,
          1
        ], this.length = 3), g === "le" && this._initArray(this.toArray(), c, g);
      }, a.prototype._initArray = function(u, c, g) {
        if (i(typeof u.length == "number"), u.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(u.length / 3), this.words = new Array(this.length);
        for (var b = 0; b < this.length; b++)
          this.words[b] = 0;
        var _, p, s = 0;
        if (g === "be")
          for (b = u.length - 1, _ = 0; b >= 0; b -= 3)
            p = u[b] | u[b - 1] << 8 | u[b - 2] << 16, this.words[_] |= p << s & 67108863, this.words[_ + 1] = p >>> 26 - s & 67108863, s += 24, s >= 26 && (s -= 26, _++);
        else if (g === "le")
          for (b = 0, _ = 0; b < u.length; b += 3)
            p = u[b] | u[b + 1] << 8 | u[b + 2] << 16, this.words[_] |= p << s & 67108863, this.words[_ + 1] = p >>> 26 - s & 67108863, s += 24, s >= 26 && (s -= 26, _++);
        return this._strip();
      };
      function d(o, u) {
        var c = o.charCodeAt(u);
        if (c >= 48 && c <= 57)
          return c - 48;
        if (c >= 65 && c <= 70)
          return c - 55;
        if (c >= 97 && c <= 102)
          return c - 87;
        i(!1, "Invalid character in " + o);
      }
      function v(o, u, c) {
        var g = d(o, c);
        return c - 1 >= u && (g |= d(o, c - 1) << 4), g;
      }
      a.prototype._parseHex = function(u, c, g) {
        this.length = Math.ceil((u.length - c) / 6), this.words = new Array(this.length);
        for (var b = 0; b < this.length; b++)
          this.words[b] = 0;
        var _ = 0, p = 0, s;
        if (g === "be")
          for (b = u.length - 1; b >= c; b -= 2)
            s = v(u, c, b) << _, this.words[p] |= s & 67108863, _ >= 18 ? (_ -= 18, p += 1, this.words[p] |= s >>> 26) : _ += 8;
        else {
          var y = u.length - c;
          for (b = y % 2 === 0 ? c + 1 : c; b < u.length; b += 2)
            s = v(u, c, b) << _, this.words[p] |= s & 67108863, _ >= 18 ? (_ -= 18, p += 1, this.words[p] |= s >>> 26) : _ += 8;
        }
        this._strip();
      };
      function m(o, u, c, g) {
        for (var b = 0, _ = 0, p = Math.min(o.length, c), s = u; s < p; s++) {
          var y = o.charCodeAt(s) - 48;
          b *= g, y >= 49 ? _ = y - 49 + 10 : y >= 17 ? _ = y - 17 + 10 : _ = y, i(y >= 0 && _ < g, "Invalid character"), b += _;
        }
        return b;
      }
      a.prototype._parseBase = function(u, c, g) {
        this.words = [0], this.length = 1;
        for (var b = 0, _ = 1; _ <= 67108863; _ *= c)
          b++;
        b--, _ = _ / c | 0;
        for (var p = u.length - g, s = p % b, y = Math.min(p, p - s) + g, T = 0, P = g; P < y; P += b)
          T = m(u, P, P + b, c), this.imuln(_), this.words[0] + T < 67108864 ? this.words[0] += T : this._iaddn(T);
        if (s !== 0) {
          var z = 1;
          for (T = m(u, P, u.length, c), P = 0; P < s; P++)
            z *= c;
          this.imuln(z), this.words[0] + T < 67108864 ? this.words[0] += T : this._iaddn(T);
        }
        this._strip();
      }, a.prototype.copy = function(u) {
        u.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          u.words[c] = this.words[c];
        u.length = this.length, u.negative = this.negative, u.red = this.red;
      };
      function h(o, u) {
        o.words = u.words, o.length = u.length, o.negative = u.negative, o.red = u.red;
      }
      if (a.prototype._move = function(u) {
        h(u, this);
      }, a.prototype.clone = function() {
        var u = new a(null);
        return this.copy(u), u;
      }, a.prototype._expand = function(u) {
        for (; this.length < u; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype._strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, typeof Symbol < "u" && typeof Symbol.for == "function")
        try {
          a.prototype[Symbol.for("nodejs.util.inspect.custom")] = w;
        } catch {
          a.prototype.inspect = w;
        }
      else
        a.prototype.inspect = w;
      function w() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      }
      var M = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], S = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], E = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(u, c) {
        u = u || 10, c = c | 0 || 1;
        var g;
        if (u === 16 || u === "hex") {
          g = "";
          for (var b = 0, _ = 0, p = 0; p < this.length; p++) {
            var s = this.words[p], y = ((s << b | _) & 16777215).toString(16);
            _ = s >>> 24 - b & 16777215, b += 2, b >= 26 && (b -= 26, p--), _ !== 0 || p !== this.length - 1 ? g = M[6 - y.length] + y + g : g = y + g;
          }
          for (_ !== 0 && (g = _.toString(16) + g); g.length % c !== 0; )
            g = "0" + g;
          return this.negative !== 0 && (g = "-" + g), g;
        }
        if (u === (u | 0) && u >= 2 && u <= 36) {
          var T = S[u], P = E[u];
          g = "";
          var z = this.clone();
          for (z.negative = 0; !z.isZero(); ) {
            var J = z.modrn(P).toString(u);
            z = z.idivn(P), z.isZero() ? g = J + g : g = M[T - J.length] + J + g;
          }
          for (this.isZero() && (g = "0" + g); g.length % c !== 0; )
            g = "0" + g;
          return this.negative !== 0 && (g = "-" + g), g;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var u = this.words[0];
        return this.length === 2 ? u += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? u += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -u : u;
      }, a.prototype.toJSON = function() {
        return this.toString(16, 2);
      }, l && (a.prototype.toBuffer = function(u, c) {
        return this.toArrayLike(l, u, c);
      }), a.prototype.toArray = function(u, c) {
        return this.toArrayLike(Array, u, c);
      };
      var A = function(u, c) {
        return u.allocUnsafe ? u.allocUnsafe(c) : new u(c);
      };
      a.prototype.toArrayLike = function(u, c, g) {
        this._strip();
        var b = this.byteLength(), _ = g || Math.max(1, b);
        i(b <= _, "byte array longer than desired length"), i(_ > 0, "Requested array length <= 0");
        var p = A(u, _), s = c === "le" ? "LE" : "BE";
        return this["_toArrayLike" + s](p, b), p;
      }, a.prototype._toArrayLikeLE = function(u, c) {
        for (var g = 0, b = 0, _ = 0, p = 0; _ < this.length; _++) {
          var s = this.words[_] << p | b;
          u[g++] = s & 255, g < u.length && (u[g++] = s >> 8 & 255), g < u.length && (u[g++] = s >> 16 & 255), p === 6 ? (g < u.length && (u[g++] = s >> 24 & 255), b = 0, p = 0) : (b = s >>> 24, p += 2);
        }
        if (g < u.length)
          for (u[g++] = b; g < u.length; )
            u[g++] = 0;
      }, a.prototype._toArrayLikeBE = function(u, c) {
        for (var g = u.length - 1, b = 0, _ = 0, p = 0; _ < this.length; _++) {
          var s = this.words[_] << p | b;
          u[g--] = s & 255, g >= 0 && (u[g--] = s >> 8 & 255), g >= 0 && (u[g--] = s >> 16 & 255), p === 6 ? (g >= 0 && (u[g--] = s >> 24 & 255), b = 0, p = 0) : (b = s >>> 24, p += 2);
        }
        if (g >= 0)
          for (u[g--] = b; g >= 0; )
            u[g--] = 0;
      }, Math.clz32 ? a.prototype._countBits = function(u) {
        return 32 - Math.clz32(u);
      } : a.prototype._countBits = function(u) {
        var c = u, g = 0;
        return c >= 4096 && (g += 13, c >>>= 13), c >= 64 && (g += 7, c >>>= 7), c >= 8 && (g += 4, c >>>= 4), c >= 2 && (g += 2, c >>>= 2), g + c;
      }, a.prototype._zeroBits = function(u) {
        if (u === 0)
          return 26;
        var c = u, g = 0;
        return c & 8191 || (g += 13, c >>>= 13), c & 127 || (g += 7, c >>>= 7), c & 15 || (g += 4, c >>>= 4), c & 3 || (g += 2, c >>>= 2), c & 1 || g++, g;
      }, a.prototype.bitLength = function() {
        var u = this.words[this.length - 1], c = this._countBits(u);
        return (this.length - 1) * 26 + c;
      };
      function B(o) {
        for (var u = new Array(o.bitLength()), c = 0; c < u.length; c++) {
          var g = c / 26 | 0, b = c % 26;
          u[c] = o.words[g] >>> b & 1;
        }
        return u;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var u = 0, c = 0; c < this.length; c++) {
          var g = this._zeroBits(this.words[c]);
          if (u += g, g !== 26)
            break;
        }
        return u;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(u) {
        return this.negative !== 0 ? this.abs().inotn(u).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(u) {
        return this.testn(u - 1) ? this.notn(u).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(u) {
        for (; this.length < u.length; )
          this.words[this.length++] = 0;
        for (var c = 0; c < u.length; c++)
          this.words[c] = this.words[c] | u.words[c];
        return this._strip();
      }, a.prototype.ior = function(u) {
        return i((this.negative | u.negative) === 0), this.iuor(u);
      }, a.prototype.or = function(u) {
        return this.length > u.length ? this.clone().ior(u) : u.clone().ior(this);
      }, a.prototype.uor = function(u) {
        return this.length > u.length ? this.clone().iuor(u) : u.clone().iuor(this);
      }, a.prototype.iuand = function(u) {
        var c;
        this.length > u.length ? c = u : c = this;
        for (var g = 0; g < c.length; g++)
          this.words[g] = this.words[g] & u.words[g];
        return this.length = c.length, this._strip();
      }, a.prototype.iand = function(u) {
        return i((this.negative | u.negative) === 0), this.iuand(u);
      }, a.prototype.and = function(u) {
        return this.length > u.length ? this.clone().iand(u) : u.clone().iand(this);
      }, a.prototype.uand = function(u) {
        return this.length > u.length ? this.clone().iuand(u) : u.clone().iuand(this);
      }, a.prototype.iuxor = function(u) {
        var c, g;
        this.length > u.length ? (c = this, g = u) : (c = u, g = this);
        for (var b = 0; b < g.length; b++)
          this.words[b] = c.words[b] ^ g.words[b];
        if (this !== c)
          for (; b < c.length; b++)
            this.words[b] = c.words[b];
        return this.length = c.length, this._strip();
      }, a.prototype.ixor = function(u) {
        return i((this.negative | u.negative) === 0), this.iuxor(u);
      }, a.prototype.xor = function(u) {
        return this.length > u.length ? this.clone().ixor(u) : u.clone().ixor(this);
      }, a.prototype.uxor = function(u) {
        return this.length > u.length ? this.clone().iuxor(u) : u.clone().iuxor(this);
      }, a.prototype.inotn = function(u) {
        i(typeof u == "number" && u >= 0);
        var c = Math.ceil(u / 26) | 0, g = u % 26;
        this._expand(c), g > 0 && c--;
        for (var b = 0; b < c; b++)
          this.words[b] = ~this.words[b] & 67108863;
        return g > 0 && (this.words[b] = ~this.words[b] & 67108863 >> 26 - g), this._strip();
      }, a.prototype.notn = function(u) {
        return this.clone().inotn(u);
      }, a.prototype.setn = function(u, c) {
        i(typeof u == "number" && u >= 0);
        var g = u / 26 | 0, b = u % 26;
        return this._expand(g + 1), c ? this.words[g] = this.words[g] | 1 << b : this.words[g] = this.words[g] & ~(1 << b), this._strip();
      }, a.prototype.iadd = function(u) {
        var c;
        if (this.negative !== 0 && u.negative === 0)
          return this.negative = 0, c = this.isub(u), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && u.negative !== 0)
          return u.negative = 0, c = this.isub(u), u.negative = 1, c._normSign();
        var g, b;
        this.length > u.length ? (g = this, b = u) : (g = u, b = this);
        for (var _ = 0, p = 0; p < b.length; p++)
          c = (g.words[p] | 0) + (b.words[p] | 0) + _, this.words[p] = c & 67108863, _ = c >>> 26;
        for (; _ !== 0 && p < g.length; p++)
          c = (g.words[p] | 0) + _, this.words[p] = c & 67108863, _ = c >>> 26;
        if (this.length = g.length, _ !== 0)
          this.words[this.length] = _, this.length++;
        else if (g !== this)
          for (; p < g.length; p++)
            this.words[p] = g.words[p];
        return this;
      }, a.prototype.add = function(u) {
        var c;
        return u.negative !== 0 && this.negative === 0 ? (u.negative = 0, c = this.sub(u), u.negative ^= 1, c) : u.negative === 0 && this.negative !== 0 ? (this.negative = 0, c = u.sub(this), this.negative = 1, c) : this.length > u.length ? this.clone().iadd(u) : u.clone().iadd(this);
      }, a.prototype.isub = function(u) {
        if (u.negative !== 0) {
          u.negative = 0;
          var c = this.iadd(u);
          return u.negative = 1, c._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(u), this.negative = 1, this._normSign();
        var g = this.cmp(u);
        if (g === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var b, _;
        g > 0 ? (b = this, _ = u) : (b = u, _ = this);
        for (var p = 0, s = 0; s < _.length; s++)
          c = (b.words[s] | 0) - (_.words[s] | 0) + p, p = c >> 26, this.words[s] = c & 67108863;
        for (; p !== 0 && s < b.length; s++)
          c = (b.words[s] | 0) + p, p = c >> 26, this.words[s] = c & 67108863;
        if (p === 0 && s < b.length && b !== this)
          for (; s < b.length; s++)
            this.words[s] = b.words[s];
        return this.length = Math.max(this.length, s), b !== this && (this.negative = 1), this._strip();
      }, a.prototype.sub = function(u) {
        return this.clone().isub(u);
      };
      function k(o, u, c) {
        c.negative = u.negative ^ o.negative;
        var g = o.length + u.length | 0;
        c.length = g, g = g - 1 | 0;
        var b = o.words[0] | 0, _ = u.words[0] | 0, p = b * _, s = p & 67108863, y = p / 67108864 | 0;
        c.words[0] = s;
        for (var T = 1; T < g; T++) {
          for (var P = y >>> 26, z = y & 67108863, J = Math.min(T, u.length - 1), Z = Math.max(0, T - o.length + 1); Z <= J; Z++) {
            var F = T - Z | 0;
            b = o.words[F] | 0, _ = u.words[Z] | 0, p = b * _ + z, P += p / 67108864 | 0, z = p & 67108863;
          }
          c.words[T] = z | 0, y = P | 0;
        }
        return y !== 0 ? c.words[T] = y | 0 : c.length--, c._strip();
      }
      var C = function(u, c, g) {
        var b = u.words, _ = c.words, p = g.words, s = 0, y, T, P, z = b[0] | 0, J = z & 8191, Z = z >>> 13, F = b[1] | 0, ee = F & 8191, re = F >>> 13, de = b[2] | 0, se = de & 8191, Q = de >>> 13, ge = b[3] | 0, Ye = ge & 8191, Ce = ge >>> 13, Be = b[4] | 0, st = Be & 8191, De = Be >>> 13, _e = b[5] | 0, St = _e & 8191, Oe = _e >>> 13, Fe = b[6] | 0, Et = Fe & 8191, Ue = Fe >>> 13, oe = b[7] | 0, le = oe & 8191, ie = oe >>> 13, fe = b[8] | 0, Te = fe & 8191, N = fe >>> 13, R = b[9] | 0, L = R & 8191, V = R >>> 13, ne = _[0] | 0, Se = ne & 8191, ue = ne >>> 13, xe = _[1] | 0, He = xe & 8191, be = xe >>> 13, Ie = _[2] | 0, rt = Ie & 8191, Ne = Ie >>> 13, ze = _[3] | 0, kt = ze & 8191, Le = ze >>> 13, $e = _[4] | 0, Ot = $e & 8191, je = $e >>> 13, Ve = _[5] | 0, Nt = Ve & 8191, qe = Ve >>> 13, Ke = _[6] | 0, K = Ke & 8191, W = Ke >>> 13, G = _[7] | 0, U = G & 8191, X = G >>> 13, H = _[8] | 0, ye = H & 8191, ce = H >>> 13, we = _[9] | 0, Qe = we & 8191, Ze = we >>> 13;
        g.negative = u.negative ^ c.negative, g.length = 19, y = Math.imul(J, Se), T = Math.imul(J, ue), T = T + Math.imul(Z, Se) | 0, P = Math.imul(Z, ue);
        var lt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, y = Math.imul(ee, Se), T = Math.imul(ee, ue), T = T + Math.imul(re, Se) | 0, P = Math.imul(re, ue), y = y + Math.imul(J, He) | 0, T = T + Math.imul(J, be) | 0, T = T + Math.imul(Z, He) | 0, P = P + Math.imul(Z, be) | 0;
        var Xe = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, y = Math.imul(se, Se), T = Math.imul(se, ue), T = T + Math.imul(Q, Se) | 0, P = Math.imul(Q, ue), y = y + Math.imul(ee, He) | 0, T = T + Math.imul(ee, be) | 0, T = T + Math.imul(re, He) | 0, P = P + Math.imul(re, be) | 0, y = y + Math.imul(J, rt) | 0, T = T + Math.imul(J, Ne) | 0, T = T + Math.imul(Z, rt) | 0, P = P + Math.imul(Z, Ne) | 0;
        var ht = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, y = Math.imul(Ye, Se), T = Math.imul(Ye, ue), T = T + Math.imul(Ce, Se) | 0, P = Math.imul(Ce, ue), y = y + Math.imul(se, He) | 0, T = T + Math.imul(se, be) | 0, T = T + Math.imul(Q, He) | 0, P = P + Math.imul(Q, be) | 0, y = y + Math.imul(ee, rt) | 0, T = T + Math.imul(ee, Ne) | 0, T = T + Math.imul(re, rt) | 0, P = P + Math.imul(re, Ne) | 0, y = y + Math.imul(J, kt) | 0, T = T + Math.imul(J, Le) | 0, T = T + Math.imul(Z, kt) | 0, P = P + Math.imul(Z, Le) | 0;
        var ct = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, y = Math.imul(st, Se), T = Math.imul(st, ue), T = T + Math.imul(De, Se) | 0, P = Math.imul(De, ue), y = y + Math.imul(Ye, He) | 0, T = T + Math.imul(Ye, be) | 0, T = T + Math.imul(Ce, He) | 0, P = P + Math.imul(Ce, be) | 0, y = y + Math.imul(se, rt) | 0, T = T + Math.imul(se, Ne) | 0, T = T + Math.imul(Q, rt) | 0, P = P + Math.imul(Q, Ne) | 0, y = y + Math.imul(ee, kt) | 0, T = T + Math.imul(ee, Le) | 0, T = T + Math.imul(re, kt) | 0, P = P + Math.imul(re, Le) | 0, y = y + Math.imul(J, Ot) | 0, T = T + Math.imul(J, je) | 0, T = T + Math.imul(Z, Ot) | 0, P = P + Math.imul(Z, je) | 0;
        var pt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, y = Math.imul(St, Se), T = Math.imul(St, ue), T = T + Math.imul(Oe, Se) | 0, P = Math.imul(Oe, ue), y = y + Math.imul(st, He) | 0, T = T + Math.imul(st, be) | 0, T = T + Math.imul(De, He) | 0, P = P + Math.imul(De, be) | 0, y = y + Math.imul(Ye, rt) | 0, T = T + Math.imul(Ye, Ne) | 0, T = T + Math.imul(Ce, rt) | 0, P = P + Math.imul(Ce, Ne) | 0, y = y + Math.imul(se, kt) | 0, T = T + Math.imul(se, Le) | 0, T = T + Math.imul(Q, kt) | 0, P = P + Math.imul(Q, Le) | 0, y = y + Math.imul(ee, Ot) | 0, T = T + Math.imul(ee, je) | 0, T = T + Math.imul(re, Ot) | 0, P = P + Math.imul(re, je) | 0, y = y + Math.imul(J, Nt) | 0, T = T + Math.imul(J, qe) | 0, T = T + Math.imul(Z, Nt) | 0, P = P + Math.imul(Z, qe) | 0;
        var yt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, y = Math.imul(Et, Se), T = Math.imul(Et, ue), T = T + Math.imul(Ue, Se) | 0, P = Math.imul(Ue, ue), y = y + Math.imul(St, He) | 0, T = T + Math.imul(St, be) | 0, T = T + Math.imul(Oe, He) | 0, P = P + Math.imul(Oe, be) | 0, y = y + Math.imul(st, rt) | 0, T = T + Math.imul(st, Ne) | 0, T = T + Math.imul(De, rt) | 0, P = P + Math.imul(De, Ne) | 0, y = y + Math.imul(Ye, kt) | 0, T = T + Math.imul(Ye, Le) | 0, T = T + Math.imul(Ce, kt) | 0, P = P + Math.imul(Ce, Le) | 0, y = y + Math.imul(se, Ot) | 0, T = T + Math.imul(se, je) | 0, T = T + Math.imul(Q, Ot) | 0, P = P + Math.imul(Q, je) | 0, y = y + Math.imul(ee, Nt) | 0, T = T + Math.imul(ee, qe) | 0, T = T + Math.imul(re, Nt) | 0, P = P + Math.imul(re, qe) | 0, y = y + Math.imul(J, K) | 0, T = T + Math.imul(J, W) | 0, T = T + Math.imul(Z, K) | 0, P = P + Math.imul(Z, W) | 0;
        var bt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, y = Math.imul(le, Se), T = Math.imul(le, ue), T = T + Math.imul(ie, Se) | 0, P = Math.imul(ie, ue), y = y + Math.imul(Et, He) | 0, T = T + Math.imul(Et, be) | 0, T = T + Math.imul(Ue, He) | 0, P = P + Math.imul(Ue, be) | 0, y = y + Math.imul(St, rt) | 0, T = T + Math.imul(St, Ne) | 0, T = T + Math.imul(Oe, rt) | 0, P = P + Math.imul(Oe, Ne) | 0, y = y + Math.imul(st, kt) | 0, T = T + Math.imul(st, Le) | 0, T = T + Math.imul(De, kt) | 0, P = P + Math.imul(De, Le) | 0, y = y + Math.imul(Ye, Ot) | 0, T = T + Math.imul(Ye, je) | 0, T = T + Math.imul(Ce, Ot) | 0, P = P + Math.imul(Ce, je) | 0, y = y + Math.imul(se, Nt) | 0, T = T + Math.imul(se, qe) | 0, T = T + Math.imul(Q, Nt) | 0, P = P + Math.imul(Q, qe) | 0, y = y + Math.imul(ee, K) | 0, T = T + Math.imul(ee, W) | 0, T = T + Math.imul(re, K) | 0, P = P + Math.imul(re, W) | 0, y = y + Math.imul(J, U) | 0, T = T + Math.imul(J, X) | 0, T = T + Math.imul(Z, U) | 0, P = P + Math.imul(Z, X) | 0;
        var wt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, y = Math.imul(Te, Se), T = Math.imul(Te, ue), T = T + Math.imul(N, Se) | 0, P = Math.imul(N, ue), y = y + Math.imul(le, He) | 0, T = T + Math.imul(le, be) | 0, T = T + Math.imul(ie, He) | 0, P = P + Math.imul(ie, be) | 0, y = y + Math.imul(Et, rt) | 0, T = T + Math.imul(Et, Ne) | 0, T = T + Math.imul(Ue, rt) | 0, P = P + Math.imul(Ue, Ne) | 0, y = y + Math.imul(St, kt) | 0, T = T + Math.imul(St, Le) | 0, T = T + Math.imul(Oe, kt) | 0, P = P + Math.imul(Oe, Le) | 0, y = y + Math.imul(st, Ot) | 0, T = T + Math.imul(st, je) | 0, T = T + Math.imul(De, Ot) | 0, P = P + Math.imul(De, je) | 0, y = y + Math.imul(Ye, Nt) | 0, T = T + Math.imul(Ye, qe) | 0, T = T + Math.imul(Ce, Nt) | 0, P = P + Math.imul(Ce, qe) | 0, y = y + Math.imul(se, K) | 0, T = T + Math.imul(se, W) | 0, T = T + Math.imul(Q, K) | 0, P = P + Math.imul(Q, W) | 0, y = y + Math.imul(ee, U) | 0, T = T + Math.imul(ee, X) | 0, T = T + Math.imul(re, U) | 0, P = P + Math.imul(re, X) | 0, y = y + Math.imul(J, ye) | 0, T = T + Math.imul(J, ce) | 0, T = T + Math.imul(Z, ye) | 0, P = P + Math.imul(Z, ce) | 0;
        var mt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, y = Math.imul(L, Se), T = Math.imul(L, ue), T = T + Math.imul(V, Se) | 0, P = Math.imul(V, ue), y = y + Math.imul(Te, He) | 0, T = T + Math.imul(Te, be) | 0, T = T + Math.imul(N, He) | 0, P = P + Math.imul(N, be) | 0, y = y + Math.imul(le, rt) | 0, T = T + Math.imul(le, Ne) | 0, T = T + Math.imul(ie, rt) | 0, P = P + Math.imul(ie, Ne) | 0, y = y + Math.imul(Et, kt) | 0, T = T + Math.imul(Et, Le) | 0, T = T + Math.imul(Ue, kt) | 0, P = P + Math.imul(Ue, Le) | 0, y = y + Math.imul(St, Ot) | 0, T = T + Math.imul(St, je) | 0, T = T + Math.imul(Oe, Ot) | 0, P = P + Math.imul(Oe, je) | 0, y = y + Math.imul(st, Nt) | 0, T = T + Math.imul(st, qe) | 0, T = T + Math.imul(De, Nt) | 0, P = P + Math.imul(De, qe) | 0, y = y + Math.imul(Ye, K) | 0, T = T + Math.imul(Ye, W) | 0, T = T + Math.imul(Ce, K) | 0, P = P + Math.imul(Ce, W) | 0, y = y + Math.imul(se, U) | 0, T = T + Math.imul(se, X) | 0, T = T + Math.imul(Q, U) | 0, P = P + Math.imul(Q, X) | 0, y = y + Math.imul(ee, ye) | 0, T = T + Math.imul(ee, ce) | 0, T = T + Math.imul(re, ye) | 0, P = P + Math.imul(re, ce) | 0, y = y + Math.imul(J, Qe) | 0, T = T + Math.imul(J, Ze) | 0, T = T + Math.imul(Z, Qe) | 0, P = P + Math.imul(Z, Ze) | 0;
        var ft = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, y = Math.imul(L, He), T = Math.imul(L, be), T = T + Math.imul(V, He) | 0, P = Math.imul(V, be), y = y + Math.imul(Te, rt) | 0, T = T + Math.imul(Te, Ne) | 0, T = T + Math.imul(N, rt) | 0, P = P + Math.imul(N, Ne) | 0, y = y + Math.imul(le, kt) | 0, T = T + Math.imul(le, Le) | 0, T = T + Math.imul(ie, kt) | 0, P = P + Math.imul(ie, Le) | 0, y = y + Math.imul(Et, Ot) | 0, T = T + Math.imul(Et, je) | 0, T = T + Math.imul(Ue, Ot) | 0, P = P + Math.imul(Ue, je) | 0, y = y + Math.imul(St, Nt) | 0, T = T + Math.imul(St, qe) | 0, T = T + Math.imul(Oe, Nt) | 0, P = P + Math.imul(Oe, qe) | 0, y = y + Math.imul(st, K) | 0, T = T + Math.imul(st, W) | 0, T = T + Math.imul(De, K) | 0, P = P + Math.imul(De, W) | 0, y = y + Math.imul(Ye, U) | 0, T = T + Math.imul(Ye, X) | 0, T = T + Math.imul(Ce, U) | 0, P = P + Math.imul(Ce, X) | 0, y = y + Math.imul(se, ye) | 0, T = T + Math.imul(se, ce) | 0, T = T + Math.imul(Q, ye) | 0, P = P + Math.imul(Q, ce) | 0, y = y + Math.imul(ee, Qe) | 0, T = T + Math.imul(ee, Ze) | 0, T = T + Math.imul(re, Qe) | 0, P = P + Math.imul(re, Ze) | 0;
        var gt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, y = Math.imul(L, rt), T = Math.imul(L, Ne), T = T + Math.imul(V, rt) | 0, P = Math.imul(V, Ne), y = y + Math.imul(Te, kt) | 0, T = T + Math.imul(Te, Le) | 0, T = T + Math.imul(N, kt) | 0, P = P + Math.imul(N, Le) | 0, y = y + Math.imul(le, Ot) | 0, T = T + Math.imul(le, je) | 0, T = T + Math.imul(ie, Ot) | 0, P = P + Math.imul(ie, je) | 0, y = y + Math.imul(Et, Nt) | 0, T = T + Math.imul(Et, qe) | 0, T = T + Math.imul(Ue, Nt) | 0, P = P + Math.imul(Ue, qe) | 0, y = y + Math.imul(St, K) | 0, T = T + Math.imul(St, W) | 0, T = T + Math.imul(Oe, K) | 0, P = P + Math.imul(Oe, W) | 0, y = y + Math.imul(st, U) | 0, T = T + Math.imul(st, X) | 0, T = T + Math.imul(De, U) | 0, P = P + Math.imul(De, X) | 0, y = y + Math.imul(Ye, ye) | 0, T = T + Math.imul(Ye, ce) | 0, T = T + Math.imul(Ce, ye) | 0, P = P + Math.imul(Ce, ce) | 0, y = y + Math.imul(se, Qe) | 0, T = T + Math.imul(se, Ze) | 0, T = T + Math.imul(Q, Qe) | 0, P = P + Math.imul(Q, Ze) | 0;
        var at = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, y = Math.imul(L, kt), T = Math.imul(L, Le), T = T + Math.imul(V, kt) | 0, P = Math.imul(V, Le), y = y + Math.imul(Te, Ot) | 0, T = T + Math.imul(Te, je) | 0, T = T + Math.imul(N, Ot) | 0, P = P + Math.imul(N, je) | 0, y = y + Math.imul(le, Nt) | 0, T = T + Math.imul(le, qe) | 0, T = T + Math.imul(ie, Nt) | 0, P = P + Math.imul(ie, qe) | 0, y = y + Math.imul(Et, K) | 0, T = T + Math.imul(Et, W) | 0, T = T + Math.imul(Ue, K) | 0, P = P + Math.imul(Ue, W) | 0, y = y + Math.imul(St, U) | 0, T = T + Math.imul(St, X) | 0, T = T + Math.imul(Oe, U) | 0, P = P + Math.imul(Oe, X) | 0, y = y + Math.imul(st, ye) | 0, T = T + Math.imul(st, ce) | 0, T = T + Math.imul(De, ye) | 0, P = P + Math.imul(De, ce) | 0, y = y + Math.imul(Ye, Qe) | 0, T = T + Math.imul(Ye, Ze) | 0, T = T + Math.imul(Ce, Qe) | 0, P = P + Math.imul(Ce, Ze) | 0;
        var dt = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, y = Math.imul(L, Ot), T = Math.imul(L, je), T = T + Math.imul(V, Ot) | 0, P = Math.imul(V, je), y = y + Math.imul(Te, Nt) | 0, T = T + Math.imul(Te, qe) | 0, T = T + Math.imul(N, Nt) | 0, P = P + Math.imul(N, qe) | 0, y = y + Math.imul(le, K) | 0, T = T + Math.imul(le, W) | 0, T = T + Math.imul(ie, K) | 0, P = P + Math.imul(ie, W) | 0, y = y + Math.imul(Et, U) | 0, T = T + Math.imul(Et, X) | 0, T = T + Math.imul(Ue, U) | 0, P = P + Math.imul(Ue, X) | 0, y = y + Math.imul(St, ye) | 0, T = T + Math.imul(St, ce) | 0, T = T + Math.imul(Oe, ye) | 0, P = P + Math.imul(Oe, ce) | 0, y = y + Math.imul(st, Qe) | 0, T = T + Math.imul(st, Ze) | 0, T = T + Math.imul(De, Qe) | 0, P = P + Math.imul(De, Ze) | 0;
        var ve = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, y = Math.imul(L, Nt), T = Math.imul(L, qe), T = T + Math.imul(V, Nt) | 0, P = Math.imul(V, qe), y = y + Math.imul(Te, K) | 0, T = T + Math.imul(Te, W) | 0, T = T + Math.imul(N, K) | 0, P = P + Math.imul(N, W) | 0, y = y + Math.imul(le, U) | 0, T = T + Math.imul(le, X) | 0, T = T + Math.imul(ie, U) | 0, P = P + Math.imul(ie, X) | 0, y = y + Math.imul(Et, ye) | 0, T = T + Math.imul(Et, ce) | 0, T = T + Math.imul(Ue, ye) | 0, P = P + Math.imul(Ue, ce) | 0, y = y + Math.imul(St, Qe) | 0, T = T + Math.imul(St, Ze) | 0, T = T + Math.imul(Oe, Qe) | 0, P = P + Math.imul(Oe, Ze) | 0;
        var D = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, y = Math.imul(L, K), T = Math.imul(L, W), T = T + Math.imul(V, K) | 0, P = Math.imul(V, W), y = y + Math.imul(Te, U) | 0, T = T + Math.imul(Te, X) | 0, T = T + Math.imul(N, U) | 0, P = P + Math.imul(N, X) | 0, y = y + Math.imul(le, ye) | 0, T = T + Math.imul(le, ce) | 0, T = T + Math.imul(ie, ye) | 0, P = P + Math.imul(ie, ce) | 0, y = y + Math.imul(Et, Qe) | 0, T = T + Math.imul(Et, Ze) | 0, T = T + Math.imul(Ue, Qe) | 0, P = P + Math.imul(Ue, Ze) | 0;
        var j = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, y = Math.imul(L, U), T = Math.imul(L, X), T = T + Math.imul(V, U) | 0, P = Math.imul(V, X), y = y + Math.imul(Te, ye) | 0, T = T + Math.imul(Te, ce) | 0, T = T + Math.imul(N, ye) | 0, P = P + Math.imul(N, ce) | 0, y = y + Math.imul(le, Qe) | 0, T = T + Math.imul(le, Ze) | 0, T = T + Math.imul(ie, Qe) | 0, P = P + Math.imul(ie, Ze) | 0;
        var Y = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, y = Math.imul(L, ye), T = Math.imul(L, ce), T = T + Math.imul(V, ye) | 0, P = Math.imul(V, ce), y = y + Math.imul(Te, Qe) | 0, T = T + Math.imul(Te, Ze) | 0, T = T + Math.imul(N, Qe) | 0, P = P + Math.imul(N, Ze) | 0;
        var me = (s + y | 0) + ((T & 8191) << 13) | 0;
        s = (P + (T >>> 13) | 0) + (me >>> 26) | 0, me &= 67108863, y = Math.imul(L, Qe), T = Math.imul(L, Ze), T = T + Math.imul(V, Qe) | 0, P = Math.imul(V, Ze);
        var pe = (s + y | 0) + ((T & 8191) << 13) | 0;
        return s = (P + (T >>> 13) | 0) + (pe >>> 26) | 0, pe &= 67108863, p[0] = lt, p[1] = Xe, p[2] = ht, p[3] = ct, p[4] = pt, p[5] = yt, p[6] = bt, p[7] = wt, p[8] = mt, p[9] = ft, p[10] = gt, p[11] = at, p[12] = dt, p[13] = ve, p[14] = D, p[15] = j, p[16] = Y, p[17] = me, p[18] = pe, s !== 0 && (p[19] = s, g.length++), g;
      };
      Math.imul || (C = k);
      function I(o, u, c) {
        c.negative = u.negative ^ o.negative, c.length = o.length + u.length;
        for (var g = 0, b = 0, _ = 0; _ < c.length - 1; _++) {
          var p = b;
          b = 0;
          for (var s = g & 67108863, y = Math.min(_, u.length - 1), T = Math.max(0, _ - o.length + 1); T <= y; T++) {
            var P = _ - T, z = o.words[P] | 0, J = u.words[T] | 0, Z = z * J, F = Z & 67108863;
            p = p + (Z / 67108864 | 0) | 0, F = F + s | 0, s = F & 67108863, p = p + (F >>> 26) | 0, b += p >>> 26, p &= 67108863;
          }
          c.words[_] = s, g = p, p = b;
        }
        return g !== 0 ? c.words[_] = g : c.length--, c._strip();
      }
      function O(o, u, c) {
        return I(o, u, c);
      }
      a.prototype.mulTo = function(u, c) {
        var g, b = this.length + u.length;
        return this.length === 10 && u.length === 10 ? g = C(this, u, c) : b < 63 ? g = k(this, u, c) : b < 1024 ? g = I(this, u, c) : g = O(this, u, c), g;
      }, a.prototype.mul = function(u) {
        var c = new a(null);
        return c.words = new Array(this.length + u.length), this.mulTo(u, c);
      }, a.prototype.mulf = function(u) {
        var c = new a(null);
        return c.words = new Array(this.length + u.length), O(this, u, c);
      }, a.prototype.imul = function(u) {
        return this.clone().mulTo(u, this);
      }, a.prototype.imuln = function(u) {
        var c = u < 0;
        c && (u = -u), i(typeof u == "number"), i(u < 67108864);
        for (var g = 0, b = 0; b < this.length; b++) {
          var _ = (this.words[b] | 0) * u, p = (_ & 67108863) + (g & 67108863);
          g >>= 26, g += _ / 67108864 | 0, g += p >>> 26, this.words[b] = p & 67108863;
        }
        return g !== 0 && (this.words[b] = g, this.length++), c ? this.ineg() : this;
      }, a.prototype.muln = function(u) {
        return this.clone().imuln(u);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(u) {
        var c = B(u);
        if (c.length === 0)
          return new a(1);
        for (var g = this, b = 0; b < c.length && c[b] === 0; b++, g = g.sqr())
          ;
        if (++b < c.length)
          for (var _ = g.sqr(); b < c.length; b++, _ = _.sqr())
            c[b] !== 0 && (g = g.mul(_));
        return g;
      }, a.prototype.iushln = function(u) {
        i(typeof u == "number" && u >= 0);
        var c = u % 26, g = (u - c) / 26, b = 67108863 >>> 26 - c << 26 - c, _;
        if (c !== 0) {
          var p = 0;
          for (_ = 0; _ < this.length; _++) {
            var s = this.words[_] & b, y = (this.words[_] | 0) - s << c;
            this.words[_] = y | p, p = s >>> 26 - c;
          }
          p && (this.words[_] = p, this.length++);
        }
        if (g !== 0) {
          for (_ = this.length - 1; _ >= 0; _--)
            this.words[_ + g] = this.words[_];
          for (_ = 0; _ < g; _++)
            this.words[_] = 0;
          this.length += g;
        }
        return this._strip();
      }, a.prototype.ishln = function(u) {
        return i(this.negative === 0), this.iushln(u);
      }, a.prototype.iushrn = function(u, c, g) {
        i(typeof u == "number" && u >= 0);
        var b;
        c ? b = (c - c % 26) / 26 : b = 0;
        var _ = u % 26, p = Math.min((u - _) / 26, this.length), s = 67108863 ^ 67108863 >>> _ << _, y = g;
        if (b -= p, b = Math.max(0, b), y) {
          for (var T = 0; T < p; T++)
            y.words[T] = this.words[T];
          y.length = p;
        }
        if (p !== 0)
          if (this.length > p)
            for (this.length -= p, T = 0; T < this.length; T++)
              this.words[T] = this.words[T + p];
          else
            this.words[0] = 0, this.length = 1;
        var P = 0;
        for (T = this.length - 1; T >= 0 && (P !== 0 || T >= b); T--) {
          var z = this.words[T] | 0;
          this.words[T] = P << 26 - _ | z >>> _, P = z & s;
        }
        return y && P !== 0 && (y.words[y.length++] = P), this.length === 0 && (this.words[0] = 0, this.length = 1), this._strip();
      }, a.prototype.ishrn = function(u, c, g) {
        return i(this.negative === 0), this.iushrn(u, c, g);
      }, a.prototype.shln = function(u) {
        return this.clone().ishln(u);
      }, a.prototype.ushln = function(u) {
        return this.clone().iushln(u);
      }, a.prototype.shrn = function(u) {
        return this.clone().ishrn(u);
      }, a.prototype.ushrn = function(u) {
        return this.clone().iushrn(u);
      }, a.prototype.testn = function(u) {
        i(typeof u == "number" && u >= 0);
        var c = u % 26, g = (u - c) / 26, b = 1 << c;
        if (this.length <= g)
          return !1;
        var _ = this.words[g];
        return !!(_ & b);
      }, a.prototype.imaskn = function(u) {
        i(typeof u == "number" && u >= 0);
        var c = u % 26, g = (u - c) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= g)
          return this;
        if (c !== 0 && g++, this.length = Math.min(g, this.length), c !== 0) {
          var b = 67108863 ^ 67108863 >>> c << c;
          this.words[this.length - 1] &= b;
        }
        return this._strip();
      }, a.prototype.maskn = function(u) {
        return this.clone().imaskn(u);
      }, a.prototype.iaddn = function(u) {
        return i(typeof u == "number"), i(u < 67108864), u < 0 ? this.isubn(-u) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) <= u ? (this.words[0] = u - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(u), this.negative = 1, this) : this._iaddn(u);
      }, a.prototype._iaddn = function(u) {
        this.words[0] += u;
        for (var c = 0; c < this.length && this.words[c] >= 67108864; c++)
          this.words[c] -= 67108864, c === this.length - 1 ? this.words[c + 1] = 1 : this.words[c + 1]++;
        return this.length = Math.max(this.length, c + 1), this;
      }, a.prototype.isubn = function(u) {
        if (i(typeof u == "number"), i(u < 67108864), u < 0)
          return this.iaddn(-u);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(u), this.negative = 1, this;
        if (this.words[0] -= u, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var c = 0; c < this.length && this.words[c] < 0; c++)
            this.words[c] += 67108864, this.words[c + 1] -= 1;
        return this._strip();
      }, a.prototype.addn = function(u) {
        return this.clone().iaddn(u);
      }, a.prototype.subn = function(u) {
        return this.clone().isubn(u);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(u, c, g) {
        var b = u.length + g, _;
        this._expand(b);
        var p, s = 0;
        for (_ = 0; _ < u.length; _++) {
          p = (this.words[_ + g] | 0) + s;
          var y = (u.words[_] | 0) * c;
          p -= y & 67108863, s = (p >> 26) - (y / 67108864 | 0), this.words[_ + g] = p & 67108863;
        }
        for (; _ < this.length - g; _++)
          p = (this.words[_ + g] | 0) + s, s = p >> 26, this.words[_ + g] = p & 67108863;
        if (s === 0)
          return this._strip();
        for (i(s === -1), s = 0, _ = 0; _ < this.length; _++)
          p = -(this.words[_] | 0) + s, s = p >> 26, this.words[_] = p & 67108863;
        return this.negative = 1, this._strip();
      }, a.prototype._wordDiv = function(u, c) {
        var g = this.length - u.length, b = this.clone(), _ = u, p = _.words[_.length - 1] | 0, s = this._countBits(p);
        g = 26 - s, g !== 0 && (_ = _.ushln(g), b.iushln(g), p = _.words[_.length - 1] | 0);
        var y = b.length - _.length, T;
        if (c !== "mod") {
          T = new a(null), T.length = y + 1, T.words = new Array(T.length);
          for (var P = 0; P < T.length; P++)
            T.words[P] = 0;
        }
        var z = b.clone()._ishlnsubmul(_, 1, y);
        z.negative === 0 && (b = z, T && (T.words[y] = 1));
        for (var J = y - 1; J >= 0; J--) {
          var Z = (b.words[_.length + J] | 0) * 67108864 + (b.words[_.length + J - 1] | 0);
          for (Z = Math.min(Z / p | 0, 67108863), b._ishlnsubmul(_, Z, J); b.negative !== 0; )
            Z--, b.negative = 0, b._ishlnsubmul(_, 1, J), b.isZero() || (b.negative ^= 1);
          T && (T.words[J] = Z);
        }
        return T && T._strip(), b._strip(), c !== "div" && g !== 0 && b.iushrn(g), {
          div: T || null,
          mod: b
        };
      }, a.prototype.divmod = function(u, c, g) {
        if (i(!u.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var b, _, p;
        return this.negative !== 0 && u.negative === 0 ? (p = this.neg().divmod(u, c), c !== "mod" && (b = p.div.neg()), c !== "div" && (_ = p.mod.neg(), g && _.negative !== 0 && _.iadd(u)), {
          div: b,
          mod: _
        }) : this.negative === 0 && u.negative !== 0 ? (p = this.divmod(u.neg(), c), c !== "mod" && (b = p.div.neg()), {
          div: b,
          mod: p.mod
        }) : this.negative & u.negative ? (p = this.neg().divmod(u.neg(), c), c !== "div" && (_ = p.mod.neg(), g && _.negative !== 0 && _.isub(u)), {
          div: p.div,
          mod: _
        }) : u.length > this.length || this.cmp(u) < 0 ? {
          div: new a(0),
          mod: this
        } : u.length === 1 ? c === "div" ? {
          div: this.divn(u.words[0]),
          mod: null
        } : c === "mod" ? {
          div: null,
          mod: new a(this.modrn(u.words[0]))
        } : {
          div: this.divn(u.words[0]),
          mod: new a(this.modrn(u.words[0]))
        } : this._wordDiv(u, c);
      }, a.prototype.div = function(u) {
        return this.divmod(u, "div", !1).div;
      }, a.prototype.mod = function(u) {
        return this.divmod(u, "mod", !1).mod;
      }, a.prototype.umod = function(u) {
        return this.divmod(u, "mod", !0).mod;
      }, a.prototype.divRound = function(u) {
        var c = this.divmod(u);
        if (c.mod.isZero())
          return c.div;
        var g = c.div.negative !== 0 ? c.mod.isub(u) : c.mod, b = u.ushrn(1), _ = u.andln(1), p = g.cmp(b);
        return p < 0 || _ === 1 && p === 0 ? c.div : c.div.negative !== 0 ? c.div.isubn(1) : c.div.iaddn(1);
      }, a.prototype.modrn = function(u) {
        var c = u < 0;
        c && (u = -u), i(u <= 67108863);
        for (var g = (1 << 26) % u, b = 0, _ = this.length - 1; _ >= 0; _--)
          b = (g * b + (this.words[_] | 0)) % u;
        return c ? -b : b;
      }, a.prototype.modn = function(u) {
        return this.modrn(u);
      }, a.prototype.idivn = function(u) {
        var c = u < 0;
        c && (u = -u), i(u <= 67108863);
        for (var g = 0, b = this.length - 1; b >= 0; b--) {
          var _ = (this.words[b] | 0) + g * 67108864;
          this.words[b] = _ / u | 0, g = _ % u;
        }
        return this._strip(), c ? this.ineg() : this;
      }, a.prototype.divn = function(u) {
        return this.clone().idivn(u);
      }, a.prototype.egcd = function(u) {
        i(u.negative === 0), i(!u.isZero());
        var c = this, g = u.clone();
        c.negative !== 0 ? c = c.umod(u) : c = c.clone();
        for (var b = new a(1), _ = new a(0), p = new a(0), s = new a(1), y = 0; c.isEven() && g.isEven(); )
          c.iushrn(1), g.iushrn(1), ++y;
        for (var T = g.clone(), P = c.clone(); !c.isZero(); ) {
          for (var z = 0, J = 1; !(c.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (c.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(T), _.isub(P)), b.iushrn(1), _.iushrn(1);
          for (var Z = 0, F = 1; !(g.words[0] & F) && Z < 26; ++Z, F <<= 1)
            ;
          if (Z > 0)
            for (g.iushrn(Z); Z-- > 0; )
              (p.isOdd() || s.isOdd()) && (p.iadd(T), s.isub(P)), p.iushrn(1), s.iushrn(1);
          c.cmp(g) >= 0 ? (c.isub(g), b.isub(p), _.isub(s)) : (g.isub(c), p.isub(b), s.isub(_));
        }
        return {
          a: p,
          b: s,
          gcd: g.iushln(y)
        };
      }, a.prototype._invmp = function(u) {
        i(u.negative === 0), i(!u.isZero());
        var c = this, g = u.clone();
        c.negative !== 0 ? c = c.umod(u) : c = c.clone();
        for (var b = new a(1), _ = new a(0), p = g.clone(); c.cmpn(1) > 0 && g.cmpn(1) > 0; ) {
          for (var s = 0, y = 1; !(c.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (c.iushrn(s); s-- > 0; )
              b.isOdd() && b.iadd(p), b.iushrn(1);
          for (var T = 0, P = 1; !(g.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (g.iushrn(T); T-- > 0; )
              _.isOdd() && _.iadd(p), _.iushrn(1);
          c.cmp(g) >= 0 ? (c.isub(g), b.isub(_)) : (g.isub(c), _.isub(b));
        }
        var z;
        return c.cmpn(1) === 0 ? z = b : z = _, z.cmpn(0) < 0 && z.iadd(u), z;
      }, a.prototype.gcd = function(u) {
        if (this.isZero())
          return u.abs();
        if (u.isZero())
          return this.abs();
        var c = this.clone(), g = u.clone();
        c.negative = 0, g.negative = 0;
        for (var b = 0; c.isEven() && g.isEven(); b++)
          c.iushrn(1), g.iushrn(1);
        do {
          for (; c.isEven(); )
            c.iushrn(1);
          for (; g.isEven(); )
            g.iushrn(1);
          var _ = c.cmp(g);
          if (_ < 0) {
            var p = c;
            c = g, g = p;
          } else if (_ === 0 || g.cmpn(1) === 0)
            break;
          c.isub(g);
        } while (!0);
        return g.iushln(b);
      }, a.prototype.invm = function(u) {
        return this.egcd(u).a.umod(u);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(u) {
        return this.words[0] & u;
      }, a.prototype.bincn = function(u) {
        i(typeof u == "number");
        var c = u % 26, g = (u - c) / 26, b = 1 << c;
        if (this.length <= g)
          return this._expand(g + 1), this.words[g] |= b, this;
        for (var _ = b, p = g; _ !== 0 && p < this.length; p++) {
          var s = this.words[p] | 0;
          s += _, _ = s >>> 26, s &= 67108863, this.words[p] = s;
        }
        return _ !== 0 && (this.words[p] = _, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(u) {
        var c = u < 0;
        if (this.negative !== 0 && !c)
          return -1;
        if (this.negative === 0 && c)
          return 1;
        this._strip();
        var g;
        if (this.length > 1)
          g = 1;
        else {
          c && (u = -u), i(u <= 67108863, "Number is too big");
          var b = this.words[0] | 0;
          g = b === u ? 0 : b < u ? -1 : 1;
        }
        return this.negative !== 0 ? -g | 0 : g;
      }, a.prototype.cmp = function(u) {
        if (this.negative !== 0 && u.negative === 0)
          return -1;
        if (this.negative === 0 && u.negative !== 0)
          return 1;
        var c = this.ucmp(u);
        return this.negative !== 0 ? -c | 0 : c;
      }, a.prototype.ucmp = function(u) {
        if (this.length > u.length)
          return 1;
        if (this.length < u.length)
          return -1;
        for (var c = 0, g = this.length - 1; g >= 0; g--) {
          var b = this.words[g] | 0, _ = u.words[g] | 0;
          if (b !== _) {
            b < _ ? c = -1 : b > _ && (c = 1);
            break;
          }
        }
        return c;
      }, a.prototype.gtn = function(u) {
        return this.cmpn(u) === 1;
      }, a.prototype.gt = function(u) {
        return this.cmp(u) === 1;
      }, a.prototype.gten = function(u) {
        return this.cmpn(u) >= 0;
      }, a.prototype.gte = function(u) {
        return this.cmp(u) >= 0;
      }, a.prototype.ltn = function(u) {
        return this.cmpn(u) === -1;
      }, a.prototype.lt = function(u) {
        return this.cmp(u) === -1;
      }, a.prototype.lten = function(u) {
        return this.cmpn(u) <= 0;
      }, a.prototype.lte = function(u) {
        return this.cmp(u) <= 0;
      }, a.prototype.eqn = function(u) {
        return this.cmpn(u) === 0;
      }, a.prototype.eq = function(u) {
        return this.cmp(u) === 0;
      }, a.red = function(u) {
        return new x(u);
      }, a.prototype.toRed = function(u) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), u.convertTo(this)._forceRed(u);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(u) {
        return this.red = u, this;
      }, a.prototype.forceRed = function(u) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(u);
      }, a.prototype.redAdd = function(u) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, u);
      }, a.prototype.redIAdd = function(u) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, u);
      }, a.prototype.redSub = function(u) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, u);
      }, a.prototype.redISub = function(u) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, u);
      }, a.prototype.redShl = function(u) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, u);
      }, a.prototype.redMul = function(u) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, u), this.red.mul(this, u);
      }, a.prototype.redIMul = function(u) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, u), this.red.imul(this, u);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(u) {
        return i(this.red && !u.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, u);
      };
      var q = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function $(o, u) {
        this.name = o, this.p = new a(u, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      $.prototype._tmp = function() {
        var u = new a(null);
        return u.words = new Array(Math.ceil(this.n / 13)), u;
      }, $.prototype.ireduce = function(u) {
        var c = u, g;
        do
          this.split(c, this.tmp), c = this.imulK(c), c = c.iadd(this.tmp), g = c.bitLength();
        while (g > this.n);
        var b = g < this.n ? -1 : c.ucmp(this.p);
        return b === 0 ? (c.words[0] = 0, c.length = 1) : b > 0 ? c.isub(this.p) : c.strip !== void 0 ? c.strip() : c._strip(), c;
      }, $.prototype.split = function(u, c) {
        u.iushrn(this.n, 0, c);
      }, $.prototype.imulK = function(u) {
        return u.imul(this.k);
      };
      function ae() {
        $.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(ae, $), ae.prototype.split = function(u, c) {
        for (var g = 4194303, b = Math.min(u.length, 9), _ = 0; _ < b; _++)
          c.words[_] = u.words[_];
        if (c.length = b, u.length <= 9) {
          u.words[0] = 0, u.length = 1;
          return;
        }
        var p = u.words[9];
        for (c.words[c.length++] = p & g, _ = 10; _ < u.length; _++) {
          var s = u.words[_] | 0;
          u.words[_ - 10] = (s & g) << 4 | p >>> 22, p = s;
        }
        p >>>= 22, u.words[_ - 10] = p, p === 0 && u.length > 10 ? u.length -= 10 : u.length -= 9;
      }, ae.prototype.imulK = function(u) {
        u.words[u.length] = 0, u.words[u.length + 1] = 0, u.length += 2;
        for (var c = 0, g = 0; g < u.length; g++) {
          var b = u.words[g] | 0;
          c += b * 977, u.words[g] = c & 67108863, c = b * 64 + (c / 67108864 | 0);
        }
        return u.words[u.length - 1] === 0 && (u.length--, u.words[u.length - 1] === 0 && u.length--), u;
      };
      function he() {
        $.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f(he, $);
      function te() {
        $.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(te, $);
      function Ee() {
        $.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(Ee, $), Ee.prototype.imulK = function(u) {
        for (var c = 0, g = 0; g < u.length; g++) {
          var b = (u.words[g] | 0) * 19 + c, _ = b & 67108863;
          b >>>= 26, u.words[g] = _, c = b;
        }
        return c !== 0 && (u.words[u.length++] = c), u;
      }, a._prime = function(u) {
        if (q[u])
          return q[u];
        var c;
        if (u === "k256")
          c = new ae();
        else if (u === "p224")
          c = new he();
        else if (u === "p192")
          c = new te();
        else if (u === "p25519")
          c = new Ee();
        else
          throw new Error("Unknown prime " + u);
        return q[u] = c, c;
      };
      function x(o) {
        if (typeof o == "string") {
          var u = a._prime(o);
          this.m = u.p, this.prime = u;
        } else
          i(o.gtn(1), "modulus must be greater than 1"), this.m = o, this.prime = null;
      }
      x.prototype._verify1 = function(u) {
        i(u.negative === 0, "red works only with positives"), i(u.red, "red works only with red numbers");
      }, x.prototype._verify2 = function(u, c) {
        i((u.negative | c.negative) === 0, "red works only with positives"), i(
          u.red && u.red === c.red,
          "red works only with red numbers"
        );
      }, x.prototype.imod = function(u) {
        return this.prime ? this.prime.ireduce(u)._forceRed(this) : (h(u, u.umod(this.m)._forceRed(this)), u);
      }, x.prototype.neg = function(u) {
        return u.isZero() ? u.clone() : this.m.sub(u)._forceRed(this);
      }, x.prototype.add = function(u, c) {
        this._verify2(u, c);
        var g = u.add(c);
        return g.cmp(this.m) >= 0 && g.isub(this.m), g._forceRed(this);
      }, x.prototype.iadd = function(u, c) {
        this._verify2(u, c);
        var g = u.iadd(c);
        return g.cmp(this.m) >= 0 && g.isub(this.m), g;
      }, x.prototype.sub = function(u, c) {
        this._verify2(u, c);
        var g = u.sub(c);
        return g.cmpn(0) < 0 && g.iadd(this.m), g._forceRed(this);
      }, x.prototype.isub = function(u, c) {
        this._verify2(u, c);
        var g = u.isub(c);
        return g.cmpn(0) < 0 && g.iadd(this.m), g;
      }, x.prototype.shl = function(u, c) {
        return this._verify1(u), this.imod(u.ushln(c));
      }, x.prototype.imul = function(u, c) {
        return this._verify2(u, c), this.imod(u.imul(c));
      }, x.prototype.mul = function(u, c) {
        return this._verify2(u, c), this.imod(u.mul(c));
      }, x.prototype.isqr = function(u) {
        return this.imul(u, u.clone());
      }, x.prototype.sqr = function(u) {
        return this.mul(u, u);
      }, x.prototype.sqrt = function(u) {
        if (u.isZero())
          return u.clone();
        var c = this.m.andln(3);
        if (i(c % 2 === 1), c === 3) {
          var g = this.m.add(new a(1)).iushrn(2);
          return this.pow(u, g);
        }
        for (var b = this.m.subn(1), _ = 0; !b.isZero() && b.andln(1) === 0; )
          _++, b.iushrn(1);
        i(!b.isZero());
        var p = new a(1).toRed(this), s = p.redNeg(), y = this.m.subn(1).iushrn(1), T = this.m.bitLength();
        for (T = new a(2 * T * T).toRed(this); this.pow(T, y).cmp(s) !== 0; )
          T.redIAdd(s);
        for (var P = this.pow(T, b), z = this.pow(u, b.addn(1).iushrn(1)), J = this.pow(u, b), Z = _; J.cmp(p) !== 0; ) {
          for (var F = J, ee = 0; F.cmp(p) !== 0; ee++)
            F = F.redSqr();
          i(ee < Z);
          var re = this.pow(P, new a(1).iushln(Z - ee - 1));
          z = z.redMul(re), P = re.redSqr(), J = J.redMul(P), Z = ee;
        }
        return z;
      }, x.prototype.invm = function(u) {
        var c = u._invmp(this.m);
        return c.negative !== 0 ? (c.negative = 0, this.imod(c).redNeg()) : this.imod(c);
      }, x.prototype.pow = function(u, c) {
        if (c.isZero())
          return new a(1).toRed(this);
        if (c.cmpn(1) === 0)
          return u.clone();
        var g = 4, b = new Array(1 << g);
        b[0] = new a(1).toRed(this), b[1] = u;
        for (var _ = 2; _ < b.length; _++)
          b[_] = this.mul(b[_ - 1], u);
        var p = b[0], s = 0, y = 0, T = c.bitLength() % 26;
        for (T === 0 && (T = 26), _ = c.length - 1; _ >= 0; _--) {
          for (var P = c.words[_], z = T - 1; z >= 0; z--) {
            var J = P >> z & 1;
            if (p !== b[0] && (p = this.sqr(p)), J === 0 && s === 0) {
              y = 0;
              continue;
            }
            s <<= 1, s |= J, y++, !(y !== g && (_ !== 0 || z !== 0)) && (p = this.mul(p, b[s]), y = 0, s = 0);
          }
          T = 26;
        }
        return p;
      }, x.prototype.convertTo = function(u) {
        var c = u.umod(this.m);
        return c === u ? c.clone() : c;
      }, x.prototype.convertFrom = function(u) {
        var c = u.clone();
        return c.red = null, c;
      }, a.mont = function(u) {
        return new n(u);
      };
      function n(o) {
        x.call(this, o), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(n, x), n.prototype.convertTo = function(u) {
        return this.imod(u.ushln(this.shift));
      }, n.prototype.convertFrom = function(u) {
        var c = this.imod(u.mul(this.rinv));
        return c.red = null, c;
      }, n.prototype.imul = function(u, c) {
        if (u.isZero() || c.isZero())
          return u.words[0] = 0, u.length = 1, u;
        var g = u.imul(c), b = g.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = g.isub(b).iushrn(this.shift), p = _;
        return _.cmp(this.m) >= 0 ? p = _.isub(this.m) : _.cmpn(0) < 0 && (p = _.iadd(this.m)), p._forceRed(this);
      }, n.prototype.mul = function(u, c) {
        if (u.isZero() || c.isZero())
          return new a(0)._forceRed(this);
        var g = u.mul(c), b = g.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), _ = g.isub(b).iushrn(this.shift), p = _;
        return _.cmp(this.m) >= 0 ? p = _.isub(this.m) : _.cmpn(0) < 0 && (p = _.iadd(this.m)), p._forceRed(this);
      }, n.prototype.invm = function(u) {
        var c = this.imod(u._invmp(this.m).mul(this.r2));
        return c._forceRed(this);
      };
    })(t, ut);
  }(Gu)), Gu.exports;
}
var P0, D6;
function km() {
  if (D6)
    return P0;
  D6 = 1;
  var t = Am(), e = go();
  function r(a) {
    var l = i(a), d = l.toRed(t.mont(a.modulus)).redPow(new t(a.publicExponent)).fromRed();
    return { blinder: d, unblinder: l.invm(a.modulus) };
  }
  function i(a) {
    var l = a.modulus.byteLength(), d;
    do
      d = new t(e(l));
    while (d.cmp(a.modulus) >= 0 || !d.umod(a.prime1) || !d.umod(a.prime2));
    return d;
  }
  function f(a, l) {
    var d = r(l), v = l.modulus.byteLength(), m = new t(a).mul(d.blinder).umod(l.modulus), h = m.toRed(t.mont(l.prime1)), w = m.toRed(t.mont(l.prime2)), M = l.coefficient, S = l.prime1, E = l.prime2, A = h.redPow(l.exponent1).fromRed(), B = w.redPow(l.exponent2).fromRed(), k = A.isub(B).imul(M).umod(S).imul(E);
    return B.iadd(k).imul(d.unblinder).umod(l.modulus).toArrayLike(Je, "be", v);
  }
  return f.getr = i, P0 = f, P0;
}
var O0 = {};
const SI = "elliptic", EI = "6.5.5", AI = "EC cryptography", kI = "lib/elliptic.js", TI = [
  "lib"
], CI = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, BI = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, II = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], RI = "Fedor Indutny <fedor@indutny.com>", PI = "MIT", OI = {
  url: "https://github.com/indutny/elliptic/issues"
}, NI = "https://github.com/indutny/elliptic", DI = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, UI = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, LI = {
  name: SI,
  version: EI,
  description: AI,
  main: kI,
  files: TI,
  scripts: CI,
  repository: BI,
  keywords: II,
  author: RI,
  license: PI,
  bugs: OI,
  homepage: NI,
  devDependencies: DI,
  dependencies: UI
};
var N0 = {}, Qu = { exports: {} };
Qu.exports;
var U6;
function Ti() {
  return U6 || (U6 = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(Qu)), Qu.exports;
}
var D0 = {}, L6;
function Tm() {
  return L6 || (L6 = 1, function(t) {
    var e = t;
    function r(a, l) {
      if (Array.isArray(a))
        return a.slice();
      if (!a)
        return [];
      var d = [];
      if (typeof a != "string") {
        for (var v = 0; v < a.length; v++)
          d[v] = a[v] | 0;
        return d;
      }
      if (l === "hex") {
        a = a.replace(/[^a-z0-9]+/ig, ""), a.length % 2 !== 0 && (a = "0" + a);
        for (var v = 0; v < a.length; v += 2)
          d.push(parseInt(a[v] + a[v + 1], 16));
      } else
        for (var v = 0; v < a.length; v++) {
          var m = a.charCodeAt(v), h = m >> 8, w = m & 255;
          h ? d.push(h, w) : d.push(w);
        }
      return d;
    }
    e.toArray = r;
    function i(a) {
      return a.length === 1 ? "0" + a : a;
    }
    e.zero2 = i;
    function f(a) {
      for (var l = "", d = 0; d < a.length; d++)
        l += i(a[d].toString(16));
      return l;
    }
    e.toHex = f, e.encode = function(l, d) {
      return d === "hex" ? f(l) : l;
    };
  }(D0)), D0;
}
var F6;
function An() {
  return F6 || (F6 = 1, function(t) {
    var e = t, r = Ti(), i = mn(), f = Tm();
    e.assert = i, e.toArray = f.toArray, e.zero2 = f.zero2, e.toHex = f.toHex, e.encode = f.encode;
    function a(h, w, M) {
      var S = new Array(Math.max(h.bitLength(), M) + 1), E;
      for (E = 0; E < S.length; E += 1)
        S[E] = 0;
      var A = 1 << w + 1, B = h.clone();
      for (E = 0; E < S.length; E++) {
        var k, C = B.andln(A - 1);
        B.isOdd() ? (C > (A >> 1) - 1 ? k = (A >> 1) - C : k = C, B.isubn(k)) : k = 0, S[E] = k, B.iushrn(1);
      }
      return S;
    }
    e.getNAF = a;
    function l(h, w) {
      var M = [
        [],
        []
      ];
      h = h.clone(), w = w.clone();
      for (var S = 0, E = 0, A; h.cmpn(-S) > 0 || w.cmpn(-E) > 0; ) {
        var B = h.andln(3) + S & 3, k = w.andln(3) + E & 3;
        B === 3 && (B = -1), k === 3 && (k = -1);
        var C;
        B & 1 ? (A = h.andln(7) + S & 7, (A === 3 || A === 5) && k === 2 ? C = -B : C = B) : C = 0, M[0].push(C);
        var I;
        k & 1 ? (A = w.andln(7) + E & 7, (A === 3 || A === 5) && B === 2 ? I = -k : I = k) : I = 0, M[1].push(I), 2 * S === C + 1 && (S = 1 - S), 2 * E === I + 1 && (E = 1 - E), h.iushrn(1), w.iushrn(1);
      }
      return M;
    }
    e.getJSF = l;
    function d(h, w, M) {
      var S = "_" + w;
      h.prototype[w] = function() {
        return this[S] !== void 0 ? this[S] : this[S] = M.call(this);
      };
    }
    e.cachedProperty = d;
    function v(h) {
      return typeof h == "string" ? e.toArray(h, "hex") : h;
    }
    e.parseBytes = v;
    function m(h) {
      return new r(h, "hex", "le");
    }
    e.intFromLE = m;
  }(N0)), N0;
}
var U0 = {}, L0, q6;
function _c() {
  if (q6)
    return L0;
  q6 = 1;
  var t = Ti(), e = An(), r = e.getNAF, i = e.getJSF, f = e.assert;
  function a(d, v) {
    this.type = d, this.p = new t(v.p, 16), this.red = v.prime ? t.red(v.prime) : t.mont(this.p), this.zero = new t(0).toRed(this.red), this.one = new t(1).toRed(this.red), this.two = new t(2).toRed(this.red), this.n = v.n && new t(v.n, 16), this.g = v.g && this.pointFromJSON(v.g, v.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var m = this.n && this.p.div(this.n);
    !m || m.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  L0 = a, a.prototype.point = function() {
    throw new Error("Not implemented");
  }, a.prototype.validate = function() {
    throw new Error("Not implemented");
  }, a.prototype._fixedNafMul = function(v, m) {
    f(v.precomputed);
    var h = v._getDoubles(), w = r(m, 1, this._bitLength), M = (1 << h.step + 1) - (h.step % 2 === 0 ? 2 : 1);
    M /= 3;
    var S = [], E, A;
    for (E = 0; E < w.length; E += h.step) {
      A = 0;
      for (var B = E + h.step - 1; B >= E; B--)
        A = (A << 1) + w[B];
      S.push(A);
    }
    for (var k = this.jpoint(null, null, null), C = this.jpoint(null, null, null), I = M; I > 0; I--) {
      for (E = 0; E < S.length; E++)
        A = S[E], A === I ? C = C.mixedAdd(h.points[E]) : A === -I && (C = C.mixedAdd(h.points[E].neg()));
      k = k.add(C);
    }
    return k.toP();
  }, a.prototype._wnafMul = function(v, m) {
    var h = 4, w = v._getNAFPoints(h);
    h = w.wnd;
    for (var M = w.points, S = r(m, h, this._bitLength), E = this.jpoint(null, null, null), A = S.length - 1; A >= 0; A--) {
      for (var B = 0; A >= 0 && S[A] === 0; A--)
        B++;
      if (A >= 0 && B++, E = E.dblp(B), A < 0)
        break;
      var k = S[A];
      f(k !== 0), v.type === "affine" ? k > 0 ? E = E.mixedAdd(M[k - 1 >> 1]) : E = E.mixedAdd(M[-k - 1 >> 1].neg()) : k > 0 ? E = E.add(M[k - 1 >> 1]) : E = E.add(M[-k - 1 >> 1].neg());
    }
    return v.type === "affine" ? E.toP() : E;
  }, a.prototype._wnafMulAdd = function(v, m, h, w, M) {
    var S = this._wnafT1, E = this._wnafT2, A = this._wnafT3, B = 0, k, C, I;
    for (k = 0; k < w; k++) {
      I = m[k];
      var O = I._getNAFPoints(v);
      S[k] = O.wnd, E[k] = O.points;
    }
    for (k = w - 1; k >= 1; k -= 2) {
      var q = k - 1, $ = k;
      if (S[q] !== 1 || S[$] !== 1) {
        A[q] = r(h[q], S[q], this._bitLength), A[$] = r(h[$], S[$], this._bitLength), B = Math.max(A[q].length, B), B = Math.max(A[$].length, B);
        continue;
      }
      var ae = [
        m[q],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        m[$]
        /* 7 */
      ];
      m[q].y.cmp(m[$].y) === 0 ? (ae[1] = m[q].add(m[$]), ae[2] = m[q].toJ().mixedAdd(m[$].neg())) : m[q].y.cmp(m[$].y.redNeg()) === 0 ? (ae[1] = m[q].toJ().mixedAdd(m[$]), ae[2] = m[q].add(m[$].neg())) : (ae[1] = m[q].toJ().mixedAdd(m[$]), ae[2] = m[q].toJ().mixedAdd(m[$].neg()));
      var he = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], te = i(h[q], h[$]);
      for (B = Math.max(te[0].length, B), A[q] = new Array(B), A[$] = new Array(B), C = 0; C < B; C++) {
        var Ee = te[0][C] | 0, x = te[1][C] | 0;
        A[q][C] = he[(Ee + 1) * 3 + (x + 1)], A[$][C] = 0, E[q] = ae;
      }
    }
    var n = this.jpoint(null, null, null), o = this._wnafT4;
    for (k = B; k >= 0; k--) {
      for (var u = 0; k >= 0; ) {
        var c = !0;
        for (C = 0; C < w; C++)
          o[C] = A[C][k] | 0, o[C] !== 0 && (c = !1);
        if (!c)
          break;
        u++, k--;
      }
      if (k >= 0 && u++, n = n.dblp(u), k < 0)
        break;
      for (C = 0; C < w; C++) {
        var g = o[C];
        g !== 0 && (g > 0 ? I = E[C][g - 1 >> 1] : g < 0 && (I = E[C][-g - 1 >> 1].neg()), I.type === "affine" ? n = n.mixedAdd(I) : n = n.add(I));
      }
    }
    for (k = 0; k < w; k++)
      E[k] = null;
    return M ? n : n.toP();
  };
  function l(d, v) {
    this.curve = d, this.type = v, this.precomputed = null;
  }
  return a.BasePoint = l, l.prototype.eq = function() {
    throw new Error("Not implemented");
  }, l.prototype.validate = function() {
    return this.curve.validate(this);
  }, a.prototype.decodePoint = function(v, m) {
    v = e.toArray(v, m);
    var h = this.p.byteLength();
    if ((v[0] === 4 || v[0] === 6 || v[0] === 7) && v.length - 1 === 2 * h) {
      v[0] === 6 ? f(v[v.length - 1] % 2 === 0) : v[0] === 7 && f(v[v.length - 1] % 2 === 1);
      var w = this.point(
        v.slice(1, 1 + h),
        v.slice(1 + h, 1 + 2 * h)
      );
      return w;
    } else if ((v[0] === 2 || v[0] === 3) && v.length - 1 === h)
      return this.pointFromX(v.slice(1, 1 + h), v[0] === 3);
    throw new Error("Unknown point format");
  }, l.prototype.encodeCompressed = function(v) {
    return this.encode(v, !0);
  }, l.prototype._encode = function(v) {
    var m = this.curve.p.byteLength(), h = this.getX().toArray("be", m);
    return v ? [this.getY().isEven() ? 2 : 3].concat(h) : [4].concat(h, this.getY().toArray("be", m));
  }, l.prototype.encode = function(v, m) {
    return e.encode(this._encode(m), v);
  }, l.prototype.precompute = function(v) {
    if (this.precomputed)
      return this;
    var m = {
      doubles: null,
      naf: null,
      beta: null
    };
    return m.naf = this._getNAFPoints(8), m.doubles = this._getDoubles(4, v), m.beta = this._getBeta(), this.precomputed = m, this;
  }, l.prototype._hasDoubles = function(v) {
    if (!this.precomputed)
      return !1;
    var m = this.precomputed.doubles;
    return m ? m.points.length >= Math.ceil((v.bitLength() + 1) / m.step) : !1;
  }, l.prototype._getDoubles = function(v, m) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var h = [this], w = this, M = 0; M < m; M += v) {
      for (var S = 0; S < v; S++)
        w = w.dbl();
      h.push(w);
    }
    return {
      step: v,
      points: h
    };
  }, l.prototype._getNAFPoints = function(v) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var m = [this], h = (1 << v) - 1, w = h === 1 ? null : this.dbl(), M = 1; M < h; M++)
      m[M] = m[M - 1].add(w);
    return {
      wnd: v,
      points: m
    };
  }, l.prototype._getBeta = function() {
    return null;
  }, l.prototype.dblp = function(v) {
    for (var m = this, h = 0; h < v; h++)
      m = m.dbl();
    return m;
  }, L0;
}
var F0, z6;
function FI() {
  if (z6)
    return F0;
  z6 = 1;
  var t = An(), e = Ti(), r = Lt(), i = _c(), f = t.assert;
  function a(v) {
    i.call(this, "short", v), this.a = new e(v.a, 16).toRed(this.red), this.b = new e(v.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(v), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  r(a, i), F0 = a, a.prototype._getEndomorphism = function(m) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var h, w;
      if (m.beta)
        h = new e(m.beta, 16).toRed(this.red);
      else {
        var M = this._getEndoRoots(this.p);
        h = M[0].cmp(M[1]) < 0 ? M[0] : M[1], h = h.toRed(this.red);
      }
      if (m.lambda)
        w = new e(m.lambda, 16);
      else {
        var S = this._getEndoRoots(this.n);
        this.g.mul(S[0]).x.cmp(this.g.x.redMul(h)) === 0 ? w = S[0] : (w = S[1], f(this.g.mul(w).x.cmp(this.g.x.redMul(h)) === 0));
      }
      var E;
      return m.basis ? E = m.basis.map(function(A) {
        return {
          a: new e(A.a, 16),
          b: new e(A.b, 16)
        };
      }) : E = this._getEndoBasis(w), {
        beta: h,
        lambda: w,
        basis: E
      };
    }
  }, a.prototype._getEndoRoots = function(m) {
    var h = m === this.p ? this.red : e.mont(m), w = new e(2).toRed(h).redInvm(), M = w.redNeg(), S = new e(3).toRed(h).redNeg().redSqrt().redMul(w), E = M.redAdd(S).fromRed(), A = M.redSub(S).fromRed();
    return [E, A];
  }, a.prototype._getEndoBasis = function(m) {
    for (var h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), w = m, M = this.n.clone(), S = new e(1), E = new e(0), A = new e(0), B = new e(1), k, C, I, O, q, $, ae, he = 0, te, Ee; w.cmpn(0) !== 0; ) {
      var x = M.div(w);
      te = M.sub(x.mul(w)), Ee = A.sub(x.mul(S));
      var n = B.sub(x.mul(E));
      if (!I && te.cmp(h) < 0)
        k = ae.neg(), C = S, I = te.neg(), O = Ee;
      else if (I && ++he === 2)
        break;
      ae = te, M = w, w = te, A = S, S = Ee, B = E, E = n;
    }
    q = te.neg(), $ = Ee;
    var o = I.sqr().add(O.sqr()), u = q.sqr().add($.sqr());
    return u.cmp(o) >= 0 && (q = k, $ = C), I.negative && (I = I.neg(), O = O.neg()), q.negative && (q = q.neg(), $ = $.neg()), [
      { a: I, b: O },
      { a: q, b: $ }
    ];
  }, a.prototype._endoSplit = function(m) {
    var h = this.endo.basis, w = h[0], M = h[1], S = M.b.mul(m).divRound(this.n), E = w.b.neg().mul(m).divRound(this.n), A = S.mul(w.a), B = E.mul(M.a), k = S.mul(w.b), C = E.mul(M.b), I = m.sub(A).sub(B), O = k.add(C).neg();
    return { k1: I, k2: O };
  }, a.prototype.pointFromX = function(m, h) {
    m = new e(m, 16), m.red || (m = m.toRed(this.red));
    var w = m.redSqr().redMul(m).redIAdd(m.redMul(this.a)).redIAdd(this.b), M = w.redSqrt();
    if (M.redSqr().redSub(w).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var S = M.fromRed().isOdd();
    return (h && !S || !h && S) && (M = M.redNeg()), this.point(m, M);
  }, a.prototype.validate = function(m) {
    if (m.inf)
      return !0;
    var h = m.x, w = m.y, M = this.a.redMul(h), S = h.redSqr().redMul(h).redIAdd(M).redIAdd(this.b);
    return w.redSqr().redISub(S).cmpn(0) === 0;
  }, a.prototype._endoWnafMulAdd = function(m, h, w) {
    for (var M = this._endoWnafT1, S = this._endoWnafT2, E = 0; E < m.length; E++) {
      var A = this._endoSplit(h[E]), B = m[E], k = B._getBeta();
      A.k1.negative && (A.k1.ineg(), B = B.neg(!0)), A.k2.negative && (A.k2.ineg(), k = k.neg(!0)), M[E * 2] = B, M[E * 2 + 1] = k, S[E * 2] = A.k1, S[E * 2 + 1] = A.k2;
    }
    for (var C = this._wnafMulAdd(1, M, S, E * 2, w), I = 0; I < E * 2; I++)
      M[I] = null, S[I] = null;
    return C;
  };
  function l(v, m, h, w) {
    i.BasePoint.call(this, v, "affine"), m === null && h === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(m, 16), this.y = new e(h, 16), w && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  r(l, i.BasePoint), a.prototype.point = function(m, h, w) {
    return new l(this, m, h, w);
  }, a.prototype.pointFromJSON = function(m, h) {
    return l.fromJSON(this, m, h);
  }, l.prototype._getBeta = function() {
    if (this.curve.endo) {
      var m = this.precomputed;
      if (m && m.beta)
        return m.beta;
      var h = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (m) {
        var w = this.curve, M = function(S) {
          return w.point(S.x.redMul(w.endo.beta), S.y);
        };
        m.beta = h, h.precomputed = {
          beta: null,
          naf: m.naf && {
            wnd: m.naf.wnd,
            points: m.naf.points.map(M)
          },
          doubles: m.doubles && {
            step: m.doubles.step,
            points: m.doubles.points.map(M)
          }
        };
      }
      return h;
    }
  }, l.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, l.fromJSON = function(m, h, w) {
    typeof h == "string" && (h = JSON.parse(h));
    var M = m.point(h[0], h[1], w);
    if (!h[2])
      return M;
    function S(A) {
      return m.point(A[0], A[1], w);
    }
    var E = h[2];
    return M.precomputed = {
      beta: null,
      doubles: E.doubles && {
        step: E.doubles.step,
        points: [M].concat(E.doubles.points.map(S))
      },
      naf: E.naf && {
        wnd: E.naf.wnd,
        points: [M].concat(E.naf.points.map(S))
      }
    }, M;
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.inf;
  }, l.prototype.add = function(m) {
    if (this.inf)
      return m;
    if (m.inf)
      return this;
    if (this.eq(m))
      return this.dbl();
    if (this.neg().eq(m))
      return this.curve.point(null, null);
    if (this.x.cmp(m.x) === 0)
      return this.curve.point(null, null);
    var h = this.y.redSub(m.y);
    h.cmpn(0) !== 0 && (h = h.redMul(this.x.redSub(m.x).redInvm()));
    var w = h.redSqr().redISub(this.x).redISub(m.x), M = h.redMul(this.x.redSub(w)).redISub(this.y);
    return this.curve.point(w, M);
  }, l.prototype.dbl = function() {
    if (this.inf)
      return this;
    var m = this.y.redAdd(this.y);
    if (m.cmpn(0) === 0)
      return this.curve.point(null, null);
    var h = this.curve.a, w = this.x.redSqr(), M = m.redInvm(), S = w.redAdd(w).redIAdd(w).redIAdd(h).redMul(M), E = S.redSqr().redISub(this.x.redAdd(this.x)), A = S.redMul(this.x.redSub(E)).redISub(this.y);
    return this.curve.point(E, A);
  }, l.prototype.getX = function() {
    return this.x.fromRed();
  }, l.prototype.getY = function() {
    return this.y.fromRed();
  }, l.prototype.mul = function(m) {
    return m = new e(m, 16), this.isInfinity() ? this : this._hasDoubles(m) ? this.curve._fixedNafMul(this, m) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [m]) : this.curve._wnafMul(this, m);
  }, l.prototype.mulAdd = function(m, h, w) {
    var M = [this, h], S = [m, w];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, S) : this.curve._wnafMulAdd(1, M, S, 2);
  }, l.prototype.jmulAdd = function(m, h, w) {
    var M = [this, h], S = [m, w];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, S, !0) : this.curve._wnafMulAdd(1, M, S, 2, !0);
  }, l.prototype.eq = function(m) {
    return this === m || this.inf === m.inf && (this.inf || this.x.cmp(m.x) === 0 && this.y.cmp(m.y) === 0);
  }, l.prototype.neg = function(m) {
    if (this.inf)
      return this;
    var h = this.curve.point(this.x, this.y.redNeg());
    if (m && this.precomputed) {
      var w = this.precomputed, M = function(S) {
        return S.neg();
      };
      h.precomputed = {
        naf: w.naf && {
          wnd: w.naf.wnd,
          points: w.naf.points.map(M)
        },
        doubles: w.doubles && {
          step: w.doubles.step,
          points: w.doubles.points.map(M)
        }
      };
    }
    return h;
  }, l.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var m = this.curve.jpoint(this.x, this.y, this.curve.one);
    return m;
  };
  function d(v, m, h, w) {
    i.BasePoint.call(this, v, "jacobian"), m === null && h === null && w === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(m, 16), this.y = new e(h, 16), this.z = new e(w, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return r(d, i.BasePoint), a.prototype.jpoint = function(m, h, w) {
    return new d(this, m, h, w);
  }, d.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var m = this.z.redInvm(), h = m.redSqr(), w = this.x.redMul(h), M = this.y.redMul(h).redMul(m);
    return this.curve.point(w, M);
  }, d.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, d.prototype.add = function(m) {
    if (this.isInfinity())
      return m;
    if (m.isInfinity())
      return this;
    var h = m.z.redSqr(), w = this.z.redSqr(), M = this.x.redMul(h), S = m.x.redMul(w), E = this.y.redMul(h.redMul(m.z)), A = m.y.redMul(w.redMul(this.z)), B = M.redSub(S), k = E.redSub(A);
    if (B.cmpn(0) === 0)
      return k.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var C = B.redSqr(), I = C.redMul(B), O = M.redMul(C), q = k.redSqr().redIAdd(I).redISub(O).redISub(O), $ = k.redMul(O.redISub(q)).redISub(E.redMul(I)), ae = this.z.redMul(m.z).redMul(B);
    return this.curve.jpoint(q, $, ae);
  }, d.prototype.mixedAdd = function(m) {
    if (this.isInfinity())
      return m.toJ();
    if (m.isInfinity())
      return this;
    var h = this.z.redSqr(), w = this.x, M = m.x.redMul(h), S = this.y, E = m.y.redMul(h).redMul(this.z), A = w.redSub(M), B = S.redSub(E);
    if (A.cmpn(0) === 0)
      return B.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var k = A.redSqr(), C = k.redMul(A), I = w.redMul(k), O = B.redSqr().redIAdd(C).redISub(I).redISub(I), q = B.redMul(I.redISub(O)).redISub(S.redMul(C)), $ = this.z.redMul(A);
    return this.curve.jpoint(O, q, $);
  }, d.prototype.dblp = function(m) {
    if (m === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!m)
      return this.dbl();
    var h;
    if (this.curve.zeroA || this.curve.threeA) {
      var w = this;
      for (h = 0; h < m; h++)
        w = w.dbl();
      return w;
    }
    var M = this.curve.a, S = this.curve.tinv, E = this.x, A = this.y, B = this.z, k = B.redSqr().redSqr(), C = A.redAdd(A);
    for (h = 0; h < m; h++) {
      var I = E.redSqr(), O = C.redSqr(), q = O.redSqr(), $ = I.redAdd(I).redIAdd(I).redIAdd(M.redMul(k)), ae = E.redMul(O), he = $.redSqr().redISub(ae.redAdd(ae)), te = ae.redISub(he), Ee = $.redMul(te);
      Ee = Ee.redIAdd(Ee).redISub(q);
      var x = C.redMul(B);
      h + 1 < m && (k = k.redMul(q)), E = he, B = x, C = Ee;
    }
    return this.curve.jpoint(E, C.redMul(S), B);
  }, d.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, d.prototype._zeroDbl = function() {
    var m, h, w;
    if (this.zOne) {
      var M = this.x.redSqr(), S = this.y.redSqr(), E = S.redSqr(), A = this.x.redAdd(S).redSqr().redISub(M).redISub(E);
      A = A.redIAdd(A);
      var B = M.redAdd(M).redIAdd(M), k = B.redSqr().redISub(A).redISub(A), C = E.redIAdd(E);
      C = C.redIAdd(C), C = C.redIAdd(C), m = k, h = B.redMul(A.redISub(k)).redISub(C), w = this.y.redAdd(this.y);
    } else {
      var I = this.x.redSqr(), O = this.y.redSqr(), q = O.redSqr(), $ = this.x.redAdd(O).redSqr().redISub(I).redISub(q);
      $ = $.redIAdd($);
      var ae = I.redAdd(I).redIAdd(I), he = ae.redSqr(), te = q.redIAdd(q);
      te = te.redIAdd(te), te = te.redIAdd(te), m = he.redISub($).redISub($), h = ae.redMul($.redISub(m)).redISub(te), w = this.y.redMul(this.z), w = w.redIAdd(w);
    }
    return this.curve.jpoint(m, h, w);
  }, d.prototype._threeDbl = function() {
    var m, h, w;
    if (this.zOne) {
      var M = this.x.redSqr(), S = this.y.redSqr(), E = S.redSqr(), A = this.x.redAdd(S).redSqr().redISub(M).redISub(E);
      A = A.redIAdd(A);
      var B = M.redAdd(M).redIAdd(M).redIAdd(this.curve.a), k = B.redSqr().redISub(A).redISub(A);
      m = k;
      var C = E.redIAdd(E);
      C = C.redIAdd(C), C = C.redIAdd(C), h = B.redMul(A.redISub(k)).redISub(C), w = this.y.redAdd(this.y);
    } else {
      var I = this.z.redSqr(), O = this.y.redSqr(), q = this.x.redMul(O), $ = this.x.redSub(I).redMul(this.x.redAdd(I));
      $ = $.redAdd($).redIAdd($);
      var ae = q.redIAdd(q);
      ae = ae.redIAdd(ae);
      var he = ae.redAdd(ae);
      m = $.redSqr().redISub(he), w = this.y.redAdd(this.z).redSqr().redISub(O).redISub(I);
      var te = O.redSqr();
      te = te.redIAdd(te), te = te.redIAdd(te), te = te.redIAdd(te), h = $.redMul(ae.redISub(m)).redISub(te);
    }
    return this.curve.jpoint(m, h, w);
  }, d.prototype._dbl = function() {
    var m = this.curve.a, h = this.x, w = this.y, M = this.z, S = M.redSqr().redSqr(), E = h.redSqr(), A = w.redSqr(), B = E.redAdd(E).redIAdd(E).redIAdd(m.redMul(S)), k = h.redAdd(h);
    k = k.redIAdd(k);
    var C = k.redMul(A), I = B.redSqr().redISub(C.redAdd(C)), O = C.redISub(I), q = A.redSqr();
    q = q.redIAdd(q), q = q.redIAdd(q), q = q.redIAdd(q);
    var $ = B.redMul(O).redISub(q), ae = w.redAdd(w).redMul(M);
    return this.curve.jpoint(I, $, ae);
  }, d.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var m = this.x.redSqr(), h = this.y.redSqr(), w = this.z.redSqr(), M = h.redSqr(), S = m.redAdd(m).redIAdd(m), E = S.redSqr(), A = this.x.redAdd(h).redSqr().redISub(m).redISub(M);
    A = A.redIAdd(A), A = A.redAdd(A).redIAdd(A), A = A.redISub(E);
    var B = A.redSqr(), k = M.redIAdd(M);
    k = k.redIAdd(k), k = k.redIAdd(k), k = k.redIAdd(k);
    var C = S.redIAdd(A).redSqr().redISub(E).redISub(B).redISub(k), I = h.redMul(C);
    I = I.redIAdd(I), I = I.redIAdd(I);
    var O = this.x.redMul(B).redISub(I);
    O = O.redIAdd(O), O = O.redIAdd(O);
    var q = this.y.redMul(C.redMul(k.redISub(C)).redISub(A.redMul(B)));
    q = q.redIAdd(q), q = q.redIAdd(q), q = q.redIAdd(q);
    var $ = this.z.redAdd(A).redSqr().redISub(w).redISub(B);
    return this.curve.jpoint(O, q, $);
  }, d.prototype.mul = function(m, h) {
    return m = new e(m, h), this.curve._wnafMul(this, m);
  }, d.prototype.eq = function(m) {
    if (m.type === "affine")
      return this.eq(m.toJ());
    if (this === m)
      return !0;
    var h = this.z.redSqr(), w = m.z.redSqr();
    if (this.x.redMul(w).redISub(m.x.redMul(h)).cmpn(0) !== 0)
      return !1;
    var M = h.redMul(this.z), S = w.redMul(m.z);
    return this.y.redMul(S).redISub(m.y.redMul(M)).cmpn(0) === 0;
  }, d.prototype.eqXToP = function(m) {
    var h = this.z.redSqr(), w = m.toRed(this.curve.red).redMul(h);
    if (this.x.cmp(w) === 0)
      return !0;
    for (var M = m.clone(), S = this.curve.redN.redMul(h); ; ) {
      if (M.iadd(this.curve.n), M.cmp(this.curve.p) >= 0)
        return !1;
      if (w.redIAdd(S), this.x.cmp(w) === 0)
        return !0;
    }
  }, d.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, d.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, F0;
}
var q0, j6;
function qI() {
  if (j6)
    return q0;
  j6 = 1;
  var t = Ti(), e = Lt(), r = _c(), i = An();
  function f(l) {
    r.call(this, "mont", l), this.a = new t(l.a, 16).toRed(this.red), this.b = new t(l.b, 16).toRed(this.red), this.i4 = new t(4).toRed(this.red).redInvm(), this.two = new t(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(f, r), q0 = f, f.prototype.validate = function(d) {
    var v = d.normalize().x, m = v.redSqr(), h = m.redMul(v).redAdd(m.redMul(this.a)).redAdd(v), w = h.redSqrt();
    return w.redSqr().cmp(h) === 0;
  };
  function a(l, d, v) {
    r.BasePoint.call(this, l, "projective"), d === null && v === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new t(d, 16), this.z = new t(v, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(a, r.BasePoint), f.prototype.decodePoint = function(d, v) {
    return this.point(i.toArray(d, v), 1);
  }, f.prototype.point = function(d, v) {
    return new a(this, d, v);
  }, f.prototype.pointFromJSON = function(d) {
    return a.fromJSON(this, d);
  }, a.prototype.precompute = function() {
  }, a.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, a.fromJSON = function(d, v) {
    return new a(d, v[0], v[1] || d.one);
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, a.prototype.dbl = function() {
    var d = this.x.redAdd(this.z), v = d.redSqr(), m = this.x.redSub(this.z), h = m.redSqr(), w = v.redSub(h), M = v.redMul(h), S = w.redMul(h.redAdd(this.curve.a24.redMul(w)));
    return this.curve.point(M, S);
  }, a.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.diffAdd = function(d, v) {
    var m = this.x.redAdd(this.z), h = this.x.redSub(this.z), w = d.x.redAdd(d.z), M = d.x.redSub(d.z), S = M.redMul(m), E = w.redMul(h), A = v.z.redMul(S.redAdd(E).redSqr()), B = v.x.redMul(S.redISub(E).redSqr());
    return this.curve.point(A, B);
  }, a.prototype.mul = function(d) {
    for (var v = d.clone(), m = this, h = this.curve.point(null, null), w = this, M = []; v.cmpn(0) !== 0; v.iushrn(1))
      M.push(v.andln(1));
    for (var S = M.length - 1; S >= 0; S--)
      M[S] === 0 ? (m = m.diffAdd(h, w), h = h.dbl()) : (h = m.diffAdd(h, w), m = m.dbl());
    return h;
  }, a.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.eq = function(d) {
    return this.getX().cmp(d.getX()) === 0;
  }, a.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, a.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, q0;
}
var z0, $6;
function zI() {
  if ($6)
    return z0;
  $6 = 1;
  var t = An(), e = Ti(), r = Lt(), i = _c(), f = t.assert;
  function a(d) {
    this.twisted = (d.a | 0) !== 1, this.mOneA = this.twisted && (d.a | 0) === -1, this.extended = this.mOneA, i.call(this, "edwards", d), this.a = new e(d.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(d.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(d.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), f(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (d.c | 0) === 1;
  }
  r(a, i), z0 = a, a.prototype._mulA = function(v) {
    return this.mOneA ? v.redNeg() : this.a.redMul(v);
  }, a.prototype._mulC = function(v) {
    return this.oneC ? v : this.c.redMul(v);
  }, a.prototype.jpoint = function(v, m, h, w) {
    return this.point(v, m, h, w);
  }, a.prototype.pointFromX = function(v, m) {
    v = new e(v, 16), v.red || (v = v.toRed(this.red));
    var h = v.redSqr(), w = this.c2.redSub(this.a.redMul(h)), M = this.one.redSub(this.c2.redMul(this.d).redMul(h)), S = w.redMul(M.redInvm()), E = S.redSqrt();
    if (E.redSqr().redSub(S).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var A = E.fromRed().isOdd();
    return (m && !A || !m && A) && (E = E.redNeg()), this.point(v, E);
  }, a.prototype.pointFromY = function(v, m) {
    v = new e(v, 16), v.red || (v = v.toRed(this.red));
    var h = v.redSqr(), w = h.redSub(this.c2), M = h.redMul(this.d).redMul(this.c2).redSub(this.a), S = w.redMul(M.redInvm());
    if (S.cmp(this.zero) === 0) {
      if (m)
        throw new Error("invalid point");
      return this.point(this.zero, v);
    }
    var E = S.redSqrt();
    if (E.redSqr().redSub(S).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return E.fromRed().isOdd() !== m && (E = E.redNeg()), this.point(E, v);
  }, a.prototype.validate = function(v) {
    if (v.isInfinity())
      return !0;
    v.normalize();
    var m = v.x.redSqr(), h = v.y.redSqr(), w = m.redMul(this.a).redAdd(h), M = this.c2.redMul(this.one.redAdd(this.d.redMul(m).redMul(h)));
    return w.cmp(M) === 0;
  };
  function l(d, v, m, h, w) {
    i.BasePoint.call(this, d, "projective"), v === null && m === null && h === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(v, 16), this.y = new e(m, 16), this.z = h ? new e(h, 16) : this.curve.one, this.t = w && new e(w, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return r(l, i.BasePoint), a.prototype.pointFromJSON = function(v) {
    return l.fromJSON(this, v);
  }, a.prototype.point = function(v, m, h, w) {
    return new l(this, v, m, h, w);
  }, l.fromJSON = function(v, m) {
    return new l(v, m[0], m[1], m[2]);
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, l.prototype._extDbl = function() {
    var v = this.x.redSqr(), m = this.y.redSqr(), h = this.z.redSqr();
    h = h.redIAdd(h);
    var w = this.curve._mulA(v), M = this.x.redAdd(this.y).redSqr().redISub(v).redISub(m), S = w.redAdd(m), E = S.redSub(h), A = w.redSub(m), B = M.redMul(E), k = S.redMul(A), C = M.redMul(A), I = E.redMul(S);
    return this.curve.point(B, k, I, C);
  }, l.prototype._projDbl = function() {
    var v = this.x.redAdd(this.y).redSqr(), m = this.x.redSqr(), h = this.y.redSqr(), w, M, S, E, A, B;
    if (this.curve.twisted) {
      E = this.curve._mulA(m);
      var k = E.redAdd(h);
      this.zOne ? (w = v.redSub(m).redSub(h).redMul(k.redSub(this.curve.two)), M = k.redMul(E.redSub(h)), S = k.redSqr().redSub(k).redSub(k)) : (A = this.z.redSqr(), B = k.redSub(A).redISub(A), w = v.redSub(m).redISub(h).redMul(B), M = k.redMul(E.redSub(h)), S = k.redMul(B));
    } else
      E = m.redAdd(h), A = this.curve._mulC(this.z).redSqr(), B = E.redSub(A).redSub(A), w = this.curve._mulC(v.redISub(E)).redMul(B), M = this.curve._mulC(E).redMul(m.redISub(h)), S = E.redMul(B);
    return this.curve.point(w, M, S);
  }, l.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, l.prototype._extAdd = function(v) {
    var m = this.y.redSub(this.x).redMul(v.y.redSub(v.x)), h = this.y.redAdd(this.x).redMul(v.y.redAdd(v.x)), w = this.t.redMul(this.curve.dd).redMul(v.t), M = this.z.redMul(v.z.redAdd(v.z)), S = h.redSub(m), E = M.redSub(w), A = M.redAdd(w), B = h.redAdd(m), k = S.redMul(E), C = A.redMul(B), I = S.redMul(B), O = E.redMul(A);
    return this.curve.point(k, C, O, I);
  }, l.prototype._projAdd = function(v) {
    var m = this.z.redMul(v.z), h = m.redSqr(), w = this.x.redMul(v.x), M = this.y.redMul(v.y), S = this.curve.d.redMul(w).redMul(M), E = h.redSub(S), A = h.redAdd(S), B = this.x.redAdd(this.y).redMul(v.x.redAdd(v.y)).redISub(w).redISub(M), k = m.redMul(E).redMul(B), C, I;
    return this.curve.twisted ? (C = m.redMul(A).redMul(M.redSub(this.curve._mulA(w))), I = E.redMul(A)) : (C = m.redMul(A).redMul(M.redSub(w)), I = this.curve._mulC(E).redMul(A)), this.curve.point(k, C, I);
  }, l.prototype.add = function(v) {
    return this.isInfinity() ? v : v.isInfinity() ? this : this.curve.extended ? this._extAdd(v) : this._projAdd(v);
  }, l.prototype.mul = function(v) {
    return this._hasDoubles(v) ? this.curve._fixedNafMul(this, v) : this.curve._wnafMul(this, v);
  }, l.prototype.mulAdd = function(v, m, h) {
    return this.curve._wnafMulAdd(1, [this, m], [v, h], 2, !1);
  }, l.prototype.jmulAdd = function(v, m, h) {
    return this.curve._wnafMulAdd(1, [this, m], [v, h], 2, !0);
  }, l.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var v = this.z.redInvm();
    return this.x = this.x.redMul(v), this.y = this.y.redMul(v), this.t && (this.t = this.t.redMul(v)), this.z = this.curve.one, this.zOne = !0, this;
  }, l.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, l.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, l.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, l.prototype.eq = function(v) {
    return this === v || this.getX().cmp(v.getX()) === 0 && this.getY().cmp(v.getY()) === 0;
  }, l.prototype.eqXToP = function(v) {
    var m = v.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(m) === 0)
      return !0;
    for (var h = v.clone(), w = this.curve.redN.redMul(this.z); ; ) {
      if (h.iadd(this.curve.n), h.cmp(this.curve.p) >= 0)
        return !1;
      if (m.redIAdd(w), this.x.cmp(m) === 0)
        return !0;
    }
  }, l.prototype.toP = l.prototype.normalize, l.prototype.mixedAdd = l.prototype.add, z0;
}
var V6;
function a_() {
  return V6 || (V6 = 1, function(t) {
    var e = t;
    e.base = _c(), e.short = FI(), e.mont = qI(), e.edwards = zI();
  }(U0)), U0;
}
var j0 = {}, $0 = {}, ir = {}, H6;
function ui() {
  if (H6)
    return ir;
  H6 = 1;
  var t = mn(), e = Lt();
  ir.inherits = e;
  function r(n, o) {
    return (n.charCodeAt(o) & 64512) !== 55296 || o < 0 || o + 1 >= n.length ? !1 : (n.charCodeAt(o + 1) & 64512) === 56320;
  }
  function i(n, o) {
    if (Array.isArray(n))
      return n.slice();
    if (!n)
      return [];
    var u = [];
    if (typeof n == "string")
      if (o) {
        if (o === "hex")
          for (n = n.replace(/[^a-z0-9]+/ig, ""), n.length % 2 !== 0 && (n = "0" + n), g = 0; g < n.length; g += 2)
            u.push(parseInt(n[g] + n[g + 1], 16));
      } else
        for (var c = 0, g = 0; g < n.length; g++) {
          var b = n.charCodeAt(g);
          b < 128 ? u[c++] = b : b < 2048 ? (u[c++] = b >> 6 | 192, u[c++] = b & 63 | 128) : r(n, g) ? (b = 65536 + ((b & 1023) << 10) + (n.charCodeAt(++g) & 1023), u[c++] = b >> 18 | 240, u[c++] = b >> 12 & 63 | 128, u[c++] = b >> 6 & 63 | 128, u[c++] = b & 63 | 128) : (u[c++] = b >> 12 | 224, u[c++] = b >> 6 & 63 | 128, u[c++] = b & 63 | 128);
        }
    else
      for (g = 0; g < n.length; g++)
        u[g] = n[g] | 0;
    return u;
  }
  ir.toArray = i;
  function f(n) {
    for (var o = "", u = 0; u < n.length; u++)
      o += d(n[u].toString(16));
    return o;
  }
  ir.toHex = f;
  function a(n) {
    var o = n >>> 24 | n >>> 8 & 65280 | n << 8 & 16711680 | (n & 255) << 24;
    return o >>> 0;
  }
  ir.htonl = a;
  function l(n, o) {
    for (var u = "", c = 0; c < n.length; c++) {
      var g = n[c];
      o === "little" && (g = a(g)), u += v(g.toString(16));
    }
    return u;
  }
  ir.toHex32 = l;
  function d(n) {
    return n.length === 1 ? "0" + n : n;
  }
  ir.zero2 = d;
  function v(n) {
    return n.length === 7 ? "0" + n : n.length === 6 ? "00" + n : n.length === 5 ? "000" + n : n.length === 4 ? "0000" + n : n.length === 3 ? "00000" + n : n.length === 2 ? "000000" + n : n.length === 1 ? "0000000" + n : n;
  }
  ir.zero8 = v;
  function m(n, o, u, c) {
    var g = u - o;
    t(g % 4 === 0);
    for (var b = new Array(g / 4), _ = 0, p = o; _ < b.length; _++, p += 4) {
      var s;
      c === "big" ? s = n[p] << 24 | n[p + 1] << 16 | n[p + 2] << 8 | n[p + 3] : s = n[p + 3] << 24 | n[p + 2] << 16 | n[p + 1] << 8 | n[p], b[_] = s >>> 0;
    }
    return b;
  }
  ir.join32 = m;
  function h(n, o) {
    for (var u = new Array(n.length * 4), c = 0, g = 0; c < n.length; c++, g += 4) {
      var b = n[c];
      o === "big" ? (u[g] = b >>> 24, u[g + 1] = b >>> 16 & 255, u[g + 2] = b >>> 8 & 255, u[g + 3] = b & 255) : (u[g + 3] = b >>> 24, u[g + 2] = b >>> 16 & 255, u[g + 1] = b >>> 8 & 255, u[g] = b & 255);
    }
    return u;
  }
  ir.split32 = h;
  function w(n, o) {
    return n >>> o | n << 32 - o;
  }
  ir.rotr32 = w;
  function M(n, o) {
    return n << o | n >>> 32 - o;
  }
  ir.rotl32 = M;
  function S(n, o) {
    return n + o >>> 0;
  }
  ir.sum32 = S;
  function E(n, o, u) {
    return n + o + u >>> 0;
  }
  ir.sum32_3 = E;
  function A(n, o, u, c) {
    return n + o + u + c >>> 0;
  }
  ir.sum32_4 = A;
  function B(n, o, u, c, g) {
    return n + o + u + c + g >>> 0;
  }
  ir.sum32_5 = B;
  function k(n, o, u, c) {
    var g = n[o], b = n[o + 1], _ = c + b >>> 0, p = (_ < c ? 1 : 0) + u + g;
    n[o] = p >>> 0, n[o + 1] = _;
  }
  ir.sum64 = k;
  function C(n, o, u, c) {
    var g = o + c >>> 0, b = (g < o ? 1 : 0) + n + u;
    return b >>> 0;
  }
  ir.sum64_hi = C;
  function I(n, o, u, c) {
    var g = o + c;
    return g >>> 0;
  }
  ir.sum64_lo = I;
  function O(n, o, u, c, g, b, _, p) {
    var s = 0, y = o;
    y = y + c >>> 0, s += y < o ? 1 : 0, y = y + b >>> 0, s += y < b ? 1 : 0, y = y + p >>> 0, s += y < p ? 1 : 0;
    var T = n + u + g + _ + s;
    return T >>> 0;
  }
  ir.sum64_4_hi = O;
  function q(n, o, u, c, g, b, _, p) {
    var s = o + c + b + p;
    return s >>> 0;
  }
  ir.sum64_4_lo = q;
  function $(n, o, u, c, g, b, _, p, s, y) {
    var T = 0, P = o;
    P = P + c >>> 0, T += P < o ? 1 : 0, P = P + b >>> 0, T += P < b ? 1 : 0, P = P + p >>> 0, T += P < p ? 1 : 0, P = P + y >>> 0, T += P < y ? 1 : 0;
    var z = n + u + g + _ + s + T;
    return z >>> 0;
  }
  ir.sum64_5_hi = $;
  function ae(n, o, u, c, g, b, _, p, s, y) {
    var T = o + c + b + p + y;
    return T >>> 0;
  }
  ir.sum64_5_lo = ae;
  function he(n, o, u) {
    var c = o << 32 - u | n >>> u;
    return c >>> 0;
  }
  ir.rotr64_hi = he;
  function te(n, o, u) {
    var c = n << 32 - u | o >>> u;
    return c >>> 0;
  }
  ir.rotr64_lo = te;
  function Ee(n, o, u) {
    return n >>> u;
  }
  ir.shr64_hi = Ee;
  function x(n, o, u) {
    var c = n << 32 - u | o >>> u;
    return c >>> 0;
  }
  return ir.shr64_lo = x, ir;
}
var V0 = {}, W6;
function Gf() {
  if (W6)
    return V0;
  W6 = 1;
  var t = ui(), e = mn();
  function r() {
    this.pending = null, this.pendingTotal = 0, this.blockSize = this.constructor.blockSize, this.outSize = this.constructor.outSize, this.hmacStrength = this.constructor.hmacStrength, this.padLength = this.constructor.padLength / 8, this.endian = "big", this._delta8 = this.blockSize / 8, this._delta32 = this.blockSize / 32;
  }
  return V0.BlockHash = r, r.prototype.update = function(f, a) {
    if (f = t.toArray(f, a), this.pending ? this.pending = this.pending.concat(f) : this.pending = f, this.pendingTotal += f.length, this.pending.length >= this._delta8) {
      f = this.pending;
      var l = f.length % this._delta8;
      this.pending = f.slice(f.length - l, f.length), this.pending.length === 0 && (this.pending = null), f = t.join32(f, 0, f.length - l, this.endian);
      for (var d = 0; d < f.length; d += this._delta32)
        this._update(f, d, d + this._delta32);
    }
    return this;
  }, r.prototype.digest = function(f) {
    return this.update(this._pad()), e(this.pending === null), this._digest(f);
  }, r.prototype._pad = function() {
    var f = this.pendingTotal, a = this._delta8, l = a - (f + this.padLength) % a, d = new Array(l + this.padLength);
    d[0] = 128;
    for (var v = 1; v < l; v++)
      d[v] = 0;
    if (f <<= 3, this.endian === "big") {
      for (var m = 8; m < this.padLength; m++)
        d[v++] = 0;
      d[v++] = 0, d[v++] = 0, d[v++] = 0, d[v++] = 0, d[v++] = f >>> 24 & 255, d[v++] = f >>> 16 & 255, d[v++] = f >>> 8 & 255, d[v++] = f & 255;
    } else
      for (d[v++] = f & 255, d[v++] = f >>> 8 & 255, d[v++] = f >>> 16 & 255, d[v++] = f >>> 24 & 255, d[v++] = 0, d[v++] = 0, d[v++] = 0, d[v++] = 0, m = 8; m < this.padLength; m++)
        d[v++] = 0;
    return d;
  }, V0;
}
var _a = {}, $n = {}, K6;
function s_() {
  if (K6)
    return $n;
  K6 = 1;
  var t = ui(), e = t.rotr32;
  function r(h, w, M, S) {
    if (h === 0)
      return i(w, M, S);
    if (h === 1 || h === 3)
      return a(w, M, S);
    if (h === 2)
      return f(w, M, S);
  }
  $n.ft_1 = r;
  function i(h, w, M) {
    return h & w ^ ~h & M;
  }
  $n.ch32 = i;
  function f(h, w, M) {
    return h & w ^ h & M ^ w & M;
  }
  $n.maj32 = f;
  function a(h, w, M) {
    return h ^ w ^ M;
  }
  $n.p32 = a;
  function l(h) {
    return e(h, 2) ^ e(h, 13) ^ e(h, 22);
  }
  $n.s0_256 = l;
  function d(h) {
    return e(h, 6) ^ e(h, 11) ^ e(h, 25);
  }
  $n.s1_256 = d;
  function v(h) {
    return e(h, 7) ^ e(h, 18) ^ h >>> 3;
  }
  $n.g0_256 = v;
  function m(h) {
    return e(h, 17) ^ e(h, 19) ^ h >>> 10;
  }
  return $n.g1_256 = m, $n;
}
var H0, Z6;
function jI() {
  if (Z6)
    return H0;
  Z6 = 1;
  var t = ui(), e = Gf(), r = s_(), i = t.rotl32, f = t.sum32, a = t.sum32_5, l = r.ft_1, d = e.BlockHash, v = [
    1518500249,
    1859775393,
    2400959708,
    3395469782
  ];
  function m() {
    if (!(this instanceof m))
      return new m();
    d.call(this), this.h = [
      1732584193,
      4023233417,
      2562383102,
      271733878,
      3285377520
    ], this.W = new Array(80);
  }
  return t.inherits(m, d), H0 = m, m.blockSize = 512, m.outSize = 160, m.hmacStrength = 80, m.padLength = 64, m.prototype._update = function(w, M) {
    for (var S = this.W, E = 0; E < 16; E++)
      S[E] = w[M + E];
    for (; E < S.length; E++)
      S[E] = i(S[E - 3] ^ S[E - 8] ^ S[E - 14] ^ S[E - 16], 1);
    var A = this.h[0], B = this.h[1], k = this.h[2], C = this.h[3], I = this.h[4];
    for (E = 0; E < S.length; E++) {
      var O = ~~(E / 20), q = a(i(A, 5), l(O, B, k, C), I, S[E], v[O]);
      I = C, C = k, k = i(B, 30), B = A, A = q;
    }
    this.h[0] = f(this.h[0], A), this.h[1] = f(this.h[1], B), this.h[2] = f(this.h[2], k), this.h[3] = f(this.h[3], C), this.h[4] = f(this.h[4], I);
  }, m.prototype._digest = function(w) {
    return w === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  }, H0;
}
var W0, G6;
function o_() {
  if (G6)
    return W0;
  G6 = 1;
  var t = ui(), e = Gf(), r = s_(), i = mn(), f = t.sum32, a = t.sum32_4, l = t.sum32_5, d = r.ch32, v = r.maj32, m = r.s0_256, h = r.s1_256, w = r.g0_256, M = r.g1_256, S = e.BlockHash, E = [
    1116352408,
    1899447441,
    3049323471,
    3921009573,
    961987163,
    1508970993,
    2453635748,
    2870763221,
    3624381080,
    310598401,
    607225278,
    1426881987,
    1925078388,
    2162078206,
    2614888103,
    3248222580,
    3835390401,
    4022224774,
    264347078,
    604807628,
    770255983,
    1249150122,
    1555081692,
    1996064986,
    2554220882,
    2821834349,
    2952996808,
    3210313671,
    3336571891,
    3584528711,
    113926993,
    338241895,
    666307205,
    773529912,
    1294757372,
    1396182291,
    1695183700,
    1986661051,
    2177026350,
    2456956037,
    2730485921,
    2820302411,
    3259730800,
    3345764771,
    3516065817,
    3600352804,
    4094571909,
    275423344,
    430227734,
    506948616,
    659060556,
    883997877,
    958139571,
    1322822218,
    1537002063,
    1747873779,
    1955562222,
    2024104815,
    2227730452,
    2361852424,
    2428436474,
    2756734187,
    3204031479,
    3329325298
  ];
  function A() {
    if (!(this instanceof A))
      return new A();
    S.call(this), this.h = [
      1779033703,
      3144134277,
      1013904242,
      2773480762,
      1359893119,
      2600822924,
      528734635,
      1541459225
    ], this.k = E, this.W = new Array(64);
  }
  return t.inherits(A, S), W0 = A, A.blockSize = 512, A.outSize = 256, A.hmacStrength = 192, A.padLength = 64, A.prototype._update = function(k, C) {
    for (var I = this.W, O = 0; O < 16; O++)
      I[O] = k[C + O];
    for (; O < I.length; O++)
      I[O] = a(M(I[O - 2]), I[O - 7], w(I[O - 15]), I[O - 16]);
    var q = this.h[0], $ = this.h[1], ae = this.h[2], he = this.h[3], te = this.h[4], Ee = this.h[5], x = this.h[6], n = this.h[7];
    for (i(this.k.length === I.length), O = 0; O < I.length; O++) {
      var o = l(n, h(te), d(te, Ee, x), this.k[O], I[O]), u = f(m(q), v(q, $, ae));
      n = x, x = Ee, Ee = te, te = f(he, o), he = ae, ae = $, $ = q, q = f(o, u);
    }
    this.h[0] = f(this.h[0], q), this.h[1] = f(this.h[1], $), this.h[2] = f(this.h[2], ae), this.h[3] = f(this.h[3], he), this.h[4] = f(this.h[4], te), this.h[5] = f(this.h[5], Ee), this.h[6] = f(this.h[6], x), this.h[7] = f(this.h[7], n);
  }, A.prototype._digest = function(k) {
    return k === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  }, W0;
}
var K0, Q6;
function $I() {
  if (Q6)
    return K0;
  Q6 = 1;
  var t = ui(), e = o_();
  function r() {
    if (!(this instanceof r))
      return new r();
    e.call(this), this.h = [
      3238371032,
      914150663,
      812702999,
      4144912697,
      4290775857,
      1750603025,
      1694076839,
      3204075428
    ];
  }
  return t.inherits(r, e), K0 = r, r.blockSize = 512, r.outSize = 224, r.hmacStrength = 192, r.padLength = 64, r.prototype._digest = function(f) {
    return f === "hex" ? t.toHex32(this.h.slice(0, 7), "big") : t.split32(this.h.slice(0, 7), "big");
  }, K0;
}
var Z0, Y6;
function f_() {
  if (Y6)
    return Z0;
  Y6 = 1;
  var t = ui(), e = Gf(), r = mn(), i = t.rotr64_hi, f = t.rotr64_lo, a = t.shr64_hi, l = t.shr64_lo, d = t.sum64, v = t.sum64_hi, m = t.sum64_lo, h = t.sum64_4_hi, w = t.sum64_4_lo, M = t.sum64_5_hi, S = t.sum64_5_lo, E = e.BlockHash, A = [
    1116352408,
    3609767458,
    1899447441,
    602891725,
    3049323471,
    3964484399,
    3921009573,
    2173295548,
    961987163,
    4081628472,
    1508970993,
    3053834265,
    2453635748,
    2937671579,
    2870763221,
    3664609560,
    3624381080,
    2734883394,
    310598401,
    1164996542,
    607225278,
    1323610764,
    1426881987,
    3590304994,
    1925078388,
    4068182383,
    2162078206,
    991336113,
    2614888103,
    633803317,
    3248222580,
    3479774868,
    3835390401,
    2666613458,
    4022224774,
    944711139,
    264347078,
    2341262773,
    604807628,
    2007800933,
    770255983,
    1495990901,
    1249150122,
    1856431235,
    1555081692,
    3175218132,
    1996064986,
    2198950837,
    2554220882,
    3999719339,
    2821834349,
    766784016,
    2952996808,
    2566594879,
    3210313671,
    3203337956,
    3336571891,
    1034457026,
    3584528711,
    2466948901,
    113926993,
    3758326383,
    338241895,
    168717936,
    666307205,
    1188179964,
    773529912,
    1546045734,
    1294757372,
    1522805485,
    1396182291,
    2643833823,
    1695183700,
    2343527390,
    1986661051,
    1014477480,
    2177026350,
    1206759142,
    2456956037,
    344077627,
    2730485921,
    1290863460,
    2820302411,
    3158454273,
    3259730800,
    3505952657,
    3345764771,
    106217008,
    3516065817,
    3606008344,
    3600352804,
    1432725776,
    4094571909,
    1467031594,
    275423344,
    851169720,
    430227734,
    3100823752,
    506948616,
    1363258195,
    659060556,
    3750685593,
    883997877,
    3785050280,
    958139571,
    3318307427,
    1322822218,
    3812723403,
    1537002063,
    2003034995,
    1747873779,
    3602036899,
    1955562222,
    1575990012,
    2024104815,
    1125592928,
    2227730452,
    2716904306,
    2361852424,
    442776044,
    2428436474,
    593698344,
    2756734187,
    3733110249,
    3204031479,
    2999351573,
    3329325298,
    3815920427,
    3391569614,
    3928383900,
    3515267271,
    566280711,
    3940187606,
    3454069534,
    4118630271,
    4000239992,
    116418474,
    1914138554,
    174292421,
    2731055270,
    289380356,
    3203993006,
    460393269,
    320620315,
    685471733,
    587496836,
    852142971,
    1086792851,
    1017036298,
    365543100,
    1126000580,
    2618297676,
    1288033470,
    3409855158,
    1501505948,
    4234509866,
    1607167915,
    987167468,
    1816402316,
    1246189591
  ];
  function B() {
    if (!(this instanceof B))
      return new B();
    E.call(this), this.h = [
      1779033703,
      4089235720,
      3144134277,
      2227873595,
      1013904242,
      4271175723,
      2773480762,
      1595750129,
      1359893119,
      2917565137,
      2600822924,
      725511199,
      528734635,
      4215389547,
      1541459225,
      327033209
    ], this.k = A, this.W = new Array(160);
  }
  t.inherits(B, E), Z0 = B, B.blockSize = 1024, B.outSize = 512, B.hmacStrength = 192, B.padLength = 128, B.prototype._prepareBlock = function(u, c) {
    for (var g = this.W, b = 0; b < 32; b++)
      g[b] = u[c + b];
    for (; b < g.length; b += 2) {
      var _ = x(g[b - 4], g[b - 3]), p = n(g[b - 4], g[b - 3]), s = g[b - 14], y = g[b - 13], T = te(g[b - 30], g[b - 29]), P = Ee(g[b - 30], g[b - 29]), z = g[b - 32], J = g[b - 31];
      g[b] = h(
        _,
        p,
        s,
        y,
        T,
        P,
        z,
        J
      ), g[b + 1] = w(
        _,
        p,
        s,
        y,
        T,
        P,
        z,
        J
      );
    }
  }, B.prototype._update = function(u, c) {
    this._prepareBlock(u, c);
    var g = this.W, b = this.h[0], _ = this.h[1], p = this.h[2], s = this.h[3], y = this.h[4], T = this.h[5], P = this.h[6], z = this.h[7], J = this.h[8], Z = this.h[9], F = this.h[10], ee = this.h[11], re = this.h[12], de = this.h[13], se = this.h[14], Q = this.h[15];
    r(this.k.length === g.length);
    for (var ge = 0; ge < g.length; ge += 2) {
      var Ye = se, Ce = Q, Be = ae(J, Z), st = he(J, Z), De = k(J, Z, F, ee, re), _e = C(J, Z, F, ee, re, de), St = this.k[ge], Oe = this.k[ge + 1], Fe = g[ge], Et = g[ge + 1], Ue = M(
        Ye,
        Ce,
        Be,
        st,
        De,
        _e,
        St,
        Oe,
        Fe,
        Et
      ), oe = S(
        Ye,
        Ce,
        Be,
        st,
        De,
        _e,
        St,
        Oe,
        Fe,
        Et
      );
      Ye = q(b, _), Ce = $(b, _), Be = I(b, _, p, s, y), st = O(b, _, p, s, y, T);
      var le = v(Ye, Ce, Be, st), ie = m(Ye, Ce, Be, st);
      se = re, Q = de, re = F, de = ee, F = J, ee = Z, J = v(P, z, Ue, oe), Z = m(z, z, Ue, oe), P = y, z = T, y = p, T = s, p = b, s = _, b = v(Ue, oe, le, ie), _ = m(Ue, oe, le, ie);
    }
    d(this.h, 0, b, _), d(this.h, 2, p, s), d(this.h, 4, y, T), d(this.h, 6, P, z), d(this.h, 8, J, Z), d(this.h, 10, F, ee), d(this.h, 12, re, de), d(this.h, 14, se, Q);
  }, B.prototype._digest = function(u) {
    return u === "hex" ? t.toHex32(this.h, "big") : t.split32(this.h, "big");
  };
  function k(o, u, c, g, b) {
    var _ = o & c ^ ~o & b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function C(o, u, c, g, b, _) {
    var p = u & g ^ ~u & _;
    return p < 0 && (p += 4294967296), p;
  }
  function I(o, u, c, g, b) {
    var _ = o & c ^ o & b ^ c & b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function O(o, u, c, g, b, _) {
    var p = u & g ^ u & _ ^ g & _;
    return p < 0 && (p += 4294967296), p;
  }
  function q(o, u) {
    var c = i(o, u, 28), g = i(u, o, 2), b = i(u, o, 7), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function $(o, u) {
    var c = f(o, u, 28), g = f(u, o, 2), b = f(u, o, 7), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function ae(o, u) {
    var c = i(o, u, 14), g = i(o, u, 18), b = i(u, o, 9), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function he(o, u) {
    var c = f(o, u, 14), g = f(o, u, 18), b = f(u, o, 9), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function te(o, u) {
    var c = i(o, u, 1), g = i(o, u, 8), b = a(o, u, 7), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function Ee(o, u) {
    var c = f(o, u, 1), g = f(o, u, 8), b = l(o, u, 7), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function x(o, u) {
    var c = i(o, u, 19), g = i(u, o, 29), b = a(o, u, 6), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  function n(o, u) {
    var c = f(o, u, 19), g = f(u, o, 29), b = l(o, u, 6), _ = c ^ g ^ b;
    return _ < 0 && (_ += 4294967296), _;
  }
  return Z0;
}
var G0, J6;
function VI() {
  if (J6)
    return G0;
  J6 = 1;
  var t = ui(), e = f_();
  function r() {
    if (!(this instanceof r))
      return new r();
    e.call(this), this.h = [
      3418070365,
      3238371032,
      1654270250,
      914150663,
      2438529370,
      812702999,
      355462360,
      4144912697,
      1731405415,
      4290775857,
      2394180231,
      1750603025,
      3675008525,
      1694076839,
      1203062813,
      3204075428
    ];
  }
  return t.inherits(r, e), G0 = r, r.blockSize = 1024, r.outSize = 384, r.hmacStrength = 192, r.padLength = 128, r.prototype._digest = function(f) {
    return f === "hex" ? t.toHex32(this.h.slice(0, 12), "big") : t.split32(this.h.slice(0, 12), "big");
  }, G0;
}
var X6;
function HI() {
  return X6 || (X6 = 1, _a.sha1 = jI(), _a.sha224 = $I(), _a.sha256 = o_(), _a.sha384 = VI(), _a.sha512 = f_()), _a;
}
var Q0 = {}, e3;
function WI() {
  if (e3)
    return Q0;
  e3 = 1;
  var t = ui(), e = Gf(), r = t.rotl32, i = t.sum32, f = t.sum32_3, a = t.sum32_4, l = e.BlockHash;
  function d() {
    if (!(this instanceof d))
      return new d();
    l.call(this), this.h = [1732584193, 4023233417, 2562383102, 271733878, 3285377520], this.endian = "little";
  }
  t.inherits(d, l), Q0.ripemd160 = d, d.blockSize = 512, d.outSize = 160, d.hmacStrength = 192, d.padLength = 64, d.prototype._update = function(B, k) {
    for (var C = this.h[0], I = this.h[1], O = this.h[2], q = this.h[3], $ = this.h[4], ae = C, he = I, te = O, Ee = q, x = $, n = 0; n < 80; n++) {
      var o = i(
        r(
          a(C, v(n, I, O, q), B[w[n] + k], m(n)),
          S[n]
        ),
        $
      );
      C = $, $ = q, q = r(O, 10), O = I, I = o, o = i(
        r(
          a(ae, v(79 - n, he, te, Ee), B[M[n] + k], h(n)),
          E[n]
        ),
        x
      ), ae = x, x = Ee, Ee = r(te, 10), te = he, he = o;
    }
    o = f(this.h[1], O, Ee), this.h[1] = f(this.h[2], q, x), this.h[2] = f(this.h[3], $, ae), this.h[3] = f(this.h[4], C, he), this.h[4] = f(this.h[0], I, te), this.h[0] = o;
  }, d.prototype._digest = function(B) {
    return B === "hex" ? t.toHex32(this.h, "little") : t.split32(this.h, "little");
  };
  function v(A, B, k, C) {
    return A <= 15 ? B ^ k ^ C : A <= 31 ? B & k | ~B & C : A <= 47 ? (B | ~k) ^ C : A <= 63 ? B & C | k & ~C : B ^ (k | ~C);
  }
  function m(A) {
    return A <= 15 ? 0 : A <= 31 ? 1518500249 : A <= 47 ? 1859775393 : A <= 63 ? 2400959708 : 2840853838;
  }
  function h(A) {
    return A <= 15 ? 1352829926 : A <= 31 ? 1548603684 : A <= 47 ? 1836072691 : A <= 63 ? 2053994217 : 0;
  }
  var w = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
  ], M = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
  ], S = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
  ], E = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
  ];
  return Q0;
}
var Y0, t3;
function KI() {
  if (t3)
    return Y0;
  t3 = 1;
  var t = ui(), e = mn();
  function r(i, f, a) {
    if (!(this instanceof r))
      return new r(i, f, a);
    this.Hash = i, this.blockSize = i.blockSize / 8, this.outSize = i.outSize / 8, this.inner = null, this.outer = null, this._init(t.toArray(f, a));
  }
  return Y0 = r, r.prototype._init = function(f) {
    f.length > this.blockSize && (f = new this.Hash().update(f).digest()), e(f.length <= this.blockSize);
    for (var a = f.length; a < this.blockSize; a++)
      f.push(0);
    for (a = 0; a < f.length; a++)
      f[a] ^= 54;
    for (this.inner = new this.Hash().update(f), a = 0; a < f.length; a++)
      f[a] ^= 106;
    this.outer = new this.Hash().update(f);
  }, r.prototype.update = function(f, a) {
    return this.inner.update(f, a), this;
  }, r.prototype.digest = function(f) {
    return this.outer.update(this.inner.digest()), this.outer.digest(f);
  }, Y0;
}
var r3;
function Qf() {
  return r3 || (r3 = 1, function(t) {
    var e = t;
    e.utils = ui(), e.common = Gf(), e.sha = HI(), e.ripemd = WI(), e.hmac = KI(), e.sha1 = e.sha.sha1, e.sha256 = e.sha.sha256, e.sha224 = e.sha.sha224, e.sha384 = e.sha.sha384, e.sha512 = e.sha.sha512, e.ripemd160 = e.ripemd.ripemd160;
  }($0)), $0;
}
var J0, n3;
function ZI() {
  return n3 || (n3 = 1, J0 = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), J0;
}
var i3;
function Cm() {
  return i3 || (i3 = 1, function(t) {
    var e = t, r = Qf(), i = a_(), f = An(), a = f.assert;
    function l(m) {
      m.type === "short" ? this.curve = new i.short(m) : m.type === "edwards" ? this.curve = new i.edwards(m) : this.curve = new i.mont(m), this.g = this.curve.g, this.n = this.curve.n, this.hash = m.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = l;
    function d(m, h) {
      Object.defineProperty(e, m, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var w = new l(h);
          return Object.defineProperty(e, m, {
            configurable: !0,
            enumerable: !0,
            value: w
          }), w;
        }
      });
    }
    d("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), d("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), d("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), d("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), d("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), d("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), d("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var v;
    try {
      v = ZI();
    } catch {
      v = void 0;
    }
    d("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        v
      ]
    });
  }(j0)), j0;
}
var X0, a3;
function u_() {
  if (a3)
    return X0;
  a3 = 1;
  var t = Qf(), e = Tm(), r = mn();
  function i(f) {
    if (!(this instanceof i))
      return new i(f);
    this.hash = f.hash, this.predResist = !!f.predResist, this.outLen = this.hash.outSize, this.minEntropy = f.minEntropy || this.hash.hmacStrength, this._reseed = null, this.reseedInterval = null, this.K = null, this.V = null;
    var a = e.toArray(f.entropy, f.entropyEnc || "hex"), l = e.toArray(f.nonce, f.nonceEnc || "hex"), d = e.toArray(f.pers, f.persEnc || "hex");
    r(
      a.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._init(a, l, d);
  }
  return X0 = i, i.prototype._init = function(a, l, d) {
    var v = a.concat(l).concat(d);
    this.K = new Array(this.outLen / 8), this.V = new Array(this.outLen / 8);
    for (var m = 0; m < this.V.length; m++)
      this.K[m] = 0, this.V[m] = 1;
    this._update(v), this._reseed = 1, this.reseedInterval = 281474976710656;
  }, i.prototype._hmac = function() {
    return new t.hmac(this.hash, this.K);
  }, i.prototype._update = function(a) {
    var l = this._hmac().update(this.V).update([0]);
    a && (l = l.update(a)), this.K = l.digest(), this.V = this._hmac().update(this.V).digest(), a && (this.K = this._hmac().update(this.V).update([1]).update(a).digest(), this.V = this._hmac().update(this.V).digest());
  }, i.prototype.reseed = function(a, l, d, v) {
    typeof l != "string" && (v = d, d = l, l = null), a = e.toArray(a, l), d = e.toArray(d, v), r(
      a.length >= this.minEntropy / 8,
      "Not enough entropy. Minimum is: " + this.minEntropy + " bits"
    ), this._update(a.concat(d || [])), this._reseed = 1;
  }, i.prototype.generate = function(a, l, d, v) {
    if (this._reseed > this.reseedInterval)
      throw new Error("Reseed is required");
    typeof l != "string" && (v = d, d = l, l = null), d && (d = e.toArray(d, v || "hex"), this._update(d));
    for (var m = []; m.length < a; )
      this.V = this._hmac().update(this.V).digest(), m = m.concat(this.V);
    var h = m.slice(0, a);
    return this._update(d), this._reseed++, e.encode(h, l);
  }, X0;
}
var ep, s3;
function GI() {
  if (s3)
    return ep;
  s3 = 1;
  var t = Ti(), e = An(), r = e.assert;
  function i(f, a) {
    this.ec = f, this.priv = null, this.pub = null, a.priv && this._importPrivate(a.priv, a.privEnc), a.pub && this._importPublic(a.pub, a.pubEnc);
  }
  return ep = i, i.fromPublic = function(a, l, d) {
    return l instanceof i ? l : new i(a, {
      pub: l,
      pubEnc: d
    });
  }, i.fromPrivate = function(a, l, d) {
    return l instanceof i ? l : new i(a, {
      priv: l,
      privEnc: d
    });
  }, i.prototype.validate = function() {
    var a = this.getPublic();
    return a.isInfinity() ? { result: !1, reason: "Invalid public key" } : a.validate() ? a.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, i.prototype.getPublic = function(a, l) {
    return typeof a == "string" && (l = a, a = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), l ? this.pub.encode(l, a) : this.pub;
  }, i.prototype.getPrivate = function(a) {
    return a === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, i.prototype._importPrivate = function(a, l) {
    this.priv = new t(a, l || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, i.prototype._importPublic = function(a, l) {
    if (a.x || a.y) {
      this.ec.curve.type === "mont" ? r(a.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && r(a.x && a.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(a.x, a.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(a, l);
  }, i.prototype.derive = function(a) {
    return a.validate() || r(a.validate(), "public point not validated"), a.mul(this.priv).getX();
  }, i.prototype.sign = function(a, l, d) {
    return this.ec.sign(a, this, l, d);
  }, i.prototype.verify = function(a, l) {
    return this.ec.verify(a, l, this);
  }, i.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, ep;
}
var tp, o3;
function QI() {
  if (o3)
    return tp;
  o3 = 1;
  var t = Ti(), e = An(), r = e.assert;
  function i(v, m) {
    if (v instanceof i)
      return v;
    this._importDER(v, m) || (r(v.r && v.s, "Signature without r or s"), this.r = new t(v.r, 16), this.s = new t(v.s, 16), v.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = v.recoveryParam);
  }
  tp = i;
  function f() {
    this.place = 0;
  }
  function a(v, m) {
    var h = v[m.place++];
    if (!(h & 128))
      return h;
    var w = h & 15;
    if (w === 0 || w > 4)
      return !1;
    for (var M = 0, S = 0, E = m.place; S < w; S++, E++)
      M <<= 8, M |= v[E], M >>>= 0;
    return M <= 127 ? !1 : (m.place = E, M);
  }
  function l(v) {
    for (var m = 0, h = v.length - 1; !v[m] && !(v[m + 1] & 128) && m < h; )
      m++;
    return m === 0 ? v : v.slice(m);
  }
  i.prototype._importDER = function(m, h) {
    m = e.toArray(m, h);
    var w = new f();
    if (m[w.place++] !== 48)
      return !1;
    var M = a(m, w);
    if (M === !1 || M + w.place !== m.length || m[w.place++] !== 2)
      return !1;
    var S = a(m, w);
    if (S === !1)
      return !1;
    var E = m.slice(w.place, S + w.place);
    if (w.place += S, m[w.place++] !== 2)
      return !1;
    var A = a(m, w);
    if (A === !1 || m.length !== A + w.place)
      return !1;
    var B = m.slice(w.place, A + w.place);
    if (E[0] === 0)
      if (E[1] & 128)
        E = E.slice(1);
      else
        return !1;
    if (B[0] === 0)
      if (B[1] & 128)
        B = B.slice(1);
      else
        return !1;
    return this.r = new t(E), this.s = new t(B), this.recoveryParam = null, !0;
  };
  function d(v, m) {
    if (m < 128) {
      v.push(m);
      return;
    }
    var h = 1 + (Math.log(m) / Math.LN2 >>> 3);
    for (v.push(h | 128); --h; )
      v.push(m >>> (h << 3) & 255);
    v.push(m);
  }
  return i.prototype.toDER = function(m) {
    var h = this.r.toArray(), w = this.s.toArray();
    for (h[0] & 128 && (h = [0].concat(h)), w[0] & 128 && (w = [0].concat(w)), h = l(h), w = l(w); !w[0] && !(w[1] & 128); )
      w = w.slice(1);
    var M = [2];
    d(M, h.length), M = M.concat(h), M.push(2), d(M, w.length);
    var S = M.concat(w), E = [48];
    return d(E, S.length), E = E.concat(S), e.encode(E, m);
  }, tp;
}
var rp, f3;
function YI() {
  if (f3)
    return rp;
  f3 = 1;
  var t = Ti(), e = u_(), r = An(), i = Cm(), f = Kf(), a = r.assert, l = GI(), d = QI();
  function v(m) {
    if (!(this instanceof v))
      return new v(m);
    typeof m == "string" && (a(
      Object.prototype.hasOwnProperty.call(i, m),
      "Unknown curve " + m
    ), m = i[m]), m instanceof i.PresetCurve && (m = { curve: m }), this.curve = m.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = m.curve.g, this.g.precompute(m.curve.n.bitLength() + 1), this.hash = m.hash || m.curve.hash;
  }
  return rp = v, v.prototype.keyPair = function(h) {
    return new l(this, h);
  }, v.prototype.keyFromPrivate = function(h, w) {
    return l.fromPrivate(this, h, w);
  }, v.prototype.keyFromPublic = function(h, w) {
    return l.fromPublic(this, h, w);
  }, v.prototype.genKeyPair = function(h) {
    h || (h = {});
    for (var w = new e({
      hash: this.hash,
      pers: h.pers,
      persEnc: h.persEnc || "utf8",
      entropy: h.entropy || f(this.hash.hmacStrength),
      entropyEnc: h.entropy && h.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), M = this.n.byteLength(), S = this.n.sub(new t(2)); ; ) {
      var E = new t(w.generate(M));
      if (!(E.cmp(S) > 0))
        return E.iaddn(1), this.keyFromPrivate(E);
    }
  }, v.prototype._truncateToN = function(h, w) {
    var M = h.byteLength() * 8 - this.n.bitLength();
    return M > 0 && (h = h.ushrn(M)), !w && h.cmp(this.n) >= 0 ? h.sub(this.n) : h;
  }, v.prototype.sign = function(h, w, M, S) {
    typeof M == "object" && (S = M, M = null), S || (S = {}), w = this.keyFromPrivate(w, M), h = this._truncateToN(new t(h, 16));
    for (var E = this.n.byteLength(), A = w.getPrivate().toArray("be", E), B = h.toArray("be", E), k = new e({
      hash: this.hash,
      entropy: A,
      nonce: B,
      pers: S.pers,
      persEnc: S.persEnc || "utf8"
    }), C = this.n.sub(new t(1)), I = 0; ; I++) {
      var O = S.k ? S.k(I) : new t(k.generate(this.n.byteLength()));
      if (O = this._truncateToN(O, !0), !(O.cmpn(1) <= 0 || O.cmp(C) >= 0)) {
        var q = this.g.mul(O);
        if (!q.isInfinity()) {
          var $ = q.getX(), ae = $.umod(this.n);
          if (ae.cmpn(0) !== 0) {
            var he = O.invm(this.n).mul(ae.mul(w.getPrivate()).iadd(h));
            if (he = he.umod(this.n), he.cmpn(0) !== 0) {
              var te = (q.getY().isOdd() ? 1 : 0) | ($.cmp(ae) !== 0 ? 2 : 0);
              return S.canonical && he.cmp(this.nh) > 0 && (he = this.n.sub(he), te ^= 1), new d({ r: ae, s: he, recoveryParam: te });
            }
          }
        }
      }
    }
  }, v.prototype.verify = function(h, w, M, S) {
    h = this._truncateToN(new t(h, 16)), M = this.keyFromPublic(M, S), w = new d(w, "hex");
    var E = w.r, A = w.s;
    if (E.cmpn(1) < 0 || E.cmp(this.n) >= 0 || A.cmpn(1) < 0 || A.cmp(this.n) >= 0)
      return !1;
    var B = A.invm(this.n), k = B.mul(h).umod(this.n), C = B.mul(E).umod(this.n), I;
    return this.curve._maxwellTrick ? (I = this.g.jmulAdd(k, M.getPublic(), C), I.isInfinity() ? !1 : I.eqXToP(E)) : (I = this.g.mulAdd(k, M.getPublic(), C), I.isInfinity() ? !1 : I.getX().umod(this.n).cmp(E) === 0);
  }, v.prototype.recoverPubKey = function(m, h, w, M) {
    a((3 & w) === w, "The recovery param is more than two bits"), h = new d(h, M);
    var S = this.n, E = new t(m), A = h.r, B = h.s, k = w & 1, C = w >> 1;
    if (A.cmp(this.curve.p.umod(this.curve.n)) >= 0 && C)
      throw new Error("Unable to find sencond key candinate");
    C ? A = this.curve.pointFromX(A.add(this.curve.n), k) : A = this.curve.pointFromX(A, k);
    var I = h.r.invm(S), O = S.sub(E).mul(I).umod(S), q = B.mul(I).umod(S);
    return this.g.mulAdd(O, A, q);
  }, v.prototype.getKeyRecoveryParam = function(m, h, w, M) {
    if (h = new d(h, M), h.recoveryParam !== null)
      return h.recoveryParam;
    for (var S = 0; S < 4; S++) {
      var E;
      try {
        E = this.recoverPubKey(m, h, S);
      } catch {
        continue;
      }
      if (E.eq(w))
        return S;
    }
    throw new Error("Unable to find valid recovery factor");
  }, rp;
}
var np, u3;
function JI() {
  if (u3)
    return np;
  u3 = 1;
  var t = An(), e = t.assert, r = t.parseBytes, i = t.cachedProperty;
  function f(a, l) {
    this.eddsa = a, this._secret = r(l.secret), a.isPoint(l.pub) ? this._pub = l.pub : this._pubBytes = r(l.pub);
  }
  return f.fromPublic = function(l, d) {
    return d instanceof f ? d : new f(l, { pub: d });
  }, f.fromSecret = function(l, d) {
    return d instanceof f ? d : new f(l, { secret: d });
  }, f.prototype.secret = function() {
    return this._secret;
  }, i(f, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), i(f, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), i(f, "privBytes", function() {
    var l = this.eddsa, d = this.hash(), v = l.encodingLength - 1, m = d.slice(0, l.encodingLength);
    return m[0] &= 248, m[v] &= 127, m[v] |= 64, m;
  }), i(f, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), i(f, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), i(f, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), f.prototype.sign = function(l) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(l, this);
  }, f.prototype.verify = function(l, d) {
    return this.eddsa.verify(l, d, this);
  }, f.prototype.getSecret = function(l) {
    return e(this._secret, "KeyPair is public only"), t.encode(this.secret(), l);
  }, f.prototype.getPublic = function(l) {
    return t.encode(this.pubBytes(), l);
  }, np = f, np;
}
var ip, l3;
function XI() {
  if (l3)
    return ip;
  l3 = 1;
  var t = Ti(), e = An(), r = e.assert, i = e.cachedProperty, f = e.parseBytes;
  function a(l, d) {
    this.eddsa = l, typeof d != "object" && (d = f(d)), Array.isArray(d) && (d = {
      R: d.slice(0, l.encodingLength),
      S: d.slice(l.encodingLength)
    }), r(d.R && d.S, "Signature without R or S"), l.isPoint(d.R) && (this._R = d.R), d.S instanceof t && (this._S = d.S), this._Rencoded = Array.isArray(d.R) ? d.R : d.Rencoded, this._Sencoded = Array.isArray(d.S) ? d.S : d.Sencoded;
  }
  return i(a, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), i(a, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), i(a, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), i(a, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), a.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, a.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, ip = a, ip;
}
var ap, c3;
function eR() {
  if (c3)
    return ap;
  c3 = 1;
  var t = Qf(), e = Cm(), r = An(), i = r.assert, f = r.parseBytes, a = JI(), l = XI();
  function d(v) {
    if (i(v === "ed25519", "only tested with ed25519 so far"), !(this instanceof d))
      return new d(v);
    v = e[v].curve, this.curve = v, this.g = v.g, this.g.precompute(v.n.bitLength() + 1), this.pointClass = v.point().constructor, this.encodingLength = Math.ceil(v.n.bitLength() / 8), this.hash = t.sha512;
  }
  return ap = d, d.prototype.sign = function(m, h) {
    m = f(m);
    var w = this.keyFromSecret(h), M = this.hashInt(w.messagePrefix(), m), S = this.g.mul(M), E = this.encodePoint(S), A = this.hashInt(E, w.pubBytes(), m).mul(w.priv()), B = M.add(A).umod(this.curve.n);
    return this.makeSignature({ R: S, S: B, Rencoded: E });
  }, d.prototype.verify = function(m, h, w) {
    m = f(m), h = this.makeSignature(h);
    var M = this.keyFromPublic(w), S = this.hashInt(h.Rencoded(), M.pubBytes(), m), E = this.g.mul(h.S()), A = h.R().add(M.pub().mul(S));
    return A.eq(E);
  }, d.prototype.hashInt = function() {
    for (var m = this.hash(), h = 0; h < arguments.length; h++)
      m.update(arguments[h]);
    return r.intFromLE(m.digest()).umod(this.curve.n);
  }, d.prototype.keyFromPublic = function(m) {
    return a.fromPublic(this, m);
  }, d.prototype.keyFromSecret = function(m) {
    return a.fromSecret(this, m);
  }, d.prototype.makeSignature = function(m) {
    return m instanceof l ? m : new l(this, m);
  }, d.prototype.encodePoint = function(m) {
    var h = m.getY().toArray("le", this.encodingLength);
    return h[this.encodingLength - 1] |= m.getX().isOdd() ? 128 : 0, h;
  }, d.prototype.decodePoint = function(m) {
    m = r.parseBytes(m);
    var h = m.length - 1, w = m.slice(0, h).concat(m[h] & -129), M = (m[h] & 128) !== 0, S = r.intFromLE(w);
    return this.curve.pointFromY(S, M);
  }, d.prototype.encodeInt = function(m) {
    return m.toArray("le", this.encodingLength);
  }, d.prototype.decodeInt = function(m) {
    return r.intFromLE(m);
  }, d.prototype.isPoint = function(m) {
    return m instanceof this.pointClass;
  }, ap;
}
var d3;
function l_() {
  return d3 || (d3 = 1, function(t) {
    var e = t;
    e.version = LI.version, e.utils = An(), e.rand = Kf(), e.curve = a_(), e.curves = Cm(), e.ec = YI(), e.eddsa = eR();
  }(O0)), O0;
}
var bn = {}, sp = {}, Yu = { exports: {} };
Yu.exports;
var h3;
function tR() {
  return h3 || (h3 = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(Yu)), Yu.exports;
}
var op = {};
const rR = {}, nR = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: rR
}, Symbol.toStringTag, { value: "Module" })), iR = /* @__PURE__ */ P5(nR);
var p3;
function aR() {
  return p3 || (p3 = 1, function(t) {
    var e = Yf(), r = Lt(), i = t;
    i.define = function(l, d) {
      return new f(l, d);
    };
    function f(a, l) {
      this.name = a, this.body = l, this.decoders = {}, this.encoders = {};
    }
    f.prototype._createNamed = function(l) {
      var d;
      try {
        d = iR.runInThisContext(
          "(function " + this.name + `(entity) {
  this._initNamed(entity);
})`
        );
      } catch {
        d = function(m) {
          this._initNamed(m);
        };
      }
      return r(d, l), d.prototype._initNamed = function(m) {
        l.call(this, m);
      }, new d(this);
    }, f.prototype._getDecoder = function(l) {
      return l = l || "der", this.decoders.hasOwnProperty(l) || (this.decoders[l] = this._createNamed(e.decoders[l])), this.decoders[l];
    }, f.prototype.decode = function(l, d, v) {
      return this._getDecoder(d).decode(l, v);
    }, f.prototype._getEncoder = function(l) {
      return l = l || "der", this.encoders.hasOwnProperty(l) || (this.encoders[l] = this._createNamed(e.encoders[l])), this.encoders[l];
    }, f.prototype.encode = function(l, d, v) {
      return this._getEncoder(d).encode(l, v);
    };
  }(op)), op;
}
var fp = {}, up = {}, v3;
function sR() {
  if (v3)
    return up;
  v3 = 1;
  var t = Lt();
  function e(i) {
    this._reporterState = {
      obj: null,
      path: [],
      options: i || {},
      errors: []
    };
  }
  up.Reporter = e, e.prototype.isError = function(f) {
    return f instanceof r;
  }, e.prototype.save = function() {
    var f = this._reporterState;
    return { obj: f.obj, pathLen: f.path.length };
  }, e.prototype.restore = function(f) {
    var a = this._reporterState;
    a.obj = f.obj, a.path = a.path.slice(0, f.pathLen);
  }, e.prototype.enterKey = function(f) {
    return this._reporterState.path.push(f);
  }, e.prototype.exitKey = function(f) {
    var a = this._reporterState;
    a.path = a.path.slice(0, f - 1);
  }, e.prototype.leaveKey = function(f, a, l) {
    var d = this._reporterState;
    this.exitKey(f), d.obj !== null && (d.obj[a] = l);
  }, e.prototype.path = function() {
    return this._reporterState.path.join("/");
  }, e.prototype.enterObject = function() {
    var f = this._reporterState, a = f.obj;
    return f.obj = {}, a;
  }, e.prototype.leaveObject = function(f) {
    var a = this._reporterState, l = a.obj;
    return a.obj = f, l;
  }, e.prototype.error = function(f) {
    var a, l = this._reporterState, d = f instanceof r;
    if (d ? a = f : a = new r(l.path.map(function(v) {
      return "[" + JSON.stringify(v) + "]";
    }).join(""), f.message || f, f.stack), !l.options.partial)
      throw a;
    return d || l.errors.push(a), a;
  }, e.prototype.wrapResult = function(f) {
    var a = this._reporterState;
    return a.options.partial ? {
      result: this.isError(f) ? null : f,
      errors: a.errors
    } : f;
  };
  function r(i, f) {
    this.path = i, this.rethrow(f);
  }
  return t(r, Error), r.prototype.rethrow = function(f) {
    if (this.message = f + " at: " + (this.path || "(shallow)"), Error.captureStackTrace && Error.captureStackTrace(this, r), !this.stack)
      try {
        throw new Error(this.message);
      } catch (a) {
        this.stack = a.stack;
      }
    return this;
  }, up;
}
var Tu = {}, m3;
function g3() {
  if (m3)
    return Tu;
  m3 = 1;
  var t = Lt(), e = xf().Reporter, r = kr.Buffer;
  function i(a, l) {
    if (e.call(this, l), !r.isBuffer(a)) {
      this.error("Input not Buffer");
      return;
    }
    this.base = a, this.offset = 0, this.length = a.length;
  }
  t(i, e), Tu.DecoderBuffer = i, i.prototype.save = function() {
    return { offset: this.offset, reporter: e.prototype.save.call(this) };
  }, i.prototype.restore = function(l) {
    var d = new i(this.base);
    return d.offset = l.offset, d.length = this.offset, this.offset = l.offset, e.prototype.restore.call(this, l.reporter), d;
  }, i.prototype.isEmpty = function() {
    return this.offset === this.length;
  }, i.prototype.readUInt8 = function(l) {
    return this.offset + 1 <= this.length ? this.base.readUInt8(this.offset++, !0) : this.error(l || "DecoderBuffer overrun");
  }, i.prototype.skip = function(l, d) {
    if (!(this.offset + l <= this.length))
      return this.error(d || "DecoderBuffer overrun");
    var v = new i(this.base);
    return v._reporterState = this._reporterState, v.offset = this.offset, v.length = this.offset + l, this.offset += l, v;
  }, i.prototype.raw = function(l) {
    return this.base.slice(l ? l.offset : this.offset, this.length);
  };
  function f(a, l) {
    if (Array.isArray(a))
      this.length = 0, this.value = a.map(function(d) {
        return d instanceof f || (d = new f(d, l)), this.length += d.length, d;
      }, this);
    else if (typeof a == "number") {
      if (!(0 <= a && a <= 255))
        return l.error("non-byte EncoderBuffer value");
      this.value = a, this.length = 1;
    } else if (typeof a == "string")
      this.value = a, this.length = r.byteLength(a);
    else if (r.isBuffer(a))
      this.value = a, this.length = a.length;
    else
      return l.error("Unsupported type: " + typeof a);
  }
  return Tu.EncoderBuffer = f, f.prototype.join = function(l, d) {
    return l || (l = new r(this.length)), d || (d = 0), this.length === 0 || (Array.isArray(this.value) ? this.value.forEach(function(v) {
      v.join(l, d), d += v.length;
    }) : (typeof this.value == "number" ? l[d] = this.value : typeof this.value == "string" ? l.write(this.value, d) : r.isBuffer(this.value) && this.value.copy(l, d), d += this.length)), l;
  }, Tu;
}
var lp, y3;
function oR() {
  if (y3)
    return lp;
  y3 = 1;
  var t = xf().Reporter, e = xf().EncoderBuffer, r = xf().DecoderBuffer, i = mn(), f = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
  ], a = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
  ].concat(f), l = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
  ];
  function d(m, h) {
    var w = {};
    this._baseState = w, w.enc = m, w.parent = h || null, w.children = null, w.tag = null, w.args = null, w.reverseArgs = null, w.choice = null, w.optional = !1, w.any = !1, w.obj = !1, w.use = null, w.useDecoder = null, w.key = null, w.default = null, w.explicit = null, w.implicit = null, w.contains = null, w.parent || (w.children = [], this._wrap());
  }
  lp = d;
  var v = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
  ];
  return d.prototype.clone = function() {
    var h = this._baseState, w = {};
    v.forEach(function(S) {
      w[S] = h[S];
    });
    var M = new this.constructor(w.parent);
    return M._baseState = w, M;
  }, d.prototype._wrap = function() {
    var h = this._baseState;
    a.forEach(function(w) {
      this[w] = function() {
        var S = new this.constructor(this);
        return h.children.push(S), S[w].apply(S, arguments);
      };
    }, this);
  }, d.prototype._init = function(h) {
    var w = this._baseState;
    i(w.parent === null), h.call(this), w.children = w.children.filter(function(M) {
      return M._baseState.parent === this;
    }, this), i.equal(w.children.length, 1, "Root node can have only one child");
  }, d.prototype._useArgs = function(h) {
    var w = this._baseState, M = h.filter(function(S) {
      return S instanceof this.constructor;
    }, this);
    h = h.filter(function(S) {
      return !(S instanceof this.constructor);
    }, this), M.length !== 0 && (i(w.children === null), w.children = M, M.forEach(function(S) {
      S._baseState.parent = this;
    }, this)), h.length !== 0 && (i(w.args === null), w.args = h, w.reverseArgs = h.map(function(S) {
      if (typeof S != "object" || S.constructor !== Object)
        return S;
      var E = {};
      return Object.keys(S).forEach(function(A) {
        A == (A | 0) && (A |= 0);
        var B = S[A];
        E[B] = A;
      }), E;
    }));
  }, l.forEach(function(m) {
    d.prototype[m] = function() {
      var w = this._baseState;
      throw new Error(m + " not implemented for encoding: " + w.enc);
    };
  }), f.forEach(function(m) {
    d.prototype[m] = function() {
      var w = this._baseState, M = Array.prototype.slice.call(arguments);
      return i(w.tag === null), w.tag = m, this._useArgs(M), this;
    };
  }), d.prototype.use = function(h) {
    i(h);
    var w = this._baseState;
    return i(w.use === null), w.use = h, this;
  }, d.prototype.optional = function() {
    var h = this._baseState;
    return h.optional = !0, this;
  }, d.prototype.def = function(h) {
    var w = this._baseState;
    return i(w.default === null), w.default = h, w.optional = !0, this;
  }, d.prototype.explicit = function(h) {
    var w = this._baseState;
    return i(w.explicit === null && w.implicit === null), w.explicit = h, this;
  }, d.prototype.implicit = function(h) {
    var w = this._baseState;
    return i(w.explicit === null && w.implicit === null), w.implicit = h, this;
  }, d.prototype.obj = function() {
    var h = this._baseState, w = Array.prototype.slice.call(arguments);
    return h.obj = !0, w.length !== 0 && this._useArgs(w), this;
  }, d.prototype.key = function(h) {
    var w = this._baseState;
    return i(w.key === null), w.key = h, this;
  }, d.prototype.any = function() {
    var h = this._baseState;
    return h.any = !0, this;
  }, d.prototype.choice = function(h) {
    var w = this._baseState;
    return i(w.choice === null), w.choice = h, this._useArgs(Object.keys(h).map(function(M) {
      return h[M];
    })), this;
  }, d.prototype.contains = function(h) {
    var w = this._baseState;
    return i(w.use === null), w.contains = h, this;
  }, d.prototype._decode = function(h, w) {
    var M = this._baseState;
    if (M.parent === null)
      return h.wrapResult(M.children[0]._decode(h, w));
    var S = M.default, E = !0, A = null;
    if (M.key !== null && (A = h.enterKey(M.key)), M.optional) {
      var B = null;
      if (M.explicit !== null ? B = M.explicit : M.implicit !== null ? B = M.implicit : M.tag !== null && (B = M.tag), B === null && !M.any) {
        var k = h.save();
        try {
          M.choice === null ? this._decodeGeneric(M.tag, h, w) : this._decodeChoice(h, w), E = !0;
        } catch {
          E = !1;
        }
        h.restore(k);
      } else if (E = this._peekTag(h, B, M.any), h.isError(E))
        return E;
    }
    var C;
    if (M.obj && E && (C = h.enterObject()), E) {
      if (M.explicit !== null) {
        var I = this._decodeTag(h, M.explicit);
        if (h.isError(I))
          return I;
        h = I;
      }
      var O = h.offset;
      if (M.use === null && M.choice === null) {
        if (M.any)
          var k = h.save();
        var q = this._decodeTag(
          h,
          M.implicit !== null ? M.implicit : M.tag,
          M.any
        );
        if (h.isError(q))
          return q;
        M.any ? S = h.raw(k) : h = q;
      }
      if (w && w.track && M.tag !== null && w.track(h.path(), O, h.length, "tagged"), w && w.track && M.tag !== null && w.track(h.path(), h.offset, h.length, "content"), M.any ? S = S : M.choice === null ? S = this._decodeGeneric(M.tag, h, w) : S = this._decodeChoice(h, w), h.isError(S))
        return S;
      if (!M.any && M.choice === null && M.children !== null && M.children.forEach(function(he) {
        he._decode(h, w);
      }), M.contains && (M.tag === "octstr" || M.tag === "bitstr")) {
        var $ = new r(S);
        S = this._getUse(M.contains, h._reporterState.obj)._decode($, w);
      }
    }
    return M.obj && E && (S = h.leaveObject(C)), M.key !== null && (S !== null || E === !0) ? h.leaveKey(A, M.key, S) : A !== null && h.exitKey(A), S;
  }, d.prototype._decodeGeneric = function(h, w, M) {
    var S = this._baseState;
    return h === "seq" || h === "set" ? null : h === "seqof" || h === "setof" ? this._decodeList(w, h, S.args[0], M) : /str$/.test(h) ? this._decodeStr(w, h, M) : h === "objid" && S.args ? this._decodeObjid(w, S.args[0], S.args[1], M) : h === "objid" ? this._decodeObjid(w, null, null, M) : h === "gentime" || h === "utctime" ? this._decodeTime(w, h, M) : h === "null_" ? this._decodeNull(w, M) : h === "bool" ? this._decodeBool(w, M) : h === "objDesc" ? this._decodeStr(w, h, M) : h === "int" || h === "enum" ? this._decodeInt(w, S.args && S.args[0], M) : S.use !== null ? this._getUse(S.use, w._reporterState.obj)._decode(w, M) : w.error("unknown tag: " + h);
  }, d.prototype._getUse = function(h, w) {
    var M = this._baseState;
    return M.useDecoder = this._use(h, w), i(M.useDecoder._baseState.parent === null), M.useDecoder = M.useDecoder._baseState.children[0], M.implicit !== M.useDecoder._baseState.implicit && (M.useDecoder = M.useDecoder.clone(), M.useDecoder._baseState.implicit = M.implicit), M.useDecoder;
  }, d.prototype._decodeChoice = function(h, w) {
    var M = this._baseState, S = null, E = !1;
    return Object.keys(M.choice).some(function(A) {
      var B = h.save(), k = M.choice[A];
      try {
        var C = k._decode(h, w);
        if (h.isError(C))
          return !1;
        S = { type: A, value: C }, E = !0;
      } catch {
        return h.restore(B), !1;
      }
      return !0;
    }, this), E ? S : h.error("Choice not matched");
  }, d.prototype._createEncoderBuffer = function(h) {
    return new e(h, this.reporter);
  }, d.prototype._encode = function(h, w, M) {
    var S = this._baseState;
    if (!(S.default !== null && S.default === h)) {
      var E = this._encodeValue(h, w, M);
      if (E !== void 0 && !this._skipDefault(E, w, M))
        return E;
    }
  }, d.prototype._encodeValue = function(h, w, M) {
    var S = this._baseState;
    if (S.parent === null)
      return S.children[0]._encode(h, w || new t());
    var k = null;
    if (this.reporter = w, S.optional && h === void 0)
      if (S.default !== null)
        h = S.default;
      else
        return;
    var E = null, A = !1;
    if (S.any)
      k = this._createEncoderBuffer(h);
    else if (S.choice)
      k = this._encodeChoice(h, w);
    else if (S.contains)
      E = this._getUse(S.contains, M)._encode(h, w), A = !0;
    else if (S.children)
      E = S.children.map(function(O) {
        if (O._baseState.tag === "null_")
          return O._encode(null, w, h);
        if (O._baseState.key === null)
          return w.error("Child should have a key");
        var q = w.enterKey(O._baseState.key);
        if (typeof h != "object")
          return w.error("Child expected, but input is not object");
        var $ = O._encode(h[O._baseState.key], w, h);
        return w.leaveKey(q), $;
      }, this).filter(function(O) {
        return O;
      }), E = this._createEncoderBuffer(E);
    else if (S.tag === "seqof" || S.tag === "setof") {
      if (!(S.args && S.args.length === 1))
        return w.error("Too many args for : " + S.tag);
      if (!Array.isArray(h))
        return w.error("seqof/setof, but data is not Array");
      var B = this.clone();
      B._baseState.implicit = null, E = this._createEncoderBuffer(h.map(function(O) {
        var q = this._baseState;
        return this._getUse(q.args[0], h)._encode(O, w);
      }, B));
    } else
      S.use !== null ? k = this._getUse(S.use, M)._encode(h, w) : (E = this._encodePrimitive(S.tag, h), A = !0);
    var k;
    if (!S.any && S.choice === null) {
      var C = S.implicit !== null ? S.implicit : S.tag, I = S.implicit === null ? "universal" : "context";
      C === null ? S.use === null && w.error("Tag could be omitted only for .use()") : S.use === null && (k = this._encodeComposite(C, A, I, E));
    }
    return S.explicit !== null && (k = this._encodeComposite(S.explicit, !1, "context", k)), k;
  }, d.prototype._encodeChoice = function(h, w) {
    var M = this._baseState, S = M.choice[h.type];
    return S || i(
      !1,
      h.type + " not found in " + JSON.stringify(Object.keys(M.choice))
    ), S._encode(h.value, w);
  }, d.prototype._encodePrimitive = function(h, w) {
    var M = this._baseState;
    if (/str$/.test(h))
      return this._encodeStr(w, h);
    if (h === "objid" && M.args)
      return this._encodeObjid(w, M.reverseArgs[0], M.args[1]);
    if (h === "objid")
      return this._encodeObjid(w, null, null);
    if (h === "gentime" || h === "utctime")
      return this._encodeTime(w, h);
    if (h === "null_")
      return this._encodeNull();
    if (h === "int" || h === "enum")
      return this._encodeInt(w, M.args && M.reverseArgs[0]);
    if (h === "bool")
      return this._encodeBool(w);
    if (h === "objDesc")
      return this._encodeStr(w, h);
    throw new Error("Unsupported tag: " + h);
  }, d.prototype._isNumstr = function(h) {
    return /^[0-9 ]*$/.test(h);
  }, d.prototype._isPrintstr = function(h) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(h);
  }, lp;
}
var b3;
function xf() {
  return b3 || (b3 = 1, function(t) {
    var e = t;
    e.Reporter = sR().Reporter, e.DecoderBuffer = g3().DecoderBuffer, e.EncoderBuffer = g3().EncoderBuffer, e.Node = oR();
  }(fp)), fp;
}
var cp = {}, dp = {}, w3;
function fR() {
  return w3 || (w3 = 1, function(t) {
    var e = c_();
    t.tagClass = {
      0: "universal",
      1: "application",
      2: "context",
      3: "private"
    }, t.tagClassByName = e._reverse(t.tagClass), t.tag = {
      0: "end",
      1: "bool",
      2: "int",
      3: "bitstr",
      4: "octstr",
      5: "null_",
      6: "objid",
      7: "objDesc",
      8: "external",
      9: "real",
      10: "enum",
      11: "embed",
      12: "utf8str",
      13: "relativeOid",
      16: "seq",
      17: "set",
      18: "numstr",
      19: "printstr",
      20: "t61str",
      21: "videostr",
      22: "ia5str",
      23: "utctime",
      24: "gentime",
      25: "graphstr",
      26: "iso646str",
      27: "genstr",
      28: "unistr",
      29: "charstr",
      30: "bmpstr"
    }, t.tagByName = e._reverse(t.tag);
  }(dp)), dp;
}
var _3;
function c_() {
  return _3 || (_3 = 1, function(t) {
    var e = t;
    e._reverse = function(i) {
      var f = {};
      return Object.keys(i).forEach(function(a) {
        (a | 0) == a && (a = a | 0);
        var l = i[a];
        f[l] = a;
      }), f;
    }, e.der = fR();
  }(cp)), cp;
}
var hp = {}, pp, x3;
function d_() {
  if (x3)
    return pp;
  x3 = 1;
  var t = Lt(), e = Yf(), r = e.base, i = e.bignum, f = e.constants.der;
  function a(m) {
    this.enc = "der", this.name = m.name, this.entity = m, this.tree = new l(), this.tree._init(m.body);
  }
  pp = a, a.prototype.decode = function(h, w) {
    return h instanceof r.DecoderBuffer || (h = new r.DecoderBuffer(h, w)), this.tree._decode(h, w);
  };
  function l(m) {
    r.Node.call(this, "der", m);
  }
  t(l, r.Node), l.prototype._peekTag = function(h, w, M) {
    if (h.isEmpty())
      return !1;
    var S = h.save(), E = d(h, 'Failed to peek tag: "' + w + '"');
    return h.isError(E) ? E : (h.restore(S), E.tag === w || E.tagStr === w || E.tagStr + "of" === w || M);
  }, l.prototype._decodeTag = function(h, w, M) {
    var S = d(
      h,
      'Failed to decode tag of "' + w + '"'
    );
    if (h.isError(S))
      return S;
    var E = v(
      h,
      S.primitive,
      'Failed to get length of "' + w + '"'
    );
    if (h.isError(E))
      return E;
    if (!M && S.tag !== w && S.tagStr !== w && S.tagStr + "of" !== w)
      return h.error('Failed to match tag: "' + w + '"');
    if (S.primitive || E !== null)
      return h.skip(E, 'Failed to match body of: "' + w + '"');
    var A = h.save(), B = this._skipUntilEnd(
      h,
      'Failed to skip indefinite length body: "' + this.tag + '"'
    );
    return h.isError(B) ? B : (E = h.offset - A.offset, h.restore(A), h.skip(E, 'Failed to match body of: "' + w + '"'));
  }, l.prototype._skipUntilEnd = function(h, w) {
    for (; ; ) {
      var M = d(h, w);
      if (h.isError(M))
        return M;
      var S = v(h, M.primitive, w);
      if (h.isError(S))
        return S;
      var E;
      if (M.primitive || S !== null ? E = h.skip(S) : E = this._skipUntilEnd(h, w), h.isError(E))
        return E;
      if (M.tagStr === "end")
        break;
    }
  }, l.prototype._decodeList = function(h, w, M, S) {
    for (var E = []; !h.isEmpty(); ) {
      var A = this._peekTag(h, "end");
      if (h.isError(A))
        return A;
      var B = M.decode(h, "der", S);
      if (h.isError(B) && A)
        break;
      E.push(B);
    }
    return E;
  }, l.prototype._decodeStr = function(h, w) {
    if (w === "bitstr") {
      var M = h.readUInt8();
      return h.isError(M) ? M : { unused: M, data: h.raw() };
    } else if (w === "bmpstr") {
      var S = h.raw();
      if (S.length % 2 === 1)
        return h.error("Decoding of string type: bmpstr length mismatch");
      for (var E = "", A = 0; A < S.length / 2; A++)
        E += String.fromCharCode(S.readUInt16BE(A * 2));
      return E;
    } else if (w === "numstr") {
      var B = h.raw().toString("ascii");
      return this._isNumstr(B) ? B : h.error("Decoding of string type: numstr unsupported characters");
    } else {
      if (w === "octstr")
        return h.raw();
      if (w === "objDesc")
        return h.raw();
      if (w === "printstr") {
        var k = h.raw().toString("ascii");
        return this._isPrintstr(k) ? k : h.error("Decoding of string type: printstr unsupported characters");
      } else
        return /str$/.test(w) ? h.raw().toString() : h.error("Decoding of string type: " + w + " unsupported");
    }
  }, l.prototype._decodeObjid = function(h, w, M) {
    for (var S, E = [], A = 0; !h.isEmpty(); ) {
      var B = h.readUInt8();
      A <<= 7, A |= B & 127, B & 128 || (E.push(A), A = 0);
    }
    B & 128 && E.push(A);
    var k = E[0] / 40 | 0, C = E[0] % 40;
    if (M ? S = E : S = [k, C].concat(E.slice(1)), w) {
      var I = w[S.join(" ")];
      I === void 0 && (I = w[S.join(".")]), I !== void 0 && (S = I);
    }
    return S;
  }, l.prototype._decodeTime = function(h, w) {
    var M = h.raw().toString();
    if (w === "gentime")
      var S = M.slice(0, 4) | 0, E = M.slice(4, 6) | 0, A = M.slice(6, 8) | 0, B = M.slice(8, 10) | 0, k = M.slice(10, 12) | 0, C = M.slice(12, 14) | 0;
    else if (w === "utctime") {
      var S = M.slice(0, 2) | 0, E = M.slice(2, 4) | 0, A = M.slice(4, 6) | 0, B = M.slice(6, 8) | 0, k = M.slice(8, 10) | 0, C = M.slice(10, 12) | 0;
      S < 70 ? S = 2e3 + S : S = 1900 + S;
    } else
      return h.error("Decoding " + w + " time is not supported yet");
    return Date.UTC(S, E - 1, A, B, k, C, 0);
  }, l.prototype._decodeNull = function(h) {
    return null;
  }, l.prototype._decodeBool = function(h) {
    var w = h.readUInt8();
    return h.isError(w) ? w : w !== 0;
  }, l.prototype._decodeInt = function(h, w) {
    var M = h.raw(), S = new i(M);
    return w && (S = w[S.toString(10)] || S), S;
  }, l.prototype._use = function(h, w) {
    return typeof h == "function" && (h = h(w)), h._getDecoder("der").tree;
  };
  function d(m, h) {
    var w = m.readUInt8(h);
    if (m.isError(w))
      return w;
    var M = f.tagClass[w >> 6], S = (w & 32) === 0;
    if ((w & 31) === 31) {
      var E = w;
      for (w = 0; (E & 128) === 128; ) {
        if (E = m.readUInt8(h), m.isError(E))
          return E;
        w <<= 7, w |= E & 127;
      }
    } else
      w &= 31;
    var A = f.tag[w];
    return {
      cls: M,
      primitive: S,
      tag: w,
      tagStr: A
    };
  }
  function v(m, h, w) {
    var M = m.readUInt8(w);
    if (m.isError(M))
      return M;
    if (!h && M === 128)
      return null;
    if (!(M & 128))
      return M;
    var S = M & 127;
    if (S > 4)
      return m.error("length octect is too long");
    M = 0;
    for (var E = 0; E < S; E++) {
      M <<= 8;
      var A = m.readUInt8(w);
      if (m.isError(A))
        return A;
      M |= A;
    }
    return M;
  }
  return pp;
}
var vp, M3;
function uR() {
  if (M3)
    return vp;
  M3 = 1;
  var t = Lt(), e = kr.Buffer, r = d_();
  function i(f) {
    r.call(this, f), this.enc = "pem";
  }
  return t(i, r), vp = i, i.prototype.decode = function(a, l) {
    for (var d = a.toString().split(/[\r\n]+/g), v = l.label.toUpperCase(), m = /^-----(BEGIN|END) ([^-]+)-----$/, h = -1, w = -1, M = 0; M < d.length; M++) {
      var S = d[M].match(m);
      if (S !== null && S[2] === v)
        if (h === -1) {
          if (S[1] !== "BEGIN")
            break;
          h = M;
        } else {
          if (S[1] !== "END")
            break;
          w = M;
          break;
        }
    }
    if (h === -1 || w === -1)
      throw new Error("PEM section not found for: " + v);
    var E = d.slice(h + 1, w).join("");
    E.replace(/[^a-z0-9\+\/=]+/gi, "");
    var A = new e(E, "base64");
    return r.prototype.decode.call(this, A, l);
  }, vp;
}
var S3;
function lR() {
  return S3 || (S3 = 1, function(t) {
    var e = t;
    e.der = d_(), e.pem = uR();
  }(hp)), hp;
}
var mp = {}, gp, E3;
function h_() {
  if (E3)
    return gp;
  E3 = 1;
  var t = Lt(), e = kr.Buffer, r = Yf(), i = r.base, f = r.constants.der;
  function a(m) {
    this.enc = "der", this.name = m.name, this.entity = m, this.tree = new l(), this.tree._init(m.body);
  }
  gp = a, a.prototype.encode = function(h, w) {
    return this.tree._encode(h, w).join();
  };
  function l(m) {
    i.Node.call(this, "der", m);
  }
  t(l, i.Node), l.prototype._encodeComposite = function(h, w, M, S) {
    var E = v(h, w, M, this.reporter);
    if (S.length < 128) {
      var k = new e(2);
      return k[0] = E, k[1] = S.length, this._createEncoderBuffer([k, S]);
    }
    for (var A = 1, B = S.length; B >= 256; B >>= 8)
      A++;
    var k = new e(2 + A);
    k[0] = E, k[1] = 128 | A;
    for (var B = 1 + A, C = S.length; C > 0; B--, C >>= 8)
      k[B] = C & 255;
    return this._createEncoderBuffer([k, S]);
  }, l.prototype._encodeStr = function(h, w) {
    if (w === "bitstr")
      return this._createEncoderBuffer([h.unused | 0, h.data]);
    if (w === "bmpstr") {
      for (var M = new e(h.length * 2), S = 0; S < h.length; S++)
        M.writeUInt16BE(h.charCodeAt(S), S * 2);
      return this._createEncoderBuffer(M);
    } else
      return w === "numstr" ? this._isNumstr(h) ? this._createEncoderBuffer(h) : this.reporter.error("Encoding of string type: numstr supports only digits and space") : w === "printstr" ? this._isPrintstr(h) ? this._createEncoderBuffer(h) : this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark") : /str$/.test(w) ? this._createEncoderBuffer(h) : w === "objDesc" ? this._createEncoderBuffer(h) : this.reporter.error("Encoding of string type: " + w + " unsupported");
  }, l.prototype._encodeObjid = function(h, w, M) {
    if (typeof h == "string") {
      if (!w)
        return this.reporter.error("string objid given, but no values map found");
      if (!w.hasOwnProperty(h))
        return this.reporter.error("objid not found in values map");
      h = w[h].split(/[\s\.]+/g);
      for (var S = 0; S < h.length; S++)
        h[S] |= 0;
    } else if (Array.isArray(h)) {
      h = h.slice();
      for (var S = 0; S < h.length; S++)
        h[S] |= 0;
    }
    if (!Array.isArray(h))
      return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(h));
    if (!M) {
      if (h[1] >= 40)
        return this.reporter.error("Second objid identifier OOB");
      h.splice(0, 2, h[0] * 40 + h[1]);
    }
    for (var E = 0, S = 0; S < h.length; S++) {
      var A = h[S];
      for (E++; A >= 128; A >>= 7)
        E++;
    }
    for (var B = new e(E), k = B.length - 1, S = h.length - 1; S >= 0; S--) {
      var A = h[S];
      for (B[k--] = A & 127; (A >>= 7) > 0; )
        B[k--] = 128 | A & 127;
    }
    return this._createEncoderBuffer(B);
  };
  function d(m) {
    return m < 10 ? "0" + m : m;
  }
  l.prototype._encodeTime = function(h, w) {
    var M, S = new Date(h);
    return w === "gentime" ? M = [
      d(S.getFullYear()),
      d(S.getUTCMonth() + 1),
      d(S.getUTCDate()),
      d(S.getUTCHours()),
      d(S.getUTCMinutes()),
      d(S.getUTCSeconds()),
      "Z"
    ].join("") : w === "utctime" ? M = [
      d(S.getFullYear() % 100),
      d(S.getUTCMonth() + 1),
      d(S.getUTCDate()),
      d(S.getUTCHours()),
      d(S.getUTCMinutes()),
      d(S.getUTCSeconds()),
      "Z"
    ].join("") : this.reporter.error("Encoding " + w + " time is not supported yet"), this._encodeStr(M, "octstr");
  }, l.prototype._encodeNull = function() {
    return this._createEncoderBuffer("");
  }, l.prototype._encodeInt = function(h, w) {
    if (typeof h == "string") {
      if (!w)
        return this.reporter.error("String int or enum given, but no values map");
      if (!w.hasOwnProperty(h))
        return this.reporter.error("Values map doesn't contain: " + JSON.stringify(h));
      h = w[h];
    }
    if (typeof h != "number" && !e.isBuffer(h)) {
      var M = h.toArray();
      !h.sign && M[0] & 128 && M.unshift(0), h = new e(M);
    }
    if (e.isBuffer(h)) {
      var S = h.length;
      h.length === 0 && S++;
      var A = new e(S);
      return h.copy(A), h.length === 0 && (A[0] = 0), this._createEncoderBuffer(A);
    }
    if (h < 128)
      return this._createEncoderBuffer(h);
    if (h < 256)
      return this._createEncoderBuffer([0, h]);
    for (var S = 1, E = h; E >= 256; E >>= 8)
      S++;
    for (var A = new Array(S), E = A.length - 1; E >= 0; E--)
      A[E] = h & 255, h >>= 8;
    return A[0] & 128 && A.unshift(0), this._createEncoderBuffer(new e(A));
  }, l.prototype._encodeBool = function(h) {
    return this._createEncoderBuffer(h ? 255 : 0);
  }, l.prototype._use = function(h, w) {
    return typeof h == "function" && (h = h(w)), h._getEncoder("der").tree;
  }, l.prototype._skipDefault = function(h, w, M) {
    var S = this._baseState, E;
    if (S.default === null)
      return !1;
    var A = h.join();
    if (S.defaultBuffer === void 0 && (S.defaultBuffer = this._encodeValue(S.default, w, M).join()), A.length !== S.defaultBuffer.length)
      return !1;
    for (E = 0; E < A.length; E++)
      if (A[E] !== S.defaultBuffer[E])
        return !1;
    return !0;
  };
  function v(m, h, w, M) {
    var S;
    if (m === "seqof" ? m = "seq" : m === "setof" && (m = "set"), f.tagByName.hasOwnProperty(m))
      S = f.tagByName[m];
    else if (typeof m == "number" && (m | 0) === m)
      S = m;
    else
      return M.error("Unknown tag: " + m);
    return S >= 31 ? M.error("Multi-octet tag encoding unsupported") : (h || (S |= 32), S |= f.tagClassByName[w || "universal"] << 6, S);
  }
  return gp;
}
var yp, A3;
function cR() {
  if (A3)
    return yp;
  A3 = 1;
  var t = Lt(), e = h_();
  function r(i) {
    e.call(this, i), this.enc = "pem";
  }
  return t(r, e), yp = r, r.prototype.encode = function(f, a) {
    for (var l = e.prototype.encode.call(this, f), d = l.toString("base64"), v = ["-----BEGIN " + a.label + "-----"], m = 0; m < d.length; m += 64)
      v.push(d.slice(m, m + 64));
    return v.push("-----END " + a.label + "-----"), v.join(`
`);
  }, yp;
}
var k3;
function dR() {
  return k3 || (k3 = 1, function(t) {
    var e = t;
    e.der = h_(), e.pem = cR();
  }(mp)), mp;
}
var T3;
function Yf() {
  return T3 || (T3 = 1, function(t) {
    var e = t;
    e.bignum = tR(), e.define = aR().define, e.base = xf(), e.constants = c_(), e.decoders = lR(), e.encoders = dR();
  }(sp)), sp;
}
var bp, C3;
function hR() {
  if (C3)
    return bp;
  C3 = 1;
  var t = Yf(), e = t.define("Time", function() {
    this.choice({
      utcTime: this.utctime(),
      generalTime: this.gentime()
    });
  }), r = t.define("AttributeTypeValue", function() {
    this.seq().obj(
      this.key("type").objid(),
      this.key("value").any()
    );
  }), i = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("parameters").optional(),
      this.key("curve").objid().optional()
    );
  }), f = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  }), a = t.define("RelativeDistinguishedName", function() {
    this.setof(r);
  }), l = t.define("RDNSequence", function() {
    this.seqof(a);
  }), d = t.define("Name", function() {
    this.choice({
      rdnSequence: this.use(l)
    });
  }), v = t.define("Validity", function() {
    this.seq().obj(
      this.key("notBefore").use(e),
      this.key("notAfter").use(e)
    );
  }), m = t.define("Extension", function() {
    this.seq().obj(
      this.key("extnID").objid(),
      this.key("critical").bool().def(!1),
      this.key("extnValue").octstr()
    );
  }), h = t.define("TBSCertificate", function() {
    this.seq().obj(
      this.key("version").explicit(0).int().optional(),
      this.key("serialNumber").int(),
      this.key("signature").use(i),
      this.key("issuer").use(d),
      this.key("validity").use(v),
      this.key("subject").use(d),
      this.key("subjectPublicKeyInfo").use(f),
      this.key("issuerUniqueID").implicit(1).bitstr().optional(),
      this.key("subjectUniqueID").implicit(2).bitstr().optional(),
      this.key("extensions").explicit(3).seqof(m).optional()
    );
  }), w = t.define("X509Certificate", function() {
    this.seq().obj(
      this.key("tbsCertificate").use(h),
      this.key("signatureAlgorithm").use(i),
      this.key("signatureValue").bitstr()
    );
  });
  return bp = w, bp;
}
var B3;
function pR() {
  if (B3)
    return bn;
  B3 = 1;
  var t = Yf();
  bn.certificate = hR();
  var e = t.define("RSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("modulus").int(),
      this.key("publicExponent").int(),
      this.key("privateExponent").int(),
      this.key("prime1").int(),
      this.key("prime2").int(),
      this.key("exponent1").int(),
      this.key("exponent2").int(),
      this.key("coefficient").int()
    );
  });
  bn.RSAPrivateKey = e;
  var r = t.define("RSAPublicKey", function() {
    this.seq().obj(
      this.key("modulus").int(),
      this.key("publicExponent").int()
    );
  });
  bn.RSAPublicKey = r;
  var i = t.define("AlgorithmIdentifier", function() {
    this.seq().obj(
      this.key("algorithm").objid(),
      this.key("none").null_().optional(),
      this.key("curve").objid().optional(),
      this.key("params").seq().obj(
        this.key("p").int(),
        this.key("q").int(),
        this.key("g").int()
      ).optional()
    );
  }), f = t.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").use(i),
      this.key("subjectPublicKey").bitstr()
    );
  });
  bn.PublicKey = f;
  var a = t.define("PrivateKeyInfo", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("algorithm").use(i),
      this.key("subjectPrivateKey").octstr()
    );
  });
  bn.PrivateKey = a;
  var l = t.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(
      this.key("algorithm").seq().obj(
        this.key("id").objid(),
        this.key("decrypt").seq().obj(
          this.key("kde").seq().obj(
            this.key("id").objid(),
            this.key("kdeparams").seq().obj(
              this.key("salt").octstr(),
              this.key("iters").int()
            )
          ),
          this.key("cipher").seq().obj(
            this.key("algo").objid(),
            this.key("iv").octstr()
          )
        )
      ),
      this.key("subjectPrivateKey").octstr()
    );
  });
  bn.EncryptedPrivateKey = l;
  var d = t.define("DSAPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("p").int(),
      this.key("q").int(),
      this.key("g").int(),
      this.key("pub_key").int(),
      this.key("priv_key").int()
    );
  });
  bn.DSAPrivateKey = d, bn.DSAparam = t.define("DSAparam", function() {
    this.int();
  });
  var v = t.define("ECParameters", function() {
    this.choice({
      namedCurve: this.objid()
    });
  }), m = t.define("ECPrivateKey", function() {
    this.seq().obj(
      this.key("version").int(),
      this.key("privateKey").octstr(),
      this.key("parameters").optional().explicit(0).use(v),
      this.key("publicKey").optional().explicit(1).bitstr()
    );
  });
  return bn.ECPrivateKey = m, bn.signature = t.define("signature", function() {
    this.seq().obj(
      this.key("r").int(),
      this.key("s").int()
    );
  }), bn;
}
const vR = {
  "2.16.840.1.101.3.4.1.1": "aes-128-ecb",
  "2.16.840.1.101.3.4.1.2": "aes-128-cbc",
  "2.16.840.1.101.3.4.1.3": "aes-128-ofb",
  "2.16.840.1.101.3.4.1.4": "aes-128-cfb",
  "2.16.840.1.101.3.4.1.21": "aes-192-ecb",
  "2.16.840.1.101.3.4.1.22": "aes-192-cbc",
  "2.16.840.1.101.3.4.1.23": "aes-192-ofb",
  "2.16.840.1.101.3.4.1.24": "aes-192-cfb",
  "2.16.840.1.101.3.4.1.41": "aes-256-ecb",
  "2.16.840.1.101.3.4.1.42": "aes-256-cbc",
  "2.16.840.1.101.3.4.1.43": "aes-256-ofb",
  "2.16.840.1.101.3.4.1.44": "aes-256-cfb"
};
var wp, I3;
function mR() {
  if (I3)
    return wp;
  I3 = 1;
  var t = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m, e = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m, r = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m, i = bc(), f = Sm(), a = Vt().Buffer;
  return wp = function(l, d) {
    var v = l.toString(), m = v.match(t), h;
    if (m) {
      var M = "aes" + m[1], S = a.from(m[2], "hex"), E = a.from(m[3].replace(/[\r\n]/g, ""), "base64"), A = i(d, S.slice(0, 8), parseInt(m[1], 10)).key, B = [], k = f.createDecipheriv(M, A, S);
      B.push(k.update(E)), B.push(k.final()), h = a.concat(B);
    } else {
      var w = v.match(r);
      h = a.from(w[2].replace(/[\r\n]/g, ""), "base64");
    }
    var C = v.match(e)[1];
    return {
      tag: C,
      data: h
    };
  }, wp;
}
var _p, R3;
function xc() {
  if (R3)
    return _p;
  R3 = 1;
  var t = pR(), e = vR, r = mR(), i = Sm(), f = V8(), a = Vt().Buffer;
  function l(v, m) {
    var h = v.algorithm.decrypt.kde.kdeparams.salt, w = parseInt(v.algorithm.decrypt.kde.kdeparams.iters.toString(), 10), M = e[v.algorithm.decrypt.cipher.algo.join(".")], S = v.algorithm.decrypt.cipher.iv, E = v.subjectPrivateKey, A = parseInt(M.split("-")[1], 10) / 8, B = f.pbkdf2Sync(m, h, w, A, "sha1"), k = i.createDecipheriv(M, B, S), C = [];
    return C.push(k.update(E)), C.push(k.final()), a.concat(C);
  }
  function d(v) {
    var m;
    typeof v == "object" && !a.isBuffer(v) && (m = v.passphrase, v = v.key), typeof v == "string" && (v = a.from(v));
    var h = r(v, m), w = h.tag, M = h.data, S, E;
    switch (w) {
      case "CERTIFICATE":
        E = t.certificate.decode(M, "der").tbsCertificate.subjectPublicKeyInfo;
      case "PUBLIC KEY":
        switch (E || (E = t.PublicKey.decode(M, "der")), S = E.algorithm.algorithm.join("."), S) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPublicKey.decode(E.subjectPublicKey.data, "der");
          case "1.2.840.10045.2.1":
            return E.subjectPrivateKey = E.subjectPublicKey, {
              type: "ec",
              data: E
            };
          case "1.2.840.10040.4.1":
            return E.algorithm.params.pub_key = t.DSAparam.decode(E.subjectPublicKey.data, "der"), {
              type: "dsa",
              data: E.algorithm.params
            };
          default:
            throw new Error("unknown key id " + S);
        }
      case "ENCRYPTED PRIVATE KEY":
        M = t.EncryptedPrivateKey.decode(M, "der"), M = l(M, m);
      case "PRIVATE KEY":
        switch (E = t.PrivateKey.decode(M, "der"), S = E.algorithm.algorithm.join("."), S) {
          case "1.2.840.113549.1.1.1":
            return t.RSAPrivateKey.decode(E.subjectPrivateKey, "der");
          case "1.2.840.10045.2.1":
            return {
              curve: E.algorithm.curve,
              privateKey: t.ECPrivateKey.decode(E.subjectPrivateKey, "der").privateKey
            };
          case "1.2.840.10040.4.1":
            return E.algorithm.params.priv_key = t.DSAparam.decode(E.subjectPrivateKey, "der"), {
              type: "dsa",
              params: E.algorithm.params
            };
          default:
            throw new Error("unknown key id " + S);
        }
      case "RSA PUBLIC KEY":
        return t.RSAPublicKey.decode(M, "der");
      case "RSA PRIVATE KEY":
        return t.RSAPrivateKey.decode(M, "der");
      case "DSA PRIVATE KEY":
        return {
          type: "dsa",
          params: t.DSAPrivateKey.decode(M, "der")
        };
      case "EC PRIVATE KEY":
        return M = t.ECPrivateKey.decode(M, "der"), {
          curve: M.parameters.value,
          privateKey: M.privateKey
        };
      default:
        throw new Error("unknown key type " + w);
    }
  }
  return d.signature = t.signature, _p = d, _p;
}
const p_ = {
  "1.3.132.0.10": "secp256k1",
  "1.3.132.0.33": "p224",
  "1.2.840.10045.3.1.1": "p192",
  "1.2.840.10045.3.1.7": "p256",
  "1.3.132.0.34": "p384",
  "1.3.132.0.35": "p521"
};
var P3;
function gR() {
  if (P3)
    return Fo.exports;
  P3 = 1;
  var t = Vt().Buffer, e = L8(), r = km(), i = l_().ec, f = Am(), a = xc(), l = p_, d = 1;
  function v(k, C, I, O, q) {
    var $ = a(C);
    if ($.curve) {
      if (O !== "ecdsa" && O !== "ecdsa/rsa")
        throw new Error("wrong private key type");
      return m(k, $);
    } else if ($.type === "dsa") {
      if (O !== "dsa")
        throw new Error("wrong private key type");
      return h(k, $, I);
    }
    if (O !== "rsa" && O !== "ecdsa/rsa")
      throw new Error("wrong private key type");
    if (C.padding !== void 0 && C.padding !== d)
      throw new Error("illegal or unsupported padding mode");
    k = t.concat([q, k]);
    for (var ae = $.modulus.byteLength(), he = [0, 1]; k.length + he.length + 1 < ae; )
      he.push(255);
    he.push(0);
    for (var te = -1; ++te < k.length; )
      he.push(k[te]);
    var Ee = r(he, $);
    return Ee;
  }
  function m(k, C) {
    var I = l[C.curve.join(".")];
    if (!I)
      throw new Error("unknown curve " + C.curve.join("."));
    var O = new i(I), q = O.keyFromPrivate(C.privateKey), $ = q.sign(k);
    return t.from($.toDER());
  }
  function h(k, C, I) {
    for (var O = C.params.priv_key, q = C.params.p, $ = C.params.q, ae = C.params.g, he = new f(0), te, Ee = S(k, $).mod($), x = !1, n = M(O, $, k, I); x === !1; )
      te = A($, n, I), he = B(ae, te, q, $), x = te.invm($).imul(Ee.add(O.mul(he))).mod($), x.cmpn(0) === 0 && (x = !1, he = new f(0));
    return w(he, x);
  }
  function w(k, C) {
    k = k.toArray(), C = C.toArray(), k[0] & 128 && (k = [0].concat(k)), C[0] & 128 && (C = [0].concat(C));
    var I = k.length + C.length + 4, O = [
      48,
      I,
      2,
      k.length
    ];
    return O = O.concat(k, [2, C.length], C), t.from(O);
  }
  function M(k, C, I, O) {
    if (k = t.from(k.toArray()), k.length < C.byteLength()) {
      var q = t.alloc(C.byteLength() - k.length);
      k = t.concat([q, k]);
    }
    var $ = I.length, ae = E(I, C), he = t.alloc($);
    he.fill(1);
    var te = t.alloc($);
    return te = e(O, te).update(he).update(t.from([0])).update(k).update(ae).digest(), he = e(O, te).update(he).digest(), te = e(O, te).update(he).update(t.from([1])).update(k).update(ae).digest(), he = e(O, te).update(he).digest(), { k: te, v: he };
  }
  function S(k, C) {
    var I = new f(k), O = (k.length << 3) - C.bitLength();
    return O > 0 && I.ishrn(O), I;
  }
  function E(k, C) {
    k = S(k, C), k = k.mod(C);
    var I = t.from(k.toArray());
    if (I.length < C.byteLength()) {
      var O = t.alloc(C.byteLength() - I.length);
      I = t.concat([O, I]);
    }
    return I;
  }
  function A(k, C, I) {
    var O, q;
    do {
      for (O = t.alloc(0); O.length * 8 < k.bitLength(); )
        C.v = e(I, C.k).update(C.v).digest(), O = t.concat([O, C.v]);
      q = S(O, k), C.k = e(I, C.k).update(C.v).update(t.from([0])).digest(), C.v = e(I, C.k).update(C.v).digest();
    } while (q.cmp(k) !== -1);
    return q;
  }
  function B(k, C, I, O) {
    return k.toRed(f.mont(I)).redPow(C).fromRed().mod(O);
  }
  return Fo.exports = v, Fo.exports.getKey = M, Fo.exports.makeKey = A, Fo.exports;
}
var xp, O3;
function yR() {
  if (O3)
    return xp;
  O3 = 1;
  var t = Vt().Buffer, e = Am(), r = l_().ec, i = xc(), f = p_;
  function a(m, h, w, M, S) {
    var E = i(w);
    if (E.type === "ec") {
      if (M !== "ecdsa" && M !== "ecdsa/rsa")
        throw new Error("wrong public key type");
      return l(m, h, E);
    } else if (E.type === "dsa") {
      if (M !== "dsa")
        throw new Error("wrong public key type");
      return d(m, h, E);
    }
    if (M !== "rsa" && M !== "ecdsa/rsa")
      throw new Error("wrong public key type");
    h = t.concat([S, h]);
    for (var A = E.modulus.byteLength(), B = [1], k = 0; h.length + B.length + 2 < A; )
      B.push(255), k += 1;
    B.push(0);
    for (var C = -1; ++C < h.length; )
      B.push(h[C]);
    B = t.from(B);
    var I = e.mont(E.modulus);
    m = new e(m).toRed(I), m = m.redPow(new e(E.publicExponent)), m = t.from(m.fromRed().toArray());
    var O = k < 8 ? 1 : 0;
    for (A = Math.min(m.length, B.length), m.length !== B.length && (O = 1), C = -1; ++C < A; )
      O |= m[C] ^ B[C];
    return O === 0;
  }
  function l(m, h, w) {
    var M = f[w.data.algorithm.curve.join(".")];
    if (!M)
      throw new Error("unknown curve " + w.data.algorithm.curve.join("."));
    var S = new r(M), E = w.data.subjectPrivateKey.data;
    return S.verify(h, m, E);
  }
  function d(m, h, w) {
    var M = w.data.p, S = w.data.q, E = w.data.g, A = w.data.pub_key, B = i.signature.decode(m, "der"), k = B.s, C = B.r;
    v(k, S), v(C, S);
    var I = e.mont(M), O = k.invm(S), q = E.toRed(I).redPow(new e(h).mul(O).mod(S)).fromRed().mul(A.toRed(I).redPow(C.mul(O).mod(S)).fromRed()).mod(M).mod(S);
    return q.cmp(C) === 0;
  }
  function v(m, h) {
    if (m.cmpn(0) <= 0)
      throw new Error("invalid sig");
    if (m.cmp(h) >= 0)
      throw new Error("invalid sig");
  }
  return xp = a, xp;
}
var Mp, N3;
function bR() {
  if (N3)
    return Mp;
  N3 = 1;
  var t = Vt().Buffer, e = Hf(), r = MI(), i = Lt(), f = gR(), a = yR(), l = F8;
  Object.keys(l).forEach(function(w) {
    l[w].id = t.from(l[w].id, "hex"), l[w.toLowerCase()] = l[w];
  });
  function d(w) {
    r.Writable.call(this);
    var M = l[w];
    if (!M)
      throw new Error("Unknown message digest");
    this._hashType = M.hash, this._hash = e(M.hash), this._tag = M.id, this._signType = M.sign;
  }
  i(d, r.Writable), d.prototype._write = function(M, S, E) {
    this._hash.update(M), E();
  }, d.prototype.update = function(M, S) {
    return this._hash.update(typeof M == "string" ? t.from(M, S) : M), this;
  }, d.prototype.sign = function(M, S) {
    this.end();
    var E = this._hash.digest(), A = f(E, M, this._hashType, this._signType, this._tag);
    return S ? A.toString(S) : A;
  };
  function v(w) {
    r.Writable.call(this);
    var M = l[w];
    if (!M)
      throw new Error("Unknown message digest");
    this._hash = e(M.hash), this._tag = M.id, this._signType = M.sign;
  }
  i(v, r.Writable), v.prototype._write = function(M, S, E) {
    this._hash.update(M), E();
  }, v.prototype.update = function(M, S) {
    return this._hash.update(typeof M == "string" ? t.from(M, S) : M), this;
  }, v.prototype.verify = function(M, S, E) {
    var A = typeof S == "string" ? t.from(S, E) : S;
    this.end();
    var B = this._hash.digest();
    return a(A, B, M, this._signType, this._tag);
  };
  function m(w) {
    return new d(w);
  }
  function h(w) {
    return new v(w);
  }
  return Mp = {
    Sign: m,
    Verify: h,
    createSign: m,
    createVerify: h
  }, Mp;
}
var Sp = {};
const wR = "elliptic", _R = "6.5.4", xR = "EC cryptography", MR = "lib/elliptic.js", SR = [
  "lib"
], ER = {
  lint: "eslint lib test",
  "lint:fix": "npm run lint -- --fix",
  unit: "istanbul test _mocha --reporter=spec test/index.js",
  test: "npm run lint && npm run unit",
  version: "grunt dist && git add dist/"
}, AR = {
  type: "git",
  url: "git@github.com:indutny/elliptic"
}, kR = [
  "EC",
  "Elliptic",
  "curve",
  "Cryptography"
], TR = "Fedor Indutny <fedor@indutny.com>", CR = "MIT", BR = {
  url: "https://github.com/indutny/elliptic/issues"
}, IR = "https://github.com/indutny/elliptic", RR = {
  brfs: "^2.0.2",
  coveralls: "^3.1.0",
  eslint: "^7.6.0",
  grunt: "^1.2.1",
  "grunt-browserify": "^5.3.0",
  "grunt-cli": "^1.3.2",
  "grunt-contrib-connect": "^3.0.0",
  "grunt-contrib-copy": "^1.0.0",
  "grunt-contrib-uglify": "^5.0.0",
  "grunt-mocha-istanbul": "^5.0.2",
  "grunt-saucelabs": "^9.0.1",
  istanbul: "^0.4.5",
  mocha: "^8.0.1"
}, PR = {
  "bn.js": "^4.11.9",
  brorand: "^1.1.0",
  "hash.js": "^1.0.0",
  "hmac-drbg": "^1.0.1",
  inherits: "^2.0.4",
  "minimalistic-assert": "^1.0.1",
  "minimalistic-crypto-utils": "^1.0.1"
}, OR = {
  name: wR,
  version: _R,
  description: xR,
  main: MR,
  files: SR,
  scripts: ER,
  repository: AR,
  keywords: kR,
  author: TR,
  license: CR,
  bugs: BR,
  homepage: IR,
  devDependencies: RR,
  dependencies: PR
};
var Ep = {}, Ju = { exports: {} };
Ju.exports;
var D3;
function Ci() {
  return D3 || (D3 = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(Ju)), Ju.exports;
}
var U3;
function kn() {
  return U3 || (U3 = 1, function(t) {
    var e = t, r = Ci(), i = mn(), f = Tm();
    e.assert = i, e.toArray = f.toArray, e.zero2 = f.zero2, e.toHex = f.toHex, e.encode = f.encode;
    function a(h, w, M) {
      var S = new Array(Math.max(h.bitLength(), M) + 1);
      S.fill(0);
      for (var E = 1 << w + 1, A = h.clone(), B = 0; B < S.length; B++) {
        var k, C = A.andln(E - 1);
        A.isOdd() ? (C > (E >> 1) - 1 ? k = (E >> 1) - C : k = C, A.isubn(k)) : k = 0, S[B] = k, A.iushrn(1);
      }
      return S;
    }
    e.getNAF = a;
    function l(h, w) {
      var M = [
        [],
        []
      ];
      h = h.clone(), w = w.clone();
      for (var S = 0, E = 0, A; h.cmpn(-S) > 0 || w.cmpn(-E) > 0; ) {
        var B = h.andln(3) + S & 3, k = w.andln(3) + E & 3;
        B === 3 && (B = -1), k === 3 && (k = -1);
        var C;
        B & 1 ? (A = h.andln(7) + S & 7, (A === 3 || A === 5) && k === 2 ? C = -B : C = B) : C = 0, M[0].push(C);
        var I;
        k & 1 ? (A = w.andln(7) + E & 7, (A === 3 || A === 5) && B === 2 ? I = -k : I = k) : I = 0, M[1].push(I), 2 * S === C + 1 && (S = 1 - S), 2 * E === I + 1 && (E = 1 - E), h.iushrn(1), w.iushrn(1);
      }
      return M;
    }
    e.getJSF = l;
    function d(h, w, M) {
      var S = "_" + w;
      h.prototype[w] = function() {
        return this[S] !== void 0 ? this[S] : this[S] = M.call(this);
      };
    }
    e.cachedProperty = d;
    function v(h) {
      return typeof h == "string" ? e.toArray(h, "hex") : h;
    }
    e.parseBytes = v;
    function m(h) {
      return new r(h, "hex", "le");
    }
    e.intFromLE = m;
  }(Ep)), Ep;
}
var Ap = {}, kp, L3;
function Mc() {
  if (L3)
    return kp;
  L3 = 1;
  var t = Ci(), e = kn(), r = e.getNAF, i = e.getJSF, f = e.assert;
  function a(d, v) {
    this.type = d, this.p = new t(v.p, 16), this.red = v.prime ? t.red(v.prime) : t.mont(this.p), this.zero = new t(0).toRed(this.red), this.one = new t(1).toRed(this.red), this.two = new t(2).toRed(this.red), this.n = v.n && new t(v.n, 16), this.g = v.g && this.pointFromJSON(v.g, v.gRed), this._wnafT1 = new Array(4), this._wnafT2 = new Array(4), this._wnafT3 = new Array(4), this._wnafT4 = new Array(4), this._bitLength = this.n ? this.n.bitLength() : 0;
    var m = this.n && this.p.div(this.n);
    !m || m.cmpn(100) > 0 ? this.redN = null : (this._maxwellTrick = !0, this.redN = this.n.toRed(this.red));
  }
  kp = a, a.prototype.point = function() {
    throw new Error("Not implemented");
  }, a.prototype.validate = function() {
    throw new Error("Not implemented");
  }, a.prototype._fixedNafMul = function(v, m) {
    f(v.precomputed);
    var h = v._getDoubles(), w = r(m, 1, this._bitLength), M = (1 << h.step + 1) - (h.step % 2 === 0 ? 2 : 1);
    M /= 3;
    var S = [], E, A;
    for (E = 0; E < w.length; E += h.step) {
      A = 0;
      for (var B = E + h.step - 1; B >= E; B--)
        A = (A << 1) + w[B];
      S.push(A);
    }
    for (var k = this.jpoint(null, null, null), C = this.jpoint(null, null, null), I = M; I > 0; I--) {
      for (E = 0; E < S.length; E++)
        A = S[E], A === I ? C = C.mixedAdd(h.points[E]) : A === -I && (C = C.mixedAdd(h.points[E].neg()));
      k = k.add(C);
    }
    return k.toP();
  }, a.prototype._wnafMul = function(v, m) {
    var h = 4, w = v._getNAFPoints(h);
    h = w.wnd;
    for (var M = w.points, S = r(m, h, this._bitLength), E = this.jpoint(null, null, null), A = S.length - 1; A >= 0; A--) {
      for (var B = 0; A >= 0 && S[A] === 0; A--)
        B++;
      if (A >= 0 && B++, E = E.dblp(B), A < 0)
        break;
      var k = S[A];
      f(k !== 0), v.type === "affine" ? k > 0 ? E = E.mixedAdd(M[k - 1 >> 1]) : E = E.mixedAdd(M[-k - 1 >> 1].neg()) : k > 0 ? E = E.add(M[k - 1 >> 1]) : E = E.add(M[-k - 1 >> 1].neg());
    }
    return v.type === "affine" ? E.toP() : E;
  }, a.prototype._wnafMulAdd = function(v, m, h, w, M) {
    var S = this._wnafT1, E = this._wnafT2, A = this._wnafT3, B = 0, k, C, I;
    for (k = 0; k < w; k++) {
      I = m[k];
      var O = I._getNAFPoints(v);
      S[k] = O.wnd, E[k] = O.points;
    }
    for (k = w - 1; k >= 1; k -= 2) {
      var q = k - 1, $ = k;
      if (S[q] !== 1 || S[$] !== 1) {
        A[q] = r(h[q], S[q], this._bitLength), A[$] = r(h[$], S[$], this._bitLength), B = Math.max(A[q].length, B), B = Math.max(A[$].length, B);
        continue;
      }
      var ae = [
        m[q],
        /* 1 */
        null,
        /* 3 */
        null,
        /* 5 */
        m[$]
        /* 7 */
      ];
      m[q].y.cmp(m[$].y) === 0 ? (ae[1] = m[q].add(m[$]), ae[2] = m[q].toJ().mixedAdd(m[$].neg())) : m[q].y.cmp(m[$].y.redNeg()) === 0 ? (ae[1] = m[q].toJ().mixedAdd(m[$]), ae[2] = m[q].add(m[$].neg())) : (ae[1] = m[q].toJ().mixedAdd(m[$]), ae[2] = m[q].toJ().mixedAdd(m[$].neg()));
      var he = [
        -3,
        /* -1 -1 */
        -1,
        /* -1 0 */
        -5,
        /* -1 1 */
        -7,
        /* 0 -1 */
        0,
        /* 0 0 */
        7,
        /* 0 1 */
        5,
        /* 1 -1 */
        1,
        /* 1 0 */
        3
        /* 1 1 */
      ], te = i(h[q], h[$]);
      for (B = Math.max(te[0].length, B), A[q] = new Array(B), A[$] = new Array(B), C = 0; C < B; C++) {
        var Ee = te[0][C] | 0, x = te[1][C] | 0;
        A[q][C] = he[(Ee + 1) * 3 + (x + 1)], A[$][C] = 0, E[q] = ae;
      }
    }
    var n = this.jpoint(null, null, null), o = this._wnafT4;
    for (k = B; k >= 0; k--) {
      for (var u = 0; k >= 0; ) {
        var c = !0;
        for (C = 0; C < w; C++)
          o[C] = A[C][k] | 0, o[C] !== 0 && (c = !1);
        if (!c)
          break;
        u++, k--;
      }
      if (k >= 0 && u++, n = n.dblp(u), k < 0)
        break;
      for (C = 0; C < w; C++) {
        var g = o[C];
        g !== 0 && (g > 0 ? I = E[C][g - 1 >> 1] : g < 0 && (I = E[C][-g - 1 >> 1].neg()), I.type === "affine" ? n = n.mixedAdd(I) : n = n.add(I));
      }
    }
    for (k = 0; k < w; k++)
      E[k] = null;
    return M ? n : n.toP();
  };
  function l(d, v) {
    this.curve = d, this.type = v, this.precomputed = null;
  }
  return a.BasePoint = l, l.prototype.eq = function() {
    throw new Error("Not implemented");
  }, l.prototype.validate = function() {
    return this.curve.validate(this);
  }, a.prototype.decodePoint = function(v, m) {
    v = e.toArray(v, m);
    var h = this.p.byteLength();
    if ((v[0] === 4 || v[0] === 6 || v[0] === 7) && v.length - 1 === 2 * h) {
      v[0] === 6 ? f(v[v.length - 1] % 2 === 0) : v[0] === 7 && f(v[v.length - 1] % 2 === 1);
      var w = this.point(
        v.slice(1, 1 + h),
        v.slice(1 + h, 1 + 2 * h)
      );
      return w;
    } else if ((v[0] === 2 || v[0] === 3) && v.length - 1 === h)
      return this.pointFromX(v.slice(1, 1 + h), v[0] === 3);
    throw new Error("Unknown point format");
  }, l.prototype.encodeCompressed = function(v) {
    return this.encode(v, !0);
  }, l.prototype._encode = function(v) {
    var m = this.curve.p.byteLength(), h = this.getX().toArray("be", m);
    return v ? [this.getY().isEven() ? 2 : 3].concat(h) : [4].concat(h, this.getY().toArray("be", m));
  }, l.prototype.encode = function(v, m) {
    return e.encode(this._encode(m), v);
  }, l.prototype.precompute = function(v) {
    if (this.precomputed)
      return this;
    var m = {
      doubles: null,
      naf: null,
      beta: null
    };
    return m.naf = this._getNAFPoints(8), m.doubles = this._getDoubles(4, v), m.beta = this._getBeta(), this.precomputed = m, this;
  }, l.prototype._hasDoubles = function(v) {
    if (!this.precomputed)
      return !1;
    var m = this.precomputed.doubles;
    return m ? m.points.length >= Math.ceil((v.bitLength() + 1) / m.step) : !1;
  }, l.prototype._getDoubles = function(v, m) {
    if (this.precomputed && this.precomputed.doubles)
      return this.precomputed.doubles;
    for (var h = [this], w = this, M = 0; M < m; M += v) {
      for (var S = 0; S < v; S++)
        w = w.dbl();
      h.push(w);
    }
    return {
      step: v,
      points: h
    };
  }, l.prototype._getNAFPoints = function(v) {
    if (this.precomputed && this.precomputed.naf)
      return this.precomputed.naf;
    for (var m = [this], h = (1 << v) - 1, w = h === 1 ? null : this.dbl(), M = 1; M < h; M++)
      m[M] = m[M - 1].add(w);
    return {
      wnd: v,
      points: m
    };
  }, l.prototype._getBeta = function() {
    return null;
  }, l.prototype.dblp = function(v) {
    for (var m = this, h = 0; h < v; h++)
      m = m.dbl();
    return m;
  }, kp;
}
var Tp, F3;
function NR() {
  if (F3)
    return Tp;
  F3 = 1;
  var t = kn(), e = Ci(), r = Lt(), i = Mc(), f = t.assert;
  function a(v) {
    i.call(this, "short", v), this.a = new e(v.a, 16).toRed(this.red), this.b = new e(v.b, 16).toRed(this.red), this.tinv = this.two.redInvm(), this.zeroA = this.a.fromRed().cmpn(0) === 0, this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0, this.endo = this._getEndomorphism(v), this._endoWnafT1 = new Array(4), this._endoWnafT2 = new Array(4);
  }
  r(a, i), Tp = a, a.prototype._getEndomorphism = function(m) {
    if (!(!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1)) {
      var h, w;
      if (m.beta)
        h = new e(m.beta, 16).toRed(this.red);
      else {
        var M = this._getEndoRoots(this.p);
        h = M[0].cmp(M[1]) < 0 ? M[0] : M[1], h = h.toRed(this.red);
      }
      if (m.lambda)
        w = new e(m.lambda, 16);
      else {
        var S = this._getEndoRoots(this.n);
        this.g.mul(S[0]).x.cmp(this.g.x.redMul(h)) === 0 ? w = S[0] : (w = S[1], f(this.g.mul(w).x.cmp(this.g.x.redMul(h)) === 0));
      }
      var E;
      return m.basis ? E = m.basis.map(function(A) {
        return {
          a: new e(A.a, 16),
          b: new e(A.b, 16)
        };
      }) : E = this._getEndoBasis(w), {
        beta: h,
        lambda: w,
        basis: E
      };
    }
  }, a.prototype._getEndoRoots = function(m) {
    var h = m === this.p ? this.red : e.mont(m), w = new e(2).toRed(h).redInvm(), M = w.redNeg(), S = new e(3).toRed(h).redNeg().redSqrt().redMul(w), E = M.redAdd(S).fromRed(), A = M.redSub(S).fromRed();
    return [E, A];
  }, a.prototype._getEndoBasis = function(m) {
    for (var h = this.n.ushrn(Math.floor(this.n.bitLength() / 2)), w = m, M = this.n.clone(), S = new e(1), E = new e(0), A = new e(0), B = new e(1), k, C, I, O, q, $, ae, he = 0, te, Ee; w.cmpn(0) !== 0; ) {
      var x = M.div(w);
      te = M.sub(x.mul(w)), Ee = A.sub(x.mul(S));
      var n = B.sub(x.mul(E));
      if (!I && te.cmp(h) < 0)
        k = ae.neg(), C = S, I = te.neg(), O = Ee;
      else if (I && ++he === 2)
        break;
      ae = te, M = w, w = te, A = S, S = Ee, B = E, E = n;
    }
    q = te.neg(), $ = Ee;
    var o = I.sqr().add(O.sqr()), u = q.sqr().add($.sqr());
    return u.cmp(o) >= 0 && (q = k, $ = C), I.negative && (I = I.neg(), O = O.neg()), q.negative && (q = q.neg(), $ = $.neg()), [
      { a: I, b: O },
      { a: q, b: $ }
    ];
  }, a.prototype._endoSplit = function(m) {
    var h = this.endo.basis, w = h[0], M = h[1], S = M.b.mul(m).divRound(this.n), E = w.b.neg().mul(m).divRound(this.n), A = S.mul(w.a), B = E.mul(M.a), k = S.mul(w.b), C = E.mul(M.b), I = m.sub(A).sub(B), O = k.add(C).neg();
    return { k1: I, k2: O };
  }, a.prototype.pointFromX = function(m, h) {
    m = new e(m, 16), m.red || (m = m.toRed(this.red));
    var w = m.redSqr().redMul(m).redIAdd(m.redMul(this.a)).redIAdd(this.b), M = w.redSqrt();
    if (M.redSqr().redSub(w).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var S = M.fromRed().isOdd();
    return (h && !S || !h && S) && (M = M.redNeg()), this.point(m, M);
  }, a.prototype.validate = function(m) {
    if (m.inf)
      return !0;
    var h = m.x, w = m.y, M = this.a.redMul(h), S = h.redSqr().redMul(h).redIAdd(M).redIAdd(this.b);
    return w.redSqr().redISub(S).cmpn(0) === 0;
  }, a.prototype._endoWnafMulAdd = function(m, h, w) {
    for (var M = this._endoWnafT1, S = this._endoWnafT2, E = 0; E < m.length; E++) {
      var A = this._endoSplit(h[E]), B = m[E], k = B._getBeta();
      A.k1.negative && (A.k1.ineg(), B = B.neg(!0)), A.k2.negative && (A.k2.ineg(), k = k.neg(!0)), M[E * 2] = B, M[E * 2 + 1] = k, S[E * 2] = A.k1, S[E * 2 + 1] = A.k2;
    }
    for (var C = this._wnafMulAdd(1, M, S, E * 2, w), I = 0; I < E * 2; I++)
      M[I] = null, S[I] = null;
    return C;
  };
  function l(v, m, h, w) {
    i.BasePoint.call(this, v, "affine"), m === null && h === null ? (this.x = null, this.y = null, this.inf = !0) : (this.x = new e(m, 16), this.y = new e(h, 16), w && (this.x.forceRed(this.curve.red), this.y.forceRed(this.curve.red)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.inf = !1);
  }
  r(l, i.BasePoint), a.prototype.point = function(m, h, w) {
    return new l(this, m, h, w);
  }, a.prototype.pointFromJSON = function(m, h) {
    return l.fromJSON(this, m, h);
  }, l.prototype._getBeta = function() {
    if (this.curve.endo) {
      var m = this.precomputed;
      if (m && m.beta)
        return m.beta;
      var h = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
      if (m) {
        var w = this.curve, M = function(S) {
          return w.point(S.x.redMul(w.endo.beta), S.y);
        };
        m.beta = h, h.precomputed = {
          beta: null,
          naf: m.naf && {
            wnd: m.naf.wnd,
            points: m.naf.points.map(M)
          },
          doubles: m.doubles && {
            step: m.doubles.step,
            points: m.doubles.points.map(M)
          }
        };
      }
      return h;
    }
  }, l.prototype.toJSON = function() {
    return this.precomputed ? [this.x, this.y, this.precomputed && {
      doubles: this.precomputed.doubles && {
        step: this.precomputed.doubles.step,
        points: this.precomputed.doubles.points.slice(1)
      },
      naf: this.precomputed.naf && {
        wnd: this.precomputed.naf.wnd,
        points: this.precomputed.naf.points.slice(1)
      }
    }] : [this.x, this.y];
  }, l.fromJSON = function(m, h, w) {
    typeof h == "string" && (h = JSON.parse(h));
    var M = m.point(h[0], h[1], w);
    if (!h[2])
      return M;
    function S(A) {
      return m.point(A[0], A[1], w);
    }
    var E = h[2];
    return M.precomputed = {
      beta: null,
      doubles: E.doubles && {
        step: E.doubles.step,
        points: [M].concat(E.doubles.points.map(S))
      },
      naf: E.naf && {
        wnd: E.naf.wnd,
        points: [M].concat(E.naf.points.map(S))
      }
    }, M;
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.inf;
  }, l.prototype.add = function(m) {
    if (this.inf)
      return m;
    if (m.inf)
      return this;
    if (this.eq(m))
      return this.dbl();
    if (this.neg().eq(m))
      return this.curve.point(null, null);
    if (this.x.cmp(m.x) === 0)
      return this.curve.point(null, null);
    var h = this.y.redSub(m.y);
    h.cmpn(0) !== 0 && (h = h.redMul(this.x.redSub(m.x).redInvm()));
    var w = h.redSqr().redISub(this.x).redISub(m.x), M = h.redMul(this.x.redSub(w)).redISub(this.y);
    return this.curve.point(w, M);
  }, l.prototype.dbl = function() {
    if (this.inf)
      return this;
    var m = this.y.redAdd(this.y);
    if (m.cmpn(0) === 0)
      return this.curve.point(null, null);
    var h = this.curve.a, w = this.x.redSqr(), M = m.redInvm(), S = w.redAdd(w).redIAdd(w).redIAdd(h).redMul(M), E = S.redSqr().redISub(this.x.redAdd(this.x)), A = S.redMul(this.x.redSub(E)).redISub(this.y);
    return this.curve.point(E, A);
  }, l.prototype.getX = function() {
    return this.x.fromRed();
  }, l.prototype.getY = function() {
    return this.y.fromRed();
  }, l.prototype.mul = function(m) {
    return m = new e(m, 16), this.isInfinity() ? this : this._hasDoubles(m) ? this.curve._fixedNafMul(this, m) : this.curve.endo ? this.curve._endoWnafMulAdd([this], [m]) : this.curve._wnafMul(this, m);
  }, l.prototype.mulAdd = function(m, h, w) {
    var M = [this, h], S = [m, w];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, S) : this.curve._wnafMulAdd(1, M, S, 2);
  }, l.prototype.jmulAdd = function(m, h, w) {
    var M = [this, h], S = [m, w];
    return this.curve.endo ? this.curve._endoWnafMulAdd(M, S, !0) : this.curve._wnafMulAdd(1, M, S, 2, !0);
  }, l.prototype.eq = function(m) {
    return this === m || this.inf === m.inf && (this.inf || this.x.cmp(m.x) === 0 && this.y.cmp(m.y) === 0);
  }, l.prototype.neg = function(m) {
    if (this.inf)
      return this;
    var h = this.curve.point(this.x, this.y.redNeg());
    if (m && this.precomputed) {
      var w = this.precomputed, M = function(S) {
        return S.neg();
      };
      h.precomputed = {
        naf: w.naf && {
          wnd: w.naf.wnd,
          points: w.naf.points.map(M)
        },
        doubles: w.doubles && {
          step: w.doubles.step,
          points: w.doubles.points.map(M)
        }
      };
    }
    return h;
  }, l.prototype.toJ = function() {
    if (this.inf)
      return this.curve.jpoint(null, null, null);
    var m = this.curve.jpoint(this.x, this.y, this.curve.one);
    return m;
  };
  function d(v, m, h, w) {
    i.BasePoint.call(this, v, "jacobian"), m === null && h === null && w === null ? (this.x = this.curve.one, this.y = this.curve.one, this.z = new e(0)) : (this.x = new e(m, 16), this.y = new e(h, 16), this.z = new e(w, 16)), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.zOne = this.z === this.curve.one;
  }
  return r(d, i.BasePoint), a.prototype.jpoint = function(m, h, w) {
    return new d(this, m, h, w);
  }, d.prototype.toP = function() {
    if (this.isInfinity())
      return this.curve.point(null, null);
    var m = this.z.redInvm(), h = m.redSqr(), w = this.x.redMul(h), M = this.y.redMul(h).redMul(m);
    return this.curve.point(w, M);
  }, d.prototype.neg = function() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
  }, d.prototype.add = function(m) {
    if (this.isInfinity())
      return m;
    if (m.isInfinity())
      return this;
    var h = m.z.redSqr(), w = this.z.redSqr(), M = this.x.redMul(h), S = m.x.redMul(w), E = this.y.redMul(h.redMul(m.z)), A = m.y.redMul(w.redMul(this.z)), B = M.redSub(S), k = E.redSub(A);
    if (B.cmpn(0) === 0)
      return k.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var C = B.redSqr(), I = C.redMul(B), O = M.redMul(C), q = k.redSqr().redIAdd(I).redISub(O).redISub(O), $ = k.redMul(O.redISub(q)).redISub(E.redMul(I)), ae = this.z.redMul(m.z).redMul(B);
    return this.curve.jpoint(q, $, ae);
  }, d.prototype.mixedAdd = function(m) {
    if (this.isInfinity())
      return m.toJ();
    if (m.isInfinity())
      return this;
    var h = this.z.redSqr(), w = this.x, M = m.x.redMul(h), S = this.y, E = m.y.redMul(h).redMul(this.z), A = w.redSub(M), B = S.redSub(E);
    if (A.cmpn(0) === 0)
      return B.cmpn(0) !== 0 ? this.curve.jpoint(null, null, null) : this.dbl();
    var k = A.redSqr(), C = k.redMul(A), I = w.redMul(k), O = B.redSqr().redIAdd(C).redISub(I).redISub(I), q = B.redMul(I.redISub(O)).redISub(S.redMul(C)), $ = this.z.redMul(A);
    return this.curve.jpoint(O, q, $);
  }, d.prototype.dblp = function(m) {
    if (m === 0)
      return this;
    if (this.isInfinity())
      return this;
    if (!m)
      return this.dbl();
    var h;
    if (this.curve.zeroA || this.curve.threeA) {
      var w = this;
      for (h = 0; h < m; h++)
        w = w.dbl();
      return w;
    }
    var M = this.curve.a, S = this.curve.tinv, E = this.x, A = this.y, B = this.z, k = B.redSqr().redSqr(), C = A.redAdd(A);
    for (h = 0; h < m; h++) {
      var I = E.redSqr(), O = C.redSqr(), q = O.redSqr(), $ = I.redAdd(I).redIAdd(I).redIAdd(M.redMul(k)), ae = E.redMul(O), he = $.redSqr().redISub(ae.redAdd(ae)), te = ae.redISub(he), Ee = $.redMul(te);
      Ee = Ee.redIAdd(Ee).redISub(q);
      var x = C.redMul(B);
      h + 1 < m && (k = k.redMul(q)), E = he, B = x, C = Ee;
    }
    return this.curve.jpoint(E, C.redMul(S), B);
  }, d.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.zeroA ? this._zeroDbl() : this.curve.threeA ? this._threeDbl() : this._dbl();
  }, d.prototype._zeroDbl = function() {
    var m, h, w;
    if (this.zOne) {
      var M = this.x.redSqr(), S = this.y.redSqr(), E = S.redSqr(), A = this.x.redAdd(S).redSqr().redISub(M).redISub(E);
      A = A.redIAdd(A);
      var B = M.redAdd(M).redIAdd(M), k = B.redSqr().redISub(A).redISub(A), C = E.redIAdd(E);
      C = C.redIAdd(C), C = C.redIAdd(C), m = k, h = B.redMul(A.redISub(k)).redISub(C), w = this.y.redAdd(this.y);
    } else {
      var I = this.x.redSqr(), O = this.y.redSqr(), q = O.redSqr(), $ = this.x.redAdd(O).redSqr().redISub(I).redISub(q);
      $ = $.redIAdd($);
      var ae = I.redAdd(I).redIAdd(I), he = ae.redSqr(), te = q.redIAdd(q);
      te = te.redIAdd(te), te = te.redIAdd(te), m = he.redISub($).redISub($), h = ae.redMul($.redISub(m)).redISub(te), w = this.y.redMul(this.z), w = w.redIAdd(w);
    }
    return this.curve.jpoint(m, h, w);
  }, d.prototype._threeDbl = function() {
    var m, h, w;
    if (this.zOne) {
      var M = this.x.redSqr(), S = this.y.redSqr(), E = S.redSqr(), A = this.x.redAdd(S).redSqr().redISub(M).redISub(E);
      A = A.redIAdd(A);
      var B = M.redAdd(M).redIAdd(M).redIAdd(this.curve.a), k = B.redSqr().redISub(A).redISub(A);
      m = k;
      var C = E.redIAdd(E);
      C = C.redIAdd(C), C = C.redIAdd(C), h = B.redMul(A.redISub(k)).redISub(C), w = this.y.redAdd(this.y);
    } else {
      var I = this.z.redSqr(), O = this.y.redSqr(), q = this.x.redMul(O), $ = this.x.redSub(I).redMul(this.x.redAdd(I));
      $ = $.redAdd($).redIAdd($);
      var ae = q.redIAdd(q);
      ae = ae.redIAdd(ae);
      var he = ae.redAdd(ae);
      m = $.redSqr().redISub(he), w = this.y.redAdd(this.z).redSqr().redISub(O).redISub(I);
      var te = O.redSqr();
      te = te.redIAdd(te), te = te.redIAdd(te), te = te.redIAdd(te), h = $.redMul(ae.redISub(m)).redISub(te);
    }
    return this.curve.jpoint(m, h, w);
  }, d.prototype._dbl = function() {
    var m = this.curve.a, h = this.x, w = this.y, M = this.z, S = M.redSqr().redSqr(), E = h.redSqr(), A = w.redSqr(), B = E.redAdd(E).redIAdd(E).redIAdd(m.redMul(S)), k = h.redAdd(h);
    k = k.redIAdd(k);
    var C = k.redMul(A), I = B.redSqr().redISub(C.redAdd(C)), O = C.redISub(I), q = A.redSqr();
    q = q.redIAdd(q), q = q.redIAdd(q), q = q.redIAdd(q);
    var $ = B.redMul(O).redISub(q), ae = w.redAdd(w).redMul(M);
    return this.curve.jpoint(I, $, ae);
  }, d.prototype.trpl = function() {
    if (!this.curve.zeroA)
      return this.dbl().add(this);
    var m = this.x.redSqr(), h = this.y.redSqr(), w = this.z.redSqr(), M = h.redSqr(), S = m.redAdd(m).redIAdd(m), E = S.redSqr(), A = this.x.redAdd(h).redSqr().redISub(m).redISub(M);
    A = A.redIAdd(A), A = A.redAdd(A).redIAdd(A), A = A.redISub(E);
    var B = A.redSqr(), k = M.redIAdd(M);
    k = k.redIAdd(k), k = k.redIAdd(k), k = k.redIAdd(k);
    var C = S.redIAdd(A).redSqr().redISub(E).redISub(B).redISub(k), I = h.redMul(C);
    I = I.redIAdd(I), I = I.redIAdd(I);
    var O = this.x.redMul(B).redISub(I);
    O = O.redIAdd(O), O = O.redIAdd(O);
    var q = this.y.redMul(C.redMul(k.redISub(C)).redISub(A.redMul(B)));
    q = q.redIAdd(q), q = q.redIAdd(q), q = q.redIAdd(q);
    var $ = this.z.redAdd(A).redSqr().redISub(w).redISub(B);
    return this.curve.jpoint(O, q, $);
  }, d.prototype.mul = function(m, h) {
    return m = new e(m, h), this.curve._wnafMul(this, m);
  }, d.prototype.eq = function(m) {
    if (m.type === "affine")
      return this.eq(m.toJ());
    if (this === m)
      return !0;
    var h = this.z.redSqr(), w = m.z.redSqr();
    if (this.x.redMul(w).redISub(m.x.redMul(h)).cmpn(0) !== 0)
      return !1;
    var M = h.redMul(this.z), S = w.redMul(m.z);
    return this.y.redMul(S).redISub(m.y.redMul(M)).cmpn(0) === 0;
  }, d.prototype.eqXToP = function(m) {
    var h = this.z.redSqr(), w = m.toRed(this.curve.red).redMul(h);
    if (this.x.cmp(w) === 0)
      return !0;
    for (var M = m.clone(), S = this.curve.redN.redMul(h); ; ) {
      if (M.iadd(this.curve.n), M.cmp(this.curve.p) >= 0)
        return !1;
      if (w.redIAdd(S), this.x.cmp(w) === 0)
        return !0;
    }
  }, d.prototype.inspect = function() {
    return this.isInfinity() ? "<EC JPoint Infinity>" : "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
  }, d.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, Tp;
}
var Cp, q3;
function DR() {
  if (q3)
    return Cp;
  q3 = 1;
  var t = Ci(), e = Lt(), r = Mc(), i = kn();
  function f(l) {
    r.call(this, "mont", l), this.a = new t(l.a, 16).toRed(this.red), this.b = new t(l.b, 16).toRed(this.red), this.i4 = new t(4).toRed(this.red).redInvm(), this.two = new t(2).toRed(this.red), this.a24 = this.i4.redMul(this.a.redAdd(this.two));
  }
  e(f, r), Cp = f, f.prototype.validate = function(d) {
    var v = d.normalize().x, m = v.redSqr(), h = m.redMul(v).redAdd(m.redMul(this.a)).redAdd(v), w = h.redSqrt();
    return w.redSqr().cmp(h) === 0;
  };
  function a(l, d, v) {
    r.BasePoint.call(this, l, "projective"), d === null && v === null ? (this.x = this.curve.one, this.z = this.curve.zero) : (this.x = new t(d, 16), this.z = new t(v, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)));
  }
  return e(a, r.BasePoint), f.prototype.decodePoint = function(d, v) {
    return this.point(i.toArray(d, v), 1);
  }, f.prototype.point = function(d, v) {
    return new a(this, d, v);
  }, f.prototype.pointFromJSON = function(d) {
    return a.fromJSON(this, d);
  }, a.prototype.precompute = function() {
  }, a.prototype._encode = function() {
    return this.getX().toArray("be", this.curve.p.byteLength());
  }, a.fromJSON = function(d, v) {
    return new a(d, v[0], v[1] || d.one);
  }, a.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, a.prototype.isInfinity = function() {
    return this.z.cmpn(0) === 0;
  }, a.prototype.dbl = function() {
    var d = this.x.redAdd(this.z), v = d.redSqr(), m = this.x.redSub(this.z), h = m.redSqr(), w = v.redSub(h), M = v.redMul(h), S = w.redMul(h.redAdd(this.curve.a24.redMul(w)));
    return this.curve.point(M, S);
  }, a.prototype.add = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.diffAdd = function(d, v) {
    var m = this.x.redAdd(this.z), h = this.x.redSub(this.z), w = d.x.redAdd(d.z), M = d.x.redSub(d.z), S = M.redMul(m), E = w.redMul(h), A = v.z.redMul(S.redAdd(E).redSqr()), B = v.x.redMul(S.redISub(E).redSqr());
    return this.curve.point(A, B);
  }, a.prototype.mul = function(d) {
    for (var v = d.clone(), m = this, h = this.curve.point(null, null), w = this, M = []; v.cmpn(0) !== 0; v.iushrn(1))
      M.push(v.andln(1));
    for (var S = M.length - 1; S >= 0; S--)
      M[S] === 0 ? (m = m.diffAdd(h, w), h = h.dbl()) : (h = m.diffAdd(h, w), m = m.dbl());
    return h;
  }, a.prototype.mulAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.jumlAdd = function() {
    throw new Error("Not supported on Montgomery curve");
  }, a.prototype.eq = function(d) {
    return this.getX().cmp(d.getX()) === 0;
  }, a.prototype.normalize = function() {
    return this.x = this.x.redMul(this.z.redInvm()), this.z = this.curve.one, this;
  }, a.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, Cp;
}
var Bp, z3;
function UR() {
  if (z3)
    return Bp;
  z3 = 1;
  var t = kn(), e = Ci(), r = Lt(), i = Mc(), f = t.assert;
  function a(d) {
    this.twisted = (d.a | 0) !== 1, this.mOneA = this.twisted && (d.a | 0) === -1, this.extended = this.mOneA, i.call(this, "edwards", d), this.a = new e(d.a, 16).umod(this.red.m), this.a = this.a.toRed(this.red), this.c = new e(d.c, 16).toRed(this.red), this.c2 = this.c.redSqr(), this.d = new e(d.d, 16).toRed(this.red), this.dd = this.d.redAdd(this.d), f(!this.twisted || this.c.fromRed().cmpn(1) === 0), this.oneC = (d.c | 0) === 1;
  }
  r(a, i), Bp = a, a.prototype._mulA = function(v) {
    return this.mOneA ? v.redNeg() : this.a.redMul(v);
  }, a.prototype._mulC = function(v) {
    return this.oneC ? v : this.c.redMul(v);
  }, a.prototype.jpoint = function(v, m, h, w) {
    return this.point(v, m, h, w);
  }, a.prototype.pointFromX = function(v, m) {
    v = new e(v, 16), v.red || (v = v.toRed(this.red));
    var h = v.redSqr(), w = this.c2.redSub(this.a.redMul(h)), M = this.one.redSub(this.c2.redMul(this.d).redMul(h)), S = w.redMul(M.redInvm()), E = S.redSqrt();
    if (E.redSqr().redSub(S).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    var A = E.fromRed().isOdd();
    return (m && !A || !m && A) && (E = E.redNeg()), this.point(v, E);
  }, a.prototype.pointFromY = function(v, m) {
    v = new e(v, 16), v.red || (v = v.toRed(this.red));
    var h = v.redSqr(), w = h.redSub(this.c2), M = h.redMul(this.d).redMul(this.c2).redSub(this.a), S = w.redMul(M.redInvm());
    if (S.cmp(this.zero) === 0) {
      if (m)
        throw new Error("invalid point");
      return this.point(this.zero, v);
    }
    var E = S.redSqrt();
    if (E.redSqr().redSub(S).cmp(this.zero) !== 0)
      throw new Error("invalid point");
    return E.fromRed().isOdd() !== m && (E = E.redNeg()), this.point(E, v);
  }, a.prototype.validate = function(v) {
    if (v.isInfinity())
      return !0;
    v.normalize();
    var m = v.x.redSqr(), h = v.y.redSqr(), w = m.redMul(this.a).redAdd(h), M = this.c2.redMul(this.one.redAdd(this.d.redMul(m).redMul(h)));
    return w.cmp(M) === 0;
  };
  function l(d, v, m, h, w) {
    i.BasePoint.call(this, d, "projective"), v === null && m === null && h === null ? (this.x = this.curve.zero, this.y = this.curve.one, this.z = this.curve.one, this.t = this.curve.zero, this.zOne = !0) : (this.x = new e(v, 16), this.y = new e(m, 16), this.z = h ? new e(h, 16) : this.curve.one, this.t = w && new e(w, 16), this.x.red || (this.x = this.x.toRed(this.curve.red)), this.y.red || (this.y = this.y.toRed(this.curve.red)), this.z.red || (this.z = this.z.toRed(this.curve.red)), this.t && !this.t.red && (this.t = this.t.toRed(this.curve.red)), this.zOne = this.z === this.curve.one, this.curve.extended && !this.t && (this.t = this.x.redMul(this.y), this.zOne || (this.t = this.t.redMul(this.z.redInvm()))));
  }
  return r(l, i.BasePoint), a.prototype.pointFromJSON = function(v) {
    return l.fromJSON(this, v);
  }, a.prototype.point = function(v, m, h, w) {
    return new l(this, v, m, h, w);
  }, l.fromJSON = function(v, m) {
    return new l(v, m[0], m[1], m[2]);
  }, l.prototype.inspect = function() {
    return this.isInfinity() ? "<EC Point Infinity>" : "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
  }, l.prototype.isInfinity = function() {
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
  }, l.prototype._extDbl = function() {
    var v = this.x.redSqr(), m = this.y.redSqr(), h = this.z.redSqr();
    h = h.redIAdd(h);
    var w = this.curve._mulA(v), M = this.x.redAdd(this.y).redSqr().redISub(v).redISub(m), S = w.redAdd(m), E = S.redSub(h), A = w.redSub(m), B = M.redMul(E), k = S.redMul(A), C = M.redMul(A), I = E.redMul(S);
    return this.curve.point(B, k, I, C);
  }, l.prototype._projDbl = function() {
    var v = this.x.redAdd(this.y).redSqr(), m = this.x.redSqr(), h = this.y.redSqr(), w, M, S, E, A, B;
    if (this.curve.twisted) {
      E = this.curve._mulA(m);
      var k = E.redAdd(h);
      this.zOne ? (w = v.redSub(m).redSub(h).redMul(k.redSub(this.curve.two)), M = k.redMul(E.redSub(h)), S = k.redSqr().redSub(k).redSub(k)) : (A = this.z.redSqr(), B = k.redSub(A).redISub(A), w = v.redSub(m).redISub(h).redMul(B), M = k.redMul(E.redSub(h)), S = k.redMul(B));
    } else
      E = m.redAdd(h), A = this.curve._mulC(this.z).redSqr(), B = E.redSub(A).redSub(A), w = this.curve._mulC(v.redISub(E)).redMul(B), M = this.curve._mulC(E).redMul(m.redISub(h)), S = E.redMul(B);
    return this.curve.point(w, M, S);
  }, l.prototype.dbl = function() {
    return this.isInfinity() ? this : this.curve.extended ? this._extDbl() : this._projDbl();
  }, l.prototype._extAdd = function(v) {
    var m = this.y.redSub(this.x).redMul(v.y.redSub(v.x)), h = this.y.redAdd(this.x).redMul(v.y.redAdd(v.x)), w = this.t.redMul(this.curve.dd).redMul(v.t), M = this.z.redMul(v.z.redAdd(v.z)), S = h.redSub(m), E = M.redSub(w), A = M.redAdd(w), B = h.redAdd(m), k = S.redMul(E), C = A.redMul(B), I = S.redMul(B), O = E.redMul(A);
    return this.curve.point(k, C, O, I);
  }, l.prototype._projAdd = function(v) {
    var m = this.z.redMul(v.z), h = m.redSqr(), w = this.x.redMul(v.x), M = this.y.redMul(v.y), S = this.curve.d.redMul(w).redMul(M), E = h.redSub(S), A = h.redAdd(S), B = this.x.redAdd(this.y).redMul(v.x.redAdd(v.y)).redISub(w).redISub(M), k = m.redMul(E).redMul(B), C, I;
    return this.curve.twisted ? (C = m.redMul(A).redMul(M.redSub(this.curve._mulA(w))), I = E.redMul(A)) : (C = m.redMul(A).redMul(M.redSub(w)), I = this.curve._mulC(E).redMul(A)), this.curve.point(k, C, I);
  }, l.prototype.add = function(v) {
    return this.isInfinity() ? v : v.isInfinity() ? this : this.curve.extended ? this._extAdd(v) : this._projAdd(v);
  }, l.prototype.mul = function(v) {
    return this._hasDoubles(v) ? this.curve._fixedNafMul(this, v) : this.curve._wnafMul(this, v);
  }, l.prototype.mulAdd = function(v, m, h) {
    return this.curve._wnafMulAdd(1, [this, m], [v, h], 2, !1);
  }, l.prototype.jmulAdd = function(v, m, h) {
    return this.curve._wnafMulAdd(1, [this, m], [v, h], 2, !0);
  }, l.prototype.normalize = function() {
    if (this.zOne)
      return this;
    var v = this.z.redInvm();
    return this.x = this.x.redMul(v), this.y = this.y.redMul(v), this.t && (this.t = this.t.redMul(v)), this.z = this.curve.one, this.zOne = !0, this;
  }, l.prototype.neg = function() {
    return this.curve.point(
      this.x.redNeg(),
      this.y,
      this.z,
      this.t && this.t.redNeg()
    );
  }, l.prototype.getX = function() {
    return this.normalize(), this.x.fromRed();
  }, l.prototype.getY = function() {
    return this.normalize(), this.y.fromRed();
  }, l.prototype.eq = function(v) {
    return this === v || this.getX().cmp(v.getX()) === 0 && this.getY().cmp(v.getY()) === 0;
  }, l.prototype.eqXToP = function(v) {
    var m = v.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(m) === 0)
      return !0;
    for (var h = v.clone(), w = this.curve.redN.redMul(this.z); ; ) {
      if (h.iadd(this.curve.n), h.cmp(this.curve.p) >= 0)
        return !1;
      if (m.redIAdd(w), this.x.cmp(m) === 0)
        return !0;
    }
  }, l.prototype.toP = l.prototype.normalize, l.prototype.mixedAdd = l.prototype.add, Bp;
}
var j3;
function v_() {
  return j3 || (j3 = 1, function(t) {
    var e = t;
    e.base = Mc(), e.short = NR(), e.mont = DR(), e.edwards = UR();
  }(Ap)), Ap;
}
var Ip = {}, Rp, $3;
function LR() {
  return $3 || ($3 = 1, Rp = {
    doubles: {
      step: 4,
      points: [
        [
          "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
          "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
        ],
        [
          "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
          "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
        ],
        [
          "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
          "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
        ],
        [
          "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
          "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
        ],
        [
          "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
          "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
        ],
        [
          "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
          "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
        ],
        [
          "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
          "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
        ],
        [
          "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
          "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
        ],
        [
          "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
          "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
        ],
        [
          "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
          "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
        ],
        [
          "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
          "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
        ],
        [
          "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
          "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
        ],
        [
          "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
          "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
        ],
        [
          "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
          "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
        ],
        [
          "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
          "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
        ],
        [
          "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
          "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
        ],
        [
          "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
          "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
        ],
        [
          "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
          "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
        ],
        [
          "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
          "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
        ],
        [
          "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
          "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
        ],
        [
          "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
          "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
        ],
        [
          "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
          "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
        ],
        [
          "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
          "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
        ],
        [
          "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
          "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
        ],
        [
          "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
          "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
        ],
        [
          "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
          "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
        ],
        [
          "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
          "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
        ],
        [
          "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
          "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
        ],
        [
          "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
          "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
        ],
        [
          "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
          "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
        ],
        [
          "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
          "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
        ],
        [
          "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
          "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
        ],
        [
          "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
          "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
        ],
        [
          "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
          "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
        ],
        [
          "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
          "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
        ],
        [
          "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
          "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
        ],
        [
          "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
          "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
        ],
        [
          "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
          "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
        ],
        [
          "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
          "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
        ],
        [
          "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
          "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
        ],
        [
          "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
          "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
        ],
        [
          "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
          "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
        ],
        [
          "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
          "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
        ],
        [
          "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
          "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
        ],
        [
          "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
          "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
        ],
        [
          "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
          "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
        ],
        [
          "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
          "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
        ],
        [
          "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
          "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
        ],
        [
          "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
          "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
        ],
        [
          "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
          "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
        ],
        [
          "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
          "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
        ],
        [
          "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
          "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
        ],
        [
          "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
          "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
        ],
        [
          "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
          "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
        ],
        [
          "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
          "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
        ],
        [
          "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
          "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
        ],
        [
          "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
          "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
        ],
        [
          "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
          "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
        ],
        [
          "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
          "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
        ],
        [
          "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
          "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
        ],
        [
          "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
          "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
        ],
        [
          "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
          "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
        ],
        [
          "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
          "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
        ],
        [
          "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
          "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
        ],
        [
          "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
          "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
        ]
      ]
    },
    naf: {
      wnd: 7,
      points: [
        [
          "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
          "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
        ],
        [
          "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
          "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
        ],
        [
          "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
          "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
        ],
        [
          "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
          "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
        ],
        [
          "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
          "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
        ],
        [
          "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
          "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
        ],
        [
          "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
          "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
        ],
        [
          "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
          "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
        ],
        [
          "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
          "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
        ],
        [
          "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
          "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
        ],
        [
          "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
          "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
        ],
        [
          "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
          "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
        ],
        [
          "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
          "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
        ],
        [
          "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
          "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
        ],
        [
          "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
          "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
        ],
        [
          "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
          "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
        ],
        [
          "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
          "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
        ],
        [
          "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
          "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
        ],
        [
          "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
          "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
        ],
        [
          "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
          "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
        ],
        [
          "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
          "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
        ],
        [
          "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
          "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
        ],
        [
          "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
          "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
        ],
        [
          "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
          "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
        ],
        [
          "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
          "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
        ],
        [
          "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
          "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
        ],
        [
          "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
          "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
        ],
        [
          "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
          "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
        ],
        [
          "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
          "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
        ],
        [
          "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
          "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
        ],
        [
          "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
          "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
        ],
        [
          "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
          "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
        ],
        [
          "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
          "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
        ],
        [
          "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
          "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
        ],
        [
          "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
          "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
        ],
        [
          "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
          "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
        ],
        [
          "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
          "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
        ],
        [
          "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
          "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
        ],
        [
          "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
          "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
        ],
        [
          "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
          "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
        ],
        [
          "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
          "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
        ],
        [
          "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
          "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
        ],
        [
          "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
          "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
        ],
        [
          "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
          "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
        ],
        [
          "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
          "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
        ],
        [
          "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
          "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
        ],
        [
          "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
          "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
        ],
        [
          "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
          "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
        ],
        [
          "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
          "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
        ],
        [
          "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
          "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
        ],
        [
          "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
          "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
        ],
        [
          "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
          "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
        ],
        [
          "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
          "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
        ],
        [
          "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
          "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
        ],
        [
          "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
          "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
        ],
        [
          "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
          "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
        ],
        [
          "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
          "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
        ],
        [
          "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
          "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
        ],
        [
          "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
          "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
        ],
        [
          "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
          "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
        ],
        [
          "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
          "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
        ],
        [
          "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
          "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
        ],
        [
          "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
          "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
        ],
        [
          "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
          "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
        ],
        [
          "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
          "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
        ],
        [
          "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
          "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
        ],
        [
          "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
          "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
        ],
        [
          "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
          "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
        ],
        [
          "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
          "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
        ],
        [
          "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
          "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
        ],
        [
          "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
          "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
        ],
        [
          "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
          "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
        ],
        [
          "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
          "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
        ],
        [
          "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
          "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
        ],
        [
          "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
          "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
        ],
        [
          "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
          "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
        ],
        [
          "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
          "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
        ],
        [
          "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
          "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
        ],
        [
          "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
          "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
        ],
        [
          "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
          "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
        ],
        [
          "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
          "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
        ],
        [
          "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
          "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
        ],
        [
          "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
          "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
        ],
        [
          "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
          "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
        ],
        [
          "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
          "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
        ],
        [
          "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
          "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
        ],
        [
          "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
          "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
        ],
        [
          "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
          "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
        ],
        [
          "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
          "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
        ],
        [
          "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
          "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
        ],
        [
          "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
          "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
        ],
        [
          "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
          "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
        ],
        [
          "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
          "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
        ],
        [
          "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
          "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
        ],
        [
          "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
          "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
        ],
        [
          "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
          "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
        ],
        [
          "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
          "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
        ],
        [
          "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
          "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
        ],
        [
          "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
          "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
        ],
        [
          "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
          "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
        ],
        [
          "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
          "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
        ],
        [
          "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
          "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
        ],
        [
          "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
          "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
        ],
        [
          "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
          "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
        ],
        [
          "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
          "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
        ],
        [
          "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
          "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
        ],
        [
          "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
          "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
        ],
        [
          "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
          "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
        ],
        [
          "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
          "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
        ],
        [
          "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
          "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
        ],
        [
          "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
          "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
        ],
        [
          "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
          "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
        ],
        [
          "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
          "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
        ],
        [
          "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
          "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
        ],
        [
          "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
          "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
        ],
        [
          "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
          "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
        ],
        [
          "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
          "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
        ],
        [
          "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
          "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
        ],
        [
          "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
          "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
        ],
        [
          "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
          "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
        ],
        [
          "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
          "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
        ],
        [
          "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
          "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
        ],
        [
          "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
          "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
        ],
        [
          "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
          "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
        ],
        [
          "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
          "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
        ],
        [
          "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
          "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
        ],
        [
          "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
          "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
        ]
      ]
    }
  }), Rp;
}
var V3;
function Bm() {
  return V3 || (V3 = 1, function(t) {
    var e = t, r = Qf(), i = v_(), f = kn(), a = f.assert;
    function l(m) {
      m.type === "short" ? this.curve = new i.short(m) : m.type === "edwards" ? this.curve = new i.edwards(m) : this.curve = new i.mont(m), this.g = this.curve.g, this.n = this.curve.n, this.hash = m.hash, a(this.g.validate(), "Invalid curve"), a(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
    }
    e.PresetCurve = l;
    function d(m, h) {
      Object.defineProperty(e, m, {
        configurable: !0,
        enumerable: !0,
        get: function() {
          var w = new l(h);
          return Object.defineProperty(e, m, {
            configurable: !0,
            enumerable: !0,
            value: w
          }), w;
        }
      });
    }
    d("p192", {
      type: "short",
      prime: "p192",
      p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
      b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
      n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
      hash: r.sha256,
      gRed: !1,
      g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
      ]
    }), d("p224", {
      type: "short",
      prime: "p224",
      p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
      a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
      b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
      n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
      hash: r.sha256,
      gRed: !1,
      g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
      ]
    }), d("p256", {
      type: "short",
      prime: null,
      p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
      a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
      b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
      n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
      hash: r.sha256,
      gRed: !1,
      g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
      ]
    }), d("p384", {
      type: "short",
      prime: null,
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
      a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
      b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
      n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
      hash: r.sha384,
      gRed: !1,
      g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
      ]
    }), d("p521", {
      type: "short",
      prime: null,
      p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
      a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
      b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
      n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
      hash: r.sha512,
      gRed: !1,
      g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
      ]
    }), d("curve25519", {
      type: "mont",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "76d06",
      b: "1",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "9"
      ]
    }), d("ed25519", {
      type: "edwards",
      prime: "p25519",
      p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
      a: "-1",
      c: "1",
      // -121665 * (121666^(-1)) (mod P)
      d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
      n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
      hash: r.sha256,
      gRed: !1,
      g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
      ]
    });
    var v;
    try {
      v = LR();
    } catch {
      v = void 0;
    }
    d("secp256k1", {
      type: "short",
      prime: "k256",
      p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
      a: "0",
      b: "7",
      n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
      h: "1",
      hash: r.sha256,
      // Precomputed endomorphism
      beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
      lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
      basis: [
        {
          a: "3086d221a7d46bcde86c90e49284eb15",
          b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
          a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
          b: "3086d221a7d46bcde86c90e49284eb15"
        }
      ],
      gRed: !1,
      g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        v
      ]
    });
  }(Ip)), Ip;
}
var Pp, H3;
function FR() {
  if (H3)
    return Pp;
  H3 = 1;
  var t = Ci(), e = kn(), r = e.assert;
  function i(f, a) {
    this.ec = f, this.priv = null, this.pub = null, a.priv && this._importPrivate(a.priv, a.privEnc), a.pub && this._importPublic(a.pub, a.pubEnc);
  }
  return Pp = i, i.fromPublic = function(a, l, d) {
    return l instanceof i ? l : new i(a, {
      pub: l,
      pubEnc: d
    });
  }, i.fromPrivate = function(a, l, d) {
    return l instanceof i ? l : new i(a, {
      priv: l,
      privEnc: d
    });
  }, i.prototype.validate = function() {
    var a = this.getPublic();
    return a.isInfinity() ? { result: !1, reason: "Invalid public key" } : a.validate() ? a.mul(this.ec.curve.n).isInfinity() ? { result: !0, reason: null } : { result: !1, reason: "Public key * N != O" } : { result: !1, reason: "Public key is not a point" };
  }, i.prototype.getPublic = function(a, l) {
    return typeof a == "string" && (l = a, a = null), this.pub || (this.pub = this.ec.g.mul(this.priv)), l ? this.pub.encode(l, a) : this.pub;
  }, i.prototype.getPrivate = function(a) {
    return a === "hex" ? this.priv.toString(16, 2) : this.priv;
  }, i.prototype._importPrivate = function(a, l) {
    this.priv = new t(a, l || 16), this.priv = this.priv.umod(this.ec.curve.n);
  }, i.prototype._importPublic = function(a, l) {
    if (a.x || a.y) {
      this.ec.curve.type === "mont" ? r(a.x, "Need x coordinate") : (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") && r(a.x && a.y, "Need both x and y coordinate"), this.pub = this.ec.curve.point(a.x, a.y);
      return;
    }
    this.pub = this.ec.curve.decodePoint(a, l);
  }, i.prototype.derive = function(a) {
    return a.validate() || r(a.validate(), "public point not validated"), a.mul(this.priv).getX();
  }, i.prototype.sign = function(a, l, d) {
    return this.ec.sign(a, this, l, d);
  }, i.prototype.verify = function(a, l) {
    return this.ec.verify(a, l, this);
  }, i.prototype.inspect = function() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
  }, Pp;
}
var Op, W3;
function qR() {
  if (W3)
    return Op;
  W3 = 1;
  var t = Ci(), e = kn(), r = e.assert;
  function i(v, m) {
    if (v instanceof i)
      return v;
    this._importDER(v, m) || (r(v.r && v.s, "Signature without r or s"), this.r = new t(v.r, 16), this.s = new t(v.s, 16), v.recoveryParam === void 0 ? this.recoveryParam = null : this.recoveryParam = v.recoveryParam);
  }
  Op = i;
  function f() {
    this.place = 0;
  }
  function a(v, m) {
    var h = v[m.place++];
    if (!(h & 128))
      return h;
    var w = h & 15;
    if (w === 0 || w > 4)
      return !1;
    for (var M = 0, S = 0, E = m.place; S < w; S++, E++)
      M <<= 8, M |= v[E], M >>>= 0;
    return M <= 127 ? !1 : (m.place = E, M);
  }
  function l(v) {
    for (var m = 0, h = v.length - 1; !v[m] && !(v[m + 1] & 128) && m < h; )
      m++;
    return m === 0 ? v : v.slice(m);
  }
  i.prototype._importDER = function(m, h) {
    m = e.toArray(m, h);
    var w = new f();
    if (m[w.place++] !== 48)
      return !1;
    var M = a(m, w);
    if (M === !1 || M + w.place !== m.length || m[w.place++] !== 2)
      return !1;
    var S = a(m, w);
    if (S === !1)
      return !1;
    var E = m.slice(w.place, S + w.place);
    if (w.place += S, m[w.place++] !== 2)
      return !1;
    var A = a(m, w);
    if (A === !1 || m.length !== A + w.place)
      return !1;
    var B = m.slice(w.place, A + w.place);
    if (E[0] === 0)
      if (E[1] & 128)
        E = E.slice(1);
      else
        return !1;
    if (B[0] === 0)
      if (B[1] & 128)
        B = B.slice(1);
      else
        return !1;
    return this.r = new t(E), this.s = new t(B), this.recoveryParam = null, !0;
  };
  function d(v, m) {
    if (m < 128) {
      v.push(m);
      return;
    }
    var h = 1 + (Math.log(m) / Math.LN2 >>> 3);
    for (v.push(h | 128); --h; )
      v.push(m >>> (h << 3) & 255);
    v.push(m);
  }
  return i.prototype.toDER = function(m) {
    var h = this.r.toArray(), w = this.s.toArray();
    for (h[0] & 128 && (h = [0].concat(h)), w[0] & 128 && (w = [0].concat(w)), h = l(h), w = l(w); !w[0] && !(w[1] & 128); )
      w = w.slice(1);
    var M = [2];
    d(M, h.length), M = M.concat(h), M.push(2), d(M, w.length);
    var S = M.concat(w), E = [48];
    return d(E, S.length), E = E.concat(S), e.encode(E, m);
  }, Op;
}
var Np, K3;
function zR() {
  if (K3)
    return Np;
  K3 = 1;
  var t = Ci(), e = u_(), r = kn(), i = Bm(), f = Kf(), a = r.assert, l = FR(), d = qR();
  function v(m) {
    if (!(this instanceof v))
      return new v(m);
    typeof m == "string" && (a(
      Object.prototype.hasOwnProperty.call(i, m),
      "Unknown curve " + m
    ), m = i[m]), m instanceof i.PresetCurve && (m = { curve: m }), this.curve = m.curve.curve, this.n = this.curve.n, this.nh = this.n.ushrn(1), this.g = this.curve.g, this.g = m.curve.g, this.g.precompute(m.curve.n.bitLength() + 1), this.hash = m.hash || m.curve.hash;
  }
  return Np = v, v.prototype.keyPair = function(h) {
    return new l(this, h);
  }, v.prototype.keyFromPrivate = function(h, w) {
    return l.fromPrivate(this, h, w);
  }, v.prototype.keyFromPublic = function(h, w) {
    return l.fromPublic(this, h, w);
  }, v.prototype.genKeyPair = function(h) {
    h || (h = {});
    for (var w = new e({
      hash: this.hash,
      pers: h.pers,
      persEnc: h.persEnc || "utf8",
      entropy: h.entropy || f(this.hash.hmacStrength),
      entropyEnc: h.entropy && h.entropyEnc || "utf8",
      nonce: this.n.toArray()
    }), M = this.n.byteLength(), S = this.n.sub(new t(2)); ; ) {
      var E = new t(w.generate(M));
      if (!(E.cmp(S) > 0))
        return E.iaddn(1), this.keyFromPrivate(E);
    }
  }, v.prototype._truncateToN = function(h, w) {
    var M = h.byteLength() * 8 - this.n.bitLength();
    return M > 0 && (h = h.ushrn(M)), !w && h.cmp(this.n) >= 0 ? h.sub(this.n) : h;
  }, v.prototype.sign = function(h, w, M, S) {
    typeof M == "object" && (S = M, M = null), S || (S = {}), w = this.keyFromPrivate(w, M), h = this._truncateToN(new t(h, 16));
    for (var E = this.n.byteLength(), A = w.getPrivate().toArray("be", E), B = h.toArray("be", E), k = new e({
      hash: this.hash,
      entropy: A,
      nonce: B,
      pers: S.pers,
      persEnc: S.persEnc || "utf8"
    }), C = this.n.sub(new t(1)), I = 0; ; I++) {
      var O = S.k ? S.k(I) : new t(k.generate(this.n.byteLength()));
      if (O = this._truncateToN(O, !0), !(O.cmpn(1) <= 0 || O.cmp(C) >= 0)) {
        var q = this.g.mul(O);
        if (!q.isInfinity()) {
          var $ = q.getX(), ae = $.umod(this.n);
          if (ae.cmpn(0) !== 0) {
            var he = O.invm(this.n).mul(ae.mul(w.getPrivate()).iadd(h));
            if (he = he.umod(this.n), he.cmpn(0) !== 0) {
              var te = (q.getY().isOdd() ? 1 : 0) | ($.cmp(ae) !== 0 ? 2 : 0);
              return S.canonical && he.cmp(this.nh) > 0 && (he = this.n.sub(he), te ^= 1), new d({ r: ae, s: he, recoveryParam: te });
            }
          }
        }
      }
    }
  }, v.prototype.verify = function(h, w, M, S) {
    h = this._truncateToN(new t(h, 16)), M = this.keyFromPublic(M, S), w = new d(w, "hex");
    var E = w.r, A = w.s;
    if (E.cmpn(1) < 0 || E.cmp(this.n) >= 0 || A.cmpn(1) < 0 || A.cmp(this.n) >= 0)
      return !1;
    var B = A.invm(this.n), k = B.mul(h).umod(this.n), C = B.mul(E).umod(this.n), I;
    return this.curve._maxwellTrick ? (I = this.g.jmulAdd(k, M.getPublic(), C), I.isInfinity() ? !1 : I.eqXToP(E)) : (I = this.g.mulAdd(k, M.getPublic(), C), I.isInfinity() ? !1 : I.getX().umod(this.n).cmp(E) === 0);
  }, v.prototype.recoverPubKey = function(m, h, w, M) {
    a((3 & w) === w, "The recovery param is more than two bits"), h = new d(h, M);
    var S = this.n, E = new t(m), A = h.r, B = h.s, k = w & 1, C = w >> 1;
    if (A.cmp(this.curve.p.umod(this.curve.n)) >= 0 && C)
      throw new Error("Unable to find sencond key candinate");
    C ? A = this.curve.pointFromX(A.add(this.curve.n), k) : A = this.curve.pointFromX(A, k);
    var I = h.r.invm(S), O = S.sub(E).mul(I).umod(S), q = B.mul(I).umod(S);
    return this.g.mulAdd(O, A, q);
  }, v.prototype.getKeyRecoveryParam = function(m, h, w, M) {
    if (h = new d(h, M), h.recoveryParam !== null)
      return h.recoveryParam;
    for (var S = 0; S < 4; S++) {
      var E;
      try {
        E = this.recoverPubKey(m, h, S);
      } catch {
        continue;
      }
      if (E.eq(w))
        return S;
    }
    throw new Error("Unable to find valid recovery factor");
  }, Np;
}
var Dp, Z3;
function jR() {
  if (Z3)
    return Dp;
  Z3 = 1;
  var t = kn(), e = t.assert, r = t.parseBytes, i = t.cachedProperty;
  function f(a, l) {
    this.eddsa = a, this._secret = r(l.secret), a.isPoint(l.pub) ? this._pub = l.pub : this._pubBytes = r(l.pub);
  }
  return f.fromPublic = function(l, d) {
    return d instanceof f ? d : new f(l, { pub: d });
  }, f.fromSecret = function(l, d) {
    return d instanceof f ? d : new f(l, { secret: d });
  }, f.prototype.secret = function() {
    return this._secret;
  }, i(f, "pubBytes", function() {
    return this.eddsa.encodePoint(this.pub());
  }), i(f, "pub", function() {
    return this._pubBytes ? this.eddsa.decodePoint(this._pubBytes) : this.eddsa.g.mul(this.priv());
  }), i(f, "privBytes", function() {
    var l = this.eddsa, d = this.hash(), v = l.encodingLength - 1, m = d.slice(0, l.encodingLength);
    return m[0] &= 248, m[v] &= 127, m[v] |= 64, m;
  }), i(f, "priv", function() {
    return this.eddsa.decodeInt(this.privBytes());
  }), i(f, "hash", function() {
    return this.eddsa.hash().update(this.secret()).digest();
  }), i(f, "messagePrefix", function() {
    return this.hash().slice(this.eddsa.encodingLength);
  }), f.prototype.sign = function(l) {
    return e(this._secret, "KeyPair can only verify"), this.eddsa.sign(l, this);
  }, f.prototype.verify = function(l, d) {
    return this.eddsa.verify(l, d, this);
  }, f.prototype.getSecret = function(l) {
    return e(this._secret, "KeyPair is public only"), t.encode(this.secret(), l);
  }, f.prototype.getPublic = function(l) {
    return t.encode(this.pubBytes(), l);
  }, Dp = f, Dp;
}
var Up, G3;
function $R() {
  if (G3)
    return Up;
  G3 = 1;
  var t = Ci(), e = kn(), r = e.assert, i = e.cachedProperty, f = e.parseBytes;
  function a(l, d) {
    this.eddsa = l, typeof d != "object" && (d = f(d)), Array.isArray(d) && (d = {
      R: d.slice(0, l.encodingLength),
      S: d.slice(l.encodingLength)
    }), r(d.R && d.S, "Signature without R or S"), l.isPoint(d.R) && (this._R = d.R), d.S instanceof t && (this._S = d.S), this._Rencoded = Array.isArray(d.R) ? d.R : d.Rencoded, this._Sencoded = Array.isArray(d.S) ? d.S : d.Sencoded;
  }
  return i(a, "S", function() {
    return this.eddsa.decodeInt(this.Sencoded());
  }), i(a, "R", function() {
    return this.eddsa.decodePoint(this.Rencoded());
  }), i(a, "Rencoded", function() {
    return this.eddsa.encodePoint(this.R());
  }), i(a, "Sencoded", function() {
    return this.eddsa.encodeInt(this.S());
  }), a.prototype.toBytes = function() {
    return this.Rencoded().concat(this.Sencoded());
  }, a.prototype.toHex = function() {
    return e.encode(this.toBytes(), "hex").toUpperCase();
  }, Up = a, Up;
}
var Lp, Q3;
function VR() {
  if (Q3)
    return Lp;
  Q3 = 1;
  var t = Qf(), e = Bm(), r = kn(), i = r.assert, f = r.parseBytes, a = jR(), l = $R();
  function d(v) {
    if (i(v === "ed25519", "only tested with ed25519 so far"), !(this instanceof d))
      return new d(v);
    v = e[v].curve, this.curve = v, this.g = v.g, this.g.precompute(v.n.bitLength() + 1), this.pointClass = v.point().constructor, this.encodingLength = Math.ceil(v.n.bitLength() / 8), this.hash = t.sha512;
  }
  return Lp = d, d.prototype.sign = function(m, h) {
    m = f(m);
    var w = this.keyFromSecret(h), M = this.hashInt(w.messagePrefix(), m), S = this.g.mul(M), E = this.encodePoint(S), A = this.hashInt(E, w.pubBytes(), m).mul(w.priv()), B = M.add(A).umod(this.curve.n);
    return this.makeSignature({ R: S, S: B, Rencoded: E });
  }, d.prototype.verify = function(m, h, w) {
    m = f(m), h = this.makeSignature(h);
    var M = this.keyFromPublic(w), S = this.hashInt(h.Rencoded(), M.pubBytes(), m), E = this.g.mul(h.S()), A = h.R().add(M.pub().mul(S));
    return A.eq(E);
  }, d.prototype.hashInt = function() {
    for (var m = this.hash(), h = 0; h < arguments.length; h++)
      m.update(arguments[h]);
    return r.intFromLE(m.digest()).umod(this.curve.n);
  }, d.prototype.keyFromPublic = function(m) {
    return a.fromPublic(this, m);
  }, d.prototype.keyFromSecret = function(m) {
    return a.fromSecret(this, m);
  }, d.prototype.makeSignature = function(m) {
    return m instanceof l ? m : new l(this, m);
  }, d.prototype.encodePoint = function(m) {
    var h = m.getY().toArray("le", this.encodingLength);
    return h[this.encodingLength - 1] |= m.getX().isOdd() ? 128 : 0, h;
  }, d.prototype.decodePoint = function(m) {
    m = r.parseBytes(m);
    var h = m.length - 1, w = m.slice(0, h).concat(m[h] & -129), M = (m[h] & 128) !== 0, S = r.intFromLE(w);
    return this.curve.pointFromY(S, M);
  }, d.prototype.encodeInt = function(m) {
    return m.toArray("le", this.encodingLength);
  }, d.prototype.decodeInt = function(m) {
    return r.intFromLE(m);
  }, d.prototype.isPoint = function(m) {
    return m instanceof this.pointClass;
  }, Lp;
}
var Y3;
function HR() {
  return Y3 || (Y3 = 1, function(t) {
    var e = t;
    e.version = OR.version, e.utils = kn(), e.rand = Kf(), e.curve = v_(), e.curves = Bm(), e.ec = zR(), e.eddsa = VR();
  }(Sp)), Sp;
}
var Xu = { exports: {} };
Xu.exports;
var J3;
function WR() {
  return J3 || (J3 = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(Xu)), Xu.exports;
}
var Fp, X3;
function KR() {
  if (X3)
    return Fp;
  X3 = 1;
  var t = HR(), e = WR();
  Fp = function(l) {
    return new i(l);
  };
  var r = {
    secp256k1: {
      name: "secp256k1",
      byteLength: 32
    },
    secp224r1: {
      name: "p224",
      byteLength: 28
    },
    prime256v1: {
      name: "p256",
      byteLength: 32
    },
    prime192v1: {
      name: "p192",
      byteLength: 24
    },
    ed25519: {
      name: "ed25519",
      byteLength: 32
    },
    secp384r1: {
      name: "p384",
      byteLength: 48
    },
    secp521r1: {
      name: "p521",
      byteLength: 66
    }
  };
  r.p224 = r.secp224r1, r.p256 = r.secp256r1 = r.prime256v1, r.p192 = r.secp192r1 = r.prime192v1, r.p384 = r.secp384r1, r.p521 = r.secp521r1;
  function i(a) {
    this.curveType = r[a], this.curveType || (this.curveType = {
      name: a
    }), this.curve = new t.ec(this.curveType.name), this.keys = void 0;
  }
  i.prototype.generateKeys = function(a, l) {
    return this.keys = this.curve.genKeyPair(), this.getPublicKey(a, l);
  }, i.prototype.computeSecret = function(a, l, d) {
    l = l || "utf8", Je.isBuffer(a) || (a = new Je(a, l));
    var v = this.curve.keyFromPublic(a).getPublic(), m = v.mul(this.keys.getPrivate()).getX();
    return f(m, d, this.curveType.byteLength);
  }, i.prototype.getPublicKey = function(a, l) {
    var d = this.keys.getPublic(l === "compressed", !0);
    return l === "hybrid" && (d[d.length - 1] % 2 ? d[0] = 7 : d[0] = 6), f(d, a);
  }, i.prototype.getPrivateKey = function(a) {
    return f(this.keys.getPrivate(), a);
  }, i.prototype.setPublicKey = function(a, l) {
    return l = l || "utf8", Je.isBuffer(a) || (a = new Je(a, l)), this.keys._importPublic(a), this;
  }, i.prototype.setPrivateKey = function(a, l) {
    l = l || "utf8", Je.isBuffer(a) || (a = new Je(a, l));
    var d = new e(a);
    return d = d.toString(16), this.keys = this.curve.genKeyPair(), this.keys._importPrivate(d), this;
  };
  function f(a, l, d) {
    Array.isArray(a) || (a = a.toArray());
    var v = new Je(a);
    if (d && v.length < d) {
      var m = new Je(d - v.length);
      m.fill(0), v = Je.concat([m, v]);
    }
    return l ? v.toString(l) : v;
  }
  return Fp;
}
var qp = {}, zp, ew;
function m_() {
  if (ew)
    return zp;
  ew = 1;
  var t = Hf(), e = Vt().Buffer;
  zp = function(i, f) {
    for (var a = e.alloc(0), l = 0, d; a.length < f; )
      d = r(l++), a = e.concat([a, t("sha1").update(i).update(d).digest()]);
    return a.slice(0, f);
  };
  function r(i) {
    var f = e.allocUnsafe(4);
    return f.writeUInt32BE(i, 0), f;
  }
  return zp;
}
var jp, tw;
function g_() {
  return tw || (tw = 1, jp = function(e, r) {
    for (var i = e.length, f = -1; ++f < i; )
      e[f] ^= r[f];
    return e;
  }), jp;
}
var el = { exports: {} };
el.exports;
var rw;
function Im() {
  return rw || (rw = 1, function(t) {
    (function(e, r) {
      function i(x, n) {
        if (!x)
          throw new Error(n || "Assertion failed");
      }
      function f(x, n) {
        x.super_ = n;
        var o = function() {
        };
        o.prototype = n.prototype, x.prototype = new o(), x.prototype.constructor = x;
      }
      function a(x, n, o) {
        if (a.isBN(x))
          return x;
        this.negative = 0, this.words = null, this.length = 0, this.red = null, x !== null && ((n === "le" || n === "be") && (o = n, n = 10), this._init(x || 0, n || 10, o || "be"));
      }
      typeof e == "object" ? e.exports = a : r.BN = a, a.BN = a, a.wordSize = 26;
      var l;
      try {
        typeof window < "u" && typeof window.Buffer < "u" ? l = window.Buffer : l = kr.Buffer;
      } catch {
      }
      a.isBN = function(n) {
        return n instanceof a ? !0 : n !== null && typeof n == "object" && n.constructor.wordSize === a.wordSize && Array.isArray(n.words);
      }, a.max = function(n, o) {
        return n.cmp(o) > 0 ? n : o;
      }, a.min = function(n, o) {
        return n.cmp(o) < 0 ? n : o;
      }, a.prototype._init = function(n, o, u) {
        if (typeof n == "number")
          return this._initNumber(n, o, u);
        if (typeof n == "object")
          return this._initArray(n, o, u);
        o === "hex" && (o = 16), i(o === (o | 0) && o >= 2 && o <= 36), n = n.toString().replace(/\s+/g, "");
        var c = 0;
        n[0] === "-" && (c++, this.negative = 1), c < n.length && (o === 16 ? this._parseHex(n, c, u) : (this._parseBase(n, o, c), u === "le" && this._initArray(this.toArray(), o, u)));
      }, a.prototype._initNumber = function(n, o, u) {
        n < 0 && (this.negative = 1, n = -n), n < 67108864 ? (this.words = [n & 67108863], this.length = 1) : n < 4503599627370496 ? (this.words = [
          n & 67108863,
          n / 67108864 & 67108863
        ], this.length = 2) : (i(n < 9007199254740992), this.words = [
          n & 67108863,
          n / 67108864 & 67108863,
          1
        ], this.length = 3), u === "le" && this._initArray(this.toArray(), o, u);
      }, a.prototype._initArray = function(n, o, u) {
        if (i(typeof n.length == "number"), n.length <= 0)
          return this.words = [0], this.length = 1, this;
        this.length = Math.ceil(n.length / 3), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g, b, _ = 0;
        if (u === "be")
          for (c = n.length - 1, g = 0; c >= 0; c -= 3)
            b = n[c] | n[c - 1] << 8 | n[c - 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        else if (u === "le")
          for (c = 0, g = 0; c < n.length; c += 3)
            b = n[c] | n[c + 1] << 8 | n[c + 2] << 16, this.words[g] |= b << _ & 67108863, this.words[g + 1] = b >>> 26 - _ & 67108863, _ += 24, _ >= 26 && (_ -= 26, g++);
        return this.strip();
      };
      function d(x, n) {
        var o = x.charCodeAt(n);
        return o >= 65 && o <= 70 ? o - 55 : o >= 97 && o <= 102 ? o - 87 : o - 48 & 15;
      }
      function v(x, n, o) {
        var u = d(x, o);
        return o - 1 >= n && (u |= d(x, o - 1) << 4), u;
      }
      a.prototype._parseHex = function(n, o, u) {
        this.length = Math.ceil((n.length - o) / 6), this.words = new Array(this.length);
        for (var c = 0; c < this.length; c++)
          this.words[c] = 0;
        var g = 0, b = 0, _;
        if (u === "be")
          for (c = n.length - 1; c >= o; c -= 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        else {
          var p = n.length - o;
          for (c = p % 2 === 0 ? o + 1 : o; c < n.length; c += 2)
            _ = v(n, o, c) << g, this.words[b] |= _ & 67108863, g >= 18 ? (g -= 18, b += 1, this.words[b] |= _ >>> 26) : g += 8;
        }
        this.strip();
      };
      function m(x, n, o, u) {
        for (var c = 0, g = Math.min(x.length, o), b = n; b < g; b++) {
          var _ = x.charCodeAt(b) - 48;
          c *= u, _ >= 49 ? c += _ - 49 + 10 : _ >= 17 ? c += _ - 17 + 10 : c += _;
        }
        return c;
      }
      a.prototype._parseBase = function(n, o, u) {
        this.words = [0], this.length = 1;
        for (var c = 0, g = 1; g <= 67108863; g *= o)
          c++;
        c--, g = g / o | 0;
        for (var b = n.length - u, _ = b % c, p = Math.min(b, b - _) + u, s = 0, y = u; y < p; y += c)
          s = m(n, y, y + c, o), this.imuln(g), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        if (_ !== 0) {
          var T = 1;
          for (s = m(n, y, n.length, o), y = 0; y < _; y++)
            T *= o;
          this.imuln(T), this.words[0] + s < 67108864 ? this.words[0] += s : this._iaddn(s);
        }
        this.strip();
      }, a.prototype.copy = function(n) {
        n.words = new Array(this.length);
        for (var o = 0; o < this.length; o++)
          n.words[o] = this.words[o];
        n.length = this.length, n.negative = this.negative, n.red = this.red;
      }, a.prototype.clone = function() {
        var n = new a(null);
        return this.copy(n), n;
      }, a.prototype._expand = function(n) {
        for (; this.length < n; )
          this.words[this.length++] = 0;
        return this;
      }, a.prototype.strip = function() {
        for (; this.length > 1 && this.words[this.length - 1] === 0; )
          this.length--;
        return this._normSign();
      }, a.prototype._normSign = function() {
        return this.length === 1 && this.words[0] === 0 && (this.negative = 0), this;
      }, a.prototype.inspect = function() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
      };
      var h = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
      ], w = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
      ], M = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        1e7,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64e6,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        243e5,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
      ];
      a.prototype.toString = function(n, o) {
        n = n || 10, o = o | 0 || 1;
        var u;
        if (n === 16 || n === "hex") {
          u = "";
          for (var c = 0, g = 0, b = 0; b < this.length; b++) {
            var _ = this.words[b], p = ((_ << c | g) & 16777215).toString(16);
            g = _ >>> 24 - c & 16777215, g !== 0 || b !== this.length - 1 ? u = h[6 - p.length] + p + u : u = p + u, c += 2, c >= 26 && (c -= 26, b--);
          }
          for (g !== 0 && (u = g.toString(16) + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        if (n === (n | 0) && n >= 2 && n <= 36) {
          var s = w[n], y = M[n];
          u = "";
          var T = this.clone();
          for (T.negative = 0; !T.isZero(); ) {
            var P = T.modn(y).toString(n);
            T = T.idivn(y), T.isZero() ? u = P + u : u = h[s - P.length] + P + u;
          }
          for (this.isZero() && (u = "0" + u); u.length % o !== 0; )
            u = "0" + u;
          return this.negative !== 0 && (u = "-" + u), u;
        }
        i(!1, "Base should be between 2 and 36");
      }, a.prototype.toNumber = function() {
        var n = this.words[0];
        return this.length === 2 ? n += this.words[1] * 67108864 : this.length === 3 && this.words[2] === 1 ? n += 4503599627370496 + this.words[1] * 67108864 : this.length > 2 && i(!1, "Number can only safely store up to 53 bits"), this.negative !== 0 ? -n : n;
      }, a.prototype.toJSON = function() {
        return this.toString(16);
      }, a.prototype.toBuffer = function(n, o) {
        return i(typeof l < "u"), this.toArrayLike(l, n, o);
      }, a.prototype.toArray = function(n, o) {
        return this.toArrayLike(Array, n, o);
      }, a.prototype.toArrayLike = function(n, o, u) {
        var c = this.byteLength(), g = u || Math.max(1, c);
        i(c <= g, "byte array longer than desired length"), i(g > 0, "Requested array length <= 0"), this.strip();
        var b = o === "le", _ = new n(g), p, s, y = this.clone();
        if (b) {
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[s] = p;
          for (; s < g; s++)
            _[s] = 0;
        } else {
          for (s = 0; s < g - c; s++)
            _[s] = 0;
          for (s = 0; !y.isZero(); s++)
            p = y.andln(255), y.iushrn(8), _[g - s - 1] = p;
        }
        return _;
      }, Math.clz32 ? a.prototype._countBits = function(n) {
        return 32 - Math.clz32(n);
      } : a.prototype._countBits = function(n) {
        var o = n, u = 0;
        return o >= 4096 && (u += 13, o >>>= 13), o >= 64 && (u += 7, o >>>= 7), o >= 8 && (u += 4, o >>>= 4), o >= 2 && (u += 2, o >>>= 2), u + o;
      }, a.prototype._zeroBits = function(n) {
        if (n === 0)
          return 26;
        var o = n, u = 0;
        return o & 8191 || (u += 13, o >>>= 13), o & 127 || (u += 7, o >>>= 7), o & 15 || (u += 4, o >>>= 4), o & 3 || (u += 2, o >>>= 2), o & 1 || u++, u;
      }, a.prototype.bitLength = function() {
        var n = this.words[this.length - 1], o = this._countBits(n);
        return (this.length - 1) * 26 + o;
      };
      function S(x) {
        for (var n = new Array(x.bitLength()), o = 0; o < n.length; o++) {
          var u = o / 26 | 0, c = o % 26;
          n[o] = (x.words[u] & 1 << c) >>> c;
        }
        return n;
      }
      a.prototype.zeroBits = function() {
        if (this.isZero())
          return 0;
        for (var n = 0, o = 0; o < this.length; o++) {
          var u = this._zeroBits(this.words[o]);
          if (n += u, u !== 26)
            break;
        }
        return n;
      }, a.prototype.byteLength = function() {
        return Math.ceil(this.bitLength() / 8);
      }, a.prototype.toTwos = function(n) {
        return this.negative !== 0 ? this.abs().inotn(n).iaddn(1) : this.clone();
      }, a.prototype.fromTwos = function(n) {
        return this.testn(n - 1) ? this.notn(n).iaddn(1).ineg() : this.clone();
      }, a.prototype.isNeg = function() {
        return this.negative !== 0;
      }, a.prototype.neg = function() {
        return this.clone().ineg();
      }, a.prototype.ineg = function() {
        return this.isZero() || (this.negative ^= 1), this;
      }, a.prototype.iuor = function(n) {
        for (; this.length < n.length; )
          this.words[this.length++] = 0;
        for (var o = 0; o < n.length; o++)
          this.words[o] = this.words[o] | n.words[o];
        return this.strip();
      }, a.prototype.ior = function(n) {
        return i((this.negative | n.negative) === 0), this.iuor(n);
      }, a.prototype.or = function(n) {
        return this.length > n.length ? this.clone().ior(n) : n.clone().ior(this);
      }, a.prototype.uor = function(n) {
        return this.length > n.length ? this.clone().iuor(n) : n.clone().iuor(this);
      }, a.prototype.iuand = function(n) {
        var o;
        this.length > n.length ? o = n : o = this;
        for (var u = 0; u < o.length; u++)
          this.words[u] = this.words[u] & n.words[u];
        return this.length = o.length, this.strip();
      }, a.prototype.iand = function(n) {
        return i((this.negative | n.negative) === 0), this.iuand(n);
      }, a.prototype.and = function(n) {
        return this.length > n.length ? this.clone().iand(n) : n.clone().iand(this);
      }, a.prototype.uand = function(n) {
        return this.length > n.length ? this.clone().iuand(n) : n.clone().iuand(this);
      }, a.prototype.iuxor = function(n) {
        var o, u;
        this.length > n.length ? (o = this, u = n) : (o = n, u = this);
        for (var c = 0; c < u.length; c++)
          this.words[c] = o.words[c] ^ u.words[c];
        if (this !== o)
          for (; c < o.length; c++)
            this.words[c] = o.words[c];
        return this.length = o.length, this.strip();
      }, a.prototype.ixor = function(n) {
        return i((this.negative | n.negative) === 0), this.iuxor(n);
      }, a.prototype.xor = function(n) {
        return this.length > n.length ? this.clone().ixor(n) : n.clone().ixor(this);
      }, a.prototype.uxor = function(n) {
        return this.length > n.length ? this.clone().iuxor(n) : n.clone().iuxor(this);
      }, a.prototype.inotn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = Math.ceil(n / 26) | 0, u = n % 26;
        this._expand(o), u > 0 && o--;
        for (var c = 0; c < o; c++)
          this.words[c] = ~this.words[c] & 67108863;
        return u > 0 && (this.words[c] = ~this.words[c] & 67108863 >> 26 - u), this.strip();
      }, a.prototype.notn = function(n) {
        return this.clone().inotn(n);
      }, a.prototype.setn = function(n, o) {
        i(typeof n == "number" && n >= 0);
        var u = n / 26 | 0, c = n % 26;
        return this._expand(u + 1), o ? this.words[u] = this.words[u] | 1 << c : this.words[u] = this.words[u] & ~(1 << c), this.strip();
      }, a.prototype.iadd = function(n) {
        var o;
        if (this.negative !== 0 && n.negative === 0)
          return this.negative = 0, o = this.isub(n), this.negative ^= 1, this._normSign();
        if (this.negative === 0 && n.negative !== 0)
          return n.negative = 0, o = this.isub(n), n.negative = 1, o._normSign();
        var u, c;
        this.length > n.length ? (u = this, c = n) : (u = n, c = this);
        for (var g = 0, b = 0; b < c.length; b++)
          o = (u.words[b] | 0) + (c.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        for (; g !== 0 && b < u.length; b++)
          o = (u.words[b] | 0) + g, this.words[b] = o & 67108863, g = o >>> 26;
        if (this.length = u.length, g !== 0)
          this.words[this.length] = g, this.length++;
        else if (u !== this)
          for (; b < u.length; b++)
            this.words[b] = u.words[b];
        return this;
      }, a.prototype.add = function(n) {
        var o;
        return n.negative !== 0 && this.negative === 0 ? (n.negative = 0, o = this.sub(n), n.negative ^= 1, o) : n.negative === 0 && this.negative !== 0 ? (this.negative = 0, o = n.sub(this), this.negative = 1, o) : this.length > n.length ? this.clone().iadd(n) : n.clone().iadd(this);
      }, a.prototype.isub = function(n) {
        if (n.negative !== 0) {
          n.negative = 0;
          var o = this.iadd(n);
          return n.negative = 1, o._normSign();
        } else if (this.negative !== 0)
          return this.negative = 0, this.iadd(n), this.negative = 1, this._normSign();
        var u = this.cmp(n);
        if (u === 0)
          return this.negative = 0, this.length = 1, this.words[0] = 0, this;
        var c, g;
        u > 0 ? (c = this, g = n) : (c = n, g = this);
        for (var b = 0, _ = 0; _ < g.length; _++)
          o = (c.words[_] | 0) - (g.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        for (; b !== 0 && _ < c.length; _++)
          o = (c.words[_] | 0) + b, b = o >> 26, this.words[_] = o & 67108863;
        if (b === 0 && _ < c.length && c !== this)
          for (; _ < c.length; _++)
            this.words[_] = c.words[_];
        return this.length = Math.max(this.length, _), c !== this && (this.negative = 1), this.strip();
      }, a.prototype.sub = function(n) {
        return this.clone().isub(n);
      };
      function E(x, n, o) {
        o.negative = n.negative ^ x.negative;
        var u = x.length + n.length | 0;
        o.length = u, u = u - 1 | 0;
        var c = x.words[0] | 0, g = n.words[0] | 0, b = c * g, _ = b & 67108863, p = b / 67108864 | 0;
        o.words[0] = _;
        for (var s = 1; s < u; s++) {
          for (var y = p >>> 26, T = p & 67108863, P = Math.min(s, n.length - 1), z = Math.max(0, s - x.length + 1); z <= P; z++) {
            var J = s - z | 0;
            c = x.words[J] | 0, g = n.words[z] | 0, b = c * g + T, y += b / 67108864 | 0, T = b & 67108863;
          }
          o.words[s] = T | 0, p = y | 0;
        }
        return p !== 0 ? o.words[s] = p | 0 : o.length--, o.strip();
      }
      var A = function(n, o, u) {
        var c = n.words, g = o.words, b = u.words, _ = 0, p, s, y, T = c[0] | 0, P = T & 8191, z = T >>> 13, J = c[1] | 0, Z = J & 8191, F = J >>> 13, ee = c[2] | 0, re = ee & 8191, de = ee >>> 13, se = c[3] | 0, Q = se & 8191, ge = se >>> 13, Ye = c[4] | 0, Ce = Ye & 8191, Be = Ye >>> 13, st = c[5] | 0, De = st & 8191, _e = st >>> 13, St = c[6] | 0, Oe = St & 8191, Fe = St >>> 13, Et = c[7] | 0, Ue = Et & 8191, oe = Et >>> 13, le = c[8] | 0, ie = le & 8191, fe = le >>> 13, Te = c[9] | 0, N = Te & 8191, R = Te >>> 13, L = g[0] | 0, V = L & 8191, ne = L >>> 13, Se = g[1] | 0, ue = Se & 8191, xe = Se >>> 13, He = g[2] | 0, be = He & 8191, Ie = He >>> 13, rt = g[3] | 0, Ne = rt & 8191, ze = rt >>> 13, kt = g[4] | 0, Le = kt & 8191, $e = kt >>> 13, Ot = g[5] | 0, je = Ot & 8191, Ve = Ot >>> 13, Nt = g[6] | 0, qe = Nt & 8191, Ke = Nt >>> 13, K = g[7] | 0, W = K & 8191, G = K >>> 13, U = g[8] | 0, X = U & 8191, H = U >>> 13, ye = g[9] | 0, ce = ye & 8191, we = ye >>> 13;
        u.negative = n.negative ^ o.negative, u.length = 19, p = Math.imul(P, V), s = Math.imul(P, ne), s = s + Math.imul(z, V) | 0, y = Math.imul(z, ne);
        var Qe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Qe >>> 26) | 0, Qe &= 67108863, p = Math.imul(Z, V), s = Math.imul(Z, ne), s = s + Math.imul(F, V) | 0, y = Math.imul(F, ne), p = p + Math.imul(P, ue) | 0, s = s + Math.imul(P, xe) | 0, s = s + Math.imul(z, ue) | 0, y = y + Math.imul(z, xe) | 0;
        var Ze = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Ze >>> 26) | 0, Ze &= 67108863, p = Math.imul(re, V), s = Math.imul(re, ne), s = s + Math.imul(de, V) | 0, y = Math.imul(de, ne), p = p + Math.imul(Z, ue) | 0, s = s + Math.imul(Z, xe) | 0, s = s + Math.imul(F, ue) | 0, y = y + Math.imul(F, xe) | 0, p = p + Math.imul(P, be) | 0, s = s + Math.imul(P, Ie) | 0, s = s + Math.imul(z, be) | 0, y = y + Math.imul(z, Ie) | 0;
        var lt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (lt >>> 26) | 0, lt &= 67108863, p = Math.imul(Q, V), s = Math.imul(Q, ne), s = s + Math.imul(ge, V) | 0, y = Math.imul(ge, ne), p = p + Math.imul(re, ue) | 0, s = s + Math.imul(re, xe) | 0, s = s + Math.imul(de, ue) | 0, y = y + Math.imul(de, xe) | 0, p = p + Math.imul(Z, be) | 0, s = s + Math.imul(Z, Ie) | 0, s = s + Math.imul(F, be) | 0, y = y + Math.imul(F, Ie) | 0, p = p + Math.imul(P, Ne) | 0, s = s + Math.imul(P, ze) | 0, s = s + Math.imul(z, Ne) | 0, y = y + Math.imul(z, ze) | 0;
        var Xe = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (Xe >>> 26) | 0, Xe &= 67108863, p = Math.imul(Ce, V), s = Math.imul(Ce, ne), s = s + Math.imul(Be, V) | 0, y = Math.imul(Be, ne), p = p + Math.imul(Q, ue) | 0, s = s + Math.imul(Q, xe) | 0, s = s + Math.imul(ge, ue) | 0, y = y + Math.imul(ge, xe) | 0, p = p + Math.imul(re, be) | 0, s = s + Math.imul(re, Ie) | 0, s = s + Math.imul(de, be) | 0, y = y + Math.imul(de, Ie) | 0, p = p + Math.imul(Z, Ne) | 0, s = s + Math.imul(Z, ze) | 0, s = s + Math.imul(F, Ne) | 0, y = y + Math.imul(F, ze) | 0, p = p + Math.imul(P, Le) | 0, s = s + Math.imul(P, $e) | 0, s = s + Math.imul(z, Le) | 0, y = y + Math.imul(z, $e) | 0;
        var ht = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ht >>> 26) | 0, ht &= 67108863, p = Math.imul(De, V), s = Math.imul(De, ne), s = s + Math.imul(_e, V) | 0, y = Math.imul(_e, ne), p = p + Math.imul(Ce, ue) | 0, s = s + Math.imul(Ce, xe) | 0, s = s + Math.imul(Be, ue) | 0, y = y + Math.imul(Be, xe) | 0, p = p + Math.imul(Q, be) | 0, s = s + Math.imul(Q, Ie) | 0, s = s + Math.imul(ge, be) | 0, y = y + Math.imul(ge, Ie) | 0, p = p + Math.imul(re, Ne) | 0, s = s + Math.imul(re, ze) | 0, s = s + Math.imul(de, Ne) | 0, y = y + Math.imul(de, ze) | 0, p = p + Math.imul(Z, Le) | 0, s = s + Math.imul(Z, $e) | 0, s = s + Math.imul(F, Le) | 0, y = y + Math.imul(F, $e) | 0, p = p + Math.imul(P, je) | 0, s = s + Math.imul(P, Ve) | 0, s = s + Math.imul(z, je) | 0, y = y + Math.imul(z, Ve) | 0;
        var ct = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ct >>> 26) | 0, ct &= 67108863, p = Math.imul(Oe, V), s = Math.imul(Oe, ne), s = s + Math.imul(Fe, V) | 0, y = Math.imul(Fe, ne), p = p + Math.imul(De, ue) | 0, s = s + Math.imul(De, xe) | 0, s = s + Math.imul(_e, ue) | 0, y = y + Math.imul(_e, xe) | 0, p = p + Math.imul(Ce, be) | 0, s = s + Math.imul(Ce, Ie) | 0, s = s + Math.imul(Be, be) | 0, y = y + Math.imul(Be, Ie) | 0, p = p + Math.imul(Q, Ne) | 0, s = s + Math.imul(Q, ze) | 0, s = s + Math.imul(ge, Ne) | 0, y = y + Math.imul(ge, ze) | 0, p = p + Math.imul(re, Le) | 0, s = s + Math.imul(re, $e) | 0, s = s + Math.imul(de, Le) | 0, y = y + Math.imul(de, $e) | 0, p = p + Math.imul(Z, je) | 0, s = s + Math.imul(Z, Ve) | 0, s = s + Math.imul(F, je) | 0, y = y + Math.imul(F, Ve) | 0, p = p + Math.imul(P, qe) | 0, s = s + Math.imul(P, Ke) | 0, s = s + Math.imul(z, qe) | 0, y = y + Math.imul(z, Ke) | 0;
        var pt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (pt >>> 26) | 0, pt &= 67108863, p = Math.imul(Ue, V), s = Math.imul(Ue, ne), s = s + Math.imul(oe, V) | 0, y = Math.imul(oe, ne), p = p + Math.imul(Oe, ue) | 0, s = s + Math.imul(Oe, xe) | 0, s = s + Math.imul(Fe, ue) | 0, y = y + Math.imul(Fe, xe) | 0, p = p + Math.imul(De, be) | 0, s = s + Math.imul(De, Ie) | 0, s = s + Math.imul(_e, be) | 0, y = y + Math.imul(_e, Ie) | 0, p = p + Math.imul(Ce, Ne) | 0, s = s + Math.imul(Ce, ze) | 0, s = s + Math.imul(Be, Ne) | 0, y = y + Math.imul(Be, ze) | 0, p = p + Math.imul(Q, Le) | 0, s = s + Math.imul(Q, $e) | 0, s = s + Math.imul(ge, Le) | 0, y = y + Math.imul(ge, $e) | 0, p = p + Math.imul(re, je) | 0, s = s + Math.imul(re, Ve) | 0, s = s + Math.imul(de, je) | 0, y = y + Math.imul(de, Ve) | 0, p = p + Math.imul(Z, qe) | 0, s = s + Math.imul(Z, Ke) | 0, s = s + Math.imul(F, qe) | 0, y = y + Math.imul(F, Ke) | 0, p = p + Math.imul(P, W) | 0, s = s + Math.imul(P, G) | 0, s = s + Math.imul(z, W) | 0, y = y + Math.imul(z, G) | 0;
        var yt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (yt >>> 26) | 0, yt &= 67108863, p = Math.imul(ie, V), s = Math.imul(ie, ne), s = s + Math.imul(fe, V) | 0, y = Math.imul(fe, ne), p = p + Math.imul(Ue, ue) | 0, s = s + Math.imul(Ue, xe) | 0, s = s + Math.imul(oe, ue) | 0, y = y + Math.imul(oe, xe) | 0, p = p + Math.imul(Oe, be) | 0, s = s + Math.imul(Oe, Ie) | 0, s = s + Math.imul(Fe, be) | 0, y = y + Math.imul(Fe, Ie) | 0, p = p + Math.imul(De, Ne) | 0, s = s + Math.imul(De, ze) | 0, s = s + Math.imul(_e, Ne) | 0, y = y + Math.imul(_e, ze) | 0, p = p + Math.imul(Ce, Le) | 0, s = s + Math.imul(Ce, $e) | 0, s = s + Math.imul(Be, Le) | 0, y = y + Math.imul(Be, $e) | 0, p = p + Math.imul(Q, je) | 0, s = s + Math.imul(Q, Ve) | 0, s = s + Math.imul(ge, je) | 0, y = y + Math.imul(ge, Ve) | 0, p = p + Math.imul(re, qe) | 0, s = s + Math.imul(re, Ke) | 0, s = s + Math.imul(de, qe) | 0, y = y + Math.imul(de, Ke) | 0, p = p + Math.imul(Z, W) | 0, s = s + Math.imul(Z, G) | 0, s = s + Math.imul(F, W) | 0, y = y + Math.imul(F, G) | 0, p = p + Math.imul(P, X) | 0, s = s + Math.imul(P, H) | 0, s = s + Math.imul(z, X) | 0, y = y + Math.imul(z, H) | 0;
        var bt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (bt >>> 26) | 0, bt &= 67108863, p = Math.imul(N, V), s = Math.imul(N, ne), s = s + Math.imul(R, V) | 0, y = Math.imul(R, ne), p = p + Math.imul(ie, ue) | 0, s = s + Math.imul(ie, xe) | 0, s = s + Math.imul(fe, ue) | 0, y = y + Math.imul(fe, xe) | 0, p = p + Math.imul(Ue, be) | 0, s = s + Math.imul(Ue, Ie) | 0, s = s + Math.imul(oe, be) | 0, y = y + Math.imul(oe, Ie) | 0, p = p + Math.imul(Oe, Ne) | 0, s = s + Math.imul(Oe, ze) | 0, s = s + Math.imul(Fe, Ne) | 0, y = y + Math.imul(Fe, ze) | 0, p = p + Math.imul(De, Le) | 0, s = s + Math.imul(De, $e) | 0, s = s + Math.imul(_e, Le) | 0, y = y + Math.imul(_e, $e) | 0, p = p + Math.imul(Ce, je) | 0, s = s + Math.imul(Ce, Ve) | 0, s = s + Math.imul(Be, je) | 0, y = y + Math.imul(Be, Ve) | 0, p = p + Math.imul(Q, qe) | 0, s = s + Math.imul(Q, Ke) | 0, s = s + Math.imul(ge, qe) | 0, y = y + Math.imul(ge, Ke) | 0, p = p + Math.imul(re, W) | 0, s = s + Math.imul(re, G) | 0, s = s + Math.imul(de, W) | 0, y = y + Math.imul(de, G) | 0, p = p + Math.imul(Z, X) | 0, s = s + Math.imul(Z, H) | 0, s = s + Math.imul(F, X) | 0, y = y + Math.imul(F, H) | 0, p = p + Math.imul(P, ce) | 0, s = s + Math.imul(P, we) | 0, s = s + Math.imul(z, ce) | 0, y = y + Math.imul(z, we) | 0;
        var wt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (wt >>> 26) | 0, wt &= 67108863, p = Math.imul(N, ue), s = Math.imul(N, xe), s = s + Math.imul(R, ue) | 0, y = Math.imul(R, xe), p = p + Math.imul(ie, be) | 0, s = s + Math.imul(ie, Ie) | 0, s = s + Math.imul(fe, be) | 0, y = y + Math.imul(fe, Ie) | 0, p = p + Math.imul(Ue, Ne) | 0, s = s + Math.imul(Ue, ze) | 0, s = s + Math.imul(oe, Ne) | 0, y = y + Math.imul(oe, ze) | 0, p = p + Math.imul(Oe, Le) | 0, s = s + Math.imul(Oe, $e) | 0, s = s + Math.imul(Fe, Le) | 0, y = y + Math.imul(Fe, $e) | 0, p = p + Math.imul(De, je) | 0, s = s + Math.imul(De, Ve) | 0, s = s + Math.imul(_e, je) | 0, y = y + Math.imul(_e, Ve) | 0, p = p + Math.imul(Ce, qe) | 0, s = s + Math.imul(Ce, Ke) | 0, s = s + Math.imul(Be, qe) | 0, y = y + Math.imul(Be, Ke) | 0, p = p + Math.imul(Q, W) | 0, s = s + Math.imul(Q, G) | 0, s = s + Math.imul(ge, W) | 0, y = y + Math.imul(ge, G) | 0, p = p + Math.imul(re, X) | 0, s = s + Math.imul(re, H) | 0, s = s + Math.imul(de, X) | 0, y = y + Math.imul(de, H) | 0, p = p + Math.imul(Z, ce) | 0, s = s + Math.imul(Z, we) | 0, s = s + Math.imul(F, ce) | 0, y = y + Math.imul(F, we) | 0;
        var mt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (mt >>> 26) | 0, mt &= 67108863, p = Math.imul(N, be), s = Math.imul(N, Ie), s = s + Math.imul(R, be) | 0, y = Math.imul(R, Ie), p = p + Math.imul(ie, Ne) | 0, s = s + Math.imul(ie, ze) | 0, s = s + Math.imul(fe, Ne) | 0, y = y + Math.imul(fe, ze) | 0, p = p + Math.imul(Ue, Le) | 0, s = s + Math.imul(Ue, $e) | 0, s = s + Math.imul(oe, Le) | 0, y = y + Math.imul(oe, $e) | 0, p = p + Math.imul(Oe, je) | 0, s = s + Math.imul(Oe, Ve) | 0, s = s + Math.imul(Fe, je) | 0, y = y + Math.imul(Fe, Ve) | 0, p = p + Math.imul(De, qe) | 0, s = s + Math.imul(De, Ke) | 0, s = s + Math.imul(_e, qe) | 0, y = y + Math.imul(_e, Ke) | 0, p = p + Math.imul(Ce, W) | 0, s = s + Math.imul(Ce, G) | 0, s = s + Math.imul(Be, W) | 0, y = y + Math.imul(Be, G) | 0, p = p + Math.imul(Q, X) | 0, s = s + Math.imul(Q, H) | 0, s = s + Math.imul(ge, X) | 0, y = y + Math.imul(ge, H) | 0, p = p + Math.imul(re, ce) | 0, s = s + Math.imul(re, we) | 0, s = s + Math.imul(de, ce) | 0, y = y + Math.imul(de, we) | 0;
        var ft = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ft >>> 26) | 0, ft &= 67108863, p = Math.imul(N, Ne), s = Math.imul(N, ze), s = s + Math.imul(R, Ne) | 0, y = Math.imul(R, ze), p = p + Math.imul(ie, Le) | 0, s = s + Math.imul(ie, $e) | 0, s = s + Math.imul(fe, Le) | 0, y = y + Math.imul(fe, $e) | 0, p = p + Math.imul(Ue, je) | 0, s = s + Math.imul(Ue, Ve) | 0, s = s + Math.imul(oe, je) | 0, y = y + Math.imul(oe, Ve) | 0, p = p + Math.imul(Oe, qe) | 0, s = s + Math.imul(Oe, Ke) | 0, s = s + Math.imul(Fe, qe) | 0, y = y + Math.imul(Fe, Ke) | 0, p = p + Math.imul(De, W) | 0, s = s + Math.imul(De, G) | 0, s = s + Math.imul(_e, W) | 0, y = y + Math.imul(_e, G) | 0, p = p + Math.imul(Ce, X) | 0, s = s + Math.imul(Ce, H) | 0, s = s + Math.imul(Be, X) | 0, y = y + Math.imul(Be, H) | 0, p = p + Math.imul(Q, ce) | 0, s = s + Math.imul(Q, we) | 0, s = s + Math.imul(ge, ce) | 0, y = y + Math.imul(ge, we) | 0;
        var gt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (gt >>> 26) | 0, gt &= 67108863, p = Math.imul(N, Le), s = Math.imul(N, $e), s = s + Math.imul(R, Le) | 0, y = Math.imul(R, $e), p = p + Math.imul(ie, je) | 0, s = s + Math.imul(ie, Ve) | 0, s = s + Math.imul(fe, je) | 0, y = y + Math.imul(fe, Ve) | 0, p = p + Math.imul(Ue, qe) | 0, s = s + Math.imul(Ue, Ke) | 0, s = s + Math.imul(oe, qe) | 0, y = y + Math.imul(oe, Ke) | 0, p = p + Math.imul(Oe, W) | 0, s = s + Math.imul(Oe, G) | 0, s = s + Math.imul(Fe, W) | 0, y = y + Math.imul(Fe, G) | 0, p = p + Math.imul(De, X) | 0, s = s + Math.imul(De, H) | 0, s = s + Math.imul(_e, X) | 0, y = y + Math.imul(_e, H) | 0, p = p + Math.imul(Ce, ce) | 0, s = s + Math.imul(Ce, we) | 0, s = s + Math.imul(Be, ce) | 0, y = y + Math.imul(Be, we) | 0;
        var at = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (at >>> 26) | 0, at &= 67108863, p = Math.imul(N, je), s = Math.imul(N, Ve), s = s + Math.imul(R, je) | 0, y = Math.imul(R, Ve), p = p + Math.imul(ie, qe) | 0, s = s + Math.imul(ie, Ke) | 0, s = s + Math.imul(fe, qe) | 0, y = y + Math.imul(fe, Ke) | 0, p = p + Math.imul(Ue, W) | 0, s = s + Math.imul(Ue, G) | 0, s = s + Math.imul(oe, W) | 0, y = y + Math.imul(oe, G) | 0, p = p + Math.imul(Oe, X) | 0, s = s + Math.imul(Oe, H) | 0, s = s + Math.imul(Fe, X) | 0, y = y + Math.imul(Fe, H) | 0, p = p + Math.imul(De, ce) | 0, s = s + Math.imul(De, we) | 0, s = s + Math.imul(_e, ce) | 0, y = y + Math.imul(_e, we) | 0;
        var dt = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (dt >>> 26) | 0, dt &= 67108863, p = Math.imul(N, qe), s = Math.imul(N, Ke), s = s + Math.imul(R, qe) | 0, y = Math.imul(R, Ke), p = p + Math.imul(ie, W) | 0, s = s + Math.imul(ie, G) | 0, s = s + Math.imul(fe, W) | 0, y = y + Math.imul(fe, G) | 0, p = p + Math.imul(Ue, X) | 0, s = s + Math.imul(Ue, H) | 0, s = s + Math.imul(oe, X) | 0, y = y + Math.imul(oe, H) | 0, p = p + Math.imul(Oe, ce) | 0, s = s + Math.imul(Oe, we) | 0, s = s + Math.imul(Fe, ce) | 0, y = y + Math.imul(Fe, we) | 0;
        var ve = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (ve >>> 26) | 0, ve &= 67108863, p = Math.imul(N, W), s = Math.imul(N, G), s = s + Math.imul(R, W) | 0, y = Math.imul(R, G), p = p + Math.imul(ie, X) | 0, s = s + Math.imul(ie, H) | 0, s = s + Math.imul(fe, X) | 0, y = y + Math.imul(fe, H) | 0, p = p + Math.imul(Ue, ce) | 0, s = s + Math.imul(Ue, we) | 0, s = s + Math.imul(oe, ce) | 0, y = y + Math.imul(oe, we) | 0;
        var D = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (D >>> 26) | 0, D &= 67108863, p = Math.imul(N, X), s = Math.imul(N, H), s = s + Math.imul(R, X) | 0, y = Math.imul(R, H), p = p + Math.imul(ie, ce) | 0, s = s + Math.imul(ie, we) | 0, s = s + Math.imul(fe, ce) | 0, y = y + Math.imul(fe, we) | 0;
        var j = (_ + p | 0) + ((s & 8191) << 13) | 0;
        _ = (y + (s >>> 13) | 0) + (j >>> 26) | 0, j &= 67108863, p = Math.imul(N, ce), s = Math.imul(N, we), s = s + Math.imul(R, ce) | 0, y = Math.imul(R, we);
        var Y = (_ + p | 0) + ((s & 8191) << 13) | 0;
        return _ = (y + (s >>> 13) | 0) + (Y >>> 26) | 0, Y &= 67108863, b[0] = Qe, b[1] = Ze, b[2] = lt, b[3] = Xe, b[4] = ht, b[5] = ct, b[6] = pt, b[7] = yt, b[8] = bt, b[9] = wt, b[10] = mt, b[11] = ft, b[12] = gt, b[13] = at, b[14] = dt, b[15] = ve, b[16] = D, b[17] = j, b[18] = Y, _ !== 0 && (b[19] = _, u.length++), u;
      };
      Math.imul || (A = E);
      function B(x, n, o) {
        o.negative = n.negative ^ x.negative, o.length = x.length + n.length;
        for (var u = 0, c = 0, g = 0; g < o.length - 1; g++) {
          var b = c;
          c = 0;
          for (var _ = u & 67108863, p = Math.min(g, n.length - 1), s = Math.max(0, g - x.length + 1); s <= p; s++) {
            var y = g - s, T = x.words[y] | 0, P = n.words[s] | 0, z = T * P, J = z & 67108863;
            b = b + (z / 67108864 | 0) | 0, J = J + _ | 0, _ = J & 67108863, b = b + (J >>> 26) | 0, c += b >>> 26, b &= 67108863;
          }
          o.words[g] = _, u = b, b = c;
        }
        return u !== 0 ? o.words[g] = u : o.length--, o.strip();
      }
      function k(x, n, o) {
        var u = new C();
        return u.mulp(x, n, o);
      }
      a.prototype.mulTo = function(n, o) {
        var u, c = this.length + n.length;
        return this.length === 10 && n.length === 10 ? u = A(this, n, o) : c < 63 ? u = E(this, n, o) : c < 1024 ? u = B(this, n, o) : u = k(this, n, o), u;
      };
      function C(x, n) {
        this.x = x, this.y = n;
      }
      C.prototype.makeRBT = function(n) {
        for (var o = new Array(n), u = a.prototype._countBits(n) - 1, c = 0; c < n; c++)
          o[c] = this.revBin(c, u, n);
        return o;
      }, C.prototype.revBin = function(n, o, u) {
        if (n === 0 || n === u - 1)
          return n;
        for (var c = 0, g = 0; g < o; g++)
          c |= (n & 1) << o - g - 1, n >>= 1;
        return c;
      }, C.prototype.permute = function(n, o, u, c, g, b) {
        for (var _ = 0; _ < b; _++)
          c[_] = o[n[_]], g[_] = u[n[_]];
      }, C.prototype.transform = function(n, o, u, c, g, b) {
        this.permute(b, n, o, u, c, g);
        for (var _ = 1; _ < g; _ <<= 1)
          for (var p = _ << 1, s = Math.cos(2 * Math.PI / p), y = Math.sin(2 * Math.PI / p), T = 0; T < g; T += p)
            for (var P = s, z = y, J = 0; J < _; J++) {
              var Z = u[T + J], F = c[T + J], ee = u[T + J + _], re = c[T + J + _], de = P * ee - z * re;
              re = P * re + z * ee, ee = de, u[T + J] = Z + ee, c[T + J] = F + re, u[T + J + _] = Z - ee, c[T + J + _] = F - re, J !== p && (de = s * P - y * z, z = s * z + y * P, P = de);
            }
      }, C.prototype.guessLen13b = function(n, o) {
        var u = Math.max(o, n) | 1, c = u & 1, g = 0;
        for (u = u / 2 | 0; u; u = u >>> 1)
          g++;
        return 1 << g + 1 + c;
      }, C.prototype.conjugate = function(n, o, u) {
        if (!(u <= 1))
          for (var c = 0; c < u / 2; c++) {
            var g = n[c];
            n[c] = n[u - c - 1], n[u - c - 1] = g, g = o[c], o[c] = -o[u - c - 1], o[u - c - 1] = -g;
          }
      }, C.prototype.normalize13b = function(n, o) {
        for (var u = 0, c = 0; c < o / 2; c++) {
          var g = Math.round(n[2 * c + 1] / o) * 8192 + Math.round(n[2 * c] / o) + u;
          n[c] = g & 67108863, g < 67108864 ? u = 0 : u = g / 67108864 | 0;
        }
        return n;
      }, C.prototype.convert13b = function(n, o, u, c) {
        for (var g = 0, b = 0; b < o; b++)
          g = g + (n[b] | 0), u[2 * b] = g & 8191, g = g >>> 13, u[2 * b + 1] = g & 8191, g = g >>> 13;
        for (b = 2 * o; b < c; ++b)
          u[b] = 0;
        i(g === 0), i((g & -8192) === 0);
      }, C.prototype.stub = function(n) {
        for (var o = new Array(n), u = 0; u < n; u++)
          o[u] = 0;
        return o;
      }, C.prototype.mulp = function(n, o, u) {
        var c = 2 * this.guessLen13b(n.length, o.length), g = this.makeRBT(c), b = this.stub(c), _ = new Array(c), p = new Array(c), s = new Array(c), y = new Array(c), T = new Array(c), P = new Array(c), z = u.words;
        z.length = c, this.convert13b(n.words, n.length, _, c), this.convert13b(o.words, o.length, y, c), this.transform(_, b, p, s, c, g), this.transform(y, b, T, P, c, g);
        for (var J = 0; J < c; J++) {
          var Z = p[J] * T[J] - s[J] * P[J];
          s[J] = p[J] * P[J] + s[J] * T[J], p[J] = Z;
        }
        return this.conjugate(p, s, c), this.transform(p, s, z, b, c, g), this.conjugate(z, b, c), this.normalize13b(z, c), u.negative = n.negative ^ o.negative, u.length = n.length + o.length, u.strip();
      }, a.prototype.mul = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), this.mulTo(n, o);
      }, a.prototype.mulf = function(n) {
        var o = new a(null);
        return o.words = new Array(this.length + n.length), k(this, n, o);
      }, a.prototype.imul = function(n) {
        return this.clone().mulTo(n, this);
      }, a.prototype.imuln = function(n) {
        i(typeof n == "number"), i(n < 67108864);
        for (var o = 0, u = 0; u < this.length; u++) {
          var c = (this.words[u] | 0) * n, g = (c & 67108863) + (o & 67108863);
          o >>= 26, o += c / 67108864 | 0, o += g >>> 26, this.words[u] = g & 67108863;
        }
        return o !== 0 && (this.words[u] = o, this.length++), this;
      }, a.prototype.muln = function(n) {
        return this.clone().imuln(n);
      }, a.prototype.sqr = function() {
        return this.mul(this);
      }, a.prototype.isqr = function() {
        return this.imul(this.clone());
      }, a.prototype.pow = function(n) {
        var o = S(n);
        if (o.length === 0)
          return new a(1);
        for (var u = this, c = 0; c < o.length && o[c] === 0; c++, u = u.sqr())
          ;
        if (++c < o.length)
          for (var g = u.sqr(); c < o.length; c++, g = g.sqr())
            o[c] !== 0 && (u = u.mul(g));
        return u;
      }, a.prototype.iushln = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 67108863 >>> 26 - o << 26 - o, g;
        if (o !== 0) {
          var b = 0;
          for (g = 0; g < this.length; g++) {
            var _ = this.words[g] & c, p = (this.words[g] | 0) - _ << o;
            this.words[g] = p | b, b = _ >>> 26 - o;
          }
          b && (this.words[g] = b, this.length++);
        }
        if (u !== 0) {
          for (g = this.length - 1; g >= 0; g--)
            this.words[g + u] = this.words[g];
          for (g = 0; g < u; g++)
            this.words[g] = 0;
          this.length += u;
        }
        return this.strip();
      }, a.prototype.ishln = function(n) {
        return i(this.negative === 0), this.iushln(n);
      }, a.prototype.iushrn = function(n, o, u) {
        i(typeof n == "number" && n >= 0);
        var c;
        o ? c = (o - o % 26) / 26 : c = 0;
        var g = n % 26, b = Math.min((n - g) / 26, this.length), _ = 67108863 ^ 67108863 >>> g << g, p = u;
        if (c -= b, c = Math.max(0, c), p) {
          for (var s = 0; s < b; s++)
            p.words[s] = this.words[s];
          p.length = b;
        }
        if (b !== 0)
          if (this.length > b)
            for (this.length -= b, s = 0; s < this.length; s++)
              this.words[s] = this.words[s + b];
          else
            this.words[0] = 0, this.length = 1;
        var y = 0;
        for (s = this.length - 1; s >= 0 && (y !== 0 || s >= c); s--) {
          var T = this.words[s] | 0;
          this.words[s] = y << 26 - g | T >>> g, y = T & _;
        }
        return p && y !== 0 && (p.words[p.length++] = y), this.length === 0 && (this.words[0] = 0, this.length = 1), this.strip();
      }, a.prototype.ishrn = function(n, o, u) {
        return i(this.negative === 0), this.iushrn(n, o, u);
      }, a.prototype.shln = function(n) {
        return this.clone().ishln(n);
      }, a.prototype.ushln = function(n) {
        return this.clone().iushln(n);
      }, a.prototype.shrn = function(n) {
        return this.clone().ishrn(n);
      }, a.prototype.ushrn = function(n) {
        return this.clone().iushrn(n);
      }, a.prototype.testn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return !1;
        var g = this.words[u];
        return !!(g & c);
      }, a.prototype.imaskn = function(n) {
        i(typeof n == "number" && n >= 0);
        var o = n % 26, u = (n - o) / 26;
        if (i(this.negative === 0, "imaskn works only with positive numbers"), this.length <= u)
          return this;
        if (o !== 0 && u++, this.length = Math.min(u, this.length), o !== 0) {
          var c = 67108863 ^ 67108863 >>> o << o;
          this.words[this.length - 1] &= c;
        }
        return this.strip();
      }, a.prototype.maskn = function(n) {
        return this.clone().imaskn(n);
      }, a.prototype.iaddn = function(n) {
        return i(typeof n == "number"), i(n < 67108864), n < 0 ? this.isubn(-n) : this.negative !== 0 ? this.length === 1 && (this.words[0] | 0) < n ? (this.words[0] = n - (this.words[0] | 0), this.negative = 0, this) : (this.negative = 0, this.isubn(n), this.negative = 1, this) : this._iaddn(n);
      }, a.prototype._iaddn = function(n) {
        this.words[0] += n;
        for (var o = 0; o < this.length && this.words[o] >= 67108864; o++)
          this.words[o] -= 67108864, o === this.length - 1 ? this.words[o + 1] = 1 : this.words[o + 1]++;
        return this.length = Math.max(this.length, o + 1), this;
      }, a.prototype.isubn = function(n) {
        if (i(typeof n == "number"), i(n < 67108864), n < 0)
          return this.iaddn(-n);
        if (this.negative !== 0)
          return this.negative = 0, this.iaddn(n), this.negative = 1, this;
        if (this.words[0] -= n, this.length === 1 && this.words[0] < 0)
          this.words[0] = -this.words[0], this.negative = 1;
        else
          for (var o = 0; o < this.length && this.words[o] < 0; o++)
            this.words[o] += 67108864, this.words[o + 1] -= 1;
        return this.strip();
      }, a.prototype.addn = function(n) {
        return this.clone().iaddn(n);
      }, a.prototype.subn = function(n) {
        return this.clone().isubn(n);
      }, a.prototype.iabs = function() {
        return this.negative = 0, this;
      }, a.prototype.abs = function() {
        return this.clone().iabs();
      }, a.prototype._ishlnsubmul = function(n, o, u) {
        var c = n.length + u, g;
        this._expand(c);
        var b, _ = 0;
        for (g = 0; g < n.length; g++) {
          b = (this.words[g + u] | 0) + _;
          var p = (n.words[g] | 0) * o;
          b -= p & 67108863, _ = (b >> 26) - (p / 67108864 | 0), this.words[g + u] = b & 67108863;
        }
        for (; g < this.length - u; g++)
          b = (this.words[g + u] | 0) + _, _ = b >> 26, this.words[g + u] = b & 67108863;
        if (_ === 0)
          return this.strip();
        for (i(_ === -1), _ = 0, g = 0; g < this.length; g++)
          b = -(this.words[g] | 0) + _, _ = b >> 26, this.words[g] = b & 67108863;
        return this.negative = 1, this.strip();
      }, a.prototype._wordDiv = function(n, o) {
        var u = this.length - n.length, c = this.clone(), g = n, b = g.words[g.length - 1] | 0, _ = this._countBits(b);
        u = 26 - _, u !== 0 && (g = g.ushln(u), c.iushln(u), b = g.words[g.length - 1] | 0);
        var p = c.length - g.length, s;
        if (o !== "mod") {
          s = new a(null), s.length = p + 1, s.words = new Array(s.length);
          for (var y = 0; y < s.length; y++)
            s.words[y] = 0;
        }
        var T = c.clone()._ishlnsubmul(g, 1, p);
        T.negative === 0 && (c = T, s && (s.words[p] = 1));
        for (var P = p - 1; P >= 0; P--) {
          var z = (c.words[g.length + P] | 0) * 67108864 + (c.words[g.length + P - 1] | 0);
          for (z = Math.min(z / b | 0, 67108863), c._ishlnsubmul(g, z, P); c.negative !== 0; )
            z--, c.negative = 0, c._ishlnsubmul(g, 1, P), c.isZero() || (c.negative ^= 1);
          s && (s.words[P] = z);
        }
        return s && s.strip(), c.strip(), o !== "div" && u !== 0 && c.iushrn(u), {
          div: s || null,
          mod: c
        };
      }, a.prototype.divmod = function(n, o, u) {
        if (i(!n.isZero()), this.isZero())
          return {
            div: new a(0),
            mod: new a(0)
          };
        var c, g, b;
        return this.negative !== 0 && n.negative === 0 ? (b = this.neg().divmod(n, o), o !== "mod" && (c = b.div.neg()), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.iadd(n)), {
          div: c,
          mod: g
        }) : this.negative === 0 && n.negative !== 0 ? (b = this.divmod(n.neg(), o), o !== "mod" && (c = b.div.neg()), {
          div: c,
          mod: b.mod
        }) : this.negative & n.negative ? (b = this.neg().divmod(n.neg(), o), o !== "div" && (g = b.mod.neg(), u && g.negative !== 0 && g.isub(n)), {
          div: b.div,
          mod: g
        }) : n.length > this.length || this.cmp(n) < 0 ? {
          div: new a(0),
          mod: this
        } : n.length === 1 ? o === "div" ? {
          div: this.divn(n.words[0]),
          mod: null
        } : o === "mod" ? {
          div: null,
          mod: new a(this.modn(n.words[0]))
        } : {
          div: this.divn(n.words[0]),
          mod: new a(this.modn(n.words[0]))
        } : this._wordDiv(n, o);
      }, a.prototype.div = function(n) {
        return this.divmod(n, "div", !1).div;
      }, a.prototype.mod = function(n) {
        return this.divmod(n, "mod", !1).mod;
      }, a.prototype.umod = function(n) {
        return this.divmod(n, "mod", !0).mod;
      }, a.prototype.divRound = function(n) {
        var o = this.divmod(n);
        if (o.mod.isZero())
          return o.div;
        var u = o.div.negative !== 0 ? o.mod.isub(n) : o.mod, c = n.ushrn(1), g = n.andln(1), b = u.cmp(c);
        return b < 0 || g === 1 && b === 0 ? o.div : o.div.negative !== 0 ? o.div.isubn(1) : o.div.iaddn(1);
      }, a.prototype.modn = function(n) {
        i(n <= 67108863);
        for (var o = (1 << 26) % n, u = 0, c = this.length - 1; c >= 0; c--)
          u = (o * u + (this.words[c] | 0)) % n;
        return u;
      }, a.prototype.idivn = function(n) {
        i(n <= 67108863);
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = (this.words[u] | 0) + o * 67108864;
          this.words[u] = c / n | 0, o = c % n;
        }
        return this.strip();
      }, a.prototype.divn = function(n) {
        return this.clone().idivn(n);
      }, a.prototype.egcd = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = new a(0), _ = new a(1), p = 0; o.isEven() && u.isEven(); )
          o.iushrn(1), u.iushrn(1), ++p;
        for (var s = u.clone(), y = o.clone(); !o.isZero(); ) {
          for (var T = 0, P = 1; !(o.words[0] & P) && T < 26; ++T, P <<= 1)
            ;
          if (T > 0)
            for (o.iushrn(T); T-- > 0; )
              (c.isOdd() || g.isOdd()) && (c.iadd(s), g.isub(y)), c.iushrn(1), g.iushrn(1);
          for (var z = 0, J = 1; !(u.words[0] & J) && z < 26; ++z, J <<= 1)
            ;
          if (z > 0)
            for (u.iushrn(z); z-- > 0; )
              (b.isOdd() || _.isOdd()) && (b.iadd(s), _.isub(y)), b.iushrn(1), _.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(b), g.isub(_)) : (u.isub(o), b.isub(c), _.isub(g));
        }
        return {
          a: b,
          b: _,
          gcd: u.iushln(p)
        };
      }, a.prototype._invmp = function(n) {
        i(n.negative === 0), i(!n.isZero());
        var o = this, u = n.clone();
        o.negative !== 0 ? o = o.umod(n) : o = o.clone();
        for (var c = new a(1), g = new a(0), b = u.clone(); o.cmpn(1) > 0 && u.cmpn(1) > 0; ) {
          for (var _ = 0, p = 1; !(o.words[0] & p) && _ < 26; ++_, p <<= 1)
            ;
          if (_ > 0)
            for (o.iushrn(_); _-- > 0; )
              c.isOdd() && c.iadd(b), c.iushrn(1);
          for (var s = 0, y = 1; !(u.words[0] & y) && s < 26; ++s, y <<= 1)
            ;
          if (s > 0)
            for (u.iushrn(s); s-- > 0; )
              g.isOdd() && g.iadd(b), g.iushrn(1);
          o.cmp(u) >= 0 ? (o.isub(u), c.isub(g)) : (u.isub(o), g.isub(c));
        }
        var T;
        return o.cmpn(1) === 0 ? T = c : T = g, T.cmpn(0) < 0 && T.iadd(n), T;
      }, a.prototype.gcd = function(n) {
        if (this.isZero())
          return n.abs();
        if (n.isZero())
          return this.abs();
        var o = this.clone(), u = n.clone();
        o.negative = 0, u.negative = 0;
        for (var c = 0; o.isEven() && u.isEven(); c++)
          o.iushrn(1), u.iushrn(1);
        do {
          for (; o.isEven(); )
            o.iushrn(1);
          for (; u.isEven(); )
            u.iushrn(1);
          var g = o.cmp(u);
          if (g < 0) {
            var b = o;
            o = u, u = b;
          } else if (g === 0 || u.cmpn(1) === 0)
            break;
          o.isub(u);
        } while (!0);
        return u.iushln(c);
      }, a.prototype.invm = function(n) {
        return this.egcd(n).a.umod(n);
      }, a.prototype.isEven = function() {
        return (this.words[0] & 1) === 0;
      }, a.prototype.isOdd = function() {
        return (this.words[0] & 1) === 1;
      }, a.prototype.andln = function(n) {
        return this.words[0] & n;
      }, a.prototype.bincn = function(n) {
        i(typeof n == "number");
        var o = n % 26, u = (n - o) / 26, c = 1 << o;
        if (this.length <= u)
          return this._expand(u + 1), this.words[u] |= c, this;
        for (var g = c, b = u; g !== 0 && b < this.length; b++) {
          var _ = this.words[b] | 0;
          _ += g, g = _ >>> 26, _ &= 67108863, this.words[b] = _;
        }
        return g !== 0 && (this.words[b] = g, this.length++), this;
      }, a.prototype.isZero = function() {
        return this.length === 1 && this.words[0] === 0;
      }, a.prototype.cmpn = function(n) {
        var o = n < 0;
        if (this.negative !== 0 && !o)
          return -1;
        if (this.negative === 0 && o)
          return 1;
        this.strip();
        var u;
        if (this.length > 1)
          u = 1;
        else {
          o && (n = -n), i(n <= 67108863, "Number is too big");
          var c = this.words[0] | 0;
          u = c === n ? 0 : c < n ? -1 : 1;
        }
        return this.negative !== 0 ? -u | 0 : u;
      }, a.prototype.cmp = function(n) {
        if (this.negative !== 0 && n.negative === 0)
          return -1;
        if (this.negative === 0 && n.negative !== 0)
          return 1;
        var o = this.ucmp(n);
        return this.negative !== 0 ? -o | 0 : o;
      }, a.prototype.ucmp = function(n) {
        if (this.length > n.length)
          return 1;
        if (this.length < n.length)
          return -1;
        for (var o = 0, u = this.length - 1; u >= 0; u--) {
          var c = this.words[u] | 0, g = n.words[u] | 0;
          if (c !== g) {
            c < g ? o = -1 : c > g && (o = 1);
            break;
          }
        }
        return o;
      }, a.prototype.gtn = function(n) {
        return this.cmpn(n) === 1;
      }, a.prototype.gt = function(n) {
        return this.cmp(n) === 1;
      }, a.prototype.gten = function(n) {
        return this.cmpn(n) >= 0;
      }, a.prototype.gte = function(n) {
        return this.cmp(n) >= 0;
      }, a.prototype.ltn = function(n) {
        return this.cmpn(n) === -1;
      }, a.prototype.lt = function(n) {
        return this.cmp(n) === -1;
      }, a.prototype.lten = function(n) {
        return this.cmpn(n) <= 0;
      }, a.prototype.lte = function(n) {
        return this.cmp(n) <= 0;
      }, a.prototype.eqn = function(n) {
        return this.cmpn(n) === 0;
      }, a.prototype.eq = function(n) {
        return this.cmp(n) === 0;
      }, a.red = function(n) {
        return new te(n);
      }, a.prototype.toRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), i(this.negative === 0, "red works only with positives"), n.convertTo(this)._forceRed(n);
      }, a.prototype.fromRed = function() {
        return i(this.red, "fromRed works only with numbers in reduction context"), this.red.convertFrom(this);
      }, a.prototype._forceRed = function(n) {
        return this.red = n, this;
      }, a.prototype.forceRed = function(n) {
        return i(!this.red, "Already a number in reduction context"), this._forceRed(n);
      }, a.prototype.redAdd = function(n) {
        return i(this.red, "redAdd works only with red numbers"), this.red.add(this, n);
      }, a.prototype.redIAdd = function(n) {
        return i(this.red, "redIAdd works only with red numbers"), this.red.iadd(this, n);
      }, a.prototype.redSub = function(n) {
        return i(this.red, "redSub works only with red numbers"), this.red.sub(this, n);
      }, a.prototype.redISub = function(n) {
        return i(this.red, "redISub works only with red numbers"), this.red.isub(this, n);
      }, a.prototype.redShl = function(n) {
        return i(this.red, "redShl works only with red numbers"), this.red.shl(this, n);
      }, a.prototype.redMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.mul(this, n);
      }, a.prototype.redIMul = function(n) {
        return i(this.red, "redMul works only with red numbers"), this.red._verify2(this, n), this.red.imul(this, n);
      }, a.prototype.redSqr = function() {
        return i(this.red, "redSqr works only with red numbers"), this.red._verify1(this), this.red.sqr(this);
      }, a.prototype.redISqr = function() {
        return i(this.red, "redISqr works only with red numbers"), this.red._verify1(this), this.red.isqr(this);
      }, a.prototype.redSqrt = function() {
        return i(this.red, "redSqrt works only with red numbers"), this.red._verify1(this), this.red.sqrt(this);
      }, a.prototype.redInvm = function() {
        return i(this.red, "redInvm works only with red numbers"), this.red._verify1(this), this.red.invm(this);
      }, a.prototype.redNeg = function() {
        return i(this.red, "redNeg works only with red numbers"), this.red._verify1(this), this.red.neg(this);
      }, a.prototype.redPow = function(n) {
        return i(this.red && !n.red, "redPow(normalNum)"), this.red._verify1(this), this.red.pow(this, n);
      };
      var I = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
      };
      function O(x, n) {
        this.name = x, this.p = new a(n, 16), this.n = this.p.bitLength(), this.k = new a(1).iushln(this.n).isub(this.p), this.tmp = this._tmp();
      }
      O.prototype._tmp = function() {
        var n = new a(null);
        return n.words = new Array(Math.ceil(this.n / 13)), n;
      }, O.prototype.ireduce = function(n) {
        var o = n, u;
        do
          this.split(o, this.tmp), o = this.imulK(o), o = o.iadd(this.tmp), u = o.bitLength();
        while (u > this.n);
        var c = u < this.n ? -1 : o.ucmp(this.p);
        return c === 0 ? (o.words[0] = 0, o.length = 1) : c > 0 ? o.isub(this.p) : o.strip !== void 0 ? o.strip() : o._strip(), o;
      }, O.prototype.split = function(n, o) {
        n.iushrn(this.n, 0, o);
      }, O.prototype.imulK = function(n) {
        return n.imul(this.k);
      };
      function q() {
        O.call(
          this,
          "k256",
          "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f"
        );
      }
      f(q, O), q.prototype.split = function(n, o) {
        for (var u = 4194303, c = Math.min(n.length, 9), g = 0; g < c; g++)
          o.words[g] = n.words[g];
        if (o.length = c, n.length <= 9) {
          n.words[0] = 0, n.length = 1;
          return;
        }
        var b = n.words[9];
        for (o.words[o.length++] = b & u, g = 10; g < n.length; g++) {
          var _ = n.words[g] | 0;
          n.words[g - 10] = (_ & u) << 4 | b >>> 22, b = _;
        }
        b >>>= 22, n.words[g - 10] = b, b === 0 && n.length > 10 ? n.length -= 10 : n.length -= 9;
      }, q.prototype.imulK = function(n) {
        n.words[n.length] = 0, n.words[n.length + 1] = 0, n.length += 2;
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = n.words[u] | 0;
          o += c * 977, n.words[u] = o & 67108863, o = c * 64 + (o / 67108864 | 0);
        }
        return n.words[n.length - 1] === 0 && (n.length--, n.words[n.length - 1] === 0 && n.length--), n;
      };
      function $() {
        O.call(
          this,
          "p224",
          "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001"
        );
      }
      f($, O);
      function ae() {
        O.call(
          this,
          "p192",
          "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff"
        );
      }
      f(ae, O);
      function he() {
        O.call(
          this,
          "25519",
          "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed"
        );
      }
      f(he, O), he.prototype.imulK = function(n) {
        for (var o = 0, u = 0; u < n.length; u++) {
          var c = (n.words[u] | 0) * 19 + o, g = c & 67108863;
          c >>>= 26, n.words[u] = g, o = c;
        }
        return o !== 0 && (n.words[n.length++] = o), n;
      }, a._prime = function(n) {
        if (I[n])
          return I[n];
        var o;
        if (n === "k256")
          o = new q();
        else if (n === "p224")
          o = new $();
        else if (n === "p192")
          o = new ae();
        else if (n === "p25519")
          o = new he();
        else
          throw new Error("Unknown prime " + n);
        return I[n] = o, o;
      };
      function te(x) {
        if (typeof x == "string") {
          var n = a._prime(x);
          this.m = n.p, this.prime = n;
        } else
          i(x.gtn(1), "modulus must be greater than 1"), this.m = x, this.prime = null;
      }
      te.prototype._verify1 = function(n) {
        i(n.negative === 0, "red works only with positives"), i(n.red, "red works only with red numbers");
      }, te.prototype._verify2 = function(n, o) {
        i((n.negative | o.negative) === 0, "red works only with positives"), i(
          n.red && n.red === o.red,
          "red works only with red numbers"
        );
      }, te.prototype.imod = function(n) {
        return this.prime ? this.prime.ireduce(n)._forceRed(this) : n.umod(this.m)._forceRed(this);
      }, te.prototype.neg = function(n) {
        return n.isZero() ? n.clone() : this.m.sub(n)._forceRed(this);
      }, te.prototype.add = function(n, o) {
        this._verify2(n, o);
        var u = n.add(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u._forceRed(this);
      }, te.prototype.iadd = function(n, o) {
        this._verify2(n, o);
        var u = n.iadd(o);
        return u.cmp(this.m) >= 0 && u.isub(this.m), u;
      }, te.prototype.sub = function(n, o) {
        this._verify2(n, o);
        var u = n.sub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u._forceRed(this);
      }, te.prototype.isub = function(n, o) {
        this._verify2(n, o);
        var u = n.isub(o);
        return u.cmpn(0) < 0 && u.iadd(this.m), u;
      }, te.prototype.shl = function(n, o) {
        return this._verify1(n), this.imod(n.ushln(o));
      }, te.prototype.imul = function(n, o) {
        return this._verify2(n, o), this.imod(n.imul(o));
      }, te.prototype.mul = function(n, o) {
        return this._verify2(n, o), this.imod(n.mul(o));
      }, te.prototype.isqr = function(n) {
        return this.imul(n, n.clone());
      }, te.prototype.sqr = function(n) {
        return this.mul(n, n);
      }, te.prototype.sqrt = function(n) {
        if (n.isZero())
          return n.clone();
        var o = this.m.andln(3);
        if (i(o % 2 === 1), o === 3) {
          var u = this.m.add(new a(1)).iushrn(2);
          return this.pow(n, u);
        }
        for (var c = this.m.subn(1), g = 0; !c.isZero() && c.andln(1) === 0; )
          g++, c.iushrn(1);
        i(!c.isZero());
        var b = new a(1).toRed(this), _ = b.redNeg(), p = this.m.subn(1).iushrn(1), s = this.m.bitLength();
        for (s = new a(2 * s * s).toRed(this); this.pow(s, p).cmp(_) !== 0; )
          s.redIAdd(_);
        for (var y = this.pow(s, c), T = this.pow(n, c.addn(1).iushrn(1)), P = this.pow(n, c), z = g; P.cmp(b) !== 0; ) {
          for (var J = P, Z = 0; J.cmp(b) !== 0; Z++)
            J = J.redSqr();
          i(Z < z);
          var F = this.pow(y, new a(1).iushln(z - Z - 1));
          T = T.redMul(F), y = F.redSqr(), P = P.redMul(y), z = Z;
        }
        return T;
      }, te.prototype.invm = function(n) {
        var o = n._invmp(this.m);
        return o.negative !== 0 ? (o.negative = 0, this.imod(o).redNeg()) : this.imod(o);
      }, te.prototype.pow = function(n, o) {
        if (o.isZero())
          return new a(1).toRed(this);
        if (o.cmpn(1) === 0)
          return n.clone();
        var u = 4, c = new Array(1 << u);
        c[0] = new a(1).toRed(this), c[1] = n;
        for (var g = 2; g < c.length; g++)
          c[g] = this.mul(c[g - 1], n);
        var b = c[0], _ = 0, p = 0, s = o.bitLength() % 26;
        for (s === 0 && (s = 26), g = o.length - 1; g >= 0; g--) {
          for (var y = o.words[g], T = s - 1; T >= 0; T--) {
            var P = y >> T & 1;
            if (b !== c[0] && (b = this.sqr(b)), P === 0 && _ === 0) {
              p = 0;
              continue;
            }
            _ <<= 1, _ |= P, p++, !(p !== u && (g !== 0 || T !== 0)) && (b = this.mul(b, c[_]), p = 0, _ = 0);
          }
          s = 26;
        }
        return b;
      }, te.prototype.convertTo = function(n) {
        var o = n.umod(this.m);
        return o === n ? o.clone() : o;
      }, te.prototype.convertFrom = function(n) {
        var o = n.clone();
        return o.red = null, o;
      }, a.mont = function(n) {
        return new Ee(n);
      };
      function Ee(x) {
        te.call(this, x), this.shift = this.m.bitLength(), this.shift % 26 !== 0 && (this.shift += 26 - this.shift % 26), this.r = new a(1).iushln(this.shift), this.r2 = this.imod(this.r.sqr()), this.rinv = this.r._invmp(this.m), this.minv = this.rinv.mul(this.r).isubn(1).div(this.m), this.minv = this.minv.umod(this.r), this.minv = this.r.sub(this.minv);
      }
      f(Ee, te), Ee.prototype.convertTo = function(n) {
        return this.imod(n.ushln(this.shift));
      }, Ee.prototype.convertFrom = function(n) {
        var o = this.imod(n.mul(this.rinv));
        return o.red = null, o;
      }, Ee.prototype.imul = function(n, o) {
        if (n.isZero() || o.isZero())
          return n.words[0] = 0, n.length = 1, n;
        var u = n.imul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.mul = function(n, o) {
        if (n.isZero() || o.isZero())
          return new a(0)._forceRed(this);
        var u = n.mul(o), c = u.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m), g = u.isub(c).iushrn(this.shift), b = g;
        return g.cmp(this.m) >= 0 ? b = g.isub(this.m) : g.cmpn(0) < 0 && (b = g.iadd(this.m)), b._forceRed(this);
      }, Ee.prototype.invm = function(n) {
        var o = this.imod(n._invmp(this.m).mul(this.r2));
        return o._forceRed(this);
      };
    })(t, ut);
  }(el)), el.exports;
}
var $p, nw;
function y_() {
  if (nw)
    return $p;
  nw = 1;
  var t = Im(), e = Vt().Buffer;
  function r(i, f) {
    return e.from(i.toRed(t.mont(f.modulus)).redPow(new t(f.publicExponent)).fromRed().toArray());
  }
  return $p = r, $p;
}
var Vp, iw;
function ZR() {
  if (iw)
    return Vp;
  iw = 1;
  var t = xc(), e = go(), r = Hf(), i = m_(), f = g_(), a = Im(), l = y_(), d = km(), v = Vt().Buffer;
  Vp = function(S, E, A) {
    var B;
    S.padding ? B = S.padding : A ? B = 1 : B = 4;
    var k = t(S), C;
    if (B === 4)
      C = m(k, E);
    else if (B === 1)
      C = h(k, E, A);
    else if (B === 3) {
      if (C = new a(E), C.cmp(k.modulus) >= 0)
        throw new Error("data too long for modulus");
    } else
      throw new Error("unknown padding");
    return A ? d(C, k) : l(C, k);
  };
  function m(M, S) {
    var E = M.modulus.byteLength(), A = S.length, B = r("sha1").update(v.alloc(0)).digest(), k = B.length, C = 2 * k;
    if (A > E - C - 2)
      throw new Error("message too long");
    var I = v.alloc(E - A - C - 2), O = E - k - 1, q = e(k), $ = f(v.concat([B, I, v.alloc(1, 1), S], O), i(q, O)), ae = f(q, i($, k));
    return new a(v.concat([v.alloc(1), ae, $], E));
  }
  function h(M, S, E) {
    var A = S.length, B = M.modulus.byteLength();
    if (A > B - 11)
      throw new Error("message too long");
    var k;
    return E ? k = v.alloc(B - A - 3, 255) : k = w(B - A - 3), new a(v.concat([v.from([0, E ? 1 : 2]), k, v.alloc(1), S], B));
  }
  function w(M) {
    for (var S = v.allocUnsafe(M), E = 0, A = e(M * 2), B = 0, k; E < M; )
      B === A.length && (A = e(M * 2), B = 0), k = A[B++], k && (S[E++] = k);
    return S;
  }
  return Vp;
}
var Hp, aw;
function GR() {
  if (aw)
    return Hp;
  aw = 1;
  var t = xc(), e = m_(), r = g_(), i = Im(), f = km(), a = Hf(), l = y_(), d = Vt().Buffer;
  Hp = function(M, S, E) {
    var A;
    M.padding ? A = M.padding : E ? A = 1 : A = 4;
    var B = t(M), k = B.modulus.byteLength();
    if (S.length > k || new i(S).cmp(B.modulus) >= 0)
      throw new Error("decryption error");
    var C;
    E ? C = l(new i(S), B) : C = f(S, B);
    var I = d.alloc(k - C.length);
    if (C = d.concat([I, C], k), A === 4)
      return v(B, C);
    if (A === 1)
      return m(B, C, E);
    if (A === 3)
      return C;
    throw new Error("unknown padding");
  };
  function v(w, M) {
    var S = w.modulus.byteLength(), E = a("sha1").update(d.alloc(0)).digest(), A = E.length;
    if (M[0] !== 0)
      throw new Error("decryption error");
    var B = M.slice(1, A + 1), k = M.slice(A + 1), C = r(B, e(k, A)), I = r(k, e(C, S - A - 1));
    if (h(E, I.slice(0, A)))
      throw new Error("decryption error");
    for (var O = A; I[O] === 0; )
      O++;
    if (I[O++] !== 1)
      throw new Error("decryption error");
    return I.slice(O);
  }
  function m(w, M, S) {
    for (var E = M.slice(0, 2), A = 2, B = 0; M[A++] !== 0; )
      if (A >= M.length) {
        B++;
        break;
      }
    var k = M.slice(2, A - 1);
    if ((E.toString("hex") !== "0002" && !S || E.toString("hex") !== "0001" && S) && B++, k.length < 8 && B++, B)
      throw new Error("decryption error");
    return M.slice(A);
  }
  function h(w, M) {
    w = d.from(w), M = d.from(M);
    var S = 0, E = w.length;
    w.length !== M.length && (S++, E = Math.min(w.length, M.length));
    for (var A = -1; ++A < E; )
      S += w[A] ^ M[A];
    return S;
  }
  return Hp;
}
var sw;
function QR() {
  return sw || (sw = 1, function(t) {
    t.publicEncrypt = ZR(), t.privateDecrypt = GR(), t.privateEncrypt = function(r, i) {
      return t.publicEncrypt(r, i, !0);
    }, t.publicDecrypt = function(r, i) {
      return t.privateDecrypt(r, i, !0);
    };
  }(qp)), qp;
}
var ws = {}, ow;
function YR() {
  if (ow)
    return ws;
  ow = 1;
  function t() {
    throw new Error(`secure random number generation not supported by this browser
use chrome, FireFox or Internet Explorer 11`);
  }
  var e = Vt(), r = go(), i = e.Buffer, f = e.kMaxLength, a = ut.crypto || ut.msCrypto, l = Math.pow(2, 32) - 1;
  function d(M, S) {
    if (typeof M != "number" || M !== M)
      throw new TypeError("offset must be a number");
    if (M > l || M < 0)
      throw new TypeError("offset must be a uint32");
    if (M > f || M > S)
      throw new RangeError("offset out of range");
  }
  function v(M, S, E) {
    if (typeof M != "number" || M !== M)
      throw new TypeError("size must be a number");
    if (M > l || M < 0)
      throw new TypeError("size must be a uint32");
    if (M + S > E || M > f)
      throw new RangeError("buffer too small");
  }
  a && a.getRandomValues || !It.browser ? (ws.randomFill = m, ws.randomFillSync = w) : (ws.randomFill = t, ws.randomFillSync = t);
  function m(M, S, E, A) {
    if (!i.isBuffer(M) && !(M instanceof ut.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof S == "function")
      A = S, S = 0, E = M.length;
    else if (typeof E == "function")
      A = E, E = M.length - S;
    else if (typeof A != "function")
      throw new TypeError('"cb" argument must be a function');
    return d(S, M.length), v(E, S, M.length), h(M, S, E, A);
  }
  function h(M, S, E, A) {
    if (It.browser) {
      var B = M.buffer, k = new Uint8Array(B, S, E);
      if (a.getRandomValues(k), A) {
        It.nextTick(function() {
          A(null, M);
        });
        return;
      }
      return M;
    }
    if (A) {
      r(E, function(I, O) {
        if (I)
          return A(I);
        O.copy(M, S), A(null, M);
      });
      return;
    }
    var C = r(E);
    return C.copy(M, S), M;
  }
  function w(M, S, E) {
    if (typeof S > "u" && (S = 0), !i.isBuffer(M) && !(M instanceof ut.Uint8Array))
      throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    return d(S, M.length), E === void 0 && (E = M.length - S), v(E, S, M.length), h(M, S, E);
  }
  return ws;
}
var fw;
function b_() {
  if (fw)
    return zt;
  fw = 1, zt.randomBytes = zt.rng = zt.pseudoRandomBytes = zt.prng = go(), zt.createHash = zt.Hash = Hf(), zt.createHmac = zt.Hmac = L8();
  var t = zB(), e = Object.keys(t), r = ["sha1", "sha224", "sha256", "sha384", "sha512", "md5", "rmd160"].concat(e);
  zt.getHashes = function() {
    return r;
  };
  var i = V8();
  zt.pbkdf2 = i.pbkdf2, zt.pbkdf2Sync = i.pbkdf2Sync;
  var f = sI();
  zt.Cipher = f.Cipher, zt.createCipher = f.createCipher, zt.Cipheriv = f.Cipheriv, zt.createCipheriv = f.createCipheriv, zt.Decipher = f.Decipher, zt.createDecipher = f.createDecipher, zt.Decipheriv = f.Decipheriv, zt.createDecipheriv = f.createDecipheriv, zt.getCiphers = f.getCiphers, zt.listCiphers = f.listCiphers;
  var a = yI();
  zt.DiffieHellmanGroup = a.DiffieHellmanGroup, zt.createDiffieHellmanGroup = a.createDiffieHellmanGroup, zt.getDiffieHellman = a.getDiffieHellman, zt.createDiffieHellman = a.createDiffieHellman, zt.DiffieHellman = a.DiffieHellman;
  var l = bR();
  zt.createSign = l.createSign, zt.Sign = l.Sign, zt.createVerify = l.createVerify, zt.Verify = l.Verify, zt.createECDH = KR();
  var d = QR();
  zt.publicEncrypt = d.publicEncrypt, zt.privateEncrypt = d.privateEncrypt, zt.publicDecrypt = d.publicDecrypt, zt.privateDecrypt = d.privateDecrypt;
  var v = YR();
  return zt.randomFill = v.randomFill, zt.randomFillSync = v.randomFillSync, zt.createCredentials = function() {
    throw new Error([
      "sorry, createCredentials is not implemented yet",
      "we accept pull requests",
      "https://github.com/crypto-browserify/crypto-browserify"
    ].join(`
`));
  }, zt.constants = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
  }, zt;
}
(function(t) {
  (function(e) {
    var r = function(K) {
      var W, G = new Float64Array(16);
      if (K)
        for (W = 0; W < K.length; W++)
          G[W] = K[W];
      return G;
    }, i = function() {
      throw new Error("no PRNG");
    }, f = new Uint8Array(16), a = new Uint8Array(32);
    a[0] = 9;
    var l = r(), d = r([1]), v = r([56129, 1]), m = r([30883, 4953, 19914, 30187, 55467, 16705, 2637, 112, 59544, 30585, 16505, 36039, 65139, 11119, 27886, 20995]), h = r([61785, 9906, 39828, 60374, 45398, 33411, 5274, 224, 53552, 61171, 33010, 6542, 64743, 22239, 55772, 9222]), w = r([54554, 36645, 11616, 51542, 42930, 38181, 51040, 26924, 56412, 64982, 57905, 49316, 21502, 52590, 14035, 8553]), M = r([26200, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214, 26214]), S = r([41136, 18958, 6951, 50414, 58488, 44335, 6150, 12099, 55207, 15867, 153, 11085, 57099, 20417, 9344, 11139]);
    function E(K, W, G, U) {
      K[W] = G >> 24 & 255, K[W + 1] = G >> 16 & 255, K[W + 2] = G >> 8 & 255, K[W + 3] = G & 255, K[W + 4] = U >> 24 & 255, K[W + 5] = U >> 16 & 255, K[W + 6] = U >> 8 & 255, K[W + 7] = U & 255;
    }
    function A(K, W, G, U, X) {
      var H, ye = 0;
      for (H = 0; H < X; H++)
        ye |= K[W + H] ^ G[U + H];
      return (1 & ye - 1 >>> 8) - 1;
    }
    function B(K, W, G, U) {
      return A(K, W, G, U, 16);
    }
    function k(K, W, G, U) {
      return A(K, W, G, U, 32);
    }
    function C(K, W, G, U) {
      for (var X = U[0] & 255 | (U[1] & 255) << 8 | (U[2] & 255) << 16 | (U[3] & 255) << 24, H = G[0] & 255 | (G[1] & 255) << 8 | (G[2] & 255) << 16 | (G[3] & 255) << 24, ye = G[4] & 255 | (G[5] & 255) << 8 | (G[6] & 255) << 16 | (G[7] & 255) << 24, ce = G[8] & 255 | (G[9] & 255) << 8 | (G[10] & 255) << 16 | (G[11] & 255) << 24, we = G[12] & 255 | (G[13] & 255) << 8 | (G[14] & 255) << 16 | (G[15] & 255) << 24, Qe = U[4] & 255 | (U[5] & 255) << 8 | (U[6] & 255) << 16 | (U[7] & 255) << 24, Ze = W[0] & 255 | (W[1] & 255) << 8 | (W[2] & 255) << 16 | (W[3] & 255) << 24, lt = W[4] & 255 | (W[5] & 255) << 8 | (W[6] & 255) << 16 | (W[7] & 255) << 24, Xe = W[8] & 255 | (W[9] & 255) << 8 | (W[10] & 255) << 16 | (W[11] & 255) << 24, ht = W[12] & 255 | (W[13] & 255) << 8 | (W[14] & 255) << 16 | (W[15] & 255) << 24, ct = U[8] & 255 | (U[9] & 255) << 8 | (U[10] & 255) << 16 | (U[11] & 255) << 24, pt = G[16] & 255 | (G[17] & 255) << 8 | (G[18] & 255) << 16 | (G[19] & 255) << 24, yt = G[20] & 255 | (G[21] & 255) << 8 | (G[22] & 255) << 16 | (G[23] & 255) << 24, bt = G[24] & 255 | (G[25] & 255) << 8 | (G[26] & 255) << 16 | (G[27] & 255) << 24, wt = G[28] & 255 | (G[29] & 255) << 8 | (G[30] & 255) << 16 | (G[31] & 255) << 24, mt = U[12] & 255 | (U[13] & 255) << 8 | (U[14] & 255) << 16 | (U[15] & 255) << 24, ft = X, gt = H, at = ye, dt = ce, ve = we, D = Qe, j = Ze, Y = lt, me = Xe, pe = ht, Pe = ct, Re = pt, nt = yt, ot = bt, _t = wt, Pt = mt, Ae, Ft = 0; Ft < 20; Ft += 2)
        Ae = ft + nt | 0, ve ^= Ae << 7 | Ae >>> 25, Ae = ve + ft | 0, me ^= Ae << 9 | Ae >>> 23, Ae = me + ve | 0, nt ^= Ae << 13 | Ae >>> 19, Ae = nt + me | 0, ft ^= Ae << 18 | Ae >>> 14, Ae = D + gt | 0, pe ^= Ae << 7 | Ae >>> 25, Ae = pe + D | 0, ot ^= Ae << 9 | Ae >>> 23, Ae = ot + pe | 0, gt ^= Ae << 13 | Ae >>> 19, Ae = gt + ot | 0, D ^= Ae << 18 | Ae >>> 14, Ae = Pe + j | 0, _t ^= Ae << 7 | Ae >>> 25, Ae = _t + Pe | 0, at ^= Ae << 9 | Ae >>> 23, Ae = at + _t | 0, j ^= Ae << 13 | Ae >>> 19, Ae = j + at | 0, Pe ^= Ae << 18 | Ae >>> 14, Ae = Pt + Re | 0, dt ^= Ae << 7 | Ae >>> 25, Ae = dt + Pt | 0, Y ^= Ae << 9 | Ae >>> 23, Ae = Y + dt | 0, Re ^= Ae << 13 | Ae >>> 19, Ae = Re + Y | 0, Pt ^= Ae << 18 | Ae >>> 14, Ae = ft + dt | 0, gt ^= Ae << 7 | Ae >>> 25, Ae = gt + ft | 0, at ^= Ae << 9 | Ae >>> 23, Ae = at + gt | 0, dt ^= Ae << 13 | Ae >>> 19, Ae = dt + at | 0, ft ^= Ae << 18 | Ae >>> 14, Ae = D + ve | 0, j ^= Ae << 7 | Ae >>> 25, Ae = j + D | 0, Y ^= Ae << 9 | Ae >>> 23, Ae = Y + j | 0, ve ^= Ae << 13 | Ae >>> 19, Ae = ve + Y | 0, D ^= Ae << 18 | Ae >>> 14, Ae = Pe + pe | 0, Re ^= Ae << 7 | Ae >>> 25, Ae = Re + Pe | 0, me ^= Ae << 9 | Ae >>> 23, Ae = me + Re | 0, pe ^= Ae << 13 | Ae >>> 19, Ae = pe + me | 0, Pe ^= Ae << 18 | Ae >>> 14, Ae = Pt + _t | 0, nt ^= Ae << 7 | Ae >>> 25, Ae = nt + Pt | 0, ot ^= Ae << 9 | Ae >>> 23, Ae = ot + nt | 0, _t ^= Ae << 13 | Ae >>> 19, Ae = _t + ot | 0, Pt ^= Ae << 18 | Ae >>> 14;
      ft = ft + X | 0, gt = gt + H | 0, at = at + ye | 0, dt = dt + ce | 0, ve = ve + we | 0, D = D + Qe | 0, j = j + Ze | 0, Y = Y + lt | 0, me = me + Xe | 0, pe = pe + ht | 0, Pe = Pe + ct | 0, Re = Re + pt | 0, nt = nt + yt | 0, ot = ot + bt | 0, _t = _t + wt | 0, Pt = Pt + mt | 0, K[0] = ft >>> 0 & 255, K[1] = ft >>> 8 & 255, K[2] = ft >>> 16 & 255, K[3] = ft >>> 24 & 255, K[4] = gt >>> 0 & 255, K[5] = gt >>> 8 & 255, K[6] = gt >>> 16 & 255, K[7] = gt >>> 24 & 255, K[8] = at >>> 0 & 255, K[9] = at >>> 8 & 255, K[10] = at >>> 16 & 255, K[11] = at >>> 24 & 255, K[12] = dt >>> 0 & 255, K[13] = dt >>> 8 & 255, K[14] = dt >>> 16 & 255, K[15] = dt >>> 24 & 255, K[16] = ve >>> 0 & 255, K[17] = ve >>> 8 & 255, K[18] = ve >>> 16 & 255, K[19] = ve >>> 24 & 255, K[20] = D >>> 0 & 255, K[21] = D >>> 8 & 255, K[22] = D >>> 16 & 255, K[23] = D >>> 24 & 255, K[24] = j >>> 0 & 255, K[25] = j >>> 8 & 255, K[26] = j >>> 16 & 255, K[27] = j >>> 24 & 255, K[28] = Y >>> 0 & 255, K[29] = Y >>> 8 & 255, K[30] = Y >>> 16 & 255, K[31] = Y >>> 24 & 255, K[32] = me >>> 0 & 255, K[33] = me >>> 8 & 255, K[34] = me >>> 16 & 255, K[35] = me >>> 24 & 255, K[36] = pe >>> 0 & 255, K[37] = pe >>> 8 & 255, K[38] = pe >>> 16 & 255, K[39] = pe >>> 24 & 255, K[40] = Pe >>> 0 & 255, K[41] = Pe >>> 8 & 255, K[42] = Pe >>> 16 & 255, K[43] = Pe >>> 24 & 255, K[44] = Re >>> 0 & 255, K[45] = Re >>> 8 & 255, K[46] = Re >>> 16 & 255, K[47] = Re >>> 24 & 255, K[48] = nt >>> 0 & 255, K[49] = nt >>> 8 & 255, K[50] = nt >>> 16 & 255, K[51] = nt >>> 24 & 255, K[52] = ot >>> 0 & 255, K[53] = ot >>> 8 & 255, K[54] = ot >>> 16 & 255, K[55] = ot >>> 24 & 255, K[56] = _t >>> 0 & 255, K[57] = _t >>> 8 & 255, K[58] = _t >>> 16 & 255, K[59] = _t >>> 24 & 255, K[60] = Pt >>> 0 & 255, K[61] = Pt >>> 8 & 255, K[62] = Pt >>> 16 & 255, K[63] = Pt >>> 24 & 255;
    }
    function I(K, W, G, U) {
      for (var X = U[0] & 255 | (U[1] & 255) << 8 | (U[2] & 255) << 16 | (U[3] & 255) << 24, H = G[0] & 255 | (G[1] & 255) << 8 | (G[2] & 255) << 16 | (G[3] & 255) << 24, ye = G[4] & 255 | (G[5] & 255) << 8 | (G[6] & 255) << 16 | (G[7] & 255) << 24, ce = G[8] & 255 | (G[9] & 255) << 8 | (G[10] & 255) << 16 | (G[11] & 255) << 24, we = G[12] & 255 | (G[13] & 255) << 8 | (G[14] & 255) << 16 | (G[15] & 255) << 24, Qe = U[4] & 255 | (U[5] & 255) << 8 | (U[6] & 255) << 16 | (U[7] & 255) << 24, Ze = W[0] & 255 | (W[1] & 255) << 8 | (W[2] & 255) << 16 | (W[3] & 255) << 24, lt = W[4] & 255 | (W[5] & 255) << 8 | (W[6] & 255) << 16 | (W[7] & 255) << 24, Xe = W[8] & 255 | (W[9] & 255) << 8 | (W[10] & 255) << 16 | (W[11] & 255) << 24, ht = W[12] & 255 | (W[13] & 255) << 8 | (W[14] & 255) << 16 | (W[15] & 255) << 24, ct = U[8] & 255 | (U[9] & 255) << 8 | (U[10] & 255) << 16 | (U[11] & 255) << 24, pt = G[16] & 255 | (G[17] & 255) << 8 | (G[18] & 255) << 16 | (G[19] & 255) << 24, yt = G[20] & 255 | (G[21] & 255) << 8 | (G[22] & 255) << 16 | (G[23] & 255) << 24, bt = G[24] & 255 | (G[25] & 255) << 8 | (G[26] & 255) << 16 | (G[27] & 255) << 24, wt = G[28] & 255 | (G[29] & 255) << 8 | (G[30] & 255) << 16 | (G[31] & 255) << 24, mt = U[12] & 255 | (U[13] & 255) << 8 | (U[14] & 255) << 16 | (U[15] & 255) << 24, ft = X, gt = H, at = ye, dt = ce, ve = we, D = Qe, j = Ze, Y = lt, me = Xe, pe = ht, Pe = ct, Re = pt, nt = yt, ot = bt, _t = wt, Pt = mt, Ae, Ft = 0; Ft < 20; Ft += 2)
        Ae = ft + nt | 0, ve ^= Ae << 7 | Ae >>> 25, Ae = ve + ft | 0, me ^= Ae << 9 | Ae >>> 23, Ae = me + ve | 0, nt ^= Ae << 13 | Ae >>> 19, Ae = nt + me | 0, ft ^= Ae << 18 | Ae >>> 14, Ae = D + gt | 0, pe ^= Ae << 7 | Ae >>> 25, Ae = pe + D | 0, ot ^= Ae << 9 | Ae >>> 23, Ae = ot + pe | 0, gt ^= Ae << 13 | Ae >>> 19, Ae = gt + ot | 0, D ^= Ae << 18 | Ae >>> 14, Ae = Pe + j | 0, _t ^= Ae << 7 | Ae >>> 25, Ae = _t + Pe | 0, at ^= Ae << 9 | Ae >>> 23, Ae = at + _t | 0, j ^= Ae << 13 | Ae >>> 19, Ae = j + at | 0, Pe ^= Ae << 18 | Ae >>> 14, Ae = Pt + Re | 0, dt ^= Ae << 7 | Ae >>> 25, Ae = dt + Pt | 0, Y ^= Ae << 9 | Ae >>> 23, Ae = Y + dt | 0, Re ^= Ae << 13 | Ae >>> 19, Ae = Re + Y | 0, Pt ^= Ae << 18 | Ae >>> 14, Ae = ft + dt | 0, gt ^= Ae << 7 | Ae >>> 25, Ae = gt + ft | 0, at ^= Ae << 9 | Ae >>> 23, Ae = at + gt | 0, dt ^= Ae << 13 | Ae >>> 19, Ae = dt + at | 0, ft ^= Ae << 18 | Ae >>> 14, Ae = D + ve | 0, j ^= Ae << 7 | Ae >>> 25, Ae = j + D | 0, Y ^= Ae << 9 | Ae >>> 23, Ae = Y + j | 0, ve ^= Ae << 13 | Ae >>> 19, Ae = ve + Y | 0, D ^= Ae << 18 | Ae >>> 14, Ae = Pe + pe | 0, Re ^= Ae << 7 | Ae >>> 25, Ae = Re + Pe | 0, me ^= Ae << 9 | Ae >>> 23, Ae = me + Re | 0, pe ^= Ae << 13 | Ae >>> 19, Ae = pe + me | 0, Pe ^= Ae << 18 | Ae >>> 14, Ae = Pt + _t | 0, nt ^= Ae << 7 | Ae >>> 25, Ae = nt + Pt | 0, ot ^= Ae << 9 | Ae >>> 23, Ae = ot + nt | 0, _t ^= Ae << 13 | Ae >>> 19, Ae = _t + ot | 0, Pt ^= Ae << 18 | Ae >>> 14;
      K[0] = ft >>> 0 & 255, K[1] = ft >>> 8 & 255, K[2] = ft >>> 16 & 255, K[3] = ft >>> 24 & 255, K[4] = D >>> 0 & 255, K[5] = D >>> 8 & 255, K[6] = D >>> 16 & 255, K[7] = D >>> 24 & 255, K[8] = Pe >>> 0 & 255, K[9] = Pe >>> 8 & 255, K[10] = Pe >>> 16 & 255, K[11] = Pe >>> 24 & 255, K[12] = Pt >>> 0 & 255, K[13] = Pt >>> 8 & 255, K[14] = Pt >>> 16 & 255, K[15] = Pt >>> 24 & 255, K[16] = j >>> 0 & 255, K[17] = j >>> 8 & 255, K[18] = j >>> 16 & 255, K[19] = j >>> 24 & 255, K[20] = Y >>> 0 & 255, K[21] = Y >>> 8 & 255, K[22] = Y >>> 16 & 255, K[23] = Y >>> 24 & 255, K[24] = me >>> 0 & 255, K[25] = me >>> 8 & 255, K[26] = me >>> 16 & 255, K[27] = me >>> 24 & 255, K[28] = pe >>> 0 & 255, K[29] = pe >>> 8 & 255, K[30] = pe >>> 16 & 255, K[31] = pe >>> 24 & 255;
    }
    function O(K, W, G, U) {
      C(K, W, G, U);
    }
    function q(K, W, G, U) {
      I(K, W, G, U);
    }
    var $ = new Uint8Array([101, 120, 112, 97, 110, 100, 32, 51, 50, 45, 98, 121, 116, 101, 32, 107]);
    function ae(K, W, G, U, X, H, ye) {
      var ce = new Uint8Array(16), we = new Uint8Array(64), Qe, Ze;
      for (Ze = 0; Ze < 16; Ze++)
        ce[Ze] = 0;
      for (Ze = 0; Ze < 8; Ze++)
        ce[Ze] = H[Ze];
      for (; X >= 64; ) {
        for (O(we, ce, ye, $), Ze = 0; Ze < 64; Ze++)
          K[W + Ze] = G[U + Ze] ^ we[Ze];
        for (Qe = 1, Ze = 8; Ze < 16; Ze++)
          Qe = Qe + (ce[Ze] & 255) | 0, ce[Ze] = Qe & 255, Qe >>>= 8;
        X -= 64, W += 64, U += 64;
      }
      if (X > 0)
        for (O(we, ce, ye, $), Ze = 0; Ze < X; Ze++)
          K[W + Ze] = G[U + Ze] ^ we[Ze];
      return 0;
    }
    function he(K, W, G, U, X) {
      var H = new Uint8Array(16), ye = new Uint8Array(64), ce, we;
      for (we = 0; we < 16; we++)
        H[we] = 0;
      for (we = 0; we < 8; we++)
        H[we] = U[we];
      for (; G >= 64; ) {
        for (O(ye, H, X, $), we = 0; we < 64; we++)
          K[W + we] = ye[we];
        for (ce = 1, we = 8; we < 16; we++)
          ce = ce + (H[we] & 255) | 0, H[we] = ce & 255, ce >>>= 8;
        G -= 64, W += 64;
      }
      if (G > 0)
        for (O(ye, H, X, $), we = 0; we < G; we++)
          K[W + we] = ye[we];
      return 0;
    }
    function te(K, W, G, U, X) {
      var H = new Uint8Array(32);
      q(H, U, X, $);
      for (var ye = new Uint8Array(8), ce = 0; ce < 8; ce++)
        ye[ce] = U[ce + 16];
      return he(K, W, G, ye, H);
    }
    function Ee(K, W, G, U, X, H, ye) {
      var ce = new Uint8Array(32);
      q(ce, H, ye, $);
      for (var we = new Uint8Array(8), Qe = 0; Qe < 8; Qe++)
        we[Qe] = H[Qe + 16];
      return ae(K, W, G, U, X, we, ce);
    }
    var x = function(K) {
      this.buffer = new Uint8Array(16), this.r = new Uint16Array(10), this.h = new Uint16Array(10), this.pad = new Uint16Array(8), this.leftover = 0, this.fin = 0;
      var W, G, U, X, H, ye, ce, we;
      W = K[0] & 255 | (K[1] & 255) << 8, this.r[0] = W & 8191, G = K[2] & 255 | (K[3] & 255) << 8, this.r[1] = (W >>> 13 | G << 3) & 8191, U = K[4] & 255 | (K[5] & 255) << 8, this.r[2] = (G >>> 10 | U << 6) & 7939, X = K[6] & 255 | (K[7] & 255) << 8, this.r[3] = (U >>> 7 | X << 9) & 8191, H = K[8] & 255 | (K[9] & 255) << 8, this.r[4] = (X >>> 4 | H << 12) & 255, this.r[5] = H >>> 1 & 8190, ye = K[10] & 255 | (K[11] & 255) << 8, this.r[6] = (H >>> 14 | ye << 2) & 8191, ce = K[12] & 255 | (K[13] & 255) << 8, this.r[7] = (ye >>> 11 | ce << 5) & 8065, we = K[14] & 255 | (K[15] & 255) << 8, this.r[8] = (ce >>> 8 | we << 8) & 8191, this.r[9] = we >>> 5 & 127, this.pad[0] = K[16] & 255 | (K[17] & 255) << 8, this.pad[1] = K[18] & 255 | (K[19] & 255) << 8, this.pad[2] = K[20] & 255 | (K[21] & 255) << 8, this.pad[3] = K[22] & 255 | (K[23] & 255) << 8, this.pad[4] = K[24] & 255 | (K[25] & 255) << 8, this.pad[5] = K[26] & 255 | (K[27] & 255) << 8, this.pad[6] = K[28] & 255 | (K[29] & 255) << 8, this.pad[7] = K[30] & 255 | (K[31] & 255) << 8;
    };
    x.prototype.blocks = function(K, W, G) {
      for (var U = this.fin ? 0 : 2048, X, H, ye, ce, we, Qe, Ze, lt, Xe, ht, ct, pt, yt, bt, wt, mt, ft, gt, at, dt = this.h[0], ve = this.h[1], D = this.h[2], j = this.h[3], Y = this.h[4], me = this.h[5], pe = this.h[6], Pe = this.h[7], Re = this.h[8], nt = this.h[9], ot = this.r[0], _t = this.r[1], Pt = this.r[2], Ae = this.r[3], Ft = this.r[4], Zt = this.r[5], Gt = this.r[6], jt = this.r[7], Wt = this.r[8], Kt = this.r[9]; G >= 16; )
        X = K[W + 0] & 255 | (K[W + 1] & 255) << 8, dt += X & 8191, H = K[W + 2] & 255 | (K[W + 3] & 255) << 8, ve += (X >>> 13 | H << 3) & 8191, ye = K[W + 4] & 255 | (K[W + 5] & 255) << 8, D += (H >>> 10 | ye << 6) & 8191, ce = K[W + 6] & 255 | (K[W + 7] & 255) << 8, j += (ye >>> 7 | ce << 9) & 8191, we = K[W + 8] & 255 | (K[W + 9] & 255) << 8, Y += (ce >>> 4 | we << 12) & 8191, me += we >>> 1 & 8191, Qe = K[W + 10] & 255 | (K[W + 11] & 255) << 8, pe += (we >>> 14 | Qe << 2) & 8191, Ze = K[W + 12] & 255 | (K[W + 13] & 255) << 8, Pe += (Qe >>> 11 | Ze << 5) & 8191, lt = K[W + 14] & 255 | (K[W + 15] & 255) << 8, Re += (Ze >>> 8 | lt << 8) & 8191, nt += lt >>> 5 | U, Xe = 0, ht = Xe, ht += dt * ot, ht += ve * (5 * Kt), ht += D * (5 * Wt), ht += j * (5 * jt), ht += Y * (5 * Gt), Xe = ht >>> 13, ht &= 8191, ht += me * (5 * Zt), ht += pe * (5 * Ft), ht += Pe * (5 * Ae), ht += Re * (5 * Pt), ht += nt * (5 * _t), Xe += ht >>> 13, ht &= 8191, ct = Xe, ct += dt * _t, ct += ve * ot, ct += D * (5 * Kt), ct += j * (5 * Wt), ct += Y * (5 * jt), Xe = ct >>> 13, ct &= 8191, ct += me * (5 * Gt), ct += pe * (5 * Zt), ct += Pe * (5 * Ft), ct += Re * (5 * Ae), ct += nt * (5 * Pt), Xe += ct >>> 13, ct &= 8191, pt = Xe, pt += dt * Pt, pt += ve * _t, pt += D * ot, pt += j * (5 * Kt), pt += Y * (5 * Wt), Xe = pt >>> 13, pt &= 8191, pt += me * (5 * jt), pt += pe * (5 * Gt), pt += Pe * (5 * Zt), pt += Re * (5 * Ft), pt += nt * (5 * Ae), Xe += pt >>> 13, pt &= 8191, yt = Xe, yt += dt * Ae, yt += ve * Pt, yt += D * _t, yt += j * ot, yt += Y * (5 * Kt), Xe = yt >>> 13, yt &= 8191, yt += me * (5 * Wt), yt += pe * (5 * jt), yt += Pe * (5 * Gt), yt += Re * (5 * Zt), yt += nt * (5 * Ft), Xe += yt >>> 13, yt &= 8191, bt = Xe, bt += dt * Ft, bt += ve * Ae, bt += D * Pt, bt += j * _t, bt += Y * ot, Xe = bt >>> 13, bt &= 8191, bt += me * (5 * Kt), bt += pe * (5 * Wt), bt += Pe * (5 * jt), bt += Re * (5 * Gt), bt += nt * (5 * Zt), Xe += bt >>> 13, bt &= 8191, wt = Xe, wt += dt * Zt, wt += ve * Ft, wt += D * Ae, wt += j * Pt, wt += Y * _t, Xe = wt >>> 13, wt &= 8191, wt += me * ot, wt += pe * (5 * Kt), wt += Pe * (5 * Wt), wt += Re * (5 * jt), wt += nt * (5 * Gt), Xe += wt >>> 13, wt &= 8191, mt = Xe, mt += dt * Gt, mt += ve * Zt, mt += D * Ft, mt += j * Ae, mt += Y * Pt, Xe = mt >>> 13, mt &= 8191, mt += me * _t, mt += pe * ot, mt += Pe * (5 * Kt), mt += Re * (5 * Wt), mt += nt * (5 * jt), Xe += mt >>> 13, mt &= 8191, ft = Xe, ft += dt * jt, ft += ve * Gt, ft += D * Zt, ft += j * Ft, ft += Y * Ae, Xe = ft >>> 13, ft &= 8191, ft += me * Pt, ft += pe * _t, ft += Pe * ot, ft += Re * (5 * Kt), ft += nt * (5 * Wt), Xe += ft >>> 13, ft &= 8191, gt = Xe, gt += dt * Wt, gt += ve * jt, gt += D * Gt, gt += j * Zt, gt += Y * Ft, Xe = gt >>> 13, gt &= 8191, gt += me * Ae, gt += pe * Pt, gt += Pe * _t, gt += Re * ot, gt += nt * (5 * Kt), Xe += gt >>> 13, gt &= 8191, at = Xe, at += dt * Kt, at += ve * Wt, at += D * jt, at += j * Gt, at += Y * Zt, Xe = at >>> 13, at &= 8191, at += me * Ft, at += pe * Ae, at += Pe * Pt, at += Re * _t, at += nt * ot, Xe += at >>> 13, at &= 8191, Xe = (Xe << 2) + Xe | 0, Xe = Xe + ht | 0, ht = Xe & 8191, Xe = Xe >>> 13, ct += Xe, dt = ht, ve = ct, D = pt, j = yt, Y = bt, me = wt, pe = mt, Pe = ft, Re = gt, nt = at, W += 16, G -= 16;
      this.h[0] = dt, this.h[1] = ve, this.h[2] = D, this.h[3] = j, this.h[4] = Y, this.h[5] = me, this.h[6] = pe, this.h[7] = Pe, this.h[8] = Re, this.h[9] = nt;
    }, x.prototype.finish = function(K, W) {
      var G = new Uint16Array(10), U, X, H, ye;
      if (this.leftover) {
        for (ye = this.leftover, this.buffer[ye++] = 1; ye < 16; ye++)
          this.buffer[ye] = 0;
        this.fin = 1, this.blocks(this.buffer, 0, 16);
      }
      for (U = this.h[1] >>> 13, this.h[1] &= 8191, ye = 2; ye < 10; ye++)
        this.h[ye] += U, U = this.h[ye] >>> 13, this.h[ye] &= 8191;
      for (this.h[0] += U * 5, U = this.h[0] >>> 13, this.h[0] &= 8191, this.h[1] += U, U = this.h[1] >>> 13, this.h[1] &= 8191, this.h[2] += U, G[0] = this.h[0] + 5, U = G[0] >>> 13, G[0] &= 8191, ye = 1; ye < 10; ye++)
        G[ye] = this.h[ye] + U, U = G[ye] >>> 13, G[ye] &= 8191;
      for (G[9] -= 8192, X = (U ^ 1) - 1, ye = 0; ye < 10; ye++)
        G[ye] &= X;
      for (X = ~X, ye = 0; ye < 10; ye++)
        this.h[ye] = this.h[ye] & X | G[ye];
      for (this.h[0] = (this.h[0] | this.h[1] << 13) & 65535, this.h[1] = (this.h[1] >>> 3 | this.h[2] << 10) & 65535, this.h[2] = (this.h[2] >>> 6 | this.h[3] << 7) & 65535, this.h[3] = (this.h[3] >>> 9 | this.h[4] << 4) & 65535, this.h[4] = (this.h[4] >>> 12 | this.h[5] << 1 | this.h[6] << 14) & 65535, this.h[5] = (this.h[6] >>> 2 | this.h[7] << 11) & 65535, this.h[6] = (this.h[7] >>> 5 | this.h[8] << 8) & 65535, this.h[7] = (this.h[8] >>> 8 | this.h[9] << 5) & 65535, H = this.h[0] + this.pad[0], this.h[0] = H & 65535, ye = 1; ye < 8; ye++)
        H = (this.h[ye] + this.pad[ye] | 0) + (H >>> 16) | 0, this.h[ye] = H & 65535;
      K[W + 0] = this.h[0] >>> 0 & 255, K[W + 1] = this.h[0] >>> 8 & 255, K[W + 2] = this.h[1] >>> 0 & 255, K[W + 3] = this.h[1] >>> 8 & 255, K[W + 4] = this.h[2] >>> 0 & 255, K[W + 5] = this.h[2] >>> 8 & 255, K[W + 6] = this.h[3] >>> 0 & 255, K[W + 7] = this.h[3] >>> 8 & 255, K[W + 8] = this.h[4] >>> 0 & 255, K[W + 9] = this.h[4] >>> 8 & 255, K[W + 10] = this.h[5] >>> 0 & 255, K[W + 11] = this.h[5] >>> 8 & 255, K[W + 12] = this.h[6] >>> 0 & 255, K[W + 13] = this.h[6] >>> 8 & 255, K[W + 14] = this.h[7] >>> 0 & 255, K[W + 15] = this.h[7] >>> 8 & 255;
    }, x.prototype.update = function(K, W, G) {
      var U, X;
      if (this.leftover) {
        for (X = 16 - this.leftover, X > G && (X = G), U = 0; U < X; U++)
          this.buffer[this.leftover + U] = K[W + U];
        if (G -= X, W += X, this.leftover += X, this.leftover < 16)
          return;
        this.blocks(this.buffer, 0, 16), this.leftover = 0;
      }
      if (G >= 16 && (X = G - G % 16, this.blocks(K, W, X), W += X, G -= X), G) {
        for (U = 0; U < G; U++)
          this.buffer[this.leftover + U] = K[W + U];
        this.leftover += G;
      }
    };
    function n(K, W, G, U, X, H) {
      var ye = new x(H);
      return ye.update(G, U, X), ye.finish(K, W), 0;
    }
    function o(K, W, G, U, X, H) {
      var ye = new Uint8Array(16);
      return n(ye, 0, G, U, X, H), B(K, W, ye, 0);
    }
    function u(K, W, G, U, X) {
      var H;
      if (G < 32)
        return -1;
      for (Ee(K, 0, W, 0, G, U, X), n(K, 16, K, 32, G - 32, K), H = 0; H < 16; H++)
        K[H] = 0;
      return 0;
    }
    function c(K, W, G, U, X) {
      var H, ye = new Uint8Array(32);
      if (G < 32 || (te(ye, 0, 32, U, X), o(W, 16, W, 32, G - 32, ye) !== 0))
        return -1;
      for (Ee(K, 0, W, 0, G, U, X), H = 0; H < 32; H++)
        K[H] = 0;
      return 0;
    }
    function g(K, W) {
      var G;
      for (G = 0; G < 16; G++)
        K[G] = W[G] | 0;
    }
    function b(K) {
      var W, G, U = 1;
      for (W = 0; W < 16; W++)
        G = K[W] + U + 65535, U = Math.floor(G / 65536), K[W] = G - U * 65536;
      K[0] += U - 1 + 37 * (U - 1);
    }
    function _(K, W, G) {
      for (var U, X = ~(G - 1), H = 0; H < 16; H++)
        U = X & (K[H] ^ W[H]), K[H] ^= U, W[H] ^= U;
    }
    function p(K, W) {
      var G, U, X, H = r(), ye = r();
      for (G = 0; G < 16; G++)
        ye[G] = W[G];
      for (b(ye), b(ye), b(ye), U = 0; U < 2; U++) {
        for (H[0] = ye[0] - 65517, G = 1; G < 15; G++)
          H[G] = ye[G] - 65535 - (H[G - 1] >> 16 & 1), H[G - 1] &= 65535;
        H[15] = ye[15] - 32767 - (H[14] >> 16 & 1), X = H[15] >> 16 & 1, H[14] &= 65535, _(ye, H, 1 - X);
      }
      for (G = 0; G < 16; G++)
        K[2 * G] = ye[G] & 255, K[2 * G + 1] = ye[G] >> 8;
    }
    function s(K, W) {
      var G = new Uint8Array(32), U = new Uint8Array(32);
      return p(G, K), p(U, W), k(G, 0, U, 0);
    }
    function y(K) {
      var W = new Uint8Array(32);
      return p(W, K), W[0] & 1;
    }
    function T(K, W) {
      var G;
      for (G = 0; G < 16; G++)
        K[G] = W[2 * G] + (W[2 * G + 1] << 8);
      K[15] &= 32767;
    }
    function P(K, W, G) {
      for (var U = 0; U < 16; U++)
        K[U] = W[U] + G[U];
    }
    function z(K, W, G) {
      for (var U = 0; U < 16; U++)
        K[U] = W[U] - G[U];
    }
    function J(K, W, G) {
      var U, X, H = 0, ye = 0, ce = 0, we = 0, Qe = 0, Ze = 0, lt = 0, Xe = 0, ht = 0, ct = 0, pt = 0, yt = 0, bt = 0, wt = 0, mt = 0, ft = 0, gt = 0, at = 0, dt = 0, ve = 0, D = 0, j = 0, Y = 0, me = 0, pe = 0, Pe = 0, Re = 0, nt = 0, ot = 0, _t = 0, Pt = 0, Ae = G[0], Ft = G[1], Zt = G[2], Gt = G[3], jt = G[4], Wt = G[5], Kt = G[6], br = G[7], rr = G[8], hr = G[9], pr = G[10], vr = G[11], Er = G[12], Nr = G[13], Dr = G[14], Ur = G[15];
      U = W[0], H += U * Ae, ye += U * Ft, ce += U * Zt, we += U * Gt, Qe += U * jt, Ze += U * Wt, lt += U * Kt, Xe += U * br, ht += U * rr, ct += U * hr, pt += U * pr, yt += U * vr, bt += U * Er, wt += U * Nr, mt += U * Dr, ft += U * Ur, U = W[1], ye += U * Ae, ce += U * Ft, we += U * Zt, Qe += U * Gt, Ze += U * jt, lt += U * Wt, Xe += U * Kt, ht += U * br, ct += U * rr, pt += U * hr, yt += U * pr, bt += U * vr, wt += U * Er, mt += U * Nr, ft += U * Dr, gt += U * Ur, U = W[2], ce += U * Ae, we += U * Ft, Qe += U * Zt, Ze += U * Gt, lt += U * jt, Xe += U * Wt, ht += U * Kt, ct += U * br, pt += U * rr, yt += U * hr, bt += U * pr, wt += U * vr, mt += U * Er, ft += U * Nr, gt += U * Dr, at += U * Ur, U = W[3], we += U * Ae, Qe += U * Ft, Ze += U * Zt, lt += U * Gt, Xe += U * jt, ht += U * Wt, ct += U * Kt, pt += U * br, yt += U * rr, bt += U * hr, wt += U * pr, mt += U * vr, ft += U * Er, gt += U * Nr, at += U * Dr, dt += U * Ur, U = W[4], Qe += U * Ae, Ze += U * Ft, lt += U * Zt, Xe += U * Gt, ht += U * jt, ct += U * Wt, pt += U * Kt, yt += U * br, bt += U * rr, wt += U * hr, mt += U * pr, ft += U * vr, gt += U * Er, at += U * Nr, dt += U * Dr, ve += U * Ur, U = W[5], Ze += U * Ae, lt += U * Ft, Xe += U * Zt, ht += U * Gt, ct += U * jt, pt += U * Wt, yt += U * Kt, bt += U * br, wt += U * rr, mt += U * hr, ft += U * pr, gt += U * vr, at += U * Er, dt += U * Nr, ve += U * Dr, D += U * Ur, U = W[6], lt += U * Ae, Xe += U * Ft, ht += U * Zt, ct += U * Gt, pt += U * jt, yt += U * Wt, bt += U * Kt, wt += U * br, mt += U * rr, ft += U * hr, gt += U * pr, at += U * vr, dt += U * Er, ve += U * Nr, D += U * Dr, j += U * Ur, U = W[7], Xe += U * Ae, ht += U * Ft, ct += U * Zt, pt += U * Gt, yt += U * jt, bt += U * Wt, wt += U * Kt, mt += U * br, ft += U * rr, gt += U * hr, at += U * pr, dt += U * vr, ve += U * Er, D += U * Nr, j += U * Dr, Y += U * Ur, U = W[8], ht += U * Ae, ct += U * Ft, pt += U * Zt, yt += U * Gt, bt += U * jt, wt += U * Wt, mt += U * Kt, ft += U * br, gt += U * rr, at += U * hr, dt += U * pr, ve += U * vr, D += U * Er, j += U * Nr, Y += U * Dr, me += U * Ur, U = W[9], ct += U * Ae, pt += U * Ft, yt += U * Zt, bt += U * Gt, wt += U * jt, mt += U * Wt, ft += U * Kt, gt += U * br, at += U * rr, dt += U * hr, ve += U * pr, D += U * vr, j += U * Er, Y += U * Nr, me += U * Dr, pe += U * Ur, U = W[10], pt += U * Ae, yt += U * Ft, bt += U * Zt, wt += U * Gt, mt += U * jt, ft += U * Wt, gt += U * Kt, at += U * br, dt += U * rr, ve += U * hr, D += U * pr, j += U * vr, Y += U * Er, me += U * Nr, pe += U * Dr, Pe += U * Ur, U = W[11], yt += U * Ae, bt += U * Ft, wt += U * Zt, mt += U * Gt, ft += U * jt, gt += U * Wt, at += U * Kt, dt += U * br, ve += U * rr, D += U * hr, j += U * pr, Y += U * vr, me += U * Er, pe += U * Nr, Pe += U * Dr, Re += U * Ur, U = W[12], bt += U * Ae, wt += U * Ft, mt += U * Zt, ft += U * Gt, gt += U * jt, at += U * Wt, dt += U * Kt, ve += U * br, D += U * rr, j += U * hr, Y += U * pr, me += U * vr, pe += U * Er, Pe += U * Nr, Re += U * Dr, nt += U * Ur, U = W[13], wt += U * Ae, mt += U * Ft, ft += U * Zt, gt += U * Gt, at += U * jt, dt += U * Wt, ve += U * Kt, D += U * br, j += U * rr, Y += U * hr, me += U * pr, pe += U * vr, Pe += U * Er, Re += U * Nr, nt += U * Dr, ot += U * Ur, U = W[14], mt += U * Ae, ft += U * Ft, gt += U * Zt, at += U * Gt, dt += U * jt, ve += U * Wt, D += U * Kt, j += U * br, Y += U * rr, me += U * hr, pe += U * pr, Pe += U * vr, Re += U * Er, nt += U * Nr, ot += U * Dr, _t += U * Ur, U = W[15], ft += U * Ae, gt += U * Ft, at += U * Zt, dt += U * Gt, ve += U * jt, D += U * Wt, j += U * Kt, Y += U * br, me += U * rr, pe += U * hr, Pe += U * pr, Re += U * vr, nt += U * Er, ot += U * Nr, _t += U * Dr, Pt += U * Ur, H += 38 * gt, ye += 38 * at, ce += 38 * dt, we += 38 * ve, Qe += 38 * D, Ze += 38 * j, lt += 38 * Y, Xe += 38 * me, ht += 38 * pe, ct += 38 * Pe, pt += 38 * Re, yt += 38 * nt, bt += 38 * ot, wt += 38 * _t, mt += 38 * Pt, X = 1, U = H + X + 65535, X = Math.floor(U / 65536), H = U - X * 65536, U = ye + X + 65535, X = Math.floor(U / 65536), ye = U - X * 65536, U = ce + X + 65535, X = Math.floor(U / 65536), ce = U - X * 65536, U = we + X + 65535, X = Math.floor(U / 65536), we = U - X * 65536, U = Qe + X + 65535, X = Math.floor(U / 65536), Qe = U - X * 65536, U = Ze + X + 65535, X = Math.floor(U / 65536), Ze = U - X * 65536, U = lt + X + 65535, X = Math.floor(U / 65536), lt = U - X * 65536, U = Xe + X + 65535, X = Math.floor(U / 65536), Xe = U - X * 65536, U = ht + X + 65535, X = Math.floor(U / 65536), ht = U - X * 65536, U = ct + X + 65535, X = Math.floor(U / 65536), ct = U - X * 65536, U = pt + X + 65535, X = Math.floor(U / 65536), pt = U - X * 65536, U = yt + X + 65535, X = Math.floor(U / 65536), yt = U - X * 65536, U = bt + X + 65535, X = Math.floor(U / 65536), bt = U - X * 65536, U = wt + X + 65535, X = Math.floor(U / 65536), wt = U - X * 65536, U = mt + X + 65535, X = Math.floor(U / 65536), mt = U - X * 65536, U = ft + X + 65535, X = Math.floor(U / 65536), ft = U - X * 65536, H += X - 1 + 37 * (X - 1), X = 1, U = H + X + 65535, X = Math.floor(U / 65536), H = U - X * 65536, U = ye + X + 65535, X = Math.floor(U / 65536), ye = U - X * 65536, U = ce + X + 65535, X = Math.floor(U / 65536), ce = U - X * 65536, U = we + X + 65535, X = Math.floor(U / 65536), we = U - X * 65536, U = Qe + X + 65535, X = Math.floor(U / 65536), Qe = U - X * 65536, U = Ze + X + 65535, X = Math.floor(U / 65536), Ze = U - X * 65536, U = lt + X + 65535, X = Math.floor(U / 65536), lt = U - X * 65536, U = Xe + X + 65535, X = Math.floor(U / 65536), Xe = U - X * 65536, U = ht + X + 65535, X = Math.floor(U / 65536), ht = U - X * 65536, U = ct + X + 65535, X = Math.floor(U / 65536), ct = U - X * 65536, U = pt + X + 65535, X = Math.floor(U / 65536), pt = U - X * 65536, U = yt + X + 65535, X = Math.floor(U / 65536), yt = U - X * 65536, U = bt + X + 65535, X = Math.floor(U / 65536), bt = U - X * 65536, U = wt + X + 65535, X = Math.floor(U / 65536), wt = U - X * 65536, U = mt + X + 65535, X = Math.floor(U / 65536), mt = U - X * 65536, U = ft + X + 65535, X = Math.floor(U / 65536), ft = U - X * 65536, H += X - 1 + 37 * (X - 1), K[0] = H, K[1] = ye, K[2] = ce, K[3] = we, K[4] = Qe, K[5] = Ze, K[6] = lt, K[7] = Xe, K[8] = ht, K[9] = ct, K[10] = pt, K[11] = yt, K[12] = bt, K[13] = wt, K[14] = mt, K[15] = ft;
    }
    function Z(K, W) {
      J(K, W, W);
    }
    function F(K, W) {
      var G = r(), U;
      for (U = 0; U < 16; U++)
        G[U] = W[U];
      for (U = 253; U >= 0; U--)
        Z(G, G), U !== 2 && U !== 4 && J(G, G, W);
      for (U = 0; U < 16; U++)
        K[U] = G[U];
    }
    function ee(K, W) {
      var G = r(), U;
      for (U = 0; U < 16; U++)
        G[U] = W[U];
      for (U = 250; U >= 0; U--)
        Z(G, G), U !== 1 && J(G, G, W);
      for (U = 0; U < 16; U++)
        K[U] = G[U];
    }
    function re(K, W, G) {
      var U = new Uint8Array(32), X = new Float64Array(80), H, ye, ce = r(), we = r(), Qe = r(), Ze = r(), lt = r(), Xe = r();
      for (ye = 0; ye < 31; ye++)
        U[ye] = W[ye];
      for (U[31] = W[31] & 127 | 64, U[0] &= 248, T(X, G), ye = 0; ye < 16; ye++)
        we[ye] = X[ye], Ze[ye] = ce[ye] = Qe[ye] = 0;
      for (ce[0] = Ze[0] = 1, ye = 254; ye >= 0; --ye)
        H = U[ye >>> 3] >>> (ye & 7) & 1, _(ce, we, H), _(Qe, Ze, H), P(lt, ce, Qe), z(ce, ce, Qe), P(Qe, we, Ze), z(we, we, Ze), Z(Ze, lt), Z(Xe, ce), J(ce, Qe, ce), J(Qe, we, lt), P(lt, ce, Qe), z(ce, ce, Qe), Z(we, ce), z(Qe, Ze, Xe), J(ce, Qe, v), P(ce, ce, Ze), J(Qe, Qe, ce), J(ce, Ze, Xe), J(Ze, we, X), Z(we, lt), _(ce, we, H), _(Qe, Ze, H);
      for (ye = 0; ye < 16; ye++)
        X[ye + 16] = ce[ye], X[ye + 32] = Qe[ye], X[ye + 48] = we[ye], X[ye + 64] = Ze[ye];
      var ht = X.subarray(32), ct = X.subarray(16);
      return F(ht, ht), J(ct, ct, ht), p(K, ct), 0;
    }
    function de(K, W) {
      return re(K, W, a);
    }
    function se(K, W) {
      return i(W, 32), de(K, W);
    }
    function Q(K, W, G) {
      var U = new Uint8Array(32);
      return re(U, G, W), q(K, f, U, $);
    }
    var ge = u, Ye = c;
    function Ce(K, W, G, U, X, H) {
      var ye = new Uint8Array(32);
      return Q(ye, X, H), ge(K, W, G, U, ye);
    }
    function Be(K, W, G, U, X, H) {
      var ye = new Uint8Array(32);
      return Q(ye, X, H), Ye(K, W, G, U, ye);
    }
    var st = [
      1116352408,
      3609767458,
      1899447441,
      602891725,
      3049323471,
      3964484399,
      3921009573,
      2173295548,
      961987163,
      4081628472,
      1508970993,
      3053834265,
      2453635748,
      2937671579,
      2870763221,
      3664609560,
      3624381080,
      2734883394,
      310598401,
      1164996542,
      607225278,
      1323610764,
      1426881987,
      3590304994,
      1925078388,
      4068182383,
      2162078206,
      991336113,
      2614888103,
      633803317,
      3248222580,
      3479774868,
      3835390401,
      2666613458,
      4022224774,
      944711139,
      264347078,
      2341262773,
      604807628,
      2007800933,
      770255983,
      1495990901,
      1249150122,
      1856431235,
      1555081692,
      3175218132,
      1996064986,
      2198950837,
      2554220882,
      3999719339,
      2821834349,
      766784016,
      2952996808,
      2566594879,
      3210313671,
      3203337956,
      3336571891,
      1034457026,
      3584528711,
      2466948901,
      113926993,
      3758326383,
      338241895,
      168717936,
      666307205,
      1188179964,
      773529912,
      1546045734,
      1294757372,
      1522805485,
      1396182291,
      2643833823,
      1695183700,
      2343527390,
      1986661051,
      1014477480,
      2177026350,
      1206759142,
      2456956037,
      344077627,
      2730485921,
      1290863460,
      2820302411,
      3158454273,
      3259730800,
      3505952657,
      3345764771,
      106217008,
      3516065817,
      3606008344,
      3600352804,
      1432725776,
      4094571909,
      1467031594,
      275423344,
      851169720,
      430227734,
      3100823752,
      506948616,
      1363258195,
      659060556,
      3750685593,
      883997877,
      3785050280,
      958139571,
      3318307427,
      1322822218,
      3812723403,
      1537002063,
      2003034995,
      1747873779,
      3602036899,
      1955562222,
      1575990012,
      2024104815,
      1125592928,
      2227730452,
      2716904306,
      2361852424,
      442776044,
      2428436474,
      593698344,
      2756734187,
      3733110249,
      3204031479,
      2999351573,
      3329325298,
      3815920427,
      3391569614,
      3928383900,
      3515267271,
      566280711,
      3940187606,
      3454069534,
      4118630271,
      4000239992,
      116418474,
      1914138554,
      174292421,
      2731055270,
      289380356,
      3203993006,
      460393269,
      320620315,
      685471733,
      587496836,
      852142971,
      1086792851,
      1017036298,
      365543100,
      1126000580,
      2618297676,
      1288033470,
      3409855158,
      1501505948,
      4234509866,
      1607167915,
      987167468,
      1816402316,
      1246189591
    ];
    function De(K, W, G, U) {
      for (var X = new Int32Array(16), H = new Int32Array(16), ye, ce, we, Qe, Ze, lt, Xe, ht, ct, pt, yt, bt, wt, mt, ft, gt, at, dt, ve, D, j, Y, me, pe, Pe, Re, nt = K[0], ot = K[1], _t = K[2], Pt = K[3], Ae = K[4], Ft = K[5], Zt = K[6], Gt = K[7], jt = W[0], Wt = W[1], Kt = W[2], br = W[3], rr = W[4], hr = W[5], pr = W[6], vr = W[7], Er = 0; U >= 128; ) {
        for (ve = 0; ve < 16; ve++)
          D = 8 * ve + Er, X[ve] = G[D + 0] << 24 | G[D + 1] << 16 | G[D + 2] << 8 | G[D + 3], H[ve] = G[D + 4] << 24 | G[D + 5] << 16 | G[D + 6] << 8 | G[D + 7];
        for (ve = 0; ve < 80; ve++)
          if (ye = nt, ce = ot, we = _t, Qe = Pt, Ze = Ae, lt = Ft, Xe = Zt, ht = Gt, ct = jt, pt = Wt, yt = Kt, bt = br, wt = rr, mt = hr, ft = pr, gt = vr, j = Gt, Y = vr, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = (Ae >>> 14 | rr << 18) ^ (Ae >>> 18 | rr << 14) ^ (rr >>> 9 | Ae << 23), Y = (rr >>> 14 | Ae << 18) ^ (rr >>> 18 | Ae << 14) ^ (Ae >>> 9 | rr << 23), me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, j = Ae & Ft ^ ~Ae & Zt, Y = rr & hr ^ ~rr & pr, me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, j = st[ve * 2], Y = st[ve * 2 + 1], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, j = X[ve % 16], Y = H[ve % 16], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, at = Pe & 65535 | Re << 16, dt = me & 65535 | pe << 16, j = at, Y = dt, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = (nt >>> 28 | jt << 4) ^ (jt >>> 2 | nt << 30) ^ (jt >>> 7 | nt << 25), Y = (jt >>> 28 | nt << 4) ^ (nt >>> 2 | jt << 30) ^ (nt >>> 7 | jt << 25), me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, j = nt & ot ^ nt & _t ^ ot & _t, Y = jt & Wt ^ jt & Kt ^ Wt & Kt, me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, ht = Pe & 65535 | Re << 16, gt = me & 65535 | pe << 16, j = Qe, Y = bt, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = at, Y = dt, me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, Qe = Pe & 65535 | Re << 16, bt = me & 65535 | pe << 16, ot = ye, _t = ce, Pt = we, Ae = Qe, Ft = Ze, Zt = lt, Gt = Xe, nt = ht, Wt = ct, Kt = pt, br = yt, rr = bt, hr = wt, pr = mt, vr = ft, jt = gt, ve % 16 === 15)
            for (D = 0; D < 16; D++)
              j = X[D], Y = H[D], me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = X[(D + 9) % 16], Y = H[(D + 9) % 16], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, at = X[(D + 1) % 16], dt = H[(D + 1) % 16], j = (at >>> 1 | dt << 31) ^ (at >>> 8 | dt << 24) ^ at >>> 7, Y = (dt >>> 1 | at << 31) ^ (dt >>> 8 | at << 24) ^ (dt >>> 7 | at << 25), me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, at = X[(D + 14) % 16], dt = H[(D + 14) % 16], j = (at >>> 19 | dt << 13) ^ (dt >>> 29 | at << 3) ^ at >>> 6, Y = (dt >>> 19 | at << 13) ^ (at >>> 29 | dt << 3) ^ (dt >>> 6 | at << 26), me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, X[D] = Pe & 65535 | Re << 16, H[D] = me & 65535 | pe << 16;
        j = nt, Y = jt, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[0], Y = W[0], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[0] = nt = Pe & 65535 | Re << 16, W[0] = jt = me & 65535 | pe << 16, j = ot, Y = Wt, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[1], Y = W[1], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[1] = ot = Pe & 65535 | Re << 16, W[1] = Wt = me & 65535 | pe << 16, j = _t, Y = Kt, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[2], Y = W[2], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[2] = _t = Pe & 65535 | Re << 16, W[2] = Kt = me & 65535 | pe << 16, j = Pt, Y = br, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[3], Y = W[3], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[3] = Pt = Pe & 65535 | Re << 16, W[3] = br = me & 65535 | pe << 16, j = Ae, Y = rr, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[4], Y = W[4], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[4] = Ae = Pe & 65535 | Re << 16, W[4] = rr = me & 65535 | pe << 16, j = Ft, Y = hr, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[5], Y = W[5], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[5] = Ft = Pe & 65535 | Re << 16, W[5] = hr = me & 65535 | pe << 16, j = Zt, Y = pr, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[6], Y = W[6], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[6] = Zt = Pe & 65535 | Re << 16, W[6] = pr = me & 65535 | pe << 16, j = Gt, Y = vr, me = Y & 65535, pe = Y >>> 16, Pe = j & 65535, Re = j >>> 16, j = K[7], Y = W[7], me += Y & 65535, pe += Y >>> 16, Pe += j & 65535, Re += j >>> 16, pe += me >>> 16, Pe += pe >>> 16, Re += Pe >>> 16, K[7] = Gt = Pe & 65535 | Re << 16, W[7] = vr = me & 65535 | pe << 16, Er += 128, U -= 128;
      }
      return U;
    }
    function _e(K, W, G) {
      var U = new Int32Array(8), X = new Int32Array(8), H = new Uint8Array(256), ye, ce = G;
      for (U[0] = 1779033703, U[1] = 3144134277, U[2] = 1013904242, U[3] = 2773480762, U[4] = 1359893119, U[5] = 2600822924, U[6] = 528734635, U[7] = 1541459225, X[0] = 4089235720, X[1] = 2227873595, X[2] = 4271175723, X[3] = 1595750129, X[4] = 2917565137, X[5] = 725511199, X[6] = 4215389547, X[7] = 327033209, De(U, X, W, G), G %= 128, ye = 0; ye < G; ye++)
        H[ye] = W[ce - G + ye];
      for (H[G] = 128, G = 256 - 128 * (G < 112 ? 1 : 0), H[G - 9] = 0, E(H, G - 8, ce / 536870912 | 0, ce << 3), De(U, X, H, G), ye = 0; ye < 8; ye++)
        E(K, 8 * ye, U[ye], X[ye]);
      return 0;
    }
    function St(K, W) {
      var G = r(), U = r(), X = r(), H = r(), ye = r(), ce = r(), we = r(), Qe = r(), Ze = r();
      z(G, K[1], K[0]), z(Ze, W[1], W[0]), J(G, G, Ze), P(U, K[0], K[1]), P(Ze, W[0], W[1]), J(U, U, Ze), J(X, K[3], W[3]), J(X, X, h), J(H, K[2], W[2]), P(H, H, H), z(ye, U, G), z(ce, H, X), P(we, H, X), P(Qe, U, G), J(K[0], ye, ce), J(K[1], Qe, we), J(K[2], we, ce), J(K[3], ye, Qe);
    }
    function Oe(K, W, G) {
      var U;
      for (U = 0; U < 4; U++)
        _(K[U], W[U], G);
    }
    function Fe(K, W) {
      var G = r(), U = r(), X = r();
      F(X, W[2]), J(G, W[0], X), J(U, W[1], X), p(K, U), K[31] ^= y(G) << 7;
    }
    function Et(K, W, G) {
      var U, X;
      for (g(K[0], l), g(K[1], d), g(K[2], d), g(K[3], l), X = 255; X >= 0; --X)
        U = G[X / 8 | 0] >> (X & 7) & 1, Oe(K, W, U), St(W, K), St(K, K), Oe(K, W, U);
    }
    function Ue(K, W) {
      var G = [r(), r(), r(), r()];
      g(G[0], w), g(G[1], M), g(G[2], d), J(G[3], w, M), Et(K, G, W);
    }
    function oe(K, W, G) {
      var U = new Uint8Array(64), X = [r(), r(), r(), r()], H;
      for (G || i(W, 32), _e(U, W, 32), U[0] &= 248, U[31] &= 127, U[31] |= 64, Ue(X, U), Fe(K, X), H = 0; H < 32; H++)
        W[H + 32] = K[H];
      return 0;
    }
    var le = new Float64Array([237, 211, 245, 92, 26, 99, 18, 88, 214, 156, 247, 162, 222, 249, 222, 20, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 16]);
    function ie(K, W) {
      var G, U, X, H;
      for (U = 63; U >= 32; --U) {
        for (G = 0, X = U - 32, H = U - 12; X < H; ++X)
          W[X] += G - 16 * W[U] * le[X - (U - 32)], G = Math.floor((W[X] + 128) / 256), W[X] -= G * 256;
        W[X] += G, W[U] = 0;
      }
      for (G = 0, X = 0; X < 32; X++)
        W[X] += G - (W[31] >> 4) * le[X], G = W[X] >> 8, W[X] &= 255;
      for (X = 0; X < 32; X++)
        W[X] -= G * le[X];
      for (U = 0; U < 32; U++)
        W[U + 1] += W[U] >> 8, K[U] = W[U] & 255;
    }
    function fe(K) {
      var W = new Float64Array(64), G;
      for (G = 0; G < 64; G++)
        W[G] = K[G];
      for (G = 0; G < 64; G++)
        K[G] = 0;
      ie(K, W);
    }
    function Te(K, W, G, U) {
      var X = new Uint8Array(64), H = new Uint8Array(64), ye = new Uint8Array(64), ce, we, Qe = new Float64Array(64), Ze = [r(), r(), r(), r()];
      _e(X, U, 32), X[0] &= 248, X[31] &= 127, X[31] |= 64;
      var lt = G + 64;
      for (ce = 0; ce < G; ce++)
        K[64 + ce] = W[ce];
      for (ce = 0; ce < 32; ce++)
        K[32 + ce] = X[32 + ce];
      for (_e(ye, K.subarray(32), G + 32), fe(ye), Ue(Ze, ye), Fe(K, Ze), ce = 32; ce < 64; ce++)
        K[ce] = U[ce];
      for (_e(H, K, G + 64), fe(H), ce = 0; ce < 64; ce++)
        Qe[ce] = 0;
      for (ce = 0; ce < 32; ce++)
        Qe[ce] = ye[ce];
      for (ce = 0; ce < 32; ce++)
        for (we = 0; we < 32; we++)
          Qe[ce + we] += H[ce] * X[we];
      return ie(K.subarray(32), Qe), lt;
    }
    function N(K, W) {
      var G = r(), U = r(), X = r(), H = r(), ye = r(), ce = r(), we = r();
      return g(K[2], d), T(K[1], W), Z(X, K[1]), J(H, X, m), z(X, X, K[2]), P(H, K[2], H), Z(ye, H), Z(ce, ye), J(we, ce, ye), J(G, we, X), J(G, G, H), ee(G, G), J(G, G, X), J(G, G, H), J(G, G, H), J(K[0], G, H), Z(U, K[0]), J(U, U, H), s(U, X) && J(K[0], K[0], S), Z(U, K[0]), J(U, U, H), s(U, X) ? -1 : (y(K[0]) === W[31] >> 7 && z(K[0], l, K[0]), J(K[3], K[0], K[1]), 0);
    }
    function R(K, W, G, U) {
      var X, H = new Uint8Array(32), ye = new Uint8Array(64), ce = [r(), r(), r(), r()], we = [r(), r(), r(), r()];
      if (G < 64 || N(we, U))
        return -1;
      for (X = 0; X < G; X++)
        K[X] = W[X];
      for (X = 0; X < 32; X++)
        K[X + 32] = U[X];
      if (_e(ye, K, G), fe(ye), Et(ce, we, ye), Ue(we, W.subarray(32)), St(ce, we), Fe(H, ce), G -= 64, k(W, 0, H, 0)) {
        for (X = 0; X < G; X++)
          K[X] = 0;
        return -1;
      }
      for (X = 0; X < G; X++)
        K[X] = W[X + 64];
      return G;
    }
    var L = 32, V = 24, ne = 32, Se = 16, ue = 32, xe = 32, He = 32, be = 32, Ie = 32, rt = V, Ne = ne, ze = Se, kt = 64, Le = 32, $e = 64, Ot = 32, je = 64;
    e.lowlevel = {
      crypto_core_hsalsa20: q,
      crypto_stream_xor: Ee,
      crypto_stream: te,
      crypto_stream_salsa20_xor: ae,
      crypto_stream_salsa20: he,
      crypto_onetimeauth: n,
      crypto_onetimeauth_verify: o,
      crypto_verify_16: B,
      crypto_verify_32: k,
      crypto_secretbox: u,
      crypto_secretbox_open: c,
      crypto_scalarmult: re,
      crypto_scalarmult_base: de,
      crypto_box_beforenm: Q,
      crypto_box_afternm: ge,
      crypto_box: Ce,
      crypto_box_open: Be,
      crypto_box_keypair: se,
      crypto_hash: _e,
      crypto_sign: Te,
      crypto_sign_keypair: oe,
      crypto_sign_open: R,
      crypto_secretbox_KEYBYTES: L,
      crypto_secretbox_NONCEBYTES: V,
      crypto_secretbox_ZEROBYTES: ne,
      crypto_secretbox_BOXZEROBYTES: Se,
      crypto_scalarmult_BYTES: ue,
      crypto_scalarmult_SCALARBYTES: xe,
      crypto_box_PUBLICKEYBYTES: He,
      crypto_box_SECRETKEYBYTES: be,
      crypto_box_BEFORENMBYTES: Ie,
      crypto_box_NONCEBYTES: rt,
      crypto_box_ZEROBYTES: Ne,
      crypto_box_BOXZEROBYTES: ze,
      crypto_sign_BYTES: kt,
      crypto_sign_PUBLICKEYBYTES: Le,
      crypto_sign_SECRETKEYBYTES: $e,
      crypto_sign_SEEDBYTES: Ot,
      crypto_hash_BYTES: je,
      gf: r,
      D: m,
      L: le,
      pack25519: p,
      unpack25519: T,
      M: J,
      A: P,
      S: Z,
      Z: z,
      pow2523: ee,
      add: St,
      set25519: g,
      modL: ie,
      scalarmult: Et,
      scalarbase: Ue
    };
    function Ve(K, W) {
      if (K.length !== L)
        throw new Error("bad key size");
      if (W.length !== V)
        throw new Error("bad nonce size");
    }
    function Nt(K, W) {
      if (K.length !== He)
        throw new Error("bad public key size");
      if (W.length !== be)
        throw new Error("bad secret key size");
    }
    function qe() {
      for (var K = 0; K < arguments.length; K++)
        if (!(arguments[K] instanceof Uint8Array))
          throw new TypeError("unexpected type, use Uint8Array");
    }
    function Ke(K) {
      for (var W = 0; W < K.length; W++)
        K[W] = 0;
    }
    e.randomBytes = function(K) {
      var W = new Uint8Array(K);
      return i(W, K), W;
    }, e.secretbox = function(K, W, G) {
      qe(K, W, G), Ve(G, W);
      for (var U = new Uint8Array(ne + K.length), X = new Uint8Array(U.length), H = 0; H < K.length; H++)
        U[H + ne] = K[H];
      return u(X, U, U.length, W, G), X.subarray(Se);
    }, e.secretbox.open = function(K, W, G) {
      qe(K, W, G), Ve(G, W);
      for (var U = new Uint8Array(Se + K.length), X = new Uint8Array(U.length), H = 0; H < K.length; H++)
        U[H + Se] = K[H];
      return U.length < 32 || c(X, U, U.length, W, G) !== 0 ? null : X.subarray(ne);
    }, e.secretbox.keyLength = L, e.secretbox.nonceLength = V, e.secretbox.overheadLength = Se, e.scalarMult = function(K, W) {
      if (qe(K, W), K.length !== xe)
        throw new Error("bad n size");
      if (W.length !== ue)
        throw new Error("bad p size");
      var G = new Uint8Array(ue);
      return re(G, K, W), G;
    }, e.scalarMult.base = function(K) {
      if (qe(K), K.length !== xe)
        throw new Error("bad n size");
      var W = new Uint8Array(ue);
      return de(W, K), W;
    }, e.scalarMult.scalarLength = xe, e.scalarMult.groupElementLength = ue, e.box = function(K, W, G, U) {
      var X = e.box.before(G, U);
      return e.secretbox(K, W, X);
    }, e.box.before = function(K, W) {
      qe(K, W), Nt(K, W);
      var G = new Uint8Array(Ie);
      return Q(G, K, W), G;
    }, e.box.after = e.secretbox, e.box.open = function(K, W, G, U) {
      var X = e.box.before(G, U);
      return e.secretbox.open(K, W, X);
    }, e.box.open.after = e.secretbox.open, e.box.keyPair = function() {
      var K = new Uint8Array(He), W = new Uint8Array(be);
      return se(K, W), { publicKey: K, secretKey: W };
    }, e.box.keyPair.fromSecretKey = function(K) {
      if (qe(K), K.length !== be)
        throw new Error("bad secret key size");
      var W = new Uint8Array(He);
      return de(W, K), { publicKey: W, secretKey: new Uint8Array(K) };
    }, e.box.publicKeyLength = He, e.box.secretKeyLength = be, e.box.sharedKeyLength = Ie, e.box.nonceLength = rt, e.box.overheadLength = e.secretbox.overheadLength, e.sign = function(K, W) {
      if (qe(K, W), W.length !== $e)
        throw new Error("bad secret key size");
      var G = new Uint8Array(kt + K.length);
      return Te(G, K, K.length, W), G;
    }, e.sign.open = function(K, W) {
      if (qe(K, W), W.length !== Le)
        throw new Error("bad public key size");
      var G = new Uint8Array(K.length), U = R(G, K, K.length, W);
      if (U < 0)
        return null;
      for (var X = new Uint8Array(U), H = 0; H < X.length; H++)
        X[H] = G[H];
      return X;
    }, e.sign.detached = function(K, W) {
      for (var G = e.sign(K, W), U = new Uint8Array(kt), X = 0; X < U.length; X++)
        U[X] = G[X];
      return U;
    }, e.sign.detached.verify = function(K, W, G) {
      if (qe(K, W, G), W.length !== kt)
        throw new Error("bad signature size");
      if (G.length !== Le)
        throw new Error("bad public key size");
      var U = new Uint8Array(kt + K.length), X = new Uint8Array(kt + K.length), H;
      for (H = 0; H < kt; H++)
        U[H] = W[H];
      for (H = 0; H < K.length; H++)
        U[H + kt] = K[H];
      return R(X, U, U.length, G) >= 0;
    }, e.sign.keyPair = function() {
      var K = new Uint8Array(Le), W = new Uint8Array($e);
      return oe(K, W), { publicKey: K, secretKey: W };
    }, e.sign.keyPair.fromSecretKey = function(K) {
      if (qe(K), K.length !== $e)
        throw new Error("bad secret key size");
      for (var W = new Uint8Array(Le), G = 0; G < W.length; G++)
        W[G] = K[32 + G];
      return { publicKey: W, secretKey: new Uint8Array(K) };
    }, e.sign.keyPair.fromSeed = function(K) {
      if (qe(K), K.length !== Ot)
        throw new Error("bad seed size");
      for (var W = new Uint8Array(Le), G = new Uint8Array($e), U = 0; U < 32; U++)
        G[U] = K[U];
      return oe(W, G, !0), { publicKey: W, secretKey: G };
    }, e.sign.publicKeyLength = Le, e.sign.secretKeyLength = $e, e.sign.seedLength = Ot, e.sign.signatureLength = kt, e.hash = function(K) {
      qe(K);
      var W = new Uint8Array(je);
      return _e(W, K, K.length), W;
    }, e.hash.hashLength = je, e.verify = function(K, W) {
      return qe(K, W), K.length === 0 || W.length === 0 || K.length !== W.length ? !1 : A(K, 0, W, 0, K.length) === 0;
    }, e.setPRNG = function(K) {
      i = K;
    }, function() {
      var K = typeof self < "u" ? self.crypto || self.msCrypto : null;
      if (K && K.getRandomValues) {
        var W = 65536;
        e.setPRNG(function(G, U) {
          var X, H = new Uint8Array(U);
          for (X = 0; X < U; X += W)
            K.getRandomValues(H.subarray(X, X + Math.min(U - X, W)));
          for (X = 0; X < U; X++)
            G[X] = H[X];
          Ke(H);
        });
      } else
        typeof JC < "u" && (K = b_(), K && K.randomBytes && e.setPRNG(function(G, U) {
          var X, H = K.randomBytes(U);
          for (X = 0; X < U; X++)
            G[X] = H[X];
          Ke(H);
        }));
    }();
  })(t.exports ? t.exports : self.nacl = self.nacl || {});
})(x8);
var w_ = x8.exports, Xi = {};
Object.defineProperty(Xi, "__esModule", { value: !0 });
Xi.bitsToBytes = Xi.bytesToBits = Xi.lpad = void 0;
function __(t, e, r) {
  for (; t.length < r; )
    t = e + t;
  return t;
}
Xi.lpad = __;
function JR(t) {
  let e = "";
  for (let r = 0; r < t.length; r++) {
    let i = t.at(r);
    e += __(i.toString(2), "0", 8);
  }
  return e;
}
Xi.bytesToBits = JR;
function XR(t) {
  if (t.length % 8 !== 0)
    throw Error("Uneven bits");
  let e = [];
  for (; t.length > 0; )
    e.push(parseInt(t.slice(0, 8), 2)), t = t.slice(8);
  return Je.from(e);
}
Xi.bitsToBytes = XR;
var Jf = {};
Object.defineProperty(Jf, "__esModule", { value: !0 });
Jf.wordlist = void 0;
const eP = [
  "abandon",
  "ability",
  "able",
  "about",
  "above",
  "absent",
  "absorb",
  "abstract",
  "absurd",
  "abuse",
  "access",
  "accident",
  "account",
  "accuse",
  "achieve",
  "acid",
  "acoustic",
  "acquire",
  "across",
  "act",
  "action",
  "actor",
  "actress",
  "actual",
  "adapt",
  "add",
  "addict",
  "address",
  "adjust",
  "admit",
  "adult",
  "advance",
  "advice",
  "aerobic",
  "affair",
  "afford",
  "afraid",
  "again",
  "age",
  "agent",
  "agree",
  "ahead",
  "aim",
  "air",
  "airport",
  "aisle",
  "alarm",
  "album",
  "alcohol",
  "alert",
  "alien",
  "all",
  "alley",
  "allow",
  "almost",
  "alone",
  "alpha",
  "already",
  "also",
  "alter",
  "always",
  "amateur",
  "amazing",
  "among",
  "amount",
  "amused",
  "analyst",
  "anchor",
  "ancient",
  "anger",
  "angle",
  "angry",
  "animal",
  "ankle",
  "announce",
  "annual",
  "another",
  "answer",
  "antenna",
  "antique",
  "anxiety",
  "any",
  "apart",
  "apology",
  "appear",
  "apple",
  "approve",
  "april",
  "arch",
  "arctic",
  "area",
  "arena",
  "argue",
  "arm",
  "armed",
  "armor",
  "army",
  "around",
  "arrange",
  "arrest",
  "arrive",
  "arrow",
  "art",
  "artefact",
  "artist",
  "artwork",
  "ask",
  "aspect",
  "assault",
  "asset",
  "assist",
  "assume",
  "asthma",
  "athlete",
  "atom",
  "attack",
  "attend",
  "attitude",
  "attract",
  "auction",
  "audit",
  "august",
  "aunt",
  "author",
  "auto",
  "autumn",
  "average",
  "avocado",
  "avoid",
  "awake",
  "aware",
  "away",
  "awesome",
  "awful",
  "awkward",
  "axis",
  "baby",
  "bachelor",
  "bacon",
  "badge",
  "bag",
  "balance",
  "balcony",
  "ball",
  "bamboo",
  "banana",
  "banner",
  "bar",
  "barely",
  "bargain",
  "barrel",
  "base",
  "basic",
  "basket",
  "battle",
  "beach",
  "bean",
  "beauty",
  "because",
  "become",
  "beef",
  "before",
  "begin",
  "behave",
  "behind",
  "believe",
  "below",
  "belt",
  "bench",
  "benefit",
  "best",
  "betray",
  "better",
  "between",
  "beyond",
  "bicycle",
  "bid",
  "bike",
  "bind",
  "biology",
  "bird",
  "birth",
  "bitter",
  "black",
  "blade",
  "blame",
  "blanket",
  "blast",
  "bleak",
  "bless",
  "blind",
  "blood",
  "blossom",
  "blouse",
  "blue",
  "blur",
  "blush",
  "board",
  "boat",
  "body",
  "boil",
  "bomb",
  "bone",
  "bonus",
  "book",
  "boost",
  "border",
  "boring",
  "borrow",
  "boss",
  "bottom",
  "bounce",
  "box",
  "boy",
  "bracket",
  "brain",
  "brand",
  "brass",
  "brave",
  "bread",
  "breeze",
  "brick",
  "bridge",
  "brief",
  "bright",
  "bring",
  "brisk",
  "broccoli",
  "broken",
  "bronze",
  "broom",
  "brother",
  "brown",
  "brush",
  "bubble",
  "buddy",
  "budget",
  "buffalo",
  "build",
  "bulb",
  "bulk",
  "bullet",
  "bundle",
  "bunker",
  "burden",
  "burger",
  "burst",
  "bus",
  "business",
  "busy",
  "butter",
  "buyer",
  "buzz",
  "cabbage",
  "cabin",
  "cable",
  "cactus",
  "cage",
  "cake",
  "call",
  "calm",
  "camera",
  "camp",
  "can",
  "canal",
  "cancel",
  "candy",
  "cannon",
  "canoe",
  "canvas",
  "canyon",
  "capable",
  "capital",
  "captain",
  "car",
  "carbon",
  "card",
  "cargo",
  "carpet",
  "carry",
  "cart",
  "case",
  "cash",
  "casino",
  "castle",
  "casual",
  "cat",
  "catalog",
  "catch",
  "category",
  "cattle",
  "caught",
  "cause",
  "caution",
  "cave",
  "ceiling",
  "celery",
  "cement",
  "census",
  "century",
  "cereal",
  "certain",
  "chair",
  "chalk",
  "champion",
  "change",
  "chaos",
  "chapter",
  "charge",
  "chase",
  "chat",
  "cheap",
  "check",
  "cheese",
  "chef",
  "cherry",
  "chest",
  "chicken",
  "chief",
  "child",
  "chimney",
  "choice",
  "choose",
  "chronic",
  "chuckle",
  "chunk",
  "churn",
  "cigar",
  "cinnamon",
  "circle",
  "citizen",
  "city",
  "civil",
  "claim",
  "clap",
  "clarify",
  "claw",
  "clay",
  "clean",
  "clerk",
  "clever",
  "click",
  "client",
  "cliff",
  "climb",
  "clinic",
  "clip",
  "clock",
  "clog",
  "close",
  "cloth",
  "cloud",
  "clown",
  "club",
  "clump",
  "cluster",
  "clutch",
  "coach",
  "coast",
  "coconut",
  "code",
  "coffee",
  "coil",
  "coin",
  "collect",
  "color",
  "column",
  "combine",
  "come",
  "comfort",
  "comic",
  "common",
  "company",
  "concert",
  "conduct",
  "confirm",
  "congress",
  "connect",
  "consider",
  "control",
  "convince",
  "cook",
  "cool",
  "copper",
  "copy",
  "coral",
  "core",
  "corn",
  "correct",
  "cost",
  "cotton",
  "couch",
  "country",
  "couple",
  "course",
  "cousin",
  "cover",
  "coyote",
  "crack",
  "cradle",
  "craft",
  "cram",
  "crane",
  "crash",
  "crater",
  "crawl",
  "crazy",
  "cream",
  "credit",
  "creek",
  "crew",
  "cricket",
  "crime",
  "crisp",
  "critic",
  "crop",
  "cross",
  "crouch",
  "crowd",
  "crucial",
  "cruel",
  "cruise",
  "crumble",
  "crunch",
  "crush",
  "cry",
  "crystal",
  "cube",
  "culture",
  "cup",
  "cupboard",
  "curious",
  "current",
  "curtain",
  "curve",
  "cushion",
  "custom",
  "cute",
  "cycle",
  "dad",
  "damage",
  "damp",
  "dance",
  "danger",
  "daring",
  "dash",
  "daughter",
  "dawn",
  "day",
  "deal",
  "debate",
  "debris",
  "decade",
  "december",
  "decide",
  "decline",
  "decorate",
  "decrease",
  "deer",
  "defense",
  "define",
  "defy",
  "degree",
  "delay",
  "deliver",
  "demand",
  "demise",
  "denial",
  "dentist",
  "deny",
  "depart",
  "depend",
  "deposit",
  "depth",
  "deputy",
  "derive",
  "describe",
  "desert",
  "design",
  "desk",
  "despair",
  "destroy",
  "detail",
  "detect",
  "develop",
  "device",
  "devote",
  "diagram",
  "dial",
  "diamond",
  "diary",
  "dice",
  "diesel",
  "diet",
  "differ",
  "digital",
  "dignity",
  "dilemma",
  "dinner",
  "dinosaur",
  "direct",
  "dirt",
  "disagree",
  "discover",
  "disease",
  "dish",
  "dismiss",
  "disorder",
  "display",
  "distance",
  "divert",
  "divide",
  "divorce",
  "dizzy",
  "doctor",
  "document",
  "dog",
  "doll",
  "dolphin",
  "domain",
  "donate",
  "donkey",
  "donor",
  "door",
  "dose",
  "double",
  "dove",
  "draft",
  "dragon",
  "drama",
  "drastic",
  "draw",
  "dream",
  "dress",
  "drift",
  "drill",
  "drink",
  "drip",
  "drive",
  "drop",
  "drum",
  "dry",
  "duck",
  "dumb",
  "dune",
  "during",
  "dust",
  "dutch",
  "duty",
  "dwarf",
  "dynamic",
  "eager",
  "eagle",
  "early",
  "earn",
  "earth",
  "easily",
  "east",
  "easy",
  "echo",
  "ecology",
  "economy",
  "edge",
  "edit",
  "educate",
  "effort",
  "egg",
  "eight",
  "either",
  "elbow",
  "elder",
  "electric",
  "elegant",
  "element",
  "elephant",
  "elevator",
  "elite",
  "else",
  "embark",
  "embody",
  "embrace",
  "emerge",
  "emotion",
  "employ",
  "empower",
  "empty",
  "enable",
  "enact",
  "end",
  "endless",
  "endorse",
  "enemy",
  "energy",
  "enforce",
  "engage",
  "engine",
  "enhance",
  "enjoy",
  "enlist",
  "enough",
  "enrich",
  "enroll",
  "ensure",
  "enter",
  "entire",
  "entry",
  "envelope",
  "episode",
  "equal",
  "equip",
  "era",
  "erase",
  "erode",
  "erosion",
  "error",
  "erupt",
  "escape",
  "essay",
  "essence",
  "estate",
  "eternal",
  "ethics",
  "evidence",
  "evil",
  "evoke",
  "evolve",
  "exact",
  "example",
  "excess",
  "exchange",
  "excite",
  "exclude",
  "excuse",
  "execute",
  "exercise",
  "exhaust",
  "exhibit",
  "exile",
  "exist",
  "exit",
  "exotic",
  "expand",
  "expect",
  "expire",
  "explain",
  "expose",
  "express",
  "extend",
  "extra",
  "eye",
  "eyebrow",
  "fabric",
  "face",
  "faculty",
  "fade",
  "faint",
  "faith",
  "fall",
  "false",
  "fame",
  "family",
  "famous",
  "fan",
  "fancy",
  "fantasy",
  "farm",
  "fashion",
  "fat",
  "fatal",
  "father",
  "fatigue",
  "fault",
  "favorite",
  "feature",
  "february",
  "federal",
  "fee",
  "feed",
  "feel",
  "female",
  "fence",
  "festival",
  "fetch",
  "fever",
  "few",
  "fiber",
  "fiction",
  "field",
  "figure",
  "file",
  "film",
  "filter",
  "final",
  "find",
  "fine",
  "finger",
  "finish",
  "fire",
  "firm",
  "first",
  "fiscal",
  "fish",
  "fit",
  "fitness",
  "fix",
  "flag",
  "flame",
  "flash",
  "flat",
  "flavor",
  "flee",
  "flight",
  "flip",
  "float",
  "flock",
  "floor",
  "flower",
  "fluid",
  "flush",
  "fly",
  "foam",
  "focus",
  "fog",
  "foil",
  "fold",
  "follow",
  "food",
  "foot",
  "force",
  "forest",
  "forget",
  "fork",
  "fortune",
  "forum",
  "forward",
  "fossil",
  "foster",
  "found",
  "fox",
  "fragile",
  "frame",
  "frequent",
  "fresh",
  "friend",
  "fringe",
  "frog",
  "front",
  "frost",
  "frown",
  "frozen",
  "fruit",
  "fuel",
  "fun",
  "funny",
  "furnace",
  "fury",
  "future",
  "gadget",
  "gain",
  "galaxy",
  "gallery",
  "game",
  "gap",
  "garage",
  "garbage",
  "garden",
  "garlic",
  "garment",
  "gas",
  "gasp",
  "gate",
  "gather",
  "gauge",
  "gaze",
  "general",
  "genius",
  "genre",
  "gentle",
  "genuine",
  "gesture",
  "ghost",
  "giant",
  "gift",
  "giggle",
  "ginger",
  "giraffe",
  "girl",
  "give",
  "glad",
  "glance",
  "glare",
  "glass",
  "glide",
  "glimpse",
  "globe",
  "gloom",
  "glory",
  "glove",
  "glow",
  "glue",
  "goat",
  "goddess",
  "gold",
  "good",
  "goose",
  "gorilla",
  "gospel",
  "gossip",
  "govern",
  "gown",
  "grab",
  "grace",
  "grain",
  "grant",
  "grape",
  "grass",
  "gravity",
  "great",
  "green",
  "grid",
  "grief",
  "grit",
  "grocery",
  "group",
  "grow",
  "grunt",
  "guard",
  "guess",
  "guide",
  "guilt",
  "guitar",
  "gun",
  "gym",
  "habit",
  "hair",
  "half",
  "hammer",
  "hamster",
  "hand",
  "happy",
  "harbor",
  "hard",
  "harsh",
  "harvest",
  "hat",
  "have",
  "hawk",
  "hazard",
  "head",
  "health",
  "heart",
  "heavy",
  "hedgehog",
  "height",
  "hello",
  "helmet",
  "help",
  "hen",
  "hero",
  "hidden",
  "high",
  "hill",
  "hint",
  "hip",
  "hire",
  "history",
  "hobby",
  "hockey",
  "hold",
  "hole",
  "holiday",
  "hollow",
  "home",
  "honey",
  "hood",
  "hope",
  "horn",
  "horror",
  "horse",
  "hospital",
  "host",
  "hotel",
  "hour",
  "hover",
  "hub",
  "huge",
  "human",
  "humble",
  "humor",
  "hundred",
  "hungry",
  "hunt",
  "hurdle",
  "hurry",
  "hurt",
  "husband",
  "hybrid",
  "ice",
  "icon",
  "idea",
  "identify",
  "idle",
  "ignore",
  "ill",
  "illegal",
  "illness",
  "image",
  "imitate",
  "immense",
  "immune",
  "impact",
  "impose",
  "improve",
  "impulse",
  "inch",
  "include",
  "income",
  "increase",
  "index",
  "indicate",
  "indoor",
  "industry",
  "infant",
  "inflict",
  "inform",
  "inhale",
  "inherit",
  "initial",
  "inject",
  "injury",
  "inmate",
  "inner",
  "innocent",
  "input",
  "inquiry",
  "insane",
  "insect",
  "inside",
  "inspire",
  "install",
  "intact",
  "interest",
  "into",
  "invest",
  "invite",
  "involve",
  "iron",
  "island",
  "isolate",
  "issue",
  "item",
  "ivory",
  "jacket",
  "jaguar",
  "jar",
  "jazz",
  "jealous",
  "jeans",
  "jelly",
  "jewel",
  "job",
  "join",
  "joke",
  "journey",
  "joy",
  "judge",
  "juice",
  "jump",
  "jungle",
  "junior",
  "junk",
  "just",
  "kangaroo",
  "keen",
  "keep",
  "ketchup",
  "key",
  "kick",
  "kid",
  "kidney",
  "kind",
  "kingdom",
  "kiss",
  "kit",
  "kitchen",
  "kite",
  "kitten",
  "kiwi",
  "knee",
  "knife",
  "knock",
  "know",
  "lab",
  "label",
  "labor",
  "ladder",
  "lady",
  "lake",
  "lamp",
  "language",
  "laptop",
  "large",
  "later",
  "latin",
  "laugh",
  "laundry",
  "lava",
  "law",
  "lawn",
  "lawsuit",
  "layer",
  "lazy",
  "leader",
  "leaf",
  "learn",
  "leave",
  "lecture",
  "left",
  "leg",
  "legal",
  "legend",
  "leisure",
  "lemon",
  "lend",
  "length",
  "lens",
  "leopard",
  "lesson",
  "letter",
  "level",
  "liar",
  "liberty",
  "library",
  "license",
  "life",
  "lift",
  "light",
  "like",
  "limb",
  "limit",
  "link",
  "lion",
  "liquid",
  "list",
  "little",
  "live",
  "lizard",
  "load",
  "loan",
  "lobster",
  "local",
  "lock",
  "logic",
  "lonely",
  "long",
  "loop",
  "lottery",
  "loud",
  "lounge",
  "love",
  "loyal",
  "lucky",
  "luggage",
  "lumber",
  "lunar",
  "lunch",
  "luxury",
  "lyrics",
  "machine",
  "mad",
  "magic",
  "magnet",
  "maid",
  "mail",
  "main",
  "major",
  "make",
  "mammal",
  "man",
  "manage",
  "mandate",
  "mango",
  "mansion",
  "manual",
  "maple",
  "marble",
  "march",
  "margin",
  "marine",
  "market",
  "marriage",
  "mask",
  "mass",
  "master",
  "match",
  "material",
  "math",
  "matrix",
  "matter",
  "maximum",
  "maze",
  "meadow",
  "mean",
  "measure",
  "meat",
  "mechanic",
  "medal",
  "media",
  "melody",
  "melt",
  "member",
  "memory",
  "mention",
  "menu",
  "mercy",
  "merge",
  "merit",
  "merry",
  "mesh",
  "message",
  "metal",
  "method",
  "middle",
  "midnight",
  "milk",
  "million",
  "mimic",
  "mind",
  "minimum",
  "minor",
  "minute",
  "miracle",
  "mirror",
  "misery",
  "miss",
  "mistake",
  "mix",
  "mixed",
  "mixture",
  "mobile",
  "model",
  "modify",
  "mom",
  "moment",
  "monitor",
  "monkey",
  "monster",
  "month",
  "moon",
  "moral",
  "more",
  "morning",
  "mosquito",
  "mother",
  "motion",
  "motor",
  "mountain",
  "mouse",
  "move",
  "movie",
  "much",
  "muffin",
  "mule",
  "multiply",
  "muscle",
  "museum",
  "mushroom",
  "music",
  "must",
  "mutual",
  "myself",
  "mystery",
  "myth",
  "naive",
  "name",
  "napkin",
  "narrow",
  "nasty",
  "nation",
  "nature",
  "near",
  "neck",
  "need",
  "negative",
  "neglect",
  "neither",
  "nephew",
  "nerve",
  "nest",
  "net",
  "network",
  "neutral",
  "never",
  "news",
  "next",
  "nice",
  "night",
  "noble",
  "noise",
  "nominee",
  "noodle",
  "normal",
  "north",
  "nose",
  "notable",
  "note",
  "nothing",
  "notice",
  "novel",
  "now",
  "nuclear",
  "number",
  "nurse",
  "nut",
  "oak",
  "obey",
  "object",
  "oblige",
  "obscure",
  "observe",
  "obtain",
  "obvious",
  "occur",
  "ocean",
  "october",
  "odor",
  "off",
  "offer",
  "office",
  "often",
  "oil",
  "okay",
  "old",
  "olive",
  "olympic",
  "omit",
  "once",
  "one",
  "onion",
  "online",
  "only",
  "open",
  "opera",
  "opinion",
  "oppose",
  "option",
  "orange",
  "orbit",
  "orchard",
  "order",
  "ordinary",
  "organ",
  "orient",
  "original",
  "orphan",
  "ostrich",
  "other",
  "outdoor",
  "outer",
  "output",
  "outside",
  "oval",
  "oven",
  "over",
  "own",
  "owner",
  "oxygen",
  "oyster",
  "ozone",
  "pact",
  "paddle",
  "page",
  "pair",
  "palace",
  "palm",
  "panda",
  "panel",
  "panic",
  "panther",
  "paper",
  "parade",
  "parent",
  "park",
  "parrot",
  "party",
  "pass",
  "patch",
  "path",
  "patient",
  "patrol",
  "pattern",
  "pause",
  "pave",
  "payment",
  "peace",
  "peanut",
  "pear",
  "peasant",
  "pelican",
  "pen",
  "penalty",
  "pencil",
  "people",
  "pepper",
  "perfect",
  "permit",
  "person",
  "pet",
  "phone",
  "photo",
  "phrase",
  "physical",
  "piano",
  "picnic",
  "picture",
  "piece",
  "pig",
  "pigeon",
  "pill",
  "pilot",
  "pink",
  "pioneer",
  "pipe",
  "pistol",
  "pitch",
  "pizza",
  "place",
  "planet",
  "plastic",
  "plate",
  "play",
  "please",
  "pledge",
  "pluck",
  "plug",
  "plunge",
  "poem",
  "poet",
  "point",
  "polar",
  "pole",
  "police",
  "pond",
  "pony",
  "pool",
  "popular",
  "portion",
  "position",
  "possible",
  "post",
  "potato",
  "pottery",
  "poverty",
  "powder",
  "power",
  "practice",
  "praise",
  "predict",
  "prefer",
  "prepare",
  "present",
  "pretty",
  "prevent",
  "price",
  "pride",
  "primary",
  "print",
  "priority",
  "prison",
  "private",
  "prize",
  "problem",
  "process",
  "produce",
  "profit",
  "program",
  "project",
  "promote",
  "proof",
  "property",
  "prosper",
  "protect",
  "proud",
  "provide",
  "public",
  "pudding",
  "pull",
  "pulp",
  "pulse",
  "pumpkin",
  "punch",
  "pupil",
  "puppy",
  "purchase",
  "purity",
  "purpose",
  "purse",
  "push",
  "put",
  "puzzle",
  "pyramid",
  "quality",
  "quantum",
  "quarter",
  "question",
  "quick",
  "quit",
  "quiz",
  "quote",
  "rabbit",
  "raccoon",
  "race",
  "rack",
  "radar",
  "radio",
  "rail",
  "rain",
  "raise",
  "rally",
  "ramp",
  "ranch",
  "random",
  "range",
  "rapid",
  "rare",
  "rate",
  "rather",
  "raven",
  "raw",
  "razor",
  "ready",
  "real",
  "reason",
  "rebel",
  "rebuild",
  "recall",
  "receive",
  "recipe",
  "record",
  "recycle",
  "reduce",
  "reflect",
  "reform",
  "refuse",
  "region",
  "regret",
  "regular",
  "reject",
  "relax",
  "release",
  "relief",
  "rely",
  "remain",
  "remember",
  "remind",
  "remove",
  "render",
  "renew",
  "rent",
  "reopen",
  "repair",
  "repeat",
  "replace",
  "report",
  "require",
  "rescue",
  "resemble",
  "resist",
  "resource",
  "response",
  "result",
  "retire",
  "retreat",
  "return",
  "reunion",
  "reveal",
  "review",
  "reward",
  "rhythm",
  "rib",
  "ribbon",
  "rice",
  "rich",
  "ride",
  "ridge",
  "rifle",
  "right",
  "rigid",
  "ring",
  "riot",
  "ripple",
  "risk",
  "ritual",
  "rival",
  "river",
  "road",
  "roast",
  "robot",
  "robust",
  "rocket",
  "romance",
  "roof",
  "rookie",
  "room",
  "rose",
  "rotate",
  "rough",
  "round",
  "route",
  "royal",
  "rubber",
  "rude",
  "rug",
  "rule",
  "run",
  "runway",
  "rural",
  "sad",
  "saddle",
  "sadness",
  "safe",
  "sail",
  "salad",
  "salmon",
  "salon",
  "salt",
  "salute",
  "same",
  "sample",
  "sand",
  "satisfy",
  "satoshi",
  "sauce",
  "sausage",
  "save",
  "say",
  "scale",
  "scan",
  "scare",
  "scatter",
  "scene",
  "scheme",
  "school",
  "science",
  "scissors",
  "scorpion",
  "scout",
  "scrap",
  "screen",
  "script",
  "scrub",
  "sea",
  "search",
  "season",
  "seat",
  "second",
  "secret",
  "section",
  "security",
  "seed",
  "seek",
  "segment",
  "select",
  "sell",
  "seminar",
  "senior",
  "sense",
  "sentence",
  "series",
  "service",
  "session",
  "settle",
  "setup",
  "seven",
  "shadow",
  "shaft",
  "shallow",
  "share",
  "shed",
  "shell",
  "sheriff",
  "shield",
  "shift",
  "shine",
  "ship",
  "shiver",
  "shock",
  "shoe",
  "shoot",
  "shop",
  "short",
  "shoulder",
  "shove",
  "shrimp",
  "shrug",
  "shuffle",
  "shy",
  "sibling",
  "sick",
  "side",
  "siege",
  "sight",
  "sign",
  "silent",
  "silk",
  "silly",
  "silver",
  "similar",
  "simple",
  "since",
  "sing",
  "siren",
  "sister",
  "situate",
  "six",
  "size",
  "skate",
  "sketch",
  "ski",
  "skill",
  "skin",
  "skirt",
  "skull",
  "slab",
  "slam",
  "sleep",
  "slender",
  "slice",
  "slide",
  "slight",
  "slim",
  "slogan",
  "slot",
  "slow",
  "slush",
  "small",
  "smart",
  "smile",
  "smoke",
  "smooth",
  "snack",
  "snake",
  "snap",
  "sniff",
  "snow",
  "soap",
  "soccer",
  "social",
  "sock",
  "soda",
  "soft",
  "solar",
  "soldier",
  "solid",
  "solution",
  "solve",
  "someone",
  "song",
  "soon",
  "sorry",
  "sort",
  "soul",
  "sound",
  "soup",
  "source",
  "south",
  "space",
  "spare",
  "spatial",
  "spawn",
  "speak",
  "special",
  "speed",
  "spell",
  "spend",
  "sphere",
  "spice",
  "spider",
  "spike",
  "spin",
  "spirit",
  "split",
  "spoil",
  "sponsor",
  "spoon",
  "sport",
  "spot",
  "spray",
  "spread",
  "spring",
  "spy",
  "square",
  "squeeze",
  "squirrel",
  "stable",
  "stadium",
  "staff",
  "stage",
  "stairs",
  "stamp",
  "stand",
  "start",
  "state",
  "stay",
  "steak",
  "steel",
  "stem",
  "step",
  "stereo",
  "stick",
  "still",
  "sting",
  "stock",
  "stomach",
  "stone",
  "stool",
  "story",
  "stove",
  "strategy",
  "street",
  "strike",
  "strong",
  "struggle",
  "student",
  "stuff",
  "stumble",
  "style",
  "subject",
  "submit",
  "subway",
  "success",
  "such",
  "sudden",
  "suffer",
  "sugar",
  "suggest",
  "suit",
  "summer",
  "sun",
  "sunny",
  "sunset",
  "super",
  "supply",
  "supreme",
  "sure",
  "surface",
  "surge",
  "surprise",
  "surround",
  "survey",
  "suspect",
  "sustain",
  "swallow",
  "swamp",
  "swap",
  "swarm",
  "swear",
  "sweet",
  "swift",
  "swim",
  "swing",
  "switch",
  "sword",
  "symbol",
  "symptom",
  "syrup",
  "system",
  "table",
  "tackle",
  "tag",
  "tail",
  "talent",
  "talk",
  "tank",
  "tape",
  "target",
  "task",
  "taste",
  "tattoo",
  "taxi",
  "teach",
  "team",
  "tell",
  "ten",
  "tenant",
  "tennis",
  "tent",
  "term",
  "test",
  "text",
  "thank",
  "that",
  "theme",
  "then",
  "theory",
  "there",
  "they",
  "thing",
  "this",
  "thought",
  "three",
  "thrive",
  "throw",
  "thumb",
  "thunder",
  "ticket",
  "tide",
  "tiger",
  "tilt",
  "timber",
  "time",
  "tiny",
  "tip",
  "tired",
  "tissue",
  "title",
  "toast",
  "tobacco",
  "today",
  "toddler",
  "toe",
  "together",
  "toilet",
  "token",
  "tomato",
  "tomorrow",
  "tone",
  "tongue",
  "tonight",
  "tool",
  "tooth",
  "top",
  "topic",
  "topple",
  "torch",
  "tornado",
  "tortoise",
  "toss",
  "total",
  "tourist",
  "toward",
  "tower",
  "town",
  "toy",
  "track",
  "trade",
  "traffic",
  "tragic",
  "train",
  "transfer",
  "trap",
  "trash",
  "travel",
  "tray",
  "treat",
  "tree",
  "trend",
  "trial",
  "tribe",
  "trick",
  "trigger",
  "trim",
  "trip",
  "trophy",
  "trouble",
  "truck",
  "true",
  "truly",
  "trumpet",
  "trust",
  "truth",
  "try",
  "tube",
  "tuition",
  "tumble",
  "tuna",
  "tunnel",
  "turkey",
  "turn",
  "turtle",
  "twelve",
  "twenty",
  "twice",
  "twin",
  "twist",
  "two",
  "type",
  "typical",
  "ugly",
  "umbrella",
  "unable",
  "unaware",
  "uncle",
  "uncover",
  "under",
  "undo",
  "unfair",
  "unfold",
  "unhappy",
  "uniform",
  "unique",
  "unit",
  "universe",
  "unknown",
  "unlock",
  "until",
  "unusual",
  "unveil",
  "update",
  "upgrade",
  "uphold",
  "upon",
  "upper",
  "upset",
  "urban",
  "urge",
  "usage",
  "use",
  "used",
  "useful",
  "useless",
  "usual",
  "utility",
  "vacant",
  "vacuum",
  "vague",
  "valid",
  "valley",
  "valve",
  "van",
  "vanish",
  "vapor",
  "various",
  "vast",
  "vault",
  "vehicle",
  "velvet",
  "vendor",
  "venture",
  "venue",
  "verb",
  "verify",
  "version",
  "very",
  "vessel",
  "veteran",
  "viable",
  "vibrant",
  "vicious",
  "victory",
  "video",
  "view",
  "village",
  "vintage",
  "violin",
  "virtual",
  "virus",
  "visa",
  "visit",
  "visual",
  "vital",
  "vivid",
  "vocal",
  "voice",
  "void",
  "volcano",
  "volume",
  "vote",
  "voyage",
  "wage",
  "wagon",
  "wait",
  "walk",
  "wall",
  "walnut",
  "want",
  "warfare",
  "warm",
  "warrior",
  "wash",
  "wasp",
  "waste",
  "water",
  "wave",
  "way",
  "wealth",
  "weapon",
  "wear",
  "weasel",
  "weather",
  "web",
  "wedding",
  "weekend",
  "weird",
  "welcome",
  "west",
  "wet",
  "whale",
  "what",
  "wheat",
  "wheel",
  "when",
  "where",
  "whip",
  "whisper",
  "wide",
  "width",
  "wife",
  "wild",
  "will",
  "win",
  "window",
  "wine",
  "wing",
  "wink",
  "winner",
  "winter",
  "wire",
  "wisdom",
  "wise",
  "wish",
  "witness",
  "wolf",
  "woman",
  "wonder",
  "wood",
  "wool",
  "word",
  "work",
  "world",
  "worry",
  "worth",
  "wrap",
  "wreck",
  "wrestle",
  "wrist",
  "write",
  "wrong",
  "yard",
  "year",
  "yellow",
  "you",
  "young",
  "youth",
  "zebra",
  "zero",
  "zone",
  "zoo"
];
Jf.wordlist = eP;
var tP = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(fr, "__esModule", { value: !0 });
fr.mnemonicFromRandomSeed = fr.mnemonicIndexesToBytes = fr.bytesToMnemonics = fr.bytesToMnemonicIndexes = fr.mnemonicNew = fr.mnemonicValidate = fr.mnemonicToHDSeed = fr.mnemonicToWalletKey = fr.mnemonicToPrivateKey = fr.mnemonicToSeed = fr.mnemonicToEntropy = void 0;
const x_ = tP(w_), rP = Yn, nP = ni, Sc = jf, Z1 = Xi, Tl = Jf, Rm = 1e5;
async function M_(t) {
  const e = await Xf(t);
  return await iP(e) && !await Om(e);
}
function Pm(t) {
  return t.map((e) => e.toLowerCase().trim());
}
async function Om(t) {
  return (await (0, Sc.pbkdf2_sha512)(t, "TON seed version", Math.max(1, Math.floor(Rm / 256)), 64))[0] == 0;
}
async function iP(t) {
  return (await (0, Sc.pbkdf2_sha512)(t, "TON fast seed version", 1, 64))[0] == 1;
}
async function Xf(t, e) {
  return await (0, nP.hmac_sha512)(t.join(" "), e && e.length > 0 ? e : "");
}
fr.mnemonicToEntropy = Xf;
async function Nm(t, e, r) {
  const i = await Xf(t, r);
  return await (0, Sc.pbkdf2_sha512)(i, e, Rm, 64);
}
fr.mnemonicToSeed = Nm;
async function S_(t, e) {
  t = Pm(t);
  const r = await Nm(t, "TON default seed", e);
  let i = x_.default.sign.keyPair.fromSeed(r.slice(0, 32));
  return {
    publicKey: Je.from(i.publicKey),
    secretKey: Je.from(i.secretKey)
  };
}
fr.mnemonicToPrivateKey = S_;
async function aP(t, e) {
  let i = (await S_(t, e)).secretKey.slice(0, 32);
  const f = x_.default.sign.keyPair.fromSeed(i);
  return {
    publicKey: Je.from(f.publicKey),
    secretKey: Je.from(f.secretKey)
  };
}
fr.mnemonicToWalletKey = aP;
async function sP(t, e) {
  return t = Pm(t), await Nm(t, "TON HD Keys seed", e);
}
fr.mnemonicToHDSeed = sP;
async function E_(t, e) {
  t = Pm(t);
  for (let r of t)
    if (Tl.wordlist.indexOf(r) < 0)
      return !1;
  return e && e.length > 0 && !await M_(t) ? !1 : await Om(await Xf(t, e));
}
fr.mnemonicValidate = E_;
async function oP(t = 24, e) {
  let r = [];
  for (; ; ) {
    r = [];
    for (let i = 0; i < t; i++) {
      let f = await (0, rP.getSecureRandomNumber)(0, Tl.wordlist.length);
      r.push(Tl.wordlist[f]);
    }
    if (!(e && e.length > 0 && !await M_(r)) && await Om(await Xf(r, e)))
      break;
  }
  return r;
}
fr.mnemonicNew = oP;
function A_(t, e) {
  let r = (0, Z1.bytesToBits)(t), i = [];
  for (let f = 0; f < e; f++) {
    let a = r.slice(f * 11, f * 11 + 11);
    i.push(parseInt(a, 2));
  }
  return i;
}
fr.bytesToMnemonicIndexes = A_;
function k_(t, e) {
  let r = A_(t, e), i = [];
  for (let f of r)
    i.push(Tl.wordlist[f]);
  return i;
}
fr.bytesToMnemonics = k_;
function fP(t) {
  let e = "";
  for (let r of t) {
    if (!Number.isSafeInteger(r) || r < 0 || r >= 2028)
      throw Error("Invalid input");
    e += (0, Z1.lpad)(r.toString(2), "0", 11);
  }
  for (; e.length % 8 !== 0; )
    e = e + "0";
  return (0, Z1.bitsToBytes)(e);
}
fr.mnemonicIndexesToBytes = fP;
async function uP(t, e = 24, r) {
  const i = Math.ceil(e * 11 / 8);
  let f = t;
  for (; ; ) {
    let a = await (0, Sc.pbkdf2_sha512)(f, "TON mnemonic seed", Math.max(1, Math.floor(Rm / 256)), i), l = k_(a, e);
    if (await E_(l, r))
      return l;
    f = a;
  }
}
fr.mnemonicFromRandomSeed = uP;
var Wr = {}, lP = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Wr, "__esModule", { value: !0 });
Wr.openBox = Wr.sealBox = Wr.signVerify = Wr.sign = Wr.keyPairFromSeed = Wr.keyPairFromSecretKey = void 0;
const wo = lP(w_);
function cP(t) {
  let e = wo.default.sign.keyPair.fromSecretKey(new Uint8Array(t));
  return {
    publicKey: Je.from(e.publicKey),
    secretKey: Je.from(e.secretKey)
  };
}
Wr.keyPairFromSecretKey = cP;
function dP(t) {
  let e = wo.default.sign.keyPair.fromSeed(new Uint8Array(t));
  return {
    publicKey: Je.from(e.publicKey),
    secretKey: Je.from(e.secretKey)
  };
}
Wr.keyPairFromSeed = dP;
function hP(t, e) {
  return Je.from(wo.default.sign.detached(new Uint8Array(t), new Uint8Array(e)));
}
Wr.sign = hP;
function pP(t, e, r) {
  return wo.default.sign.detached.verify(new Uint8Array(t), new Uint8Array(e), new Uint8Array(r));
}
Wr.signVerify = pP;
function vP(t, e, r) {
  return Je.from(wo.default.secretbox(t, e, r));
}
Wr.sealBox = vP;
function mP(t, e, r) {
  let i = wo.default.secretbox.open(t, e, r);
  return i ? Je.from(i) : null;
}
Wr.openBox = mP;
var ea = {};
Object.defineProperty(ea, "__esModule", { value: !0 });
ea.deriveEd25519Path = ea.deriveED25519HardenedKey = ea.getED25519MasterKeyFromSeed = void 0;
const T_ = ni, gP = "ed25519 seed", uw = 2147483648;
async function C_(t) {
  const e = await (0, T_.hmac_sha512)(gP, t), r = e.slice(0, 32), i = e.slice(32);
  return {
    key: r,
    chainCode: i
  };
}
ea.getED25519MasterKeyFromSeed = C_;
async function B_(t, e) {
  if (e >= uw)
    throw Error("Key index must be less than offset");
  const r = Je.alloc(4);
  r.writeUInt32BE(e + uw, 0);
  const i = Je.concat([Je.alloc(1, 0), t.key, r]), f = await (0, T_.hmac_sha512)(t.chainCode, i), a = f.slice(0, 32), l = f.slice(32);
  return {
    key: a,
    chainCode: l
  };
}
ea.deriveED25519HardenedKey = B_;
async function yP(t, e) {
  let r = await C_(t), i = [...e];
  for (; i.length > 0; ) {
    let f = i[0];
    i = i.slice(1), r = await B_(r, f);
  }
  return r.key;
}
ea.deriveEd25519Path = yP;
var ta = {};
Object.defineProperty(ta, "__esModule", { value: !0 });
ta.deriveSymmetricPath = ta.deriveSymmetricHardenedKey = ta.getSymmetricMasterKeyFromSeed = void 0;
const I_ = ni, bP = "Symmetric key seed";
async function R_(t) {
  const e = await (0, I_.hmac_sha512)(bP, t), r = e.slice(32), i = e.slice(0, 32);
  return {
    key: r,
    chainCode: i
  };
}
ta.getSymmetricMasterKeyFromSeed = R_;
async function P_(t, e) {
  const r = Je.concat([Je.alloc(1, 0), Je.from(e)]), i = await (0, I_.hmac_sha512)(t.chainCode, r), f = i.slice(32), a = i.slice(0, 32);
  return {
    key: f,
    chainCode: a
  };
}
ta.deriveSymmetricHardenedKey = P_;
async function wP(t, e) {
  let r = await R_(t), i = [...e];
  for (; i.length > 0; ) {
    let f = i[0];
    i = i.slice(1), r = await P_(r, f);
  }
  return r.key;
}
ta.deriveSymmetricPath = wP;
var ra = {};
Object.defineProperty(ra, "__esModule", { value: !0 });
ra.deriveMnemonicsPath = ra.deriveMnemonicHardenedKey = ra.getMnemonicsMasterKeyFromSeed = void 0;
const _P = fr, O_ = ni, lw = 2147483648, xP = "TON Mnemonics HD seed";
async function N_(t) {
  const e = await (0, O_.hmac_sha512)(xP, t), r = e.slice(0, 32), i = e.slice(32);
  return {
    key: r,
    chainCode: i
  };
}
ra.getMnemonicsMasterKeyFromSeed = N_;
async function D_(t, e) {
  if (e >= lw)
    throw Error("Key index must be less than offset");
  const r = Je.alloc(4);
  r.writeUInt32BE(e + lw, 0);
  const i = Je.concat([Je.alloc(1, 0), t.key, r]), f = await (0, O_.hmac_sha512)(t.chainCode, i), a = f.slice(0, 32), l = f.slice(32);
  return {
    key: a,
    chainCode: l
  };
}
ra.deriveMnemonicHardenedKey = D_;
async function MP(t, e, r = 24, i) {
  let f = await N_(t), a = [...e];
  for (; a.length > 0; ) {
    let l = a[0];
    a = a.slice(1), f = await D_(f, l);
  }
  return await (0, _P.mnemonicFromRandomSeed)(f.key, r, i);
}
ra.deriveMnemonicsPath = MP;
var cw;
function gs() {
  return cw || (cw = 1, function(t) {
    Object.defineProperty(t, "__esModule", { value: !0 }), t.getMnemonicsMasterKeyFromSeed = t.deriveMnemonicHardenedKey = t.deriveMnemonicsPath = t.deriveSymmetricPath = t.deriveSymmetricHardenedKey = t.getSymmetricMasterKeyFromSeed = t.deriveEd25519Path = t.deriveED25519HardenedKey = t.getED25519MasterKeyFromSeed = t.signVerify = t.sign = t.keyPairFromSecretKey = t.keyPairFromSeed = t.openBox = t.sealBox = t.mnemonicWordList = t.mnemonicToHDSeed = t.mnemonicToSeed = t.mnemonicToWalletKey = t.mnemonicToPrivateKey = t.mnemonicValidate = t.mnemonicNew = t.newSecurePassphrase = t.newSecureWords = t.getSecureRandomNumber = t.getSecureRandomWords = t.getSecureRandomBytes = t.hmac_sha512 = t.pbkdf2_sha512 = t.sha512_sync = t.sha512 = t.sha256_sync = t.sha256 = void 0;
    var e = Yi;
    Object.defineProperty(t, "sha256", { enumerable: !0, get: function() {
      return e.sha256;
    } }), Object.defineProperty(t, "sha256_sync", { enumerable: !0, get: function() {
      return e.sha256_sync;
    } });
    var r = Ji;
    Object.defineProperty(t, "sha512", { enumerable: !0, get: function() {
      return r.sha512;
    } }), Object.defineProperty(t, "sha512_sync", { enumerable: !0, get: function() {
      return r.sha512_sync;
    } });
    var i = jf;
    Object.defineProperty(t, "pbkdf2_sha512", { enumerable: !0, get: function() {
      return i.pbkdf2_sha512;
    } });
    var f = ni;
    Object.defineProperty(t, "hmac_sha512", { enumerable: !0, get: function() {
      return f.hmac_sha512;
    } });
    var a = Yn;
    Object.defineProperty(t, "getSecureRandomBytes", { enumerable: !0, get: function() {
      return a.getSecureRandomBytes;
    } }), Object.defineProperty(t, "getSecureRandomWords", { enumerable: !0, get: function() {
      return a.getSecureRandomWords;
    } }), Object.defineProperty(t, "getSecureRandomNumber", { enumerable: !0, get: function() {
      return a.getSecureRandomNumber;
    } });
    var l = hc;
    Object.defineProperty(t, "newSecureWords", { enumerable: !0, get: function() {
      return l.newSecureWords;
    } });
    var d = YC();
    Object.defineProperty(t, "newSecurePassphrase", { enumerable: !0, get: function() {
      return d.newSecurePassphrase;
    } });
    var v = fr;
    Object.defineProperty(t, "mnemonicNew", { enumerable: !0, get: function() {
      return v.mnemonicNew;
    } }), Object.defineProperty(t, "mnemonicValidate", { enumerable: !0, get: function() {
      return v.mnemonicValidate;
    } }), Object.defineProperty(t, "mnemonicToPrivateKey", { enumerable: !0, get: function() {
      return v.mnemonicToPrivateKey;
    } }), Object.defineProperty(t, "mnemonicToWalletKey", { enumerable: !0, get: function() {
      return v.mnemonicToWalletKey;
    } }), Object.defineProperty(t, "mnemonicToSeed", { enumerable: !0, get: function() {
      return v.mnemonicToSeed;
    } }), Object.defineProperty(t, "mnemonicToHDSeed", { enumerable: !0, get: function() {
      return v.mnemonicToHDSeed;
    } });
    var m = Jf;
    Object.defineProperty(t, "mnemonicWordList", { enumerable: !0, get: function() {
      return m.wordlist;
    } });
    var h = Wr;
    Object.defineProperty(t, "sealBox", { enumerable: !0, get: function() {
      return h.sealBox;
    } }), Object.defineProperty(t, "openBox", { enumerable: !0, get: function() {
      return h.openBox;
    } });
    var w = Wr;
    Object.defineProperty(t, "keyPairFromSeed", { enumerable: !0, get: function() {
      return w.keyPairFromSeed;
    } }), Object.defineProperty(t, "keyPairFromSecretKey", { enumerable: !0, get: function() {
      return w.keyPairFromSecretKey;
    } }), Object.defineProperty(t, "sign", { enumerable: !0, get: function() {
      return w.sign;
    } }), Object.defineProperty(t, "signVerify", { enumerable: !0, get: function() {
      return w.signVerify;
    } });
    var M = ea;
    Object.defineProperty(t, "getED25519MasterKeyFromSeed", { enumerable: !0, get: function() {
      return M.getED25519MasterKeyFromSeed;
    } }), Object.defineProperty(t, "deriveED25519HardenedKey", { enumerable: !0, get: function() {
      return M.deriveED25519HardenedKey;
    } }), Object.defineProperty(t, "deriveEd25519Path", { enumerable: !0, get: function() {
      return M.deriveEd25519Path;
    } });
    var S = ta;
    Object.defineProperty(t, "getSymmetricMasterKeyFromSeed", { enumerable: !0, get: function() {
      return S.getSymmetricMasterKeyFromSeed;
    } }), Object.defineProperty(t, "deriveSymmetricHardenedKey", { enumerable: !0, get: function() {
      return S.deriveSymmetricHardenedKey;
    } }), Object.defineProperty(t, "deriveSymmetricPath", { enumerable: !0, get: function() {
      return S.deriveSymmetricPath;
    } });
    var E = ra;
    Object.defineProperty(t, "deriveMnemonicsPath", { enumerable: !0, get: function() {
      return E.deriveMnemonicsPath;
    } }), Object.defineProperty(t, "deriveMnemonicHardenedKey", { enumerable: !0, get: function() {
      return E.deriveMnemonicHardenedKey;
    } }), Object.defineProperty(t, "getMnemonicsMasterKeyFromSeed", { enumerable: !0, get: function() {
      return E.getMnemonicsMasterKeyFromSeed;
    } });
  }(Nd)), Nd;
}
Object.defineProperty(fc, "__esModule", { value: !0 });
fc.wonderCalculator = void 0;
const SP = pa(), Vn = va, qo = vo, EP = po, AP = co, kP = xi, TP = gs(), CP = ho, BP = zf;
function IP(t, e, r) {
  let i, f = null;
  if (t === Vn.CellType.Ordinary) {
    let M = 0;
    for (let S of r)
      M = M | S.mask.value;
    i = new qo.LevelMask(M);
  } else if (t === Vn.CellType.PrunedBranch)
    f = (0, EP.exoticPruned)(e, r), i = new qo.LevelMask(f.mask);
  else if (t === Vn.CellType.MerkleProof)
    (0, AP.exoticMerkleProof)(e, r), i = new qo.LevelMask(r[0].mask.value >> 1);
  else if (t === Vn.CellType.MerkleUpdate)
    (0, CP.exoticMerkleUpdate)(e, r), i = new qo.LevelMask((r[0].mask.value | r[1].mask.value) >> 1);
  else if (t === Vn.CellType.Library)
    (0, BP.exoticLibrary)(e, r), i = new qo.LevelMask();
  else
    throw new Error("Unsupported exotic type");
  let a = [], l = [], d = t === Vn.CellType.PrunedBranch ? 1 : i.hashCount, m = i.hashCount - d;
  for (let M = 0, S = 0; M <= i.level; M++) {
    if (!i.isSignificant(M))
      continue;
    if (S < m) {
      S++;
      continue;
    }
    let E;
    if (S === m) {
      if (!(M === 0 || t === Vn.CellType.PrunedBranch))
        throw Error("Invalid");
      E = e;
    } else {
      if (!(M !== 0 && t !== Vn.CellType.PrunedBranch))
        throw Error("Invalid: " + M + ", " + t);
      E = new SP.BitString(l[S - m - 1], 0, 256);
    }
    let A = 0;
    for (let I of r) {
      let O;
      t == Vn.CellType.MerkleProof || t == Vn.CellType.MerkleUpdate ? O = I.depth(M + 1) : O = I.depth(M), A = Math.max(A, O);
    }
    r.length > 0 && A++;
    let B = (0, kP.getRepr)(e, E, r, M, i.apply(M).value, t), k = (0, TP.sha256_sync)(B), C = S - m;
    a[C] = A, l[C] = k, S++;
  }
  let h = [], w = [];
  if (f)
    for (let M = 0; M < 4; M++) {
      const { hashIndex: S } = i.apply(M), { hashIndex: E } = i;
      S !== E ? (h.push(f.pruned[S].hash), w.push(f.pruned[S].depth)) : (h.push(l[0]), w.push(a[0]));
    }
  else
    for (let M = 0; M < 4; M++)
      h.push(l[i.apply(M).hashIndex]), w.push(a[i.apply(M).hashIndex]);
  return {
    mask: i,
    hashes: h,
    depths: w
  };
}
fc.wonderCalculator = IP;
var hi = {}, Ec = {};
Object.defineProperty(Ec, "__esModule", { value: !0 });
Ec.topologicalSort = void 0;
function RP(t) {
  let e = [t], r = /* @__PURE__ */ new Map(), i = /* @__PURE__ */ new Set(), f = [];
  for (; e.length > 0; ) {
    const m = [...e];
    e = [];
    for (let h of m) {
      const w = h.hash().toString("hex");
      if (!r.has(w)) {
        i.add(w), r.set(w, { cell: h, refs: h.refs.map((M) => M.hash().toString("hex")) });
        for (let M of h.refs)
          e.push(M);
      }
    }
  }
  let a = /* @__PURE__ */ new Set();
  function l(m) {
    if (!i.has(m))
      return;
    if (a.has(m))
      throw Error("Not a DAG");
    a.add(m);
    let h = r.get(m).refs;
    for (let w = h.length - 1; w >= 0; w--)
      l(h[w]);
    f.push(m), a.delete(m), i.delete(m);
  }
  for (; i.size > 0; ) {
    const m = Array.from(i)[0];
    l(m);
  }
  let d = /* @__PURE__ */ new Map();
  for (let m = 0; m < f.length; m++)
    d.set(f[f.length - m - 1], m);
  let v = [];
  for (let m = f.length - 1; m >= 0; m--) {
    let h = f[m];
    const w = r.get(h);
    v.push({ cell: w.cell, refs: w.refs.map((M) => d.get(M)) });
  }
  return v;
}
Ec.topologicalSort = RP;
var Ac = {};
Object.defineProperty(Ac, "__esModule", { value: !0 });
Ac.bitsForNumber = void 0;
function PP(t, e) {
  let r = BigInt(t);
  if (e === "int")
    return r === 0n || r === -1n ? 1 : (r > 0 ? r : -r).toString(2).length + 1;
  if (e === "uint") {
    if (r < 0)
      throw Error(`value is negative. Got ${t}`);
    return r.toString(2).length;
  } else
    throw Error(`invalid mode. Got ${e}`);
}
Ac.bitsForNumber = PP;
var eu = {};
Object.defineProperty(eu, "__esModule", { value: !0 });
eu.crc32c = void 0;
const Pi = 2197175160;
function OP(t) {
  let e = -1;
  for (let i = 0; i < t.length; i++)
    e ^= t[i], e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1, e = e & 1 ? e >>> 1 ^ Pi : e >>> 1;
  e = e ^ 4294967295;
  let r = Je.alloc(4);
  return r.writeInt32LE(e), r;
}
eu.crc32c = OP;
var dw;
function NP() {
  if (dw)
    return hi;
  dw = 1, Object.defineProperty(hi, "__esModule", { value: !0 }), hi.serializeBoc = hi.deserializeBoc = hi.parseBoc = void 0;
  const t = qn, e = pa(), r = ys(), i = Ec, f = Ac, a = tc(), l = xi, d = ec(), v = eu;
  function m(k) {
    return h(k & 7);
  }
  function h(k) {
    let C = 0;
    for (let I = 0; I < 3; I++)
      C += k & 1, k = k >> 1;
    return C + 1;
  }
  function w(k, C) {
    const I = k.loadUint(8), O = I % 8, q = !!(I & 8), $ = k.loadUint(8), ae = Math.ceil($ / 2), he = !!($ % 2), te = I >> 5, Ee = (I & 16) != 0, n = Ee ? m(te) * 32 : 0, o = Ee ? m(te) * 2 : 0;
    k.skip(n * 8), k.skip(o * 8);
    let u = e.BitString.EMPTY;
    ae > 0 && (he ? u = k.loadPaddedBits(ae * 8) : u = k.loadBits(ae * 8));
    let c = [];
    for (let g = 0; g < O; g++)
      c.push(k.loadUint(C * 8));
    return {
      bits: u,
      refs: c,
      exotic: q
    };
  }
  function M(k, C) {
    return 2 + Math.ceil(k.bits.length / 8) + k.refs.length * C;
  }
  function S(k) {
    let C = new t.BitReader(new e.BitString(k, 0, k.length * 8)), I = C.loadUint(32);
    if (I === 1761568243) {
      let O = C.loadUint(8), q = C.loadUint(8), $ = C.loadUint(O * 8), ae = C.loadUint(O * 8), he = C.loadUint(O * 8), te = C.loadUint(q * 8), Ee = C.loadBuffer($ * q), x = C.loadBuffer(te);
      return {
        size: O,
        offBytes: q,
        cells: $,
        roots: ae,
        absent: he,
        totalCellSize: te,
        index: Ee,
        cellData: x,
        root: [0]
      };
    } else if (I === 2898503464) {
      let O = C.loadUint(8), q = C.loadUint(8), $ = C.loadUint(O * 8), ae = C.loadUint(O * 8), he = C.loadUint(O * 8), te = C.loadUint(q * 8), Ee = C.loadBuffer($ * q), x = C.loadBuffer(te), n = C.loadBuffer(4);
      if (!(0, v.crc32c)(k.subarray(0, k.length - 4)).equals(n))
        throw Error("Invalid CRC32C");
      return {
        size: O,
        offBytes: q,
        cells: $,
        roots: ae,
        absent: he,
        totalCellSize: te,
        index: Ee,
        cellData: x,
        root: [0]
      };
    } else if (I === 3052313714) {
      let O = C.loadUint(1), q = C.loadUint(1);
      C.loadUint(1), C.loadUint(2);
      let $ = C.loadUint(3), ae = C.loadUint(8), he = C.loadUint($ * 8), te = C.loadUint($ * 8), Ee = C.loadUint($ * 8), x = C.loadUint(ae * 8), n = [];
      for (let c = 0; c < te; c++)
        n.push(C.loadUint($ * 8));
      let o = null;
      O && (o = C.loadBuffer(he * ae));
      let u = C.loadBuffer(x);
      if (q) {
        let c = C.loadBuffer(4);
        if (!(0, v.crc32c)(k.subarray(0, k.length - 4)).equals(c))
          throw Error("Invalid CRC32C");
      }
      return {
        size: $,
        offBytes: ae,
        cells: he,
        roots: te,
        absent: Ee,
        totalCellSize: x,
        index: o,
        cellData: u,
        root: n
      };
    } else
      throw Error("Invalid magic");
  }
  hi.parseBoc = S;
  function E(k) {
    let C = S(k), I = new t.BitReader(new e.BitString(C.cellData, 0, C.cellData.length * 8)), O = [];
    for (let $ = 0; $ < C.cells; $++) {
      let ae = w(I, C.size);
      O.push({ ...ae, result: null });
    }
    for (let $ = O.length - 1; $ >= 0; $--) {
      if (O[$].result)
        throw Error("Impossible");
      let ae = [];
      for (let he of O[$].refs) {
        if (!O[he].result)
          throw Error("Invalid BOC file");
        ae.push(O[he].result);
      }
      O[$].result = new r.Cell({ bits: O[$].bits, refs: ae, exotic: O[$].exotic });
    }
    let q = [];
    for (let $ = 0; $ < C.root.length; $++)
      q.push(O[C.root[$]].result);
    return q;
  }
  hi.deserializeBoc = E;
  function A(k, C, I, O) {
    let q = (0, l.getRefsDescriptor)(k.refs, k.mask.value, k.type), $ = (0, l.getBitsDescriptor)(k.bits);
    O.writeUint(q, 8), O.writeUint($, 8), O.writeBuffer((0, d.bitsToPaddedBuffer)(k.bits));
    for (let ae of C)
      O.writeUint(ae, I * 8);
  }
  function B(k, C) {
    let I = (0, i.topologicalSort)(k), O = I.length, q = C.idx, $ = C.crc32, ae = !1, he = 0, te = Math.max(Math.ceil((0, f.bitsForNumber)(O, "uint") / 8), 1), Ee = 0, x = [];
    for (let g of I) {
      let b = M(g.cell, te);
      Ee += b, x.push(Ee);
    }
    let n = Math.max(Math.ceil((0, f.bitsForNumber)(Ee, "uint") / 8), 1), o = (6 + // offset_bytes
    3 * te + // cells_num, roots, complete
    n + // full_size
    1 * te + // root_idx
    (q ? O * n : 0) + Ee + ($ ? 4 : 0)) * 8, u = new a.BitBuilder(o);
    if (u.writeUint(3052313714, 32), u.writeBit(q), u.writeBit($), u.writeBit(ae), u.writeUint(he, 2), u.writeUint(te, 3), u.writeUint(n, 8), u.writeUint(O, te * 8), u.writeUint(1, te * 8), u.writeUint(0, te * 8), u.writeUint(Ee, n * 8), u.writeUint(0, te * 8), q)
      for (let g = 0; g < O; g++)
        u.writeUint(x[g], n * 8);
    for (let g = 0; g < O; g++)
      A(I[g].cell, I[g].refs, te, u);
    if ($) {
      let g = (0, v.crc32c)(u.buffer());
      u.writeBuffer(g);
    }
    let c = u.buffer();
    if (c.length !== o / 8)
      throw Error("Internal error");
    return c;
  }
  return hi.serializeBoc = B, hi;
}
var hw;
function ys() {
  if (hw)
    return Po;
  hw = 1;
  var t = ut && ut.__importDefault || function(M) {
    return M && M.__esModule ? M : { default: M };
  }, e;
  Object.defineProperty(Po, "__esModule", { value: !0 }), Po.Cell = void 0;
  const r = t(fo), i = pa(), f = va, a = fm(), l = ac, d = fc, v = NP(), m = qn, h = Tr();
  let w = class U_ {
    /**
     * Deserialize cells from BOC
     * @param src source buffer
     * @returns array of cells
     */
    static fromBoc(S) {
      return (0, v.deserializeBoc)(S);
    }
    /**
     * Helper class that deserializes a single cell from BOC in base64
     * @param src source string
     */
    static fromBase64(S) {
      let E = U_.fromBoc(Je.from(S, "base64"));
      if (E.length !== 1)
        throw new Error("Deserialized more than one cell");
      return E[0];
    }
    constructor(S) {
      this._hashes = [], this._depths = [], this.beginParse = (O = !1) => {
        if (this.isExotic && !O)
          throw new Error("Exotic cells cannot be parsed");
        return new a.Slice(new m.BitReader(this.bits), this.refs);
      }, this.hash = (O = 3) => this._hashes[Math.min(this._hashes.length - 1, O)], this.depth = (O = 3) => this._depths[Math.min(this._depths.length - 1, O)], this.level = () => this.mask.level, this.equals = (O) => this.hash().equals(O.hash()), this[e] = () => this.toString();
      let E = i.BitString.EMPTY;
      S && S.bits && (E = S.bits);
      let A = [];
      S && S.refs && (A = [...S.refs]);
      let B, k, C, I = f.CellType.Ordinary;
      if (S && S.exotic) {
        let O = (0, l.resolveExotic)(E, A), q = (0, d.wonderCalculator)(O.type, E, A);
        C = q.mask, k = q.depths, B = q.hashes, I = O.type;
      } else {
        if (A.length > 4)
          throw new Error("Invalid number of references");
        if (E.length > 1023)
          throw new Error(`Bits overflow: ${E.length} > 1023`);
        let O = (0, d.wonderCalculator)(f.CellType.Ordinary, E, A);
        C = O.mask, k = O.depths, B = O.hashes, I = f.CellType.Ordinary;
      }
      this.type = I, this.bits = E, this.refs = A, this.mask = C, this._depths = k, this._hashes = B, Object.freeze(this), Object.freeze(this.refs), Object.freeze(this.bits), Object.freeze(this.mask), Object.freeze(this._depths), Object.freeze(this._hashes);
    }
    /**
     * Check if cell is exotic
     */
    get isExotic() {
      return this.type !== f.CellType.Ordinary;
    }
    /**
     * Serializes cell to BOC
     * @param opts options
     */
    toBoc(S) {
      let E = S && S.idx !== null && S.idx !== void 0 ? S.idx : !1, A = S && S.crc32 !== null && S.crc32 !== void 0 ? S.crc32 : !0;
      return (0, v.serializeBoc)(this, { idx: E, crc32: A });
    }
    /**
     * Format cell to string
     * @param indent indentation
     * @returns string representation
     */
    toString(S) {
      let E = S || "", A = "x";
      this.isExotic && (this.type === f.CellType.MerkleProof ? A = "p" : this.type === f.CellType.MerkleUpdate ? A = "u" : this.type === f.CellType.PrunedBranch && (A = "p"));
      let B = E + (this.isExotic ? A : "x") + "{" + this.bits.toString() + "}";
      for (let k in this.refs) {
        const C = this.refs[k];
        B += `
` + C.toString(E + " ");
      }
      return B;
    }
    /**
     * Covnert cell to slice
     * @returns slice
     */
    asSlice() {
      return this.beginParse();
    }
    /**
     * Convert cell to a builder that has this cell stored
     * @returns builder
     */
    asBuilder() {
      return (0, h.beginCell)().storeSlice(this.asSlice());
    }
  };
  return Po.Cell = w, e = r.default, w.EMPTY = new w(), Po;
}
var pw;
function Tr() {
  if (pw)
    return ga;
  pw = 1, Object.defineProperty(ga, "__esModule", { value: !0 }), ga.Builder = ga.beginCell = void 0;
  const t = tc(), e = ys(), r = p8();
  function i() {
    return new f();
  }
  ga.beginCell = i;
  let f = class L_ {
    constructor() {
      this._bits = new t.BitBuilder(), this._refs = [];
    }
    /**
     * Bits written so far
     */
    get bits() {
      return this._bits.length;
    }
    /**
     * References written so far
     */
    get refs() {
      return this._refs.length;
    }
    /**
     * Available bits
     */
    get availableBits() {
      return 1023 - this.bits;
    }
    /**
     * Available references
     */
    get availableRefs() {
      return 4 - this.refs;
    }
    /**
     * Write a single bit
     * @param value bit to write, true or positive number for 1, false or zero or negative for 0
     * @returns this builder
     */
    storeBit(l) {
      return this._bits.writeBit(l), this;
    }
    /**
     * Write bits from BitString
     * @param src source bits
     * @returns this builder
     */
    storeBits(l) {
      return this._bits.writeBits(l), this;
    }
    /**
     * Store Buffer
     * @param src source buffer
     * @param bytes optional number of bytes to write
     * @returns this builder
     */
    storeBuffer(l, d) {
      if (d != null && l.length !== d)
        throw Error(`Buffer length ${l.length} is not equal to ${d}`);
      return this._bits.writeBuffer(l), this;
    }
    /**
     * Store Maybe Buffer
     * @param src source buffer or null
     * @param bytes optional number of bytes to write
     * @returns this builder
     */
    storeMaybeBuffer(l, d) {
      return l !== null ? (this.storeBit(1), this.storeBuffer(l, d)) : this.storeBit(0), this;
    }
    /**
     * Store uint value
     * @param value value as bigint or number
     * @param bits number of bits to write
     * @returns this builder
     */
    storeUint(l, d) {
      return this._bits.writeUint(l, d), this;
    }
    /**
     * Store maybe uint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write
     * @returns this builder
     */
    storeMaybeUint(l, d) {
      return l != null ? (this.storeBit(1), this.storeUint(l, d)) : this.storeBit(0), this;
    }
    /**
     * Store int value
     * @param value value as bigint or number
     * @param bits number of bits to write
     * @returns this builder
     */
    storeInt(l, d) {
      return this._bits.writeInt(l, d), this;
    }
    /**
     * Store maybe int value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write
     * @returns this builder
     */
    storeMaybeInt(l, d) {
      return l != null ? (this.storeBit(1), this.storeInt(l, d)) : this.storeBit(0), this;
    }
    /**
     * Store varuint value
     * @param value value as bigint or number
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeVarUint(l, d) {
      return this._bits.writeVarUint(l, d), this;
    }
    /**
     * Store maybe varuint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeMaybeVarUint(l, d) {
      return l != null ? (this.storeBit(1), this.storeVarUint(l, d)) : this.storeBit(0), this;
    }
    /**
     * Store varint value
     * @param value value as bigint or number
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeVarInt(l, d) {
      return this._bits.writeVarInt(l, d), this;
    }
    /**
     * Store maybe varint value
     * @param value value as bigint or number, null or undefined
     * @param bits number of bits to write to header
     * @returns this builder
     */
    storeMaybeVarInt(l, d) {
      return l != null ? (this.storeBit(1), this.storeVarInt(l, d)) : this.storeBit(0), this;
    }
    /**
     * Store coins value
     * @param amount amount of coins
     * @returns this builder
     */
    storeCoins(l) {
      return this._bits.writeCoins(l), this;
    }
    /**
     * Store maybe coins value
     * @param amount amount of coins, null or undefined
     * @returns this builder
     */
    storeMaybeCoins(l) {
      return l != null ? (this.storeBit(1), this.storeCoins(l)) : this.storeBit(0), this;
    }
    /**
     * Store address
     * @param addres address to store
     * @returns this builder
     */
    storeAddress(l) {
      return this._bits.writeAddress(l), this;
    }
    /**
     * Store reference
     * @param cell cell or builder to store
     * @returns this builder
     */
    storeRef(l) {
      if (this._refs.length >= 4)
        throw new Error("Too many references");
      if (l instanceof e.Cell)
        this._refs.push(l);
      else if (l instanceof L_)
        this._refs.push(l.endCell());
      else
        throw new Error("Invalid argument");
      return this;
    }
    /**
     * Store reference if not null
     * @param cell cell or builder to store
     * @returns this builder
     */
    storeMaybeRef(l) {
      return l ? (this.storeBit(1), this.storeRef(l)) : this.storeBit(0), this;
    }
    /**
     * Store slice it in this builder
     * @param src source slice
     */
    storeSlice(l) {
      let d = l.clone();
      for (d.remainingBits > 0 && this.storeBits(d.loadBits(d.remainingBits)); d.remainingRefs > 0; )
        this.storeRef(d.loadRef());
      return this;
    }
    /**
     * Store slice in this builder if not null
     * @param src source slice
     */
    storeMaybeSlice(l) {
      return l ? (this.storeBit(1), this.storeSlice(l)) : this.storeBit(0), this;
    }
    /**
     * Store builder
     * @param src builder to store
     * @returns this builder
     */
    storeBuilder(l) {
      return this.storeSlice(l.endCell().beginParse());
    }
    /**
     * Store builder if not null
     * @param src builder to store
     * @returns this builder
     */
    storeMaybeBuilder(l) {
      return l ? (this.storeBit(1), this.storeBuilder(l)) : this.storeBit(0), this;
    }
    /**
     * Store writer or builder
     * @param writer writer or builder to store
     * @returns this builder
     */
    storeWritable(l) {
      return typeof l == "object" ? l.writeTo(this) : l(this), this;
    }
    /**
     * Store writer or builder if not null
     * @param writer writer or builder to store
     * @returns this builder
     */
    storeMaybeWritable(l) {
      return l ? (this.storeBit(1), this.storeWritable(l)) : this.storeBit(0), this;
    }
    /**
     * Store object in this builder
     * @param writer Writable or writer functuin
     */
    store(l) {
      return this.storeWritable(l), this;
    }
    /**
     * Store string tail
     * @param src source string
     * @returns this builder
     */
    storeStringTail(l) {
      return (0, r.writeString)(l, this), this;
    }
    /**
     * Store string tail
     * @param src source string
     * @returns this builder
     */
    storeMaybeStringTail(l) {
      return l != null ? (this.storeBit(1), (0, r.writeString)(l, this)) : this.storeBit(0), this;
    }
    /**
     * Store string tail in ref
     * @param src source string
     * @returns this builder
     */
    storeStringRefTail(l) {
      return this.storeRef(i().storeStringTail(l)), this;
    }
    /**
     * Store maybe string tail in ref
     * @param src source string
     * @returns this builder
     */
    storeMaybeStringRefTail(l) {
      return l != null ? (this.storeBit(1), this.storeStringRefTail(l)) : this.storeBit(0), this;
    }
    /**
     * Store dictionary in this builder
     * @param dict dictionary to store
     * @returns this builder
     */
    storeDict(l, d, v) {
      return l ? l.store(this, d, v) : this.storeBit(0), this;
    }
    /**
     * Store dictionary in this builder directly
     * @param dict dictionary to store
     * @returns this builder
     */
    storeDictDirect(l, d, v) {
      return l.storeDirect(this, d, v), this;
    }
    /**
     * Complete cell
     * @param opts options
     * @returns cell
     */
    endCell(l) {
      return new e.Cell({
        bits: this._bits.build(),
        refs: this._refs,
        exotic: l == null ? void 0 : l.exotic
      });
    }
    /**
     * Convert to cell
     * @returns cell
     */
    asCell() {
      return this.endCell();
    }
    /**
     * Convert to slice
     * @returns slice
     */
    asSlice() {
      return this.endCell().beginParse();
    }
  };
  return ga.Builder = f, ga;
}
var ii = {}, Mi = {};
Object.defineProperty(Mi, "__esModule", { value: !0 });
Mi.SimpleLibraryValue = Mi.storeSimpleLibrary = Mi.loadSimpleLibrary = void 0;
function F_(t) {
  return {
    public: t.loadBit(),
    root: t.loadRef()
  };
}
Mi.loadSimpleLibrary = F_;
function q_(t) {
  return (e) => {
    e.storeBit(t.public), e.storeRef(t.root);
  };
}
Mi.storeSimpleLibrary = q_;
Mi.SimpleLibraryValue = {
  serialize(t, e) {
    q_(t)(e);
  },
  parse(t) {
    return F_(t);
  }
};
var ja = {};
Object.defineProperty(ja, "__esModule", { value: !0 });
ja.storeTickTock = ja.loadTickTock = void 0;
function DP(t) {
  return {
    tick: t.loadBit(),
    tock: t.loadBit()
  };
}
ja.loadTickTock = DP;
function UP(t) {
  return (e) => {
    e.storeBit(t.tick), e.storeBit(t.tock);
  };
}
ja.storeTickTock = UP;
Object.defineProperty(ii, "__esModule", { value: !0 });
ii.storeStateInit = ii.loadStateInit = void 0;
const LP = ms(), FP = Mi, z_ = ja;
function qP(t) {
  let e;
  t.loadBit() && (e = t.loadUint(5));
  let r;
  t.loadBit() && (r = (0, z_.loadTickTock)(t));
  let i = t.loadMaybeRef(), f = t.loadMaybeRef(), a = t.loadDict(LP.Dictionary.Keys.BigUint(256), FP.SimpleLibraryValue);
  return a.size === 0 && (a = void 0), {
    splitDepth: e,
    special: r,
    code: i,
    data: f,
    libraries: a
  };
}
ii.loadStateInit = qP;
function zP(t) {
  return (e) => {
    t.splitDepth !== null && t.splitDepth !== void 0 ? (e.storeBit(!0), e.storeUint(t.splitDepth, 5)) : e.storeBit(!1), t.special !== null && t.special !== void 0 ? (e.storeBit(!0), e.store((0, z_.storeTickTock)(t.special))) : e.storeBit(!1), e.storeMaybeRef(t.code), e.storeMaybeRef(t.data), e.storeDict(t.libraries);
  };
}
ii.storeStateInit = zP;
Object.defineProperty(Xl, "__esModule", { value: !0 });
Xl.contractAddress = void 0;
const jP = Tr(), $P = ii, VP = hn;
function HP(t, e) {
  let r = (0, jP.beginCell)().store((0, $P.storeStateInit)(e)).endCell().hash();
  return new VP.Address(t, r);
}
Xl.contractAddress = HP;
var Ys = {};
Object.defineProperty(Ys, "__esModule", { value: !0 });
Ys.parseTuple = Ys.serializeTuple = void 0;
const Rf = Tr(), WP = BigInt("-9223372036854775808"), KP = BigInt("9223372036854775807");
function j_(t, e) {
  if (t.type === "null")
    e.storeUint(0, 8);
  else if (t.type === "int")
    t.value <= KP && t.value >= WP ? (e.storeUint(1, 8), e.storeInt(t.value, 64)) : (e.storeUint(256, 15), e.storeInt(t.value, 257));
  else if (t.type === "nan")
    e.storeInt(767, 16);
  else if (t.type === "cell")
    e.storeUint(3, 8), e.storeRef(t.cell);
  else if (t.type === "slice")
    e.storeUint(4, 8), e.storeUint(0, 10), e.storeUint(t.cell.bits.length, 10), e.storeUint(0, 3), e.storeUint(t.cell.refs.length, 3), e.storeRef(t.cell);
  else if (t.type === "builder")
    e.storeUint(5, 8), e.storeRef(t.cell);
  else if (t.type === "tuple") {
    let r = null, i = null;
    for (let f = 0; f < t.items.length; f++) {
      let a = r;
      r = i, i = a, f > 1 && (r = (0, Rf.beginCell)().storeRef(i).storeRef(r).endCell());
      let l = (0, Rf.beginCell)();
      j_(t.items[f], l), i = l.endCell();
    }
    e.storeUint(7, 8), e.storeUint(t.items.length, 16), r && e.storeRef(r), i && e.storeRef(i);
  } else
    throw Error("Invalid value");
}
function of(t) {
  let e = t.loadUint(8);
  if (e === 0)
    return { type: "null" };
  if (e === 1)
    return { type: "int", value: t.loadIntBig(64) };
  if (e === 2)
    return t.loadUint(7) === 0 ? { type: "int", value: t.loadIntBig(257) } : (t.loadBit(), { type: "nan" });
  if (e === 3)
    return { type: "cell", cell: t.loadRef() };
  if (e === 4) {
    let r = t.loadUint(10), i = t.loadUint(10), f = t.loadUint(3), a = t.loadUint(3), l = t.loadRef().beginParse();
    l.skip(r);
    let d = l.loadBits(i - r), v = (0, Rf.beginCell)().storeBits(d);
    if (f < a) {
      for (let m = 0; m < f; m++)
        l.loadRef();
      for (let m = 0; m < a - f; m++)
        v.storeRef(l.loadRef());
    }
    return { type: "slice", cell: v.endCell() };
  } else {
    if (e === 5)
      return { type: "builder", cell: t.loadRef() };
    if (e === 7) {
      let r = t.loadUint(16), i = [];
      if (r > 1) {
        let f = t.loadRef().beginParse(), a = t.loadRef().beginParse();
        i.unshift(of(a));
        for (let l = 0; l < r - 2; l++) {
          let d = f;
          f = d.loadRef().beginParse(), a = d.loadRef().beginParse(), i.unshift(of(a));
        }
        i.unshift(of(f));
      } else
        r === 1 && i.push(of(t.loadRef().beginParse()));
      return { type: "tuple", items: i };
    } else
      throw Error("Unsupported stack item");
  }
}
function $_(t, e) {
  if (t.length > 0) {
    let r = (0, Rf.beginCell)();
    $_(t.slice(0, t.length - 1), r), e.storeRef(r.endCell()), j_(t[t.length - 1], e);
  }
}
function ZP(t) {
  let e = (0, Rf.beginCell)();
  e.storeUint(t.length, 24);
  let r = [...t];
  return $_(r, e), e.endCell();
}
Ys.serializeTuple = ZP;
function GP(t) {
  let e = [], r = t.beginParse(), i = r.loadUint(24);
  for (let f = 0; f < i; f++) {
    let a = r.loadRef();
    e.unshift(of(r)), r = a.beginParse();
  }
  return e;
}
Ys.parseTuple = GP;
var kc = {};
Object.defineProperty(kc, "__esModule", { value: !0 });
kc.TupleReader = void 0;
class Os {
  constructor(e) {
    this.items = [...e];
  }
  get remaining() {
    return this.items.length;
  }
  peek() {
    if (this.items.length === 0)
      throw Error("EOF");
    return this.items[0];
  }
  pop() {
    if (this.items.length === 0)
      throw Error("EOF");
    let e = this.items[0];
    return this.items.splice(0, 1), e;
  }
  skip(e = 1) {
    for (let r = 0; r < e; r++)
      this.pop();
    return this;
  }
  readBigNumber() {
    let e = this.pop();
    if (e.type !== "int")
      throw Error("Not a number");
    return e.value;
  }
  readBigNumberOpt() {
    let e = this.pop();
    if (e.type === "null")
      return null;
    if (e.type !== "int")
      throw Error("Not a number");
    return e.value;
  }
  readNumber() {
    return Number(this.readBigNumber());
  }
  readNumberOpt() {
    let e = this.readBigNumberOpt();
    return e !== null ? Number(e) : null;
  }
  readBoolean() {
    return this.readNumber() !== 0;
  }
  readBooleanOpt() {
    let e = this.readNumberOpt();
    return e !== null ? e !== 0 : null;
  }
  readAddress() {
    let e = this.readCell().beginParse().loadAddress();
    if (e !== null)
      return e;
    throw Error("Not an address");
  }
  readAddressOpt() {
    let e = this.readCellOpt();
    return e !== null ? e.beginParse().loadMaybeAddress() : null;
  }
  readCell() {
    let e = this.pop();
    if (e.type !== "cell" && e.type !== "slice" && e.type !== "builder")
      throw Error("Not a cell: " + e.type);
    return e.cell;
  }
  readCellOpt() {
    let e = this.pop();
    if (e.type === "null")
      return null;
    if (e.type !== "cell" && e.type !== "slice" && e.type !== "builder")
      throw Error("Not a cell");
    return e.cell;
  }
  readTuple() {
    let e = this.pop();
    if (e.type !== "tuple")
      throw Error("Not a tuple");
    return new Os(e.items);
  }
  readTupleOpt() {
    let e = this.pop();
    if (e.type === "null")
      return null;
    if (e.type !== "tuple")
      throw Error("Not a tuple");
    return new Os(e.items);
  }
  static readLispList(e) {
    const r = [];
    let i = e;
    for (; i !== null; ) {
      var f = i.pop();
      if (i.items.length === 0 || i.items[0].type !== "tuple" && i.items[0].type !== "null")
        throw Error("Lisp list consists only from (any, tuple) elements and ends with null");
      i = i.readTupleOpt(), r.push(f);
    }
    return r;
  }
  readLispListDirect() {
    return this.items.length === 1 && this.items[0].type === "null" ? [] : Os.readLispList(this);
  }
  readLispList() {
    return Os.readLispList(this.readTupleOpt());
  }
  readBuffer() {
    let e = this.readCell().beginParse();
    if (e.remainingRefs !== 0 || e.remainingBits % 8 !== 0)
      throw Error("Not a buffer");
    return e.loadBuffer(e.remainingBits / 8);
  }
  readBufferOpt() {
    if (this.peek().type === "null")
      return null;
    let r = this.readCell().beginParse();
    if (r.remainingRefs !== 0 || r.remainingBits % 8 !== 0)
      throw Error("Not a buffer");
    return r.loadBuffer(r.remainingBits / 8);
  }
  readString() {
    return this.readCell().beginParse().loadStringTail();
  }
  readStringOpt() {
    return this.peek().type === "null" ? null : this.readCell().beginParse().loadStringTail();
  }
}
kc.TupleReader = Os;
var Tc = {};
Object.defineProperty(Tc, "__esModule", { value: !0 });
Tc.TupleBuilder = void 0;
const Wp = Tr(), Kp = ys(), Zp = fm();
class QP {
  constructor() {
    this._tuple = [];
  }
  writeNumber(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "int", value: BigInt(e) });
  }
  writeBoolean(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "int", value: e ? -1n : 0n });
  }
  writeBuffer(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "slice", cell: (0, Wp.beginCell)().storeBuffer(e).endCell() });
  }
  writeString(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "slice", cell: (0, Wp.beginCell)().storeStringTail(e).endCell() });
  }
  writeCell(e) {
    e == null ? this._tuple.push({ type: "null" }) : e instanceof Kp.Cell ? this._tuple.push({ type: "cell", cell: e }) : e instanceof Zp.Slice && this._tuple.push({ type: "cell", cell: e.asCell() });
  }
  writeSlice(e) {
    e == null ? this._tuple.push({ type: "null" }) : e instanceof Kp.Cell ? this._tuple.push({ type: "slice", cell: e }) : e instanceof Zp.Slice && this._tuple.push({ type: "slice", cell: e.asCell() });
  }
  writeBuilder(e) {
    e == null ? this._tuple.push({ type: "null" }) : e instanceof Kp.Cell ? this._tuple.push({ type: "builder", cell: e }) : e instanceof Zp.Slice && this._tuple.push({ type: "builder", cell: e.asCell() });
  }
  writeTuple(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "tuple", items: e });
  }
  writeAddress(e) {
    e == null ? this._tuple.push({ type: "null" }) : this._tuple.push({ type: "slice", cell: (0, Wp.beginCell)().storeAddress(e).endCell() });
  }
  build() {
    return [...this._tuple];
  }
}
Tc.TupleBuilder = QP;
var V_ = {}, na = {}, $a = {};
Object.defineProperty($a, "__esModule", { value: !0 });
$a.fromNano = $a.toNano = void 0;
function YP(t) {
  if (typeof t == "bigint")
    return t * 1000000000n;
  {
    if (typeof t == "number") {
      if (!Number.isFinite(t))
        throw Error("Invalid number");
      if (Math.log10(t) <= 6)
        t = t.toLocaleString("en", { minimumFractionDigits: 9, useGrouping: !1 });
      else if (t - Math.trunc(t) === 0)
        t = t.toLocaleString("en", { maximumFractionDigits: 0, useGrouping: !1 });
      else
        throw Error("Not enough precision for a number value. Use string value instead");
    }
    let e = !1;
    for (; t.startsWith("-"); )
      e = !e, t = t.slice(1);
    if (t === ".")
      throw Error("Invalid number");
    let r = t.split(".");
    if (r.length > 2)
      throw Error("Invalid number");
    let i = r[0], f = r[1];
    if (i || (i = "0"), f || (f = "0"), f.length > 9)
      throw Error("Invalid number");
    for (; f.length < 9; )
      f += "0";
    let a = BigInt(i) * 1000000000n + BigInt(f);
    return e && (a = -a), a;
  }
}
$a.toNano = YP;
function JP(t) {
  let e = BigInt(t), r = !1;
  e < 0 && (r = !0, e = -e);
  let f = (e % 1000000000n).toString();
  for (; f.length < 9; )
    f = "0" + f;
  f = f.match(/^([0-9]*[1-9]|0)(0*)/)[1];
  let d = `${(e / 1000000000n).toString()}${f === "0" ? "" : `.${f}`}`;
  return r && (d = "-" + d), d;
}
$a.fromNano = JP;
Object.defineProperty(na, "__esModule", { value: !0 });
na.comment = na.external = na.internal = void 0;
const Cl = hn, H_ = ys(), W_ = Tr(), XP = $a;
function eO(t) {
  let e = !0;
  t.bounce !== null && t.bounce !== void 0 && (e = t.bounce);
  let r;
  if (typeof t.to == "string")
    r = Cl.Address.parse(t.to);
  else if (Cl.Address.isAddress(t.to))
    r = t.to;
  else
    throw new Error(`Invalid address ${t.to}`);
  let i;
  typeof t.value == "string" ? i = (0, XP.toNano)(t.value) : i = t.value;
  let f = H_.Cell.EMPTY;
  return typeof t.body == "string" ? f = (0, W_.beginCell)().storeUint(0, 32).storeStringTail(t.body).endCell() : t.body && (f = t.body), {
    info: {
      type: "internal",
      dest: r,
      value: { coins: i },
      bounce: e,
      ihrDisabled: !0,
      bounced: !1,
      ihrFee: 0n,
      forwardFee: 0n,
      createdAt: 0,
      createdLt: 0n
    },
    init: t.init ?? void 0,
    body: f
  };
}
na.internal = eO;
function tO(t) {
  let e;
  if (typeof t.to == "string")
    e = Cl.Address.parse(t.to);
  else if (Cl.Address.isAddress(t.to))
    e = t.to;
  else
    throw new Error(`Invalid address ${t.to}`);
  return {
    info: {
      type: "external-in",
      dest: e,
      importFee: 0n
    },
    init: t.init ?? void 0,
    body: t.body || H_.Cell.EMPTY
  };
}
na.external = tO;
function rO(t) {
  return (0, W_.beginCell)().storeUint(0, 32).storeStringTail(t).endCell();
}
na.comment = rO;
var Va = {}, Ha = {}, Wa = {};
Object.defineProperty(Wa, "__esModule", { value: !0 });
Wa.storeAccountState = Wa.loadAccountState = void 0;
const K_ = ii;
function nO(t) {
  return t.loadBit() ? { type: "active", state: (0, K_.loadStateInit)(t) } : t.loadBit() ? { type: "frozen", stateHash: t.loadUintBig(256) } : { type: "uninit" };
}
Wa.loadAccountState = nO;
function iO(t) {
  return (e) => {
    t.type === "active" ? (e.storeBit(!0), e.store((0, K_.storeStateInit)(t.state))) : t.type === "frozen" ? (e.storeBit(!1), e.storeBit(!0), e.storeUint(t.stateHash, 256)) : t.type === "uninit" && (e.storeBit(!1), e.storeBit(!1));
  };
}
Wa.storeAccountState = iO;
var pn = {};
Object.defineProperty(pn, "__esModule", { value: !0 });
pn.storeCurrencyCollection = pn.loadCurrencyCollection = void 0;
const vw = ms();
function aO(t) {
  const e = t.loadCoins(), r = t.loadDict(vw.Dictionary.Keys.Uint(32), vw.Dictionary.Values.BigVarUint(
    5
    /* log2(32) */
  ));
  return r.size === 0 ? { coins: e } : { other: r, coins: e };
}
pn.loadCurrencyCollection = aO;
function sO(t) {
  return (e) => {
    e.storeCoins(t.coins), t.other ? e.storeDict(t.other) : e.storeBit(0);
  };
}
pn.storeCurrencyCollection = sO;
Object.defineProperty(Ha, "__esModule", { value: !0 });
Ha.storeAccountStorage = Ha.loadAccountStorage = void 0;
const Z_ = Wa, G_ = pn;
function oO(t) {
  return {
    lastTransLt: t.loadUintBig(64),
    balance: (0, G_.loadCurrencyCollection)(t),
    state: (0, Z_.loadAccountState)(t)
  };
}
Ha.loadAccountStorage = oO;
function fO(t) {
  return (e) => {
    e.storeUint(t.lastTransLt, 64), e.store((0, G_.storeCurrencyCollection)(t.balance)), e.store((0, Z_.storeAccountState)(t.state));
  };
}
Ha.storeAccountStorage = fO;
var Ka = {}, Za = {};
Object.defineProperty(Za, "__esModule", { value: !0 });
Za.storeStorageUsed = Za.loadStorageUsed = void 0;
function uO(t) {
  return {
    cells: t.loadVarUintBig(3),
    bits: t.loadVarUintBig(3),
    publicCells: t.loadVarUintBig(3)
  };
}
Za.loadStorageUsed = uO;
function lO(t) {
  return (e) => {
    e.storeVarUint(t.cells, 3), e.storeVarUint(t.bits, 3), e.storeVarUint(t.publicCells, 3);
  };
}
Za.storeStorageUsed = lO;
Object.defineProperty(Ka, "__esModule", { value: !0 });
Ka.storeStorageInfo = Ka.loadStorageInfo = void 0;
const Q_ = Za;
function cO(t) {
  return {
    used: (0, Q_.loadStorageUsed)(t),
    lastPaid: t.loadUint(32),
    duePayment: t.loadMaybeCoins()
  };
}
Ka.loadStorageInfo = cO;
function dO(t) {
  return (e) => {
    e.store((0, Q_.storeStorageUsed)(t.used)), e.storeUint(t.lastPaid, 32), e.storeMaybeCoins(t.duePayment);
  };
}
Ka.storeStorageInfo = dO;
Object.defineProperty(Va, "__esModule", { value: !0 });
Va.storeAccount = Va.loadAccount = void 0;
const Y_ = Ha, J_ = Ka;
function hO(t) {
  return {
    addr: t.loadAddress(),
    storageStats: (0, J_.loadStorageInfo)(t),
    storage: (0, Y_.loadAccountStorage)(t)
  };
}
Va.loadAccount = hO;
function pO(t) {
  return (e) => {
    e.storeAddress(t.addr), e.store((0, J_.storeStorageInfo)(t.storageStats)), e.store((0, Y_.storeAccountStorage)(t.storage));
  };
}
Va.storeAccount = pO;
var Ga = {};
Object.defineProperty(Ga, "__esModule", { value: !0 });
Ga.storeAccountStatus = Ga.loadAccountStatus = void 0;
function vO(t) {
  const e = t.loadUint(2);
  if (e === 0)
    return "uninitialized";
  if (e === 1)
    return "frozen";
  if (e === 2)
    return "active";
  if (e === 3)
    return "non-existing";
  throw Error("Invalid data");
}
Ga.loadAccountStatus = vO;
function mO(t) {
  return (e) => {
    if (t === "uninitialized")
      e.storeUint(0, 2);
    else if (t === "frozen")
      e.storeUint(1, 2);
    else if (t === "active")
      e.storeUint(2, 2);
    else if (t === "non-existing")
      e.storeUint(3, 2);
    else
      throw Error("Invalid data");
    return e;
  };
}
Ga.storeAccountStatus = mO;
var la = {};
Object.defineProperty(la, "__esModule", { value: !0 });
la.storeAccountStatusChange = la.loadAccountStatusChange = void 0;
function gO(t) {
  return t.loadBit() ? t.loadBit() ? "deleted" : "frozen" : "unchanged";
}
la.loadAccountStatusChange = gO;
function yO(t) {
  return (e) => {
    if (t == "unchanged")
      e.storeBit(0);
    else if (t === "frozen")
      e.storeBit(1), e.storeBit(0);
    else if (t === "deleted")
      e.storeBit(1), e.storeBit(1);
    else
      throw Error("Invalid account status change");
  };
}
la.storeAccountStatusChange = yO;
var Gn = {}, Qa = {}, Ya = {};
Object.defineProperty(Ya, "__esModule", { value: !0 });
Ya.storeCommonMessageInfoRelaxed = Ya.loadCommonMessageInfoRelaxed = void 0;
const X_ = pn;
function bO(t) {
  if (!t.loadBit()) {
    const a = t.loadBit(), l = t.loadBit(), d = t.loadBit(), v = t.loadMaybeAddress(), m = t.loadAddress(), h = (0, X_.loadCurrencyCollection)(t), w = t.loadCoins(), M = t.loadCoins(), S = t.loadUintBig(64), E = t.loadUint(32);
    return {
      type: "internal",
      ihrDisabled: a,
      bounce: l,
      bounced: d,
      src: v,
      dest: m,
      value: h,
      ihrFee: w,
      forwardFee: M,
      createdLt: S,
      createdAt: E
    };
  }
  if (!t.loadBit())
    throw Error("External In message is not possible for CommonMessageInfoRelaxed");
  const e = t.loadMaybeAddress(), r = t.loadMaybeExternalAddress(), i = t.loadUintBig(64), f = t.loadUint(32);
  return {
    type: "external-out",
    src: e,
    dest: r,
    createdLt: i,
    createdAt: f
  };
}
Ya.loadCommonMessageInfoRelaxed = bO;
function wO(t) {
  return (e) => {
    if (t.type === "internal")
      e.storeBit(0), e.storeBit(t.ihrDisabled), e.storeBit(t.bounce), e.storeBit(t.bounced), e.storeAddress(t.src), e.storeAddress(t.dest), e.store((0, X_.storeCurrencyCollection)(t.value)), e.storeCoins(t.ihrFee), e.storeCoins(t.forwardFee), e.storeUint(t.createdLt, 64), e.storeUint(t.createdAt, 32);
    else if (t.type === "external-out")
      e.storeBit(1), e.storeBit(1), e.storeAddress(t.src), e.storeAddress(t.dest), e.storeUint(t.createdLt, 64), e.storeUint(t.createdAt, 32);
    else
      throw new Error("Unknown CommonMessageInfo type");
  };
}
Ya.storeCommonMessageInfoRelaxed = wO;
Object.defineProperty(Qa, "__esModule", { value: !0 });
Qa.storeMessageRelaxed = Qa.loadMessageRelaxed = void 0;
const _O = Tr(), e9 = Ya, G1 = ii;
function xO(t) {
  const e = (0, e9.loadCommonMessageInfoRelaxed)(t);
  let r = null;
  t.loadBit() && (t.loadBit() ? r = (0, G1.loadStateInit)(t.loadRef().beginParse()) : r = (0, G1.loadStateInit)(t));
  const i = t.loadBit() ? t.loadRef() : t.asCell();
  return {
    info: e,
    init: r,
    body: i
  };
}
Qa.loadMessageRelaxed = xO;
function MO(t, e) {
  return (r) => {
    if (r.store((0, e9.storeCommonMessageInfoRelaxed)(t.info)), t.init) {
      r.storeBit(!0);
      let f = (0, _O.beginCell)().store((0, G1.storeStateInit)(t.init)), a = !1;
      e && e.forceRef ? a = !0 : r.availableBits - 2 >= f.bits ? a = !1 : a = !0, a ? (r.storeBit(!0), r.storeRef(f)) : (r.storeBit(!1), r.storeBuilder(f));
    } else
      r.storeBit(!1);
    let i = !1;
    e && e.forceRef ? i = !0 : r.availableBits - 1 >= t.body.bits.length && r.refs + t.body.refs.length <= 4 && !t.body.isExotic ? i = !1 : i = !0, i ? (r.storeBit(!0), r.storeRef(t.body)) : (r.storeBit(!1), r.storeBuilder(t.body.asBuilder()));
  };
}
Qa.storeMessageRelaxed = MO;
Object.defineProperty(Gn, "__esModule", { value: !0 });
Gn.loadOutList = Gn.storeOutList = Gn.loadOutAction = Gn.storeOutAction = void 0;
const t9 = Qa, Q1 = Tr();
function r9(t) {
  switch (t.type) {
    case "sendMsg":
      return SO(t);
    case "setCode":
      return EO(t);
    default:
      throw new Error(`Unknown action type ${t.type}`);
  }
}
Gn.storeOutAction = r9;
const n9 = 247711853;
function SO(t) {
  return (e) => {
    e.storeUint(n9, 32).storeUint(t.mode, 8).storeRef((0, Q1.beginCell)().store((0, t9.storeMessageRelaxed)(t.outMsg)).endCell());
  };
}
const i9 = 2907562126;
function EO(t) {
  return (e) => {
    e.storeUint(i9, 32).storeRef(t.newCode);
  };
}
function a9(t) {
  const e = t.loadUint(32);
  if (e === n9) {
    const r = t.loadUint(8), i = (0, t9.loadMessageRelaxed)(t.loadRef().beginParse());
    return {
      type: "sendMsg",
      mode: r,
      outMsg: i
    };
  }
  if (e === i9)
    return {
      type: "setCode",
      newCode: t.loadRef()
    };
  throw new Error(`Unknown out action tag 0x${e.toString(16)}`);
}
Gn.loadOutAction = a9;
function AO(t) {
  const e = t.reduce((r, i) => (0, Q1.beginCell)().storeRef(r).store(r9(i)).endCell(), (0, Q1.beginCell)().endCell());
  return (r) => {
    r.storeSlice(e.beginParse());
  };
}
Gn.storeOutList = AO;
function kO(t) {
  const e = [];
  for (; t.remainingRefs; ) {
    const r = t.loadRef();
    e.push(a9(t)), t = r.beginParse();
  }
  return e.reverse();
}
Gn.loadOutList = kO;
var Ja = {};
Object.defineProperty(Ja, "__esModule", { value: !0 });
Ja.storeCommonMessageInfo = Ja.loadCommonMessageInfo = void 0;
const s9 = pn;
function TO(t) {
  if (!t.loadBit()) {
    const a = t.loadBit(), l = t.loadBit(), d = t.loadBit(), v = t.loadAddress(), m = t.loadAddress(), h = (0, s9.loadCurrencyCollection)(t), w = t.loadCoins(), M = t.loadCoins(), S = t.loadUintBig(64), E = t.loadUint(32);
    return {
      type: "internal",
      ihrDisabled: a,
      bounce: l,
      bounced: d,
      src: v,
      dest: m,
      value: h,
      ihrFee: w,
      forwardFee: M,
      createdLt: S,
      createdAt: E
    };
  }
  if (!t.loadBit()) {
    const a = t.loadMaybeExternalAddress(), l = t.loadAddress(), d = t.loadCoins();
    return {
      type: "external-in",
      src: a,
      dest: l,
      importFee: d
    };
  }
  const e = t.loadAddress(), r = t.loadMaybeExternalAddress(), i = t.loadUintBig(64), f = t.loadUint(32);
  return {
    type: "external-out",
    src: e,
    dest: r,
    createdLt: i,
    createdAt: f
  };
}
Ja.loadCommonMessageInfo = TO;
function CO(t) {
  return (e) => {
    if (t.type === "internal")
      e.storeBit(0), e.storeBit(t.ihrDisabled), e.storeBit(t.bounce), e.storeBit(t.bounced), e.storeAddress(t.src), e.storeAddress(t.dest), e.store((0, s9.storeCurrencyCollection)(t.value)), e.storeCoins(t.ihrFee), e.storeCoins(t.forwardFee), e.storeUint(t.createdLt, 64), e.storeUint(t.createdAt, 32);
    else if (t.type === "external-in")
      e.storeBit(1), e.storeBit(0), e.storeAddress(t.src), e.storeAddress(t.dest), e.storeCoins(t.importFee);
    else if (t.type === "external-out")
      e.storeBit(1), e.storeBit(1), e.storeAddress(t.src), e.storeAddress(t.dest), e.storeUint(t.createdLt, 64), e.storeUint(t.createdAt, 32);
    else
      throw new Error("Unknown CommonMessageInfo type");
  };
}
Ja.storeCommonMessageInfo = CO;
var Xa = {};
Object.defineProperty(Xa, "__esModule", { value: !0 });
Xa.storeComputeSkipReason = Xa.loadComputeSkipReason = void 0;
function BO(t) {
  let e = t.loadUint(2);
  if (e === 0)
    return "no-state";
  if (e === 1)
    return "bad-state";
  if (e === 2)
    return "no-gas";
  throw new Error(`Unknown ComputeSkipReason: ${e}`);
}
Xa.loadComputeSkipReason = BO;
function IO(t) {
  return (e) => {
    if (t === "no-state")
      e.storeUint(0, 2);
    else if (t === "bad-state")
      e.storeUint(1, 2);
    else if (t === "no-gas")
      e.storeUint(2, 2);
    else
      throw new Error(`Unknown ComputeSkipReason: ${t}`);
  };
}
Xa.storeComputeSkipReason = IO;
var es = {};
Object.defineProperty(es, "__esModule", { value: !0 });
es.storeDepthBalanceInfo = es.loadDepthBalanceInfo = void 0;
const o9 = pn;
function RO(t) {
  return {
    splitDepth: t.loadUint(5),
    balance: (0, o9.loadCurrencyCollection)(t)
  };
}
es.loadDepthBalanceInfo = RO;
function PO(t) {
  return (e) => {
    e.storeUint(t.splitDepth, 5), e.store((0, o9.storeCurrencyCollection)(t.balance));
  };
}
es.storeDepthBalanceInfo = PO;
var ts = {};
Object.defineProperty(ts, "__esModule", { value: !0 });
ts.storeHashUpdate = ts.loadHashUpdate = void 0;
function OO(t) {
  if (t.loadUint(8) !== 114)
    throw Error("Invalid data");
  const e = t.loadBuffer(32), r = t.loadBuffer(32);
  return { oldHash: e, newHash: r };
}
ts.loadHashUpdate = OO;
function NO(t) {
  return (e) => {
    e.storeUint(114, 8), e.storeBuffer(t.oldHash), e.storeBuffer(t.newHash);
  };
}
ts.storeHashUpdate = NO;
var tu = {};
Object.defineProperty(tu, "__esModule", { value: !0 });
tu.loadMasterchainStateExtra = void 0;
const Gp = ms(), DO = pn;
function UO(t) {
  if (t.loadUint(16) !== 52262)
    throw Error("Invalid data");
  t.loadBit() && t.loadRef();
  let e = t.loadUintBig(256), r = Gp.Dictionary.load(Gp.Dictionary.Keys.Int(32), Gp.Dictionary.Values.Cell(), t);
  const i = (0, DO.loadCurrencyCollection)(t);
  return {
    config: r,
    configAddress: e,
    globalBalance: i
  };
}
tu.loadMasterchainStateExtra = UO;
var Si = {};
Object.defineProperty(Si, "__esModule", { value: !0 });
Si.MessageValue = Si.storeMessage = Si.loadMessage = void 0;
const f9 = Tr(), u9 = Ja, Y1 = ii;
function l9(t) {
  const e = (0, u9.loadCommonMessageInfo)(t);
  let r = null;
  t.loadBit() && (t.loadBit() ? r = (0, Y1.loadStateInit)(t.loadRef().beginParse()) : r = (0, Y1.loadStateInit)(t));
  const i = t.loadBit() ? t.loadRef() : t.asCell();
  return {
    info: e,
    init: r,
    body: i
  };
}
Si.loadMessage = l9;
function c9(t, e) {
  return (r) => {
    if (r.store((0, u9.storeCommonMessageInfo)(t.info)), t.init) {
      r.storeBit(!0);
      let f = (0, f9.beginCell)().store((0, Y1.storeStateInit)(t.init)), a = !1;
      e && e.forceRef ? a = !0 : a = r.availableBits - 2 < f.bits + t.body.bits.length, a ? (r.storeBit(!0), r.storeRef(f)) : (r.storeBit(!1), r.storeBuilder(f));
    } else
      r.storeBit(!1);
    let i = !1;
    e && e.forceRef ? i = !0 : i = r.availableBits - 1 < t.body.bits.length || r.refs + t.body.refs.length > 4, i ? (r.storeBit(!0), r.storeRef(t.body)) : (r.storeBit(!1), r.storeBuilder(t.body.asBuilder()));
  };
}
Si.storeMessage = c9;
Si.MessageValue = {
  serialize(t, e) {
    e.storeRef((0, f9.beginCell)().store(c9(t)));
  },
  parse(t) {
    return l9(t.loadRef().beginParse());
  }
};
var Cc = {};
Object.defineProperty(Cc, "__esModule", { value: !0 });
Cc.SendMode = void 0;
var mw;
(function(t) {
  t[t.CARRY_ALL_REMAINING_BALANCE = 128] = "CARRY_ALL_REMAINING_BALANCE", t[t.CARRY_ALL_REMAINING_INCOMING_VALUE = 64] = "CARRY_ALL_REMAINING_INCOMING_VALUE", t[t.DESTROY_ACCOUNT_IF_ZERO = 32] = "DESTROY_ACCOUNT_IF_ZERO", t[t.PAY_GAS_SEPARATELY = 1] = "PAY_GAS_SEPARATELY", t[t.IGNORE_ERRORS = 2] = "IGNORE_ERRORS", t[t.NONE = 0] = "NONE";
})(mw || (Cc.SendMode = mw = {}));
var rs = {};
Object.defineProperty(rs, "__esModule", { value: !0 });
rs.storeShardAccount = rs.loadShardAccount = void 0;
const gw = Tr(), d9 = Va;
function LO(t) {
  let e = t.loadRef(), r;
  if (!e.isExotic) {
    let i = e.beginParse();
    i.loadBit() && (r = (0, d9.loadAccount)(i));
  }
  return {
    account: r,
    lastTransactionHash: t.loadUintBig(256),
    lastTransactionLt: t.loadUintBig(64)
  };
}
rs.loadShardAccount = LO;
function FO(t) {
  return (e) => {
    t.account ? e.storeRef((0, gw.beginCell)().storeBit(!0).store((0, d9.storeAccount)(t.account))) : e.storeRef((0, gw.beginCell)().storeBit(!1)), e.storeUint(t.lastTransactionHash, 256), e.storeUint(t.lastTransactionLt, 64);
  };
}
rs.storeShardAccount = FO;
var Dm = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.storeShardAccounts = t.loadShardAccounts = t.ShardAccountRefValue = void 0;
  const e = ms(), r = es, i = rs;
  t.ShardAccountRefValue = {
    parse: (l) => {
      let d = (0, r.loadDepthBalanceInfo)(l), v = (0, i.loadShardAccount)(l);
      return {
        depthBalanceInfo: d,
        shardAccount: v
      };
    },
    serialize(l, d) {
      d.store((0, r.storeDepthBalanceInfo)(l.depthBalanceInfo)), d.store((0, i.storeShardAccount)(l.shardAccount));
    }
  };
  function f(l) {
    return e.Dictionary.load(e.Dictionary.Keys.BigUint(256), t.ShardAccountRefValue, l);
  }
  t.loadShardAccounts = f;
  function a(l) {
    return (d) => {
      d.storeDict(l);
    };
  }
  t.storeShardAccounts = a;
})(Dm);
var ns = {};
Object.defineProperty(ns, "__esModule", { value: !0 });
ns.storeShardIdent = ns.loadShardIdent = void 0;
function qO(t) {
  if (t.loadUint(2) !== 0)
    throw Error("Invalid data");
  return {
    shardPrefixBits: t.loadUint(6),
    workchainId: t.loadInt(32),
    shardPrefix: t.loadUintBig(64)
  };
}
ns.loadShardIdent = qO;
function zO(t) {
  return (e) => {
    e.storeUint(0, 2), e.storeUint(t.shardPrefixBits, 6), e.storeInt(t.workchainId, 32), e.storeUint(t.shardPrefix, 64);
  };
}
ns.storeShardIdent = zO;
var Bc = {};
Object.defineProperty(Bc, "__esModule", { value: !0 });
Bc.loadShardStateUnsplit = void 0;
const jO = tu, $O = Dm, VO = ns;
function HO(t) {
  if (t.loadUint(32) !== 2418257890)
    throw Error("Invalid data");
  let e = t.loadInt(32), r = (0, VO.loadShardIdent)(t), i = t.loadUint(32), f = t.loadUint(32), a = t.loadUint(32), l = t.loadUintBig(64), d = t.loadUint(32);
  t.loadRef();
  let v = t.loadBit(), m = t.loadRef(), h;
  m.isExotic || (h = (0, $O.loadShardAccounts)(m.beginParse())), t.loadRef();
  let w = t.loadBit(), M = null;
  if (w) {
    let S = t.loadRef();
    S.isExotic || (M = (0, jO.loadMasterchainStateExtra)(S.beginParse()));
  }
  return {
    globalId: e,
    shardId: r,
    seqno: i,
    vertSeqNo: f,
    genUtime: a,
    genLt: l,
    minRefMcSeqno: d,
    beforeSplit: v,
    accounts: h,
    extras: M
  };
}
Bc.loadShardStateUnsplit = HO;
var is = {};
Object.defineProperty(is, "__esModule", { value: !0 });
is.storeSplitMergeInfo = is.loadSplitMergeInfo = void 0;
function WO(t) {
  let e = t.loadUint(6), r = t.loadUint(6), i = t.loadUintBig(256), f = t.loadUintBig(256);
  return {
    currentShardPrefixLength: e,
    accountSplitDepth: r,
    thisAddress: i,
    siblingAddress: f
  };
}
is.loadSplitMergeInfo = WO;
function KO(t) {
  return (e) => {
    e.storeUint(t.currentShardPrefixLength, 6), e.storeUint(t.accountSplitDepth, 6), e.storeUint(t.thisAddress, 256), e.storeUint(t.siblingAddress, 256);
  };
}
is.storeSplitMergeInfo = KO;
var ca = {};
Object.defineProperty(ca, "__esModule", { value: !0 });
ca.storeStorageUsedShort = ca.loadStorageUsedShort = void 0;
function ZO(t) {
  let e = t.loadVarUintBig(3), r = t.loadVarUintBig(3);
  return {
    cells: e,
    bits: r
  };
}
ca.loadStorageUsedShort = ZO;
function GO(t) {
  return (e) => {
    e.storeVarUint(t.cells, 3), e.storeVarUint(t.bits, 3);
  };
}
ca.storeStorageUsedShort = GO;
var xa = {}, Ma = {}, as = {};
Object.defineProperty(as, "__esModule", { value: !0 });
as.storeTransactionActionPhase = as.loadTransactionActionPhase = void 0;
const h9 = la, p9 = ca;
function QO(t) {
  let e = t.loadBit(), r = t.loadBit(), i = t.loadBit(), f = (0, h9.loadAccountStatusChange)(t), a = t.loadBit() ? t.loadCoins() : void 0, l = t.loadBit() ? t.loadCoins() : void 0, d = t.loadInt(32), v = t.loadBit() ? t.loadInt(32) : void 0, m = t.loadUint(16), h = t.loadUint(16), w = t.loadUint(16), M = t.loadUint(16), S = t.loadUintBig(256), E = (0, p9.loadStorageUsedShort)(t);
  return {
    success: e,
    valid: r,
    noFunds: i,
    statusChange: f,
    totalFwdFees: a,
    totalActionFees: l,
    resultCode: d,
    resultArg: v,
    totalActions: m,
    specActions: h,
    skippedActions: w,
    messagesCreated: M,
    actionListHash: S,
    totalMessageSize: E
  };
}
as.loadTransactionActionPhase = QO;
function YO(t) {
  return (e) => {
    e.storeBit(t.success), e.storeBit(t.valid), e.storeBit(t.noFunds), e.store((0, h9.storeAccountStatusChange)(t.statusChange)), e.storeMaybeCoins(t.totalFwdFees), e.storeMaybeCoins(t.totalActionFees), e.storeInt(t.resultCode, 32), e.storeMaybeInt(t.resultArg, 32), e.storeUint(t.totalActions, 16), e.storeUint(t.specActions, 16), e.storeUint(t.skippedActions, 16), e.storeUint(t.messagesCreated, 16), e.storeUint(t.actionListHash, 256), e.store((0, p9.storeStorageUsedShort)(t.totalMessageSize));
  };
}
as.storeTransactionActionPhase = YO;
var ss = {};
Object.defineProperty(ss, "__esModule", { value: !0 });
ss.storeTransactionBouncePhase = ss.loadTransactionBouncePhase = void 0;
const Bl = ca;
function JO(t) {
  if (t.loadBit()) {
    let e = (0, Bl.loadStorageUsedShort)(t), r = t.loadCoins(), i = t.loadCoins();
    return {
      type: "ok",
      messageSize: e,
      messageFees: r,
      forwardFees: i
    };
  }
  if (t.loadBit()) {
    let e = (0, Bl.loadStorageUsedShort)(t), r = t.loadCoins();
    return {
      type: "no-funds",
      messageSize: e,
      requiredForwardFees: r
    };
  }
  return {
    type: "negative-funds"
  };
}
ss.loadTransactionBouncePhase = JO;
function XO(t) {
  return (e) => {
    if (t.type === "ok")
      e.storeBit(!0), e.store((0, Bl.storeStorageUsedShort)(t.messageSize)), e.storeCoins(t.messageFees), e.storeCoins(t.forwardFees);
    else if (t.type === "negative-funds")
      e.storeBit(!1), e.storeBit(!1);
    else if (t.type === "no-funds")
      e.storeBit(!1), e.storeBit(!0), e.store((0, Bl.storeStorageUsedShort)(t.messageSize)), e.storeCoins(t.requiredForwardFees);
    else
      throw new Error("Invalid TransactionBouncePhase type");
  };
}
ss.storeTransactionBouncePhase = XO;
var os = {};
Object.defineProperty(os, "__esModule", { value: !0 });
os.storeTransactionComputePhase = os.loadTransactionComputePhase = void 0;
const eN = Tr(), v9 = Xa;
function tN(t) {
  if (!t.loadBit())
    return {
      type: "skipped",
      reason: (0, v9.loadComputeSkipReason)(t)
    };
  let e = t.loadBit(), r = t.loadBit(), i = t.loadBit(), f = t.loadCoins();
  const a = t.loadRef().beginParse();
  let l = a.loadVarUintBig(3), d = a.loadVarUintBig(3), v = a.loadBit() ? a.loadVarUintBig(2) : void 0, m = a.loadUint(8), h = a.loadInt(32), w = a.loadBit() ? a.loadInt(32) : void 0, M = a.loadUint(32), S = a.loadUintBig(256), E = a.loadUintBig(256);
  return {
    type: "vm",
    success: e,
    messageStateUsed: r,
    accountActivated: i,
    gasFees: f,
    gasUsed: l,
    gasLimit: d,
    gasCredit: v,
    mode: m,
    exitCode: h,
    exitArg: w,
    vmSteps: M,
    vmInitStateHash: S,
    vmFinalStateHash: E
  };
}
os.loadTransactionComputePhase = tN;
function rN(t) {
  return (e) => {
    if (t.type === "skipped") {
      e.storeBit(0), e.store((0, v9.storeComputeSkipReason)(t.reason));
      return;
    }
    e.storeBit(1), e.storeBit(t.success), e.storeBit(t.messageStateUsed), e.storeBit(t.accountActivated), e.storeCoins(t.gasFees), e.storeRef((0, eN.beginCell)().storeVarUint(t.gasUsed, 3).storeVarUint(t.gasLimit, 3).store((r) => t.gasCredit !== void 0 && t.gasCredit !== null ? r.storeBit(1).storeVarUint(t.gasCredit, 2) : r.storeBit(0)).storeUint(t.mode, 8).storeInt(t.exitCode, 32).store((r) => t.exitArg !== void 0 && t.exitArg !== null ? r.storeBit(1).storeInt(t.exitArg, 32) : r.storeBit(0)).storeUint(t.vmSteps, 32).storeUint(t.vmInitStateHash, 256).storeUint(t.vmFinalStateHash, 256).endCell());
  };
}
os.storeTransactionComputePhase = rN;
var fs = {};
Object.defineProperty(fs, "__esModule", { value: !0 });
fs.storeTransactionCreditPhase = fs.loadTransactionCreditPhase = void 0;
const m9 = pn;
function nN(t) {
  const e = t.loadBit() ? t.loadCoins() : void 0, r = (0, m9.loadCurrencyCollection)(t);
  return {
    dueFeesColelcted: e,
    credit: r
  };
}
fs.loadTransactionCreditPhase = nN;
function iN(t) {
  return (e) => {
    t.dueFeesColelcted === null || t.dueFeesColelcted === void 0 ? e.storeBit(!1) : (e.storeBit(!0), e.storeCoins(t.dueFeesColelcted)), e.store((0, m9.storeCurrencyCollection)(t.credit));
  };
}
fs.storeTransactionCreditPhase = iN;
var us = {};
Object.defineProperty(us, "__esModule", { value: !0 });
us.storeTransactionsStoragePhase = us.loadTransactionStoragePhase = void 0;
const g9 = la;
function aN(t) {
  const e = t.loadCoins();
  let r;
  t.loadBit() && (r = t.loadCoins());
  const i = (0, g9.loadAccountStatusChange)(t);
  return {
    storageFeesCollected: e,
    storageFeesDue: r,
    statusChange: i
  };
}
us.loadTransactionStoragePhase = aN;
function sN(t) {
  return (e) => {
    e.storeCoins(t.storageFeesCollected), t.storageFeesDue === null || t.storageFeesDue === void 0 ? e.storeBit(!1) : (e.storeBit(!0), e.storeCoins(t.storageFeesDue)), e.store((0, g9.storeAccountStatusChange)(t.statusChange));
  };
}
us.storeTransactionsStoragePhase = sN;
var yw;
function y9() {
  if (yw)
    return Ma;
  yw = 1, Object.defineProperty(Ma, "__esModule", { value: !0 }), Ma.storeTransactionDescription = Ma.loadTransactionDescription = void 0;
  const t = Tr(), e = is, r = b9(), i = as, f = ss, a = os, l = fs, d = us;
  function v(h) {
    let w = h.loadUint(4);
    if (w === 0) {
      const M = h.loadBit();
      let S;
      h.loadBit() && (S = (0, d.loadTransactionStoragePhase)(h));
      let E;
      h.loadBit() && (E = (0, l.loadTransactionCreditPhase)(h));
      let A = (0, a.loadTransactionComputePhase)(h), B;
      h.loadBit() && (B = (0, i.loadTransactionActionPhase)(h.loadRef().beginParse()));
      let k = h.loadBit(), C;
      h.loadBit() && (C = (0, f.loadTransactionBouncePhase)(h));
      const I = h.loadBit();
      return {
        type: "generic",
        creditFirst: M,
        storagePhase: S,
        creditPhase: E,
        computePhase: A,
        actionPhase: B,
        bouncePhase: C,
        aborted: k,
        destroyed: I
      };
    }
    if (w === 1)
      return {
        type: "storage",
        storagePhase: (0, d.loadTransactionStoragePhase)(h)
      };
    if (w === 2 || w === 3) {
      const M = w === 3;
      let S = (0, d.loadTransactionStoragePhase)(h), E = (0, a.loadTransactionComputePhase)(h), A;
      h.loadBit() && (A = (0, i.loadTransactionActionPhase)(h.loadRef().beginParse()));
      const B = h.loadBit(), k = h.loadBit();
      return {
        type: "tick-tock",
        isTock: M,
        storagePhase: S,
        computePhase: E,
        actionPhase: A,
        aborted: B,
        destroyed: k
      };
    }
    if (w === 4) {
      let M = (0, e.loadSplitMergeInfo)(h), S;
      h.loadBit() && (S = (0, d.loadTransactionStoragePhase)(h));
      let E = (0, a.loadTransactionComputePhase)(h), A;
      h.loadBit() && (A = (0, i.loadTransactionActionPhase)(h.loadRef().beginParse()));
      const B = h.loadBit(), k = h.loadBit();
      return {
        type: "split-prepare",
        splitInfo: M,
        storagePhase: S,
        computePhase: E,
        actionPhase: A,
        aborted: B,
        destroyed: k
      };
    }
    if (w === 5) {
      let M = (0, e.loadSplitMergeInfo)(h), S = (0, r.loadTransaction)(h.loadRef().beginParse());
      const E = h.loadBit();
      return {
        type: "split-install",
        splitInfo: M,
        prepareTransaction: S,
        installed: E
      };
    }
    throw Error(`Unsupported transaction description type ${w}`);
  }
  Ma.loadTransactionDescription = v;
  function m(h) {
    return (w) => {
      if (h.type === "generic")
        w.storeUint(0, 4), w.storeBit(h.creditFirst), h.storagePhase ? (w.storeBit(!0), w.store((0, d.storeTransactionsStoragePhase)(h.storagePhase))) : w.storeBit(!1), h.creditPhase ? (w.storeBit(!0), w.store((0, l.storeTransactionCreditPhase)(h.creditPhase))) : w.storeBit(!1), w.store((0, a.storeTransactionComputePhase)(h.computePhase)), h.actionPhase ? (w.storeBit(!0), w.storeRef((0, t.beginCell)().store((0, i.storeTransactionActionPhase)(h.actionPhase)))) : w.storeBit(!1), w.storeBit(h.aborted), h.bouncePhase ? (w.storeBit(!0), w.store((0, f.storeTransactionBouncePhase)(h.bouncePhase))) : w.storeBit(!1), w.storeBit(h.destroyed);
      else if (h.type === "storage")
        w.storeUint(1, 4), w.store((0, d.storeTransactionsStoragePhase)(h.storagePhase));
      else if (h.type === "tick-tock")
        w.storeUint(h.isTock ? 3 : 2, 4), w.store((0, d.storeTransactionsStoragePhase)(h.storagePhase)), w.store((0, a.storeTransactionComputePhase)(h.computePhase)), h.actionPhase ? (w.storeBit(!0), w.storeRef((0, t.beginCell)().store((0, i.storeTransactionActionPhase)(h.actionPhase)))) : w.storeBit(!1), w.storeBit(h.aborted), w.storeBit(h.destroyed);
      else if (h.type === "split-prepare")
        w.storeUint(4, 4), w.store((0, e.storeSplitMergeInfo)(h.splitInfo)), h.storagePhase ? (w.storeBit(!0), w.store((0, d.storeTransactionsStoragePhase)(h.storagePhase))) : w.storeBit(!1), w.store((0, a.storeTransactionComputePhase)(h.computePhase)), h.actionPhase ? (w.storeBit(!0), w.store((0, i.storeTransactionActionPhase)(h.actionPhase))) : w.storeBit(!1), w.storeBit(h.aborted), w.storeBit(h.destroyed);
      else if (h.type === "split-install")
        w.storeUint(5, 4), w.store((0, e.storeSplitMergeInfo)(h.splitInfo)), w.storeRef((0, t.beginCell)().store((0, r.storeTransaction)(h.prepareTransaction))), w.storeBit(h.installed);
      else
        throw Error(`Unsupported transaction description type ${h.type}`);
    };
  }
  return Ma.storeTransactionDescription = m, Ma;
}
var bw;
function b9() {
  if (bw)
    return xa;
  bw = 1, Object.defineProperty(xa, "__esModule", { value: !0 }), xa.storeTransaction = xa.loadTransaction = void 0;
  const t = Tr(), e = ms(), r = Ga, i = pn, f = ts, a = Si, l = y9();
  function d(m) {
    let h = m.asCell();
    if (m.loadUint(4) !== 7)
      throw Error("Invalid data");
    let w = m.loadUintBig(256), M = m.loadUintBig(64), S = m.loadUintBig(256), E = m.loadUintBig(64), A = m.loadUint(32), B = m.loadUint(15), k = (0, r.loadAccountStatus)(m), C = (0, r.loadAccountStatus)(m), O = m.loadRef().beginParse(), q = O.loadBit() ? (0, a.loadMessage)(O.loadRef().beginParse()) : void 0, $ = O.loadDict(e.Dictionary.Keys.Uint(15), a.MessageValue);
    O.endParse();
    let ae = (0, i.loadCurrencyCollection)(m), he = (0, f.loadHashUpdate)(m.loadRef().beginParse()), te = (0, l.loadTransactionDescription)(m.loadRef().beginParse());
    return {
      address: w,
      lt: M,
      prevTransactionHash: S,
      prevTransactionLt: E,
      now: A,
      outMessagesCount: B,
      oldStatus: k,
      endStatus: C,
      inMessage: q,
      outMessages: $,
      totalFees: ae,
      stateUpdate: he,
      description: te,
      raw: h,
      hash: () => h.hash()
    };
  }
  xa.loadTransaction = d;
  function v(m) {
    return (h) => {
      h.storeUint(7, 4), h.storeUint(m.address, 256), h.storeUint(m.lt, 64), h.storeUint(m.prevTransactionHash, 256), h.storeUint(m.prevTransactionLt, 64), h.storeUint(m.now, 32), h.storeUint(m.outMessagesCount, 15), h.store((0, r.storeAccountStatus)(m.oldStatus)), h.store((0, r.storeAccountStatus)(m.endStatus));
      let w = (0, t.beginCell)();
      m.inMessage ? (w.storeBit(!0), w.storeRef((0, t.beginCell)().store((0, a.storeMessage)(m.inMessage)))) : w.storeBit(!1), w.storeDict(m.outMessages), h.storeRef(w), h.store((0, i.storeCurrencyCollection)(m.totalFees)), h.storeRef((0, t.beginCell)().store((0, f.storeHashUpdate)(m.stateUpdate))), h.storeRef((0, t.beginCell)().store((0, l.storeTransactionDescription)(m.description)));
    };
  }
  return xa.storeTransaction = v, xa;
}
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.loadStorageInfo = t.storeStateInit = t.loadStateInit = t.storeSplitMergeInfo = t.loadSplitMergeInfo = t.storeSimpleLibrary = t.loadSimpleLibrary = t.loadShardStateUnsplit = t.storeShardIdent = t.loadShardIdent = t.storeShardAccounts = t.loadShardAccounts = t.ShardAccountRefValue = t.storeShardAccount = t.loadShardAccount = t.SendMode = t.storeMessageRelaxed = t.loadMessageRelaxed = t.storeMessage = t.loadMessage = t.loadMasterchainStateExtra = t.storeHashUpdate = t.loadHashUpdate = t.storeDepthBalanceInfo = t.loadDepthBalanceInfo = t.storeCurrencyCollection = t.loadCurrencyCollection = t.storeComputeSkipReason = t.loadComputeSkipReason = t.storeCommonMessageInfoRelaxed = t.loadCommonMessageInfoRelaxed = t.storeCommonMessageInfo = t.loadCommonMessageInfo = t.storeOutList = t.loadOutList = t.storeOutAction = t.loadOutAction = t.storeAccountStorage = t.loadAccountStorage = t.storeAccountStatusChange = t.loadAccountStatusChange = t.storeAccountStatus = t.loadAccountStatus = t.storeAccountState = t.loadAccountState = t.storeAccount = t.loadAccount = t.comment = t.external = t.internal = void 0, t.storeTransactionsStoragePhase = t.loadTransactionStoragePhase = t.storeTransactionDescription = t.loadTransactionDescription = t.storeTransactionCreditPhase = t.loadTransactionCreditPhase = t.storeTransactionComputePhase = t.loadTransactionComputePhase = t.storeTransactionBouncePhase = t.loadTransactionBouncePhase = t.storeTransactionActionPhase = t.loadTransactionActionPhase = t.storeTransaction = t.loadTransaction = t.storeTickTock = t.loadTickTock = t.storeStorageUsedShort = t.loadStorageUsedShort = t.storeStorageUsed = t.loadStorageUsed = t.storeStorageInfo = void 0;
  var e = na;
  Object.defineProperty(t, "internal", { enumerable: !0, get: function() {
    return e.internal;
  } }), Object.defineProperty(t, "external", { enumerable: !0, get: function() {
    return e.external;
  } }), Object.defineProperty(t, "comment", { enumerable: !0, get: function() {
    return e.comment;
  } });
  var r = Va;
  Object.defineProperty(t, "loadAccount", { enumerable: !0, get: function() {
    return r.loadAccount;
  } }), Object.defineProperty(t, "storeAccount", { enumerable: !0, get: function() {
    return r.storeAccount;
  } });
  var i = Wa;
  Object.defineProperty(t, "loadAccountState", { enumerable: !0, get: function() {
    return i.loadAccountState;
  } }), Object.defineProperty(t, "storeAccountState", { enumerable: !0, get: function() {
    return i.storeAccountState;
  } });
  var f = Ga;
  Object.defineProperty(t, "loadAccountStatus", { enumerable: !0, get: function() {
    return f.loadAccountStatus;
  } }), Object.defineProperty(t, "storeAccountStatus", { enumerable: !0, get: function() {
    return f.storeAccountStatus;
  } });
  var a = la;
  Object.defineProperty(t, "loadAccountStatusChange", { enumerable: !0, get: function() {
    return a.loadAccountStatusChange;
  } }), Object.defineProperty(t, "storeAccountStatusChange", { enumerable: !0, get: function() {
    return a.storeAccountStatusChange;
  } });
  var l = Ha;
  Object.defineProperty(t, "loadAccountStorage", { enumerable: !0, get: function() {
    return l.loadAccountStorage;
  } }), Object.defineProperty(t, "storeAccountStorage", { enumerable: !0, get: function() {
    return l.storeAccountStorage;
  } });
  var d = Gn;
  Object.defineProperty(t, "loadOutAction", { enumerable: !0, get: function() {
    return d.loadOutAction;
  } }), Object.defineProperty(t, "storeOutAction", { enumerable: !0, get: function() {
    return d.storeOutAction;
  } }), Object.defineProperty(t, "loadOutList", { enumerable: !0, get: function() {
    return d.loadOutList;
  } }), Object.defineProperty(t, "storeOutList", { enumerable: !0, get: function() {
    return d.storeOutList;
  } });
  var v = Ja;
  Object.defineProperty(t, "loadCommonMessageInfo", { enumerable: !0, get: function() {
    return v.loadCommonMessageInfo;
  } }), Object.defineProperty(t, "storeCommonMessageInfo", { enumerable: !0, get: function() {
    return v.storeCommonMessageInfo;
  } });
  var m = Ya;
  Object.defineProperty(t, "loadCommonMessageInfoRelaxed", { enumerable: !0, get: function() {
    return m.loadCommonMessageInfoRelaxed;
  } }), Object.defineProperty(t, "storeCommonMessageInfoRelaxed", { enumerable: !0, get: function() {
    return m.storeCommonMessageInfoRelaxed;
  } });
  var h = Xa;
  Object.defineProperty(t, "loadComputeSkipReason", { enumerable: !0, get: function() {
    return h.loadComputeSkipReason;
  } }), Object.defineProperty(t, "storeComputeSkipReason", { enumerable: !0, get: function() {
    return h.storeComputeSkipReason;
  } });
  var w = pn;
  Object.defineProperty(t, "loadCurrencyCollection", { enumerable: !0, get: function() {
    return w.loadCurrencyCollection;
  } }), Object.defineProperty(t, "storeCurrencyCollection", { enumerable: !0, get: function() {
    return w.storeCurrencyCollection;
  } });
  var M = es;
  Object.defineProperty(t, "loadDepthBalanceInfo", { enumerable: !0, get: function() {
    return M.loadDepthBalanceInfo;
  } }), Object.defineProperty(t, "storeDepthBalanceInfo", { enumerable: !0, get: function() {
    return M.storeDepthBalanceInfo;
  } });
  var S = ts;
  Object.defineProperty(t, "loadHashUpdate", { enumerable: !0, get: function() {
    return S.loadHashUpdate;
  } }), Object.defineProperty(t, "storeHashUpdate", { enumerable: !0, get: function() {
    return S.storeHashUpdate;
  } });
  var E = tu;
  Object.defineProperty(t, "loadMasterchainStateExtra", { enumerable: !0, get: function() {
    return E.loadMasterchainStateExtra;
  } });
  var A = Si;
  Object.defineProperty(t, "loadMessage", { enumerable: !0, get: function() {
    return A.loadMessage;
  } }), Object.defineProperty(t, "storeMessage", { enumerable: !0, get: function() {
    return A.storeMessage;
  } });
  var B = Qa;
  Object.defineProperty(t, "loadMessageRelaxed", { enumerable: !0, get: function() {
    return B.loadMessageRelaxed;
  } }), Object.defineProperty(t, "storeMessageRelaxed", { enumerable: !0, get: function() {
    return B.storeMessageRelaxed;
  } });
  var k = Cc;
  Object.defineProperty(t, "SendMode", { enumerable: !0, get: function() {
    return k.SendMode;
  } });
  var C = rs;
  Object.defineProperty(t, "loadShardAccount", { enumerable: !0, get: function() {
    return C.loadShardAccount;
  } }), Object.defineProperty(t, "storeShardAccount", { enumerable: !0, get: function() {
    return C.storeShardAccount;
  } });
  var I = Dm;
  Object.defineProperty(t, "ShardAccountRefValue", { enumerable: !0, get: function() {
    return I.ShardAccountRefValue;
  } }), Object.defineProperty(t, "loadShardAccounts", { enumerable: !0, get: function() {
    return I.loadShardAccounts;
  } }), Object.defineProperty(t, "storeShardAccounts", { enumerable: !0, get: function() {
    return I.storeShardAccounts;
  } });
  var O = ns;
  Object.defineProperty(t, "loadShardIdent", { enumerable: !0, get: function() {
    return O.loadShardIdent;
  } }), Object.defineProperty(t, "storeShardIdent", { enumerable: !0, get: function() {
    return O.storeShardIdent;
  } });
  var q = Bc;
  Object.defineProperty(t, "loadShardStateUnsplit", { enumerable: !0, get: function() {
    return q.loadShardStateUnsplit;
  } });
  var $ = Mi;
  Object.defineProperty(t, "loadSimpleLibrary", { enumerable: !0, get: function() {
    return $.loadSimpleLibrary;
  } }), Object.defineProperty(t, "storeSimpleLibrary", { enumerable: !0, get: function() {
    return $.storeSimpleLibrary;
  } });
  var ae = is;
  Object.defineProperty(t, "loadSplitMergeInfo", { enumerable: !0, get: function() {
    return ae.loadSplitMergeInfo;
  } }), Object.defineProperty(t, "storeSplitMergeInfo", { enumerable: !0, get: function() {
    return ae.storeSplitMergeInfo;
  } });
  var he = ii;
  Object.defineProperty(t, "loadStateInit", { enumerable: !0, get: function() {
    return he.loadStateInit;
  } }), Object.defineProperty(t, "storeStateInit", { enumerable: !0, get: function() {
    return he.storeStateInit;
  } });
  var te = Ka;
  Object.defineProperty(t, "loadStorageInfo", { enumerable: !0, get: function() {
    return te.loadStorageInfo;
  } }), Object.defineProperty(t, "storeStorageInfo", { enumerable: !0, get: function() {
    return te.storeStorageInfo;
  } });
  var Ee = Za;
  Object.defineProperty(t, "loadStorageUsed", { enumerable: !0, get: function() {
    return Ee.loadStorageUsed;
  } }), Object.defineProperty(t, "storeStorageUsed", { enumerable: !0, get: function() {
    return Ee.storeStorageUsed;
  } });
  var x = ca;
  Object.defineProperty(t, "loadStorageUsedShort", { enumerable: !0, get: function() {
    return x.loadStorageUsedShort;
  } }), Object.defineProperty(t, "storeStorageUsedShort", { enumerable: !0, get: function() {
    return x.storeStorageUsedShort;
  } });
  var n = ja;
  Object.defineProperty(t, "loadTickTock", { enumerable: !0, get: function() {
    return n.loadTickTock;
  } }), Object.defineProperty(t, "storeTickTock", { enumerable: !0, get: function() {
    return n.storeTickTock;
  } });
  var o = b9();
  Object.defineProperty(t, "loadTransaction", { enumerable: !0, get: function() {
    return o.loadTransaction;
  } }), Object.defineProperty(t, "storeTransaction", { enumerable: !0, get: function() {
    return o.storeTransaction;
  } });
  var u = as;
  Object.defineProperty(t, "loadTransactionActionPhase", { enumerable: !0, get: function() {
    return u.loadTransactionActionPhase;
  } }), Object.defineProperty(t, "storeTransactionActionPhase", { enumerable: !0, get: function() {
    return u.storeTransactionActionPhase;
  } });
  var c = ss;
  Object.defineProperty(t, "loadTransactionBouncePhase", { enumerable: !0, get: function() {
    return c.loadTransactionBouncePhase;
  } }), Object.defineProperty(t, "storeTransactionBouncePhase", { enumerable: !0, get: function() {
    return c.storeTransactionBouncePhase;
  } });
  var g = os;
  Object.defineProperty(t, "loadTransactionComputePhase", { enumerable: !0, get: function() {
    return g.loadTransactionComputePhase;
  } }), Object.defineProperty(t, "storeTransactionComputePhase", { enumerable: !0, get: function() {
    return g.storeTransactionComputePhase;
  } });
  var b = fs;
  Object.defineProperty(t, "loadTransactionCreditPhase", { enumerable: !0, get: function() {
    return b.loadTransactionCreditPhase;
  } }), Object.defineProperty(t, "storeTransactionCreditPhase", { enumerable: !0, get: function() {
    return b.storeTransactionCreditPhase;
  } });
  var _ = y9();
  Object.defineProperty(t, "loadTransactionDescription", { enumerable: !0, get: function() {
    return _.loadTransactionDescription;
  } }), Object.defineProperty(t, "storeTransactionDescription", { enumerable: !0, get: function() {
    return _.storeTransactionDescription;
  } });
  var p = us;
  Object.defineProperty(t, "loadTransactionStoragePhase", { enumerable: !0, get: function() {
    return p.loadTransactionStoragePhase;
  } }), Object.defineProperty(t, "storeTransactionsStoragePhase", { enumerable: !0, get: function() {
    return p.storeTransactionsStoragePhase;
  } });
})(V_);
var Ic = {};
Object.defineProperty(Ic, "__esModule", { value: !0 });
Ic.openContract = void 0;
const oN = hn, ww = ys();
function fN(t, e) {
  let r, i = null;
  if (!oN.Address.isAddress(t.address))
    throw Error("Invalid address");
  if (r = t.address, t.init) {
    if (!(t.init.code instanceof ww.Cell))
      throw Error("Invalid init.code");
    if (!(t.init.data instanceof ww.Cell))
      throw Error("Invalid init.data");
    i = t.init;
  }
  let f = e({ address: r, init: i });
  return new Proxy(t, {
    get(a, l) {
      const d = a[l];
      return typeof l == "string" && (l.startsWith("get") || l.startsWith("send")) && typeof d == "function" ? (...v) => d.apply(a, [f, ...v]) : d;
    }
  });
}
Ic.openContract = fN;
var Rc = {};
Object.defineProperty(Rc, "__esModule", { value: !0 });
Rc.ComputeError = void 0;
class Um extends Error {
  constructor(e, r, i) {
    super(e), this.exitCode = r, this.debugLogs = i && i.debugLogs ? i.debugLogs : null, this.logs = i && i.logs ? i.logs : null, Object.setPrototypeOf(this, Um.prototype);
  }
}
Rc.ComputeError = Um;
var Pc = {};
Object.defineProperty(Pc, "__esModule", { value: !0 });
Pc.getMethodId = void 0;
const uN = new Int16Array([
  0,
  4129,
  8258,
  12387,
  16516,
  20645,
  24774,
  28903,
  33032,
  37161,
  41290,
  45419,
  49548,
  53677,
  57806,
  61935,
  4657,
  528,
  12915,
  8786,
  21173,
  17044,
  29431,
  25302,
  37689,
  33560,
  45947,
  41818,
  54205,
  50076,
  62463,
  58334,
  9314,
  13379,
  1056,
  5121,
  25830,
  29895,
  17572,
  21637,
  42346,
  46411,
  34088,
  38153,
  58862,
  62927,
  50604,
  54669,
  13907,
  9842,
  5649,
  1584,
  30423,
  26358,
  22165,
  18100,
  46939,
  42874,
  38681,
  34616,
  63455,
  59390,
  55197,
  51132,
  18628,
  22757,
  26758,
  30887,
  2112,
  6241,
  10242,
  14371,
  51660,
  55789,
  59790,
  63919,
  35144,
  39273,
  43274,
  47403,
  23285,
  19156,
  31415,
  27286,
  6769,
  2640,
  14899,
  10770,
  56317,
  52188,
  64447,
  60318,
  39801,
  35672,
  47931,
  43802,
  27814,
  31879,
  19684,
  23749,
  11298,
  15363,
  3168,
  7233,
  60846,
  64911,
  52716,
  56781,
  44330,
  48395,
  36200,
  40265,
  32407,
  28342,
  24277,
  20212,
  15891,
  11826,
  7761,
  3696,
  65439,
  61374,
  57309,
  53244,
  48923,
  44858,
  40793,
  36728,
  37256,
  33193,
  45514,
  41451,
  53516,
  49453,
  61774,
  57711,
  4224,
  161,
  12482,
  8419,
  20484,
  16421,
  28742,
  24679,
  33721,
  37784,
  41979,
  46042,
  49981,
  54044,
  58239,
  62302,
  689,
  4752,
  8947,
  13010,
  16949,
  21012,
  25207,
  29270,
  46570,
  42443,
  38312,
  34185,
  62830,
  58703,
  54572,
  50445,
  13538,
  9411,
  5280,
  1153,
  29798,
  25671,
  21540,
  17413,
  42971,
  47098,
  34713,
  38840,
  59231,
  63358,
  50973,
  55100,
  9939,
  14066,
  1681,
  5808,
  26199,
  30326,
  17941,
  22068,
  55628,
  51565,
  63758,
  59695,
  39368,
  35305,
  47498,
  43435,
  22596,
  18533,
  30726,
  26663,
  6336,
  2273,
  14466,
  10403,
  52093,
  56156,
  60223,
  64286,
  35833,
  39896,
  43963,
  48026,
  19061,
  23124,
  27191,
  31254,
  2801,
  6864,
  10931,
  14994,
  64814,
  60687,
  56684,
  52557,
  48554,
  44427,
  40424,
  36297,
  31782,
  27655,
  23652,
  19525,
  15522,
  11395,
  7392,
  3265,
  61215,
  65342,
  53085,
  57212,
  44955,
  49082,
  36825,
  40952,
  28183,
  32310,
  20053,
  24180,
  11923,
  16050,
  3793,
  7920
]);
function lN(t) {
  t instanceof Je || (t = Je.from(t));
  let e = 0;
  for (let r = 0; r < t.length; r++) {
    const i = t[r];
    e = (uN[(e >> 8 ^ i) & 255] ^ e << 8) & 65535;
  }
  return e;
}
function cN(t) {
  return lN(t) & 65535 | 65536;
}
Pc.getMethodId = cN;
var Js = {};
Object.defineProperty(Js, "__esModule", { value: !0 });
Js.safeSignVerify = Js.safeSign = void 0;
const Lm = gs(), dN = 8, hN = 64;
function w9(t, e) {
  let r = Je.from(e);
  if (r.length > hN)
    throw Error("Seed can	 be longer than 64 bytes");
  if (r.length < dN)
    throw Error("Seed must be at least 8 bytes");
  return (0, Lm.sha256_sync)(Je.concat([Je.from([255, 255]), r, t.hash()]));
}
function pN(t, e, r = "ton-safe-sign-magic") {
  return (0, Lm.sign)(w9(t, r), e);
}
Js.safeSign = pN;
function vN(t, e, r, i = "ton-safe-sign-magic") {
  return (0, Lm.signVerify)(w9(t, i), e, r);
}
Js.safeSignVerify = vN;
(function(t) {
  var e = ut && ut.__createBinding || (Object.create ? function(c, g, b, _) {
    _ === void 0 && (_ = b);
    var p = Object.getOwnPropertyDescriptor(g, b);
    (!p || ("get" in p ? !g.__esModule : p.writable || p.configurable)) && (p = { enumerable: !0, get: function() {
      return g[b];
    } }), Object.defineProperty(c, _, p);
  } : function(c, g, b, _) {
    _ === void 0 && (_ = b), c[_] = g[b];
  }), r = ut && ut.__exportStar || function(c, g) {
    for (var b in c)
      b !== "default" && !Object.prototype.hasOwnProperty.call(g, b) && e(g, c, b);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.safeSignVerify = t.safeSign = t.getMethodId = t.base32Encode = t.base32Decode = t.crc32c = t.crc16 = t.fromNano = t.toNano = t.ComputeError = t.openContract = t.TupleBuilder = t.TupleReader = t.serializeTuple = t.parseTuple = t.generateMerkleUpdate = t.generateMerkleProof = t.exoticPruned = t.exoticMerkleUpdate = t.exoticMerkleProof = t.Dictionary = t.Cell = t.CellType = t.Slice = t.beginCell = t.Builder = t.BitBuilder = t.BitReader = t.BitString = t.contractAddress = t.ADNLAddress = t.ExternalAddress = t.address = t.Address = void 0;
  var i = hn;
  Object.defineProperty(t, "Address", { enumerable: !0, get: function() {
    return i.Address;
  } }), Object.defineProperty(t, "address", { enumerable: !0, get: function() {
    return i.address;
  } });
  var f = lo;
  Object.defineProperty(t, "ExternalAddress", { enumerable: !0, get: function() {
    return f.ExternalAddress;
  } });
  var a = Jl;
  Object.defineProperty(t, "ADNLAddress", { enumerable: !0, get: function() {
    return a.ADNLAddress;
  } });
  var l = Xl;
  Object.defineProperty(t, "contractAddress", { enumerable: !0, get: function() {
    return l.contractAddress;
  } });
  var d = pa();
  Object.defineProperty(t, "BitString", { enumerable: !0, get: function() {
    return d.BitString;
  } });
  var v = qn;
  Object.defineProperty(t, "BitReader", { enumerable: !0, get: function() {
    return v.BitReader;
  } });
  var m = tc();
  Object.defineProperty(t, "BitBuilder", { enumerable: !0, get: function() {
    return m.BitBuilder;
  } });
  var h = Tr();
  Object.defineProperty(t, "Builder", { enumerable: !0, get: function() {
    return h.Builder;
  } }), Object.defineProperty(t, "beginCell", { enumerable: !0, get: function() {
    return h.beginCell;
  } });
  var w = fm();
  Object.defineProperty(t, "Slice", { enumerable: !0, get: function() {
    return w.Slice;
  } });
  var M = va;
  Object.defineProperty(t, "CellType", { enumerable: !0, get: function() {
    return M.CellType;
  } });
  var S = ys();
  Object.defineProperty(t, "Cell", { enumerable: !0, get: function() {
    return S.Cell;
  } });
  var E = ms();
  Object.defineProperty(t, "Dictionary", { enumerable: !0, get: function() {
    return E.Dictionary;
  } });
  var A = co;
  Object.defineProperty(t, "exoticMerkleProof", { enumerable: !0, get: function() {
    return A.exoticMerkleProof;
  } });
  var B = ho;
  Object.defineProperty(t, "exoticMerkleUpdate", { enumerable: !0, get: function() {
    return B.exoticMerkleUpdate;
  } });
  var k = po;
  Object.defineProperty(t, "exoticPruned", { enumerable: !0, get: function() {
    return k.exoticPruned;
  } });
  var C = om();
  Object.defineProperty(t, "generateMerkleProof", { enumerable: !0, get: function() {
    return C.generateMerkleProof;
  } });
  var I = d8();
  Object.defineProperty(t, "generateMerkleUpdate", { enumerable: !0, get: function() {
    return I.generateMerkleUpdate;
  } });
  var O = Ys;
  Object.defineProperty(t, "parseTuple", { enumerable: !0, get: function() {
    return O.parseTuple;
  } }), Object.defineProperty(t, "serializeTuple", { enumerable: !0, get: function() {
    return O.serializeTuple;
  } });
  var q = kc;
  Object.defineProperty(t, "TupleReader", { enumerable: !0, get: function() {
    return q.TupleReader;
  } });
  var $ = Tc;
  Object.defineProperty(t, "TupleBuilder", { enumerable: !0, get: function() {
    return $.TupleBuilder;
  } }), r(V_, t);
  var ae = Ic;
  Object.defineProperty(t, "openContract", { enumerable: !0, get: function() {
    return ae.openContract;
  } });
  var he = Rc;
  Object.defineProperty(t, "ComputeError", { enumerable: !0, get: function() {
    return he.ComputeError;
  } });
  var te = $a;
  Object.defineProperty(t, "toNano", { enumerable: !0, get: function() {
    return te.toNano;
  } }), Object.defineProperty(t, "fromNano", { enumerable: !0, get: function() {
    return te.fromNano;
  } });
  var Ee = uo;
  Object.defineProperty(t, "crc16", { enumerable: !0, get: function() {
    return Ee.crc16;
  } });
  var x = eu;
  Object.defineProperty(t, "crc32c", { enumerable: !0, get: function() {
    return x.crc32c;
  } });
  var n = qa;
  Object.defineProperty(t, "base32Decode", { enumerable: !0, get: function() {
    return n.base32Decode;
  } }), Object.defineProperty(t, "base32Encode", { enumerable: !0, get: function() {
    return n.base32Encode;
  } });
  var o = Pc;
  Object.defineProperty(t, "getMethodId", { enumerable: !0, get: function() {
    return o.getMethodId;
  } });
  var u = Js;
  Object.defineProperty(t, "safeSign", { enumerable: !0, get: function() {
    return u.safeSign;
  } }), Object.defineProperty(t, "safeSignVerify", { enumerable: !0, get: function() {
    return u.safeSignVerify;
  } });
})(At);
const _9 = (t) => new Promise((e) => setTimeout(e, t)), Il = (t = "", e = 4) => t ? `${t.slice(0, e + 2)}...${t.slice(-e)}` : "", x9 = (t) => {
  if (!t)
    return !1;
  try {
    return !!At.Address.parse(t);
  } catch {
    return !1;
  }
}, mN = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "senderAddr",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "receiverAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "receiverAddrWorkchain",
            type: "int8"
          }
        ],
        indexed: !1,
        internalType: "struct LockPayload",
        name: "lockPayload",
        type: "tuple"
      }
    ],
    name: "Locked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "senderAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "senderAddrWorkchain",
            type: "int8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "receiverAddr",
            type: "address"
          },
          {
            internalType: "address",
            name: "bridgeAddr",
            type: "address"
          }
        ],
        indexed: !1,
        internalType: "struct UnlockPayload",
        name: "unlockPayload",
        type: "tuple"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "externalId",
        type: "uint256"
      }
    ],
    name: "Unlocked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_validatorAddr",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenAddr",
        type: "address"
      }
    ],
    name: "__Bridge_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newValidatorAddr",
        type: "address"
      }
    ],
    name: "changeValidatorAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "senderAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "senderAddrWorkchain",
            type: "int8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "receiverAddr",
            type: "address"
          },
          {
            internalType: "address",
            name: "bridgeAddr",
            type: "address"
          }
        ],
        internalType: "struct UnlockPayload",
        name: "_unlockPayload",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "externalId",
        type: "uint256"
      }
    ],
    name: "getUnlockPayloadHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_receiverAddrHash",
        type: "uint256"
      },
      {
        internalType: "int8",
        name: "_receiverAddrWorkchain",
        type: "int8"
      }
    ],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "pulls",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "senderAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "senderAddrWorkchain",
            type: "int8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "receiverAddr",
            type: "address"
          },
          {
            internalType: "address",
            name: "bridgeAddr",
            type: "address"
          }
        ],
        internalType: "struct UnlockPayload",
        name: "_unlockPayload",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "_externalId",
        type: "uint256"
      }
    ],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "validatorAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenAddr",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], M9 = ({
  abi: t,
  address: e,
  publicClient: r,
  signer: i
}) => ({
  ...NM({
    abi: t,
    address: e,
    publicClient: r,
    walletClient: i
  }),
  account: i == null ? void 0 : i.account,
  chain: i == null ? void 0 : i.chain
}), Fm = () => M9({
  abi: mN,
  address: qf
}), S9 = (t) => M9({
  abi: UM,
  address: t8
}), gN = (t) => {
  const e = Fm();
  return LM({
    contracts: t.map((i) => ({
      ...e,
      functionName: "pulls",
      args: [i.payloadHash]
    })),
    watch: !0,
    select(i) {
      return t.filter((f, a) => i[a].result === !1);
    }
  });
}, yN = () => {
  var v;
  const t = A5(!1), { address: e } = k5(), i = ((v = sT({
    variables: {
      where: {
        status: { equals: a8.Pushed },
        OR: [
          { senderAddr: { equals: t } },
          { senderAddr: { equals: e == null ? void 0 : e.toLowerCase() } }
        ]
      }
    },
    pollInterval: 5e3,
    skip: !e || !t
  }).data) == null ? void 0 : v.bridgeTransfers) || [], f = [], a = [];
  return i.forEach((m) => {
    const h = m.receiverAddr;
    if (DM(h)) {
      a.push(m);
      return;
    }
    x9(h) && f.push(m);
  }), [
    ...gN(a).data || [],
    ...f || []
  ];
}, bN = ({
  defaultOpen: t = !1,
  defaultData: e = null
}) => {
  const [r, i] = Ei(t), [f, a] = Ei(e);
  return [r, (v) => {
    i(!0), v && a(v);
  }, () => {
    i(!1), a(e);
  }, f];
}, wN = async ({
  writeAsync: t,
  externalId: e,
  pullPayloadSignature: r,
  pullPayload: i
}) => {
  const f = Fm();
  await t({
    ...f,
    functionName: "unlock",
    args: [r, i, BigInt(e)]
  });
}, _N = async ({
  amount: t,
  receiverAddrHash: e,
  receiverAddrWorkchain: r,
  writeAsync: i
}) => {
  const f = Fm();
  await i({
    ...f,
    functionName: "lock",
    args: [t, e, r]
  });
};
var xN = gs(), qm = Object.defineProperty, E9 = (t) => {
  throw TypeError(t);
}, MN = (t, e, r) => e in t ? qm(t, e, { enumerable: !0, configurable: !0, writable: !0, value: r }) : t[e] = r, ke = (t, e) => qm(t, "name", { value: e, configurable: !0 }), SN = (t, e) => {
  for (var r in e)
    qm(t, r, { get: e[r], enumerable: !0 });
}, Ge = (t, e, r) => MN(t, typeof e != "symbol" ? e + "" : e, r), zm = (t, e, r) => e.has(t) || E9("Cannot " + r), vt = (t, e, r) => (zm(t, e, "read from private field"), r ? r.call(t) : e.get(t)), sr = (t, e, r) => e.has(t) ? E9("Cannot add the same private member more than once") : e instanceof WeakSet ? e.add(t) : e.set(t, r), Xt = (t, e, r, i) => (zm(t, e, "write to private field"), e.set(t, r), r), gr = (t, e, r) => (zm(t, e, "access private method"), r), EN = (t, e, r, i) => ({
  set _(f) {
    Xt(t, e, f);
  },
  get _() {
    return vt(t, e, i);
  }
}), AN = {};
SN(AN, {
  GagarinMasterBridge__factory: () => LD,
  GagarinStaking__factory: () => FD
});
var kN = "6.13.2";
function A9(t, e, r) {
  const i = e.split("|").map((a) => a.trim());
  for (let a = 0; a < i.length; a++)
    switch (e) {
      case "any":
        return;
      case "bigint":
      case "boolean":
      case "number":
      case "string":
        if (typeof t === e)
          return;
    }
  const f = new Error(`invalid value for type ${e}`);
  throw f.code = "INVALID_ARGUMENT", f.argument = `value.${r}`, f.value = t, f;
}
ke(A9, "checkType");
async function Rl(t) {
  const e = Object.keys(t);
  return (await Promise.all(e.map((i) => Promise.resolve(t[i])))).reduce((i, f, a) => (i[e[a]] = f, i), {});
}
ke(Rl, "resolveProperties");
function $t(t, e, r) {
  for (let i in e) {
    let f = e[i];
    const a = r ? r[i] : null;
    a && A9(f, a, i), Object.defineProperty(t, i, {
      enumerable: !0,
      value: f,
      writable: !1
    });
  }
}
ke($t, "defineProperties");
function Oa(t) {
  if (t == null)
    return "null";
  if (Array.isArray(t))
    return "[ " + t.map(Oa).join(", ") + " ]";
  if (t instanceof Uint8Array) {
    const e = "0123456789abcdef";
    let r = "0x";
    for (let i = 0; i < t.length; i++)
      r += e[t[i] >> 4], r += e[t[i] & 15];
    return r;
  }
  if (typeof t == "object" && typeof t.toJSON == "function")
    return Oa(t.toJSON());
  switch (typeof t) {
    case "boolean":
    case "symbol":
      return t.toString();
    case "bigint":
      return BigInt(t).toString();
    case "number":
      return t.toString();
    case "string":
      return JSON.stringify(t);
    case "object": {
      const e = Object.keys(t);
      return e.sort(), "{ " + e.map((r) => `${Oa(r)}: ${Oa(t[r])}`).join(", ") + " }";
    }
  }
  return "[ COULD NOT SERIALIZE ]";
}
ke(Oa, "stringify");
function ls(t, e) {
  return t && t.code === e;
}
ke(ls, "isError");
function jm(t) {
  return ls(t, "CALL_EXCEPTION");
}
ke(jm, "isCallException");
function Xs(t, e, r) {
  let i = t;
  {
    const a = [];
    if (r) {
      if ("message" in r || "code" in r || "name" in r)
        throw new Error(`value will overwrite populated values: ${Oa(r)}`);
      for (const l in r) {
        if (l === "shortMessage")
          continue;
        const d = r[l];
        a.push(l + "=" + Oa(d));
      }
    }
    a.push(`code=${e}`), a.push(`version=${kN}`), a.length && (t += " (" + a.join(", ") + ")");
  }
  let f;
  switch (e) {
    case "INVALID_ARGUMENT":
      f = new TypeError(t);
      break;
    case "NUMERIC_FAULT":
    case "BUFFER_OVERRUN":
      f = new RangeError(t);
      break;
    default:
      f = new Error(t);
  }
  return $t(f, {
    code: e
  }), r && Object.assign(f, r), f.shortMessage == null && $t(f, {
    shortMessage: i
  }), f;
}
ke(Xs, "makeError");
function Ut(t, e, r, i) {
  if (!t)
    throw Xs(e, r, i);
}
ke(Ut, "assert");
function Mt(t, e, r, i) {
  Ut(t, e, "INVALID_ARGUMENT", {
    argument: r,
    value: i
  });
}
ke(Mt, "assertArgument");
function $m(t, e, r) {
  r == null && (r = ""), r && (r = ": " + r), Ut(t >= e, "missing arguemnt" + r, "MISSING_ARGUMENT", {
    count: t,
    expectedCount: e
  }), Ut(t <= e, "too many arguments" + r, "UNEXPECTED_ARGUMENT", {
    count: t,
    expectedCount: e
  });
}
ke($m, "assertArgumentCount");
var TN = [
  "NFD",
  "NFC",
  "NFKD",
  "NFKC"
].reduce((t, e) => {
  try {
    if ("test".normalize(e) !== "test")
      throw new Error("bad");
    if (e === "NFD" && "é".normalize("NFD") !== "é")
      throw new Error("broken");
    t.push(e);
  } catch {
  }
  return t;
}, []);
function k9(t) {
  Ut(TN.indexOf(t) >= 0, "platform missing String.prototype.normalize", "UNSUPPORTED_OPERATION", {
    operation: "String.prototype.normalize",
    info: {
      form: t
    }
  });
}
ke(k9, "assertNormalize");
function Oc(t, e, r) {
  if (r == null && (r = ""), t !== e) {
    let i = r, f = "new";
    r && (i += ".", f += " " + r), Ut(!1, `private constructor; use ${i}from* methods`, "UNSUPPORTED_OPERATION", {
      operation: f
    });
  }
}
ke(Oc, "assertPrivate");
function Vm(t, e, r) {
  if (t instanceof Uint8Array)
    return r ? new Uint8Array(t) : t;
  if (typeof t == "string" && t.match(/^0x(?:[0-9a-f][0-9a-f])*$/i)) {
    const i = new Uint8Array((t.length - 2) / 2);
    let f = 2;
    for (let a = 0; a < i.length; a++)
      i[a] = parseInt(t.substring(f, f + 2), 16), f += 2;
    return i;
  }
  Mt(!1, "invalid BytesLike value", e || "value", t);
}
ke(Vm, "_getBytes");
function vn(t, e) {
  return Vm(t, e, !1);
}
ke(vn, "getBytes");
function Nn(t, e) {
  return Vm(t, e, !0);
}
ke(Nn, "getBytesCopy");
function ai(t, e) {
  return !(typeof t != "string" || !t.match(/^0x[0-9A-Fa-f]*$/) || typeof e == "number" && t.length !== 2 + 2 * e || e === !0 && t.length % 2 !== 0);
}
ke(ai, "isHexString");
function T9(t) {
  return ai(t, !0) || t instanceof Uint8Array;
}
ke(T9, "isBytesLike");
var _w = "0123456789abcdef";
function mr(t) {
  const e = vn(t);
  let r = "0x";
  for (let i = 0; i < e.length; i++) {
    const f = e[i];
    r += _w[(f & 240) >> 4] + _w[f & 15];
  }
  return r;
}
ke(mr, "hexlify");
function ia(t) {
  return "0x" + t.map((e) => mr(e).substring(2)).join("");
}
ke(ia, "concat");
function Vi(t, e, r) {
  const i = vn(t);
  return r != null && r > i.length && Ut(!1, "cannot slice beyond data bounds", "BUFFER_OVERRUN", {
    buffer: i,
    length: i.length,
    offset: r
  }), mr(i.slice(e ?? 0, r ?? i.length));
}
ke(Vi, "dataSlice");
function Hm(t, e, r) {
  const i = vn(t);
  Ut(e >= i.length, "padding exceeds data length", "BUFFER_OVERRUN", {
    buffer: new Uint8Array(i),
    length: e,
    offset: e + 1
  });
  const f = new Uint8Array(e);
  return f.fill(0), r ? f.set(i, e - i.length) : f.set(i, 0), mr(f);
}
ke(Hm, "zeroPad");
function C9(t, e) {
  return Hm(t, e, !0);
}
ke(C9, "zeroPadValue");
function B9(t, e) {
  return Hm(t, e, !1);
}
ke(B9, "zeroPadBytes");
var Nc = BigInt(0), Pn = BigInt(1), Ns = 9007199254740991;
function I9(t, e) {
  const r = ru(t, "value"), i = BigInt(ci(e, "width"));
  if (Ut(r >> i === Nc, "overflow", "NUMERIC_FAULT", {
    operation: "fromTwos",
    fault: "overflow",
    value: t
  }), r >> i - Pn) {
    const f = (Pn << i) - Pn;
    return -((~r & f) + Pn);
  }
  return r;
}
ke(I9, "fromTwos");
function R9(t, e) {
  let r = li(t, "value");
  const i = BigInt(ci(e, "width")), f = Pn << i - Pn;
  if (r < Nc) {
    r = -r, Ut(r <= f, "too low", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: t
    });
    const a = (Pn << i) - Pn;
    return (~r & a) + Pn;
  } else
    Ut(r < f, "too high", "NUMERIC_FAULT", {
      operation: "toTwos",
      fault: "overflow",
      value: t
    });
  return r;
}
ke(R9, "toTwos");
function ff(t, e) {
  const r = ru(t, "value"), i = BigInt(ci(e, "bits"));
  return r & (Pn << i) - Pn;
}
ke(ff, "mask");
function li(t, e) {
  switch (typeof t) {
    case "bigint":
      return t;
    case "number":
      return Mt(Number.isInteger(t), "underflow", e || "value", t), Mt(t >= -Ns && t <= Ns, "overflow", e || "value", t), BigInt(t);
    case "string":
      try {
        if (t === "")
          throw new Error("empty string");
        return t[0] === "-" && t[1] !== "-" ? -BigInt(t.substring(1)) : BigInt(t);
      } catch (r) {
        Mt(!1, `invalid BigNumberish string: ${r.message}`, e || "value", t);
      }
  }
  Mt(!1, "invalid BigNumberish value", e || "value", t);
}
ke(li, "getBigInt");
function ru(t, e) {
  const r = li(t, e);
  return Ut(r >= Nc, "unsigned value cannot be negative", "NUMERIC_FAULT", {
    fault: "overflow",
    operation: "getUint",
    value: t
  }), r;
}
ke(ru, "getUint");
var xw = "0123456789abcdef";
function Wm(t) {
  if (t instanceof Uint8Array) {
    let e = "0x0";
    for (const r of t)
      e += xw[r >> 4], e += xw[r & 15];
    return BigInt(e);
  }
  return li(t);
}
ke(Wm, "toBigInt");
function ci(t, e) {
  switch (typeof t) {
    case "bigint":
      return Mt(t >= -Ns && t <= Ns, "overflow", e || "value", t), Number(t);
    case "number":
      return Mt(Number.isInteger(t), "underflow", e || "value", t), Mt(t >= -Ns && t <= Ns, "overflow", e || "value", t), t;
    case "string":
      try {
        if (t === "")
          throw new Error("empty string");
        return ci(BigInt(t), e);
      } catch (r) {
        Mt(!1, `invalid numeric string: ${r.message}`, e || "value", t);
      }
  }
  Mt(!1, "invalid numeric value", e || "value", t);
}
ke(ci, "getNumber");
function P9(t) {
  return ci(Wm(t));
}
ke(P9, "toNumber");
function Km(t, e) {
  let i = ru(t, "value").toString(16);
  if (e == null)
    i.length % 2 && (i = "0" + i);
  else {
    const f = ci(e, "width");
    for (Ut(f * 2 >= i.length, `value exceeds width (${f} bytes)`, "NUMERIC_FAULT", {
      operation: "toBeHex",
      fault: "overflow",
      value: t
    }); i.length < f * 2; )
      i = "0" + i;
  }
  return "0x" + i;
}
ke(Km, "toBeHex");
function O9(t) {
  const e = ru(t, "value");
  if (e === Nc)
    return new Uint8Array([]);
  let r = e.toString(16);
  r.length % 2 && (r = "0" + r);
  const i = new Uint8Array(r.length / 2);
  for (let f = 0; f < i.length; f++) {
    const a = f * 2;
    i[f] = parseInt(r.substring(a, a + 2), 16);
  }
  return i;
}
ke(O9, "toBeArray");
var uf, N9 = class {
  /**
   *  Create a new **EventPayload** for %%emitter%% with
   *  the %%listener%% and for %%filter%%.
   */
  constructor(e, r, i) {
    Ge(this, "filter"), Ge(this, "emitter"), sr(this, uf), Xt(this, uf, r), $t(this, {
      emitter: e,
      filter: i
    });
  }
  /**
   *  Unregister the triggered listener for future events.
   */
  async removeListener() {
    vt(this, uf) != null && await this.emitter.off(this.filter, vt(this, uf));
  }
};
uf = /* @__PURE__ */ new WeakMap();
ke(N9, "EventPayload");
var CN = N9;
function D9(t, e, r, i, f) {
  Mt(!1, `invalid codepoint at offset ${e}; ${t}`, "bytes", r);
}
ke(D9, "errorFunc");
function Zm(t, e, r, i, f) {
  if (t === "BAD_PREFIX" || t === "UNEXPECTED_CONTINUE") {
    let a = 0;
    for (let l = e + 1; l < r.length && r[l] >> 6 === 2; l++)
      a++;
    return a;
  }
  return t === "OVERRUN" ? r.length - e - 1 : 0;
}
ke(Zm, "ignoreFunc");
function U9(t, e, r, i, f) {
  return t === "OVERLONG" ? (Mt(typeof f == "number", "invalid bad code point for replacement", "badCodepoint", f), i.push(f), 0) : (i.push(65533), Zm(t, e, r));
}
ke(U9, "replaceFunc");
var BN = Object.freeze({
  error: D9,
  ignore: Zm,
  replace: U9
});
function L9(t, e) {
  e == null && (e = BN.error);
  const r = vn(t, "bytes"), i = [];
  let f = 0;
  for (; f < r.length; ) {
    const a = r[f++];
    if (!(a >> 7)) {
      i.push(a);
      continue;
    }
    let l = null, d = null;
    if ((a & 224) === 192)
      l = 1, d = 127;
    else if ((a & 240) === 224)
      l = 2, d = 2047;
    else if ((a & 248) === 240)
      l = 3, d = 65535;
    else {
      (a & 192) === 128 ? f += e("UNEXPECTED_CONTINUE", f - 1, r, i) : f += e("BAD_PREFIX", f - 1, r, i);
      continue;
    }
    if (f - 1 + l >= r.length) {
      f += e("OVERRUN", f - 1, r, i);
      continue;
    }
    let v = a & (1 << 8 - l - 1) - 1;
    for (let m = 0; m < l; m++) {
      let h = r[f];
      if ((h & 192) != 128) {
        f += e("MISSING_CONTINUE", f, r, i), v = null;
        break;
      }
      v = v << 6 | h & 63, f++;
    }
    if (v !== null) {
      if (v > 1114111) {
        f += e("OUT_OF_RANGE", f - 1 - l, r, i, v);
        continue;
      }
      if (v >= 55296 && v <= 57343) {
        f += e("UTF16_SURROGATE", f - 1 - l, r, i, v);
        continue;
      }
      if (v <= d) {
        f += e("OVERLONG", f - 1 - l, r, i, v);
        continue;
      }
      i.push(v);
    }
  }
  return i;
}
ke(L9, "getUtf8CodePoints");
function Gm(t, e) {
  Mt(typeof t == "string", "invalid string value", "str", t), e != null && (k9(e), t = t.normalize(e));
  let r = [];
  for (let i = 0; i < t.length; i++) {
    const f = t.charCodeAt(i);
    if (f < 128)
      r.push(f);
    else if (f < 2048)
      r.push(f >> 6 | 192), r.push(f & 63 | 128);
    else if ((f & 64512) == 55296) {
      i++;
      const a = t.charCodeAt(i);
      Mt(i < t.length && (a & 64512) === 56320, "invalid surrogate pair", "str", t);
      const l = 65536 + ((f & 1023) << 10) + (a & 1023);
      r.push(l >> 18 | 240), r.push(l >> 12 & 63 | 128), r.push(l >> 6 & 63 | 128), r.push(l & 63 | 128);
    } else
      r.push(f >> 12 | 224), r.push(f >> 6 & 63 | 128), r.push(f & 63 | 128);
  }
  return new Uint8Array(r);
}
ke(Gm, "toUtf8Bytes");
function F9(t) {
  return t.map((e) => e <= 65535 ? String.fromCharCode(e) : (e -= 65536, String.fromCharCode((e >> 10 & 1023) + 55296, (e & 1023) + 56320))).join("");
}
ke(F9, "_toUtf8String");
function q9(t, e) {
  return F9(L9(t, e));
}
ke(q9, "toUtf8String");
function J1(t) {
  const e = [];
  for (; t; )
    e.unshift(t & 255), t >>= 8;
  return e;
}
ke(J1, "arrayifyInteger");
function Qm(t) {
  if (Array.isArray(t)) {
    let i = [];
    if (t.forEach(function(a) {
      i = i.concat(Qm(a));
    }), i.length <= 55)
      return i.unshift(192 + i.length), i;
    const f = J1(i.length);
    return f.unshift(247 + f.length), f.concat(i);
  }
  const e = Array.prototype.slice.call(vn(t, "object"));
  if (e.length === 1 && e[0] <= 127)
    return e;
  if (e.length <= 55)
    return e.unshift(128 + e.length), e;
  const r = J1(e.length);
  return r.unshift(183 + r.length), r.concat(e);
}
ke(Qm, "_encode");
var Mw = "0123456789abcdef";
function z9(t) {
  let e = "0x";
  for (const r of Qm(t))
    e += Mw[r >> 4], e += Mw[r & 15];
  return e;
}
ke(z9, "encodeRlp");
var Kr = 32, X1 = new Uint8Array(Kr), IN = [
  "then"
], Cu = {}, j9 = /* @__PURE__ */ new WeakMap();
function Wi(t) {
  return j9.get(t);
}
ke(Wi, "getNames");
function ev(t, e) {
  j9.set(t, e);
}
ke(ev, "setNames");
function Es(t, e) {
  const r = new Error(`deferred error during ABI decoding triggered accessing ${t}`);
  throw r.error = e, r;
}
ke(Es, "throwError");
function Pl(t, e, r) {
  return t.indexOf(null) >= 0 ? e.map((i, f) => i instanceof Ol ? Pl(Wi(i), i, r) : i) : t.reduce((i, f, a) => {
    let l = e.getValue(f);
    return f in i || (r && l instanceof Ol && (l = Pl(Wi(l), l, r)), i[f] = l), i;
  }, {});
}
ke(Pl, "toObject");
var lf, $9 = class cf extends Array {
  /**
   *  @private
   */
  constructor(...e) {
    const r = e[0];
    let i = e[1], f = (e[2] || []).slice(), a = !0;
    r !== Cu && (i = e, f = [], a = !1), super(i.length), sr(this, lf), i.forEach((v, m) => {
      this[m] = v;
    });
    const l = f.reduce((v, m) => (typeof m == "string" && v.set(m, (v.get(m) || 0) + 1), v), /* @__PURE__ */ new Map());
    if (ev(this, Object.freeze(i.map((v, m) => {
      const h = f[m];
      return h != null && l.get(h) === 1 ? h : null;
    }))), Xt(this, lf, []), vt(this, lf) == null && vt(this, lf), !a)
      return;
    Object.freeze(this);
    const d = new Proxy(this, {
      get: /* @__PURE__ */ ke((v, m, h) => {
        if (typeof m == "string") {
          if (m.match(/^[0-9]+$/)) {
            const M = ci(m, "%index");
            if (M < 0 || M >= this.length)
              throw new RangeError("out of result range");
            const S = v[M];
            return S instanceof Error && Es(`index ${M}`, S), S;
          }
          if (IN.indexOf(m) >= 0)
            return Reflect.get(v, m, h);
          const w = v[m];
          if (w instanceof Function)
            return function(...M) {
              return w.apply(this === h ? v : this, M);
            };
          if (!(m in v))
            return v.getValue.apply(this === h ? v : this, [
              m
            ]);
        }
        return Reflect.get(v, m, h);
      }, "get")
    });
    return ev(d, Wi(this)), d;
  }
  /**
   *  Returns the Result as a normal Array. If %%deep%%, any children
   *  which are Result objects are also converted to a normal Array.
   *
   *  This will throw if there are any outstanding deferred
   *  errors.
   */
  toArray(e) {
    const r = [];
    return this.forEach((i, f) => {
      i instanceof Error && Es(`index ${f}`, i), e && i instanceof cf && (i = i.toArray(e)), r.push(i);
    }), r;
  }
  /**
   *  Returns the Result as an Object with each name-value pair. If
   *  %%deep%%, any children which are Result objects are also
   *  converted to an Object.
   *
   *  This will throw if any value is unnamed, or if there are
   *  any outstanding deferred errors.
   */
  toObject(e) {
    const r = Wi(this);
    return r.reduce((i, f, a) => (Ut(f != null, `value at index ${a} unnamed`, "UNSUPPORTED_OPERATION", {
      operation: "toObject()"
    }), Pl(r, this, e)), {});
  }
  /**
   *  @_ignore
   */
  slice(e, r) {
    e == null && (e = 0), e < 0 && (e += this.length, e < 0 && (e = 0)), r == null && (r = this.length), r < 0 && (r += this.length, r < 0 && (r = 0)), r > this.length && (r = this.length);
    const i = Wi(this), f = [], a = [];
    for (let l = e; l < r; l++)
      f.push(this[l]), a.push(i[l]);
    return new cf(Cu, f, a);
  }
  /**
   *  @_ignore
   */
  filter(e, r) {
    const i = Wi(this), f = [], a = [];
    for (let l = 0; l < this.length; l++) {
      const d = this[l];
      d instanceof Error && Es(`index ${l}`, d), e.call(r, d, l, this) && (f.push(d), a.push(i[l]));
    }
    return new cf(Cu, f, a);
  }
  /**
   *  @_ignore
   */
  map(e, r) {
    const i = [];
    for (let f = 0; f < this.length; f++) {
      const a = this[f];
      a instanceof Error && Es(`index ${f}`, a), i.push(e.call(r, a, f, this));
    }
    return i;
  }
  /**
   *  Returns the value for %%name%%.
   *
   *  Since it is possible to have a key whose name conflicts with
   *  a method on a [[Result]] or its superclass Array, or any
   *  JavaScript keyword, this ensures all named values are still
   *  accessible by name.
   */
  getValue(e) {
    const r = Wi(this).indexOf(e);
    if (r === -1)
      return;
    const i = this[r];
    return i instanceof Error && Es(`property ${JSON.stringify(e)}`, i.error), i;
  }
  /**
   *  Creates a new [[Result]] for %%items%% with each entry
   *  also accessible by its corresponding name in %%keys%%.
   */
  static fromItems(e, r) {
    return new cf(Cu, e, r);
  }
};
lf = /* @__PURE__ */ new WeakMap();
ke($9, "Result");
var Ol = $9;
function tv(t) {
  let e = O9(t);
  return Ut(e.length <= Kr, "value out-of-bounds", "BUFFER_OVERRUN", {
    buffer: e,
    length: Kr,
    offset: e.length
  }), e.length !== Kr && (e = Nn(ia([
    X1.slice(e.length % Kr),
    e
  ]))), e;
}
ke(tv, "getValue");
var V9 = class {
  constructor(e, r, i, f) {
    Ge(this, "name"), Ge(this, "type"), Ge(this, "localName"), Ge(this, "dynamic"), $t(this, {
      name: e,
      type: r,
      localName: i,
      dynamic: f
    }, {
      name: "string",
      type: "string",
      localName: "string",
      dynamic: "boolean"
    });
  }
  _throwError(e, r) {
    Mt(!1, e, this.localName, r);
  }
};
ke(V9, "Coder");
var Bi = V9, Hi, Ki, df, tl, H9 = class {
  constructor() {
    sr(this, df), sr(this, Hi), sr(this, Ki), Xt(this, Hi, []), Xt(this, Ki, 0);
  }
  get data() {
    return ia(vt(this, Hi));
  }
  get length() {
    return vt(this, Ki);
  }
  appendWriter(e) {
    return gr(this, df, tl).call(this, Nn(e.data));
  }
  // Arrayish item; pad on the right to *nearest* WordSize
  writeBytes(e) {
    let r = Nn(e);
    const i = r.length % Kr;
    return i && (r = Nn(ia([
      r,
      X1.slice(i)
    ]))), gr(this, df, tl).call(this, r);
  }
  // Numeric item; pad on the left *to* WordSize
  writeValue(e) {
    return gr(this, df, tl).call(this, tv(e));
  }
  // Inserts a numeric place-holder, returning a callback that can
  // be used to asjust the value later
  writeUpdatableValue() {
    const e = vt(this, Hi).length;
    return vt(this, Hi).push(X1), Xt(this, Ki, vt(this, Ki) + Kr), (r) => {
      vt(this, Hi)[e] = tv(r);
    };
  }
};
Hi = /* @__PURE__ */ new WeakMap();
Ki = /* @__PURE__ */ new WeakMap();
df = /* @__PURE__ */ new WeakSet();
tl = /* @__PURE__ */ ke(function(t) {
  return vt(this, Hi).push(t), Xt(this, Ki, vt(this, Ki) + t.length), t.length;
}, "#writeData");
ke(H9, "Writer");
var rv = H9, ln, cn, Na, $s, Ua, Mf, nv, W9, K9 = class Z9 {
  constructor(e, r, i) {
    sr(this, Mf), Ge(this, "allowLoose"), sr(this, ln), sr(this, cn), sr(this, Na), sr(this, $s), sr(this, Ua), $t(this, {
      allowLoose: !!r
    }), Xt(this, ln, Nn(e)), Xt(this, Na, 0), Xt(this, $s, null), Xt(this, Ua, i ?? 1024), Xt(this, cn, 0);
  }
  get data() {
    return mr(vt(this, ln));
  }
  get dataLength() {
    return vt(this, ln).length;
  }
  get consumed() {
    return vt(this, cn);
  }
  get bytes() {
    return new Uint8Array(vt(this, ln));
  }
  // Create a sub-reader with the same underlying data, but offset
  subReader(e) {
    const r = new Z9(vt(this, ln).slice(vt(this, cn) + e), this.allowLoose, vt(this, Ua));
    return Xt(r, $s, this), r;
  }
  // Read bytes
  readBytes(e, r) {
    let i = gr(this, Mf, W9).call(this, 0, e, !!r);
    return gr(this, Mf, nv).call(this, e), Xt(this, cn, vt(this, cn) + i.length), i.slice(0, e);
  }
  // Read a numeric values
  readValue() {
    return Wm(this.readBytes(Kr));
  }
  readIndex() {
    return P9(this.readBytes(Kr));
  }
};
ln = /* @__PURE__ */ new WeakMap();
cn = /* @__PURE__ */ new WeakMap();
Na = /* @__PURE__ */ new WeakMap();
$s = /* @__PURE__ */ new WeakMap();
Ua = /* @__PURE__ */ new WeakMap();
Mf = /* @__PURE__ */ new WeakSet();
nv = /* @__PURE__ */ ke(function(t) {
  var e;
  if (vt(this, $s))
    return gr(e = vt(this, $s), Mf, nv).call(e, t);
  Xt(this, Na, vt(this, Na) + t), Ut(vt(this, Ua) < 1 || vt(this, Na) <= vt(this, Ua) * this.dataLength, `compressed ABI data exceeds inflation ratio of ${vt(this, Ua)} ( see: https://github.com/ethers-io/ethers.js/issues/4537 )`, "BUFFER_OVERRUN", {
    buffer: Nn(vt(this, ln)),
    offset: vt(this, cn),
    length: t,
    info: {
      bytesRead: vt(this, Na),
      dataLength: this.dataLength
    }
  });
}, "#incrementBytesRead");
W9 = /* @__PURE__ */ ke(function(t, e, r) {
  let i = Math.ceil(e / Kr) * Kr;
  return vt(this, cn) + i > vt(this, ln).length && (this.allowLoose && r && vt(this, cn) + e <= vt(this, ln).length ? i = e : Ut(!1, "data out-of-bounds", "BUFFER_OVERRUN", {
    buffer: Nn(vt(this, ln)),
    length: vt(this, ln).length,
    offset: vt(this, cn) + i
  })), vt(this, ln).slice(vt(this, cn), vt(this, cn) + i);
}, "#peekBytes");
ke(K9, "Reader");
var RN = K9;
function iv(t) {
  if (!Number.isSafeInteger(t) || t < 0)
    throw new Error(`Wrong positive integer: ${t}`);
}
ke(iv, "number");
function Ym(t, ...e) {
  if (!(t instanceof Uint8Array))
    throw new Error("Expected Uint8Array");
  if (e.length > 0 && !e.includes(t.length))
    throw new Error(`Expected Uint8Array of length ${e}, not of length=${t.length}`);
}
ke(Ym, "bytes");
function av(t, e = !0) {
  if (t.destroyed)
    throw new Error("Hash instance has been destroyed");
  if (e && t.finished)
    throw new Error("Hash#digest() has already been called");
}
ke(av, "exists");
function G9(t, e) {
  Ym(t);
  const r = e.outputLen;
  if (t.length < r)
    throw new Error(`digestInto() expects output buffer of length at least ${r}`);
}
ke(G9, "output");
var Bu = /* @__PURE__ */ BigInt(2 ** 32 - 1), Sw = /* @__PURE__ */ BigInt(32);
function Q9(t, e = !1) {
  return e ? {
    h: Number(t & Bu),
    l: Number(t >> Sw & Bu)
  } : {
    h: Number(t >> Sw & Bu) | 0,
    l: Number(t & Bu) | 0
  };
}
ke(Q9, "fromBig");
function Y9(t, e = !1) {
  let r = new Uint32Array(t.length), i = new Uint32Array(t.length);
  for (let f = 0; f < t.length; f++) {
    const { h: a, l } = Q9(t[f], e);
    [r[f], i[f]] = [
      a,
      l
    ];
  }
  return [
    r,
    i
  ];
}
ke(Y9, "split");
var PN = /* @__PURE__ */ ke((t, e, r) => t << r | e >>> 32 - r, "rotlSH"), ON = /* @__PURE__ */ ke((t, e, r) => e << r | t >>> 32 - r, "rotlSL"), NN = /* @__PURE__ */ ke((t, e, r) => e << r - 32 | t >>> 64 - r, "rotlBH"), DN = /* @__PURE__ */ ke((t, e, r) => t << r - 32 | e >>> 64 - r, "rotlBL"), UN = /* @__PURE__ */ ke((t) => t instanceof Uint8Array, "u8a"), LN = /* @__PURE__ */ ke((t) => new Uint32Array(t.buffer, t.byteOffset, Math.floor(t.byteLength / 4)), "u32"), FN = new Uint8Array(new Uint32Array([
  287454020
]).buffer)[0] === 68;
if (!FN)
  throw new Error("Non little-endian hardware is not supported");
function J9(t) {
  if (typeof t != "string")
    throw new Error(`utf8ToBytes expected string, got ${typeof t}`);
  return new Uint8Array(new TextEncoder().encode(t));
}
ke(J9, "utf8ToBytes");
function Dc(t) {
  if (typeof t == "string" && (t = J9(t)), !UN(t))
    throw new Error(`expected Uint8Array, got ${typeof t}`);
  return t;
}
ke(Dc, "toBytes");
var X9 = class {
  // Safe version that clones internal state
  clone() {
    return this._cloneInto();
  }
};
ke(X9, "Hash");
var qN = X9;
function ex(t) {
  const e = /* @__PURE__ */ ke((i) => t().update(Dc(i)).digest(), "hashC"), r = t();
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = () => t(), e;
}
ke(ex, "wrapConstructor");
function zN(t) {
  const e = /* @__PURE__ */ ke((i, f) => t(f).update(Dc(i)).digest(), "hashC"), r = t({});
  return e.outputLen = r.outputLen, e.blockLen = r.blockLen, e.create = (i) => t(i), e;
}
ke(zN, "wrapXOFConstructorWithOpts");
var [tx, rx, nx] = [
  [],
  [],
  []
], jN = /* @__PURE__ */ BigInt(0), zo = /* @__PURE__ */ BigInt(1), $N = /* @__PURE__ */ BigInt(2), VN = /* @__PURE__ */ BigInt(7), HN = /* @__PURE__ */ BigInt(256), WN = /* @__PURE__ */ BigInt(113);
for (let t = 0, e = zo, r = 1, i = 0; t < 24; t++) {
  [r, i] = [
    i,
    (2 * r + 3 * i) % 5
  ], tx.push(2 * (5 * i + r)), rx.push((t + 1) * (t + 2) / 2 % 64);
  let f = jN;
  for (let a = 0; a < 7; a++)
    e = (e << zo ^ (e >> VN) * WN) % HN, e & $N && (f ^= zo << (zo << /* @__PURE__ */ BigInt(a)) - zo);
  nx.push(f);
}
var [KN, ZN] = /* @__PURE__ */ Y9(nx, !0), Ew = /* @__PURE__ */ ke((t, e, r) => r > 32 ? NN(t, e, r) : PN(t, e, r), "rotlH"), Aw = /* @__PURE__ */ ke((t, e, r) => r > 32 ? DN(t, e, r) : ON(t, e, r), "rotlL");
function ix(t, e = 24) {
  const r = new Uint32Array(10);
  for (let i = 24 - e; i < 24; i++) {
    for (let l = 0; l < 10; l++)
      r[l] = t[l] ^ t[l + 10] ^ t[l + 20] ^ t[l + 30] ^ t[l + 40];
    for (let l = 0; l < 10; l += 2) {
      const d = (l + 8) % 10, v = (l + 2) % 10, m = r[v], h = r[v + 1], w = Ew(m, h, 1) ^ r[d], M = Aw(m, h, 1) ^ r[d + 1];
      for (let S = 0; S < 50; S += 10)
        t[l + S] ^= w, t[l + S + 1] ^= M;
    }
    let f = t[2], a = t[3];
    for (let l = 0; l < 24; l++) {
      const d = rx[l], v = Ew(f, a, d), m = Aw(f, a, d), h = tx[l];
      f = t[h], a = t[h + 1], t[h] = v, t[h + 1] = m;
    }
    for (let l = 0; l < 50; l += 10) {
      for (let d = 0; d < 10; d++)
        r[d] = t[l + d];
      for (let d = 0; d < 10; d++)
        t[l + d] ^= ~r[(d + 2) % 10] & r[(d + 4) % 10];
    }
    t[0] ^= KN[i], t[1] ^= ZN[i];
  }
  r.fill(0);
}
ke(ix, "keccakP");
var ax = class sx extends qN {
  // NOTE: we accept arguments in bytes instead of bits here.
  constructor(e, r, i, f = !1, a = 24) {
    if (super(), this.blockLen = e, this.suffix = r, this.outputLen = i, this.enableXOF = f, this.rounds = a, this.pos = 0, this.posOut = 0, this.finished = !1, this.destroyed = !1, iv(i), 0 >= this.blockLen || this.blockLen >= 200)
      throw new Error("Sha3 supports only keccak-f1600 function");
    this.state = new Uint8Array(200), this.state32 = LN(this.state);
  }
  keccak() {
    ix(this.state32, this.rounds), this.posOut = 0, this.pos = 0;
  }
  update(e) {
    av(this);
    const { blockLen: r, state: i } = this;
    e = Dc(e);
    const f = e.length;
    for (let a = 0; a < f; ) {
      const l = Math.min(r - this.pos, f - a);
      for (let d = 0; d < l; d++)
        i[this.pos++] ^= e[a++];
      this.pos === r && this.keccak();
    }
    return this;
  }
  finish() {
    if (this.finished)
      return;
    this.finished = !0;
    const { state: e, suffix: r, pos: i, blockLen: f } = this;
    e[i] ^= r, r & 128 && i === f - 1 && this.keccak(), e[f - 1] ^= 128, this.keccak();
  }
  writeInto(e) {
    av(this, !1), Ym(e), this.finish();
    const r = this.state, { blockLen: i } = this;
    for (let f = 0, a = e.length; f < a; ) {
      this.posOut >= i && this.keccak();
      const l = Math.min(i - this.posOut, a - f);
      e.set(r.subarray(this.posOut, this.posOut + l), f), this.posOut += l, f += l;
    }
    return e;
  }
  xofInto(e) {
    if (!this.enableXOF)
      throw new Error("XOF is not possible for this instance");
    return this.writeInto(e);
  }
  xof(e) {
    return iv(e), this.xofInto(new Uint8Array(e));
  }
  digestInto(e) {
    if (G9(e, this), this.finished)
      throw new Error("digest() was already called");
    return this.writeInto(e), this.destroy(), e;
  }
  digest() {
    return this.digestInto(new Uint8Array(this.outputLen));
  }
  destroy() {
    this.destroyed = !0, this.state.fill(0);
  }
  _cloneInto(e) {
    const { blockLen: r, suffix: i, outputLen: f, rounds: a, enableXOF: l } = this;
    return e || (e = new sx(r, i, f, l, a)), e.state32.set(this.state32), e.pos = this.pos, e.posOut = this.posOut, e.finished = this.finished, e.rounds = a, e.suffix = i, e.outputLen = f, e.enableXOF = l, e.destroyed = this.destroyed, e;
  }
};
ke(ax, "Keccak");
var GN = ax, QN = /* @__PURE__ */ ke((t, e, r) => ex(() => new GN(e, t, r)), "gen"), YN = /* @__PURE__ */ QN(1, 136, 256 / 8), ox = !1, fx = /* @__PURE__ */ ke(function(t) {
  return YN(t);
}, "_keccak256"), ux = fx;
function si(t) {
  const e = vn(t, "data");
  return mr(ux(e));
}
ke(si, "keccak256");
si._ = fx;
si.lock = function() {
  ox = !0;
};
si.register = function(t) {
  if (ox)
    throw new TypeError("keccak256 is locked");
  ux = t;
};
Object.freeze(si);
var JN = BigInt(0), XN = BigInt(36);
function sv(t) {
  t = t.toLowerCase();
  const e = t.substring(2).split(""), r = new Uint8Array(40);
  for (let f = 0; f < 40; f++)
    r[f] = e[f].charCodeAt(0);
  const i = vn(si(r));
  for (let f = 0; f < 40; f += 2)
    i[f >> 1] >> 4 >= 8 && (e[f] = e[f].toUpperCase()), (i[f >> 1] & 15) >= 8 && (e[f + 1] = e[f + 1].toUpperCase());
  return "0x" + e.join("");
}
ke(sv, "getChecksumAddress");
var Jm = {};
for (let t = 0; t < 10; t++)
  Jm[String(t)] = String(t);
for (let t = 0; t < 26; t++)
  Jm[String.fromCharCode(65 + t)] = String(10 + t);
var kw = 15;
function lx(t) {
  t = t.toUpperCase(), t = t.substring(4) + t.substring(0, 2) + "00";
  let e = t.split("").map((i) => Jm[i]).join("");
  for (; e.length >= kw; ) {
    let i = e.substring(0, kw);
    e = parseInt(i, 10) % 97 + e.substring(i.length);
  }
  let r = String(98 - parseInt(e, 10) % 97);
  for (; r.length < 2; )
    r = "0" + r;
  return r;
}
ke(lx, "ibanChecksum");
var eD = function() {
  const t = {};
  for (let e = 0; e < 36; e++) {
    const r = "0123456789abcdefghijklmnopqrstuvwxyz"[e];
    t[r] = BigInt(e);
  }
  return t;
}();
function cx(t) {
  t = t.toLowerCase();
  let e = JN;
  for (let r = 0; r < t.length; r++)
    e = e * XN + eD[t[r]];
  return e;
}
ke(cx, "fromBase36");
function oi(t) {
  if (Mt(typeof t == "string", "invalid address", "address", t), t.match(/^(0x)?[0-9a-fA-F]{40}$/)) {
    t.startsWith("0x") || (t = "0x" + t);
    const e = sv(t);
    return Mt(!t.match(/([A-F].*[a-f])|([a-f].*[A-F])/) || e === t, "bad address checksum", "address", t), e;
  }
  if (t.match(/^XE[0-9]{2}[0-9A-Za-z]{30,31}$/)) {
    Mt(t.substring(2, 4) === lx(t), "bad icap checksum", "address", t);
    let e = cx(t.substring(4)).toString(16);
    for (; e.length < 40; )
      e = "0" + e;
    return sv("0x" + e);
  }
  Mt(!1, "invalid address", "address", t);
}
ke(oi, "getAddress");
function dx(t) {
  const e = oi(t.from);
  let i = li(t.nonce, "tx.nonce").toString(16);
  return i === "0" ? i = "0x" : i.length % 2 ? i = "0x0" + i : i = "0x" + i, oi(Vi(si(z9([
    e,
    i
  ])), 12));
}
ke(dx, "getCreateAddress");
function Xm(t) {
  return t && typeof t.getAddress == "function";
}
ke(Xm, "isAddressable");
async function rl(t, e) {
  const r = await e;
  return (r == null || r === "0x0000000000000000000000000000000000000000") && (Ut(typeof t != "string", "unconfigured name", "UNCONFIGURED_NAME", {
    value: t
  }), Mt(!1, "invalid AddressLike value; did not resolve to a value address", "target", t)), oi(r);
}
ke(rl, "checkAddress");
function eo(t, e) {
  if (typeof t == "string")
    return t.match(/^0x[0-9a-f]{40}$/i) ? oi(t) : (Ut(e != null, "ENS resolution requires a provider", "UNSUPPORTED_OPERATION", {
      operation: "resolveName"
    }), rl(t, e.resolveName(t)));
  if (Xm(t))
    return rl(t, t.getAddress());
  if (t && typeof t.then == "function")
    return rl(t, t);
  Mt(!1, "unsupported addressable value", "target", t);
}
ke(eo, "resolveAddress");
var mi = {};
function Tt(t, e) {
  let r = !1;
  return e < 0 && (r = !0, e *= -1), new nn(mi, `${r ? "" : "u"}int${e}`, t, {
    signed: r,
    width: e
  });
}
ke(Tt, "n");
function Yt(t, e) {
  return new nn(mi, `bytes${e || ""}`, t, {
    size: e
  });
}
ke(Yt, "b");
var Tw = Symbol.for("_ethers_typed"), As, hx = class Li {
  /**
   *  @_ignore:
   */
  constructor(e, r, i, f) {
    Ge(this, "type"), Ge(this, "value"), sr(this, As), Ge(this, "_typedSymbol"), f == null && (f = null), Oc(mi, e, "Typed"), $t(this, {
      _typedSymbol: Tw,
      type: r,
      value: i
    }), Xt(this, As, f), this.format();
  }
  /**
   *  Format the type as a Human-Readable type.
   */
  format() {
    if (this.type === "array")
      throw new Error("");
    if (this.type === "dynamicArray")
      throw new Error("");
    return this.type === "tuple" ? `tuple(${this.value.map((e) => e.format()).join(",")})` : this.type;
  }
  /**
   *  The default value returned by this type.
   */
  defaultValue() {
    return 0;
  }
  /**
   *  The minimum value for numeric types.
   */
  minValue() {
    return 0;
  }
  /**
   *  The maximum value for numeric types.
   */
  maxValue() {
    return 0;
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedBigInt]].
   */
  isBigInt() {
    return !!this.type.match(/^u?int[0-9]+$/);
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedData]].
   */
  isData() {
    return this.type.startsWith("bytes");
  }
  /**
   *  Returns ``true`` and provides a type guard is this is a [[TypedString]].
   */
  isString() {
    return this.type === "string";
  }
  /**
   *  Returns the tuple name, if this is a tuple. Throws otherwise.
   */
  get tupleName() {
    if (this.type !== "tuple")
      throw TypeError("not a tuple");
    return vt(this, As);
  }
  // Returns the length of this type as an array
  // - `null` indicates the length is unforced, it could be dynamic
  // - `-1` indicates the length is dynamic
  // - any other value indicates it is a static array and is its length
  /**
   *  Returns the length of the array type or ``-1`` if it is dynamic.
   *
   *  Throws if the type is not an array.
   */
  get arrayLength() {
    if (this.type !== "array")
      throw TypeError("not an array");
    return vt(this, As) === !0 ? -1 : vt(this, As) === !1 ? this.value.length : null;
  }
  /**
   *  Returns a new **Typed** of %%type%% with the %%value%%.
   */
  static from(e, r) {
    return new Li(mi, e, r);
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static uint8(e) {
    return Tt(e, 8);
  }
  /**
   *  Return a new ``uint16`` type for %%v%%.
   */
  static uint16(e) {
    return Tt(e, 16);
  }
  /**
   *  Return a new ``uint24`` type for %%v%%.
   */
  static uint24(e) {
    return Tt(e, 24);
  }
  /**
   *  Return a new ``uint32`` type for %%v%%.
   */
  static uint32(e) {
    return Tt(e, 32);
  }
  /**
   *  Return a new ``uint40`` type for %%v%%.
   */
  static uint40(e) {
    return Tt(e, 40);
  }
  /**
   *  Return a new ``uint48`` type for %%v%%.
   */
  static uint48(e) {
    return Tt(e, 48);
  }
  /**
   *  Return a new ``uint56`` type for %%v%%.
   */
  static uint56(e) {
    return Tt(e, 56);
  }
  /**
   *  Return a new ``uint64`` type for %%v%%.
   */
  static uint64(e) {
    return Tt(e, 64);
  }
  /**
   *  Return a new ``uint72`` type for %%v%%.
   */
  static uint72(e) {
    return Tt(e, 72);
  }
  /**
   *  Return a new ``uint80`` type for %%v%%.
   */
  static uint80(e) {
    return Tt(e, 80);
  }
  /**
   *  Return a new ``uint88`` type for %%v%%.
   */
  static uint88(e) {
    return Tt(e, 88);
  }
  /**
   *  Return a new ``uint96`` type for %%v%%.
   */
  static uint96(e) {
    return Tt(e, 96);
  }
  /**
   *  Return a new ``uint104`` type for %%v%%.
   */
  static uint104(e) {
    return Tt(e, 104);
  }
  /**
   *  Return a new ``uint112`` type for %%v%%.
   */
  static uint112(e) {
    return Tt(e, 112);
  }
  /**
   *  Return a new ``uint120`` type for %%v%%.
   */
  static uint120(e) {
    return Tt(e, 120);
  }
  /**
   *  Return a new ``uint128`` type for %%v%%.
   */
  static uint128(e) {
    return Tt(e, 128);
  }
  /**
   *  Return a new ``uint136`` type for %%v%%.
   */
  static uint136(e) {
    return Tt(e, 136);
  }
  /**
   *  Return a new ``uint144`` type for %%v%%.
   */
  static uint144(e) {
    return Tt(e, 144);
  }
  /**
   *  Return a new ``uint152`` type for %%v%%.
   */
  static uint152(e) {
    return Tt(e, 152);
  }
  /**
   *  Return a new ``uint160`` type for %%v%%.
   */
  static uint160(e) {
    return Tt(e, 160);
  }
  /**
   *  Return a new ``uint168`` type for %%v%%.
   */
  static uint168(e) {
    return Tt(e, 168);
  }
  /**
   *  Return a new ``uint176`` type for %%v%%.
   */
  static uint176(e) {
    return Tt(e, 176);
  }
  /**
   *  Return a new ``uint184`` type for %%v%%.
   */
  static uint184(e) {
    return Tt(e, 184);
  }
  /**
   *  Return a new ``uint192`` type for %%v%%.
   */
  static uint192(e) {
    return Tt(e, 192);
  }
  /**
   *  Return a new ``uint200`` type for %%v%%.
   */
  static uint200(e) {
    return Tt(e, 200);
  }
  /**
   *  Return a new ``uint208`` type for %%v%%.
   */
  static uint208(e) {
    return Tt(e, 208);
  }
  /**
   *  Return a new ``uint216`` type for %%v%%.
   */
  static uint216(e) {
    return Tt(e, 216);
  }
  /**
   *  Return a new ``uint224`` type for %%v%%.
   */
  static uint224(e) {
    return Tt(e, 224);
  }
  /**
   *  Return a new ``uint232`` type for %%v%%.
   */
  static uint232(e) {
    return Tt(e, 232);
  }
  /**
   *  Return a new ``uint240`` type for %%v%%.
   */
  static uint240(e) {
    return Tt(e, 240);
  }
  /**
   *  Return a new ``uint248`` type for %%v%%.
   */
  static uint248(e) {
    return Tt(e, 248);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint256(e) {
    return Tt(e, 256);
  }
  /**
   *  Return a new ``uint256`` type for %%v%%.
   */
  static uint(e) {
    return Tt(e, 256);
  }
  /**
   *  Return a new ``int8`` type for %%v%%.
   */
  static int8(e) {
    return Tt(e, -8);
  }
  /**
   *  Return a new ``int16`` type for %%v%%.
   */
  static int16(e) {
    return Tt(e, -16);
  }
  /**
   *  Return a new ``int24`` type for %%v%%.
   */
  static int24(e) {
    return Tt(e, -24);
  }
  /**
   *  Return a new ``int32`` type for %%v%%.
   */
  static int32(e) {
    return Tt(e, -32);
  }
  /**
   *  Return a new ``int40`` type for %%v%%.
   */
  static int40(e) {
    return Tt(e, -40);
  }
  /**
   *  Return a new ``int48`` type for %%v%%.
   */
  static int48(e) {
    return Tt(e, -48);
  }
  /**
   *  Return a new ``int56`` type for %%v%%.
   */
  static int56(e) {
    return Tt(e, -56);
  }
  /**
   *  Return a new ``int64`` type for %%v%%.
   */
  static int64(e) {
    return Tt(e, -64);
  }
  /**
   *  Return a new ``int72`` type for %%v%%.
   */
  static int72(e) {
    return Tt(e, -72);
  }
  /**
   *  Return a new ``int80`` type for %%v%%.
   */
  static int80(e) {
    return Tt(e, -80);
  }
  /**
   *  Return a new ``int88`` type for %%v%%.
   */
  static int88(e) {
    return Tt(e, -88);
  }
  /**
   *  Return a new ``int96`` type for %%v%%.
   */
  static int96(e) {
    return Tt(e, -96);
  }
  /**
   *  Return a new ``int104`` type for %%v%%.
   */
  static int104(e) {
    return Tt(e, -104);
  }
  /**
   *  Return a new ``int112`` type for %%v%%.
   */
  static int112(e) {
    return Tt(e, -112);
  }
  /**
   *  Return a new ``int120`` type for %%v%%.
   */
  static int120(e) {
    return Tt(e, -120);
  }
  /**
   *  Return a new ``int128`` type for %%v%%.
   */
  static int128(e) {
    return Tt(e, -128);
  }
  /**
   *  Return a new ``int136`` type for %%v%%.
   */
  static int136(e) {
    return Tt(e, -136);
  }
  /**
   *  Return a new ``int144`` type for %%v%%.
   */
  static int144(e) {
    return Tt(e, -144);
  }
  /**
   *  Return a new ``int52`` type for %%v%%.
   */
  static int152(e) {
    return Tt(e, -152);
  }
  /**
   *  Return a new ``int160`` type for %%v%%.
   */
  static int160(e) {
    return Tt(e, -160);
  }
  /**
   *  Return a new ``int168`` type for %%v%%.
   */
  static int168(e) {
    return Tt(e, -168);
  }
  /**
   *  Return a new ``int176`` type for %%v%%.
   */
  static int176(e) {
    return Tt(e, -176);
  }
  /**
   *  Return a new ``int184`` type for %%v%%.
   */
  static int184(e) {
    return Tt(e, -184);
  }
  /**
   *  Return a new ``int92`` type for %%v%%.
   */
  static int192(e) {
    return Tt(e, -192);
  }
  /**
   *  Return a new ``int200`` type for %%v%%.
   */
  static int200(e) {
    return Tt(e, -200);
  }
  /**
   *  Return a new ``int208`` type for %%v%%.
   */
  static int208(e) {
    return Tt(e, -208);
  }
  /**
   *  Return a new ``int216`` type for %%v%%.
   */
  static int216(e) {
    return Tt(e, -216);
  }
  /**
   *  Return a new ``int224`` type for %%v%%.
   */
  static int224(e) {
    return Tt(e, -224);
  }
  /**
   *  Return a new ``int232`` type for %%v%%.
   */
  static int232(e) {
    return Tt(e, -232);
  }
  /**
   *  Return a new ``int240`` type for %%v%%.
   */
  static int240(e) {
    return Tt(e, -240);
  }
  /**
   *  Return a new ``int248`` type for %%v%%.
   */
  static int248(e) {
    return Tt(e, -248);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int256(e) {
    return Tt(e, -256);
  }
  /**
   *  Return a new ``int256`` type for %%v%%.
   */
  static int(e) {
    return Tt(e, -256);
  }
  /**
   *  Return a new ``bytes1`` type for %%v%%.
   */
  static bytes1(e) {
    return Yt(e, 1);
  }
  /**
   *  Return a new ``bytes2`` type for %%v%%.
   */
  static bytes2(e) {
    return Yt(e, 2);
  }
  /**
   *  Return a new ``bytes3`` type for %%v%%.
   */
  static bytes3(e) {
    return Yt(e, 3);
  }
  /**
   *  Return a new ``bytes4`` type for %%v%%.
   */
  static bytes4(e) {
    return Yt(e, 4);
  }
  /**
   *  Return a new ``bytes5`` type for %%v%%.
   */
  static bytes5(e) {
    return Yt(e, 5);
  }
  /**
   *  Return a new ``bytes6`` type for %%v%%.
   */
  static bytes6(e) {
    return Yt(e, 6);
  }
  /**
   *  Return a new ``bytes7`` type for %%v%%.
   */
  static bytes7(e) {
    return Yt(e, 7);
  }
  /**
   *  Return a new ``bytes8`` type for %%v%%.
   */
  static bytes8(e) {
    return Yt(e, 8);
  }
  /**
   *  Return a new ``bytes9`` type for %%v%%.
   */
  static bytes9(e) {
    return Yt(e, 9);
  }
  /**
   *  Return a new ``bytes10`` type for %%v%%.
   */
  static bytes10(e) {
    return Yt(e, 10);
  }
  /**
   *  Return a new ``bytes11`` type for %%v%%.
   */
  static bytes11(e) {
    return Yt(e, 11);
  }
  /**
   *  Return a new ``bytes12`` type for %%v%%.
   */
  static bytes12(e) {
    return Yt(e, 12);
  }
  /**
   *  Return a new ``bytes13`` type for %%v%%.
   */
  static bytes13(e) {
    return Yt(e, 13);
  }
  /**
   *  Return a new ``bytes14`` type for %%v%%.
   */
  static bytes14(e) {
    return Yt(e, 14);
  }
  /**
   *  Return a new ``bytes15`` type for %%v%%.
   */
  static bytes15(e) {
    return Yt(e, 15);
  }
  /**
   *  Return a new ``bytes16`` type for %%v%%.
   */
  static bytes16(e) {
    return Yt(e, 16);
  }
  /**
   *  Return a new ``bytes17`` type for %%v%%.
   */
  static bytes17(e) {
    return Yt(e, 17);
  }
  /**
   *  Return a new ``bytes18`` type for %%v%%.
   */
  static bytes18(e) {
    return Yt(e, 18);
  }
  /**
   *  Return a new ``bytes19`` type for %%v%%.
   */
  static bytes19(e) {
    return Yt(e, 19);
  }
  /**
   *  Return a new ``bytes20`` type for %%v%%.
   */
  static bytes20(e) {
    return Yt(e, 20);
  }
  /**
   *  Return a new ``bytes21`` type for %%v%%.
   */
  static bytes21(e) {
    return Yt(e, 21);
  }
  /**
   *  Return a new ``bytes22`` type for %%v%%.
   */
  static bytes22(e) {
    return Yt(e, 22);
  }
  /**
   *  Return a new ``bytes23`` type for %%v%%.
   */
  static bytes23(e) {
    return Yt(e, 23);
  }
  /**
   *  Return a new ``bytes24`` type for %%v%%.
   */
  static bytes24(e) {
    return Yt(e, 24);
  }
  /**
   *  Return a new ``bytes25`` type for %%v%%.
   */
  static bytes25(e) {
    return Yt(e, 25);
  }
  /**
   *  Return a new ``bytes26`` type for %%v%%.
   */
  static bytes26(e) {
    return Yt(e, 26);
  }
  /**
   *  Return a new ``bytes27`` type for %%v%%.
   */
  static bytes27(e) {
    return Yt(e, 27);
  }
  /**
   *  Return a new ``bytes28`` type for %%v%%.
   */
  static bytes28(e) {
    return Yt(e, 28);
  }
  /**
   *  Return a new ``bytes29`` type for %%v%%.
   */
  static bytes29(e) {
    return Yt(e, 29);
  }
  /**
   *  Return a new ``bytes30`` type for %%v%%.
   */
  static bytes30(e) {
    return Yt(e, 30);
  }
  /**
   *  Return a new ``bytes31`` type for %%v%%.
   */
  static bytes31(e) {
    return Yt(e, 31);
  }
  /**
   *  Return a new ``bytes32`` type for %%v%%.
   */
  static bytes32(e) {
    return Yt(e, 32);
  }
  /**
   *  Return a new ``address`` type for %%v%%.
   */
  static address(e) {
    return new Li(mi, "address", e);
  }
  /**
   *  Return a new ``bool`` type for %%v%%.
   */
  static bool(e) {
    return new Li(mi, "bool", !!e);
  }
  /**
   *  Return a new ``bytes`` type for %%v%%.
   */
  static bytes(e) {
    return new Li(mi, "bytes", e);
  }
  /**
   *  Return a new ``string`` type for %%v%%.
   */
  static string(e) {
    return new Li(mi, "string", e);
  }
  /**
   *  Return a new ``array`` type for %%v%%, allowing %%dynamic%% length.
   */
  static array(e, r) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``tuple`` type for %%v%%, with the optional %%name%%.
   */
  static tuple(e, r) {
    throw new Error("not implemented yet");
  }
  /**
   *  Return a new ``uint8`` type for %%v%%.
   */
  static overrides(e) {
    return new Li(mi, "overrides", Object.assign({}, e));
  }
  /**
   *  Returns true only if %%value%% is a [[Typed]] instance.
   */
  static isTyped(e) {
    return e && typeof e == "object" && "_typedSymbol" in e && e._typedSymbol === Tw;
  }
  /**
   *  If the value is a [[Typed]] instance, validates the underlying value
   *  and returns it, otherwise returns value directly.
   *
   *  This is useful for functions that with to accept either a [[Typed]]
   *  object or values.
   */
  static dereference(e, r) {
    if (Li.isTyped(e)) {
      if (e.type !== r)
        throw new Error(`invalid type: expecetd ${r}, got ${e.type}`);
      return e.value;
    }
    return e;
  }
};
As = /* @__PURE__ */ new WeakMap();
ke(hx, "Typed");
var nn = hx, px = class extends Bi {
  constructor(e) {
    super("address", "address", e, !1);
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000";
  }
  encode(e, r) {
    let i = nn.dereference(r, "string");
    try {
      i = oi(i);
    } catch (f) {
      return this._throwError(f.message, r);
    }
    return e.writeValue(i);
  }
  decode(e) {
    return oi(Km(e.readValue(), 20));
  }
};
ke(px, "AddressCoder");
var tD = px, vx = class extends Bi {
  constructor(e) {
    super(e.name, e.type, "_", e.dynamic), Ge(this, "coder"), this.coder = e;
  }
  defaultValue() {
    return this.coder.defaultValue();
  }
  encode(e, r) {
    return this.coder.encode(e, r);
  }
  decode(e) {
    return this.coder.decode(e);
  }
};
ke(vx, "AnonymousCoder");
var rD = vx;
function eg(t, e, r) {
  let i = [];
  if (Array.isArray(r))
    i = r;
  else if (r && typeof r == "object") {
    let v = {};
    i = e.map((m) => {
      const h = m.localName;
      return Ut(h, "cannot encode object for signature with missing names", "INVALID_ARGUMENT", {
        argument: "values",
        info: {
          coder: m
        },
        value: r
      }), Ut(!v[h], "cannot encode object for signature with duplicate names", "INVALID_ARGUMENT", {
        argument: "values",
        info: {
          coder: m
        },
        value: r
      }), v[h] = !0, r[h];
    });
  } else
    Mt(!1, "invalid tuple value", "tuple", r);
  Mt(e.length === i.length, "types/value length mismatch", "tuple", r);
  let f = new rv(), a = new rv(), l = [];
  e.forEach((v, m) => {
    let h = i[m];
    if (v.dynamic) {
      let w = a.length;
      v.encode(a, h);
      let M = f.writeUpdatableValue();
      l.push((S) => {
        M(S + w);
      });
    } else
      v.encode(f, h);
  }), l.forEach((v) => {
    v(f.length);
  });
  let d = t.appendWriter(f);
  return d += t.appendWriter(a), d;
}
ke(eg, "pack");
function tg(t, e) {
  let r = [], i = [], f = t.subReader(0);
  return e.forEach((a) => {
    let l = null;
    if (a.dynamic) {
      let d = t.readIndex(), v = f.subReader(d);
      try {
        l = a.decode(v);
      } catch (m) {
        if (ls(m, "BUFFER_OVERRUN"))
          throw m;
        l = m, l.baseType = a.name, l.name = a.localName, l.type = a.type;
      }
    } else
      try {
        l = a.decode(t);
      } catch (d) {
        if (ls(d, "BUFFER_OVERRUN"))
          throw d;
        l = d, l.baseType = a.name, l.name = a.localName, l.type = a.type;
      }
    if (l == null)
      throw new Error("investigate");
    r.push(l), i.push(a.localName || null);
  }), Ol.fromItems(r, i);
}
ke(tg, "unpack");
var mx = class extends Bi {
  constructor(e, r, i) {
    const f = e.type + "[" + (r >= 0 ? r : "") + "]", a = r === -1 || e.dynamic;
    super("array", f, i, a), Ge(this, "coder"), Ge(this, "length"), $t(this, {
      coder: e,
      length: r
    });
  }
  defaultValue() {
    const e = this.coder.defaultValue(), r = [];
    for (let i = 0; i < this.length; i++)
      r.push(e);
    return r;
  }
  encode(e, r) {
    const i = nn.dereference(r, "array");
    Array.isArray(i) || this._throwError("expected array value", i);
    let f = this.length;
    f === -1 && (f = i.length, e.writeValue(i.length)), $m(i.length, f, "coder array" + (this.localName ? " " + this.localName : ""));
    let a = [];
    for (let l = 0; l < i.length; l++)
      a.push(this.coder);
    return eg(e, a, i);
  }
  decode(e) {
    let r = this.length;
    r === -1 && (r = e.readIndex(), Ut(r * Kr <= e.dataLength, "insufficient data length", "BUFFER_OVERRUN", {
      buffer: e.bytes,
      offset: r * Kr,
      length: e.dataLength
    }));
    let i = [];
    for (let f = 0; f < r; f++)
      i.push(new rD(this.coder));
    return tg(e, i);
  }
};
ke(mx, "ArrayCoder");
var nD = mx, gx = class extends Bi {
  constructor(e) {
    super("bool", "bool", e, !1);
  }
  defaultValue() {
    return !1;
  }
  encode(e, r) {
    const i = nn.dereference(r, "bool");
    return e.writeValue(i ? 1 : 0);
  }
  decode(e) {
    return !!e.readValue();
  }
};
ke(gx, "BooleanCoder");
var iD = gx, yx = class extends Bi {
  constructor(e, r) {
    super(e, e, r, !0);
  }
  defaultValue() {
    return "0x";
  }
  encode(e, r) {
    r = Nn(r);
    let i = e.writeValue(r.length);
    return i += e.writeBytes(r), i;
  }
  decode(e) {
    return e.readBytes(e.readIndex(), !0);
  }
};
ke(yx, "DynamicBytesCoder");
var bx = yx, wx = class extends bx {
  constructor(e) {
    super("bytes", e);
  }
  decode(e) {
    return mr(super.decode(e));
  }
};
ke(wx, "BytesCoder");
var aD = wx, _x = class extends Bi {
  constructor(e, r) {
    let i = "bytes" + String(e);
    super(i, i, r, !1), Ge(this, "size"), $t(this, {
      size: e
    }, {
      size: "number"
    });
  }
  defaultValue() {
    return "0x0000000000000000000000000000000000000000000000000000000000000000".substring(0, 2 + this.size * 2);
  }
  encode(e, r) {
    let i = Nn(nn.dereference(r, this.type));
    return i.length !== this.size && this._throwError("incorrect data length", r), e.writeBytes(i);
  }
  decode(e) {
    return mr(e.readBytes(this.size));
  }
};
ke(_x, "FixedBytesCoder");
var sD = _x, oD = new Uint8Array([]), xx = class extends Bi {
  constructor(e) {
    super("null", "", e, !1);
  }
  defaultValue() {
    return null;
  }
  encode(e, r) {
    return r != null && this._throwError("not null", r), e.writeBytes(oD);
  }
  decode(e) {
    return e.readBytes(0), null;
  }
};
ke(xx, "NullCoder");
var fD = xx, uD = BigInt(0), lD = BigInt(1), cD = BigInt("0xffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffffff"), Mx = class extends Bi {
  constructor(e, r, i) {
    const f = (r ? "int" : "uint") + e * 8;
    super(f, f, i, !1), Ge(this, "size"), Ge(this, "signed"), $t(this, {
      size: e,
      signed: r
    }, {
      size: "number",
      signed: "boolean"
    });
  }
  defaultValue() {
    return 0;
  }
  encode(e, r) {
    let i = li(nn.dereference(r, this.type)), f = ff(cD, Kr * 8);
    if (this.signed) {
      let a = ff(f, this.size * 8 - 1);
      (i > a || i < -(a + lD)) && this._throwError("value out-of-bounds", r), i = R9(i, 8 * Kr);
    } else
      (i < uD || i > ff(f, this.size * 8)) && this._throwError("value out-of-bounds", r);
    return e.writeValue(i);
  }
  decode(e) {
    let r = ff(e.readValue(), this.size * 8);
    return this.signed && (r = I9(r, this.size * 8)), r;
  }
};
ke(Mx, "NumberCoder");
var dD = Mx, Sx = class extends bx {
  constructor(e) {
    super("string", e);
  }
  defaultValue() {
    return "";
  }
  encode(e, r) {
    return super.encode(e, Gm(nn.dereference(r, "string")));
  }
  decode(e) {
    return q9(super.decode(e));
  }
};
ke(Sx, "StringCoder");
var hD = Sx, Ex = class extends Bi {
  constructor(e, r) {
    let i = !1;
    const f = [];
    e.forEach((l) => {
      l.dynamic && (i = !0), f.push(l.type);
    });
    const a = "tuple(" + f.join(",") + ")";
    super("tuple", a, r, i), Ge(this, "coders"), $t(this, {
      coders: Object.freeze(e.slice())
    });
  }
  defaultValue() {
    const e = [];
    this.coders.forEach((i) => {
      e.push(i.defaultValue());
    });
    const r = this.coders.reduce((i, f) => {
      const a = f.localName;
      return a && (i[a] || (i[a] = 0), i[a]++), i;
    }, {});
    return this.coders.forEach((i, f) => {
      let a = i.localName;
      !a || r[a] !== 1 || (a === "length" && (a = "_length"), e[a] == null && (e[a] = e[f]));
    }), Object.freeze(e);
  }
  encode(e, r) {
    const i = nn.dereference(r, "tuple");
    return eg(e, this.coders, i);
  }
  decode(e) {
    return tg(e, this.coders);
  }
};
ke(Ex, "TupleCoder");
var nl = Ex;
function to(t) {
  return si(Gm(t));
}
ke(to, "id");
function il(t, e) {
  return {
    address: oi(t),
    storageKeys: e.map((r, i) => (Mt(ai(r, 32), "invalid slot", `storageKeys[${i}]`, r), r.toLowerCase()))
  };
}
ke(il, "accessSetify");
function Ax(t) {
  if (Array.isArray(t))
    return t.map((r, i) => Array.isArray(r) ? (Mt(r.length === 2, "invalid slot set", `value[${i}]`, r), il(r[0], r[1])) : (Mt(r != null && typeof r == "object", "invalid address-slot set", "value", t), il(r.address, r.storageKeys)));
  Mt(t != null && typeof t == "object", "invalid access list", "value", t);
  const e = Object.keys(t).map((r) => {
    const i = t[r].reduce((f, a) => (f[a] = !0, f), {});
    return il(r, Object.keys(i).sort());
  });
  return e.sort((r, i) => r.address.localeCompare(i.address)), e;
}
ke(Ax, "accessListify");
function qr(t) {
  const e = /* @__PURE__ */ new Set();
  return t.forEach((r) => e.add(r)), Object.freeze(e);
}
ke(qr, "setify");
var pD = "external public payable override", vD = qr(pD.split(" ")), kx = "constant external internal payable private public pure view override", mD = qr(kx.split(" ")), Tx = "constructor error event fallback function receive struct", Cx = qr(Tx.split(" ")), Bx = "calldata memory storage payable indexed", gD = qr(Bx.split(" ")), yD = "tuple returns", bD = [
  Tx,
  Bx,
  yD,
  kx
].join(" "), wD = qr(bD.split(" ")), _D = {
  "(": "OPEN_PAREN",
  ")": "CLOSE_PAREN",
  "[": "OPEN_BRACKET",
  "]": "CLOSE_BRACKET",
  ",": "COMMA",
  "@": "AT"
}, xD = new RegExp("^(\\s*)"), MD = new RegExp("^([0-9]+)"), SD = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)"), Ix = new RegExp("^([a-zA-Z$_][a-zA-Z0-9$_]*)$"), Rx = new RegExp("^(address|bool|bytes([0-9]*)|string|u?int([0-9]*))$"), Lr, Hn, Iu, Qp, jo, Ii = (jo = class {
  constructor(t) {
    sr(this, Iu), sr(this, Lr), sr(this, Hn), Xt(this, Lr, 0), Xt(this, Hn, t.slice());
  }
  get offset() {
    return vt(this, Lr);
  }
  get length() {
    return vt(this, Hn).length - vt(this, Lr);
  }
  clone() {
    return new jo(vt(this, Hn));
  }
  reset() {
    Xt(this, Lr, 0);
  }
  // Pops and returns the value of the next token, if it is a keyword in allowed; throws if out of tokens
  popKeyword(t) {
    const e = this.peek();
    if (e.type !== "KEYWORD" || !t.has(e.text))
      throw new Error(`expected keyword ${e.text}`);
    return this.pop().text;
  }
  // Pops and returns the value of the next token if it is `type`; throws if out of tokens
  popType(t) {
    if (this.peek().type !== t) {
      const e = this.peek();
      throw new Error(`expected ${t}; got ${e.type} ${JSON.stringify(e.text)}`);
    }
    return this.pop().text;
  }
  // Pops and returns a "(" TOKENS ")"
  popParen() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const e = gr(this, Iu, Qp).call(this, vt(this, Lr) + 1, t.match + 1);
    return Xt(this, Lr, t.match + 1), e;
  }
  // Pops and returns the items within "(" ITEM1 "," ITEM2 "," ... ")"
  popParams() {
    const t = this.peek();
    if (t.type !== "OPEN_PAREN")
      throw new Error("bad start");
    const e = [];
    for (; vt(this, Lr) < t.match - 1; ) {
      const r = this.peek().linkNext;
      e.push(gr(this, Iu, Qp).call(this, vt(this, Lr) + 1, r)), Xt(this, Lr, r);
    }
    return Xt(this, Lr, t.match + 1), e;
  }
  // Returns the top Token, throwing if out of tokens
  peek() {
    if (vt(this, Lr) >= vt(this, Hn).length)
      throw new Error("out-of-bounds");
    return vt(this, Hn)[vt(this, Lr)];
  }
  // Returns the next value, if it is a keyword in `allowed`
  peekKeyword(t) {
    const e = this.peekType("KEYWORD");
    return e != null && t.has(e) ? e : null;
  }
  // Returns the value of the next token if it is `type`
  peekType(t) {
    if (this.length === 0)
      return null;
    const e = this.peek();
    return e.type === t ? e.text : null;
  }
  // Returns the next token; throws if out of tokens
  pop() {
    const t = this.peek();
    return EN(this, Lr)._++, t;
  }
  toString() {
    const t = [];
    for (let e = vt(this, Lr); e < vt(this, Hn).length; e++) {
      const r = vt(this, Hn)[e];
      t.push(`${r.type}:${r.text}`);
    }
    return `<TokenString ${t.join(" ")}>`;
  }
}, Lr = /* @__PURE__ */ new WeakMap(), Hn = /* @__PURE__ */ new WeakMap(), Iu = /* @__PURE__ */ new WeakSet(), Qp = /* @__PURE__ */ ke(function(t = 0, e = 0) {
  return new jo(vt(this, Hn).slice(t, e).map((r) => Object.freeze(Object.assign({}, r, {
    match: r.match - t,
    linkBack: r.linkBack - t,
    linkNext: r.linkNext - t
  }))));
}, "#subTokenString"), ke(jo, "TokenString"), jo);
function Ri(t) {
  const e = [], r = /* @__PURE__ */ ke((l) => {
    const d = a < t.length ? JSON.stringify(t[a]) : "$EOI";
    throw new Error(`invalid token ${d} at ${a}: ${l}`);
  }, "throwError");
  let i = [], f = [], a = 0;
  for (; a < t.length; ) {
    let l = t.substring(a), d = l.match(xD);
    d && (a += d[1].length, l = t.substring(a));
    const v = {
      depth: i.length,
      linkBack: -1,
      linkNext: -1,
      match: -1,
      type: "",
      text: "",
      offset: a,
      value: -1
    };
    e.push(v);
    let m = _D[l[0]] || "";
    if (m) {
      if (v.type = m, v.text = l[0], a++, m === "OPEN_PAREN")
        i.push(e.length - 1), f.push(e.length - 1);
      else if (m == "CLOSE_PAREN")
        i.length === 0 && r("no matching open bracket"), v.match = i.pop(), e[v.match].match = e.length - 1, v.depth--, v.linkBack = f.pop(), e[v.linkBack].linkNext = e.length - 1;
      else if (m === "COMMA")
        v.linkBack = f.pop(), e[v.linkBack].linkNext = e.length - 1, f.push(e.length - 1);
      else if (m === "OPEN_BRACKET")
        v.type = "BRACKET";
      else if (m === "CLOSE_BRACKET") {
        let h = e.pop().text;
        if (e.length > 0 && e[e.length - 1].type === "NUMBER") {
          const w = e.pop().text;
          h = w + h, e[e.length - 1].value = ci(w);
        }
        if (e.length === 0 || e[e.length - 1].type !== "BRACKET")
          throw new Error("missing opening bracket");
        e[e.length - 1].text += h;
      }
      continue;
    }
    if (d = l.match(SD), d) {
      if (v.text = d[1], a += v.text.length, wD.has(v.text)) {
        v.type = "KEYWORD";
        continue;
      }
      if (v.text.match(Rx)) {
        v.type = "TYPE";
        continue;
      }
      v.type = "ID";
      continue;
    }
    if (d = l.match(MD), d) {
      v.text = d[1], v.type = "NUMBER", a += v.text.length;
      continue;
    }
    throw new Error(`unexpected token ${JSON.stringify(l[0])} at position ${a}`);
  }
  return new Ii(e.map((l) => Object.freeze(l)));
}
ke(Ri, "lex");
function ov(t, e) {
  let r = [];
  for (const i in e.keys())
    t.has(i) && r.push(i);
  if (r.length > 1)
    throw new Error(`conflicting types: ${r.join(", ")}`);
}
ke(ov, "allowSingle");
function nu(t, e) {
  if (e.peekKeyword(Cx)) {
    const r = e.pop().text;
    if (r !== t)
      throw new Error(`expected ${t}, got ${r}`);
  }
  return e.popType("ID");
}
ke(nu, "consumeName");
function fi(t, e) {
  const r = /* @__PURE__ */ new Set();
  for (; ; ) {
    const i = t.peekType("KEYWORD");
    if (i == null || e && !e.has(i))
      break;
    if (t.pop(), r.has(i))
      throw new Error(`duplicate keywords: ${JSON.stringify(i)}`);
    r.add(i);
  }
  return Object.freeze(r);
}
ke(fi, "consumeKeywords");
function rg(t) {
  let e = fi(t, mD);
  return ov(e, qr("constant payable nonpayable".split(" "))), ov(e, qr("pure view payable nonpayable".split(" "))), e.has("view") ? "view" : e.has("pure") ? "pure" : e.has("payable") ? "payable" : e.has("nonpayable") ? "nonpayable" : e.has("constant") ? "view" : "nonpayable";
}
ke(rg, "consumeMutability");
function Jn(t, e) {
  return t.popParams().map((r) => Zr.from(r, e));
}
ke(Jn, "consumeParams");
function ng(t) {
  if (t.peekType("AT")) {
    if (t.pop(), t.peekType("NUMBER"))
      return li(t.pop().text);
    throw new Error("invalid gas");
  }
  return null;
}
ke(ng, "consumeGas");
function da(t) {
  if (t.length)
    throw new Error(`unexpected tokens at offset ${t.offset}: ${t.toString()}`);
}
ke(da, "consumeEoi");
var ED = new RegExp(/^(.*)\[([0-9]*)\]$/);
function fv(t) {
  const e = t.match(Rx);
  if (Mt(e, "invalid type", "type", t), t === "uint")
    return "uint256";
  if (t === "int")
    return "int256";
  if (e[2]) {
    const r = parseInt(e[2]);
    Mt(r !== 0 && r <= 32, "invalid bytes length", "type", t);
  } else if (e[3]) {
    const r = parseInt(e[3]);
    Mt(r !== 0 && r <= 256 && r % 8 === 0, "invalid numeric width", "type", t);
  }
  return t;
}
ke(fv, "verifyBasicType");
var dr = {}, an = Symbol.for("_ethers_internal"), Cw = "_ParamTypeInternal", Bw = "_ErrorInternal", Iw = "_EventInternal", Rw = "_ConstructorInternal", Pw = "_FallbackInternal", Ow = "_FunctionInternal", Nw = "_StructInternal", Pf, al, Px = class Bn {
  /**
   *  @private
   */
  constructor(e, r, i, f, a, l, d, v) {
    if (sr(this, Pf), Ge(this, "name"), Ge(this, "type"), Ge(this, "baseType"), Ge(this, "indexed"), Ge(this, "components"), Ge(this, "arrayLength"), Ge(this, "arrayChildren"), Oc(e, dr, "ParamType"), Object.defineProperty(this, an, {
      value: Cw
    }), l && (l = Object.freeze(l.slice())), f === "array") {
      if (d == null || v == null)
        throw new Error("");
    } else if (d != null || v != null)
      throw new Error("");
    if (f === "tuple") {
      if (l == null)
        throw new Error("");
    } else if (l != null)
      throw new Error("");
    $t(this, {
      name: r,
      type: i,
      baseType: f,
      indexed: a,
      components: l,
      arrayLength: d,
      arrayChildren: v
    });
  }
  /**
   *  Return a string representation of this type.
   *
   *  For example,
   *
   *  ``sighash" => "(uint256,address)"``
   *
   *  ``"minimal" => "tuple(uint256,address) indexed"``
   *
   *  ``"full" => "tuple(uint256 foo, address bar) indexed baz"``
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json") {
      const i = this.name || "";
      if (this.isArray()) {
        const a = JSON.parse(this.arrayChildren.format("json"));
        return a.name = i, a.type += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`, JSON.stringify(a);
      }
      const f = {
        type: this.baseType === "tuple" ? "tuple" : this.type,
        name: i
      };
      return typeof this.indexed == "boolean" && (f.indexed = this.indexed), this.isTuple() && (f.components = this.components.map((a) => JSON.parse(a.format(e)))), JSON.stringify(f);
    }
    let r = "";
    return this.isArray() ? (r += this.arrayChildren.format(e), r += `[${this.arrayLength < 0 ? "" : String(this.arrayLength)}]`) : this.isTuple() ? r += "(" + this.components.map((i) => i.format(e)).join(e === "full" ? ", " : ",") + ")" : r += this.type, e !== "sighash" && (this.indexed === !0 && (r += " indexed"), e === "full" && this.name && (r += " " + this.name)), r;
  }
  /**
   *  Returns true if %%this%% is an Array type.
   *
   *  This provides a type gaurd ensuring that [[arrayChildren]]
   *  and [[arrayLength]] are non-null.
   */
  isArray() {
    return this.baseType === "array";
  }
  /**
   *  Returns true if %%this%% is a Tuple type.
   *
   *  This provides a type gaurd ensuring that [[components]]
   *  is non-null.
   */
  isTuple() {
    return this.baseType === "tuple";
  }
  /**
   *  Returns true if %%this%% is an Indexable type.
   *
   *  This provides a type gaurd ensuring that [[indexed]]
   *  is non-null.
   */
  isIndexable() {
    return this.indexed != null;
  }
  /**
   *  Walks the **ParamType** with %%value%%, calling %%process%%
   *  on each type, destructing the %%value%% recursively.
   */
  walk(e, r) {
    if (this.isArray()) {
      if (!Array.isArray(e))
        throw new Error("invalid array value");
      if (this.arrayLength !== -1 && e.length !== this.arrayLength)
        throw new Error("array is wrong length");
      const i = this;
      return e.map((f) => i.arrayChildren.walk(f, r));
    }
    if (this.isTuple()) {
      if (!Array.isArray(e))
        throw new Error("invalid tuple value");
      if (e.length !== this.components.length)
        throw new Error("array is wrong length");
      const i = this;
      return e.map((f, a) => i.components[a].walk(f, r));
    }
    return r(this.type, e);
  }
  /**
   *  Walks the **ParamType** with %%value%%, asynchronously calling
   *  %%process%% on each type, destructing the %%value%% recursively.
   *
   *  This can be used to resolve ENS names by walking and resolving each
   *  ``"address"`` type.
   */
  async walkAsync(e, r) {
    const i = [], f = [
      e
    ];
    return gr(this, Pf, al).call(this, i, e, r, (a) => {
      f[0] = a;
    }), i.length && await Promise.all(i), f[0];
  }
  /**
   *  Creates a new **ParamType** for %%obj%%.
   *
   *  If %%allowIndexed%% then the ``indexed`` keyword is permitted,
   *  otherwise the ``indexed`` keyword will throw an error.
   */
  static from(e, r) {
    if (Bn.isParamType(e))
      return e;
    if (typeof e == "string")
      try {
        return Bn.from(Ri(e), r);
      } catch {
        Mt(!1, "invalid param type", "obj", e);
      }
    else if (e instanceof Ii) {
      let d = "", v = "", m = null;
      fi(e, qr([
        "tuple"
      ])).has("tuple") || e.peekType("OPEN_PAREN") ? (v = "tuple", m = e.popParams().map((A) => Bn.from(A)), d = `tuple(${m.map((A) => A.format()).join(",")})`) : (d = fv(e.popType("TYPE")), v = d);
      let h = null, w = null;
      for (; e.length && e.peekType("BRACKET"); ) {
        const A = e.pop();
        h = new Bn(dr, "", d, v, null, m, w, h), w = A.value, d += A.text, v = "array", m = null;
      }
      let M = null;
      if (fi(e, gD).has("indexed")) {
        if (!r)
          throw new Error("");
        M = !0;
      }
      const E = e.peekType("ID") ? e.pop().text : "";
      if (e.length)
        throw new Error("leftover tokens");
      return new Bn(dr, E, d, v, M, m, w, h);
    }
    const i = e.name;
    Mt(!i || typeof i == "string" && i.match(Ix), "invalid name", "obj.name", i);
    let f = e.indexed;
    f != null && (Mt(r, "parameter cannot be indexed", "obj.indexed", e.indexed), f = !!f);
    let a = e.type, l = a.match(ED);
    if (l) {
      const d = parseInt(l[2] || "-1"), v = Bn.from({
        type: l[1],
        components: e.components
      });
      return new Bn(dr, i || "", a, "array", f, null, d, v);
    }
    if (a === "tuple" || a.startsWith(
      "tuple("
      /* fix: ) */
    ) || a.startsWith(
      "("
      /* fix: ) */
    )) {
      const d = e.components != null ? e.components.map((m) => Bn.from(m)) : null;
      return new Bn(dr, i || "", a, "tuple", f, d, null, null);
    }
    return a = fv(e.type), new Bn(dr, i || "", a, a, f, null, null, null);
  }
  /**
   *  Returns true if %%value%% is a **ParamType**.
   */
  static isParamType(e) {
    return e && e[an] === Cw;
  }
};
Pf = /* @__PURE__ */ new WeakSet();
al = /* @__PURE__ */ ke(function(t, e, r, i) {
  if (this.isArray()) {
    if (!Array.isArray(e))
      throw new Error("invalid array value");
    if (this.arrayLength !== -1 && e.length !== this.arrayLength)
      throw new Error("array is wrong length");
    const a = this.arrayChildren, l = e.slice();
    l.forEach((d, v) => {
      var m;
      gr(m = a, Pf, al).call(m, t, d, r, (h) => {
        l[v] = h;
      });
    }), i(l);
    return;
  }
  if (this.isTuple()) {
    const a = this.components;
    let l;
    if (Array.isArray(e))
      l = e.slice();
    else {
      if (e == null || typeof e != "object")
        throw new Error("invalid tuple value");
      l = a.map((d) => {
        if (!d.name)
          throw new Error("cannot use object value with unnamed components");
        if (!(d.name in e))
          throw new Error(`missing value for component ${d.name}`);
        return e[d.name];
      });
    }
    if (l.length !== this.components.length)
      throw new Error("array is wrong length");
    l.forEach((d, v) => {
      var m;
      gr(m = a[v], Pf, al).call(m, t, d, r, (h) => {
        l[v] = h;
      });
    }), i(l);
    return;
  }
  const f = r(this.type, e);
  f.then ? t.push(async function() {
    i(await f);
  }()) : i(f);
}, "#walkAsync");
ke(Px, "ParamType");
var Zr = Px, Ox = class uv {
  /**
   *  @private
   */
  constructor(e, r, i) {
    Ge(this, "type"), Ge(this, "inputs"), Oc(e, dr, "Fragment"), i = Object.freeze(i.slice()), $t(this, {
      type: r,
      inputs: i
    });
  }
  /**
   *  Creates a new **Fragment** for %%obj%%, wich can be any supported
   *  ABI frgament type.
   */
  static from(e) {
    if (typeof e == "string") {
      try {
        uv.from(JSON.parse(e));
      } catch {
      }
      return uv.from(Ri(e));
    }
    if (e instanceof Ii)
      switch (e.peekKeyword(Cx)) {
        case "constructor":
          return ol.from(e);
        case "error":
          return yi.from(e);
        case "event":
          return sl.from(e);
        case "fallback":
        case "receive":
          return Dw.from(e);
        case "function":
          return fl.from(e);
        case "struct":
          return Yp.from(e);
      }
    else if (typeof e == "object") {
      switch (e.type) {
        case "constructor":
          return ol.from(e);
        case "error":
          return yi.from(e);
        case "event":
          return sl.from(e);
        case "fallback":
        case "receive":
          return Dw.from(e);
        case "function":
          return fl.from(e);
        case "struct":
          return Yp.from(e);
      }
      Ut(!1, `unsupported type: ${e.type}`, "UNSUPPORTED_OPERATION", {
        operation: "Fragment.from"
      });
    }
    Mt(!1, "unsupported frgament object", "obj", e);
  }
  /**
   *  Returns true if %%value%% is a [[ConstructorFragment]].
   */
  static isConstructor(e) {
    return ol.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is an [[ErrorFragment]].
   */
  static isError(e) {
    return yi.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is an [[EventFragment]].
   */
  static isEvent(e) {
    return sl.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is a [[FunctionFragment]].
   */
  static isFunction(e) {
    return fl.isFragment(e);
  }
  /**
   *  Returns true if %%value%% is a [[StructFragment]].
   */
  static isStruct(e) {
    return Yp.isFragment(e);
  }
};
ke(Ox, "Fragment");
var Uc = Ox, Nx = class extends Uc {
  /**
   *  @private
   */
  constructor(e, r, i, f) {
    super(e, r, f), Ge(this, "name"), Mt(typeof i == "string" && i.match(Ix), "invalid identifier", "name", i), f = Object.freeze(f.slice()), $t(this, {
      name: i
    });
  }
};
ke(Nx, "NamedFragment");
var Lc = Nx;
function ro(t, e) {
  return "(" + e.map((r) => r.format(t)).join(t === "full" ? ", " : ",") + ")";
}
ke(ro, "joinParams");
var Dx = class hf extends Lc {
  /**
   *  @private
   */
  constructor(e, r, i) {
    super(e, "error", r, i), Object.defineProperty(this, an, {
      value: Bw
    });
  }
  /**
   *  The Custom Error selector.
   */
  get selector() {
    return to(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this fragment as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "error",
        name: this.name,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [];
    return e !== "sighash" && r.push("error"), r.push(this.name + ro(e, this.inputs)), r.join(" ");
  }
  /**
   *  Returns a new **ErrorFragment** for %%obj%%.
   */
  static from(e) {
    if (hf.isFragment(e))
      return e;
    if (typeof e == "string")
      return hf.from(Ri(e));
    if (e instanceof Ii) {
      const r = nu("error", e), i = Jn(e);
      return da(e), new hf(dr, r, i);
    }
    return new hf(dr, e.name, e.inputs ? e.inputs.map(Zr.from) : []);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **ErrorFragment**.
   */
  static isFragment(e) {
    return e && e[an] === Bw;
  }
};
ke(Dx, "ErrorFragment");
var yi = Dx, Ux = class ks extends Lc {
  /**
   *  @private
   */
  constructor(e, r, i, f) {
    super(e, "event", r, i), Ge(this, "anonymous"), Object.defineProperty(this, an, {
      value: Iw
    }), $t(this, {
      anonymous: f
    });
  }
  /**
   *  The Event topic hash.
   */
  get topicHash() {
    return to(this.format("sighash"));
  }
  /**
   *  Returns a string representation of this event as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "event",
        anonymous: this.anonymous,
        name: this.name,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [];
    return e !== "sighash" && r.push("event"), r.push(this.name + ro(e, this.inputs)), e !== "sighash" && this.anonymous && r.push("anonymous"), r.join(" ");
  }
  /**
   *  Return the topic hash for an event with %%name%% and %%params%%.
   */
  static getTopicHash(e, r) {
    return r = (r || []).map((f) => Zr.from(f)), new ks(dr, e, r, !1).topicHash;
  }
  /**
   *  Returns a new **EventFragment** for %%obj%%.
   */
  static from(e) {
    if (ks.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return ks.from(Ri(e));
      } catch {
        Mt(!1, "invalid event fragment", "obj", e);
      }
    else if (e instanceof Ii) {
      const r = nu("event", e), i = Jn(e, !0), f = !!fi(e, qr([
        "anonymous"
      ])).has("anonymous");
      return da(e), new ks(dr, r, i, f);
    }
    return new ks(dr, e.name, e.inputs ? e.inputs.map((r) => Zr.from(r, !0)) : [], !!e.anonymous);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is an
   *  **EventFragment**.
   */
  static isFragment(e) {
    return e && e[an] === Iw;
  }
};
ke(Ux, "EventFragment");
var sl = Ux, Lx = class pf extends Uc {
  /**
   *  @private
   */
  constructor(e, r, i, f, a) {
    super(e, r, i), Ge(this, "payable"), Ge(this, "gas"), Object.defineProperty(this, an, {
      value: Rw
    }), $t(this, {
      payable: f,
      gas: a
    });
  }
  /**
   *  Returns a string representation of this constructor as %%format%%.
   */
  format(e) {
    if (Ut(e != null && e !== "sighash", "cannot format a constructor for sighash", "UNSUPPORTED_OPERATION", {
      operation: "format(sighash)"
    }), e === "json")
      return JSON.stringify({
        type: "constructor",
        stateMutability: this.payable ? "payable" : "undefined",
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [
      `constructor${ro(e, this.inputs)}`
    ];
    return this.payable && r.push("payable"), this.gas != null && r.push(`@${this.gas.toString()}`), r.join(" ");
  }
  /**
   *  Returns a new **ConstructorFragment** for %%obj%%.
   */
  static from(e) {
    if (pf.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return pf.from(Ri(e));
      } catch {
        Mt(!1, "invalid constuctor fragment", "obj", e);
      }
    else if (e instanceof Ii) {
      fi(e, qr([
        "constructor"
      ]));
      const r = Jn(e), i = !!fi(e, vD).has("payable"), f = ng(e);
      return da(e), new pf(dr, "constructor", r, i, f);
    }
    return new pf(dr, "constructor", e.inputs ? e.inputs.map(Zr.from) : [], !!e.payable, e.gas != null ? e.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **ConstructorFragment**.
   */
  static isFragment(e) {
    return e && e[an] === Rw;
  }
};
ke(Lx, "ConstructorFragment");
var ol = Lx, Fx = class Ta extends Uc {
  constructor(e, r, i) {
    super(e, "fallback", r), Ge(this, "payable"), Object.defineProperty(this, an, {
      value: Pw
    }), $t(this, {
      payable: i
    });
  }
  /**
   *  Returns a string representation of this fallback as %%format%%.
   */
  format(e) {
    const r = this.inputs.length === 0 ? "receive" : "fallback";
    if (e === "json") {
      const i = this.payable ? "payable" : "nonpayable";
      return JSON.stringify({
        type: r,
        stateMutability: i
      });
    }
    return `${r}()${this.payable ? " payable" : ""}`;
  }
  /**
   *  Returns a new **FallbackFragment** for %%obj%%.
   */
  static from(e) {
    if (Ta.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return Ta.from(Ri(e));
      } catch {
        Mt(!1, "invalid fallback fragment", "obj", e);
      }
    else if (e instanceof Ii) {
      const r = e.toString(), i = e.peekKeyword(qr([
        "fallback",
        "receive"
      ]));
      if (Mt(i, "type must be fallback or receive", "obj", r), e.popKeyword(qr([
        "fallback",
        "receive"
      ])) === "receive") {
        const d = Jn(e);
        return Mt(d.length === 0, "receive cannot have arguments", "obj.inputs", d), fi(e, qr([
          "payable"
        ])), da(e), new Ta(dr, [], !0);
      }
      let a = Jn(e);
      a.length ? Mt(a.length === 1 && a[0].type === "bytes", "invalid fallback inputs", "obj.inputs", a.map((d) => d.format("minimal")).join(", ")) : a = [
        Zr.from("bytes")
      ];
      const l = rg(e);
      if (Mt(l === "nonpayable" || l === "payable", "fallback cannot be constants", "obj.stateMutability", l), fi(e, qr([
        "returns"
      ])).has("returns")) {
        const d = Jn(e);
        Mt(d.length === 1 && d[0].type === "bytes", "invalid fallback outputs", "obj.outputs", d.map((v) => v.format("minimal")).join(", "));
      }
      return da(e), new Ta(dr, a, l === "payable");
    }
    if (e.type === "receive")
      return new Ta(dr, [], !0);
    if (e.type === "fallback") {
      const r = [
        Zr.from("bytes")
      ], i = e.stateMutability === "payable";
      return new Ta(dr, r, i);
    }
    Mt(!1, "invalid fallback description", "obj", e);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FallbackFragment**.
   */
  static isFragment(e) {
    return e && e[an] === Pw;
  }
};
ke(Fx, "FallbackFragment");
var Dw = Fx, qx = class Ts extends Lc {
  /**
   *  @private
   */
  constructor(e, r, i, f, a, l) {
    super(e, "function", r, f), Ge(this, "constant"), Ge(this, "outputs"), Ge(this, "stateMutability"), Ge(this, "payable"), Ge(this, "gas"), Object.defineProperty(this, an, {
      value: Ow
    }), a = Object.freeze(a.slice()), $t(this, {
      constant: i === "view" || i === "pure",
      gas: l,
      outputs: a,
      payable: i === "payable",
      stateMutability: i
    });
  }
  /**
   *  The Function selector.
   */
  get selector() {
    return to(this.format("sighash")).substring(0, 10);
  }
  /**
   *  Returns a string representation of this function as %%format%%.
   */
  format(e) {
    if (e == null && (e = "sighash"), e === "json")
      return JSON.stringify({
        type: "function",
        name: this.name,
        constant: this.constant,
        stateMutability: this.stateMutability !== "nonpayable" ? this.stateMutability : void 0,
        payable: this.payable,
        gas: this.gas != null ? this.gas : void 0,
        inputs: this.inputs.map((i) => JSON.parse(i.format(e))),
        outputs: this.outputs.map((i) => JSON.parse(i.format(e)))
      });
    const r = [];
    return e !== "sighash" && r.push("function"), r.push(this.name + ro(e, this.inputs)), e !== "sighash" && (this.stateMutability !== "nonpayable" && r.push(this.stateMutability), this.outputs && this.outputs.length && (r.push("returns"), r.push(ro(e, this.outputs))), this.gas != null && r.push(`@${this.gas.toString()}`)), r.join(" ");
  }
  /**
   *  Return the selector for a function with %%name%% and %%params%%.
   */
  static getSelector(e, r) {
    return r = (r || []).map((f) => Zr.from(f)), new Ts(dr, e, "view", r, [], null).selector;
  }
  /**
   *  Returns a new **FunctionFragment** for %%obj%%.
   */
  static from(e) {
    if (Ts.isFragment(e))
      return e;
    if (typeof e == "string")
      try {
        return Ts.from(Ri(e));
      } catch {
        Mt(!1, "invalid function fragment", "obj", e);
      }
    else if (e instanceof Ii) {
      const i = nu("function", e), f = Jn(e), a = rg(e);
      let l = [];
      fi(e, qr([
        "returns"
      ])).has("returns") && (l = Jn(e));
      const d = ng(e);
      return da(e), new Ts(dr, i, a, f, l, d);
    }
    let r = e.stateMutability;
    return r == null && (r = "payable", typeof e.constant == "boolean" ? (r = "view", e.constant || (r = "payable", typeof e.payable == "boolean" && !e.payable && (r = "nonpayable"))) : typeof e.payable == "boolean" && !e.payable && (r = "nonpayable")), new Ts(dr, e.name, r, e.inputs ? e.inputs.map(Zr.from) : [], e.outputs ? e.outputs.map(Zr.from) : [], e.gas != null ? e.gas : null);
  }
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **FunctionFragment**.
   */
  static isFragment(e) {
    return e && e[an] === Ow;
  }
};
ke(qx, "FunctionFragment");
var fl = qx, zx = class ul extends Lc {
  /**
   *  @private
   */
  constructor(e, r, i) {
    super(e, "struct", r, i), Object.defineProperty(this, an, {
      value: Nw
    });
  }
  /**
   *  Returns a string representation of this struct as %%format%%.
   */
  format() {
    throw new Error("@TODO");
  }
  /**
   *  Returns a new **StructFragment** for %%obj%%.
   */
  static from(e) {
    if (typeof e == "string")
      try {
        return ul.from(Ri(e));
      } catch {
        Mt(!1, "invalid struct fragment", "obj", e);
      }
    else if (e instanceof Ii) {
      const r = nu("struct", e), i = Jn(e);
      return da(e), new ul(dr, r, i);
    }
    return new ul(dr, e.name, e.inputs ? e.inputs.map(Zr.from) : []);
  }
  // @TODO: fix this return type
  /**
   *  Returns ``true`` and provides a type guard if %%value%% is a
   *  **StructFragment**.
   */
  static isFragment(e) {
    return e && e[an] === Nw;
  }
};
ke(zx, "StructFragment");
var Yp = zx, zn = /* @__PURE__ */ new Map();
zn.set(0, "GENERIC_PANIC");
zn.set(1, "ASSERT_FALSE");
zn.set(17, "OVERFLOW");
zn.set(18, "DIVIDE_BY_ZERO");
zn.set(33, "ENUM_RANGE_ERROR");
zn.set(34, "BAD_STORAGE_DATA");
zn.set(49, "STACK_UNDERFLOW");
zn.set(50, "ARRAY_RANGE_ERROR");
zn.set(65, "OUT_OF_MEMORY");
zn.set(81, "UNINITIALIZED_FUNCTION_CALL");
var AD = new RegExp(/^bytes([0-9]*)$/), kD = new RegExp(/^(u?int)([0-9]*)$/), Jp = null, Uw = 1024;
function jx(t, e, r, i) {
  let f = "missing revert data", a = null;
  const l = null;
  let d = null;
  if (r) {
    f = "execution reverted";
    const m = vn(r);
    if (r = mr(r), m.length === 0)
      f += " (no data present; likely require(false) occurred", a = "require(false)";
    else if (m.length % 32 !== 4)
      f += " (could not decode reason; invalid data length)";
    else if (mr(m.slice(0, 4)) === "0x08c379a0")
      try {
        a = i.decode([
          "string"
        ], m.slice(4))[0], d = {
          signature: "Error(string)",
          name: "Error",
          args: [
            a
          ]
        }, f += `: ${JSON.stringify(a)}`;
      } catch {
        f += " (could not decode reason; invalid string data)";
      }
    else if (mr(m.slice(0, 4)) === "0x4e487b71")
      try {
        const h = Number(i.decode([
          "uint256"
        ], m.slice(4))[0]);
        d = {
          signature: "Panic(uint256)",
          name: "Panic",
          args: [
            h
          ]
        }, a = `Panic due to ${zn.get(h) || "UNKNOWN"}(${h})`, f += `: ${a}`;
      } catch {
        f += " (could not decode panic code)";
      }
    else
      f += " (unknown custom error)";
  }
  const v = {
    to: e.to ? oi(e.to) : null,
    data: e.data || "0x"
  };
  return e.from && (v.from = oi(e.from)), Xs(f, "CALL_EXCEPTION", {
    action: t,
    data: r,
    reason: a,
    transaction: v,
    invocation: l,
    revert: d
  });
}
ke(jx, "getBuiltinCallException");
var Da, Vs, $x = class lv {
  constructor() {
    sr(this, Da);
  }
  /**
   *  Get the default values for the given %%types%%.
   *
   *  For example, a ``uint`` is by default ``0`` and ``bool``
   *  is by default ``false``.
   */
  getDefaultValue(e) {
    const r = e.map((f) => gr(this, Da, Vs).call(this, Zr.from(f)));
    return new nl(r, "_").defaultValue();
  }
  /**
   *  Encode the %%values%% as the %%types%% into ABI data.
   *
   *  @returns DataHexstring
   */
  encode(e, r) {
    $m(r.length, e.length, "types/values length mismatch");
    const i = e.map((l) => gr(this, Da, Vs).call(this, Zr.from(l))), f = new nl(i, "_"), a = new rv();
    return f.encode(a, r), a.data;
  }
  /**
   *  Decode the ABI %%data%% as the %%types%% into values.
   *
   *  If %%loose%% decoding is enabled, then strict padding is
   *  not enforced. Some older versions of Solidity incorrectly
   *  padded event data emitted from ``external`` functions.
   */
  decode(e, r, i) {
    const f = e.map((l) => gr(this, Da, Vs).call(this, Zr.from(l)));
    return new nl(f, "_").decode(new RN(r, i, Uw));
  }
  static _setDefaultMaxInflation(e) {
    Mt(typeof e == "number" && Number.isInteger(e), "invalid defaultMaxInflation factor", "value", e), Uw = e;
  }
  /**
   *  Returns the shared singleton instance of a default [[AbiCoder]].
   *
   *  On the first call, the instance is created internally.
   */
  static defaultAbiCoder() {
    return Jp == null && (Jp = new lv()), Jp;
  }
  /**
   *  Returns an ethers-compatible [[CallExceptionError]] Error for the given
   *  result %%data%% for the [[CallExceptionAction]] %%action%% against
   *  the Transaction %%tx%%.
   */
  static getBuiltinCallException(e, r, i) {
    return jx(e, r, i, lv.defaultAbiCoder());
  }
};
Da = /* @__PURE__ */ new WeakSet();
Vs = /* @__PURE__ */ ke(function(t) {
  if (t.isArray())
    return new nD(gr(this, Da, Vs).call(this, t.arrayChildren), t.arrayLength, t.name);
  if (t.isTuple())
    return new nl(t.components.map((r) => gr(this, Da, Vs).call(this, r)), t.name);
  switch (t.baseType) {
    case "address":
      return new tD(t.name);
    case "bool":
      return new iD(t.name);
    case "string":
      return new hD(t.name);
    case "bytes":
      return new aD(t.name);
    case "":
      return new fD(t.name);
  }
  let e = t.type.match(kD);
  if (e) {
    let r = parseInt(e[2] || "256");
    return Mt(r !== 0 && r <= 256 && r % 8 === 0, "invalid " + e[1] + " bit length", "param", t), new dD(r / 8, e[1] === "int", t.name);
  }
  if (e = t.type.match(AD), e) {
    let r = parseInt(e[1]);
    return Mt(r !== 0 && r <= 32, "invalid bytes length", "param", t), new sD(r, t.name);
  }
  Mt(!1, "invalid type", "type", t.type);
}, "#getCoder");
ke($x, "AbiCoder");
var Lw = $x, Vx = class {
  /**
   *  @_ignore:
   */
  constructor(e, r, i) {
    Ge(this, "fragment"), Ge(this, "name"), Ge(this, "signature"), Ge(this, "topic"), Ge(this, "args");
    const f = e.name, a = e.format();
    $t(this, {
      fragment: e,
      name: f,
      signature: a,
      topic: r,
      args: i
    });
  }
};
ke(Vx, "LogDescription");
var TD = Vx, Hx = class {
  /**
   *  @_ignore:
   */
  constructor(e, r, i, f) {
    Ge(this, "fragment"), Ge(this, "name"), Ge(this, "args"), Ge(this, "signature"), Ge(this, "selector"), Ge(this, "value");
    const a = e.name, l = e.format();
    $t(this, {
      fragment: e,
      name: a,
      args: i,
      signature: l,
      selector: r,
      value: f
    });
  }
};
ke(Hx, "TransactionDescription");
var CD = Hx, Wx = class {
  /**
   *  @_ignore:
   */
  constructor(e, r, i) {
    Ge(this, "fragment"), Ge(this, "name"), Ge(this, "args"), Ge(this, "signature"), Ge(this, "selector");
    const f = e.name, a = e.format();
    $t(this, {
      fragment: e,
      name: f,
      args: i,
      signature: a,
      selector: r
    });
  }
};
ke(Wx, "ErrorDescription");
var BD = Wx, Kx = class {
  /**
   *  @_ignore:
   */
  constructor(e) {
    Ge(this, "hash"), Ge(this, "_isIndexed"), $t(this, {
      hash: e,
      _isIndexed: !0
    });
  }
  /**
   *  Returns ``true`` if %%value%% is an **Indexed**.
   *
   *  This provides a Type Guard for property access.
   */
  static isIndexed(e) {
    return !!(e && e._isIndexed);
  }
};
ke(Kx, "Indexed");
var Fw = Kx, qw = {
  0: "generic panic",
  1: "assert(false)",
  17: "arithmetic overflow",
  18: "division or modulo by zero",
  33: "enum overflow",
  34: "invalid encoded storage byte array accessed",
  49: "out-of-bounds array access; popping on an empty array",
  50: "out-of-bounds access of an array or bytesN",
  65: "out of memory",
  81: "uninitialized function"
}, zw = {
  "0x08c379a0": {
    signature: "Error(string)",
    name: "Error",
    inputs: [
      "string"
    ],
    reason: /* @__PURE__ */ ke((t) => `reverted with reason string ${JSON.stringify(t)}`, "reason")
  },
  "0x4e487b71": {
    signature: "Panic(uint256)",
    name: "Panic",
    inputs: [
      "uint256"
    ],
    reason: /* @__PURE__ */ ke((t) => {
      let e = "unknown panic code";
      return t >= 0 && t <= 255 && qw[t.toString()] && (e = qw[t.toString()]), `reverted with panic code 0x${t.toString(16)} (${e})`;
    }, "reason")
  }
}, pi, bi, wi, $r, Fi, ll, cl, Zx = class Cs {
  /**
   *  Create a new Interface for the %%fragments%%.
   */
  constructor(e) {
    sr(this, Fi), Ge(this, "fragments"), Ge(this, "deploy"), Ge(this, "fallback"), Ge(this, "receive"), sr(this, pi), sr(this, bi), sr(this, wi), sr(this, $r);
    let r = [];
    typeof e == "string" ? r = JSON.parse(e) : r = e, Xt(this, wi, /* @__PURE__ */ new Map()), Xt(this, pi, /* @__PURE__ */ new Map()), Xt(this, bi, /* @__PURE__ */ new Map());
    const i = [];
    for (const l of r)
      try {
        i.push(Uc.from(l));
      } catch (d) {
        console.log(`[Warning] Invalid Fragment ${JSON.stringify(l)}:`, d.message);
      }
    $t(this, {
      fragments: Object.freeze(i)
    });
    let f = null, a = !1;
    Xt(this, $r, this.getAbiCoder()), this.fragments.forEach((l, d) => {
      let v;
      switch (l.type) {
        case "constructor":
          if (this.deploy) {
            console.log("duplicate definition - constructor");
            return;
          }
          $t(this, {
            deploy: l
          });
          return;
        case "fallback":
          l.inputs.length === 0 ? a = !0 : (Mt(!f || l.payable !== f.payable, "conflicting fallback fragments", `fragments[${d}]`, l), f = l, a = f.payable);
          return;
        case "function":
          v = vt(this, wi);
          break;
        case "event":
          v = vt(this, bi);
          break;
        case "error":
          v = vt(this, pi);
          break;
        default:
          return;
      }
      const m = l.format();
      v.has(m) || v.set(m, l);
    }), this.deploy || $t(this, {
      deploy: ol.from("constructor()")
    }), $t(this, {
      fallback: f,
      receive: a
    });
  }
  /**
   *  Returns the entire Human-Readable ABI, as an array of
   *  signatures, optionally as %%minimal%% strings, which
   *  removes parameter names and unneceesary spaces.
   */
  format(e) {
    const r = e ? "minimal" : "full";
    return this.fragments.map((f) => f.format(r));
  }
  /**
   *  Return the JSON-encoded ABI. This is the format Solidiy
   *  returns.
   */
  formatJson() {
    const e = this.fragments.map((r) => r.format("json"));
    return JSON.stringify(e.map((r) => JSON.parse(r)));
  }
  /**
   *  The ABI coder that will be used to encode and decode binary
   *  data.
   */
  getAbiCoder() {
    return Lw.defaultAbiCoder();
  }
  /**
   *  Get the function name for %%key%%, which may be a function selector,
   *  function name or function signature that belongs to the ABI.
   */
  getFunctionName(e) {
    const r = gr(this, Fi, ll).call(this, e, null, !1);
    return Mt(r, "no matching function", "key", e), r.name;
  }
  /**
   *  Returns true if %%key%% (a function selector, function name or
   *  function signature) is present in the ABI.
   *
   *  In the case of a function name, the name may be ambiguous, so
   *  accessing the [[FunctionFragment]] may require refinement.
   */
  hasFunction(e) {
    return !!gr(this, Fi, ll).call(this, e, null, !1);
  }
  /**
   *  Get the [[FunctionFragment]] for %%key%%, which may be a function
   *  selector, function name or function signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple functions match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single function in
   *  the ABI, this will throw.
   */
  getFunction(e, r) {
    return gr(this, Fi, ll).call(this, e, r || null, !0);
  }
  /**
   *  Iterate over all functions, calling %%callback%%, sorted by their name.
   */
  forEachFunction(e) {
    const r = Array.from(vt(this, wi).keys());
    r.sort((i, f) => i.localeCompare(f));
    for (let i = 0; i < r.length; i++) {
      const f = r[i];
      e(vt(this, wi).get(f), i);
    }
  }
  /**
   *  Get the event name for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   */
  getEventName(e) {
    const r = gr(this, Fi, cl).call(this, e, null, !1);
    return Mt(r, "no matching event", "key", e), r.name;
  }
  /**
   *  Returns true if %%key%% (an event topic hash, event name or
   *  event signature) is present in the ABI.
   *
   *  In the case of an event name, the name may be ambiguous, so
   *  accessing the [[EventFragment]] may require refinement.
   */
  hasEvent(e) {
    return !!gr(this, Fi, cl).call(this, e, null, !1);
  }
  /**
   *  Get the [[EventFragment]] for %%key%%, which may be a topic hash,
   *  event name or event signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple events match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single event in
   *  the ABI, this will throw.
   */
  getEvent(e, r) {
    return gr(this, Fi, cl).call(this, e, r || null, !0);
  }
  /**
   *  Iterate over all events, calling %%callback%%, sorted by their name.
   */
  forEachEvent(e) {
    const r = Array.from(vt(this, bi).keys());
    r.sort((i, f) => i.localeCompare(f));
    for (let i = 0; i < r.length; i++) {
      const f = r[i];
      e(vt(this, bi).get(f), i);
    }
  }
  /**
   *  Get the [[ErrorFragment]] for %%key%%, which may be an error
   *  selector, error name or error signature that belongs to the ABI.
   *
   *  If %%values%% is provided, it will use the Typed API to handle
   *  ambiguous cases where multiple errors match by name.
   *
   *  If the %%key%% and %%values%% do not refine to a single error in
   *  the ABI, this will throw.
   */
  getError(e, r) {
    if (ai(e)) {
      const f = e.toLowerCase();
      if (zw[f])
        return yi.from(zw[f].signature);
      for (const a of vt(this, pi).values())
        if (f === a.selector)
          return a;
      return null;
    }
    if (e.indexOf("(") === -1) {
      const f = [];
      for (const [a, l] of vt(this, pi))
        a.split(
          "("
          /* fix:) */
        )[0] === e && f.push(l);
      if (f.length === 0)
        return e === "Error" ? yi.from("error Error(string)") : e === "Panic" ? yi.from("error Panic(uint256)") : null;
      if (f.length > 1) {
        const a = f.map((l) => JSON.stringify(l.format())).join(", ");
        Mt(!1, `ambiguous error description (i.e. ${a})`, "name", e);
      }
      return f[0];
    }
    if (e = yi.from(e).format(), e === "Error(string)")
      return yi.from("error Error(string)");
    if (e === "Panic(uint256)")
      return yi.from("error Panic(uint256)");
    const i = vt(this, pi).get(e);
    return i || null;
  }
  /**
   *  Iterate over all errors, calling %%callback%%, sorted by their name.
   */
  forEachError(e) {
    const r = Array.from(vt(this, pi).keys());
    r.sort((i, f) => i.localeCompare(f));
    for (let i = 0; i < r.length; i++) {
      const f = r[i];
      e(vt(this, pi).get(f), i);
    }
  }
  // Get the 4-byte selector used by Solidity to identify a function
  /*
  getSelector(fragment: ErrorFragment | FunctionFragment): string {
      if (typeof(fragment) === "string") {
          const matches: Array<Fragment> = [ ];

          try { matches.push(this.getFunction(fragment)); } catch (error) { }
          try { matches.push(this.getError(<string>fragment)); } catch (_) { }

          if (matches.length === 0) {
              logger.throwArgumentError("unknown fragment", "key", fragment);
          } else if (matches.length > 1) {
              logger.throwArgumentError("ambiguous fragment matches function and error", "key", fragment);
          }

          fragment = matches[0];
      }

      return dataSlice(id(fragment.format()), 0, 4);
  }
      */
  // Get the 32-byte topic hash used by Solidity to identify an event
  /*
  getEventTopic(fragment: EventFragment): string {
      //if (typeof(fragment) === "string") { fragment = this.getEvent(eventFragment); }
      return id(fragment.format());
  }
  */
  _decodeParams(e, r) {
    return vt(this, $r).decode(e, r);
  }
  _encodeParams(e, r) {
    return vt(this, $r).encode(e, r);
  }
  /**
   *  Encodes a ``tx.data`` object for deploying the Contract with
   *  the %%values%% as the constructor arguments.
   */
  encodeDeploy(e) {
    return this._encodeParams(this.deploy.inputs, e || []);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified error (see [[getError]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeErrorResult(e, r) {
    if (typeof e == "string") {
      const i = this.getError(e);
      Mt(i, "unknown error", "fragment", e), e = i;
    }
    return Mt(Vi(r, 0, 4) === e.selector, `data signature does not match error ${e.name}.`, "data", r), this._decodeParams(e.inputs, Vi(r, 4));
  }
  /**
   *  Encodes the transaction revert data for a call result that
   *  reverted from the the Contract with the sepcified %%error%%
   *  (see [[getError]] for valid values for %%fragment%%) with the %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeErrorResult(e, r) {
    if (typeof e == "string") {
      const i = this.getError(e);
      Mt(i, "unknown error", "fragment", e), e = i;
    }
    return ia([
      e.selector,
      this._encodeParams(e.inputs, r || [])
    ]);
  }
  /**
   *  Decodes the %%data%% from a transaction ``tx.data`` for
   *  the function specified (see [[getFunction]] for valid values
   *  for %%fragment%%).
   *
   *  Most developers should prefer the [[parseTransaction]] method
   *  instead, which will automatically detect the fragment.
   */
  decodeFunctionData(e, r) {
    if (typeof e == "string") {
      const i = this.getFunction(e);
      Mt(i, "unknown function", "fragment", e), e = i;
    }
    return Mt(Vi(r, 0, 4) === e.selector, `data signature does not match function ${e.name}.`, "data", r), this._decodeParams(e.inputs, Vi(r, 4));
  }
  /**
   *  Encodes the ``tx.data`` for a transaction that calls the function
   *  specified (see [[getFunction]] for valid values for %%fragment%%) with
   *  the %%values%%.
   */
  encodeFunctionData(e, r) {
    if (typeof e == "string") {
      const i = this.getFunction(e);
      Mt(i, "unknown function", "fragment", e), e = i;
    }
    return ia([
      e.selector,
      this._encodeParams(e.inputs, r || [])
    ]);
  }
  /**
   *  Decodes the result %%data%% (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values for
   *  %%key%%).
   *
   *  Most developers should prefer the [[parseCallResult]] method instead,
   *  which will automatically detect a ``CALL_EXCEPTION`` and throw the
   *  corresponding error.
   */
  decodeFunctionResult(e, r) {
    if (typeof e == "string") {
      const a = this.getFunction(e);
      Mt(a, "unknown function", "fragment", e), e = a;
    }
    let i = "invalid length for result data";
    const f = Nn(r);
    if (f.length % 32 === 0)
      try {
        return vt(this, $r).decode(e.outputs, f);
      } catch {
        i = "could not decode result data";
      }
    Ut(!1, i, "BAD_DATA", {
      value: mr(f),
      info: {
        method: e.name,
        signature: e.format()
      }
    });
  }
  makeError(e, r) {
    const i = vn(e, "data"), f = Lw.getBuiltinCallException("call", r, i);
    if (f.message.startsWith("execution reverted (unknown custom error)")) {
      const d = mr(i.slice(0, 4)), v = this.getError(d);
      if (v)
        try {
          const m = vt(this, $r).decode(v.inputs, i.slice(4));
          f.revert = {
            name: v.name,
            signature: v.format(),
            args: m
          }, f.reason = f.revert.signature, f.message = `execution reverted: ${f.reason}`;
        } catch {
          f.message = "execution reverted (coult not decode custom error)";
        }
    }
    const l = this.parseTransaction(r);
    return l && (f.invocation = {
      method: l.name,
      signature: l.signature,
      args: l.args
    }), f;
  }
  /**
   *  Encodes the result data (e.g. from an ``eth_call``) for the
   *  specified function (see [[getFunction]] for valid values
   *  for %%fragment%%) with %%values%%.
   *
   *  This is generally not used by most developers, unless trying to mock
   *  a result from a Contract.
   */
  encodeFunctionResult(e, r) {
    if (typeof e == "string") {
      const i = this.getFunction(e);
      Mt(i, "unknown function", "fragment", e), e = i;
    }
    return mr(vt(this, $r).encode(e.outputs, r || []));
  }
  /*
      spelunk(inputs: Array<ParamType>, values: ReadonlyArray<any>, processfunc: (type: string, value: any) => Promise<any>): Promise<Array<any>> {
          const promises: Array<Promise<>> = [ ];
          const process = function(type: ParamType, value: any): any {
              if (type.baseType === "array") {
                  return descend(type.child
              }
              if (type. === "address") {
              }
          };

          const descend = function (inputs: Array<ParamType>, values: ReadonlyArray<any>) {
              if (inputs.length !== values.length) { throw new Error("length mismatch"); }

          };

          const result: Array<any> = [ ];
          values.forEach((value, index) => {
              if (value == null) {
                  topics.push(null);
              } else if (param.baseType === "array" || param.baseType === "tuple") {
                  logger.throwArgumentError("filtering with tuples or arrays not supported", ("contract." + param.name), value);
              } else if (Array.isArray(value)) {
                  topics.push(value.map((value) => encodeTopic(param, value)));
              } else {
                  topics.push(encodeTopic(param, value));
              }
          });
      }
  */
  // Create the filter for the event with search criteria (e.g. for eth_filterLog)
  encodeFilterTopics(e, r) {
    if (typeof e == "string") {
      const a = this.getEvent(e);
      Mt(a, "unknown event", "eventFragment", e), e = a;
    }
    Ut(r.length <= e.inputs.length, `too many arguments for ${e.format()}`, "UNEXPECTED_ARGUMENT", {
      count: r.length,
      expectedCount: e.inputs.length
    });
    const i = [];
    e.anonymous || i.push(e.topicHash);
    const f = /* @__PURE__ */ ke((a, l) => a.type === "string" ? to(l) : a.type === "bytes" ? si(mr(l)) : (a.type === "bool" && typeof l == "boolean" ? l = l ? "0x01" : "0x00" : a.type.match(/^u?int/) ? l = Km(l) : a.type.match(/^bytes/) ? l = B9(l, 32) : a.type === "address" && vt(this, $r).encode([
      "address"
    ], [
      l
    ]), C9(mr(l), 32)), "encodeTopic");
    for (r.forEach((a, l) => {
      const d = e.inputs[l];
      if (!d.indexed) {
        Mt(a == null, "cannot filter non-indexed parameters; must be null", "contract." + d.name, a);
        return;
      }
      a == null ? i.push(null) : d.baseType === "array" || d.baseType === "tuple" ? Mt(!1, "filtering with tuples or arrays not supported", "contract." + d.name, a) : Array.isArray(a) ? i.push(a.map((v) => f(d, v))) : i.push(f(d, a));
    }); i.length && i[i.length - 1] === null; )
      i.pop();
    return i;
  }
  encodeEventLog(e, r) {
    if (typeof e == "string") {
      const l = this.getEvent(e);
      Mt(l, "unknown event", "eventFragment", e), e = l;
    }
    const i = [], f = [], a = [];
    return e.anonymous || i.push(e.topicHash), Mt(r.length === e.inputs.length, "event arguments/values mismatch", "values", r), e.inputs.forEach((l, d) => {
      const v = r[d];
      if (l.indexed)
        if (l.type === "string")
          i.push(to(v));
        else if (l.type === "bytes")
          i.push(si(v));
        else {
          if (l.baseType === "tuple" || l.baseType === "array")
            throw new Error("not implemented");
          i.push(vt(this, $r).encode([
            l.type
          ], [
            v
          ]));
        }
      else
        f.push(l), a.push(v);
    }), {
      data: vt(this, $r).encode(f, a),
      topics: i
    };
  }
  // Decode a filter for the event and the search criteria
  decodeEventLog(e, r, i) {
    if (typeof e == "string") {
      const S = this.getEvent(e);
      Mt(S, "unknown event", "eventFragment", e), e = S;
    }
    if (i != null && !e.anonymous) {
      const S = e.topicHash;
      Mt(ai(i[0], 32) && i[0].toLowerCase() === S, "fragment/topic mismatch", "topics[0]", i[0]), i = i.slice(1);
    }
    const f = [], a = [], l = [];
    e.inputs.forEach((S, E) => {
      S.indexed ? S.type === "string" || S.type === "bytes" || S.baseType === "tuple" || S.baseType === "array" ? (f.push(Zr.from({
        type: "bytes32",
        name: S.name
      })), l.push(!0)) : (f.push(S), l.push(!1)) : (a.push(S), l.push(!1));
    });
    const d = i != null ? vt(this, $r).decode(f, ia(i)) : null, v = vt(this, $r).decode(a, r, !0), m = [], h = [];
    let w = 0, M = 0;
    return e.inputs.forEach((S, E) => {
      let A = null;
      if (S.indexed)
        if (d == null)
          A = new Fw(null);
        else if (l[E])
          A = new Fw(d[M++]);
        else
          try {
            A = d[M++];
          } catch (B) {
            A = B;
          }
      else
        try {
          A = v[w++];
        } catch (B) {
          A = B;
        }
      m.push(A), h.push(S.name || null);
    }), Ol.fromItems(m, h);
  }
  /**
   *  Parses a transaction, finding the matching function and extracts
   *  the parameter values along with other useful function details.
   *
   *  If the matching function cannot be found, return null.
   */
  parseTransaction(e) {
    const r = vn(e.data, "tx.data"), i = li(e.value != null ? e.value : 0, "tx.value"), f = this.getFunction(mr(r.slice(0, 4)));
    if (!f)
      return null;
    const a = vt(this, $r).decode(f.inputs, r.slice(4));
    return new CD(f, f.selector, a, i);
  }
  parseCallResult(e) {
    throw new Error("@TODO");
  }
  /**
   *  Parses a receipt log, finding the matching event and extracts
   *  the parameter values along with other useful event details.
   *
   *  If the matching event cannot be found, returns null.
   */
  parseLog(e) {
    const r = this.getEvent(e.topics[0]);
    return !r || r.anonymous ? null : new TD(r, r.topicHash, this.decodeEventLog(r, e.data, e.topics));
  }
  /**
   *  Parses a revert data, finding the matching error and extracts
   *  the parameter values along with other useful error details.
   *
   *  If the matching error cannot be found, returns null.
   */
  parseError(e) {
    const r = mr(e), i = this.getError(Vi(r, 0, 4));
    if (!i)
      return null;
    const f = vt(this, $r).decode(i.inputs, Vi(r, 4));
    return new BD(i, i.selector, f);
  }
  /**
   *  Creates a new [[Interface]] from the ABI %%value%%.
   *
   *  The %%value%% may be provided as an existing [[Interface]] object,
   *  a JSON-encoded ABI or any Human-Readable ABI format.
   */
  static from(e) {
    return e instanceof Cs ? e : typeof e == "string" ? new Cs(JSON.parse(e)) : typeof e.formatJson == "function" ? new Cs(e.formatJson()) : typeof e.format == "function" ? new Cs(e.format("json")) : new Cs(e);
  }
};
pi = /* @__PURE__ */ new WeakMap();
bi = /* @__PURE__ */ new WeakMap();
wi = /* @__PURE__ */ new WeakMap();
$r = /* @__PURE__ */ new WeakMap();
Fi = /* @__PURE__ */ new WeakSet();
ll = /* @__PURE__ */ ke(function(t, e, r) {
  if (ai(t)) {
    const f = t.toLowerCase();
    for (const a of vt(this, wi).values())
      if (f === a.selector)
        return a;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const f = [];
    for (const [a, l] of vt(this, wi))
      a.split(
        "("
        /* fix:) */
      )[0] === t && f.push(l);
    if (e) {
      const a = e.length > 0 ? e[e.length - 1] : null;
      let l = e.length, d = !0;
      nn.isTyped(a) && a.type === "overrides" && (d = !1, l--);
      for (let v = f.length - 1; v >= 0; v--) {
        const m = f[v].inputs.length;
        m !== l && (!d || m !== l - 1) && f.splice(v, 1);
      }
      for (let v = f.length - 1; v >= 0; v--) {
        const m = f[v].inputs;
        for (let h = 0; h < e.length; h++)
          if (nn.isTyped(e[h])) {
            if (h >= m.length) {
              if (e[h].type === "overrides")
                continue;
              f.splice(v, 1);
              break;
            }
            if (e[h].type !== m[h].baseType) {
              f.splice(v, 1);
              break;
            }
          }
      }
    }
    if (f.length === 1 && e && e.length !== f[0].inputs.length) {
      const a = e[e.length - 1];
      (a == null || Array.isArray(a) || typeof a != "object") && f.splice(0, 1);
    }
    if (f.length === 0)
      return null;
    if (f.length > 1 && r) {
      const a = f.map((l) => JSON.stringify(l.format())).join(", ");
      Mt(!1, `ambiguous function description (i.e. matches ${a})`, "key", t);
    }
    return f[0];
  }
  const i = vt(this, wi).get(fl.from(t).format());
  return i || null;
}, "#getFunction");
cl = /* @__PURE__ */ ke(function(t, e, r) {
  if (ai(t)) {
    const f = t.toLowerCase();
    for (const a of vt(this, bi).values())
      if (f === a.topicHash)
        return a;
    return null;
  }
  if (t.indexOf("(") === -1) {
    const f = [];
    for (const [a, l] of vt(this, bi))
      a.split(
        "("
        /* fix:) */
      )[0] === t && f.push(l);
    if (e) {
      for (let a = f.length - 1; a >= 0; a--)
        f[a].inputs.length < e.length && f.splice(a, 1);
      for (let a = f.length - 1; a >= 0; a--) {
        const l = f[a].inputs;
        for (let d = 0; d < e.length; d++)
          if (nn.isTyped(e[d]) && e[d].type !== l[d].baseType) {
            f.splice(a, 1);
            break;
          }
      }
    }
    if (f.length === 0)
      return null;
    if (f.length > 1 && r) {
      const a = f.map((l) => JSON.stringify(l.format())).join(", ");
      Mt(!1, `ambiguous event description (i.e. matches ${a})`, "key", t);
    }
    return f[0];
  }
  const i = vt(this, bi).get(sl.from(t).format());
  return i || null;
}, "#getEvent");
ke(Zx, "Interface");
var Fc = Zx, Gx = BigInt(0);
function un(t) {
  return t == null ? null : t.toString();
}
ke(un, "toJson");
function Qx(t) {
  const e = {};
  t.to && (e.to = t.to), t.from && (e.from = t.from), t.data && (e.data = mr(t.data));
  const r = "chainId,gasLimit,gasPrice,maxFeePerBlobGas,maxFeePerGas,maxPriorityFeePerGas,value".split(/,/);
  for (const f of r)
    !(f in t) || t[f] == null || (e[f] = li(t[f], `request.${f}`));
  const i = "type,nonce".split(/,/);
  for (const f of i)
    !(f in t) || t[f] == null || (e[f] = ci(t[f], `request.${f}`));
  return t.accessList && (e.accessList = Ax(t.accessList)), "blockTag" in t && (e.blockTag = t.blockTag), "enableCcipRead" in t && (e.enableCcipRead = !!t.enableCcipRead), "customData" in t && (e.customData = t.customData), "blobVersionedHashes" in t && t.blobVersionedHashes && (e.blobVersionedHashes = t.blobVersionedHashes.slice()), "kzg" in t && (e.kzg = t.kzg), "blobs" in t && t.blobs && (e.blobs = t.blobs.map((f) => T9(f) ? mr(f) : Object.assign({}, f))), e;
}
ke(Qx, "copyRequest");
var Yx = class {
  /**
   *  @_ignore:
   */
  constructor(e, r) {
    Ge(this, "provider"), Ge(this, "transactionHash"), Ge(this, "blockHash"), Ge(this, "blockNumber"), Ge(this, "removed"), Ge(this, "address"), Ge(this, "data"), Ge(this, "topics"), Ge(this, "index"), Ge(this, "transactionIndex"), this.provider = r;
    const i = Object.freeze(e.topics.slice());
    $t(this, {
      transactionHash: e.transactionHash,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      removed: e.removed,
      address: e.address,
      data: e.data,
      topics: i,
      index: e.index,
      transactionIndex: e.transactionIndex
    });
  }
  /**
   *  Returns a JSON-compatible object.
   */
  toJSON() {
    const { address: e, blockHash: r, blockNumber: i, data: f, index: a, removed: l, topics: d, transactionHash: v, transactionIndex: m } = this;
    return {
      _type: "log",
      address: e,
      blockHash: r,
      blockNumber: i,
      data: f,
      index: a,
      removed: l,
      topics: d,
      transactionHash: v,
      transactionIndex: m
    };
  }
  /**
   *  Returns the block that this log occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    return Ut(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction that this log occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.transactionHash);
    return Ut(!!e, "failed to find transaction", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  Returns the transaction receipt fot the transaction that this
   *  log occurred in.
   */
  async getTransactionReceipt() {
    const e = await this.provider.getTransactionReceipt(this.transactionHash);
    return Ut(!!e, "failed to find transaction receipt", "UNKNOWN_ERROR", {}), e;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return t7(this);
  }
};
ke(Yx, "Log");
var qc = Yx, dl, Jx = class {
  /**
   *  @_ignore:
   */
  constructor(e, r) {
    Ge(this, "provider"), Ge(this, "to"), Ge(this, "from"), Ge(this, "contractAddress"), Ge(this, "hash"), Ge(this, "index"), Ge(this, "blockHash"), Ge(this, "blockNumber"), Ge(this, "logsBloom"), Ge(this, "gasUsed"), Ge(this, "blobGasUsed"), Ge(this, "cumulativeGasUsed"), Ge(this, "gasPrice"), Ge(this, "blobGasPrice"), Ge(this, "type"), Ge(this, "status"), Ge(this, "root"), sr(this, dl), Xt(this, dl, Object.freeze(e.logs.map((f) => new qc(f, r))));
    let i = Gx;
    e.effectiveGasPrice != null ? i = e.effectiveGasPrice : e.gasPrice != null && (i = e.gasPrice), $t(this, {
      provider: r,
      to: e.to,
      from: e.from,
      contractAddress: e.contractAddress,
      hash: e.hash,
      index: e.index,
      blockHash: e.blockHash,
      blockNumber: e.blockNumber,
      logsBloom: e.logsBloom,
      gasUsed: e.gasUsed,
      cumulativeGasUsed: e.cumulativeGasUsed,
      blobGasUsed: e.blobGasUsed,
      gasPrice: i,
      blobGasPrice: e.blobGasPrice,
      type: e.type,
      //byzantium: tx.byzantium,
      status: e.status,
      root: e.root
    });
  }
  /**
   *  The logs for this transaction.
   */
  get logs() {
    return vt(this, dl);
  }
  /**
   *  Returns a JSON-compatible representation.
   */
  toJSON() {
    const { to: e, from: r, contractAddress: i, hash: f, index: a, blockHash: l, blockNumber: d, logsBloom: v, logs: m, status: h, root: w } = this;
    return {
      _type: "TransactionReceipt",
      blockHash: l,
      blockNumber: d,
      //byzantium,
      contractAddress: i,
      cumulativeGasUsed: un(this.cumulativeGasUsed),
      from: r,
      gasPrice: un(this.gasPrice),
      blobGasUsed: un(this.blobGasUsed),
      blobGasPrice: un(this.blobGasPrice),
      gasUsed: un(this.gasUsed),
      hash: f,
      index: a,
      logs: m,
      logsBloom: v,
      root: w,
      status: h,
      to: e
    };
  }
  /**
   *  @_ignore:
   */
  get length() {
    return this.logs.length;
  }
  [Symbol.iterator]() {
    let e = 0;
    return {
      next: /* @__PURE__ */ ke(() => e < this.length ? {
        value: this.logs[e++],
        done: !1
      } : {
        value: void 0,
        done: !0
      }, "next")
    };
  }
  /**
   *  The total fee for this transaction, in wei.
   */
  get fee() {
    return this.gasUsed * this.gasPrice;
  }
  /**
   *  Resolves to the block this transaction occurred in.
   */
  async getBlock() {
    const e = await this.provider.getBlock(this.blockHash);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to the transaction this transaction occurred in.
   */
  async getTransaction() {
    const e = await this.provider.getTransaction(this.hash);
    if (e == null)
      throw new Error("TODO");
    return e;
  }
  /**
   *  Resolves to the return value of the execution of this transaction.
   *
   *  Support for this feature is limited, as it requires an archive node
   *  with the ``debug_`` or ``trace_`` API enabled.
   */
  async getResult() {
    return await this.provider.getTransactionResult(this.hash);
  }
  /**
   *  Resolves to the number of confirmations this transaction has.
   */
  async confirmations() {
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  @_ignore:
   */
  removedEvent() {
    return ag(this);
  }
  /**
   *  @_ignore:
   */
  reorderedEvent(e) {
    return Ut(!e || e.isMined(), "unmined 'other' transction cannot be orphaned", "UNSUPPORTED_OPERATION", {
      operation: "reorderedEvent(other)"
    }), ig(this, e);
  }
};
dl = /* @__PURE__ */ new WeakMap();
ke(Jx, "TransactionReceipt");
var ID = Jx, Ca, Xx = class e7 {
  /**
   *  @_ignore:
   */
  constructor(e, r) {
    Ge(this, "provider"), Ge(this, "blockNumber"), Ge(this, "blockHash"), Ge(this, "index"), Ge(this, "hash"), Ge(this, "type"), Ge(this, "to"), Ge(this, "from"), Ge(this, "nonce"), Ge(this, "gasLimit"), Ge(this, "gasPrice"), Ge(this, "maxPriorityFeePerGas"), Ge(this, "maxFeePerGas"), Ge(this, "maxFeePerBlobGas"), Ge(this, "data"), Ge(this, "value"), Ge(this, "chainId"), Ge(this, "signature"), Ge(this, "accessList"), Ge(this, "blobVersionedHashes"), sr(this, Ca), this.provider = r, this.blockNumber = e.blockNumber != null ? e.blockNumber : null, this.blockHash = e.blockHash != null ? e.blockHash : null, this.hash = e.hash, this.index = e.index, this.type = e.type, this.from = e.from, this.to = e.to || null, this.gasLimit = e.gasLimit, this.nonce = e.nonce, this.data = e.data, this.value = e.value, this.gasPrice = e.gasPrice, this.maxPriorityFeePerGas = e.maxPriorityFeePerGas != null ? e.maxPriorityFeePerGas : null, this.maxFeePerGas = e.maxFeePerGas != null ? e.maxFeePerGas : null, this.maxFeePerBlobGas = e.maxFeePerBlobGas != null ? e.maxFeePerBlobGas : null, this.chainId = e.chainId, this.signature = e.signature, this.accessList = e.accessList != null ? e.accessList : null, this.blobVersionedHashes = e.blobVersionedHashes != null ? e.blobVersionedHashes : null, Xt(this, Ca, -1);
  }
  /**
   *  Returns a JSON-compatible representation of this transaction.
   */
  toJSON() {
    const { blockNumber: e, blockHash: r, index: i, hash: f, type: a, to: l, from: d, nonce: v, data: m, signature: h, accessList: w, blobVersionedHashes: M } = this;
    return {
      _type: "TransactionResponse",
      accessList: w,
      blockNumber: e,
      blockHash: r,
      blobVersionedHashes: M,
      chainId: un(this.chainId),
      data: m,
      from: d,
      gasLimit: un(this.gasLimit),
      gasPrice: un(this.gasPrice),
      hash: f,
      maxFeePerGas: un(this.maxFeePerGas),
      maxPriorityFeePerGas: un(this.maxPriorityFeePerGas),
      maxFeePerBlobGas: un(this.maxFeePerBlobGas),
      nonce: v,
      signature: h,
      to: l,
      index: i,
      type: a,
      value: un(this.value)
    };
  }
  /**
   *  Resolves to the Block that this transaction was included in.
   *
   *  This will return null if the transaction has not been included yet.
   */
  async getBlock() {
    let e = this.blockNumber;
    if (e == null) {
      const i = await this.getTransaction();
      i && (e = i.blockNumber);
    }
    if (e == null)
      return null;
    const r = this.provider.getBlock(e);
    if (r == null)
      throw new Error("TODO");
    return r;
  }
  /**
   *  Resolves to this transaction being re-requested from the
   *  provider. This can be used if you have an unmined transaction
   *  and wish to get an up-to-date populated instance.
   */
  async getTransaction() {
    return this.provider.getTransaction(this.hash);
  }
  /**
   *  Resolve to the number of confirmations this transaction has.
   */
  async confirmations() {
    if (this.blockNumber == null) {
      const { tx: r, blockNumber: i } = await Rl({
        tx: this.getTransaction(),
        blockNumber: this.provider.getBlockNumber()
      });
      return r == null || r.blockNumber == null ? 0 : i - r.blockNumber + 1;
    }
    return await this.provider.getBlockNumber() - this.blockNumber + 1;
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(e, r) {
    const i = e ?? 1, f = r ?? 0;
    let a = vt(this, Ca), l = -1, d = a === -1;
    const v = /* @__PURE__ */ ke(async () => {
      if (d)
        return null;
      const { blockNumber: M, nonce: S } = await Rl({
        blockNumber: this.provider.getBlockNumber(),
        nonce: this.provider.getTransactionCount(this.from)
      });
      if (S < this.nonce) {
        a = M;
        return;
      }
      if (d)
        return null;
      const E = await this.getTransaction();
      if (!(E && E.blockNumber != null))
        for (l === -1 && (l = a - 3, l < vt(this, Ca) && (l = vt(this, Ca))); l <= M; ) {
          if (d)
            return null;
          const A = await this.provider.getBlock(l, !0);
          if (A == null)
            return;
          for (const B of A)
            if (B === this.hash)
              return;
          for (let B = 0; B < A.length; B++) {
            const k = await A.getTransaction(B);
            if (k.from === this.from && k.nonce === this.nonce) {
              if (d)
                return null;
              const C = await this.provider.getTransactionReceipt(k.hash);
              if (C == null || M - C.blockNumber + 1 < i)
                return;
              let I = "replaced";
              k.data === this.data && k.to === this.to && k.value === this.value ? I = "repriced" : k.data === "0x" && k.from === k.to && k.value === Gx && (I = "cancelled"), Ut(!1, "transaction was replaced", "TRANSACTION_REPLACED", {
                cancelled: I === "replaced" || I === "cancelled",
                reason: I,
                replacement: k.replaceableTransaction(a),
                hash: k.hash,
                receipt: C
              });
            }
          }
          l++;
        }
    }, "checkReplacement"), m = /* @__PURE__ */ ke((M) => {
      if (M == null || M.status !== 0)
        return M;
      Ut(!1, "transaction execution reverted", "CALL_EXCEPTION", {
        action: "sendTransaction",
        data: null,
        reason: null,
        invocation: null,
        revert: null,
        transaction: {
          to: M.to,
          from: M.from,
          data: ""
          // @TODO: in v7, split out sendTransaction properties
        },
        receipt: M
      });
    }, "checkReceipt"), h = await this.provider.getTransactionReceipt(this.hash);
    if (i === 0)
      return m(h);
    if (h) {
      if (await h.confirmations() >= i)
        return m(h);
    } else if (await v(), i === 0)
      return null;
    return await new Promise((M, S) => {
      const E = [], A = /* @__PURE__ */ ke(() => {
        E.forEach((k) => k());
      }, "cancel");
      if (E.push(() => {
        d = !0;
      }), f > 0) {
        const k = setTimeout(() => {
          A(), S(Xs("wait for transaction timeout", "TIMEOUT"));
        }, f);
        E.push(() => {
          clearTimeout(k);
        });
      }
      const B = /* @__PURE__ */ ke(async (k) => {
        if (await k.confirmations() >= i) {
          A();
          try {
            M(m(k));
          } catch (C) {
            S(C);
          }
        }
      }, "txListener");
      if (E.push(() => {
        this.provider.off(this.hash, B);
      }), this.provider.on(this.hash, B), a >= 0) {
        const k = /* @__PURE__ */ ke(async () => {
          try {
            await v();
          } catch (C) {
            if (ls(C, "TRANSACTION_REPLACED")) {
              A(), S(C);
              return;
            }
          }
          d || this.provider.once("block", k);
        }, "replaceListener");
        E.push(() => {
          this.provider.off("block", k);
        }), this.provider.once("block", k);
      }
    });
  }
  /**
   *  Returns ``true`` if this transaction has been included.
   *
   *  This is effective only as of the time the TransactionResponse
   *  was instantiated. To get up-to-date information, use
   *  [[getTransaction]].
   *
   *  This provides a Type Guard that this transaction will have
   *  non-null property values for properties that are null for
   *  unmined transactions.
   */
  isMined() {
    return this.blockHash != null;
  }
  /**
   *  Returns true if the transaction is a legacy (i.e. ``type == 0``)
   *  transaction.
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLegacy() {
    return this.type === 0;
  }
  /**
   *  Returns true if the transaction is a Berlin (i.e. ``type == 1``)
   *  transaction. See [[link-eip-2070]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isBerlin() {
    return this.type === 1;
  }
  /**
   *  Returns true if the transaction is a London (i.e. ``type == 2``)
   *  transaction. See [[link-eip-1559]].
   *
   *  This provides a Type Guard that this transaction will have
   *  the ``null``-ness for hardfork-specific properties set correctly.
   */
  isLondon() {
    return this.type === 2;
  }
  /**
   *  Returns true if hte transaction is a Cancun (i.e. ``type == 3``)
   *  transaction. See [[link-eip-4844]].
   */
  isCancun() {
    return this.type === 3;
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that evict this transaction.
   */
  removedEvent() {
    return Ut(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
      operation: "removeEvent()"
    }), ag(this);
  }
  /**
   *  Returns a filter which can be used to listen for orphan events
   *  that re-order this event against %%other%%.
   */
  reorderedEvent(e) {
    return Ut(this.isMined(), "unmined transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
      operation: "removeEvent()"
    }), Ut(!e || e.isMined(), "unmined 'other' transaction canot be orphaned", "UNSUPPORTED_OPERATION", {
      operation: "removeEvent()"
    }), ig(this, e);
  }
  /**
   *  Returns a new TransactionResponse instance which has the ability to
   *  detect (and throw an error) if the transaction is replaced, which
   *  will begin scanning at %%startBlock%%.
   *
   *  This should generally not be used by developers and is intended
   *  primarily for internal use. Setting an incorrect %%startBlock%% can
   *  have devastating performance consequences if used incorrectly.
   */
  replaceableTransaction(e) {
    Mt(Number.isInteger(e) && e >= 0, "invalid startBlock", "startBlock", e);
    const r = new e7(this, this.provider);
    return Xt(r, Ca, e), r;
  }
};
Ca = /* @__PURE__ */ new WeakMap();
ke(Xx, "TransactionResponse");
var RD = Xx;
function ig(t, e) {
  return {
    orphan: "reorder-transaction",
    tx: t,
    other: e
  };
}
ke(ig, "createReorderedTransactionFilter");
function ag(t) {
  return {
    orphan: "drop-transaction",
    tx: t
  };
}
ke(ag, "createRemovedTransactionFilter");
function t7(t) {
  return {
    orphan: "drop-log",
    log: {
      transactionHash: t.transactionHash,
      blockHash: t.blockHash,
      blockNumber: t.blockNumber,
      address: t.address,
      data: t.data,
      topics: Object.freeze(t.topics.slice()),
      index: t.index
    }
  };
}
ke(t7, "createRemovedLogFilter");
var r7 = class extends qc {
  /**
   * @_ignore:
   */
  constructor(e, r, i) {
    super(e, e.provider), Ge(this, "interface"), Ge(this, "fragment"), Ge(this, "args");
    const f = r.decodeEventLog(i, e.data, e.topics);
    $t(this, {
      args: f,
      fragment: i,
      interface: r
    });
  }
  /**
   *  The name of the event.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The signature of the event.
   */
  get eventSignature() {
    return this.fragment.format();
  }
};
ke(r7, "EventLog");
var sg = r7, n7 = class extends qc {
  /**
   * @_ignore:
   */
  constructor(e, r) {
    super(e, e.provider), Ge(this, "error"), $t(this, {
      error: r
    });
  }
};
ke(n7, "UndecodedEventLog");
var i7 = n7, vf, a7 = class extends ID {
  /**
   *  @_ignore:
   */
  constructor(e, r, i) {
    super(i, r), sr(this, vf), Xt(this, vf, e);
  }
  /**
   *  The parsed logs for any [[Log]] which has a matching event in the
   *  Contract ABI.
   */
  get logs() {
    return super.logs.map((e) => {
      const r = e.topics.length ? vt(this, vf).getEvent(e.topics[0]) : null;
      if (r)
        try {
          return new sg(e, vt(this, vf), r);
        } catch (i) {
          return new i7(e, i);
        }
      return e;
    });
  }
};
vf = /* @__PURE__ */ new WeakMap();
ke(a7, "ContractTransactionReceipt");
var PD = a7, hl, s7 = class extends RD {
  /**
   *  @_ignore:
   */
  constructor(e, r, i) {
    super(i, r), sr(this, hl), Xt(this, hl, e);
  }
  /**
   *  Resolves once this transaction has been mined and has
   *  %%confirms%% blocks including it (default: ``1``) with an
   *  optional %%timeout%%.
   *
   *  This can resolve to ``null`` only if %%confirms%% is ``0``
   *  and the transaction has not been mined, otherwise this will
   *  wait until enough confirmations have completed.
   */
  async wait(e, r) {
    const i = await super.wait(e, r);
    return i == null ? null : new PD(vt(this, hl), this.provider, i);
  }
};
hl = /* @__PURE__ */ new WeakMap();
ke(s7, "ContractTransactionResponse");
var og = s7, o7 = class extends CN {
  /**
   *  @_event:
   */
  constructor(e, r, i, f) {
    super(e, r, i), Ge(this, "log"), $t(this, {
      log: f
    });
  }
  /**
   *  Resolves to the block the event occured in.
   */
  async getBlock() {
    return await this.log.getBlock();
  }
  /**
   *  Resolves to the transaction the event occured in.
   */
  async getTransaction() {
    return await this.log.getTransaction();
  }
  /**
   *  Resolves to the transaction receipt the event occured in.
   */
  async getTransactionReceipt() {
    return await this.log.getTransactionReceipt();
  }
};
ke(o7, "ContractUnknownEventPayload");
var f7 = o7, u7 = class extends f7 {
  /**
   *  @_ignore:
   */
  constructor(e, r, i, f, a) {
    super(e, r, i, new sg(a, e.interface, f));
    const l = e.interface.decodeEventLog(f, this.log.data, this.log.topics);
    $t(this, {
      args: l,
      fragment: f
    });
  }
  /**
   *  The event name.
   */
  get eventName() {
    return this.fragment.name;
  }
  /**
   *  The event signature.
   */
  get eventSignature() {
    return this.fragment.format();
  }
};
ke(u7, "ContractEventPayload");
var OD = u7, jw = BigInt(0);
function fg(t) {
  return t && typeof t.call == "function";
}
ke(fg, "canCall");
function ug(t) {
  return t && typeof t.estimateGas == "function";
}
ke(ug, "canEstimate");
function iu(t) {
  return t && typeof t.resolveName == "function";
}
ke(iu, "canResolve");
function lg(t) {
  return t && typeof t.sendTransaction == "function";
}
ke(lg, "canSend");
function cg(t) {
  if (t != null) {
    if (iu(t))
      return t;
    if (t.provider)
      return t.provider;
  }
}
ke(cg, "getResolver");
var Ru, Xp, ND = (Xp = class {
  constructor(t, e, r) {
    if (sr(this, Ru), Ge(this, "fragment"), $t(this, {
      fragment: e
    }), e.inputs.length < r.length)
      throw new Error("too many arguments");
    const i = ha(t.runner, "resolveName"), f = iu(i) ? i : null;
    Xt(this, Ru, async function() {
      const a = await Promise.all(e.inputs.map((l, d) => r[d] == null ? null : l.walkAsync(r[d], (m, h) => m === "address" ? Array.isArray(h) ? Promise.all(h.map((w) => eo(w, f))) : eo(h, f) : h)));
      return t.interface.encodeFilterTopics(e, a);
    }());
  }
  getTopicFilter() {
    return vt(this, Ru);
  }
}, Ru = /* @__PURE__ */ new WeakMap(), ke(Xp, "PreparedTopicFilter"), Xp);
function ha(t, e) {
  return t == null ? null : typeof t[e] == "function" ? t : t.provider && typeof t.provider[e] == "function" ? t.provider : null;
}
ke(ha, "getRunner");
function Zi(t) {
  return t == null ? null : t.provider || null;
}
ke(Zi, "getProvider");
async function zc(t, e) {
  const r = nn.dereference(t, "overrides");
  Mt(typeof r == "object", "invalid overrides parameter", "overrides", t);
  const i = Qx(r);
  return Mt(i.to == null || (e || []).indexOf("to") >= 0, "cannot override to", "overrides.to", i.to), Mt(i.data == null || (e || []).indexOf("data") >= 0, "cannot override data", "overrides.data", i.data), i.from && (i.from = i.from), i;
}
ke(zc, "copyOverrides");
async function dg(t, e, r) {
  const i = ha(t, "resolveName"), f = iu(i) ? i : null;
  return await Promise.all(e.map((a, l) => a.walkAsync(r[l], (d, v) => (v = nn.dereference(v, d), d === "address" ? eo(v, f) : v))));
}
ke(dg, "resolveArgs");
function l7(t) {
  const e = /* @__PURE__ */ ke(async function(l) {
    const d = await zc(l, [
      "data"
    ]);
    d.to = await t.getAddress(), d.from && (d.from = await eo(d.from, cg(t.runner)));
    const v = t.interface, m = li(d.value || jw, "overrides.value") === jw, h = (d.data || "0x") === "0x";
    v.fallback && !v.fallback.payable && v.receive && !h && !m && Mt(!1, "cannot send data to receive or send value to non-payable fallback", "overrides", l), Mt(v.fallback || h, "cannot send data to receive-only contract", "overrides.data", d.data);
    const w = v.receive || v.fallback && v.fallback.payable;
    return Mt(w || m, "cannot send value to non-payable fallback", "overrides.value", d.value), Mt(v.fallback || h, "cannot send data to receive-only contract", "overrides.data", d.data), d;
  }, "populateTransaction"), r = /* @__PURE__ */ ke(async function(l) {
    const d = ha(t.runner, "call");
    Ut(fg(d), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
      operation: "call"
    });
    const v = await e(l);
    try {
      return await d.call(v);
    } catch (m) {
      throw jm(m) && m.data ? t.interface.makeError(m.data, v) : m;
    }
  }, "staticCall"), i = /* @__PURE__ */ ke(async function(l) {
    const d = t.runner;
    Ut(lg(d), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
      operation: "sendTransaction"
    });
    const v = await d.sendTransaction(await e(l)), m = Zi(t.runner);
    return new og(t.interface, m, v);
  }, "send"), f = /* @__PURE__ */ ke(async function(l) {
    const d = ha(t.runner, "estimateGas");
    return Ut(ug(d), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
      operation: "estimateGas"
    }), await d.estimateGas(await e(l));
  }, "estimateGas"), a = /* @__PURE__ */ ke(async (l) => await i(l), "method");
  return $t(a, {
    _contract: t,
    estimateGas: f,
    populateTransaction: e,
    send: i,
    staticCall: r
  }), a;
}
ke(l7, "buildWrappedFallback");
function c7(t, e) {
  const r = /* @__PURE__ */ ke(function(...m) {
    const h = t.interface.getFunction(e, m);
    return Ut(h, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: {
        key: e,
        args: m
      }
    }), h;
  }, "getFragment"), i = /* @__PURE__ */ ke(async function(...m) {
    const h = r(...m);
    let w = {};
    if (h.inputs.length + 1 === m.length && (w = await zc(m.pop()), w.from && (w.from = await eo(w.from, cg(t.runner)))), h.inputs.length !== m.length)
      throw new Error("internal error: fragment inputs doesn't match arguments; should not happen");
    const M = await dg(t.runner, h.inputs, m);
    return Object.assign({}, w, await Rl({
      to: t.getAddress(),
      data: t.interface.encodeFunctionData(h, M)
    }));
  }, "populateTransaction"), f = /* @__PURE__ */ ke(async function(...m) {
    const h = await d(...m);
    return h.length === 1 ? h[0] : h;
  }, "staticCall"), a = /* @__PURE__ */ ke(async function(...m) {
    const h = t.runner;
    Ut(lg(h), "contract runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
      operation: "sendTransaction"
    });
    const w = await h.sendTransaction(await i(...m)), M = Zi(t.runner);
    return new og(t.interface, M, w);
  }, "send"), l = /* @__PURE__ */ ke(async function(...m) {
    const h = ha(t.runner, "estimateGas");
    return Ut(ug(h), "contract runner does not support gas estimation", "UNSUPPORTED_OPERATION", {
      operation: "estimateGas"
    }), await h.estimateGas(await i(...m));
  }, "estimateGas"), d = /* @__PURE__ */ ke(async function(...m) {
    const h = ha(t.runner, "call");
    Ut(fg(h), "contract runner does not support calling", "UNSUPPORTED_OPERATION", {
      operation: "call"
    });
    const w = await i(...m);
    let M = "0x";
    try {
      M = await h.call(w);
    } catch (E) {
      throw jm(E) && E.data ? t.interface.makeError(E.data, w) : E;
    }
    const S = r(...m);
    return t.interface.decodeFunctionResult(S, M);
  }, "staticCallResult"), v = /* @__PURE__ */ ke(async (...m) => r(...m).constant ? await f(...m) : await a(...m), "method");
  return $t(v, {
    name: t.interface.getFunctionName(e),
    _contract: t,
    _key: e,
    getFragment: r,
    estimateGas: l,
    populateTransaction: i,
    send: a,
    staticCall: f,
    staticCallResult: d
  }), Object.defineProperty(v, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: /* @__PURE__ */ ke(() => {
      const m = t.interface.getFunction(e);
      return Ut(m, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: {
          key: e
        }
      }), m;
    }, "get")
  }), v;
}
ke(c7, "buildWrappedMethod");
function d7(t, e) {
  const r = /* @__PURE__ */ ke(function(...f) {
    const a = t.interface.getEvent(e, f);
    return Ut(a, "no matching fragment", "UNSUPPORTED_OPERATION", {
      operation: "fragment",
      info: {
        key: e,
        args: f
      }
    }), a;
  }, "getFragment"), i = /* @__PURE__ */ ke(function(...f) {
    return new ND(t, r(...f), f);
  }, "method");
  return $t(i, {
    name: t.interface.getEventName(e),
    _contract: t,
    _key: e,
    getFragment: r
  }), Object.defineProperty(i, "fragment", {
    configurable: !1,
    enumerable: !0,
    get: /* @__PURE__ */ ke(() => {
      const f = t.interface.getEvent(e);
      return Ut(f, "no matching fragment", "UNSUPPORTED_OPERATION", {
        operation: "fragment",
        info: {
          key: e
        }
      }), f;
    }, "get")
  }), i;
}
ke(d7, "buildWrappedEvent");
var jc = Symbol.for("_ethersInternal_contract"), h7 = /* @__PURE__ */ new WeakMap();
function p7(t, e) {
  h7.set(t[jc], e);
}
ke(p7, "setInternal");
function en(t) {
  return h7.get(t[jc]);
}
ke(en, "getInternal");
function v7(t) {
  return t && typeof t == "object" && "getTopicFilter" in t && typeof t.getTopicFilter == "function" && t.fragment;
}
ke(v7, "isDeferred");
async function $c(t, e) {
  let r, i = null;
  if (Array.isArray(e)) {
    const a = /* @__PURE__ */ ke(function(l) {
      if (ai(l, 32))
        return l;
      const d = t.interface.getEvent(l);
      return Mt(d, "unknown fragment", "name", l), d.topicHash;
    }, "topicHashify");
    r = e.map((l) => l == null ? null : Array.isArray(l) ? l.map(a) : a(l));
  } else
    e === "*" ? r = [
      null
    ] : typeof e == "string" ? ai(e, 32) ? r = [
      e
    ] : (i = t.interface.getEvent(e), Mt(i, "unknown fragment", "event", e), r = [
      i.topicHash
    ]) : v7(e) ? r = await e.getTopicFilter() : "fragment" in e ? (i = e.fragment, r = [
      i.topicHash
    ]) : Mt(!1, "unknown event name", "event", e);
  r = r.map((a) => {
    if (a == null)
      return null;
    if (Array.isArray(a)) {
      const l = Array.from(new Set(a.map((d) => d.toLowerCase())).values());
      return l.length === 1 ? l[0] : (l.sort(), l);
    }
    return a.toLowerCase();
  });
  const f = r.map((a) => a == null ? "null" : Array.isArray(a) ? a.join("|") : a).join("&");
  return {
    fragment: i,
    tag: f,
    topics: r
  };
}
ke($c, "getSubInfo");
async function Ds(t, e) {
  const { subs: r } = en(t);
  return r.get((await $c(t, e)).tag) || null;
}
ke(Ds, "hasSub");
async function cv(t, e, r) {
  const i = Zi(t.runner);
  Ut(i, "contract runner does not support subscribing", "UNSUPPORTED_OPERATION", {
    operation: e
  });
  const { fragment: f, tag: a, topics: l } = await $c(t, r), { addr: d, subs: v } = en(t);
  let m = v.get(a);
  if (!m) {
    const w = {
      address: d || t,
      topics: l
    }, M = /* @__PURE__ */ ke((B) => {
      let k = f;
      if (k == null)
        try {
          k = t.interface.getEvent(B.topics[0]);
        } catch {
        }
      if (k) {
        const C = k, I = f ? t.interface.decodeEventLog(f, B.data, B.topics) : [];
        Nl(t, r, I, (O) => new OD(t, O, r, C, B));
      } else
        Nl(t, r, [], (C) => new f7(t, C, r, B));
    }, "listener");
    let S = [];
    m = {
      tag: a,
      listeners: [],
      start: /* @__PURE__ */ ke(() => {
        S.length || S.push(i.on(w, M));
      }, "start"),
      stop: /* @__PURE__ */ ke(async () => {
        if (S.length == 0)
          return;
        let B = S;
        S = [], await Promise.all(B), i.off(w, M);
      }, "stop")
    }, v.set(a, m);
  }
  return m;
}
ke(cv, "getSub");
var dv = Promise.resolve();
async function m7(t, e, r, i) {
  await dv;
  const f = await Ds(t, e);
  if (!f)
    return !1;
  const a = f.listeners.length;
  return f.listeners = f.listeners.filter(({ listener: l, once: d }) => {
    const v = Array.from(r);
    i && v.push(i(d ? null : l));
    try {
      l.call(t, ...v);
    } catch {
    }
    return !d;
  }), f.listeners.length === 0 && (f.stop(), en(t).subs.delete(f.tag)), a > 0;
}
ke(m7, "_emit");
async function Nl(t, e, r, i) {
  try {
    await dv;
  } catch {
  }
  const f = m7(t, e, r, i);
  return dv = f, await f;
}
ke(Nl, "emit");
var Pu = [
  "then"
], g7;
g7 = jc;
var y7 = class pl {
  /**
   *  Creates a new contract connected to %%target%% with the %%abi%% and
   *  optionally connected to a %%runner%% to perform operations on behalf
   *  of.
   */
  constructor(e, r, i, f) {
    Ge(this, "target"), Ge(this, "interface"), Ge(this, "runner"), Ge(this, "filters"), Ge(this, g7), Ge(this, "fallback"), Mt(typeof e == "string" || Xm(e), "invalid value for Contract target", "target", e), i == null && (i = null);
    const a = Fc.from(r);
    $t(this, {
      target: e,
      runner: i,
      interface: a
    }), Object.defineProperty(this, jc, {
      value: {}
    });
    let l, d = null, v = null;
    if (f) {
      const w = Zi(i);
      v = new og(this.interface, w, f);
    }
    let m = /* @__PURE__ */ new Map();
    if (typeof e == "string")
      if (ai(e))
        d = e, l = Promise.resolve(e);
      else {
        const w = ha(i, "resolveName");
        if (!iu(w))
          throw Xs("contract runner does not support name resolution", "UNSUPPORTED_OPERATION", {
            operation: "resolveName"
          });
        l = w.resolveName(e).then((M) => {
          if (M == null)
            throw Xs("an ENS name used for a contract target must be correctly configured", "UNCONFIGURED_NAME", {
              value: e
            });
          return en(this).addr = M, M;
        });
      }
    else
      l = e.getAddress().then((w) => {
        if (w == null)
          throw new Error("TODO");
        return en(this).addr = w, w;
      });
    p7(this, {
      addrPromise: l,
      addr: d,
      deployTx: v,
      subs: m
    });
    const h = new Proxy({}, {
      get: /* @__PURE__ */ ke((w, M, S) => {
        if (typeof M == "symbol" || Pu.indexOf(M) >= 0)
          return Reflect.get(w, M, S);
        try {
          return this.getEvent(M);
        } catch (E) {
          if (!ls(E, "INVALID_ARGUMENT") || E.argument !== "key")
            throw E;
        }
      }, "get"),
      has: /* @__PURE__ */ ke((w, M) => Pu.indexOf(M) >= 0 ? Reflect.has(w, M) : Reflect.has(w, M) || this.interface.hasEvent(String(M)), "has")
    });
    return $t(this, {
      filters: h
    }), $t(this, {
      fallback: a.receive || a.fallback ? l7(this) : null
    }), new Proxy(this, {
      get: /* @__PURE__ */ ke((w, M, S) => {
        if (typeof M == "symbol" || M in w || Pu.indexOf(M) >= 0)
          return Reflect.get(w, M, S);
        try {
          return w.getFunction(M);
        } catch (E) {
          if (!ls(E, "INVALID_ARGUMENT") || E.argument !== "key")
            throw E;
        }
      }, "get"),
      has: /* @__PURE__ */ ke((w, M) => typeof M == "symbol" || M in w || Pu.indexOf(M) >= 0 ? Reflect.has(w, M) : w.interface.hasFunction(M), "has")
    });
  }
  /**
   *  Return a new Contract instance with the same target and ABI, but
   *  a different %%runner%%.
   */
  connect(e) {
    return new pl(this.target, this.interface, e);
  }
  /**
   *  Return a new Contract instance with the same ABI and runner, but
   *  a different %%target%%.
   */
  attach(e) {
    return new pl(e, this.interface, this.runner);
  }
  /**
   *  Return the resolved address of this Contract.
   */
  async getAddress() {
    return await en(this).addrPromise;
  }
  /**
   *  Return the deployed bytecode or null if no bytecode is found.
   */
  async getDeployedCode() {
    const e = Zi(this.runner);
    Ut(e, "runner does not support .provider", "UNSUPPORTED_OPERATION", {
      operation: "getDeployedCode"
    });
    const r = await e.getCode(await this.getAddress());
    return r === "0x" ? null : r;
  }
  /**
   *  Resolve to this Contract once the bytecode has been deployed, or
   *  resolve immediately if already deployed.
   */
  async waitForDeployment() {
    const e = this.deploymentTransaction();
    if (e)
      return await e.wait(), this;
    if (await this.getDeployedCode() != null)
      return this;
    const i = Zi(this.runner);
    return Ut(i != null, "contract runner does not support .provider", "UNSUPPORTED_OPERATION", {
      operation: "waitForDeployment"
    }), new Promise((f, a) => {
      const l = /* @__PURE__ */ ke(async () => {
        try {
          if (await this.getDeployedCode() != null)
            return f(this);
          i.once("block", l);
        } catch (d) {
          a(d);
        }
      }, "checkCode");
      l();
    });
  }
  /**
   *  Return the transaction used to deploy this contract.
   *
   *  This is only available if this instance was returned from a
   *  [[ContractFactory]].
   */
  deploymentTransaction() {
    return en(this).deployTx;
  }
  /**
   *  Return the function for a given name. This is useful when a contract
   *  method name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getFunction(e) {
    return typeof e != "string" && (e = e.format()), c7(this, e);
  }
  /**
   *  Return the event for a given name. This is useful when a contract
   *  event name conflicts with a JavaScript name such as ``prototype`` or
   *  when using a Contract programatically.
   */
  getEvent(e) {
    return typeof e != "string" && (e = e.format()), d7(this, e);
  }
  /**
   *  @_ignore:
   */
  async queryTransaction(e) {
    throw new Error("@TODO");
  }
  /*
      // @TODO: this is a non-backwards compatible change, but will be added
      //        in v7 and in a potential SmartContract class in an upcoming
      //        v6 release
      async getTransactionReceipt(hash: string): Promise<null | ContractTransactionReceipt> {
          const provider = getProvider(this.runner);
          assert(provider, "contract runner does not have a provider",
              "UNSUPPORTED_OPERATION", { operation: "queryTransaction" });

          const receipt = await provider.getTransactionReceipt(hash);
          if (receipt == null) { return null; }

          return new ContractTransactionReceipt(this.interface, provider, receipt);
      }
      */
  /**
  *  Provide historic access to event data for %%event%% in the range
  *  %%fromBlock%% (default: ``0``) to %%toBlock%% (default: ``"latest"``)
  *  inclusive.
  */
  async queryFilter(e, r, i) {
    r == null && (r = 0), i == null && (i = "latest");
    const { addr: f, addrPromise: a } = en(this), l = f || await a, { fragment: d, topics: v } = await $c(this, e), m = {
      address: l,
      topics: v,
      fromBlock: r,
      toBlock: i
    }, h = Zi(this.runner);
    return Ut(h, "contract runner does not have a provider", "UNSUPPORTED_OPERATION", {
      operation: "queryFilter"
    }), (await h.getLogs(m)).map((w) => {
      let M = d;
      if (M == null)
        try {
          M = this.interface.getEvent(w.topics[0]);
        } catch {
        }
      if (M)
        try {
          return new sg(w, this.interface, M);
        } catch (S) {
          return new i7(w, S);
        }
      return new qc(w, h);
    });
  }
  /**
   *  Add an event %%listener%% for the %%event%%.
   */
  async on(e, r) {
    const i = await cv(this, "on", e);
    return i.listeners.push({
      listener: r,
      once: !1
    }), i.start(), this;
  }
  /**
   *  Add an event %%listener%% for the %%event%%, but remove the listener
   *  after it is fired once.
   */
  async once(e, r) {
    const i = await cv(this, "once", e);
    return i.listeners.push({
      listener: r,
      once: !0
    }), i.start(), this;
  }
  /**
   *  Emit an %%event%% calling all listeners with %%args%%.
   *
   *  Resolves to ``true`` if any listeners were called.
   */
  async emit(e, ...r) {
    return await Nl(this, e, r, null);
  }
  /**
   *  Resolves to the number of listeners of %%event%% or the total number
   *  of listeners if unspecified.
   */
  async listenerCount(e) {
    if (e) {
      const f = await Ds(this, e);
      return f ? f.listeners.length : 0;
    }
    const { subs: r } = en(this);
    let i = 0;
    for (const { listeners: f } of r.values())
      i += f.length;
    return i;
  }
  /**
   *  Resolves to the listeners subscribed to %%event%% or all listeners
   *  if unspecified.
   */
  async listeners(e) {
    if (e) {
      const f = await Ds(this, e);
      return f ? f.listeners.map(({ listener: a }) => a) : [];
    }
    const { subs: r } = en(this);
    let i = [];
    for (const { listeners: f } of r.values())
      i = i.concat(f.map(({ listener: a }) => a));
    return i;
  }
  /**
   *  Remove the %%listener%% from the listeners for %%event%% or remove
   *  all listeners if unspecified.
   */
  async off(e, r) {
    const i = await Ds(this, e);
    if (!i)
      return this;
    if (r) {
      const f = i.listeners.map(({ listener: a }) => a).indexOf(r);
      f >= 0 && i.listeners.splice(f, 1);
    }
    return (r == null || i.listeners.length === 0) && (i.stop(), en(this).subs.delete(i.tag)), this;
  }
  /**
   *  Remove all the listeners for %%event%% or remove all listeners if
   *  unspecified.
   */
  async removeAllListeners(e) {
    if (e) {
      const r = await Ds(this, e);
      if (!r)
        return this;
      r.stop(), en(this).subs.delete(r.tag);
    } else {
      const { subs: r } = en(this);
      for (const { tag: i, stop: f } of r.values())
        f(), r.delete(i);
    }
    return this;
  }
  /**
   *  Alias for [on].
   */
  async addListener(e, r) {
    return await this.on(e, r);
  }
  /**
   *  Alias for [off].
   */
  async removeListener(e, r) {
    return await this.off(e, r);
  }
  /**
   *  Create a new Class for the %%abi%%.
   */
  static buildClass(e) {
    var r;
    return r = class extends pl {
      constructor(f, a = null) {
        super(f, e, a);
      }
    }, ke(r, "CustomContract"), r;
  }
  /**
   *  Create a new BaseContract with a specified Interface.
   */
  static from(e, r, i) {
    return i == null && (i = null), new this(e, r, i);
  }
};
ke(y7, "BaseContract");
var hv = y7;
function b7() {
  return hv;
}
ke(b7, "_ContractBase");
var w7 = class extends b7() {
};
ke(w7, "Contract");
var _7 = w7, x7 = class M7 {
  /**
   *  Create a new **ContractFactory** with %%abi%% and %%bytecode%%,
   *  optionally connected to %%runner%%.
   *
   *  The %%bytecode%% may be the ``bytecode`` property within the
   *  standard Solidity JSON output.
   */
  constructor(e, r, i) {
    Ge(this, "interface"), Ge(this, "bytecode"), Ge(this, "runner");
    const f = Fc.from(e);
    r instanceof Uint8Array || (typeof r == "object" && (r = r.object), r.startsWith("0x") || (r = "0x" + r)), r = mr(vn(r)), $t(this, {
      bytecode: r,
      interface: f,
      runner: i || null
    });
  }
  attach(e) {
    return new hv(e, this.interface, this.runner);
  }
  /**
   *  Resolves to the transaction to deploy the contract, passing %%args%%
   *  into the constructor.
   */
  async getDeployTransaction(...e) {
    let r = {};
    const i = this.interface.deploy;
    if (i.inputs.length + 1 === e.length && (r = await zc(e.pop())), i.inputs.length !== e.length)
      throw new Error("incorrect number of arguments to constructor");
    const f = await dg(this.runner, i.inputs, e), a = ia([
      this.bytecode,
      this.interface.encodeDeploy(f)
    ]);
    return Object.assign({}, r, {
      data: a
    });
  }
  /**
   *  Resolves to the Contract deployed by passing %%args%% into the
   *  constructor.
   *
   *  This will resolve to the Contract before it has been deployed to the
   *  network, so the [[BaseContract-waitForDeployment]] should be used before
   *  sending any transactions to it.
   */
  async deploy(...e) {
    const r = await this.getDeployTransaction(...e);
    Ut(this.runner && typeof this.runner.sendTransaction == "function", "factory runner does not support sending transactions", "UNSUPPORTED_OPERATION", {
      operation: "sendTransaction"
    });
    const i = await this.runner.sendTransaction(r), f = dx(i);
    return new hv(f, this.interface, this.runner, i);
  }
  /**
   *  Return a new **ContractFactory** with the same ABI and bytecode,
   *  but connected to %%runner%%.
   */
  connect(e) {
    return new M7(this.interface, this.bytecode, e);
  }
  /**
   *  Create a new **ContractFactory** from the standard Solidity JSON output.
   */
  static fromSolidity(e, r) {
    Mt(e != null, "bad compiler output", "output", e), typeof e == "string" && (e = JSON.parse(e));
    const i = e.abi;
    let f = "";
    return e.bytecode ? f = e.bytecode : e.evm && e.evm.bytecode && (f = e.evm.bytecode), new this(i, f, r);
  }
};
ke(x7, "ContractFactory");
var DD = x7, vl = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        components: [
          {
            internalType: "address",
            name: "senderAddr",
            type: "address"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "receiverAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "receiverAddrWorkchain",
            type: "int8"
          }
        ],
        indexed: !1,
        internalType: "struct LockPayload",
        name: "lockPayload",
        type: "tuple"
      }
    ],
    name: "Locked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "senderAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "senderAddrWorkchain",
            type: "int8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "receiverAddr",
            type: "address"
          },
          {
            internalType: "address",
            name: "bridgeAddr",
            type: "address"
          }
        ],
        indexed: !1,
        internalType: "struct UnlockPayload",
        name: "unlockPayload",
        type: "tuple"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "externalId",
        type: "uint256"
      }
    ],
    name: "Unlocked",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_validatorAddr",
        type: "address"
      },
      {
        internalType: "address",
        name: "_tokenAddr",
        type: "address"
      }
    ],
    name: "__Bridge_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_newValidatorAddr",
        type: "address"
      }
    ],
    name: "changeValidatorAddr",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "senderAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "senderAddrWorkchain",
            type: "int8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "receiverAddr",
            type: "address"
          },
          {
            internalType: "address",
            name: "bridgeAddr",
            type: "address"
          }
        ],
        internalType: "struct UnlockPayload",
        name: "_unlockPayload",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "externalId",
        type: "uint256"
      }
    ],
    name: "getUnlockPayloadHash",
    outputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    stateMutability: "pure",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "_amount",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "_receiverAddrHash",
        type: "uint256"
      },
      {
        internalType: "int8",
        name: "_receiverAddrWorkchain",
        type: "int8"
      }
    ],
    name: "lock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes32",
        name: "",
        type: "bytes32"
      }
    ],
    name: "pulls",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "tokenAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "bytes",
        name: "_signature",
        type: "bytes"
      },
      {
        components: [
          {
            internalType: "uint256",
            name: "senderAddrHash",
            type: "uint256"
          },
          {
            internalType: "int8",
            name: "senderAddrWorkchain",
            type: "int8"
          },
          {
            internalType: "uint256",
            name: "amount",
            type: "uint256"
          },
          {
            internalType: "address",
            name: "receiverAddr",
            type: "address"
          },
          {
            internalType: "address",
            name: "bridgeAddr",
            type: "address"
          }
        ],
        internalType: "struct UnlockPayload",
        name: "_unlockPayload",
        type: "tuple"
      },
      {
        internalType: "uint256",
        name: "_externalId",
        type: "uint256"
      }
    ],
    name: "unlock",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "validatorAddr",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "_tokenAddr",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], S7 = "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", UD = /* @__PURE__ */ ke((t) => t.length > 1, "isSuperArgs"), Vc = class extends DD {
  constructor(...e) {
    UD(e) ? super(...e) : super(vl, S7, e[0]);
  }
  getDeployTransaction(e) {
    return super.getDeployTransaction(e || {});
  }
  deploy(e) {
    return super.deploy(e || {});
  }
  connect(e) {
    return super.connect(e);
  }
  static createInterface() {
    return new Fc(vl);
  }
  static connect(e, r) {
    return new _7(e, vl, r);
  }
};
ke(Vc, "GagarinMasterBridge__factory");
Ge(Vc, "bytecode", S7);
Ge(Vc, "abi", vl);
var LD = Vc, pv = [
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "lockPeriod",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "alpPerGgr",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "emergencyWithdrawFee",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "uint64",
        name: "apr",
        type: "uint64"
      },
      {
        indexed: !1,
        internalType: "bool",
        name: "isActive",
        type: "bool"
      }
    ],
    name: "CreatePool",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Deposit",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "emergencyWithdrawFee",
        type: "uint256"
      }
    ],
    name: "EmergencyWithdraw",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "uint8",
        name: "version",
        type: "uint8"
      }
    ],
    name: "Initialized",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "address",
        name: "previousOwner",
        type: "address"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "OwnershipTransferred",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Paused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "oldPid",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "uint256",
        name: "newPid",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "ReStake",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !1,
        internalType: "address",
        name: "account",
        type: "address"
      }
    ],
    name: "Unpaused",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "Withdraw",
    type: "event"
  },
  {
    anonymous: !1,
    inputs: [
      {
        indexed: !0,
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      },
      {
        indexed: !0,
        internalType: "address",
        name: "user",
        type: "address"
      },
      {
        indexed: !1,
        internalType: "uint256",
        name: "reward",
        type: "uint256"
      }
    ],
    name: "WithdrawReward",
    type: "event"
  },
  {
    inputs: [],
    name: "GGR",
    outputs: [
      {
        internalType: "contract IERC20Upgradeable",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "PERCENT_DECIMALS",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ggr",
        type: "address"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "__GagarinStaking_init",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "lockPeriod",
        type: "uint256"
      },
      {
        internalType: "uint64",
        name: "alpPerGgr",
        type: "uint64"
      },
      {
        internalType: "uint64",
        name: "emergencyWithdrawFee",
        type: "uint64"
      },
      {
        internalType: "uint64",
        name: "apr",
        type: "uint64"
      },
      {
        internalType: "bool",
        name: "isActive",
        type: "bool"
      }
    ],
    name: "createPool",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      },
      {
        internalType: "uint256",
        name: "amount",
        type: "uint256"
      }
    ],
    name: "deposit",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "emergencyWithdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      }
    ],
    name: "getPool",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "pid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "staked",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "paidReward",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "lockPeriod",
            type: "uint256"
          },
          {
            internalType: "uint64",
            name: "alpPerGgr",
            type: "uint64"
          },
          {
            internalType: "uint64",
            name: "emergencyWithdrawFee",
            type: "uint64"
          },
          {
            internalType: "uint64",
            name: "apr",
            type: "uint64"
          },
          {
            internalType: "bool",
            name: "isActive",
            type: "bool"
          }
        ],
        internalType: "struct GagarinStaking.PoolInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "user",
        type: "address"
      }
    ],
    name: "getUser",
    outputs: [
      {
        components: [
          {
            internalType: "uint256",
            name: "pid",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "stakedAmount",
            type: "uint256"
          },
          {
            internalType: "uint256",
            name: "totalReward",
            type: "uint256"
          },
          {
            internalType: "uint64",
            name: "stakedAt",
            type: "uint64"
          },
          {
            internalType: "uint64",
            name: "lastRewardAt",
            type: "uint64"
          }
        ],
        internalType: "struct GagarinStaking.UserInfo",
        name: "",
        type: "tuple"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "from",
        type: "address"
      },
      {
        internalType: "address",
        name: "to",
        type: "address"
      }
    ],
    name: "moveStakingData",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "owner",
    outputs: [
      {
        internalType: "address",
        name: "",
        type: "address"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "pause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "paused",
    outputs: [
      {
        internalType: "bool",
        name: "",
        type: "bool"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "uint256",
        name: "pid",
        type: "uint256"
      }
    ],
    name: "reStake",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "userAddr",
        type: "address"
      },
      {
        internalType: "uint256",
        name: "timestamp",
        type: "uint256"
      }
    ],
    name: "releasable",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "release",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "renounceOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "ggr",
        type: "address"
      },
      {
        internalType: "address",
        name: "vault",
        type: "address"
      }
    ],
    name: "setAddrs",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "totalPools",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalReward",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [],
    name: "totalStaked",
    outputs: [
      {
        internalType: "uint256",
        name: "",
        type: "uint256"
      }
    ],
    stateMutability: "view",
    type: "function"
  },
  {
    inputs: [
      {
        internalType: "address",
        name: "newOwner",
        type: "address"
      }
    ],
    name: "transferOwnership",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "unpause",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  },
  {
    inputs: [],
    name: "withdraw",
    outputs: [],
    stateMutability: "nonpayable",
    type: "function"
  }
], hg = class {
  static createInterface() {
    return new Fc(pv);
  }
  static connect(e, r) {
    return new _7(e, pv, r);
  }
};
ke(hg, "GagarinStaking__factory");
Ge(hg, "abi", pv);
var FD = hg, E7 = class ml {
  constructor(e, r) {
    Ge(this, "address"), Ge(this, "init"), this.address = e, this.init = r;
  }
  static createFromAddress(e) {
    return new ml(e);
  }
  static createFromConfig(e, r, i = 0) {
    const f = ml.buildDataCellFromConfig(e), a = {
      code: r,
      data: f
    };
    return new ml(At.contractAddress(i, a), a);
  }
  static buildDataCellFromConfig(e) {
    return At.beginCell().storeCoins(e.totalSupply).storeAddress(e.adminAddr).storeRef(e.content).storeRef(e.jettonWalletCode).endCell();
  }
  async sendDeploy(e, r, i) {
    await e.internal(r, {
      value: i,
      sendMode: At.SendMode.PAY_GAS_SEPARATELY,
      body: At.beginCell().endCell()
    });
  }
  async sendMint(e, r, i) {
    return await e.internal(r, {
      value: i.value,
      body: At.beginCell().storeUint(21, 32).storeUint(0, 64).storeAddress(i.address).storeCoins(i.value || At.toNano("0.2")).storeRef(At.beginCell().storeUint(395134233, 32).storeUint(0, 64).storeCoins(i.amount).storeAddress(null).storeAddress(null).storeCoins(0).storeBit(!1).endCell()).endCell()
    });
  }
  static buildBodyChangeAdmin({ admin: e, queryId: r = 0 }) {
    return At.beginCell().storeUint(3, 32).storeUint(r, 64).storeAddress(e).endCell();
  }
  async sendMsg(e, r, i) {
    return await e.internal(r, {
      value: i.value,
      body: i.body
    });
  }
  async getWalletAddress(e, r) {
    const { stack: i } = await e.get("get_wallet_address", [
      {
        type: "slice",
        cell: At.beginCell().storeAddress(r).endCell()
      }
    ]), [f] = [
      i.readAddress()
    ];
    return {
      address: f
    };
  }
  async getJettonData(e) {
    const { stack: r } = await e.get("get_jetton_data", []), [i, f, a, l, d] = [
      r.readBigNumber(),
      r.readBoolean(),
      r.readAddress(),
      r.readCell(),
      r.readCell()
    ];
    return {
      totalSupply: i,
      mintable: f,
      adminAddr: a,
      content: l,
      walletCode: d
    };
  }
};
ke(E7, "J");
var A7 = E7, pg = class gl {
  constructor(e, r) {
    Ge(this, "address"), Ge(this, "init"), this.address = e, this.init = r;
  }
  static createFromAddress(e) {
    return new gl(e);
  }
  static buildSendTransferMsg(e) {
    return At.beginCell().storeUint(gl.OP_CODES.TRANSFER, 32).storeUint(0, 64).storeCoins(e.jettonAmount).storeAddress(e.destAddr).storeAddress(e.responseAddr).storeDict(e.customPayload).storeCoins(e.forwardToncoinAmount).storeMaybeRef(e.forwardPayload || null).endCell();
  }
  async sendTransfer(e, r, i) {
    return await e.internal(r, {
      value: i.coinAmount,
      body: At.beginCell().storeUint(gl.OP_CODES.TRANSFER, 32).storeUint(0, 64).storeCoins(i.jettonAmount).storeAddress(i.destAddr).storeAddress(i.responseAddr).storeDict(i.customPayload).storeCoins(i.forwardToncoinAmount).storeMaybeRef(i.forwardPayload || null).endCell()
    });
  }
  async getBalance(e) {
    if ((await e.getState()).state.type !== "active")
      return {
        amount: 0n
      };
    const { stack: i } = await e.get("get_wallet_data", []), [f] = [
      i.readBigNumber()
    ];
    return {
      amount: f
    };
  }
};
ke(pg, "Jw");
Ge(pg, "OP_CODES", {
  TRANSFER: BigInt(260734629)
});
var k7 = pg, e1 = /* @__PURE__ */ ke((t) => BigInt(`0x${t.toString("hex")}`), "bufToBigInt"), qD = /* @__PURE__ */ ke((t, e) => {
  let r = t.toString(16);
  return e && r.length < e * 2 && (r = "0".repeat(e * 2 - r.length) + r), Je.from(r, "hex");
}, "bigIntToBuf"), $w;
(function(t) {
  t[t.STOPPED = 0] = "STOPPED", t[t.RUNNING = 1] = "RUNNING";
})($w || ($w = {}));
var vg = class cr {
  constructor(e, r) {
    Ge(this, "address"), Ge(this, "init"), this.address = e, this.init = r;
  }
  static createFromAddress(e) {
    return new cr(e);
  }
  static async createFromCfg(e, r, i = 0) {
    const f = await cr.buildDataCellFromCfg(e), a = {
      code: r,
      data: f
    };
    return new cr(At.contractAddress(i, a), a);
  }
  static get poolsDictK() {
    return At.Dictionary.Keys.BigInt(128);
  }
  static get poolsDictV() {
    return At.Dictionary.Values.BigInt(128);
  }
  static get stakesDictK() {
    return At.Dictionary.Keys.BigInt(256);
  }
  static get stakesDictV() {
    return {
      serialize: /* @__PURE__ */ ke((e, r) => {
        r.storeSlice(e.beginParse());
      }, "serialize"),
      parse: cr.parseStake
    };
  }
  static parseStake(e) {
    const r = e.loadUint(8), i = e.loadUintBig(128), f = e.loadUintBig(128), a = e.loadCoins();
    return {
      wc: r,
      lock: i,
      updatedAt: f,
      amount: a
    };
  }
  static async buildDataCellFromCfg(e) {
    const r = At.Dictionary.empty(cr.poolsDictK, cr.poolsDictV);
    e.pools.forEach((a) => {
      r.set(a.lock, a.multiplier);
    });
    const i = At.Dictionary.empty(cr.stakesDictK, cr.stakesDictV);
    e.stakes.forEach((a) => {
      i.set(e1(a.ownerAddr.hash), At.beginCell().storeUint(a.ownerAddr.workChain, 8).storeUint(a.lock, 128).storeUint(a.updatedAt, 128).storeCoins(a.amount).endCell());
    });
    const f = At.beginCell().storeUint(e.state, 4).storeAddress(e.jAddr).storeAddress(e.adminAddr).storeDict(r);
    return e.stakes.length ? f.storeDict(i) : f.storeBit(!1), f.storeRef(e.jwCode).endCell();
  }
  static buildStakeMsgBody({ lock: e }) {
    return At.beginCell().storeUint(cr.OpCodes.STAKE, 32).storeUint(e, 128).endCell();
  }
  static buildWithdrawPayload() {
    return At.beginCell().storeUint(cr.OpCodes.WITHDRAW, 32).storeUint(0, 64).endCell();
  }
  static async buildUpgradePayload({ queryId: e = 0, code: r, data: i }) {
    const f = At.beginCell().storeUint(cr.OpCodes.UPGRADE, 32).storeUint(e, 64).storeRef(r);
    return i && f.storeRef(i), f.endCell();
  }
  static async buildChangeDataPayload({ queryId: e = 0, data: r }) {
    return At.beginCell().storeUint(cr.OpCodes.CHANGE_DATA, 32).storeUint(e, 64).storeRef(await cr.buildDataCellFromCfg(r)).endCell();
  }
  async sendMsg(e, r, i) {
    return await e.internal(r, {
      value: i.value,
      body: i.body
    });
  }
  async sendDeploy(e, r, i) {
    await e.internal(r, {
      value: i,
      sendMode: At.SendMode.PAY_GAS_SEPARATELY,
      body: At.beginCell().endCell()
    });
  }
  async getStoredData(e) {
    const { stack: r } = await e.get("get_stored_data", []), [i, f, a, l, d, v] = [
      r.readNumber(),
      r.readAddress(),
      r.readAddress(),
      r.readCell(),
      r.readCellOpt(),
      r.readCell()
    ], m = At.Dictionary.loadDirect(cr.poolsDictK, cr.poolsDictV, l.beginParse()), h = d ? At.Dictionary.loadDirect(cr.stakesDictK, cr.stakesDictV, d.beginParse()) : At.Dictionary.empty(cr.stakesDictK, cr.stakesDictV), w = m.keys().map((S) => ({
      lock: S,
      multiplier: m.get(S)
    })), M = h.keys().map((S) => {
      const E = h.get(S);
      return {
        ownerAddr: new At.Address(+E.wc.toString(), qD(S, 32)),
        lock: E.lock,
        updatedAt: E.updatedAt,
        amount: E.amount
      };
    });
    return {
      state: i,
      jAddr: f,
      adminAddr: a,
      pools: w,
      stakes: M,
      jwCode: v
    };
  }
  async getPools(e) {
    const { stack: r } = await e.get("get_pools", []), [i] = [
      r.readCell()
    ], f = At.Dictionary.loadDirect(cr.poolsDictK, cr.poolsDictV, i.beginParse());
    return {
      pools: f.keys().map((l) => ({
        lock: l,
        multiplier: f.get(l)
      }))
    };
  }
  async getCalcPenalty(e, { amount: r }) {
    const { stack: i } = await e.get("get_calc_penalty", [
      {
        type: "int",
        value: r
      }
    ]), [f] = [
      i.readBigNumber()
    ];
    return {
      penalty: f
    };
  }
  async getEstimateWithdrawAmount(e, { owner: r }) {
    const { stack: i } = await e.get("get_estimate_withdraw_amount", [
      {
        type: "int",
        value: e1(r.hash)
      }
    ]), [f] = [
      i.readBigNumber()
    ];
    return {
      amount: f
    };
  }
  async getStake(e, { owner: r }) {
    const { stack: i } = await e.get("get_stake", [
      {
        type: "int",
        value: e1(r.hash)
      }
    ]), [f] = [
      i.readCellOpt()
    ], { wc: a, ...l } = cr.parseStake(f.beginParse());
    return {
      stake: {
        ownerAddr: new At.Address(a, r.hash),
        ...l
      }
    };
  }
  async getMultiplierAndStakeAmount(e, { owner: r }) {
    const { pools: i } = await this.getPools(e), { stake: { amount: f, lock: a } } = await this.getStake(e, {
      owner: r
    });
    i.sort((v, m) => v.lock < m.lock ? -1 : 1);
    let l = -1;
    for (let v = 0; v < i.length && i[v].lock <= a; v++)
      l = v;
    return {
      multiplier: l !== -1 ? i[l].multiplier : BigInt(0),
      amount: f
    };
  }
};
ke(vg, "LockPool");
Ge(vg, "OpCodes", {
  STAKE: BigInt(1254833821),
  WITHDRAW: BigInt(2354023824),
  CHANGE_DATA: BigInt(4038890404),
  UPGRADE: BigInt(621263097)
});
Ge(vg, "Errors", {
  BAD_SENDER_JW: 1001,
  STAKE_NOT_FOUND: 1002,
  POOL_NOT_FOUND: 1003,
  STOPPED: 1004,
  BAD_SENDER_ADMIN: 1005
});
var Hc = class yl {
  constructor(e, r) {
    Ge(this, "address"), Ge(this, "init"), this.address = e, this.init = r;
  }
  static createFromAddress(e) {
    return new yl(e);
  }
  static async createFromCfg(e, r, i = 0) {
    const f = await yl.buildDataCellFromCfg(e), a = {
      code: r,
      data: f
    };
    return new yl(At.contractAddress(i, a), a);
  }
  static async buildDataCellFromCfg(e) {
    return At.beginCell().storeUint(e.inited ? 1 : 0, 1).storeUint(e.mintHash, 256).storeAddress(e.bridge).endCell();
  }
  async getStoredData(e) {
    const { stack: r } = await e.get("get_stored_data", []), [i, f, a] = [
      r.readNumber() === 1,
      r.readBigNumber(),
      r.readAddress()
    ];
    return {
      inited: i,
      mintHash: f,
      bridge: a
    };
  }
};
ke(Hc, "MintRecord");
Ge(Hc, "Ops", {
  INIT: BigInt(392720184)
});
Ge(Hc, "Errors", {
  ALREADY_INITED: 2001,
  BAD_SENDER: 2002
});
var zD = Hc, mg = class qi {
  constructor(e, r) {
    Ge(this, "address"), Ge(this, "init"), this.address = e, this.init = r;
  }
  static createFromAddress(e) {
    return new qi(e);
  }
  static async createFromConfig(e, r, i = 0) {
    const f = await qi.buildDataCellFromCfg(e), a = {
      code: r,
      data: f
    };
    return new qi(At.contractAddress(i, a), a);
  }
  static async buildDataCellFromCfg(e) {
    return At.beginCell().storeAddress(e.adminAddr).storeAddress(e.srcJAddr).storeAddress(e.dstJAddr).storeRef(e.srcJwCode).storeRef(e.dstJwCode).endCell();
  }
  static buildSwapPayload() {
    return At.beginCell().storeUint(qi.OpCodes.SWAP, 32).endCell();
  }
  static async buildChangeDataPayload({ queryId: e = 0, data: r }) {
    return At.beginCell().storeUint(qi.OpCodes.CHANGE_DATA, 32).storeUint(e, 64).storeRef(await qi.buildDataCellFromCfg(r)).endCell();
  }
  static async buildUpgradePayload({ queryId: e = 0, code: r, data: i }) {
    const f = At.beginCell().storeUint(qi.OpCodes.UPGRADE, 32).storeUint(e, 64).storeRef(r);
    return i && f.storeRef(i), f.endCell();
  }
  async sendMsg(e, r, i) {
    return await e.internal(r, {
      value: i.value,
      body: i.body
    });
  }
  async sendDeploy(e, r, i) {
    await e.internal(r, {
      value: i,
      sendMode: At.SendMode.PAY_GAS_SEPARATELY,
      body: At.beginCell().endCell()
    });
  }
  async getStoredData(e) {
    const { stack: r } = await e.get("get_stored_data", []), [i, f, a, l, d] = [
      r.readAddress(),
      r.readAddress(),
      r.readAddress(),
      r.readCell(),
      r.readCell()
    ];
    return {
      adminAddr: i,
      srcJAddr: f,
      dstJAddr: a,
      srcJwCode: l,
      dstJwCode: d
    };
  }
};
ke(mg, "Sdlp");
Ge(mg, "OpCodes", {
  SWAP: BigInt(3097994780),
  UPGRADE: BigInt(1951534160),
  CHANGE_DATA: BigInt(3643300756)
});
Ge(mg, "Errors", {
  BAD_SENDER_JW: 1001,
  BAD_SENDER_ADMIN: 1002
});
var Vw;
(function(t) {
  t[t.STOPPED = 0] = "STOPPED", t[t.RUNNING = 1] = "RUNNING";
})(Vw || (Vw = {}));
var cs = class vi {
  constructor(e, r) {
    Ge(this, "address"), Ge(this, "init"), this.address = e, this.init = r;
  }
  static createFromAddress(e) {
    return new vi(e);
  }
  static async createFromCfg(e, r, i = 0) {
    const f = await vi.buildDataCellFromCfg(e), a = {
      code: r,
      data: f
    };
    return new vi(At.contractAddress(i, a), a);
  }
  static async buildDataCellFromCfg(e) {
    return At.beginCell().storeUint(e.state, 4).storeUint(e.validatorPubkey, 256).storeUint(e.masterBridge, 160).storeAddress(e.admin).storeAddress(e.jAddr).storeRef(e.jwCode).storeRef(e.mintRecordCode).endCell();
  }
  static buildBurnPayload({ receiver: e }) {
    return At.beginCell().storeUint(vi.Ops.BURN, 32).storeUint(e, 256).endCell();
  }
  static buildBodyMint({ queryId: e = 0, mintSig: r, mint: i }) {
    return At.beginCell().storeUint(vi.Ops.MINT, 32).storeUint(e, 64).storeBuffer(r, 64).storeRef(At.beginCell().storeUint(i.id, 128).storeUint(i.masterBridge, 160).storeUint(i.time, 64).storeUint(i.sender, 160).storeCoins(i.amount).storeAddress(i.receiver).endCell()).endCell();
  }
  static async buildUpgradePayload({ queryId: e = 0, code: r, data: i }) {
    const f = At.beginCell().storeUint(vi.Ops.UPGRADE, 32).storeUint(e, 64).storeRef(r);
    return i && f.storeRef(i), f.endCell();
  }
  static async buildChangeDataPayload({ queryId: e = 0, data: r }) {
    return At.beginCell().storeUint(vi.Ops.CHANGE_DATA, 32).storeUint(e, 64).storeRef(await vi.buildDataCellFromCfg(r)).endCell();
  }
  async sendMsg(e, r, i) {
    return await e.internal(r, {
      value: i.value,
      body: i.body
    });
  }
  async sendDeploy(e, r, i) {
    await e.internal(r, {
      value: i,
      sendMode: At.SendMode.PAY_GAS_SEPARATELY,
      body: At.beginCell().endCell()
    });
  }
  async getStoredData(e) {
    const { stack: r } = await e.get("get_stored_data", []), [i, f, a, l, d, v, m] = [
      r.readNumber(),
      r.readBigNumber(),
      r.readBigNumber(),
      r.readAddress(),
      r.readAddress(),
      r.readCell(),
      r.readCell()
    ];
    return {
      state: i,
      validatorPubkey: f,
      masterBridge: a,
      admin: l,
      jAddr: d,
      jwCode: v,
      mintRecordCode: m
    };
  }
  async getMintHash(e, r) {
    const { stack: i } = await e.get("get_mint_hash", [
      {
        type: "slice",
        cell: At.beginCell().storeSlice(r[0]).endCell()
      }
    ]), [f] = [
      i.readBigNumber()
    ];
    return f;
  }
  async getMintRecord(e, r) {
    const { stack: i } = await e.get("get_mint_record", [
      {
        type: "int",
        value: r[0]
      }
    ]), [f] = [
      i.readAddress()
    ];
    return zD.createFromAddress(f);
  }
};
ke(cs, "SlaveBridge");
Ge(cs, "Ops", {
  MINT: BigInt(945679012),
  BURN: BigInt(1847002305),
  CHANGE_DATA: BigInt(3286364478),
  UPGRADE: BigInt(3182705805)
});
Ge(cs, "Logs", {
  MINT: BigInt(613941062),
  BURN: BigInt(1927090467)
});
Ge(cs, "Errors", {
  BAD_SENDER_JW: 1001,
  BAD_SENDER_MINT_RECORD: 1002,
  BAD_SIGNATURE: 1003,
  BAD_MASTER_BRIDGE: 1004,
  BAD_MSG_VALUE: 1005,
  BAD_SENDER_ADMIN: 1006,
  STOPPED: 1007
});
Ge(cs, "buildMint", /* @__PURE__ */ ke(async ({ slaveBridge: t, validatorSecret: e, mint: { id: r, masterBridge: i, time: f, sender: a, amount: l, receiver: d } }) => {
  const v = cs.buildBodyMint({
    mintSig: Je.alloc(64),
    mint: {
      id: r,
      masterBridge: i,
      time: f,
      sender: a,
      amount: l,
      receiver: d
    }
  }).beginParse().loadRef().beginParse(), m = await t.getMintHash([
    v
  ]);
  return {
    mintSig: await xN.sign(Je.from(m.toString(16), "hex"), e),
    mintSlice: v,
    mintHash: m,
    mint: {
      id: r,
      masterBridge: i,
      time: f,
      sender: a,
      amount: l,
      receiver: d
    }
  };
}, "buildMint"));
var T7 = cs;
/*! Bundled license information:

@noble/hashes/esm/utils.js:
  (*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) *)
*/
var dn = {}, au = {}, Wc = {};
Object.defineProperty(Wc, "__esModule", { value: !0 });
Wc.InMemoryCache = void 0;
class jD {
  constructor() {
    this.cache = /* @__PURE__ */ new Map(), this.set = async (e, r, i) => {
      i !== null ? this.cache.set(e + "$$" + r, i) : this.cache.delete(e + "$$" + r);
    }, this.get = async (e, r) => {
      let i = this.cache.get(e + "$$" + r);
      return i !== void 0 ? i : null;
    };
  }
}
Wc.InMemoryCache = jD;
var $D = /* @__PURE__ */ function() {
  function t(r, i) {
    if (typeof r != "function")
      throw new TypeError("DataLoader must be constructed with a function which accepts " + ("Array<key> and returns Promise<Array<value>>, but got: " + r + "."));
    this._batchLoadFn = r, this._maxBatchSize = KD(i), this._batchScheduleFn = ZD(i), this._cacheKeyFn = GD(i), this._cacheMap = QD(i), this._batch = null, this.name = YD(i);
  }
  var e = t.prototype;
  return e.load = function(i) {
    if (i == null)
      throw new TypeError("The loader.load() function must be called with a value, " + ("but got: " + String(i) + "."));
    var f = HD(this), a = this._cacheMap, l = this._cacheKeyFn(i);
    if (a) {
      var d = a.get(l);
      if (d) {
        var v = f.cacheHits || (f.cacheHits = []);
        return new Promise(function(h) {
          v.push(function() {
            h(d);
          });
        });
      }
    }
    f.keys.push(i);
    var m = new Promise(function(h, w) {
      f.callbacks.push({
        resolve: h,
        reject: w
      });
    });
    return a && a.set(l, m), m;
  }, e.loadMany = function(i) {
    if (!C7(i))
      throw new TypeError("The loader.loadMany() function must be called with Array<key> " + ("but got: " + i + "."));
    for (var f = [], a = 0; a < i.length; a++)
      f.push(this.load(i[a]).catch(function(l) {
        return l;
      }));
    return Promise.all(f);
  }, e.clear = function(i) {
    var f = this._cacheMap;
    if (f) {
      var a = this._cacheKeyFn(i);
      f.delete(a);
    }
    return this;
  }, e.clearAll = function() {
    var i = this._cacheMap;
    return i && i.clear(), this;
  }, e.prime = function(i, f) {
    var a = this._cacheMap;
    if (a) {
      var l = this._cacheKeyFn(i);
      if (a.get(l) === void 0) {
        var d;
        f instanceof Error ? (d = Promise.reject(f), d.catch(function() {
        })) : d = Promise.resolve(f), a.set(l, d);
      }
    }
    return this;
  }, t;
}(), VD = typeof It == "object" && typeof It.nextTick == "function" ? function(t) {
  t1 || (t1 = Promise.resolve()), t1.then(function() {
    It.nextTick(t);
  });
} : typeof setImmediate == "function" ? function(t) {
  setImmediate(t);
} : function(t) {
  setTimeout(t);
}, t1;
function HD(t) {
  var e = t._batch;
  if (e !== null && !e.hasDispatched && e.keys.length < t._maxBatchSize)
    return e;
  var r = {
    hasDispatched: !1,
    keys: [],
    callbacks: []
  };
  return t._batch = r, t._batchScheduleFn(function() {
    WD(t, r);
  }), r;
}
function WD(t, e) {
  if (e.hasDispatched = !0, e.keys.length === 0) {
    vv(e);
    return;
  }
  var r;
  try {
    r = t._batchLoadFn(e.keys);
  } catch (i) {
    return r1(t, e, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function " + ("errored synchronously: " + String(i) + ".")));
  }
  if (!r || typeof r.then != "function")
    return r1(t, e, new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise: " + String(r) + ".")));
  r.then(function(i) {
    if (!C7(i))
      throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did " + ("not return a Promise of an Array: " + String(i) + "."));
    if (i.length !== e.keys.length)
      throw new TypeError("DataLoader must be constructed with a function which accepts Array<key> and returns Promise<Array<value>>, but the function did not return a Promise of an Array of the same length as the Array of keys." + (`

Keys:
` + String(e.keys)) + (`

Values:
` + String(i)));
    vv(e);
    for (var f = 0; f < e.callbacks.length; f++) {
      var a = i[f];
      a instanceof Error ? e.callbacks[f].reject(a) : e.callbacks[f].resolve(a);
    }
  }).catch(function(i) {
    r1(t, e, i);
  });
}
function r1(t, e, r) {
  vv(e);
  for (var i = 0; i < e.keys.length; i++)
    t.clear(e.keys[i]), e.callbacks[i].reject(r);
}
function vv(t) {
  if (t.cacheHits)
    for (var e = 0; e < t.cacheHits.length; e++)
      t.cacheHits[e]();
}
function KD(t) {
  var e = !t || t.batch !== !1;
  if (!e)
    return 1;
  var r = t && t.maxBatchSize;
  if (r === void 0)
    return 1 / 0;
  if (typeof r != "number" || r < 1)
    throw new TypeError("maxBatchSize must be a positive number: " + r);
  return r;
}
function ZD(t) {
  var e = t && t.batchScheduleFn;
  if (e === void 0)
    return VD;
  if (typeof e != "function")
    throw new TypeError("batchScheduleFn must be a function: " + e);
  return e;
}
function GD(t) {
  var e = t && t.cacheKeyFn;
  if (e === void 0)
    return function(r) {
      return r;
    };
  if (typeof e != "function")
    throw new TypeError("cacheKeyFn must be a function: " + e);
  return e;
}
function QD(t) {
  var e = !t || t.cache !== !1;
  if (!e)
    return null;
  var r = t && t.cacheMap;
  if (r === void 0)
    return /* @__PURE__ */ new Map();
  if (r !== null) {
    var i = ["get", "set", "delete", "clear"], f = i.filter(function(a) {
      return r && typeof r[a] != "function";
    });
    if (f.length !== 0)
      throw new TypeError("Custom cacheMap missing methods: " + f.join(", "));
  }
  return r;
}
function YD(t) {
  return t && t.name ? t.name : null;
}
function C7(t) {
  return typeof t == "object" && t !== null && typeof t.length == "number" && (t.length === 0 || t.length > 0 && Object.prototype.hasOwnProperty.call(t, t.length - 1));
}
var JD = $D;
function B7(t, e) {
  return function() {
    return t.apply(e, arguments);
  };
}
const { toString: XD } = Object.prototype, { getPrototypeOf: gg } = Object, Kc = /* @__PURE__ */ ((t) => (e) => {
  const r = XD.call(e);
  return t[r] || (t[r] = r.slice(8, -1).toLowerCase());
})(/* @__PURE__ */ Object.create(null)), jn = (t) => (t = t.toLowerCase(), (e) => Kc(e) === t), Zc = (t) => (e) => typeof e === t, { isArray: _o } = Array, Of = Zc("undefined");
function eU(t) {
  return t !== null && !Of(t) && t.constructor !== null && !Of(t.constructor) && Sn(t.constructor.isBuffer) && t.constructor.isBuffer(t);
}
const I7 = jn("ArrayBuffer");
function tU(t) {
  let e;
  return typeof ArrayBuffer < "u" && ArrayBuffer.isView ? e = ArrayBuffer.isView(t) : e = t && t.buffer && I7(t.buffer), e;
}
const rU = Zc("string"), Sn = Zc("function"), R7 = Zc("number"), Gc = (t) => t !== null && typeof t == "object", nU = (t) => t === !0 || t === !1, bl = (t) => {
  if (Kc(t) !== "object")
    return !1;
  const e = gg(t);
  return (e === null || e === Object.prototype || Object.getPrototypeOf(e) === null) && !(Symbol.toStringTag in t) && !(Symbol.iterator in t);
}, iU = jn("Date"), aU = jn("File"), sU = jn("Blob"), oU = jn("FileList"), fU = (t) => Gc(t) && Sn(t.pipe), uU = (t) => {
  let e;
  return t && (typeof FormData == "function" && t instanceof FormData || Sn(t.append) && ((e = Kc(t)) === "formdata" || // detect form-data instance
  e === "object" && Sn(t.toString) && t.toString() === "[object FormData]"));
}, lU = jn("URLSearchParams"), [cU, dU, hU, pU] = ["ReadableStream", "Request", "Response", "Headers"].map(jn), vU = (t) => t.trim ? t.trim() : t.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
function su(t, e, { allOwnKeys: r = !1 } = {}) {
  if (t === null || typeof t > "u")
    return;
  let i, f;
  if (typeof t != "object" && (t = [t]), _o(t))
    for (i = 0, f = t.length; i < f; i++)
      e.call(null, t[i], i, t);
  else {
    const a = r ? Object.getOwnPropertyNames(t) : Object.keys(t), l = a.length;
    let d;
    for (i = 0; i < l; i++)
      d = a[i], e.call(null, t[d], d, t);
  }
}
function P7(t, e) {
  e = e.toLowerCase();
  const r = Object.keys(t);
  let i = r.length, f;
  for (; i-- > 0; )
    if (f = r[i], e === f.toLowerCase())
      return f;
  return null;
}
const O7 = typeof globalThis < "u" ? globalThis : typeof self < "u" ? self : typeof window < "u" ? window : ut, N7 = (t) => !Of(t) && t !== O7;
function mv() {
  const { caseless: t } = N7(this) && this || {}, e = {}, r = (i, f) => {
    const a = t && P7(e, f) || f;
    bl(e[a]) && bl(i) ? e[a] = mv(e[a], i) : bl(i) ? e[a] = mv({}, i) : _o(i) ? e[a] = i.slice() : e[a] = i;
  };
  for (let i = 0, f = arguments.length; i < f; i++)
    arguments[i] && su(arguments[i], r);
  return e;
}
const mU = (t, e, r, { allOwnKeys: i } = {}) => (su(e, (f, a) => {
  r && Sn(f) ? t[a] = B7(f, r) : t[a] = f;
}, { allOwnKeys: i }), t), gU = (t) => (t.charCodeAt(0) === 65279 && (t = t.slice(1)), t), yU = (t, e, r, i) => {
  t.prototype = Object.create(e.prototype, i), t.prototype.constructor = t, Object.defineProperty(t, "super", {
    value: e.prototype
  }), r && Object.assign(t.prototype, r);
}, bU = (t, e, r, i) => {
  let f, a, l;
  const d = {};
  if (e = e || {}, t == null)
    return e;
  do {
    for (f = Object.getOwnPropertyNames(t), a = f.length; a-- > 0; )
      l = f[a], (!i || i(l, t, e)) && !d[l] && (e[l] = t[l], d[l] = !0);
    t = r !== !1 && gg(t);
  } while (t && (!r || r(t, e)) && t !== Object.prototype);
  return e;
}, wU = (t, e, r) => {
  t = String(t), (r === void 0 || r > t.length) && (r = t.length), r -= e.length;
  const i = t.indexOf(e, r);
  return i !== -1 && i === r;
}, _U = (t) => {
  if (!t)
    return null;
  if (_o(t))
    return t;
  let e = t.length;
  if (!R7(e))
    return null;
  const r = new Array(e);
  for (; e-- > 0; )
    r[e] = t[e];
  return r;
}, xU = /* @__PURE__ */ ((t) => (e) => t && e instanceof t)(typeof Uint8Array < "u" && gg(Uint8Array)), MU = (t, e) => {
  const i = (t && t[Symbol.iterator]).call(t);
  let f;
  for (; (f = i.next()) && !f.done; ) {
    const a = f.value;
    e.call(t, a[0], a[1]);
  }
}, SU = (t, e) => {
  let r;
  const i = [];
  for (; (r = t.exec(e)) !== null; )
    i.push(r);
  return i;
}, EU = jn("HTMLFormElement"), AU = (t) => t.toLowerCase().replace(
  /[-_\s]([a-z\d])(\w*)/g,
  function(r, i, f) {
    return i.toUpperCase() + f;
  }
), Hw = (({ hasOwnProperty: t }) => (e, r) => t.call(e, r))(Object.prototype), kU = jn("RegExp"), D7 = (t, e) => {
  const r = Object.getOwnPropertyDescriptors(t), i = {};
  su(r, (f, a) => {
    let l;
    (l = e(f, a, t)) !== !1 && (i[a] = l || f);
  }), Object.defineProperties(t, i);
}, TU = (t) => {
  D7(t, (e, r) => {
    if (Sn(t) && ["arguments", "caller", "callee"].indexOf(r) !== -1)
      return !1;
    const i = t[r];
    if (Sn(i)) {
      if (e.enumerable = !1, "writable" in e) {
        e.writable = !1;
        return;
      }
      e.set || (e.set = () => {
        throw Error("Can not rewrite read-only method '" + r + "'");
      });
    }
  });
}, CU = (t, e) => {
  const r = {}, i = (f) => {
    f.forEach((a) => {
      r[a] = !0;
    });
  };
  return _o(t) ? i(t) : i(String(t).split(e)), r;
}, BU = () => {
}, IU = (t, e) => t != null && Number.isFinite(t = +t) ? t : e, n1 = "abcdefghijklmnopqrstuvwxyz", Ww = "0123456789", U7 = {
  DIGIT: Ww,
  ALPHA: n1,
  ALPHA_DIGIT: n1 + n1.toUpperCase() + Ww
}, RU = (t = 16, e = U7.ALPHA_DIGIT) => {
  let r = "";
  const { length: i } = e;
  for (; t--; )
    r += e[Math.random() * i | 0];
  return r;
};
function PU(t) {
  return !!(t && Sn(t.append) && t[Symbol.toStringTag] === "FormData" && t[Symbol.iterator]);
}
const OU = (t) => {
  const e = new Array(10), r = (i, f) => {
    if (Gc(i)) {
      if (e.indexOf(i) >= 0)
        return;
      if (!("toJSON" in i)) {
        e[f] = i;
        const a = _o(i) ? [] : {};
        return su(i, (l, d) => {
          const v = r(l, f + 1);
          !Of(v) && (a[d] = v);
        }), e[f] = void 0, a;
      }
    }
    return i;
  };
  return r(t, 0);
}, NU = jn("AsyncFunction"), DU = (t) => t && (Gc(t) || Sn(t)) && Sn(t.then) && Sn(t.catch);
var et = {
  isArray: _o,
  isArrayBuffer: I7,
  isBuffer: eU,
  isFormData: uU,
  isArrayBufferView: tU,
  isString: rU,
  isNumber: R7,
  isBoolean: nU,
  isObject: Gc,
  isPlainObject: bl,
  isReadableStream: cU,
  isRequest: dU,
  isResponse: hU,
  isHeaders: pU,
  isUndefined: Of,
  isDate: iU,
  isFile: aU,
  isBlob: sU,
  isRegExp: kU,
  isFunction: Sn,
  isStream: fU,
  isURLSearchParams: lU,
  isTypedArray: xU,
  isFileList: oU,
  forEach: su,
  merge: mv,
  extend: mU,
  trim: vU,
  stripBOM: gU,
  inherits: yU,
  toFlatObject: bU,
  kindOf: Kc,
  kindOfTest: jn,
  endsWith: wU,
  toArray: _U,
  forEachEntry: MU,
  matchAll: SU,
  isHTMLForm: EU,
  hasOwnProperty: Hw,
  hasOwnProp: Hw,
  // an alias to avoid ESLint no-prototype-builtins detection
  reduceDescriptors: D7,
  freezeMethods: TU,
  toObjectSet: CU,
  toCamelCase: AU,
  noop: BU,
  toFiniteNumber: IU,
  findKey: P7,
  global: O7,
  isContextDefined: N7,
  ALPHABET: U7,
  generateString: RU,
  isSpecCompliantForm: PU,
  toJSONObject: OU,
  isAsyncFn: NU,
  isThenable: DU
};
function qt(t, e, r, i, f) {
  Error.call(this), Error.captureStackTrace ? Error.captureStackTrace(this, this.constructor) : this.stack = new Error().stack, this.message = t, this.name = "AxiosError", e && (this.code = e), r && (this.config = r), i && (this.request = i), f && (this.response = f);
}
et.inherits(qt, Error, {
  toJSON: function() {
    return {
      // Standard
      message: this.message,
      name: this.name,
      // Microsoft
      description: this.description,
      number: this.number,
      // Mozilla
      fileName: this.fileName,
      lineNumber: this.lineNumber,
      columnNumber: this.columnNumber,
      stack: this.stack,
      // Axios
      config: et.toJSONObject(this.config),
      code: this.code,
      status: this.response && this.response.status ? this.response.status : null
    };
  }
});
const L7 = qt.prototype, F7 = {};
[
  "ERR_BAD_OPTION_VALUE",
  "ERR_BAD_OPTION",
  "ECONNABORTED",
  "ETIMEDOUT",
  "ERR_NETWORK",
  "ERR_FR_TOO_MANY_REDIRECTS",
  "ERR_DEPRECATED",
  "ERR_BAD_RESPONSE",
  "ERR_BAD_REQUEST",
  "ERR_CANCELED",
  "ERR_NOT_SUPPORT",
  "ERR_INVALID_URL"
  // eslint-disable-next-line func-names
].forEach((t) => {
  F7[t] = { value: t };
});
Object.defineProperties(qt, F7);
Object.defineProperty(L7, "isAxiosError", { value: !0 });
qt.from = (t, e, r, i, f, a) => {
  const l = Object.create(L7);
  return et.toFlatObject(t, l, function(v) {
    return v !== Error.prototype;
  }, (d) => d !== "isAxiosError"), qt.call(l, t.message, e, r, i, f), l.cause = t, l.name = t.name, a && Object.assign(l, a), l;
};
var UU = null;
function gv(t) {
  return et.isPlainObject(t) || et.isArray(t);
}
function q7(t) {
  return et.endsWith(t, "[]") ? t.slice(0, -2) : t;
}
function Kw(t, e, r) {
  return t ? t.concat(e).map(function(f, a) {
    return f = q7(f), !r && a ? "[" + f + "]" : f;
  }).join(r ? "." : "") : e;
}
function LU(t) {
  return et.isArray(t) && !t.some(gv);
}
const FU = et.toFlatObject(et, {}, null, function(e) {
  return /^is[A-Z]/.test(e);
});
function Qc(t, e, r) {
  if (!et.isObject(t))
    throw new TypeError("target must be an object");
  e = e || new FormData(), r = et.toFlatObject(r, {
    metaTokens: !0,
    dots: !1,
    indexes: !1
  }, !1, function(A, B) {
    return !et.isUndefined(B[A]);
  });
  const i = r.metaTokens, f = r.visitor || h, a = r.dots, l = r.indexes, v = (r.Blob || typeof Blob < "u" && Blob) && et.isSpecCompliantForm(e);
  if (!et.isFunction(f))
    throw new TypeError("visitor must be a function");
  function m(E) {
    if (E === null)
      return "";
    if (et.isDate(E))
      return E.toISOString();
    if (!v && et.isBlob(E))
      throw new qt("Blob is not supported. Use a Buffer instead.");
    return et.isArrayBuffer(E) || et.isTypedArray(E) ? v && typeof Blob == "function" ? new Blob([E]) : Je.from(E) : E;
  }
  function h(E, A, B) {
    let k = E;
    if (E && !B && typeof E == "object") {
      if (et.endsWith(A, "{}"))
        A = i ? A : A.slice(0, -2), E = JSON.stringify(E);
      else if (et.isArray(E) && LU(E) || (et.isFileList(E) || et.endsWith(A, "[]")) && (k = et.toArray(E)))
        return A = q7(A), k.forEach(function(I, O) {
          !(et.isUndefined(I) || I === null) && e.append(
            // eslint-disable-next-line no-nested-ternary
            l === !0 ? Kw([A], O, a) : l === null ? A : A + "[]",
            m(I)
          );
        }), !1;
    }
    return gv(E) ? !0 : (e.append(Kw(B, A, a), m(E)), !1);
  }
  const w = [], M = Object.assign(FU, {
    defaultVisitor: h,
    convertValue: m,
    isVisitable: gv
  });
  function S(E, A) {
    if (!et.isUndefined(E)) {
      if (w.indexOf(E) !== -1)
        throw Error("Circular reference detected in " + A.join("."));
      w.push(E), et.forEach(E, function(k, C) {
        (!(et.isUndefined(k) || k === null) && f.call(
          e,
          k,
          et.isString(C) ? C.trim() : C,
          A,
          M
        )) === !0 && S(k, A ? A.concat(C) : [C]);
      }), w.pop();
    }
  }
  if (!et.isObject(t))
    throw new TypeError("data must be an object");
  return S(t), e;
}
function Zw(t) {
  const e = {
    "!": "%21",
    "'": "%27",
    "(": "%28",
    ")": "%29",
    "~": "%7E",
    "%20": "+",
    "%00": "\0"
  };
  return encodeURIComponent(t).replace(/[!'()~]|%20|%00/g, function(i) {
    return e[i];
  });
}
function yg(t, e) {
  this._pairs = [], t && Qc(t, this, e);
}
const z7 = yg.prototype;
z7.append = function(e, r) {
  this._pairs.push([e, r]);
};
z7.toString = function(e) {
  const r = e ? function(i) {
    return e.call(this, i, Zw);
  } : Zw;
  return this._pairs.map(function(f) {
    return r(f[0]) + "=" + r(f[1]);
  }, "").join("&");
};
function qU(t) {
  return encodeURIComponent(t).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function j7(t, e, r) {
  if (!e)
    return t;
  const i = r && r.encode || qU, f = r && r.serialize;
  let a;
  if (f ? a = f(e, r) : a = et.isURLSearchParams(e) ? e.toString() : new yg(e, r).toString(i), a) {
    const l = t.indexOf("#");
    l !== -1 && (t = t.slice(0, l)), t += (t.indexOf("?") === -1 ? "?" : "&") + a;
  }
  return t;
}
class zU {
  constructor() {
    this.handlers = [];
  }
  /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */
  use(e, r, i) {
    return this.handlers.push({
      fulfilled: e,
      rejected: r,
      synchronous: i ? i.synchronous : !1,
      runWhen: i ? i.runWhen : null
    }), this.handlers.length - 1;
  }
  /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */
  eject(e) {
    this.handlers[e] && (this.handlers[e] = null);
  }
  /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */
  clear() {
    this.handlers && (this.handlers = []);
  }
  /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */
  forEach(e) {
    et.forEach(this.handlers, function(i) {
      i !== null && e(i);
    });
  }
}
var Gw = zU, $7 = {
  silentJSONParsing: !0,
  forcedJSONParsing: !0,
  clarifyTimeoutError: !1
}, jU = typeof URLSearchParams < "u" ? URLSearchParams : yg, $U = typeof FormData < "u" ? FormData : null, VU = typeof Blob < "u" ? Blob : null, HU = {
  isBrowser: !0,
  classes: {
    URLSearchParams: jU,
    FormData: $U,
    Blob: VU
  },
  protocols: ["http", "https", "file", "blob", "url", "data"]
};
const bg = typeof window < "u" && typeof document < "u", WU = ((t) => bg && ["ReactNative", "NativeScript", "NS"].indexOf(t) < 0)(typeof navigator < "u" && navigator.product), KU = typeof WorkerGlobalScope < "u" && // eslint-disable-next-line no-undef
self instanceof WorkerGlobalScope && typeof self.importScripts == "function", ZU = bg && window.location.href || "http://localhost";
var GU = /* @__PURE__ */ Object.freeze({
  __proto__: null,
  hasBrowserEnv: bg,
  hasStandardBrowserWebWorkerEnv: KU,
  hasStandardBrowserEnv: WU,
  origin: ZU
}), Dn = {
  ...GU,
  ...HU
};
function QU(t, e) {
  return Qc(t, new Dn.classes.URLSearchParams(), Object.assign({
    visitor: function(r, i, f, a) {
      return Dn.isNode && et.isBuffer(r) ? (this.append(i, r.toString("base64")), !1) : a.defaultVisitor.apply(this, arguments);
    }
  }, e));
}
function YU(t) {
  return et.matchAll(/\w+|\[(\w*)]/g, t).map((e) => e[0] === "[]" ? "" : e[1] || e[0]);
}
function JU(t) {
  const e = {}, r = Object.keys(t);
  let i;
  const f = r.length;
  let a;
  for (i = 0; i < f; i++)
    a = r[i], e[a] = t[a];
  return e;
}
function V7(t) {
  function e(r, i, f, a) {
    let l = r[a++];
    if (l === "__proto__")
      return !0;
    const d = Number.isFinite(+l), v = a >= r.length;
    return l = !l && et.isArray(f) ? f.length : l, v ? (et.hasOwnProp(f, l) ? f[l] = [f[l], i] : f[l] = i, !d) : ((!f[l] || !et.isObject(f[l])) && (f[l] = []), e(r, i, f[l], a) && et.isArray(f[l]) && (f[l] = JU(f[l])), !d);
  }
  if (et.isFormData(t) && et.isFunction(t.entries)) {
    const r = {};
    return et.forEachEntry(t, (i, f) => {
      e(YU(i), f, r, 0);
    }), r;
  }
  return null;
}
function XU(t, e, r) {
  if (et.isString(t))
    try {
      return (e || JSON.parse)(t), et.trim(t);
    } catch (i) {
      if (i.name !== "SyntaxError")
        throw i;
    }
  return (0, JSON.stringify)(t);
}
const wg = {
  transitional: $7,
  adapter: ["xhr", "http", "fetch"],
  transformRequest: [function(e, r) {
    const i = r.getContentType() || "", f = i.indexOf("application/json") > -1, a = et.isObject(e);
    if (a && et.isHTMLForm(e) && (e = new FormData(e)), et.isFormData(e))
      return f ? JSON.stringify(V7(e)) : e;
    if (et.isArrayBuffer(e) || et.isBuffer(e) || et.isStream(e) || et.isFile(e) || et.isBlob(e) || et.isReadableStream(e))
      return e;
    if (et.isArrayBufferView(e))
      return e.buffer;
    if (et.isURLSearchParams(e))
      return r.setContentType("application/x-www-form-urlencoded;charset=utf-8", !1), e.toString();
    let d;
    if (a) {
      if (i.indexOf("application/x-www-form-urlencoded") > -1)
        return QU(e, this.formSerializer).toString();
      if ((d = et.isFileList(e)) || i.indexOf("multipart/form-data") > -1) {
        const v = this.env && this.env.FormData;
        return Qc(
          d ? { "files[]": e } : e,
          v && new v(),
          this.formSerializer
        );
      }
    }
    return a || f ? (r.setContentType("application/json", !1), XU(e)) : e;
  }],
  transformResponse: [function(e) {
    const r = this.transitional || wg.transitional, i = r && r.forcedJSONParsing, f = this.responseType === "json";
    if (et.isResponse(e) || et.isReadableStream(e))
      return e;
    if (e && et.isString(e) && (i && !this.responseType || f)) {
      const l = !(r && r.silentJSONParsing) && f;
      try {
        return JSON.parse(e);
      } catch (d) {
        if (l)
          throw d.name === "SyntaxError" ? qt.from(d, qt.ERR_BAD_RESPONSE, this, null, this.response) : d;
      }
    }
    return e;
  }],
  /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */
  timeout: 0,
  xsrfCookieName: "XSRF-TOKEN",
  xsrfHeaderName: "X-XSRF-TOKEN",
  maxContentLength: -1,
  maxBodyLength: -1,
  env: {
    FormData: Dn.classes.FormData,
    Blob: Dn.classes.Blob
  },
  validateStatus: function(e) {
    return e >= 200 && e < 300;
  },
  headers: {
    common: {
      Accept: "application/json, text/plain, */*",
      "Content-Type": void 0
    }
  }
};
et.forEach(["delete", "get", "head", "post", "put", "patch"], (t) => {
  wg.headers[t] = {};
});
var _g = wg;
const eL = et.toObjectSet([
  "age",
  "authorization",
  "content-length",
  "content-type",
  "etag",
  "expires",
  "from",
  "host",
  "if-modified-since",
  "if-unmodified-since",
  "last-modified",
  "location",
  "max-forwards",
  "proxy-authorization",
  "referer",
  "retry-after",
  "user-agent"
]);
var tL = (t) => {
  const e = {};
  let r, i, f;
  return t && t.split(`
`).forEach(function(l) {
    f = l.indexOf(":"), r = l.substring(0, f).trim().toLowerCase(), i = l.substring(f + 1).trim(), !(!r || e[r] && eL[r]) && (r === "set-cookie" ? e[r] ? e[r].push(i) : e[r] = [i] : e[r] = e[r] ? e[r] + ", " + i : i);
  }), e;
};
const Qw = Symbol("internals");
function $o(t) {
  return t && String(t).trim().toLowerCase();
}
function wl(t) {
  return t === !1 || t == null ? t : et.isArray(t) ? t.map(wl) : String(t);
}
function rL(t) {
  const e = /* @__PURE__ */ Object.create(null), r = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
  let i;
  for (; i = r.exec(t); )
    e[i[1]] = i[2];
  return e;
}
const nL = (t) => /^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(t.trim());
function i1(t, e, r, i, f) {
  if (et.isFunction(i))
    return i.call(this, e, r);
  if (f && (e = r), !!et.isString(e)) {
    if (et.isString(i))
      return e.indexOf(i) !== -1;
    if (et.isRegExp(i))
      return i.test(e);
  }
}
function iL(t) {
  return t.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (e, r, i) => r.toUpperCase() + i);
}
function aL(t, e) {
  const r = et.toCamelCase(" " + e);
  ["get", "set", "has"].forEach((i) => {
    Object.defineProperty(t, i + r, {
      value: function(f, a, l) {
        return this[i].call(this, e, f, a, l);
      },
      configurable: !0
    });
  });
}
class Yc {
  constructor(e) {
    e && this.set(e);
  }
  set(e, r, i) {
    const f = this;
    function a(d, v, m) {
      const h = $o(v);
      if (!h)
        throw new Error("header name must be a non-empty string");
      const w = et.findKey(f, h);
      (!w || f[w] === void 0 || m === !0 || m === void 0 && f[w] !== !1) && (f[w || v] = wl(d));
    }
    const l = (d, v) => et.forEach(d, (m, h) => a(m, h, v));
    if (et.isPlainObject(e) || e instanceof this.constructor)
      l(e, r);
    else if (et.isString(e) && (e = e.trim()) && !nL(e))
      l(tL(e), r);
    else if (et.isHeaders(e))
      for (const [d, v] of e.entries())
        a(v, d, i);
    else
      e != null && a(r, e, i);
    return this;
  }
  get(e, r) {
    if (e = $o(e), e) {
      const i = et.findKey(this, e);
      if (i) {
        const f = this[i];
        if (!r)
          return f;
        if (r === !0)
          return rL(f);
        if (et.isFunction(r))
          return r.call(this, f, i);
        if (et.isRegExp(r))
          return r.exec(f);
        throw new TypeError("parser must be boolean|regexp|function");
      }
    }
  }
  has(e, r) {
    if (e = $o(e), e) {
      const i = et.findKey(this, e);
      return !!(i && this[i] !== void 0 && (!r || i1(this, this[i], i, r)));
    }
    return !1;
  }
  delete(e, r) {
    const i = this;
    let f = !1;
    function a(l) {
      if (l = $o(l), l) {
        const d = et.findKey(i, l);
        d && (!r || i1(i, i[d], d, r)) && (delete i[d], f = !0);
      }
    }
    return et.isArray(e) ? e.forEach(a) : a(e), f;
  }
  clear(e) {
    const r = Object.keys(this);
    let i = r.length, f = !1;
    for (; i--; ) {
      const a = r[i];
      (!e || i1(this, this[a], a, e, !0)) && (delete this[a], f = !0);
    }
    return f;
  }
  normalize(e) {
    const r = this, i = {};
    return et.forEach(this, (f, a) => {
      const l = et.findKey(i, a);
      if (l) {
        r[l] = wl(f), delete r[a];
        return;
      }
      const d = e ? iL(a) : String(a).trim();
      d !== a && delete r[a], r[d] = wl(f), i[d] = !0;
    }), this;
  }
  concat(...e) {
    return this.constructor.concat(this, ...e);
  }
  toJSON(e) {
    const r = /* @__PURE__ */ Object.create(null);
    return et.forEach(this, (i, f) => {
      i != null && i !== !1 && (r[f] = e && et.isArray(i) ? i.join(", ") : i);
    }), r;
  }
  [Symbol.iterator]() {
    return Object.entries(this.toJSON())[Symbol.iterator]();
  }
  toString() {
    return Object.entries(this.toJSON()).map(([e, r]) => e + ": " + r).join(`
`);
  }
  get [Symbol.toStringTag]() {
    return "AxiosHeaders";
  }
  static from(e) {
    return e instanceof this ? e : new this(e);
  }
  static concat(e, ...r) {
    const i = new this(e);
    return r.forEach((f) => i.set(f)), i;
  }
  static accessor(e) {
    const i = (this[Qw] = this[Qw] = {
      accessors: {}
    }).accessors, f = this.prototype;
    function a(l) {
      const d = $o(l);
      i[d] || (aL(f, l), i[d] = !0);
    }
    return et.isArray(e) ? e.forEach(a) : a(e), this;
  }
}
Yc.accessor(["Content-Type", "Content-Length", "Accept", "Accept-Encoding", "User-Agent", "Authorization"]);
et.reduceDescriptors(Yc.prototype, ({ value: t }, e) => {
  let r = e[0].toUpperCase() + e.slice(1);
  return {
    get: () => t,
    set(i) {
      this[r] = i;
    }
  };
});
et.freezeMethods(Yc);
var Un = Yc;
function a1(t, e) {
  const r = this || _g, i = e || r, f = Un.from(i.headers);
  let a = i.data;
  return et.forEach(t, function(d) {
    a = d.call(r, a, f.normalize(), e ? e.status : void 0);
  }), f.normalize(), a;
}
function H7(t) {
  return !!(t && t.__CANCEL__);
}
function xo(t, e, r) {
  qt.call(this, t ?? "canceled", qt.ERR_CANCELED, e, r), this.name = "CanceledError";
}
et.inherits(xo, qt, {
  __CANCEL__: !0
});
function W7(t, e, r) {
  const i = r.config.validateStatus;
  !r.status || !i || i(r.status) ? t(r) : e(new qt(
    "Request failed with status code " + r.status,
    [qt.ERR_BAD_REQUEST, qt.ERR_BAD_RESPONSE][Math.floor(r.status / 100) - 4],
    r.config,
    r.request,
    r
  ));
}
function sL(t) {
  const e = /^([-+\w]{1,25})(:?\/\/|:)/.exec(t);
  return e && e[1] || "";
}
function oL(t, e) {
  t = t || 10;
  const r = new Array(t), i = new Array(t);
  let f = 0, a = 0, l;
  return e = e !== void 0 ? e : 1e3, function(v) {
    const m = Date.now(), h = i[a];
    l || (l = m), r[f] = v, i[f] = m;
    let w = a, M = 0;
    for (; w !== f; )
      M += r[w++], w = w % t;
    if (f = (f + 1) % t, f === a && (a = (a + 1) % t), m - l < e)
      return;
    const S = h && m - h;
    return S ? Math.round(M * 1e3 / S) : void 0;
  };
}
function fL(t, e) {
  let r = 0;
  const i = 1e3 / e;
  let f = null;
  return function() {
    const l = this === !0, d = Date.now();
    if (l || d - r > i)
      return f && (clearTimeout(f), f = null), r = d, t.apply(null, arguments);
    f || (f = setTimeout(() => (f = null, r = Date.now(), t.apply(null, arguments)), i - (d - r)));
  };
}
var Dl = (t, e, r = 3) => {
  let i = 0;
  const f = oL(50, 250);
  return fL((a) => {
    const l = a.loaded, d = a.lengthComputable ? a.total : void 0, v = l - i, m = f(v), h = l <= d;
    i = l;
    const w = {
      loaded: l,
      total: d,
      progress: d ? l / d : void 0,
      bytes: v,
      rate: m || void 0,
      estimated: m && d && h ? (d - l) / m : void 0,
      event: a,
      lengthComputable: d != null
    };
    w[e ? "download" : "upload"] = !0, t(w);
  }, r);
}, uL = Dn.hasStandardBrowserEnv ? (
  // Standard browser envs have full support of the APIs needed to test
  // whether the request URL is of the same origin as current location.
  function() {
    const e = /(msie|trident)/i.test(navigator.userAgent), r = document.createElement("a");
    let i;
    function f(a) {
      let l = a;
      return e && (r.setAttribute("href", l), l = r.href), r.setAttribute("href", l), {
        href: r.href,
        protocol: r.protocol ? r.protocol.replace(/:$/, "") : "",
        host: r.host,
        search: r.search ? r.search.replace(/^\?/, "") : "",
        hash: r.hash ? r.hash.replace(/^#/, "") : "",
        hostname: r.hostname,
        port: r.port,
        pathname: r.pathname.charAt(0) === "/" ? r.pathname : "/" + r.pathname
      };
    }
    return i = f(window.location.href), function(l) {
      const d = et.isString(l) ? f(l) : l;
      return d.protocol === i.protocol && d.host === i.host;
    };
  }()
) : (
  // Non standard browser envs (web workers, react-native) lack needed support.
  /* @__PURE__ */ function() {
    return function() {
      return !0;
    };
  }()
), lL = Dn.hasStandardBrowserEnv ? (
  // Standard browser envs support document.cookie
  {
    write(t, e, r, i, f, a) {
      const l = [t + "=" + encodeURIComponent(e)];
      et.isNumber(r) && l.push("expires=" + new Date(r).toGMTString()), et.isString(i) && l.push("path=" + i), et.isString(f) && l.push("domain=" + f), a === !0 && l.push("secure"), document.cookie = l.join("; ");
    },
    read(t) {
      const e = document.cookie.match(new RegExp("(^|;\\s*)(" + t + ")=([^;]*)"));
      return e ? decodeURIComponent(e[3]) : null;
    },
    remove(t) {
      this.write(t, "", Date.now() - 864e5);
    }
  }
) : (
  // Non-standard browser env (web workers, react-native) lack needed support.
  {
    write() {
    },
    read() {
      return null;
    },
    remove() {
    }
  }
);
function cL(t) {
  return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(t);
}
function dL(t, e) {
  return e ? t.replace(/\/?\/$/, "") + "/" + e.replace(/^\/+/, "") : t;
}
function K7(t, e) {
  return t && !cL(e) ? dL(t, e) : e;
}
const Yw = (t) => t instanceof Un ? { ...t } : t;
function ds(t, e) {
  e = e || {};
  const r = {};
  function i(m, h, w) {
    return et.isPlainObject(m) && et.isPlainObject(h) ? et.merge.call({ caseless: w }, m, h) : et.isPlainObject(h) ? et.merge({}, h) : et.isArray(h) ? h.slice() : h;
  }
  function f(m, h, w) {
    if (et.isUndefined(h)) {
      if (!et.isUndefined(m))
        return i(void 0, m, w);
    } else
      return i(m, h, w);
  }
  function a(m, h) {
    if (!et.isUndefined(h))
      return i(void 0, h);
  }
  function l(m, h) {
    if (et.isUndefined(h)) {
      if (!et.isUndefined(m))
        return i(void 0, m);
    } else
      return i(void 0, h);
  }
  function d(m, h, w) {
    if (w in e)
      return i(m, h);
    if (w in t)
      return i(void 0, m);
  }
  const v = {
    url: a,
    method: a,
    data: a,
    baseURL: l,
    transformRequest: l,
    transformResponse: l,
    paramsSerializer: l,
    timeout: l,
    timeoutMessage: l,
    withCredentials: l,
    withXSRFToken: l,
    adapter: l,
    responseType: l,
    xsrfCookieName: l,
    xsrfHeaderName: l,
    onUploadProgress: l,
    onDownloadProgress: l,
    decompress: l,
    maxContentLength: l,
    maxBodyLength: l,
    beforeRedirect: l,
    transport: l,
    httpAgent: l,
    httpsAgent: l,
    cancelToken: l,
    socketPath: l,
    responseEncoding: l,
    validateStatus: d,
    headers: (m, h) => f(Yw(m), Yw(h), !0)
  };
  return et.forEach(Object.keys(Object.assign({}, t, e)), function(h) {
    const w = v[h] || f, M = w(t[h], e[h], h);
    et.isUndefined(M) && w !== d || (r[h] = M);
  }), r;
}
var Z7 = (t) => {
  const e = ds({}, t);
  let { data: r, withXSRFToken: i, xsrfHeaderName: f, xsrfCookieName: a, headers: l, auth: d } = e;
  e.headers = l = Un.from(l), e.url = j7(K7(e.baseURL, e.url), t.params, t.paramsSerializer), d && l.set(
    "Authorization",
    "Basic " + btoa((d.username || "") + ":" + (d.password ? unescape(encodeURIComponent(d.password)) : ""))
  );
  let v;
  if (et.isFormData(r)) {
    if (Dn.hasStandardBrowserEnv || Dn.hasStandardBrowserWebWorkerEnv)
      l.setContentType(void 0);
    else if ((v = l.getContentType()) !== !1) {
      const [m, ...h] = v ? v.split(";").map((w) => w.trim()).filter(Boolean) : [];
      l.setContentType([m || "multipart/form-data", ...h].join("; "));
    }
  }
  if (Dn.hasStandardBrowserEnv && (i && et.isFunction(i) && (i = i(e)), i || i !== !1 && uL(e.url))) {
    const m = f && a && lL.read(a);
    m && l.set(f, m);
  }
  return e;
};
const hL = typeof XMLHttpRequest < "u";
var pL = hL && function(t) {
  return new Promise(function(r, i) {
    const f = Z7(t);
    let a = f.data;
    const l = Un.from(f.headers).normalize();
    let { responseType: d } = f, v;
    function m() {
      f.cancelToken && f.cancelToken.unsubscribe(v), f.signal && f.signal.removeEventListener("abort", v);
    }
    let h = new XMLHttpRequest();
    h.open(f.method.toUpperCase(), f.url, !0), h.timeout = f.timeout;
    function w() {
      if (!h)
        return;
      const S = Un.from(
        "getAllResponseHeaders" in h && h.getAllResponseHeaders()
      ), A = {
        data: !d || d === "text" || d === "json" ? h.responseText : h.response,
        status: h.status,
        statusText: h.statusText,
        headers: S,
        config: t,
        request: h
      };
      W7(function(k) {
        r(k), m();
      }, function(k) {
        i(k), m();
      }, A), h = null;
    }
    "onloadend" in h ? h.onloadend = w : h.onreadystatechange = function() {
      !h || h.readyState !== 4 || h.status === 0 && !(h.responseURL && h.responseURL.indexOf("file:") === 0) || setTimeout(w);
    }, h.onabort = function() {
      h && (i(new qt("Request aborted", qt.ECONNABORTED, f, h)), h = null);
    }, h.onerror = function() {
      i(new qt("Network Error", qt.ERR_NETWORK, f, h)), h = null;
    }, h.ontimeout = function() {
      let E = f.timeout ? "timeout of " + f.timeout + "ms exceeded" : "timeout exceeded";
      const A = f.transitional || $7;
      f.timeoutErrorMessage && (E = f.timeoutErrorMessage), i(new qt(
        E,
        A.clarifyTimeoutError ? qt.ETIMEDOUT : qt.ECONNABORTED,
        f,
        h
      )), h = null;
    }, a === void 0 && l.setContentType(null), "setRequestHeader" in h && et.forEach(l.toJSON(), function(E, A) {
      h.setRequestHeader(A, E);
    }), et.isUndefined(f.withCredentials) || (h.withCredentials = !!f.withCredentials), d && d !== "json" && (h.responseType = f.responseType), typeof f.onDownloadProgress == "function" && h.addEventListener("progress", Dl(f.onDownloadProgress, !0)), typeof f.onUploadProgress == "function" && h.upload && h.upload.addEventListener("progress", Dl(f.onUploadProgress)), (f.cancelToken || f.signal) && (v = (S) => {
      h && (i(!S || S.type ? new xo(null, t, h) : S), h.abort(), h = null);
    }, f.cancelToken && f.cancelToken.subscribe(v), f.signal && (f.signal.aborted ? v() : f.signal.addEventListener("abort", v)));
    const M = sL(f.url);
    if (M && Dn.protocols.indexOf(M) === -1) {
      i(new qt("Unsupported protocol " + M + ":", qt.ERR_BAD_REQUEST, t));
      return;
    }
    h.send(a || null);
  });
};
const vL = (t, e) => {
  let r = new AbortController(), i;
  const f = function(v) {
    if (!i) {
      i = !0, l();
      const m = v instanceof Error ? v : this.reason;
      r.abort(m instanceof qt ? m : new xo(m instanceof Error ? m.message : m));
    }
  };
  let a = e && setTimeout(() => {
    f(new qt(`timeout ${e} of ms exceeded`, qt.ETIMEDOUT));
  }, e);
  const l = () => {
    t && (a && clearTimeout(a), a = null, t.forEach((v) => {
      v && (v.removeEventListener ? v.removeEventListener("abort", f) : v.unsubscribe(f));
    }), t = null);
  };
  t.forEach((v) => v && v.addEventListener && v.addEventListener("abort", f));
  const { signal: d } = r;
  return d.unsubscribe = l, [d, () => {
    a && clearTimeout(a), a = null;
  }];
};
var mL = vL;
const gL = function* (t, e) {
  let r = t.byteLength;
  if (r < e) {
    yield t;
    return;
  }
  let i = 0, f;
  for (; i < r; )
    f = i + e, yield t.slice(i, f), i = f;
}, yL = async function* (t, e, r) {
  for await (const i of t)
    yield* gL(ArrayBuffer.isView(i) ? i : await r(String(i)), e);
}, Jw = (t, e, r, i, f) => {
  const a = yL(t, e, f);
  let l = 0;
  return new ReadableStream({
    type: "bytes",
    async pull(d) {
      const { done: v, value: m } = await a.next();
      if (v) {
        d.close(), i();
        return;
      }
      let h = m.byteLength;
      r && r(l += h), d.enqueue(new Uint8Array(m));
    },
    cancel(d) {
      return i(d), a.return();
    }
  }, {
    highWaterMark: 2
  });
}, Xw = (t, e) => {
  const r = t != null;
  return (i) => setTimeout(() => e({
    lengthComputable: r,
    total: t,
    loaded: i
  }));
}, Jc = typeof fetch == "function" && typeof Request == "function" && typeof Response == "function", G7 = Jc && typeof ReadableStream == "function", yv = Jc && (typeof TextEncoder == "function" ? /* @__PURE__ */ ((t) => (e) => t.encode(e))(new TextEncoder()) : async (t) => new Uint8Array(await new Response(t).arrayBuffer())), bL = G7 && (() => {
  let t = !1;
  const e = new Request(Dn.origin, {
    body: new ReadableStream(),
    method: "POST",
    get duplex() {
      return t = !0, "half";
    }
  }).headers.has("Content-Type");
  return t && !e;
})(), e5 = 64 * 1024, bv = G7 && !!(() => {
  try {
    return et.isReadableStream(new Response("").body);
  } catch {
  }
})(), Ul = {
  stream: bv && ((t) => t.body)
};
Jc && ((t) => {
  ["text", "arrayBuffer", "blob", "formData", "stream"].forEach((e) => {
    !Ul[e] && (Ul[e] = et.isFunction(t[e]) ? (r) => r[e]() : (r, i) => {
      throw new qt(`Response type '${e}' is not supported`, qt.ERR_NOT_SUPPORT, i);
    });
  });
})(new Response());
const wL = async (t) => {
  if (t == null)
    return 0;
  if (et.isBlob(t))
    return t.size;
  if (et.isSpecCompliantForm(t))
    return (await new Request(t).arrayBuffer()).byteLength;
  if (et.isArrayBufferView(t))
    return t.byteLength;
  if (et.isURLSearchParams(t) && (t = t + ""), et.isString(t))
    return (await yv(t)).byteLength;
}, _L = async (t, e) => {
  const r = et.toFiniteNumber(t.getContentLength());
  return r ?? wL(e);
};
var xL = Jc && (async (t) => {
  let {
    url: e,
    method: r,
    data: i,
    signal: f,
    cancelToken: a,
    timeout: l,
    onDownloadProgress: d,
    onUploadProgress: v,
    responseType: m,
    headers: h,
    withCredentials: w = "same-origin",
    fetchOptions: M
  } = Z7(t);
  m = m ? (m + "").toLowerCase() : "text";
  let [S, E] = f || a || l ? mL([f, a], l) : [], A, B;
  const k = () => {
    !A && setTimeout(() => {
      S && S.unsubscribe();
    }), A = !0;
  };
  let C;
  try {
    if (v && bL && r !== "get" && r !== "head" && (C = await _L(h, i)) !== 0) {
      let $ = new Request(e, {
        method: "POST",
        body: i,
        duplex: "half"
      }), ae;
      et.isFormData(i) && (ae = $.headers.get("content-type")) && h.setContentType(ae), $.body && (i = Jw($.body, e5, Xw(
        C,
        Dl(v)
      ), null, yv));
    }
    et.isString(w) || (w = w ? "cors" : "omit"), B = new Request(e, {
      ...M,
      signal: S,
      method: r.toUpperCase(),
      headers: h.normalize().toJSON(),
      body: i,
      duplex: "half",
      withCredentials: w
    });
    let I = await fetch(B);
    const O = bv && (m === "stream" || m === "response");
    if (bv && (d || O)) {
      const $ = {};
      ["status", "statusText", "headers"].forEach((he) => {
        $[he] = I[he];
      });
      const ae = et.toFiniteNumber(I.headers.get("content-length"));
      I = new Response(
        Jw(I.body, e5, d && Xw(
          ae,
          Dl(d, !0)
        ), O && k, yv),
        $
      );
    }
    m = m || "text";
    let q = await Ul[et.findKey(Ul, m) || "text"](I, t);
    return !O && k(), E && E(), await new Promise(($, ae) => {
      W7($, ae, {
        data: q,
        headers: Un.from(I.headers),
        status: I.status,
        statusText: I.statusText,
        config: t,
        request: B
      });
    });
  } catch (I) {
    throw k(), I && I.name === "TypeError" && /fetch/i.test(I.message) ? Object.assign(
      new qt("Network Error", qt.ERR_NETWORK, t, B),
      {
        cause: I.cause || I
      }
    ) : qt.from(I, I && I.code, t, B);
  }
});
const wv = {
  http: UU,
  xhr: pL,
  fetch: xL
};
et.forEach(wv, (t, e) => {
  if (t) {
    try {
      Object.defineProperty(t, "name", { value: e });
    } catch {
    }
    Object.defineProperty(t, "adapterName", { value: e });
  }
});
const t5 = (t) => `- ${t}`, ML = (t) => et.isFunction(t) || t === null || t === !1;
var Q7 = {
  getAdapter: (t) => {
    t = et.isArray(t) ? t : [t];
    const { length: e } = t;
    let r, i;
    const f = {};
    for (let a = 0; a < e; a++) {
      r = t[a];
      let l;
      if (i = r, !ML(r) && (i = wv[(l = String(r)).toLowerCase()], i === void 0))
        throw new qt(`Unknown adapter '${l}'`);
      if (i)
        break;
      f[l || "#" + a] = i;
    }
    if (!i) {
      const a = Object.entries(f).map(
        ([d, v]) => `adapter ${d} ` + (v === !1 ? "is not supported by the environment" : "is not available in the build")
      );
      let l = e ? a.length > 1 ? `since :
` + a.map(t5).join(`
`) : " " + t5(a[0]) : "as no adapter specified";
      throw new qt(
        "There is no suitable adapter to dispatch the request " + l,
        "ERR_NOT_SUPPORT"
      );
    }
    return i;
  },
  adapters: wv
};
function s1(t) {
  if (t.cancelToken && t.cancelToken.throwIfRequested(), t.signal && t.signal.aborted)
    throw new xo(null, t);
}
function r5(t) {
  return s1(t), t.headers = Un.from(t.headers), t.data = a1.call(
    t,
    t.transformRequest
  ), ["post", "put", "patch"].indexOf(t.method) !== -1 && t.headers.setContentType("application/x-www-form-urlencoded", !1), Q7.getAdapter(t.adapter || _g.adapter)(t).then(function(i) {
    return s1(t), i.data = a1.call(
      t,
      t.transformResponse,
      i
    ), i.headers = Un.from(i.headers), i;
  }, function(i) {
    return H7(i) || (s1(t), i && i.response && (i.response.data = a1.call(
      t,
      t.transformResponse,
      i.response
    ), i.response.headers = Un.from(i.response.headers))), Promise.reject(i);
  });
}
const Y7 = "1.7.2", xg = {};
["object", "boolean", "number", "function", "string", "symbol"].forEach((t, e) => {
  xg[t] = function(i) {
    return typeof i === t || "a" + (e < 1 ? "n " : " ") + t;
  };
});
const n5 = {};
xg.transitional = function(e, r, i) {
  function f(a, l) {
    return "[Axios v" + Y7 + "] Transitional option '" + a + "'" + l + (i ? ". " + i : "");
  }
  return (a, l, d) => {
    if (e === !1)
      throw new qt(
        f(l, " has been removed" + (r ? " in " + r : "")),
        qt.ERR_DEPRECATED
      );
    return r && !n5[l] && (n5[l] = !0, console.warn(
      f(
        l,
        " has been deprecated since v" + r + " and will be removed in the near future"
      )
    )), e ? e(a, l, d) : !0;
  };
};
function SL(t, e, r) {
  if (typeof t != "object")
    throw new qt("options must be an object", qt.ERR_BAD_OPTION_VALUE);
  const i = Object.keys(t);
  let f = i.length;
  for (; f-- > 0; ) {
    const a = i[f], l = e[a];
    if (l) {
      const d = t[a], v = d === void 0 || l(d, a, t);
      if (v !== !0)
        throw new qt("option " + a + " must be " + v, qt.ERR_BAD_OPTION_VALUE);
      continue;
    }
    if (r !== !0)
      throw new qt("Unknown option " + a, qt.ERR_BAD_OPTION);
  }
}
var _v = {
  assertOptions: SL,
  validators: xg
};
const Oi = _v.validators;
class Ll {
  constructor(e) {
    this.defaults = e, this.interceptors = {
      request: new Gw(),
      response: new Gw()
    };
  }
  /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */
  async request(e, r) {
    try {
      return await this._request(e, r);
    } catch (i) {
      if (i instanceof Error) {
        let f;
        Error.captureStackTrace ? Error.captureStackTrace(f = {}) : f = new Error();
        const a = f.stack ? f.stack.replace(/^.+\n/, "") : "";
        try {
          i.stack ? a && !String(i.stack).endsWith(a.replace(/^.+\n.+\n/, "")) && (i.stack += `
` + a) : i.stack = a;
        } catch {
        }
      }
      throw i;
    }
  }
  _request(e, r) {
    typeof e == "string" ? (r = r || {}, r.url = e) : r = e || {}, r = ds(this.defaults, r);
    const { transitional: i, paramsSerializer: f, headers: a } = r;
    i !== void 0 && _v.assertOptions(i, {
      silentJSONParsing: Oi.transitional(Oi.boolean),
      forcedJSONParsing: Oi.transitional(Oi.boolean),
      clarifyTimeoutError: Oi.transitional(Oi.boolean)
    }, !1), f != null && (et.isFunction(f) ? r.paramsSerializer = {
      serialize: f
    } : _v.assertOptions(f, {
      encode: Oi.function,
      serialize: Oi.function
    }, !0)), r.method = (r.method || this.defaults.method || "get").toLowerCase();
    let l = a && et.merge(
      a.common,
      a[r.method]
    );
    a && et.forEach(
      ["delete", "get", "head", "post", "put", "patch", "common"],
      (E) => {
        delete a[E];
      }
    ), r.headers = Un.concat(l, a);
    const d = [];
    let v = !0;
    this.interceptors.request.forEach(function(A) {
      typeof A.runWhen == "function" && A.runWhen(r) === !1 || (v = v && A.synchronous, d.unshift(A.fulfilled, A.rejected));
    });
    const m = [];
    this.interceptors.response.forEach(function(A) {
      m.push(A.fulfilled, A.rejected);
    });
    let h, w = 0, M;
    if (!v) {
      const E = [r5.bind(this), void 0];
      for (E.unshift.apply(E, d), E.push.apply(E, m), M = E.length, h = Promise.resolve(r); w < M; )
        h = h.then(E[w++], E[w++]);
      return h;
    }
    M = d.length;
    let S = r;
    for (w = 0; w < M; ) {
      const E = d[w++], A = d[w++];
      try {
        S = E(S);
      } catch (B) {
        A.call(this, B);
        break;
      }
    }
    try {
      h = r5.call(this, S);
    } catch (E) {
      return Promise.reject(E);
    }
    for (w = 0, M = m.length; w < M; )
      h = h.then(m[w++], m[w++]);
    return h;
  }
  getUri(e) {
    e = ds(this.defaults, e);
    const r = K7(e.baseURL, e.url);
    return j7(r, e.params, e.paramsSerializer);
  }
}
et.forEach(["delete", "get", "head", "options"], function(e) {
  Ll.prototype[e] = function(r, i) {
    return this.request(ds(i || {}, {
      method: e,
      url: r,
      data: (i || {}).data
    }));
  };
});
et.forEach(["post", "put", "patch"], function(e) {
  function r(i) {
    return function(a, l, d) {
      return this.request(ds(d || {}, {
        method: e,
        headers: i ? {
          "Content-Type": "multipart/form-data"
        } : {},
        url: a,
        data: l
      }));
    };
  }
  Ll.prototype[e] = r(), Ll.prototype[e + "Form"] = r(!0);
});
var _l = Ll;
class Mg {
  constructor(e) {
    if (typeof e != "function")
      throw new TypeError("executor must be a function.");
    let r;
    this.promise = new Promise(function(a) {
      r = a;
    });
    const i = this;
    this.promise.then((f) => {
      if (!i._listeners)
        return;
      let a = i._listeners.length;
      for (; a-- > 0; )
        i._listeners[a](f);
      i._listeners = null;
    }), this.promise.then = (f) => {
      let a;
      const l = new Promise((d) => {
        i.subscribe(d), a = d;
      }).then(f);
      return l.cancel = function() {
        i.unsubscribe(a);
      }, l;
    }, e(function(a, l, d) {
      i.reason || (i.reason = new xo(a, l, d), r(i.reason));
    });
  }
  /**
   * Throws a `CanceledError` if cancellation has been requested.
   */
  throwIfRequested() {
    if (this.reason)
      throw this.reason;
  }
  /**
   * Subscribe to the cancel signal
   */
  subscribe(e) {
    if (this.reason) {
      e(this.reason);
      return;
    }
    this._listeners ? this._listeners.push(e) : this._listeners = [e];
  }
  /**
   * Unsubscribe from the cancel signal
   */
  unsubscribe(e) {
    if (!this._listeners)
      return;
    const r = this._listeners.indexOf(e);
    r !== -1 && this._listeners.splice(r, 1);
  }
  /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */
  static source() {
    let e;
    return {
      token: new Mg(function(f) {
        e = f;
      }),
      cancel: e
    };
  }
}
var EL = Mg;
function AL(t) {
  return function(r) {
    return t.apply(null, r);
  };
}
function kL(t) {
  return et.isObject(t) && t.isAxiosError === !0;
}
const xv = {
  Continue: 100,
  SwitchingProtocols: 101,
  Processing: 102,
  EarlyHints: 103,
  Ok: 200,
  Created: 201,
  Accepted: 202,
  NonAuthoritativeInformation: 203,
  NoContent: 204,
  ResetContent: 205,
  PartialContent: 206,
  MultiStatus: 207,
  AlreadyReported: 208,
  ImUsed: 226,
  MultipleChoices: 300,
  MovedPermanently: 301,
  Found: 302,
  SeeOther: 303,
  NotModified: 304,
  UseProxy: 305,
  Unused: 306,
  TemporaryRedirect: 307,
  PermanentRedirect: 308,
  BadRequest: 400,
  Unauthorized: 401,
  PaymentRequired: 402,
  Forbidden: 403,
  NotFound: 404,
  MethodNotAllowed: 405,
  NotAcceptable: 406,
  ProxyAuthenticationRequired: 407,
  RequestTimeout: 408,
  Conflict: 409,
  Gone: 410,
  LengthRequired: 411,
  PreconditionFailed: 412,
  PayloadTooLarge: 413,
  UriTooLong: 414,
  UnsupportedMediaType: 415,
  RangeNotSatisfiable: 416,
  ExpectationFailed: 417,
  ImATeapot: 418,
  MisdirectedRequest: 421,
  UnprocessableEntity: 422,
  Locked: 423,
  FailedDependency: 424,
  TooEarly: 425,
  UpgradeRequired: 426,
  PreconditionRequired: 428,
  TooManyRequests: 429,
  RequestHeaderFieldsTooLarge: 431,
  UnavailableForLegalReasons: 451,
  InternalServerError: 500,
  NotImplemented: 501,
  BadGateway: 502,
  ServiceUnavailable: 503,
  GatewayTimeout: 504,
  HttpVersionNotSupported: 505,
  VariantAlsoNegotiates: 506,
  InsufficientStorage: 507,
  LoopDetected: 508,
  NotExtended: 510,
  NetworkAuthenticationRequired: 511
};
Object.entries(xv).forEach(([t, e]) => {
  xv[e] = t;
});
var TL = xv;
function J7(t) {
  const e = new _l(t), r = B7(_l.prototype.request, e);
  return et.extend(r, _l.prototype, e, { allOwnKeys: !0 }), et.extend(r, e, null, { allOwnKeys: !0 }), r.create = function(f) {
    return J7(ds(t, f));
  }, r;
}
const Sr = J7(_g);
Sr.Axios = _l;
Sr.CanceledError = xo;
Sr.CancelToken = EL;
Sr.isCancel = H7;
Sr.VERSION = Y7;
Sr.toFormData = Qc;
Sr.AxiosError = qt;
Sr.Cancel = Sr.CanceledError;
Sr.all = function(e) {
  return Promise.all(e);
};
Sr.spread = AL;
Sr.isAxiosError = kL;
Sr.mergeConfig = ds;
Sr.AxiosHeaders = Un;
Sr.formToJSON = (t) => V7(et.isHTMLForm(t) ? new FormData(t) : t);
Sr.getAdapter = Q7.getAdapter;
Sr.HttpStatusCode = TL;
Sr.default = Sr;
var X7 = Sr, Sg = {}, Mv = {}, Xn = {}, Xc = {}, ou = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.getParsedType = t.ZodParsedType = t.objectUtil = t.util = void 0;
  var e;
  (function(i) {
    i.assertEqual = (d) => d;
    function f(d) {
    }
    i.assertIs = f;
    function a(d) {
      throw new Error();
    }
    i.assertNever = a, i.arrayToEnum = (d) => {
      const v = {};
      for (const m of d)
        v[m] = m;
      return v;
    }, i.getValidEnumValues = (d) => {
      const v = i.objectKeys(d).filter((h) => typeof d[d[h]] != "number"), m = {};
      for (const h of v)
        m[h] = d[h];
      return i.objectValues(m);
    }, i.objectValues = (d) => i.objectKeys(d).map(function(v) {
      return d[v];
    }), i.objectKeys = typeof Object.keys == "function" ? (d) => Object.keys(d) : (d) => {
      const v = [];
      for (const m in d)
        Object.prototype.hasOwnProperty.call(d, m) && v.push(m);
      return v;
    }, i.find = (d, v) => {
      for (const m of d)
        if (v(m))
          return m;
    }, i.isInteger = typeof Number.isInteger == "function" ? (d) => Number.isInteger(d) : (d) => typeof d == "number" && isFinite(d) && Math.floor(d) === d;
    function l(d, v = " | ") {
      return d.map((m) => typeof m == "string" ? `'${m}'` : m).join(v);
    }
    i.joinValues = l, i.jsonStringifyReplacer = (d, v) => typeof v == "bigint" ? v.toString() : v;
  })(e = t.util || (t.util = {})), function(i) {
    i.mergeShapes = (f, a) => ({
      ...f,
      ...a
      // second overwrites first
    });
  }(t.objectUtil || (t.objectUtil = {})), t.ZodParsedType = e.arrayToEnum([
    "string",
    "nan",
    "number",
    "integer",
    "float",
    "boolean",
    "date",
    "bigint",
    "symbol",
    "function",
    "undefined",
    "null",
    "array",
    "object",
    "unknown",
    "promise",
    "void",
    "never",
    "map",
    "set"
  ]);
  const r = (i) => {
    switch (typeof i) {
      case "undefined":
        return t.ZodParsedType.undefined;
      case "string":
        return t.ZodParsedType.string;
      case "number":
        return isNaN(i) ? t.ZodParsedType.nan : t.ZodParsedType.number;
      case "boolean":
        return t.ZodParsedType.boolean;
      case "function":
        return t.ZodParsedType.function;
      case "bigint":
        return t.ZodParsedType.bigint;
      case "symbol":
        return t.ZodParsedType.symbol;
      case "object":
        return Array.isArray(i) ? t.ZodParsedType.array : i === null ? t.ZodParsedType.null : i.then && typeof i.then == "function" && i.catch && typeof i.catch == "function" ? t.ZodParsedType.promise : typeof Map < "u" && i instanceof Map ? t.ZodParsedType.map : typeof Set < "u" && i instanceof Set ? t.ZodParsedType.set : typeof Date < "u" && i instanceof Date ? t.ZodParsedType.date : t.ZodParsedType.object;
      default:
        return t.ZodParsedType.unknown;
    }
  };
  t.getParsedType = r;
})(ou);
var ei = {};
Object.defineProperty(ei, "__esModule", { value: !0 });
ei.ZodError = ei.quotelessJson = ei.ZodIssueCode = void 0;
const eM = ou;
ei.ZodIssueCode = eM.util.arrayToEnum([
  "invalid_type",
  "invalid_literal",
  "custom",
  "invalid_union",
  "invalid_union_discriminator",
  "invalid_enum_value",
  "unrecognized_keys",
  "invalid_arguments",
  "invalid_return_type",
  "invalid_date",
  "invalid_string",
  "too_small",
  "too_big",
  "invalid_intersection_types",
  "not_multiple_of",
  "not_finite"
]);
const CL = (t) => JSON.stringify(t, null, 2).replace(/"([^"]+)":/g, "$1:");
ei.quotelessJson = CL;
class Nf extends Error {
  constructor(e) {
    super(), this.issues = [], this.addIssue = (i) => {
      this.issues = [...this.issues, i];
    }, this.addIssues = (i = []) => {
      this.issues = [...this.issues, ...i];
    };
    const r = new.target.prototype;
    Object.setPrototypeOf ? Object.setPrototypeOf(this, r) : this.__proto__ = r, this.name = "ZodError", this.issues = e;
  }
  get errors() {
    return this.issues;
  }
  format(e) {
    const r = e || function(a) {
      return a.message;
    }, i = { _errors: [] }, f = (a) => {
      for (const l of a.issues)
        if (l.code === "invalid_union")
          l.unionErrors.map(f);
        else if (l.code === "invalid_return_type")
          f(l.returnTypeError);
        else if (l.code === "invalid_arguments")
          f(l.argumentsError);
        else if (l.path.length === 0)
          i._errors.push(r(l));
        else {
          let d = i, v = 0;
          for (; v < l.path.length; ) {
            const m = l.path[v];
            v === l.path.length - 1 ? (d[m] = d[m] || { _errors: [] }, d[m]._errors.push(r(l))) : d[m] = d[m] || { _errors: [] }, d = d[m], v++;
          }
        }
    };
    return f(this), i;
  }
  static assert(e) {
    if (!(e instanceof Nf))
      throw new Error(`Not a ZodError: ${e}`);
  }
  toString() {
    return this.message;
  }
  get message() {
    return JSON.stringify(this.issues, eM.util.jsonStringifyReplacer, 2);
  }
  get isEmpty() {
    return this.issues.length === 0;
  }
  flatten(e = (r) => r.message) {
    const r = {}, i = [];
    for (const f of this.issues)
      f.path.length > 0 ? (r[f.path[0]] = r[f.path[0]] || [], r[f.path[0]].push(e(f))) : i.push(e(f));
    return { formErrors: i, fieldErrors: r };
  }
  get formErrors() {
    return this.flatten();
  }
}
ei.ZodError = Nf;
Nf.create = (t) => new Nf(t);
Object.defineProperty(Xc, "__esModule", { value: !0 });
const Sa = ou, Fr = ei, BL = (t, e) => {
  let r;
  switch (t.code) {
    case Fr.ZodIssueCode.invalid_type:
      t.received === Sa.ZodParsedType.undefined ? r = "Required" : r = `Expected ${t.expected}, received ${t.received}`;
      break;
    case Fr.ZodIssueCode.invalid_literal:
      r = `Invalid literal value, expected ${JSON.stringify(t.expected, Sa.util.jsonStringifyReplacer)}`;
      break;
    case Fr.ZodIssueCode.unrecognized_keys:
      r = `Unrecognized key(s) in object: ${Sa.util.joinValues(t.keys, ", ")}`;
      break;
    case Fr.ZodIssueCode.invalid_union:
      r = "Invalid input";
      break;
    case Fr.ZodIssueCode.invalid_union_discriminator:
      r = `Invalid discriminator value. Expected ${Sa.util.joinValues(t.options)}`;
      break;
    case Fr.ZodIssueCode.invalid_enum_value:
      r = `Invalid enum value. Expected ${Sa.util.joinValues(t.options)}, received '${t.received}'`;
      break;
    case Fr.ZodIssueCode.invalid_arguments:
      r = "Invalid function arguments";
      break;
    case Fr.ZodIssueCode.invalid_return_type:
      r = "Invalid function return type";
      break;
    case Fr.ZodIssueCode.invalid_date:
      r = "Invalid date";
      break;
    case Fr.ZodIssueCode.invalid_string:
      typeof t.validation == "object" ? "includes" in t.validation ? (r = `Invalid input: must include "${t.validation.includes}"`, typeof t.validation.position == "number" && (r = `${r} at one or more positions greater than or equal to ${t.validation.position}`)) : "startsWith" in t.validation ? r = `Invalid input: must start with "${t.validation.startsWith}"` : "endsWith" in t.validation ? r = `Invalid input: must end with "${t.validation.endsWith}"` : Sa.util.assertNever(t.validation) : t.validation !== "regex" ? r = `Invalid ${t.validation}` : r = "Invalid";
      break;
    case Fr.ZodIssueCode.too_small:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "more than"} ${t.minimum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at least" : "over"} ${t.minimum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${t.minimum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly equal to " : t.inclusive ? "greater than or equal to " : "greater than "}${new Date(Number(t.minimum))}` : r = "Invalid input";
      break;
    case Fr.ZodIssueCode.too_big:
      t.type === "array" ? r = `Array must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "less than"} ${t.maximum} element(s)` : t.type === "string" ? r = `String must contain ${t.exact ? "exactly" : t.inclusive ? "at most" : "under"} ${t.maximum} character(s)` : t.type === "number" ? r = `Number must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "bigint" ? r = `BigInt must be ${t.exact ? "exactly" : t.inclusive ? "less than or equal to" : "less than"} ${t.maximum}` : t.type === "date" ? r = `Date must be ${t.exact ? "exactly" : t.inclusive ? "smaller than or equal to" : "smaller than"} ${new Date(Number(t.maximum))}` : r = "Invalid input";
      break;
    case Fr.ZodIssueCode.custom:
      r = "Invalid input";
      break;
    case Fr.ZodIssueCode.invalid_intersection_types:
      r = "Intersection results could not be merged";
      break;
    case Fr.ZodIssueCode.not_multiple_of:
      r = `Number must be a multiple of ${t.multipleOf}`;
      break;
    case Fr.ZodIssueCode.not_finite:
      r = "Number must be finite";
      break;
    default:
      r = e.defaultError, Sa.util.assertNever(t);
  }
  return { message: r };
};
Xc.default = BL;
var IL = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(Xn, "__esModule", { value: !0 });
Xn.getErrorMap = Xn.setErrorMap = Xn.defaultErrorMap = void 0;
const tM = IL(Xc);
Xn.defaultErrorMap = tM.default;
let rM = tM.default;
function RL(t) {
  rM = t;
}
Xn.setErrorMap = RL;
function PL() {
  return rM;
}
Xn.getErrorMap = PL;
var Eg = {};
(function(t) {
  var e = ut && ut.__importDefault || function(S) {
    return S && S.__esModule ? S : { default: S };
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.isAsync = t.isValid = t.isDirty = t.isAborted = t.OK = t.DIRTY = t.INVALID = t.ParseStatus = t.addIssueToContext = t.EMPTY_PATH = t.makeIssue = void 0;
  const r = Xn, i = e(Xc), f = (S) => {
    const { data: E, path: A, errorMaps: B, issueData: k } = S, C = [...A, ...k.path || []], I = {
      ...k,
      path: C
    };
    if (k.message !== void 0)
      return {
        ...k,
        path: C,
        message: k.message
      };
    let O = "";
    const q = B.filter(($) => !!$).slice().reverse();
    for (const $ of q)
      O = $(I, { data: E, defaultError: O }).message;
    return {
      ...k,
      path: C,
      message: O
    };
  };
  t.makeIssue = f, t.EMPTY_PATH = [];
  function a(S, E) {
    const A = (0, r.getErrorMap)(), B = (0, t.makeIssue)({
      issueData: E,
      data: S.data,
      path: S.path,
      errorMaps: [
        S.common.contextualErrorMap,
        S.schemaErrorMap,
        A,
        A === i.default ? void 0 : i.default
        // then global default map
      ].filter((k) => !!k)
    });
    S.common.issues.push(B);
  }
  t.addIssueToContext = a;
  class l {
    constructor() {
      this.value = "valid";
    }
    dirty() {
      this.value === "valid" && (this.value = "dirty");
    }
    abort() {
      this.value !== "aborted" && (this.value = "aborted");
    }
    static mergeArray(E, A) {
      const B = [];
      for (const k of A) {
        if (k.status === "aborted")
          return t.INVALID;
        k.status === "dirty" && E.dirty(), B.push(k.value);
      }
      return { status: E.value, value: B };
    }
    static async mergeObjectAsync(E, A) {
      const B = [];
      for (const k of A) {
        const C = await k.key, I = await k.value;
        B.push({
          key: C,
          value: I
        });
      }
      return l.mergeObjectSync(E, B);
    }
    static mergeObjectSync(E, A) {
      const B = {};
      for (const k of A) {
        const { key: C, value: I } = k;
        if (C.status === "aborted" || I.status === "aborted")
          return t.INVALID;
        C.status === "dirty" && E.dirty(), I.status === "dirty" && E.dirty(), C.value !== "__proto__" && (typeof I.value < "u" || k.alwaysSet) && (B[C.value] = I.value);
      }
      return { status: E.value, value: B };
    }
  }
  t.ParseStatus = l, t.INVALID = Object.freeze({
    status: "aborted"
  });
  const d = (S) => ({ status: "dirty", value: S });
  t.DIRTY = d;
  const v = (S) => ({ status: "valid", value: S });
  t.OK = v;
  const m = (S) => S.status === "aborted";
  t.isAborted = m;
  const h = (S) => S.status === "dirty";
  t.isDirty = h;
  const w = (S) => S.status === "valid";
  t.isValid = w;
  const M = (S) => typeof Promise < "u" && S instanceof Promise;
  t.isAsync = M;
})(Eg);
var nM = {};
Object.defineProperty(nM, "__esModule", { value: !0 });
var iM = {}, aM = {};
(function(t) {
  Object.defineProperty(t, "__esModule", { value: !0 }), t.errorUtil = void 0, function(e) {
    e.errToObj = (r) => typeof r == "string" ? { message: r } : r || {}, e.toString = (r) => typeof r == "string" ? r : r == null ? void 0 : r.message;
  }(t.errorUtil || (t.errorUtil = {}));
})(aM);
(function(t) {
  var e = ut && ut.__classPrivateFieldGet || function(ve, D, j, Y) {
    if (j === "a" && !Y)
      throw new TypeError("Private accessor was defined without a getter");
    if (typeof D == "function" ? ve !== D || !Y : !D.has(ve))
      throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return j === "m" ? Y : j === "a" ? Y.call(ve) : Y ? Y.value : D.get(ve);
  }, r = ut && ut.__classPrivateFieldSet || function(ve, D, j, Y, me) {
    if (Y === "m")
      throw new TypeError("Private method is not writable");
    if (Y === "a" && !me)
      throw new TypeError("Private accessor was defined without a setter");
    if (typeof D == "function" ? ve !== D || !me : !D.has(ve))
      throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return Y === "a" ? me.call(ve, j) : me ? me.value = j : D.set(ve, j), j;
  }, i, f;
  Object.defineProperty(t, "__esModule", { value: !0 }), t.boolean = t.bigint = t.array = t.any = t.coerce = t.ZodFirstPartyTypeKind = t.late = t.ZodSchema = t.Schema = t.custom = t.ZodReadonly = t.ZodPipeline = t.ZodBranded = t.BRAND = t.ZodNaN = t.ZodCatch = t.ZodDefault = t.ZodNullable = t.ZodOptional = t.ZodTransformer = t.ZodEffects = t.ZodPromise = t.ZodNativeEnum = t.ZodEnum = t.ZodLiteral = t.ZodLazy = t.ZodFunction = t.ZodSet = t.ZodMap = t.ZodRecord = t.ZodTuple = t.ZodIntersection = t.ZodDiscriminatedUnion = t.ZodUnion = t.ZodObject = t.ZodArray = t.ZodVoid = t.ZodNever = t.ZodUnknown = t.ZodAny = t.ZodNull = t.ZodUndefined = t.ZodSymbol = t.ZodDate = t.ZodBoolean = t.ZodBigInt = t.ZodNumber = t.ZodString = t.datetimeRegex = t.ZodType = void 0, t.NEVER = t.void = t.unknown = t.union = t.undefined = t.tuple = t.transformer = t.symbol = t.string = t.strictObject = t.set = t.record = t.promise = t.preprocess = t.pipeline = t.ostring = t.optional = t.onumber = t.oboolean = t.object = t.number = t.nullable = t.null = t.never = t.nativeEnum = t.nan = t.map = t.literal = t.lazy = t.intersection = t.instanceof = t.function = t.enum = t.effect = t.discriminatedUnion = t.date = void 0;
  const a = Xn, l = aM, d = Eg, v = ou, m = ei;
  class h {
    constructor(D, j, Y, me) {
      this._cachedPath = [], this.parent = D, this.data = j, this._path = Y, this._key = me;
    }
    get path() {
      return this._cachedPath.length || (this._key instanceof Array ? this._cachedPath.push(...this._path, ...this._key) : this._cachedPath.push(...this._path, this._key)), this._cachedPath;
    }
  }
  const w = (ve, D) => {
    if ((0, d.isValid)(D))
      return { success: !0, data: D.value };
    if (!ve.common.issues.length)
      throw new Error("Validation failed but no issues detected.");
    return {
      success: !1,
      get error() {
        if (this._error)
          return this._error;
        const j = new m.ZodError(ve.common.issues);
        return this._error = j, this._error;
      }
    };
  };
  function M(ve) {
    if (!ve)
      return {};
    const { errorMap: D, invalid_type_error: j, required_error: Y, description: me } = ve;
    if (D && (j || Y))
      throw new Error(`Can't use "invalid_type_error" or "required_error" in conjunction with custom error map.`);
    return D ? { errorMap: D, description: me } : { errorMap: (Pe, Re) => {
      var nt, ot;
      const { message: _t } = ve;
      return Pe.code === "invalid_enum_value" ? { message: _t ?? Re.defaultError } : typeof Re.data > "u" ? { message: (nt = _t ?? Y) !== null && nt !== void 0 ? nt : Re.defaultError } : Pe.code !== "invalid_type" ? { message: Re.defaultError } : { message: (ot = _t ?? j) !== null && ot !== void 0 ? ot : Re.defaultError };
    }, description: me };
  }
  class S {
    constructor(D) {
      this.spa = this.safeParseAsync, this._def = D, this.parse = this.parse.bind(this), this.safeParse = this.safeParse.bind(this), this.parseAsync = this.parseAsync.bind(this), this.safeParseAsync = this.safeParseAsync.bind(this), this.spa = this.spa.bind(this), this.refine = this.refine.bind(this), this.refinement = this.refinement.bind(this), this.superRefine = this.superRefine.bind(this), this.optional = this.optional.bind(this), this.nullable = this.nullable.bind(this), this.nullish = this.nullish.bind(this), this.array = this.array.bind(this), this.promise = this.promise.bind(this), this.or = this.or.bind(this), this.and = this.and.bind(this), this.transform = this.transform.bind(this), this.brand = this.brand.bind(this), this.default = this.default.bind(this), this.catch = this.catch.bind(this), this.describe = this.describe.bind(this), this.pipe = this.pipe.bind(this), this.readonly = this.readonly.bind(this), this.isNullable = this.isNullable.bind(this), this.isOptional = this.isOptional.bind(this);
    }
    get description() {
      return this._def.description;
    }
    _getType(D) {
      return (0, v.getParsedType)(D.data);
    }
    _getOrReturnCtx(D, j) {
      return j || {
        common: D.parent.common,
        data: D.data,
        parsedType: (0, v.getParsedType)(D.data),
        schemaErrorMap: this._def.errorMap,
        path: D.path,
        parent: D.parent
      };
    }
    _processInputParams(D) {
      return {
        status: new d.ParseStatus(),
        ctx: {
          common: D.parent.common,
          data: D.data,
          parsedType: (0, v.getParsedType)(D.data),
          schemaErrorMap: this._def.errorMap,
          path: D.path,
          parent: D.parent
        }
      };
    }
    _parseSync(D) {
      const j = this._parse(D);
      if ((0, d.isAsync)(j))
        throw new Error("Synchronous parse encountered promise.");
      return j;
    }
    _parseAsync(D) {
      const j = this._parse(D);
      return Promise.resolve(j);
    }
    parse(D, j) {
      const Y = this.safeParse(D, j);
      if (Y.success)
        return Y.data;
      throw Y.error;
    }
    safeParse(D, j) {
      var Y;
      const me = {
        common: {
          issues: [],
          async: (Y = j == null ? void 0 : j.async) !== null && Y !== void 0 ? Y : !1,
          contextualErrorMap: j == null ? void 0 : j.errorMap
        },
        path: (j == null ? void 0 : j.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: D,
        parsedType: (0, v.getParsedType)(D)
      }, pe = this._parseSync({ data: D, path: me.path, parent: me });
      return w(me, pe);
    }
    async parseAsync(D, j) {
      const Y = await this.safeParseAsync(D, j);
      if (Y.success)
        return Y.data;
      throw Y.error;
    }
    async safeParseAsync(D, j) {
      const Y = {
        common: {
          issues: [],
          contextualErrorMap: j == null ? void 0 : j.errorMap,
          async: !0
        },
        path: (j == null ? void 0 : j.path) || [],
        schemaErrorMap: this._def.errorMap,
        parent: null,
        data: D,
        parsedType: (0, v.getParsedType)(D)
      }, me = this._parse({ data: D, path: Y.path, parent: Y }), pe = await ((0, d.isAsync)(me) ? me : Promise.resolve(me));
      return w(Y, pe);
    }
    refine(D, j) {
      const Y = (me) => typeof j == "string" || typeof j > "u" ? { message: j } : typeof j == "function" ? j(me) : j;
      return this._refinement((me, pe) => {
        const Pe = D(me), Re = () => pe.addIssue({
          code: m.ZodIssueCode.custom,
          ...Y(me)
        });
        return typeof Promise < "u" && Pe instanceof Promise ? Pe.then((nt) => nt ? !0 : (Re(), !1)) : Pe ? !0 : (Re(), !1);
      });
    }
    refinement(D, j) {
      return this._refinement((Y, me) => D(Y) ? !0 : (me.addIssue(typeof j == "function" ? j(Y, me) : j), !1));
    }
    _refinement(D) {
      return new fe({
        schema: this,
        typeName: He.ZodEffects,
        effect: { type: "refinement", refinement: D }
      });
    }
    superRefine(D) {
      return this._refinement(D);
    }
    optional() {
      return Te.create(this, this._def);
    }
    nullable() {
      return N.create(this, this._def);
    }
    nullish() {
      return this.nullable().optional();
    }
    array() {
      return re.create(this, this._def);
    }
    promise() {
      return ie.create(this, this._def);
    }
    or(D) {
      return Q.create([this, D], this._def);
    }
    and(D) {
      return Be.create(this, D, this._def);
    }
    transform(D) {
      return new fe({
        ...M(this._def),
        schema: this,
        typeName: He.ZodEffects,
        effect: { type: "transform", transform: D }
      });
    }
    default(D) {
      const j = typeof D == "function" ? D : () => D;
      return new R({
        ...M(this._def),
        innerType: this,
        defaultValue: j,
        typeName: He.ZodDefault
      });
    }
    brand() {
      return new ne({
        typeName: He.ZodBranded,
        type: this,
        ...M(this._def)
      });
    }
    catch(D) {
      const j = typeof D == "function" ? D : () => D;
      return new L({
        ...M(this._def),
        innerType: this,
        catchValue: j,
        typeName: He.ZodCatch
      });
    }
    describe(D) {
      const j = this.constructor;
      return new j({
        ...this._def,
        description: D
      });
    }
    pipe(D) {
      return Se.create(this, D);
    }
    readonly() {
      return ue.create(this);
    }
    isOptional() {
      return this.safeParse(void 0).success;
    }
    isNullable() {
      return this.safeParse(null).success;
    }
  }
  t.ZodType = S, t.Schema = S, t.ZodSchema = S;
  const E = /^c[^\s-]{8,}$/i, A = /^[0-9a-z]+$/, B = /^[0-9A-HJKMNP-TV-Z]{26}$/, k = /^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/i, C = /^[a-z0-9_-]{21}$/i, I = /^[-+]?P(?!$)(?:(?:[-+]?\d+Y)|(?:[-+]?\d+[.,]\d+Y$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:(?:[-+]?\d+W)|(?:[-+]?\d+[.,]\d+W$))?(?:(?:[-+]?\d+D)|(?:[-+]?\d+[.,]\d+D$))?(?:T(?=[\d+-])(?:(?:[-+]?\d+H)|(?:[-+]?\d+[.,]\d+H$))?(?:(?:[-+]?\d+M)|(?:[-+]?\d+[.,]\d+M$))?(?:[-+]?\d+(?:[.,]\d+)?S)?)??$/, O = /^(?!\.)(?!.*\.\.)([A-Z0-9_'+\-\.]*)[A-Z0-9_+-]@([A-Z0-9][A-Z0-9\-]*\.)+[A-Z]{2,}$/i, q = "^(\\p{Extended_Pictographic}|\\p{Emoji_Component})+$";
  let $;
  const ae = /^(?:(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])\.){3}(?:25[0-5]|2[0-4][0-9]|1[0-9][0-9]|[1-9][0-9]|[0-9])$/, he = /^(([a-f0-9]{1,4}:){7}|::([a-f0-9]{1,4}:){0,6}|([a-f0-9]{1,4}:){1}:([a-f0-9]{1,4}:){0,5}|([a-f0-9]{1,4}:){2}:([a-f0-9]{1,4}:){0,4}|([a-f0-9]{1,4}:){3}:([a-f0-9]{1,4}:){0,3}|([a-f0-9]{1,4}:){4}:([a-f0-9]{1,4}:){0,2}|([a-f0-9]{1,4}:){5}:([a-f0-9]{1,4}:){0,1})([a-f0-9]{1,4}|(((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2}))\.){3}((25[0-5])|(2[0-4][0-9])|(1[0-9]{2})|([0-9]{1,2})))$/, te = /^([0-9a-zA-Z+/]{4})*(([0-9a-zA-Z+/]{2}==)|([0-9a-zA-Z+/]{3}=))?$/, Ee = "((\\d\\d[2468][048]|\\d\\d[13579][26]|\\d\\d0[48]|[02468][048]00|[13579][26]00)-02-29|\\d{4}-((0[13578]|1[02])-(0[1-9]|[12]\\d|3[01])|(0[469]|11)-(0[1-9]|[12]\\d|30)|(02)-(0[1-9]|1\\d|2[0-8])))", x = new RegExp(`^${Ee}$`);
  function n(ve) {
    let D = "([01]\\d|2[0-3]):[0-5]\\d:[0-5]\\d";
    return ve.precision ? D = `${D}\\.\\d{${ve.precision}}` : ve.precision == null && (D = `${D}(\\.\\d+)?`), D;
  }
  function o(ve) {
    return new RegExp(`^${n(ve)}$`);
  }
  function u(ve) {
    let D = `${Ee}T${n(ve)}`;
    const j = [];
    return j.push(ve.local ? "Z?" : "Z"), ve.offset && j.push("([+-]\\d{2}:?\\d{2})"), D = `${D}(${j.join("|")})`, new RegExp(`^${D}$`);
  }
  t.datetimeRegex = u;
  function c(ve, D) {
    return !!((D === "v4" || !D) && ae.test(ve) || (D === "v6" || !D) && he.test(ve));
  }
  class g extends S {
    _parse(D) {
      if (this._def.coerce && (D.data = String(D.data)), this._getType(D) !== v.ZodParsedType.string) {
        const pe = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(pe, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.string,
          received: pe.parsedType
        }), d.INVALID;
      }
      const Y = new d.ParseStatus();
      let me;
      for (const pe of this._def.checks)
        if (pe.kind === "min")
          D.data.length < pe.value && (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.too_small,
            minimum: pe.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "max")
          D.data.length > pe.value && (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.too_big,
            maximum: pe.value,
            type: "string",
            inclusive: !0,
            exact: !1,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "length") {
          const Pe = D.data.length > pe.value, Re = D.data.length < pe.value;
          (Pe || Re) && (me = this._getOrReturnCtx(D, me), Pe ? (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.too_big,
            maximum: pe.value,
            type: "string",
            inclusive: !0,
            exact: !0,
            message: pe.message
          }) : Re && (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.too_small,
            minimum: pe.value,
            type: "string",
            inclusive: !0,
            exact: !0,
            message: pe.message
          }), Y.dirty());
        } else if (pe.kind === "email")
          O.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "email",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "emoji")
          $ || ($ = new RegExp(q, "u")), $.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "emoji",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "uuid")
          k.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "uuid",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "nanoid")
          C.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "nanoid",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "cuid")
          E.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "cuid",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "cuid2")
          A.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "cuid2",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "ulid")
          B.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "ulid",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty());
        else if (pe.kind === "url")
          try {
            new URL(D.data);
          } catch {
            me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
              validation: "url",
              code: m.ZodIssueCode.invalid_string,
              message: pe.message
            }), Y.dirty();
          }
        else
          pe.kind === "regex" ? (pe.regex.lastIndex = 0, pe.regex.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "regex",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty())) : pe.kind === "trim" ? D.data = D.data.trim() : pe.kind === "includes" ? D.data.includes(pe.value, pe.position) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.invalid_string,
            validation: { includes: pe.value, position: pe.position },
            message: pe.message
          }), Y.dirty()) : pe.kind === "toLowerCase" ? D.data = D.data.toLowerCase() : pe.kind === "toUpperCase" ? D.data = D.data.toUpperCase() : pe.kind === "startsWith" ? D.data.startsWith(pe.value) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.invalid_string,
            validation: { startsWith: pe.value },
            message: pe.message
          }), Y.dirty()) : pe.kind === "endsWith" ? D.data.endsWith(pe.value) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.invalid_string,
            validation: { endsWith: pe.value },
            message: pe.message
          }), Y.dirty()) : pe.kind === "datetime" ? u(pe).test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.invalid_string,
            validation: "datetime",
            message: pe.message
          }), Y.dirty()) : pe.kind === "date" ? x.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.invalid_string,
            validation: "date",
            message: pe.message
          }), Y.dirty()) : pe.kind === "time" ? o(pe).test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.invalid_string,
            validation: "time",
            message: pe.message
          }), Y.dirty()) : pe.kind === "duration" ? I.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "duration",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty()) : pe.kind === "ip" ? c(D.data, pe.version) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "ip",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty()) : pe.kind === "base64" ? te.test(D.data) || (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
            validation: "base64",
            code: m.ZodIssueCode.invalid_string,
            message: pe.message
          }), Y.dirty()) : v.util.assertNever(pe);
      return { status: Y.value, value: D.data };
    }
    _regex(D, j, Y) {
      return this.refinement((me) => D.test(me), {
        validation: j,
        code: m.ZodIssueCode.invalid_string,
        ...l.errorUtil.errToObj(Y)
      });
    }
    _addCheck(D) {
      return new g({
        ...this._def,
        checks: [...this._def.checks, D]
      });
    }
    email(D) {
      return this._addCheck({ kind: "email", ...l.errorUtil.errToObj(D) });
    }
    url(D) {
      return this._addCheck({ kind: "url", ...l.errorUtil.errToObj(D) });
    }
    emoji(D) {
      return this._addCheck({ kind: "emoji", ...l.errorUtil.errToObj(D) });
    }
    uuid(D) {
      return this._addCheck({ kind: "uuid", ...l.errorUtil.errToObj(D) });
    }
    nanoid(D) {
      return this._addCheck({ kind: "nanoid", ...l.errorUtil.errToObj(D) });
    }
    cuid(D) {
      return this._addCheck({ kind: "cuid", ...l.errorUtil.errToObj(D) });
    }
    cuid2(D) {
      return this._addCheck({ kind: "cuid2", ...l.errorUtil.errToObj(D) });
    }
    ulid(D) {
      return this._addCheck({ kind: "ulid", ...l.errorUtil.errToObj(D) });
    }
    base64(D) {
      return this._addCheck({ kind: "base64", ...l.errorUtil.errToObj(D) });
    }
    ip(D) {
      return this._addCheck({ kind: "ip", ...l.errorUtil.errToObj(D) });
    }
    datetime(D) {
      var j, Y;
      return typeof D == "string" ? this._addCheck({
        kind: "datetime",
        precision: null,
        offset: !1,
        local: !1,
        message: D
      }) : this._addCheck({
        kind: "datetime",
        precision: typeof (D == null ? void 0 : D.precision) > "u" ? null : D == null ? void 0 : D.precision,
        offset: (j = D == null ? void 0 : D.offset) !== null && j !== void 0 ? j : !1,
        local: (Y = D == null ? void 0 : D.local) !== null && Y !== void 0 ? Y : !1,
        ...l.errorUtil.errToObj(D == null ? void 0 : D.message)
      });
    }
    date(D) {
      return this._addCheck({ kind: "date", message: D });
    }
    time(D) {
      return typeof D == "string" ? this._addCheck({
        kind: "time",
        precision: null,
        message: D
      }) : this._addCheck({
        kind: "time",
        precision: typeof (D == null ? void 0 : D.precision) > "u" ? null : D == null ? void 0 : D.precision,
        ...l.errorUtil.errToObj(D == null ? void 0 : D.message)
      });
    }
    duration(D) {
      return this._addCheck({ kind: "duration", ...l.errorUtil.errToObj(D) });
    }
    regex(D, j) {
      return this._addCheck({
        kind: "regex",
        regex: D,
        ...l.errorUtil.errToObj(j)
      });
    }
    includes(D, j) {
      return this._addCheck({
        kind: "includes",
        value: D,
        position: j == null ? void 0 : j.position,
        ...l.errorUtil.errToObj(j == null ? void 0 : j.message)
      });
    }
    startsWith(D, j) {
      return this._addCheck({
        kind: "startsWith",
        value: D,
        ...l.errorUtil.errToObj(j)
      });
    }
    endsWith(D, j) {
      return this._addCheck({
        kind: "endsWith",
        value: D,
        ...l.errorUtil.errToObj(j)
      });
    }
    min(D, j) {
      return this._addCheck({
        kind: "min",
        value: D,
        ...l.errorUtil.errToObj(j)
      });
    }
    max(D, j) {
      return this._addCheck({
        kind: "max",
        value: D,
        ...l.errorUtil.errToObj(j)
      });
    }
    length(D, j) {
      return this._addCheck({
        kind: "length",
        value: D,
        ...l.errorUtil.errToObj(j)
      });
    }
    /**
     * @deprecated Use z.string().min(1) instead.
     * @see {@link ZodString.min}
     */
    nonempty(D) {
      return this.min(1, l.errorUtil.errToObj(D));
    }
    trim() {
      return new g({
        ...this._def,
        checks: [...this._def.checks, { kind: "trim" }]
      });
    }
    toLowerCase() {
      return new g({
        ...this._def,
        checks: [...this._def.checks, { kind: "toLowerCase" }]
      });
    }
    toUpperCase() {
      return new g({
        ...this._def,
        checks: [...this._def.checks, { kind: "toUpperCase" }]
      });
    }
    get isDatetime() {
      return !!this._def.checks.find((D) => D.kind === "datetime");
    }
    get isDate() {
      return !!this._def.checks.find((D) => D.kind === "date");
    }
    get isTime() {
      return !!this._def.checks.find((D) => D.kind === "time");
    }
    get isDuration() {
      return !!this._def.checks.find((D) => D.kind === "duration");
    }
    get isEmail() {
      return !!this._def.checks.find((D) => D.kind === "email");
    }
    get isURL() {
      return !!this._def.checks.find((D) => D.kind === "url");
    }
    get isEmoji() {
      return !!this._def.checks.find((D) => D.kind === "emoji");
    }
    get isUUID() {
      return !!this._def.checks.find((D) => D.kind === "uuid");
    }
    get isNANOID() {
      return !!this._def.checks.find((D) => D.kind === "nanoid");
    }
    get isCUID() {
      return !!this._def.checks.find((D) => D.kind === "cuid");
    }
    get isCUID2() {
      return !!this._def.checks.find((D) => D.kind === "cuid2");
    }
    get isULID() {
      return !!this._def.checks.find((D) => D.kind === "ulid");
    }
    get isIP() {
      return !!this._def.checks.find((D) => D.kind === "ip");
    }
    get isBase64() {
      return !!this._def.checks.find((D) => D.kind === "base64");
    }
    get minLength() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "min" && (D === null || j.value > D) && (D = j.value);
      return D;
    }
    get maxLength() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "max" && (D === null || j.value < D) && (D = j.value);
      return D;
    }
  }
  t.ZodString = g, g.create = (ve) => {
    var D;
    return new g({
      checks: [],
      typeName: He.ZodString,
      coerce: (D = ve == null ? void 0 : ve.coerce) !== null && D !== void 0 ? D : !1,
      ...M(ve)
    });
  };
  function b(ve, D) {
    const j = (ve.toString().split(".")[1] || "").length, Y = (D.toString().split(".")[1] || "").length, me = j > Y ? j : Y, pe = parseInt(ve.toFixed(me).replace(".", "")), Pe = parseInt(D.toFixed(me).replace(".", ""));
    return pe % Pe / Math.pow(10, me);
  }
  class _ extends S {
    constructor() {
      super(...arguments), this.min = this.gte, this.max = this.lte, this.step = this.multipleOf;
    }
    _parse(D) {
      if (this._def.coerce && (D.data = Number(D.data)), this._getType(D) !== v.ZodParsedType.number) {
        const pe = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(pe, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.number,
          received: pe.parsedType
        }), d.INVALID;
      }
      let Y;
      const me = new d.ParseStatus();
      for (const pe of this._def.checks)
        pe.kind === "int" ? v.util.isInteger(D.data) || (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: "integer",
          received: "float",
          message: pe.message
        }), me.dirty()) : pe.kind === "min" ? (pe.inclusive ? D.data < pe.value : D.data <= pe.value) && (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.too_small,
          minimum: pe.value,
          type: "number",
          inclusive: pe.inclusive,
          exact: !1,
          message: pe.message
        }), me.dirty()) : pe.kind === "max" ? (pe.inclusive ? D.data > pe.value : D.data >= pe.value) && (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.too_big,
          maximum: pe.value,
          type: "number",
          inclusive: pe.inclusive,
          exact: !1,
          message: pe.message
        }), me.dirty()) : pe.kind === "multipleOf" ? b(D.data, pe.value) !== 0 && (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.not_multiple_of,
          multipleOf: pe.value,
          message: pe.message
        }), me.dirty()) : pe.kind === "finite" ? Number.isFinite(D.data) || (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.not_finite,
          message: pe.message
        }), me.dirty()) : v.util.assertNever(pe);
      return { status: me.value, value: D.data };
    }
    gte(D, j) {
      return this.setLimit("min", D, !0, l.errorUtil.toString(j));
    }
    gt(D, j) {
      return this.setLimit("min", D, !1, l.errorUtil.toString(j));
    }
    lte(D, j) {
      return this.setLimit("max", D, !0, l.errorUtil.toString(j));
    }
    lt(D, j) {
      return this.setLimit("max", D, !1, l.errorUtil.toString(j));
    }
    setLimit(D, j, Y, me) {
      return new _({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: D,
            value: j,
            inclusive: Y,
            message: l.errorUtil.toString(me)
          }
        ]
      });
    }
    _addCheck(D) {
      return new _({
        ...this._def,
        checks: [...this._def.checks, D]
      });
    }
    int(D) {
      return this._addCheck({
        kind: "int",
        message: l.errorUtil.toString(D)
      });
    }
    positive(D) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !1,
        message: l.errorUtil.toString(D)
      });
    }
    negative(D) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !1,
        message: l.errorUtil.toString(D)
      });
    }
    nonpositive(D) {
      return this._addCheck({
        kind: "max",
        value: 0,
        inclusive: !0,
        message: l.errorUtil.toString(D)
      });
    }
    nonnegative(D) {
      return this._addCheck({
        kind: "min",
        value: 0,
        inclusive: !0,
        message: l.errorUtil.toString(D)
      });
    }
    multipleOf(D, j) {
      return this._addCheck({
        kind: "multipleOf",
        value: D,
        message: l.errorUtil.toString(j)
      });
    }
    finite(D) {
      return this._addCheck({
        kind: "finite",
        message: l.errorUtil.toString(D)
      });
    }
    safe(D) {
      return this._addCheck({
        kind: "min",
        inclusive: !0,
        value: Number.MIN_SAFE_INTEGER,
        message: l.errorUtil.toString(D)
      })._addCheck({
        kind: "max",
        inclusive: !0,
        value: Number.MAX_SAFE_INTEGER,
        message: l.errorUtil.toString(D)
      });
    }
    get minValue() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "min" && (D === null || j.value > D) && (D = j.value);
      return D;
    }
    get maxValue() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "max" && (D === null || j.value < D) && (D = j.value);
      return D;
    }
    get isInt() {
      return !!this._def.checks.find((D) => D.kind === "int" || D.kind === "multipleOf" && v.util.isInteger(D.value));
    }
    get isFinite() {
      let D = null, j = null;
      for (const Y of this._def.checks) {
        if (Y.kind === "finite" || Y.kind === "int" || Y.kind === "multipleOf")
          return !0;
        Y.kind === "min" ? (j === null || Y.value > j) && (j = Y.value) : Y.kind === "max" && (D === null || Y.value < D) && (D = Y.value);
      }
      return Number.isFinite(j) && Number.isFinite(D);
    }
  }
  t.ZodNumber = _, _.create = (ve) => new _({
    checks: [],
    typeName: He.ZodNumber,
    coerce: (ve == null ? void 0 : ve.coerce) || !1,
    ...M(ve)
  });
  class p extends S {
    constructor() {
      super(...arguments), this.min = this.gte, this.max = this.lte;
    }
    _parse(D) {
      if (this._def.coerce && (D.data = BigInt(D.data)), this._getType(D) !== v.ZodParsedType.bigint) {
        const pe = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(pe, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.bigint,
          received: pe.parsedType
        }), d.INVALID;
      }
      let Y;
      const me = new d.ParseStatus();
      for (const pe of this._def.checks)
        pe.kind === "min" ? (pe.inclusive ? D.data < pe.value : D.data <= pe.value) && (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.too_small,
          type: "bigint",
          minimum: pe.value,
          inclusive: pe.inclusive,
          message: pe.message
        }), me.dirty()) : pe.kind === "max" ? (pe.inclusive ? D.data > pe.value : D.data >= pe.value) && (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.too_big,
          type: "bigint",
          maximum: pe.value,
          inclusive: pe.inclusive,
          message: pe.message
        }), me.dirty()) : pe.kind === "multipleOf" ? D.data % pe.value !== BigInt(0) && (Y = this._getOrReturnCtx(D, Y), (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.not_multiple_of,
          multipleOf: pe.value,
          message: pe.message
        }), me.dirty()) : v.util.assertNever(pe);
      return { status: me.value, value: D.data };
    }
    gte(D, j) {
      return this.setLimit("min", D, !0, l.errorUtil.toString(j));
    }
    gt(D, j) {
      return this.setLimit("min", D, !1, l.errorUtil.toString(j));
    }
    lte(D, j) {
      return this.setLimit("max", D, !0, l.errorUtil.toString(j));
    }
    lt(D, j) {
      return this.setLimit("max", D, !1, l.errorUtil.toString(j));
    }
    setLimit(D, j, Y, me) {
      return new p({
        ...this._def,
        checks: [
          ...this._def.checks,
          {
            kind: D,
            value: j,
            inclusive: Y,
            message: l.errorUtil.toString(me)
          }
        ]
      });
    }
    _addCheck(D) {
      return new p({
        ...this._def,
        checks: [...this._def.checks, D]
      });
    }
    positive(D) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !1,
        message: l.errorUtil.toString(D)
      });
    }
    negative(D) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !1,
        message: l.errorUtil.toString(D)
      });
    }
    nonpositive(D) {
      return this._addCheck({
        kind: "max",
        value: BigInt(0),
        inclusive: !0,
        message: l.errorUtil.toString(D)
      });
    }
    nonnegative(D) {
      return this._addCheck({
        kind: "min",
        value: BigInt(0),
        inclusive: !0,
        message: l.errorUtil.toString(D)
      });
    }
    multipleOf(D, j) {
      return this._addCheck({
        kind: "multipleOf",
        value: D,
        message: l.errorUtil.toString(j)
      });
    }
    get minValue() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "min" && (D === null || j.value > D) && (D = j.value);
      return D;
    }
    get maxValue() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "max" && (D === null || j.value < D) && (D = j.value);
      return D;
    }
  }
  t.ZodBigInt = p, p.create = (ve) => {
    var D;
    return new p({
      checks: [],
      typeName: He.ZodBigInt,
      coerce: (D = ve == null ? void 0 : ve.coerce) !== null && D !== void 0 ? D : !1,
      ...M(ve)
    });
  };
  class s extends S {
    _parse(D) {
      if (this._def.coerce && (D.data = !!D.data), this._getType(D) !== v.ZodParsedType.boolean) {
        const Y = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.boolean,
          received: Y.parsedType
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
  }
  t.ZodBoolean = s, s.create = (ve) => new s({
    typeName: He.ZodBoolean,
    coerce: (ve == null ? void 0 : ve.coerce) || !1,
    ...M(ve)
  });
  class y extends S {
    _parse(D) {
      if (this._def.coerce && (D.data = new Date(D.data)), this._getType(D) !== v.ZodParsedType.date) {
        const pe = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(pe, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.date,
          received: pe.parsedType
        }), d.INVALID;
      }
      if (isNaN(D.data.getTime())) {
        const pe = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(pe, {
          code: m.ZodIssueCode.invalid_date
        }), d.INVALID;
      }
      const Y = new d.ParseStatus();
      let me;
      for (const pe of this._def.checks)
        pe.kind === "min" ? D.data.getTime() < pe.value && (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
          code: m.ZodIssueCode.too_small,
          message: pe.message,
          inclusive: !0,
          exact: !1,
          minimum: pe.value,
          type: "date"
        }), Y.dirty()) : pe.kind === "max" ? D.data.getTime() > pe.value && (me = this._getOrReturnCtx(D, me), (0, d.addIssueToContext)(me, {
          code: m.ZodIssueCode.too_big,
          message: pe.message,
          inclusive: !0,
          exact: !1,
          maximum: pe.value,
          type: "date"
        }), Y.dirty()) : v.util.assertNever(pe);
      return {
        status: Y.value,
        value: new Date(D.data.getTime())
      };
    }
    _addCheck(D) {
      return new y({
        ...this._def,
        checks: [...this._def.checks, D]
      });
    }
    min(D, j) {
      return this._addCheck({
        kind: "min",
        value: D.getTime(),
        message: l.errorUtil.toString(j)
      });
    }
    max(D, j) {
      return this._addCheck({
        kind: "max",
        value: D.getTime(),
        message: l.errorUtil.toString(j)
      });
    }
    get minDate() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "min" && (D === null || j.value > D) && (D = j.value);
      return D != null ? new Date(D) : null;
    }
    get maxDate() {
      let D = null;
      for (const j of this._def.checks)
        j.kind === "max" && (D === null || j.value < D) && (D = j.value);
      return D != null ? new Date(D) : null;
    }
  }
  t.ZodDate = y, y.create = (ve) => new y({
    checks: [],
    coerce: (ve == null ? void 0 : ve.coerce) || !1,
    typeName: He.ZodDate,
    ...M(ve)
  });
  class T extends S {
    _parse(D) {
      if (this._getType(D) !== v.ZodParsedType.symbol) {
        const Y = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.symbol,
          received: Y.parsedType
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
  }
  t.ZodSymbol = T, T.create = (ve) => new T({
    typeName: He.ZodSymbol,
    ...M(ve)
  });
  class P extends S {
    _parse(D) {
      if (this._getType(D) !== v.ZodParsedType.undefined) {
        const Y = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.undefined,
          received: Y.parsedType
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
  }
  t.ZodUndefined = P, P.create = (ve) => new P({
    typeName: He.ZodUndefined,
    ...M(ve)
  });
  class z extends S {
    _parse(D) {
      if (this._getType(D) !== v.ZodParsedType.null) {
        const Y = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.null,
          received: Y.parsedType
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
  }
  t.ZodNull = z, z.create = (ve) => new z({
    typeName: He.ZodNull,
    ...M(ve)
  });
  class J extends S {
    constructor() {
      super(...arguments), this._any = !0;
    }
    _parse(D) {
      return (0, d.OK)(D.data);
    }
  }
  t.ZodAny = J, J.create = (ve) => new J({
    typeName: He.ZodAny,
    ...M(ve)
  });
  class Z extends S {
    constructor() {
      super(...arguments), this._unknown = !0;
    }
    _parse(D) {
      return (0, d.OK)(D.data);
    }
  }
  t.ZodUnknown = Z, Z.create = (ve) => new Z({
    typeName: He.ZodUnknown,
    ...M(ve)
  });
  class F extends S {
    _parse(D) {
      const j = this._getOrReturnCtx(D);
      return (0, d.addIssueToContext)(j, {
        code: m.ZodIssueCode.invalid_type,
        expected: v.ZodParsedType.never,
        received: j.parsedType
      }), d.INVALID;
    }
  }
  t.ZodNever = F, F.create = (ve) => new F({
    typeName: He.ZodNever,
    ...M(ve)
  });
  class ee extends S {
    _parse(D) {
      if (this._getType(D) !== v.ZodParsedType.undefined) {
        const Y = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.void,
          received: Y.parsedType
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
  }
  t.ZodVoid = ee, ee.create = (ve) => new ee({
    typeName: He.ZodVoid,
    ...M(ve)
  });
  class re extends S {
    _parse(D) {
      const { ctx: j, status: Y } = this._processInputParams(D), me = this._def;
      if (j.parsedType !== v.ZodParsedType.array)
        return (0, d.addIssueToContext)(j, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.array,
          received: j.parsedType
        }), d.INVALID;
      if (me.exactLength !== null) {
        const Pe = j.data.length > me.exactLength.value, Re = j.data.length < me.exactLength.value;
        (Pe || Re) && ((0, d.addIssueToContext)(j, {
          code: Pe ? m.ZodIssueCode.too_big : m.ZodIssueCode.too_small,
          minimum: Re ? me.exactLength.value : void 0,
          maximum: Pe ? me.exactLength.value : void 0,
          type: "array",
          inclusive: !0,
          exact: !0,
          message: me.exactLength.message
        }), Y.dirty());
      }
      if (me.minLength !== null && j.data.length < me.minLength.value && ((0, d.addIssueToContext)(j, {
        code: m.ZodIssueCode.too_small,
        minimum: me.minLength.value,
        type: "array",
        inclusive: !0,
        exact: !1,
        message: me.minLength.message
      }), Y.dirty()), me.maxLength !== null && j.data.length > me.maxLength.value && ((0, d.addIssueToContext)(j, {
        code: m.ZodIssueCode.too_big,
        maximum: me.maxLength.value,
        type: "array",
        inclusive: !0,
        exact: !1,
        message: me.maxLength.message
      }), Y.dirty()), j.common.async)
        return Promise.all([...j.data].map((Pe, Re) => me.type._parseAsync(new h(j, Pe, j.path, Re)))).then((Pe) => d.ParseStatus.mergeArray(Y, Pe));
      const pe = [...j.data].map((Pe, Re) => me.type._parseSync(new h(j, Pe, j.path, Re)));
      return d.ParseStatus.mergeArray(Y, pe);
    }
    get element() {
      return this._def.type;
    }
    min(D, j) {
      return new re({
        ...this._def,
        minLength: { value: D, message: l.errorUtil.toString(j) }
      });
    }
    max(D, j) {
      return new re({
        ...this._def,
        maxLength: { value: D, message: l.errorUtil.toString(j) }
      });
    }
    length(D, j) {
      return new re({
        ...this._def,
        exactLength: { value: D, message: l.errorUtil.toString(j) }
      });
    }
    nonempty(D) {
      return this.min(1, D);
    }
  }
  t.ZodArray = re, re.create = (ve, D) => new re({
    type: ve,
    minLength: null,
    maxLength: null,
    exactLength: null,
    typeName: He.ZodArray,
    ...M(D)
  });
  function de(ve) {
    if (ve instanceof se) {
      const D = {};
      for (const j in ve.shape) {
        const Y = ve.shape[j];
        D[j] = Te.create(de(Y));
      }
      return new se({
        ...ve._def,
        shape: () => D
      });
    } else
      return ve instanceof re ? new re({
        ...ve._def,
        type: de(ve.element)
      }) : ve instanceof Te ? Te.create(de(ve.unwrap())) : ve instanceof N ? N.create(de(ve.unwrap())) : ve instanceof st ? st.create(ve.items.map((D) => de(D))) : ve;
  }
  class se extends S {
    constructor() {
      super(...arguments), this._cached = null, this.nonstrict = this.passthrough, this.augment = this.extend;
    }
    _getCached() {
      if (this._cached !== null)
        return this._cached;
      const D = this._def.shape(), j = v.util.objectKeys(D);
      return this._cached = { shape: D, keys: j };
    }
    _parse(D) {
      if (this._getType(D) !== v.ZodParsedType.object) {
        const ot = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(ot, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.object,
          received: ot.parsedType
        }), d.INVALID;
      }
      const { status: Y, ctx: me } = this._processInputParams(D), { shape: pe, keys: Pe } = this._getCached(), Re = [];
      if (!(this._def.catchall instanceof F && this._def.unknownKeys === "strip"))
        for (const ot in me.data)
          Pe.includes(ot) || Re.push(ot);
      const nt = [];
      for (const ot of Pe) {
        const _t = pe[ot], Pt = me.data[ot];
        nt.push({
          key: { status: "valid", value: ot },
          value: _t._parse(new h(me, Pt, me.path, ot)),
          alwaysSet: ot in me.data
        });
      }
      if (this._def.catchall instanceof F) {
        const ot = this._def.unknownKeys;
        if (ot === "passthrough")
          for (const _t of Re)
            nt.push({
              key: { status: "valid", value: _t },
              value: { status: "valid", value: me.data[_t] }
            });
        else if (ot === "strict")
          Re.length > 0 && ((0, d.addIssueToContext)(me, {
            code: m.ZodIssueCode.unrecognized_keys,
            keys: Re
          }), Y.dirty());
        else if (ot !== "strip")
          throw new Error("Internal ZodObject error: invalid unknownKeys value.");
      } else {
        const ot = this._def.catchall;
        for (const _t of Re) {
          const Pt = me.data[_t];
          nt.push({
            key: { status: "valid", value: _t },
            value: ot._parse(
              new h(me, Pt, me.path, _t)
              //, ctx.child(key), value, getParsedType(value)
            ),
            alwaysSet: _t in me.data
          });
        }
      }
      return me.common.async ? Promise.resolve().then(async () => {
        const ot = [];
        for (const _t of nt) {
          const Pt = await _t.key, Ae = await _t.value;
          ot.push({
            key: Pt,
            value: Ae,
            alwaysSet: _t.alwaysSet
          });
        }
        return ot;
      }).then((ot) => d.ParseStatus.mergeObjectSync(Y, ot)) : d.ParseStatus.mergeObjectSync(Y, nt);
    }
    get shape() {
      return this._def.shape();
    }
    strict(D) {
      return l.errorUtil.errToObj, new se({
        ...this._def,
        unknownKeys: "strict",
        ...D !== void 0 ? {
          errorMap: (j, Y) => {
            var me, pe, Pe, Re;
            const nt = (Pe = (pe = (me = this._def).errorMap) === null || pe === void 0 ? void 0 : pe.call(me, j, Y).message) !== null && Pe !== void 0 ? Pe : Y.defaultError;
            return j.code === "unrecognized_keys" ? {
              message: (Re = l.errorUtil.errToObj(D).message) !== null && Re !== void 0 ? Re : nt
            } : {
              message: nt
            };
          }
        } : {}
      });
    }
    strip() {
      return new se({
        ...this._def,
        unknownKeys: "strip"
      });
    }
    passthrough() {
      return new se({
        ...this._def,
        unknownKeys: "passthrough"
      });
    }
    // const AugmentFactory =
    //   <Def extends ZodObjectDef>(def: Def) =>
    //   <Augmentation extends ZodRawShape>(
    //     augmentation: Augmentation
    //   ): ZodObject<
    //     extendShape<ReturnType<Def["shape"]>, Augmentation>,
    //     Def["unknownKeys"],
    //     Def["catchall"]
    //   > => {
    //     return new ZodObject({
    //       ...def,
    //       shape: () => ({
    //         ...def.shape(),
    //         ...augmentation,
    //       }),
    //     }) as any;
    //   };
    extend(D) {
      return new se({
        ...this._def,
        shape: () => ({
          ...this._def.shape(),
          ...D
        })
      });
    }
    /**
     * Prior to zod@1.0.12 there was a bug in the
     * inferred type of merged objects. Please
     * upgrade if you are experiencing issues.
     */
    merge(D) {
      return new se({
        unknownKeys: D._def.unknownKeys,
        catchall: D._def.catchall,
        shape: () => ({
          ...this._def.shape(),
          ...D._def.shape()
        }),
        typeName: He.ZodObject
      });
    }
    // merge<
    //   Incoming extends AnyZodObject,
    //   Augmentation extends Incoming["shape"],
    //   NewOutput extends {
    //     [k in keyof Augmentation | keyof Output]: k extends keyof Augmentation
    //       ? Augmentation[k]["_output"]
    //       : k extends keyof Output
    //       ? Output[k]
    //       : never;
    //   },
    //   NewInput extends {
    //     [k in keyof Augmentation | keyof Input]: k extends keyof Augmentation
    //       ? Augmentation[k]["_input"]
    //       : k extends keyof Input
    //       ? Input[k]
    //       : never;
    //   }
    // >(
    //   merging: Incoming
    // ): ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"],
    //   NewOutput,
    //   NewInput
    // > {
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    setKey(D, j) {
      return this.augment({ [D]: j });
    }
    // merge<Incoming extends AnyZodObject>(
    //   merging: Incoming
    // ): //ZodObject<T & Incoming["_shape"], UnknownKeys, Catchall> = (merging) => {
    // ZodObject<
    //   extendShape<T, ReturnType<Incoming["_def"]["shape"]>>,
    //   Incoming["_def"]["unknownKeys"],
    //   Incoming["_def"]["catchall"]
    // > {
    //   // const mergedShape = objectUtil.mergeShapes(
    //   //   this._def.shape(),
    //   //   merging._def.shape()
    //   // );
    //   const merged: any = new ZodObject({
    //     unknownKeys: merging._def.unknownKeys,
    //     catchall: merging._def.catchall,
    //     shape: () =>
    //       objectUtil.mergeShapes(this._def.shape(), merging._def.shape()),
    //     typeName: ZodFirstPartyTypeKind.ZodObject,
    //   }) as any;
    //   return merged;
    // }
    catchall(D) {
      return new se({
        ...this._def,
        catchall: D
      });
    }
    pick(D) {
      const j = {};
      return v.util.objectKeys(D).forEach((Y) => {
        D[Y] && this.shape[Y] && (j[Y] = this.shape[Y]);
      }), new se({
        ...this._def,
        shape: () => j
      });
    }
    omit(D) {
      const j = {};
      return v.util.objectKeys(this.shape).forEach((Y) => {
        D[Y] || (j[Y] = this.shape[Y]);
      }), new se({
        ...this._def,
        shape: () => j
      });
    }
    /**
     * @deprecated
     */
    deepPartial() {
      return de(this);
    }
    partial(D) {
      const j = {};
      return v.util.objectKeys(this.shape).forEach((Y) => {
        const me = this.shape[Y];
        D && !D[Y] ? j[Y] = me : j[Y] = me.optional();
      }), new se({
        ...this._def,
        shape: () => j
      });
    }
    required(D) {
      const j = {};
      return v.util.objectKeys(this.shape).forEach((Y) => {
        if (D && !D[Y])
          j[Y] = this.shape[Y];
        else {
          let pe = this.shape[Y];
          for (; pe instanceof Te; )
            pe = pe._def.innerType;
          j[Y] = pe;
        }
      }), new se({
        ...this._def,
        shape: () => j
      });
    }
    keyof() {
      return Ue(v.util.objectKeys(this.shape));
    }
  }
  t.ZodObject = se, se.create = (ve, D) => new se({
    shape: () => ve,
    unknownKeys: "strip",
    catchall: F.create(),
    typeName: He.ZodObject,
    ...M(D)
  }), se.strictCreate = (ve, D) => new se({
    shape: () => ve,
    unknownKeys: "strict",
    catchall: F.create(),
    typeName: He.ZodObject,
    ...M(D)
  }), se.lazycreate = (ve, D) => new se({
    shape: ve,
    unknownKeys: "strip",
    catchall: F.create(),
    typeName: He.ZodObject,
    ...M(D)
  });
  class Q extends S {
    _parse(D) {
      const { ctx: j } = this._processInputParams(D), Y = this._def.options;
      function me(pe) {
        for (const Re of pe)
          if (Re.result.status === "valid")
            return Re.result;
        for (const Re of pe)
          if (Re.result.status === "dirty")
            return j.common.issues.push(...Re.ctx.common.issues), Re.result;
        const Pe = pe.map((Re) => new m.ZodError(Re.ctx.common.issues));
        return (0, d.addIssueToContext)(j, {
          code: m.ZodIssueCode.invalid_union,
          unionErrors: Pe
        }), d.INVALID;
      }
      if (j.common.async)
        return Promise.all(Y.map(async (pe) => {
          const Pe = {
            ...j,
            common: {
              ...j.common,
              issues: []
            },
            parent: null
          };
          return {
            result: await pe._parseAsync({
              data: j.data,
              path: j.path,
              parent: Pe
            }),
            ctx: Pe
          };
        })).then(me);
      {
        let pe;
        const Pe = [];
        for (const nt of Y) {
          const ot = {
            ...j,
            common: {
              ...j.common,
              issues: []
            },
            parent: null
          }, _t = nt._parseSync({
            data: j.data,
            path: j.path,
            parent: ot
          });
          if (_t.status === "valid")
            return _t;
          _t.status === "dirty" && !pe && (pe = { result: _t, ctx: ot }), ot.common.issues.length && Pe.push(ot.common.issues);
        }
        if (pe)
          return j.common.issues.push(...pe.ctx.common.issues), pe.result;
        const Re = Pe.map((nt) => new m.ZodError(nt));
        return (0, d.addIssueToContext)(j, {
          code: m.ZodIssueCode.invalid_union,
          unionErrors: Re
        }), d.INVALID;
      }
    }
    get options() {
      return this._def.options;
    }
  }
  t.ZodUnion = Q, Q.create = (ve, D) => new Q({
    options: ve,
    typeName: He.ZodUnion,
    ...M(D)
  });
  const ge = (ve) => ve instanceof Fe ? ge(ve.schema) : ve instanceof fe ? ge(ve.innerType()) : ve instanceof Et ? [ve.value] : ve instanceof oe ? ve.options : ve instanceof le ? v.util.objectValues(ve.enum) : ve instanceof R ? ge(ve._def.innerType) : ve instanceof P ? [void 0] : ve instanceof z ? [null] : ve instanceof Te ? [void 0, ...ge(ve.unwrap())] : ve instanceof N ? [null, ...ge(ve.unwrap())] : ve instanceof ne || ve instanceof ue ? ge(ve.unwrap()) : ve instanceof L ? ge(ve._def.innerType) : [];
  class Ye extends S {
    _parse(D) {
      const { ctx: j } = this._processInputParams(D);
      if (j.parsedType !== v.ZodParsedType.object)
        return (0, d.addIssueToContext)(j, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.object,
          received: j.parsedType
        }), d.INVALID;
      const Y = this.discriminator, me = j.data[Y], pe = this.optionsMap.get(me);
      return pe ? j.common.async ? pe._parseAsync({
        data: j.data,
        path: j.path,
        parent: j
      }) : pe._parseSync({
        data: j.data,
        path: j.path,
        parent: j
      }) : ((0, d.addIssueToContext)(j, {
        code: m.ZodIssueCode.invalid_union_discriminator,
        options: Array.from(this.optionsMap.keys()),
        path: [Y]
      }), d.INVALID);
    }
    get discriminator() {
      return this._def.discriminator;
    }
    get options() {
      return this._def.options;
    }
    get optionsMap() {
      return this._def.optionsMap;
    }
    /**
     * The constructor of the discriminated union schema. Its behaviour is very similar to that of the normal z.union() constructor.
     * However, it only allows a union of objects, all of which need to share a discriminator property. This property must
     * have a different value for each object in the union.
     * @param discriminator the name of the discriminator property
     * @param types an array of object schemas
     * @param params
     */
    static create(D, j, Y) {
      const me = /* @__PURE__ */ new Map();
      for (const pe of j) {
        const Pe = ge(pe.shape[D]);
        if (!Pe.length)
          throw new Error(`A discriminator value for key \`${D}\` could not be extracted from all schema options`);
        for (const Re of Pe) {
          if (me.has(Re))
            throw new Error(`Discriminator property ${String(D)} has duplicate value ${String(Re)}`);
          me.set(Re, pe);
        }
      }
      return new Ye({
        typeName: He.ZodDiscriminatedUnion,
        discriminator: D,
        options: j,
        optionsMap: me,
        ...M(Y)
      });
    }
  }
  t.ZodDiscriminatedUnion = Ye;
  function Ce(ve, D) {
    const j = (0, v.getParsedType)(ve), Y = (0, v.getParsedType)(D);
    if (ve === D)
      return { valid: !0, data: ve };
    if (j === v.ZodParsedType.object && Y === v.ZodParsedType.object) {
      const me = v.util.objectKeys(D), pe = v.util.objectKeys(ve).filter((Re) => me.indexOf(Re) !== -1), Pe = { ...ve, ...D };
      for (const Re of pe) {
        const nt = Ce(ve[Re], D[Re]);
        if (!nt.valid)
          return { valid: !1 };
        Pe[Re] = nt.data;
      }
      return { valid: !0, data: Pe };
    } else if (j === v.ZodParsedType.array && Y === v.ZodParsedType.array) {
      if (ve.length !== D.length)
        return { valid: !1 };
      const me = [];
      for (let pe = 0; pe < ve.length; pe++) {
        const Pe = ve[pe], Re = D[pe], nt = Ce(Pe, Re);
        if (!nt.valid)
          return { valid: !1 };
        me.push(nt.data);
      }
      return { valid: !0, data: me };
    } else
      return j === v.ZodParsedType.date && Y === v.ZodParsedType.date && +ve == +D ? { valid: !0, data: ve } : { valid: !1 };
  }
  class Be extends S {
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D), me = (pe, Pe) => {
        if ((0, d.isAborted)(pe) || (0, d.isAborted)(Pe))
          return d.INVALID;
        const Re = Ce(pe.value, Pe.value);
        return Re.valid ? (((0, d.isDirty)(pe) || (0, d.isDirty)(Pe)) && j.dirty(), { status: j.value, value: Re.data }) : ((0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_intersection_types
        }), d.INVALID);
      };
      return Y.common.async ? Promise.all([
        this._def.left._parseAsync({
          data: Y.data,
          path: Y.path,
          parent: Y
        }),
        this._def.right._parseAsync({
          data: Y.data,
          path: Y.path,
          parent: Y
        })
      ]).then(([pe, Pe]) => me(pe, Pe)) : me(this._def.left._parseSync({
        data: Y.data,
        path: Y.path,
        parent: Y
      }), this._def.right._parseSync({
        data: Y.data,
        path: Y.path,
        parent: Y
      }));
    }
  }
  t.ZodIntersection = Be, Be.create = (ve, D, j) => new Be({
    left: ve,
    right: D,
    typeName: He.ZodIntersection,
    ...M(j)
  });
  class st extends S {
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D);
      if (Y.parsedType !== v.ZodParsedType.array)
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.array,
          received: Y.parsedType
        }), d.INVALID;
      if (Y.data.length < this._def.items.length)
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.too_small,
          minimum: this._def.items.length,
          inclusive: !0,
          exact: !1,
          type: "array"
        }), d.INVALID;
      !this._def.rest && Y.data.length > this._def.items.length && ((0, d.addIssueToContext)(Y, {
        code: m.ZodIssueCode.too_big,
        maximum: this._def.items.length,
        inclusive: !0,
        exact: !1,
        type: "array"
      }), j.dirty());
      const pe = [...Y.data].map((Pe, Re) => {
        const nt = this._def.items[Re] || this._def.rest;
        return nt ? nt._parse(new h(Y, Pe, Y.path, Re)) : null;
      }).filter((Pe) => !!Pe);
      return Y.common.async ? Promise.all(pe).then((Pe) => d.ParseStatus.mergeArray(j, Pe)) : d.ParseStatus.mergeArray(j, pe);
    }
    get items() {
      return this._def.items;
    }
    rest(D) {
      return new st({
        ...this._def,
        rest: D
      });
    }
  }
  t.ZodTuple = st, st.create = (ve, D) => {
    if (!Array.isArray(ve))
      throw new Error("You must pass an array of schemas to z.tuple([ ... ])");
    return new st({
      items: ve,
      typeName: He.ZodTuple,
      rest: null,
      ...M(D)
    });
  };
  class De extends S {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D);
      if (Y.parsedType !== v.ZodParsedType.object)
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.object,
          received: Y.parsedType
        }), d.INVALID;
      const me = [], pe = this._def.keyType, Pe = this._def.valueType;
      for (const Re in Y.data)
        me.push({
          key: pe._parse(new h(Y, Re, Y.path, Re)),
          value: Pe._parse(new h(Y, Y.data[Re], Y.path, Re)),
          alwaysSet: Re in Y.data
        });
      return Y.common.async ? d.ParseStatus.mergeObjectAsync(j, me) : d.ParseStatus.mergeObjectSync(j, me);
    }
    get element() {
      return this._def.valueType;
    }
    static create(D, j, Y) {
      return j instanceof S ? new De({
        keyType: D,
        valueType: j,
        typeName: He.ZodRecord,
        ...M(Y)
      }) : new De({
        keyType: g.create(),
        valueType: D,
        typeName: He.ZodRecord,
        ...M(j)
      });
    }
  }
  t.ZodRecord = De;
  class _e extends S {
    get keySchema() {
      return this._def.keyType;
    }
    get valueSchema() {
      return this._def.valueType;
    }
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D);
      if (Y.parsedType !== v.ZodParsedType.map)
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.map,
          received: Y.parsedType
        }), d.INVALID;
      const me = this._def.keyType, pe = this._def.valueType, Pe = [...Y.data.entries()].map(([Re, nt], ot) => ({
        key: me._parse(new h(Y, Re, Y.path, [ot, "key"])),
        value: pe._parse(new h(Y, nt, Y.path, [ot, "value"]))
      }));
      if (Y.common.async) {
        const Re = /* @__PURE__ */ new Map();
        return Promise.resolve().then(async () => {
          for (const nt of Pe) {
            const ot = await nt.key, _t = await nt.value;
            if (ot.status === "aborted" || _t.status === "aborted")
              return d.INVALID;
            (ot.status === "dirty" || _t.status === "dirty") && j.dirty(), Re.set(ot.value, _t.value);
          }
          return { status: j.value, value: Re };
        });
      } else {
        const Re = /* @__PURE__ */ new Map();
        for (const nt of Pe) {
          const ot = nt.key, _t = nt.value;
          if (ot.status === "aborted" || _t.status === "aborted")
            return d.INVALID;
          (ot.status === "dirty" || _t.status === "dirty") && j.dirty(), Re.set(ot.value, _t.value);
        }
        return { status: j.value, value: Re };
      }
    }
  }
  t.ZodMap = _e, _e.create = (ve, D, j) => new _e({
    valueType: D,
    keyType: ve,
    typeName: He.ZodMap,
    ...M(j)
  });
  class St extends S {
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D);
      if (Y.parsedType !== v.ZodParsedType.set)
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.set,
          received: Y.parsedType
        }), d.INVALID;
      const me = this._def;
      me.minSize !== null && Y.data.size < me.minSize.value && ((0, d.addIssueToContext)(Y, {
        code: m.ZodIssueCode.too_small,
        minimum: me.minSize.value,
        type: "set",
        inclusive: !0,
        exact: !1,
        message: me.minSize.message
      }), j.dirty()), me.maxSize !== null && Y.data.size > me.maxSize.value && ((0, d.addIssueToContext)(Y, {
        code: m.ZodIssueCode.too_big,
        maximum: me.maxSize.value,
        type: "set",
        inclusive: !0,
        exact: !1,
        message: me.maxSize.message
      }), j.dirty());
      const pe = this._def.valueType;
      function Pe(nt) {
        const ot = /* @__PURE__ */ new Set();
        for (const _t of nt) {
          if (_t.status === "aborted")
            return d.INVALID;
          _t.status === "dirty" && j.dirty(), ot.add(_t.value);
        }
        return { status: j.value, value: ot };
      }
      const Re = [...Y.data.values()].map((nt, ot) => pe._parse(new h(Y, nt, Y.path, ot)));
      return Y.common.async ? Promise.all(Re).then((nt) => Pe(nt)) : Pe(Re);
    }
    min(D, j) {
      return new St({
        ...this._def,
        minSize: { value: D, message: l.errorUtil.toString(j) }
      });
    }
    max(D, j) {
      return new St({
        ...this._def,
        maxSize: { value: D, message: l.errorUtil.toString(j) }
      });
    }
    size(D, j) {
      return this.min(D, j).max(D, j);
    }
    nonempty(D) {
      return this.min(1, D);
    }
  }
  t.ZodSet = St, St.create = (ve, D) => new St({
    valueType: ve,
    minSize: null,
    maxSize: null,
    typeName: He.ZodSet,
    ...M(D)
  });
  class Oe extends S {
    constructor() {
      super(...arguments), this.validate = this.implement;
    }
    _parse(D) {
      const { ctx: j } = this._processInputParams(D);
      if (j.parsedType !== v.ZodParsedType.function)
        return (0, d.addIssueToContext)(j, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.function,
          received: j.parsedType
        }), d.INVALID;
      function Y(Re, nt) {
        return (0, d.makeIssue)({
          data: Re,
          path: j.path,
          errorMaps: [
            j.common.contextualErrorMap,
            j.schemaErrorMap,
            (0, a.getErrorMap)(),
            a.defaultErrorMap
          ].filter((ot) => !!ot),
          issueData: {
            code: m.ZodIssueCode.invalid_arguments,
            argumentsError: nt
          }
        });
      }
      function me(Re, nt) {
        return (0, d.makeIssue)({
          data: Re,
          path: j.path,
          errorMaps: [
            j.common.contextualErrorMap,
            j.schemaErrorMap,
            (0, a.getErrorMap)(),
            a.defaultErrorMap
          ].filter((ot) => !!ot),
          issueData: {
            code: m.ZodIssueCode.invalid_return_type,
            returnTypeError: nt
          }
        });
      }
      const pe = { errorMap: j.common.contextualErrorMap }, Pe = j.data;
      if (this._def.returns instanceof ie) {
        const Re = this;
        return (0, d.OK)(async function(...nt) {
          const ot = new m.ZodError([]), _t = await Re._def.args.parseAsync(nt, pe).catch((Ft) => {
            throw ot.addIssue(Y(nt, Ft)), ot;
          }), Pt = await Reflect.apply(Pe, this, _t);
          return await Re._def.returns._def.type.parseAsync(Pt, pe).catch((Ft) => {
            throw ot.addIssue(me(Pt, Ft)), ot;
          });
        });
      } else {
        const Re = this;
        return (0, d.OK)(function(...nt) {
          const ot = Re._def.args.safeParse(nt, pe);
          if (!ot.success)
            throw new m.ZodError([Y(nt, ot.error)]);
          const _t = Reflect.apply(Pe, this, ot.data), Pt = Re._def.returns.safeParse(_t, pe);
          if (!Pt.success)
            throw new m.ZodError([me(_t, Pt.error)]);
          return Pt.data;
        });
      }
    }
    parameters() {
      return this._def.args;
    }
    returnType() {
      return this._def.returns;
    }
    args(...D) {
      return new Oe({
        ...this._def,
        args: st.create(D).rest(Z.create())
      });
    }
    returns(D) {
      return new Oe({
        ...this._def,
        returns: D
      });
    }
    implement(D) {
      return this.parse(D);
    }
    strictImplement(D) {
      return this.parse(D);
    }
    static create(D, j, Y) {
      return new Oe({
        args: D || st.create([]).rest(Z.create()),
        returns: j || Z.create(),
        typeName: He.ZodFunction,
        ...M(Y)
      });
    }
  }
  t.ZodFunction = Oe;
  class Fe extends S {
    get schema() {
      return this._def.getter();
    }
    _parse(D) {
      const { ctx: j } = this._processInputParams(D);
      return this._def.getter()._parse({ data: j.data, path: j.path, parent: j });
    }
  }
  t.ZodLazy = Fe, Fe.create = (ve, D) => new Fe({
    getter: ve,
    typeName: He.ZodLazy,
    ...M(D)
  });
  class Et extends S {
    _parse(D) {
      if (D.data !== this._def.value) {
        const j = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(j, {
          received: j.data,
          code: m.ZodIssueCode.invalid_literal,
          expected: this._def.value
        }), d.INVALID;
      }
      return { status: "valid", value: D.data };
    }
    get value() {
      return this._def.value;
    }
  }
  t.ZodLiteral = Et, Et.create = (ve, D) => new Et({
    value: ve,
    typeName: He.ZodLiteral,
    ...M(D)
  });
  function Ue(ve, D) {
    return new oe({
      values: ve,
      typeName: He.ZodEnum,
      ...M(D)
    });
  }
  class oe extends S {
    constructor() {
      super(...arguments), i.set(this, void 0);
    }
    _parse(D) {
      if (typeof D.data != "string") {
        const j = this._getOrReturnCtx(D), Y = this._def.values;
        return (0, d.addIssueToContext)(j, {
          expected: v.util.joinValues(Y),
          received: j.parsedType,
          code: m.ZodIssueCode.invalid_type
        }), d.INVALID;
      }
      if (e(this, i, "f") || r(this, i, new Set(this._def.values), "f"), !e(this, i, "f").has(D.data)) {
        const j = this._getOrReturnCtx(D), Y = this._def.values;
        return (0, d.addIssueToContext)(j, {
          received: j.data,
          code: m.ZodIssueCode.invalid_enum_value,
          options: Y
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
    get options() {
      return this._def.values;
    }
    get enum() {
      const D = {};
      for (const j of this._def.values)
        D[j] = j;
      return D;
    }
    get Values() {
      const D = {};
      for (const j of this._def.values)
        D[j] = j;
      return D;
    }
    get Enum() {
      const D = {};
      for (const j of this._def.values)
        D[j] = j;
      return D;
    }
    extract(D, j = this._def) {
      return oe.create(D, {
        ...this._def,
        ...j
      });
    }
    exclude(D, j = this._def) {
      return oe.create(this.options.filter((Y) => !D.includes(Y)), {
        ...this._def,
        ...j
      });
    }
  }
  t.ZodEnum = oe, i = /* @__PURE__ */ new WeakMap(), oe.create = Ue;
  class le extends S {
    constructor() {
      super(...arguments), f.set(this, void 0);
    }
    _parse(D) {
      const j = v.util.getValidEnumValues(this._def.values), Y = this._getOrReturnCtx(D);
      if (Y.parsedType !== v.ZodParsedType.string && Y.parsedType !== v.ZodParsedType.number) {
        const me = v.util.objectValues(j);
        return (0, d.addIssueToContext)(Y, {
          expected: v.util.joinValues(me),
          received: Y.parsedType,
          code: m.ZodIssueCode.invalid_type
        }), d.INVALID;
      }
      if (e(this, f, "f") || r(this, f, new Set(v.util.getValidEnumValues(this._def.values)), "f"), !e(this, f, "f").has(D.data)) {
        const me = v.util.objectValues(j);
        return (0, d.addIssueToContext)(Y, {
          received: Y.data,
          code: m.ZodIssueCode.invalid_enum_value,
          options: me
        }), d.INVALID;
      }
      return (0, d.OK)(D.data);
    }
    get enum() {
      return this._def.values;
    }
  }
  t.ZodNativeEnum = le, f = /* @__PURE__ */ new WeakMap(), le.create = (ve, D) => new le({
    values: ve,
    typeName: He.ZodNativeEnum,
    ...M(D)
  });
  class ie extends S {
    unwrap() {
      return this._def.type;
    }
    _parse(D) {
      const { ctx: j } = this._processInputParams(D);
      if (j.parsedType !== v.ZodParsedType.promise && j.common.async === !1)
        return (0, d.addIssueToContext)(j, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.promise,
          received: j.parsedType
        }), d.INVALID;
      const Y = j.parsedType === v.ZodParsedType.promise ? j.data : Promise.resolve(j.data);
      return (0, d.OK)(Y.then((me) => this._def.type.parseAsync(me, {
        path: j.path,
        errorMap: j.common.contextualErrorMap
      })));
    }
  }
  t.ZodPromise = ie, ie.create = (ve, D) => new ie({
    type: ve,
    typeName: He.ZodPromise,
    ...M(D)
  });
  class fe extends S {
    innerType() {
      return this._def.schema;
    }
    sourceType() {
      return this._def.schema._def.typeName === He.ZodEffects ? this._def.schema.sourceType() : this._def.schema;
    }
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D), me = this._def.effect || null, pe = {
        addIssue: (Pe) => {
          (0, d.addIssueToContext)(Y, Pe), Pe.fatal ? j.abort() : j.dirty();
        },
        get path() {
          return Y.path;
        }
      };
      if (pe.addIssue = pe.addIssue.bind(pe), me.type === "preprocess") {
        const Pe = me.transform(Y.data, pe);
        if (Y.common.async)
          return Promise.resolve(Pe).then(async (Re) => {
            if (j.value === "aborted")
              return d.INVALID;
            const nt = await this._def.schema._parseAsync({
              data: Re,
              path: Y.path,
              parent: Y
            });
            return nt.status === "aborted" ? d.INVALID : nt.status === "dirty" || j.value === "dirty" ? (0, d.DIRTY)(nt.value) : nt;
          });
        {
          if (j.value === "aborted")
            return d.INVALID;
          const Re = this._def.schema._parseSync({
            data: Pe,
            path: Y.path,
            parent: Y
          });
          return Re.status === "aborted" ? d.INVALID : Re.status === "dirty" || j.value === "dirty" ? (0, d.DIRTY)(Re.value) : Re;
        }
      }
      if (me.type === "refinement") {
        const Pe = (Re) => {
          const nt = me.refinement(Re, pe);
          if (Y.common.async)
            return Promise.resolve(nt);
          if (nt instanceof Promise)
            throw new Error("Async refinement encountered during synchronous parse operation. Use .parseAsync instead.");
          return Re;
        };
        if (Y.common.async === !1) {
          const Re = this._def.schema._parseSync({
            data: Y.data,
            path: Y.path,
            parent: Y
          });
          return Re.status === "aborted" ? d.INVALID : (Re.status === "dirty" && j.dirty(), Pe(Re.value), { status: j.value, value: Re.value });
        } else
          return this._def.schema._parseAsync({ data: Y.data, path: Y.path, parent: Y }).then((Re) => Re.status === "aborted" ? d.INVALID : (Re.status === "dirty" && j.dirty(), Pe(Re.value).then(() => ({ status: j.value, value: Re.value }))));
      }
      if (me.type === "transform")
        if (Y.common.async === !1) {
          const Pe = this._def.schema._parseSync({
            data: Y.data,
            path: Y.path,
            parent: Y
          });
          if (!(0, d.isValid)(Pe))
            return Pe;
          const Re = me.transform(Pe.value, pe);
          if (Re instanceof Promise)
            throw new Error("Asynchronous transform encountered during synchronous parse operation. Use .parseAsync instead.");
          return { status: j.value, value: Re };
        } else
          return this._def.schema._parseAsync({ data: Y.data, path: Y.path, parent: Y }).then((Pe) => (0, d.isValid)(Pe) ? Promise.resolve(me.transform(Pe.value, pe)).then((Re) => ({ status: j.value, value: Re })) : Pe);
      v.util.assertNever(me);
    }
  }
  t.ZodEffects = fe, t.ZodTransformer = fe, fe.create = (ve, D, j) => new fe({
    schema: ve,
    typeName: He.ZodEffects,
    effect: D,
    ...M(j)
  }), fe.createWithPreprocess = (ve, D, j) => new fe({
    schema: D,
    effect: { type: "preprocess", transform: ve },
    typeName: He.ZodEffects,
    ...M(j)
  });
  class Te extends S {
    _parse(D) {
      return this._getType(D) === v.ZodParsedType.undefined ? (0, d.OK)(void 0) : this._def.innerType._parse(D);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  t.ZodOptional = Te, Te.create = (ve, D) => new Te({
    innerType: ve,
    typeName: He.ZodOptional,
    ...M(D)
  });
  class N extends S {
    _parse(D) {
      return this._getType(D) === v.ZodParsedType.null ? (0, d.OK)(null) : this._def.innerType._parse(D);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  t.ZodNullable = N, N.create = (ve, D) => new N({
    innerType: ve,
    typeName: He.ZodNullable,
    ...M(D)
  });
  class R extends S {
    _parse(D) {
      const { ctx: j } = this._processInputParams(D);
      let Y = j.data;
      return j.parsedType === v.ZodParsedType.undefined && (Y = this._def.defaultValue()), this._def.innerType._parse({
        data: Y,
        path: j.path,
        parent: j
      });
    }
    removeDefault() {
      return this._def.innerType;
    }
  }
  t.ZodDefault = R, R.create = (ve, D) => new R({
    innerType: ve,
    typeName: He.ZodDefault,
    defaultValue: typeof D.default == "function" ? D.default : () => D.default,
    ...M(D)
  });
  class L extends S {
    _parse(D) {
      const { ctx: j } = this._processInputParams(D), Y = {
        ...j,
        common: {
          ...j.common,
          issues: []
        }
      }, me = this._def.innerType._parse({
        data: Y.data,
        path: Y.path,
        parent: {
          ...Y
        }
      });
      return (0, d.isAsync)(me) ? me.then((pe) => ({
        status: "valid",
        value: pe.status === "valid" ? pe.value : this._def.catchValue({
          get error() {
            return new m.ZodError(Y.common.issues);
          },
          input: Y.data
        })
      })) : {
        status: "valid",
        value: me.status === "valid" ? me.value : this._def.catchValue({
          get error() {
            return new m.ZodError(Y.common.issues);
          },
          input: Y.data
        })
      };
    }
    removeCatch() {
      return this._def.innerType;
    }
  }
  t.ZodCatch = L, L.create = (ve, D) => new L({
    innerType: ve,
    typeName: He.ZodCatch,
    catchValue: typeof D.catch == "function" ? D.catch : () => D.catch,
    ...M(D)
  });
  class V extends S {
    _parse(D) {
      if (this._getType(D) !== v.ZodParsedType.nan) {
        const Y = this._getOrReturnCtx(D);
        return (0, d.addIssueToContext)(Y, {
          code: m.ZodIssueCode.invalid_type,
          expected: v.ZodParsedType.nan,
          received: Y.parsedType
        }), d.INVALID;
      }
      return { status: "valid", value: D.data };
    }
  }
  t.ZodNaN = V, V.create = (ve) => new V({
    typeName: He.ZodNaN,
    ...M(ve)
  }), t.BRAND = Symbol("zod_brand");
  class ne extends S {
    _parse(D) {
      const { ctx: j } = this._processInputParams(D), Y = j.data;
      return this._def.type._parse({
        data: Y,
        path: j.path,
        parent: j
      });
    }
    unwrap() {
      return this._def.type;
    }
  }
  t.ZodBranded = ne;
  class Se extends S {
    _parse(D) {
      const { status: j, ctx: Y } = this._processInputParams(D);
      if (Y.common.async)
        return (async () => {
          const pe = await this._def.in._parseAsync({
            data: Y.data,
            path: Y.path,
            parent: Y
          });
          return pe.status === "aborted" ? d.INVALID : pe.status === "dirty" ? (j.dirty(), (0, d.DIRTY)(pe.value)) : this._def.out._parseAsync({
            data: pe.value,
            path: Y.path,
            parent: Y
          });
        })();
      {
        const me = this._def.in._parseSync({
          data: Y.data,
          path: Y.path,
          parent: Y
        });
        return me.status === "aborted" ? d.INVALID : me.status === "dirty" ? (j.dirty(), {
          status: "dirty",
          value: me.value
        }) : this._def.out._parseSync({
          data: me.value,
          path: Y.path,
          parent: Y
        });
      }
    }
    static create(D, j) {
      return new Se({
        in: D,
        out: j,
        typeName: He.ZodPipeline
      });
    }
  }
  t.ZodPipeline = Se;
  class ue extends S {
    _parse(D) {
      const j = this._def.innerType._parse(D), Y = (me) => ((0, d.isValid)(me) && (me.value = Object.freeze(me.value)), me);
      return (0, d.isAsync)(j) ? j.then((me) => Y(me)) : Y(j);
    }
    unwrap() {
      return this._def.innerType;
    }
  }
  t.ZodReadonly = ue, ue.create = (ve, D) => new ue({
    innerType: ve,
    typeName: He.ZodReadonly,
    ...M(D)
  });
  function xe(ve, D = {}, j) {
    return ve ? J.create().superRefine((Y, me) => {
      var pe, Pe;
      if (!ve(Y)) {
        const Re = typeof D == "function" ? D(Y) : typeof D == "string" ? { message: D } : D, nt = (Pe = (pe = Re.fatal) !== null && pe !== void 0 ? pe : j) !== null && Pe !== void 0 ? Pe : !0, ot = typeof Re == "string" ? { message: Re } : Re;
        me.addIssue({ code: "custom", ...ot, fatal: nt });
      }
    }) : J.create();
  }
  t.custom = xe, t.late = {
    object: se.lazycreate
  };
  var He;
  (function(ve) {
    ve.ZodString = "ZodString", ve.ZodNumber = "ZodNumber", ve.ZodNaN = "ZodNaN", ve.ZodBigInt = "ZodBigInt", ve.ZodBoolean = "ZodBoolean", ve.ZodDate = "ZodDate", ve.ZodSymbol = "ZodSymbol", ve.ZodUndefined = "ZodUndefined", ve.ZodNull = "ZodNull", ve.ZodAny = "ZodAny", ve.ZodUnknown = "ZodUnknown", ve.ZodNever = "ZodNever", ve.ZodVoid = "ZodVoid", ve.ZodArray = "ZodArray", ve.ZodObject = "ZodObject", ve.ZodUnion = "ZodUnion", ve.ZodDiscriminatedUnion = "ZodDiscriminatedUnion", ve.ZodIntersection = "ZodIntersection", ve.ZodTuple = "ZodTuple", ve.ZodRecord = "ZodRecord", ve.ZodMap = "ZodMap", ve.ZodSet = "ZodSet", ve.ZodFunction = "ZodFunction", ve.ZodLazy = "ZodLazy", ve.ZodLiteral = "ZodLiteral", ve.ZodEnum = "ZodEnum", ve.ZodEffects = "ZodEffects", ve.ZodNativeEnum = "ZodNativeEnum", ve.ZodOptional = "ZodOptional", ve.ZodNullable = "ZodNullable", ve.ZodDefault = "ZodDefault", ve.ZodCatch = "ZodCatch", ve.ZodPromise = "ZodPromise", ve.ZodBranded = "ZodBranded", ve.ZodPipeline = "ZodPipeline", ve.ZodReadonly = "ZodReadonly";
  })(He = t.ZodFirstPartyTypeKind || (t.ZodFirstPartyTypeKind = {}));
  const be = (ve, D = {
    message: `Input not instance of ${ve.name}`
  }) => xe((j) => j instanceof ve, D);
  t.instanceof = be;
  const Ie = g.create;
  t.string = Ie;
  const rt = _.create;
  t.number = rt;
  const Ne = V.create;
  t.nan = Ne;
  const ze = p.create;
  t.bigint = ze;
  const kt = s.create;
  t.boolean = kt;
  const Le = y.create;
  t.date = Le;
  const $e = T.create;
  t.symbol = $e;
  const Ot = P.create;
  t.undefined = Ot;
  const je = z.create;
  t.null = je;
  const Ve = J.create;
  t.any = Ve;
  const Nt = Z.create;
  t.unknown = Nt;
  const qe = F.create;
  t.never = qe;
  const Ke = ee.create;
  t.void = Ke;
  const K = re.create;
  t.array = K;
  const W = se.create;
  t.object = W;
  const G = se.strictCreate;
  t.strictObject = G;
  const U = Q.create;
  t.union = U;
  const X = Ye.create;
  t.discriminatedUnion = X;
  const H = Be.create;
  t.intersection = H;
  const ye = st.create;
  t.tuple = ye;
  const ce = De.create;
  t.record = ce;
  const we = _e.create;
  t.map = we;
  const Qe = St.create;
  t.set = Qe;
  const Ze = Oe.create;
  t.function = Ze;
  const lt = Fe.create;
  t.lazy = lt;
  const Xe = Et.create;
  t.literal = Xe;
  const ht = oe.create;
  t.enum = ht;
  const ct = le.create;
  t.nativeEnum = ct;
  const pt = ie.create;
  t.promise = pt;
  const yt = fe.create;
  t.effect = yt, t.transformer = yt;
  const bt = Te.create;
  t.optional = bt;
  const wt = N.create;
  t.nullable = wt;
  const mt = fe.createWithPreprocess;
  t.preprocess = mt;
  const ft = Se.create;
  t.pipeline = ft;
  const gt = () => Ie().optional();
  t.ostring = gt;
  const at = () => rt().optional();
  t.onumber = at;
  const dt = () => kt().optional();
  t.oboolean = dt, t.coerce = {
    string: (ve) => g.create({ ...ve, coerce: !0 }),
    number: (ve) => _.create({ ...ve, coerce: !0 }),
    boolean: (ve) => s.create({
      ...ve,
      coerce: !0
    }),
    bigint: (ve) => p.create({ ...ve, coerce: !0 }),
    date: (ve) => y.create({ ...ve, coerce: !0 })
  }, t.NEVER = d.INVALID;
})(iM);
(function(t) {
  var e = ut && ut.__createBinding || (Object.create ? function(i, f, a, l) {
    l === void 0 && (l = a), Object.defineProperty(i, l, { enumerable: !0, get: function() {
      return f[a];
    } });
  } : function(i, f, a, l) {
    l === void 0 && (l = a), i[l] = f[a];
  }), r = ut && ut.__exportStar || function(i, f) {
    for (var a in i)
      a !== "default" && !Object.prototype.hasOwnProperty.call(f, a) && e(f, i, a);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), r(Xn, t), r(Eg, t), r(nM, t), r(ou, t), r(iM, t), r(ei, t);
})(Mv);
(function(t) {
  var e = ut && ut.__createBinding || (Object.create ? function(l, d, v, m) {
    m === void 0 && (m = v), Object.defineProperty(l, m, { enumerable: !0, get: function() {
      return d[v];
    } });
  } : function(l, d, v, m) {
    m === void 0 && (m = v), l[m] = d[v];
  }), r = ut && ut.__setModuleDefault || (Object.create ? function(l, d) {
    Object.defineProperty(l, "default", { enumerable: !0, value: d });
  } : function(l, d) {
    l.default = d;
  }), i = ut && ut.__importStar || function(l) {
    if (l && l.__esModule)
      return l;
    var d = {};
    if (l != null)
      for (var v in l)
        v !== "default" && Object.prototype.hasOwnProperty.call(l, v) && e(d, l, v);
    return r(d, l), d;
  }, f = ut && ut.__exportStar || function(l, d) {
    for (var v in l)
      v !== "default" && !Object.prototype.hasOwnProperty.call(d, v) && e(d, l, v);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.z = void 0;
  const a = i(Mv);
  t.z = a, f(Mv, t), t.default = a;
})(Sg);
const OL = "@ton/ton", NL = "13.11.1", DL = "https://github.com/ton-org/ton.git", UL = "Whales Corp. <developers@whalescorp.com>", LL = "MIT", FL = "dist/index.js", qL = [
  "dist"
], zL = {
  docs: "rm -fr docs && typedoc src/index.ts",
  build: "rm -fr dist && tsc --declaration",
  test: "jest --verbose --runInBand",
  release: "yarn build && yarn release-it --npm.yarn1"
}, jL = {
  "@release-it/keep-a-changelog": "^5.0.0",
  "@ton/core": "^0.56.0",
  "@ton/crypto": "3.2.0",
  "@ton/emulator": "^2.1.1",
  "@types/jest": "^27.0.1",
  "@types/node": "^16.7.10",
  buffer: "^6.0.3",
  expect: "^27.1.0",
  jest: "^27.1.0",
  "jest-mock": "^27.1.0",
  karma: "^6.3.4",
  "karma-chrome-launcher": "^3.1.0",
  "karma-jasmine": "^4.0.1",
  "karma-typescript": "^5.5.2",
  "karma-webpack": "^5.0.0",
  prando: "^6.0.1",
  "release-it": "^17.1.1",
  "ts-jest": "^27.0.5",
  "ts-loader": "^9.2.5",
  "ts-node": "^10.7.0",
  typedoc: "^0.23.24",
  typescript: "^4.4.2",
  webpack: "^5.51.2"
}, $L = {
  axios: "^1.6.7",
  dataloader: "^2.0.0",
  "symbol.inspect": "1.0.1",
  teslabot: "^1.3.0",
  zod: "^3.21.4"
}, VL = {
  "@ton/core": ">=0.56.0",
  "@ton/crypto": ">=3.2.0"
}, HL = {
  access: "public",
  registry: "https://registry.npmjs.org/"
}, WL = "yarn@3.4.1", KL = {
  name: OL,
  version: NL,
  repository: DL,
  author: UL,
  license: LL,
  main: FL,
  files: qL,
  scripts: zL,
  devDependencies: jL,
  dependencies: $L,
  peerDependencies: VL,
  publishConfig: HL,
  "release-it": {
    github: {
      release: !0
    },
    plugins: {
      "@release-it/keep-a-changelog": {
        filename: "CHANGELOG.md"
      }
    }
  },
  packageManager: WL
};
var sM = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
};
Object.defineProperty(au, "__esModule", { value: !0 });
au.HttpApi = void 0;
const ZL = Wc, i5 = sM(JD), GL = sM(X7), xt = Sg, QL = KL.version, no = xt.z.object({
  "@type": xt.z.literal("ton.blockIdExt"),
  workchain: xt.z.number(),
  shard: xt.z.string(),
  seqno: xt.z.number(),
  root_hash: xt.z.string(),
  file_hash: xt.z.string()
}), YL = xt.z.object({
  balance: xt.z.union([xt.z.number(), xt.z.string()]),
  state: xt.z.union([xt.z.literal("active"), xt.z.literal("uninitialized"), xt.z.literal("frozen")]),
  data: xt.z.string(),
  code: xt.z.string(),
  last_transaction_id: xt.z.object({
    "@type": xt.z.literal("internal.transactionId"),
    lt: xt.z.string(),
    hash: xt.z.string()
  }),
  block_id: no,
  sync_utime: xt.z.number()
}), JL = xt.z.object({
  "@type": xt.z.literal("ok")
}), XL = xt.z.object({
  "@type": xt.z.literal("query.fees"),
  source_fees: xt.z.object({
    "@type": xt.z.literal("fees"),
    in_fwd_fee: xt.z.number(),
    storage_fee: xt.z.number(),
    gas_fee: xt.z.number(),
    fwd_fee: xt.z.number()
  })
}), eF = xt.z.object({
  gas_used: xt.z.number(),
  exit_code: xt.z.number(),
  stack: xt.z.array(xt.z.unknown())
}), tF = xt.z.union([
  xt.z.object({
    "@type": xt.z.literal("msg.dataRaw"),
    body: xt.z.string()
  }),
  xt.z.object({
    "@type": xt.z.literal("msg.dataText"),
    text: xt.z.string()
  }),
  xt.z.object({
    "@type": xt.z.literal("msg.dataDecryptedText"),
    text: xt.z.string()
  }),
  xt.z.object({
    "@type": xt.z.literal("msg.dataEncryptedText"),
    text: xt.z.string()
  })
]), a5 = xt.z.object({
  source: xt.z.string(),
  destination: xt.z.string(),
  value: xt.z.string(),
  fwd_fee: xt.z.string(),
  ihr_fee: xt.z.string(),
  created_lt: xt.z.string(),
  body_hash: xt.z.string(),
  msg_data: tF,
  message: xt.z.string()
}), Sv = xt.z.object({
  data: xt.z.string(),
  utime: xt.z.number(),
  transaction_id: xt.z.object({
    lt: xt.z.string(),
    hash: xt.z.string()
  }),
  fee: xt.z.string(),
  storage_fee: xt.z.string(),
  other_fee: xt.z.string(),
  in_msg: xt.z.union([xt.z.undefined(), a5]),
  out_msgs: xt.z.array(a5)
}), s5 = xt.z.array(Sv), rF = xt.z.object({
  state_root_hash: xt.z.string(),
  last: no,
  init: no
}), nF = xt.z.object({
  shards: xt.z.array(no)
}), iF = xt.z.object({
  "@type": xt.z.literal("blocks.shortTxId"),
  mode: xt.z.number(),
  account: xt.z.string(),
  lt: xt.z.string(),
  hash: xt.z.string()
}), o5 = xt.z.object({
  id: no,
  req_count: xt.z.number(),
  incomplete: xt.z.boolean(),
  transactions: xt.z.array(iF)
});
class f5 {
  constructor(e, r, i, f) {
    this.namespace = e, this.cache = r, this.codec = i, this.keyEncoder = f;
  }
  async get(e) {
    let r = await this.cache.get(this.namespace, this.keyEncoder(e));
    if (r) {
      let i = this.codec.safeParse(JSON.parse(r));
      if (i.success)
        return i.data;
    }
    return null;
  }
  async set(e, r) {
    r !== null ? await this.cache.set(this.namespace, this.keyEncoder(e), JSON.stringify(r)) : await this.cache.set(this.namespace, this.keyEncoder(e), null);
  }
}
class aF {
  constructor(e, r) {
    this.endpoint = e, this.cache = new ZL.InMemoryCache(), this.parameters = {
      timeout: (r == null ? void 0 : r.timeout) || 3e4,
      apiKey: r == null ? void 0 : r.apiKey,
      adapter: r == null ? void 0 : r.adapter
    }, this.shardCache = new f5("ton-shard", this.cache, xt.z.array(no), (i) => i + ""), this.shardLoader = new i5.default(async (i) => await Promise.all(i.map(async (f) => {
      const a = await this.shardCache.get(f);
      if (a)
        return a;
      let l = (await this.doCall("shards", { seqno: f }, nF)).shards;
      return await this.shardCache.set(f, l), l;
    }))), this.shardTransactionsCache = new f5("ton-shard-tx", this.cache, o5, (i) => i.workchain + ":" + i.shard + ":" + i.seqno), this.shardTransactionsLoader = new i5.default(async (i) => await Promise.all(i.map(async (f) => {
      const a = await this.shardTransactionsCache.get(f);
      if (a)
        return a;
      let l = await this.doCall("getBlockTransactions", { workchain: f.workchain, seqno: f.seqno, shard: f.shard }, o5);
      return await this.shardTransactionsCache.set(f, l), l;
    })), { cacheKeyFn: (i) => i.workchain + ":" + i.shard + ":" + i.seqno });
  }
  getAddressInformation(e) {
    return this.doCall("getAddressInformation", { address: e.toString() }, YL);
  }
  async getTransactions(e, r) {
    const i = r.inclusive;
    delete r.inclusive;
    let f;
    r.hash && (f = Je.from(r.hash, "base64").toString("hex"));
    let a = r.limit;
    r.hash && r.lt && i !== !0 && a++;
    let l = await this.doCall("getTransactions", { address: e.toString(), ...r, limit: a, hash: f }, s5);
    return l.length > a && (l = l.slice(0, a)), r.hash && r.lt && i !== !0 && l.shift(), l;
  }
  async getMasterchainInfo() {
    return await this.doCall("getMasterchainInfo", {}, rF);
  }
  async getShards(e) {
    return await this.shardLoader.load(e);
  }
  async getBlockTransactions(e, r, i) {
    return await this.shardTransactionsLoader.load({ workchain: e, seqno: r, shard: i });
  }
  async getTransaction(e, r, i) {
    let f = Je.from(i, "base64").toString("hex"), l = (await this.doCall("getTransactions", { address: e.toString(), lt: r, hash: f, limit: 1 }, s5)).find((d) => d.transaction_id.lt === r && d.transaction_id.hash === i);
    return l || null;
  }
  async callGetMethod(e, r, i) {
    return await this.doCall("runGetMethod", { address: e.toString(), method: r, stack: sF(i) }, eF);
  }
  async sendBoc(e) {
    await this.doCall("sendBoc", { boc: e.toString("base64") }, JL);
  }
  async estimateFee(e, r) {
    return await this.doCall("estimateFee", {
      address: e.toString(),
      body: r.body.toBoc().toString("base64"),
      init_data: r.initData ? r.initData.toBoc().toString("base64") : "",
      init_code: r.initCode ? r.initCode.toBoc().toString("base64") : "",
      ignore_chksig: r.ignoreSignature
    }, XL);
  }
  async tryLocateResultTx(e, r, i) {
    return await this.doCall("tryLocateResultTx", { source: e.toString(), destination: r.toString(), created_lt: i }, Sv);
  }
  async tryLocateSourceTx(e, r, i) {
    return await this.doCall("tryLocateSourceTx", { source: e.toString(), destination: r.toString(), created_lt: i }, Sv);
  }
  async doCall(e, r, i) {
    let f = {
      "Content-Type": "application/json",
      "X-Ton-Client-Version": QL
    };
    this.parameters.apiKey && (f["X-API-Key"] = this.parameters.apiKey);
    let a = await GL.default.post(this.endpoint, JSON.stringify({
      id: "1",
      jsonrpc: "2.0",
      method: e,
      params: r
    }), {
      headers: f,
      timeout: this.parameters.timeout,
      adapter: this.parameters.adapter
    });
    if (a.status !== 200 || !a.data.ok)
      throw Error("Received error: " + JSON.stringify(a.data));
    let l = i.safeParse(a.data.result);
    if (l.success)
      return l.data;
    throw Error("Malformed response: " + l.error.format()._errors.join(", "));
  }
}
au.HttpApi = aF;
function sF(t) {
  let e = [];
  for (let r of t)
    if (r.type === "int")
      e.push(["num", r.value.toString()]);
    else if (r.type === "cell")
      e.push(["tvm.Cell", r.cell.toBoc().toString("base64")]);
    else if (r.type === "slice")
      e.push(["tvm.Slice", r.cell.toBoc().toString("base64")]);
    else if (r.type === "builder")
      e.push(["tvm.Builder", r.cell.toBoc().toString("base64")]);
    else
      throw Error("Unsupported stack item type: " + r.type);
  return e;
}
var ed = {};
Object.defineProperty(ed, "__esModule", { value: !0 });
ed.TonClient = void 0;
const oF = au, or = At;
class fF {
  constructor(e) {
    this.parameters = {
      endpoint: e.endpoint
    }, this.api = new oF.HttpApi(this.parameters.endpoint, {
      timeout: e.timeout,
      apiKey: e.apiKey,
      adapter: e.httpAdapter
    });
  }
  /**
   * Get Address Balance
   * @param address address for balance check
   * @returns balance
   */
  async getBalance(e) {
    return (await this.getContractState(e)).balance;
  }
  /**
   * Invoke get method
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   */
  async runMethod(e, r, i = []) {
    let f = await this.api.callGetMethod(e, r, i);
    if (f.exit_code !== 0)
      throw Error("Unable to execute get method. Got exit_code: " + f.exit_code);
    return { gas_used: f.gas_used, stack: u5(f.stack) };
  }
  /**
   * Invoke get method
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   * @deprecated use runMethod instead
   */
  async callGetMethod(e, r, i = []) {
    return this.runMethod(e, r, i);
  }
  /**
   * Invoke get method that returns error code instead of throwing error
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
  */
  async runMethodWithError(e, r, i = []) {
    let f = await this.api.callGetMethod(e, r, i);
    return { gas_used: f.gas_used, stack: u5(f.stack), exit_code: f.exit_code };
  }
  /**
   * Invoke get method that returns error code instead of throwing error
   * @param address contract address
   * @param name name of method
   * @param params optional parameters
   * @returns stack and gas_used field
   * @deprecated use runMethodWithError instead
   */
  async callGetMethodWithError(e, r, i = []) {
    return this.runMethodWithError(e, r, i);
  }
  /**
   * Get transactions
   * @param address address
   */
  async getTransactions(e, r) {
    let i = await this.api.getTransactions(e, r), f = [];
    for (let a of i)
      f.push((0, or.loadTransaction)(or.Cell.fromBoc(Je.from(a.data, "base64"))[0].beginParse()));
    return f;
  }
  /**
   * Get transaction by it's id
   * @param address address
   * @param lt logical time
   * @param hash transaction hash
   * @returns transaction or null if not exist
   */
  async getTransaction(e, r, i) {
    let f = await this.api.getTransaction(e, r, i);
    return f ? (0, or.loadTransaction)(or.Cell.fromBoc(Je.from(f.data, "base64"))[0].beginParse()) : null;
  }
  /**
   * Locate outcoming transaction of destination address by incoming message
   * @param source message source address
   * @param destination message destination address
   * @param created_lt message's created lt
   * @returns transaction
   */
  async tryLocateResultTx(e, r, i) {
    let f = await this.api.tryLocateResultTx(e, r, i);
    return (0, or.loadTransaction)(or.Cell.fromBase64(f.data).beginParse());
  }
  /**
   * Locate incoming transaction of source address by outcoming message
   * @param source message source address
   * @param destination message destination address
   * @param created_lt message's created lt
   * @returns transaction
   */
  async tryLocateSourceTx(e, r, i) {
    let f = await this.api.tryLocateSourceTx(e, r, i);
    return (0, or.loadTransaction)(or.Cell.fromBase64(f.data).beginParse());
  }
  /**
   * Fetch latest masterchain info
   * @returns masterchain info
   */
  async getMasterchainInfo() {
    let e = await this.api.getMasterchainInfo();
    return {
      workchain: e.init.workchain,
      shard: e.last.shard,
      initSeqno: e.init.seqno,
      latestSeqno: e.last.seqno
    };
  }
  /**
   * Fetch latest workchain shards
   * @param seqno masterchain seqno
   */
  async getWorkchainShards(e) {
    return (await this.api.getShards(e)).map((i) => ({
      workchain: i.workchain,
      shard: i.shard,
      seqno: i.seqno
    }));
  }
  /**
   * Fetch transactions inf shards
   * @param workchain
   * @param seqno
   * @param shard
   */
  async getShardTransactions(e, r, i) {
    let f = await this.api.getBlockTransactions(e, r, i);
    if (f.incomplete)
      throw Error("Unsupported");
    return f.transactions.map((a) => ({
      account: or.Address.parseRaw(a.account),
      lt: a.lt,
      hash: a.hash
    }));
  }
  /**
   * Send message to a network
   * @param src source message
   */
  async sendMessage(e) {
    const r = (0, or.beginCell)().store((0, or.storeMessage)(e)).endCell().toBoc();
    await this.api.sendBoc(r);
  }
  /**
   * Send file to a network
   * @param src source file
   */
  async sendFile(e) {
    await this.api.sendBoc(e);
  }
  /**
   * Estimate fees for external message
   * @param address target address
   * @returns
   */
  async estimateExternalMessageFee(e, r) {
    return await this.api.estimateFee(e, { body: r.body, initCode: r.initCode, initData: r.initData, ignoreSignature: r.ignoreSignature });
  }
  /**
   * Send external message to contract
   * @param contract contract to send message
   * @param src message body
   */
  async sendExternalMessage(e, r) {
    if (await this.isContractDeployed(e.address) || !e.init) {
      const i = (0, or.external)({
        to: e.address,
        body: r
      });
      await this.sendMessage(i);
    } else {
      const i = (0, or.external)({
        to: e.address,
        init: e.init,
        body: r
      });
      await this.sendMessage(i);
    }
  }
  /**
   * Check if contract is deployed
   * @param address addres to check
   * @returns true if contract is in active state
   */
  async isContractDeployed(e) {
    return (await this.getContractState(e)).state === "active";
  }
  /**
   * Resolves contract state
   * @param address contract address
   */
  async getContractState(e) {
    let r = await this.api.getAddressInformation(e), i = BigInt(r.balance), f = r.state;
    return {
      balance: i,
      state: f,
      code: r.code !== "" ? Je.from(r.code, "base64") : null,
      data: r.data !== "" ? Je.from(r.data, "base64") : null,
      lastTransaction: r.last_transaction_id.lt !== "0" ? {
        lt: r.last_transaction_id.lt,
        hash: r.last_transaction_id.hash
      } : null,
      blockId: {
        workchain: r.block_id.workchain,
        shard: r.block_id.shard,
        seqno: r.block_id.seqno
      },
      timestampt: r.sync_utime
    };
  }
  /**
   * Open contract
   * @param src source contract
   * @returns contract
   */
  open(e) {
    return (0, or.openContract)(e, (r) => Ev(this, r.address, r.init));
  }
  /**
   * Create a provider
   * @param address address
   * @param init optional init
   * @returns provider
   */
  provider(e, r) {
    return Ev(this, e, r ?? null);
  }
}
ed.TonClient = fF;
function oM(t) {
  switch (t["@type"]) {
    case "tvm.stackEntryNumber":
      return { type: "int", value: BigInt(t.number.number) };
    case "tvm.stackEntryCell":
      return { type: "cell", cell: or.Cell.fromBase64(t.cell) };
    case "tvm.stackEntryTuple":
      return { type: "tuple", items: t.tuple.elements.map(oM) };
    default:
      throw Error("Unsupported item type: " + t["@type"]);
  }
}
function uF(t) {
  if (t[0] === "num") {
    let e = t[1];
    return e.startsWith("-") ? { type: "int", value: -BigInt(e.slice(1)) } : { type: "int", value: BigInt(e) };
  } else {
    if (t[0] === "null")
      return { type: "null" };
    if (t[0] === "cell")
      return { type: "cell", cell: or.Cell.fromBoc(Je.from(t[1].bytes, "base64"))[0] };
    if (t[0] === "slice")
      return { type: "slice", cell: or.Cell.fromBoc(Je.from(t[1].bytes, "base64"))[0] };
    if (t[0] === "builder")
      return { type: "builder", cell: or.Cell.fromBoc(Je.from(t[1].bytes, "base64"))[0] };
    if (t[0] === "tuple" || t[0] === "list")
      return t[1].elements.length === 0 ? { type: "null" } : {
        type: t[0],
        items: t[1].elements.map(oM)
      };
    throw Error("Unsupported stack item type: " + t[0]);
  }
}
function u5(t) {
  let e = [];
  for (let r of t)
    e.push(uF(r));
  return new or.TupleReader(e);
}
function Ev(t, e, r) {
  return {
    async getState() {
      let i = await t.getContractState(e), f = i.balance, a = i.lastTransaction ? { lt: BigInt(i.lastTransaction.lt), hash: Je.from(i.lastTransaction.hash, "base64") } : null, l;
      if (i.state === "active")
        l = {
          type: "active",
          code: i.code ? i.code : null,
          data: i.data ? i.data : null
        };
      else if (i.state === "uninitialized")
        l = {
          type: "uninit"
        };
      else if (i.state === "frozen")
        l = {
          type: "frozen",
          stateHash: Je.alloc(0)
        };
      else
        throw Error("Unsupported state");
      return {
        balance: f,
        last: a,
        state: l
      };
    },
    async get(i, f) {
      return { stack: (await t.callGetMethod(e, i, f)).stack };
    },
    async external(i) {
      let f = null;
      r && !await t.isContractDeployed(e) && (f = r);
      const a = (0, or.external)({
        to: e,
        init: f,
        body: i
      });
      let l = (0, or.beginCell)().store((0, or.storeMessage)(a)).endCell().toBoc();
      await t.sendFile(l);
    },
    async internal(i, f) {
      let a = null;
      r && !await t.isContractDeployed(e) && (a = r);
      let l = !0;
      f.bounce !== null && f.bounce !== void 0 && (l = f.bounce);
      let d;
      typeof f.value == "string" ? d = (0, or.toNano)(f.value) : d = f.value;
      let v = null;
      typeof f.body == "string" ? v = (0, or.comment)(f.body) : f.body && (v = f.body), await i.send({
        to: e,
        value: d,
        bounce: l,
        sendMode: f.sendMode,
        init: a,
        body: v
      });
    },
    open(i) {
      return (0, or.openContract)(i, (f) => Ev(t, f.address, f.init ?? null));
    },
    getTransactions(i, f, a, l) {
      return t.getTransactions(i, { limit: l ?? 100, lt: f.toString(), hash: a.toString("base64"), inclusive: !0 });
    }
  };
}
var td = {}, rd = {};
Object.defineProperty(rd, "__esModule", { value: !0 });
rd.toUrlSafe = void 0;
function lF(t) {
  for (; t.indexOf("/") >= 0; )
    t = t.replace("/", "_");
  for (; t.indexOf("+") >= 0; )
    t = t.replace("+", "-");
  for (; t.indexOf("=") >= 0; )
    t = t.replace("=", "");
  return t;
}
rd.toUrlSafe = lF;
var o1 = ut && ut.__classPrivateFieldSet || function(t, e, r, i, f) {
  if (i === "m")
    throw new TypeError("Private method is not writable");
  if (i === "a" && !f)
    throw new TypeError("Private accessor was defined without a setter");
  if (typeof e == "function" ? t !== e || !f : !e.has(t))
    throw new TypeError("Cannot write private member to an object whose class did not declare it");
  return i === "a" ? f.call(t, r) : f ? f.value = r : e.set(t, r), r;
}, Qt = ut && ut.__classPrivateFieldGet || function(t, e, r, i) {
  if (r === "a" && !i)
    throw new TypeError("Private accessor was defined without a getter");
  if (typeof e == "function" ? t !== e || !i : !e.has(t))
    throw new TypeError("Cannot read private member from an object whose class did not declare it");
  return r === "m" ? i : r === "a" ? i.call(t) : i ? i.value : e.get(t);
}, cF = ut && ut.__importDefault || function(t) {
  return t && t.__esModule ? t : { default: t };
}, Yr, Jr, Xr;
Object.defineProperty(td, "__esModule", { value: !0 });
td.TonClient4 = void 0;
const Cn = cF(X7), Hr = At, f1 = rd, Me = Sg;
class dF {
  constructor(e) {
    Yr.set(this, void 0), Jr.set(this, void 0), Xr.set(this, void 0), o1(this, Yr, e.endpoint, "f"), o1(this, Jr, e.timeout || 5e3, "f"), o1(this, Xr, e.httpAdapter, "f");
  }
  /**
   * Get Last Block
   * @returns last block info
   */
  async getLastBlock() {
    let e = await Cn.default.get(Qt(this, Yr, "f") + "/block/latest", { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), r = hF.safeParse(e.data);
    if (!r.success)
      throw Error("Mailformed response: " + r.error.format()._errors.join(", "));
    return r.data;
  }
  /**
   * Get block info
   * @param seqno block sequence number
   * @returns block info
   */
  async getBlock(e) {
    let r = await Cn.default.get(Qt(this, Yr, "f") + "/block/" + e, { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), i = l5.safeParse(r.data);
    if (!i.success)
      throw Error("Mailformed response");
    if (!i.data.exist)
      throw Error("Block is out of scope");
    return i.data.block;
  }
  /**
   * Get block info by unix timestamp
   * @param ts unix timestamp
   * @returns block info
   */
  async getBlockByUtime(e) {
    let r = await Cn.default.get(Qt(this, Yr, "f") + "/block/utime/" + e, { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), i = l5.safeParse(r.data);
    if (!i.success)
      throw Error("Mailformed response");
    if (!i.data.exist)
      throw Error("Block is out of scope");
    return i.data.block;
  }
  /**
   * Get block info by unix timestamp
   * @param seqno block sequence number
   * @param address account address
   * @returns account info
   */
  async getAccount(e, r) {
    let i = await Cn.default.get(Qt(this, Yr, "f") + "/block/" + e + "/" + r.toString({ urlSafe: !0 }), { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), f = pF.safeParse(i.data);
    if (!f.success)
      throw Error("Mailformed response");
    return f.data;
  }
  /**
   * Get account lite info (without code and data)
   * @param seqno block sequence number
   * @param address account address
   * @returns account lite info
   */
  async getAccountLite(e, r) {
    let i = await Cn.default.get(Qt(this, Yr, "f") + "/block/" + e + "/" + r.toString({ urlSafe: !0 }) + "/lite", { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), f = vF.safeParse(i.data);
    if (!f.success)
      throw Error("Mailformed response");
    return f.data;
  }
  /**
   * Check if contract is deployed
   * @param address addres to check
   * @returns true if contract is in active state
   */
  async isContractDeployed(e, r) {
    return (await this.getAccountLite(e, r)).account.state.type === "active";
  }
  /**
   * Check if account was updated since
   * @param seqno block sequence number
   * @param address account address
   * @param lt account last transaction lt
   * @returns account change info
   */
  async isAccountChanged(e, r, i) {
    let f = await Cn.default.get(Qt(this, Yr, "f") + "/block/" + e + "/" + r.toString({ urlSafe: !0 }) + "/changed/" + i.toString(10), { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), a = mF.safeParse(f.data);
    if (!a.success)
      throw Error("Mailformed response");
    return a.data;
  }
  /**
   * Load unparsed account transactions
   * @param address address
   * @param lt last transaction lt
   * @param hash last transaction hash
   * @returns unparsed transactions
   */
  async getAccountTransactions(e, r, i) {
    let f = await Cn.default.get(Qt(this, Yr, "f") + "/account/" + e.toString({ urlSafe: !0 }) + "/tx/" + r.toString(10) + "/" + (0, f1.toUrlSafe)(i.toString("base64")), { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), a = wF.safeParse(f.data);
    if (!a.success)
      throw Error("Mailformed response");
    let l = a.data, d = [], v = Hr.Cell.fromBoc(Je.from(l.boc, "base64"));
    for (let m = 0; m < l.blocks.length; m++)
      d.push({
        block: l.blocks[m],
        tx: (0, Hr.loadTransaction)(v[m].beginParse())
      });
    return d;
  }
  /**
   * Load parsed account transactions
   * @param address address
   * @param lt last transaction lt
   * @param hash last transaction hash
   * @param count number of transactions to load
   * @returns parsed transactions
   */
  async getAccountTransactionsParsed(e, r, i, f = 20) {
    let a = await Cn.default.get(Qt(this, Yr, "f") + "/account/" + e.toString({ urlSafe: !0 }) + "/tx/parsed/" + r.toString(10) + "/" + (0, f1.toUrlSafe)(i.toString("base64")), {
      adapter: Qt(this, Xr, "f"),
      timeout: Qt(this, Jr, "f"),
      params: {
        count: f
      }
    }), l = CF.safeParse(a.data);
    if (!l.success)
      throw Error("Mailformed response");
    return l.data;
  }
  /**
   * Get network config
   * @param seqno block sequence number
   * @param ids optional config ids
   * @returns network config
   */
  async getConfig(e, r) {
    let i = "";
    r && r.length > 0 && (i = "/" + [...r].sort().join(","));
    let f = await Cn.default.get(Qt(this, Yr, "f") + "/block/" + e + "/config" + i, { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), a = yF.safeParse(f.data);
    if (!a.success)
      throw Error("Mailformed response");
    return a.data;
  }
  /**
   * Execute run method
   * @param seqno block sequence number
   * @param address account address
   * @param name method name
   * @param args method arguments
   * @returns method result
   */
  async runMethod(e, r, i, f) {
    let a = f && f.length > 0 ? "/" + (0, f1.toUrlSafe)((0, Hr.serializeTuple)(f).toBoc({ idx: !1, crc32: !1 }).toString("base64")) : "", l = Qt(this, Yr, "f") + "/block/" + e + "/" + r.toString({ urlSafe: !0 }) + "/run/" + encodeURIComponent(i) + a, d = await Cn.default.get(l, { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") }), v = gF.safeParse(d.data);
    if (!v.success)
      throw Error("Mailformed response");
    let m = v.data.resultRaw ? (0, Hr.parseTuple)(Hr.Cell.fromBoc(Je.from(v.data.resultRaw, "base64"))[0]) : [];
    return {
      exitCode: v.data.exitCode,
      result: m,
      resultRaw: v.data.resultRaw,
      block: v.data.block,
      shardBlock: v.data.shardBlock,
      reader: new Hr.TupleReader(m)
    };
  }
  /**
   * Send external message
   * @param message message boc
   * @returns message status
   */
  async sendMessage(e) {
    let r = await Cn.default.post(Qt(this, Yr, "f") + "/send", { boc: e.toString("base64") }, { adapter: Qt(this, Xr, "f"), timeout: Qt(this, Jr, "f") });
    if (!bF.safeParse(r.data).success)
      throw Error("Mailformed response");
    return { status: r.data.status };
  }
  /**
   * Open smart contract
   * @param contract contract
   * @returns opened contract
   */
  open(e) {
    return (0, Hr.openContract)(e, (r) => mf(this, null, r.address, r.init));
  }
  /**
   * Open smart contract
   * @param block block number
   * @param contract contract
   * @returns opened contract
   */
  openAt(e, r) {
    return (0, Hr.openContract)(r, (i) => mf(this, e, i.address, i.init));
  }
  /**
   * Create provider
   * @param address address
   * @param init optional init data
   * @returns provider
   */
  provider(e, r) {
    return mf(this, null, e, r ?? null);
  }
  /**
   * Create provider at specified block number
   * @param block block number
   * @param address address
   * @param init optional init data
   * @returns provider
   */
  providerAt(e, r, i) {
    return mf(this, e, r, i ?? null);
  }
}
td.TonClient4 = dF;
Yr = /* @__PURE__ */ new WeakMap(), Jr = /* @__PURE__ */ new WeakMap(), Xr = /* @__PURE__ */ new WeakMap();
function mf(t, e, r, i) {
  return {
    async getState() {
      let f = e;
      f === null && (f = (await t.getLastBlock()).last.seqno);
      let a = await t.getAccount(f, r), l = a.account.last ? { lt: BigInt(a.account.last.lt), hash: Je.from(a.account.last.hash, "base64") } : null, d;
      if (a.account.state.type === "active")
        d = {
          type: "active",
          code: a.account.state.code ? Je.from(a.account.state.code, "base64") : null,
          data: a.account.state.data ? Je.from(a.account.state.data, "base64") : null
        };
      else if (a.account.state.type === "uninit")
        d = {
          type: "uninit"
        };
      else if (a.account.state.type === "frozen")
        d = {
          type: "frozen",
          stateHash: Je.from(a.account.state.stateHash, "base64")
        };
      else
        throw Error("Unsupported state");
      return {
        balance: BigInt(a.account.balance.coins),
        last: l,
        state: d
      };
    },
    async get(f, a) {
      let l = e;
      l === null && (l = (await t.getLastBlock()).last.seqno);
      let d = await t.runMethod(l, r, f, a);
      if (d.exitCode !== 0 && d.exitCode !== 1)
        throw Error("Exit code: " + d.exitCode);
      return {
        stack: new Hr.TupleReader(d.result)
      };
    },
    async external(f) {
      let a = await t.getLastBlock(), l = null;
      i && (await t.getAccountLite(a.last.seqno, r)).account.state.type !== "active" && (l = i);
      const d = (0, Hr.external)({
        to: r,
        init: l,
        body: f
      });
      let v = (0, Hr.beginCell)().store((0, Hr.storeMessage)(d)).endCell().toBoc();
      await t.sendMessage(v);
    },
    async internal(f, a) {
      let l = await t.getLastBlock(), d = null;
      i && (await t.getAccountLite(l.last.seqno, r)).account.state.type !== "active" && (d = i);
      let v = !0;
      a.bounce !== null && a.bounce !== void 0 && (v = a.bounce);
      let m;
      typeof a.value == "string" ? m = (0, Hr.toNano)(a.value) : m = a.value;
      let h = null;
      typeof a.body == "string" ? h = (0, Hr.comment)(a.body) : a.body && (h = a.body), await f.send({
        to: r,
        value: m,
        bounce: v,
        sendMode: a.sendMode,
        init: d,
        body: h
      });
    },
    open(f) {
      return (0, Hr.openContract)(f, (a) => mf(t, e, a.address, a.init ?? null));
    },
    async getTransactions(f, a, l, d) {
      const v = typeof d == "number";
      if (v && d <= 0)
        return [];
      let m = [];
      do {
        const h = await t.getAccountTransactions(f, a, l), w = h[0].tx, [M, S] = [w.lt, w.hash()];
        if (m.length > 0 && M === a && S.equals(l) && h.shift(), h.length === 0)
          break;
        const A = h[h.length - 1].tx, [B, k] = [A.lt, A.hash()];
        if (B === a && k.equals(l))
          break;
        m.push(...h.map((C) => C.tx)), a = B, l = k;
      } while (v && m.length < d);
      return v && (m = m.slice(0, d)), m;
    }
  };
}
const hF = Me.z.object({
  last: Me.z.object({
    seqno: Me.z.number(),
    shard: Me.z.string(),
    workchain: Me.z.number(),
    fileHash: Me.z.string(),
    rootHash: Me.z.string()
  }),
  init: Me.z.object({
    fileHash: Me.z.string(),
    rootHash: Me.z.string()
  }),
  stateRootHash: Me.z.string(),
  now: Me.z.number()
}), l5 = Me.z.union([Me.z.object({
  exist: Me.z.literal(!1)
}), Me.z.object({
  exist: Me.z.literal(!0),
  block: Me.z.object({
    shards: Me.z.array(Me.z.object({
      workchain: Me.z.number(),
      seqno: Me.z.number(),
      shard: Me.z.string(),
      rootHash: Me.z.string(),
      fileHash: Me.z.string(),
      transactions: Me.z.array(Me.z.object({
        account: Me.z.string(),
        hash: Me.z.string(),
        lt: Me.z.string()
      }))
    }))
  })
})]), fM = Me.z.object({
  lastPaid: Me.z.number(),
  duePayment: Me.z.union([Me.z.null(), Me.z.string()]),
  used: Me.z.object({
    bits: Me.z.number(),
    cells: Me.z.number(),
    publicCells: Me.z.number()
  })
}), pF = Me.z.object({
  account: Me.z.object({
    state: Me.z.union([
      Me.z.object({ type: Me.z.literal("uninit") }),
      Me.z.object({ type: Me.z.literal("active"), code: Me.z.union([Me.z.string(), Me.z.null()]), data: Me.z.union([Me.z.string(), Me.z.null()]) }),
      Me.z.object({ type: Me.z.literal("frozen"), stateHash: Me.z.string() })
    ]),
    balance: Me.z.object({
      coins: Me.z.string()
    }),
    last: Me.z.union([
      Me.z.null(),
      Me.z.object({
        lt: Me.z.string(),
        hash: Me.z.string()
      })
    ]),
    storageStat: Me.z.union([Me.z.null(), fM])
  }),
  block: Me.z.object({
    workchain: Me.z.number(),
    seqno: Me.z.number(),
    shard: Me.z.string(),
    rootHash: Me.z.string(),
    fileHash: Me.z.string()
  })
}), vF = Me.z.object({
  account: Me.z.object({
    state: Me.z.union([
      Me.z.object({ type: Me.z.literal("uninit") }),
      Me.z.object({ type: Me.z.literal("active"), codeHash: Me.z.string(), dataHash: Me.z.string() }),
      Me.z.object({ type: Me.z.literal("frozen"), stateHash: Me.z.string() })
    ]),
    balance: Me.z.object({
      coins: Me.z.string()
    }),
    last: Me.z.union([
      Me.z.null(),
      Me.z.object({
        lt: Me.z.string(),
        hash: Me.z.string()
      })
    ]),
    storageStat: Me.z.union([Me.z.null(), fM])
  })
}), mF = Me.z.object({
  changed: Me.z.boolean(),
  block: Me.z.object({
    workchain: Me.z.number(),
    seqno: Me.z.number(),
    shard: Me.z.string(),
    rootHash: Me.z.string(),
    fileHash: Me.z.string()
  })
}), gF = Me.z.object({
  exitCode: Me.z.number(),
  resultRaw: Me.z.union([Me.z.string(), Me.z.null()]),
  block: Me.z.object({
    workchain: Me.z.number(),
    seqno: Me.z.number(),
    shard: Me.z.string(),
    rootHash: Me.z.string(),
    fileHash: Me.z.string()
  }),
  shardBlock: Me.z.object({
    workchain: Me.z.number(),
    seqno: Me.z.number(),
    shard: Me.z.string(),
    rootHash: Me.z.string(),
    fileHash: Me.z.string()
  })
}), yF = Me.z.object({
  config: Me.z.object({
    cell: Me.z.string(),
    address: Me.z.string(),
    globalBalance: Me.z.object({
      coins: Me.z.string()
    })
  })
}), bF = Me.z.object({
  status: Me.z.number()
}), uM = Me.z.array(Me.z.object({
  workchain: Me.z.number(),
  seqno: Me.z.number(),
  shard: Me.z.string(),
  rootHash: Me.z.string(),
  fileHash: Me.z.string()
})), wF = Me.z.object({
  blocks: uM,
  boc: Me.z.string()
}), c5 = Me.z.object({
  bits: Me.z.number(),
  data: Me.z.string()
}), _F = Me.z.union([
  Me.z.object({
    type: Me.z.literal("internal"),
    value: Me.z.string(),
    dest: Me.z.string(),
    src: Me.z.string(),
    bounced: Me.z.boolean(),
    bounce: Me.z.boolean(),
    ihrDisabled: Me.z.boolean(),
    createdAt: Me.z.number(),
    createdLt: Me.z.string(),
    fwdFee: Me.z.string(),
    ihrFee: Me.z.string()
  }),
  Me.z.object({
    type: Me.z.literal("external-in"),
    dest: Me.z.string(),
    src: Me.z.union([c5, Me.z.null()]),
    importFee: Me.z.string()
  }),
  Me.z.object({
    type: Me.z.literal("external-out"),
    dest: Me.z.union([c5, Me.z.null()])
  })
]), xF = Me.z.object({
  splitDepth: Me.z.union([Me.z.number(), Me.z.null()]),
  code: Me.z.union([Me.z.string(), Me.z.null()]),
  data: Me.z.union([Me.z.string(), Me.z.null()]),
  special: Me.z.union([Me.z.object({ tick: Me.z.boolean(), tock: Me.z.boolean() }), Me.z.null()])
}), d5 = Me.z.object({
  body: Me.z.string(),
  info: _F,
  init: Me.z.union([xF, Me.z.null()])
}), h5 = Me.z.union([Me.z.literal("uninitialized"), Me.z.literal("frozen"), Me.z.literal("active"), Me.z.literal("non-existing")]), MF = Me.z.union([
  Me.z.object({ type: Me.z.literal("comment"), comment: Me.z.string() }),
  Me.z.object({ type: Me.z.literal("payload"), cell: Me.z.string() })
]), SF = Me.z.union([
  Me.z.object({ kind: Me.z.literal("ton"), amount: Me.z.string() }),
  Me.z.object({ kind: Me.z.literal("token"), amount: Me.z.string() })
]), EF = Me.z.union([
  Me.z.literal("jetton::excesses"),
  Me.z.literal("jetton::transfer"),
  Me.z.literal("jetton::transfer_notification"),
  Me.z.literal("deposit"),
  Me.z.literal("deposit::ok"),
  Me.z.literal("withdraw"),
  Me.z.literal("withdraw::all"),
  Me.z.literal("withdraw::delayed"),
  Me.z.literal("withdraw::ok"),
  Me.z.literal("airdrop")
]), AF = Me.z.object({
  type: EF,
  options: Me.z.optional(Me.z.record(Me.z.string()))
}), kF = Me.z.object({
  address: Me.z.string(),
  comment: Me.z.optional(Me.z.string()),
  items: Me.z.array(SF),
  op: Me.z.optional(AF)
}), TF = Me.z.object({
  address: Me.z.string(),
  lt: Me.z.string(),
  hash: Me.z.string(),
  prevTransaction: Me.z.object({
    lt: Me.z.string(),
    hash: Me.z.string()
  }),
  time: Me.z.number(),
  outMessagesCount: Me.z.number(),
  oldStatus: h5,
  newStatus: h5,
  fees: Me.z.string(),
  update: Me.z.object({
    oldHash: Me.z.string(),
    newHash: Me.z.string()
  }),
  inMessage: Me.z.union([d5, Me.z.null()]),
  outMessages: Me.z.array(d5),
  parsed: Me.z.object({
    seqno: Me.z.union([Me.z.number(), Me.z.null()]),
    body: Me.z.union([MF, Me.z.null()]),
    status: Me.z.union([Me.z.literal("success"), Me.z.literal("failed"), Me.z.literal("pending")]),
    dest: Me.z.union([Me.z.string(), Me.z.null()]),
    kind: Me.z.union([Me.z.literal("out"), Me.z.literal("in")]),
    amount: Me.z.string(),
    resolvedAddress: Me.z.string(),
    bounced: Me.z.boolean(),
    mentioned: Me.z.array(Me.z.string())
  }),
  operation: kF
}), CF = Me.z.object({
  blocks: uM,
  transactions: Me.z.array(TF)
});
var nd = {}, Pr = {};
Object.defineProperty(Pr, "__esModule", { value: !0 });
Pr.createWalletTransferV4 = Pr.createWalletTransferV3 = Pr.createWalletTransferV2 = Pr.createWalletTransferV1 = void 0;
const zr = At, id = gs();
function BF(t) {
  let e = (0, zr.beginCell)().storeUint(t.seqno, 32);
  t.message && (e.storeUint(t.sendMode, 8), e.storeRef((0, zr.beginCell)().store((0, zr.storeMessageRelaxed)(t.message))));
  let r = (0, id.sign)(e.endCell().hash(), t.secretKey);
  return (0, zr.beginCell)().storeBuffer(r).storeBuilder(e).endCell();
}
Pr.createWalletTransferV1 = BF;
function IF(t) {
  if (t.messages.length > 4)
    throw Error("Maximum number of messages in a single transfer is 4");
  let e = (0, zr.beginCell)().storeUint(t.seqno, 32);
  if (t.seqno === 0)
    for (let f = 0; f < 32; f++)
      e.storeBit(1);
  else
    e.storeUint(t.timeout || Math.floor(Date.now() / 1e3) + 60, 32);
  for (let f of t.messages)
    e.storeUint(t.sendMode, 8), e.storeRef((0, zr.beginCell)().store((0, zr.storeMessageRelaxed)(f)));
  let r = (0, id.sign)(e.endCell().hash(), t.secretKey);
  return (0, zr.beginCell)().storeBuffer(r).storeBuilder(e).endCell();
}
Pr.createWalletTransferV2 = IF;
function RF(t) {
  if (t.messages.length > 4)
    throw Error("Maximum number of messages in a single transfer is 4");
  let e = (0, zr.beginCell)().storeUint(t.walletId, 32);
  if (t.seqno === 0)
    for (let f = 0; f < 32; f++)
      e.storeBit(1);
  else
    e.storeUint(t.timeout || Math.floor(Date.now() / 1e3) + 60, 32);
  e.storeUint(t.seqno, 32);
  for (let f of t.messages)
    e.storeUint(t.sendMode, 8), e.storeRef((0, zr.beginCell)().store((0, zr.storeMessageRelaxed)(f)));
  let r = (0, id.sign)(e.endCell().hash(), t.secretKey);
  return (0, zr.beginCell)().storeBuffer(r).storeBuilder(e).endCell();
}
Pr.createWalletTransferV3 = RF;
function PF(t) {
  if (t.messages.length > 4)
    throw Error("Maximum number of messages in a single transfer is 4");
  let e = (0, zr.beginCell)().storeUint(t.walletId, 32);
  if (t.seqno === 0)
    for (let f = 0; f < 32; f++)
      e.storeBit(1);
  else
    e.storeUint(t.timeout || Math.floor(Date.now() / 1e3) + 60, 32);
  e.storeUint(t.seqno, 32), e.storeUint(0, 8);
  for (let f of t.messages)
    e.storeUint(t.sendMode, 8), e.storeRef((0, zr.beginCell)().store((0, zr.storeMessageRelaxed)(f)));
  let r = (0, id.sign)(e.endCell().hash(), t.secretKey);
  return (0, zr.beginCell)().storeBuffer(r).storeBuilder(e).endCell();
}
Pr.createWalletTransferV4 = PF;
Object.defineProperty(nd, "__esModule", { value: !0 });
nd.WalletContractV1R1 = void 0;
const _s = At, OF = Pr;
class Ag {
  static create(e) {
    return new Ag(e.workchain, e.publicKey);
  }
  constructor(e, r) {
    this.workchain = e, this.publicKey = r;
    let i = _s.Cell.fromBoc(Je.from("te6cckEBAQEARAAAhP8AIN2k8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVEH98Ik=", "base64"))[0], f = (0, _s.beginCell)().storeUint(0, 32).storeBuffer(r).endCell();
    this.init = { code: i, data: f }, this.address = (0, _s.contractAddress)(e, { code: i, data: f });
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    let r = await e.getState();
    return r.state.type === "active" ? _s.Cell.fromBoc(r.state.data)[0].beginParse().loadUint(32) : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let r = _s.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, OF.createWalletTransferV1)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      message: e.message
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          message: (0, _s.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })
        });
        await this.send(e, a);
      }
    };
  }
}
nd.WalletContractV1R1 = Ag;
var ad = {};
Object.defineProperty(ad, "__esModule", { value: !0 });
ad.WalletContractV1R2 = void 0;
const Vo = At, NF = Pr;
class kg {
  static create(e) {
    return new kg(e.workchain, e.publicKey);
  }
  constructor(e, r) {
    this.workchain = e, this.publicKey = r;
    let i = Vo.Cell.fromBoc(Je.from("te6cckEBAQEAUwAAov8AIN0gggFMl7qXMO1E0NcLH+Ck8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVNDieG8=", "base64"))[0], f = (0, Vo.beginCell)().storeUint(0, 32).storeBuffer(r).endCell();
    this.init = { code: i, data: f }, this.address = (0, Vo.contractAddress)(e, { code: i, data: f });
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let r = Vo.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, NF.createWalletTransferV1)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      message: e.message
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          message: (0, Vo.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })
        });
        await this.send(e, a);
      }
    };
  }
}
ad.WalletContractV1R2 = kg;
var sd = {};
Object.defineProperty(sd, "__esModule", { value: !0 });
sd.WalletContractV1R3 = void 0;
const Ho = At, DF = Pr;
class Tg {
  static create(e) {
    return new Tg(e.workchain, e.publicKey);
  }
  constructor(e, r) {
    this.workchain = e, this.publicKey = r;
    let i = Ho.Cell.fromBoc(Je.from("te6cckEBAQEAXwAAuv8AIN0gggFMl7ohggEznLqxnHGw7UTQ0x/XC//jBOCk8mCBAgDXGCDXCx/tRNDTH9P/0VESuvKhIvkBVBBE+RDyovgAAdMfMSDXSpbTB9QC+wDe0aTIyx/L/8ntVLW4bkI=", "base64"))[0], f = (0, Ho.beginCell)().storeUint(0, 32).storeBuffer(r).endCell();
    this.init = { code: i, data: f }, this.address = (0, Ho.contractAddress)(e, { code: i, data: f });
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let r = Ho.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, DF.createWalletTransferV1)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      message: e.message
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          message: (0, Ho.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })
        });
        await this.send(e, a);
      }
    };
  }
}
sd.WalletContractV1R3 = Tg;
var od = {};
Object.defineProperty(od, "__esModule", { value: !0 });
od.WalletContractV2R1 = void 0;
const Wo = At, UF = Pr;
class Cg {
  static create(e) {
    return new Cg(e.workchain, e.publicKey);
  }
  constructor(e, r) {
    this.workchain = e, this.publicKey = r;
    let i = Wo.Cell.fromBoc(Je.from("te6cckEBAQEAVwAAqv8AIN0gggFMl7qXMO1E0NcLH+Ck8mCDCNcYINMf0x8B+CO78mPtRNDTH9P/0VExuvKhA/kBVBBC+RDyovgAApMg10qW0wfUAvsA6NGkyMsfy//J7VShNwu2", "base64"))[0], f = (0, Wo.beginCell)().storeUint(0, 32).storeBuffer(r).endCell();
    this.init = { code: i, data: f }, this.address = (0, Wo.contractAddress)(e, { code: i, data: f });
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let r = Wo.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, UF.createWalletTransferV2)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      messages: e.messages,
      timeout: e.timeout
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          messages: [(0, Wo.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })]
        });
        await this.send(e, a);
      }
    };
  }
}
od.WalletContractV2R1 = Cg;
var fd = {};
Object.defineProperty(fd, "__esModule", { value: !0 });
fd.WalletContractV2R2 = void 0;
const Ko = At, LF = Pr;
class Bg {
  static create(e) {
    return new Bg(e.workchain, e.publicKey);
  }
  constructor(e, r) {
    this.workchain = e, this.publicKey = r;
    let i = Ko.Cell.fromBoc(Je.from("te6cckEBAQEAYwAAwv8AIN0gggFMl7ohggEznLqxnHGw7UTQ0x/XC//jBOCk8mCDCNcYINMf0x8B+CO78mPtRNDTH9P/0VExuvKhA/kBVBBC+RDyovgAApMg10qW0wfUAvsA6NGkyMsfy//J7VQETNeh", "base64"))[0], f = (0, Ko.beginCell)().storeUint(0, 32).storeBuffer(r).endCell();
    this.init = { code: i, data: f }, this.address = (0, Ko.contractAddress)(e, { code: i, data: f });
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let r = Ko.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, LF.createWalletTransferV2)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      messages: e.messages,
      timeout: e.timeout
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          messages: [(0, Ko.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })]
        });
        await this.send(e, a);
      }
    };
  }
}
fd.WalletContractV2R2 = Bg;
var ud = {};
Object.defineProperty(ud, "__esModule", { value: !0 });
ud.WalletContractV3R1 = void 0;
const Zo = At, FF = Pr;
class Ig {
  static create(e) {
    return new Ig(e.workchain, e.publicKey, e.walletId);
  }
  constructor(e, r, i) {
    this.workchain = e, this.publicKey = r, i != null ? this.walletId = i : this.walletId = 698983191 + e;
    let f = Zo.Cell.fromBoc(Je.from("te6cckEBAQEAYgAAwP8AIN0gggFMl7qXMO1E0NcLH+Ck8mCDCNcYINMf0x/TH/gjE7vyY+1E0NMf0x/T/9FRMrryoVFEuvKiBPkBVBBV+RDyo/gAkyDXSpbTB9QC+wDo0QGkyMsfyx/L/8ntVD++buA=", "base64"))[0], a = (0, Zo.beginCell)().storeUint(0, 32).storeUint(this.walletId, 32).storeBuffer(r).endCell();
    this.init = { code: f, data: a }, this.address = (0, Zo.contractAddress)(e, { code: f, data: a });
  }
  /**
   * Get wallet balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create transfer
   */
  createTransfer(e) {
    let r = Zo.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, FF.createWalletTransferV3)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      messages: e.messages,
      timeout: e.timeout,
      walletId: this.walletId
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          messages: [(0, Zo.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })]
        });
        await this.send(e, a);
      }
    };
  }
}
ud.WalletContractV3R1 = Ig;
var ld = {};
Object.defineProperty(ld, "__esModule", { value: !0 });
ld.WalletContractV3R2 = void 0;
const Go = At, qF = Pr;
class Rg {
  static create(e) {
    return new Rg(e.workchain, e.publicKey, e.walletId);
  }
  constructor(e, r, i) {
    this.workchain = e, this.publicKey = r, i != null ? this.walletId = i : this.walletId = 698983191 + e;
    let f = Go.Cell.fromBoc(Je.from("te6cckEBAQEAcQAA3v8AIN0gggFMl7ohggEznLqxn3Gw7UTQ0x/THzHXC//jBOCk8mCDCNcYINMf0x/TH/gjE7vyY+1E0NMf0x/T/9FRMrryoVFEuvKiBPkBVBBV+RDyo/gAkyDXSpbTB9QC+wDo0QGkyMsfyx/L/8ntVBC9ba0=", "base64"))[0], a = (0, Go.beginCell)().storeUint(0, 32).storeUint(this.walletId, 32).storeBuffer(r).endCell();
    this.init = { code: f, data: a }, this.address = (0, Go.contractAddress)(e, { code: f, data: a });
  }
  /**
   * Get wallet balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create transfer
   */
  createTransfer(e) {
    let r = Go.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, qF.createWalletTransferV3)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      messages: e.messages,
      timeout: e.timeout,
      walletId: this.walletId
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          messages: [(0, Go.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })]
        });
        await this.send(e, a);
      }
    };
  }
}
ld.WalletContractV3R2 = Rg;
var cd = {};
Object.defineProperty(cd, "__esModule", { value: !0 });
cd.WalletContractV4 = void 0;
const Qo = At, zF = Pr;
class Pg {
  static create(e) {
    return new Pg(e.workchain, e.publicKey, e.walletId);
  }
  constructor(e, r, i) {
    this.workchain = e, this.publicKey = r, i != null ? this.walletId = i : this.walletId = 698983191 + e;
    let f = Qo.Cell.fromBoc(Je.from("te6ccgECFAEAAtQAART/APSkE/S88sgLAQIBIAIDAgFIBAUE+PKDCNcYINMf0x/THwL4I7vyZO1E0NMf0x/T//QE0VFDuvKhUVG68qIF+QFUEGT5EPKj+AAkpMjLH1JAyx9SMMv/UhD0AMntVPgPAdMHIcAAn2xRkyDXSpbTB9QC+wDoMOAhwAHjACHAAuMAAcADkTDjDQOkyMsfEssfy/8QERITAubQAdDTAyFxsJJfBOAi10nBIJJfBOAC0x8hghBwbHVnvSKCEGRzdHK9sJJfBeAD+kAwIPpEAcjKB8v/ydDtRNCBAUDXIfQEMFyBAQj0Cm+hMbOSXwfgBdM/yCWCEHBsdWe6kjgw4w0DghBkc3RyupJfBuMNBgcCASAICQB4AfoA9AQw+CdvIjBQCqEhvvLgUIIQcGx1Z4MesXCAGFAEywUmzxZY+gIZ9ADLaRfLH1Jgyz8gyYBA+wAGAIpQBIEBCPRZMO1E0IEBQNcgyAHPFvQAye1UAXKwjiOCEGRzdHKDHrFwgBhQBcsFUAPPFiP6AhPLassfyz/JgED7AJJfA+ICASAKCwBZvSQrb2omhAgKBrkPoCGEcNQICEekk30pkQzmkD6f+YN4EoAbeBAUiYcVnzGEAgFYDA0AEbjJftRNDXCx+AA9sp37UTQgQFA1yH0BDACyMoHy//J0AGBAQj0Cm+hMYAIBIA4PABmtznaiaEAga5Drhf/AABmvHfaiaEAQa5DrhY/AAG7SB/oA1NQi+QAFyMoHFcv/ydB3dIAYyMsFywIizxZQBfoCFMtrEszMyXP7AMhAFIEBCPRR8qcCAHCBAQjXGPoA0z/IVCBHgQEI9FHyp4IQbm90ZXB0gBjIywXLAlAGzxZQBPoCFMtqEssfyz/Jc/sAAgBsgQEI1xj6ANM/MFIkgQEI9Fnyp4IQZHN0cnB0gBjIywXLAlAFzxZQA/oCE8tqyx8Syz/Jc/sAAAr0AMntVA==", "base64"))[0], a = (0, Qo.beginCell)().storeUint(0, 32).storeUint(this.walletId, 32).storeBuffer(this.publicKey).storeBit(0).endCell();
    this.init = { code: f, data: a }, this.address = (0, Qo.contractAddress)(e, { code: f, data: a });
  }
  /**
   * Get Wallet Balance
   */
  async getBalance(e) {
    return (await e.getState()).balance;
  }
  /**
   * Get Wallet Seqno
   */
  async getSeqno(e) {
    return (await e.getState()).state.type === "active" ? (await e.get("seqno", [])).stack.readNumber() : 0;
  }
  /**
   * Send signed transfer
   */
  async send(e, r) {
    await e.external(r);
  }
  /**
   * Sign and send transfer
   */
  async sendTransfer(e, r) {
    let i = this.createTransfer(r);
    await this.send(e, i);
  }
  /**
   * Create signed transfer
   */
  createTransfer(e) {
    let r = Qo.SendMode.PAY_GAS_SEPARATELY;
    return e.sendMode !== null && e.sendMode !== void 0 && (r = e.sendMode), (0, zF.createWalletTransferV4)({
      seqno: e.seqno,
      sendMode: r,
      secretKey: e.secretKey,
      messages: e.messages,
      timeout: e.timeout,
      walletId: this.walletId
    });
  }
  /**
   * Create sender
   */
  sender(e, r) {
    return {
      send: async (i) => {
        let f = await this.getSeqno(e), a = this.createTransfer({
          seqno: f,
          secretKey: r,
          sendMode: i.sendMode,
          messages: [(0, Qo.internal)({
            to: i.to,
            value: i.value,
            init: i.init,
            body: i.body,
            bounce: i.bounce
          })]
        });
        await this.send(e, a);
      }
    };
  }
}
cd.WalletContractV4 = Pg;
var dd = {};
Object.defineProperty(dd, "__esModule", { value: !0 });
dd.JettonMaster = void 0;
const jF = At;
class Og {
  static create(e) {
    return new Og(e);
  }
  constructor(e) {
    this.address = e;
  }
  async getWalletAddress(e, r) {
    return (await e.get("get_wallet_address", [{ type: "slice", cell: (0, jF.beginCell)().storeAddress(r).endCell() }])).stack.readAddress();
  }
  async getJettonData(e) {
    let r = await e.get("get_jetton_data", []), i = r.stack.readBigNumber(), f = r.stack.readBoolean(), a = r.stack.readAddress(), l = r.stack.readCell(), d = r.stack.readCell();
    return {
      totalSupply: i,
      mintable: f,
      adminAddress: a,
      content: l,
      walletCode: d
    };
  }
}
dd.JettonMaster = Og;
var hd = {};
Object.defineProperty(hd, "__esModule", { value: !0 });
hd.JettonWallet = void 0;
class Ng {
  static create(e) {
    return new Ng(e);
  }
  constructor(e) {
    this.address = e;
  }
  async getBalance(e) {
    return (await e.getState()).state.type !== "active" ? 0n : (await e.get("get_wallet_data", [])).stack.readBigNumber();
  }
}
hd.JettonWallet = Ng;
var fu = {};
Object.defineProperty(fu, "__esModule", { value: !0 });
fu.MultisigOrder = void 0;
const p5 = gs(), Ou = At;
class Fl {
  constructor(e) {
    this.signatures = {}, this.payload = e;
  }
  static fromCell(e) {
    var l;
    let r = e.beginParse(), i = (l = r.loadMaybeRef()) == null ? void 0 : l.beginParse();
    const f = r.asCell();
    let a = new Fl(f);
    if (i) {
      for (; i.remainingBits > 0; ) {
        const d = i.loadBuffer(64), v = i.loadUint(8);
        a.signatures[v] = d, i.remainingRefs > 0 ? i = i.loadRef().asSlice() : i.skip(1);
      }
      i.endParse();
    }
    return a;
  }
  static fromPayload(e) {
    return new Fl(e);
  }
  addSignature(e, r, i) {
    const f = this.payload.hash();
    if (!(0, p5.signVerify)(f, r, i.owners.get(e).slice(0, -1)))
      throw Error("invalid signature");
    this.signatures[e] = r;
  }
  sign(e, r) {
    const i = this.payload.hash();
    return this.signatures[e] = (0, p5.sign)(i, r), i;
  }
  unionSignatures(e) {
    this.signatures = Object.assign({}, this.signatures, e.signatures);
  }
  clearSignatures() {
    this.signatures = {};
  }
  toCell(e) {
    let r = (0, Ou.beginCell)().storeBit(0);
    for (const i in this.signatures) {
      const f = this.signatures[i];
      r = (0, Ou.beginCell)().storeBit(1).storeRef((0, Ou.beginCell)().storeBuffer(f).storeUint(parseInt(i), 8).storeBuilder(r).endCell());
    }
    return (0, Ou.beginCell)().storeUint(e, 8).storeBuilder(r).storeBuilder(this.payload.asBuilder()).endCell();
  }
}
fu.MultisigOrder = Fl;
var pd = {};
Object.defineProperty(pd, "__esModule", { value: !0 });
pd.MultisigOrderBuilder = void 0;
const Yo = At, $F = fu;
class VF {
  constructor(e, r) {
    this.messages = (0, Yo.beginCell)(), this.queryId = 0n, this.walletId = e, this.queryOffset = r || 7200;
  }
  addMessage(e, r) {
    if (this.messages.refs >= 4)
      throw Error("only 4 refs are allowed");
    this.updateQueryId(), this.messages.storeUint(r, 8), this.messages.storeRef((0, Yo.beginCell)().store((0, Yo.storeMessageRelaxed)(e)).endCell());
  }
  clearMessages() {
    this.messages = (0, Yo.beginCell)();
  }
  build() {
    return $F.MultisigOrder.fromPayload((0, Yo.beginCell)().storeUint(this.walletId, 32).storeUint(this.queryId, 64).storeBuilder(this.messages).endCell());
  }
  updateQueryId() {
    const e = BigInt(Math.floor(Date.now() / 1e3 + this.queryOffset));
    this.queryId = e << 32n;
  }
}
pd.MultisigOrderBuilder = VF;
var vd = {};
Object.defineProperty(vd, "__esModule", { value: !0 });
vd.MultisigWallet = void 0;
const v5 = gs(), on = At, HF = on.Cell.fromBase64("te6ccgECKwEABBgAART/APSkE/S88sgLAQIBIAIDAgFIBAUE2vIgxwCOgzDbPOCDCNcYIPkBAdMH2zwiwAAToVNxePQOb6Hyn9s8VBq6+RDyoAb0BCD5AQHTH1EYuvKq0z9wUwHwCgHCCAGDCryx8mhTFYBA9A5voSCYDqQgwgryZw7f+COqH1NAufJhVCOjU04gIyEiAgLMBgcCASAMDQIBIAgJAgFmCgsAA9GEAiPymAvHoHN9CYbZ5S7Z4BPHohwhJQAtAKkItdJEqCTItdKlwLUAdAT8ArobBKAATwhbpEx4CBukTDgAdAg10rDAJrUAvALyFjPFszJ4HHXI8gBzxb0AMmACASAODwIBIBQVARW77ZbVA0cFUg2zyCoCAUgQEQIBIBITAXOxHXQgwjXGCD5AQHTB4IB1MTtQ9hTIHj0Dm+h8p/XC/9eMfkQ8qCuAfQEIW6TW3Ey4PkBWNs8AaQBgJwA9rtqA6ADoAPoCAXoCEfyAgPyA3XlP+AXkegAA54tkwAAXrhlXP8EA1WZ2oexAAgEgFhcCASAYGQFRtyVbZ4YmRmpGEAgegc30McJNhFpAADMaYeYuAFrgJhwLb+4cC3d0bhAjAYm1WZtnhqvgb+2xxsoicAgej430pBHEoFpAADHDhBACGuQkuuBk9kUWE5kAOeLKhACQCB6IYFImHFImHFImXEA2YlzNijAjAgEgGhsAF7UGtc4QQDVZnah7EAIBIBwdAgOZOB4fARGsGm2eL4G2CUAjABWt+UEAzJV2oewYQAENqTbPBVfBYCMAFa3f3CCAarM7UPYgAiDbPALyZfgAUENxQxPbPO1UIyoACtP/0wcwBKDbPC+uUyCw8mISsQKkJbNTHLmwJYEA4aojoCi8sPJpggGGoPgBBZcCERACPj4wjo0REB/bPEDXePRDEL0F4lQWW1Rz51YQU9zbPFRxClR6vCQlKCYAIO1E0NMf0wfTB9M/9AT0BNEAXgGOGjDSAAHyo9MH0wdQA9cBIPkBBfkBFbrypFAD4GwhIddKqgIi10m68qtwVCATAAwByMv/ywcE1ts87VT4D3AlblOJvrGYEG4QLVDHXwePGzBUJANQTds8UFWgRlAQSRA6SwlTuds8UFQWf+L4AAeDJaGOLCaAQPSWb6UglDBTA7neII4WODk5CNIAAZfTBzAW8AcFkTDifwgHBZJsMeKz5jAGKicoKQBgcI4pA9CDCNcY0wf0BDBTFnj0Dm+h8qXXC/9URUT5EPKmrlIgsVIDvRShI27mbCIyAH5SML6OIF8D+ACTItdKmALTB9QC+wAC6DJwyMoAQBSAQPRDAvAHjhdxyMsAFMsHEssHWM8BWM8WQBOAQPRDAeIBII6KEEUQNEMA2zztVJJfBuIqABzIyx/LB8sHyz/0APQAyQ==");
class Dg {
  constructor(e, r, i, f, a) {
    this.provider = null, this.owners = on.Dictionary.empty(), this.workchain = r, this.walletId = i, this.k = f;
    for (let l = 0; l < e.length; l += 1)
      this.owners.set(l, Je.concat([e[l], Je.alloc(1)]));
    this.init = {
      code: HF,
      data: (0, on.beginCell)().storeUint(this.walletId, 32).storeUint(this.owners.size, 8).storeUint(this.k, 8).storeUint(0, 64).storeDict(this.owners, on.Dictionary.Keys.Uint(8), on.Dictionary.Values.Buffer(33)).storeBit(0).endCell()
    }, this.address = (a == null ? void 0 : a.address) || (0, on.contractAddress)(r, this.init), a != null && a.provider ? this.provider = a.provider : a != null && a.client && (this.provider = a.client.provider(this.address, {
      code: this.init.code,
      data: this.init.data
    }));
  }
  static async fromAddress(e, r) {
    let i;
    if (r.provider)
      i = r.provider;
    else {
      if (!r.client)
        throw Error("Either provider or client must be specified");
      i = r.client.provider(e, {
        code: null,
        data: null
      });
    }
    const f = (await i.getState()).state;
    if (f.type !== "active")
      throw Error("Contract must be active");
    const a = on.Cell.fromBoc(f.data)[0].beginParse(), l = a.loadUint(32);
    a.skip(8);
    const d = a.loadUint(8);
    a.skip(64);
    const v = a.loadDict(on.Dictionary.Keys.Uint(8), on.Dictionary.Values.Buffer(33));
    let m = [];
    for (const [h, w] of v) {
      const M = w.subarray(0, 32);
      m.push(M);
    }
    return new Dg(m, e.workChain, l, d, {
      address: e,
      provider: i,
      client: r.client
    });
  }
  async deployExternal(e) {
    if (!e && !this.provider)
      throw Error("you must specify provider if there is no such property in MultisigWallet instance");
    e || (e = this.provider), await e.external(on.Cell.EMPTY);
  }
  async deployInternal(e, r = 1000000000n) {
    await e.send({
      sendMode: 3,
      to: this.address,
      value: r,
      init: this.init,
      body: on.Cell.EMPTY,
      bounce: !0
    });
  }
  async sendOrder(e, r, i) {
    if (!i && !this.provider)
      throw Error("you must specify provider if there is no such property in MultisigWallet instance");
    i || (i = this.provider);
    let f = (0, v5.keyPairFromSecretKey)(r).publicKey, a = this.getOwnerIdByPubkey(f), l = e.toCell(a), d = (0, v5.sign)(l.hash(), r);
    l = (0, on.beginCell)().storeBuffer(d).storeSlice(l.asSlice()).endCell(), await i.external(l);
  }
  async sendOrderWithoutSecretKey(e, r, i, f) {
    if (!f && !this.provider)
      throw Error("you must specify provider if there is no such property in MultisigWallet instance");
    f || (f = this.provider);
    let a = e.toCell(i);
    a = (0, on.beginCell)().storeBuffer(r).storeSlice(a.asSlice()).endCell(), await f.external(a);
  }
  getOwnerIdByPubkey(e) {
    for (const [r, i] of this.owners)
      if (i.subarray(0, 32).equals(e))
        return r;
    throw Error("public key is not an owner");
  }
}
vd.MultisigWallet = Dg;
var md = {};
Object.defineProperty(md, "__esModule", { value: !0 });
md.ElectorContract = void 0;
const _n = At, WF = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    const e = new _n.Address(-1, t.loadBuffer(32)), r = t.loadUintBig(64), i = t.loadCoins();
    return { address: e, weight: r, stake: i };
  }
}, KF = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    const e = t.loadCoins();
    t.skip(64);
    const r = new _n.Address(-1, t.loadBuffer(32)), i = t.loadBuffer(32);
    return { stake: e, address: r, adnl: i };
  }
};
class Ug {
  //readonly source: ContractSource = new UnknownContractSource('org.ton.elector', -1, 'Elector Contract');
  static create() {
    return new Ug();
  }
  constructor() {
    this.address = _n.Address.parseRaw("-1:3333333333333333333333333333333333333333333333333333333333333333");
  }
  async getReturnedStake(e, r) {
    if (r.workChain !== -1)
      throw Error("Only masterchain addresses could have stake");
    return (await e.get("compute_returned_stake", [{ type: "int", value: BigInt("0x" + r.hash.toString("hex")) }])).stack.readBigNumber();
  }
  async getPastElectionsList(e) {
    const r = await e.get("past_elections_list", []), i = new _n.TupleReader(r.stack.readLispList()), f = [];
    for (; i.remaining > 0; ) {
      const a = i.readTuple(), l = a.readNumber(), d = a.readNumber();
      a.pop();
      const v = a.readNumber();
      f.push({ id: l, unfreezeAt: d, stakeHeld: v });
    }
    return f;
  }
  async getPastElections(e) {
    const r = await e.get("past_elections", []), i = new _n.TupleReader(r.stack.readLispList()), f = [];
    for (; i.remaining > 0; ) {
      const a = i.readTuple(), l = a.readNumber(), d = a.readNumber(), v = a.readNumber();
      a.pop();
      const m = a.readCell(), h = a.readBigNumber(), w = a.readBigNumber();
      let M = /* @__PURE__ */ new Map();
      const S = m.beginParse().loadDictDirect(_n.Dictionary.Keys.Buffer(32), WF);
      for (const [E, A] of S)
        M.set(BigInt("0x" + E.toString("hex")).toString(10), { address: A.address, weight: A.weight, stake: A.stake });
      f.push({ id: l, unfreezeAt: d, stakeHeld: v, totalStake: h, bonuses: w, frozen: M });
    }
    return f;
  }
  async getElectionEntities(e) {
    const r = await e.getState();
    if (r.state.type !== "active")
      throw Error("Unexpected error");
    const f = _n.Cell.fromBoc(r.state.data)[0].beginParse();
    if (!f.loadBit())
      return null;
    const a = f.loadRef().beginParse(), l = a.loadUint(32), d = a.loadUint(32), v = a.loadCoins(), m = a.loadCoins(), h = a.loadDict(_n.Dictionary.Keys.Buffer(32), KF);
    let w = [];
    if (h)
      for (const [M, S] of h)
        w.push({ pubkey: M, stake: S.stake, address: S.address, adnl: S.adnl });
    return { minStake: v, allStakes: m, endElectionsTime: d, startWorkTime: l, entities: w };
  }
  // possible code for fetching data via get method if it is possible to set gas limit by request
  // async getElectionEntities(block: number) {
  //     const res = await this.client.runMethod(block, this.address, 'participant_list_extended');
  //     if (res.exitCode !== 0 && res.exitCode !== 1) {
  //         throw Error('Exit code: ' + res.exitCode);
  //     }
  //     let tuple = new TupleReader(res.result);
  //     const startWorkTime = tuple.readNumber();
  //     const endElectionsTime = tuple.readNumber();
  //     const minStake = tuple.readBigNumber();
  //     const allStakes = tuple.readBigNumber();
  //     let entriesTuple = tuple.readTuple();
  //     const entriesRaw = new TupleReader(entriesTuple.readLispList());
  //     let entities: { pubkey: Buffer, stake: bigint, address: Address, adnl: Buffer }[] = [];
  //     while (entriesRaw.remaining > 0) {
  //         const electionsEntry = entriesRaw.readTuple();
  //         const pubkey = electionsEntry.readBuffer();
  //         const stake = electionsEntry.readBigNumber();
  //         const address = electionsEntry.readAddress();
  //         const adnl = electionsEntry.readBuffer();
  //         entities.push({ pubkey, stake, address, adnl });
  //     }
  //     return { minStake, allStakes, endElectionsTime, startWorkTime, entities };
  // }
  async getActiveElectionId(e) {
    const i = (await e.get("active_election_id", [])).stack.readNumber();
    return i > 0 ? i : null;
  }
  async getComplaints(e, r) {
    const i = new _n.TupleBuilder();
    i.writeNumber(r);
    const f = await e.get("list_complaints", i.build());
    if (f.stack.peek().type === "null")
      return [];
    const a = new _n.TupleReader(f.stack.readLispList()), l = [];
    for (; a.remaining > 0; ) {
      const d = a.readTuple(), v = d.readBigNumber(), m = d.readTuple(), h = m.readTuple(), w = Je.from(h.readBigNumber().toString(16), "hex");
      h.readCell();
      const M = h.readNumber(), S = h.readNumber(), E = new _n.Address(-1, Je.from(h.readBigNumber().toString(16), "hex")), A = h.readBigNumber(), B = h.readBigNumber(), k = h.readBigNumber(), C = [], I = new _n.TupleReader(m.readLispList());
      for (; I.remaining > 0; )
        C.push(I.readNumber());
      const O = m.readBigNumber(), q = m.readBigNumber();
      l.push({
        id: v,
        publicKey: w,
        createdAt: M,
        severity: S,
        paid: A,
        suggestedFine: B,
        suggestedFinePart: k,
        rewardAddress: E,
        votes: C,
        remainingWeight: q,
        vsetId: O
      });
    }
    return l;
  }
}
md.ElectorContract = Ug;
var Dt = {};
Object.defineProperty(Dt, "__esModule", { value: !0 });
Dt.parseFullConfig = Dt.loadConfigParamsAsSlice = Dt.loadConfigParamById = Dt.parseVotingSetup = Dt.parseProposalSetup = Dt.configParse29 = Dt.configParse28 = Dt.configParseMsgPrices = Dt.configParseGasLimitsPrices = Dt.configParseBridge = Dt.configParseValidatorSet = Dt.configParse12 = Dt.configParseWorkchainDescriptor = Dt.configParse40 = Dt.configParse8 = Dt.configParse18 = Dt.configParse17 = Dt.configParse16 = Dt.configParse15 = Dt.configParse13 = Dt.configParse5 = Dt.configParseMasterAddressRequired = Dt.parseBridge = Dt.parseValidatorSet = Dt.configParseMasterAddress = void 0;
const tn = At;
function Sf(t) {
  return t ? new tn.Address(-1, t.loadBuffer(32)) : null;
}
Dt.configParseMasterAddress = Sf;
function m5(t) {
  if (t.loadUint(32) !== 2390828938)
    throw Error("Invalid config");
  return t.loadBuffer(32);
}
const g5 = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    const e = t.loadUint(8);
    if (e === 83)
      return {
        publicKey: m5(t),
        weight: t.loadUintBig(64),
        adnlAddress: null
      };
    if (e === 115)
      return {
        publicKey: m5(t),
        weight: t.loadUintBig(64),
        adnlAddress: t.loadBuffer(32)
      };
    throw Error("Invalid config");
  }
};
function lM(t) {
  const e = t.loadUint(8);
  if (e === 17) {
    const r = t.loadUint(32), i = t.loadUint(32), f = t.loadUint(16), a = t.loadUint(16), l = t.loadDictDirect(tn.Dictionary.Keys.Uint(16), g5);
    return {
      timeSince: r,
      timeUntil: i,
      total: f,
      main: a,
      totalWeight: null,
      list: l
    };
  } else if (e === 18) {
    const r = t.loadUint(32), i = t.loadUint(32), f = t.loadUint(16), a = t.loadUint(16), l = t.loadUintBig(64), d = t.loadDict(tn.Dictionary.Keys.Uint(16), g5);
    return {
      timeSince: r,
      timeUntil: i,
      total: f,
      main: a,
      totalWeight: l,
      list: d
    };
  }
}
Dt.parseValidatorSet = lM;
function cM(t) {
  const e = new tn.Address(-1, t.loadBuffer(32)), r = new tn.Address(-1, t.loadBuffer(32)), i = t.loadDict(tn.Dictionary.Keys.Buffer(32), tn.Dictionary.Values.Buffer(32)), f = /* @__PURE__ */ new Map();
  for (const [l, d] of i)
    f.set(new tn.Address(-1, l).toString(), d);
  const a = t.loadBuffer(32);
  return {
    bridgeAddress: e,
    oracleMultisigAddress: r,
    oracles: f,
    externalChainAddress: a
  };
}
Dt.parseBridge = cM;
function Av(t) {
  if (!t)
    throw Error("Invalid config");
  return Sf(t);
}
Dt.configParseMasterAddressRequired = Av;
function dM(t) {
  if (!t)
    throw Error("Invalid config");
  if (t.loadUint(8) === 1) {
    const r = t.loadBit() ? new tn.Address(-1, t.loadBuffer(32)) : null, i = t.loadUint(32), f = t.loadUint(32);
    return {
      blackholeAddr: r,
      feeBurnNominator: i,
      feeBurnDenominator: f
    };
  }
  throw new Error("Invalid config");
}
Dt.configParse5 = dM;
function ZF(t) {
  if (!t)
    throw Error("Invalid config");
  if (t.loadUint(8) === 26) {
    const r = t.loadCoins(), i = t.loadCoins(), f = t.loadCoins();
    return {
      deposit: r,
      bitPrice: i,
      cellPrice: f
    };
  }
  throw new Error("Invalid config");
}
Dt.configParse13 = ZF;
function hM(t) {
  if (!t)
    throw Error("Invalid config");
  const e = t.loadUint(32), r = t.loadUint(32), i = t.loadUint(32), f = t.loadUint(32);
  return {
    validatorsElectedFor: e,
    electorsStartBefore: r,
    electorsEndBefore: i,
    stakeHeldFor: f
  };
}
Dt.configParse15 = hM;
function pM(t) {
  if (!t)
    throw Error("Invalid config");
  const e = t.loadUint(16), r = t.loadUint(16), i = t.loadUint(16);
  return {
    maxValidators: e,
    maxMainValidators: r,
    minValidators: i
  };
}
Dt.configParse16 = pM;
function vM(t) {
  if (!t)
    throw Error("Invalid config");
  const e = t.loadCoins(), r = t.loadCoins(), i = t.loadCoins(), f = t.loadUint(32);
  return {
    minStake: e,
    maxStake: r,
    minTotalStake: i,
    maxStakeFactor: f
  };
}
Dt.configParse17 = vM;
const GF = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    if (t.loadUint(8) !== 204)
      throw Error("Invalid config");
    const r = t.loadUint(32), i = t.loadUintBig(64), f = t.loadUintBig(64), a = t.loadUintBig(64), l = t.loadUintBig(64);
    return {
      utime_since: r,
      bit_price_ps: i,
      cell_price_ps: f,
      mc_bit_price_ps: a,
      mc_cell_price_ps: l
    };
  }
};
function mM(t) {
  if (!t)
    throw Error("Invalid config");
  return t.loadDictDirect(tn.Dictionary.Keys.Buffer(4), GF).values();
}
Dt.configParse18 = mM;
function gM(t) {
  if (!t)
    return {
      version: 0,
      capabilities: 0n
    };
  const e = t.loadUint(32), r = t.loadUintBig(64);
  return {
    version: e,
    capabilities: r
  };
}
Dt.configParse8 = gM;
function yM(t) {
  if (!t)
    return null;
  if (t.loadUint(8) !== 1)
    throw Error("Invalid config");
  const r = t.loadCoins(), i = t.loadCoins(), f = t.loadUint(16), a = t.loadUint(16), l = t.loadUint(16), d = t.loadUint(16), v = t.loadUint(16), m = t.loadUint(16), h = t.loadUint(16), w = t.loadUint(16), M = t.loadUint(16);
  return {
    defaultFlatFine: r,
    defaultProportionaFine: i,
    severityFlatMult: f,
    severityProportionalMult: a,
    unfunishableInterval: l,
    longInterval: d,
    longFlatMult: v,
    longProportionalMult: m,
    mediumInterval: h,
    mediumFlatMult: w,
    mediumProportionalMult: M
  };
}
Dt.configParse40 = yM;
function QF(t) {
  if (t.loadUint(8) !== 166)
    throw Error("Invalid config");
  const e = t.loadUint(32), r = t.loadUint(8), i = t.loadUint(8), f = t.loadUint(8), a = t.loadBit(), l = t.loadBit(), d = t.loadBit(), v = t.loadUint(13), m = t.loadBuffer(32), h = t.loadBuffer(32), w = t.loadUint(32);
  if (t.loadBit())
    throw Error("Invalid config");
  const M = t.loadUint(32), S = t.loadUintBig(64);
  return {
    enabledSince: e,
    actialMinSplit: r,
    min_split: i,
    max_split: f,
    basic: a,
    active: l,
    accept_msgs: d,
    flags: v,
    zerostateRootHash: m,
    zerostateFileHash: h,
    version: w,
    format: {
      vmVersion: M,
      vmMode: S
    }
  };
}
Dt.configParseWorkchainDescriptor = QF;
const YF = {
  serialize(t, e) {
    throw Error("not implemented");
  },
  parse(t) {
    if (t.loadUint(8) !== 166)
      throw Error("Invalid config");
    const e = t.loadUint(32), r = t.loadUint(8), i = t.loadUint(8), f = t.loadUint(8), a = t.loadBit(), l = t.loadBit(), d = t.loadBit(), v = t.loadUint(13), m = t.loadBuffer(32), h = t.loadBuffer(32), w = t.loadUint(32);
    if (t.loadBit())
      throw Error("Invalid config");
    const M = t.loadUint(32), S = t.loadUintBig(64);
    return {
      enabledSince: e,
      actialMinSplit: r,
      min_split: i,
      max_split: f,
      basic: a,
      active: l,
      accept_msgs: d,
      flags: v,
      zerostateRootHash: m,
      zerostateFileHash: h,
      version: w,
      format: {
        vmVersion: M,
        vmMode: S
      }
    };
  }
};
function bM(t) {
  if (!t)
    throw Error("Invalid config");
  const e = t.loadDict(tn.Dictionary.Keys.Uint(32), YF);
  if (e)
    return e;
  throw Error("No workchains exist");
}
Dt.configParse12 = bM;
function Ba(t) {
  return t ? lM(t) : null;
}
Dt.configParseValidatorSet = Ba;
function xl(t) {
  return t ? cM(t) : null;
}
Dt.configParseBridge = xl;
function JF(t) {
  const e = t.loadUint(8);
  if (e === 222) {
    const r = t.loadUintBig(64), i = t.loadUintBig(64), f = t.loadUintBig(64), a = t.loadUintBig(64), l = t.loadUintBig(64), d = t.loadUintBig(64), v = t.loadUintBig(64);
    return {
      gasPrice: r,
      gasLimit: i,
      specialGasLimit: f,
      gasCredit: a,
      blockGasLimit: l,
      freezeDueLimit: d,
      deleteDueLimit: v
    };
  } else if (e === 221) {
    const r = t.loadUintBig(64), i = t.loadUintBig(64), f = t.loadUintBig(64), a = t.loadUintBig(64), l = t.loadUintBig(64), d = t.loadUintBig(64);
    return {
      gasPrice: r,
      gasLimit: i,
      gasCredit: f,
      blockGasLimit: a,
      freezeDueLimit: l,
      deleteDueLimit: d
    };
  } else
    throw Error("Invalid config");
}
function kv(t) {
  if (!t)
    throw Error("Invalid config");
  if (t.loadUint(8) === 209) {
    const r = t.loadUintBig(64), i = t.loadUintBig(64), f = JF(t);
    return {
      flatLimit: r,
      flatGasPrice: i,
      other: f
    };
  } else
    throw Error("Invalid config");
}
Dt.configParseGasLimitsPrices = kv;
function Tv(t) {
  if (!t)
    throw new Error("Invalid config");
  if (t.loadUint(8) !== 234)
    throw new Error("Invalid msg prices param");
  return {
    lumpPrice: t.loadUintBig(64),
    bitPrice: t.loadUintBig(64),
    cellPrice: t.loadUintBig(64),
    ihrPriceFactor: t.loadUint(32),
    firstFrac: t.loadUint(16),
    nextFrac: t.loadUint(16)
  };
}
Dt.configParseMsgPrices = Tv;
function wM(t) {
  if (!t)
    throw new Error("Invalid config");
  const e = t.loadUint(8);
  if (e === 193) {
    const r = t.loadUint(32), i = t.loadUint(32), f = t.loadUint(32), a = t.loadUint(32);
    return {
      masterCatchainLifetime: r,
      shardCatchainLifetime: i,
      shardValidatorsLifetime: f,
      shardValidatorsCount: a
    };
  }
  if (e === 194) {
    const r = t.loadUint(7), i = t.loadBit(), f = t.loadUint(32), a = t.loadUint(32), l = t.loadUint(32), d = t.loadUint(32);
    return {
      flags: r,
      suffleMasterValidators: i,
      masterCatchainLifetime: f,
      shardCatchainLifetime: a,
      shardValidatorsLifetime: l,
      shardValidatorsCount: d
    };
  }
  throw new Error("Invalid config");
}
Dt.configParse28 = wM;
function _M(t) {
  if (!t)
    throw new Error("Invalid config");
  const e = t.loadUint(8);
  if (e === 214) {
    const r = t.loadUint(32), i = t.loadUint(32), f = t.loadUint(32), a = t.loadUint(32), l = t.loadUint(32), d = t.loadUint(32), v = t.loadUint(32), m = t.loadUint(32);
    return {
      roundCandidates: r,
      nextCandidateDelay: i,
      consensusTimeout: f,
      fastAttempts: a,
      attemptDuration: l,
      catchainMaxDeps: d,
      maxBlockBytes: v,
      maxColaltedBytes: m
    };
  } else if (e === 215) {
    const r = t.loadUint(7), i = t.loadBit(), f = t.loadUint(8), a = t.loadUint(32), l = t.loadUint(32), d = t.loadUint(32), v = t.loadUint(32), m = t.loadUint(32), h = t.loadUint(32), w = t.loadUint(32);
    return {
      flags: r,
      newCatchainIds: i,
      roundCandidates: f,
      nextCandidateDelay: a,
      consensusTimeout: l,
      fastAttempts: d,
      attemptDuration: v,
      catchainMaxDeps: m,
      maxBlockBytes: h,
      maxColaltedBytes: w
    };
  } else if (e === 216) {
    const r = t.loadUint(7), i = t.loadBit(), f = t.loadUint(8), a = t.loadUint(32), l = t.loadUint(32), d = t.loadUint(32), v = t.loadUint(32), m = t.loadUint(32), h = t.loadUint(32), w = t.loadUint(32), M = t.loadUint(16);
    return {
      flags: r,
      newCatchainIds: i,
      roundCandidates: f,
      nextCandidateDelay: a,
      consensusTimeout: l,
      fastAttempts: d,
      attemptDuration: v,
      catchainMaxDeps: m,
      maxBlockBytes: h,
      maxColaltedBytes: w,
      protoVersion: M
    };
  } else if (e === 217) {
    const r = t.loadUint(7), i = t.loadBit(), f = t.loadUint(8), a = t.loadUint(32), l = t.loadUint(32), d = t.loadUint(32), v = t.loadUint(32), m = t.loadUint(32), h = t.loadUint(32), w = t.loadUint(32), M = t.loadUint(16), S = t.loadUint(32);
    return {
      flags: r,
      newCatchainIds: i,
      roundCandidates: f,
      nextCandidateDelay: a,
      consensusTimeout: l,
      fastAttempts: d,
      attemptDuration: v,
      catchainMaxDeps: m,
      maxBlockBytes: h,
      maxColaltedBytes: w,
      protoVersion: M,
      catchainMaxBlocksCoeff: S
    };
  }
  throw new Error("Invalid config");
}
Dt.configParse29 = _M;
function Cv(t) {
  if (t.loadUint(8) !== 54)
    throw new Error("Invalid config");
  const r = t.loadUint(8), i = t.loadUint(8), f = t.loadUint(8), a = t.loadUint(8), l = t.loadUint(32), d = t.loadUint(32), v = t.loadUint(32), m = t.loadUint(32);
  return { minTotalRounds: r, maxTotalRounds: i, minWins: f, maxLoses: a, minStoreSec: l, maxStoreSec: d, bitPrice: v, cellPrice: m };
}
Dt.parseProposalSetup = Cv;
function xM(t) {
  if (!t)
    throw new Error("Invalid config");
  if (t.loadUint(8) !== 145)
    throw new Error("Invalid config");
  const r = Cv(t.loadRef().beginParse()), i = Cv(t.loadRef().beginParse());
  return { normalParams: r, criticalParams: i };
}
Dt.parseVotingSetup = xM;
function MM(t) {
  return tn.Cell.fromBase64(t).beginParse().loadDictDirect(tn.Dictionary.Keys.Int(32), tn.Dictionary.Values.Cell());
}
function XF(t, e) {
  return MM(t).get(e);
}
Dt.loadConfigParamById = XF;
function eq(t) {
  const e = MM(t), r = /* @__PURE__ */ new Map();
  for (const [i, f] of e)
    r.set(i, f.beginParse());
  return r;
}
Dt.loadConfigParamsAsSlice = eq;
function tq(t) {
  return {
    configAddress: Av(t.get(0)),
    electorAddress: Av(t.get(1)),
    minterAddress: Sf(t.get(2)),
    feeCollectorAddress: Sf(t.get(3)),
    dnsRootAddress: Sf(t.get(4)),
    burningConfig: dM(t.get(5)),
    globalVersion: gM(t.get(8)),
    workchains: bM(t.get(12)),
    voting: xM(t.get(11)),
    validators: {
      ...hM(t.get(15)),
      ...pM(t.get(16)),
      ...vM(t.get(17))
    },
    storagePrices: mM(t.get(18)),
    gasPrices: {
      masterchain: kv(t.get(20)),
      workchain: kv(t.get(21))
    },
    msgPrices: {
      masterchain: Tv(t.get(24)),
      workchain: Tv(t.get(25))
    },
    validatorSets: {
      prevValidators: Ba(t.get(32)),
      prevTempValidators: Ba(t.get(33)),
      currentValidators: Ba(t.get(34)),
      currentTempValidators: Ba(t.get(35)),
      nextValidators: Ba(t.get(36)),
      nextTempValidators: Ba(t.get(37))
    },
    validatorsPunish: yM(t.get(40)),
    bridges: {
      ethereum: xl(t.get(71)),
      binance: xl(t.get(72)),
      polygon: xl(t.get(73))
    },
    catchain: wM(t.get(28)),
    consensus: _M(t.get(29))
    // TODO: mint_new_price:Grams mint_add_price:Grams = ConfigParam 6;
    // TODO: to_mint:ExtraCurrencyCollection = ConfigParam 7
    // TODO: mandatory_params:(Hashmap 32 True) = ConfigParam 9
    // TODO: critical_params:(Hashmap 32 True) = ConfigParam 10
    // TODO: BlockCreateFees = ConfigParam 14
  };
}
Dt.parseFullConfig = tq;
var Mn = {};
Object.defineProperty(Mn, "__esModule", { value: !0 });
Mn.computeMessageForwardFees = Mn.computeExternalMessageFees = Mn.computeGasPrices = Mn.computeFwdFees = Mn.computeStorageFees = void 0;
const u1 = At;
function rq(t) {
  const { lastPaid: e, now: r, storagePrices: i, storageStat: f, special: a, masterchain: l } = t;
  if (r <= e || i.length === 0 || r < i[0].utime_since || a)
    return BigInt(0);
  let d = Math.max(e, i[0].utime_since), v = BigInt(0);
  for (let m = 0; m < i.length && d < r; m++) {
    let h = m < i.length - 1 ? Math.min(r, i[m + 1].utime_since) : r, w = BigInt(0);
    if (d < h) {
      let M = h - d;
      w += BigInt(f.cells) * (l ? i[m].mc_cell_price_ps : i[m].cell_price_ps), w += BigInt(f.bits) * (l ? i[m].mc_bit_price_ps : i[m].bit_price_ps), w = w * BigInt(M);
    }
    d = h, v += w;
  }
  return SM(v);
}
Mn.computeStorageFees = rq;
function Lg(t, e, r) {
  return t.lumpPrice + SM(t.bitPrice * r + t.cellPrice * e);
}
Mn.computeFwdFees = Lg;
function nq(t, e) {
  return t <= e.flatLimit ? e.flatPrice : e.flatPrice + (e.price * (t - e.flatLimit) >> 16n);
}
Mn.computeGasPrices = nq;
function iq(t, e) {
  let r = ql(e);
  return r.bits -= e.bits.length, r.cells -= 1, Lg(t, BigInt(r.cells), BigInt(r.bits));
}
Mn.computeExternalMessageFees = iq;
function aq(t, e) {
  let r = (0, u1.loadMessageRelaxed)(e.beginParse()), i = { bits: 0, cells: 0 };
  if (r.init) {
    const v = new u1.Cell().asBuilder();
    (0, u1.storeStateInit)(r.init)(v);
    const m = v.endCell();
    let h = ql(m);
    h.bits -= m.bits.length, h.cells -= 1, i.bits += h.bits, i.cells += h.cells;
  }
  let f = ql(r.body);
  f.bits -= r.body.bits.length, f.cells -= 1, i.bits += f.bits, i.cells += f.cells;
  let a = Lg(t, BigInt(i.cells), BigInt(i.bits)), l = a * BigInt(t.firstFrac) >> 16n, d = a - l;
  return { fees: l, remaining: d };
}
Mn.computeMessageForwardFees = aq;
function ql(t) {
  let e = t.bits.length, r = 1;
  for (let i of t.refs) {
    let f = ql(i);
    r += f.cells, e += f.bits;
  }
  return { bits: e, cells: r };
}
function SM(t) {
  let e = t % 65536n, r = t >> 16n;
  return e !== 0n && (r += 1n), r;
}
(function(t) {
  var e = ut && ut.__createBinding || (Object.create ? function($, ae, he, te) {
    te === void 0 && (te = he);
    var Ee = Object.getOwnPropertyDescriptor(ae, he);
    (!Ee || ("get" in Ee ? !ae.__esModule : Ee.writable || Ee.configurable)) && (Ee = { enumerable: !0, get: function() {
      return ae[he];
    } }), Object.defineProperty($, te, Ee);
  } : function($, ae, he, te) {
    te === void 0 && (te = he), $[te] = ae[he];
  }), r = ut && ut.__exportStar || function($, ae) {
    for (var he in $)
      he !== "default" && !Object.prototype.hasOwnProperty.call(ae, he) && e(ae, $, he);
  };
  Object.defineProperty(t, "__esModule", { value: !0 }), t.computeStorageFees = t.computeMessageForwardFees = t.computeGasPrices = t.computeFwdFees = t.computeExternalMessageFees = t.loadConfigParamsAsSlice = t.loadConfigParamById = t.parseFullConfig = t.parseVotingSetup = t.parseValidatorSet = t.parseProposalSetup = t.parseBridge = t.configParseWorkchainDescriptor = t.configParseValidatorSet = t.configParseMsgPrices = t.configParseMasterAddressRequired = t.configParseMasterAddress = t.configParseGasLimitsPrices = t.configParseBridge = t.configParse40 = t.configParse29 = t.configParse28 = t.configParse18 = t.configParse17 = t.configParse16 = t.configParse15 = t.configParse13 = t.configParse12 = t.configParse8 = t.configParse5 = t.ElectorContract = t.MultisigWallet = t.MultisigOrderBuilder = t.MultisigOrder = t.JettonWallet = t.JettonMaster = t.WalletContractV4 = t.WalletContractV3R2 = t.WalletContractV3R1 = t.WalletContractV2R2 = t.WalletContractV2R1 = t.WalletContractV1R3 = t.WalletContractV1R2 = t.WalletContractV1R1 = t.TonClient4 = t.TonClient = t.HttpApi = void 0, r(At, t);
  var i = au;
  Object.defineProperty(t, "HttpApi", { enumerable: !0, get: function() {
    return i.HttpApi;
  } });
  var f = ed;
  Object.defineProperty(t, "TonClient", { enumerable: !0, get: function() {
    return f.TonClient;
  } });
  var a = td;
  Object.defineProperty(t, "TonClient4", { enumerable: !0, get: function() {
    return a.TonClient4;
  } });
  var l = nd;
  Object.defineProperty(t, "WalletContractV1R1", { enumerable: !0, get: function() {
    return l.WalletContractV1R1;
  } });
  var d = ad;
  Object.defineProperty(t, "WalletContractV1R2", { enumerable: !0, get: function() {
    return d.WalletContractV1R2;
  } });
  var v = sd;
  Object.defineProperty(t, "WalletContractV1R3", { enumerable: !0, get: function() {
    return v.WalletContractV1R3;
  } });
  var m = od;
  Object.defineProperty(t, "WalletContractV2R1", { enumerable: !0, get: function() {
    return m.WalletContractV2R1;
  } });
  var h = fd;
  Object.defineProperty(t, "WalletContractV2R2", { enumerable: !0, get: function() {
    return h.WalletContractV2R2;
  } });
  var w = ud;
  Object.defineProperty(t, "WalletContractV3R1", { enumerable: !0, get: function() {
    return w.WalletContractV3R1;
  } });
  var M = ld;
  Object.defineProperty(t, "WalletContractV3R2", { enumerable: !0, get: function() {
    return M.WalletContractV3R2;
  } });
  var S = cd;
  Object.defineProperty(t, "WalletContractV4", { enumerable: !0, get: function() {
    return S.WalletContractV4;
  } });
  var E = dd;
  Object.defineProperty(t, "JettonMaster", { enumerable: !0, get: function() {
    return E.JettonMaster;
  } });
  var A = hd;
  Object.defineProperty(t, "JettonWallet", { enumerable: !0, get: function() {
    return A.JettonWallet;
  } });
  var B = fu;
  Object.defineProperty(t, "MultisigOrder", { enumerable: !0, get: function() {
    return B.MultisigOrder;
  } });
  var k = pd;
  Object.defineProperty(t, "MultisigOrderBuilder", { enumerable: !0, get: function() {
    return k.MultisigOrderBuilder;
  } });
  var C = vd;
  Object.defineProperty(t, "MultisigWallet", { enumerable: !0, get: function() {
    return C.MultisigWallet;
  } });
  var I = md;
  Object.defineProperty(t, "ElectorContract", { enumerable: !0, get: function() {
    return I.ElectorContract;
  } });
  var O = Dt;
  Object.defineProperty(t, "configParse5", { enumerable: !0, get: function() {
    return O.configParse5;
  } }), Object.defineProperty(t, "configParse8", { enumerable: !0, get: function() {
    return O.configParse8;
  } }), Object.defineProperty(t, "configParse12", { enumerable: !0, get: function() {
    return O.configParse12;
  } }), Object.defineProperty(t, "configParse13", { enumerable: !0, get: function() {
    return O.configParse13;
  } }), Object.defineProperty(t, "configParse15", { enumerable: !0, get: function() {
    return O.configParse15;
  } }), Object.defineProperty(t, "configParse16", { enumerable: !0, get: function() {
    return O.configParse16;
  } }), Object.defineProperty(t, "configParse17", { enumerable: !0, get: function() {
    return O.configParse17;
  } }), Object.defineProperty(t, "configParse18", { enumerable: !0, get: function() {
    return O.configParse18;
  } }), Object.defineProperty(t, "configParse28", { enumerable: !0, get: function() {
    return O.configParse28;
  } }), Object.defineProperty(t, "configParse29", { enumerable: !0, get: function() {
    return O.configParse29;
  } }), Object.defineProperty(t, "configParse40", { enumerable: !0, get: function() {
    return O.configParse40;
  } }), Object.defineProperty(t, "configParseBridge", { enumerable: !0, get: function() {
    return O.configParseBridge;
  } }), Object.defineProperty(t, "configParseGasLimitsPrices", { enumerable: !0, get: function() {
    return O.configParseGasLimitsPrices;
  } }), Object.defineProperty(t, "configParseMasterAddress", { enumerable: !0, get: function() {
    return O.configParseMasterAddress;
  } }), Object.defineProperty(t, "configParseMasterAddressRequired", { enumerable: !0, get: function() {
    return O.configParseMasterAddressRequired;
  } }), Object.defineProperty(t, "configParseMsgPrices", { enumerable: !0, get: function() {
    return O.configParseMsgPrices;
  } }), Object.defineProperty(t, "configParseValidatorSet", { enumerable: !0, get: function() {
    return O.configParseValidatorSet;
  } }), Object.defineProperty(t, "configParseWorkchainDescriptor", { enumerable: !0, get: function() {
    return O.configParseWorkchainDescriptor;
  } }), Object.defineProperty(t, "parseBridge", { enumerable: !0, get: function() {
    return O.parseBridge;
  } }), Object.defineProperty(t, "parseProposalSetup", { enumerable: !0, get: function() {
    return O.parseProposalSetup;
  } }), Object.defineProperty(t, "parseValidatorSet", { enumerable: !0, get: function() {
    return O.parseValidatorSet;
  } }), Object.defineProperty(t, "parseVotingSetup", { enumerable: !0, get: function() {
    return O.parseVotingSetup;
  } }), Object.defineProperty(t, "parseFullConfig", { enumerable: !0, get: function() {
    return O.parseFullConfig;
  } }), Object.defineProperty(t, "loadConfigParamById", { enumerable: !0, get: function() {
    return O.loadConfigParamById;
  } }), Object.defineProperty(t, "loadConfigParamsAsSlice", { enumerable: !0, get: function() {
    return O.loadConfigParamsAsSlice;
  } });
  var q = Mn;
  Object.defineProperty(t, "computeExternalMessageFees", { enumerable: !0, get: function() {
    return q.computeExternalMessageFees;
  } }), Object.defineProperty(t, "computeFwdFees", { enumerable: !0, get: function() {
    return q.computeFwdFees;
  } }), Object.defineProperty(t, "computeGasPrices", { enumerable: !0, get: function() {
    return q.computeGasPrices;
  } }), Object.defineProperty(t, "computeMessageForwardFees", { enumerable: !0, get: function() {
    return q.computeMessageForwardFees;
  } }), Object.defineProperty(t, "computeStorageFees", { enumerable: !0, get: function() {
    return q.computeStorageFees;
  } });
})(dn);
const Bv = new dn.TonClient({
  endpoint: Kk,
  apiKey: Zk
}), sq = async ({
  walletAddr: t,
  tonConnectUI: e,
  receiver: r,
  amount: i
}) => {
  try {
    const f = dn.Address.parse(t), a = dn.Address.parse(e8), l = Bv.open(A7.createFromAddress(a)), { address: d } = await l.getWalletAddress(f), v = k7.buildSendTransferMsg({
      destAddr: dn.Address.parse(r8),
      jettonAmount: i,
      responseAddr: f,
      forwardToncoinAmount: dn.toNano("0.3"),
      forwardPayload: T7.buildBurnPayload({ receiver: r }),
      customPayload: dn.Dictionary.empty()
    });
    await e.sendTransaction({
      validUntil: Date.now() + 1e6,
      messages: [
        {
          address: d.toString(),
          amount: dn.toNano("0.5").toString(),
          payload: v.toBoc().toString("base64")
        }
      ]
    });
  } catch (f) {
    console.log("run `bridge burn action` failed: ", f);
  }
}, oq = async ({
  tonConnectUI: t,
  receiver: e,
  amount: r,
  signature: i,
  externalId: f,
  externalTimestamp: a,
  sender: l
}) => {
  try {
    const d = dn.Address.parse(r8), v = dn.Address.parse(e);
    await t.sendTransaction({
      validUntil: Date.now() + 1e6,
      messages: [
        {
          address: d.toString(),
          amount: dn.toNano("0.5").toString(),
          payload: T7.buildBodyMint({
            mintSig: Je.from(i.slice(2), "hex"),
            mint: {
              id: BigInt(f),
              masterBridge: BigInt(qf),
              time: Number(a),
              sender: BigInt(l),
              amount: BigInt(r),
              receiver: v
            }
          }).toBoc().toString("base64")
        }
      ]
    });
  } catch (d) {
    console.log("run `bridge mint action` failed: ", d);
  }
};
var rn = /* @__PURE__ */ ((t) => (t[t.EnterAmount = 0] = "EnterAmount", t[t.ConfirmTransaction = 1] = "ConfirmTransaction", t[t.ClaimTransaction = 2] = "ClaimTransaction", t[t.SuccessTransaction = 3] = "SuccessTransaction", t))(rn || {});
const fq = async ({
  formData: t,
  allowance: e,
  isAllowanceSuccess: r,
  writeAsyncApprove: i
}) => {
  if (r && e < t.parsedInputValue) {
    const f = S9();
    await i({
      ...f,
      functionName: "approve",
      args: [qf, t.parsedInputValue]
    });
  }
}, uq = async ({
  tonConnectUI: t,
  bridgeTransferAdded: e,
  incompleteTransaction: r
}) => {
  let i = null;
  r ? i = r : i = e.BRIDGE_TRANSFER_ADDED || null, await oq({
    externalId: i.externalId,
    amount: i.amount,
    externalTimestamp: i.pushTxTimestamp,
    signature: i.signature,
    receiver: i.receiverAddr,
    sender: i.senderAddr,
    tonConnectUI: t
  }), await _9(4e4);
}, lq = async ({
  formData: t,
  fromNetworkData: e,
  toNetworkData: r,
  tonConnectUI: i
}) => {
  await sq({
    walletAddr: `${e.address}`,
    tonConnectUI: i,
    receiver: BigInt(r.address),
    amount: t.parsedInputValue
  });
}, cq = async ({
  bridgeTransferAdded: t,
  incompleteTransaction: e,
  writeAsyncUnlock: r
}) => {
  let i = null;
  if (e ? i = e : i = t.BRIDGE_TRANSFER_ADDED || null, i) {
    const f = i.externalId, a = i.signature, l = At.Address.parse(i.senderAddr), d = {
      bridgeAddr: qf,
      receiverAddr: i.receiverAddr,
      senderAddrWorkchain: l.workChain,
      senderAddrHash: BigInt(`0x${l.toRawString().slice(2)}`),
      amount: BigInt(i.amount)
    };
    await wN({
      writeAsync: r,
      externalId: f,
      pullPayloadSignature: a,
      pullPayload: d
    }), await _9(1e4);
  }
}, dq = (t) => {
  if (t.address)
    return (t == null ? void 0 : t.vm) === "TVM" ? At.Address.parse(t.address).toRawString() : t.address.toLowerCase();
}, hq = ({
  formData: t,
  fromNetworkData: e,
  toNetworkData: r,
  incompleteTransaction: i,
  setCurrentStep: f
}) => {
  const [a] = RM(), l = S9(), { data: d, isSuccess: v } = FM({
    ...l,
    functionName: "allowance",
    args: [e.address, qf]
  }), { writeAsync: m, data: h } = gd(
    {}
  ), { writeAsync: w, data: M } = gd({}), { writeAsync: S } = gd({}), { isSuccess: E } = jg({
    hash: h == null ? void 0 : h.hash
  }), { isSuccess: A } = jg({
    hash: M == null ? void 0 : M.hash
  }), { setErrorMessage: B } = im(), [k, C] = Ei(!1), [I, O] = Ei(!1), q = dq(e), { data: $, error: ae } = fT({
    variables: {
      senderAddr: q
    },
    skip: !q
  }), he = async () => {
    const x = At.Address.parse(r.address);
    await _N({
      writeAsync: w,
      amount: t.parsedInputValue,
      receiverAddrHash: BigInt(`0x${x.toRawString().slice(2)}`),
      receiverAddrWorkchain: x.workChain
    }), B("");
  };
  nf(() => {
    E && he();
  }, [E]), nf(() => {
    A && (C(!1), O(!0));
  }, [A]);
  const te = async () => {
    try {
      C(!0), e.vm === "EVM" && (await fq({
        formData: t,
        allowance: d,
        isAllowanceSuccess: v,
        writeAsyncApprove: m
      }), d >= t.parsedInputValue && he()), e.vm === "TVM" && (await lq({
        formData: t,
        fromNetworkData: e,
        toNetworkData: r,
        tonConnectUI: a
      }), B(""));
    } catch (x) {
      console.error(x), O(!1), C(!1), B(
        "Oops, an unknown error has occurred. Please refresh the page and try again."
      );
    }
  }, Ee = async () => {
    try {
      C(!0), e.vm === "EVM" && await uq({
        tonConnectUI: a,
        bridgeTransferAdded: $,
        incompleteTransaction: i
      }), e.vm === "TVM" && await cq({
        bridgeTransferAdded: $,
        incompleteTransaction: i,
        writeAsyncUnlock: S
      }), B(""), f(rn.SuccessTransaction);
    } catch (x) {
      console.error(x), B(
        "Oops, an unknown error has occurred. Please refresh the page and try again."
      );
    } finally {
      C(!1);
    }
  };
  return nf(() => {
    ae && (console.error(ae), B(
      "Oops, an unknown error has occurred. Please refresh the page and try again."
    )), ae || B("");
  }, [ae, B]), nf(() => {
    $ && A && (O(!1), C(!1), f(rn.ClaimTransaction));
  }, [$, A]), {
    transactionLoading: k,
    stampLoading: I,
    handleClaimClick: Ee,
    handleConfirmTransferClick: te
  };
}, pq = ({
  defaultFormData: t,
  fromNetworkData: e,
  toNetworkData: r
}) => {
  const [i, f] = Ei(t), a = zg(() => {
    let d = "0", v = e.balance ?? BigInt(0);
    if (e.decimals && r.decimals && e.balance)
      if (e.decimals > r.decimals) {
        const m = gf(
          // TODO rename
          e.balance,
          e.decimals - r.decimals
        );
        v = c1(
          m,
          e.decimals - r.decimals
        ), d = gf(
          v,
          e.decimals
        );
      } else
        d = d = gf(
          e.balance,
          e.decimals
        );
    f((m) => ({
      ...m,
      inputValue: d,
      parsedInputValue: v,
      convertedInputValue: d
    }));
  }, [e, r]), l = zg(
    (d) => {
      const v = d.target.value;
      if (/^\d*(\.\d*)?$/.test(v)) {
        const [, m, ...h] = v.split(".");
        if (h && h.length)
          f((w) => ({
            ...w
          }));
        else if (r.decimals && (m == null ? void 0 : m.length) > r.decimals)
          f((w) => ({
            ...w
          }));
        else if (e.decimals && e.balance) {
          const w = c1(v, e.decimals);
          w > e.balance ? a() : f((M) => ({
            ...M,
            inputValue: v,
            parsedInputValue: w,
            convertedInputValue: v
          }));
        }
      }
    },
    [e, a, r]
  );
  return { formData: i, setFormData: f, handleMaxClick: a, handleInputChange: l };
}, vq = (t) => /* @__PURE__ */ _r.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ _r.createElement("path", { d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z", fill: "#EDBC04" }), /* @__PURE__ */ _r.createElement("path", { d: "M12.1605 8.31843L14.5693 10.7276C14.6559 10.8143 14.7964 10.8143 14.883 10.7276L16.1527 9.45773C16.2393 9.37112 16.2393 9.23067 16.1527 9.14405L12.1604 5.15094C12.0739 5.06427 11.9333 5.06427 11.8467 5.15094L7.85598 9.1426C7.76936 9.22922 7.76936 9.36966 7.85598 9.45628L9.12561 10.7262C9.21223 10.8128 9.35273 10.8128 9.43934 10.7262L11.8467 8.31843C11.9334 8.23175 12.0739 8.23175 12.1605 8.31843Z", fill: "white" }), /* @__PURE__ */ _r.createElement("path", { d: "M6.42058 10.5728L5.1509 11.8427C5.06428 11.9293 5.06428 12.0698 5.1509 12.1564L6.42048 13.4264C6.50709 13.513 6.6476 13.513 6.73422 13.4264L8.0039 12.1564C8.09052 12.0698 8.09052 11.9293 8.0039 11.8427L6.73426 10.5728C6.64771 10.4862 6.50726 10.4862 6.42058 10.5728Z", fill: "white" }), /* @__PURE__ */ _r.createElement("path", { d: "M12.1567 18.8527L16.1496 14.8589C16.2363 14.7722 16.2363 14.6317 16.1495 14.5451L14.8792 13.2758C14.7925 13.1893 14.6521 13.1893 14.5655 13.2759L12.1567 15.6851C12.0701 15.7718 11.9296 15.7718 11.843 15.6851L9.43538 13.2771C9.34882 13.1906 9.20853 13.1905 9.12187 13.2769L7.85035 14.5452C7.76352 14.6318 7.76341 14.7723 7.85013 14.8591L11.843 18.8526C11.9296 18.9392 12.0701 18.9392 12.1567 18.8527Z", fill: "white" }), /* @__PURE__ */ _r.createElement("path", { d: "M17.2624 10.5728L15.9927 11.8427C15.9061 11.9293 15.9061 12.0698 15.9927 12.1564L17.2623 13.4263C17.349 13.513 17.4895 13.513 17.5761 13.4263L18.8457 12.1564C18.9324 12.0697 18.9324 11.9293 18.8457 11.8427L17.5761 10.5728C17.4895 10.4862 17.3491 10.4862 17.2624 10.5728Z", fill: "white" }), /* @__PURE__ */ _r.createElement("path", { d: "M13.4525 11.8434L12.1588 10.5494C12.0721 10.4627 11.9316 10.4627 11.845 10.5494L10.5513 11.8434C10.4647 11.93 10.4647 12.0705 10.5513 12.1571L11.845 13.4512C11.9316 13.5378 12.0721 13.5378 12.1588 13.4512L13.4525 12.1571C13.5391 12.0704 13.5391 11.93 13.4525 11.8434Z", fill: "white" })), mq = () => {
  const { address: t, isConnected: e } = k5(), { data: r } = qM({
    address: t,
    token: t8,
    watch: !0
  });
  return {
    isConnected: e,
    name: "BNB",
    vm: "EVM",
    iconComponent: vq,
    balance: r == null ? void 0 : r.value,
    decimals: r == null ? void 0 : r.decimals,
    symbol: r == null ? void 0 : r.symbol,
    address: t
  };
}, gq = (t) => /* @__PURE__ */ _r.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ _r.createElement("rect", { width: 24, height: 24, rx: 12, fill: "#2FA8FF" }), /* @__PURE__ */ _r.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M7.64216 6.39849L16.4252 6.39844C16.7359 6.39844 17.0464 6.44407 17.3709 6.59536C17.7599 6.77667 17.9661 7.06246 18.1106 7.27381C18.1219 7.29025 18.1324 7.30719 18.1421 7.32453C18.312 7.62698 18.3996 7.95354 18.3996 8.30482C18.3996 8.63859 18.3202 9.00223 18.1421 9.31917C18.1404 9.32224 18.1387 9.32521 18.137 9.32823L12.588 18.8601C12.4656 19.0704 12.2404 19.1993 11.9972 19.1984C11.754 19.1976 11.5296 19.067 11.4088 18.8559L5.96172 9.34439C5.96016 9.34182 5.95859 9.33924 5.95702 9.33662C5.83236 9.1312 5.63958 8.81353 5.60586 8.40359C5.57487 8.02658 5.6596 7.64885 5.84903 7.32134C6.03845 6.99378 6.32363 6.73193 6.66663 6.57164C7.0344 6.39978 7.4071 6.39849 7.64216 6.39849ZM11.3187 7.76015H7.64216C7.40061 7.76015 7.30788 7.77502 7.24306 7.80534C7.15341 7.84717 7.07814 7.91601 7.0278 8.00304C6.97747 8.09012 6.95471 8.19101 6.96298 8.29201C6.96774 8.3499 6.99134 8.41611 7.13054 8.64569C7.13345 8.6505 7.1363 8.65537 7.1391 8.66023L11.3187 15.9586V7.76015ZM12.6805 7.76015V15.9947L16.9569 8.64866C17.0052 8.56096 17.0379 8.43423 17.0379 8.30482C17.0379 8.19984 17.0161 8.10868 16.9675 8.01473C16.9164 7.94129 16.8853 7.90243 16.8593 7.8758C16.837 7.85304 16.8198 7.84085 16.7956 7.82955C16.6945 7.78241 16.591 7.76015 16.4252 7.76015H12.6805Z", fill: "#EEF9FC" })), yq = async ({
  userAddress: t,
  jAddress: e
}) => {
  try {
    const r = dn.Address.parse(t), i = Bv.open(A7.createFromAddress(dn.Address.parse(e))), { address: f } = await i.getWalletAddress(r);
    return {
      data: (await Bv.open(k7.createFromAddress(f)).getBalance()).amount || BigInt(0)
    };
  } catch (r) {
    return {
      error: {
        status: 418,
        statusText: "something went wrong",
        data: r == null ? void 0 : r.toString()
      }
    };
  }
}, bq = () => {
  const t = A5(), e = PM(), { data: r } = zM({
    queryFn: () => yq({
      userAddress: t,
      jAddress: e8
    }),
    queryKey: [t],
    refetchInterval: 5e3
  });
  return {
    isConnected: !!e,
    address: t,
    name: "TON",
    vm: "TVM",
    iconComponent: gq,
    balance: r == null ? void 0 : r.data,
    decimals: 18,
    symbol: "GGR"
  };
}, wq = () => {
  const [t, e] = Ei(Vk), r = mq(), i = bq(), f = () => {
    e((a) => a === "EVM" ? "TON" : "EVM");
  };
  return {
    fromNetworkData: t == "EVM" ? r : i,
    toNetworkData: t == "EVM" ? i : r,
    handleSwitchNetworksClick: f
  };
}, _q = {
  inputValue: "",
  parsedInputValue: BigInt(0),
  convertedInputValue: "",
  recipientAddress: void 0,
  senderAddress: void 0
};
var EM = { exports: {} };
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
(function(t) {
  (function() {
    var e = {}.hasOwnProperty;
    function r() {
      for (var a = "", l = 0; l < arguments.length; l++) {
        var d = arguments[l];
        d && (a = f(a, i(d)));
      }
      return a;
    }
    function i(a) {
      if (typeof a == "string" || typeof a == "number")
        return a;
      if (typeof a != "object")
        return "";
      if (Array.isArray(a))
        return r.apply(null, a);
      if (a.toString !== Object.prototype.toString && !a.toString.toString().includes("[native code]"))
        return a.toString();
      var l = "";
      for (var d in a)
        e.call(a, d) && a[d] && (l = f(l, d));
      return l;
    }
    function f(a, l) {
      return l ? a ? a + " " + l : a + l : a;
    }
    t.exports ? (r.default = r, t.exports = r) : window.classNames = r;
  })();
})(EM);
var xq = EM.exports;
const hs = /* @__PURE__ */ R5(xq), Fg = (t) => /* @__PURE__ */ _r.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ _r.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M1.0625 12.6459C1.54704 16.0601 4.53595 18.2671 8.29387 18.4672C4.9682 18.59 2.38085 17.6918 1.66233 15.8955C1.65384 15.8742 1.64512 15.8527 1.63618 15.8309C1.03177 16.9603 0.883491 18.0317 1.30124 18.9206C2.53994 21.5564 8.28638 21.5887 14.1363 18.9929C16.8544 17.7868 19.1166 16.2254 20.6355 14.6349C19.838 13.9942 19.3298 13.0255 19.3298 11.9414C19.3298 10.0122 20.9393 8.44818 22.9248 8.44818C22.9367 8.44818 22.9486 8.44824 22.9605 8.44835C21.4408 4.11714 17.2178 1.00195 12.246 1.00195C8.24604 1.00195 4.73071 3.01839 2.71791 6.06223C2.08118 7.17388 1.5897 8.18912 1.29328 9.21955C1.1725 9.6702 1.0804 10.1321 1.01898 10.6033C0.949332 11.2519 0.960098 11.9244 1.0625 12.6459ZM23.0004 15.4339C22.9753 15.4344 22.9501 15.4347 22.9248 15.4347C22.4018 15.4347 21.9048 15.3262 21.4565 15.131C19.5631 17.3402 16.8047 19.5131 13.5109 20.9747C11.8544 21.7098 10.2844 22.1933 8.81902 22.4829C9.90006 22.8163 11.0514 22.9962 12.246 22.9962C17.262 22.9962 21.5158 19.8253 23.0004 15.4339ZM15.0671 17.0297C14.0449 17.4157 13.0253 17.7225 12.0303 17.9526C8.63035 17.9465 5.87609 15.2642 5.87609 11.9562C5.87609 8.72947 8.49662 6.09803 11.7808 5.96497L11.7818 5.96055C14.2806 5.89204 16.0175 6.14201 16.6771 6.28026V8.36701C15.8583 8.18432 13.4798 7.94533 11.8142 8.03449L11.8143 8.03751C9.69225 8.14259 8.00487 9.84923 8.00487 11.9392C8.00487 14.0968 9.80339 15.846 12.022 15.846L12.0333 15.8459V15.8414C13.477 15.8414 14.4331 15.7608 15.0561 15.6675V12.8918L17.1882 12.2973L17.1882 16.0842C17.5273 15.9211 17.8599 15.7525 18.1851 15.5791C17.2091 16.1247 16.1617 16.6164 15.0671 17.0297Z", fill: "#3C5BFC" })), Mq = "_typography_iuw1x_1", Sq = "_regular_iuw1x_5", Eq = "_medium_iuw1x_9", Aq = "_semiBold_iuw1x_13", kq = "_bold_iuw1x_17", Tq = "_heading1_iuw1x_21", Cq = "_heading2_iuw1x_27", Bq = "_heading3_iuw1x_32", Iq = "_heading4_iuw1x_37", Rq = "_paragraph1_iuw1x_43", Pq = "_paragraph2_iuw1x_48", Oq = "_paragraph3_iuw1x_54", Nq = "_paragraph4_iuw1x_59", Dq = "_paragraph5_iuw1x_65", Vr = {
  typography: Mq,
  regular: Sq,
  medium: Eq,
  semiBold: Aq,
  bold: kq,
  heading1: Tq,
  heading2: Cq,
  heading3: Bq,
  heading4: Iq,
  paragraph1: Rq,
  paragraph2: Pq,
  paragraph3: Oq,
  paragraph4: Nq,
  paragraph5: Dq
}, y5 = {
  heading1: Vr.heading1,
  heading2: Vr.heading2,
  heading3: Vr.heading3,
  heading4: Vr.heading4,
  paragraph1: Vr.paragraph1,
  paragraph2: Vr.paragraph2,
  paragraph3: Vr.paragraph3,
  paragraph4: Vr.paragraph4,
  paragraph5: Vr.paragraph5
}, b5 = {
  bold: Vr.bold,
  regular: Vr.regular,
  medium: Vr.medium,
  semiBold: Vr.semiBold
}, Uq = ({
  className: t,
  children: e,
  variant: r,
  weight: i = "regular",
  component: f,
  withHTML: a = !1,
  ...l
}) => {
  const d = f || "p";
  return a ? /* @__PURE__ */ tt.jsx(
    d,
    {
      ...l,
      dangerouslySetInnerHTML: { __html: e },
      className: hs(
        Vr.typography,
        b5[i],
        y5[r],
        t
      )
    }
  ) : /* @__PURE__ */ tt.jsx(
    d,
    {
      ...l,
      className: hs(
        Vr.typography,
        b5[i],
        y5[r],
        t
      ),
      children: e
    }
  );
}, Or = nr.memo(Uq), Lq = "_info_1gpce_1", Fq = "_title_1gpce_6", qq = "_inner_1gpce_10", zq = "_icon_1gpce_17", jq = "_value_1gpce_22", Jo = {
  info: Lq,
  title: Fq,
  inner: qq,
  icon: zq,
  value: jq
}, $q = ({ value: t, symbol: e }) => /* @__PURE__ */ tt.jsxs("div", { className: Jo.info, children: [
  /* @__PURE__ */ tt.jsx(Or, { className: Jo.title, variant: "paragraph4", weight: "medium", children: "Amount" }),
  /* @__PURE__ */ tt.jsxs("div", { className: Jo.inner, children: [
    /* @__PURE__ */ tt.jsx(Fg, { className: Jo.icon }),
    /* @__PURE__ */ tt.jsxs(
      Or,
      {
        className: Jo.value,
        variant: "paragraph3",
        weight: "regular",
        children: [
          t,
          " ",
          e
        ]
      }
    )
  ] })
] }), AM = nr.memo($q), Vq = "_button_hjfzv_1", Hq = "_secondary_hjfzv_24", Wq = "_buttonDisabled_hjfzv_28", Kq = "_startAdornment_hjfzv_32", Zq = "_endAdornment_hjfzv_38", Us = {
  button: Vq,
  default: "_default_hjfzv_20",
  secondary: Hq,
  buttonDisabled: Wq,
  startAdornment: Kq,
  endAdornment: Zq
}, Gq = {
  default: Us.default,
  secondary: Us.secondary
}, Qq = ({
  className: t,
  children: e,
  type: r = "button",
  variant: i = "default",
  startAdornment: f,
  endAdornment: a,
  disabled: l,
  onClick: d
}) => /* @__PURE__ */ tt.jsxs(
  "button",
  {
    className: hs(
      Us.button,
      {
        [Us.buttonDisabled]: l
      },
      Gq[i],
      t
    ),
    type: r,
    disabled: l,
    onClick: d,
    children: [
      f && /* @__PURE__ */ tt.jsx("span", { className: Us.startAdornment, children: f }),
      e,
      a && /* @__PURE__ */ tt.jsx("span", { className: Us.endAdornment, children: a })
    ]
  }
), io = nr.memo(Qq), Yq = "_info_1gpce_1", Jq = "_title_1gpce_6", Xq = "_inner_1gpce_10", ez = "_icon_1gpce_17", tz = "_value_1gpce_22", Xo = {
  info: Yq,
  title: Jq,
  inner: Xq,
  icon: ez,
  value: tz
}, rz = ({
  title: t,
  address: e,
  addressIcon: r
}) => /* @__PURE__ */ tt.jsxs("div", { className: Xo.info, children: [
  /* @__PURE__ */ tt.jsx(Or, { className: Xo.title, variant: "paragraph4", weight: "medium", children: t }),
  /* @__PURE__ */ tt.jsxs("div", { className: Xo.inner, children: [
    /* @__PURE__ */ tt.jsx(r, { className: Xo.icon }),
    /* @__PURE__ */ tt.jsx(
      Or,
      {
        className: Xo.value,
        variant: "paragraph3",
        weight: "regular",
        children: e
      }
    )
  ] })
] }), Iv = nr.memo(rz), nz = "_step_1r0nd_1", iz = "_inner_1r0nd_6", az = "_actions_1r0nd_12", sz = "_action_1r0nd_12", ef = {
  step: nz,
  inner: iz,
  actions: az,
  action: sz
}, oz = ({
  formData: t,
  toNetworkData: e,
  onClaimClick: r,
  onCancelClick: i
}) => /* @__PURE__ */ tt.jsxs("div", { className: ef.step, children: [
  /* @__PURE__ */ tt.jsxs("div", { className: ef.inner, children: [
    /* @__PURE__ */ tt.jsx(AM, { value: t.inputValue, symbol: e.symbol }),
    /* @__PURE__ */ tt.jsx(
      Iv,
      {
        title: "For wallet",
        address: Il(e.address, 6),
        addressIcon: e.iconComponent
      }
    )
  ] }),
  /* @__PURE__ */ tt.jsxs("div", { className: ef.actions, children: [
    /* @__PURE__ */ tt.jsx(io, { className: ef.action, onClick: r, children: "Claim" }),
    /* @__PURE__ */ tt.jsx(
      io,
      {
        className: ef.action,
        variant: "secondary",
        onClick: i,
        children: "Cancel"
      }
    )
  ] })
] }), fz = nr.memo(oz), uz = "_root_5tzs8_1", lz = "_items_5tzs8_6", cz = "_actions_5tzs8_12", dz = "_action_5tzs8_12", hz = "_actionIcon_5tzs8_25", xs = {
  root: uz,
  items: lz,
  actions: cz,
  action: dz,
  actionIcon: hz
}, pz = ({
  formData: t,
  fromNetworkData: e,
  toNetworkData: r,
  onTransferClick: i,
  onCancelClick: f
}) => {
  const a = e.iconComponent, l = r.iconComponent;
  return /* @__PURE__ */ tt.jsxs("div", { className: xs.root, children: [
    /* @__PURE__ */ tt.jsxs("div", { className: xs.items, children: [
      /* @__PURE__ */ tt.jsx(
        AM,
        {
          value: t.inputValue,
          symbol: e.symbol
        }
      ),
      /* @__PURE__ */ tt.jsx(
        Iv,
        {
          title: "From",
          address: Il(e.address, 6),
          addressIcon: a
        }
      ),
      /* @__PURE__ */ tt.jsx(
        Iv,
        {
          title: "To",
          address: Il(r.address, 6),
          addressIcon: l
        }
      )
    ] }),
    /* @__PURE__ */ tt.jsxs("div", { className: xs.actions, children: [
      /* @__PURE__ */ tt.jsx(
        io,
        {
          className: xs.action,
          startAdornment: /* @__PURE__ */ tt.jsx(a, { className: xs.actionIcon }),
          onClick: i,
          children: "Transfer"
        }
      ),
      /* @__PURE__ */ tt.jsx(
        io,
        {
          className: xs.action,
          variant: "secondary",
          onClick: f,
          children: "Cancel"
        }
      )
    ] })
  ] });
}, vz = nr.memo(pz), mz = "_input_1fgkd_1", gz = "_field_1fgkd_11", yz = "_startAdornment_1fgkd_24", bz = "_endAdornment_1fgkd_30", Nu = {
  input: mz,
  field: gz,
  startAdornment: yz,
  endAdornment: bz
}, wz = ({
  className: t,
  readOnly: e,
  placeholder: r,
  value: i,
  startAdornment: f,
  endAdornment: a,
  onChange: l
}) => /* @__PURE__ */ tt.jsxs("div", { className: hs(Nu.input, t), children: [
  f && /* @__PURE__ */ tt.jsx("span", { className: Nu.startAdornment, children: f }),
  /* @__PURE__ */ tt.jsx(
    "input",
    {
      className: Nu.field,
      type: "text",
      placeholder: r,
      readOnly: e,
      value: i,
      onChange: l
    }
  ),
  a && /* @__PURE__ */ tt.jsx("span", { className: Nu.endAdornment, children: a })
] }), _z = nr.memo(wz), xz = "_button_c3zg3_1", Mz = "_text_c3zg3_16", w5 = {
  button: xz,
  text: Mz
}, Sz = ({ className: t, onClick: e }) => /* @__PURE__ */ tt.jsx("div", { className: hs(w5.button, t), onClick: e, children: /* @__PURE__ */ tt.jsx(Or, { className: w5.text, variant: "paragraph5", weight: "semiBold", children: "MAX" }) }), Ez = nr.memo(Sz), Az = "_container_196n6_1", kz = "_input_196n6_5", _5 = {
  container: Az,
  input: kz
}, Tz = ({ value: t }) => /* @__PURE__ */ tt.jsx("div", { className: _5.container, children: /* @__PURE__ */ tt.jsx(
  "input",
  {
    className: _5.input,
    readOnly: !0,
    type: "text",
    value: t ? `${t == null ? void 0 : t.substring(0, 5)}...${t == null ? void 0 : t.substring(
      t.length - 4
    )}` : ""
  }
) }), Cz = nr.memo(Tz), Bz = ({ networkData: t, ...e }) => {
  switch (t.name) {
    case "BNB":
      return /* @__PURE__ */ tt.jsx(VM, { ...e, label: "Connect wallet" });
    case "TON":
      return /* @__PURE__ */ tt.jsx(OM, { ...e });
    default:
      return null;
  }
}, Iz = nr.memo(Bz), Rz = "_exchangeSection_5txqp_1", Pz = "_exchangeSectionConnect_5txqp_8", Oz = "_networkInfo_5txqp_15", Nz = "_networkIcon_5txqp_20", Dz = "_networkName_5txqp_26", tf = {
  exchangeSection: Rz,
  exchangeSectionConnect: Pz,
  networkInfo: Oz,
  networkIcon: Nz,
  networkName: Dz
}, Uz = ({ networkData: t }) => {
  if (!t.isConnected)
    return /* @__PURE__ */ tt.jsx("div", { className: tf.exchangeSectionConnect, children: /* @__PURE__ */ tt.jsx(Iz, { networkData: t }) });
  const e = t.iconComponent;
  return /* @__PURE__ */ tt.jsxs("div", { className: tf.exchangeSection, children: [
    /* @__PURE__ */ tt.jsx(Cz, { value: t.address }),
    /* @__PURE__ */ tt.jsxs("div", { className: tf.networkInfo, children: [
      /* @__PURE__ */ tt.jsx(e, { className: tf.networkIcon }),
      /* @__PURE__ */ tt.jsx(Or, { variant: "paragraph3", className: tf.networkName, children: t.name })
    ] })
  ] });
}, x5 = nr.memo(Uz), Lz = (t) => /* @__PURE__ */ _r.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ _r.createElement("path", { d: "M6.5 8L18 8M18 8L14.85 5M18 8L14.85 11", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" }), /* @__PURE__ */ _r.createElement("path", { d: "M17.5 16L6 16M6 16L9.15001 13M6 16L9.15 19", stroke: "currentColor", strokeWidth: 1.5, strokeLinecap: "round", strokeLinejoin: "round" })), Fz = "_toggler_he8ct_1", qz = "_switchIcon_he8ct_12", M5 = {
  toggler: Fz,
  switchIcon: qz
}, zz = ({
  onSwitchNetworksClick: t
}) => /* @__PURE__ */ tt.jsx("div", { className: M5.toggler, onClick: t, children: /* @__PURE__ */ tt.jsx(Lz, { className: M5.switchIcon }) }), jz = nr.memo(zz), $z = "_panel_9vrhy_1", Vz = "_walletSectionContainer_9vrhy_6", Hz = "_togglerContainer_9vrhy_10", Wz = "_addressLabel_9vrhy_17", Ni = {
  panel: $z,
  walletSectionContainer: Vz,
  togglerContainer: Hz,
  addressLabel: Wz
}, Kz = ({
  fromNetworkData: t,
  toNetworkData: e,
  onSwitchNetworksClick: r
}) => /* @__PURE__ */ tt.jsxs("div", { className: Ni.panel, children: [
  /* @__PURE__ */ tt.jsxs("div", { className: Ni.panelSection, children: [
    /* @__PURE__ */ tt.jsx(
      Or,
      {
        weight: "medium",
        variant: "paragraph4",
        className: Ni.addressLabel,
        children: "From"
      }
    ),
    /* @__PURE__ */ tt.jsx("div", { className: Ni.walletSectionContainer, children: /* @__PURE__ */ tt.jsx(x5, { networkData: t }) })
  ] }),
  /* @__PURE__ */ tt.jsx("div", { className: Ni.togglerContainer, children: /* @__PURE__ */ tt.jsx(jz, { onSwitchNetworksClick: r }) }),
  /* @__PURE__ */ tt.jsxs("div", { className: Ni.panelSection, children: [
    /* @__PURE__ */ tt.jsx(
      Or,
      {
        weight: "medium",
        variant: "paragraph4",
        className: Ni.addressLabel,
        children: "To"
      }
    ),
    /* @__PURE__ */ tt.jsx("div", { className: Ni.walletSectionContainer, children: /* @__PURE__ */ tt.jsx(x5, { networkData: e }) })
  ] })
] }), Zz = nr.memo(Kz), Gz = "_inputInfo_1grl0_1", Qz = "_amountText_1grl0_9", Yz = "_balanceText_1grl0_13", Jz = "_input_1grl0_1", Xz = "_inputIcon_1grl0_21", ej = "_action_1grl0_26", tj = "_actionIcon_1grl0_30", Ea = {
  inputInfo: Gz,
  amountText: Qz,
  balanceText: Yz,
  input: Jz,
  inputIcon: Xz,
  action: ej,
  actionIcon: tj
}, rj = ({
  formData: t,
  fromNetworkData: e,
  toNetworkData: r,
  onInputChange: i,
  onMaxClick: f,
  onTransferClick: a,
  onSwitchNetworksClick: l
}) => {
  const d = e.iconComponent;
  return /* @__PURE__ */ tt.jsxs(tt.Fragment, { children: [
    /* @__PURE__ */ tt.jsx(
      Zz,
      {
        onSwitchNetworksClick: l,
        fromNetworkData: e,
        toNetworkData: r
      }
    ),
    /* @__PURE__ */ tt.jsxs("div", { className: Ea.inputInfo, children: [
      /* @__PURE__ */ tt.jsx(
        Or,
        {
          className: Ea.amountText,
          variant: "paragraph4",
          weight: "medium",
          children: "Total Amount"
        }
      ),
      /* @__PURE__ */ tt.jsxs(
        Or,
        {
          className: Ea.balanceText,
          variant: "paragraph4",
          weight: "medium",
          children: [
            "Balance:",
            " ",
            Number(
              gf(
                (e == null ? void 0 : e.balance) ?? BigInt(0),
                (e == null ? void 0 : e.decimals) ?? 0
              )
            ).toFixed(3),
            " ",
            e.symbol
          ]
        }
      )
    ] }),
    /* @__PURE__ */ tt.jsx(
      _z,
      {
        className: Ea.input,
        value: t.inputValue,
        placeholder: `The amount ${e.symbol ? "of " + e.symbol : ""}`,
        startAdornment: /* @__PURE__ */ tt.jsx(Fg, { className: Ea.inputIcon }),
        endAdornment: /* @__PURE__ */ tt.jsx(Ez, { onClick: f }),
        onChange: i
      }
    ),
    /* @__PURE__ */ tt.jsxs(
      io,
      {
        className: Ea.action,
        startAdornment: /* @__PURE__ */ tt.jsx(d, { className: Ea.actionIcon }),
        onClick: a,
        children: [
          "Transfer ",
          e.symbol
        ]
      }
    )
  ] });
}, nj = nr.memo(rj), kM = (t) => /* @__PURE__ */ _r.createElement("svg", { viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ _r.createElement("rect", { x: 4.34326, y: 2.65686, width: 18, height: 2, transform: "rotate(45 4.34326 2.65686)", fill: "currentColor" }), /* @__PURE__ */ _r.createElement("rect", { x: 17.071, y: 4.07104, width: 18, height: 2, transform: "rotate(135 17.071 4.07104)", fill: "currentColor" })), ij = "_status_1ctcr_1", aj = "_overlay_1ctcr_16", sj = "_inner_1ctcr_27", oj = "_close_1ctcr_35", fj = "_closeIcon_1ctcr_55", rf = {
  status: ij,
  overlay: aj,
  inner: sj,
  close: oj,
  closeIcon: fj
}, uj = ({
  children: t,
  withCloseIcon: e = !0,
  onCloseClick: r
}) => /* @__PURE__ */ tt.jsxs("div", { className: rf.status, children: [
  /* @__PURE__ */ tt.jsx("div", { className: rf.overlay }),
  e && /* @__PURE__ */ tt.jsx("div", { className: rf.close, onClick: r, children: /* @__PURE__ */ tt.jsx(kM, { className: rf.closeIcon }) }),
  /* @__PURE__ */ tt.jsx("div", { className: rf.inner, children: t })
] }), qg = nr.memo(uj), lj = "_text_172s7_1", cj = {
  text: lj
}, dj = ({
  errorMessage: t,
  onCloseClick: e
}) => /* @__PURE__ */ tt.jsx(qg, { onCloseClick: e, children: /* @__PURE__ */ tt.jsx(Or, { variant: "paragraph3", weight: "semiBold", className: cj.text, children: t }) }), hj = nr.memo(dj), pj = ({
  setCurrentStep: t
}) => {
  const { errorMessage: e, setErrorMessage: r } = im(), i = () => {
    r(""), t(rn.EnterAmount);
  };
  return /* @__PURE__ */ tt.jsx(
    hj,
    {
      errorMessage: e,
      onCloseClick: i
    }
  );
}, vj = nr.memo(pj), mj = "_incompleteTransaction_1g8ef_1", gj = "_incompleteTransactionContent_1g8ef_14", yj = "_subTitle_1g8ef_23", bj = "_continueButton_1g8ef_27", wj = "_close_1g8ef_31", _j = "_closeIcon_1g8ef_50", Du = {
  incompleteTransaction: mj,
  incompleteTransactionContent: gj,
  subTitle: yj,
  continueButton: bj,
  close: wj,
  closeIcon: _j
}, xj = ({
  onContinueClick: t
}) => /* @__PURE__ */ tt.jsx("div", { className: Du.incompleteTransaction, children: /* @__PURE__ */ tt.jsxs("div", { className: Du.incompleteTransactionContent, children: [
  /* @__PURE__ */ tt.jsx(
    Or,
    {
      variant: "paragraph2",
      weight: "semiBold",
      className: Du.subTitle,
      children: "You have an incomplete transaction"
    }
  ),
  /* @__PURE__ */ tt.jsx(io, { onClick: t, className: Du.continueButton, children: "Continue" })
] }) }), Mj = nr.memo(xj), Sj = "_loader_ga1u1_1", Ej = "_loaderAnimation_ga1u1_1", Aj = {
  loader: Sj,
  loaderAnimation: Ej
}, kj = ({ className: t }) => /* @__PURE__ */ tt.jsx("div", { className: hs(Aj.loader, t) }), TM = nr.memo(kj), Tj = "_text_17crq_1", Cj = "_loader_17crq_5", S5 = {
  text: Tj,
  loader: Cj
}, Bj = () => /* @__PURE__ */ tt.jsxs(qg, { withCloseIcon: !1, children: [
  /* @__PURE__ */ tt.jsx(Or, { className: S5.text, variant: "paragraph3", weight: "semiBold", children: "Waiting for a transaction" }),
  /* @__PURE__ */ tt.jsx(TM, { className: S5.loader })
] }), Ij = nr.memo(Bj), CM = (t) => /* @__PURE__ */ _r.createElement("svg", { viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...t }, /* @__PURE__ */ _r.createElement("rect", { width: 24, height: 24, rx: 12, fill: "#10A842" }), /* @__PURE__ */ _r.createElement("path", { d: "M8 12.3633L10.7273 15.0906L17.0909 8.72692", stroke: "#F2FCFF", strokeWidth: 2, strokeLinecap: "round", strokeLinejoin: "round" })), Rj = "_icon_19tiz_1", Pj = "_title_19tiz_6", Oj = "_loader_19tiz_13", l1 = {
  icon: Rj,
  title: Pj,
  loader: Oj
}, Nj = () => /* @__PURE__ */ tt.jsxs(qg, { withCloseIcon: !1, children: [
  /* @__PURE__ */ tt.jsx(CM, { className: l1.icon }),
  /* @__PURE__ */ tt.jsx(Or, { className: l1.title, variant: "paragraph3", weight: "semiBold", children: "The transaction has been successfully sent, expect a stamp" }),
  /* @__PURE__ */ tt.jsx(TM, { className: l1.loader })
] }), Dj = nr.memo(Nj), Uj = "_step_141le_1", Lj = "_icon_141le_7", Fj = "_title_141le_12", qj = "_items_141le_19", zj = "_item_141le_19", jj = "_itemIcon_141le_33", $j = "_itemValue_141le_38", Vj = "_close_141le_44", Hj = "_closeIcon_141le_63", wn = {
  step: Uj,
  icon: Lj,
  title: Fj,
  items: qj,
  item: zj,
  itemIcon: jj,
  itemValue: $j,
  close: Vj,
  closeIcon: Hj
}, Wj = ({
  formData: t,
  toNetworkData: e,
  onCloseClick: r
}) => {
  const i = e.iconComponent;
  return /* @__PURE__ */ tt.jsxs("div", { className: wn.step, children: [
    /* @__PURE__ */ tt.jsx("div", { className: wn.close, onClick: r, children: /* @__PURE__ */ tt.jsx(kM, { className: wn.closeIcon }) }),
    /* @__PURE__ */ tt.jsx(CM, { className: wn.icon }),
    /* @__PURE__ */ tt.jsx(
      Or,
      {
        className: wn.title,
        variant: "paragraph3",
        weight: "semiBold",
        children: "You have successfully transferred the tokens"
      }
    ),
    /* @__PURE__ */ tt.jsxs("div", { className: wn.items, children: [
      /* @__PURE__ */ tt.jsxs("div", { className: wn.item, children: [
        /* @__PURE__ */ tt.jsx(Fg, { className: wn.itemIcon }),
        /* @__PURE__ */ tt.jsxs(Or, { className: wn.itemValue, variant: "paragraph3", children: [
          t.inputValue,
          " ",
          e.symbol
        ] })
      ] }),
      /* @__PURE__ */ tt.jsxs("div", { className: wn.item, children: [
        /* @__PURE__ */ tt.jsx(i, { className: wn.itemIcon }),
        /* @__PURE__ */ tt.jsx(Or, { className: wn.itemValue, variant: "paragraph3", children: Il(e.address, 3) })
      ] })
    ] })
  ] });
}, Kj = nr.memo(Wj), Zj = "_swapper_25khg_1", Gj = "_swapperSuccess_25khg_17", Qj = "_inputInfo_25khg_22", Yj = "_amountText_25khg_30", Jj = "_balanceText_25khg_34", Xj = "_input_25khg_22", e$ = "_inputIcon_25khg_42", t$ = "_action_25khg_47", r$ = "_actionIcon_25khg_51", E5 = {
  swapper: Zj,
  swapperSuccess: Gj,
  inputInfo: Qj,
  amountText: Yj,
  balanceText: Jj,
  input: Xj,
  inputIcon: e$,
  action: t$,
  actionIcon: r$
}, n$ = ({
  transactionLoading: t,
  stampLoading: e,
  incompleteTransactionOpen: r,
  errorMessage: i,
  currentStep: f,
  formData: a,
  fromNetworkData: l,
  toNetworkData: d,
  setCurrentStep: v,
  onInputChange: m,
  onSwitchNetworksClick: h,
  onMaxClick: w,
  onTransferClick: M,
  onConfirmTransferClick: S,
  onClaimClick: E,
  onCancelClick: A,
  onContinueIncompleteTransactionClick: B,
  onCloseIncompleteTransactionClick: k
}) => /* @__PURE__ */ tt.jsxs(
  "div",
  {
    className: hs(E5.swapper, {
      [E5.swapperSuccess]: f === rn.SuccessTransaction
    }),
    children: [
      t && /* @__PURE__ */ tt.jsx(Ij, {}),
      e && /* @__PURE__ */ tt.jsx(Dj, {}),
      i && /* @__PURE__ */ tt.jsx(vj, { setCurrentStep: v }),
      f === rn.EnterAmount && /* @__PURE__ */ tt.jsx(
        nj,
        {
          formData: a,
          fromNetworkData: l,
          toNetworkData: d,
          onInputChange: m,
          onSwitchNetworksClick: h,
          onMaxClick: w,
          onTransferClick: M
        }
      ),
      f === rn.ConfirmTransaction && /* @__PURE__ */ tt.jsx(
        vz,
        {
          formData: a,
          fromNetworkData: l,
          toNetworkData: d,
          onTransferClick: S,
          onCancelClick: A
        }
      ),
      f === rn.ClaimTransaction && /* @__PURE__ */ tt.jsx(
        fz,
        {
          formData: a,
          toNetworkData: d,
          onClaimClick: E,
          onCancelClick: A
        }
      ),
      f === rn.SuccessTransaction && /* @__PURE__ */ tt.jsx(
        Kj,
        {
          formData: a,
          toNetworkData: d,
          onCloseClick: A
        }
      ),
      r && /* @__PURE__ */ tt.jsx(
        Mj,
        {
          onContinueClick: B,
          onCloseClick: k
        }
      )
    ]
  }
), i$ = nr.memo(n$), a$ = (t) => {
  const [e, r] = Ei(rn.EnterAmount), [
    i,
    f,
    a
  ] = bN({ defaultOpen: !1 }), { errorMessage: l } = im(), { fromNetworkData: d, toNetworkData: v, handleSwitchNetworksClick: m } = wq(), h = yN(), w = h[0], { formData: M, setFormData: S, handleInputChange: E, handleMaxClick: A } = pq({
    defaultFormData: _q,
    fromNetworkData: d,
    toNetworkData: v
  }), {
    transactionLoading: B,
    stampLoading: k,
    handleClaimClick: C,
    handleConfirmTransferClick: I
  } = hq({
    formData: M,
    fromNetworkData: d,
    toNetworkData: v,
    incompleteTransaction: w,
    setCurrentStep: r
  });
  nf(() => {
    if (e === rn.EnterAmount && h.length && !i) {
      if (d && d.decimals) {
        const he = gf(
          BigInt(w.amount),
          d.decimals
        );
        S({
          inputValue: he,
          parsedInputValue: c1(he, d.decimals),
          convertedInputValue: he
        });
      }
      (x9(w.senderAddr) ? "TVM" : "EVM") !== d.vm && m(), f();
    }
  }, [e, d, h.length]);
  const O = () => {
    r(rn.ConfirmTransaction);
  }, q = () => {
    r(rn.EnterAmount);
  }, $ = () => {
    r(rn.ClaimTransaction), a();
  };
  return /* @__PURE__ */ tt.jsx(
    i$,
    {
      ...t,
      incompleteTransactionOpen: i,
      transactionLoading: B,
      stampLoading: k,
      errorMessage: l,
      currentStep: e,
      formData: M,
      fromNetworkData: d,
      toNetworkData: v,
      setCurrentStep: r,
      onSwitchNetworksClick: m,
      onInputChange: E,
      onMaxClick: A,
      onTransferClick: O,
      onConfirmTransferClick: I,
      onClaimClick: C,
      onContinueIncompleteTransactionClick: $,
      onCloseIncompleteTransactionClick: a,
      onCancelClick: q
    }
  );
}, s$ = nr.memo(a$), o$ = ({ children: t }) => {
  const [e] = Ei(new jM());
  return /* @__PURE__ */ tt.jsx($M, { client: e, children: t });
}, f$ = nr.memo(o$), u$ = ({ className: t }) => /* @__PURE__ */ tt.jsx(xk, { client: nT, children: /* @__PURE__ */ tt.jsx(f$, { children: /* @__PURE__ */ tt.jsx(iT, { children: /* @__PURE__ */ tt.jsx(s$, { className: t }) }) }) }), Q$ = nr.memo(u$);
export {
  Q$ as BridgeWidget
};
